var _taggedTemplateLiteral = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/taggedTemplateLiteral");

var _objectWithoutProperties = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/objectWithoutProperties");

var _defineProperty = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _createClass = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/inherits");

var _regeneratorRuntime = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/regenerator");

var _slicedToArray = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _toConsumableArray = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n  padding: 18px 40px 0 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  overflow: auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("@erecruit/ui-kit"), require("@erecruit/types"), require("@erecruit/core"), require("react-router-dom")) : "function" == typeof define && define.amd ? define(["react", "@erecruit/ui-kit", "@erecruit/types", "@erecruit/core", "react-router-dom"], t) : "object" == typeof exports ? exports["@erecruit/modules"] = t(require("react"), require("@erecruit/ui-kit"), require("@erecruit/types"), require("@erecruit/core"), require("react-router-dom")) : e["@erecruit/modules"] = t(e.react, e["@erecruit/ui-kit"], e["@erecruit/types"], e["@erecruit/core"], e["react-router-dom"]);
}(window, function (e, t, n, r, i) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        n.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 237);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    (function (e) {
      e.exports = function () {
        "use strict";

        var t, r;

        function i() {
          return t.apply(null, arguments);
        }

        function o(e) {
          return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
        }

        function a(e) {
          return null != e && "[object Object]" === Object.prototype.toString.call(e);
        }

        function s(e) {
          return void 0 === e;
        }

        function u(e) {
          return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
        }

        function c(e) {
          return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
        }

        function l(e, t) {
          var n,
              r = [];

          for (n = 0; n < e.length; ++n) {
            r.push(t(e[n], n));
          }

          return r;
        }

        function h(e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }

        function d(e, t) {
          for (var n in t) {
            h(t, n) && (e[n] = t[n]);
          }

          return h(t, "toString") && (e.toString = t.toString), h(t, "valueOf") && (e.valueOf = t.valueOf), e;
        }

        function f(e, t, n, r) {
          return It(e, t, n, r, !0).utc();
        }

        function p(e) {
          return null == e._pf && (e._pf = {
            empty: !1,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: !1,
            invalidMonth: null,
            invalidFormat: !1,
            userInvalidated: !1,
            iso: !1,
            parsedDateParts: [],
            meridiem: null,
            rfc2822: !1,
            weekdayMismatch: !1
          }), e._pf;
        }

        function m(e) {
          if (null == e._isValid) {
            var t = p(e),
                n = r.call(t.parsedDateParts, function (e) {
              return null != e;
            }),
                i = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
            if (e._strict && (i = i && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour), null != Object.isFrozen && Object.isFrozen(e)) return i;
            e._isValid = i;
          }

          return e._isValid;
        }

        function _(e) {
          var t = f(NaN);
          return null != e ? d(p(t), e) : p(t).userInvalidated = !0, t;
        }

        r = Array.prototype.some ? Array.prototype.some : function (e) {
          for (var t = Object(this), n = t.length >>> 0, r = 0; r < n; r++) {
            if (r in t && e.call(this, t[r], r, t)) return !0;
          }

          return !1;
        };
        var y = i.momentProperties = [];

        function v(e, t) {
          var n, r, i;
          if (s(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), s(t._i) || (e._i = t._i), s(t._f) || (e._f = t._f), s(t._l) || (e._l = t._l), s(t._strict) || (e._strict = t._strict), s(t._tzm) || (e._tzm = t._tzm), s(t._isUTC) || (e._isUTC = t._isUTC), s(t._offset) || (e._offset = t._offset), s(t._pf) || (e._pf = p(t)), s(t._locale) || (e._locale = t._locale), y.length > 0) for (n = 0; n < y.length; n++) {
            r = y[n], s(i = t[r]) || (e[r] = i);
          }
          return e;
        }

        var g = !1;

        function b(e) {
          v(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === g && (g = !0, i.updateOffset(this), g = !1);
        }

        function w(e) {
          return e instanceof b || null != e && null != e._isAMomentObject;
        }

        function T(e) {
          return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
        }

        function M(e) {
          var t = +e,
              n = 0;
          return 0 !== t && isFinite(t) && (n = T(t)), n;
        }

        function E(e, t, n) {
          var r,
              i = Math.min(e.length, t.length),
              o = Math.abs(e.length - t.length),
              a = 0;

          for (r = 0; r < i; r++) {
            (n && e[r] !== t[r] || !n && M(e[r]) !== M(t[r])) && a++;
          }

          return a + o;
        }

        function k(e) {
          !1 === i.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e);
        }

        function L(e, t) {
          var n = !0;
          return d(function () {
            if (null != i.deprecationHandler && i.deprecationHandler(null, e), n) {
              for (var r, o = [], a = 0; a < arguments.length; a++) {
                if (r = "", "object" == typeof arguments[a]) {
                  for (var s in r += "\n[" + a + "] ", arguments[0]) {
                    r += s + ": " + arguments[0][s] + ", ";
                  }

                  r = r.slice(0, -2);
                } else r = arguments[a];

                o.push(r);
              }

              k(e + "\nArguments: " + Array.prototype.slice.call(o).join("") + "\n" + new Error().stack), n = !1;
            }

            return t.apply(this, arguments);
          }, t);
        }

        var S,
            N = {};

        function D(e, t) {
          null != i.deprecationHandler && i.deprecationHandler(e, t), N[e] || (k(t), N[e] = !0);
        }

        function I(e) {
          return e instanceof Function || "[object Function]" === Object.prototype.toString.call(e);
        }

        function R(e, t) {
          var n,
              r = d({}, e);

          for (n in t) {
            h(t, n) && (a(e[n]) && a(t[n]) ? (r[n] = {}, d(r[n], e[n]), d(r[n], t[n])) : null != t[n] ? r[n] = t[n] : delete r[n]);
          }

          for (n in e) {
            h(e, n) && !h(t, n) && a(e[n]) && (r[n] = d({}, r[n]));
          }

          return r;
        }

        function x(e) {
          null != e && this.set(e);
        }

        i.suppressDeprecationWarnings = !1, i.deprecationHandler = null, S = Object.keys ? Object.keys : function (e) {
          var t,
              n = [];

          for (t in e) {
            h(e, t) && n.push(t);
          }

          return n;
        };
        var Y = {};

        function C(e, t) {
          var n = e.toLowerCase();
          Y[n] = Y[n + "s"] = Y[t] = e;
        }

        function O(e) {
          return "string" == typeof e ? Y[e] || Y[e.toLowerCase()] : void 0;
        }

        function F(e) {
          var t,
              n,
              r = {};

          for (n in e) {
            h(e, n) && (t = O(n)) && (r[t] = e[n]);
          }

          return r;
        }

        var A = {};

        function j(e, t) {
          A[e] = t;
        }

        function U(e, t, n) {
          var r = "" + Math.abs(e),
              i = t - r.length,
              o = e >= 0;
          return (o ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + r;
        }

        var P = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
            V = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
            W = {},
            H = {};

        function B(e, t, n, r) {
          var i = r;
          "string" == typeof r && (i = function i() {
            return this[r]();
          }), e && (H[e] = i), t && (H[t[0]] = function () {
            return U(i.apply(this, arguments), t[1], t[2]);
          }), n && (H[n] = function () {
            return this.localeData().ordinal(i.apply(this, arguments), e);
          });
        }

        function z(e, t) {
          return e.isValid() ? (t = Z(t, e.localeData()), W[t] = W[t] || function (e) {
            var t,
                n,
                r,
                i = e.match(P);

            for (t = 0, n = i.length; t < n; t++) {
              H[i[t]] ? i[t] = H[i[t]] : i[t] = (r = i[t]).match(/\[[\s\S]/) ? r.replace(/^\[|\]$/g, "") : r.replace(/\\/g, "");
            }

            return function (t) {
              var r,
                  o = "";

              for (r = 0; r < n; r++) {
                o += I(i[r]) ? i[r].call(t, e) : i[r];
              }

              return o;
            };
          }(t), W[t](e)) : e.localeData().invalidDate();
        }

        function Z(e, t) {
          var n = 5;

          function r(e) {
            return t.longDateFormat(e) || e;
          }

          for (V.lastIndex = 0; n >= 0 && V.test(e);) {
            e = e.replace(V, r), V.lastIndex = 0, n -= 1;
          }

          return e;
        }

        var Q = /\d/,
            G = /\d\d/,
            q = /\d{3}/,
            J = /\d{4}/,
            X = /[+-]?\d{6}/,
            K = /\d\d?/,
            $ = /\d\d\d\d?/,
            ee = /\d\d\d\d\d\d?/,
            te = /\d{1,3}/,
            ne = /\d{1,4}/,
            re = /[+-]?\d{1,6}/,
            ie = /\d+/,
            oe = /[+-]?\d+/,
            ae = /Z|[+-]\d\d:?\d\d/gi,
            se = /Z|[+-]\d\d(?::?\d\d)?/gi,
            ue = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
            ce = {};

        function le(e, t, n) {
          ce[e] = I(t) ? t : function (e, r) {
            return e && n ? n : t;
          };
        }

        function he(e, t) {
          return h(ce, e) ? ce[e](t._strict, t._locale) : new RegExp(de(e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, n, r, i) {
            return t || n || r || i;
          })));
        }

        function de(e) {
          return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        var fe = {};

        function pe(e, t) {
          var n,
              r = t;

          for ("string" == typeof e && (e = [e]), u(t) && (r = function r(e, n) {
            n[t] = M(e);
          }), n = 0; n < e.length; n++) {
            fe[e[n]] = r;
          }
        }

        function me(e, t) {
          pe(e, function (e, n, r, i) {
            r._w = r._w || {}, t(e, r._w, r, i);
          });
        }

        function _e(e, t, n) {
          null != t && h(fe, e) && fe[e](t, n._a, n, e);
        }

        var ye = 0,
            ve = 1,
            ge = 2,
            be = 3,
            we = 4,
            Te = 5,
            Me = 6,
            Ee = 7,
            ke = 8;

        function Le(e) {
          return Se(e) ? 366 : 365;
        }

        function Se(e) {
          return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
        }

        B("Y", 0, 0, function () {
          var e = this.year();
          return e <= 9999 ? "" + e : "+" + e;
        }), B(0, ["YY", 2], 0, function () {
          return this.year() % 100;
        }), B(0, ["YYYY", 4], 0, "year"), B(0, ["YYYYY", 5], 0, "year"), B(0, ["YYYYYY", 6, !0], 0, "year"), C("year", "y"), j("year", 1), le("Y", oe), le("YY", K, G), le("YYYY", ne, J), le("YYYYY", re, X), le("YYYYYY", re, X), pe(["YYYYY", "YYYYYY"], ye), pe("YYYY", function (e, t) {
          t[ye] = 2 === e.length ? i.parseTwoDigitYear(e) : M(e);
        }), pe("YY", function (e, t) {
          t[ye] = i.parseTwoDigitYear(e);
        }), pe("Y", function (e, t) {
          t[ye] = parseInt(e, 10);
        }), i.parseTwoDigitYear = function (e) {
          return M(e) + (M(e) > 68 ? 1900 : 2e3);
        };
        var Ne,
            De = Ie("FullYear", !0);

        function Ie(e, t) {
          return function (n) {
            return null != n ? (xe(this, e, n), i.updateOffset(this, t), this) : Re(this, e);
          };
        }

        function Re(e, t) {
          return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
        }

        function xe(e, t, n) {
          e.isValid() && !isNaN(n) && ("FullYear" === t && Se(e.year()) && 1 === e.month() && 29 === e.date() ? e._d["set" + (e._isUTC ? "UTC" : "") + t](n, e.month(), Ye(n, e.month())) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
        }

        function Ye(e, t) {
          if (isNaN(e) || isNaN(t)) return NaN;
          var n,
              r = (t % (n = 12) + n) % n;
          return e += (t - r) / 12, 1 === r ? Se(e) ? 29 : 28 : 31 - r % 7 % 2;
        }

        Ne = Array.prototype.indexOf ? Array.prototype.indexOf : function (e) {
          var t;

          for (t = 0; t < this.length; ++t) {
            if (this[t] === e) return t;
          }

          return -1;
        }, B("M", ["MM", 2], "Mo", function () {
          return this.month() + 1;
        }), B("MMM", 0, 0, function (e) {
          return this.localeData().monthsShort(this, e);
        }), B("MMMM", 0, 0, function (e) {
          return this.localeData().months(this, e);
        }), C("month", "M"), j("month", 8), le("M", K), le("MM", K, G), le("MMM", function (e, t) {
          return t.monthsShortRegex(e);
        }), le("MMMM", function (e, t) {
          return t.monthsRegex(e);
        }), pe(["M", "MM"], function (e, t) {
          t[ve] = M(e) - 1;
        }), pe(["MMM", "MMMM"], function (e, t, n, r) {
          var i = n._locale.monthsParse(e, r, n._strict);

          null != i ? t[ve] = i : p(n).invalidMonth = e;
        });
        var Ce = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
            Oe = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            Fe = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");

        function Ae(e, t) {
          var n;
          if (!e.isValid()) return e;
          if ("string" == typeof t) if (/^\d+$/.test(t)) t = M(t);else if (!u(t = e.localeData().monthsParse(t))) return e;
          return n = Math.min(e.date(), Ye(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
        }

        function je(e) {
          return null != e ? (Ae(this, e), i.updateOffset(this, !0), this) : Re(this, "Month");
        }

        var Ue = ue,
            Pe = ue;

        function Ve() {
          function e(e, t) {
            return t.length - e.length;
          }

          var t,
              n,
              r = [],
              i = [],
              o = [];

          for (t = 0; t < 12; t++) {
            n = f([2e3, t]), r.push(this.monthsShort(n, "")), i.push(this.months(n, "")), o.push(this.months(n, "")), o.push(this.monthsShort(n, ""));
          }

          for (r.sort(e), i.sort(e), o.sort(e), t = 0; t < 12; t++) {
            r[t] = de(r[t]), i[t] = de(i[t]);
          }

          for (t = 0; t < 24; t++) {
            o[t] = de(o[t]);
          }

          this._monthsRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + r.join("|") + ")", "i");
        }

        function We(e) {
          var t;

          if (e < 100 && e >= 0) {
            var n = Array.prototype.slice.call(arguments);
            n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e);
          } else t = new Date(Date.UTC.apply(null, arguments));

          return t;
        }

        function He(e, t, n) {
          var r = 7 + t - n,
              i = (7 + We(e, 0, r).getUTCDay() - t) % 7;
          return -i + r - 1;
        }

        function Be(e, t, n, r, i) {
          var o,
              a,
              s = (7 + n - r) % 7,
              u = He(e, r, i),
              c = 1 + 7 * (t - 1) + s + u;
          return c <= 0 ? a = Le(o = e - 1) + c : c > Le(e) ? (o = e + 1, a = c - Le(e)) : (o = e, a = c), {
            year: o,
            dayOfYear: a
          };
        }

        function ze(e, t, n) {
          var r,
              i,
              o = He(e.year(), t, n),
              a = Math.floor((e.dayOfYear() - o - 1) / 7) + 1;
          return a < 1 ? (i = e.year() - 1, r = a + Ze(i, t, n)) : a > Ze(e.year(), t, n) ? (r = a - Ze(e.year(), t, n), i = e.year() + 1) : (i = e.year(), r = a), {
            week: r,
            year: i
          };
        }

        function Ze(e, t, n) {
          var r = He(e, t, n),
              i = He(e + 1, t, n);
          return (Le(e) - r + i) / 7;
        }

        function Qe(e, t) {
          return e.slice(t, 7).concat(e.slice(0, t));
        }

        B("w", ["ww", 2], "wo", "week"), B("W", ["WW", 2], "Wo", "isoWeek"), C("week", "w"), C("isoWeek", "W"), j("week", 5), j("isoWeek", 5), le("w", K), le("ww", K, G), le("W", K), le("WW", K, G), me(["w", "ww", "W", "WW"], function (e, t, n, r) {
          t[r.substr(0, 1)] = M(e);
        }), B("d", 0, "do", "day"), B("dd", 0, 0, function (e) {
          return this.localeData().weekdaysMin(this, e);
        }), B("ddd", 0, 0, function (e) {
          return this.localeData().weekdaysShort(this, e);
        }), B("dddd", 0, 0, function (e) {
          return this.localeData().weekdays(this, e);
        }), B("e", 0, 0, "weekday"), B("E", 0, 0, "isoWeekday"), C("day", "d"), C("weekday", "e"), C("isoWeekday", "E"), j("day", 11), j("weekday", 11), j("isoWeekday", 11), le("d", K), le("e", K), le("E", K), le("dd", function (e, t) {
          return t.weekdaysMinRegex(e);
        }), le("ddd", function (e, t) {
          return t.weekdaysShortRegex(e);
        }), le("dddd", function (e, t) {
          return t.weekdaysRegex(e);
        }), me(["dd", "ddd", "dddd"], function (e, t, n, r) {
          var i = n._locale.weekdaysParse(e, r, n._strict);

          null != i ? t.d = i : p(n).invalidWeekday = e;
        }), me(["d", "e", "E"], function (e, t, n, r) {
          t[r] = M(e);
        });
        var Ge = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            qe = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            Je = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            Xe = ue,
            Ke = ue,
            $e = ue;

        function et() {
          function e(e, t) {
            return t.length - e.length;
          }

          var t,
              n,
              r,
              i,
              o,
              a = [],
              s = [],
              u = [],
              c = [];

          for (t = 0; t < 7; t++) {
            n = f([2e3, 1]).day(t), r = this.weekdaysMin(n, ""), i = this.weekdaysShort(n, ""), o = this.weekdays(n, ""), a.push(r), s.push(i), u.push(o), c.push(r), c.push(i), c.push(o);
          }

          for (a.sort(e), s.sort(e), u.sort(e), c.sort(e), t = 0; t < 7; t++) {
            s[t] = de(s[t]), u[t] = de(u[t]), c[t] = de(c[t]);
          }

          this._weekdaysRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + u.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + a.join("|") + ")", "i");
        }

        function tt() {
          return this.hours() % 12 || 12;
        }

        function nt(e, t) {
          B(e, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), t);
          });
        }

        function rt(e, t) {
          return t._meridiemParse;
        }

        B("H", ["HH", 2], 0, "hour"), B("h", ["hh", 2], 0, tt), B("k", ["kk", 2], 0, function () {
          return this.hours() || 24;
        }), B("hmm", 0, 0, function () {
          return "" + tt.apply(this) + U(this.minutes(), 2);
        }), B("hmmss", 0, 0, function () {
          return "" + tt.apply(this) + U(this.minutes(), 2) + U(this.seconds(), 2);
        }), B("Hmm", 0, 0, function () {
          return "" + this.hours() + U(this.minutes(), 2);
        }), B("Hmmss", 0, 0, function () {
          return "" + this.hours() + U(this.minutes(), 2) + U(this.seconds(), 2);
        }), nt("a", !0), nt("A", !1), C("hour", "h"), j("hour", 13), le("a", rt), le("A", rt), le("H", K), le("h", K), le("k", K), le("HH", K, G), le("hh", K, G), le("kk", K, G), le("hmm", $), le("hmmss", ee), le("Hmm", $), le("Hmmss", ee), pe(["H", "HH"], be), pe(["k", "kk"], function (e, t, n) {
          var r = M(e);
          t[be] = 24 === r ? 0 : r;
        }), pe(["a", "A"], function (e, t, n) {
          n._isPm = n._locale.isPM(e), n._meridiem = e;
        }), pe(["h", "hh"], function (e, t, n) {
          t[be] = M(e), p(n).bigHour = !0;
        }), pe("hmm", function (e, t, n) {
          var r = e.length - 2;
          t[be] = M(e.substr(0, r)), t[we] = M(e.substr(r)), p(n).bigHour = !0;
        }), pe("hmmss", function (e, t, n) {
          var r = e.length - 4,
              i = e.length - 2;
          t[be] = M(e.substr(0, r)), t[we] = M(e.substr(r, 2)), t[Te] = M(e.substr(i)), p(n).bigHour = !0;
        }), pe("Hmm", function (e, t, n) {
          var r = e.length - 2;
          t[be] = M(e.substr(0, r)), t[we] = M(e.substr(r));
        }), pe("Hmmss", function (e, t, n) {
          var r = e.length - 4,
              i = e.length - 2;
          t[be] = M(e.substr(0, r)), t[we] = M(e.substr(r, 2)), t[Te] = M(e.substr(i));
        });
        var it,
            ot = Ie("Hours", !0),
            at = {
          calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
          },
          longDateFormat: {
            LTS: "h:mm:ss A",
            LT: "h:mm A",
            L: "MM/DD/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A"
          },
          invalidDate: "Invalid date",
          ordinal: "%d",
          dayOfMonthOrdinalParse: /\d{1,2}/,
          relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
          },
          months: Oe,
          monthsShort: Fe,
          week: {
            dow: 0,
            doy: 6
          },
          weekdays: Ge,
          weekdaysMin: Je,
          weekdaysShort: qe,
          meridiemParse: /[ap]\.?m?\.?/i
        },
            st = {},
            ut = {};

        function ct(e) {
          return e ? e.toLowerCase().replace("_", "-") : e;
        }

        function lt(t) {
          var r = null;
          if (!st[t] && void 0 !== e && e && e.exports) try {
            r = it._abbr, n(266)("./" + t), ht(r);
          } catch (e) {}
          return st[t];
        }

        function ht(e, t) {
          var n;
          return e && ((n = s(t) ? ft(e) : dt(e, t)) ? it = n : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), it._abbr;
        }

        function dt(e, t) {
          if (null !== t) {
            var n,
                r = at;
            if (t.abbr = e, null != st[e]) D("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), r = st[e]._config;else if (null != t.parentLocale) if (null != st[t.parentLocale]) r = st[t.parentLocale]._config;else {
              if (null == (n = lt(t.parentLocale))) return ut[t.parentLocale] || (ut[t.parentLocale] = []), ut[t.parentLocale].push({
                name: e,
                config: t
              }), null;
              r = n._config;
            }
            return st[e] = new x(R(r, t)), ut[e] && ut[e].forEach(function (e) {
              dt(e.name, e.config);
            }), ht(e), st[e];
          }

          return delete st[e], null;
        }

        function ft(e) {
          var t;
          if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e) return it;

          if (!o(e)) {
            if (t = lt(e)) return t;
            e = [e];
          }

          return function (e) {
            for (var t, n, r, i, o = 0; o < e.length;) {
              for (i = ct(e[o]).split("-"), t = i.length, n = (n = ct(e[o + 1])) ? n.split("-") : null; t > 0;) {
                if (r = lt(i.slice(0, t).join("-"))) return r;
                if (n && n.length >= t && E(i, n, !0) >= t - 1) break;
                t--;
              }

              o++;
            }

            return it;
          }(e);
        }

        function pt(e) {
          var t,
              n = e._a;
          return n && -2 === p(e).overflow && (t = n[ve] < 0 || n[ve] > 11 ? ve : n[ge] < 1 || n[ge] > Ye(n[ye], n[ve]) ? ge : n[be] < 0 || n[be] > 24 || 24 === n[be] && (0 !== n[we] || 0 !== n[Te] || 0 !== n[Me]) ? be : n[we] < 0 || n[we] > 59 ? we : n[Te] < 0 || n[Te] > 59 ? Te : n[Me] < 0 || n[Me] > 999 ? Me : -1, p(e)._overflowDayOfYear && (t < ye || t > ge) && (t = ge), p(e)._overflowWeeks && -1 === t && (t = Ee), p(e)._overflowWeekday && -1 === t && (t = ke), p(e).overflow = t), e;
        }

        function mt(e, t, n) {
          return null != e ? e : null != t ? t : n;
        }

        function _t(e) {
          var t,
              n,
              r,
              o,
              a,
              s = [];

          if (!e._d) {
            for (r = function (e) {
              var t = new Date(i.now());
              return e._useUTC ? [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()] : [t.getFullYear(), t.getMonth(), t.getDate()];
            }(e), e._w && null == e._a[ge] && null == e._a[ve] && function (e) {
              var t, n, r, i, o, a, s, u;
              if (null != (t = e._w).GG || null != t.W || null != t.E) o = 1, a = 4, n = mt(t.GG, e._a[ye], ze(Rt(), 1, 4).year), r = mt(t.W, 1), ((i = mt(t.E, 1)) < 1 || i > 7) && (u = !0);else {
                o = e._locale._week.dow, a = e._locale._week.doy;
                var c = ze(Rt(), o, a);
                n = mt(t.gg, e._a[ye], c.year), r = mt(t.w, c.week), null != t.d ? ((i = t.d) < 0 || i > 6) && (u = !0) : null != t.e ? (i = t.e + o, (t.e < 0 || t.e > 6) && (u = !0)) : i = o;
              }
              r < 1 || r > Ze(n, o, a) ? p(e)._overflowWeeks = !0 : null != u ? p(e)._overflowWeekday = !0 : (s = Be(n, r, i, o, a), e._a[ye] = s.year, e._dayOfYear = s.dayOfYear);
            }(e), null != e._dayOfYear && (a = mt(e._a[ye], r[ye]), (e._dayOfYear > Le(a) || 0 === e._dayOfYear) && (p(e)._overflowDayOfYear = !0), n = We(a, 0, e._dayOfYear), e._a[ve] = n.getUTCMonth(), e._a[ge] = n.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t) {
              e._a[t] = s[t] = r[t];
            }

            for (; t < 7; t++) {
              e._a[t] = s[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
            }

            24 === e._a[be] && 0 === e._a[we] && 0 === e._a[Te] && 0 === e._a[Me] && (e._nextDay = !0, e._a[be] = 0), e._d = (e._useUTC ? We : function (e, t, n, r, i, o, a) {
              var s;
              return e < 100 && e >= 0 ? (s = new Date(e + 400, t, n, r, i, o, a), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, n, r, i, o, a), s;
            }).apply(null, s), o = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[be] = 24), e._w && void 0 !== e._w.d && e._w.d !== o && (p(e).weekdayMismatch = !0);
          }
        }

        var yt = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
            vt = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
            gt = /Z|[+-]\d\d(?::?\d\d)?/,
            bt = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/]],
            wt = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
            Tt = /^\/?Date\((\-?\d+)/i;

        function Mt(e) {
          var t,
              n,
              r,
              i,
              o,
              a,
              s = e._i,
              u = yt.exec(s) || vt.exec(s);

          if (u) {
            for (p(e).iso = !0, t = 0, n = bt.length; t < n; t++) {
              if (bt[t][1].exec(u[1])) {
                i = bt[t][0], r = !1 !== bt[t][2];
                break;
              }
            }

            if (null == i) return void (e._isValid = !1);

            if (u[3]) {
              for (t = 0, n = wt.length; t < n; t++) {
                if (wt[t][1].exec(u[3])) {
                  o = (u[2] || " ") + wt[t][0];
                  break;
                }
              }

              if (null == o) return void (e._isValid = !1);
            }

            if (!r && null != o) return void (e._isValid = !1);

            if (u[4]) {
              if (!gt.exec(u[4])) return void (e._isValid = !1);
              a = "Z";
            }

            e._f = i + (o || "") + (a || ""), Nt(e);
          } else e._isValid = !1;
        }

        var Et = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

        function kt(e) {
          var t = parseInt(e, 10);
          return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
        }

        var Lt = {
          UT: 0,
          GMT: 0,
          EDT: -240,
          EST: -300,
          CDT: -300,
          CST: -360,
          MDT: -360,
          MST: -420,
          PDT: -420,
          PST: -480
        };

        function St(e) {
          var t,
              n,
              r,
              i,
              o,
              a,
              s,
              u = Et.exec(e._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));

          if (u) {
            var c = (t = u[4], n = u[3], r = u[2], i = u[5], o = u[6], a = u[7], s = [kt(t), Fe.indexOf(n), parseInt(r, 10), parseInt(i, 10), parseInt(o, 10)], a && s.push(parseInt(a, 10)), s);
            if (!function (e, t, n) {
              if (e) {
                var r = qe.indexOf(e),
                    i = new Date(t[0], t[1], t[2]).getDay();
                if (r !== i) return p(n).weekdayMismatch = !0, n._isValid = !1, !1;
              }

              return !0;
            }(u[1], c, e)) return;
            e._a = c, e._tzm = function (e, t, n) {
              if (e) return Lt[e];
              if (t) return 0;
              var r = parseInt(n, 10),
                  i = r % 100,
                  o = (r - i) / 100;
              return 60 * o + i;
            }(u[8], u[9], u[10]), e._d = We.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), p(e).rfc2822 = !0;
          } else e._isValid = !1;
        }

        function Nt(e) {
          if (e._f !== i.ISO_8601) {
            if (e._f !== i.RFC_2822) {
              e._a = [], p(e).empty = !0;
              var t,
                  n,
                  r,
                  o,
                  a,
                  s = "" + e._i,
                  u = s.length,
                  c = 0;

              for (r = Z(e._f, e._locale).match(P) || [], t = 0; t < r.length; t++) {
                o = r[t], (n = (s.match(he(o, e)) || [])[0]) && ((a = s.substr(0, s.indexOf(n))).length > 0 && p(e).unusedInput.push(a), s = s.slice(s.indexOf(n) + n.length), c += n.length), H[o] ? (n ? p(e).empty = !1 : p(e).unusedTokens.push(o), _e(o, n, e)) : e._strict && !n && p(e).unusedTokens.push(o);
              }

              p(e).charsLeftOver = u - c, s.length > 0 && p(e).unusedInput.push(s), e._a[be] <= 12 && !0 === p(e).bigHour && e._a[be] > 0 && (p(e).bigHour = void 0), p(e).parsedDateParts = e._a.slice(0), p(e).meridiem = e._meridiem, e._a[be] = (l = e._locale, h = e._a[be], null == (d = e._meridiem) ? h : null != l.meridiemHour ? l.meridiemHour(h, d) : null != l.isPM ? ((f = l.isPM(d)) && h < 12 && (h += 12), f || 12 !== h || (h = 0), h) : h), _t(e), pt(e);
            } else St(e);
          } else Mt(e);
          var l, h, d, f;
        }

        function Dt(e) {
          var t = e._i,
              n = e._f;
          return e._locale = e._locale || ft(e._l), null === t || void 0 === n && "" === t ? _({
            nullInput: !0
          }) : ("string" == typeof t && (e._i = t = e._locale.preparse(t)), w(t) ? new b(pt(t)) : (c(t) ? e._d = t : o(n) ? function (e) {
            var t, n, r, i, o;
            if (0 === e._f.length) return p(e).invalidFormat = !0, void (e._d = new Date(NaN));

            for (i = 0; i < e._f.length; i++) {
              o = 0, t = v({}, e), null != e._useUTC && (t._useUTC = e._useUTC), t._f = e._f[i], Nt(t), m(t) && (o += p(t).charsLeftOver, o += 10 * p(t).unusedTokens.length, p(t).score = o, (null == r || o < r) && (r = o, n = t));
            }

            d(e, n || t);
          }(e) : n ? Nt(e) : function (e) {
            var t = e._i;
            s(t) ? e._d = new Date(i.now()) : c(t) ? e._d = new Date(t.valueOf()) : "string" == typeof t ? function (e) {
              var t = Tt.exec(e._i);
              null === t ? (Mt(e), !1 === e._isValid && (delete e._isValid, St(e), !1 === e._isValid && (delete e._isValid, i.createFromInputFallback(e)))) : e._d = new Date(+t[1]);
            }(e) : o(t) ? (e._a = l(t.slice(0), function (e) {
              return parseInt(e, 10);
            }), _t(e)) : a(t) ? function (e) {
              if (!e._d) {
                var t = F(e._i);
                e._a = l([t.year, t.month, t.day || t.date, t.hour, t.minute, t.second, t.millisecond], function (e) {
                  return e && parseInt(e, 10);
                }), _t(e);
              }
            }(e) : u(t) ? e._d = new Date(t) : i.createFromInputFallback(e);
          }(e), m(e) || (e._d = null), e));
        }

        function It(e, t, n, r, i) {
          var s,
              u = {};
          return !0 !== n && !1 !== n || (r = n, n = void 0), (a(e) && function (e) {
            if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
            var t;

            for (t in e) {
              if (e.hasOwnProperty(t)) return !1;
            }

            return !0;
          }(e) || o(e) && 0 === e.length) && (e = void 0), u._isAMomentObject = !0, u._useUTC = u._isUTC = i, u._l = n, u._i = e, u._f = t, u._strict = r, (s = new b(pt(Dt(u))))._nextDay && (s.add(1, "d"), s._nextDay = void 0), s;
        }

        function Rt(e, t, n, r) {
          return It(e, t, n, r, !1);
        }

        i.createFromInputFallback = L("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (e) {
          e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
        }), i.ISO_8601 = function () {}, i.RFC_2822 = function () {};
        var xt = L("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
          var e = Rt.apply(null, arguments);
          return this.isValid() && e.isValid() ? e < this ? this : e : _();
        }),
            Yt = L("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
          var e = Rt.apply(null, arguments);
          return this.isValid() && e.isValid() ? e > this ? this : e : _();
        });

        function Ct(e, t) {
          var n, r;
          if (1 === t.length && o(t[0]) && (t = t[0]), !t.length) return Rt();

          for (n = t[0], r = 1; r < t.length; ++r) {
            t[r].isValid() && !t[r][e](n) || (n = t[r]);
          }

          return n;
        }

        var Ot = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

        function Ft(e) {
          var t = F(e),
              n = t.year || 0,
              r = t.quarter || 0,
              i = t.month || 0,
              o = t.week || t.isoWeek || 0,
              a = t.day || 0,
              s = t.hour || 0,
              u = t.minute || 0,
              c = t.second || 0,
              l = t.millisecond || 0;
          this._isValid = function (e) {
            for (var t in e) {
              if (-1 === Ne.call(Ot, t) || null != e[t] && isNaN(e[t])) return !1;
            }

            for (var n = !1, r = 0; r < Ot.length; ++r) {
              if (e[Ot[r]]) {
                if (n) return !1;
                parseFloat(e[Ot[r]]) !== M(e[Ot[r]]) && (n = !0);
              }
            }

            return !0;
          }(t), this._milliseconds = +l + 1e3 * c + 6e4 * u + 1e3 * s * 60 * 60, this._days = +a + 7 * o, this._months = +i + 3 * r + 12 * n, this._data = {}, this._locale = ft(), this._bubble();
        }

        function At(e) {
          return e instanceof Ft;
        }

        function jt(e) {
          return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
        }

        function Ut(e, t) {
          B(e, 0, 0, function () {
            var e = this.utcOffset(),
                n = "+";
            return e < 0 && (e = -e, n = "-"), n + U(~~(e / 60), 2) + t + U(~~e % 60, 2);
          });
        }

        Ut("Z", ":"), Ut("ZZ", ""), le("Z", se), le("ZZ", se), pe(["Z", "ZZ"], function (e, t, n) {
          n._useUTC = !0, n._tzm = Vt(se, e);
        });
        var Pt = /([\+\-]|\d\d)/gi;

        function Vt(e, t) {
          var n = (t || "").match(e);
          if (null === n) return null;
          var r = n[n.length - 1] || [],
              i = (r + "").match(Pt) || ["-", 0, 0],
              o = 60 * i[1] + M(i[2]);
          return 0 === o ? 0 : "+" === i[0] ? o : -o;
        }

        function Wt(e, t) {
          var n, r;
          return t._isUTC ? (n = t.clone(), r = (w(e) || c(e) ? e.valueOf() : Rt(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + r), i.updateOffset(n, !1), n) : Rt(e).local();
        }

        function Ht(e) {
          return 15 * -Math.round(e._d.getTimezoneOffset() / 15);
        }

        function Bt() {
          return !!this.isValid() && this._isUTC && 0 === this._offset;
        }

        i.updateOffset = function () {};

        var zt = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,
            Zt = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

        function Qt(e, t) {
          var n,
              r,
              i,
              o,
              a,
              s,
              c = e,
              l = null;
          return At(e) ? c = {
            ms: e._milliseconds,
            d: e._days,
            M: e._months
          } : u(e) ? (c = {}, t ? c[t] = e : c.milliseconds = e) : (l = zt.exec(e)) ? (n = "-" === l[1] ? -1 : 1, c = {
            y: 0,
            d: M(l[ge]) * n,
            h: M(l[be]) * n,
            m: M(l[we]) * n,
            s: M(l[Te]) * n,
            ms: M(jt(1e3 * l[Me])) * n
          }) : (l = Zt.exec(e)) ? (n = "-" === l[1] ? -1 : 1, c = {
            y: Gt(l[2], n),
            M: Gt(l[3], n),
            w: Gt(l[4], n),
            d: Gt(l[5], n),
            h: Gt(l[6], n),
            m: Gt(l[7], n),
            s: Gt(l[8], n)
          }) : null == c ? c = {} : "object" == typeof c && ("from" in c || "to" in c) && (o = Rt(c.from), a = Rt(c.to), i = o.isValid() && a.isValid() ? (a = Wt(a, o), o.isBefore(a) ? s = qt(o, a) : ((s = qt(a, o)).milliseconds = -s.milliseconds, s.months = -s.months), s) : {
            milliseconds: 0,
            months: 0
          }, (c = {}).ms = i.milliseconds, c.M = i.months), r = new Ft(c), At(e) && h(e, "_locale") && (r._locale = e._locale), r;
        }

        function Gt(e, t) {
          var n = e && parseFloat(e.replace(",", "."));
          return (isNaN(n) ? 0 : n) * t;
        }

        function qt(e, t) {
          var n = {};
          return n.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
        }

        function Jt(e, t) {
          return function (n, r) {
            var i;
            return null === r || isNaN(+r) || (D(t, "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), i = n, n = r, r = i), Xt(this, Qt(n = "string" == typeof n ? +n : n, r), e), this;
          };
        }

        function Xt(e, t, n, r) {
          var o = t._milliseconds,
              a = jt(t._days),
              s = jt(t._months);
          e.isValid() && (r = null == r || r, s && Ae(e, Re(e, "Month") + s * n), a && xe(e, "Date", Re(e, "Date") + a * n), o && e._d.setTime(e._d.valueOf() + o * n), r && i.updateOffset(e, a || s));
        }

        Qt.fn = Ft.prototype, Qt.invalid = function () {
          return Qt(NaN);
        };
        var Kt = Jt(1, "add"),
            $t = Jt(-1, "subtract");

        function en(e, t) {
          var n,
              r,
              i = 12 * (t.year() - e.year()) + (t.month() - e.month()),
              o = e.clone().add(i, "months");
          return t - o < 0 ? (n = e.clone().add(i - 1, "months"), r = (t - o) / (o - n)) : (n = e.clone().add(i + 1, "months"), r = (t - o) / (n - o)), -(i + r) || 0;
        }

        function tn(e) {
          var t;
          return void 0 === e ? this._locale._abbr : (null != (t = ft(e)) && (this._locale = t), this);
        }

        i.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", i.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
        var nn = L("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (e) {
          return void 0 === e ? this.localeData() : this.locale(e);
        });

        function rn() {
          return this._locale;
        }

        var on = 1e3,
            an = 60 * on,
            sn = 60 * an,
            un = 3506328 * sn;

        function cn(e, t) {
          return (e % t + t) % t;
        }

        function ln(e, t, n) {
          return e < 100 && e >= 0 ? new Date(e + 400, t, n) - un : new Date(e, t, n).valueOf();
        }

        function hn(e, t, n) {
          return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - un : Date.UTC(e, t, n);
        }

        function dn(e, t) {
          B(0, [e, e.length], 0, t);
        }

        function fn(e, t, n, r, i) {
          var o;
          return null == e ? ze(this, r, i).year : (o = Ze(e, r, i), t > o && (t = o), function (e, t, n, r, i) {
            var o = Be(e, t, n, r, i),
                a = We(o.year, 0, o.dayOfYear);
            return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
          }.call(this, e, t, n, r, i));
        }

        B(0, ["gg", 2], 0, function () {
          return this.weekYear() % 100;
        }), B(0, ["GG", 2], 0, function () {
          return this.isoWeekYear() % 100;
        }), dn("gggg", "weekYear"), dn("ggggg", "weekYear"), dn("GGGG", "isoWeekYear"), dn("GGGGG", "isoWeekYear"), C("weekYear", "gg"), C("isoWeekYear", "GG"), j("weekYear", 1), j("isoWeekYear", 1), le("G", oe), le("g", oe), le("GG", K, G), le("gg", K, G), le("GGGG", ne, J), le("gggg", ne, J), le("GGGGG", re, X), le("ggggg", re, X), me(["gggg", "ggggg", "GGGG", "GGGGG"], function (e, t, n, r) {
          t[r.substr(0, 2)] = M(e);
        }), me(["gg", "GG"], function (e, t, n, r) {
          t[r] = i.parseTwoDigitYear(e);
        }), B("Q", 0, "Qo", "quarter"), C("quarter", "Q"), j("quarter", 7), le("Q", Q), pe("Q", function (e, t) {
          t[ve] = 3 * (M(e) - 1);
        }), B("D", ["DD", 2], "Do", "date"), C("date", "D"), j("date", 9), le("D", K), le("DD", K, G), le("Do", function (e, t) {
          return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
        }), pe(["D", "DD"], ge), pe("Do", function (e, t) {
          t[ge] = M(e.match(K)[0]);
        });
        var pn = Ie("Date", !0);
        B("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), C("dayOfYear", "DDD"), j("dayOfYear", 4), le("DDD", te), le("DDDD", q), pe(["DDD", "DDDD"], function (e, t, n) {
          n._dayOfYear = M(e);
        }), B("m", ["mm", 2], 0, "minute"), C("minute", "m"), j("minute", 14), le("m", K), le("mm", K, G), pe(["m", "mm"], we);
        var mn = Ie("Minutes", !1);
        B("s", ["ss", 2], 0, "second"), C("second", "s"), j("second", 15), le("s", K), le("ss", K, G), pe(["s", "ss"], Te);

        var _n,
            yn = Ie("Seconds", !1);

        for (B("S", 0, 0, function () {
          return ~~(this.millisecond() / 100);
        }), B(0, ["SS", 2], 0, function () {
          return ~~(this.millisecond() / 10);
        }), B(0, ["SSS", 3], 0, "millisecond"), B(0, ["SSSS", 4], 0, function () {
          return 10 * this.millisecond();
        }), B(0, ["SSSSS", 5], 0, function () {
          return 100 * this.millisecond();
        }), B(0, ["SSSSSS", 6], 0, function () {
          return 1e3 * this.millisecond();
        }), B(0, ["SSSSSSS", 7], 0, function () {
          return 1e4 * this.millisecond();
        }), B(0, ["SSSSSSSS", 8], 0, function () {
          return 1e5 * this.millisecond();
        }), B(0, ["SSSSSSSSS", 9], 0, function () {
          return 1e6 * this.millisecond();
        }), C("millisecond", "ms"), j("millisecond", 16), le("S", te, Q), le("SS", te, G), le("SSS", te, q), _n = "SSSS"; _n.length <= 9; _n += "S") {
          le(_n, ie);
        }

        function vn(e, t) {
          t[Me] = M(1e3 * ("0." + e));
        }

        for (_n = "S"; _n.length <= 9; _n += "S") {
          pe(_n, vn);
        }

        var gn = Ie("Milliseconds", !1);
        B("z", 0, 0, "zoneAbbr"), B("zz", 0, 0, "zoneName");
        var bn = b.prototype;

        function wn(e) {
          return e;
        }

        bn.add = Kt, bn.calendar = function (e, t) {
          var n = e || Rt(),
              r = Wt(n, this).startOf("day"),
              o = i.calendarFormat(this, r) || "sameElse",
              a = t && (I(t[o]) ? t[o].call(this, n) : t[o]);
          return this.format(a || this.localeData().calendar(o, this, Rt(n)));
        }, bn.clone = function () {
          return new b(this);
        }, bn.diff = function (e, t, n) {
          var r, i, o;
          if (!this.isValid()) return NaN;
          if (!(r = Wt(e, this)).isValid()) return NaN;

          switch (i = 6e4 * (r.utcOffset() - this.utcOffset()), t = O(t)) {
            case "year":
              o = en(this, r) / 12;
              break;

            case "month":
              o = en(this, r);
              break;

            case "quarter":
              o = en(this, r) / 3;
              break;

            case "second":
              o = (this - r) / 1e3;
              break;

            case "minute":
              o = (this - r) / 6e4;
              break;

            case "hour":
              o = (this - r) / 36e5;
              break;

            case "day":
              o = (this - r - i) / 864e5;
              break;

            case "week":
              o = (this - r - i) / 6048e5;
              break;

            default:
              o = this - r;
          }

          return n ? o : T(o);
        }, bn.endOf = function (e) {
          var t;
          if (void 0 === (e = O(e)) || "millisecond" === e || !this.isValid()) return this;
          var n = this._isUTC ? hn : ln;

          switch (e) {
            case "year":
              t = n(this.year() + 1, 0, 1) - 1;
              break;

            case "quarter":
              t = n(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
              break;

            case "month":
              t = n(this.year(), this.month() + 1, 1) - 1;
              break;

            case "week":
              t = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
              break;

            case "isoWeek":
              t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
              break;

            case "day":
            case "date":
              t = n(this.year(), this.month(), this.date() + 1) - 1;
              break;

            case "hour":
              t = this._d.valueOf(), t += sn - cn(t + (this._isUTC ? 0 : this.utcOffset() * an), sn) - 1;
              break;

            case "minute":
              t = this._d.valueOf(), t += an - cn(t, an) - 1;
              break;

            case "second":
              t = this._d.valueOf(), t += on - cn(t, on) - 1;
          }

          return this._d.setTime(t), i.updateOffset(this, !0), this;
        }, bn.format = function (e) {
          e || (e = this.isUtc() ? i.defaultFormatUtc : i.defaultFormat);
          var t = z(this, e);
          return this.localeData().postformat(t);
        }, bn.from = function (e, t) {
          return this.isValid() && (w(e) && e.isValid() || Rt(e).isValid()) ? Qt({
            to: this,
            from: e
          }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
        }, bn.fromNow = function (e) {
          return this.from(Rt(), e);
        }, bn.to = function (e, t) {
          return this.isValid() && (w(e) && e.isValid() || Rt(e).isValid()) ? Qt({
            from: this,
            to: e
          }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
        }, bn.toNow = function (e) {
          return this.to(Rt(), e);
        }, bn.get = function (e) {
          return I(this[e = O(e)]) ? this[e]() : this;
        }, bn.invalidAt = function () {
          return p(this).overflow;
        }, bn.isAfter = function (e, t) {
          var n = w(e) ? e : Rt(e);
          return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = O(t) || "millisecond") ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf());
        }, bn.isBefore = function (e, t) {
          var n = w(e) ? e : Rt(e);
          return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = O(t) || "millisecond") ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf());
        }, bn.isBetween = function (e, t, n, r) {
          var i = w(e) ? e : Rt(e),
              o = w(t) ? t : Rt(t);
          return !!(this.isValid() && i.isValid() && o.isValid()) && ("(" === (r = r || "()")[0] ? this.isAfter(i, n) : !this.isBefore(i, n)) && (")" === r[1] ? this.isBefore(o, n) : !this.isAfter(o, n));
        }, bn.isSame = function (e, t) {
          var n,
              r = w(e) ? e : Rt(e);
          return !(!this.isValid() || !r.isValid()) && ("millisecond" === (t = O(t) || "millisecond") ? this.valueOf() === r.valueOf() : (n = r.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf()));
        }, bn.isSameOrAfter = function (e, t) {
          return this.isSame(e, t) || this.isAfter(e, t);
        }, bn.isSameOrBefore = function (e, t) {
          return this.isSame(e, t) || this.isBefore(e, t);
        }, bn.isValid = function () {
          return m(this);
        }, bn.lang = nn, bn.locale = tn, bn.localeData = rn, bn.max = Yt, bn.min = xt, bn.parsingFlags = function () {
          return d({}, p(this));
        }, bn.set = function (e, t) {
          if ("object" == typeof e) for (var n = function (e) {
            var t = [];

            for (var n in e) {
              t.push({
                unit: n,
                priority: A[n]
              });
            }

            return t.sort(function (e, t) {
              return e.priority - t.priority;
            }), t;
          }(e = F(e)), r = 0; r < n.length; r++) {
            this[n[r].unit](e[n[r].unit]);
          } else if (I(this[e = O(e)])) return this[e](t);
          return this;
        }, bn.startOf = function (e) {
          var t;
          if (void 0 === (e = O(e)) || "millisecond" === e || !this.isValid()) return this;
          var n = this._isUTC ? hn : ln;

          switch (e) {
            case "year":
              t = n(this.year(), 0, 1);
              break;

            case "quarter":
              t = n(this.year(), this.month() - this.month() % 3, 1);
              break;

            case "month":
              t = n(this.year(), this.month(), 1);
              break;

            case "week":
              t = n(this.year(), this.month(), this.date() - this.weekday());
              break;

            case "isoWeek":
              t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
              break;

            case "day":
            case "date":
              t = n(this.year(), this.month(), this.date());
              break;

            case "hour":
              t = this._d.valueOf(), t -= cn(t + (this._isUTC ? 0 : this.utcOffset() * an), sn);
              break;

            case "minute":
              t = this._d.valueOf(), t -= cn(t, an);
              break;

            case "second":
              t = this._d.valueOf(), t -= cn(t, on);
          }

          return this._d.setTime(t), i.updateOffset(this, !0), this;
        }, bn.subtract = $t, bn.toArray = function () {
          var e = this;
          return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()];
        }, bn.toObject = function () {
          var e = this;
          return {
            years: e.year(),
            months: e.month(),
            date: e.date(),
            hours: e.hours(),
            minutes: e.minutes(),
            seconds: e.seconds(),
            milliseconds: e.milliseconds()
          };
        }, bn.toDate = function () {
          return new Date(this.valueOf());
        }, bn.toISOString = function (e) {
          if (!this.isValid()) return null;
          var t = !0 !== e,
              n = t ? this.clone().utc() : this;
          return n.year() < 0 || n.year() > 9999 ? z(n, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : I(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", z(n, "Z")) : z(n, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
        }, bn.inspect = function () {
          if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
          var e = "moment",
              t = "";
          this.isLocal() || (e = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", t = "Z");
          var n = "[" + e + '("]',
              r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY",
              i = t + '[")]';
          return this.format(n + r + "-MM-DD[T]HH:mm:ss.SSS" + i);
        }, bn.toJSON = function () {
          return this.isValid() ? this.toISOString() : null;
        }, bn.toString = function () {
          return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
        }, bn.unix = function () {
          return Math.floor(this.valueOf() / 1e3);
        }, bn.valueOf = function () {
          return this._d.valueOf() - 6e4 * (this._offset || 0);
        }, bn.creationData = function () {
          return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
          };
        }, bn.year = De, bn.isLeapYear = function () {
          return Se(this.year());
        }, bn.weekYear = function (e) {
          return fn.call(this, e, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
        }, bn.isoWeekYear = function (e) {
          return fn.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
        }, bn.quarter = bn.quarters = function (e) {
          return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
        }, bn.month = je, bn.daysInMonth = function () {
          return Ye(this.year(), this.month());
        }, bn.week = bn.weeks = function (e) {
          var t = this.localeData().week(this);
          return null == e ? t : this.add(7 * (e - t), "d");
        }, bn.isoWeek = bn.isoWeeks = function (e) {
          var t = ze(this, 1, 4).week;
          return null == e ? t : this.add(7 * (e - t), "d");
        }, bn.weeksInYear = function () {
          var e = this.localeData()._week;

          return Ze(this.year(), e.dow, e.doy);
        }, bn.isoWeeksInYear = function () {
          return Ze(this.year(), 1, 4);
        }, bn.date = pn, bn.day = bn.days = function (e) {
          if (!this.isValid()) return null != e ? this : NaN;
          var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
          return null != e ? (e = function (e, t) {
            return "string" != typeof e ? e : isNaN(e) ? "number" == typeof (e = t.weekdaysParse(e)) ? e : null : parseInt(e, 10);
          }(e, this.localeData()), this.add(e - t, "d")) : t;
        }, bn.weekday = function (e) {
          if (!this.isValid()) return null != e ? this : NaN;
          var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
          return null == e ? t : this.add(e - t, "d");
        }, bn.isoWeekday = function (e) {
          if (!this.isValid()) return null != e ? this : NaN;

          if (null != e) {
            var t = function (e, t) {
              return "string" == typeof e ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
            }(e, this.localeData());

            return this.day(this.day() % 7 ? t : t - 7);
          }

          return this.day() || 7;
        }, bn.dayOfYear = function (e) {
          var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
          return null == e ? t : this.add(e - t, "d");
        }, bn.hour = bn.hours = ot, bn.minute = bn.minutes = mn, bn.second = bn.seconds = yn, bn.millisecond = bn.milliseconds = gn, bn.utcOffset = function (e, t, n) {
          var r,
              o = this._offset || 0;
          if (!this.isValid()) return null != e ? this : NaN;

          if (null != e) {
            if ("string" == typeof e) {
              if (null === (e = Vt(se, e))) return this;
            } else Math.abs(e) < 16 && !n && (e *= 60);

            return !this._isUTC && t && (r = Ht(this)), this._offset = e, this._isUTC = !0, null != r && this.add(r, "m"), o !== e && (!t || this._changeInProgress ? Xt(this, Qt(e - o, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, i.updateOffset(this, !0), this._changeInProgress = null)), this;
          }

          return this._isUTC ? o : Ht(this);
        }, bn.utc = function (e) {
          return this.utcOffset(0, e);
        }, bn.local = function (e) {
          return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Ht(this), "m")), this;
        }, bn.parseZone = function () {
          if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);else if ("string" == typeof this._i) {
            var e = Vt(ae, this._i);
            null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
          }
          return this;
        }, bn.hasAlignedHourOffset = function (e) {
          return !!this.isValid() && (e = e ? Rt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 == 0);
        }, bn.isDST = function () {
          return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
        }, bn.isLocal = function () {
          return !!this.isValid() && !this._isUTC;
        }, bn.isUtcOffset = function () {
          return !!this.isValid() && this._isUTC;
        }, bn.isUtc = Bt, bn.isUTC = Bt, bn.zoneAbbr = function () {
          return this._isUTC ? "UTC" : "";
        }, bn.zoneName = function () {
          return this._isUTC ? "Coordinated Universal Time" : "";
        }, bn.dates = L("dates accessor is deprecated. Use date instead.", pn), bn.months = L("months accessor is deprecated. Use month instead", je), bn.years = L("years accessor is deprecated. Use year instead", De), bn.zone = L("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function (e, t) {
          return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
        }), bn.isDSTShifted = L("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function () {
          if (!s(this._isDSTShifted)) return this._isDSTShifted;
          var e = {};

          if (v(e, this), (e = Dt(e))._a) {
            var t = e._isUTC ? f(e._a) : Rt(e._a);
            this._isDSTShifted = this.isValid() && E(e._a, t.toArray()) > 0;
          } else this._isDSTShifted = !1;

          return this._isDSTShifted;
        });
        var Tn = x.prototype;

        function Mn(e, t, n, r) {
          var i = ft(),
              o = f().set(r, t);
          return i[n](o, e);
        }

        function En(e, t, n) {
          if (u(e) && (t = e, e = void 0), e = e || "", null != t) return Mn(e, t, n, "month");
          var r,
              i = [];

          for (r = 0; r < 12; r++) {
            i[r] = Mn(e, r, n, "month");
          }

          return i;
        }

        function kn(e, t, n, r) {
          "boolean" == typeof e ? (u(t) && (n = t, t = void 0), t = t || "") : (n = t = e, e = !1, u(t) && (n = t, t = void 0), t = t || "");
          var i,
              o = ft(),
              a = e ? o._week.dow : 0;
          if (null != n) return Mn(t, (n + a) % 7, r, "day");
          var s = [];

          for (i = 0; i < 7; i++) {
            s[i] = Mn(t, (i + a) % 7, r, "day");
          }

          return s;
        }

        Tn.calendar = function (e, t, n) {
          var r = this._calendar[e] || this._calendar.sameElse;
          return I(r) ? r.call(t, n) : r;
        }, Tn.longDateFormat = function (e) {
          var t = this._longDateFormat[e],
              n = this._longDateFormat[e.toUpperCase()];

          return t || !n ? t : (this._longDateFormat[e] = n.replace(/MMMM|MM|DD|dddd/g, function (e) {
            return e.slice(1);
          }), this._longDateFormat[e]);
        }, Tn.invalidDate = function () {
          return this._invalidDate;
        }, Tn.ordinal = function (e) {
          return this._ordinal.replace("%d", e);
        }, Tn.preparse = wn, Tn.postformat = wn, Tn.relativeTime = function (e, t, n, r) {
          var i = this._relativeTime[n];
          return I(i) ? i(e, t, n, r) : i.replace(/%d/i, e);
        }, Tn.pastFuture = function (e, t) {
          var n = this._relativeTime[e > 0 ? "future" : "past"];
          return I(n) ? n(t) : n.replace(/%s/i, t);
        }, Tn.set = function (e) {
          var t, n;

          for (n in e) {
            I(t = e[n]) ? this[n] = t : this["_" + n] = t;
          }

          this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
        }, Tn.months = function (e, t) {
          return e ? o(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Ce).test(t) ? "format" : "standalone"][e.month()] : o(this._months) ? this._months : this._months.standalone;
        }, Tn.monthsShort = function (e, t) {
          return e ? o(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Ce.test(t) ? "format" : "standalone"][e.month()] : o(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
        }, Tn.monthsParse = function (e, t, n) {
          var r, i, o;
          if (this._monthsParseExact) return function (e, t, n) {
            var r,
                i,
                o,
                a = e.toLocaleLowerCase();
            if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r) {
              o = f([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(o, "").toLocaleLowerCase(), this._longMonthsParse[r] = this.months(o, "").toLocaleLowerCase();
            }
            return n ? "MMM" === t ? -1 !== (i = Ne.call(this._shortMonthsParse, a)) ? i : null : -1 !== (i = Ne.call(this._longMonthsParse, a)) ? i : null : "MMM" === t ? -1 !== (i = Ne.call(this._shortMonthsParse, a)) ? i : -1 !== (i = Ne.call(this._longMonthsParse, a)) ? i : null : -1 !== (i = Ne.call(this._longMonthsParse, a)) ? i : -1 !== (i = Ne.call(this._shortMonthsParse, a)) ? i : null;
          }.call(this, e, t, n);

          for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
            if (i = f([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp("^" + this.months(i, "").replace(".", "") + "$", "i"), this._shortMonthsParse[r] = new RegExp("^" + this.monthsShort(i, "").replace(".", "") + "$", "i")), n || this._monthsParse[r] || (o = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[r] = new RegExp(o.replace(".", ""), "i")), n && "MMMM" === t && this._longMonthsParse[r].test(e)) return r;
            if (n && "MMM" === t && this._shortMonthsParse[r].test(e)) return r;
            if (!n && this._monthsParse[r].test(e)) return r;
          }
        }, Tn.monthsRegex = function (e) {
          return this._monthsParseExact ? (h(this, "_monthsRegex") || Ve.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (h(this, "_monthsRegex") || (this._monthsRegex = Pe), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
        }, Tn.monthsShortRegex = function (e) {
          return this._monthsParseExact ? (h(this, "_monthsRegex") || Ve.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (h(this, "_monthsShortRegex") || (this._monthsShortRegex = Ue), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
        }, Tn.week = function (e) {
          return ze(e, this._week.dow, this._week.doy).week;
        }, Tn.firstDayOfYear = function () {
          return this._week.doy;
        }, Tn.firstDayOfWeek = function () {
          return this._week.dow;
        }, Tn.weekdays = function (e, t) {
          var n = o(this._weekdays) ? this._weekdays : this._weekdays[e && !0 !== e && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
          return !0 === e ? Qe(n, this._week.dow) : e ? n[e.day()] : n;
        }, Tn.weekdaysMin = function (e) {
          return !0 === e ? Qe(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
        }, Tn.weekdaysShort = function (e) {
          return !0 === e ? Qe(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
        }, Tn.weekdaysParse = function (e, t, n) {
          var r, i, o;
          if (this._weekdaysParseExact) return function (e, t, n) {
            var r,
                i,
                o,
                a = e.toLocaleLowerCase();
            if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r) {
              o = f([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(o, "").toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(o, "").toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(o, "").toLocaleLowerCase();
            }
            return n ? "dddd" === t ? -1 !== (i = Ne.call(this._weekdaysParse, a)) ? i : null : "ddd" === t ? -1 !== (i = Ne.call(this._shortWeekdaysParse, a)) ? i : null : -1 !== (i = Ne.call(this._minWeekdaysParse, a)) ? i : null : "dddd" === t ? -1 !== (i = Ne.call(this._weekdaysParse, a)) ? i : -1 !== (i = Ne.call(this._shortWeekdaysParse, a)) ? i : -1 !== (i = Ne.call(this._minWeekdaysParse, a)) ? i : null : "ddd" === t ? -1 !== (i = Ne.call(this._shortWeekdaysParse, a)) ? i : -1 !== (i = Ne.call(this._weekdaysParse, a)) ? i : -1 !== (i = Ne.call(this._minWeekdaysParse, a)) ? i : null : -1 !== (i = Ne.call(this._minWeekdaysParse, a)) ? i : -1 !== (i = Ne.call(this._weekdaysParse, a)) ? i : -1 !== (i = Ne.call(this._shortWeekdaysParse, a)) ? i : null;
          }.call(this, e, t, n);

          for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
            if (i = f([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp("^" + this.weekdays(i, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[r] = new RegExp("^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[r] = new RegExp("^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[r] || (o = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[r] = new RegExp(o.replace(".", ""), "i")), n && "dddd" === t && this._fullWeekdaysParse[r].test(e)) return r;
            if (n && "ddd" === t && this._shortWeekdaysParse[r].test(e)) return r;
            if (n && "dd" === t && this._minWeekdaysParse[r].test(e)) return r;
            if (!n && this._weekdaysParse[r].test(e)) return r;
          }
        }, Tn.weekdaysRegex = function (e) {
          return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || et.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (h(this, "_weekdaysRegex") || (this._weekdaysRegex = Xe), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
        }, Tn.weekdaysShortRegex = function (e) {
          return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || et.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (h(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Ke), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
        }, Tn.weekdaysMinRegex = function (e) {
          return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || et.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (h(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = $e), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
        }, Tn.isPM = function (e) {
          return "p" === (e + "").toLowerCase().charAt(0);
        }, Tn.meridiem = function (e, t, n) {
          return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
        }, ht("en", {
          dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
          ordinal: function ordinal(e) {
            var t = e % 10,
                n = 1 === M(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
            return e + n;
          }
        }), i.lang = L("moment.lang is deprecated. Use moment.locale instead.", ht), i.langData = L("moment.langData is deprecated. Use moment.localeData instead.", ft);
        var Ln = Math.abs;

        function Sn(e, t, n, r) {
          var i = Qt(t, n);
          return e._milliseconds += r * i._milliseconds, e._days += r * i._days, e._months += r * i._months, e._bubble();
        }

        function Nn(e) {
          return e < 0 ? Math.floor(e) : Math.ceil(e);
        }

        function Dn(e) {
          return 4800 * e / 146097;
        }

        function In(e) {
          return 146097 * e / 4800;
        }

        function Rn(e) {
          return function () {
            return this.as(e);
          };
        }

        var xn = Rn("ms"),
            Yn = Rn("s"),
            Cn = Rn("m"),
            On = Rn("h"),
            Fn = Rn("d"),
            An = Rn("w"),
            jn = Rn("M"),
            Un = Rn("Q"),
            Pn = Rn("y");

        function Vn(e) {
          return function () {
            return this.isValid() ? this._data[e] : NaN;
          };
        }

        var Wn = Vn("milliseconds"),
            Hn = Vn("seconds"),
            Bn = Vn("minutes"),
            zn = Vn("hours"),
            Zn = Vn("days"),
            Qn = Vn("months"),
            Gn = Vn("years"),
            qn = Math.round,
            Jn = {
          ss: 44,
          s: 45,
          m: 45,
          h: 22,
          d: 26,
          M: 11
        },
            Xn = Math.abs;

        function Kn(e) {
          return (e > 0) - (e < 0) || +e;
        }

        function $n() {
          if (!this.isValid()) return this.localeData().invalidDate();
          var e,
              t,
              n = Xn(this._milliseconds) / 1e3,
              r = Xn(this._days),
              i = Xn(this._months);
          e = T(n / 60), t = T(e / 60), n %= 60, e %= 60;
          var o = T(i / 12),
              a = i %= 12,
              s = r,
              u = t,
              c = e,
              l = n ? n.toFixed(3).replace(/\.?0+$/, "") : "",
              h = this.asSeconds();
          if (!h) return "P0D";
          var d = h < 0 ? "-" : "",
              f = Kn(this._months) !== Kn(h) ? "-" : "",
              p = Kn(this._days) !== Kn(h) ? "-" : "",
              m = Kn(this._milliseconds) !== Kn(h) ? "-" : "";
          return d + "P" + (o ? f + o + "Y" : "") + (a ? f + a + "M" : "") + (s ? p + s + "D" : "") + (u || c || l ? "T" : "") + (u ? m + u + "H" : "") + (c ? m + c + "M" : "") + (l ? m + l + "S" : "");
        }

        var er = Ft.prototype;
        return er.isValid = function () {
          return this._isValid;
        }, er.abs = function () {
          var e = this._data;
          return this._milliseconds = Ln(this._milliseconds), this._days = Ln(this._days), this._months = Ln(this._months), e.milliseconds = Ln(e.milliseconds), e.seconds = Ln(e.seconds), e.minutes = Ln(e.minutes), e.hours = Ln(e.hours), e.months = Ln(e.months), e.years = Ln(e.years), this;
        }, er.add = function (e, t) {
          return Sn(this, e, t, 1);
        }, er.subtract = function (e, t) {
          return Sn(this, e, t, -1);
        }, er.as = function (e) {
          if (!this.isValid()) return NaN;
          var t,
              n,
              r = this._milliseconds;
          if ("month" === (e = O(e)) || "quarter" === e || "year" === e) switch (t = this._days + r / 864e5, n = this._months + Dn(t), e) {
            case "month":
              return n;

            case "quarter":
              return n / 3;

            case "year":
              return n / 12;
          } else switch (t = this._days + Math.round(In(this._months)), e) {
            case "week":
              return t / 7 + r / 6048e5;

            case "day":
              return t + r / 864e5;

            case "hour":
              return 24 * t + r / 36e5;

            case "minute":
              return 1440 * t + r / 6e4;

            case "second":
              return 86400 * t + r / 1e3;

            case "millisecond":
              return Math.floor(864e5 * t) + r;

            default:
              throw new Error("Unknown unit " + e);
          }
        }, er.asMilliseconds = xn, er.asSeconds = Yn, er.asMinutes = Cn, er.asHours = On, er.asDays = Fn, er.asWeeks = An, er.asMonths = jn, er.asQuarters = Un, er.asYears = Pn, er.valueOf = function () {
          return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * M(this._months / 12) : NaN;
        }, er._bubble = function () {
          var e,
              t,
              n,
              r,
              i,
              o = this._milliseconds,
              a = this._days,
              s = this._months,
              u = this._data;
          return o >= 0 && a >= 0 && s >= 0 || o <= 0 && a <= 0 && s <= 0 || (o += 864e5 * Nn(In(s) + a), a = 0, s = 0), u.milliseconds = o % 1e3, e = T(o / 1e3), u.seconds = e % 60, t = T(e / 60), u.minutes = t % 60, n = T(t / 60), u.hours = n % 24, a += T(n / 24), i = T(Dn(a)), s += i, a -= Nn(In(i)), r = T(s / 12), s %= 12, u.days = a, u.months = s, u.years = r, this;
        }, er.clone = function () {
          return Qt(this);
        }, er.get = function (e) {
          return e = O(e), this.isValid() ? this[e + "s"]() : NaN;
        }, er.milliseconds = Wn, er.seconds = Hn, er.minutes = Bn, er.hours = zn, er.days = Zn, er.weeks = function () {
          return T(this.days() / 7);
        }, er.months = Qn, er.years = Gn, er.humanize = function (e) {
          if (!this.isValid()) return this.localeData().invalidDate();

          var t = this.localeData(),
              n = function (e, t, n) {
            var r = Qt(e).abs(),
                i = qn(r.as("s")),
                o = qn(r.as("m")),
                a = qn(r.as("h")),
                s = qn(r.as("d")),
                u = qn(r.as("M")),
                c = qn(r.as("y")),
                l = i <= Jn.ss && ["s", i] || i < Jn.s && ["ss", i] || o <= 1 && ["m"] || o < Jn.m && ["mm", o] || a <= 1 && ["h"] || a < Jn.h && ["hh", a] || s <= 1 && ["d"] || s < Jn.d && ["dd", s] || u <= 1 && ["M"] || u < Jn.M && ["MM", u] || c <= 1 && ["y"] || ["yy", c];
            return l[2] = t, l[3] = +e > 0, l[4] = n, function (e, t, n, r, i) {
              return i.relativeTime(t || 1, !!n, e, r);
            }.apply(null, l);
          }(this, !e, t);

          return e && (n = t.pastFuture(+this, n)), t.postformat(n);
        }, er.toISOString = $n, er.toString = $n, er.toJSON = $n, er.locale = tn, er.localeData = rn, er.toIsoString = L("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", $n), er.lang = nn, B("X", 0, 0, "unix"), B("x", 0, 0, "valueOf"), le("x", oe), le("X", /[+-]?\d+(\.\d{1,3})?/), pe("X", function (e, t, n) {
          n._d = new Date(1e3 * parseFloat(e, 10));
        }), pe("x", function (e, t, n) {
          n._d = new Date(M(e));
        }), i.version = "2.24.0", t = Rt, i.fn = bn, i.min = function () {
          return Ct("isBefore", [].slice.call(arguments, 0));
        }, i.max = function () {
          return Ct("isAfter", [].slice.call(arguments, 0));
        }, i.now = function () {
          return Date.now ? Date.now() : +new Date();
        }, i.utc = f, i.unix = function (e) {
          return Rt(1e3 * e);
        }, i.months = function (e, t) {
          return En(e, t, "months");
        }, i.isDate = c, i.locale = ht, i.invalid = _, i.duration = Qt, i.isMoment = w, i.weekdays = function (e, t, n) {
          return kn(e, t, n, "weekdays");
        }, i.parseZone = function () {
          return Rt.apply(null, arguments).parseZone();
        }, i.localeData = ft, i.isDuration = At, i.monthsShort = function (e, t) {
          return En(e, t, "monthsShort");
        }, i.weekdaysMin = function (e, t, n) {
          return kn(e, t, n, "weekdaysMin");
        }, i.defineLocale = dt, i.updateLocale = function (e, t) {
          if (null != t) {
            var n,
                r,
                i = at;
            null != (r = lt(e)) && (i = r._config), t = R(i, t), (n = new x(t)).parentLocale = st[e], st[e] = n, ht(e);
          } else null != st[e] && (null != st[e].parentLocale ? st[e] = st[e].parentLocale : null != st[e] && delete st[e]);

          return st[e];
        }, i.locales = function () {
          return S(st);
        }, i.weekdaysShort = function (e, t, n) {
          return kn(e, t, n, "weekdaysShort");
        }, i.normalizeUnits = O, i.relativeTimeRounding = function (e) {
          return void 0 === e ? qn : "function" == typeof e && (qn = e, !0);
        }, i.relativeTimeThreshold = function (e, t) {
          return void 0 !== Jn[e] && (void 0 === t ? Jn[e] : (Jn[e] = t, "s" === e && (Jn.ss = t - 1), !0));
        }, i.calendarFormat = function (e, t) {
          var n = e.diff(t, "days", !0);
          return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
        }, i.prototype = bn, i.HTML5_FMT = {
          DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
          DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
          DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
          DATE: "YYYY-MM-DD",
          TIME: "HH:mm",
          TIME_SECONDS: "HH:mm:ss",
          TIME_MS: "HH:mm:ss.SSS",
          WEEK: "GGGG-[W]WW",
          MONTH: "YYYY-MM"
        }, i;
      }();
    }).call(this, n(47)(e));
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "__extends", function () {
      return i;
    }), n.d(t, "__assign", function () {
      return _o2;
    }), n.d(t, "__rest", function () {
      return a;
    }), n.d(t, "__decorate", function () {
      return s;
    }), n.d(t, "__param", function () {
      return u;
    }), n.d(t, "__metadata", function () {
      return c;
    }), n.d(t, "__awaiter", function () {
      return l;
    }), n.d(t, "__generator", function () {
      return h;
    }), n.d(t, "__exportStar", function () {
      return d;
    }), n.d(t, "__values", function () {
      return f;
    }), n.d(t, "__read", function () {
      return p;
    }), n.d(t, "__spread", function () {
      return m;
    }), n.d(t, "__spreadArrays", function () {
      return _;
    }), n.d(t, "__await", function () {
      return y;
    }), n.d(t, "__asyncGenerator", function () {
      return v;
    }), n.d(t, "__asyncDelegator", function () {
      return g;
    }), n.d(t, "__asyncValues", function () {
      return b;
    }), n.d(t, "__makeTemplateObject", function () {
      return w;
    }), n.d(t, "__importStar", function () {
      return T;
    }), n.d(t, "__importDefault", function () {
      return M;
    }), n.d(t, "__classPrivateFieldGet", function () {
      return E;
    }), n.d(t, "__classPrivateFieldSet", function () {
      return k;
    });
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0
    
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.
    
    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var _r2 = function r(e, t) {
      return (_r2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    };

    function i(e, t) {
      function n() {
        this.constructor = e;
      }

      _r2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }

    var _o2 = function o() {
      return (_o2 = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var i in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          }
        }

        return e;
      }).apply(this, arguments);
    };

    function a(e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;

        for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) {
          t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
        }
      }

      return n;
    }

    function s(e, t, n, r) {
      var i,
          o = arguments.length,
          a = o < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (i = e[s]) && (a = (o < 3 ? i(a) : o > 3 ? i(t, n, a) : i(t, n)) || a);
      }
      return o > 3 && a && Object.defineProperty(t, n, a), a;
    }

    function u(e, t) {
      return function (n, r) {
        t(n, r, e);
      };
    }

    function c(e, t) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
    }

    function l(e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(r.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          var t;
          e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    }

    function h(e, t) {
      var n,
          r,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;

                switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    }

    function d(e, t) {
      for (var n in e) {
        t.hasOwnProperty(n) || (t[n] = e[n]);
      }
    }

    function f(e) {
      var t = "function" == typeof Symbol && Symbol.iterator,
          n = t && e[t],
          r = 0;
      if (n) return n.call(e);
      if (e && "number" == typeof e.length) return {
        next: function next() {
          return e && r >= e.length && (e = void 0), {
            value: e && e[r++],
            done: !e
          };
        }
      };
      throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function p(e, t) {
      var n = "function" == typeof Symbol && e[Symbol.iterator];
      if (!n) return e;
      var r,
          i,
          o = n.call(e),
          a = [];

      try {
        for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) {
          a.push(r.value);
        }
      } catch (e) {
        i = {
          error: e
        };
      } finally {
        try {
          r && !r.done && (n = o.return) && n.call(o);
        } finally {
          if (i) throw i.error;
        }
      }

      return a;
    }

    function m() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e = e.concat(p(arguments[t]));
      }

      return e;
    }

    function _() {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }

      var r = Array(e),
          i = 0;

      for (t = 0; t < n; t++) {
        for (var o = arguments[t], a = 0, s = o.length; a < s; a++, i++) {
          r[i] = o[a];
        }
      }

      return r;
    }

    function y(e) {
      return this instanceof y ? (this.v = e, this) : new y(e);
    }

    function v(e, t, n) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var r,
          i = n.apply(e, t || []),
          o = [];
      return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function () {
        return this;
      }, r;

      function a(e) {
        i[e] && (r[e] = function (t) {
          return new Promise(function (n, r) {
            o.push([e, t, n, r]) > 1 || s(e, t);
          });
        });
      }

      function s(e, t) {
        try {
          (n = i[e](t)).value instanceof y ? Promise.resolve(n.value.v).then(u, c) : l(o[0][2], n);
        } catch (e) {
          l(o[0][3], e);
        }

        var n;
      }

      function u(e) {
        s("next", e);
      }

      function c(e) {
        s("throw", e);
      }

      function l(e, t) {
        e(t), o.shift(), o.length && s(o[0][0], o[0][1]);
      }
    }

    function g(e) {
      var t, n;
      return t = {}, r("next"), r("throw", function (e) {
        throw e;
      }), r("return"), t[Symbol.iterator] = function () {
        return this;
      }, t;

      function r(r, i) {
        t[r] = e[r] ? function (t) {
          return (n = !n) ? {
            value: y(e[r](t)),
            done: "return" === r
          } : i ? i(t) : t;
        } : i;
      }
    }

    function b(e) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var t,
          n = e[Symbol.asyncIterator];
      return n ? n.call(e) : (e = f(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
        return this;
      }, t);

      function r(n) {
        t[n] = e[n] && function (t) {
          return new Promise(function (r, i) {
            (function (e, t, n, r) {
              Promise.resolve(r).then(function (t) {
                e({
                  value: t,
                  done: n
                });
              }, t);
            })(r, i, (t = e[n](t)).done, t.value);
          });
        };
      }
    }

    function w(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }

    function T(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }

    function M(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function E(e, t) {
      if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
      return t.get(e);
    }

    function k(e, t, n) {
      if (!t.has(e)) throw new TypeError("attempted to set private field on non-instance");
      return t.set(e, n), n;
    }
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r,
        i,
        o = n(3),
        a = n(16),
        s = n(13),
        u = n(25),
        c = ((r = {})["no-app"] = "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()", r["bad-app-name"] = "Illegal App name: '{$appName}", r["duplicate-app"] = "Firebase App named '{$appName}' already exists", r["app-deleted"] = "Firebase App named '{$appName}' already deleted", r["invalid-app-argument"] = "firebase.{$appName}() takes either no argument or a Firebase App instance.", r["invalid-log-argument"] = "First argument to `onLog` must be null or a function.", r),
        l = new a.ErrorFactory("app", "Firebase", c),
        h = "@firebase/app",
        d = "0.6.3",
        f = "[DEFAULT]",
        p = ((i = {})[h] = "fire-core", i["@firebase/analytics"] = "fire-analytics", i["@firebase/auth"] = "fire-auth", i["@firebase/database"] = "fire-rtdb", i["@firebase/functions"] = "fire-fn", i["@firebase/installations"] = "fire-iid", i["@firebase/messaging"] = "fire-fcm", i["@firebase/performance"] = "fire-perf", i["@firebase/remote-config"] = "fire-rc", i["@firebase/storage"] = "fire-gcs", i["@firebase/firestore"] = "fire-fst", i["fire-js"] = "fire-js", i["firebase-wrapper"] = "fire-js-all", i),
        m = new u.Logger("@firebase/app"),
        _ = function () {
      function e(e, t, n) {
        var r,
            i,
            u = this;
        this.firebase_ = n, this.isDeleted_ = !1, this.name_ = t.name, this.automaticDataCollectionEnabled_ = t.automaticDataCollectionEnabled || !1, this.options_ = a.deepCopy(e), this.container = new s.ComponentContainer(t.name), this._addComponent(new s.Component("app", function () {
          return u;
        }, "PUBLIC"));

        try {
          for (var c = o.__values(this.firebase_.INTERNAL.components.values()), l = c.next(); !l.done; l = c.next()) {
            var h = l.value;

            this._addComponent(h);
          }
        } catch (e) {
          r = {
            error: e
          };
        } finally {
          try {
            l && !l.done && (i = c.return) && i.call(c);
          } finally {
            if (r) throw r.error;
          }
        }
      }

      return Object.defineProperty(e.prototype, "automaticDataCollectionEnabled", {
        get: function get() {
          return this.checkDestroyed_(), this.automaticDataCollectionEnabled_;
        },
        set: function set(e) {
          this.checkDestroyed_(), this.automaticDataCollectionEnabled_ = e;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "name", {
        get: function get() {
          return this.checkDestroyed_(), this.name_;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "options", {
        get: function get() {
          return this.checkDestroyed_(), this.options_;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.delete = function () {
        var e = this;
        return new Promise(function (t) {
          e.checkDestroyed_(), t();
        }).then(function () {
          return e.firebase_.INTERNAL.removeApp(e.name_), Promise.all(e.container.getProviders().map(function (e) {
            return e.delete();
          }));
        }).then(function () {
          e.isDeleted_ = !0;
        });
      }, e.prototype._getService = function (e, t) {
        return void 0 === t && (t = f), this.checkDestroyed_(), this.container.getProvider(e).getImmediate({
          identifier: t
        });
      }, e.prototype._removeServiceInstance = function (e, t) {
        void 0 === t && (t = f), this.container.getProvider(e).clearInstance(t);
      }, e.prototype._addComponent = function (e) {
        try {
          this.container.addComponent(e);
        } catch (t) {
          m.debug("Component " + e.name + " failed to register with FirebaseApp " + this.name, t);
        }
      }, e.prototype._addOrOverwriteComponent = function (e) {
        this.container.addOrOverwriteComponent(e);
      }, e.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) throw l.create("app-deleted", {
          appName: this.name_
        });
      }, e;
    }();

    _.prototype.name && _.prototype.options || _.prototype.delete || console.log("dc");
    var y = "7.14.3";
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    var v =
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
    function e() {
      var t = function (e) {
        var t = {},
            n = new Map(),
            r = {
          __esModule: !0,
          initializeApp: function initializeApp(n, i) {
            if (void 0 === i && (i = {}), "object" != typeof i || null === i) {
              var o = i;
              i = {
                name: o
              };
            }

            var s = i;
            void 0 === s.name && (s.name = f);
            var u = s.name;
            if ("string" != typeof u || !u) throw l.create("bad-app-name", {
              appName: String(u)
            });
            if (a.contains(t, u)) throw l.create("duplicate-app", {
              appName: u
            });
            var c = new e(n, s, r);
            return t[u] = c, c;
          },
          app: i,
          registerVersion: function registerVersion(e, t, n) {
            var r,
                i = null !== (r = p[e]) && void 0 !== r ? r : e;
            n && (i += "-" + n);
            var o = i.match(/\s|\//),
                a = t.match(/\s|\//);

            if (o || a) {
              var u = ['Unable to register library "' + i + '" with version "' + t + '":'];
              return o && u.push('library name "' + i + '" contains illegal characters (whitespace or "/")'), o && a && u.push("and"), a && u.push('version name "' + t + '" contains illegal characters (whitespace or "/")'), void m.warn(u.join(" "));
            }

            c(new s.Component(i + "-version", function () {
              return {
                library: i,
                version: t
              };
            }, "VERSION"));
          },
          setLogLevel: u.setLogLevel,
          onLog: function onLog(e, t) {
            if (null !== e && "function" != typeof e) throw l.create("invalid-log-argument", {
              appName: name
            });
            u.setUserLogHandler(e, t);
          },
          apps: null,
          SDK_VERSION: y,
          INTERNAL: {
            registerComponent: c,
            removeApp: function removeApp(e) {
              delete t[e];
            },
            components: n,
            useAsService: function useAsService(e, t) {
              return "serverAuth" === t ? null : t;
            }
          }
        };

        function i(e) {
          if (e = e || f, !a.contains(t, e)) throw l.create("no-app", {
            appName: e
          });
          return t[e];
        }

        function c(s) {
          var u,
              c,
              h = s.name;
          if (n.has(h)) return m.debug("There were multiple attempts to register component " + h + "."), "PUBLIC" === s.type ? r[h] : null;

          if (n.set(h, s), "PUBLIC" === s.type) {
            var d = function d(e) {
              if (void 0 === e && (e = i()), "function" != typeof e[h]) throw l.create("invalid-app-argument", {
                appName: h
              });
              return e[h]();
            };

            void 0 !== s.serviceProps && a.deepExtend(d, s.serviceProps), r[h] = d, e.prototype[h] = function () {
              for (var e = [], t = 0; t < arguments.length; t++) {
                e[t] = arguments[t];
              }

              return this._getService.bind(this, h).apply(this, s.multipleInstances ? e : []);
            };
          }

          try {
            for (var f = o.__values(Object.keys(t)), p = f.next(); !p.done; p = f.next()) {
              var _ = p.value;

              t[_]._addComponent(s);
            }
          } catch (e) {
            u = {
              error: e
            };
          } finally {
            try {
              p && !p.done && (c = f.return) && c.call(f);
            } finally {
              if (u) throw u.error;
            }
          }

          return "PUBLIC" === s.type ? r[h] : null;
        }

        return r.default = r, Object.defineProperty(r, "apps", {
          get: function get() {
            return Object.keys(t).map(function (e) {
              return t[e];
            });
          }
        }), i.App = e, r;
      }(_);

      return t.INTERNAL = o.__assign(o.__assign({}, t.INTERNAL), {
        createFirebaseNamespace: e,
        extendNamespace: function extendNamespace(e) {
          a.deepExtend(t, e);
        },
        createSubscribe: a.createSubscribe,
        ErrorFactory: a.ErrorFactory,
        deepExtend: a.deepExtend
      }), t;
    }(),
        g = function () {
      function e(e) {
        this.container = e;
      }

      return e.prototype.getPlatformInfoString = function () {
        return this.container.getProviders().map(function (e) {
          if (function (e) {
            var t = e.getComponent();
            return "VERSION" === (null == t ? void 0 : t.type);
          }
          /**
           * @license
           * Copyright 2019 Google Inc.
           *
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           *   http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           */
          (e)) {
            var t = e.getImmediate();
            return t.library + "/" + t.version;
          }

          return null;
        }).filter(function (e) {
          return e;
        }).join(" ");
      }, e;
    }();
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    if (a.isBrowser() && void 0 !== self.firebase) {
      m.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
      var b = self.firebase.SDK_VERSION;
      b && b.indexOf("LITE") >= 0 && m.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
    }

    var w = v.initializeApp;

    v.initializeApp = function () {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }

      return a.isNode() && m.warn('\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the "main" field in package.json.\n      \n      If you are using Webpack, you can specify "main" as the first item in\n      "resolve.mainFields":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify "main"\n      as the first item in "mainFields", e.g. [\'main\', \'module\'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      '), w.apply(void 0, e);
    };

    var T = v;
    !function (e, t) {
      e.INTERNAL.registerComponent(new s.Component("platform-logger", function (e) {
        return new g(e);
      }, "PRIVATE")), e.registerVersion(h, d, t), e.registerVersion("fire-js", "");
    }(T), t.default = T, t.firebase = T;
  }, function (e, t, n) {
    "use strict";

    var r = /&|[(]|[)]|[a-zA-Z_0-9-]+|[|]|[~]/g,
        i = /[a-zA-Z_0-9]+/,
        o = function o(e) {
      var t;

      switch (e) {
        case "true":
        case "false":
          t = function t() {
            return "true" === e;
          };

          break;

        default:
          t = function t(_t2) {
            return _t2(e);
          };

      }

      return {
        evaluate: t
      };
    },
        a = function a(e) {
      if (void 0 === e) throw Error("Error while parsing expression");
      return e;
    },
        s = {
      "&": function _(e, t) {
        return {
          evaluate: function evaluate(n) {
            return e.evaluate(n) && t.evaluate(n);
          }
        };
      },
      "|": function _(e, t) {
        return {
          evaluate: function evaluate(n) {
            return e.evaluate(n) || t.evaluate(n);
          }
        };
      }
    },
        u = function u(e) {
      var t = [],
          n = [],
          u = function u() {
        var e = t.pop();
        if (!e) throw Error("Error while parsing expression");

        if ("~" === e) {
          var _e2 = a(n.pop());

          n.push(function (e) {
            return {
              evaluate: function evaluate(t) {
                return !e.evaluate(t);
              }
            };
          }(_e2));
        } else {
          var _t3 = a(n.pop()),
              _r3 = a(n.pop());

          n.push(s[e](_r3, _t3));
        }
      };

      if (!e) return o("");

      for (function (e) {
        return _toConsumableArray(e.matchAll(r)).map(function (e) {
          return e[0];
        });
      }(e).forEach(function (e) {
        switch (e) {
          case "(":
          case "~":
            t.push(e);
            break;

          case ")":
            for (; "(" !== t[t.length - 1];) {
              u();
            }

            t.pop();
            break;

          case "&":
          case "|":
            for (; t.length > 0 && "(" !== t[t.length - 1];) {
              u();
            }

            t.push(e);
            break;

          default:
            (function (e) {
              if (!i.test(e)) throw Error("Error while parsing expression");
              n.push(o(e));
            })(e);

        }
      }); t.length > 0;) {
        u();
      }

      if (1 !== n.length) throw Error("Error while parsing expression");
      return n.pop();
    };

    var c = n(0),
        l = n.n(c),
        h = n(4),
        d = n(8),
        f = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Permissions\\PermissionsProvider.tsx";
    var p = l.a.createContext({
      permissions: new Set(),
      refresh: function refresh() {}
    });
    var m = new Set([]);

    function _(_ref) {
      var e = _ref.children;

      var _Object = Object(c.useState)(m),
          _Object2 = _slicedToArray(_Object, 2),
          t = _Object2[0],
          n = _Object2[1],
          r = Object(c.useCallback)(function _callee2() {
        var e;
        return _regeneratorRuntime.async(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _regeneratorRuntime.awrap(function _callee() {
                  return _regeneratorRuntime.async(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _regeneratorRuntime.awrap(Object(d.y)().getResources([new h.Requests.PermissionRequest({
                            filter: {
                              category: "ContactPortal"
                            }
                          })]));

                        case 2:
                          _context.t0 = function (e) {
                            return e.id;
                          };

                          return _context.abrupt("return", _context.sent[0].data.map(_context.t0));

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  });
                }());

              case 2:
                e = _context2.sent;
                n(new Set(e));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        });
      }, []);

      Object(c.useEffect)(function () {
        r();
      }, []);
      var i = Object(c.useMemo)(function () {
        return {
          refresh: r,
          permissions: t
        };
      }, [t, r]);
      return l.a.createElement(p.Provider, {
        value: i,
        __source: {
          fileName: f,
          lineNumber: 49
        },
        __self: this
      }, e);
    }

    var y = function y() {
      var _Object3 = Object(c.useContext)(p),
          e = _Object3.permissions,
          t = _Object3.refresh;

      return Object(c.useMemo)(function () {
        function n(t) {
          return "" === t || e.has(t);
        }

        return {
          permissions: e,
          hasPermission: n,
          filterByPermissions: function filterByPermissions(e, t) {
            var r = t || function (e) {
              return e.permission;
            };

            return e.filter(function (e) {
              return u(r(e)).evaluate(n);
            });
          },
          refreshPermissions: t
        };
      }, [e, t]);
    },
        v = function v(e) {
      var _y = y(),
          t = _y.filterByPermissions;

      return Object(c.useMemo)(function () {
        return t(e);
      }, [e, t]);
    },
        g = function g(_ref2) {
      var e = _ref2.permission,
          t = _ref2.children;

      var _y2 = y(),
          n = _y2.hasPermission,
          r = Object(c.useMemo)(function () {
        return u(e);
      }, [e]),
          i = Object(c.useMemo)(function () {
        return r.evaluate(n);
      }, [r, n]);

      return "function" == typeof t ? t(i) : i ? t : null;
    };

    n.d(t, "d", function () {
      return u;
    }), n.d(t, "b", function () {
      return p;
    }), n.d(t, "c", function () {
      return _;
    }), n.d(t, "f", function () {
      return y;
    }), n.d(t, "e", function () {
      return v;
    }), n.d(t, "a", function () {
      return g;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(4);

    function i(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var o =
    /*#__PURE__*/
    function (_r$Requests$PositionT) {
      _inherits(o, _r$Requests$PositionT);

      function o(e) {
        var _this;

        _classCallCheck(this, o);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, e)), i(_assertThisInitialized(_this), "hasCompaniesContext", void 0), _this.hasCompaniesContext = !0;
        return _this;
      }

      return o;
    }(r.Requests.PositionTemplateRequest);

    var a =
    /*#__PURE__*/
    function (_r$Requests$WorksiteR) {
      _inherits(a, _r$Requests$WorksiteR);

      function a(e) {
        var _this2;

        _classCallCheck(this, a);

        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, e)), i(_assertThisInitialized(_this2), "hasCompaniesContext", void 0), _this2.hasCompaniesContext = !0;
        return _this2;
      }

      return a;
    }(r.Requests.WorksiteRequest);

    var s =
    /*#__PURE__*/
    function (_r$Requests$FacilityD) {
      _inherits(s, _r$Requests$FacilityD);

      function s(e) {
        var _this3;

        _classCallCheck(this, s);

        _this3 = _possibleConstructorReturn(this, _getPrototypeOf(s).call(this, e)), i(_assertThisInitialized(_this3), "hasCompaniesContext", void 0), _this3.hasCompaniesContext = !0;
        return _this3;
      }

      return s;
    }(r.Requests.FacilityDepartmentRequest);

    var u =
    /*#__PURE__*/
    function (_r$Requests$ShiftType) {
      _inherits(u, _r$Requests$ShiftType);

      function u(e) {
        var _this4;

        _classCallCheck(this, u);

        _this4 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, e)), i(_assertThisInitialized(_this4), "hasCompaniesContext", void 0), _this4.hasCompaniesContext = !0;
        return _this4;
      }

      return u;
    }(r.Requests.ShiftTypeRequest);

    var c =
    /*#__PURE__*/
    function (_r$Requests$Agreement) {
      _inherits(c, _r$Requests$Agreement);

      function c(e) {
        var _this5;

        _classCallCheck(this, c);

        _this5 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, e)), i(_assertThisInitialized(_this5), "hasCompaniesContext", void 0), _this5.hasCompaniesContext = !0;
        return _this5;
      }

      return c;
    }(r.Requests.AgreementRequest);

    var l =
    /*#__PURE__*/
    function (_r$Requests$Opportuni) {
      _inherits(l, _r$Requests$Opportuni);

      function l(e) {
        var _this6;

        _classCallCheck(this, l);

        _this6 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, e)), i(_assertThisInitialized(_this6), "hasCompaniesContext", void 0), _this6.hasCompaniesContext = !0;
        return _this6;
      }

      return l;
    }(r.Requests.OpportunityRequest);

    var h =
    /*#__PURE__*/
    function (_r$Requests$ContactRe) {
      _inherits(h, _r$Requests$ContactRe);

      function h(e) {
        var _this7;

        _classCallCheck(this, h);

        _this7 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, e)), i(_assertThisInitialized(_this7), "hasCompaniesContext", void 0), _this7.hasCompaniesContext = !0;
        return _this7;
      }

      return h;
    }(r.Requests.ContactRequest);

    var d =
    /*#__PURE__*/
    function (_r$Requests$ClientPro) {
      _inherits(d, _r$Requests$ClientPro);

      function d(e) {
        var _this8;

        _classCallCheck(this, d);

        _this8 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, e)), i(_assertThisInitialized(_this8), "hasCompaniesContext", void 0), _this8.hasCompaniesContext = !0;
        return _this8;
      }

      return d;
    }(r.Requests.ClientProjectRequest);

    var f =
    /*#__PURE__*/
    function (_r$Requests$QuickSear) {
      _inherits(f, _r$Requests$QuickSear);

      function f(e) {
        var _this9;

        _classCallCheck(this, f);

        _this9 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, e)), i(_assertThisInitialized(_this9), "hasCompaniesContext", void 0), _this9.hasCompaniesContext = !0;
        return _this9;
      }

      return f;
    }(r.Requests.QuickSearchRequest);

    var p =
    /*#__PURE__*/
    function (_r$Requests$PositionS) {
      _inherits(p, _r$Requests$PositionS);

      function p(e) {
        var _this10;

        _classCallCheck(this, p);

        _this10 = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, e)), i(_assertThisInitialized(_this10), "hasDataPref", void 0), _this10.hasDataPref = !0;
        return _this10;
      }

      return p;
    }(r.Requests.PositionSearchRequest);

    var m =
    /*#__PURE__*/
    function (_r$Requests$PositionS2) {
      _inherits(m, _r$Requests$PositionS2);

      function m(e) {
        var _this11;

        _classCallCheck(this, m);

        _this11 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, e)), i(_assertThisInitialized(_this11), "hasDataPref", void 0), _this11.hasDataPref = !0;
        return _this11;
      }

      return m;
    }(r.Requests.PositionSearchCountRequest);

    var _ =
    /*#__PURE__*/
    function (_r$Requests$MatchSear) {
      _inherits(_, _r$Requests$MatchSear);

      function _(e) {
        var _this12;

        _classCallCheck(this, _);

        _this12 = _possibleConstructorReturn(this, _getPrototypeOf(_).call(this, e)), i(_assertThisInitialized(_this12), "hasDataPref", void 0), _this12.hasDataPref = !0;
        return _this12;
      }

      return _;
    }(r.Requests.MatchSearchRequest);

    var y =
    /*#__PURE__*/
    function (_r$Requests$MatchSear2) {
      _inherits(y, _r$Requests$MatchSear2);

      function y(e) {
        var _this13;

        _classCallCheck(this, y);

        _this13 = _possibleConstructorReturn(this, _getPrototypeOf(y).call(this, e)), i(_assertThisInitialized(_this13), "hasDataPref", void 0), _this13.hasDataPref = !0;
        return _this13;
      }

      return y;
    }(r.Requests.MatchSearchCountRequest);

    var v =
    /*#__PURE__*/
    function (_r$Requests$ShiftSear) {
      _inherits(v, _r$Requests$ShiftSear);

      function v(e) {
        var _this14;

        _classCallCheck(this, v);

        _this14 = _possibleConstructorReturn(this, _getPrototypeOf(v).call(this, e)), i(_assertThisInitialized(_this14), "hasDataPref", void 0), _this14.hasDataPref = !0;
        return _this14;
      }

      return v;
    }(r.Requests.ShiftSearchDayCountRequest);

    var g =
    /*#__PURE__*/
    function (_r$Requests$ShiftSear2) {
      _inherits(g, _r$Requests$ShiftSear2);

      function g(e) {
        var _this15;

        _classCallCheck(this, g);

        _this15 = _possibleConstructorReturn(this, _getPrototypeOf(g).call(this, e)), i(_assertThisInitialized(_this15), "hasDataPref", void 0), _this15.hasDataPref = !0;
        return _this15;
      }

      return g;
    }(r.Requests.ShiftSearchRequest);

    var b =
    /*#__PURE__*/
    function (_r$Requests$ShiftSear3) {
      _inherits(b, _r$Requests$ShiftSear3);

      function b(e) {
        var _this16;

        _classCallCheck(this, b);

        _this16 = _possibleConstructorReturn(this, _getPrototypeOf(b).call(this, e)), i(_assertThisInitialized(_this16), "hasDataPref", void 0), _this16.hasDataPref = !0;
        return _this16;
      }

      return b;
    }(r.Requests.ShiftSearchCountRequest);

    var w = function w(e) {
      return Number(e.aboutType) === r.AboutTypes.Match;
    },
        T = function T(e) {
      return Number(e.aboutType) === r.AboutTypes.Position;
    };

    var M = n(12),
        E = n(48),
        k = n.n(E);

    var L =
    /*#__PURE__*/
    function () {
      function L() {
        _classCallCheck(this, L);
      }

      _createClass(L, [{
        key: "markNotificationsAsRead",
        value: function markNotificationsAsRead(e) {
          var t = new r.Requests.MarkUserNotificationAsReadRequest({
            messageIds: e
          });
          return Object(M.d)().createMutationRequest(t);
        }
      }, {
        key: "initialize",
        value: function initialize(e, t) {
          var n, i, o;
          return _regeneratorRuntime.async(function initialize$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  k.a.initializeApp(e);
                  n = k.a.messaging();
                  _context3.next = 4;
                  return _regeneratorRuntime.awrap(n.requestPermission());

                case 4:
                  _context3.next = 6;
                  return _regeneratorRuntime.awrap(n.getToken());

                case 6:
                  i = _context3.sent;
                  o = new r.Requests.RegisterUserNotificationDeviceRequest({
                    deviceHandle: i
                  });
                  _context3.next = 10;
                  return _regeneratorRuntime.awrap(Object(M.d)().createMutationRequest(o));

                case 10:
                  t && t();

                case 11:
                case "end":
                  return _context3.stop();
              }
            }
          });
        }
      }, {
        key: "getEnabledNotifications",
        value: function getEnabledNotifications() {
          var e = [new r.Requests.UserNotificationSettingRequest({
            filter: {
              notificationChannel: r.UserNotificationChannel.Push
            }
          })];
          return Object(M.d)().getResources(e);
        }
      }, {
        key: "setEnabledNotifications",
        value: function setEnabledNotifications(e) {
          var t;
          return _regeneratorRuntime.async(function setEnabledNotifications$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  t = e.map(function (e) {
                    return new r.Requests.UpdateUserNotificationSettingRequest({
                      notificationChannel: r.UserNotificationChannel.Push,
                      notificationType: e.notificationType,
                      enabled: e.enabled
                    });
                  });
                  _context4.next = 3;
                  return _regeneratorRuntime.awrap(Object(M.d)().createMutationRequests(t));

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          });
        }
      }, {
        key: "getHistory",
        value: function getHistory(e) {
          var t;
          return _regeneratorRuntime.async(function getHistory$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  t = [new r.Requests.UserNotificationRequest({
                    pager: e,
                    filter: {
                      notificationTypes: [],
                      notificationChannels: [r.UserNotificationChannel.Push]
                    }
                  })];
                  _context5.next = 3;
                  return _regeneratorRuntime.awrap(Object(M.d)().getResources(t));

                case 3:
                  _context5.t0 = this.mapToAppNotification;
                  return _context5.abrupt("return", _context5.sent[0].data.map(_context5.t0));

                case 5:
                case "end":
                  return _context5.stop();
              }
            }
          }, null, this);
        }
      }, {
        key: "getUnread",
        value: function getUnread(e) {
          var t;
          return _regeneratorRuntime.async(function getUnread$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  t = [new r.Requests.UserNotificationRequest({
                    pager: e,
                    filter: {
                      read: !1,
                      notificationTypes: [],
                      notificationChannels: [r.UserNotificationChannel.Push]
                    }
                  })];
                  _context6.next = 3;
                  return _regeneratorRuntime.awrap(Object(M.d)().getResources(t));

                case 3:
                  _context6.t0 = this.mapToAppNotification;
                  return _context6.abrupt("return", _context6.sent[0].data.map(_context6.t0));

                case 5:
                case "end":
                  return _context6.stop();
              }
            }
          }, null, this);
        }
      }, {
        key: "getUnreadCount",
        value: function getUnreadCount() {
          var e;
          return _regeneratorRuntime.async(function getUnreadCount$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  e = [new r.Requests.UserNotificationCountRequest({
                    filter: {
                      read: !1,
                      notificationTypes: [],
                      notificationChannels: [r.UserNotificationChannel.Push]
                    }
                  })];
                  _context7.next = 3;
                  return _regeneratorRuntime.awrap(Object(M.d)().getResources(e));

                case 3:
                  return _context7.abrupt("return", _context7.sent[0].data[0].count);

                case 4:
                case "end":
                  return _context7.stop();
              }
            }
          });
        }
      }, {
        key: "mapToAppNotification",
        value: function mapToAppNotification(e) {
          return _objectSpread({}, e, {
            id: e.id.toString(),
            createdOn: e.createdOn.toString(),
            data: e.data
          });
        }
      }]);

      return L;
    }();

    var S = null;

    function N() {
      null === S && (S = new L());
    }

    function D() {
      if (null === S) throw new Error("Notification service is not initialized!");
      return S;
    }

    var I = n(23);
    n.d(t, "l", function () {
      return o;
    }), n.d(t, "t", function () {
      return a;
    }), n.d(t, "d", function () {
      return s;
    }), n.d(t, "s", function () {
      return u;
    }), n.d(t, "a", function () {
      return c;
    }), n.d(t, "i", function () {
      return l;
    }), n.d(t, "c", function () {
      return h;
    }), n.d(t, "b", function () {
      return d;
    }), n.d(t, "m", function () {
      return f;
    }), n.d(t, "k", function () {
      return p;
    }), n.d(t, "j", function () {
      return m;
    }), n.d(t, "g", function () {
      return _;
    }), n.d(t, "f", function () {
      return y;
    }), n.d(t, "q", function () {
      return v;
    }), n.d(t, "r", function () {
      return g;
    }), n.d(t, "p", function () {
      return b;
    }), n.d(t, "z", function () {
      return w;
    }), n.d(t, "A", function () {
      return T;
    }), n.d(t, "y", function () {
      return M.d;
    }), n.d(t, "v", function () {
      return M.c;
    }), n.d(t, "n", function () {
      return M.ResourceApi;
    }), n.d(t, "o", function () {
      return M.ResourceApiUntyped;
    }), n.d(t, "u", function () {
      return N;
    }), n.d(t, "x", function () {
      return D;
    }), n.d(t, "e", function () {}), n.d(t, "h", function () {}), n.d(t, "B", function () {
      return I.b;
    }), n.d(t, "C", function () {
      return I.c;
    }), n.d(t, "w", function () {
      return I.a;
    });
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "createMessageKeys", function () {
      return r;
    }), n.d(t, "MessageKeysMock", function () {
      return i;
    });

    var r = function r(e) {
      return new Proxy(e, {
        get: function get(t, n) {
          return t[n] ? t[n] : r([].concat(_toConsumableArray(e), [n]));
        }
      });
    },
        i = new Proxy({}, {
      get: function get(e, t) {
        return r([t]);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r;
    n.d(t, "a", function () {
      return r;
    }), function (e) {
      e.counter = "counter", e.table = "table";
    }(r || (r = {}));
  }, function (e, t, n) {
    "use strict";

    n.d(t, "d", function () {
      return i;
    }), n.d(t, "c", function () {
      return o;
    }), n.d(t, "a", function () {
      return a;
    }), n.d(t, "b", function () {
      return s;
    });
    var r = null;

    function i(e) {
      r = e;
    }

    function o(e, t) {
      if (null === r) throw Error("Widget resources are not registered!");
      var n = r[e].find(function (e) {
        return e.widgetId === t;
      });
      if (void 0 === n) throw Error("Resource not found");
      return n;
    }

    function a() {
      if (null === r) throw Error("Widget resources are not registered!");
      return r;
    }

    function s(e) {
      if (null === r) throw Error("Widget resources are not registered!");
      return r[e];
    }
  }, function (e, t, n) {
    "use strict";

    var r = n(36),
        i = n(23),
        o = n(216),
        a = n.n(o);

    function s(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var u =
    /*#__PURE__*/
    function () {
      function u(e, t, n) {
        _classCallCheck(this, u);

        if (s(this, "serviceName", void 0), s(this, "axiosClient", null), this.serviceName = e, !t) throw new Error("[".concat(this.serviceName, "] Url cannot be empty or undefined during initialization!"));
        if (!n) throw new Error("[".concat(this.serviceName, "] Access token cannot be empty or undefined during initialization!"));
        this.axiosClient = a.a.create({
          baseURL: t,
          responseType: "json",
          headers: {
            Accept: "application/json"
          }
        }), this.axiosClient.defaults.headers.common.Authorization = "Bearer ".concat(n);
      }

      _createClass(u, [{
        key: "getClient",
        value: function getClient() {
          if (!this.axiosClient) throw new Error("[".concat(this.serviceName, "] Service is not initialised!"));
          return this.axiosClient;
        }
      }, {
        key: "setAccessToken",
        value: function setAccessToken(e) {
          this.getClient().defaults.headers.common.Authorization = "Bearer ".concat(e);
        }
      }]);

      return u;
    }();

    n.d(t, "c", function () {
      return h;
    }), n.d(t, "d", function () {
      return d;
    });

    var c =
    /*#__PURE__*/
    function (_u2) {
      _inherits(c, _u2);

      function c(e, t, n) {
        var _this17;

        _classCallCheck(this, c);

        var r, i, o;
        _this17 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, "ResourceApi", e, t)), o = void 0, (i = "onError") in (r = _assertThisInitialized(_this17)) ? Object.defineProperty(r, i, {
          value: o,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : r[i] = o, _this17.onError = n;
        return _this17;
      }

      _createClass(c, [{
        key: "getResources",
        value: function getResources(e) {
          var _t4, _n2;

          return _regeneratorRuntime.async(function getResources$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.prev = 0;
                  _context8.next = 3;
                  return _regeneratorRuntime.awrap(this.getClient().post("/resources", Object(r.f)(e)));

                case 3:
                  return _context8.abrupt("return", _context8.sent.data);

                case 6:
                  _context8.prev = 6;
                  _context8.t0 = _context8["catch"](0);
                  _t4 = _context8.t0, _n2 = Object(i.c)(_t4);
                  throw this.onError && this.onError(_n2), _context8.t0;

                case 10:
                case "end":
                  return _context8.stop();
              }
            }
          }, null, this, [[0, 6]]);
        }
      }, {
        key: "createMutationRequests",
        value: function createMutationRequests(e) {
          var _t5, _n3;

          return _regeneratorRuntime.async(function createMutationRequests$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.prev = 0;
                  _context9.next = 3;
                  return _regeneratorRuntime.awrap(this.getClient().post("/mutations", e));

                case 3:
                  return _context9.abrupt("return", _context9.sent.data);

                case 6:
                  _context9.prev = 6;
                  _context9.t0 = _context9["catch"](0);
                  _t5 = _context9.t0, _n3 = Object(i.c)(_t5);
                  throw this.onError && this.onError(_n3), _context9.t0;

                case 10:
                case "end":
                  return _context9.stop();
              }
            }
          }, null, this, [[0, 6]]);
        }
      }, {
        key: "createMutationRequest",
        value: function createMutationRequest(e) {
          var t, n;
          return _regeneratorRuntime.async(function createMutationRequest$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return _regeneratorRuntime.awrap(this.createMutationRequests([e]));

                case 2:
                  t = _context10.sent;
                  n = t[0].data;

                  if (!(!1 === n.success)) {
                    _context10.next = 6;
                    break;
                  }

                  throw new Error(n.message);

                case 6:
                  return _context10.abrupt("return", n);

                case 7:
                case "end":
                  return _context10.stop();
              }
            }
          }, null, this);
        }
      }, {
        key: "getMedia",
        value: function getMedia(e) {
          var t,
              _n4,
              _e3,
              _args11 = arguments;

          return _regeneratorRuntime.async(function getMedia$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  t = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : !1;
                  _context11.prev = 1;
                  _context11.next = 4;
                  return _regeneratorRuntime.awrap(this.getClient().get("/media/".concat(e), {
                    responseType: "blob"
                  }));

                case 4:
                  return _context11.abrupt("return", _context11.sent.data);

                case 7:
                  _context11.prev = 7;
                  _context11.t0 = _context11["catch"](1);
                  _n4 = _context11.t0;

                  if (!t) {
                    _e3 = Object(i.c)(_n4);
                    this.onError && this.onError(_e3);
                  }

                  throw _context11.t0;

                case 12:
                case "end":
                  return _context11.stop();
              }
            }
          }, null, this, [[1, 7]]);
        }
      }]);

      return c;
    }(u);

    var l = null;

    function h(e, t, n) {
      null === l && (l = new c(e, t, n));
    }

    function d() {
      if (null === l) throw new Error("Resource Api is not initialized!");
      return l;
    }
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = n(3),
        i = n(16),
        o = function () {
      function e(e, t, n) {
        this.name = e, this.instanceFactory = t, this.type = n, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY";
      }

      return e.prototype.setInstantiationMode = function (e) {
        return this.instantiationMode = e, this;
      }, e.prototype.setMultipleInstances = function (e) {
        return this.multipleInstances = e, this;
      }, e.prototype.setServiceProps = function (e) {
        return this.serviceProps = e, this;
      }, e;
    }(),
        a = "[DEFAULT]",
        s = function () {
      function e(e, t) {
        this.name = e, this.container = t, this.component = null, this.instances = new Map(), this.instancesDeferred = new Map();
      }

      return e.prototype.get = function (e) {
        void 0 === e && (e = a);
        var t = this.normalizeInstanceIdentifier(e);

        if (!this.instancesDeferred.has(t)) {
          var n = new i.Deferred();
          this.instancesDeferred.set(t, n);

          try {
            var r = this.getOrInitializeService(t);
            r && n.resolve(r);
          } catch (e) {}
        }

        return this.instancesDeferred.get(t).promise;
      }, e.prototype.getImmediate = function (e) {
        var t = r.__assign({
          identifier: a,
          optional: !1
        }, e),
            n = t.identifier,
            i = t.optional,
            o = this.normalizeInstanceIdentifier(n);

        try {
          var s = this.getOrInitializeService(o);

          if (!s) {
            if (i) return null;
            throw Error("Service " + this.name + " is not available");
          }

          return s;
        } catch (e) {
          if (i) return null;
          throw e;
        }
      }, e.prototype.getComponent = function () {
        return this.component;
      }, e.prototype.setComponent = function (e) {
        var t, n;
        if (e.name !== this.name) throw Error("Mismatching Component " + e.name + " for Provider " + this.name + ".");
        if (this.component) throw Error("Component for " + this.name + " has already been provided");
        if (this.component = e, function (e) {
          return "EAGER" === e.instantiationMode;
        }
        /**
         * @license
         * Copyright 2019 Google Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         *   http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         */
        (e)) try {
          this.getOrInitializeService(a);
        } catch (e) {}

        try {
          for (var i = r.__values(this.instancesDeferred.entries()), o = i.next(); !o.done; o = i.next()) {
            var s = r.__read(o.value, 2),
                u = s[0],
                c = s[1],
                l = this.normalizeInstanceIdentifier(u);

            try {
              var h = this.getOrInitializeService(l);
              c.resolve(h);
            } catch (e) {}
          }
        } catch (e) {
          t = {
            error: e
          };
        } finally {
          try {
            o && !o.done && (n = i.return) && n.call(i);
          } finally {
            if (t) throw t.error;
          }
        }
      }, e.prototype.clearInstance = function (e) {
        void 0 === e && (e = a), this.instancesDeferred.delete(e), this.instances.delete(e);
      }, e.prototype.delete = function () {
        return r.__awaiter(this, void 0, void 0, function () {
          var e;
          return r.__generator(this, function (t) {
            switch (t.label) {
              case 0:
                return e = Array.from(this.instances.values()), [4, Promise.all(e.filter(function (e) {
                  return "INTERNAL" in e;
                }).map(function (e) {
                  return e.INTERNAL.delete();
                }))];

              case 1:
                return t.sent(), [2];
            }
          });
        });
      }, e.prototype.isComponentSet = function () {
        return null != this.component;
      }, e.prototype.getOrInitializeService = function (e) {
        var t = this.instances.get(e);
        return !t && this.component && (t = this.component.instanceFactory(this.container, function (e) {
          return e === a ? void 0 : e;
        }(e)), this.instances.set(e, t)), t || null;
      }, e.prototype.normalizeInstanceIdentifier = function (e) {
        return this.component ? this.component.multipleInstances ? e : a : e;
      }, e;
    }();

    var u = function () {
      function e(e) {
        this.name = e, this.providers = new Map();
      }

      return e.prototype.addComponent = function (e) {
        var t = this.getProvider(e.name);
        if (t.isComponentSet()) throw new Error("Component " + e.name + " has already been registered with " + this.name);
        t.setComponent(e);
      }, e.prototype.addOrOverwriteComponent = function (e) {
        this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e);
      }, e.prototype.getProvider = function (e) {
        if (this.providers.has(e)) return this.providers.get(e);
        var t = new s(e, this);
        return this.providers.set(e, t), t;
      }, e.prototype.getProviders = function () {
        return Array.from(this.providers.values());
      }, e;
    }();

    t.Component = o, t.ComponentContainer = u, t.Provider = s;
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return a;
    });
    var r = n(4);

    function i(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var o = {
      contactId: -1,
      dataPreferences: {
        option: r.DataLevel.MyCompany,
        companies: [],
        positionTypes: []
      }
    };

    var a =
    /*#__PURE__*/
    function () {
      function a() {
        _classCallCheck(this, a);

        i(this, "data", o);
      }

      _createClass(a, [{
        key: "get",
        value: function get(e) {
          return this.data[e];
        }
      }, {
        key: "set",
        value: function set(e, t) {
          this.data = _objectSpread({}, this.data, _defineProperty({}, e, t));
        }
      }, {
        key: "settings",
        get: function get() {
          return this.data;
        },
        set: function set(e) {
          this.data = e;
        }
      }], [{
        key: "getInstance",
        value: function getInstance() {
          return a.instance || (this.instance = new a()), this.instance;
        }
      }]);

      return a;
    }();

    i(a, "instance", void 0);
  }, function (e, t, n) {
    "use strict";

    var r = n(53),
        i = Object.prototype.toString;

    function o(e) {
      return "[object Array]" === i.call(e);
    }

    function a(e) {
      return void 0 === e;
    }

    function s(e) {
      return null !== e && "object" == typeof e;
    }

    function u(e) {
      return "[object Function]" === i.call(e);
    }

    function c(e, t) {
      if (null != e) if ("object" != typeof e && (e = [e]), o(e)) for (var n = 0, r = e.length; n < r; n++) {
        t.call(null, e[n], n, e);
      } else for (var i in e) {
        Object.prototype.hasOwnProperty.call(e, i) && t.call(null, e[i], i, e);
      }
    }

    e.exports = {
      isArray: o,
      isArrayBuffer: function isArrayBuffer(e) {
        return "[object ArrayBuffer]" === i.call(e);
      },
      isBuffer: function isBuffer(e) {
        return null !== e && !a(e) && null !== e.constructor && !a(e.constructor) && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
      },
      isFormData: function isFormData(e) {
        return "undefined" != typeof FormData && e instanceof FormData;
      },
      isArrayBufferView: function isArrayBufferView(e) {
        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && e.buffer instanceof ArrayBuffer;
      },
      isString: function isString(e) {
        return "string" == typeof e;
      },
      isNumber: function isNumber(e) {
        return "number" == typeof e;
      },
      isObject: s,
      isUndefined: a,
      isDate: function isDate(e) {
        return "[object Date]" === i.call(e);
      },
      isFile: function isFile(e) {
        return "[object File]" === i.call(e);
      },
      isBlob: function isBlob(e) {
        return "[object Blob]" === i.call(e);
      },
      isFunction: u,
      isStream: function isStream(e) {
        return s(e) && u(e.pipe);
      },
      isURLSearchParams: function isURLSearchParams(e) {
        return "undefined" != typeof URLSearchParams && e instanceof URLSearchParams;
      },
      isStandardBrowserEnv: function isStandardBrowserEnv() {
        return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
      },
      forEach: c,
      merge: function e() {
        var t = {};

        function n(n, r) {
          "object" == typeof t[r] && "object" == typeof n ? t[r] = e(t[r], n) : t[r] = n;
        }

        for (var r = 0, i = arguments.length; r < i; r++) {
          c(arguments[r], n);
        }

        return t;
      },
      deepMerge: function e() {
        var t = {};

        function n(n, r) {
          "object" == typeof t[r] && "object" == typeof n ? t[r] = e(t[r], n) : t[r] = "object" == typeof n ? e({}, n) : n;
        }

        for (var r = 0, i = arguments.length; r < i; r++) {
          c(arguments[r], n);
        }

        return t;
      },
      extend: function extend(e, t, n) {
        return c(t, function (t, i) {
          e[i] = n && "function" == typeof t ? r(t, n) : t;
        }), e;
      },
      trim: function trim(e) {
        return e.replace(/^\s*/, "").replace(/\s*$/, "");
      }
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(3),
          i = {
        NODE_CLIENT: !1,
        NODE_ADMIN: !1,
        SDK_VERSION: "${JSCORE_VERSION}"
      },
          o = function o(e, t) {
        if (!e) throw a(t);
      },
          a = function a(e) {
        return new Error("Firebase Database (" + i.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + e);
      },
          s = function s(e) {
        for (var t = [], n = 0, r = 0; r < e.length; r++) {
          var i = e.charCodeAt(r);
          i < 128 ? t[n++] = i : i < 2048 ? (t[n++] = i >> 6 | 192, t[n++] = 63 & i | 128) : 55296 == (64512 & i) && r + 1 < e.length && 56320 == (64512 & e.charCodeAt(r + 1)) ? (i = 65536 + ((1023 & i) << 10) + (1023 & e.charCodeAt(++r)), t[n++] = i >> 18 | 240, t[n++] = i >> 12 & 63 | 128, t[n++] = i >> 6 & 63 | 128, t[n++] = 63 & i | 128) : (t[n++] = i >> 12 | 224, t[n++] = i >> 6 & 63 | 128, t[n++] = 63 & i | 128);
        }

        return t;
      },
          u = {
        byteToCharMap_: null,
        charToByteMap_: null,
        byteToCharMapWebSafe_: null,
        charToByteMapWebSafe_: null,
        ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",

        get ENCODED_VALS() {
          return this.ENCODED_VALS_BASE + "+/=";
        },

        get ENCODED_VALS_WEBSAFE() {
          return this.ENCODED_VALS_BASE + "-_.";
        },

        HAS_NATIVE_SUPPORT: "function" == typeof atob,
        encodeByteArray: function encodeByteArray(e, t) {
          if (!Array.isArray(e)) throw Error("encodeByteArray takes an array as a parameter");
          this.init_();

          for (var n = t ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, r = [], i = 0; i < e.length; i += 3) {
            var o = e[i],
                a = i + 1 < e.length,
                s = a ? e[i + 1] : 0,
                u = i + 2 < e.length,
                c = u ? e[i + 2] : 0,
                l = o >> 2,
                h = (3 & o) << 4 | s >> 4,
                d = (15 & s) << 2 | c >> 6,
                f = 63 & c;
            u || (f = 64, a || (d = 64)), r.push(n[l], n[h], n[d], n[f]);
          }

          return r.join("");
        },
        encodeString: function encodeString(e, t) {
          return this.HAS_NATIVE_SUPPORT && !t ? btoa(e) : this.encodeByteArray(s(e), t);
        },
        decodeString: function decodeString(e, t) {
          return this.HAS_NATIVE_SUPPORT && !t ? atob(e) : function (e) {
            for (var t = [], n = 0, r = 0; n < e.length;) {
              var i = e[n++];
              if (i < 128) t[r++] = String.fromCharCode(i);else if (i > 191 && i < 224) {
                var o = e[n++];
                t[r++] = String.fromCharCode((31 & i) << 6 | 63 & o);
              } else if (i > 239 && i < 365) {
                var a = ((7 & i) << 18 | (63 & (o = e[n++])) << 12 | (63 & (s = e[n++])) << 6 | 63 & e[n++]) - 65536;
                t[r++] = String.fromCharCode(55296 + (a >> 10)), t[r++] = String.fromCharCode(56320 + (1023 & a));
              } else {
                o = e[n++];
                var s = e[n++];
                t[r++] = String.fromCharCode((15 & i) << 12 | (63 & o) << 6 | 63 & s);
              }
            }

            return t.join("");
          }(this.decodeStringToByteArray(e, t));
        },
        decodeStringToByteArray: function decodeStringToByteArray(e, t) {
          this.init_();

          for (var n = t ? this.charToByteMapWebSafe_ : this.charToByteMap_, r = [], i = 0; i < e.length;) {
            var o = n[e.charAt(i++)],
                a = i < e.length ? n[e.charAt(i)] : 0,
                s = ++i < e.length ? n[e.charAt(i)] : 64,
                u = ++i < e.length ? n[e.charAt(i)] : 64;
            if (++i, null == o || null == a || null == s || null == u) throw Error();
            var c = o << 2 | a >> 4;

            if (r.push(c), 64 !== s) {
              var l = a << 4 & 240 | s >> 2;

              if (r.push(l), 64 !== u) {
                var h = s << 6 & 192 | u;
                r.push(h);
              }
            }
          }

          return r;
        },
        init_: function init_() {
          if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};

            for (var e = 0; e < this.ENCODED_VALS.length; e++) {
              this.byteToCharMap_[e] = this.ENCODED_VALS.charAt(e), this.charToByteMap_[this.byteToCharMap_[e]] = e, this.byteToCharMapWebSafe_[e] = this.ENCODED_VALS_WEBSAFE.charAt(e), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[e]] = e, e >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(e)] = e, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(e)] = e);
            }
          }
        }
      },
          c = function c(e) {
        try {
          return u.decodeString(e, !0);
        } catch (e) {
          console.error("base64Decode failed: ", e);
        }

        return null;
      };
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      function l(e, t) {
        if (!(t instanceof Object)) return t;

        switch (t.constructor) {
          case Date:
            return new Date(t.getTime());

          case Object:
            void 0 === e && (e = {});
            break;

          case Array:
            e = [];
            break;

          default:
            return t;
        }

        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = l(e[n], t[n]));
        }

        return e;
      }
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      var h = function () {
        function e() {
          var e = this;
          this.reject = function () {}, this.resolve = function () {}, this.promise = new Promise(function (t, n) {
            e.resolve = t, e.reject = n;
          });
        }

        return e.prototype.wrapCallback = function (e) {
          var t = this;
          return function (n, r) {
            n ? t.reject(n) : t.resolve(r), "function" == typeof e && (t.promise.catch(function () {}), 1 === e.length ? e(n) : e(n, r));
          };
        }, e;
      }();
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      function d() {
        return "undefined" != typeof navigator && "string" == typeof navigator.userAgent ? navigator.userAgent : "";
      }
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      var f = "FirebaseError",
          p = function (e) {
        function t(n, r) {
          var i = e.call(this, r) || this;
          return i.code = n, i.name = f, Object.setPrototypeOf(i, t.prototype), Error.captureStackTrace && Error.captureStackTrace(i, m.prototype.create), i;
        }

        return r.__extends(t, e), t;
      }(Error),
          m = function () {
        function e(e, t, n) {
          this.service = e, this.serviceName = t, this.errors = n;
        }

        return e.prototype.create = function (e) {
          for (var t = [], n = 1; n < arguments.length; n++) {
            t[n - 1] = arguments[n];
          }

          for (var r = t[0] || {}, i = this.service + "/" + e, o = this.errors[e], a = o ? function (e, t) {
            return e.replace(_, function (e, n) {
              var r = t[n];
              return null != r ? r.toString() : "<" + n + "?>";
            });
          }(o, r) : "Error", s = this.serviceName + ": " + a + " (" + i + ").", u = new p(i, s), c = 0, l = Object.keys(r); c < l.length; c++) {
            var h = l[c];
            "_" !== h.slice(-1) && (h in u && console.warn('Overwriting FirebaseError base field "' + h + '" can cause unexpected behavior.'), u[h] = r[h]);
          }

          return u;
        }, e;
      }();

      var _ = /\{\$([^}]+)}/g;
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */

      function y(e) {
        return JSON.parse(e);
      }
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      var v = function v(e) {
        var t = {},
            n = {},
            r = {},
            i = "";

        try {
          var o = e.split(".");
          t = y(c(o[0]) || ""), n = y(c(o[1]) || ""), i = o[2], r = n.d || {}, delete n.d;
        } catch (e) {}

        return {
          header: t,
          claims: n,
          data: r,
          signature: i
        };
      };
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      var g = function () {
        function e() {
          this.chain_ = [], this.buf_ = [], this.W_ = [], this.pad_ = [], this.inbuf_ = 0, this.total_ = 0, this.blockSize = 64, this.pad_[0] = 128;

          for (var e = 1; e < this.blockSize; ++e) {
            this.pad_[e] = 0;
          }

          this.reset();
        }

        return e.prototype.reset = function () {
          this.chain_[0] = 1732584193, this.chain_[1] = 4023233417, this.chain_[2] = 2562383102, this.chain_[3] = 271733878, this.chain_[4] = 3285377520, this.inbuf_ = 0, this.total_ = 0;
        }, e.prototype.compress_ = function (e, t) {
          t || (t = 0);
          var n = this.W_;
          if ("string" == typeof e) for (var r = 0; r < 16; r++) {
            n[r] = e.charCodeAt(t) << 24 | e.charCodeAt(t + 1) << 16 | e.charCodeAt(t + 2) << 8 | e.charCodeAt(t + 3), t += 4;
          } else for (r = 0; r < 16; r++) {
            n[r] = e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3], t += 4;
          }

          for (r = 16; r < 80; r++) {
            var i = n[r - 3] ^ n[r - 8] ^ n[r - 14] ^ n[r - 16];
            n[r] = 4294967295 & (i << 1 | i >>> 31);
          }

          var o,
              a,
              s = this.chain_[0],
              u = this.chain_[1],
              c = this.chain_[2],
              l = this.chain_[3],
              h = this.chain_[4];

          for (r = 0; r < 80; r++) {
            r < 40 ? r < 20 ? (o = l ^ u & (c ^ l), a = 1518500249) : (o = u ^ c ^ l, a = 1859775393) : r < 60 ? (o = u & c | l & (u | c), a = 2400959708) : (o = u ^ c ^ l, a = 3395469782);
            i = (s << 5 | s >>> 27) + o + h + a + n[r] & 4294967295;
            h = l, l = c, c = 4294967295 & (u << 30 | u >>> 2), u = s, s = i;
          }

          this.chain_[0] = this.chain_[0] + s & 4294967295, this.chain_[1] = this.chain_[1] + u & 4294967295, this.chain_[2] = this.chain_[2] + c & 4294967295, this.chain_[3] = this.chain_[3] + l & 4294967295, this.chain_[4] = this.chain_[4] + h & 4294967295;
        }, e.prototype.update = function (e, t) {
          if (null != e) {
            void 0 === t && (t = e.length);

            for (var n = t - this.blockSize, r = 0, i = this.buf_, o = this.inbuf_; r < t;) {
              if (0 === o) for (; r <= n;) {
                this.compress_(e, r), r += this.blockSize;
              }

              if ("string" == typeof e) {
                for (; r < t;) {
                  if (i[o] = e.charCodeAt(r), ++r, ++o === this.blockSize) {
                    this.compress_(i), o = 0;
                    break;
                  }
                }
              } else for (; r < t;) {
                if (i[o] = e[r], ++r, ++o === this.blockSize) {
                  this.compress_(i), o = 0;
                  break;
                }
              }
            }

            this.inbuf_ = o, this.total_ += t;
          }
        }, e.prototype.digest = function () {
          var e = [],
              t = 8 * this.total_;
          this.inbuf_ < 56 ? this.update(this.pad_, 56 - this.inbuf_) : this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));

          for (var n = this.blockSize - 1; n >= 56; n--) {
            this.buf_[n] = 255 & t, t /= 256;
          }

          this.compress_(this.buf_);
          var r = 0;

          for (n = 0; n < 5; n++) {
            for (var i = 24; i >= 0; i -= 8) {
              e[r] = this.chain_[n] >> i & 255, ++r;
            }
          }

          return e;
        }, e;
      }();

      var b = function () {
        function e(e, t) {
          var n = this;
          this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = t, this.task.then(function () {
            e(n);
          }).catch(function (e) {
            n.error(e);
          });
        }

        return e.prototype.next = function (e) {
          this.forEachObserver(function (t) {
            t.next(e);
          });
        }, e.prototype.error = function (e) {
          this.forEachObserver(function (t) {
            t.error(e);
          }), this.close(e);
        }, e.prototype.complete = function () {
          this.forEachObserver(function (e) {
            e.complete();
          }), this.close();
        }, e.prototype.subscribe = function (e, t, n) {
          var r,
              i = this;
          if (void 0 === e && void 0 === t && void 0 === n) throw new Error("Missing Observer.");
          void 0 === (r = function (e, t) {
            if ("object" != typeof e || null === e) return !1;

            for (var n = 0, r = t; n < r.length; n++) {
              var i = r[n];
              if (i in e && "function" == typeof e[i]) return !0;
            }

            return !1;
          }(e, ["next", "error", "complete"]) ? e : {
            next: e,
            error: t,
            complete: n
          }).next && (r.next = w), void 0 === r.error && (r.error = w), void 0 === r.complete && (r.complete = w);
          var o = this.unsubscribeOne.bind(this, this.observers.length);
          return this.finalized && this.task.then(function () {
            try {
              i.finalError ? r.error(i.finalError) : r.complete();
            } catch (e) {}
          }), this.observers.push(r), o;
        }, e.prototype.unsubscribeOne = function (e) {
          void 0 !== this.observers && void 0 !== this.observers[e] && (delete this.observers[e], this.observerCount -= 1, 0 === this.observerCount && void 0 !== this.onNoObservers && this.onNoObservers(this));
        }, e.prototype.forEachObserver = function (e) {
          if (!this.finalized) for (var t = 0; t < this.observers.length; t++) {
            this.sendOne(t, e);
          }
        }, e.prototype.sendOne = function (e, t) {
          var n = this;
          this.task.then(function () {
            if (void 0 !== n.observers && void 0 !== n.observers[e]) try {
              t(n.observers[e]);
            } catch (e) {
              "undefined" != typeof console && console.error && console.error(e);
            }
          });
        }, e.prototype.close = function (e) {
          var t = this;
          this.finalized || (this.finalized = !0, void 0 !== e && (this.finalError = e), this.task.then(function () {
            t.observers = void 0, t.onNoObservers = void 0;
          }));
        }, e;
      }();

      function w() {}
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      function T(e, t, n) {
        var r = "";

        switch (t) {
          case 1:
            r = n ? "first" : "First";
            break;

          case 2:
            r = n ? "second" : "Second";
            break;

          case 3:
            r = n ? "third" : "Third";
            break;

          case 4:
            r = n ? "fourth" : "Fourth";
            break;

          default:
            throw new Error("errorPrefix called with argumentNumber > 4.  Need to update it?");
        }

        var i = e + " failed: ";
        return i += r + " argument ";
      }

      t.CONSTANTS = i, t.Deferred = h, t.ErrorFactory = m, t.FirebaseError = p, t.Sha1 = g, t.assert = o, t.assertionError = a, t.async = function (e, t) {
        return function () {
          for (var n = [], r = 0; r < arguments.length; r++) {
            n[r] = arguments[r];
          }

          Promise.resolve(!0).then(function () {
            e.apply(void 0, n);
          }).catch(function (e) {
            t && t(e);
          });
        };
      }, t.base64 = u, t.base64Decode = c, t.base64Encode = function (e) {
        var t = s(e);
        return u.encodeByteArray(t, !0);
      }, t.contains =
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */
      function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, t.createSubscribe = function (e, t) {
        var n = new b(e, t);
        return n.subscribe.bind(n);
      }, t.decode = v, t.deepCopy =
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */
      function (e) {
        return l(void 0, e);
      }, t.deepExtend = l, t.errorPrefix = T, t.getUA = d, t.isAdmin = function (e) {
        var t = v(e).claims;
        return "object" == typeof t && !0 === t.admin;
      }, t.isBrowser = function () {
        return "object" == typeof self && self.self === self;
      }, t.isBrowserExtension = function () {
        var e = "object" == typeof chrome ? chrome.runtime : "object" == typeof browser ? browser.runtime : void 0;
        return "object" == typeof e && void 0 !== e.id;
      }, t.isElectron = function () {
        return d().indexOf("Electron/") >= 0;
      }, t.isEmpty = function (e) {
        for (var t in e) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
        }

        return !0;
      }, t.isIE = function () {
        var e = d();
        return e.indexOf("MSIE ") >= 0 || e.indexOf("Trident/") >= 0;
      }, t.isMobileCordova = function () {
        return "undefined" != typeof window && !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(d());
      }, t.isNode = function () {
        try {
          return "[object process]" === Object.prototype.toString.call(e.process);
        } catch (e) {
          return !1;
        }
      }, t.isNodeSdk = function () {
        return !0 === i.NODE_CLIENT || !0 === i.NODE_ADMIN;
      }, t.isReactNative = function () {
        return "object" == typeof navigator && "ReactNative" === navigator.product;
      }, t.isUWP = function () {
        return d().indexOf("MSAppHost/") >= 0;
      }, t.isValidFormat = function (e) {
        var t = v(e).claims;
        return !!t && "object" == typeof t && t.hasOwnProperty("iat");
      }, t.isValidTimestamp = function (e) {
        var t = v(e).claims,
            n = Math.floor(new Date().getTime() / 1e3),
            r = 0,
            i = 0;
        return "object" == typeof t && (t.hasOwnProperty("nbf") ? r = t.nbf : t.hasOwnProperty("iat") && (r = t.iat), i = t.hasOwnProperty("exp") ? t.exp : r + 86400), !!n && !!r && !!i && n >= r && n <= i;
      }, t.issuedAtTime = function (e) {
        var t = v(e).claims;
        return "object" == typeof t && t.hasOwnProperty("iat") ? t.iat : null;
      }, t.jsonEval = y, t.map = function (e, t, n) {
        var r = {};

        for (var i in e) {
          Object.prototype.hasOwnProperty.call(e, i) && (r[i] = t.call(n, e[i], i, e));
        }

        return r;
      }
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */
      , t.querystring = function (e) {
        for (var t = [], n = function n(e, _n5) {
          Array.isArray(_n5) ? _n5.forEach(function (n) {
            t.push(encodeURIComponent(e) + "=" + encodeURIComponent(n));
          }) : t.push(encodeURIComponent(e) + "=" + encodeURIComponent(_n5));
        }, r = 0, i = Object.entries(e); r < i.length; r++) {
          var o = i[r];
          n(o[0], o[1]);
        }

        return t.length ? "&" + t.join("&") : "";
      }, t.querystringDecode = function (e) {
        var t = {};
        return e.replace(/^\?/, "").split("&").forEach(function (e) {
          if (e) {
            var n = e.split("=");
            t[n[0]] = n[1];
          }
        }), t;
      }, t.safeGet = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
      }, t.stringLength = function (e) {
        for (var t = 0, n = 0; n < e.length; n++) {
          var r = e.charCodeAt(n);
          r < 128 ? t++ : r < 2048 ? t += 2 : r >= 55296 && r <= 56319 ? (t += 4, n++) : t += 3;
        }

        return t;
      }, t.stringToByteArray = function (e) {
        for (var t = [], n = 0, r = 0; r < e.length; r++) {
          var i = e.charCodeAt(r);

          if (i >= 55296 && i <= 56319) {
            var a = i - 55296;
            o(++r < e.length, "Surrogate pair missing trail surrogate."), i = 65536 + (a << 10) + (e.charCodeAt(r) - 56320);
          }

          i < 128 ? t[n++] = i : i < 2048 ? (t[n++] = i >> 6 | 192, t[n++] = 63 & i | 128) : i < 65536 ? (t[n++] = i >> 12 | 224, t[n++] = i >> 6 & 63 | 128, t[n++] = 63 & i | 128) : (t[n++] = i >> 18 | 240, t[n++] = i >> 12 & 63 | 128, t[n++] = i >> 6 & 63 | 128, t[n++] = 63 & i | 128);
        }

        return t;
      }, t.stringify = function (e) {
        return JSON.stringify(e);
      }, t.validateArgCount = function (e, t, n, r) {
        var i;
        if (r < t ? i = "at least " + t : r > n && (i = 0 === n ? "none" : "no more than " + n), i) throw new Error(e + " failed: Was called with " + r + (1 === r ? " argument." : " arguments.") + " Expects " + i + ".");
      }, t.validateCallback = function (e, t, n, r) {
        if ((!r || n) && "function" != typeof n) throw new Error(T(e, t, r) + "must be a valid function.");
      }, t.validateContextObject = function (e, t, n, r) {
        if ((!r || n) && ("object" != typeof n || null === n)) throw new Error(T(e, t, r) + "must be a valid context object.");
      }
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */
      , t.validateNamespace = function (e, t, n, r) {
        if ((!r || n) && "string" != typeof n) throw new Error(T(e, t, r) + "must be a valid firebase namespace.");
      };
    }).call(this, n(17));
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t) {
    e.exports = i;
  }, function (e, t, n) {
    "use strict";

    var r;

    var i = function i() {
      if (!r) throw Error("Dynamic fields getter is not registered!");
      return r;
    },
        o = function o(e) {
      r = e;
    };

    var a;

    var s = function s() {
      if (!a) throw Error("Custom widget form fields renderer is not registered!");
      return a;
    },
        u = function u(e) {
      a = e;
    };

    var c;

    var l = function l() {
      if (!c) throw Error("Widget dynamic fields to filter mapper is not registered!");
      return c;
    },
        h = function h(e) {
      c = e;
    };

    function d(e, t, n) {
      u(e), o(t), h(n);
    }

    n.d(t, "a", function () {
      return i;
    }), n.d(t, "e", function () {
      return o;
    }), n.d(t, "c", function () {
      return s;
    }), n.d(t, "g", function () {
      return u;
    }), n.d(t, "b", function () {
      return l;
    }), n.d(t, "f", function () {
      return h;
    }), n.d(t, "d", function () {
      return d;
    });
  }, function (e, t, n) {
    "use strict";

    n.d(t, "c", function () {
      return r;
    }), n.d(t, "a", function () {
      return i;
    }), n.d(t, "b", function () {
      return o;
    });
    var r = {
      pageSize: 10,
      current: 1,
      total: 0
    };
    var i;

    function o(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : i.Desc;
      return {
        filter: e,
        pager: {
          offset: (r.current - 1) * r.pageSize,
          limit: r.pageSize
        },
        sorter: [{
          fieldName: t,
          direction: n
        }]
      };
    }

    !function (e) {
      e[e.Asc = 1] = "Asc", e[e.Desc = 0] = "Desc";
    }(i || (i = {}));
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "createStore", function () {
      return s;
    }), n.d(t, "combineReducers", function () {
      return c;
    }), n.d(t, "bindActionCreators", function () {
      return h;
    }), n.d(t, "applyMiddleware", function () {
      return p;
    }), n.d(t, "compose", function () {
      return f;
    }), n.d(t, "__DO_NOT_USE__ActionTypes", function () {
      return o;
    });

    var r = n(49),
        i = function i() {
      return Math.random().toString(36).substring(7).split("").join(".");
    },
        o = {
      INIT: "@@redux/INIT" + i(),
      REPLACE: "@@redux/REPLACE" + i(),
      PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + i();
      }
    };

    function a(e) {
      if ("object" != typeof e || null === e) return !1;

      for (var t = e; null !== Object.getPrototypeOf(t);) {
        t = Object.getPrototypeOf(t);
      }

      return Object.getPrototypeOf(e) === t;
    }

    function s(e, t, n) {
      var i;
      if ("function" == typeof t && "function" == typeof n || "function" == typeof n && "function" == typeof arguments[3]) throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function");

      if ("function" == typeof t && void 0 === n && (n = t, t = void 0), void 0 !== n) {
        if ("function" != typeof n) throw new Error("Expected the enhancer to be a function.");
        return n(s)(e, t);
      }

      if ("function" != typeof e) throw new Error("Expected the reducer to be a function.");
      var u = e,
          c = t,
          l = [],
          h = l,
          d = !1;

      function f() {
        h === l && (h = l.slice());
      }

      function p() {
        if (d) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
        return c;
      }

      function m(e) {
        if ("function" != typeof e) throw new Error("Expected the listener to be a function.");
        if (d) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
        var t = !0;
        return f(), h.push(e), function () {
          if (t) {
            if (d) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
            t = !1, f();
            var n = h.indexOf(e);
            h.splice(n, 1);
          }
        };
      }

      function _(e) {
        if (!a(e)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (void 0 === e.type) throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (d) throw new Error("Reducers may not dispatch actions.");

        try {
          d = !0, c = u(c, e);
        } finally {
          d = !1;
        }

        for (var t = l = h, n = 0; n < t.length; n++) {
          (0, t[n])();
        }

        return e;
      }

      return _({
        type: o.INIT
      }), (i = {
        dispatch: _,
        subscribe: m,
        getState: p,
        replaceReducer: function replaceReducer(e) {
          if ("function" != typeof e) throw new Error("Expected the nextReducer to be a function.");
          u = e, _({
            type: o.REPLACE
          });
        }
      })[r.a] = function () {
        var e,
            t = m;
        return (e = {
          subscribe: function subscribe(e) {
            if ("object" != typeof e || null === e) throw new TypeError("Expected the observer to be an object.");

            function n() {
              e.next && e.next(p());
            }

            return n(), {
              unsubscribe: t(n)
            };
          }
        })[r.a] = function () {
          return this;
        }, e;
      }, i;
    }

    function u(e, t) {
      var n = t && t.type;
      return "Given " + (n && 'action "' + String(n) + '"' || "an action") + ', reducer "' + e + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.';
    }

    function c(e) {
      for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
        var i = t[r];
        0, "function" == typeof e[i] && (n[i] = e[i]);
      }

      var a,
          s = Object.keys(n);

      try {
        !function (e) {
          Object.keys(e).forEach(function (t) {
            var n = e[t];
            if (void 0 === n(void 0, {
              type: o.INIT
            })) throw new Error('Reducer "' + t + "\" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.");
            if (void 0 === n(void 0, {
              type: o.PROBE_UNKNOWN_ACTION()
            })) throw new Error('Reducer "' + t + "\" returned undefined when probed with a random type. Don't try to handle " + o.INIT + ' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.');
          });
        }(n);
      } catch (e) {
        a = e;
      }

      return function (e, t) {
        if (void 0 === e && (e = {}), a) throw a;

        for (var r = !1, i = {}, o = 0; o < s.length; o++) {
          var c = s[o],
              l = n[c],
              h = e[c],
              d = l(h, t);

          if (void 0 === d) {
            var f = u(c, t);
            throw new Error(f);
          }

          i[c] = d, r = r || d !== h;
        }

        return r ? i : e;
      };
    }

    function l(e, t) {
      return function () {
        return t(e.apply(this, arguments));
      };
    }

    function h(e, t) {
      if ("function" == typeof e) return l(e, t);
      if ("object" != typeof e || null === e) throw new Error("bindActionCreators expected an object or a function, instead received " + (null === e ? "null" : typeof e) + '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');

      for (var n = Object.keys(e), r = {}, i = 0; i < n.length; i++) {
        var o = n[i],
            a = e[o];
        "function" == typeof a && (r[o] = l(a, t));
      }

      return r;
    }

    function d(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function f() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      return 0 === t.length ? function (e) {
        return e;
      } : 1 === t.length ? t[0] : t.reduce(function (e, t) {
        return function () {
          return e(t.apply(void 0, arguments));
        };
      });
    }

    function p() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      return function (e) {
        return function () {
          var n = e.apply(void 0, arguments),
              r = function r() {
            throw new Error("Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
          },
              i = {
            getState: n.getState,
            dispatch: function dispatch() {
              return r.apply(void 0, arguments);
            }
          },
              o = t.map(function (e) {
            return e(i);
          });

          return function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {},
                  r = Object.keys(n);
              "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
                return Object.getOwnPropertyDescriptor(n, e).enumerable;
              }))), r.forEach(function (t) {
                d(e, t, n[t]);
              });
            }

            return e;
          }({}, n, {
            dispatch: r = f.apply(void 0, o)(n.dispatch)
          });
        };
      };
    }
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return r;
    }), n.d(t, "b", function () {
      return i;
    }), n.d(t, "c", function () {
      return o;
    });

    var r = function r(e, t, n) {
      var r = new FileReader();
      r.onload = function (_ref3) {
        var e = _ref3.target;
        t(null == e ? void 0 : e.result), n && n();
      }, r.readAsDataURL(e);
    };

    function i(e) {
      return e && "name" in e && "id" in e;
    }

    var o = function o(e) {
      return e.some(i);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        i = n.n(r),
        o = n(29),
        a = n(1),
        s = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\ErrorHandler\\ErrorHandlerComponents.tsx";

    var u = function u(_ref4) {
      var e = _ref4.title,
          t = _ref4.message;
      return i.a.createElement(a.Flex, {
        direction: "column",
        gutter: 2,
        gutterDirection: "vertical",
        __source: {
          fileName: s,
          lineNumber: 12
        },
        __self: void 0
      }, i.a.createElement(a.Flex, {
        gutter: 2,
        gutterDirection: "horizontal",
        align: "center",
        __source: {
          fileName: s,
          lineNumber: 13
        },
        __self: void 0
      }, i.a.createElement(a.Icon, {
        type: "alert-error-outline",
        color: "critical",
        size: "large",
        __source: {
          fileName: s,
          lineNumber: 14
        },
        __self: void 0
      }), i.a.createElement(a.H3, {
        weight: 600,
        __source: {
          fileName: s,
          lineNumber: 15
        },
        __self: void 0
      }, e || "Error")), i.a.createElement(a.FlexItem, {
        padding: [0, 8],
        gutter: 2,
        gutterDirection: "vertical",
        __source: {
          fileName: s,
          lineNumber: 17
        },
        __self: void 0
      }, i.a.createElement(a.Text, {
        color: "bodySecondary",
        __source: {
          fileName: s,
          lineNumber: 18
        },
        __self: void 0
      }, t)));
    },
        c = function c() {
      return i.a.createElement(a.Button, {
        type: "primary",
        onClick: function onClick() {
          return Object(o.b)();
        },
        __source: {
          fileName: s,
          lineNumber: 24
        },
        __self: void 0
      }, "OK");
    };

    n.d(t, "c", function () {
      return d;
    }), n.d(t, "a", function () {
      return f;
    }), n.d(t, "b", function () {
      return p;
    });
    var l = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\services\\errorHandler.tsx";
    var h = {
      400: "Error occured during execution of request",
      500: "Error occured during processing of request",
      999: "Error"
    };

    function d(e) {
      var t, n, r;
      return {
        message: e.message,
        statusCode: (null === (t = e.response) || void 0 === t ? void 0 : t.status) || 999,
        statusText: (null === (n = e.response) || void 0 === n ? void 0 : n.statusText) || "",
        stackTrace: e.stack || "",
        responseBody: (null === (r = e.response) || void 0 === r ? void 0 : r.data) || void 0
      };
    }

    function f(e) {
      if ("Network Error" === e.message) return {
        title: e.message,
        message: "Please check your internet connection and try again"
      };
      var t = "";

      if (e.responseBody && e.responseBody.length) {
        t = e.responseBody[0].message;
      }

      return {
        title: h[e.statusCode],
        message: t
      };
    }

    var p = function p(e) {
      var t = f(e);
      Object(o.c)({
        content: function content() {
          return i.a.createElement(u, {
            title: t.title,
            message: t.message,
            __source: {
              fileName: l,
              lineNumber: 54
            },
            __self: void 0
          });
        },
        footer: function footer() {
          return i.a.createElement(c, {
            __source: {
              fileName: l,
              lineNumber: 55
            },
            __self: void 0
          });
        }
      });
    };
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e) {
        return new Promise(function (t, n) {
          e.onsuccess = function () {
            t(e.result);
          }, e.onerror = function () {
            n(e.error);
          };
        });
      }

      function n(e, n, r) {
        var i,
            o = new Promise(function (o, a) {
          t(i = e[n].apply(e, r)).then(o, a);
        });
        return o.request = i, o;
      }

      function r(e, t, n) {
        n.forEach(function (n) {
          Object.defineProperty(e.prototype, n, {
            get: function get() {
              return this[t][n];
            },
            set: function set(e) {
              this[t][n] = e;
            }
          });
        });
      }

      function i(e, t, r, i) {
        i.forEach(function (i) {
          i in r.prototype && (e.prototype[i] = function () {
            return n(this[t], i, arguments);
          });
        });
      }

      function o(e, t, n, r) {
        r.forEach(function (r) {
          r in n.prototype && (e.prototype[r] = function () {
            return this[t][r].apply(this[t], arguments);
          });
        });
      }

      function a(e, t, r, i) {
        i.forEach(function (i) {
          i in r.prototype && (e.prototype[i] = function () {
            return e = this[t], (r = n(e, i, arguments)).then(function (e) {
              if (e) return new u(e, r.request);
            });
            var e, r;
          });
        });
      }

      function s(e) {
        this._index = e;
      }

      function u(e, t) {
        this._cursor = e, this._request = t;
      }

      function c(e) {
        this._store = e;
      }

      function l(e) {
        this._tx = e, this.complete = new Promise(function (t, n) {
          e.oncomplete = function () {
            t();
          }, e.onerror = function () {
            n(e.error);
          }, e.onabort = function () {
            n(e.error);
          };
        });
      }

      function h(e, t, n) {
        this._db = e, this.oldVersion = t, this.transaction = new l(n);
      }

      function d(e) {
        this._db = e;
      }

      r(s, "_index", ["name", "keyPath", "multiEntry", "unique"]), i(s, "_index", IDBIndex, ["get", "getKey", "getAll", "getAllKeys", "count"]), a(s, "_index", IDBIndex, ["openCursor", "openKeyCursor"]), r(u, "_cursor", ["direction", "key", "primaryKey", "value"]), i(u, "_cursor", IDBCursor, ["update", "delete"]), ["advance", "continue", "continuePrimaryKey"].forEach(function (e) {
        e in IDBCursor.prototype && (u.prototype[e] = function () {
          var n = this,
              r = arguments;
          return Promise.resolve().then(function () {
            return n._cursor[e].apply(n._cursor, r), t(n._request).then(function (e) {
              if (e) return new u(e, n._request);
            });
          });
        });
      }), c.prototype.createIndex = function () {
        return new s(this._store.createIndex.apply(this._store, arguments));
      }, c.prototype.index = function () {
        return new s(this._store.index.apply(this._store, arguments));
      }, r(c, "_store", ["name", "keyPath", "indexNames", "autoIncrement"]), i(c, "_store", IDBObjectStore, ["put", "add", "delete", "clear", "get", "getAll", "getKey", "getAllKeys", "count"]), a(c, "_store", IDBObjectStore, ["openCursor", "openKeyCursor"]), o(c, "_store", IDBObjectStore, ["deleteIndex"]), l.prototype.objectStore = function () {
        return new c(this._tx.objectStore.apply(this._tx, arguments));
      }, r(l, "_tx", ["objectStoreNames", "mode"]), o(l, "_tx", IDBTransaction, ["abort"]), h.prototype.createObjectStore = function () {
        return new c(this._db.createObjectStore.apply(this._db, arguments));
      }, r(h, "_db", ["name", "version", "objectStoreNames"]), o(h, "_db", IDBDatabase, ["deleteObjectStore", "close"]), d.prototype.transaction = function () {
        return new l(this._db.transaction.apply(this._db, arguments));
      }, r(d, "_db", ["name", "version", "objectStoreNames"]), o(d, "_db", IDBDatabase, ["close"]), ["openCursor", "openKeyCursor"].forEach(function (e) {
        [c, s].forEach(function (t) {
          e in t.prototype && (t.prototype[e.replace("open", "iterate")] = function () {
            var t,
                n = (t = arguments, Array.prototype.slice.call(t)),
                r = n[n.length - 1],
                i = this._store || this._index,
                o = i[e].apply(i, n.slice(0, -1));

            o.onsuccess = function () {
              r(o.result);
            };
          });
        });
      }), [s, c].forEach(function (e) {
        e.prototype.getAll || (e.prototype.getAll = function (e, t) {
          var n = this,
              r = [];
          return new Promise(function (i) {
            n.iterateCursor(e, function (e) {
              e ? (r.push(e.value), void 0 === t || r.length != t ? e.continue() : i(r)) : i(r);
            });
          });
        });
      }), e.openDb = function (e, t, r) {
        var i = n(indexedDB, "open", [e, t]),
            o = i.request;
        return o && (o.onupgradeneeded = function (e) {
          r && r(new h(o.result, e.oldVersion, o.transaction));
        }), i.then(function (e) {
          return new d(e);
        });
      }, e.deleteDb = function (e) {
        return n(indexedDB, "deleteDatabase", [e]);
      }, Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }(t);
  }, function (e, t, n) {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0
    
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.
    
    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    function r() {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }

      var r = Array(e),
          i = 0;

      for (t = 0; t < n; t++) {
        for (var o = arguments[t], a = 0, s = o.length; a < s; a++, i++) {
          r[i] = o[a];
        }
      }

      return r;
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var i;
    n.r(t), n.d(t, "LogLevel", function () {
      return o;
    }), n.d(t, "Logger", function () {
      return h;
    }), n.d(t, "setLogLevel", function () {
      return d;
    }), n.d(t, "setUserLogHandler", function () {
      return f;
    });
    var o,
        a = [];
    !function (e) {
      e[e.DEBUG = 0] = "DEBUG", e[e.VERBOSE = 1] = "VERBOSE", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e[e.SILENT = 5] = "SILENT";
    }(o || (o = {}));

    var s = {
      debug: o.DEBUG,
      verbose: o.VERBOSE,
      info: o.INFO,
      warn: o.WARN,
      error: o.ERROR,
      silent: o.SILENT
    },
        u = o.INFO,
        c = ((i = {})[o.DEBUG] = "log", i[o.VERBOSE] = "log", i[o.INFO] = "info", i[o.WARN] = "warn", i[o.ERROR] = "error", i),
        l = function l(e, t) {
      for (var n = [], i = 2; i < arguments.length; i++) {
        n[i - 2] = arguments[i];
      }

      if (!(t < e.logLevel)) {
        var o = new Date().toISOString(),
            a = c[t];
        if (!a) throw new Error("Attempted to log a message with an invalid logType (value: " + t + ")");
        console[a].apply(console, r(["[" + o + "]  " + e.name + ":"], n));
      }
    },
        h = function () {
      function e(e) {
        this.name = e, this._logLevel = u, this._logHandler = l, this._userLogHandler = null, a.push(this);
      }

      return Object.defineProperty(e.prototype, "logLevel", {
        get: function get() {
          return this._logLevel;
        },
        set: function set(e) {
          if (!(e in o)) throw new TypeError("Invalid value assigned to `logLevel`");
          this._logLevel = e;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "logHandler", {
        get: function get() {
          return this._logHandler;
        },
        set: function set(e) {
          if ("function" != typeof e) throw new TypeError("Value assigned to `logHandler` must be a function");
          this._logHandler = e;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "userLogHandler", {
        get: function get() {
          return this._userLogHandler;
        },
        set: function set(e) {
          this._userLogHandler = e;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.debug = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        this._userLogHandler && this._userLogHandler.apply(this, r([this, o.DEBUG], e)), this._logHandler.apply(this, r([this, o.DEBUG], e));
      }, e.prototype.log = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        this._userLogHandler && this._userLogHandler.apply(this, r([this, o.VERBOSE], e)), this._logHandler.apply(this, r([this, o.VERBOSE], e));
      }, e.prototype.info = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        this._userLogHandler && this._userLogHandler.apply(this, r([this, o.INFO], e)), this._logHandler.apply(this, r([this, o.INFO], e));
      }, e.prototype.warn = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        this._userLogHandler && this._userLogHandler.apply(this, r([this, o.WARN], e)), this._logHandler.apply(this, r([this, o.WARN], e));
      }, e.prototype.error = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        this._userLogHandler && this._userLogHandler.apply(this, r([this, o.ERROR], e)), this._logHandler.apply(this, r([this, o.ERROR], e));
      }, e;
    }();

    function d(e) {
      var t = "string" == typeof e ? s[e] : e;
      a.forEach(function (e) {
        e.logLevel = t;
      });
    }

    function f(e, t) {
      for (var n = function n(_n6) {
        var r = null;
        t && t.level && (r = s[t.level]), _n6.userLogHandler = null === e ? null : function (t, n) {
          for (var i = [], a = 2; a < arguments.length; a++) {
            i[a - 2] = arguments[a];
          }

          var s = i.map(function (e) {
            if (null == e) return null;
            if ("string" == typeof e) return e;
            if ("number" == typeof e || "boolean" == typeof e) return e.toString();
            if (e instanceof Error) return e.message;

            try {
              return JSON.stringify(e);
            } catch (e) {
              return null;
            }
          }).filter(function (e) {
            return e;
          }).join(" ");
          n >= (null != r ? r : t.logLevel) && e({
            level: o[n].toLowerCase(),
            message: s,
            args: i,
            type: t.name
          });
        };
      }, r = 0, i = a; r < i.length; r++) {
        n(i[r]);
      }
    }
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return a;
    }), n.d(t, "b", function () {
      return u;
    }), n.d(t, "d", function () {
      return c;
    }), n.d(t, "c", function () {
      return h;
    }), n.d(t, "e", function () {
      return d;
    });
    var r = n(0),
        i = n.n(r),
        o = n(1);

    var a = function a(e) {
      return e.map(function (e) {
        return _objectSpread({}, e, {
          dataIndex: e.dataIndex || e.key,
          width: 50,
          ellipsis: !0
        });
      });
    };

    var s = function s() {
      throw Error("Please configure Table widget formatColumns");
    };

    var u = function u() {
      return s.apply(void 0, arguments);
    },
        c = function c(e) {
      s = e;
    };

    var l = function l() {
      return i.a.createElement(o.EmptyState, {
        __source: {
          fileName: "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetResources\\Table\\helpers.tsx",
          lineNumber: 32
        },
        __self: void 0
      });
    };

    var h = function h() {
      return l.apply(void 0, arguments);
    },
        d = function d(e) {
      l = e;
    };
  }, function (e, t, n) {
    "use strict";

    n.d(t, "b", function () {
      return s;
    }), n.d(t, "c", function () {
      return u;
    }), n.d(t, "e", function () {
      return c;
    }), n.d(t, "a", function () {
      return l;
    }), n.d(t, "d", function () {
      return h;
    });
    var r = n(0),
        i = n(5),
        o = n(18),
        a = n(20);

    function s(e, t, n) {
      var _Object4 = Object(r.useState)(""),
          _Object5 = _slicedToArray(_Object4, 2),
          o = _Object5[0],
          s = _Object5[1],
          u = Object(i.useDebounce)(o, 500);

      return Object(r.useEffect)(function () {
        var r;
        (null === (r = e.filter) || void 0 === r ? void 0 : r.searchTerm) !== u && (t(_objectSpread({}, e, {
          filter: _objectSpread({}, e.filter, {
            searchTerm: u
          })
        })), n(a.c));
      }, [u, e, n, t]), [o, s];
    }

    function u(e) {
      var t = Object(i.useQuery)();
      return Object(r.useMemo)(function () {
        return t[e];
      }, [t, e]);
    }

    function c(e) {
      var t = Object(o.useHistory)();
      return Object(r.useCallback)(function (n) {
        return t.push({
          search: "?".concat(e, "=").concat(n)
        });
      }, [e, t]);
    }

    var l = function l(e, t) {
      return function (n, i, o, a, s) {
        var u = Object(r.useMemo)(function () {
          return e(n, i);
        }, [n, i]),
            c = n.filter || {};
        return Object(r.useMemo)(function () {
          return t(u, c, o, a, s);
        }, [c, o, a, s, u]);
      };
    };

    function h(e, t, n) {
      var a = n(e, Object(o.useHistory)()),
          s = Object(i.mergeProps)(a.filter, t);
      a.filter = s;

      var _Object6 = Object(r.useState)(a),
          _Object7 = _slicedToArray(_Object6, 2),
          u = _Object7[0],
          c = _Object7[1];

      return [u, c];
    }
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      n.d(t, "a", function () {
        return i;
      });
      var r = n(10);
      var i = {
        counter: {
          type: r.a.counter,
          title: e.modules.widget.selectWidget.counter.title,
          description: e.modules.widget.selectWidget.counter.description,
          icon: "time",
          sizeConstraints: {
            minW: 3,
            maxW: 6,
            minH: 3,
            maxH: 6
          }
        },
        table: {
          type: r.a.table,
          title: e.modules.widget.selectWidget.table.title,
          description: e.modules.widget.selectWidget.table.description,
          icon: "list",
          sizeConstraints: {
            minW: 6,
            maxW: 12,
            minH: 9,
            maxH: 16
          }
        }
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        i = n.n(r),
        o = n(1),
        a = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\ActionStatusInfo\\ActionStatusInfo.tsx";

    function s(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var u = function u(_ref5) {
      var e = _ref5.content,
          t = _ref5.footer,
          n = _ref5.header,
          r = _ref5.height,
          s = _ref5.isVisible,
          u = _ref5.onCancel;
      return i.a.createElement(o.Modal, {
        zIndex: 9999,
        footer: t ? t() : function () {},
        onCancel: u,
        visible: s,
        pageTitle: n ? n() : function () {},
        bodyStyle: r ? {
          height: r
        } : void 0,
        __source: {
          fileName: a,
          lineNumber: 25
        },
        __self: void 0
      }, e());
    };

    var c =
    /*#__PURE__*/
    function (_i$a$Component) {
      _inherits(c, _i$a$Component);

      _createClass(c, null, [{
        key: "showActionStatus",
        value: function showActionStatus(e) {
          c.Instance._showActionStatus(e);
        }
      }, {
        key: "closeActionStatus",
        value: function closeActionStatus() {
          c.Instance._closeActionStatus();
        }
      }]);

      function c(e) {
        var _this18;

        _classCallCheck(this, c);

        _this18 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, e)), s(_assertThisInitialized(_this18), "_showActionStatus", function (_ref6) {
          var e = _ref6.content,
              t = _ref6.header,
              n = _ref6.height,
              r = _ref6.footer;

          _this18.setState({
            isVisible: !0,
            content: e,
            header: t,
            height: n,
            footer: r
          });
        }), s(_assertThisInitialized(_this18), "_closeActionStatus", function () {
          _this18.setState({
            isVisible: !1,
            content: function content() {
              return null;
            },
            header: function header() {
              return null;
            }
          });
        }), s(_assertThisInitialized(_this18), "onCancel", function () {
          _this18.setState({
            isVisible: !1
          });
        }), _this18.state = {
          isVisible: !1,
          content: function content() {
            return null;
          },
          header: function header() {
            return null;
          },
          footer: function footer() {
            return null;
          }
        }, c.Instance = _assertThisInitialized(_this18);
        return _this18;
      }

      _createClass(c, [{
        key: "render",
        value: function render() {
          return i.a.createElement(u, {
            content: this.state.content,
            isVisible: this.state.isVisible,
            header: this.state.header,
            footer: this.state.footer,
            height: this.state.height,
            onCancel: this.onCancel,
            __source: {
              fileName: a,
              lineNumber: 93
            },
            __self: this
          });
        }
      }]);

      return c;
    }(i.a.Component);

    s(c, "Instance", void 0);

    var l = function l(e) {
      c.showActionStatus(e);
    },
        h = function h() {
      c.closeActionStatus();
    };

    n.d(t, "a", function () {
      return c;
    }), n.d(t, "c", function () {
      return l;
    }), n.d(t, "b", function () {
      return h;
    });
  }, function (e, t, n) {
    (function (t) {
      var n = "Expected a function",
          r = NaN,
          i = "[object Symbol]",
          o = /^\s+|\s+$/g,
          a = /^[-+]0x[0-9a-f]+$/i,
          s = /^0b[01]+$/i,
          u = /^0o[0-7]+$/i,
          c = parseInt,
          l = "object" == typeof t && t && t.Object === Object && t,
          h = "object" == typeof self && self && self.Object === Object && self,
          d = l || h || Function("return this")(),
          f = Object.prototype.toString,
          p = Math.max,
          m = Math.min,
          _ = function _() {
        return d.Date.now();
      };

      function y(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
      }

      function v(e) {
        if ("number" == typeof e) return e;
        if (function (e) {
          return "symbol" == typeof e || function (e) {
            return !!e && "object" == typeof e;
          }(e) && f.call(e) == i;
        }(e)) return r;

        if (y(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = y(t) ? t + "" : t;
        }

        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(o, "");
        var n = s.test(e);
        return n || u.test(e) ? c(e.slice(2), n ? 2 : 8) : a.test(e) ? r : +e;
      }

      e.exports = function (e, t, r) {
        var i,
            o,
            a,
            s,
            u,
            c,
            l = 0,
            h = !1,
            d = !1,
            f = !0;
        if ("function" != typeof e) throw new TypeError(n);

        function g(t) {
          var n = i,
              r = o;
          return i = o = void 0, l = t, s = e.apply(r, n);
        }

        function b(e) {
          var n = e - c;
          return void 0 === c || n >= t || n < 0 || d && e - l >= a;
        }

        function w() {
          var e = _();

          if (b(e)) return T(e);
          u = setTimeout(w, function (e) {
            var n = t - (e - c);
            return d ? m(n, a - (e - l)) : n;
          }(e));
        }

        function T(e) {
          return u = void 0, f && i ? g(e) : (i = o = void 0, s);
        }

        function M() {
          var e = _(),
              n = b(e);

          if (i = arguments, o = this, c = e, n) {
            if (void 0 === u) return function (e) {
              return l = e, u = setTimeout(w, t), h ? g(e) : s;
            }(c);
            if (d) return u = setTimeout(w, t), g(c);
          }

          return void 0 === u && (u = setTimeout(w, t)), s;
        }

        return t = v(t) || 0, y(r) && (h = !!r.leading, a = (d = "maxWait" in r) ? p(v(r.maxWait) || 0, t) : a, f = "trailing" in r ? !!r.trailing : f), M.cancel = function () {
          void 0 !== u && clearTimeout(u), l = 0, i = c = o = u = void 0;
        }, M.flush = function () {
          return void 0 === u ? s : T(_());
        }, M;
      };
    }).call(this, n(17));
  }, function (e, t) {
    e.exports = "data:image/svg+xml;base64,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";
  }, function (e, t) {
    var n,
        r,
        i = e.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function s(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (e) {
        n = o;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (e) {
        r = a;
      }
    }();
    var u,
        c = [],
        l = !1,
        h = -1;

    function d() {
      l && u && (l = !1, u.length ? c = u.concat(c) : h = -1, c.length && f());
    }

    function f() {
      if (!l) {
        var e = s(d);
        l = !0;

        for (var t = c.length; t;) {
          for (u = c, c = []; ++h < t;) {
            u && u[h].run();
          }

          h = -1, t = c.length;
        }

        u = null, l = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

          try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }

    function p(e, t) {
      this.fun = e, this.array = t;
    }

    function m() {}

    i.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      c.push(new p(e, t)), 1 !== c.length || l || s(f);
    }, p.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = m, i.addListener = m, i.once = m, i.off = m, i.removeListener = m, i.removeAllListeners = m, i.emit = m, i.prependListener = m, i.prependOnceListener = m, i.listeners = function (e) {
      return [];
    }, i.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "registerInstallations", function () {
      return ie;
    });
    var r,
        i = n(6),
        o = n.n(i),
        a = n(13),
        s = n(3),
        u = n(16),
        c = n(24),
        l = "@firebase/installations",
        h = "0.4.9",
        d = 1e4,
        f = "w:" + h,
        p = "FIS_v2",
        m = "https://firebaseinstallations.googleapis.com/v1",
        _ = 36e5,
        y = ((r = {})["missing-app-config-values"] = 'Missing App configuration value: "{$valueName}"', r["not-registered"] = "Firebase Installation is not registered.", r["installation-not-found"] = "Firebase Installation not found.", r["request-failed"] = '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"', r["app-offline"] = "Could not process request. Application offline.", r["delete-pending-registration"] = "Can't delete installation while there is a pending registration request.", r),
        v = new u.ErrorFactory("installations", "Installations", y);

    function g(e) {
      return e instanceof u.FirebaseError && e.code.includes("request-failed");
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function b(e) {
      var t = e.projectId;
      return m + "/projects/" + t + "/installations";
    }

    function w(e) {
      return {
        token: e.token,
        requestStatus: 2,
        expiresIn: (t = e.expiresIn, Number(t.replace("s", "000"))),
        creationTime: Date.now()
      };
      var t;
    }

    function T(e, t) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var n, r;
        return Object(s.__generator)(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, t.json()];

            case 1:
              return n = i.sent(), r = n.error, [2, v.create("request-failed", {
                requestName: e,
                serverCode: r.code,
                serverMessage: r.message,
                serverStatus: r.status
              })];
          }
        });
      });
    }

    function M(e) {
      var t = e.apiKey;
      return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": t
      });
    }

    function E(e, t) {
      var n = t.refreshToken,
          r = M(e);
      return r.append("Authorization", function (e) {
        return p + " " + e;
      }
      /**
       * @license
       * Copyright 2019 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */
      (n)), r;
    }

    function k(e) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var t;
        return Object(s.__generator)(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, e()];

            case 1:
              return (t = n.sent()).status >= 500 && t.status < 600 ? [2, e()] : [2, t];
          }
        });
      });
    }

    function L(e, t) {
      var n = t.fid;
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var t, r, i, o, a, u;
        return Object(s.__generator)(this, function (s) {
          switch (s.label) {
            case 0:
              return t = b(e), r = M(e), i = {
                fid: n,
                authVersion: p,
                appId: e.appId,
                sdkVersion: f
              }, o = {
                method: "POST",
                headers: r,
                body: JSON.stringify(i)
              }, [4, k(function () {
                return fetch(t, o);
              })];

            case 1:
              return (a = s.sent()).ok ? [4, a.json()] : [3, 3];

            case 2:
              return u = s.sent(), [2, {
                fid: u.fid || n,
                registrationStatus: 2,
                refreshToken: u.refreshToken,
                authToken: w(u.authToken)
              }];

            case 3:
              return [4, T("Create Installation", a)];

            case 4:
              throw s.sent();
          }
        });
      });
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function S(e) {
      return new Promise(function (t) {
        setTimeout(t, e);
      });
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var N = /^[cdef][\w-]{21}$/,
        D = "";

    function I() {
      try {
        var e = new Uint8Array(17);
        (self.crypto || self.msCrypto).getRandomValues(e), e[0] = 112 + e[0] % 16;

        var t = function (e) {
          return (t = e, btoa(String.fromCharCode.apply(String, Object(s.__spread)(t))).replace(/\+/g, "-").replace(/\//g, "_")).substr(0, 22);
          var t;
        }
        /**
         * @license
         * Copyright 2019 Google Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         *   http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         */
        (e);

        return N.test(t) ? t : D;
      } catch (e) {
        return D;
      }
    }

    function R(e) {
      return e.appName + "!" + e.appId;
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var x = new Map();

    function Y(e, t) {
      var n = R(e);
      C(n, t), function (e, t) {
        var n = F();
        n && n.postMessage({
          key: e,
          fid: t
        });
        A();
      }(n, t);
    }

    function C(e, t) {
      var n,
          r,
          i = x.get(e);
      if (i) try {
        for (var o = Object(s.__values)(i), a = o.next(); !a.done; a = o.next()) {
          (0, a.value)(t);
        }
      } catch (e) {
        n = {
          error: e
        };
      } finally {
        try {
          a && !a.done && (r = o.return) && r.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }

    var O = null;

    function F() {
      return !O && "BroadcastChannel" in self && ((O = new BroadcastChannel("[Firebase] FID Change")).onmessage = function (e) {
        C(e.data.key, e.data.fid);
      }), O;
    }

    function A() {
      0 === x.size && O && (O.close(), O = null);
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var j = "firebase-installations-database",
        U = 1,
        P = "firebase-installations-store",
        V = null;

    function W() {
      return V || (V = Object(c.openDb)(j, U, function (e) {
        switch (e.oldVersion) {
          case 0:
            e.createObjectStore(P);
        }
      })), V;
    }

    function H(e, t) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var n, r, i, o, a;
        return Object(s.__generator)(this, function (s) {
          switch (s.label) {
            case 0:
              return n = R(e), [4, W()];

            case 1:
              return r = s.sent(), i = r.transaction(P, "readwrite"), [4, (o = i.objectStore(P)).get(n)];

            case 2:
              return a = s.sent(), [4, o.put(t, n)];

            case 3:
              return s.sent(), [4, i.complete];

            case 4:
              return s.sent(), a && a.fid === t.fid || Y(e, t.fid), [2, t];
          }
        });
      });
    }

    function B(e) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var t, n, r;
        return Object(s.__generator)(this, function (i) {
          switch (i.label) {
            case 0:
              return t = R(e), [4, W()];

            case 1:
              return n = i.sent(), [4, (r = n.transaction(P, "readwrite")).objectStore(P).delete(t)];

            case 2:
              return i.sent(), [4, r.complete];

            case 3:
              return i.sent(), [2];
          }
        });
      });
    }

    function z(e, t) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var n, r, i, o, a, u;
        return Object(s.__generator)(this, function (s) {
          switch (s.label) {
            case 0:
              return n = R(e), [4, W()];

            case 1:
              return r = s.sent(), i = r.transaction(P, "readwrite"), [4, (o = i.objectStore(P)).get(n)];

            case 2:
              return a = s.sent(), void 0 !== (u = t(a)) ? [3, 4] : [4, o.delete(n)];

            case 3:
              return s.sent(), [3, 6];

            case 4:
              return [4, o.put(u, n)];

            case 5:
              s.sent(), s.label = 6;

            case 6:
              return [4, i.complete];

            case 7:
              return s.sent(), !u || a && a.fid === u.fid || Y(e, u.fid), [2, u];
          }
        });
      });
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Z(e) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var t, n, r;
        return Object(s.__generator)(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, z(e, function (n) {
                var r = function (e) {
                  return q(e || {
                    fid: I(),
                    registrationStatus: 0
                  });
                }(n),
                    i = function (e, t) {
                  if (0 === t.registrationStatus) {
                    if (!navigator.onLine) {
                      var n = Promise.reject(v.create("app-offline"));
                      return {
                        installationEntry: t,
                        registrationPromise: n
                      };
                    }

                    var r = {
                      fid: t.fid,
                      registrationStatus: 1,
                      registrationTime: Date.now()
                    },
                        i = function (e, t) {
                      return Object(s.__awaiter)(this, void 0, void 0, function () {
                        var n, r;
                        return Object(s.__generator)(this, function (i) {
                          switch (i.label) {
                            case 0:
                              return i.trys.push([0, 2,, 7]), [4, L(e, t)];

                            case 1:
                              return n = i.sent(), [2, H(e, n)];

                            case 2:
                              return g(r = i.sent()) && 409 === r.serverCode ? [4, B(e)] : [3, 4];

                            case 3:
                              return i.sent(), [3, 6];

                            case 4:
                              return [4, H(e, {
                                fid: t.fid,
                                registrationStatus: 0
                              })];

                            case 5:
                              i.sent(), i.label = 6;

                            case 6:
                              throw r;

                            case 7:
                              return [2];
                          }
                        });
                      });
                    }(e, r);

                    return {
                      installationEntry: r,
                      registrationPromise: i
                    };
                  }

                  return 1 === t.registrationStatus ? {
                    installationEntry: t,
                    registrationPromise: Q(e)
                  } : {
                    installationEntry: t
                  };
                }(e, r);

                return t = i.registrationPromise, i.installationEntry;
              })];

            case 1:
              return (n = i.sent()).fid !== D ? [3, 3] : (r = {}, [4, t]);

            case 2:
              return [2, (r.installationEntry = i.sent(), r)];

            case 3:
              return [2, {
                installationEntry: n,
                registrationPromise: t
              }];
          }
        });
      });
    }

    function Q(e) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var t, n, r, i;
        return Object(s.__generator)(this, function (o) {
          switch (o.label) {
            case 0:
              return [4, G(e)];

            case 1:
              t = o.sent(), o.label = 2;

            case 2:
              return 1 !== t.registrationStatus ? [3, 5] : [4, S(100)];

            case 3:
              return o.sent(), [4, G(e)];

            case 4:
              return t = o.sent(), [3, 2];

            case 5:
              return 0 !== t.registrationStatus ? [3, 7] : [4, Z(e)];

            case 6:
              return n = o.sent(), r = n.installationEntry, (i = n.registrationPromise) ? [2, i] : [2, r];

            case 7:
              return [2, t];
          }
        });
      });
    }

    function G(e) {
      return z(e, function (e) {
        if (!e) throw v.create("installation-not-found");
        return q(e);
      });
    }

    function q(e) {
      return 1 === (t = e).registrationStatus && t.registrationTime + d < Date.now() ? {
        fid: e.fid,
        registrationStatus: 0
      } : e;
      var t;
      /**
       * @license
       * Copyright 2019 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */
    }

    function J(e, t) {
      var n = e.appConfig,
          r = e.platformLoggerProvider;
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var e, i, o, a, u, c, l;
        return Object(s.__generator)(this, function (s) {
          switch (s.label) {
            case 0:
              return e = function (e, t) {
                var n = t.fid;
                return b(e) + "/" + n + "/authTokens:generate";
              }
              /**
               * @license
               * Copyright 2019 Google Inc.
               *
               * Licensed under the Apache License, Version 2.0 (the "License");
               * you may not use this file except in compliance with the License.
               * You may obtain a copy of the License at
               *
               *   http://www.apache.org/licenses/LICENSE-2.0
               *
               * Unless required by applicable law or agreed to in writing, software
               * distributed under the License is distributed on an "AS IS" BASIS,
               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
               * See the License for the specific language governing permissions and
               * limitations under the License.
               */
              (n, t), i = E(n, t), (o = r.getImmediate({
                optional: !0
              })) && i.append("x-firebase-client", o.getPlatformInfoString()), a = {
                installation: {
                  sdkVersion: f
                }
              }, u = {
                method: "POST",
                headers: i,
                body: JSON.stringify(a)
              }, [4, k(function () {
                return fetch(e, u);
              })];

            case 1:
              return (c = s.sent()).ok ? [4, c.json()] : [3, 3];

            case 2:
              return l = s.sent(), [2, w(l)];

            case 3:
              return [4, T("Generate Auth Token", c)];

            case 4:
              throw s.sent();
          }
        });
      });
    }

    function X(e, t) {
      return void 0 === t && (t = !1), Object(s.__awaiter)(this, void 0, void 0, function () {
        var n, r, i;
        return Object(s.__generator)(this, function (o) {
          switch (o.label) {
            case 0:
              return [4, z(e.appConfig, function (r) {
                if (!$(r)) throw v.create("not-registered");
                var i,
                    o = r.authToken;

                if (t || 2 !== (i = o).requestStatus || function (e) {
                  var t = Date.now();
                  return t < e.creationTime || e.creationTime + e.expiresIn < t + _;
                }(i)) {
                  if (1 === o.requestStatus) return n = function (e, t) {
                    return Object(s.__awaiter)(this, void 0, void 0, function () {
                      var n, r;
                      return Object(s.__generator)(this, function (i) {
                        switch (i.label) {
                          case 0:
                            return [4, K(e.appConfig)];

                          case 1:
                            n = i.sent(), i.label = 2;

                          case 2:
                            return 1 !== n.authToken.requestStatus ? [3, 5] : [4, S(100)];

                          case 3:
                            return i.sent(), [4, K(e.appConfig)];

                          case 4:
                            return n = i.sent(), [3, 2];

                          case 5:
                            return 0 === (r = n.authToken).requestStatus ? [2, X(e, t)] : [2, r];
                        }
                      });
                    });
                  }(e, t), r;
                  if (!navigator.onLine) throw v.create("app-offline");

                  var a = function (e) {
                    var t = {
                      requestStatus: 1,
                      requestTime: Date.now()
                    };
                    return Object(s.__assign)(Object(s.__assign)({}, e), {
                      authToken: t
                    });
                  }(r);

                  return n = function (e, t) {
                    return Object(s.__awaiter)(this, void 0, void 0, function () {
                      var n, r, i;
                      return Object(s.__generator)(this, function (o) {
                        switch (o.label) {
                          case 0:
                            return o.trys.push([0, 3,, 8]), [4, J(e, t)];

                          case 1:
                            return n = o.sent(), i = Object(s.__assign)(Object(s.__assign)({}, t), {
                              authToken: n
                            }), [4, H(e.appConfig, i)];

                          case 2:
                            return o.sent(), [2, n];

                          case 3:
                            return !g(r = o.sent()) || 401 !== r.serverCode && 404 !== r.serverCode ? [3, 5] : [4, B(e.appConfig)];

                          case 4:
                            return o.sent(), [3, 7];

                          case 5:
                            return i = Object(s.__assign)(Object(s.__assign)({}, t), {
                              authToken: {
                                requestStatus: 0
                              }
                            }), [4, H(e.appConfig, i)];

                          case 6:
                            o.sent(), o.label = 7;

                          case 7:
                            throw r;

                          case 8:
                            return [2];
                        }
                      });
                    });
                  }(e, a), a;
                }

                return r;
              })];

            case 1:
              return r = o.sent(), n ? [4, n] : [3, 3];

            case 2:
              return i = o.sent(), [3, 4];

            case 3:
              i = r.authToken, o.label = 4;

            case 4:
              return [2, i];
          }
        });
      });
    }

    function K(e) {
      return z(e, function (e) {
        if (!$(e)) throw v.create("not-registered");
        var t,
            n = e.authToken;
        return 1 === (t = n).requestStatus && t.requestTime + d < Date.now() ? Object(s.__assign)(Object(s.__assign)({}, e), {
          authToken: {
            requestStatus: 0
          }
        }) : e;
      });
    }

    function $(e) {
      return void 0 !== e && 2 === e.registrationStatus;
    }

    function ee(e) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var t;
        return Object(s.__generator)(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, Z(e)];

            case 1:
              return (t = n.sent().registrationPromise) ? [4, t] : [3, 3];

            case 2:
              n.sent(), n.label = 3;

            case 3:
              return [2];
          }
        });
      });
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function te(e, t) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var n, r, i, o;
        return Object(s.__generator)(this, function (a) {
          switch (a.label) {
            case 0:
              return n = function (e, t) {
                var n = t.fid;
                return b(e) + "/" + n;
              }
              /**
               * @license
               * Copyright 2019 Google Inc.
               *
               * Licensed under the Apache License, Version 2.0 (the "License");
               * you may not use this file except in compliance with the License.
               * You may obtain a copy of the License at
               *
               *   http://www.apache.org/licenses/LICENSE-2.0
               *
               * Unless required by applicable law or agreed to in writing, software
               * distributed under the License is distributed on an "AS IS" BASIS,
               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
               * See the License for the specific language governing permissions and
               * limitations under the License.
               */
              (e, t), r = E(e, t), i = {
                method: "DELETE",
                headers: r
              }, [4, k(function () {
                return fetch(n, i);
              })];

            case 1:
              return (o = a.sent()).ok ? [3, 3] : [4, T("Delete Installation", o)];

            case 2:
              throw a.sent();

            case 3:
              return [2];
          }
        });
      });
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function ne(e, t) {
      var n = e.appConfig;
      return function (e, t) {
        F();
        var n = R(e),
            r = x.get(n);
        r || (r = new Set(), x.set(n, r)), r.add(t);
      }(n, t), function () {
        !function (e, t) {
          var n = R(e),
              r = x.get(n);
          r && (r.delete(t), 0 === r.size && x.delete(n), A());
        }(n, t);
      };
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function re(e) {
      return v.create("missing-app-config-values", {
        valueName: e
      });
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function ie(e) {
      e.INTERNAL.registerComponent(new a.Component("installations", function (e) {
        var t = e.getProvider("app").getImmediate(),
            n = {
          appConfig: function (e) {
            var t, n;
            if (!e || !e.options) throw re("App Configuration");
            if (!e.name) throw re("App Name");

            try {
              for (var r = Object(s.__values)(["projectId", "apiKey", "appId"]), i = r.next(); !i.done; i = r.next()) {
                var o = i.value;
                if (!e.options[o]) throw re(o);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                i && !i.done && (n = r.return) && n.call(r);
              } finally {
                if (t) throw t.error;
              }
            }

            return {
              appName: e.name,
              projectId: e.options.projectId,
              apiKey: e.options.apiKey,
              appId: e.options.appId
            };
          }(t),
          platformLoggerProvider: e.getProvider("platform-logger")
        };
        return {
          app: t,
          getId: function getId() {
            /**
             * @license
             * Copyright 2019 Google Inc.
             *
             * Licensed under the Apache License, Version 2.0 (the "License");
             * you may not use this file except in compliance with the License.
             * You may obtain a copy of the License at
             *
             *   http://www.apache.org/licenses/LICENSE-2.0
             *
             * Unless required by applicable law or agreed to in writing, software
             * distributed under the License is distributed on an "AS IS" BASIS,
             * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
             * See the License for the specific language governing permissions and
             * limitations under the License.
             */
            return function (e) {
              return Object(s.__awaiter)(this, void 0, void 0, function () {
                var t, n, r;
                return Object(s.__generator)(this, function (i) {
                  switch (i.label) {
                    case 0:
                      return [4, Z(e.appConfig)];

                    case 1:
                      return t = i.sent(), n = t.installationEntry, (r = t.registrationPromise) ? r.catch(console.error) : X(e).catch(console.error), [2, n.fid];
                  }
                });
              });
            }
            /**
             * @license
             * Copyright 2019 Google Inc.
             *
             * Licensed under the Apache License, Version 2.0 (the "License");
             * you may not use this file except in compliance with the License.
             * You may obtain a copy of the License at
             *
             *   http://www.apache.org/licenses/LICENSE-2.0
             *
             * Unless required by applicable law or agreed to in writing, software
             * distributed under the License is distributed on an "AS IS" BASIS,
             * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
             * See the License for the specific language governing permissions and
             * limitations under the License.
             */
            (n);
          },
          getToken: function getToken(e) {
            return function (e, t) {
              return void 0 === t && (t = !1), Object(s.__awaiter)(this, void 0, void 0, function () {
                return Object(s.__generator)(this, function (n) {
                  switch (n.label) {
                    case 0:
                      return [4, ee(e.appConfig)];

                    case 1:
                      return n.sent(), [4, X(e, t)];

                    case 2:
                      return [2, n.sent().token];
                  }
                });
              });
            }(n, e);
          },
          delete: function _delete() {
            return function (e) {
              return Object(s.__awaiter)(this, void 0, void 0, function () {
                var t, n;
                return Object(s.__generator)(this, function (r) {
                  switch (r.label) {
                    case 0:
                      return [4, z(t = e.appConfig, function (e) {
                        if (!e || 0 !== e.registrationStatus) return e;
                      })];

                    case 1:
                      if (!(n = r.sent())) return [3, 6];
                      if (1 !== n.registrationStatus) return [3, 2];
                      throw v.create("delete-pending-registration");

                    case 2:
                      if (2 !== n.registrationStatus) return [3, 6];
                      if (navigator.onLine) return [3, 3];
                      throw v.create("app-offline");

                    case 3:
                      return [4, te(t, n)];

                    case 4:
                      return r.sent(), [4, B(t)];

                    case 5:
                      r.sent(), r.label = 6;

                    case 6:
                      return [2];
                  }
                });
              });
            }(n);
          },
          onIdChange: function onIdChange(e) {
            return ne(n, e);
          }
        };
      }, "PUBLIC")), e.registerVersion(l, h);
    }

    ie(o.a);
  }, function (e, t, n) {
    "use strict";

    var _marked =
    /*#__PURE__*/
    _regeneratorRuntime.mark(fe),
        _marked2 =
    /*#__PURE__*/
    _regeneratorRuntime.mark(pe),
        _marked3 =
    /*#__PURE__*/
    _regeneratorRuntime.mark(me),
        _marked4 =
    /*#__PURE__*/
    _regeneratorRuntime.mark(_e);

    var r = n(10),
        i = n(19),
        o = n(61),
        a = n(4),
        s = function s(e) {
      return "@@redux-saga/" + e;
    },
        u = s("IO"),
        c = s("MULTICAST");

    var l = function l(e) {
      return null == e;
    },
        h = function h(e) {
      return null != e;
    },
        d = function d(e) {
      return "function" == typeof e;
    },
        f = function f(e) {
      return "string" == typeof e;
    },
        p = Array.isArray,
        m = function e(t) {
      return t && (f(t) || v(t) || d(t) || p(t) && t.every(e));
    },
        _ = function _(e) {
      return e && d(e.take) && d(e.close);
    },
        y = function y(e) {
      return d(e) && e.hasOwnProperty("toString");
    },
        v = function v(e) {
      return Boolean(e) && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype;
    },
        g = function g(e) {
      return _(e) && e[c];
    };

    var b = function b(e) {
      return e;
    };

    "function" == typeof Symbol && Symbol.asyncIterator && Symbol.asyncIterator;

    var w = function w(e) {
      throw e;
    },
        T = function T(e) {
      return {
        value: e,
        done: !0
      };
    };

    var M = "TAKE",
        E = "PUT",
        k = "ALL",
        L = "FORK",
        S = "SELECT",
        N = function N(e, t) {
      var n;
      return (n = {})[u] = !0, n.combinator = !1, n.type = e, n.payload = t, n;
    };

    function D(e, t) {
      return void 0 === e && (e = "*"), m(e) ? N(M, {
        pattern: e
      }) : g(e) && h(t) && m(t) ? N(M, {
        channel: e,
        pattern: t
      }) : _(e) ? N(M, {
        channel: e
      }) : void 0;
    }

    function I(e, t) {
      return l(t) && (t = e, e = void 0), N(E, {
        channel: e,
        action: t
      });
    }

    function R(e, t) {
      var n,
          r = null;
      return d(e) ? n = e : (p(e) ? (r = e[0], n = e[1]) : (r = e.context, n = e.fn), r && f(n) && d(r[n]) && (n = r[n])), {
        context: r,
        fn: n,
        args: t
      };
    }

    function x(e) {
      for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
        n[r - 1] = arguments[r];
      }

      return N(L, R(e, n));
    }

    function Y(e) {
      void 0 === e && (e = b);

      for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
        n[r - 1] = arguments[r];
      }

      return N(S, {
        selector: e,
        args: n
      });
    }

    var C = function C(e) {
      return {
        done: !0,
        value: e
      };
    },
        O = {};

    function F(e) {
      return _(e) ? "channel" : y(e) ? String(e) : d(e) ? e.name : String(e);
    }

    function A(e, t, n) {
      var r,
          i,
          o,
          a = t;

      function s(t, n) {
        if (a === O) return C(t);
        if (n && !i) throw a = O, n;
        r && r(t);
        var s = n ? e[i](n) : e[a]();
        return a = s.nextState, o = s.effect, r = s.stateUpdater, i = s.errorState, a === O ? C(t) : o;
      }

      return function (e, t, n) {
        void 0 === t && (t = w), void 0 === n && (n = "iterator");
        var r = {
          meta: {
            name: n
          },
          next: e,
          throw: t,
          return: T,
          isSagaIterator: !0
        };
        return "undefined" != typeof Symbol && (r[Symbol.iterator] = function () {
          return r;
        }), r;
      }(s, function (e) {
        return s(null, e);
      }, n);
    }

    function j(e, t) {
      for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++) {
        r[i - 2] = arguments[i];
      }

      var o,
          a = {
        done: !1,
        value: D(e)
      },
          s = function s(e) {
        return o = e;
      };

      return A({
        q1: function q1() {
          return {
            nextState: "q2",
            effect: a,
            stateUpdater: s
          };
        },
        q2: function q2() {
          return {
            nextState: "q1",
            effect: (e = o, {
              done: !1,
              value: x.apply(void 0, [t].concat(r, [e]))
            })
          };
          var e;
        }
      }, "q1", "takeEvery(" + F(e) + ", " + t.name + ")");
    }

    function U(e, t) {
      for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++) {
        r[i - 2] = arguments[i];
      }

      return x.apply(void 0, [j, e, t].concat(r));
    }

    var P = n(12),
        V = (n(21), n(37));
    n(224);

    function W(e) {
      return function (t) {
        var n = t.dispatch,
            r = t.getState;
        return function (t) {
          return function (i) {
            return "function" == typeof i ? i(n, r, e) : t(i);
          };
        };
      };
    }

    var H = W();
    H.withExtraArgument = W;

    function B(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    ["A non-serializable value was detected in the state, in the path: `%s`. Value: %o", "Take a look at the reducer(s) handling this action type: %s.", "(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)"].join("\n"), ["A non-serializable value was detected in an action, in the path: `%s`. Value: %o", "Take a look at the logic that dispatched this action:  %o.", "(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)"].join("\n");

    function z(e, t) {
      return e ? "".concat(e, "/").concat(t) : t;
    }

    var Z = n(223),
        Q = n.n(Z),
        G = n(28);
    var q = null;

    function J(e) {
      q = e;
    }

    function X() {
      if (null === q) throw Error("Widget resources are not registered!");
      return q;
    }

    var K = (ee = ($ = {
      slice: "widgetContainer",
      initialState: {
        widgetItems: [],
        widgetData: {},
        widgetLayouts: []
      },
      reducers: {
        addWidget: function addWidget(e, _ref7) {
          var _ref7$payload = _ref7.payload,
              t = _ref7$payload.widgetItem,
              n = _ref7$payload.layoutDraft;

          (function (e, t) {
            e.forEach(function (e) {
              var n = t.find(function (t) {
                return t.i === e.i;
              });

              if (n) {
                var _t6 = n.x,
                    _r4 = n.y,
                    _i2 = n.w,
                    _o3 = n.h;
                e.x = _t6, e.y = _r4, e.w = _i2, e.h = _o3;
              }
            });
          })(e.widgetLayouts, n);

          var i = e.widgetItems.find(function (e) {
            return e.id === t.id;
          });
          if (i) i.dynamicWidgetArgs = t.dynamicWidgetArgs, i.widgetId = t.widgetId;else {
            var _i3 = G.a[t.type].sizeConstraints,
                _o4 = function (e) {
              var t = Q()(e, function (e) {
                return e.y;
              });
              return {
                x: 0,
                y: t ? t.y + 1 : Number.POSITIVE_INFINITY
              };
            }(n);

            e.widgetItems.push(t), e.widgetData[t.id] = {
              isLoading: !1,
              data: t.type === r.a.table ? {
                items: [],
                totalCount: 0
              } : null
            }, e.widgetLayouts.push(_objectSpread({}, _i3, {}, _o4, {
              i: "".concat(t.id),
              w: _i3.minW || 3,
              h: _i3.minH || 3
            }));
          }
        },
        removeWidget: function removeWidget(e, _ref8) {
          var t = _ref8.payload;
          var n = e.widgetItems.find(function (e) {
            return e.id === t;
          });
          n && (e.widgetItems = e.widgetItems.filter(function (e) {
            return e !== n;
          }), e.widgetLayouts = e.widgetLayouts.filter(function (e) {
            return e.i !== n.id;
          }));
        },
        clearWidgets: function clearWidgets(e) {
          e.widgetItems = [], e.widgetLayouts = [];
        },
        loadLayout: function loadLayout() {},
        loadLayoutSuccess: function loadLayoutSuccess(e, _ref9) {
          var _ref9$payload = _ref9.payload,
              t = _ref9$payload.widgetItems,
              n = _ref9$payload.widgetLayouts;
          e.widgetItems = t, e.widgetLayouts = n, e.widgetData = t.reduce(function (e, t) {
            return _objectSpread({}, e, _defineProperty({}, t.id, {
              isLoading: !1,
              data: t.type === r.a.table ? {
                items: [],
                totalCount: 0
              } : null
            }));
          }, {});
        },
        loadLayoutFail: function loadLayoutFail(e, _ref10) {
          var t = _ref10.payload;
        },
        restoreLayout: function restoreLayout(e) {
          var t = X();
          e.widgetItems = t.widgetItems, e.widgetLayouts = t.widgetLayouts, e.widgetData = t.widgetItems.reduce(function (e, t) {
            return _objectSpread({}, e, _defineProperty({}, t.id, {
              isLoading: !1,
              data: t.type === r.a.table ? {
                items: [],
                totalCount: 0
              } : null
            }));
          }, {});
        },
        saveLayout: function saveLayout(e, _ref11) {
          var t = _ref11.payload;
          e.widgetLayouts = t;
        },
        saveLayoutSuccess: function saveLayoutSuccess() {},
        saveLayoutFail: function saveLayoutFail(e, _ref12) {
          var t = _ref12.payload;
        },
        refreshBatch: function refreshBatch(e) {
          e.widgetItems.forEach(function (t) {
            e.widgetData[t.id] && (e.widgetData[t.id].isLoading = !0);
          });
        },
        refreshBatchFail: function refreshBatchFail(e, t) {
          e.error = t.payload;
        },
        refresh: function refresh(e, _ref13) {
          var t = _ref13.payload;
          e.widgetData[t.id] && (e.widgetData[t.id].isLoading = !0);
        },
        refreshSuccess: function refreshSuccess(e, _ref14) {
          var _ref14$payload = _ref14.payload,
              t = _ref14$payload.id,
              n = _ref14$payload.data;
          e.widgetData[t] && (e.widgetData[t] = {
            isLoading: !1,
            data: n
          });
        },
        refreshFail: function refreshFail(e, _ref15) {
          var t = _ref15.payload.id;
          e.widgetData[t] && (e.widgetData[t].isLoading = !1);
        }
      }
    }).slice, te = void 0 === ee ? "" : ee, ne = $.initialState, re = $.reducers || {}, ie = $.extraReducers || {}, oe = Object.keys(re), ae = function (e, t) {
      return function () {
        var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : e,
            r = arguments.length > 1 ? arguments[1] : void 0;
        return Object(V.a)(n, function (e) {
          var n = t[r.type];
          return n ? n(e, r) : void 0;
        });
      };
    }(ne, oe.reduce(function (e, t) {
      return e[z(te, t)] = re[t], e;
    }, ie)), se = oe.reduce(function (e, t) {
      var n = z(te, t);
      return e[t] = function (e) {
        function t(t) {
          return {
            type: e,
            payload: t
          };
        }

        return t.toString = function () {
          return "".concat(e);
        }, t.type = e, t;
      }(n), e;
    }, {}), ue = B({}, function (e) {
      return e ? "get ".concat(e).replace(/(?:^\w|[A-Z]|\b\w)/g, function (e, t) {
        return 0 === t ? e.toLowerCase() : e.toUpperCase();
      }).replace(/\s+/g, "").replace(/[-_]/g, "") : "getState";
    }(te), function (e) {
      return e ? function (t) {
        return t[e];
      } : function (e) {
        return e;
      };
    }(te)), {
      slice: te,
      reducer: ae,
      actions: se,
      selectors: ue
    });
    var $, ee, te, ne, re, ie, oe, ae, se, ue;
    var ce = K.actions,
        le = K.reducer;
    var he = n(11);
    var de = {
      bucket: "settings",
      container: "dashboardLayout"
    };

    function fe(_ref16) {
      var e, t, n;
      return _regeneratorRuntime.wrap(function fe$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              e = _ref16.payload;
              t = Object(he.c)(e.type, e.widgetId);
              _context12.next = 4;
              return Object(P.d)().getResources(t.getResourceRequestParams(e.dynamicWidgetArgs));

            case 4:
              n = _context12.sent;
              _context12.next = 7;
              return I(ce.refreshSuccess({
                id: e.id,
                data: t.transformData(n)
              }));

            case 7:
            case "end":
              return _context12.stop();
          }
        }
      }, _marked);
    }

    function pe() {
      var _n7, _r5, _i4, e, t;

      return _regeneratorRuntime.wrap(function pe$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return Y(function (e) {
                return e.app.widgetContainer.widgetItems;
              });

            case 3:
              _n7 = _context13.sent;
              _r5 = _n7.reduce(function (e, t) {
                return [].concat(_toConsumableArray(e), _toConsumableArray(Object(he.c)(t.type, t.widgetId).getResourceRequestParams(t.dynamicWidgetArgs)));
              }, []);
              _context13.next = 7;
              return Object(P.d)().getResources(_r5);

            case 7:
              _i4 = _context13.sent;
              _context13.next = 10;
              return e = _n7.map(function (e) {
                var t = Object(he.c)(e.type, e.widgetId),
                    n = _i4.splice(0, t.resourceRequest.length);

                return I(ce.refreshSuccess({
                  id: e.id,
                  data: t.transformData(n)
                }));
              }), t = N(k, e), t.combinator = !0, t;

            case 10:
              _context13.next = 16;
              break;

            case 12:
              _context13.prev = 12;
              _context13.t0 = _context13["catch"](0);
              _context13.next = 16;
              return I(ce.refreshBatchFail(_context13.t0.message));

            case 16:
            case "end":
              return _context13.stop();
          }
        }
      }, _marked2, null, [[0, 12]]);
    }

    function me() {
      var _e4, _t7, _n8, _e5, _JSON$parse, _r6, _i5;

      return _regeneratorRuntime.wrap(function me$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _context14.next = 3;
              return Object(P.d)().getResources([new a.Requests.StorageObjectRequest({
                filter: {
                  key: de
                }
              })]);

            case 3:
              _e4 = _context14.sent;
              _t7 = X();
              _n8 = _e4[0].data;

              if (_n8.length > 0) {
                _e5 = _n8[0], _JSON$parse = JSON.parse(_e5.content), _r6 = _JSON$parse.widgetItems, _i5 = _JSON$parse.widgetLayouts;
                _t7 = {
                  widgetItems: _r6,
                  widgetLayouts: _i5
                };
              }

              _context14.next = 9;
              return I(ce.loadLayoutSuccess(_t7));

            case 9:
              _context14.next = 11;
              return I(ce.refreshBatch());

            case 11:
              _context14.next = 17;
              break;

            case 13:
              _context14.prev = 13;
              _context14.t0 = _context14["catch"](0);
              _context14.next = 17;
              return ce.loadLayoutFail(_context14.t0.message);

            case 17:
            case "end":
              return _context14.stop();
          }
        }
      }, _marked3, null, [[0, 13]]);
    }

    function _e(_ref17) {
      var e, _t8;

      return _regeneratorRuntime.wrap(function _e$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              e = _ref17.payload;
              _context15.prev = 1;
              _context15.next = 4;
              return Y(function (e) {
                return e.app.widgetContainer.widgetItems;
              });

            case 4:
              _t8 = _context15.sent;
              _context15.next = 7;
              return Object(P.d)().createMutationRequest(new a.Requests.SetStorageObjectRequest({
                key: de,
                content: JSON.stringify({
                  widgetItems: _t8,
                  widgetLayouts: e
                })
              }));

            case 7:
              _context15.next = 9;
              return I(ce.saveLayoutSuccess());

            case 9:
              _context15.next = 15;
              break;

            case 11:
              _context15.prev = 11;
              _context15.t0 = _context15["catch"](1);
              _context15.next = 15;
              return ce.saveLayoutFail(_context15.t0.message);

            case 15:
            case "end":
              return _context15.stop();
          }
        }
      }, _marked4, null, [[1, 11]]);
    }

    var ye = [
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return U("widgetContainer/loadLayout", me);

            case 2:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee3);
    })(),
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return U("widgetContainer/saveLayout", _e);

            case 2:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee4);
    })(),
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return U("widgetContainer/refresh", fe);

            case 2:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee5);
    })(),
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return U("widgetContainer/refreshBatch", pe);

            case 2:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee6);
    })()];

    function ve(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var ge =
    /*#__PURE__*/
    function () {
      function ge(e) {
        _classCallCheck(this, ge);

        ve(this, "widgetId", void 0), ve(this, "searchType", void 0), ve(this, "searchTypeId", void 0), ve(this, "searchRoute", void 0), ve(this, "label", void 0), ve(this, "permission", void 0), ve(this, "resourceRequest", void 0), ve(this, "iconType", void 0), this.widgetId = e.widgetId, this.searchType = e.searchType, this.searchTypeId = e.searchTypeId, this.searchRoute = e.searchRoute, this.label = e.label, this.permission = e.permission, this.resourceRequest = e.resourceRequest, this.iconType = e.iconType;
      }

      _createClass(ge, [{
        key: "getResourceRequestParams",
        value: function getResourceRequestParams(e) {
          var t = Object(i.b)()(this.searchType, e);
          return this.resourceRequest.map(function (e) {
            var n = _objectSpread({}, e.resourceParams);

            return n.filter = _objectSpread({}, n.filter, {}, t), _objectSpread({}, e, {
              resourceParams: n
            });
          });
        }
      }]);

      return ge;
    }();

    var be = n(0),
        we = n.n(be),
        Te = n(226),
        Me = n(227),
        Ee = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetResources\\Table\\TableWidgetResource.tsx";

    function ke() {
      return (ke = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function Le(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var Se =
    /*#__PURE__*/
    function (_ge) {
      _inherits(Se, _ge);

      function Se(e) {
        var _this19;

        _classCallCheck(this, Se);

        _this19 = _possibleConstructorReturn(this, _getPrototypeOf(Se).call(this, e)), Le(_assertThisInitialized(_this19), "columns", void 0), Le(_assertThisInitialized(_this19), "optionalColumns", void 0), Le(_assertThisInitialized(_this19), "visibleColumns", void 0), Le(_assertThisInitialized(_this19), "searchRoute", void 0), _this19.columns = e.columns, _this19.optionalColumns = e.optionalColumns, _this19.visibleColumns = e.visibleColumns, _this19.searchRoute = e.searchRoute;
        return _this19;
      }

      _createClass(Se, [{
        key: "transformData",
        value: function transformData(e) {
          return {
            totalCount: e[1].data[0].value,
            items: e[0].data
          };
        }
      }, {
        key: "renderWidget",
        value: function renderWidget(e) {
          var t = e.data,
              n = _objectWithoutProperties(e, ["data"]);

          return we.a.createElement(Me.a, ke({
            tableConfig: this,
            data: t
          }, n, {
            __source: {
              fileName: Ee,
              lineNumber: 45
            },
            __self: this
          }));
        }
      }, {
        key: "renderForm",
        value: function renderForm(e) {
          return we.a.createElement(Te.a, ke({}, e, {
            __source: {
              fileName: Ee,
              lineNumber: 54
            },
            __self: this
          }));
        }
      }]);

      return Se;
    }(ge);

    var Ne = n(228),
        De = n(1),
        Ie = n(5),
        Re = n(46),
        xe = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetResources\\Counter\\CounterWidget.tsx";

    var Ye = Object(De.styled)(De.Flex)({
      height: 50
    }),
        Ce = Object(De.styled)(De.Skeleton)(Object(De.ant)({
      ".skeleton-paragraph": {
        display: "none"
      }
    })),
        Oe = function Oe(_ref18) {
      var e = _ref18.data,
          t = _ref18.text,
          n = _ref18.iconColor,
          r = _ref18.color,
          i = _ref18.dynamicWidgetArgs,
          o = _ref18.type,
          a = _ref18.widgetId,
          s = _ref18.id,
          u = _ref18.iconType,
          c = _ref18.isLoading,
          l = _ref18.isEditable,
          h = _ref18.onEdit,
          d = _ref18.onRemove,
          f = _ref18.onClick;
      return we.a.createElement(De.Widget, {
        onClick: f,
        __source: {
          fileName: xe,
          lineNumber: 62
        },
        __self: void 0
      }, we.a.createElement(De.WidgetHeader, {
        justify: "space-between",
        align: "center",
        __source: {
          fileName: xe,
          lineNumber: 63
        },
        __self: void 0
      }, we.a.createElement(Ce, {
        active: !0,
        paragraph: {
          rows: 0
        },
        loading: c,
        __source: {
          fileName: xe,
          lineNumber: 64
        },
        __self: void 0
      }, we.a.createElement(De.H4, {
        inline: !0,
        color: "bodyPrimary",
        __source: {
          fileName: xe,
          lineNumber: 65
        },
        __self: void 0
      }, i.title), l && we.a.createElement(Re.a, {
        id: s,
        onRemove: d,
        onEdit: function onEdit() {
          return h({
            id: s,
            widgetId: a,
            dynamicWidgetArgs: i,
            type: o
          });
        },
        __source: {
          fileName: xe,
          lineNumber: 69
        },
        __self: void 0
      }))), we.a.createElement(De.WidgetBody, {
        overflow: "hidden",
        __source: {
          fileName: xe,
          lineNumber: 77
        },
        __self: void 0
      }, we.a.createElement(De.Flex, {
        stretch: !0,
        __source: {
          fileName: xe,
          lineNumber: 78
        },
        __self: void 0
      }, we.a.createElement(De.Skeleton, {
        loading: c,
        avatar: !0,
        active: !0,
        paragraph: {
          rows: 0
        },
        __source: {
          fileName: xe,
          lineNumber: 79
        },
        __self: void 0
      }, we.a.createElement(Ye, {
        gutter: 2,
        align: "center",
        __source: {
          fileName: xe,
          lineNumber: 80
        },
        __self: void 0
      }, we.a.createElement(De.FlexItem, {
        flex: 0,
        __source: {
          fileName: xe,
          lineNumber: 81
        },
        __self: void 0
      }, we.a.createElement(De.Tag, {
        color: r,
        circle: !0,
        __source: {
          fileName: xe,
          lineNumber: 82
        },
        __self: void 0
      }, we.a.createElement(De.Icon, {
        type: u,
        color: n,
        size: "small",
        __source: {
          fileName: xe,
          lineNumber: 83
        },
        __self: void 0
      }))), we.a.createElement(De.FlexItem, {
        align: "center",
        gutter: 1,
        __source: {
          fileName: xe,
          lineNumber: 86
        },
        __self: void 0
      }, we.a.createElement(De.H1, {
        inline: !0,
        color: "bodyPrimary",
        __source: {
          fileName: xe,
          lineNumber: 87
        },
        __self: void 0
      }, e), we.a.createElement(De.ColTitle, {
        inline: !0,
        __source: {
          fileName: xe,
          lineNumber: 90
        },
        __self: void 0
      }, we.a.createElement(Ie.Intl.FormattedMessage, {
        id: t,
        values: {
          value: e
        },
        __source: {
          fileName: xe,
          lineNumber: 91
        },
        __self: void 0
      }))))))));
    };

    var Fe = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetResources\\Counter\\CounterWidgetResource.tsx";

    function Ae() {
      return (Ae = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function je(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var Ue =
    /*#__PURE__*/
    function (_ge2) {
      _inherits(Ue, _ge2);

      function Ue(e) {
        var _this20;

        _classCallCheck(this, Ue);

        _this20 = _possibleConstructorReturn(this, _getPrototypeOf(Ue).call(this, e)), je(_assertThisInitialized(_this20), "text", void 0), je(_assertThisInitialized(_this20), "iconColor", void 0), je(_assertThisInitialized(_this20), "color", void 0), _this20.text = e.text, _this20.iconColor = e.iconColor, _this20.color = e.color;
        return _this20;
      }

      _createClass(Ue, [{
        key: "transformData",
        value: function transformData(e) {
          return e[0].data[0].value;
        }
      }, {
        key: "renderWidget",
        value: function renderWidget(e) {
          var t = e.data,
              n = _objectWithoutProperties(e, ["data"]);

          return we.a.createElement(Oe, Ae({
            data: t,
            text: this.text,
            color: this.color,
            iconType: this.iconType,
            iconColor: this.iconColor
          }, n, {
            __source: {
              fileName: Fe,
              lineNumber: 42
            },
            __self: this
          }));
        }
      }, {
        key: "renderForm",
        value: function renderForm(e) {
          return we.a.createElement(Ne.a, Ae({}, e, {
            __source: {
              fileName: Fe,
              lineNumber: 54
            },
            __self: this
          }));
        }
      }]);

      return Ue;
    }(ge);

    var Pe = n(26);
    n.d(t, "f", function () {
      return r.a;
    }), n.d(t, "l", function () {
      return i.a;
    }), n.d(t, "r", function () {
      return i.e;
    }), n.d(t, "n", function () {
      return i.c;
    }), n.d(t, "t", function () {
      return i.g;
    }), n.d(t, "m", function () {
      return i.b;
    }), n.d(t, "s", function () {
      return i.f;
    }), n.d(t, "q", function () {
      return i.d;
    }), n.d(t, "e", function () {}), n.d(t, "z", function () {
      return le;
    }), n.d(t, "y", function () {
      return ce;
    }), n.d(t, "d", function () {
      return o.a;
    }), n.d(t, "A", function () {
      return ye;
    }), n.d(t, "u", function () {
      return he.d;
    }), n.d(t, "o", function () {
      return he.c;
    }), n.d(t, "i", function () {
      return he.a;
    }), n.d(t, "k", function () {
      return he.b;
    }), n.d(t, "p", function () {
      return J;
    }), n.d(t, "j", function () {
      return X;
    }), n.d(t, "a", function () {
      return ge;
    }), n.d(t, "c", function () {
      return Se;
    }), n.d(t, "b", function () {
      return Ue;
    }), n.d(t, "g", function () {
      return Pe.a;
    }), n.d(t, "h", function () {
      return Pe.b;
    }), n.d(t, "w", function () {
      return Pe.d;
    }), n.d(t, "v", function () {
      return Pe.c;
    }), n.d(t, "x", function () {
      return Pe.e;
    }), n.d(t, "B", function () {
      return G.a;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(52);
    n.d(t, "a", function () {
      return r.a;
    });
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return o;
    }), n.d(t, "e", function () {
      return a;
    }), n.d(t, "b", function () {
      return s;
    }), n.d(t, "c", function () {
      return u;
    }), n.d(t, "d", function () {
      return c;
    }), n.d(t, "f", function () {
      return l;
    });
    var r = n(4),
        i = n(14);

    var o = function o() {
      return i.a.getInstance().settings.dataPreferences.companies;
    },
        a = function a() {
      var e;
      return null === (e = i.a.getInstance().settings.dataPreferences.positionTypes) || void 0 === e ? void 0 : e.map(Number);
    },
        s = function s() {
      var e;
      return null === (e = i.a.getInstance().settings.dataPreferences.companies) || void 0 === e ? void 0 : e.map(function (e) {
        return e.companyId;
      });
    },
        u = function u() {
      return [i.a.getInstance().settings.contactId];
    },
        c = function c() {
      return i.a.getInstance().get("dataPreferences").option === r.DataLevel.MyCompany ? {
        companies: o(),
        positionTypeIds: a()
      } : {
        contactIds: u(),
        positionTypeIds: a()
      };
    },
        l = function l(e) {
      return e.map(function (e) {
        if (e.hasDataPref) {
          var _t9 = c(),
              _n9 = e.resourceParams.filter;

          if (e.resourceParams.filter = _objectSpread({}, e.resourceParams.filter, {}, _t9), _n9 && _n9.positionTypeIds) {
            var _r7 = Array.from(new Set(_t9.positionTypeIds.concat(_n9.positionTypeIds || []).map(Number)));

            e.resourceParams.filter.positionTypeIds = _r7;
          }

          return e;
        }

        var t = s();
        return e.hasCompaniesContext ? (e.resourceParams.filter = _objectSpread({}, e.resourceParams.filter, {
          companyIds: t.length > 0 ? [t[0]] : void 0
        }), e.resourceParams.companyIDs = t.length > 0 ? [t[0]] : void 0, e) : e;
      });
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var n,
          r = "undefined" != typeof Symbol ? Symbol("immer-nothing") : ((n = {})["immer-nothing"] = !0, n),
          i = "undefined" != typeof Symbol ? Symbol.for("immer-draftable") : "__$immer_draftable",
          o = "undefined" != typeof Symbol ? Symbol.for("immer-state") : "__$immer_state";

      function a(e) {
        return !!e && !!e[o];
      }

      function s(e) {
        if (!e || "object" != typeof e) return !1;
        if (Array.isArray(e)) return !0;
        var t = Object.getPrototypeOf(e);
        return !t || t === Object.prototype || !!e[i] || !!e.constructor[i];
      }

      var u = Object.assign || function (e, t) {
        for (var n in t) {
          f(t, n) && (e[n] = t[n]);
        }

        return e;
      },
          c = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (e) {
        return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
      } : Object.getOwnPropertyNames;

      function l(e, t) {
        if (void 0 === t && (t = !1), Array.isArray(e)) return e.slice();
        var n = Object.create(Object.getPrototypeOf(e));
        return c(e).forEach(function (r) {
          if (r !== o) {
            var i = Object.getOwnPropertyDescriptor(e, r),
                a = i.value;

            if (i.get) {
              if (!t) throw new Error("Immer drafts cannot have computed properties");
              a = i.get.call(e);
            }

            i.enumerable ? n[r] = a : Object.defineProperty(n, r, {
              value: a,
              writable: !0,
              configurable: !0
            });
          }
        }), n;
      }

      function h(e, t) {
        if (Array.isArray(e)) for (var n = 0; n < e.length; n++) {
          t(n, e[n], e);
        } else c(e).forEach(function (n) {
          return t(n, e[n], e);
        });
      }

      function d(e, t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      }

      function f(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }

      function p(e, t) {
        return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
      }

      var m = function m(e) {
        this.drafts = [], this.parent = e, this.canAutoFreeze = !0, this.patches = null;
      };

      function _(e) {
        e[o].revoke();
      }

      m.prototype.usePatches = function (e) {
        e && (this.patches = [], this.inversePatches = [], this.patchListener = e);
      }, m.prototype.revoke = function () {
        this.leave(), this.drafts.forEach(_), this.drafts = null;
      }, m.prototype.leave = function () {
        this === m.current && (m.current = this.parent);
      }, m.current = null, m.enter = function () {
        return this.current = new m(this.current);
      };
      var y = {};

      function v(e, t) {
        var n = Array.isArray(e),
            r = E(e);
        h(r, function (t) {
          !function (e, t, n) {
            var r = y[t];
            r ? r.enumerable = n : y[t] = r = {
              configurable: !0,
              enumerable: n,
              get: function get() {
                return function (e, t) {
                  k(e);
                  var n = w(b(e), t);
                  if (e.finalizing) return n;
                  if (n === w(e.base, t) && s(n)) return M(e), e.copy[t] = v(n, e);
                  return n;
                }(this[o], t);
              },
              set: function set(e) {
                !function (e, t, n) {
                  if (k(e), e.assigned[t] = !0, !e.modified) {
                    if (p(n, w(b(e), t))) return;
                    T(e), M(e);
                  }

                  e.copy[t] = n;
                }(this[o], t, e);
              }
            };
            Object.defineProperty(e, t, r);
          }(r, t, n || d(e, t));
        });
        var i,
            a,
            u,
            c = t ? t.scope : m.current;
        return i = r, a = o, u = {
          scope: c,
          modified: !1,
          finalizing: !1,
          finalized: !1,
          assigned: {},
          parent: t,
          base: e,
          draft: r,
          copy: null,
          revoke: g,
          revoked: !1
        }, Object.defineProperty(i, a, {
          value: u,
          enumerable: !1,
          writable: !0
        }), c.drafts.push(r), r;
      }

      function g() {
        this.revoked = !0;
      }

      function b(e) {
        return e.copy || e.base;
      }

      function w(e, t) {
        var n = e[o];

        if (n && !n.finalizing) {
          n.finalizing = !0;
          var r = e[t];
          return n.finalizing = !1, r;
        }

        return e[t];
      }

      function T(e) {
        e.modified || (e.modified = !0, e.parent && T(e.parent));
      }

      function M(e) {
        e.copy || (e.copy = E(e.base));
      }

      function E(e) {
        var t = e && e[o];

        if (t) {
          t.finalizing = !0;
          var n = l(t.draft, !0);
          return t.finalizing = !1, n;
        }

        return l(e);
      }

      function k(e) {
        if (!0 === e.revoked) throw new Error("Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + JSON.stringify(b(e)));
      }

      function L(e) {
        for (var t = e.length - 1; t >= 0; t--) {
          var n = e[t][o];
          n.modified || (Array.isArray(n.base) ? N(n) && T(n) : S(n) && T(n));
        }
      }

      function S(e) {
        for (var t = e.base, n = e.draft, r = Object.keys(n), i = r.length - 1; i >= 0; i--) {
          var a = r[i],
              s = t[a];
          if (void 0 === s && !f(t, a)) return !0;
          var u = n[a],
              c = u && u[o];
          if (c ? c.base !== s : !p(u, s)) return !0;
        }

        return r.length !== Object.keys(t).length;
      }

      function N(e) {
        var t = e.draft;
        if (t.length !== e.base.length) return !0;
        var n = Object.getOwnPropertyDescriptor(t, t.length - 1);
        return !(!n || n.get);
      }

      var D = Object.freeze({
        willFinalize: function willFinalize(e, t, n) {
          e.drafts.forEach(function (e) {
            e[o].finalizing = !0;
          }), n ? a(t) && t[o].scope === e && L(e.drafts) : (e.patches && function e(t) {
            if (t && "object" == typeof t) {
              var n = t[o];

              if (n) {
                var r = n.base,
                    i = n.draft,
                    a = n.assigned;

                if (Array.isArray(t)) {
                  if (N(n)) {
                    if (T(n), a.length = !0, i.length < r.length) for (var s = i.length; s < r.length; s++) {
                      a[s] = !1;
                    } else for (var u = r.length; u < i.length; u++) {
                      a[u] = !0;
                    }

                    for (var c = 0; c < i.length; c++) {
                      void 0 === a[c] && e(i[c]);
                    }
                  }
                } else Object.keys(i).forEach(function (t) {
                  void 0 !== r[t] || f(r, t) ? a[t] || e(i[t]) : (a[t] = !0, T(n));
                }), Object.keys(r).forEach(function (e) {
                  void 0 !== i[e] || f(i, e) || (a[e] = !1, T(n));
                });
              }
            }
          }(e.drafts[0]), L(e.drafts));
        },
        createProxy: v
      });

      function I(e, t) {
        var n = t ? t.scope : m.current,
            r = {
          scope: n,
          modified: !1,
          finalized: !1,
          assigned: {},
          parent: t,
          base: e,
          draft: null,
          drafts: {},
          copy: null,
          revoke: null
        },
            i = Array.isArray(e) ? Proxy.revocable([r], x) : Proxy.revocable(r, R),
            o = i.revoke,
            a = i.proxy;
        return r.draft = a, r.revoke = o, n.drafts.push(a), a;
      }

      var R = {
        get: function get(e, t) {
          if (t === o) return e;
          var n = e.drafts;
          if (!e.modified && f(n, t)) return n[t];
          var r = Y(e)[t];
          if (e.finalized || !s(r)) return r;

          if (e.modified) {
            if (r !== C(e.base, t)) return r;
            n = e.copy;
          }

          return n[t] = I(r, e);
        },
        has: function has(e, t) {
          return t in Y(e);
        },
        ownKeys: function ownKeys(e) {
          return Reflect.ownKeys(Y(e));
        },
        set: function set(e, t, n) {
          if (!e.modified) {
            var r = C(e.base, t),
                i = n ? p(r, n) || n === e.drafts[t] : p(r, n) && t in e.base;
            if (i) return !0;
            O(e);
          }

          return e.assigned[t] = !0, e.copy[t] = n, !0;
        },
        deleteProperty: function deleteProperty(e, t) {
          (void 0 !== C(e.base, t) || t in e.base) && (e.assigned[t] = !1, O(e));
          e.copy && delete e.copy[t];
          return !0;
        },
        getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
          var n = Y(e),
              r = Reflect.getOwnPropertyDescriptor(n, t);
          r && (r.writable = !0, r.configurable = !Array.isArray(n) || "length" !== t);
          return r;
        },
        defineProperty: function defineProperty() {
          throw new Error("Object.defineProperty() cannot be used on an Immer draft");
        },
        getPrototypeOf: function getPrototypeOf(e) {
          return Object.getPrototypeOf(e.base);
        },
        setPrototypeOf: function setPrototypeOf() {
          throw new Error("Object.setPrototypeOf() cannot be used on an Immer draft");
        }
      },
          x = {};

      function Y(e) {
        return e.copy || e.base;
      }

      function C(e, t) {
        var n = e[o],
            r = Reflect.getOwnPropertyDescriptor(n ? Y(n) : e, t);
        return r && r.value;
      }

      function O(e) {
        e.modified || (e.modified = !0, e.copy = u(l(e.base), e.drafts), e.drafts = null, e.parent && O(e.parent));
      }

      h(R, function (e, t) {
        x[e] = function () {
          return arguments[0] = arguments[0][0], t.apply(this, arguments);
        };
      }), x.deleteProperty = function (e, t) {
        if (isNaN(parseInt(t))) throw new Error("Immer only supports deleting array indices");
        return R.deleteProperty.call(this, e[0], t);
      }, x.set = function (e, t, n) {
        if ("length" !== t && isNaN(parseInt(t))) throw new Error("Immer only supports setting array indices and the 'length' property");
        return R.set.call(this, e[0], t, n);
      };
      var F = Object.freeze({
        willFinalize: function willFinalize() {},
        createProxy: I
      });

      function A(e, t, n, r) {
        Array.isArray(e.base) ? function (e, t, n, r) {
          var i,
              o,
              a = e.base,
              s = e.copy,
              u = e.assigned;
          s.length < a.length && (a = (i = [s, a])[0], s = i[1], n = (o = [r, n])[0], r = o[1]);
          var c = s.length - a.length,
              l = 0;

          for (; a[l] === s[l] && l < a.length;) {
            ++l;
          }

          var h = a.length;

          for (; h > l && a[h - 1] === s[h + c - 1];) {
            --h;
          }

          for (var d = l; d < h; ++d) {
            if (u[d] && s[d] !== a[d]) {
              var f = t.concat([d]);
              n.push({
                op: "replace",
                path: f,
                value: s[d]
              }), r.push({
                op: "replace",
                path: f,
                value: a[d]
              });
            }
          }

          for (var p = h != a.length, m = n.length, _ = h + c - 1; _ >= h; --_) {
            var y = t.concat([_]);
            n[m + _ - h] = {
              op: "add",
              path: y,
              value: s[_]
            }, p && r.push({
              op: "remove",
              path: y
            });
          }

          p || r.push({
            op: "replace",
            path: t.concat(["length"]),
            value: a.length
          });
        }(e, t, n, r) : function (e, t, n, r) {
          var i = e.base,
              o = e.copy;
          h(e.assigned, function (e, a) {
            var s = i[e],
                u = o[e],
                c = a ? e in i ? "replace" : "add" : "remove";

            if (s !== u || "replace" !== c) {
              var l = t.concat(e);
              n.push("remove" === c ? {
                op: c,
                path: l
              } : {
                op: c,
                path: l,
                value: u
              }), r.push("add" === c ? {
                op: "remove",
                path: l
              } : "remove" === c ? {
                op: "add",
                path: l,
                value: s
              } : {
                op: "replace",
                path: l,
                value: s
              });
            }
          });
        }(e, t, n, r);
      }

      function j(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n],
              i = r.path;
          if (0 === i.length && "replace" === r.op) e = r.value;else {
            for (var o = e, a = 0; a < i.length - 1; a++) {
              if (!(o = o[i[a]]) || "object" != typeof o) throw new Error("Cannot apply patch, path doesn't resolve: " + i.join("/"));
            }

            var s = i[i.length - 1];

            switch (r.op) {
              case "replace":
                o[s] = r.value;
                break;

              case "add":
                Array.isArray(o) ? o.splice(s, 0, r.value) : o[s] = r.value;
                break;

              case "remove":
                Array.isArray(o) ? o.splice(s, 1) : delete o[s];
                break;

              default:
                throw new Error("Unsupported patch operation: " + r.op);
            }
          }
        }

        return e;
      }

      var U = {
        useProxies: "undefined" != typeof Proxy && "undefined" != typeof Reflect,
        autoFreeze: void 0 === e && "verifyMinified" === function () {}.name,
        onAssign: null,
        onDelete: null,
        onCopy: null
      },
          P = function P(e) {
        u(this, U, e), this.setUseProxies(this.useProxies), this.produce = this.produce.bind(this);
      };

      P.prototype.produce = function (e, t, n) {
        var i,
            o = this;

        if ("function" == typeof e && "function" != typeof t) {
          var a = t;
          return t = e, function (e) {
            void 0 === e && (e = a);

            for (var n = [], r = arguments.length - 1; r-- > 0;) {
              n[r] = arguments[r + 1];
            }

            return o.produce(e, function (e) {
              return t.call.apply(t, [e, e].concat(n));
            });
          };
        }

        if ("function" != typeof t) throw new Error("The first or second argument to `produce` must be a function");
        if (void 0 !== n && "function" != typeof n) throw new Error("The third argument to `produce` must be a function or undefined");

        if (s(e)) {
          var u = m.enter(),
              c = this.createProxy(e),
              l = !0;

          try {
            i = t.call(c, c), l = !1;
          } finally {
            l ? u.revoke() : u.leave();
          }

          return i instanceof Promise ? i.then(function (e) {
            return u.usePatches(n), o.processResult(e, u);
          }, function (e) {
            throw u.revoke(), e;
          }) : (u.usePatches(n), this.processResult(i, u));
        }

        return void 0 === (i = t(e)) ? e : i !== r ? i : void 0;
      }, P.prototype.createDraft = function (e) {
        if (!s(e)) throw new Error("First argument to `createDraft` must be a plain object, an array, or an immerable object");
        var t = m.enter(),
            n = this.createProxy(e);
        return n[o].isManual = !0, t.leave(), n;
      }, P.prototype.finishDraft = function (e, t) {
        var n = e && e[o];
        if (!n || !n.isManual) throw new Error("First argument to `finishDraft` must be a draft returned by `createDraft`");
        if (n.finalized) throw new Error("The given draft is already finalized");
        var r = n.scope;
        return r.usePatches(t), this.processResult(void 0, r);
      }, P.prototype.setAutoFreeze = function (e) {
        this.autoFreeze = e;
      }, P.prototype.setUseProxies = function (e) {
        this.useProxies = e, u(this, e ? F : D);
      }, P.prototype.applyPatches = function (e, t) {
        return a(e) ? j(e, t) : this.produce(e, function (e) {
          return j(e, t);
        });
      }, P.prototype.processResult = function (e, t) {
        var n = t.drafts[0],
            i = void 0 !== e && e !== n;

        if (this.willFinalize(t, e, i), i) {
          if (n[o].modified) throw t.revoke(), new Error("An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.");
          s(e) && (e = this.finalize(e, null, t)), t.patches && (t.patches.push({
            op: "replace",
            path: [],
            value: e
          }), t.inversePatches.push({
            op: "replace",
            path: [],
            value: n[o].base
          }));
        } else e = this.finalize(n, [], t);

        return t.revoke(), t.patches && t.patchListener(t.patches, t.inversePatches), e !== r ? e : void 0;
      }, P.prototype.finalize = function (e, t, n) {
        var r = this,
            i = e[o];
        if (!i) return Object.isFrozen(e) ? e : this.finalizeTree(e, null, n);
        if (i.scope !== n) return e;
        if (!i.modified) return i.base;

        if (!i.finalized) {
          if (i.finalized = !0, this.finalizeTree(i.draft, t, n), this.onDelete) if (this.useProxies) {
            var a = i.assigned;

            for (var s in a) {
              a[s] || this.onDelete(i, s);
            }
          } else {
            var u = i.base,
                c = i.copy;
            h(u, function (e) {
              f(c, e) || r.onDelete(i, e);
            });
          }
          this.onCopy && this.onCopy(i), this.autoFreeze && n.canAutoFreeze && Object.freeze(i.copy), t && n.patches && A(i, t, n.patches, n.inversePatches);
        }

        return i.copy;
      }, P.prototype.finalizeTree = function (e, t, n) {
        var r = this,
            i = e[o];
        i && (this.useProxies || (i.copy = l(i.draft, !0)), e = i.copy);

        var u = !!t && !!n.patches,
            c = function c(o, l, f) {
          if (l === f) throw Error("Immer forbids circular references");
          var m = !!i && f === e;

          if (a(l)) {
            var _ = m && u && !i.assigned[o] ? t.concat(o) : null;

            if (a(l = r.finalize(l, _, n)) && (n.canAutoFreeze = !1), Array.isArray(f) || d(f, o) ? f[o] = l : Object.defineProperty(f, o, {
              value: l
            }), m && l === i.base[o]) return;
          } else {
            if (m && p(l, i.base[o])) return;
            s(l) && !Object.isFrozen(l) && h(l, c);
          }

          m && r.onAssign && r.onAssign(i, o, l);
        };

        return h(e, c), e;
      };
      var V = new P(),
          W = V.produce;
      V.setAutoFreeze.bind(V), V.setUseProxies.bind(V), V.applyPatches.bind(V), V.createDraft.bind(V), V.finishDraft.bind(V);
      t.a = W;
    }).call(this, n(32));
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(2),
          a = n.n(o),
          s = n(1),
          u = n(5),
          c = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Table\\DateRangeFilter\\TableDateRangeFilter.tsx";
      var l = u.Intl.FormattedMessage,
          h = {
        hour: 0,
        minute: 0,
        second: 0
      },
          d = {
        hour: 23,
        minute: 59,
        second: 59
      },
          f = {
        from: a()().subtract(10, "days").set(h).toDate(),
        to: a()().set(d).toDate()
      },
          p = Object(s.styled)("div")({
        display: "flex",
        justifyContent: "space-between",
        width: "90%",
        margin: "auto"
      });

      t.a = function (_ref19) {
        var t = _ref19.dateFieldKey,
            n = _ref19.onFilter,
            o = _ref19.range,
            u = _ref19.resetFilter;

        var _Object8 = Object(r.useState)(f),
            _Object9 = _slicedToArray(_Object8, 2),
            m = _Object9[0],
            _ = _Object9[1];

        Object(r.useEffect)(function () {
          void 0 === o && _(f);
        }, [o]);
        var y = Object(r.useCallback)(function (e) {
          var t = a()(e.from).set(h).toDate(),
              n = a()(e.to).set(d).toDate();

          _({
            from: t,
            to: n
          });
        }, [_]);
        return i.a.createElement(s.Container, {
          padding: [2, 2, 0, 2],
          background: "pageSecondary",
          __source: {
            fileName: c,
            lineNumber: 72
          },
          __self: void 0
        }, i.a.createElement(s.Calendar, {
          mode: "range",
          onChange: y,
          defaultValue: m,
          __source: {
            fileName: c,
            lineNumber: 73
          },
          __self: void 0
        }), i.a.createElement(p, {
          __source: {
            fileName: c,
            lineNumber: 78
          },
          __self: void 0
        }, i.a.createElement(s.Button, {
          type: "tertiary",
          onClick: function onClick() {
            return n(t, m);
          },
          __source: {
            fileName: c,
            lineNumber: 79
          },
          __self: void 0
        }, i.a.createElement(l, {
          id: e.modules.actions.apply,
          __source: {
            fileName: c,
            lineNumber: 83
          },
          __self: void 0
        })), i.a.createElement(s.Button, {
          type: "tertiary",
          onClick: function onClick() {
            u(t);
          },
          __source: {
            fileName: c,
            lineNumber: 85
          },
          __self: void 0
        }, i.a.createElement(l, {
          id: e.modules.actions.reset,
          __source: {
            fileName: c,
            lineNumber: 91
          },
          __self: void 0
        }))));
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(1),
          a = n(5),
          s = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Table\\TimeRangeFilter\\TableTimeRangeFilter.tsx";
      var u = a.Intl.FormattedMessage,
          c = {
        from: "",
        to: ""
      },
          l = Object(o.styled)("div")({
        display: "flex",
        justifyContent: "space-between",
        width: "90%",
        margin: "auto"
      });

      t.a = function (_ref20) {
        var t = _ref20.dateFieldKey,
            n = _ref20.onFilter,
            a = _ref20.range,
            h = _ref20.resetFilter;

        var _Object10 = Object(r.useState)(c),
            _Object11 = _slicedToArray(_Object10, 2),
            d = _Object11[0],
            f = _Object11[1];

        return Object(r.useEffect)(function () {
          void 0 === a && f(c);
        }, [a]), i.a.createElement(o.Container, {
          padding: [2, 2, 0, 2],
          background: "pageSecondary",
          __source: {
            fileName: s,
            lineNumber: 51
          },
          __self: void 0
        }, i.a.createElement(o.Flex, {
          gutter: 2,
          __source: {
            fileName: s,
            lineNumber: 52
          },
          __self: void 0
        }, i.a.createElement(o.TimePicker, {
          use12Hours: !0,
          format: "h:mm a",
          minuteStep: 15,
          onChange: function onChange(e) {
            e && f(_objectSpread({}, d, {
              from: e.format("HH:mm:00")
            }));
          },
          __source: {
            fileName: s,
            lineNumber: 53
          },
          __self: void 0
        }), i.a.createElement(o.TimePicker, {
          use12Hours: !0,
          format: "h:mm a",
          minuteStep: 15,
          onChange: function onChange(e) {
            e && f(_objectSpread({}, d, {
              to: e.format("HH:mm:00")
            }));
          },
          __source: {
            fileName: s,
            lineNumber: 62
          },
          __self: void 0
        })), i.a.createElement(l, {
          __source: {
            fileName: s,
            lineNumber: 72
          },
          __self: void 0
        }, i.a.createElement(o.Button, {
          type: "tertiary",
          onClick: function onClick() {
            return n(t, d);
          },
          __source: {
            fileName: s,
            lineNumber: 73
          },
          __self: void 0
        }, i.a.createElement(u, {
          id: e.modules.actions.apply,
          __source: {
            fileName: s,
            lineNumber: 77
          },
          __self: void 0
        })), i.a.createElement(o.Button, {
          type: "tertiary",
          onClick: function onClick() {
            h(t);
          },
          __source: {
            fileName: s,
            lineNumber: 79
          },
          __self: void 0
        }, i.a.createElement(u, {
          id: e.modules.actions.reset,
          __source: {
            fileName: s,
            lineNumber: 85
          },
          __self: void 0
        }))));
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(36);
    n.d(t, "getCompaniesFilter", function () {
      return r.a;
    }), n.d(t, "getPositionTypesFilter", function () {
      return r.e;
    }), n.d(t, "getCompanyIds", function () {
      return r.b;
    }), n.d(t, "getContactId", function () {
      return r.c;
    }), n.d(t, "getFilterDataForOption", function () {
      return r.d;
    }), n.d(t, "withDataPreferences", function () {
      return r.f;
    });
    var i = n(200);
    n.d(t, "initializeSettings", function () {
      return i.a;
    });
    var o = n(201);

    for (var a in o) {
      ["SettingsRepository", "getCompaniesFilter", "getPositionTypesFilter", "getCompanyIds", "getContactId", "getFilterDataForOption", "withDataPreferences", "initializeSettings", "default"].indexOf(a) < 0 && function (e) {
        n.d(t, e, function () {
          return o[e];
        });
      }(a);
    }

    var s = n(41);
    n.d(t, "fetchPositionTypes", function () {
      return s.e;
    }), n.d(t, "fetchFacilityDepartments", function () {
      return s.d;
    }), n.d(t, "transformCompaniesProps", function () {
      return s.g;
    }), n.d(t, "fetchCompanies", function () {
      return s.b;
    }), n.d(t, "fetchAllCompanies", function () {
      return s.a;
    }), n.d(t, "fetchDataPreferences", function () {
      return s.c;
    }), n.d(t, "saveDataPreferences", function () {
      return s.f;
    });
    var u = n(14);
    n.d(t, "SettingsRepository", function () {
      return u.a;
    });
  }, function (e, t, n) {
    "use strict";

    n.d(t, "e", function () {
      return a;
    }), n.d(t, "d", function () {
      return s;
    }), n.d(t, "g", function () {
      return u;
    }), n.d(t, "b", function () {
      return c;
    }), n.d(t, "a", function () {
      return h;
    }), n.d(t, "c", function () {
      return d;
    }), n.d(t, "f", function () {
      return f;
    });
    var r = n(4),
        i = n(8),
        o = n(14);

    var a = function a(e) {
      var t, n, o, a;
      return _regeneratorRuntime.async(function a$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              t = e.searchTerm, n = e.pagination, o = e.filter, a = {
                sorter: [{
                  fieldName: "name",
                  direction: r.SortDirection.Ascending
                }]
              };
              o && (a.filter = o);
              void 0 !== t && "" !== t && (a.filter ? a.filter = _objectSpread({}, a.filter, {
                searchTerm: t
              }) : a.filter = {
                searchTerm: t
              });
              a.pager = n || {
                limit: 100,
                offset: 0
              };
              _context20.next = 6;
              return _regeneratorRuntime.awrap(Object(i.y)().getResources([new r.Requests.PositionTypeRequest(a)]));

            case 6:
              return _context20.abrupt("return", _context20.sent[0].data);

            case 7:
            case "end":
              return _context20.stop();
          }
        }
      });
    },
        s = function s(e) {
      var t, n, o, a;
      return _regeneratorRuntime.async(function s$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              t = e.filter, n = e.searchTerm, o = e.pagination, a = {
                sorter: [{
                  fieldName: "name",
                  direction: r.SortDirection.Ascending
                }]
              };
              t && (a.filter = t);
              void 0 !== n && "" !== n && (a.filter = _objectSpread({}, a.filter, {
                searchTerm: n
              }));
              a.pager = o || {
                limit: 100,
                offset: 0
              };
              _context21.next = 6;
              return _regeneratorRuntime.awrap(Object(i.y)().getResources([new r.Requests.FacilityDepartmentRequest(a)]));

            case 6:
              return _context21.abrupt("return", _context21.sent[0].data);

            case 7:
            case "end":
              return _context21.stop();
          }
        }
      });
    },
        u = function u(e, t) {
      return e.map(function (e) {
        return {
          id: e.id,
          name: e.name,
          key: e.id,
          departments: t.filter(function (t) {
            return t.company.id === e.id;
          }).map(function (t) {
            return {
              id: t.id,
              name: t.name,
              companyId: e.id
            };
          })
        };
      });
    },
        c = function c() {
      var e, t, n;
      return _regeneratorRuntime.async(function c$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return _regeneratorRuntime.awrap(Object(i.y)().getResources([new r.Requests.CompanyRequest({
                pager: {
                  limit: 100
                }
              }), new r.Requests.FacilityDepartmentRequest({})]));

            case 2:
              e = _context22.sent;
              t = e[0].data;
              n = e[1].data;
              return _context22.abrupt("return", u(t, n));

            case 6:
            case "end":
              return _context22.stop();
          }
        }
      });
    },
        l = 100;

    function h() {
      var e, t, n, _o5;

      return _regeneratorRuntime.async(function h$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              e = [], t = [], n = 0;

            case 1:
              _context23.next = 3;
              return _regeneratorRuntime.awrap(Object(i.y)().getResources([new r.Requests.CompanyRequest({
                pager: {
                  limit: l,
                  offset: n
                }
              })]));

            case 3:
              _o5 = _context23.sent;
              n += l, t = _o5[0].data, e = [].concat(_toConsumableArray(e), _toConsumableArray(t));

            case 5:
              if (100 === t.length) {
                _context23.next = 1;
                break;
              }

            case 6:
              return _context23.abrupt("return", e);

            case 7:
            case "end":
              return _context23.stop();
          }
        }
      });
    }

    function d() {
      return _regeneratorRuntime.async(function d$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return _regeneratorRuntime.awrap(Object(i.y)().getResources([new r.Requests.DataPreferencesRequest({})]));

            case 2:
              return _context24.abrupt("return", _context24.sent[0].data[0]);

            case 3:
            case "end":
              return _context24.stop();
          }
        }
      });
    }

    function f() {
      var e;
      return _regeneratorRuntime.async(function f$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              e = o.a.getInstance().settings.dataPreferences;
              _context25.next = 3;
              return _regeneratorRuntime.awrap(Object(i.y)().createMutationRequest(new r.Requests.SetDataPreferencesRequest({
                preferences: {
                  companies: e.companies,
                  dataLevel: e.option,
                  positionTypeIds: e.positionTypes
                }
              })));

            case 3:
            case "end":
              return _context25.stop();
          }
        }
      });
    }
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        i = n(5),
        o = n(22),
        a = n(8),
        s = function s(e) {
      var _Object12 = Object(r.useState)(),
          _Object13 = _slicedToArray(_Object12, 2),
          t = _Object13[0],
          n = _Object13[1],
          _Object14 = Object(r.useState)(),
          _Object15 = _slicedToArray(_Object14, 2),
          s = _Object15[0],
          u = _Object15[1],
          _Object16 = Object(r.useState)(!1),
          _Object17 = _slicedToArray(_Object16, 2),
          c = _Object17[0],
          l = _Object17[1];

      return Object(r.useEffect)(function () {
        (function _callee7() {
          var _t10;

          return _regeneratorRuntime.async(function _callee7$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  if (!e) {
                    _context26.next = 12;
                    break;
                  }

                  l(!0);
                  _context26.prev = 2;
                  _context26.next = 5;
                  return _regeneratorRuntime.awrap(Object(a.y)().getMedia(e));

                case 5:
                  _t10 = _context26.sent;
                  n(_t10), i.supportedMimeTypes.includes(_t10.type) ? Object(o.a)(_t10, function (e) {
                    return u(e);
                  }, function () {
                    return l(!1);
                  }) : l(!1);
                  _context26.next = 12;
                  break;

                case 9:
                  _context26.prev = 9;
                  _context26.t0 = _context26["catch"](2);
                  throw l(!1), _context26.t0;

                case 12:
                case "end":
                  return _context26.stop();
              }
            }
          }, null, null, [[2, 9]]);
        })();
      }, [e]), {
        blob: t,
        dataURL: s,
        loading: c
      };
    },
        u = n(18);

    function c() {
      var _Object18 = Object(u.useLocation)(),
          e = _Object18.pathname,
          t = _Object18.search,
          n = Object(r.useRef)(e),
          i = Object(r.useRef)(t);

      return t !== i.current && (i.current = t), "".concat(n.current).concat(i.current);
    }

    var l = n(40);

    var h = function h(e) {
      var _Object19 = Object(r.useState)(!1),
          _Object20 = _slicedToArray(_Object19, 2),
          t = _Object20[0],
          n = _Object20[1],
          i = Object(r.useRef)(!1);

      return Object(r.useEffect)(function () {
        e && function _callee8() {
          return _regeneratorRuntime.async(function _callee8$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                  _context27.t0 = i.current;

                  if (_context27.t0) {
                    _context27.next = 7;
                    break;
                  }

                  n(!0);
                  _context27.next = 5;
                  return _regeneratorRuntime.awrap(Object(l.initializeSettings)(e));

                case 5:
                  n(!1);
                  i.current = !0;

                case 7:
                case "end":
                  return _context27.stop();
              }
            }
          });
        }();
      }, [t, n, e]), t;
    };

    n.d(t, "a", function () {
      return s;
    }), n.d(t, "b", function () {
      return c;
    }), n.d(t, "c", function () {
      return h;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(18),
        i = n(1);
    var o = Object(i.styled)(r.Link)(function (_ref21) {
      var e = _ref21.theme;
      return {
        fontWeight: 600,
        color: e.newColors.linkPrimary
      };
    });
    n.d(t, "a", function () {
      return o;
    });
  }, function (e, t, n) {
    "use strict";

    var r,
        i,
        o,
        a = n(0),
        s = n.n(a),
        u = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Error\\ErrorBoundary.tsx";

    var c =
    /*#__PURE__*/
    function (_a$Component) {
      _inherits(c, _a$Component);

      function c(e) {
        var _this21;

        _classCallCheck(this, c);

        _this21 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, e)), _this21.state = c.state;
        return _this21;
      }

      _createClass(c, [{
        key: "componentDidCatch",
        value: function componentDidCatch(e, t) {
          var n = this.props.onError,
              r = this.state.errors;
          n && n(e, t), this.setState({
            errors: [].concat(_toConsumableArray(r), [{
              error: e,
              errorInfo: t
            }])
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              e = _this$props.children,
              t = _this$props.errorComponent,
              n = this.state.errors;
          return n.length > 0 ? s.a.createElement(t, {
            errors: n,
            __source: {
              fileName: u,
              lineNumber: 51
            },
            __self: this
          }) : e;
        }
      }]);

      return c;
    }(a.Component);

    o = {
      errors: []
    }, (i = "state") in (r = c) ? Object.defineProperty(r, i, {
      value: o,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : r[i] = o;
    var l = n(195),
        h = n(196),
        d = n(197);
    n.d(t, "a", function () {
      return c;
    }), n.d(t, "b", function () {
      return l.a;
    }), n.d(t, "c", function () {
      return h.a;
    }), n.d(t, "d", function () {
      return d.a;
    });
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      n.d(t, "a", function () {
        return o;
      });
      var r = n(0);
      var i = {
        Positions: e.modules.widget.info.positions,
        Matches: e.modules.widget.info.matches,
        Shifts: e.modules.widget.info.shifts
      };

      function o(e) {
        return Object(r.useMemo)(function () {
          return e.reduce(function (e, t) {
            return void 0 === e[t.searchType] ? e[t.searchType] = {
              label: i[t.searchType],
              widgets: [t]
            } : e[t.searchType].widgets.push(t), e;
          }, {});
        }, [e]);
      }
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      n.d(t, "a", function () {
        return c;
      });
      var r = n(0),
          i = n.n(r),
          o = n(1),
          a = n(5),
          s = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetResources\\ContextMenu.tsx";

      var u = a.Intl.FormattedMessage,
          c = function c(_ref22) {
        var t = _ref22.id,
            n = _ref22.onRemove,
            r = _ref22.onEdit;
        return i.a.createElement(o.Dropdown, {
          overlay: i.a.createElement(o.DropdownMenu, {
            items: [{
              icon: "delete",
              text: i.a.createElement(u, {
                id: e.modules.widget.widgetFrame.contextMenu.remove,
                __source: {
                  fileName: s,
                  lineNumber: 23
                },
                __self: void 0
              }),
              onClick: function onClick() {
                return n(t);
              }
            }, {
              icon: "edit",
              text: i.a.createElement(u, {
                id: e.modules.widget.widgetFrame.contextMenu.edit,
                __source: {
                  fileName: s,
                  lineNumber: 32
                },
                __self: void 0
              }),
              onClick: function onClick() {
                return r(t);
              }
            }],
            style: {
              width: 224
            },
            __source: {
              fileName: s,
              lineNumber: 18
            },
            __self: void 0
          }),
          __source: {
            fileName: s,
            lineNumber: 16
          },
          __self: void 0
        }, i.a.createElement(o.Icon, {
          type: "more",
          style: {
            verticalAlign: "middle"
          },
          __source: {
            fileName: s,
            lineNumber: 43
          },
          __self: void 0
        }));
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, n) {
    "use strict";

    var r,
        i = (r = n(6)) && "object" == typeof r && "default" in r ? r.default : r;
    n(255), n(256), n(257), n(259), n(260), n(261), n(262), n(263), n(264);
    /**
     * @license
     * Copyright 2018 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    i.registerVersion("firebase", "7.14.3", "app");
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    console.warn("\nIt looks like you're using the development build of the Firebase JS SDK.\nWhen deploying Firebase apps to production, it is advisable to only import\nthe individual SDK components you intend to use.\n\nFor the module builds, these are available in the following manner\n(replace <PACKAGE> with the name of a component - i.e. auth, database, etc):\n\nCommonJS Modules:\nconst firebase = require('firebase/app');\nrequire('firebase/<PACKAGE>');\n\nES Modules:\nimport firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n\nTypescript:\nimport * as firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n"), i.registerVersion("firebase", "7.14.3"), e.exports = i;
  }, function (e, t, n) {
    "use strict";

    (function (e, r) {
      var i,
          o = n(225);
      i = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e ? e : r;
      var a = Object(o.a)(i);
      t.a = a;
    }).call(this, n(17), n(265)(e));
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return r;
    }), n.d(t, "b", function () {
      return i;
    });

    var r = {
      page: 1,
      canLoadMore: !1,
      loadedAll: !1,
      loading: !1,
      active: !1,
      body: ""
    },
        i = function i(e, t) {
      switch (t.type) {
        case "setNotes":
          return _objectSpread({}, e, {
            notes: t.payload
          });

        case "setCanLoadMore":
          return _objectSpread({}, e, {
            canLoadMore: t.payload
          });

        case "setLoading":
          return _objectSpread({}, e, {
            loading: t.payload
          });

        case "setActive":
          return _objectSpread({}, e, {
            active: t.payload
          });

        case "setBody":
          return _objectSpread({}, e, {
            body: t.payload
          });

        default:
          return e;
      }
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(35);
    n.d(t, "Comment", function () {
      return r.a;
    });
    var i = n(34);
    n.d(t, "WidgetSpecType", function () {
      return i.f;
    }), n.d(t, "WidgetContainerState", function () {
      return i.e;
    }), n.d(t, "widgetContainerReducer", function () {
      return i.z;
    }), n.d(t, "widgetContainerActions", function () {
      return i.y;
    }), n.d(t, "WidgetContainer", function () {
      return i.d;
    }), n.d(t, "widgetFrameworkSagas", function () {
      return i.A;
    }), n.d(t, "BaseWidgetResource", function () {
      return i.a;
    }), n.d(t, "TableWidgetResource", function () {
      return i.c;
    }), n.d(t, "CounterWidgetResource", function () {
      return i.b;
    }), n.d(t, "widgetRegistry", function () {
      return i.B;
    }), n.d(t, "getWidgetDynamicFieldsGetter", function () {
      return i.l;
    }), n.d(t, "registerWidgetDynamicFieldsGetter", function () {
      return i.r;
    }), n.d(t, "getWidgetFormFieldsRenderer", function () {
      return i.n;
    }), n.d(t, "registerWidgetFormFieldsRenderer", function () {
      return i.t;
    }), n.d(t, "getWidgetDynamicFormFieldsToFilterMapper", function () {
      return i.m;
    }), n.d(t, "registerWidgetDynamicFormFieldsToFilterMapper", function () {
      return i.s;
    }), n.d(t, "registerDynamicWidgetConfig", function () {
      return i.q;
    }), n.d(t, "registerWidgetResources", function () {
      return i.u;
    }), n.d(t, "getWidgetResource", function () {
      return i.o;
    }), n.d(t, "getAllResources", function () {
      return i.i;
    }), n.d(t, "getResourcesByType", function () {
      return i.k;
    }), n.d(t, "registerDefaultLayout", function () {
      return i.p;
    }), n.d(t, "getDefaultLayout", function () {
      return i.j;
    }), n.d(t, "createColumns", function () {
      return i.g;
    }), n.d(t, "formatColumns", function () {
      return i.h;
    }), n.d(t, "setFormatColumns", function () {
      return i.w;
    }), n.d(t, "renderEmptyState", function () {
      return i.v;
    }), n.d(t, "setRenderEmptyState", function () {
      return i.x;
    });
    var o = n(209);
    n.d(t, "QuickSearch", function () {
      return o.a;
    });
    var a = n(210);
    n.d(t, "TabLayout", function () {
      return a.a;
    });
    var s = n(207);
    n.d(t, "TableDateRangeFilter", function () {
      return s.b;
    }), n.d(t, "TableTimeRangeFilter", function () {
      return s.c;
    }), n.d(t, "ColumnFilters", function () {
      return s.a;
    }), n.d(t, "dateRender", function () {
      return s.d;
    });
    var u = n(43);
    n.d(t, "ThemedLink", function () {
      return u.a;
    });
    var c = n(190);

    for (var l in c) {
      ["Departments", "Comment", "WidgetSpecType", "WidgetContainerState", "widgetContainerReducer", "widgetContainerActions", "WidgetContainer", "widgetFrameworkSagas", "BaseWidgetResource", "TableWidgetResource", "CounterWidgetResource", "widgetRegistry", "getWidgetDynamicFieldsGetter", "registerWidgetDynamicFieldsGetter", "getWidgetFormFieldsRenderer", "registerWidgetFormFieldsRenderer", "getWidgetDynamicFormFieldsToFilterMapper", "registerWidgetDynamicFormFieldsToFilterMapper", "registerDynamicWidgetConfig", "registerWidgetResources", "getWidgetResource", "getAllResources", "getResourcesByType", "registerDefaultLayout", "getDefaultLayout", "createColumns", "formatColumns", "setFormatColumns", "renderEmptyState", "setRenderEmptyState", "QuickSearch", "TabLayout", "TableDateRangeFilter", "TableTimeRangeFilter", "ColumnFilters", "dateRender", "ThemedLink", "default"].indexOf(l) < 0 && function (e) {
        n.d(t, e, function () {
          return c[e];
        });
      }(l);
    }

    var h = n(193);
    n.d(t, "Notes", function () {
      return h.a;
    });
    var d = n(44);
    n.d(t, "ErrorBoundary", function () {
      return d.a;
    }), n.d(t, "GenericError", function () {
      return d.b;
    }), n.d(t, "Page404", function () {
      return d.c;
    }), n.d(t, "PageUnauthorized", function () {
      return d.d;
    });
    var f = n(29);
    n.d(t, "ActionStatusInfo", function () {
      return f.a;
    }), n.d(t, "showActionStatus", function () {
      return f.c;
    }), n.d(t, "closeActionStatus", function () {
      return f.b;
    });
    var p = n(211);
    n.d(t, "Departments", function () {
      return p.a;
    });
    var m = n(198);
    n.d(t, "AttachmentsPreview", function () {
      return m.a;
    });

    var _ = n(202);

    n.d(t, "DynamicLabels", function () {
      return _.a;
    });
    var y = n(7);
    n.d(t, "compileExpression", function () {
      return y.d;
    }), n.d(t, "PermissionsContext", function () {
      return y.b;
    }), n.d(t, "PermissionsProvider", function () {
      return y.c;
    }), n.d(t, "usePermissions", function () {
      return y.f;
    }), n.d(t, "useFilterByPermissions", function () {
      return y.e;
    }), n.d(t, "Authorize", function () {
      return y.a;
    });
    var v = n(212);
    n.d(t, "AppearanceThemes", function () {
      return v.c;
    }), n.d(t, "AppearanceContext", function () {
      return v.a;
    }), n.d(t, "AppearanceProvider", function () {
      return v.b;
    });
    var g = n(213);
    n.d(t, "ColoredCircle", function () {
      return g.a;
    });
    var b = n(214);
    n.d(t, "AuthorizedRoute", function () {
      return b.a;
    });
    var w = n(208);
    n.d(t, "CustomFieldRenderer", function () {
      return w.a;
    });
    var T = n(215);
    n.d(t, "ButtonContainer", function () {
      return T.a;
    });
    var M = n(204);
    n.d(t, "LoadMoreSelect", function () {
      return M.a;
    });
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(5),
          a = n(1),
          s = n(7),
          u = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Comment\\Comment.tsx";

      function c() {
        return (c = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var r in n) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        }).apply(this, arguments);
      }

      var _o$Intl = o.Intl,
          l = _o$Intl.FormattedMessage,
          h = _o$Intl.FormattedRelative,
          d = function d(t, n) {
        return [{
          icon: "edit",
          text: i.a.createElement(l, {
            id: e.modules.comments.edit,
            __source: {
              fileName: u,
              lineNumber: 28
            },
            __self: void 0
          }),
          onClick: function onClick() {
            return null == n ? void 0 : n();
          }
        }, {
          icon: "delete",
          text: i.a.createElement(a.Text, {
            color: "critical",
            __source: {
              fileName: u,
              lineNumber: 34
            },
            __self: void 0
          }, i.a.createElement(l, {
            id: e.modules.comments.delete,
            __source: {
              fileName: u,
              lineNumber: 35
            },
            __self: void 0
          })),
          onClick: function onClick() {
            return null == t ? void 0 : t();
          }
        }];
      };

      t.a = function (_ref23) {
        var t = _ref23.content,
            n = _ref23.datetime,
            o = _ref23.editAndDeletePermission,
            f = _ref23.onDelete,
            p = _ref23.onEdit,
            m = _objectWithoutProperties(_ref23, ["content", "datetime", "editAndDeletePermission", "onDelete", "onEdit"]);

        var _Object21 = Object(r.useState)(!1),
            _Object22 = _slicedToArray(_Object21, 2),
            _ = _Object22[0],
            y = _Object22[1],
            _Object23 = Object(r.useState)(!1),
            _Object24 = _slicedToArray(_Object23, 2),
            v = _Object24[0],
            g = _Object24[1],
            _Object25 = Object(r.useState)(""),
            _Object26 = _slicedToArray(_Object25, 2),
            b = _Object26[0],
            w = _Object26[1],
            _Object27 = Object(a.useHover)(),
            _Object28 = _slicedToArray(_Object27, 2),
            T = _Object28[0],
            M = _Object28[1],
            E = f || p,
            _Object29 = Object(s.f)(),
            k = _Object29.hasPermission,
            L = "string" == typeof n ? i.a.createElement(h, {
          value: n,
          __source: {
            fileName: u,
            lineNumber: 66
          },
          __self: void 0
        }) : n,
            S = Object(r.useCallback)(function () {
          f && f(), y(!1);
        }, [f]),
            N = Object(r.useCallback)(function () {
          p && p(b), g(!1);
        }, [p, b]),
            D = Object(r.useMemo)(function () {
          return k(o || "");
        }, [k, o]);

        return i.a.createElement(i.a.Fragment, null, _ && i.a.createElement(a.Modal, {
          okText: i.a.createElement(l, {
            id: e.modules.comments.delete,
            __source: {
              fileName: u,
              lineNumber: 90
            },
            __self: void 0
          }),
          visible: _,
          onOk: S,
          cancelText: i.a.createElement(l, {
            id: e.modules.comments.cancel,
            __source: {
              fileName: u,
              lineNumber: 94
            },
            __self: void 0
          }),
          onCancel: function onCancel() {
            return y(!1);
          },
          __source: {
            fileName: u,
            lineNumber: 89
          },
          __self: void 0
        }, i.a.createElement(a.H1, {
          __source: {
            fileName: u,
            lineNumber: 98
          },
          __self: void 0
        }, i.a.createElement(l, {
          id: e.modules.comments.deleteCaption,
          __source: {
            fileName: u,
            lineNumber: 99
          },
          __self: void 0
        }))), i.a.createElement(a.Comment, c({}, M, {
          content: "string" == typeof t ? v ? i.a.createElement(a.Flex, {
            direction: "column",
            gutter: 2,
            gutterDirection: "vertical",
            __source: {
              fileName: u,
              lineNumber: 108
            },
            __self: void 0
          }, i.a.createElement(a.RichTextEditor, {
            defaultValue: t,
            onChange: function onChange(e) {
              return w(e);
            },
            __source: {
              fileName: u,
              lineNumber: 109
            },
            __self: void 0
          }), i.a.createElement(a.Flex, {
            gutter: 2,
            justify: "flex-end",
            __source: {
              fileName: u,
              lineNumber: 113
            },
            __self: void 0
          }, i.a.createElement(a.Button, {
            onClick: function onClick() {
              return g(!1);
            },
            __source: {
              fileName: u,
              lineNumber: 114
            },
            __self: void 0
          }, i.a.createElement(a.Text, {
            weight: 600,
            __source: {
              fileName: u,
              lineNumber: 115
            },
            __self: void 0
          }, i.a.createElement(l, {
            id: e.modules.notes.cancel,
            __source: {
              fileName: u,
              lineNumber: 116
            },
            __self: void 0
          }))), i.a.createElement(a.Button, {
            type: "primary",
            onClick: N,
            __source: {
              fileName: u,
              lineNumber: 119
            },
            __self: void 0
          }, i.a.createElement(a.Text, {
            weight: 600,
            color: "bodyTertiary",
            __source: {
              fileName: u,
              lineNumber: 120
            },
            __self: void 0
          }, i.a.createElement(l, {
            id: e.modules.notes.send,
            __source: {
              fileName: u,
              lineNumber: 121
            },
            __self: void 0
          }))))) : i.a.createElement("div", {
            dangerouslySetInnerHTML: {
              __html: t
            },
            __source: {
              fileName: u,
              lineNumber: 127
            },
            __self: void 0
          }) : t,
          datetime: i.a.createElement(a.Flex, {
            gutter: 3,
            style: {
              height: 20
            },
            align: "center",
            __source: {
              fileName: u,
              lineNumber: 134
            },
            __self: void 0
          }, L, E && T && D ? i.a.createElement(a.ContextMenu, {
            items: d(f && function () {
              return y(!0);
            }, p && function () {
              return g(!0);
            }),
            __source: {
              fileName: u,
              lineNumber: 137
            },
            __self: void 0
          }) : void 0)
        }, m, {
          __source: {
            fileName: u,
            lineNumber: 103
          },
          __self: void 0
        })));
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e, t) {
      return function () {
        for (var n = new Array(arguments.length), r = 0; r < n.length; r++) {
          n[r] = arguments[r];
        }

        return e.apply(t, n);
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(15);

    function i(e) {
      return encodeURIComponent(e).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }

    e.exports = function (e, t, n) {
      if (!t) return e;
      var o;
      if (n) o = n(t);else if (r.isURLSearchParams(t)) o = t.toString();else {
        var a = [];
        r.forEach(t, function (e, t) {
          null != e && (r.isArray(e) ? t += "[]" : e = [e], r.forEach(e, function (e) {
            r.isDate(e) ? e = e.toISOString() : r.isObject(e) && (e = JSON.stringify(e)), a.push(i(t) + "=" + i(e));
          }));
        }), o = a.join("&");
      }

      if (o) {
        var s = e.indexOf("#");
        -1 !== s && (e = e.slice(0, s)), e += (-1 === e.indexOf("?") ? "?" : "&") + o;
      }

      return e;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      return !(!e || !e.__CANCEL__);
    };
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      var r = n(15),
          i = n(244),
          o = {
        "Content-Type": "application/x-www-form-urlencoded"
      };

      function a(e, t) {
        !r.isUndefined(e) && r.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
      }

      var s,
          u = {
        adapter: ("undefined" != typeof XMLHttpRequest ? s = n(57) : void 0 !== t && "[object process]" === Object.prototype.toString.call(t) && (s = n(57)), s),
        transformRequest: [function (e, t) {
          return i(t, "Accept"), i(t, "Content-Type"), r.isFormData(e) || r.isArrayBuffer(e) || r.isBuffer(e) || r.isStream(e) || r.isFile(e) || r.isBlob(e) ? e : r.isArrayBufferView(e) ? e.buffer : r.isURLSearchParams(e) ? (a(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : r.isObject(e) ? (a(t, "application/json;charset=utf-8"), JSON.stringify(e)) : e;
        }],
        transformResponse: [function (e) {
          if ("string" == typeof e) try {
            e = JSON.parse(e);
          } catch (e) {}
          return e;
        }],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        validateStatus: function validateStatus(e) {
          return e >= 200 && e < 300;
        }
      };
      u.headers = {
        common: {
          Accept: "application/json, text/plain, */*"
        }
      }, r.forEach(["delete", "get", "head"], function (e) {
        u.headers[e] = {};
      }), r.forEach(["post", "put", "patch"], function (e) {
        u.headers[e] = r.merge(o);
      }), e.exports = u;
    }).call(this, n(32));
  }, function (e, t, n) {
    "use strict";

    var r = n(15),
        i = n(245),
        o = n(54),
        a = n(247),
        s = n(250),
        u = n(251),
        c = n(58);

    e.exports = function (e) {
      return new Promise(function (t, l) {
        var h = e.data,
            d = e.headers;
        r.isFormData(h) && delete d["Content-Type"];
        var f = new XMLHttpRequest();

        if (e.auth) {
          var p = e.auth.username || "",
              m = e.auth.password || "";
          d.Authorization = "Basic " + btoa(p + ":" + m);
        }

        var _ = a(e.baseURL, e.url);

        if (f.open(e.method.toUpperCase(), o(_, e.params, e.paramsSerializer), !0), f.timeout = e.timeout, f.onreadystatechange = function () {
          if (f && 4 === f.readyState && (0 !== f.status || f.responseURL && 0 === f.responseURL.indexOf("file:"))) {
            var n = "getAllResponseHeaders" in f ? s(f.getAllResponseHeaders()) : null,
                r = {
              data: e.responseType && "text" !== e.responseType ? f.response : f.responseText,
              status: f.status,
              statusText: f.statusText,
              headers: n,
              config: e,
              request: f
            };
            i(t, l, r), f = null;
          }
        }, f.onabort = function () {
          f && (l(c("Request aborted", e, "ECONNABORTED", f)), f = null);
        }, f.onerror = function () {
          l(c("Network Error", e, null, f)), f = null;
        }, f.ontimeout = function () {
          var t = "timeout of " + e.timeout + "ms exceeded";
          e.timeoutErrorMessage && (t = e.timeoutErrorMessage), l(c(t, e, "ECONNABORTED", f)), f = null;
        }, r.isStandardBrowserEnv()) {
          var y = n(252),
              v = (e.withCredentials || u(_)) && e.xsrfCookieName ? y.read(e.xsrfCookieName) : void 0;
          v && (d[e.xsrfHeaderName] = v);
        }

        if ("setRequestHeader" in f && r.forEach(d, function (e, t) {
          void 0 === h && "content-type" === t.toLowerCase() ? delete d[t] : f.setRequestHeader(t, e);
        }), r.isUndefined(e.withCredentials) || (f.withCredentials = !!e.withCredentials), e.responseType) try {
          f.responseType = e.responseType;
        } catch (t) {
          if ("json" !== e.responseType) throw t;
        }
        "function" == typeof e.onDownloadProgress && f.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && f.upload && f.upload.addEventListener("progress", e.onUploadProgress), e.cancelToken && e.cancelToken.promise.then(function (e) {
          f && (f.abort(), l(e), f = null);
        }), void 0 === h && (h = null), f.send(h);
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(246);

    e.exports = function (e, t, n, i, o) {
      var a = new Error(e);
      return r(a, t, n, i, o);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(15);

    e.exports = function (e, t) {
      t = t || {};
      var n = {},
          i = ["url", "method", "params", "data"],
          o = ["headers", "auth", "proxy"],
          a = ["baseURL", "url", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "maxContentLength", "validateStatus", "maxRedirects", "httpAgent", "httpsAgent", "cancelToken", "socketPath"];
      r.forEach(i, function (e) {
        void 0 !== t[e] && (n[e] = t[e]);
      }), r.forEach(o, function (i) {
        r.isObject(t[i]) ? n[i] = r.deepMerge(e[i], t[i]) : void 0 !== t[i] ? n[i] = t[i] : r.isObject(e[i]) ? n[i] = r.deepMerge(e[i]) : void 0 !== e[i] && (n[i] = e[i]);
      }), r.forEach(a, function (r) {
        void 0 !== t[r] ? n[r] = t[r] : void 0 !== e[r] && (n[r] = e[r]);
      });
      var s = i.concat(o).concat(a),
          u = Object.keys(t).filter(function (e) {
        return -1 === s.indexOf(e);
      });
      return r.forEach(u, function (r) {
        void 0 !== t[r] ? n[r] = t[r] : void 0 !== e[r] && (n[r] = e[r]);
      }), n;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      this.message = e;
    }

    r.prototype.toString = function () {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }, r.prototype.__CANCEL__ = !0, e.exports = r;
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      n.d(t, "a", function () {
        return g;
      });
      var r = n(0),
          i = n.n(r),
          o = n(217),
          a = n.n(o),
          s = n(5),
          u = n(1),
          c = n(218),
          l = n(220),
          h = n(11),
          d = n(10),
          f = n(221),
          p = n(7),
          m = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetContainer\\WidgetContainer.tsx";

      var _ = s.Intl.FormattedMessage,
          y = u.styled.div(function (_ref24) {
        var e = _ref24.isInteracting,
            t = _ref24.theme,
            n = _ref24.isEditable;
        return {
          backgroundColor: a()(t.newColors.bgPagePrimary).alpha(e ? .5 : 1).css(),
          height: "100%",
          display: "grid",
          gridTemplateRows: "min-content auto min-content",
          ".react-grid-item": {
            cursor: n ? "" : "pointer"
          }
        };
      }),
          v = u.styled.div(_templateObject()),
          g = function g(_ref25) {
        var t = _ref25.widgetItems,
            n = _ref25.widgetLayouts,
            o = _ref25.widgetData,
            a = _ref25.addWidget,
            s = _ref25.removeWidget,
            g = _ref25.loadLayout,
            b = _ref25.saveLayout,
            w = _ref25.refreshBatch,
            T = _ref25.restoreLayout,
            M = _ref25.history,
            E = _ref25.onEditMode,
            k = _ref25.clearWidgets;

        var _Object30 = Object(r.useState)(!1),
            _Object31 = _slicedToArray(_Object30, 2),
            L = _Object31[0],
            S = _Object31[1],
            _Object32 = Object(r.useState)(!1),
            _Object33 = _slicedToArray(_Object32, 2),
            N = _Object33[0],
            D = _Object33[1],
            _Object34 = Object(r.useState)(!1),
            _Object35 = _slicedToArray(_Object34, 2),
            I = _Object35[0],
            R = _Object35[1],
            _Object36 = Object(r.useState)(n),
            _Object37 = _slicedToArray(_Object36, 2),
            x = _Object37[0],
            Y = _Object37[1],
            _Object38 = Object(r.useState)(!1),
            _Object39 = _slicedToArray(_Object38, 2),
            C = _Object39[0],
            O = _Object39[1],
            _Object40 = Object(r.useState)(!1),
            _Object41 = _slicedToArray(_Object40, 2),
            F = _Object41[0],
            A = _Object41[1],
            _Object42 = Object(r.useState)(void 0),
            _Object43 = _slicedToArray(_Object42, 2),
            j = _Object43[0],
            U = _Object43[1],
            _Object44 = Object(p.f)(),
            P = _Object44.hasPermission,
            V = Object(r.useCallback)(function () {
          U(void 0), S(!1);
        }, []),
            W = Object(r.useCallback)(function () {
          return S(!0);
        }, []),
            H = Object(r.useCallback)(function () {
          O(!0);
        }, []),
            B = Object(r.useCallback)(function (e) {
          D(e), E && E(e);
        }, [E]),
            z = Object(r.useCallback)(function (e) {
          s(e);
        }, [s]),
            Z = Object(r.useCallback)(function (e) {
          U(e), W();
        }, [W]),
            Q = Object(r.useCallback)(function () {
          T(), A(!1), w();
        }, [T, w]),
            G = Object(r.useCallback)(function () {
          b(x), D(!1), E && E(!1);
        }, [x, b, E]),
            q = Object(r.useCallback)(function () {
          w();
        }, [w]),
            J = Object(r.useCallback)(function (e) {
          D(!0), a({
            widgetItem: e,
            layoutDraft: x
          }), A(!1), V(), U(void 0);
        }, [a, V, x]);

        Object(r.useEffect)(function () {
          g();
        }, [g]), Object(r.useEffect)(function () {
          return function () {
            k();
          };
        }, []), Object(r.useEffect)(function () {
          !F && t.length && (q(), A(!0));
        }, [q, F, t.length]), Object(r.useEffect)(function () {
          Y(n);
        }, [t, n]), Object(r.useEffect)(function () {
          U(void 0);
        }, [L]);
        var X = t.filter(function (e) {
          var t = Object(h.c)(e.type, e.widgetId);
          return P(t.permission || "");
        });
        return i.a.createElement(y, {
          isInteracting: I,
          isEditable: N,
          __source: {
            fileName: m,
            lineNumber: 183
          },
          __self: void 0
        }, i.a.createElement(f.a, {
          visible: L,
          onCancel: V,
          onSubmit: J,
          widgetItem: j,
          __source: {
            fileName: m,
            lineNumber: 184
          },
          __self: void 0
        }), i.a.createElement(c.a, {
          isEditable: N,
          onAddNewWidget: W,
          onEdit: function onEdit() {
            return B(!0);
          },
          onRefresh: q,
          onRestore: Q,
          __source: {
            fileName: m,
            lineNumber: 190
          },
          __self: void 0
        }), i.a.createElement(v, {
          __source: {
            fileName: m,
            lineNumber: 197
          },
          __self: void 0
        }, i.a.createElement(u.LayoutEngine, {
          layout: x,
          isEditable: N,
          onInteraction: R,
          onLayoutChange: Y,
          __source: {
            fileName: m,
            lineNumber: 198
          },
          __self: void 0
        }, X.map(function (e) {
          var t = Object(h.c)(e.type, e.widgetId);
          return i.a.createElement("div", {
            key: e.id,
            __source: {
              fileName: m,
              lineNumber: 211
            },
            __self: void 0
          }, t.renderWidget(_objectSpread({}, e, {
            isLoading: o[e.id].isLoading,
            isEditable: N,
            onEdit: Z,
            onRemove: z,
            onClick: function onClick() {
              return function (e, t) {
                !N && e === d.a.counter && M.push(t);
              }(e.type, t.searchRoute);
            },
            data: o[e.id].data
          })));
        }))), N && i.a.createElement(l.a, {
          onCancel: H,
          onSaveDashboard: G,
          __source: {
            fileName: m,
            lineNumber: 228
          },
          __self: void 0
        }), C && i.a.createElement(u.Modal, {
          okText: i.a.createElement(_, {
            id: e.modules.widget.promptCancel.okText,
            __source: {
              fileName: m,
              lineNumber: 233
            },
            __self: void 0
          }),
          visible: C,
          onOk: function onOk() {
            g(), D(!1), E && E(!1), O(!1), A(!1);
          },
          onCancel: function onCancel() {
            return O(!1);
          },
          __source: {
            fileName: m,
            lineNumber: 231
          },
          __self: void 0
        }, i.a.createElement(u.H1, {
          __source: {
            fileName: m,
            lineNumber: 247
          },
          __self: void 0
        }, i.a.createElement(_, {
          id: e.modules.widget.promptCancel.title,
          __source: {
            fileName: m,
            lineNumber: 248
          },
          __self: void 0
        })), i.a.createElement(u.H4, {
          __source: {
            fileName: m,
            lineNumber: 252
          },
          __self: void 0
        }, i.a.createElement(_, {
          id: e.modules.widget.promptCancel.text,
          __source: {
            fileName: m,
            lineNumber: 253
          },
          __self: void 0
        }))));
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      n.d(t, "a", function () {
        return p;
      });
      var r = n(0),
          i = n.n(r),
          o = n(5),
          a = n(1),
          s = n(222),
          u = n(10),
          c = n(11),
          l = n(28),
          h = n(7),
          d = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetWizardContainer\\WidgetWizardContainer.tsx";

      var f = function f(t, n) {
        return 2 === t && n ? n === u.a.counter ? e.modules.widget.counterWidget.title : e.modules.widget.tableWidget.title : e.modules.widget.newWidgetWizard.pageTitle;
      },
          p = o.Intl.injectIntl(function (_ref26) {
        var t = _ref26.widgetItem,
            n = _ref26.visible,
            p = _ref26.onSubmit,
            m = _ref26.onCancel,
            _ = _ref26.intl;

        var _Object45 = Object(h.f)(),
            y = _Object45.filterByPermissions,
            _Object46 = Object(r.useState)(1),
            _Object47 = _slicedToArray(_Object46, 2),
            v = _Object47[0],
            g = _Object47[1],
            _Object48 = Object(r.useState)(t),
            _Object49 = _slicedToArray(_Object48, 2),
            b = _Object49[0],
            w = _Object49[1];

        t && 1 === v && n && (w(t), g(2));

        var T = function T() {
          g(1), w(void 0);
        };

        return i.a.createElement(a.Modal, {
          pageTitle: i.a.createElement(a.H1, {
            color: "headerTertiary",
            __source: {
              fileName: d,
              lineNumber: 96
            },
            __self: void 0
          }, i.a.createElement(o.Intl.FormattedMessage, {
            id: f(v, null == b ? void 0 : b.type),
            __source: {
              fileName: d,
              lineNumber: 97
            },
            __self: void 0
          })),
          title: i.a.createElement(a.H1, {
            __source: {
              fileName: d,
              lineNumber: 103
            },
            __self: void 0
          }, i.a.createElement(o.Intl.FormattedMessage, {
            id: f(v, null == b ? void 0 : b.type),
            __source: {
              fileName: d,
              lineNumber: 104
            },
            __self: void 0
          })),
          width: "642px",
          footer: !1,
          visible: n,
          onCancel: m,
          afterClose: T,
          __source: {
            fileName: d,
            lineNumber: 94
          },
          __self: void 0
        }, b && 2 === v ? Object(c.c)(b.type, b.widgetId).renderForm(_objectSpread({}, b, {
          onSubmit: function onSubmit(e) {
            T(), p(e);
          },
          onBack: function onBack() {
            g(v - 1), w(void 0);
          }
        })) : 2 === v && void 0 === b ? i.a.createElement(a.Text, {
          color: "critical",
          __source: {
            fileName: d,
            lineNumber: 125
          },
          __self: void 0
        }, i.a.createElement(o.Intl.FormattedMessage, {
          id: e.modules.widget.newWidgetWizard.insufficientPermissionsText,
          __source: {
            fileName: d,
            lineNumber: 126
          },
          __self: void 0
        })) : i.a.createElement(s.a, {
          widgets: Object.values(l.a),
          onSelect: function onSelect(e) {
            g(2);
            var t = y(Object(c.b)(e.type), function (e) {
              return e.permission;
            });

            if (t.length > 0) {
              var _n10 = t[0],
                  _r8 = {
                title: _.formatMessage({
                  id: _n10.label
                }),
                visibleColumns: e.type === u.a.table ? _n10.visibleColumns : void 0
              };
              w({
                widgetId: _n10.widgetId,
                type: e.type,
                dynamicWidgetArgs: _r8
              });
            } else w(void 0);
          },
          __source: {
            fileName: d,
            lineNumber: 134
          },
          __self: void 0
        }));
      });
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("af", {
        months: "Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),
        monthsShort: "Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),
        weekdays: "Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),
        weekdaysShort: "Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),
        weekdaysMin: "So_Ma_Di_Wo_Do_Vr_Sa".split("_"),
        meridiemParse: /vm|nm/i,
        isPM: function isPM(e) {
          return /^nm$/i.test(e);
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? n ? "vm" : "VM" : n ? "nm" : "NM";
        },
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Vandag om] LT",
          nextDay: "[Môre om] LT",
          nextWeek: "dddd [om] LT",
          lastDay: "[Gister om] LT",
          lastWeek: "[Laas] dddd [om] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "oor %s",
          past: "%s gelede",
          s: "'n paar sekondes",
          ss: "%d sekondes",
          m: "'n minuut",
          mm: "%d minute",
          h: "'n uur",
          hh: "%d ure",
          d: "'n dag",
          dd: "%d dae",
          M: "'n maand",
          MM: "%d maande",
          y: "'n jaar",
          yy: "%d jaar"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(e) {
          return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "١",
        2: "٢",
        3: "٣",
        4: "٤",
        5: "٥",
        6: "٦",
        7: "٧",
        8: "٨",
        9: "٩",
        0: "٠"
      },
          n = {
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        "٠": "0"
      },
          r = function r(e) {
        return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
      },
          i = {
        s: ["أقل من ثانية", "ثانية واحدة", ["ثانيتان", "ثانيتين"], "%d ثوان", "%d ثانية", "%d ثانية"],
        m: ["أقل من دقيقة", "دقيقة واحدة", ["دقيقتان", "دقيقتين"], "%d دقائق", "%d دقيقة", "%d دقيقة"],
        h: ["أقل من ساعة", "ساعة واحدة", ["ساعتان", "ساعتين"], "%d ساعات", "%d ساعة", "%d ساعة"],
        d: ["أقل من يوم", "يوم واحد", ["يومان", "يومين"], "%d أيام", "%d يومًا", "%d يوم"],
        M: ["أقل من شهر", "شهر واحد", ["شهران", "شهرين"], "%d أشهر", "%d شهرا", "%d شهر"],
        y: ["أقل من عام", "عام واحد", ["عامان", "عامين"], "%d أعوام", "%d عامًا", "%d عام"]
      },
          o = function o(e) {
        return function (t, n, o, a) {
          var s = r(t),
              u = i[e][r(t)];
          return 2 === s && (u = u[n ? 0 : 1]), u.replace(/%d/i, t);
        };
      },
          a = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];

      e.defineLocale("ar", {
        months: a,
        monthsShort: a,
        weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
        weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "D/‏M/‏YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(e) {
          return "م" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "ص" : "م";
        },
        calendar: {
          sameDay: "[اليوم عند الساعة] LT",
          nextDay: "[غدًا عند الساعة] LT",
          nextWeek: "dddd [عند الساعة] LT",
          lastDay: "[أمس عند الساعة] LT",
          lastWeek: "dddd [عند الساعة] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "بعد %s",
          past: "منذ %s",
          s: o("s"),
          ss: o("s"),
          m: o("m"),
          mm: o("m"),
          h: o("h"),
          hh: o("h"),
          d: o("d"),
          dd: o("d"),
          M: o("M"),
          MM: o("M"),
          y: o("y"),
          yy: o("y")
        },
        preparse: function preparse(e) {
          return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
            return n[e];
          }).replace(/،/g, ",");
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          }).replace(/,/g, "،");
        },
        week: {
          dow: 6,
          doy: 12
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ar-dz", {
        months: "جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
        monthsShort: "جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
        weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        weekdaysShort: "احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),
        weekdaysMin: "أح_إث_ثلا_أر_خم_جم_سب".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[اليوم على الساعة] LT",
          nextDay: "[غدا على الساعة] LT",
          nextWeek: "dddd [على الساعة] LT",
          lastDay: "[أمس على الساعة] LT",
          lastWeek: "dddd [على الساعة] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "في %s",
          past: "منذ %s",
          s: "ثوان",
          ss: "%d ثانية",
          m: "دقيقة",
          mm: "%d دقائق",
          h: "ساعة",
          hh: "%d ساعات",
          d: "يوم",
          dd: "%d أيام",
          M: "شهر",
          MM: "%d أشهر",
          y: "سنة",
          yy: "%d سنوات"
        },
        week: {
          dow: 0,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ar-kw", {
        months: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
        monthsShort: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
        weekdays: "الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        weekdaysShort: "احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),
        weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[اليوم على الساعة] LT",
          nextDay: "[غدا على الساعة] LT",
          nextWeek: "dddd [على الساعة] LT",
          lastDay: "[أمس على الساعة] LT",
          lastWeek: "dddd [على الساعة] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "في %s",
          past: "منذ %s",
          s: "ثوان",
          ss: "%d ثانية",
          m: "دقيقة",
          mm: "%d دقائق",
          h: "ساعة",
          hh: "%d ساعات",
          d: "يوم",
          dd: "%d أيام",
          M: "شهر",
          MM: "%d أشهر",
          y: "سنة",
          yy: "%d سنوات"
        },
        week: {
          dow: 0,
          doy: 12
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        0: "0"
      },
          n = function n(e) {
        return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
      },
          r = {
        s: ["أقل من ثانية", "ثانية واحدة", ["ثانيتان", "ثانيتين"], "%d ثوان", "%d ثانية", "%d ثانية"],
        m: ["أقل من دقيقة", "دقيقة واحدة", ["دقيقتان", "دقيقتين"], "%d دقائق", "%d دقيقة", "%d دقيقة"],
        h: ["أقل من ساعة", "ساعة واحدة", ["ساعتان", "ساعتين"], "%d ساعات", "%d ساعة", "%d ساعة"],
        d: ["أقل من يوم", "يوم واحد", ["يومان", "يومين"], "%d أيام", "%d يومًا", "%d يوم"],
        M: ["أقل من شهر", "شهر واحد", ["شهران", "شهرين"], "%d أشهر", "%d شهرا", "%d شهر"],
        y: ["أقل من عام", "عام واحد", ["عامان", "عامين"], "%d أعوام", "%d عامًا", "%d عام"]
      },
          i = function i(e) {
        return function (t, i, o, a) {
          var s = n(t),
              u = r[e][n(t)];
          return 2 === s && (u = u[i ? 0 : 1]), u.replace(/%d/i, t);
        };
      },
          o = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];

      e.defineLocale("ar-ly", {
        months: o,
        monthsShort: o,
        weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
        weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "D/‏M/‏YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(e) {
          return "م" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "ص" : "م";
        },
        calendar: {
          sameDay: "[اليوم عند الساعة] LT",
          nextDay: "[غدًا عند الساعة] LT",
          nextWeek: "dddd [عند الساعة] LT",
          lastDay: "[أمس عند الساعة] LT",
          lastWeek: "dddd [عند الساعة] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "بعد %s",
          past: "منذ %s",
          s: i("s"),
          ss: i("s"),
          m: i("m"),
          mm: i("m"),
          h: i("h"),
          hh: i("h"),
          d: i("d"),
          dd: i("d"),
          M: i("M"),
          MM: i("M"),
          y: i("y"),
          yy: i("y")
        },
        preparse: function preparse(e) {
          return e.replace(/،/g, ",");
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          }).replace(/,/g, "،");
        },
        week: {
          dow: 6,
          doy: 12
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ar-ma", {
        months: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
        monthsShort: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
        weekdays: "الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        weekdaysShort: "احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),
        weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[اليوم على الساعة] LT",
          nextDay: "[غدا على الساعة] LT",
          nextWeek: "dddd [على الساعة] LT",
          lastDay: "[أمس على الساعة] LT",
          lastWeek: "dddd [على الساعة] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "في %s",
          past: "منذ %s",
          s: "ثوان",
          ss: "%d ثانية",
          m: "دقيقة",
          mm: "%d دقائق",
          h: "ساعة",
          hh: "%d ساعات",
          d: "يوم",
          dd: "%d أيام",
          M: "شهر",
          MM: "%d أشهر",
          y: "سنة",
          yy: "%d سنوات"
        },
        week: {
          dow: 6,
          doy: 12
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "١",
        2: "٢",
        3: "٣",
        4: "٤",
        5: "٥",
        6: "٦",
        7: "٧",
        8: "٨",
        9: "٩",
        0: "٠"
      },
          n = {
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        "٠": "0"
      };
      e.defineLocale("ar-sa", {
        months: "يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
        monthsShort: "يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
        weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
        weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(e) {
          return "م" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "ص" : "م";
        },
        calendar: {
          sameDay: "[اليوم على الساعة] LT",
          nextDay: "[غدا على الساعة] LT",
          nextWeek: "dddd [على الساعة] LT",
          lastDay: "[أمس على الساعة] LT",
          lastWeek: "dddd [على الساعة] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "في %s",
          past: "منذ %s",
          s: "ثوان",
          ss: "%d ثانية",
          m: "دقيقة",
          mm: "%d دقائق",
          h: "ساعة",
          hh: "%d ساعات",
          d: "يوم",
          dd: "%d أيام",
          M: "شهر",
          MM: "%d أشهر",
          y: "سنة",
          yy: "%d سنوات"
        },
        preparse: function preparse(e) {
          return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
            return n[e];
          }).replace(/،/g, ",");
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          }).replace(/,/g, "،");
        },
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ar-tn", {
        months: "جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
        monthsShort: "جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
        weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
        weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
        weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[اليوم على الساعة] LT",
          nextDay: "[غدا على الساعة] LT",
          nextWeek: "dddd [على الساعة] LT",
          lastDay: "[أمس على الساعة] LT",
          lastWeek: "dddd [على الساعة] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "في %s",
          past: "منذ %s",
          s: "ثوان",
          ss: "%d ثانية",
          m: "دقيقة",
          mm: "%d دقائق",
          h: "ساعة",
          hh: "%d ساعات",
          d: "يوم",
          dd: "%d أيام",
          M: "شهر",
          MM: "%d أشهر",
          y: "سنة",
          yy: "%d سنوات"
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "-inci",
        5: "-inci",
        8: "-inci",
        70: "-inci",
        80: "-inci",
        2: "-nci",
        7: "-nci",
        20: "-nci",
        50: "-nci",
        3: "-üncü",
        4: "-üncü",
        100: "-üncü",
        6: "-ncı",
        9: "-uncu",
        10: "-uncu",
        30: "-uncu",
        60: "-ıncı",
        90: "-ıncı"
      };
      e.defineLocale("az", {
        months: "yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),
        monthsShort: "yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),
        weekdays: "Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə".split("_"),
        weekdaysShort: "Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən".split("_"),
        weekdaysMin: "Bz_BE_ÇA_Çə_CA_Cü_Şə".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[bugün saat] LT",
          nextDay: "[sabah saat] LT",
          nextWeek: "[gələn həftə] dddd [saat] LT",
          lastDay: "[dünən] LT",
          lastWeek: "[keçən həftə] dddd [saat] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s sonra",
          past: "%s əvvəl",
          s: "birneçə saniyə",
          ss: "%d saniyə",
          m: "bir dəqiqə",
          mm: "%d dəqiqə",
          h: "bir saat",
          hh: "%d saat",
          d: "bir gün",
          dd: "%d gün",
          M: "bir ay",
          MM: "%d ay",
          y: "bir il",
          yy: "%d il"
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function isPM(e) {
          return /^(gündüz|axşam)$/.test(e);
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "gecə" : e < 12 ? "səhər" : e < 17 ? "gündüz" : "axşam";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function ordinal(e) {
          if (0 === e) return e + "-ıncı";
          var n = e % 10,
              r = e % 100 - n,
              i = e >= 100 ? 100 : null;
          return e + (t[n] || t[r] || t[i]);
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n) {
        var r,
            i,
            o = {
          ss: t ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
          mm: t ? "хвіліна_хвіліны_хвілін" : "хвіліну_хвіліны_хвілін",
          hh: t ? "гадзіна_гадзіны_гадзін" : "гадзіну_гадзіны_гадзін",
          dd: "дзень_дні_дзён",
          MM: "месяц_месяцы_месяцаў",
          yy: "год_гады_гадоў"
        };
        return "m" === n ? t ? "хвіліна" : "хвіліну" : "h" === n ? t ? "гадзіна" : "гадзіну" : e + " " + (r = +e, i = o[n].split("_"), r % 10 == 1 && r % 100 != 11 ? i[0] : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? i[1] : i[2]);
      }

      e.defineLocale("be", {
        months: {
          format: "студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня".split("_"),
          standalone: "студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань".split("_")
        },
        monthsShort: "студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж".split("_"),
        weekdays: {
          format: "нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу".split("_"),
          standalone: "нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота".split("_"),
          isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort: "нд_пн_ат_ср_чц_пт_сб".split("_"),
        weekdaysMin: "нд_пн_ат_ср_чц_пт_сб".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY г.",
          LLL: "D MMMM YYYY г., HH:mm",
          LLLL: "dddd, D MMMM YYYY г., HH:mm"
        },
        calendar: {
          sameDay: "[Сёння ў] LT",
          nextDay: "[Заўтра ў] LT",
          lastDay: "[Учора ў] LT",
          nextWeek: function nextWeek() {
            return "[У] dddd [ў] LT";
          },
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
              case 3:
              case 5:
              case 6:
                return "[У мінулую] dddd [ў] LT";

              case 1:
              case 2:
              case 4:
                return "[У мінулы] dddd [ў] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "праз %s",
          past: "%s таму",
          s: "некалькі секунд",
          m: t,
          mm: t,
          h: t,
          hh: t,
          d: "дзень",
          dd: t,
          M: "месяц",
          MM: t,
          y: "год",
          yy: t
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function isPM(e) {
          return /^(дня|вечара)$/.test(e);
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "ночы" : e < 12 ? "раніцы" : e < 17 ? "дня" : "вечара";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "M":
            case "d":
            case "DDD":
            case "w":
            case "W":
              return e % 10 != 2 && e % 10 != 3 || e % 100 == 12 || e % 100 == 13 ? e + "-ы" : e + "-і";

            case "D":
              return e + "-га";

            default:
              return e;
          }
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("bg", {
        months: "януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),
        monthsShort: "янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),
        weekdays: "неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),
        weekdaysShort: "нед_пон_вто_сря_чет_пет_съб".split("_"),
        weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"),
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "D.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY H:mm",
          LLLL: "dddd, D MMMM YYYY H:mm"
        },
        calendar: {
          sameDay: "[Днес в] LT",
          nextDay: "[Утре в] LT",
          nextWeek: "dddd [в] LT",
          lastDay: "[Вчера в] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
              case 3:
              case 6:
                return "[В изминалата] dddd [в] LT";

              case 1:
              case 2:
              case 4:
              case 5:
                return "[В изминалия] dddd [в] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "след %s",
          past: "преди %s",
          s: "няколко секунди",
          ss: "%d секунди",
          m: "минута",
          mm: "%d минути",
          h: "час",
          hh: "%d часа",
          d: "ден",
          dd: "%d дни",
          M: "месец",
          MM: "%d месеца",
          y: "година",
          yy: "%d години"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = e % 100;
          return 0 === e ? e + "-ев" : 0 === n ? e + "-ен" : n > 10 && n < 20 ? e + "-ти" : 1 === t ? e + "-ви" : 2 === t ? e + "-ри" : 7 === t || 8 === t ? e + "-ми" : e + "-ти";
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("bm", {
        months: "Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo".split("_"),
        monthsShort: "Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des".split("_"),
        weekdays: "Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),
        weekdaysShort: "Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib".split("_"),
        weekdaysMin: "Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "MMMM [tile] D [san] YYYY",
          LLL: "MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm",
          LLLL: "dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm"
        },
        calendar: {
          sameDay: "[Bi lɛrɛ] LT",
          nextDay: "[Sini lɛrɛ] LT",
          nextWeek: "dddd [don lɛrɛ] LT",
          lastDay: "[Kunu lɛrɛ] LT",
          lastWeek: "dddd [tɛmɛnen lɛrɛ] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s kɔnɔ",
          past: "a bɛ %s bɔ",
          s: "sanga dama dama",
          ss: "sekondi %d",
          m: "miniti kelen",
          mm: "miniti %d",
          h: "lɛrɛ kelen",
          hh: "lɛrɛ %d",
          d: "tile kelen",
          dd: "tile %d",
          M: "kalo kelen",
          MM: "kalo %d",
          y: "san kelen",
          yy: "san %d"
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "১",
        2: "২",
        3: "৩",
        4: "৪",
        5: "৫",
        6: "৬",
        7: "৭",
        8: "৮",
        9: "৯",
        0: "০"
      },
          n = {
        "১": "1",
        "২": "2",
        "৩": "3",
        "৪": "4",
        "৫": "5",
        "৬": "6",
        "৭": "7",
        "৮": "8",
        "৯": "9",
        "০": "0"
      };
      e.defineLocale("bn", {
        months: "জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split("_"),
        monthsShort: "জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে".split("_"),
        weekdays: "রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split("_"),
        weekdaysShort: "রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),
        weekdaysMin: "রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি".split("_"),
        longDateFormat: {
          LT: "A h:mm সময়",
          LTS: "A h:mm:ss সময়",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY, A h:mm সময়",
          LLLL: "dddd, D MMMM YYYY, A h:mm সময়"
        },
        calendar: {
          sameDay: "[আজ] LT",
          nextDay: "[আগামীকাল] LT",
          nextWeek: "dddd, LT",
          lastDay: "[গতকাল] LT",
          lastWeek: "[গত] dddd, LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s পরে",
          past: "%s আগে",
          s: "কয়েক সেকেন্ড",
          ss: "%d সেকেন্ড",
          m: "এক মিনিট",
          mm: "%d মিনিট",
          h: "এক ঘন্টা",
          hh: "%d ঘন্টা",
          d: "এক দিন",
          dd: "%d দিন",
          M: "এক মাস",
          MM: "%d মাস",
          y: "এক বছর",
          yy: "%d বছর"
        },
        preparse: function preparse(e) {
          return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function (e) {
            return n[e];
          });
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "রাত" === t && e >= 4 || "দুপুর" === t && e < 5 || "বিকাল" === t ? e + 12 : e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "রাত" : e < 10 ? "সকাল" : e < 17 ? "দুপুর" : e < 20 ? "বিকাল" : "রাত";
        },
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "༡",
        2: "༢",
        3: "༣",
        4: "༤",
        5: "༥",
        6: "༦",
        7: "༧",
        8: "༨",
        9: "༩",
        0: "༠"
      },
          n = {
        "༡": "1",
        "༢": "2",
        "༣": "3",
        "༤": "4",
        "༥": "5",
        "༦": "6",
        "༧": "7",
        "༨": "8",
        "༩": "9",
        "༠": "0"
      };
      e.defineLocale("bo", {
        months: "ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ".split("_"),
        monthsShort: "ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ".split("_"),
        weekdays: "གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་".split("_"),
        weekdaysShort: "ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་".split("_"),
        weekdaysMin: "ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་".split("_"),
        longDateFormat: {
          LT: "A h:mm",
          LTS: "A h:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY, A h:mm",
          LLLL: "dddd, D MMMM YYYY, A h:mm"
        },
        calendar: {
          sameDay: "[དི་རིང] LT",
          nextDay: "[སང་ཉིན] LT",
          nextWeek: "[བདུན་ཕྲག་རྗེས་མ], LT",
          lastDay: "[ཁ་སང] LT",
          lastWeek: "[བདུན་ཕྲག་མཐའ་མ] dddd, LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s ལ་",
          past: "%s སྔན་ལ",
          s: "ལམ་སང",
          ss: "%d སྐར་ཆ།",
          m: "སྐར་མ་གཅིག",
          mm: "%d སྐར་མ",
          h: "ཆུ་ཚོད་གཅིག",
          hh: "%d ཆུ་ཚོད",
          d: "ཉིན་གཅིག",
          dd: "%d ཉིན་",
          M: "ཟླ་བ་གཅིག",
          MM: "%d ཟླ་བ",
          y: "ལོ་གཅིག",
          yy: "%d ལོ"
        },
        preparse: function preparse(e) {
          return e.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (e) {
            return n[e];
          });
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "མཚན་མོ" === t && e >= 4 || "ཉིན་གུང" === t && e < 5 || "དགོང་དག" === t ? e + 12 : e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "མཚན་མོ" : e < 10 ? "ཞོགས་ཀས" : e < 17 ? "ཉིན་གུང" : e < 20 ? "དགོང་དག" : "མཚན་མོ";
        },
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n) {
        return e + " " + function (e, t) {
          return 2 === t ? function (e) {
            var t = {
              m: "v",
              b: "v",
              d: "z"
            };
            return void 0 === t[e.charAt(0)] ? e : t[e.charAt(0)] + e.substring(1);
          }(e) : e;
        }({
          mm: "munutenn",
          MM: "miz",
          dd: "devezh"
        }[n], e);
      }

      e.defineLocale("br", {
        months: "Genver_C'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),
        monthsShort: "Gen_C'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),
        weekdays: "Sul_Lun_Meurzh_Merc'her_Yaou_Gwener_Sadorn".split("_"),
        weekdaysShort: "Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),
        weekdaysMin: "Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "h[e]mm A",
          LTS: "h[e]mm:ss A",
          L: "DD/MM/YYYY",
          LL: "D [a viz] MMMM YYYY",
          LLL: "D [a viz] MMMM YYYY h[e]mm A",
          LLLL: "dddd, D [a viz] MMMM YYYY h[e]mm A"
        },
        calendar: {
          sameDay: "[Hiziv da] LT",
          nextDay: "[Warc'hoazh da] LT",
          nextWeek: "dddd [da] LT",
          lastDay: "[Dec'h da] LT",
          lastWeek: "dddd [paset da] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "a-benn %s",
          past: "%s 'zo",
          s: "un nebeud segondennoù",
          ss: "%d eilenn",
          m: "ur vunutenn",
          mm: t,
          h: "un eur",
          hh: "%d eur",
          d: "un devezh",
          dd: t,
          M: "ur miz",
          MM: t,
          y: "ur bloaz",
          yy: function yy(e) {
            switch (function e(t) {
              return t > 9 ? e(t % 10) : t;
            }(e)) {
              case 1:
              case 3:
              case 4:
              case 5:
              case 9:
                return e + " bloaz";

              default:
                return e + " vloaz";
            }
          }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function ordinal(e) {
          var t = 1 === e ? "añ" : "vet";
          return e + t;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n) {
        var r = e + " ";

        switch (n) {
          case "ss":
            return r += 1 === e ? "sekunda" : 2 === e || 3 === e || 4 === e ? "sekunde" : "sekundi";

          case "m":
            return t ? "jedna minuta" : "jedne minute";

          case "mm":
            return r += 1 === e ? "minuta" : 2 === e || 3 === e || 4 === e ? "minute" : "minuta";

          case "h":
            return t ? "jedan sat" : "jednog sata";

          case "hh":
            return r += 1 === e ? "sat" : 2 === e || 3 === e || 4 === e ? "sata" : "sati";

          case "dd":
            return r += 1 === e ? "dan" : "dana";

          case "MM":
            return r += 1 === e ? "mjesec" : 2 === e || 3 === e || 4 === e ? "mjeseca" : "mjeseci";

          case "yy":
            return r += 1 === e ? "godina" : 2 === e || 3 === e || 4 === e ? "godine" : "godina";
        }
      }

      e.defineLocale("bs", {
        months: "januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),
        monthsShort: "jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY H:mm",
          LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
          sameDay: "[danas u] LT",
          nextDay: "[sutra u] LT",
          nextWeek: function nextWeek() {
            switch (this.day()) {
              case 0:
                return "[u] [nedjelju] [u] LT";

              case 3:
                return "[u] [srijedu] [u] LT";

              case 6:
                return "[u] [subotu] [u] LT";

              case 1:
              case 2:
              case 4:
              case 5:
                return "[u] dddd [u] LT";
            }
          },
          lastDay: "[jučer u] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
              case 3:
                return "[prošlu] dddd [u] LT";

              case 6:
                return "[prošle] [subote] [u] LT";

              case 1:
              case 2:
              case 4:
              case 5:
                return "[prošli] dddd [u] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "za %s",
          past: "prije %s",
          s: "par sekundi",
          ss: t,
          m: t,
          mm: t,
          h: t,
          hh: t,
          d: "dan",
          dd: t,
          M: "mjesec",
          MM: t,
          y: "godinu",
          yy: t
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ca", {
        months: {
          standalone: "gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),
          format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),
          isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: "gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),
        monthsParseExact: !0,
        weekdays: "diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),
        weekdaysShort: "dg._dl._dt._dc._dj._dv._ds.".split("_"),
        weekdaysMin: "dg_dl_dt_dc_dj_dv_ds".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM [de] YYYY",
          ll: "D MMM YYYY",
          LLL: "D MMMM [de] YYYY [a les] H:mm",
          lll: "D MMM YYYY, H:mm",
          LLLL: "dddd D MMMM [de] YYYY [a les] H:mm",
          llll: "ddd D MMM YYYY, H:mm"
        },
        calendar: {
          sameDay: function sameDay() {
            return "[avui a " + (1 !== this.hours() ? "les" : "la") + "] LT";
          },
          nextDay: function nextDay() {
            return "[demà a " + (1 !== this.hours() ? "les" : "la") + "] LT";
          },
          nextWeek: function nextWeek() {
            return "dddd [a " + (1 !== this.hours() ? "les" : "la") + "] LT";
          },
          lastDay: function lastDay() {
            return "[ahir a " + (1 !== this.hours() ? "les" : "la") + "] LT";
          },
          lastWeek: function lastWeek() {
            return "[el] dddd [passat a " + (1 !== this.hours() ? "les" : "la") + "] LT";
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "d'aquí %s",
          past: "fa %s",
          s: "uns segons",
          ss: "%d segons",
          m: "un minut",
          mm: "%d minuts",
          h: "una hora",
          hh: "%d hores",
          d: "un dia",
          dd: "%d dies",
          M: "un mes",
          MM: "%d mesos",
          y: "un any",
          yy: "%d anys"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function ordinal(e, t) {
          var n = 1 === e ? "r" : 2 === e ? "n" : 3 === e ? "r" : 4 === e ? "t" : "è";
          return "w" !== t && "W" !== t || (n = "a"), e + n;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),
          n = "led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_"),
          r = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i],
          i = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

      function o(e) {
        return e > 1 && e < 5 && 1 != ~~(e / 10);
      }

      function a(e, t, n, r) {
        var i = e + " ";

        switch (n) {
          case "s":
            return t || r ? "pár sekund" : "pár sekundami";

          case "ss":
            return t || r ? i + (o(e) ? "sekundy" : "sekund") : i + "sekundami";

          case "m":
            return t ? "minuta" : r ? "minutu" : "minutou";

          case "mm":
            return t || r ? i + (o(e) ? "minuty" : "minut") : i + "minutami";

          case "h":
            return t ? "hodina" : r ? "hodinu" : "hodinou";

          case "hh":
            return t || r ? i + (o(e) ? "hodiny" : "hodin") : i + "hodinami";

          case "d":
            return t || r ? "den" : "dnem";

          case "dd":
            return t || r ? i + (o(e) ? "dny" : "dní") : i + "dny";

          case "M":
            return t || r ? "měsíc" : "měsícem";

          case "MM":
            return t || r ? i + (o(e) ? "měsíce" : "měsíců") : i + "měsíci";

          case "y":
            return t || r ? "rok" : "rokem";

          case "yy":
            return t || r ? i + (o(e) ? "roky" : "let") : i + "lety";
        }
      }

      e.defineLocale("cs", {
        months: t,
        monthsShort: n,
        monthsRegex: i,
        monthsShortRegex: i,
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: r,
        longMonthsParse: r,
        shortMonthsParse: r,
        weekdays: "neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),
        weekdaysShort: "ne_po_út_st_čt_pá_so".split("_"),
        weekdaysMin: "ne_po_út_st_čt_pá_so".split("_"),
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY H:mm",
          LLLL: "dddd D. MMMM YYYY H:mm",
          l: "D. M. YYYY"
        },
        calendar: {
          sameDay: "[dnes v] LT",
          nextDay: "[zítra v] LT",
          nextWeek: function nextWeek() {
            switch (this.day()) {
              case 0:
                return "[v neděli v] LT";

              case 1:
              case 2:
                return "[v] dddd [v] LT";

              case 3:
                return "[ve středu v] LT";

              case 4:
                return "[ve čtvrtek v] LT";

              case 5:
                return "[v pátek v] LT";

              case 6:
                return "[v sobotu v] LT";
            }
          },
          lastDay: "[včera v] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
                return "[minulou neděli v] LT";

              case 1:
              case 2:
                return "[minulé] dddd [v] LT";

              case 3:
                return "[minulou středu v] LT";

              case 4:
              case 5:
                return "[minulý] dddd [v] LT";

              case 6:
                return "[minulou sobotu v] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "za %s",
          past: "před %s",
          s: a,
          ss: a,
          m: a,
          mm: a,
          h: a,
          hh: a,
          d: a,
          dd: a,
          M: a,
          MM: a,
          y: a,
          yy: a
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("cv", {
        months: "кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав".split("_"),
        monthsShort: "кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш".split("_"),
        weekdays: "вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун".split("_"),
        weekdaysShort: "выр_тун_ытл_юн_кӗҫ_эрн_шӑм".split("_"),
        weekdaysMin: "вр_тн_ыт_юн_кҫ_эр_шм".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD-MM-YYYY",
          LL: "YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]",
          LLL: "YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm",
          LLLL: "dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm"
        },
        calendar: {
          sameDay: "[Паян] LT [сехетре]",
          nextDay: "[Ыран] LT [сехетре]",
          lastDay: "[Ӗнер] LT [сехетре]",
          nextWeek: "[Ҫитес] dddd LT [сехетре]",
          lastWeek: "[Иртнӗ] dddd LT [сехетре]",
          sameElse: "L"
        },
        relativeTime: {
          future: function future(e) {
            var t = /сехет$/i.exec(e) ? "рен" : /ҫул$/i.exec(e) ? "тан" : "ран";
            return e + t;
          },
          past: "%s каялла",
          s: "пӗр-ик ҫеккунт",
          ss: "%d ҫеккунт",
          m: "пӗр минут",
          mm: "%d минут",
          h: "пӗр сехет",
          hh: "%d сехет",
          d: "пӗр кун",
          dd: "%d кун",
          M: "пӗр уйӑх",
          MM: "%d уйӑх",
          y: "пӗр ҫул",
          yy: "%d ҫул"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: "%d-мӗш",
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("cy", {
        months: "Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),
        monthsShort: "Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),
        weekdays: "Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),
        weekdaysShort: "Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),
        weekdaysMin: "Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Heddiw am] LT",
          nextDay: "[Yfory am] LT",
          nextWeek: "dddd [am] LT",
          lastDay: "[Ddoe am] LT",
          lastWeek: "dddd [diwethaf am] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "mewn %s",
          past: "%s yn ôl",
          s: "ychydig eiliadau",
          ss: "%d eiliad",
          m: "munud",
          mm: "%d munud",
          h: "awr",
          hh: "%d awr",
          d: "diwrnod",
          dd: "%d diwrnod",
          M: "mis",
          MM: "%d mis",
          y: "blwyddyn",
          yy: "%d flynedd"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        ordinal: function ordinal(e) {
          var t = e,
              n = "";
          return t > 20 ? n = 40 === t || 50 === t || 60 === t || 80 === t || 100 === t ? "fed" : "ain" : t > 0 && (n = ["", "af", "il", "ydd", "ydd", "ed", "ed", "ed", "fed", "fed", "fed", "eg", "fed", "eg", "eg", "fed", "eg", "eg", "fed", "eg", "fed"][t]), e + n;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("da", {
        months: "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),
        monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
        weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
        weekdaysShort: "søn_man_tir_ons_tor_fre_lør".split("_"),
        weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY HH:mm",
          LLLL: "dddd [d.] D. MMMM YYYY [kl.] HH:mm"
        },
        calendar: {
          sameDay: "[i dag kl.] LT",
          nextDay: "[i morgen kl.] LT",
          nextWeek: "på dddd [kl.] LT",
          lastDay: "[i går kl.] LT",
          lastWeek: "[i] dddd[s kl.] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "om %s",
          past: "%s siden",
          s: "få sekunder",
          ss: "%d sekunder",
          m: "et minut",
          mm: "%d minutter",
          h: "en time",
          hh: "%d timer",
          d: "en dag",
          dd: "%d dage",
          M: "en måned",
          MM: "%d måneder",
          y: "et år",
          yy: "%d år"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n, r) {
        var i = {
          m: ["eine Minute", "einer Minute"],
          h: ["eine Stunde", "einer Stunde"],
          d: ["ein Tag", "einem Tag"],
          dd: [e + " Tage", e + " Tagen"],
          M: ["ein Monat", "einem Monat"],
          MM: [e + " Monate", e + " Monaten"],
          y: ["ein Jahr", "einem Jahr"],
          yy: [e + " Jahre", e + " Jahren"]
        };
        return t ? i[n][0] : i[n][1];
      }

      e.defineLocale("de", {
        months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
        monthsParseExact: !0,
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY HH:mm",
          LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[heute um] LT [Uhr]",
          sameElse: "L",
          nextDay: "[morgen um] LT [Uhr]",
          nextWeek: "dddd [um] LT [Uhr]",
          lastDay: "[gestern um] LT [Uhr]",
          lastWeek: "[letzten] dddd [um] LT [Uhr]"
        },
        relativeTime: {
          future: "in %s",
          past: "vor %s",
          s: "ein paar Sekunden",
          ss: "%d Sekunden",
          m: t,
          mm: "%d Minuten",
          h: t,
          hh: "%d Stunden",
          d: t,
          dd: t,
          M: t,
          MM: t,
          y: t,
          yy: t
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n, r) {
        var i = {
          m: ["eine Minute", "einer Minute"],
          h: ["eine Stunde", "einer Stunde"],
          d: ["ein Tag", "einem Tag"],
          dd: [e + " Tage", e + " Tagen"],
          M: ["ein Monat", "einem Monat"],
          MM: [e + " Monate", e + " Monaten"],
          y: ["ein Jahr", "einem Jahr"],
          yy: [e + " Jahre", e + " Jahren"]
        };
        return t ? i[n][0] : i[n][1];
      }

      e.defineLocale("de-at", {
        months: "Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
        monthsParseExact: !0,
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY HH:mm",
          LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[heute um] LT [Uhr]",
          sameElse: "L",
          nextDay: "[morgen um] LT [Uhr]",
          nextWeek: "dddd [um] LT [Uhr]",
          lastDay: "[gestern um] LT [Uhr]",
          lastWeek: "[letzten] dddd [um] LT [Uhr]"
        },
        relativeTime: {
          future: "in %s",
          past: "vor %s",
          s: "ein paar Sekunden",
          ss: "%d Sekunden",
          m: t,
          mm: "%d Minuten",
          h: t,
          hh: "%d Stunden",
          d: t,
          dd: t,
          M: t,
          MM: t,
          y: t,
          yy: t
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n, r) {
        var i = {
          m: ["eine Minute", "einer Minute"],
          h: ["eine Stunde", "einer Stunde"],
          d: ["ein Tag", "einem Tag"],
          dd: [e + " Tage", e + " Tagen"],
          M: ["ein Monat", "einem Monat"],
          MM: [e + " Monate", e + " Monaten"],
          y: ["ein Jahr", "einem Jahr"],
          yy: [e + " Jahre", e + " Jahren"]
        };
        return t ? i[n][0] : i[n][1];
      }

      e.defineLocale("de-ch", {
        months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
        monthsParseExact: !0,
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY HH:mm",
          LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[heute um] LT [Uhr]",
          sameElse: "L",
          nextDay: "[morgen um] LT [Uhr]",
          nextWeek: "dddd [um] LT [Uhr]",
          lastDay: "[gestern um] LT [Uhr]",
          lastWeek: "[letzten] dddd [um] LT [Uhr]"
        },
        relativeTime: {
          future: "in %s",
          past: "vor %s",
          s: "ein paar Sekunden",
          ss: "%d Sekunden",
          m: t,
          mm: "%d Minuten",
          h: t,
          hh: "%d Stunden",
          d: t,
          dd: t,
          M: t,
          MM: t,
          y: t,
          yy: t
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = ["ޖެނުއަރީ", "ފެބްރުއަރީ", "މާރިޗު", "އޭޕްރީލު", "މޭ", "ޖޫން", "ޖުލައި", "އޯގަސްޓު", "ސެޕްޓެމްބަރު", "އޮކްޓޯބަރު", "ނޮވެމްބަރު", "ޑިސެމްބަރު"],
          n = ["އާދިއްތަ", "ހޯމަ", "އަންގާރަ", "ބުދަ", "ބުރާސްފަތި", "ހުކުރު", "ހޮނިހިރު"];
      e.defineLocale("dv", {
        months: t,
        monthsShort: t,
        weekdays: n,
        weekdaysShort: n,
        weekdaysMin: "އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "D/M/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /މކ|މފ/,
        isPM: function isPM(e) {
          return "މފ" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "މކ" : "މފ";
        },
        calendar: {
          sameDay: "[މިއަދު] LT",
          nextDay: "[މާދަމާ] LT",
          nextWeek: "dddd LT",
          lastDay: "[އިއްޔެ] LT",
          lastWeek: "[ފާއިތުވި] dddd LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "ތެރޭގައި %s",
          past: "ކުރިން %s",
          s: "ސިކުންތުކޮޅެއް",
          ss: "d% ސިކުންތު",
          m: "މިނިޓެއް",
          mm: "މިނިޓު %d",
          h: "ގަޑިއިރެއް",
          hh: "ގަޑިއިރު %d",
          d: "ދުވަހެއް",
          dd: "ދުވަސް %d",
          M: "މަހެއް",
          MM: "މަސް %d",
          y: "އަހަރެއް",
          yy: "އަހަރު %d"
        },
        preparse: function preparse(e) {
          return e.replace(/،/g, ",");
        },
        postformat: function postformat(e) {
          return e.replace(/,/g, "،");
        },
        week: {
          dow: 7,
          doy: 12
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("el", {
        monthsNominativeEl: "Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split("_"),
        monthsGenitiveEl: "Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),
        months: function months(e, t) {
          return e ? "string" == typeof t && /D/.test(t.substring(0, t.indexOf("MMMM"))) ? this._monthsGenitiveEl[e.month()] : this._monthsNominativeEl[e.month()] : this._monthsNominativeEl;
        },
        monthsShort: "Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),
        weekdays: "Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),
        weekdaysShort: "Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),
        weekdaysMin: "Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),
        meridiem: function meridiem(e, t, n) {
          return e > 11 ? n ? "μμ" : "ΜΜ" : n ? "πμ" : "ΠΜ";
        },
        isPM: function isPM(e) {
          return "μ" === (e + "").toLowerCase()[0];
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
          LT: "h:mm A",
          LTS: "h:mm:ss A",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY h:mm A",
          LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendarEl: {
          sameDay: "[Σήμερα {}] LT",
          nextDay: "[Αύριο {}] LT",
          nextWeek: "dddd [{}] LT",
          lastDay: "[Χθες {}] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 6:
                return "[το προηγούμενο] dddd [{}] LT";

              default:
                return "[την προηγούμενη] dddd [{}] LT";
            }
          },
          sameElse: "L"
        },
        calendar: function calendar(e, t) {
          var n,
              r = this._calendarEl[e],
              i = t && t.hours();
          return ((n = r) instanceof Function || "[object Function]" === Object.prototype.toString.call(n)) && (r = r.apply(t)), r.replace("{}", i % 12 == 1 ? "στη" : "στις");
        },
        relativeTime: {
          future: "σε %s",
          past: "%s πριν",
          s: "λίγα δευτερόλεπτα",
          ss: "%d δευτερόλεπτα",
          m: "ένα λεπτό",
          mm: "%d λεπτά",
          h: "μία ώρα",
          hh: "%d ώρες",
          d: "μία μέρα",
          dd: "%d μέρες",
          M: "ένας μήνας",
          MM: "%d μήνες",
          y: "ένας χρόνος",
          yy: "%d χρόνια"
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: "%dη",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("en-SG", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Today at] LT",
          nextDay: "[Tomorrow at] LT",
          nextWeek: "dddd [at] LT",
          lastDay: "[Yesterday at] LT",
          lastWeek: "[Last] dddd [at] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
          return e + n;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("en-au", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
          LT: "h:mm A",
          LTS: "h:mm:ss A",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY h:mm A",
          LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
          sameDay: "[Today at] LT",
          nextDay: "[Tomorrow at] LT",
          nextWeek: "dddd [at] LT",
          lastDay: "[Yesterday at] LT",
          lastWeek: "[Last] dddd [at] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
          return e + n;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("en-ca", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
          LT: "h:mm A",
          LTS: "h:mm:ss A",
          L: "YYYY-MM-DD",
          LL: "MMMM D, YYYY",
          LLL: "MMMM D, YYYY h:mm A",
          LLLL: "dddd, MMMM D, YYYY h:mm A"
        },
        calendar: {
          sameDay: "[Today at] LT",
          nextDay: "[Tomorrow at] LT",
          nextWeek: "dddd [at] LT",
          lastDay: "[Yesterday at] LT",
          lastWeek: "[Last] dddd [at] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
          return e + n;
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("en-gb", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Today at] LT",
          nextDay: "[Tomorrow at] LT",
          nextWeek: "dddd [at] LT",
          lastDay: "[Yesterday at] LT",
          lastWeek: "[Last] dddd [at] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
          return e + n;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("en-ie", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Today at] LT",
          nextDay: "[Tomorrow at] LT",
          nextWeek: "dddd [at] LT",
          lastDay: "[Yesterday at] LT",
          lastWeek: "[Last] dddd [at] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
          return e + n;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("en-il", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Today at] LT",
          nextDay: "[Tomorrow at] LT",
          nextWeek: "dddd [at] LT",
          lastDay: "[Yesterday at] LT",
          lastWeek: "[Last] dddd [at] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
          return e + n;
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("en-nz", {
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        longDateFormat: {
          LT: "h:mm A",
          LTS: "h:mm:ss A",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY h:mm A",
          LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
          sameDay: "[Today at] LT",
          nextDay: "[Tomorrow at] LT",
          nextWeek: "dddd [at] LT",
          lastDay: "[Yesterday at] LT",
          lastWeek: "[Last] dddd [at] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
          return e + n;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("eo", {
        months: "januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro".split("_"),
        monthsShort: "jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec".split("_"),
        weekdays: "dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato".split("_"),
        weekdaysShort: "dim_lun_mard_merk_ĵaŭ_ven_sab".split("_"),
        weekdaysMin: "di_lu_ma_me_ĵa_ve_sa".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY-MM-DD",
          LL: "D[-a de] MMMM, YYYY",
          LLL: "D[-a de] MMMM, YYYY HH:mm",
          LLLL: "dddd, [la] D[-a de] MMMM, YYYY HH:mm"
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function isPM(e) {
          return "p" === e.charAt(0).toLowerCase();
        },
        meridiem: function meridiem(e, t, n) {
          return e > 11 ? n ? "p.t.m." : "P.T.M." : n ? "a.t.m." : "A.T.M.";
        },
        calendar: {
          sameDay: "[Hodiaŭ je] LT",
          nextDay: "[Morgaŭ je] LT",
          nextWeek: "dddd [je] LT",
          lastDay: "[Hieraŭ je] LT",
          lastWeek: "[pasinta] dddd [je] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "post %s",
          past: "antaŭ %s",
          s: "sekundoj",
          ss: "%d sekundoj",
          m: "minuto",
          mm: "%d minutoj",
          h: "horo",
          hh: "%d horoj",
          d: "tago",
          dd: "%d tagoj",
          M: "monato",
          MM: "%d monatoj",
          y: "jaro",
          yy: "%d jaroj"
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: "%da",
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
          n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
          r = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
          i = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
      e.defineLocale("es", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function monthsShort(e, r) {
          return e ? /-MMM-/.test(r) ? n[e.month()] : t[e.month()] : t;
        },
        monthsRegex: i,
        monthsShortRegex: i,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: r,
        longMonthsParse: r,
        shortMonthsParse: r,
        weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
        weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D [de] MMMM [de] YYYY",
          LLL: "D [de] MMMM [de] YYYY H:mm",
          LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        calendar: {
          sameDay: function sameDay() {
            return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          nextDay: function nextDay() {
            return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          nextWeek: function nextWeek() {
            return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          lastDay: function lastDay() {
            return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          lastWeek: function lastWeek() {
            return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "en %s",
          past: "hace %s",
          s: "unos segundos",
          ss: "%d segundos",
          m: "un minuto",
          mm: "%d minutos",
          h: "una hora",
          hh: "%d horas",
          d: "un día",
          dd: "%d días",
          M: "un mes",
          MM: "%d meses",
          y: "un año",
          yy: "%d años"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
          n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
          r = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
          i = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
      e.defineLocale("es-do", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function monthsShort(e, r) {
          return e ? /-MMM-/.test(r) ? n[e.month()] : t[e.month()] : t;
        },
        monthsRegex: i,
        monthsShortRegex: i,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: r,
        longMonthsParse: r,
        shortMonthsParse: r,
        weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
        weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "h:mm A",
          LTS: "h:mm:ss A",
          L: "DD/MM/YYYY",
          LL: "D [de] MMMM [de] YYYY",
          LLL: "D [de] MMMM [de] YYYY h:mm A",
          LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
        },
        calendar: {
          sameDay: function sameDay() {
            return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          nextDay: function nextDay() {
            return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          nextWeek: function nextWeek() {
            return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          lastDay: function lastDay() {
            return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          lastWeek: function lastWeek() {
            return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "en %s",
          past: "hace %s",
          s: "unos segundos",
          ss: "%d segundos",
          m: "un minuto",
          mm: "%d minutos",
          h: "una hora",
          hh: "%d horas",
          d: "un día",
          dd: "%d días",
          M: "un mes",
          MM: "%d meses",
          y: "un año",
          yy: "%d años"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
          n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
          r = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
          i = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
      e.defineLocale("es-us", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: function monthsShort(e, r) {
          return e ? /-MMM-/.test(r) ? n[e.month()] : t[e.month()] : t;
        },
        monthsRegex: i,
        monthsShortRegex: i,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: r,
        longMonthsParse: r,
        shortMonthsParse: r,
        weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
        weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "h:mm A",
          LTS: "h:mm:ss A",
          L: "MM/DD/YYYY",
          LL: "D [de] MMMM [de] YYYY",
          LLL: "D [de] MMMM [de] YYYY h:mm A",
          LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
        },
        calendar: {
          sameDay: function sameDay() {
            return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          nextDay: function nextDay() {
            return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          nextWeek: function nextWeek() {
            return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          lastDay: function lastDay() {
            return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          lastWeek: function lastWeek() {
            return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "en %s",
          past: "hace %s",
          s: "unos segundos",
          ss: "%d segundos",
          m: "un minuto",
          mm: "%d minutos",
          h: "una hora",
          hh: "%d horas",
          d: "un día",
          dd: "%d días",
          M: "un mes",
          MM: "%d meses",
          y: "un año",
          yy: "%d años"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº",
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n, r) {
        var i = {
          s: ["mõne sekundi", "mõni sekund", "paar sekundit"],
          ss: [e + "sekundi", e + "sekundit"],
          m: ["ühe minuti", "üks minut"],
          mm: [e + " minuti", e + " minutit"],
          h: ["ühe tunni", "tund aega", "üks tund"],
          hh: [e + " tunni", e + " tundi"],
          d: ["ühe päeva", "üks päev"],
          M: ["kuu aja", "kuu aega", "üks kuu"],
          MM: [e + " kuu", e + " kuud"],
          y: ["ühe aasta", "aasta", "üks aasta"],
          yy: [e + " aasta", e + " aastat"]
        };
        return t ? i[n][2] ? i[n][2] : i[n][1] : r ? i[n][0] : i[n][1];
      }

      e.defineLocale("et", {
        months: "jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),
        monthsShort: "jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),
        weekdays: "pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev".split("_"),
        weekdaysShort: "P_E_T_K_N_R_L".split("_"),
        weekdaysMin: "P_E_T_K_N_R_L".split("_"),
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY H:mm",
          LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
          sameDay: "[Täna,] LT",
          nextDay: "[Homme,] LT",
          nextWeek: "[Järgmine] dddd LT",
          lastDay: "[Eile,] LT",
          lastWeek: "[Eelmine] dddd LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s pärast",
          past: "%s tagasi",
          s: t,
          ss: t,
          m: t,
          mm: t,
          h: t,
          hh: t,
          d: t,
          dd: "%d päeva",
          M: t,
          MM: t,
          y: t,
          yy: t
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("eu", {
        months: "urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),
        monthsShort: "urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),
        monthsParseExact: !0,
        weekdays: "igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),
        weekdaysShort: "ig._al._ar._az._og._ol._lr.".split("_"),
        weekdaysMin: "ig_al_ar_az_og_ol_lr".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY-MM-DD",
          LL: "YYYY[ko] MMMM[ren] D[a]",
          LLL: "YYYY[ko] MMMM[ren] D[a] HH:mm",
          LLLL: "dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",
          l: "YYYY-M-D",
          ll: "YYYY[ko] MMM D[a]",
          lll: "YYYY[ko] MMM D[a] HH:mm",
          llll: "ddd, YYYY[ko] MMM D[a] HH:mm"
        },
        calendar: {
          sameDay: "[gaur] LT[etan]",
          nextDay: "[bihar] LT[etan]",
          nextWeek: "dddd LT[etan]",
          lastDay: "[atzo] LT[etan]",
          lastWeek: "[aurreko] dddd LT[etan]",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s barru",
          past: "duela %s",
          s: "segundo batzuk",
          ss: "%d segundo",
          m: "minutu bat",
          mm: "%d minutu",
          h: "ordu bat",
          hh: "%d ordu",
          d: "egun bat",
          dd: "%d egun",
          M: "hilabete bat",
          MM: "%d hilabete",
          y: "urte bat",
          yy: "%d urte"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "۱",
        2: "۲",
        3: "۳",
        4: "۴",
        5: "۵",
        6: "۶",
        7: "۷",
        8: "۸",
        9: "۹",
        0: "۰"
      },
          n = {
        "۱": "1",
        "۲": "2",
        "۳": "3",
        "۴": "4",
        "۵": "5",
        "۶": "6",
        "۷": "7",
        "۸": "8",
        "۹": "9",
        "۰": "0"
      };
      e.defineLocale("fa", {
        months: "ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),
        monthsShort: "ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),
        weekdays: "یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),
        weekdaysShort: "یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),
        weekdaysMin: "ی_د_س_چ_پ_ج_ش".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function isPM(e) {
          return /بعد از ظهر/.test(e);
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "قبل از ظهر" : "بعد از ظهر";
        },
        calendar: {
          sameDay: "[امروز ساعت] LT",
          nextDay: "[فردا ساعت] LT",
          nextWeek: "dddd [ساعت] LT",
          lastDay: "[دیروز ساعت] LT",
          lastWeek: "dddd [پیش] [ساعت] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "در %s",
          past: "%s پیش",
          s: "چند ثانیه",
          ss: "ثانیه d%",
          m: "یک دقیقه",
          mm: "%d دقیقه",
          h: "یک ساعت",
          hh: "%d ساعت",
          d: "یک روز",
          dd: "%d روز",
          M: "یک ماه",
          MM: "%d ماه",
          y: "یک سال",
          yy: "%d سال"
        },
        preparse: function preparse(e) {
          return e.replace(/[۰-۹]/g, function (e) {
            return n[e];
          }).replace(/،/g, ",");
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          }).replace(/,/g, "،");
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: "%dم",
        week: {
          dow: 6,
          doy: 12
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän".split(" "),
          n = ["nolla", "yhden", "kahden", "kolmen", "neljän", "viiden", "kuuden", t[7], t[8], t[9]];

      function r(e, r, i, o) {
        var a = "";

        switch (i) {
          case "s":
            return o ? "muutaman sekunnin" : "muutama sekunti";

          case "ss":
            return o ? "sekunnin" : "sekuntia";

          case "m":
            return o ? "minuutin" : "minuutti";

          case "mm":
            a = o ? "minuutin" : "minuuttia";
            break;

          case "h":
            return o ? "tunnin" : "tunti";

          case "hh":
            a = o ? "tunnin" : "tuntia";
            break;

          case "d":
            return o ? "päivän" : "päivä";

          case "dd":
            a = o ? "päivän" : "päivää";
            break;

          case "M":
            return o ? "kuukauden" : "kuukausi";

          case "MM":
            a = o ? "kuukauden" : "kuukautta";
            break;

          case "y":
            return o ? "vuoden" : "vuosi";

          case "yy":
            a = o ? "vuoden" : "vuotta";
        }

        return a = function (e, r) {
          return e < 10 ? r ? n[e] : t[e] : e;
        }(e, o) + " " + a;
      }

      e.defineLocale("fi", {
        months: "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),
        monthsShort: "tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),
        weekdays: "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),
        weekdaysShort: "su_ma_ti_ke_to_pe_la".split("_"),
        weekdaysMin: "su_ma_ti_ke_to_pe_la".split("_"),
        longDateFormat: {
          LT: "HH.mm",
          LTS: "HH.mm.ss",
          L: "DD.MM.YYYY",
          LL: "Do MMMM[ta] YYYY",
          LLL: "Do MMMM[ta] YYYY, [klo] HH.mm",
          LLLL: "dddd, Do MMMM[ta] YYYY, [klo] HH.mm",
          l: "D.M.YYYY",
          ll: "Do MMM YYYY",
          lll: "Do MMM YYYY, [klo] HH.mm",
          llll: "ddd, Do MMM YYYY, [klo] HH.mm"
        },
        calendar: {
          sameDay: "[tänään] [klo] LT",
          nextDay: "[huomenna] [klo] LT",
          nextWeek: "dddd [klo] LT",
          lastDay: "[eilen] [klo] LT",
          lastWeek: "[viime] dddd[na] [klo] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s päästä",
          past: "%s sitten",
          s: r,
          ss: r,
          m: r,
          mm: r,
          h: r,
          hh: r,
          d: r,
          dd: r,
          M: r,
          MM: r,
          y: r,
          yy: r
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("fo", {
        months: "januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort: "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
        weekdays: "sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur".split("_"),
        weekdaysShort: "sun_mán_týs_mik_hós_frí_ley".split("_"),
        weekdaysMin: "su_má_tý_mi_hó_fr_le".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D. MMMM, YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Í dag kl.] LT",
          nextDay: "[Í morgin kl.] LT",
          nextWeek: "dddd [kl.] LT",
          lastDay: "[Í gjár kl.] LT",
          lastWeek: "[síðstu] dddd [kl] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "um %s",
          past: "%s síðani",
          s: "fá sekund",
          ss: "%d sekundir",
          m: "ein minuttur",
          mm: "%d minuttir",
          h: "ein tími",
          hh: "%d tímar",
          d: "ein dagur",
          dd: "%d dagar",
          M: "ein mánaður",
          MM: "%d mánaðir",
          y: "eitt ár",
          yy: "%d ár"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("fr", {
        months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
        monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
        monthsParseExact: !0,
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Aujourd’hui à] LT",
          nextDay: "[Demain à] LT",
          nextWeek: "dddd [à] LT",
          lastDay: "[Hier à] LT",
          lastWeek: "dddd [dernier à] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "dans %s",
          past: "il y a %s",
          s: "quelques secondes",
          ss: "%d secondes",
          m: "une minute",
          mm: "%d minutes",
          h: "une heure",
          hh: "%d heures",
          d: "un jour",
          dd: "%d jours",
          M: "un mois",
          MM: "%d mois",
          y: "un an",
          yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "D":
              return e + (1 === e ? "er" : "");

            default:
            case "M":
            case "Q":
            case "DDD":
            case "d":
              return e + (1 === e ? "er" : "e");

            case "w":
            case "W":
              return e + (1 === e ? "re" : "e");
          }
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("fr-ca", {
        months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
        monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
        monthsParseExact: !0,
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY-MM-DD",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Aujourd’hui à] LT",
          nextDay: "[Demain à] LT",
          nextWeek: "dddd [à] LT",
          lastDay: "[Hier à] LT",
          lastWeek: "dddd [dernier à] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "dans %s",
          past: "il y a %s",
          s: "quelques secondes",
          ss: "%d secondes",
          m: "une minute",
          mm: "%d minutes",
          h: "une heure",
          hh: "%d heures",
          d: "un jour",
          dd: "%d jours",
          M: "un mois",
          MM: "%d mois",
          y: "un an",
          yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            default:
            case "M":
            case "Q":
            case "D":
            case "DDD":
            case "d":
              return e + (1 === e ? "er" : "e");

            case "w":
            case "W":
              return e + (1 === e ? "re" : "e");
          }
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("fr-ch", {
        months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
        monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
        monthsParseExact: !0,
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Aujourd’hui à] LT",
          nextDay: "[Demain à] LT",
          nextWeek: "dddd [à] LT",
          lastDay: "[Hier à] LT",
          lastWeek: "dddd [dernier à] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "dans %s",
          past: "il y a %s",
          s: "quelques secondes",
          ss: "%d secondes",
          m: "une minute",
          mm: "%d minutes",
          h: "une heure",
          hh: "%d heures",
          d: "un jour",
          dd: "%d jours",
          M: "un mois",
          MM: "%d mois",
          y: "un an",
          yy: "%d ans"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            default:
            case "M":
            case "Q":
            case "D":
            case "DDD":
            case "d":
              return e + (1 === e ? "er" : "e");

            case "w":
            case "W":
              return e + (1 === e ? "re" : "e");
          }
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_"),
          n = "jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");
      e.defineLocale("fy", {
        months: "jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),
        monthsShort: function monthsShort(e, r) {
          return e ? /-MMM-/.test(r) ? n[e.month()] : t[e.month()] : t;
        },
        monthsParseExact: !0,
        weekdays: "snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),
        weekdaysShort: "si._mo._ti._wo._to._fr._so.".split("_"),
        weekdaysMin: "Si_Mo_Ti_Wo_To_Fr_So".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD-MM-YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[hjoed om] LT",
          nextDay: "[moarn om] LT",
          nextWeek: "dddd [om] LT",
          lastDay: "[juster om] LT",
          lastWeek: "[ôfrûne] dddd [om] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "oer %s",
          past: "%s lyn",
          s: "in pear sekonden",
          ss: "%d sekonden",
          m: "ien minút",
          mm: "%d minuten",
          h: "ien oere",
          hh: "%d oeren",
          d: "ien dei",
          dd: "%d dagen",
          M: "ien moanne",
          MM: "%d moannen",
          y: "ien jier",
          yy: "%d jierren"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(e) {
          return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ga", {
        months: ["Eanáir", "Feabhra", "Márta", "Aibreán", "Bealtaine", "Méitheamh", "Iúil", "Lúnasa", "Meán Fómhair", "Deaireadh Fómhair", "Samhain", "Nollaig"],
        monthsShort: ["Eaná", "Feab", "Márt", "Aibr", "Beal", "Méit", "Iúil", "Lúna", "Meán", "Deai", "Samh", "Noll"],
        monthsParseExact: !0,
        weekdays: ["Dé Domhnaigh", "Dé Luain", "Dé Máirt", "Dé Céadaoin", "Déardaoin", "Dé hAoine", "Dé Satharn"],
        weekdaysShort: ["Dom", "Lua", "Mái", "Céa", "Déa", "hAo", "Sat"],
        weekdaysMin: ["Do", "Lu", "Má", "Ce", "Dé", "hA", "Sa"],
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Inniu ag] LT",
          nextDay: "[Amárach ag] LT",
          nextWeek: "dddd [ag] LT",
          lastDay: "[Inné aig] LT",
          lastWeek: "dddd [seo caite] [ag] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "i %s",
          past: "%s ó shin",
          s: "cúpla soicind",
          ss: "%d soicind",
          m: "nóiméad",
          mm: "%d nóiméad",
          h: "uair an chloig",
          hh: "%d uair an chloig",
          d: "lá",
          dd: "%d lá",
          M: "mí",
          MM: "%d mí",
          y: "bliain",
          yy: "%d bliain"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function ordinal(e) {
          var t = 1 === e ? "d" : e % 10 == 2 ? "na" : "mh";
          return e + t;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("gd", {
        months: ["Am Faoilleach", "An Gearran", "Am Màrt", "An Giblean", "An Cèitean", "An t-Ògmhios", "An t-Iuchar", "An Lùnastal", "An t-Sultain", "An Dàmhair", "An t-Samhain", "An Dùbhlachd"],
        monthsShort: ["Faoi", "Gear", "Màrt", "Gibl", "Cèit", "Ògmh", "Iuch", "Lùn", "Sult", "Dàmh", "Samh", "Dùbh"],
        monthsParseExact: !0,
        weekdays: ["Didòmhnaich", "Diluain", "Dimàirt", "Diciadain", "Diardaoin", "Dihaoine", "Disathairne"],
        weekdaysShort: ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
        weekdaysMin: ["Dò", "Lu", "Mà", "Ci", "Ar", "Ha", "Sa"],
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[An-diugh aig] LT",
          nextDay: "[A-màireach aig] LT",
          nextWeek: "dddd [aig] LT",
          lastDay: "[An-dè aig] LT",
          lastWeek: "dddd [seo chaidh] [aig] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "ann an %s",
          past: "bho chionn %s",
          s: "beagan diogan",
          ss: "%d diogan",
          m: "mionaid",
          mm: "%d mionaidean",
          h: "uair",
          hh: "%d uairean",
          d: "latha",
          dd: "%d latha",
          M: "mìos",
          MM: "%d mìosan",
          y: "bliadhna",
          yy: "%d bliadhna"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function ordinal(e) {
          var t = 1 === e ? "d" : e % 10 == 2 ? "na" : "mh";
          return e + t;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("gl", {
        months: "xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),
        monthsShort: "xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "domingo_luns_martes_mércores_xoves_venres_sábado".split("_"),
        weekdaysShort: "dom._lun._mar._mér._xov._ven._sáb.".split("_"),
        weekdaysMin: "do_lu_ma_mé_xo_ve_sá".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D [de] MMMM [de] YYYY",
          LLL: "D [de] MMMM [de] YYYY H:mm",
          LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        calendar: {
          sameDay: function sameDay() {
            return "[hoxe " + (1 !== this.hours() ? "ás" : "á") + "] LT";
          },
          nextDay: function nextDay() {
            return "[mañá " + (1 !== this.hours() ? "ás" : "á") + "] LT";
          },
          nextWeek: function nextWeek() {
            return "dddd [" + (1 !== this.hours() ? "ás" : "a") + "] LT";
          },
          lastDay: function lastDay() {
            return "[onte " + (1 !== this.hours() ? "á" : "a") + "] LT";
          },
          lastWeek: function lastWeek() {
            return "[o] dddd [pasado " + (1 !== this.hours() ? "ás" : "a") + "] LT";
          },
          sameElse: "L"
        },
        relativeTime: {
          future: function future(e) {
            return 0 === e.indexOf("un") ? "n" + e : "en " + e;
          },
          past: "hai %s",
          s: "uns segundos",
          ss: "%d segundos",
          m: "un minuto",
          mm: "%d minutos",
          h: "unha hora",
          hh: "%d horas",
          d: "un día",
          dd: "%d días",
          M: "un mes",
          MM: "%d meses",
          y: "un ano",
          yy: "%d anos"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n, r) {
        var i = {
          s: ["thodde secondanim", "thodde second"],
          ss: [e + " secondanim", e + " second"],
          m: ["eka mintan", "ek minute"],
          mm: [e + " mintanim", e + " mintam"],
          h: ["eka voran", "ek vor"],
          hh: [e + " voranim", e + " voram"],
          d: ["eka disan", "ek dis"],
          dd: [e + " disanim", e + " dis"],
          M: ["eka mhoinean", "ek mhoino"],
          MM: [e + " mhoineanim", e + " mhoine"],
          y: ["eka vorsan", "ek voros"],
          yy: [e + " vorsanim", e + " vorsam"]
        };
        return t ? i[n][0] : i[n][1];
      }

      e.defineLocale("gom-latn", {
        months: "Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),
        monthsShort: "Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),
        monthsParseExact: !0,
        weekdays: "Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son'var".split("_"),
        weekdaysShort: "Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),
        weekdaysMin: "Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "A h:mm [vazta]",
          LTS: "A h:mm:ss [vazta]",
          L: "DD-MM-YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY A h:mm [vazta]",
          LLLL: "dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]",
          llll: "ddd, D MMM YYYY, A h:mm [vazta]"
        },
        calendar: {
          sameDay: "[Aiz] LT",
          nextDay: "[Faleam] LT",
          nextWeek: "[Ieta to] dddd[,] LT",
          lastDay: "[Kal] LT",
          lastWeek: "[Fatlo] dddd[,] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s",
          past: "%s adim",
          s: t,
          ss: t,
          m: t,
          mm: t,
          h: t,
          hh: t,
          d: t,
          dd: t,
          M: t,
          MM: t,
          y: t,
          yy: t
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "D":
              return e + "er";

            default:
            case "M":
            case "Q":
            case "DDD":
            case "d":
            case "w":
            case "W":
              return e;
          }
        },
        week: {
          dow: 1,
          doy: 4
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "rati" === t ? e < 4 ? e : e + 12 : "sokalli" === t ? e : "donparam" === t ? e > 12 ? e : e + 12 : "sanje" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "rati" : e < 12 ? "sokalli" : e < 16 ? "donparam" : e < 20 ? "sanje" : "rati";
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "૧",
        2: "૨",
        3: "૩",
        4: "૪",
        5: "૫",
        6: "૬",
        7: "૭",
        8: "૮",
        9: "૯",
        0: "૦"
      },
          n = {
        "૧": "1",
        "૨": "2",
        "૩": "3",
        "૪": "4",
        "૫": "5",
        "૬": "6",
        "૭": "7",
        "૮": "8",
        "૯": "9",
        "૦": "0"
      };
      e.defineLocale("gu", {
        months: "જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર".split("_"),
        monthsShort: "જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.".split("_"),
        monthsParseExact: !0,
        weekdays: "રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર".split("_"),
        weekdaysShort: "રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ".split("_"),
        weekdaysMin: "ર_સો_મં_બુ_ગુ_શુ_શ".split("_"),
        longDateFormat: {
          LT: "A h:mm વાગ્યે",
          LTS: "A h:mm:ss વાગ્યે",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY, A h:mm વાગ્યે",
          LLLL: "dddd, D MMMM YYYY, A h:mm વાગ્યે"
        },
        calendar: {
          sameDay: "[આજ] LT",
          nextDay: "[કાલે] LT",
          nextWeek: "dddd, LT",
          lastDay: "[ગઇકાલે] LT",
          lastWeek: "[પાછલા] dddd, LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s મા",
          past: "%s પેહલા",
          s: "અમુક પળો",
          ss: "%d સેકંડ",
          m: "એક મિનિટ",
          mm: "%d મિનિટ",
          h: "એક કલાક",
          hh: "%d કલાક",
          d: "એક દિવસ",
          dd: "%d દિવસ",
          M: "એક મહિનો",
          MM: "%d મહિનો",
          y: "એક વર્ષ",
          yy: "%d વર્ષ"
        },
        preparse: function preparse(e) {
          return e.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (e) {
            return n[e];
          });
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          });
        },
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "રાત" === t ? e < 4 ? e : e + 12 : "સવાર" === t ? e : "બપોર" === t ? e >= 10 ? e : e + 12 : "સાંજ" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "રાત" : e < 10 ? "સવાર" : e < 17 ? "બપોર" : e < 20 ? "સાંજ" : "રાત";
        },
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("he", {
        months: "ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),
        monthsShort: "ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),
        weekdays: "ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),
        weekdaysShort: "א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),
        weekdaysMin: "א_ב_ג_ד_ה_ו_ש".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D [ב]MMMM YYYY",
          LLL: "D [ב]MMMM YYYY HH:mm",
          LLLL: "dddd, D [ב]MMMM YYYY HH:mm",
          l: "D/M/YYYY",
          ll: "D MMM YYYY",
          lll: "D MMM YYYY HH:mm",
          llll: "ddd, D MMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[היום ב־]LT",
          nextDay: "[מחר ב־]LT",
          nextWeek: "dddd [בשעה] LT",
          lastDay: "[אתמול ב־]LT",
          lastWeek: "[ביום] dddd [האחרון בשעה] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "בעוד %s",
          past: "לפני %s",
          s: "מספר שניות",
          ss: "%d שניות",
          m: "דקה",
          mm: "%d דקות",
          h: "שעה",
          hh: function hh(e) {
            return 2 === e ? "שעתיים" : e + " שעות";
          },
          d: "יום",
          dd: function dd(e) {
            return 2 === e ? "יומיים" : e + " ימים";
          },
          M: "חודש",
          MM: function MM(e) {
            return 2 === e ? "חודשיים" : e + " חודשים";
          },
          y: "שנה",
          yy: function yy(e) {
            return 2 === e ? "שנתיים" : e % 10 == 0 && 10 !== e ? e + " שנה" : e + " שנים";
          }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function isPM(e) {
          return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(e);
        },
        meridiem: function meridiem(e, t, n) {
          return e < 5 ? "לפנות בוקר" : e < 10 ? "בבוקר" : e < 12 ? n ? 'לפנה"צ' : "לפני הצהריים" : e < 18 ? n ? 'אחה"צ' : "אחרי הצהריים" : "בערב";
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "१",
        2: "२",
        3: "३",
        4: "४",
        5: "५",
        6: "६",
        7: "७",
        8: "८",
        9: "९",
        0: "०"
      },
          n = {
        "१": "1",
        "२": "2",
        "३": "3",
        "४": "4",
        "५": "5",
        "६": "6",
        "७": "7",
        "८": "8",
        "९": "9",
        "०": "0"
      };
      e.defineLocale("hi", {
        months: "जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर".split("_"),
        monthsShort: "जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.".split("_"),
        monthsParseExact: !0,
        weekdays: "रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),
        weekdaysShort: "रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि".split("_"),
        weekdaysMin: "र_सो_मं_बु_गु_शु_श".split("_"),
        longDateFormat: {
          LT: "A h:mm बजे",
          LTS: "A h:mm:ss बजे",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY, A h:mm बजे",
          LLLL: "dddd, D MMMM YYYY, A h:mm बजे"
        },
        calendar: {
          sameDay: "[आज] LT",
          nextDay: "[कल] LT",
          nextWeek: "dddd, LT",
          lastDay: "[कल] LT",
          lastWeek: "[पिछले] dddd, LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s में",
          past: "%s पहले",
          s: "कुछ ही क्षण",
          ss: "%d सेकंड",
          m: "एक मिनट",
          mm: "%d मिनट",
          h: "एक घंटा",
          hh: "%d घंटे",
          d: "एक दिन",
          dd: "%d दिन",
          M: "एक महीने",
          MM: "%d महीने",
          y: "एक वर्ष",
          yy: "%d वर्ष"
        },
        preparse: function preparse(e) {
          return e.replace(/[१२३४५६७८९०]/g, function (e) {
            return n[e];
          });
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          });
        },
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "रात" === t ? e < 4 ? e : e + 12 : "सुबह" === t ? e : "दोपहर" === t ? e >= 10 ? e : e + 12 : "शाम" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "रात" : e < 10 ? "सुबह" : e < 17 ? "दोपहर" : e < 20 ? "शाम" : "रात";
        },
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n) {
        var r = e + " ";

        switch (n) {
          case "ss":
            return r += 1 === e ? "sekunda" : 2 === e || 3 === e || 4 === e ? "sekunde" : "sekundi";

          case "m":
            return t ? "jedna minuta" : "jedne minute";

          case "mm":
            return r += 1 === e ? "minuta" : 2 === e || 3 === e || 4 === e ? "minute" : "minuta";

          case "h":
            return t ? "jedan sat" : "jednog sata";

          case "hh":
            return r += 1 === e ? "sat" : 2 === e || 3 === e || 4 === e ? "sata" : "sati";

          case "dd":
            return r += 1 === e ? "dan" : "dana";

          case "MM":
            return r += 1 === e ? "mjesec" : 2 === e || 3 === e || 4 === e ? "mjeseca" : "mjeseci";

          case "yy":
            return r += 1 === e ? "godina" : 2 === e || 3 === e || 4 === e ? "godine" : "godina";
        }
      }

      e.defineLocale("hr", {
        months: {
          format: "siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),
          standalone: "siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")
        },
        monthsShort: "sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),
        monthsParseExact: !0,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY H:mm",
          LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
          sameDay: "[danas u] LT",
          nextDay: "[sutra u] LT",
          nextWeek: function nextWeek() {
            switch (this.day()) {
              case 0:
                return "[u] [nedjelju] [u] LT";

              case 3:
                return "[u] [srijedu] [u] LT";

              case 6:
                return "[u] [subotu] [u] LT";

              case 1:
              case 2:
              case 4:
              case 5:
                return "[u] dddd [u] LT";
            }
          },
          lastDay: "[jučer u] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
              case 3:
                return "[prošlu] dddd [u] LT";

              case 6:
                return "[prošle] [subote] [u] LT";

              case 1:
              case 2:
              case 4:
              case 5:
                return "[prošli] dddd [u] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "za %s",
          past: "prije %s",
          s: "par sekundi",
          ss: t,
          m: t,
          mm: t,
          h: t,
          hh: t,
          d: "dan",
          dd: t,
          M: "mjesec",
          MM: t,
          y: "godinu",
          yy: t
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton".split(" ");

      function n(e, t, n, r) {
        var i = e;

        switch (n) {
          case "s":
            return r || t ? "néhány másodperc" : "néhány másodperce";

          case "ss":
            return i + (r || t) ? " másodperc" : " másodperce";

          case "m":
            return "egy" + (r || t ? " perc" : " perce");

          case "mm":
            return i + (r || t ? " perc" : " perce");

          case "h":
            return "egy" + (r || t ? " óra" : " órája");

          case "hh":
            return i + (r || t ? " óra" : " órája");

          case "d":
            return "egy" + (r || t ? " nap" : " napja");

          case "dd":
            return i + (r || t ? " nap" : " napja");

          case "M":
            return "egy" + (r || t ? " hónap" : " hónapja");

          case "MM":
            return i + (r || t ? " hónap" : " hónapja");

          case "y":
            return "egy" + (r || t ? " év" : " éve");

          case "yy":
            return i + (r || t ? " év" : " éve");
        }

        return "";
      }

      function r(e) {
        return (e ? "" : "[múlt] ") + "[" + t[this.day()] + "] LT[-kor]";
      }

      e.defineLocale("hu", {
        months: "január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),
        monthsShort: "jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec".split("_"),
        weekdays: "vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),
        weekdaysShort: "vas_hét_kedd_sze_csüt_pén_szo".split("_"),
        weekdaysMin: "v_h_k_sze_cs_p_szo".split("_"),
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "YYYY.MM.DD.",
          LL: "YYYY. MMMM D.",
          LLL: "YYYY. MMMM D. H:mm",
          LLLL: "YYYY. MMMM D., dddd H:mm"
        },
        meridiemParse: /de|du/i,
        isPM: function isPM(e) {
          return "u" === e.charAt(1).toLowerCase();
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? !0 === n ? "de" : "DE" : !0 === n ? "du" : "DU";
        },
        calendar: {
          sameDay: "[ma] LT[-kor]",
          nextDay: "[holnap] LT[-kor]",
          nextWeek: function nextWeek() {
            return r.call(this, !0);
          },
          lastDay: "[tegnap] LT[-kor]",
          lastWeek: function lastWeek() {
            return r.call(this, !1);
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "%s múlva",
          past: "%s",
          s: n,
          ss: n,
          m: n,
          mm: n,
          h: n,
          hh: n,
          d: n,
          dd: n,
          M: n,
          MM: n,
          y: n,
          yy: n
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("hy-am", {
        months: {
          format: "հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի".split("_"),
          standalone: "հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր".split("_")
        },
        monthsShort: "հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ".split("_"),
        weekdays: "կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ".split("_"),
        weekdaysShort: "կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),
        weekdaysMin: "կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY թ.",
          LLL: "D MMMM YYYY թ., HH:mm",
          LLLL: "dddd, D MMMM YYYY թ., HH:mm"
        },
        calendar: {
          sameDay: "[այսօր] LT",
          nextDay: "[վաղը] LT",
          lastDay: "[երեկ] LT",
          nextWeek: function nextWeek() {
            return "dddd [օրը ժամը] LT";
          },
          lastWeek: function lastWeek() {
            return "[անցած] dddd [օրը ժամը] LT";
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "%s հետո",
          past: "%s առաջ",
          s: "մի քանի վայրկյան",
          ss: "%d վայրկյան",
          m: "րոպե",
          mm: "%d րոպե",
          h: "ժամ",
          hh: "%d ժամ",
          d: "օր",
          dd: "%d օր",
          M: "ամիս",
          MM: "%d ամիս",
          y: "տարի",
          yy: "%d տարի"
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function isPM(e) {
          return /^(ցերեկվա|երեկոյան)$/.test(e);
        },
        meridiem: function meridiem(e) {
          return e < 4 ? "գիշերվա" : e < 12 ? "առավոտվա" : e < 17 ? "ցերեկվա" : "երեկոյան";
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "DDD":
            case "w":
            case "W":
            case "DDDo":
              return 1 === e ? e + "-ին" : e + "-րդ";

            default:
              return e;
          }
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("id", {
        months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),
        weekdays: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
        weekdaysShort: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
        weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
        longDateFormat: {
          LT: "HH.mm",
          LTS: "HH.mm.ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY [pukul] HH.mm",
          LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "pagi" === t ? e : "siang" === t ? e >= 11 ? e : e + 12 : "sore" === t || "malam" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 11 ? "pagi" : e < 15 ? "siang" : e < 19 ? "sore" : "malam";
        },
        calendar: {
          sameDay: "[Hari ini pukul] LT",
          nextDay: "[Besok pukul] LT",
          nextWeek: "dddd [pukul] LT",
          lastDay: "[Kemarin pukul] LT",
          lastWeek: "dddd [lalu pukul] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "dalam %s",
          past: "%s yang lalu",
          s: "beberapa detik",
          ss: "%d detik",
          m: "semenit",
          mm: "%d menit",
          h: "sejam",
          hh: "%d jam",
          d: "sehari",
          dd: "%d hari",
          M: "sebulan",
          MM: "%d bulan",
          y: "setahun",
          yy: "%d tahun"
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e) {
        return e % 100 == 11 || e % 10 != 1;
      }

      function n(e, n, r, i) {
        var o = e + " ";

        switch (r) {
          case "s":
            return n || i ? "nokkrar sekúndur" : "nokkrum sekúndum";

          case "ss":
            return t(e) ? o + (n || i ? "sekúndur" : "sekúndum") : o + "sekúnda";

          case "m":
            return n ? "mínúta" : "mínútu";

          case "mm":
            return t(e) ? o + (n || i ? "mínútur" : "mínútum") : n ? o + "mínúta" : o + "mínútu";

          case "hh":
            return t(e) ? o + (n || i ? "klukkustundir" : "klukkustundum") : o + "klukkustund";

          case "d":
            return n ? "dagur" : i ? "dag" : "degi";

          case "dd":
            return t(e) ? n ? o + "dagar" : o + (i ? "daga" : "dögum") : n ? o + "dagur" : o + (i ? "dag" : "degi");

          case "M":
            return n ? "mánuður" : i ? "mánuð" : "mánuði";

          case "MM":
            return t(e) ? n ? o + "mánuðir" : o + (i ? "mánuði" : "mánuðum") : n ? o + "mánuður" : o + (i ? "mánuð" : "mánuði");

          case "y":
            return n || i ? "ár" : "ári";

          case "yy":
            return t(e) ? o + (n || i ? "ár" : "árum") : o + (n || i ? "ár" : "ári");
        }
      }

      e.defineLocale("is", {
        months: "janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),
        monthsShort: "jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),
        weekdays: "sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),
        weekdaysShort: "sun_mán_þri_mið_fim_fös_lau".split("_"),
        weekdaysMin: "Su_Má_Þr_Mi_Fi_Fö_La".split("_"),
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY [kl.] H:mm",
          LLLL: "dddd, D. MMMM YYYY [kl.] H:mm"
        },
        calendar: {
          sameDay: "[í dag kl.] LT",
          nextDay: "[á morgun kl.] LT",
          nextWeek: "dddd [kl.] LT",
          lastDay: "[í gær kl.] LT",
          lastWeek: "[síðasta] dddd [kl.] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "eftir %s",
          past: "fyrir %s síðan",
          s: n,
          ss: n,
          m: n,
          mm: n,
          h: "klukkustund",
          hh: n,
          d: n,
          dd: n,
          M: n,
          MM: n,
          y: n,
          yy: n
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("it", {
        months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
        monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
        weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
        weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
        weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Oggi alle] LT",
          nextDay: "[Domani alle] LT",
          nextWeek: "dddd [alle] LT",
          lastDay: "[Ieri alle] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
                return "[la scorsa] dddd [alle] LT";

              default:
                return "[lo scorso] dddd [alle] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: function future(e) {
            return (/^[0-9].+$/.test(e) ? "tra" : "in") + " " + e;
          },
          past: "%s fa",
          s: "alcuni secondi",
          ss: "%d secondi",
          m: "un minuto",
          mm: "%d minuti",
          h: "un'ora",
          hh: "%d ore",
          d: "un giorno",
          dd: "%d giorni",
          M: "un mese",
          MM: "%d mesi",
          y: "un anno",
          yy: "%d anni"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("it-ch", {
        months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
        monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
        weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
        weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
        weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Oggi alle] LT",
          nextDay: "[Domani alle] LT",
          nextWeek: "dddd [alle] LT",
          lastDay: "[Ieri alle] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
                return "[la scorsa] dddd [alle] LT";

              default:
                return "[lo scorso] dddd [alle] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: function future(e) {
            return (/^[0-9].+$/.test(e) ? "tra" : "in") + " " + e;
          },
          past: "%s fa",
          s: "alcuni secondi",
          ss: "%d secondi",
          m: "un minuto",
          mm: "%d minuti",
          h: "un'ora",
          hh: "%d ore",
          d: "un giorno",
          dd: "%d giorni",
          M: "un mese",
          MM: "%d mesi",
          y: "un anno",
          yy: "%d anni"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ja", {
        months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
        monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),
        weekdaysShort: "日_月_火_水_木_金_土".split("_"),
        weekdaysMin: "日_月_火_水_木_金_土".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY/MM/DD",
          LL: "YYYY年M月D日",
          LLL: "YYYY年M月D日 HH:mm",
          LLLL: "YYYY年M月D日 dddd HH:mm",
          l: "YYYY/MM/DD",
          ll: "YYYY年M月D日",
          lll: "YYYY年M月D日 HH:mm",
          llll: "YYYY年M月D日(ddd) HH:mm"
        },
        meridiemParse: /午前|午後/i,
        isPM: function isPM(e) {
          return "午後" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "午前" : "午後";
        },
        calendar: {
          sameDay: "[今日] LT",
          nextDay: "[明日] LT",
          nextWeek: function nextWeek(e) {
            return e.week() < this.week() ? "[来週]dddd LT" : "dddd LT";
          },
          lastDay: "[昨日] LT",
          lastWeek: function lastWeek(e) {
            return this.week() < e.week() ? "[先週]dddd LT" : "dddd LT";
          },
          sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "d":
            case "D":
            case "DDD":
              return e + "日";

            default:
              return e;
          }
        },
        relativeTime: {
          future: "%s後",
          past: "%s前",
          s: "数秒",
          ss: "%d秒",
          m: "1分",
          mm: "%d分",
          h: "1時間",
          hh: "%d時間",
          d: "1日",
          dd: "%d日",
          M: "1ヶ月",
          MM: "%dヶ月",
          y: "1年",
          yy: "%d年"
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("jv", {
        months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),
        weekdays: "Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),
        weekdaysShort: "Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),
        weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),
        longDateFormat: {
          LT: "HH.mm",
          LTS: "HH.mm.ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY [pukul] HH.mm",
          LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "enjing" === t ? e : "siyang" === t ? e >= 11 ? e : e + 12 : "sonten" === t || "ndalu" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 11 ? "enjing" : e < 15 ? "siyang" : e < 19 ? "sonten" : "ndalu";
        },
        calendar: {
          sameDay: "[Dinten puniko pukul] LT",
          nextDay: "[Mbenjang pukul] LT",
          nextWeek: "dddd [pukul] LT",
          lastDay: "[Kala wingi pukul] LT",
          lastWeek: "dddd [kepengker pukul] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "wonten ing %s",
          past: "%s ingkang kepengker",
          s: "sawetawis detik",
          ss: "%d detik",
          m: "setunggal menit",
          mm: "%d menit",
          h: "setunggal jam",
          hh: "%d jam",
          d: "sedinten",
          dd: "%d dinten",
          M: "sewulan",
          MM: "%d wulan",
          y: "setaun",
          yy: "%d taun"
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ka", {
        months: {
          standalone: "იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი".split("_"),
          format: "იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს".split("_")
        },
        monthsShort: "იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),
        weekdays: {
          standalone: "კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი".split("_"),
          format: "კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს".split("_"),
          isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort: "კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),
        weekdaysMin: "კვ_ორ_სა_ოთ_ხუ_პა_შა".split("_"),
        longDateFormat: {
          LT: "h:mm A",
          LTS: "h:mm:ss A",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY h:mm A",
          LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
          sameDay: "[დღეს] LT[-ზე]",
          nextDay: "[ხვალ] LT[-ზე]",
          lastDay: "[გუშინ] LT[-ზე]",
          nextWeek: "[შემდეგ] dddd LT[-ზე]",
          lastWeek: "[წინა] dddd LT-ზე",
          sameElse: "L"
        },
        relativeTime: {
          future: function future(e) {
            return /(წამი|წუთი|საათი|წელი)/.test(e) ? e.replace(/ი$/, "ში") : e + "ში";
          },
          past: function past(e) {
            return /(წამი|წუთი|საათი|დღე|თვე)/.test(e) ? e.replace(/(ი|ე)$/, "ის წინ") : /წელი/.test(e) ? e.replace(/წელი$/, "წლის წინ") : void 0;
          },
          s: "რამდენიმე წამი",
          ss: "%d წამი",
          m: "წუთი",
          mm: "%d წუთი",
          h: "საათი",
          hh: "%d საათი",
          d: "დღე",
          dd: "%d დღე",
          M: "თვე",
          MM: "%d თვე",
          y: "წელი",
          yy: "%d წელი"
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function ordinal(e) {
          return 0 === e ? e : 1 === e ? e + "-ლი" : e < 20 || e <= 100 && e % 20 == 0 || e % 100 == 0 ? "მე-" + e : e + "-ე";
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        0: "-ші",
        1: "-ші",
        2: "-ші",
        3: "-ші",
        4: "-ші",
        5: "-ші",
        6: "-шы",
        7: "-ші",
        8: "-ші",
        9: "-шы",
        10: "-шы",
        20: "-шы",
        30: "-шы",
        40: "-шы",
        50: "-ші",
        60: "-шы",
        70: "-ші",
        80: "-ші",
        90: "-шы",
        100: "-ші"
      };
      e.defineLocale("kk", {
        months: "қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан".split("_"),
        monthsShort: "қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел".split("_"),
        weekdays: "жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі".split("_"),
        weekdaysShort: "жек_дүй_сей_сәр_бей_жұм_сен".split("_"),
        weekdaysMin: "жк_дй_сй_ср_бй_жм_сн".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Бүгін сағат] LT",
          nextDay: "[Ертең сағат] LT",
          nextWeek: "dddd [сағат] LT",
          lastDay: "[Кеше сағат] LT",
          lastWeek: "[Өткен аптаның] dddd [сағат] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s ішінде",
          past: "%s бұрын",
          s: "бірнеше секунд",
          ss: "%d секунд",
          m: "бір минут",
          mm: "%d минут",
          h: "бір сағат",
          hh: "%d сағат",
          d: "бір күн",
          dd: "%d күн",
          M: "бір ай",
          MM: "%d ай",
          y: "бір жыл",
          yy: "%d жыл"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function ordinal(e) {
          var n = e % 10,
              r = e >= 100 ? 100 : null;
          return e + (t[e] || t[n] || t[r]);
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "១",
        2: "២",
        3: "៣",
        4: "៤",
        5: "៥",
        6: "៦",
        7: "៧",
        8: "៨",
        9: "៩",
        0: "០"
      },
          n = {
        "១": "1",
        "២": "2",
        "៣": "3",
        "៤": "4",
        "៥": "5",
        "៦": "6",
        "៧": "7",
        "៨": "8",
        "៩": "9",
        "០": "0"
      };
      e.defineLocale("km", {
        months: "មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
        monthsShort: "មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
        weekdays: "អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),
        weekdaysShort: "អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),
        weekdaysMin: "អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function isPM(e) {
          return "ល្ងាច" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "ព្រឹក" : "ល្ងាច";
        },
        calendar: {
          sameDay: "[ថ្ងៃនេះ ម៉ោង] LT",
          nextDay: "[ស្អែក ម៉ោង] LT",
          nextWeek: "dddd [ម៉ោង] LT",
          lastDay: "[ម្សិលមិញ ម៉ោង] LT",
          lastWeek: "dddd [សប្តាហ៍មុន] [ម៉ោង] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%sទៀត",
          past: "%sមុន",
          s: "ប៉ុន្មានវិនាទី",
          ss: "%d វិនាទី",
          m: "មួយនាទី",
          mm: "%d នាទី",
          h: "មួយម៉ោង",
          hh: "%d ម៉ោង",
          d: "មួយថ្ងៃ",
          dd: "%d ថ្ងៃ",
          M: "មួយខែ",
          MM: "%d ខែ",
          y: "មួយឆ្នាំ",
          yy: "%d ឆ្នាំ"
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: "ទី%d",
        preparse: function preparse(e) {
          return e.replace(/[១២៣៤៥៦៧៨៩០]/g, function (e) {
            return n[e];
          });
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          });
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "೧",
        2: "೨",
        3: "೩",
        4: "೪",
        5: "೫",
        6: "೬",
        7: "೭",
        8: "೮",
        9: "೯",
        0: "೦"
      },
          n = {
        "೧": "1",
        "೨": "2",
        "೩": "3",
        "೪": "4",
        "೫": "5",
        "೬": "6",
        "೭": "7",
        "೮": "8",
        "೯": "9",
        "೦": "0"
      };
      e.defineLocale("kn", {
        months: "ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್".split("_"),
        monthsShort: "ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ".split("_"),
        monthsParseExact: !0,
        weekdays: "ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ".split("_"),
        weekdaysShort: "ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ".split("_"),
        weekdaysMin: "ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ".split("_"),
        longDateFormat: {
          LT: "A h:mm",
          LTS: "A h:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY, A h:mm",
          LLLL: "dddd, D MMMM YYYY, A h:mm"
        },
        calendar: {
          sameDay: "[ಇಂದು] LT",
          nextDay: "[ನಾಳೆ] LT",
          nextWeek: "dddd, LT",
          lastDay: "[ನಿನ್ನೆ] LT",
          lastWeek: "[ಕೊನೆಯ] dddd, LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s ನಂತರ",
          past: "%s ಹಿಂದೆ",
          s: "ಕೆಲವು ಕ್ಷಣಗಳು",
          ss: "%d ಸೆಕೆಂಡುಗಳು",
          m: "ಒಂದು ನಿಮಿಷ",
          mm: "%d ನಿಮಿಷ",
          h: "ಒಂದು ಗಂಟೆ",
          hh: "%d ಗಂಟೆ",
          d: "ಒಂದು ದಿನ",
          dd: "%d ದಿನ",
          M: "ಒಂದು ತಿಂಗಳು",
          MM: "%d ತಿಂಗಳು",
          y: "ಒಂದು ವರ್ಷ",
          yy: "%d ವರ್ಷ"
        },
        preparse: function preparse(e) {
          return e.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (e) {
            return n[e];
          });
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "ರಾತ್ರಿ" === t ? e < 4 ? e : e + 12 : "ಬೆಳಿಗ್ಗೆ" === t ? e : "ಮಧ್ಯಾಹ್ನ" === t ? e >= 10 ? e : e + 12 : "ಸಂಜೆ" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "ರಾತ್ರಿ" : e < 10 ? "ಬೆಳಿಗ್ಗೆ" : e < 17 ? "ಮಧ್ಯಾಹ್ನ" : e < 20 ? "ಸಂಜೆ" : "ರಾತ್ರಿ";
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function ordinal(e) {
          return e + "ನೇ";
        },
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ko", {
        months: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),
        monthsShort: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),
        weekdays: "일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),
        weekdaysShort: "일_월_화_수_목_금_토".split("_"),
        weekdaysMin: "일_월_화_수_목_금_토".split("_"),
        longDateFormat: {
          LT: "A h:mm",
          LTS: "A h:mm:ss",
          L: "YYYY.MM.DD.",
          LL: "YYYY년 MMMM D일",
          LLL: "YYYY년 MMMM D일 A h:mm",
          LLLL: "YYYY년 MMMM D일 dddd A h:mm",
          l: "YYYY.MM.DD.",
          ll: "YYYY년 MMMM D일",
          lll: "YYYY년 MMMM D일 A h:mm",
          llll: "YYYY년 MMMM D일 dddd A h:mm"
        },
        calendar: {
          sameDay: "오늘 LT",
          nextDay: "내일 LT",
          nextWeek: "dddd LT",
          lastDay: "어제 LT",
          lastWeek: "지난주 dddd LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s 후",
          past: "%s 전",
          s: "몇 초",
          ss: "%d초",
          m: "1분",
          mm: "%d분",
          h: "한 시간",
          hh: "%d시간",
          d: "하루",
          dd: "%d일",
          M: "한 달",
          MM: "%d달",
          y: "일 년",
          yy: "%d년"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "d":
            case "D":
            case "DDD":
              return e + "일";

            case "M":
              return e + "월";

            case "w":
            case "W":
              return e + "주";

            default:
              return e;
          }
        },
        meridiemParse: /오전|오후/,
        isPM: function isPM(e) {
          return "오후" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "오전" : "오후";
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "١",
        2: "٢",
        3: "٣",
        4: "٤",
        5: "٥",
        6: "٦",
        7: "٧",
        8: "٨",
        9: "٩",
        0: "٠"
      },
          n = {
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        "٠": "0"
      },
          r = ["کانونی دووەم", "شوبات", "ئازار", "نیسان", "ئایار", "حوزەیران", "تەمموز", "ئاب", "ئەیلوول", "تشرینی یەكەم", "تشرینی دووەم", "كانونی یەکەم"];
      e.defineLocale("ku", {
        months: r,
        monthsShort: r,
        weekdays: "یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌".split("_"),
        weekdaysShort: "یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌".split("_"),
        weekdaysMin: "ی_د_س_چ_پ_ه_ش".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function isPM(e) {
          return /ئێواره‌/.test(e);
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "به‌یانی" : "ئێواره‌";
        },
        calendar: {
          sameDay: "[ئه‌مرۆ كاتژمێر] LT",
          nextDay: "[به‌یانی كاتژمێر] LT",
          nextWeek: "dddd [كاتژمێر] LT",
          lastDay: "[دوێنێ كاتژمێر] LT",
          lastWeek: "dddd [كاتژمێر] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "له‌ %s",
          past: "%s",
          s: "چه‌ند چركه‌یه‌ك",
          ss: "چركه‌ %d",
          m: "یه‌ك خوله‌ك",
          mm: "%d خوله‌ك",
          h: "یه‌ك كاتژمێر",
          hh: "%d كاتژمێر",
          d: "یه‌ك ڕۆژ",
          dd: "%d ڕۆژ",
          M: "یه‌ك مانگ",
          MM: "%d مانگ",
          y: "یه‌ك ساڵ",
          yy: "%d ساڵ"
        },
        preparse: function preparse(e) {
          return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
            return n[e];
          }).replace(/،/g, ",");
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          }).replace(/,/g, "،");
        },
        week: {
          dow: 6,
          doy: 12
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        0: "-чү",
        1: "-чи",
        2: "-чи",
        3: "-чү",
        4: "-чү",
        5: "-чи",
        6: "-чы",
        7: "-чи",
        8: "-чи",
        9: "-чу",
        10: "-чу",
        20: "-чы",
        30: "-чу",
        40: "-чы",
        50: "-чү",
        60: "-чы",
        70: "-чи",
        80: "-чи",
        90: "-чу",
        100: "-чү"
      };
      e.defineLocale("ky", {
        months: "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"),
        monthsShort: "янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек".split("_"),
        weekdays: "Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби".split("_"),
        weekdaysShort: "Жек_Дүй_Шей_Шар_Бей_Жум_Ише".split("_"),
        weekdaysMin: "Жк_Дй_Шй_Шр_Бй_Жм_Иш".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Бүгүн саат] LT",
          nextDay: "[Эртең саат] LT",
          nextWeek: "dddd [саат] LT",
          lastDay: "[Кечээ саат] LT",
          lastWeek: "[Өткөн аптанын] dddd [күнү] [саат] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s ичинде",
          past: "%s мурун",
          s: "бирнече секунд",
          ss: "%d секунд",
          m: "бир мүнөт",
          mm: "%d мүнөт",
          h: "бир саат",
          hh: "%d саат",
          d: "бир күн",
          dd: "%d күн",
          M: "бир ай",
          MM: "%d ай",
          y: "бир жыл",
          yy: "%d жыл"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function ordinal(e) {
          var n = e % 10,
              r = e >= 100 ? 100 : null;
          return e + (t[e] || t[n] || t[r]);
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n, r) {
        var i = {
          m: ["eng Minutt", "enger Minutt"],
          h: ["eng Stonn", "enger Stonn"],
          d: ["een Dag", "engem Dag"],
          M: ["ee Mount", "engem Mount"],
          y: ["ee Joer", "engem Joer"]
        };
        return t ? i[n][0] : i[n][1];
      }

      function n(e) {
        if (e = parseInt(e, 10), isNaN(e)) return !1;
        if (e < 0) return !0;
        if (e < 10) return 4 <= e && e <= 7;

        if (e < 100) {
          var t = e % 10,
              r = e / 10;
          return n(0 === t ? r : t);
        }

        if (e < 1e4) {
          for (; e >= 10;) {
            e /= 10;
          }

          return n(e);
        }

        return n(e /= 1e3);
      }

      e.defineLocale("lb", {
        months: "Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),
        monthsParseExact: !0,
        weekdays: "Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),
        weekdaysShort: "So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mé_Dë_Më_Do_Fr_Sa".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm [Auer]",
          LTS: "H:mm:ss [Auer]",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY H:mm [Auer]",
          LLLL: "dddd, D. MMMM YYYY H:mm [Auer]"
        },
        calendar: {
          sameDay: "[Haut um] LT",
          sameElse: "L",
          nextDay: "[Muer um] LT",
          nextWeek: "dddd [um] LT",
          lastDay: "[Gëschter um] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 2:
              case 4:
                return "[Leschten] dddd [um] LT";

              default:
                return "[Leschte] dddd [um] LT";
            }
          }
        },
        relativeTime: {
          future: function future(e) {
            return n(e.substr(0, e.indexOf(" "))) ? "a " + e : "an " + e;
          },
          past: function past(e) {
            return n(e.substr(0, e.indexOf(" "))) ? "viru " + e : "virun " + e;
          },
          s: "e puer Sekonnen",
          ss: "%d Sekonnen",
          m: t,
          mm: "%d Minutten",
          h: t,
          hh: "%d Stonnen",
          d: t,
          dd: "%d Deeg",
          M: t,
          MM: "%d Méint",
          y: t,
          yy: "%d Joer"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("lo", {
        months: "ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),
        monthsShort: "ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),
        weekdays: "ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),
        weekdaysShort: "ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),
        weekdaysMin: "ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "ວັນdddd D MMMM YYYY HH:mm"
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function isPM(e) {
          return "ຕອນແລງ" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "ຕອນເຊົ້າ" : "ຕອນແລງ";
        },
        calendar: {
          sameDay: "[ມື້ນີ້ເວລາ] LT",
          nextDay: "[ມື້ອື່ນເວລາ] LT",
          nextWeek: "[ວັນ]dddd[ໜ້າເວລາ] LT",
          lastDay: "[ມື້ວານນີ້ເວລາ] LT",
          lastWeek: "[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "ອີກ %s",
          past: "%sຜ່ານມາ",
          s: "ບໍ່ເທົ່າໃດວິນາທີ",
          ss: "%d ວິນາທີ",
          m: "1 ນາທີ",
          mm: "%d ນາທີ",
          h: "1 ຊົ່ວໂມງ",
          hh: "%d ຊົ່ວໂມງ",
          d: "1 ມື້",
          dd: "%d ມື້",
          M: "1 ເດືອນ",
          MM: "%d ເດືອນ",
          y: "1 ປີ",
          yy: "%d ປີ"
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function ordinal(e) {
          return "ທີ່" + e;
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        ss: "sekundė_sekundžių_sekundes",
        m: "minutė_minutės_minutę",
        mm: "minutės_minučių_minutes",
        h: "valanda_valandos_valandą",
        hh: "valandos_valandų_valandas",
        d: "diena_dienos_dieną",
        dd: "dienos_dienų_dienas",
        M: "mėnuo_mėnesio_mėnesį",
        MM: "mėnesiai_mėnesių_mėnesius",
        y: "metai_metų_metus",
        yy: "metai_metų_metus"
      };

      function n(e, t, n, r) {
        return t ? i(n)[0] : r ? i(n)[1] : i(n)[2];
      }

      function r(e) {
        return e % 10 == 0 || e > 10 && e < 20;
      }

      function i(e) {
        return t[e].split("_");
      }

      function o(e, t, o, a) {
        var s = e + " ";
        return 1 === e ? s + n(0, t, o[0], a) : t ? s + (r(e) ? i(o)[1] : i(o)[0]) : a ? s + i(o)[1] : s + (r(e) ? i(o)[1] : i(o)[2]);
      }

      e.defineLocale("lt", {
        months: {
          format: "sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),
          standalone: "sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split("_"),
          isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
        weekdays: {
          format: "sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split("_"),
          standalone: "sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split("_"),
          isFormat: /dddd HH:mm/
        },
        weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),
        weekdaysMin: "S_P_A_T_K_Pn_Š".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY-MM-DD",
          LL: "YYYY [m.] MMMM D [d.]",
          LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
          LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
          l: "YYYY-MM-DD",
          ll: "YYYY [m.] MMMM D [d.]",
          lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
          llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"
        },
        calendar: {
          sameDay: "[Šiandien] LT",
          nextDay: "[Rytoj] LT",
          nextWeek: "dddd LT",
          lastDay: "[Vakar] LT",
          lastWeek: "[Praėjusį] dddd LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "po %s",
          past: "prieš %s",
          s: function s(e, t, n, r) {
            return t ? "kelios sekundės" : r ? "kelių sekundžių" : "kelias sekundes";
          },
          ss: o,
          m: n,
          mm: o,
          h: n,
          hh: o,
          d: n,
          dd: o,
          M: n,
          MM: o,
          y: n,
          yy: o
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function ordinal(e) {
          return e + "-oji";
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        ss: "sekundes_sekundēm_sekunde_sekundes".split("_"),
        m: "minūtes_minūtēm_minūte_minūtes".split("_"),
        mm: "minūtes_minūtēm_minūte_minūtes".split("_"),
        h: "stundas_stundām_stunda_stundas".split("_"),
        hh: "stundas_stundām_stunda_stundas".split("_"),
        d: "dienas_dienām_diena_dienas".split("_"),
        dd: "dienas_dienām_diena_dienas".split("_"),
        M: "mēneša_mēnešiem_mēnesis_mēneši".split("_"),
        MM: "mēneša_mēnešiem_mēnesis_mēneši".split("_"),
        y: "gada_gadiem_gads_gadi".split("_"),
        yy: "gada_gadiem_gads_gadi".split("_")
      };

      function n(e, t, n) {
        return n ? t % 10 == 1 && t % 100 != 11 ? e[2] : e[3] : t % 10 == 1 && t % 100 != 11 ? e[0] : e[1];
      }

      function r(e, r, i) {
        return e + " " + n(t[i], e, r);
      }

      function i(e, r, i) {
        return n(t[i], e, r);
      }

      e.defineLocale("lv", {
        months: "janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),
        monthsShort: "jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),
        weekdays: "svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),
        weekdaysShort: "Sv_P_O_T_C_Pk_S".split("_"),
        weekdaysMin: "Sv_P_O_T_C_Pk_S".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY.",
          LL: "YYYY. [gada] D. MMMM",
          LLL: "YYYY. [gada] D. MMMM, HH:mm",
          LLLL: "YYYY. [gada] D. MMMM, dddd, HH:mm"
        },
        calendar: {
          sameDay: "[Šodien pulksten] LT",
          nextDay: "[Rīt pulksten] LT",
          nextWeek: "dddd [pulksten] LT",
          lastDay: "[Vakar pulksten] LT",
          lastWeek: "[Pagājušā] dddd [pulksten] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "pēc %s",
          past: "pirms %s",
          s: function s(e, t) {
            return t ? "dažas sekundes" : "dažām sekundēm";
          },
          ss: r,
          m: i,
          mm: r,
          h: i,
          hh: r,
          d: i,
          dd: r,
          M: i,
          MM: r,
          y: i,
          yy: r
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        words: {
          ss: ["sekund", "sekunda", "sekundi"],
          m: ["jedan minut", "jednog minuta"],
          mm: ["minut", "minuta", "minuta"],
          h: ["jedan sat", "jednog sata"],
          hh: ["sat", "sata", "sati"],
          dd: ["dan", "dana", "dana"],
          MM: ["mjesec", "mjeseca", "mjeseci"],
          yy: ["godina", "godine", "godina"]
        },
        correctGrammaticalCase: function correctGrammaticalCase(e, t) {
          return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2];
        },
        translate: function translate(e, n, r) {
          var i = t.words[r];
          return 1 === r.length ? n ? i[0] : i[1] : e + " " + t.correctGrammaticalCase(e, i);
        }
      };
      e.defineLocale("me", {
        months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
        monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY H:mm",
          LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
          sameDay: "[danas u] LT",
          nextDay: "[sjutra u] LT",
          nextWeek: function nextWeek() {
            switch (this.day()) {
              case 0:
                return "[u] [nedjelju] [u] LT";

              case 3:
                return "[u] [srijedu] [u] LT";

              case 6:
                return "[u] [subotu] [u] LT";

              case 1:
              case 2:
              case 4:
              case 5:
                return "[u] dddd [u] LT";
            }
          },
          lastDay: "[juče u] LT",
          lastWeek: function lastWeek() {
            return ["[prošle] [nedjelje] [u] LT", "[prošlog] [ponedjeljka] [u] LT", "[prošlog] [utorka] [u] LT", "[prošle] [srijede] [u] LT", "[prošlog] [četvrtka] [u] LT", "[prošlog] [petka] [u] LT", "[prošle] [subote] [u] LT"][this.day()];
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "za %s",
          past: "prije %s",
          s: "nekoliko sekundi",
          ss: t.translate,
          m: t.translate,
          mm: t.translate,
          h: t.translate,
          hh: t.translate,
          d: "dan",
          dd: t.translate,
          M: "mjesec",
          MM: t.translate,
          y: "godinu",
          yy: t.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("mi", {
        months: "Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea".split("_"),
        monthsShort: "Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: "Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei".split("_"),
        weekdaysShort: "Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),
        weekdaysMin: "Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY [i] HH:mm",
          LLLL: "dddd, D MMMM YYYY [i] HH:mm"
        },
        calendar: {
          sameDay: "[i teie mahana, i] LT",
          nextDay: "[apopo i] LT",
          nextWeek: "dddd [i] LT",
          lastDay: "[inanahi i] LT",
          lastWeek: "dddd [whakamutunga i] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "i roto i %s",
          past: "%s i mua",
          s: "te hēkona ruarua",
          ss: "%d hēkona",
          m: "he meneti",
          mm: "%d meneti",
          h: "te haora",
          hh: "%d haora",
          d: "he ra",
          dd: "%d ra",
          M: "he marama",
          MM: "%d marama",
          y: "he tau",
          yy: "%d tau"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("mk", {
        months: "јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split("_"),
        monthsShort: "јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),
        weekdays: "недела_понеделник_вторник_среда_четврток_петок_сабота".split("_"),
        weekdaysShort: "нед_пон_вто_сре_чет_пет_саб".split("_"),
        weekdaysMin: "нe_пo_вт_ср_че_пе_сa".split("_"),
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "D.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY H:mm",
          LLLL: "dddd, D MMMM YYYY H:mm"
        },
        calendar: {
          sameDay: "[Денес во] LT",
          nextDay: "[Утре во] LT",
          nextWeek: "[Во] dddd [во] LT",
          lastDay: "[Вчера во] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
              case 3:
              case 6:
                return "[Изминатата] dddd [во] LT";

              case 1:
              case 2:
              case 4:
              case 5:
                return "[Изминатиот] dddd [во] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "после %s",
          past: "пред %s",
          s: "неколку секунди",
          ss: "%d секунди",
          m: "минута",
          mm: "%d минути",
          h: "час",
          hh: "%d часа",
          d: "ден",
          dd: "%d дена",
          M: "месец",
          MM: "%d месеци",
          y: "година",
          yy: "%d години"
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = e % 100;
          return 0 === e ? e + "-ев" : 0 === n ? e + "-ен" : n > 10 && n < 20 ? e + "-ти" : 1 === t ? e + "-ви" : 2 === t ? e + "-ри" : 7 === t || 8 === t ? e + "-ми" : e + "-ти";
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ml", {
        months: "ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ".split("_"),
        monthsShort: "ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.".split("_"),
        monthsParseExact: !0,
        weekdays: "ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച".split("_"),
        weekdaysShort: "ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി".split("_"),
        weekdaysMin: "ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ".split("_"),
        longDateFormat: {
          LT: "A h:mm -നു",
          LTS: "A h:mm:ss -നു",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY, A h:mm -നു",
          LLLL: "dddd, D MMMM YYYY, A h:mm -നു"
        },
        calendar: {
          sameDay: "[ഇന്ന്] LT",
          nextDay: "[നാളെ] LT",
          nextWeek: "dddd, LT",
          lastDay: "[ഇന്നലെ] LT",
          lastWeek: "[കഴിഞ്ഞ] dddd, LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s കഴിഞ്ഞ്",
          past: "%s മുൻപ്",
          s: "അൽപ നിമിഷങ്ങൾ",
          ss: "%d സെക്കൻഡ്",
          m: "ഒരു മിനിറ്റ്",
          mm: "%d മിനിറ്റ്",
          h: "ഒരു മണിക്കൂർ",
          hh: "%d മണിക്കൂർ",
          d: "ഒരു ദിവസം",
          dd: "%d ദിവസം",
          M: "ഒരു മാസം",
          MM: "%d മാസം",
          y: "ഒരു വർഷം",
          yy: "%d വർഷം"
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "രാത്രി" === t && e >= 4 || "ഉച്ച കഴിഞ്ഞ്" === t || "വൈകുന്നേരം" === t ? e + 12 : e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "രാത്രി" : e < 12 ? "രാവിലെ" : e < 17 ? "ഉച്ച കഴിഞ്ഞ്" : e < 20 ? "വൈകുന്നേരം" : "രാത്രി";
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n, r) {
        switch (n) {
          case "s":
            return t ? "хэдхэн секунд" : "хэдхэн секундын";

          case "ss":
            return e + (t ? " секунд" : " секундын");

          case "m":
          case "mm":
            return e + (t ? " минут" : " минутын");

          case "h":
          case "hh":
            return e + (t ? " цаг" : " цагийн");

          case "d":
          case "dd":
            return e + (t ? " өдөр" : " өдрийн");

          case "M":
          case "MM":
            return e + (t ? " сар" : " сарын");

          case "y":
          case "yy":
            return e + (t ? " жил" : " жилийн");

          default:
            return e;
        }
      }

      e.defineLocale("mn", {
        months: "Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар".split("_"),
        monthsShort: "1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар".split("_"),
        monthsParseExact: !0,
        weekdays: "Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба".split("_"),
        weekdaysShort: "Ням_Дав_Мяг_Лха_Пүр_Баа_Бям".split("_"),
        weekdaysMin: "Ня_Да_Мя_Лх_Пү_Ба_Бя".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY-MM-DD",
          LL: "YYYY оны MMMMын D",
          LLL: "YYYY оны MMMMын D HH:mm",
          LLLL: "dddd, YYYY оны MMMMын D HH:mm"
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function isPM(e) {
          return "ҮХ" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "ҮӨ" : "ҮХ";
        },
        calendar: {
          sameDay: "[Өнөөдөр] LT",
          nextDay: "[Маргааш] LT",
          nextWeek: "[Ирэх] dddd LT",
          lastDay: "[Өчигдөр] LT",
          lastWeek: "[Өнгөрсөн] dddd LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s дараа",
          past: "%s өмнө",
          s: t,
          ss: t,
          m: t,
          mm: t,
          h: t,
          hh: t,
          d: t,
          dd: t,
          M: t,
          MM: t,
          y: t,
          yy: t
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "d":
            case "D":
            case "DDD":
              return e + " өдөр";

            default:
              return e;
          }
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "१",
        2: "२",
        3: "३",
        4: "४",
        5: "५",
        6: "६",
        7: "७",
        8: "८",
        9: "९",
        0: "०"
      },
          n = {
        "१": "1",
        "२": "2",
        "३": "3",
        "४": "4",
        "५": "5",
        "६": "6",
        "७": "7",
        "८": "8",
        "९": "9",
        "०": "0"
      };

      function r(e, t, n, r) {
        var i = "";
        if (t) switch (n) {
          case "s":
            i = "काही सेकंद";
            break;

          case "ss":
            i = "%d सेकंद";
            break;

          case "m":
            i = "एक मिनिट";
            break;

          case "mm":
            i = "%d मिनिटे";
            break;

          case "h":
            i = "एक तास";
            break;

          case "hh":
            i = "%d तास";
            break;

          case "d":
            i = "एक दिवस";
            break;

          case "dd":
            i = "%d दिवस";
            break;

          case "M":
            i = "एक महिना";
            break;

          case "MM":
            i = "%d महिने";
            break;

          case "y":
            i = "एक वर्ष";
            break;

          case "yy":
            i = "%d वर्षे";
        } else switch (n) {
          case "s":
            i = "काही सेकंदां";
            break;

          case "ss":
            i = "%d सेकंदां";
            break;

          case "m":
            i = "एका मिनिटा";
            break;

          case "mm":
            i = "%d मिनिटां";
            break;

          case "h":
            i = "एका तासा";
            break;

          case "hh":
            i = "%d तासां";
            break;

          case "d":
            i = "एका दिवसा";
            break;

          case "dd":
            i = "%d दिवसां";
            break;

          case "M":
            i = "एका महिन्या";
            break;

          case "MM":
            i = "%d महिन्यां";
            break;

          case "y":
            i = "एका वर्षा";
            break;

          case "yy":
            i = "%d वर्षां";
        }
        return i.replace(/%d/i, e);
      }

      e.defineLocale("mr", {
        months: "जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split("_"),
        monthsShort: "जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split("_"),
        monthsParseExact: !0,
        weekdays: "रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),
        weekdaysShort: "रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि".split("_"),
        weekdaysMin: "र_सो_मं_बु_गु_शु_श".split("_"),
        longDateFormat: {
          LT: "A h:mm वाजता",
          LTS: "A h:mm:ss वाजता",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY, A h:mm वाजता",
          LLLL: "dddd, D MMMM YYYY, A h:mm वाजता"
        },
        calendar: {
          sameDay: "[आज] LT",
          nextDay: "[उद्या] LT",
          nextWeek: "dddd, LT",
          lastDay: "[काल] LT",
          lastWeek: "[मागील] dddd, LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%sमध्ये",
          past: "%sपूर्वी",
          s: r,
          ss: r,
          m: r,
          mm: r,
          h: r,
          hh: r,
          d: r,
          dd: r,
          M: r,
          MM: r,
          y: r,
          yy: r
        },
        preparse: function preparse(e) {
          return e.replace(/[१२३४५६७८९०]/g, function (e) {
            return n[e];
          });
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "रात्री" === t ? e < 4 ? e : e + 12 : "सकाळी" === t ? e : "दुपारी" === t ? e >= 10 ? e : e + 12 : "सायंकाळी" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "रात्री" : e < 10 ? "सकाळी" : e < 17 ? "दुपारी" : e < 20 ? "सायंकाळी" : "रात्री";
        },
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ms", {
        months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
        monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
        weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
        weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
        weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
        longDateFormat: {
          LT: "HH.mm",
          LTS: "HH.mm.ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY [pukul] HH.mm",
          LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "pagi" === t ? e : "tengahari" === t ? e >= 11 ? e : e + 12 : "petang" === t || "malam" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 11 ? "pagi" : e < 15 ? "tengahari" : e < 19 ? "petang" : "malam";
        },
        calendar: {
          sameDay: "[Hari ini pukul] LT",
          nextDay: "[Esok pukul] LT",
          nextWeek: "dddd [pukul] LT",
          lastDay: "[Kelmarin pukul] LT",
          lastWeek: "dddd [lepas pukul] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "dalam %s",
          past: "%s yang lepas",
          s: "beberapa saat",
          ss: "%d saat",
          m: "seminit",
          mm: "%d minit",
          h: "sejam",
          hh: "%d jam",
          d: "sehari",
          dd: "%d hari",
          M: "sebulan",
          MM: "%d bulan",
          y: "setahun",
          yy: "%d tahun"
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ms-my", {
        months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
        monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
        weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
        weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
        weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
        longDateFormat: {
          LT: "HH.mm",
          LTS: "HH.mm.ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY [pukul] HH.mm",
          LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "pagi" === t ? e : "tengahari" === t ? e >= 11 ? e : e + 12 : "petang" === t || "malam" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 11 ? "pagi" : e < 15 ? "tengahari" : e < 19 ? "petang" : "malam";
        },
        calendar: {
          sameDay: "[Hari ini pukul] LT",
          nextDay: "[Esok pukul] LT",
          nextWeek: "dddd [pukul] LT",
          lastDay: "[Kelmarin pukul] LT",
          lastWeek: "dddd [lepas pukul] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "dalam %s",
          past: "%s yang lepas",
          s: "beberapa saat",
          ss: "%d saat",
          m: "seminit",
          mm: "%d minit",
          h: "sejam",
          hh: "%d jam",
          d: "sehari",
          dd: "%d hari",
          M: "sebulan",
          MM: "%d bulan",
          y: "setahun",
          yy: "%d tahun"
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("mt", {
        months: "Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru".split("_"),
        monthsShort: "Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ".split("_"),
        weekdays: "Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt".split("_"),
        weekdaysShort: "Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib".split("_"),
        weekdaysMin: "Ħa_Tn_Tl_Er_Ħa_Ġi_Si".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Illum fil-]LT",
          nextDay: "[Għada fil-]LT",
          nextWeek: "dddd [fil-]LT",
          lastDay: "[Il-bieraħ fil-]LT",
          lastWeek: "dddd [li għadda] [fil-]LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "f’ %s",
          past: "%s ilu",
          s: "ftit sekondi",
          ss: "%d sekondi",
          m: "minuta",
          mm: "%d minuti",
          h: "siegħa",
          hh: "%d siegħat",
          d: "ġurnata",
          dd: "%d ġranet",
          M: "xahar",
          MM: "%d xhur",
          y: "sena",
          yy: "%d sni"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "၁",
        2: "၂",
        3: "၃",
        4: "၄",
        5: "၅",
        6: "၆",
        7: "၇",
        8: "၈",
        9: "၉",
        0: "၀"
      },
          n = {
        "၁": "1",
        "၂": "2",
        "၃": "3",
        "၄": "4",
        "၅": "5",
        "၆": "6",
        "၇": "7",
        "၈": "8",
        "၉": "9",
        "၀": "0"
      };
      e.defineLocale("my", {
        months: "ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ".split("_"),
        monthsShort: "ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ".split("_"),
        weekdays: "တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ".split("_"),
        weekdaysShort: "နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),
        weekdaysMin: "နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[ယနေ.] LT [မှာ]",
          nextDay: "[မနက်ဖြန်] LT [မှာ]",
          nextWeek: "dddd LT [မှာ]",
          lastDay: "[မနေ.က] LT [မှာ]",
          lastWeek: "[ပြီးခဲ့သော] dddd LT [မှာ]",
          sameElse: "L"
        },
        relativeTime: {
          future: "လာမည့် %s မှာ",
          past: "လွန်ခဲ့သော %s က",
          s: "စက္ကန်.အနည်းငယ်",
          ss: "%d စက္ကန့်",
          m: "တစ်မိနစ်",
          mm: "%d မိနစ်",
          h: "တစ်နာရီ",
          hh: "%d နာရီ",
          d: "တစ်ရက်",
          dd: "%d ရက်",
          M: "တစ်လ",
          MM: "%d လ",
          y: "တစ်နှစ်",
          yy: "%d နှစ်"
        },
        preparse: function preparse(e) {
          return e.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (e) {
            return n[e];
          });
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          });
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("nb", {
        months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort: "jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
        monthsParseExact: !0,
        weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
        weekdaysShort: "sø._ma._ti._on._to._fr._lø.".split("_"),
        weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY [kl.] HH:mm",
          LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
        },
        calendar: {
          sameDay: "[i dag kl.] LT",
          nextDay: "[i morgen kl.] LT",
          nextWeek: "dddd [kl.] LT",
          lastDay: "[i går kl.] LT",
          lastWeek: "[forrige] dddd [kl.] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "om %s",
          past: "%s siden",
          s: "noen sekunder",
          ss: "%d sekunder",
          m: "ett minutt",
          mm: "%d minutter",
          h: "en time",
          hh: "%d timer",
          d: "en dag",
          dd: "%d dager",
          M: "en måned",
          MM: "%d måneder",
          y: "ett år",
          yy: "%d år"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "१",
        2: "२",
        3: "३",
        4: "४",
        5: "५",
        6: "६",
        7: "७",
        8: "८",
        9: "९",
        0: "०"
      },
          n = {
        "१": "1",
        "२": "2",
        "३": "3",
        "४": "4",
        "५": "5",
        "६": "6",
        "७": "7",
        "८": "8",
        "९": "9",
        "०": "0"
      };
      e.defineLocale("ne", {
        months: "जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर".split("_"),
        monthsShort: "जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.".split("_"),
        monthsParseExact: !0,
        weekdays: "आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार".split("_"),
        weekdaysShort: "आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.".split("_"),
        weekdaysMin: "आ._सो._मं._बु._बि._शु._श.".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "Aको h:mm बजे",
          LTS: "Aको h:mm:ss बजे",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY, Aको h:mm बजे",
          LLLL: "dddd, D MMMM YYYY, Aको h:mm बजे"
        },
        preparse: function preparse(e) {
          return e.replace(/[१२३४५६७८९०]/g, function (e) {
            return n[e];
          });
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "राति" === t ? e < 4 ? e : e + 12 : "बिहान" === t ? e : "दिउँसो" === t ? e >= 10 ? e : e + 12 : "साँझ" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 3 ? "राति" : e < 12 ? "बिहान" : e < 16 ? "दिउँसो" : e < 20 ? "साँझ" : "राति";
        },
        calendar: {
          sameDay: "[आज] LT",
          nextDay: "[भोलि] LT",
          nextWeek: "[आउँदो] dddd[,] LT",
          lastDay: "[हिजो] LT",
          lastWeek: "[गएको] dddd[,] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%sमा",
          past: "%s अगाडि",
          s: "केही क्षण",
          ss: "%d सेकेण्ड",
          m: "एक मिनेट",
          mm: "%d मिनेट",
          h: "एक घण्टा",
          hh: "%d घण्टा",
          d: "एक दिन",
          dd: "%d दिन",
          M: "एक महिना",
          MM: "%d महिना",
          y: "एक बर्ष",
          yy: "%d बर्ष"
        },
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),
          n = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
          r = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
          i = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
      e.defineLocale("nl", {
        months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        monthsShort: function monthsShort(e, r) {
          return e ? /-MMM-/.test(r) ? n[e.month()] : t[e.month()] : t;
        },
        monthsRegex: i,
        monthsShortRegex: i,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
        monthsParse: r,
        longMonthsParse: r,
        shortMonthsParse: r,
        weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
        weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD-MM-YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[vandaag om] LT",
          nextDay: "[morgen om] LT",
          nextWeek: "dddd [om] LT",
          lastDay: "[gisteren om] LT",
          lastWeek: "[afgelopen] dddd [om] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "over %s",
          past: "%s geleden",
          s: "een paar seconden",
          ss: "%d seconden",
          m: "één minuut",
          mm: "%d minuten",
          h: "één uur",
          hh: "%d uur",
          d: "één dag",
          dd: "%d dagen",
          M: "één maand",
          MM: "%d maanden",
          y: "één jaar",
          yy: "%d jaar"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(e) {
          return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),
          n = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
          r = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
          i = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
      e.defineLocale("nl-be", {
        months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        monthsShort: function monthsShort(e, r) {
          return e ? /-MMM-/.test(r) ? n[e.month()] : t[e.month()] : t;
        },
        monthsRegex: i,
        monthsShortRegex: i,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
        monthsParse: r,
        longMonthsParse: r,
        shortMonthsParse: r,
        weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
        weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[vandaag om] LT",
          nextDay: "[morgen om] LT",
          nextWeek: "dddd [om] LT",
          lastDay: "[gisteren om] LT",
          lastWeek: "[afgelopen] dddd [om] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "over %s",
          past: "%s geleden",
          s: "een paar seconden",
          ss: "%d seconden",
          m: "één minuut",
          mm: "%d minuten",
          h: "één uur",
          hh: "%d uur",
          d: "één dag",
          dd: "%d dagen",
          M: "één maand",
          MM: "%d maanden",
          y: "één jaar",
          yy: "%d jaar"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(e) {
          return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("nn", {
        months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
        monthsShort: "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
        weekdays: "sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),
        weekdaysShort: "sun_mån_tys_ons_tor_fre_lau".split("_"),
        weekdaysMin: "su_må_ty_on_to_fr_lø".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY [kl.] H:mm",
          LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
        },
        calendar: {
          sameDay: "[I dag klokka] LT",
          nextDay: "[I morgon klokka] LT",
          nextWeek: "dddd [klokka] LT",
          lastDay: "[I går klokka] LT",
          lastWeek: "[Føregåande] dddd [klokka] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "om %s",
          past: "%s sidan",
          s: "nokre sekund",
          ss: "%d sekund",
          m: "eit minutt",
          mm: "%d minutt",
          h: "ein time",
          hh: "%d timar",
          d: "ein dag",
          dd: "%d dagar",
          M: "ein månad",
          MM: "%d månader",
          y: "eit år",
          yy: "%d år"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "੧",
        2: "੨",
        3: "੩",
        4: "੪",
        5: "੫",
        6: "੬",
        7: "੭",
        8: "੮",
        9: "੯",
        0: "੦"
      },
          n = {
        "੧": "1",
        "੨": "2",
        "੩": "3",
        "੪": "4",
        "੫": "5",
        "੬": "6",
        "੭": "7",
        "੮": "8",
        "੯": "9",
        "੦": "0"
      };
      e.defineLocale("pa-in", {
        months: "ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),
        monthsShort: "ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),
        weekdays: "ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ".split("_"),
        weekdaysShort: "ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),
        weekdaysMin: "ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),
        longDateFormat: {
          LT: "A h:mm ਵਜੇ",
          LTS: "A h:mm:ss ਵਜੇ",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY, A h:mm ਵਜੇ",
          LLLL: "dddd, D MMMM YYYY, A h:mm ਵਜੇ"
        },
        calendar: {
          sameDay: "[ਅਜ] LT",
          nextDay: "[ਕਲ] LT",
          nextWeek: "[ਅਗਲਾ] dddd, LT",
          lastDay: "[ਕਲ] LT",
          lastWeek: "[ਪਿਛਲੇ] dddd, LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s ਵਿੱਚ",
          past: "%s ਪਿਛਲੇ",
          s: "ਕੁਝ ਸਕਿੰਟ",
          ss: "%d ਸਕਿੰਟ",
          m: "ਇਕ ਮਿੰਟ",
          mm: "%d ਮਿੰਟ",
          h: "ਇੱਕ ਘੰਟਾ",
          hh: "%d ਘੰਟੇ",
          d: "ਇੱਕ ਦਿਨ",
          dd: "%d ਦਿਨ",
          M: "ਇੱਕ ਮਹੀਨਾ",
          MM: "%d ਮਹੀਨੇ",
          y: "ਇੱਕ ਸਾਲ",
          yy: "%d ਸਾਲ"
        },
        preparse: function preparse(e) {
          return e.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (e) {
            return n[e];
          });
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          });
        },
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "ਰਾਤ" === t ? e < 4 ? e : e + 12 : "ਸਵੇਰ" === t ? e : "ਦੁਪਹਿਰ" === t ? e >= 10 ? e : e + 12 : "ਸ਼ਾਮ" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "ਰਾਤ" : e < 10 ? "ਸਵੇਰ" : e < 17 ? "ਦੁਪਹਿਰ" : e < 20 ? "ਸ਼ਾਮ" : "ਰਾਤ";
        },
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),
          n = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_");

      function r(e) {
        return e % 10 < 5 && e % 10 > 1 && ~~(e / 10) % 10 != 1;
      }

      function i(e, t, n) {
        var i = e + " ";

        switch (n) {
          case "ss":
            return i + (r(e) ? "sekundy" : "sekund");

          case "m":
            return t ? "minuta" : "minutę";

          case "mm":
            return i + (r(e) ? "minuty" : "minut");

          case "h":
            return t ? "godzina" : "godzinę";

          case "hh":
            return i + (r(e) ? "godziny" : "godzin");

          case "MM":
            return i + (r(e) ? "miesiące" : "miesięcy");

          case "yy":
            return i + (r(e) ? "lata" : "lat");
        }
      }

      e.defineLocale("pl", {
        months: function months(e, r) {
          return e ? "" === r ? "(" + n[e.month()] + "|" + t[e.month()] + ")" : /D MMMM/.test(r) ? n[e.month()] : t[e.month()] : t;
        },
        monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),
        weekdays: "niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),
        weekdaysShort: "ndz_pon_wt_śr_czw_pt_sob".split("_"),
        weekdaysMin: "Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Dziś o] LT",
          nextDay: "[Jutro o] LT",
          nextWeek: function nextWeek() {
            switch (this.day()) {
              case 0:
                return "[W niedzielę o] LT";

              case 2:
                return "[We wtorek o] LT";

              case 3:
                return "[W środę o] LT";

              case 6:
                return "[W sobotę o] LT";

              default:
                return "[W] dddd [o] LT";
            }
          },
          lastDay: "[Wczoraj o] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
                return "[W zeszłą niedzielę o] LT";

              case 3:
                return "[W zeszłą środę o] LT";

              case 6:
                return "[W zeszłą sobotę o] LT";

              default:
                return "[W zeszły] dddd [o] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "za %s",
          past: "%s temu",
          s: "kilka sekund",
          ss: i,
          m: i,
          mm: i,
          h: i,
          hh: i,
          d: "1 dzień",
          dd: "%d dni",
          M: "miesiąc",
          MM: i,
          y: "rok",
          yy: i
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("pt", {
        months: "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split("_"),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
        weekdays: "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),
        weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),
        weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D [de] MMMM [de] YYYY",
          LLL: "D [de] MMMM [de] YYYY HH:mm",
          LLLL: "dddd, D [de] MMMM [de] YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Hoje às] LT",
          nextDay: "[Amanhã às] LT",
          nextWeek: "dddd [às] LT",
          lastDay: "[Ontem às] LT",
          lastWeek: function lastWeek() {
            return 0 === this.day() || 6 === this.day() ? "[Último] dddd [às] LT" : "[Última] dddd [às] LT";
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "em %s",
          past: "há %s",
          s: "segundos",
          ss: "%d segundos",
          m: "um minuto",
          mm: "%d minutos",
          h: "uma hora",
          hh: "%d horas",
          d: "um dia",
          dd: "%d dias",
          M: "um mês",
          MM: "%d meses",
          y: "um ano",
          yy: "%d anos"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("pt-br", {
        months: "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split("_"),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
        weekdays: "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),
        weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),
        weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D [de] MMMM [de] YYYY",
          LLL: "D [de] MMMM [de] YYYY [às] HH:mm",
          LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm"
        },
        calendar: {
          sameDay: "[Hoje às] LT",
          nextDay: "[Amanhã às] LT",
          nextWeek: "dddd [às] LT",
          lastDay: "[Ontem às] LT",
          lastWeek: function lastWeek() {
            return 0 === this.day() || 6 === this.day() ? "[Último] dddd [às] LT" : "[Última] dddd [às] LT";
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "em %s",
          past: "há %s",
          s: "poucos segundos",
          ss: "%d segundos",
          m: "um minuto",
          mm: "%d minutos",
          h: "uma hora",
          hh: "%d horas",
          d: "um dia",
          dd: "%d dias",
          M: "um mês",
          MM: "%d meses",
          y: "um ano",
          yy: "%d anos"
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: "%dº"
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n) {
        var r = " ";
        return (e % 100 >= 20 || e >= 100 && e % 100 == 0) && (r = " de "), e + r + {
          ss: "secunde",
          mm: "minute",
          hh: "ore",
          dd: "zile",
          MM: "luni",
          yy: "ani"
        }[n];
      }

      e.defineLocale("ro", {
        months: "ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),
        monthsShort: "ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),
        weekdaysShort: "Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),
        weekdaysMin: "Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY H:mm",
          LLLL: "dddd, D MMMM YYYY H:mm"
        },
        calendar: {
          sameDay: "[azi la] LT",
          nextDay: "[mâine la] LT",
          nextWeek: "dddd [la] LT",
          lastDay: "[ieri la] LT",
          lastWeek: "[fosta] dddd [la] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "peste %s",
          past: "%s în urmă",
          s: "câteva secunde",
          ss: t,
          m: "un minut",
          mm: t,
          h: "o oră",
          hh: t,
          d: "o zi",
          dd: t,
          M: "o lună",
          MM: t,
          y: "un an",
          yy: t
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n) {
        var r,
            i,
            o = {
          ss: t ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
          mm: t ? "минута_минуты_минут" : "минуту_минуты_минут",
          hh: "час_часа_часов",
          dd: "день_дня_дней",
          MM: "месяц_месяца_месяцев",
          yy: "год_года_лет"
        };
        return "m" === n ? t ? "минута" : "минуту" : e + " " + (r = +e, i = o[n].split("_"), r % 10 == 1 && r % 100 != 11 ? i[0] : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? i[1] : i[2]);
      }

      var n = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
      e.defineLocale("ru", {
        months: {
          format: "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),
          standalone: "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_")
        },
        monthsShort: {
          format: "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),
          standalone: "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_")
        },
        weekdays: {
          standalone: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),
          format: "воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split("_"),
          isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort: "вс_пн_вт_ср_чт_пт_сб".split("_"),
        weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"),
        monthsParse: n,
        longMonthsParse: n,
        shortMonthsParse: n,
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY г.",
          LLL: "D MMMM YYYY г., H:mm",
          LLLL: "dddd, D MMMM YYYY г., H:mm"
        },
        calendar: {
          sameDay: "[Сегодня, в] LT",
          nextDay: "[Завтра, в] LT",
          lastDay: "[Вчера, в] LT",
          nextWeek: function nextWeek(e) {
            if (e.week() === this.week()) return 2 === this.day() ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";

            switch (this.day()) {
              case 0:
                return "[В следующее] dddd, [в] LT";

              case 1:
              case 2:
              case 4:
                return "[В следующий] dddd, [в] LT";

              case 3:
              case 5:
              case 6:
                return "[В следующую] dddd, [в] LT";
            }
          },
          lastWeek: function lastWeek(e) {
            if (e.week() === this.week()) return 2 === this.day() ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";

            switch (this.day()) {
              case 0:
                return "[В прошлое] dddd, [в] LT";

              case 1:
              case 2:
              case 4:
                return "[В прошлый] dddd, [в] LT";

              case 3:
              case 5:
              case 6:
                return "[В прошлую] dddd, [в] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "через %s",
          past: "%s назад",
          s: "несколько секунд",
          ss: t,
          m: t,
          mm: t,
          h: "час",
          hh: t,
          d: "день",
          dd: t,
          M: "месяц",
          MM: t,
          y: "год",
          yy: t
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function isPM(e) {
          return /^(дня|вечера)$/.test(e);
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "ночи" : e < 12 ? "утра" : e < 17 ? "дня" : "вечера";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "M":
            case "d":
            case "DDD":
              return e + "-й";

            case "D":
              return e + "-го";

            case "w":
            case "W":
              return e + "-я";

            default:
              return e;
          }
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = ["جنوري", "فيبروري", "مارچ", "اپريل", "مئي", "جون", "جولاءِ", "آگسٽ", "سيپٽمبر", "آڪٽوبر", "نومبر", "ڊسمبر"],
          n = ["آچر", "سومر", "اڱارو", "اربع", "خميس", "جمع", "ڇنڇر"];
      e.defineLocale("sd", {
        months: t,
        monthsShort: t,
        weekdays: n,
        weekdaysShort: n,
        weekdaysMin: n,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd، D MMMM YYYY HH:mm"
        },
        meridiemParse: /صبح|شام/,
        isPM: function isPM(e) {
          return "شام" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "صبح" : "شام";
        },
        calendar: {
          sameDay: "[اڄ] LT",
          nextDay: "[سڀاڻي] LT",
          nextWeek: "dddd [اڳين هفتي تي] LT",
          lastDay: "[ڪالهه] LT",
          lastWeek: "[گزريل هفتي] dddd [تي] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s پوء",
          past: "%s اڳ",
          s: "چند سيڪنڊ",
          ss: "%d سيڪنڊ",
          m: "هڪ منٽ",
          mm: "%d منٽ",
          h: "هڪ ڪلاڪ",
          hh: "%d ڪلاڪ",
          d: "هڪ ڏينهن",
          dd: "%d ڏينهن",
          M: "هڪ مهينو",
          MM: "%d مهينا",
          y: "هڪ سال",
          yy: "%d سال"
        },
        preparse: function preparse(e) {
          return e.replace(/،/g, ",");
        },
        postformat: function postformat(e) {
          return e.replace(/,/g, "،");
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("se", {
        months: "ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu".split("_"),
        monthsShort: "ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov".split("_"),
        weekdays: "sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat".split("_"),
        weekdaysShort: "sotn_vuos_maŋ_gask_duor_bear_láv".split("_"),
        weekdaysMin: "s_v_m_g_d_b_L".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "MMMM D. [b.] YYYY",
          LLL: "MMMM D. [b.] YYYY [ti.] HH:mm",
          LLLL: "dddd, MMMM D. [b.] YYYY [ti.] HH:mm"
        },
        calendar: {
          sameDay: "[otne ti] LT",
          nextDay: "[ihttin ti] LT",
          nextWeek: "dddd [ti] LT",
          lastDay: "[ikte ti] LT",
          lastWeek: "[ovddit] dddd [ti] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s geažes",
          past: "maŋit %s",
          s: "moadde sekunddat",
          ss: "%d sekunddat",
          m: "okta minuhta",
          mm: "%d minuhtat",
          h: "okta diimmu",
          hh: "%d diimmut",
          d: "okta beaivi",
          dd: "%d beaivvit",
          M: "okta mánnu",
          MM: "%d mánut",
          y: "okta jahki",
          yy: "%d jagit"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("si", {
        months: "ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්".split("_"),
        monthsShort: "ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ".split("_"),
        weekdays: "ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා".split("_"),
        weekdaysShort: "ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන".split("_"),
        weekdaysMin: "ඉ_ස_අ_බ_බ්‍ර_සි_සෙ".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "a h:mm",
          LTS: "a h:mm:ss",
          L: "YYYY/MM/DD",
          LL: "YYYY MMMM D",
          LLL: "YYYY MMMM D, a h:mm",
          LLLL: "YYYY MMMM D [වැනි] dddd, a h:mm:ss"
        },
        calendar: {
          sameDay: "[අද] LT[ට]",
          nextDay: "[හෙට] LT[ට]",
          nextWeek: "dddd LT[ට]",
          lastDay: "[ඊයේ] LT[ට]",
          lastWeek: "[පසුගිය] dddd LT[ට]",
          sameElse: "L"
        },
        relativeTime: {
          future: "%sකින්",
          past: "%sකට පෙර",
          s: "තත්පර කිහිපය",
          ss: "තත්පර %d",
          m: "මිනිත්තුව",
          mm: "මිනිත්තු %d",
          h: "පැය",
          hh: "පැය %d",
          d: "දිනය",
          dd: "දින %d",
          M: "මාසය",
          MM: "මාස %d",
          y: "වසර",
          yy: "වසර %d"
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function ordinal(e) {
          return e + " වැනි";
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function isPM(e) {
          return "ප.ව." === e || "පස් වරු" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e > 11 ? n ? "ප.ව." : "පස් වරු" : n ? "පෙ.ව." : "පෙර වරු";
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),
          n = "jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_");

      function r(e) {
        return e > 1 && e < 5;
      }

      function i(e, t, n, i) {
        var o = e + " ";

        switch (n) {
          case "s":
            return t || i ? "pár sekúnd" : "pár sekundami";

          case "ss":
            return t || i ? o + (r(e) ? "sekundy" : "sekúnd") : o + "sekundami";

          case "m":
            return t ? "minúta" : i ? "minútu" : "minútou";

          case "mm":
            return t || i ? o + (r(e) ? "minúty" : "minút") : o + "minútami";

          case "h":
            return t ? "hodina" : i ? "hodinu" : "hodinou";

          case "hh":
            return t || i ? o + (r(e) ? "hodiny" : "hodín") : o + "hodinami";

          case "d":
            return t || i ? "deň" : "dňom";

          case "dd":
            return t || i ? o + (r(e) ? "dni" : "dní") : o + "dňami";

          case "M":
            return t || i ? "mesiac" : "mesiacom";

          case "MM":
            return t || i ? o + (r(e) ? "mesiace" : "mesiacov") : o + "mesiacmi";

          case "y":
            return t || i ? "rok" : "rokom";

          case "yy":
            return t || i ? o + (r(e) ? "roky" : "rokov") : o + "rokmi";
        }
      }

      e.defineLocale("sk", {
        months: t,
        monthsShort: n,
        weekdays: "nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),
        weekdaysShort: "ne_po_ut_st_št_pi_so".split("_"),
        weekdaysMin: "ne_po_ut_st_št_pi_so".split("_"),
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY H:mm",
          LLLL: "dddd D. MMMM YYYY H:mm"
        },
        calendar: {
          sameDay: "[dnes o] LT",
          nextDay: "[zajtra o] LT",
          nextWeek: function nextWeek() {
            switch (this.day()) {
              case 0:
                return "[v nedeľu o] LT";

              case 1:
              case 2:
                return "[v] dddd [o] LT";

              case 3:
                return "[v stredu o] LT";

              case 4:
                return "[vo štvrtok o] LT";

              case 5:
                return "[v piatok o] LT";

              case 6:
                return "[v sobotu o] LT";
            }
          },
          lastDay: "[včera o] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
                return "[minulú nedeľu o] LT";

              case 1:
              case 2:
                return "[minulý] dddd [o] LT";

              case 3:
                return "[minulú stredu o] LT";

              case 4:
              case 5:
                return "[minulý] dddd [o] LT";

              case 6:
                return "[minulú sobotu o] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "za %s",
          past: "pred %s",
          s: i,
          ss: i,
          m: i,
          mm: i,
          h: i,
          hh: i,
          d: i,
          dd: i,
          M: i,
          MM: i,
          y: i,
          yy: i
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n, r) {
        var i = e + " ";

        switch (n) {
          case "s":
            return t || r ? "nekaj sekund" : "nekaj sekundami";

          case "ss":
            return i += 1 === e ? t ? "sekundo" : "sekundi" : 2 === e ? t || r ? "sekundi" : "sekundah" : e < 5 ? t || r ? "sekunde" : "sekundah" : "sekund";

          case "m":
            return t ? "ena minuta" : "eno minuto";

          case "mm":
            return i += 1 === e ? t ? "minuta" : "minuto" : 2 === e ? t || r ? "minuti" : "minutama" : e < 5 ? t || r ? "minute" : "minutami" : t || r ? "minut" : "minutami";

          case "h":
            return t ? "ena ura" : "eno uro";

          case "hh":
            return i += 1 === e ? t ? "ura" : "uro" : 2 === e ? t || r ? "uri" : "urama" : e < 5 ? t || r ? "ure" : "urami" : t || r ? "ur" : "urami";

          case "d":
            return t || r ? "en dan" : "enim dnem";

          case "dd":
            return i += 1 === e ? t || r ? "dan" : "dnem" : 2 === e ? t || r ? "dni" : "dnevoma" : t || r ? "dni" : "dnevi";

          case "M":
            return t || r ? "en mesec" : "enim mesecem";

          case "MM":
            return i += 1 === e ? t || r ? "mesec" : "mesecem" : 2 === e ? t || r ? "meseca" : "mesecema" : e < 5 ? t || r ? "mesece" : "meseci" : t || r ? "mesecev" : "meseci";

          case "y":
            return t || r ? "eno leto" : "enim letom";

          case "yy":
            return i += 1 === e ? t || r ? "leto" : "letom" : 2 === e ? t || r ? "leti" : "letoma" : e < 5 ? t || r ? "leta" : "leti" : t || r ? "let" : "leti";
        }
      }

      e.defineLocale("sl", {
        months: "januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),
        monthsShort: "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),
        weekdaysShort: "ned._pon._tor._sre._čet._pet._sob.".split("_"),
        weekdaysMin: "ne_po_to_sr_če_pe_so".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY H:mm",
          LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
          sameDay: "[danes ob] LT",
          nextDay: "[jutri ob] LT",
          nextWeek: function nextWeek() {
            switch (this.day()) {
              case 0:
                return "[v] [nedeljo] [ob] LT";

              case 3:
                return "[v] [sredo] [ob] LT";

              case 6:
                return "[v] [soboto] [ob] LT";

              case 1:
              case 2:
              case 4:
              case 5:
                return "[v] dddd [ob] LT";
            }
          },
          lastDay: "[včeraj ob] LT",
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
                return "[prejšnjo] [nedeljo] [ob] LT";

              case 3:
                return "[prejšnjo] [sredo] [ob] LT";

              case 6:
                return "[prejšnjo] [soboto] [ob] LT";

              case 1:
              case 2:
              case 4:
              case 5:
                return "[prejšnji] dddd [ob] LT";
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "čez %s",
          past: "pred %s",
          s: t,
          ss: t,
          m: t,
          mm: t,
          h: t,
          hh: t,
          d: t,
          dd: t,
          M: t,
          MM: t,
          y: t,
          yy: t
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("sq", {
        months: "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor".split("_"),
        monthsShort: "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj".split("_"),
        weekdays: "E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë".split("_"),
        weekdaysShort: "Die_Hën_Mar_Mër_Enj_Pre_Sht".split("_"),
        weekdaysMin: "D_H_Ma_Më_E_P_Sh".split("_"),
        weekdaysParseExact: !0,
        meridiemParse: /PD|MD/,
        isPM: function isPM(e) {
          return "M" === e.charAt(0);
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "PD" : "MD";
        },
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Sot në] LT",
          nextDay: "[Nesër në] LT",
          nextWeek: "dddd [në] LT",
          lastDay: "[Dje në] LT",
          lastWeek: "dddd [e kaluar në] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "në %s",
          past: "%s më parë",
          s: "disa sekonda",
          ss: "%d sekonda",
          m: "një minutë",
          mm: "%d minuta",
          h: "një orë",
          hh: "%d orë",
          d: "një ditë",
          dd: "%d ditë",
          M: "një muaj",
          MM: "%d muaj",
          y: "një vit",
          yy: "%d vite"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        words: {
          ss: ["sekunda", "sekunde", "sekundi"],
          m: ["jedan minut", "jedne minute"],
          mm: ["minut", "minute", "minuta"],
          h: ["jedan sat", "jednog sata"],
          hh: ["sat", "sata", "sati"],
          dd: ["dan", "dana", "dana"],
          MM: ["mesec", "meseca", "meseci"],
          yy: ["godina", "godine", "godina"]
        },
        correctGrammaticalCase: function correctGrammaticalCase(e, t) {
          return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2];
        },
        translate: function translate(e, n, r) {
          var i = t.words[r];
          return 1 === r.length ? n ? i[0] : i[1] : e + " " + t.correctGrammaticalCase(e, i);
        }
      };
      e.defineLocale("sr", {
        months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
        monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
        monthsParseExact: !0,
        weekdays: "nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota".split("_"),
        weekdaysShort: "ned._pon._uto._sre._čet._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY H:mm",
          LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
          sameDay: "[danas u] LT",
          nextDay: "[sutra u] LT",
          nextWeek: function nextWeek() {
            switch (this.day()) {
              case 0:
                return "[u] [nedelju] [u] LT";

              case 3:
                return "[u] [sredu] [u] LT";

              case 6:
                return "[u] [subotu] [u] LT";

              case 1:
              case 2:
              case 4:
              case 5:
                return "[u] dddd [u] LT";
            }
          },
          lastDay: "[juče u] LT",
          lastWeek: function lastWeek() {
            return ["[prošle] [nedelje] [u] LT", "[prošlog] [ponedeljka] [u] LT", "[prošlog] [utorka] [u] LT", "[prošle] [srede] [u] LT", "[prošlog] [četvrtka] [u] LT", "[prošlog] [petka] [u] LT", "[prošle] [subote] [u] LT"][this.day()];
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "za %s",
          past: "pre %s",
          s: "nekoliko sekundi",
          ss: t.translate,
          m: t.translate,
          mm: t.translate,
          h: t.translate,
          hh: t.translate,
          d: "dan",
          dd: t.translate,
          M: "mesec",
          MM: t.translate,
          y: "godinu",
          yy: t.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        words: {
          ss: ["секунда", "секунде", "секунди"],
          m: ["један минут", "једне минуте"],
          mm: ["минут", "минуте", "минута"],
          h: ["један сат", "једног сата"],
          hh: ["сат", "сата", "сати"],
          dd: ["дан", "дана", "дана"],
          MM: ["месец", "месеца", "месеци"],
          yy: ["година", "године", "година"]
        },
        correctGrammaticalCase: function correctGrammaticalCase(e, t) {
          return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2];
        },
        translate: function translate(e, n, r) {
          var i = t.words[r];
          return 1 === r.length ? n ? i[0] : i[1] : e + " " + t.correctGrammaticalCase(e, i);
        }
      };
      e.defineLocale("sr-cyrl", {
        months: "јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар".split("_"),
        monthsShort: "јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.".split("_"),
        monthsParseExact: !0,
        weekdays: "недеља_понедељак_уторак_среда_четвртак_петак_субота".split("_"),
        weekdaysShort: "нед._пон._уто._сре._чет._пет._суб.".split("_"),
        weekdaysMin: "не_по_ут_ср_че_пе_су".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM YYYY",
          LLL: "D. MMMM YYYY H:mm",
          LLLL: "dddd, D. MMMM YYYY H:mm"
        },
        calendar: {
          sameDay: "[данас у] LT",
          nextDay: "[сутра у] LT",
          nextWeek: function nextWeek() {
            switch (this.day()) {
              case 0:
                return "[у] [недељу] [у] LT";

              case 3:
                return "[у] [среду] [у] LT";

              case 6:
                return "[у] [суботу] [у] LT";

              case 1:
              case 2:
              case 4:
              case 5:
                return "[у] dddd [у] LT";
            }
          },
          lastDay: "[јуче у] LT",
          lastWeek: function lastWeek() {
            return ["[прошле] [недеље] [у] LT", "[прошлог] [понедељка] [у] LT", "[прошлог] [уторка] [у] LT", "[прошле] [среде] [у] LT", "[прошлог] [четвртка] [у] LT", "[прошлог] [петка] [у] LT", "[прошле] [суботе] [у] LT"][this.day()];
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "за %s",
          past: "пре %s",
          s: "неколико секунди",
          ss: t.translate,
          m: t.translate,
          mm: t.translate,
          h: t.translate,
          hh: t.translate,
          d: "дан",
          dd: t.translate,
          M: "месец",
          MM: t.translate,
          y: "годину",
          yy: t.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ss", {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),
        monthsShort: "Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),
        weekdays: "Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),
        weekdaysShort: "Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),
        weekdaysMin: "Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "h:mm A",
          LTS: "h:mm:ss A",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY h:mm A",
          LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
          sameDay: "[Namuhla nga] LT",
          nextDay: "[Kusasa nga] LT",
          nextWeek: "dddd [nga] LT",
          lastDay: "[Itolo nga] LT",
          lastWeek: "dddd [leliphelile] [nga] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "nga %s",
          past: "wenteka nga %s",
          s: "emizuzwana lomcane",
          ss: "%d mzuzwana",
          m: "umzuzu",
          mm: "%d emizuzu",
          h: "lihora",
          hh: "%d emahora",
          d: "lilanga",
          dd: "%d emalanga",
          M: "inyanga",
          MM: "%d tinyanga",
          y: "umnyaka",
          yy: "%d iminyaka"
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function meridiem(e, t, n) {
          return e < 11 ? "ekuseni" : e < 15 ? "emini" : e < 19 ? "entsambama" : "ebusuku";
        },
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "ekuseni" === t ? e : "emini" === t ? e >= 11 ? e : e + 12 : "entsambama" === t || "ebusuku" === t ? 0 === e ? 0 : e + 12 : void 0;
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: "%d",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("sv", {
        months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),
        monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
        weekdays: "söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),
        weekdaysShort: "sön_mån_tis_ons_tor_fre_lör".split("_"),
        weekdaysMin: "sö_må_ti_on_to_fr_lö".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY-MM-DD",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY [kl.] HH:mm",
          LLLL: "dddd D MMMM YYYY [kl.] HH:mm",
          lll: "D MMM YYYY HH:mm",
          llll: "ddd D MMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Idag] LT",
          nextDay: "[Imorgon] LT",
          lastDay: "[Igår] LT",
          nextWeek: "[På] dddd LT",
          lastWeek: "[I] dddd[s] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "om %s",
          past: "för %s sedan",
          s: "några sekunder",
          ss: "%d sekunder",
          m: "en minut",
          mm: "%d minuter",
          h: "en timme",
          hh: "%d timmar",
          d: "en dag",
          dd: "%d dagar",
          M: "en månad",
          MM: "%d månader",
          y: "ett år",
          yy: "%d år"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = 1 == ~~(e % 100 / 10) ? "e" : 1 === t ? "a" : 2 === t ? "a" : "e";
          return e + n;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("sw", {
        months: "Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),
        monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),
        weekdays: "Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),
        weekdaysShort: "Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),
        weekdaysMin: "J2_J3_J4_J5_Al_Ij_J1".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[leo saa] LT",
          nextDay: "[kesho saa] LT",
          nextWeek: "[wiki ijayo] dddd [saat] LT",
          lastDay: "[jana] LT",
          lastWeek: "[wiki iliyopita] dddd [saat] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s baadaye",
          past: "tokea %s",
          s: "hivi punde",
          ss: "sekunde %d",
          m: "dakika moja",
          mm: "dakika %d",
          h: "saa limoja",
          hh: "masaa %d",
          d: "siku moja",
          dd: "masiku %d",
          M: "mwezi mmoja",
          MM: "miezi %d",
          y: "mwaka mmoja",
          yy: "miaka %d"
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "௧",
        2: "௨",
        3: "௩",
        4: "௪",
        5: "௫",
        6: "௬",
        7: "௭",
        8: "௮",
        9: "௯",
        0: "௦"
      },
          n = {
        "௧": "1",
        "௨": "2",
        "௩": "3",
        "௪": "4",
        "௫": "5",
        "௬": "6",
        "௭": "7",
        "௮": "8",
        "௯": "9",
        "௦": "0"
      };
      e.defineLocale("ta", {
        months: "ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),
        monthsShort: "ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),
        weekdays: "ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை".split("_"),
        weekdaysShort: "ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி".split("_"),
        weekdaysMin: "ஞா_தி_செ_பு_வி_வெ_ச".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY, HH:mm",
          LLLL: "dddd, D MMMM YYYY, HH:mm"
        },
        calendar: {
          sameDay: "[இன்று] LT",
          nextDay: "[நாளை] LT",
          nextWeek: "dddd, LT",
          lastDay: "[நேற்று] LT",
          lastWeek: "[கடந்த வாரம்] dddd, LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s இல்",
          past: "%s முன்",
          s: "ஒரு சில விநாடிகள்",
          ss: "%d விநாடிகள்",
          m: "ஒரு நிமிடம்",
          mm: "%d நிமிடங்கள்",
          h: "ஒரு மணி நேரம்",
          hh: "%d மணி நேரம்",
          d: "ஒரு நாள்",
          dd: "%d நாட்கள்",
          M: "ஒரு மாதம்",
          MM: "%d மாதங்கள்",
          y: "ஒரு வருடம்",
          yy: "%d ஆண்டுகள்"
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function ordinal(e) {
          return e + "வது";
        },
        preparse: function preparse(e) {
          return e.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (e) {
            return n[e];
          });
        },
        postformat: function postformat(e) {
          return e.replace(/\d/g, function (e) {
            return t[e];
          });
        },
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function meridiem(e, t, n) {
          return e < 2 ? " யாமம்" : e < 6 ? " வைகறை" : e < 10 ? " காலை" : e < 14 ? " நண்பகல்" : e < 18 ? " எற்பாடு" : e < 22 ? " மாலை" : " யாமம்";
        },
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "யாமம்" === t ? e < 2 ? e : e + 12 : "வைகறை" === t || "காலை" === t ? e : "நண்பகல்" === t && e >= 10 ? e : e + 12;
        },
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("te", {
        months: "జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్".split("_"),
        monthsShort: "జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.".split("_"),
        monthsParseExact: !0,
        weekdays: "ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం".split("_"),
        weekdaysShort: "ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని".split("_"),
        weekdaysMin: "ఆ_సో_మం_బు_గు_శు_శ".split("_"),
        longDateFormat: {
          LT: "A h:mm",
          LTS: "A h:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY, A h:mm",
          LLLL: "dddd, D MMMM YYYY, A h:mm"
        },
        calendar: {
          sameDay: "[నేడు] LT",
          nextDay: "[రేపు] LT",
          nextWeek: "dddd, LT",
          lastDay: "[నిన్న] LT",
          lastWeek: "[గత] dddd, LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s లో",
          past: "%s క్రితం",
          s: "కొన్ని క్షణాలు",
          ss: "%d సెకన్లు",
          m: "ఒక నిమిషం",
          mm: "%d నిమిషాలు",
          h: "ఒక గంట",
          hh: "%d గంటలు",
          d: "ఒక రోజు",
          dd: "%d రోజులు",
          M: "ఒక నెల",
          MM: "%d నెలలు",
          y: "ఒక సంవత్సరం",
          yy: "%d సంవత్సరాలు"
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: "%dవ",
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "రాత్రి" === t ? e < 4 ? e : e + 12 : "ఉదయం" === t ? e : "మధ్యాహ్నం" === t ? e >= 10 ? e : e + 12 : "సాయంత్రం" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "రాత్రి" : e < 10 ? "ఉదయం" : e < 17 ? "మధ్యాహ్నం" : e < 20 ? "సాయంత్రం" : "రాత్రి";
        },
        week: {
          dow: 0,
          doy: 6
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("tet", {
        months: "Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split("_"),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
        weekdays: "Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),
        weekdaysShort: "Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),
        weekdaysMin: "Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Ohin iha] LT",
          nextDay: "[Aban iha] LT",
          nextWeek: "dddd [iha] LT",
          lastDay: "[Horiseik iha] LT",
          lastWeek: "dddd [semana kotuk] [iha] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "iha %s",
          past: "%s liuba",
          s: "minutu balun",
          ss: "minutu %d",
          m: "minutu ida",
          mm: "minutu %d",
          h: "oras ida",
          hh: "oras %d",
          d: "loron ida",
          dd: "loron %d",
          M: "fulan ida",
          MM: "fulan %d",
          y: "tinan ida",
          yy: "tinan %d"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
          return e + n;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        0: "-ум",
        1: "-ум",
        2: "-юм",
        3: "-юм",
        4: "-ум",
        5: "-ум",
        6: "-ум",
        7: "-ум",
        8: "-ум",
        9: "-ум",
        10: "-ум",
        12: "-ум",
        13: "-ум",
        20: "-ум",
        30: "-юм",
        40: "-ум",
        50: "-ум",
        60: "-ум",
        70: "-ум",
        80: "-ум",
        90: "-ум",
        100: "-ум"
      };
      e.defineLocale("tg", {
        months: "январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_"),
        monthsShort: "янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),
        weekdays: "якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе".split("_"),
        weekdaysShort: "яшб_дшб_сшб_чшб_пшб_ҷум_шнб".split("_"),
        weekdaysMin: "яш_дш_сш_чш_пш_ҷм_шб".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Имрӯз соати] LT",
          nextDay: "[Пагоҳ соати] LT",
          lastDay: "[Дирӯз соати] LT",
          nextWeek: "dddd[и] [ҳафтаи оянда соати] LT",
          lastWeek: "dddd[и] [ҳафтаи гузашта соати] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "баъди %s",
          past: "%s пеш",
          s: "якчанд сония",
          m: "як дақиқа",
          mm: "%d дақиқа",
          h: "як соат",
          hh: "%d соат",
          d: "як рӯз",
          dd: "%d рӯз",
          M: "як моҳ",
          MM: "%d моҳ",
          y: "як сол",
          yy: "%d сол"
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "шаб" === t ? e < 4 ? e : e + 12 : "субҳ" === t ? e : "рӯз" === t ? e >= 11 ? e : e + 12 : "бегоҳ" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "шаб" : e < 11 ? "субҳ" : e < 16 ? "рӯз" : e < 19 ? "бегоҳ" : "шаб";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function ordinal(e) {
          var n = e % 10,
              r = e >= 100 ? 100 : null;
          return e + (t[e] || t[n] || t[r]);
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("th", {
        months: "มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),
        monthsShort: "ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.".split("_"),
        monthsParseExact: !0,
        weekdays: "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),
        weekdaysShort: "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),
        weekdaysMin: "อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "H:mm",
          LTS: "H:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY เวลา H:mm",
          LLLL: "วันddddที่ D MMMM YYYY เวลา H:mm"
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function isPM(e) {
          return "หลังเที่ยง" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "ก่อนเที่ยง" : "หลังเที่ยง";
        },
        calendar: {
          sameDay: "[วันนี้ เวลา] LT",
          nextDay: "[พรุ่งนี้ เวลา] LT",
          nextWeek: "dddd[หน้า เวลา] LT",
          lastDay: "[เมื่อวานนี้ เวลา] LT",
          lastWeek: "[วัน]dddd[ที่แล้ว เวลา] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "อีก %s",
          past: "%sที่แล้ว",
          s: "ไม่กี่วินาที",
          ss: "%d วินาที",
          m: "1 นาที",
          mm: "%d นาที",
          h: "1 ชั่วโมง",
          hh: "%d ชั่วโมง",
          d: "1 วัน",
          dd: "%d วัน",
          M: "1 เดือน",
          MM: "%d เดือน",
          y: "1 ปี",
          yy: "%d ปี"
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("tl-ph", {
        months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
        monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
        weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
        weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
        weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "MM/D/YYYY",
          LL: "MMMM D, YYYY",
          LLL: "MMMM D, YYYY HH:mm",
          LLLL: "dddd, MMMM DD, YYYY HH:mm"
        },
        calendar: {
          sameDay: "LT [ngayong araw]",
          nextDay: "[Bukas ng] LT",
          nextWeek: "LT [sa susunod na] dddd",
          lastDay: "LT [kahapon]",
          lastWeek: "LT [noong nakaraang] dddd",
          sameElse: "L"
        },
        relativeTime: {
          future: "sa loob ng %s",
          past: "%s ang nakalipas",
          s: "ilang segundo",
          ss: "%d segundo",
          m: "isang minuto",
          mm: "%d minuto",
          h: "isang oras",
          hh: "%d oras",
          d: "isang araw",
          dd: "%d araw",
          M: "isang buwan",
          MM: "%d buwan",
          y: "isang taon",
          yy: "%d taon"
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(e) {
          return e;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = "pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_");

      function n(e, n, r, i) {
        var o = function (e) {
          var n = Math.floor(e % 1e3 / 100),
              r = Math.floor(e % 100 / 10),
              i = e % 10,
              o = "";
          return n > 0 && (o += t[n] + "vatlh"), r > 0 && (o += ("" !== o ? " " : "") + t[r] + "maH"), i > 0 && (o += ("" !== o ? " " : "") + t[i]), "" === o ? "pagh" : o;
        }(e);

        switch (r) {
          case "ss":
            return o + " lup";

          case "mm":
            return o + " tup";

          case "hh":
            return o + " rep";

          case "dd":
            return o + " jaj";

          case "MM":
            return o + " jar";

          case "yy":
            return o + " DIS";
        }
      }

      e.defineLocale("tlh", {
        months: "tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’".split("_"),
        monthsShort: "jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’".split("_"),
        monthsParseExact: !0,
        weekdays: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
        weekdaysShort: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
        weekdaysMin: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[DaHjaj] LT",
          nextDay: "[wa’leS] LT",
          nextWeek: "LLL",
          lastDay: "[wa’Hu’] LT",
          lastWeek: "LLL",
          sameElse: "L"
        },
        relativeTime: {
          future: function future(e) {
            var t = e;
            return t = -1 !== e.indexOf("jaj") ? t.slice(0, -3) + "leS" : -1 !== e.indexOf("jar") ? t.slice(0, -3) + "waQ" : -1 !== e.indexOf("DIS") ? t.slice(0, -3) + "nem" : t + " pIq";
          },
          past: function past(e) {
            var t = e;
            return t = -1 !== e.indexOf("jaj") ? t.slice(0, -3) + "Hu’" : -1 !== e.indexOf("jar") ? t.slice(0, -3) + "wen" : -1 !== e.indexOf("DIS") ? t.slice(0, -3) + "ben" : t + " ret";
          },
          s: "puS lup",
          ss: n,
          m: "wa’ tup",
          mm: n,
          h: "wa’ rep",
          hh: n,
          d: "wa’ jaj",
          dd: n,
          M: "wa’ jar",
          MM: n,
          y: "wa’ DIS",
          yy: n
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı"
      };
      e.defineLocale("tr", {
        months: "Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),
        monthsShort: "Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),
        weekdays: "Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),
        weekdaysShort: "Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),
        weekdaysMin: "Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[bugün saat] LT",
          nextDay: "[yarın saat] LT",
          nextWeek: "[gelecek] dddd [saat] LT",
          lastDay: "[dün] LT",
          lastWeek: "[geçen] dddd [saat] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s sonra",
          past: "%s önce",
          s: "birkaç saniye",
          ss: "%d saniye",
          m: "bir dakika",
          mm: "%d dakika",
          h: "bir saat",
          hh: "%d saat",
          d: "bir gün",
          dd: "%d gün",
          M: "bir ay",
          MM: "%d ay",
          y: "bir yıl",
          yy: "%d yıl"
        },
        ordinal: function ordinal(e, n) {
          switch (n) {
            case "d":
            case "D":
            case "Do":
            case "DD":
              return e;

            default:
              if (0 === e) return e + "'ıncı";
              var r = e % 10,
                  i = e % 100 - r,
                  o = e >= 100 ? 100 : null;
              return e + (t[r] || t[i] || t[o]);
          }
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n, r) {
        var i = {
          s: ["viensas secunds", "'iensas secunds"],
          ss: [e + " secunds", e + " secunds"],
          m: ["'n míut", "'iens míut"],
          mm: [e + " míuts", e + " míuts"],
          h: ["'n þora", "'iensa þora"],
          hh: [e + " þoras", e + " þoras"],
          d: ["'n ziua", "'iensa ziua"],
          dd: [e + " ziuas", e + " ziuas"],
          M: ["'n mes", "'iens mes"],
          MM: [e + " mesen", e + " mesen"],
          y: ["'n ar", "'iens ar"],
          yy: [e + " ars", e + " ars"]
        };
        return r ? i[n][0] : t ? i[n][0] : i[n][1];
      }

      e.defineLocale("tzl", {
        months: "Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar".split("_"),
        monthsShort: "Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec".split("_"),
        weekdays: "Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi".split("_"),
        weekdaysShort: "Súl_Lún_Mai_Már_Xhú_Vié_Sát".split("_"),
        weekdaysMin: "Sú_Lú_Ma_Má_Xh_Vi_Sá".split("_"),
        longDateFormat: {
          LT: "HH.mm",
          LTS: "HH.mm.ss",
          L: "DD.MM.YYYY",
          LL: "D. MMMM [dallas] YYYY",
          LLL: "D. MMMM [dallas] YYYY HH.mm",
          LLLL: "dddd, [li] D. MMMM [dallas] YYYY HH.mm"
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function isPM(e) {
          return "d'o" === e.toLowerCase();
        },
        meridiem: function meridiem(e, t, n) {
          return e > 11 ? n ? "d'o" : "D'O" : n ? "d'a" : "D'A";
        },
        calendar: {
          sameDay: "[oxhi à] LT",
          nextDay: "[demà à] LT",
          nextWeek: "dddd [à] LT",
          lastDay: "[ieiri à] LT",
          lastWeek: "[sür el] dddd [lasteu à] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "osprei %s",
          past: "ja%s",
          s: t,
          ss: t,
          m: t,
          mm: t,
          h: t,
          hh: t,
          d: t,
          dd: t,
          M: t,
          MM: t,
          y: t,
          yy: t
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("tzm", {
        months: "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),
        monthsShort: "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),
        weekdays: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
        weekdaysShort: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
        weekdaysMin: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[ⴰⵙⴷⵅ ⴴ] LT",
          nextDay: "[ⴰⵙⴽⴰ ⴴ] LT",
          nextWeek: "dddd [ⴴ] LT",
          lastDay: "[ⴰⵚⴰⵏⵜ ⴴ] LT",
          lastWeek: "dddd [ⴴ] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s",
          past: "ⵢⴰⵏ %s",
          s: "ⵉⵎⵉⴽ",
          ss: "%d ⵉⵎⵉⴽ",
          m: "ⵎⵉⵏⵓⴺ",
          mm: "%d ⵎⵉⵏⵓⴺ",
          h: "ⵙⴰⵄⴰ",
          hh: "%d ⵜⴰⵙⵙⴰⵄⵉⵏ",
          d: "ⴰⵙⵙ",
          dd: "%d oⵙⵙⴰⵏ",
          M: "ⴰⵢoⵓⵔ",
          MM: "%d ⵉⵢⵢⵉⵔⵏ",
          y: "ⴰⵙⴳⴰⵙ",
          yy: "%d ⵉⵙⴳⴰⵙⵏ"
        },
        week: {
          dow: 6,
          doy: 12
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("tzm-latn", {
        months: "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
        monthsShort: "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
        weekdays: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
        weekdaysShort: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
        weekdaysMin: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[asdkh g] LT",
          nextDay: "[aska g] LT",
          nextWeek: "dddd [g] LT",
          lastDay: "[assant g] LT",
          lastWeek: "dddd [g] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "dadkh s yan %s",
          past: "yan %s",
          s: "imik",
          ss: "%d imik",
          m: "minuḍ",
          mm: "%d minuḍ",
          h: "saɛa",
          hh: "%d tassaɛin",
          d: "ass",
          dd: "%d ossan",
          M: "ayowr",
          MM: "%d iyyirn",
          y: "asgas",
          yy: "%d isgasn"
        },
        week: {
          dow: 6,
          doy: 12
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("ug-cn", {
        months: "يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),
        monthsShort: "يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),
        weekdays: "يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە".split("_"),
        weekdaysShort: "يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),
        weekdaysMin: "يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY-MM-DD",
          LL: "YYYY-يىلىM-ئاينىڭD-كۈنى",
          LLL: "YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm",
          LLLL: "dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm"
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "يېرىم كېچە" === t || "سەھەر" === t || "چۈشتىن بۇرۇن" === t ? e : "چۈشتىن كېيىن" === t || "كەچ" === t ? e + 12 : e >= 11 ? e : e + 12;
        },
        meridiem: function meridiem(e, t, n) {
          var r = 100 * e + t;
          return r < 600 ? "يېرىم كېچە" : r < 900 ? "سەھەر" : r < 1130 ? "چۈشتىن بۇرۇن" : r < 1230 ? "چۈش" : r < 1800 ? "چۈشتىن كېيىن" : "كەچ";
        },
        calendar: {
          sameDay: "[بۈگۈن سائەت] LT",
          nextDay: "[ئەتە سائەت] LT",
          nextWeek: "[كېلەركى] dddd [سائەت] LT",
          lastDay: "[تۆنۈگۈن] LT",
          lastWeek: "[ئالدىنقى] dddd [سائەت] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s كېيىن",
          past: "%s بۇرۇن",
          s: "نەچچە سېكونت",
          ss: "%d سېكونت",
          m: "بىر مىنۇت",
          mm: "%d مىنۇت",
          h: "بىر سائەت",
          hh: "%d سائەت",
          d: "بىر كۈن",
          dd: "%d كۈن",
          M: "بىر ئاي",
          MM: "%d ئاي",
          y: "بىر يىل",
          yy: "%d يىل"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "d":
            case "D":
            case "DDD":
              return e + "-كۈنى";

            case "w":
            case "W":
              return e + "-ھەپتە";

            default:
              return e;
          }
        },
        preparse: function preparse(e) {
          return e.replace(/،/g, ",");
        },
        postformat: function postformat(e) {
          return e.replace(/,/g, "،");
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      function t(e, t, n) {
        var r,
            i,
            o = {
          ss: t ? "секунда_секунди_секунд" : "секунду_секунди_секунд",
          mm: t ? "хвилина_хвилини_хвилин" : "хвилину_хвилини_хвилин",
          hh: t ? "година_години_годин" : "годину_години_годин",
          dd: "день_дні_днів",
          MM: "місяць_місяці_місяців",
          yy: "рік_роки_років"
        };
        return "m" === n ? t ? "хвилина" : "хвилину" : "h" === n ? t ? "година" : "годину" : e + " " + (r = +e, i = o[n].split("_"), r % 10 == 1 && r % 100 != 11 ? i[0] : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? i[1] : i[2]);
      }

      function n(e) {
        return function () {
          return e + "о" + (11 === this.hours() ? "б" : "") + "] LT";
        };
      }

      e.defineLocale("uk", {
        months: {
          format: "січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"),
          standalone: "січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_")
        },
        monthsShort: "січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),
        weekdays: function weekdays(e, t) {
          var n = {
            nominative: "неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"),
            accusative: "неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split("_"),
            genitive: "неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split("_")
          };
          if (!0 === e) return n.nominative.slice(1, 7).concat(n.nominative.slice(0, 1));
          if (!e) return n.nominative;
          var r = /(\[[ВвУу]\]) ?dddd/.test(t) ? "accusative" : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(t) ? "genitive" : "nominative";
          return n[r][e.day()];
        },
        weekdaysShort: "нд_пн_вт_ср_чт_пт_сб".split("_"),
        weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD.MM.YYYY",
          LL: "D MMMM YYYY р.",
          LLL: "D MMMM YYYY р., HH:mm",
          LLLL: "dddd, D MMMM YYYY р., HH:mm"
        },
        calendar: {
          sameDay: n("[Сьогодні "),
          nextDay: n("[Завтра "),
          lastDay: n("[Вчора "),
          nextWeek: n("[У] dddd ["),
          lastWeek: function lastWeek() {
            switch (this.day()) {
              case 0:
              case 3:
              case 5:
              case 6:
                return n("[Минулої] dddd [").call(this);

              case 1:
              case 2:
              case 4:
                return n("[Минулого] dddd [").call(this);
            }
          },
          sameElse: "L"
        },
        relativeTime: {
          future: "за %s",
          past: "%s тому",
          s: "декілька секунд",
          ss: t,
          m: t,
          mm: t,
          h: "годину",
          hh: t,
          d: "день",
          dd: t,
          M: "місяць",
          MM: t,
          y: "рік",
          yy: t
        },
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function isPM(e) {
          return /^(дня|вечора)$/.test(e);
        },
        meridiem: function meridiem(e, t, n) {
          return e < 4 ? "ночі" : e < 12 ? "ранку" : e < 17 ? "дня" : "вечора";
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "M":
            case "d":
            case "DDD":
            case "w":
            case "W":
              return e + "-й";

            case "D":
              return e + "-го";

            default:
              return e;
          }
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      var t = ["جنوری", "فروری", "مارچ", "اپریل", "مئی", "جون", "جولائی", "اگست", "ستمبر", "اکتوبر", "نومبر", "دسمبر"],
          n = ["اتوار", "پیر", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"];
      e.defineLocale("ur", {
        months: t,
        monthsShort: t,
        weekdays: n,
        weekdaysShort: n,
        weekdaysMin: n,
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd، D MMMM YYYY HH:mm"
        },
        meridiemParse: /صبح|شام/,
        isPM: function isPM(e) {
          return "شام" === e;
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? "صبح" : "شام";
        },
        calendar: {
          sameDay: "[آج بوقت] LT",
          nextDay: "[کل بوقت] LT",
          nextWeek: "dddd [بوقت] LT",
          lastDay: "[گذشتہ روز بوقت] LT",
          lastWeek: "[گذشتہ] dddd [بوقت] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s بعد",
          past: "%s قبل",
          s: "چند سیکنڈ",
          ss: "%d سیکنڈ",
          m: "ایک منٹ",
          mm: "%d منٹ",
          h: "ایک گھنٹہ",
          hh: "%d گھنٹے",
          d: "ایک دن",
          dd: "%d دن",
          M: "ایک ماہ",
          MM: "%d ماہ",
          y: "ایک سال",
          yy: "%d سال"
        },
        preparse: function preparse(e) {
          return e.replace(/،/g, ",");
        },
        postformat: function postformat(e) {
          return e.replace(/,/g, "،");
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("uz", {
        months: "январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_"),
        monthsShort: "янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),
        weekdays: "Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба".split("_"),
        weekdaysShort: "Якш_Душ_Сеш_Чор_Пай_Жум_Шан".split("_"),
        weekdaysMin: "Як_Ду_Се_Чо_Па_Жу_Ша".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "D MMMM YYYY, dddd HH:mm"
        },
        calendar: {
          sameDay: "[Бугун соат] LT [да]",
          nextDay: "[Эртага] LT [да]",
          nextWeek: "dddd [куни соат] LT [да]",
          lastDay: "[Кеча соат] LT [да]",
          lastWeek: "[Утган] dddd [куни соат] LT [да]",
          sameElse: "L"
        },
        relativeTime: {
          future: "Якин %s ичида",
          past: "Бир неча %s олдин",
          s: "фурсат",
          ss: "%d фурсат",
          m: "бир дакика",
          mm: "%d дакика",
          h: "бир соат",
          hh: "%d соат",
          d: "бир кун",
          dd: "%d кун",
          M: "бир ой",
          MM: "%d ой",
          y: "бир йил",
          yy: "%d йил"
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("uz-latn", {
        months: "Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),
        monthsShort: "Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),
        weekdays: "Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),
        weekdaysShort: "Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),
        weekdaysMin: "Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "D MMMM YYYY, dddd HH:mm"
        },
        calendar: {
          sameDay: "[Bugun soat] LT [da]",
          nextDay: "[Ertaga] LT [da]",
          nextWeek: "dddd [kuni soat] LT [da]",
          lastDay: "[Kecha soat] LT [da]",
          lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
          sameElse: "L"
        },
        relativeTime: {
          future: "Yaqin %s ichida",
          past: "Bir necha %s oldin",
          s: "soniya",
          ss: "%d soniya",
          m: "bir daqiqa",
          mm: "%d daqiqa",
          h: "bir soat",
          hh: "%d soat",
          d: "bir kun",
          dd: "%d kun",
          M: "bir oy",
          MM: "%d oy",
          y: "bir yil",
          yy: "%d yil"
        },
        week: {
          dow: 1,
          doy: 7
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("vi", {
        months: "tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),
        monthsShort: "Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),
        monthsParseExact: !0,
        weekdays: "chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),
        weekdaysShort: "CN_T2_T3_T4_T5_T6_T7".split("_"),
        weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"),
        weekdaysParseExact: !0,
        meridiemParse: /sa|ch/i,
        isPM: function isPM(e) {
          return /^ch$/i.test(e);
        },
        meridiem: function meridiem(e, t, n) {
          return e < 12 ? n ? "sa" : "SA" : n ? "ch" : "CH";
        },
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "DD/MM/YYYY",
          LL: "D MMMM [năm] YYYY",
          LLL: "D MMMM [năm] YYYY HH:mm",
          LLLL: "dddd, D MMMM [năm] YYYY HH:mm",
          l: "DD/M/YYYY",
          ll: "D MMM YYYY",
          lll: "D MMM YYYY HH:mm",
          llll: "ddd, D MMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[Hôm nay lúc] LT",
          nextDay: "[Ngày mai lúc] LT",
          nextWeek: "dddd [tuần tới lúc] LT",
          lastDay: "[Hôm qua lúc] LT",
          lastWeek: "dddd [tuần rồi lúc] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "%s tới",
          past: "%s trước",
          s: "vài giây",
          ss: "%d giây",
          m: "một phút",
          mm: "%d phút",
          h: "một giờ",
          hh: "%d giờ",
          d: "một ngày",
          dd: "%d ngày",
          M: "một tháng",
          MM: "%d tháng",
          y: "một năm",
          yy: "%d năm"
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(e) {
          return e;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("x-pseudo", {
        months: "J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér".split("_"),
        monthsShort: "J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc".split("_"),
        monthsParseExact: !0,
        weekdays: "S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý".split("_"),
        weekdaysShort: "S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát".split("_"),
        weekdaysMin: "S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
          LT: "HH:mm",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY HH:mm",
          LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        calendar: {
          sameDay: "[T~ódá~ý át] LT",
          nextDay: "[T~ómó~rró~w át] LT",
          nextWeek: "dddd [át] LT",
          lastDay: "[Ý~ést~érdá~ý át] LT",
          lastWeek: "[L~ást] dddd [át] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "í~ñ %s",
          past: "%s á~gó",
          s: "á ~féw ~sécó~ñds",
          ss: "%d s~écóñ~ds",
          m: "á ~míñ~úté",
          mm: "%d m~íñú~tés",
          h: "á~ñ hó~úr",
          hh: "%d h~óúrs",
          d: "á ~dáý",
          dd: "%d d~áýs",
          M: "á ~móñ~th",
          MM: "%d m~óñt~hs",
          y: "á ~ýéár",
          yy: "%d ý~éárs"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(e) {
          var t = e % 10,
              n = 1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
          return e + n;
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("yo", {
        months: "Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀".split("_"),
        monthsShort: "Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀".split("_"),
        weekdays: "Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta".split("_"),
        weekdaysShort: "Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá".split("_"),
        weekdaysMin: "Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb".split("_"),
        longDateFormat: {
          LT: "h:mm A",
          LTS: "h:mm:ss A",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY h:mm A",
          LLLL: "dddd, D MMMM YYYY h:mm A"
        },
        calendar: {
          sameDay: "[Ònì ni] LT",
          nextDay: "[Ọ̀la ni] LT",
          nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
          lastDay: "[Àna ni] LT",
          lastWeek: "dddd [Ọsẹ̀ tólọ́] [ni] LT",
          sameElse: "L"
        },
        relativeTime: {
          future: "ní %s",
          past: "%s kọjá",
          s: "ìsẹjú aayá die",
          ss: "aayá %d",
          m: "ìsẹjú kan",
          mm: "ìsẹjú %d",
          h: "wákati kan",
          hh: "wákati %d",
          d: "ọjọ́ kan",
          dd: "ọjọ́ %d",
          M: "osù kan",
          MM: "osù %d",
          y: "ọdún kan",
          yy: "ọdún %d"
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: "ọjọ́ %d",
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("zh-cn", {
        months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
        monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
        weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
        weekdaysMin: "日_一_二_三_四_五_六".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY/MM/DD",
          LL: "YYYY年M月D日",
          LLL: "YYYY年M月D日Ah点mm分",
          LLLL: "YYYY年M月D日ddddAh点mm分",
          l: "YYYY/M/D",
          ll: "YYYY年M月D日",
          lll: "YYYY年M月D日 HH:mm",
          llll: "YYYY年M月D日dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "凌晨" === t || "早上" === t || "上午" === t ? e : "下午" === t || "晚上" === t ? e + 12 : e >= 11 ? e : e + 12;
        },
        meridiem: function meridiem(e, t, n) {
          var r = 100 * e + t;
          return r < 600 ? "凌晨" : r < 900 ? "早上" : r < 1130 ? "上午" : r < 1230 ? "中午" : r < 1800 ? "下午" : "晚上";
        },
        calendar: {
          sameDay: "[今天]LT",
          nextDay: "[明天]LT",
          nextWeek: "[下]ddddLT",
          lastDay: "[昨天]LT",
          lastWeek: "[上]ddddLT",
          sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "d":
            case "D":
            case "DDD":
              return e + "日";

            case "M":
              return e + "月";

            case "w":
            case "W":
              return e + "周";

            default:
              return e;
          }
        },
        relativeTime: {
          future: "%s内",
          past: "%s前",
          s: "几秒",
          ss: "%d 秒",
          m: "1 分钟",
          mm: "%d 分钟",
          h: "1 小时",
          hh: "%d 小时",
          d: "1 天",
          dd: "%d 天",
          M: "1 个月",
          MM: "%d 个月",
          y: "1 年",
          yy: "%d 年"
        },
        week: {
          dow: 1,
          doy: 4
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("zh-hk", {
        months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
        monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
        weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
        weekdaysMin: "日_一_二_三_四_五_六".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY/MM/DD",
          LL: "YYYY年M月D日",
          LLL: "YYYY年M月D日 HH:mm",
          LLLL: "YYYY年M月D日dddd HH:mm",
          l: "YYYY/M/D",
          ll: "YYYY年M月D日",
          lll: "YYYY年M月D日 HH:mm",
          llll: "YYYY年M月D日dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "凌晨" === t || "早上" === t || "上午" === t ? e : "中午" === t ? e >= 11 ? e : e + 12 : "下午" === t || "晚上" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          var r = 100 * e + t;
          return r < 600 ? "凌晨" : r < 900 ? "早上" : r < 1130 ? "上午" : r < 1230 ? "中午" : r < 1800 ? "下午" : "晚上";
        },
        calendar: {
          sameDay: "[今天]LT",
          nextDay: "[明天]LT",
          nextWeek: "[下]ddddLT",
          lastDay: "[昨天]LT",
          lastWeek: "[上]ddddLT",
          sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "d":
            case "D":
            case "DDD":
              return e + "日";

            case "M":
              return e + "月";

            case "w":
            case "W":
              return e + "週";

            default:
              return e;
          }
        },
        relativeTime: {
          future: "%s內",
          past: "%s前",
          s: "幾秒",
          ss: "%d 秒",
          m: "1 分鐘",
          mm: "%d 分鐘",
          h: "1 小時",
          hh: "%d 小時",
          d: "1 天",
          dd: "%d 天",
          M: "1 個月",
          MM: "%d 個月",
          y: "1 年",
          yy: "%d 年"
        }
      });
    }(n(2));
  }, function (e, t, n) {
    !function (e) {
      "use strict";

      e.defineLocale("zh-tw", {
        months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
        monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
        weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
        weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
        weekdaysMin: "日_一_二_三_四_五_六".split("_"),
        longDateFormat: {
          LT: "HH:mm",
          LTS: "HH:mm:ss",
          L: "YYYY/MM/DD",
          LL: "YYYY年M月D日",
          LLL: "YYYY年M月D日 HH:mm",
          LLLL: "YYYY年M月D日dddd HH:mm",
          l: "YYYY/M/D",
          ll: "YYYY年M月D日",
          lll: "YYYY年M月D日 HH:mm",
          llll: "YYYY年M月D日dddd HH:mm"
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(e, t) {
          return 12 === e && (e = 0), "凌晨" === t || "早上" === t || "上午" === t ? e : "中午" === t ? e >= 11 ? e : e + 12 : "下午" === t || "晚上" === t ? e + 12 : void 0;
        },
        meridiem: function meridiem(e, t, n) {
          var r = 100 * e + t;
          return r < 600 ? "凌晨" : r < 900 ? "早上" : r < 1130 ? "上午" : r < 1230 ? "中午" : r < 1800 ? "下午" : "晚上";
        },
        calendar: {
          sameDay: "[今天] LT",
          nextDay: "[明天] LT",
          nextWeek: "[下]dddd LT",
          lastDay: "[昨天] LT",
          lastWeek: "[上]dddd LT",
          sameElse: "L"
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(e, t) {
          switch (t) {
            case "d":
            case "D":
            case "DDD":
              return e + "日";

            case "M":
              return e + "月";

            case "w":
            case "W":
              return e + "週";

            default:
              return e;
          }
        },
        relativeTime: {
          future: "%s內",
          past: "%s前",
          s: "幾秒",
          ss: "%d 秒",
          m: "1 分鐘",
          mm: "%d 分鐘",
          h: "1 小時",
          hh: "%d 小時",
          d: "1 天",
          dd: "%d 天",
          M: "1 個月",
          MM: "%d 個月",
          y: "1 年",
          yy: "%d 年"
        }
      });
    }(n(2));
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(191);
    n.d(t, "defineVisibleColumns", function () {
      return r.b;
    }), n.d(t, "createSearchPage", function () {
      return r.a;
    });
    var i = n(27);
    n.d(t, "useFilter", function () {
      return i.b;
    }), n.d(t, "useQueryParam", function () {
      return i.c;
    }), n.d(t, "useTypeFilter", function () {
      return i.e;
    }), n.d(t, "createColumnsHook", function () {
      return i.a;
    }), n.d(t, "useSearchParams", function () {
      return i.d;
    });
    var o = n(192);

    for (var a in o) {
      ["defineVisibleColumns", "createSearchPage", "useFilter", "useQueryParam", "useTypeFilter", "createColumnsHook", "useSearchParams", "default"].indexOf(a) < 0 && function (e) {
        n.d(t, e, function () {
          return o[e];
        });
      }(a);
    }

    var s = n(20);
    n.d(t, "defaultPagination", function () {
      return s.c;
    }), n.d(t, "SortOrder", function () {
      return s.a;
    }), n.d(t, "createRequestParams", function () {
      return s.b;
    });
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      n.d(t, "b", function () {
        return v;
      }), n.d(t, "a", function () {
        return g;
      });
      var r = n(0),
          i = n.n(r),
          o = n(1),
          a = n(5),
          s = n(229),
          u = n.n(s),
          c = n(18),
          l = n(27),
          h = n(20),
          d = n(7),
          f = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\SearchEntities\\createSearchPage.tsx";

      var p = a.Intl.FormattedMessage,
          m = Object(o.styled)(o.Container)(function (_ref27) {
        var e = _ref27.useMargin;
        return {
          "&": {
            borderRadius: 8,
            margin: e ? "0 40px" : 0,
            minWidth: 716,
            overflow: "hidden"
          }
        };
      }),
          _ = Object(o.styled)(o.Container)(function () {
        return {
          "&": {
            minHeight: "100%"
          }
        };
      }),
          y = Object(o.styled)(o.Button)({
        paddingTop: 8,
        paddingBottom: 8,
        fontWeight: 600
      }),
          v = function v(e, t, n) {
        var r = e.filter(function (e) {
          return !t.includes(e);
        }),
            i = t.filter(function (t) {
          return !e.includes(t);
        });
        return [].concat(_toConsumableArray(n.filter(function (e) {
          return !i.includes(e);
        })), _toConsumableArray(r));
      },
          g = function g(_ref28) {
        var t = _ref28.title,
            n = _ref28.searchTermPlaceholderText,
            s = _ref28.baseQueryRoute,
            g = _ref28.alwaysVisibleColumns,
            b = _ref28.rowKey,
            w = _ref28.defaultSearchQuery,
            T = _ref28.filterHeaderValues,
            M = _ref28.useColumns,
            E = _ref28.parseFilterParams,
            k = _ref28.getDefaultVisibleColumns,
            L = _ref28.getRequestParams,
            S = _ref28.getReportColumns,
            _ref28$useQueryParams = _ref28.useQueryParams,
            N = _ref28$useQueryParams === void 0 ? !0 : _ref28$useQueryParams;
        return a.Intl.injectIntl(function (D) {
          var I = D.searchEntities,
              R = D.isLoading,
              x = D.filterData,
              Y = D.getFilterData,
              C = D.totalCount,
              O = D.isLoadingFilterData,
              F = D.data,
              A = D.intl,
              j = D.onRowSelect,
              U = D.headerStyle,
              P = D.scrollHeight,
              V = D.style,
              W = D.actions,
              H = D.additionalContent,
              B = D.exportAction,
              z = D.exportPermission,
              Z = D.exporting,
              Q = Object(r.useMemo)(function () {
            return D.outerParams || {};
          }, [D.outerParams]),
              G = Object(c.useHistory)();
          var q = w;
          N && (q = Object(l.c)(s), G.location.search || G.push({
            search: "?".concat(s, "=").concat(w)
          }));

          var _Object50 = Object(r.useState)(k(q)),
              _Object51 = _slicedToArray(_Object50, 2),
              J = _Object51[0],
              X = _Object51[1],
              _Object52 = Object(r.useState)(q),
              _Object53 = _slicedToArray(_Object52, 2),
              K = _Object53[0],
              $ = _Object53[1],
              _Object54 = Object(r.useState)(Q),
              _Object55 = _slicedToArray(_Object54, 2),
              ee = _Object55[0],
              te = _Object55[1],
              ne = Object(l.e)(s),
              _Object56 = Object(l.d)(K, Q, L),
              _Object57 = _slicedToArray(_Object56, 2),
              re = _Object57[0],
              ie = _Object57[1],
              oe = Object(r.useMemo)(function () {
            return S ? S(A, J) : [];
          }, [J, A]),
              _Object58 = Object(r.useState)(h.c),
              _Object59 = _slicedToArray(_Object58, 2),
              ae = _Object59[0],
              se = _Object59[1],
              _Object60 = Object(l.b)(re, ie, se),
              _Object61 = _slicedToArray(_Object60, 2),
              ue = _Object61[0],
              ce = _Object61[1],
              le = M(re, ie, G.location.search, q, x),
              he = Object(d.e)(le),
              de = Object(r.useMemo)(function () {
            return J.filter(function (e) {
              return -1 !== he.findIndex(function (t) {
                return t.key === e;
              });
            });
          }, [he, J]),
              fe = Object(r.useMemo)(function () {
            return g.filter(function (e) {
              return -1 !== he.findIndex(function (t) {
                return t.key === e;
              });
            });
          }, [he]);

          Object(r.useEffect)(function () {
            if (q && q !== K) {
              $(q), X(function (e) {
                return v(e, k(K), k(q));
              });

              var _e6 = L(q, G),
                  _t11 = Object(a.mergeProps)(_e6.filter, Q);

              _e6.filter = _t11, ie(_e6), ce(""), se(h.c);
            }
          }, [q, K, Q, ce, ie, G]), Object(r.useEffect)(function () {
            if (!u()(Q, ee)) {
              te(Q);

              var _e7 = L(K, G),
                  _t12 = Object(a.mergeProps)(_e7.filter, Q);

              _e7.filter = _t12, ie(_e7), ce(""), se(h.c);
            }
          }, [ee, Q, K, ie, ce, G]), Object(r.useEffect)(function () {
            K && I(re);
          }, [re, I, K]), Object(r.useEffect)(function () {
            x || R || Y && Y();
          }, [R, x, Y]), ae.total !== C && se(_objectSpread({}, ae, {
            total: C
          }));
          var pe = Object(r.useCallback)(function (e) {
            return {
              onClick: function onClick() {
                j && j(e);
              }
            };
          }, [j]);
          return i.a.createElement(_, {
            padding: t ? [0, 0, 8, 0] : 0,
            __source: {
              fileName: f,
              lineNumber: 362
            },
            __self: void 0
          }, i.a.createElement(o.Flex, {
            padding: t ? [10, 10, 6, 10] : 0,
            direction: "column",
            align: "center",
            __source: {
              fileName: f,
              lineNumber: 363
            },
            __self: void 0
          }, i.a.createElement(o.Flex, {
            style: {
              width: "100%"
            },
            justify: "space-between",
            __source: {
              fileName: f,
              lineNumber: 368
            },
            __self: void 0
          }, t && i.a.createElement(o.FlexItem, {
            flex: 0,
            __source: {
              fileName: f,
              lineNumber: 370
            },
            __self: void 0
          }, i.a.createElement(o.H1, {
            __source: {
              fileName: f,
              lineNumber: 371
            },
            __self: void 0
          }, t)), i.a.createElement(o.FlexItem, {
            flex: 0,
            __source: {
              fileName: f,
              lineNumber: 374
            },
            __self: void 0
          }, i.a.createElement(o.Flex, {
            align: "center",
            gutter: 2,
            __source: {
              fileName: f,
              lineNumber: 375
            },
            __self: void 0
          }, W && W.map(function (e, t) {
            return i.a.createElement(o.FlexItem, {
              flex: 0,
              key: t,
              __source: {
                fileName: f,
                lineNumber: 378
              },
              __self: void 0
            }, e);
          }), B && i.a.createElement(d.a, {
            permission: z,
            __source: {
              fileName: f,
              lineNumber: 383
            },
            __self: void 0
          }, i.a.createElement(y, {
            loading: Z,
            onClick: function onClick() {
              return B({
                params: _objectSpread({}, re, {
                  pager: void 0
                }),
                columns: oe
              });
            },
            __source: {
              fileName: f,
              lineNumber: 384
            },
            __self: void 0
          }, i.a.createElement(p, {
            id: e.modules.actions.export,
            __source: {
              fileName: f,
              lineNumber: 396
            },
            __self: void 0
          })))))), i.a.createElement(o.FlexItem, {
            __source: {
              fileName: f,
              lineNumber: 405
            },
            __self: void 0
          }, H)), i.a.createElement(m, {
            background: "pageSecondary",
            useMargin: !!t,
            __source: {
              fileName: f,
              lineNumber: 407
            },
            __self: void 0
          }, i.a.createElement(o.Container, {
            style: V,
            background: "pageSecondary",
            __source: {
              fileName: f,
              lineNumber: 408
            },
            __self: void 0
          }, i.a.createElement(o.Flex, {
            style: U,
            padding: [7, 7],
            justify: "space-between",
            __source: {
              fileName: f,
              lineNumber: 409
            },
            __self: void 0
          }, i.a.createElement(o.Search, {
            placeholder: n,
            onChange: function onChange(e) {
              return ce(e.target.value);
            },
            value: ue,
            __source: {
              fileName: f,
              lineNumber: 410
            },
            __self: void 0
          }), T && i.a.createElement(o.RadioButtonGroup, {
            defaultValue: q,
            key: String(q),
            onChange: function onChange(e) {
              return ne(e.target.value);
            },
            __source: {
              fileName: f,
              lineNumber: 416
            },
            __self: void 0
          }, i.a.createElement(o.Flex, {
            gutter: 3,
            __source: {
              fileName: f,
              lineNumber: 421
            },
            __self: void 0
          }, T.map(function (_ref29) {
            var e = _ref29.value,
                t = _ref29.label,
                n = _ref29.icon;
            return i.a.createElement(o.RadioButton, {
              value: e,
              key: String(e),
              __source: {
                fileName: f,
                lineNumber: 423
              },
              __self: void 0
            }, !!n && i.a.createElement(o.Icon, {
              type: n,
              textual: !0,
              __source: {
                fileName: f,
                lineNumber: 424
              },
              __self: void 0
            }), i.a.createElement(o.Text, {
              __source: {
                fileName: f,
                lineNumber: 425
              },
              __self: void 0
            }, t));
          })))), i.a.createElement(o.Table, {
            scroll: {
              y: P,
              x: !0
            },
            visibleColumns: de,
            alwaysVisibleColumns: fe,
            loading: R || O,
            dataSource: O ? [] : F,
            columns: he,
            onChange: function onChange(_ref30, n, r) {
              var e = _ref30.pageSize,
                  t = _ref30.current;

              var i = _objectSpread({}, re);

              se({
                pageSize: e,
                current: t
              });
              var o = e || h.c.pageSize;
              i.pager = {
                limit: o,
                offset: ((t || h.c.current) - 1) * o
              }, r.columnKey && (i.sorter = [{
                fieldName: r.columnKey,
                direction: "descend" === r.order ? 0 : 1
              }]), i.filter = Object(a.mergeProps)(E(n, le, i.filter), Q), ie(i);
            },
            pagination: ae,
            rowKey: b,
            onRow: pe,
            saveButtonText: A.formatMessage({
              id: e.vms.actions.apply
            }),
            cancelButtonText: A.formatMessage({
              id: e.vms.actions.cancel
            }),
            onVisibleColumnsChange: X,
            __source: {
              fileName: f,
              lineNumber: 432
            },
            __self: void 0
          }))));
        });
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t) {}, function (e, t, n) {
    "use strict";

    var r = n(194);
    n.d(t, "a", function () {
      return r.a;
    });
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(2),
          a = n.n(o),
          s = n(1),
          u = n(5),
          c = n(35),
          l = n(50),
          h = n(230),
          d = n(231),
          f = n(7),
          p = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Notes\\Notes.tsx";
      var _h$a = h.a,
          m = _h$a.mergeNotes,
          _ = _h$a.removeNoteFromArray,
          y = _h$a.getInitials,
          _d$a = d.a,
          v = _d$a.fetchLatestNotes,
          g = _d$a.deleteNote,
          b = _d$a.submitNote,
          w = _d$a.editNote,
          _u$Intl = u.Intl,
          T = _u$Intl.FormattedMessage,
          M = _u$Intl.injectIntl,
          E = s.styled.div(function (_ref31) {
        var e = _ref31.theme.newColors;
        return {
          width: "100%",
          margin: 0,
          padding: "38px 0",
          textAlign: "center",
          borderTop: "1px solid ".concat(e.borderWidgetPrimary),
          borderBottom: "1px solid ".concat(e.borderWidgetPrimary)
        };
      });
      t.a = M(function (_ref32) {
        var t = _ref32.intl,
            n = _ref32.userName,
            o = _ref32.type,
            u = _ref32.referenceId,
            h = _ref32.editPermission,
            d = _ref32.onDelete,
            M = _ref32.onEdit,
            k = _ref32.onSubmit;

        var _Object62 = Object(r.useReducer)(l.b, l.a),
            _Object63 = _slicedToArray(_Object62, 2),
            _Object63$ = _Object63[0],
            L = _Object63$.notes,
            S = _Object63$.canLoadMore,
            N = _Object63$.loading,
            D = _Object63$.active,
            I = _Object63$.body,
            R = _Object63[1],
            x = L || [],
            Y = Object(r.useRef)(!0),
            C = Object(r.useRef)(null),
            O = Object(r.useCallback)(function () {
          return setTimeout(function () {
            C.current && C.current.scrollIntoView && C.current.scrollIntoView({
              behavior: "smooth"
            });
          }, 100);
        }, []);

        Object(r.useEffect)(function () {
          R({
            type: "setLoading",
            payload: !0
          }), v(o, u, 0, 11).then(function (e) {
            var t = !1;
            e.length > 10 && (t = !0, e.pop()), R({
              type: "setCanLoadMore",
              payload: t
            }), R({
              type: "setNotes",
              payload: e
            }), R({
              type: "setLoading",
              payload: !1
            });
          });
        }, [u, o]), Object(r.useEffect)(function () {
          !N && (null == x ? void 0 : x.length) && (Y.current && O(), R({
            type: "setBody",
            payload: ""
          }), R({
            type: "setActive",
            payload: !1
          }), Y.current = !1);
        }, [N, x, O]);

        var F = Object(r.useCallback)(function (e) {
          R({
            type: "setActive",
            payload: e
          }), e && O();
        }, [O]),
            A = function A(e, t) {
          R({
            type: "setLoading",
            payload: !0
          }), v(o, u, e, t).then(function (e) {
            R({
              type: "setNotes",
              payload: m(x, e)
            }), R({
              type: "setCanLoadMore",
              payload: !1
            }), R({
              type: "setLoading",
              payload: !1
            });
          });
        };

        return i.a.createElement(s.Flex, {
          direction: "column",
          gutter: 2,
          gutterDirection: "vertical",
          padding: [4, 0],
          onClick: function onClick() {
            return F(!1);
          },
          __source: {
            fileName: p,
            lineNumber: 187
          },
          __self: void 0
        }, i.a.createElement(s.FlexItem, {
          __source: {
            fileName: p,
            lineNumber: 194
          },
          __self: void 0
        }, 0 === x.length && i.a.createElement(s.EmptyState, {
          description: i.a.createElement(T, {
            id: e.modules.comments.empty,
            __source: {
              fileName: p,
              lineNumber: 198
            },
            __self: void 0
          }),
          __source: {
            fileName: p,
            lineNumber: 196
          },
          __self: void 0
        }), x.map(function (_ref33) {
          var e = _ref33.body,
              t = _ref33.canDelete,
              n = _ref33.canEdit,
              r = _ref33.createdBy,
              o = _ref33.createdOn,
              u = _ref33.id;
          return i.a.createElement(c.a, {
            key: u,
            author: r.name,
            avatar: i.a.createElement(s.Avatar, {
              __source: {
                fileName: p,
                lineNumber: 206
              },
              __self: void 0
            }, y(r.name)),
            content: e,
            datetime: o && a()(o).toISOString(),
            onDelete: t ? function () {
              return function (e) {
                N || (R({
                  type: "setLoading",
                  payload: !0
                }), g(e).then(function () {
                  R({
                    type: "setLoading",
                    payload: !1
                  }), R({
                    type: "setNotes",
                    payload: _(x, e)
                  }), d && d(e);
                }));
              }(u);
            } : void 0,
            onEdit: n ? function (e) {
              return function (e, t) {
                if (!N) {
                  var _n11 = x.map(function (n) {
                    return n.id === e ? _objectSpread({}, n, {
                      body: t
                    }) : n;
                  });

                  R({
                    type: "setNotes",
                    payload: _n11
                  }), R({
                    type: "setLoading",
                    payload: !0
                  }), w(e, t).then(function () {
                    R({
                      type: "setLoading",
                      payload: !1
                    }), R({
                      type: "setLatestNotes",
                      payload: void 0
                    }), M && M(e);
                  }).catch(function () {
                    R({
                      type: "setNotes",
                      payload: x
                    });
                  });
                }
              }(u, e);
            } : void 0,
            editAndDeletePermission: h,
            __source: {
              fileName: p,
              lineNumber: 203
            },
            __self: void 0
          });
        })), i.a.createElement(s.FlexItem, {
          align: "center",
          __source: {
            fileName: p,
            lineNumber: 215
          },
          __self: void 0
        }, N ? i.a.createElement(s.Spinner, {
          size: "small",
          __source: {
            fileName: p,
            lineNumber: 216
          },
          __self: void 0
        }) : null), i.a.createElement(s.FlexItem, {
          __source: {
            fileName: p,
            lineNumber: 218
          },
          __self: void 0
        }, !N && S && i.a.createElement(E, {
          __source: {
            fileName: p,
            lineNumber: 220
          },
          __self: void 0
        }, i.a.createElement(s.Button, {
          onClick: function onClick() {
            return A(x.length, 100);
          },
          __source: {
            fileName: p,
            lineNumber: 221
          },
          __self: void 0
        }, i.a.createElement(s.Text, {
          weight: 600,
          __source: {
            fileName: p,
            lineNumber: 222
          },
          __self: void 0
        }, i.a.createElement(T, {
          id: e.modules.notes.loadMore,
          __source: {
            fileName: p,
            lineNumber: 223
          },
          __self: void 0
        }))))), i.a.createElement("div", {
          ref: C,
          __source: {
            fileName: p,
            lineNumber: 229
          },
          __self: void 0
        }), i.a.createElement(f.a, {
          permission: h,
          __source: {
            fileName: p,
            lineNumber: 230
          },
          __self: void 0
        }, i.a.createElement(s.Affix, {
          offsetBottom: 0,
          __source: {
            fileName: p,
            lineNumber: 231
          },
          __self: void 0
        }, i.a.createElement(s.Container, {
          gutter: 5,
          gutterDirection: "vertical",
          background: "pageSecondary",
          padding: [2, 0],
          overflow: "hidden",
          __source: {
            fileName: p,
            lineNumber: 232
          },
          __self: void 0
        }, i.a.createElement(s.Flex, {
          gutter: 2,
          align: "center",
          __source: {
            fileName: p,
            lineNumber: 239
          },
          __self: void 0
        }, n && i.a.createElement(s.Avatar, {
          __source: {
            fileName: p,
            lineNumber: 240
          },
          __self: void 0
        }, y(n)), i.a.createElement("div", {
          onClick: function onClick(e) {
            e.stopPropagation(), F(!0);
          },
          style: {
            width: "100%"
          },
          __source: {
            fileName: p,
            lineNumber: 241
          },
          __self: void 0
        }, i.a.createElement(s.RichTextEditor, {
          readOnly: N || !D,
          rows: D ? 3 : 1,
          modules: {
            toolbar: D
          },
          onChange: function onChange(e) {
            return R({
              type: "setBody",
              payload: e
            });
          },
          placeholder: t.formatMessage({
            id: e.modules.notes.addCommentPlaceholder
          }),
          value: I,
          __source: {
            fileName: p,
            lineNumber: 248
          },
          __self: void 0
        }))), i.a.createElement(s.Flex, {
          gutter: 2,
          justify: "flex-end",
          hidden: !D,
          __source: {
            fileName: p,
            lineNumber: 265
          },
          __self: void 0
        }, i.a.createElement(s.Button, {
          disabled: N,
          __source: {
            fileName: p,
            lineNumber: 266
          },
          __self: void 0
        }, i.a.createElement(s.Text, {
          weight: 600,
          __source: {
            fileName: p,
            lineNumber: 267
          },
          __self: void 0
        }, i.a.createElement(T, {
          id: e.modules.notes.cancel,
          __source: {
            fileName: p,
            lineNumber: 268
          },
          __self: void 0
        }))), i.a.createElement(s.Button, {
          disabled: N || "" === I || "<p><br></p>" === I,
          loading: N,
          type: "primary",
          onClick: function onClick() {
            return void (N || (R({
              type: "setLoading",
              payload: !0
            }), b(o, u, I).then(function () {
              A(0, x.length + 1), R({
                type: "setLoading",
                payload: !1
              }), R({
                type: "setBody",
                payload: ""
              }), k && k(I), O();
            })));
          },
          __source: {
            fileName: p,
            lineNumber: 271
          },
          __self: void 0
        }, i.a.createElement(s.Text, {
          weight: 600,
          color: "bodyTertiary",
          __source: {
            fileName: p,
            lineNumber: 277
          },
          __self: void 0
        }, i.a.createElement(T, {
          id: e.modules.notes.send,
          __source: {
            fileName: p,
            lineNumber: 278
          },
          __self: void 0
        }))))))));
      });
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(1),
          a = n(5),
          s = n(31),
          u = n.n(s),
          c = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Error\\GenericError.tsx";
      t.a = Object(o.styled)(function () {
        return i.a.createElement(o.Flex, {
          gutter: 4,
          gutterDirection: "vertical",
          direction: "column",
          align: "center",
          stretch: !0,
          padding: [12, 0, 0, 0],
          __source: {
            fileName: c,
            lineNumber: 11
          },
          __self: void 0
        }, i.a.createElement(o.FlexItem, {
          flex: 0,
          padding: [12, 0, 0, 0],
          __source: {
            fileName: c,
            lineNumber: 19
          },
          __self: void 0
        }, i.a.createElement("img", {
          src: u.a,
          alt: "Generic error",
          __source: {
            fileName: c,
            lineNumber: 20
          },
          __self: void 0
        })), i.a.createElement(o.FlexItem, {
          flex: 0,
          __source: {
            fileName: c,
            lineNumber: 22
          },
          __self: void 0
        }, i.a.createElement(o.H1, {
          __source: {
            fileName: c,
            lineNumber: 23
          },
          __self: void 0
        }, i.a.createElement(a.Intl.FormattedMessage, {
          id: e.modules.error.genericTitle,
          __source: {
            fileName: c,
            lineNumber: 24
          },
          __self: void 0
        }))), i.a.createElement(o.FlexItem, {
          flex: 0,
          gutter: 12,
          gutterDirection: "vertical",
          __source: {
            fileName: c,
            lineNumber: 27
          },
          __self: void 0
        }, i.a.createElement(o.Text, {
          align: "center",
          inline: !1,
          __source: {
            fileName: c,
            lineNumber: 28
          },
          __self: void 0
        }, i.a.createElement(a.Intl.FormattedMessage, {
          id: e.modules.error.genericMessage,
          __source: {
            fileName: c,
            lineNumber: 29
          },
          __self: void 0
        })), i.a.createElement(o.Flex, {
          justify: "center",
          __source: {
            fileName: c,
            lineNumber: 31
          },
          __self: void 0
        }, i.a.createElement(o.Button, {
          type: "primary",
          onClick: function onClick() {
            return window.location.reload();
          },
          __source: {
            fileName: c,
            lineNumber: 32
          },
          __self: void 0
        }, i.a.createElement(a.Intl.FormattedMessage, {
          id: e.modules.error.genericTryAgain,
          __source: {
            fileName: c,
            lineNumber: 33
          },
          __self: void 0
        })))));
      })();
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(1),
          a = n(5),
          s = n(31),
          u = n.n(s),
          c = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Error\\Page404.tsx";
      t.a = Object(o.styled)(function () {
        return i.a.createElement(o.Flex, {
          gutter: 4,
          gutterDirection: "vertical",
          direction: "column",
          align: "center",
          stretch: !0,
          padding: [12, 0, 0, 0],
          __source: {
            fileName: c,
            lineNumber: 10
          },
          __self: void 0
        }, i.a.createElement(o.FlexItem, {
          flex: 0,
          padding: [12, 0, 0, 0],
          __source: {
            fileName: c,
            lineNumber: 18
          },
          __self: void 0
        }, i.a.createElement("img", {
          src: u.a,
          alt: "Generic error",
          __source: {
            fileName: c,
            lineNumber: 19
          },
          __self: void 0
        })), i.a.createElement(o.FlexItem, {
          flex: 0,
          __source: {
            fileName: c,
            lineNumber: 21
          },
          __self: void 0
        }, i.a.createElement(o.H1, {
          __source: {
            fileName: c,
            lineNumber: 22
          },
          __self: void 0
        }, i.a.createElement(a.Intl.FormattedMessage, {
          id: e.modules.error.page404Title,
          __source: {
            fileName: c,
            lineNumber: 23
          },
          __self: void 0
        }))), i.a.createElement(o.FlexItem, {
          flex: 0,
          gutter: 12,
          gutterDirection: "vertical",
          __source: {
            fileName: c,
            lineNumber: 26
          },
          __self: void 0
        }, i.a.createElement(o.Button, {
          type: "primary",
          onClick: function onClick() {
            return window.location.replace("/");
          },
          __source: {
            fileName: c,
            lineNumber: 27
          },
          __self: void 0
        }, i.a.createElement(a.Intl.FormattedMessage, {
          id: e.modules.error.page404GoHome,
          __source: {
            fileName: c,
            lineNumber: 28
          },
          __self: void 0
        }))));
      })();
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(1),
          a = n(5),
          s = n(31),
          u = n.n(s),
          c = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Error\\PageUnauthorized.tsx";
      t.a = Object(o.styled)(function () {
        return i.a.createElement(o.Flex, {
          gutter: 4,
          gutterDirection: "vertical",
          direction: "column",
          align: "center",
          stretch: !0,
          padding: [12, 0, 0, 0],
          __source: {
            fileName: c,
            lineNumber: 10
          },
          __self: void 0
        }, i.a.createElement(o.FlexItem, {
          flex: 0,
          padding: [12, 0, 0, 0],
          __source: {
            fileName: c,
            lineNumber: 18
          },
          __self: void 0
        }, i.a.createElement("img", {
          src: u.a,
          alt: "Unauthorized",
          __source: {
            fileName: c,
            lineNumber: 19
          },
          __self: void 0
        })), i.a.createElement(o.FlexItem, {
          flex: 0,
          __source: {
            fileName: c,
            lineNumber: 21
          },
          __self: void 0
        }, i.a.createElement(o.H1, {
          __source: {
            fileName: c,
            lineNumber: 22
          },
          __self: void 0
        }, i.a.createElement(a.Intl.FormattedMessage, {
          id: e.modules.error.pageUnauthorizedTitle,
          __source: {
            fileName: c,
            lineNumber: 23
          },
          __self: void 0
        }))), i.a.createElement(o.FlexItem, {
          flex: 0,
          gutter: 12,
          gutterDirection: "vertical",
          __source: {
            fileName: c,
            lineNumber: 28
          },
          __self: void 0
        }, i.a.createElement(o.Button, {
          type: "primary",
          onClick: function onClick() {
            return window.location.replace("/");
          },
          __source: {
            fileName: c,
            lineNumber: 29
          },
          __self: void 0
        }, i.a.createElement(a.Intl.FormattedMessage, {
          id: e.modules.error.pageUnauthorizedGoHome,
          __source: {
            fileName: c,
            lineNumber: 30
          },
          __self: void 0
        }))));
      })();
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    var r = n(199);
    n.d(t, "a", function () {
      return r.a;
    });
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(5),
          a = n(1),
          s = n(232),
          u = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\AttachmentsPreview\\AttachmentsPreview.tsx";

      var c = o.Intl.FormattedMessage,
          l = function l(_ref34) {
        var e = _ref34.title,
            t = _ref34.subtitle;
        return i.a.createElement(i.a.Fragment, {
          __source: {
            fileName: u,
            lineNumber: 26
          },
          __self: void 0
        }, i.a.createElement(a.H1, {
          color: "headerTertiary",
          align: "center",
          __source: {
            fileName: u,
            lineNumber: 27
          },
          __self: void 0
        }, e), i.a.createElement(a.H3, {
          align: "center",
          __source: {
            fileName: u,
            lineNumber: 30
          },
          __self: void 0
        }, t));
      },
          h = Object(a.styled)(a.Tabs)(function (_ref35) {
        var e = _ref35.theme.newColors;
        return Object(a.ant)({
          "&": {
            height: "100%"
          },
          ".tabs-tab-active": {
            backgroundColor: e.bgRowHover
          }
        });
      }),
          d = Object(a.styled)(a.Spinner)({
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      }),
          f = Object(a.styled)(a.TabPane)({
        height: "100%"
      });

      t.a = function (_ref36) {
        var t = _ref36.isVisible,
            n = _ref36.setVisibility,
            r = _ref36.isLoading,
            o = _ref36.attachments,
            p = _ref36.subtitle,
            m = _ref36.defaultActive;
        return i.a.createElement(a.Modal, {
          width: "60%",
          bodyStyle: {
            height: "80vh",
            padding: 0
          },
          pageTitle: i.a.createElement(l, {
            subtitle: p || "",
            title: i.a.createElement(c, {
              id: e.vms.matchRecord.credentials.attachmentsModal.pageTitle,
              __source: {
                fileName: u,
                lineNumber: 84
              },
              __self: void 0
            }),
            __source: {
              fileName: u,
              lineNumber: 81
            },
            __self: void 0
          }),
          visible: t,
          footer: null,
          onOk: function onOk() {
            n(!1);
          },
          onCancel: function onCancel() {
            return n(!1);
          },
          destroyOnClose: !0,
          __source: {
            fileName: u,
            lineNumber: 74
          },
          __self: void 0
        }, r ? i.a.createElement(d, {
          spinning: r,
          __source: {
            fileName: u,
            lineNumber: 102
          },
          __self: void 0
        }) : i.a.createElement(h, {
          tabPosition: "left",
          inkColor: "unset",
          tabBarStyle: {
            width: "20%",
            boxShadow: "0px 8px 24px rgba(11, 79, 169, 0.06)",
            borderRight: "none"
          },
          tabBarGutter: 0,
          tabHeight: "61px",
          defaultActiveKey: m || o[0].id,
          __source: {
            fileName: u,
            lineNumber: 104
          },
          __self: void 0
        }, o.map(function (e) {
          return i.a.createElement(f, {
            key: e.id,
            borderTop: "none",
            tab: i.a.createElement(a.Flex, {
              align: "center",
              stretch: !0,
              __source: {
                fileName: u,
                lineNumber: 121
              },
              __self: void 0
            }, i.a.createElement(a.H3, {
              weight: 700,
              color: "linkPrimary",
              __source: {
                fileName: u,
                lineNumber: 122
              },
              __self: void 0
            }, e.name)),
            __source: {
              fileName: u,
              lineNumber: 117
            },
            __self: void 0
          }, i.a.createElement(s.a, {
            attachment: e,
            __source: {
              fileName: u,
              lineNumber: 128
            },
            __self: void 0
          }));
        })));
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return o;
    });
    var r = n(14),
        i = n(41);

    function o(e) {
      var t, n;
      return _regeneratorRuntime.async(function o$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return _regeneratorRuntime.awrap(Object(i.c)());

            case 2:
              t = _context28.sent;
              n = {
                contactId: e,
                dataPreferences: {
                  companies: t.companies,
                  option: t.dataLevel,
                  positionTypes: t.positionTypeIds
                }
              };
              r.a.getInstance().settings = n;

            case 5:
            case "end":
              return _context28.stop();
          }
        }
      });
    }
  }, function (e, t) {}, function (e, t, n) {
    "use strict";

    var r = n(203);
    n.d(t, "a", function () {
      return r.a;
    });
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(2),
          a = n.n(o),
          s = n(5),
          u = n(1),
          c = n(22),
          l = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\DynamicLabels\\DynamicLabels.tsx";
      var h = s.Intl.FormattedMessage;

      t.a = function (_ref37) {
        var t = _ref37.label,
            n = _ref37.value;
        return i.a.createElement(u.Flex, {
          gutterDirection: "vertical",
          gutter: 4,
          __source: {
            fileName: l,
            lineNumber: 50
          },
          __self: void 0
        }, i.a.createElement(u.FlexItem, {
          basis: "70%",
          __source: {
            fileName: l,
            lineNumber: 51
          },
          __self: void 0
        }, i.a.createElement(u.Text, {
          color: "bodySecondary",
          uppercase: !0,
          inline: !0,
          __source: {
            fileName: l,
            lineNumber: 52
          },
          __self: void 0
        }, Object(s.camelToTitle)(t))), i.a.createElement(u.FlexItem, {
          basis: "30%",
          __source: {
            fileName: l,
            lineNumber: 56
          },
          __self: void 0
        }, i.a.createElement(u.Text, {
          inline: !0,
          __source: {
            fileName: l,
            lineNumber: 57
          },
          __self: void 0
        }, function (t) {
          switch (typeof t) {
            case "boolean":
              return t ? i.a.createElement(h, {
                id: e.modules.dynamicLabels.yes,
                __source: {
                  fileName: l,
                  lineNumber: 14
                },
                __self: this
              }) : i.a.createElement(h, {
                id: e.modules.dynamicLabels.no,
                __source: {
                  fileName: l,
                  lineNumber: 16
                },
                __self: this
              });

            case "string":
              return Date.parse(t) ? a()(String(t)).format("MM/DD/YYYY") : t || "/";

            case "object":
              return Array.isArray(t) ? Object(c.c)(t) ? t.map(function (e) {
                return e.name;
              }).join(", ") : t.length ? "".concat(t[0], " ").concat(t[1]) : "/" : Object(c.b)(t) ? t.name : "/";

            default:
              return t && String(t) || "/";
          }
        }(n))));
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      n.d(t, "a", function () {
        return _;
      });
      var r = n(0),
          i = n.n(r),
          o = n(30),
          a = n.n(o),
          s = n(5),
          u = n(1),
          c = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\LoadMoreSelect.tsx";

      var l = 10,
          h = {
        offset: 0,
        limit: l
      },
          d = function d(t, n, o, a) {
        return Object(r.useMemo)(function () {
          var r = t.map(function (e) {
            return i.a.createElement(u.Option, {
              key: e.id,
              value: e.id,
              __source: {
                fileName: c,
                lineNumber: 27
              },
              __self: void 0
            }, e.name);
          });
          return n && !o && r.push(i.a.createElement(u.Option, {
            disabled: !0,
            key: "loadMore",
            __source: {
              fileName: c,
              lineNumber: 34
            },
            __self: void 0
          }, i.a.createElement(u.A, {
            onClick: a,
            __source: {
              fileName: c,
              lineNumber: 35
            },
            __self: void 0
          }, i.a.createElement(s.Intl.FormattedMessage, {
            id: e.vms.settings.loadMore,
            __source: {
              fileName: c,
              lineNumber: 36
            },
            __self: void 0
          })))), o && r.push(i.a.createElement(u.Option, {
            disabled: !0,
            key: "loadMore",
            __source: {
              fileName: c,
              lineNumber: 44
            },
            __self: void 0
          }, i.a.createElement(u.Spinner, {
            size: "small",
            __source: {
              fileName: c,
              lineNumber: 45
            },
            __self: void 0
          }))), r;
        }, [t, o, n, a]);
      },
          f = function f(e) {
        return _objectSpread({}, e, {
          offset: e.offset + l
        });
      },
          p = function p(e, t) {
        return Array.from([].concat(_toConsumableArray(e), _toConsumableArray(t)).reduce(function (e, t) {
          return e.set(t.id, t), e;
        }, new Map()).values()).sort(function (e, t) {
          return e.name.localeCompare(t.name);
        });
      },
          m = 800;

      function _(e) {
        var t = e.fetchEntities,
            n = e.injectFilter,
            o = e.onChange,
            s = e.defaultSelection,
            _ = e.getDefaultSelectionFilter,
            _Object64 = Object(r.useState)([]),
            _Object65 = _slicedToArray(_Object64, 2),
            y = _Object65[0],
            v = _Object65[1],
            _Object66 = Object(r.useState)(s || []),
            _Object67 = _slicedToArray(_Object66, 2),
            g = _Object67[0],
            b = _Object67[1],
            _Object68 = Object(r.useState)([]),
            _Object69 = _slicedToArray(_Object68, 2),
            w = _Object69[0],
            T = _Object69[1],
            _Object70 = Object(r.useState)(!1),
            _Object71 = _slicedToArray(_Object70, 2),
            M = _Object71[0],
            E = _Object71[1],
            _Object72 = Object(r.useState)(!0),
            _Object73 = _slicedToArray(_Object72, 2),
            k = _Object73[0],
            L = _Object73[1],
            _Object74 = Object(r.useState)(!1),
            _Object75 = _slicedToArray(_Object74, 2),
            S = _Object75[0],
            N = _Object75[1],
            D = Object(r.useRef)(!0),
            I = Object(r.useRef)(h);

        Object(r.useEffect)(function () {
          s && s.length > 0 && _ && function _callee9(e) {
            var r, i;
            return _regeneratorRuntime.async(function _callee9$(_context29) {
              while (1) {
                switch (_context29.prev = _context29.next) {
                  case 0:
                    r = e();
                    n && (r = _objectSpread({}, r, {}, n()));
                    _context29.next = 4;
                    return _regeneratorRuntime.awrap(t({
                      filter: r,
                      pagination: {
                        limit: 100,
                        offset: 0
                      }
                    }));

                  case 4:
                    i = _context29.sent;
                    v(i), T(i);

                  case 6:
                  case "end":
                    return _context29.stop();
                }
              }
            });
          }(_);
        }, []);
        var R = Object(r.useCallback)(function _callee10(e) {
          var r;
          return _regeneratorRuntime.async(function _callee10$(_context30) {
            while (1) {
              switch (_context30.prev = _context30.next) {
                case 0:
                  I.current = e ? h : f(I.current), N(!e), E(e);
                  _context30.next = 3;
                  return _regeneratorRuntime.awrap(t({
                    filter: n ? n() : void 0,
                    pagination: I.current
                  }));

                case 3:
                  r = _context30.sent;
                  v(p(e ? r : [].concat(_toConsumableArray(y), _toConsumableArray(r)), w)), L(r.length === l), E(!1), N(!1);

                case 5:
                case "end":
                  return _context30.stop();
              }
            }
          });
        }, [t, n, y, w]),
            x = Object(r.useCallback)(function () {
          R(!1);
        }, [R]),
            Y = Object(r.useCallback)(function (e) {
          e && D.current && (R(!0), D.current = !1);
        }, [R]),
            C = Object(r.useCallback)(function (e) {
          b(e);
          var t = y.filter(function (t) {
            return -1 !== e.indexOf(t.id);
          });
          T(p(w.filter(function (t) {
            return -1 !== e.indexOf(t.id);
          }), t));
        }, [T, y, w]),
            O = Object(r.useCallback)(a()(function _callee11(e) {
          var r;
          return _regeneratorRuntime.async(function _callee11$(_context31) {
            while (1) {
              switch (_context31.prev = _context31.next) {
                case 0:
                  E(!0), L(!1), D.current = !0;
                  _context31.next = 3;
                  return _regeneratorRuntime.awrap(t({
                    filter: n ? n() : void 0,
                    searchTerm: e,
                    pagination: {
                      limit: 100,
                      offset: 0
                    }
                  }));

                case 3:
                  r = _context31.sent;
                  v(r), E(!1);

                case 5:
                case "end":
                  return _context31.stop();
              }
            }
          });
        }, m), []);
        Object(r.useEffect)(function () {
          o && o(g);
        }, [o, g]);
        var F = d(y, k, S, x);
        return i.a.createElement(u.Select, {
          mode: "multiple",
          defaultValue: g,
          onChange: C,
          maxTagCount: 5,
          allowClear: !1,
          showArrow: !0,
          onSearch: O,
          filterOption: !1,
          defaultActiveFirstOption: !1,
          onDropdownVisibleChange: Y,
          __source: {
            fileName: c,
            lineNumber: 213
          },
          __self: this
        }, M ? [i.a.createElement(u.Option, {
          key: "loading",
          __source: {
            fileName: c,
            lineNumber: 227
          },
          __self: this
        }, i.a.createElement(u.Spinner, {
          size: "small",
          __source: {
            fileName: c,
            lineNumber: 228
          },
          __self: this
        }))] : F);
      }
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return r;
    });
    var r = 4;
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return u;
    });
    var r = n(0),
        i = n.n(r),
        o = n(7),
        a = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\utils.tsx";

    function s() {
      return (s = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var u = function u(e, t) {
      return function (n) {
        return i.a.createElement(o.b.Provider, {
          value: {
            permissions: new Set(t),
            refresh: function refresh() {}
          },
          __source: {
            fileName: a,
            lineNumber: 8
          },
          __self: void 0
        }, i.a.createElement(e, s({}, n, {
          __source: {
            fileName: a,
            lineNumber: 11
          },
          __self: void 0
        })));
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(38).a,
        i = n(39).a,
        o = n(0),
        a = n.n(o),
        s = n(1),
        u = n(30),
        c = n.n(u),
        l = n(8),
        h = n(14),
        d = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Table\\Filters.tsx";

    function f() {
      return (f = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var p = {
      limit: 20,
      offset: 0
    };

    var m = function m(_ref38) {
      var e = _ref38.filterData,
          t = _ref38.request,
          n = _ref38.visible,
          r = _ref38.getResources,
          i = _ref38.getParamsFromSettings,
          u = _objectWithoutProperties(_ref38, ["filterData", "request", "visible", "getResources", "getParamsFromSettings"]);

      var _Object76 = Object(o.useState)(),
          _Object77 = _slicedToArray(_Object76, 2),
          m = _Object77[0],
          _ = _Object77[1],
          _Object78 = Object(o.useState)([]),
          _Object79 = _slicedToArray(_Object78, 2),
          y = _Object79[0],
          v = _Object79[1],
          _Object80 = Object(o.useState)(!1),
          _Object81 = _slicedToArray(_Object80, 2),
          g = _Object81[0],
          b = _Object81[1],
          w = i ? i(h.a.getInstance().settings) : {},
          T = Object(o.useCallback)(function (n) {
        var i = r || Object(l.y)().getResources.bind(Object(l.y)());
        b(!0), i([new t({
          pager: p,
          filter: _objectSpread({
            searchTerm: n
          }, w),
          sorter: [{
            fieldName: "name",
            direction: 1
          }]
        })]).then(function (t) {
          var n = (null == e ? void 0 : e(t[0].data)) || t[0].data;
          b(!1);
          var r = n.map(function (e) {
            return {
              value: String(e.id),
              text: e.name
            };
          });
          v(r);
        });
      }, [e, r, t, w]);

      Object(o.useEffect)(function () {
        n && !m && (_(!0), T());
      }, [m, T, n]);
      var M = Object(o.useCallback)(c()(function (e) {
        return T(e);
      }, 400), []);
      return a.a.createElement(s.ColumnFilters, f({}, u, {
        filters: y,
        loading: g,
        onSearchTermChange: M,
        __source: {
          fileName: d,
          lineNumber: 93
        },
        __self: this
      }));
    },
        _ = n(5);

    var y = function y(e) {
      return e ? a.a.createElement(_.Intl.FormattedDate, {
        value: e,
        __source: {
          fileName: "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Table\\Cell.tsx",
          lineNumber: 5
        },
        __self: void 0
      }) : "-";
    };

    n.d(t, "b", function () {
      return r;
    }), n.d(t, "c", function () {
      return i;
    }), n.d(t, "a", function () {
      return m;
    }), n.d(t, "d", function () {
      return y;
    });
  }, function (e, t, n) {
    "use strict";

    var _edit, _view;

    var r = n(0),
        i = n.n(r),
        o = n(4),
        a = n(1),
        s = n(5),
        u = n(2),
        c = n.n(u),
        l = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\CustomFields\\customFieldsRenderers.tsx";

    var h = {
      edit: (_edit = {}, _defineProperty(_edit, o.CustomFieldType.String, function (_ref39) {
        var e = _ref39.value,
            t = _ref39.locked,
            n = _ref39.onChange;
        return i.a.createElement(a.Input, {
          onChange: n,
          value: e,
          disabled: t,
          __source: {
            fileName: l,
            lineNumber: 33
          },
          __self: void 0
        });
      }), _defineProperty(_edit, o.CustomFieldType.BigString, function (_ref40) {
        var e = _ref40.value,
            t = _ref40.locked,
            n = _ref40.onChange;
        return i.a.createElement(a.TextArea, {
          value: e,
          onChange: n,
          disabled: t,
          __source: {
            fileName: l,
            lineNumber: 36
          },
          __self: void 0
        });
      }), _defineProperty(_edit, o.CustomFieldType.List, function (_ref41) {
        var e = _ref41.value,
            t = _ref41.locked,
            n = _ref41.listValues,
            r = _ref41.onChange;
        return i.a.createElement(a.Select, {
          onChange: r,
          value: e,
          disabled: t,
          __source: {
            fileName: l,
            lineNumber: 39
          },
          __self: void 0
        }, n.map(function (e) {
          return i.a.createElement(a.Option, {
            key: e.id,
            value: e.id,
            __source: {
              fileName: l,
              lineNumber: 41
            },
            __self: void 0
          }, e.name);
        }));
      }), _defineProperty(_edit, o.CustomFieldType.CheckboxList, function (_ref42) {
        var e = _ref42.value,
            t = _ref42.locked,
            n = _ref42.listValues,
            r = _ref42.onChange;
        return i.a.createElement(a.Select, {
          onChange: r,
          value: e,
          mode: "multiple",
          disabled: t,
          __source: {
            fileName: l,
            lineNumber: 48
          },
          __self: void 0
        }, n.map(function (e) {
          return i.a.createElement(a.Option, {
            key: e.id,
            value: e.id,
            __source: {
              fileName: l,
              lineNumber: 50
            },
            __self: void 0
          }, e.name);
        }));
      }), _defineProperty(_edit, o.CustomFieldType.Number, function (_ref43) {
        var e = _ref43.value,
            t = _ref43.locked,
            n = _ref43.onChange;
        return i.a.createElement(a.InputNumber, {
          step: .01,
          onChange: n,
          value: e,
          disabled: t,
          __source: {
            fileName: l,
            lineNumber: 57
          },
          __self: void 0
        });
      }), _defineProperty(_edit, o.CustomFieldType.Money, function (_ref44) {
        var e = _ref44.value,
            t = _ref44.locked,
            n = _ref44.onChange;
        return i.a.createElement(a.Currency, {
          step: .01,
          onChange: n,
          value: e,
          disabled: t,
          __source: {
            fileName: l,
            lineNumber: 65
          },
          __self: void 0
        });
      }), _defineProperty(_edit, o.CustomFieldType.Boolean, function (_ref45) {
        var e = _ref45.value,
            t = _ref45.locked,
            n = _ref45.onChange;
        return i.a.createElement(a.Checkbox, {
          onChange: n,
          checked: e,
          disabled: t,
          __source: {
            fileName: l,
            lineNumber: 68
          },
          __self: void 0
        });
      }), _defineProperty(_edit, o.CustomFieldType.Integer, function (_ref46) {
        var e = _ref46.value,
            t = _ref46.locked,
            n = _ref46.onChange;
        return i.a.createElement(a.InputNumber, {
          value: e,
          onChange: n,
          disabled: t,
          __source: {
            fileName: l,
            lineNumber: 71
          },
          __self: void 0
        });
      }), _defineProperty(_edit, o.CustomFieldType.DatePicker, function (_ref47) {
        var e = _ref47.value,
            t = _ref47.locked,
            n = _ref47.onChange;
        return i.a.createElement(a.DatePicker, {
          value: c()(e),
          onChange: n,
          disabled: t,
          __source: {
            fileName: l,
            lineNumber: 74
          },
          __self: void 0
        });
      }), _edit),
      view: (_view = {}, _defineProperty(_view, o.CustomFieldType.String, function (_ref48) {
        var e = _ref48.value;
        return i.a.createElement("span", {
          __source: {
            fileName: l,
            lineNumber: 80
          },
          __self: void 0
        }, e ? String(e) : "-");
      }), _defineProperty(_view, o.CustomFieldType.BigString, function (_ref49) {
        var e = _ref49.value;
        return i.a.createElement("span", {
          __source: {
            fileName: l,
            lineNumber: 83
          },
          __self: void 0
        }, e ? String(e) : "-");
      }), _defineProperty(_view, o.CustomFieldType.List, function (_ref50) {
        var e = _ref50.value,
            t = _ref50.listValues;
        var n;
        var r = (null === (n = t.find(function (t) {
          return t.id === e;
        })) || void 0 === n ? void 0 : n.name) || "-";
        return i.a.createElement("span", {
          __source: {
            fileName: l,
            lineNumber: 88
          },
          __self: void 0
        }, r);
      }), _defineProperty(_view, o.CustomFieldType.CheckboxList, function (_ref51) {
        var e = _ref51.value,
            t = _ref51.listValues;
        var n = e.reduce(function (e, n) {
          var r;
          return [].concat(_toConsumableArray(e), [(null === (r = t.find(function (e) {
            return e.id === n;
          })) || void 0 === r ? void 0 : r.name) || "-"]);
        }, []);
        return i.a.createElement("span", {
          __source: {
            fileName: l,
            lineNumber: 101
          },
          __self: void 0
        }, n.length > 0 ? n.join(", ") : "-");
      }), _defineProperty(_view, o.CustomFieldType.Number, function (_ref52) {
        var e = _ref52.value;
        return i.a.createElement("span", {
          __source: {
            fileName: l,
            lineNumber: 107
          },
          __self: void 0
        }, e ? String(e) : "-");
      }), _defineProperty(_view, o.CustomFieldType.Money, function (_ref53) {
        var e = _ref53.value;
        return i.a.createElement("span", {
          __source: {
            fileName: l,
            lineNumber: 110
          },
          __self: void 0
        }, e ? i.a.createElement(s.Intl.FormattedCurrency, {
          value: e,
          __source: {
            fileName: l,
            lineNumber: 110
          },
          __self: void 0
        }) : "-");
      }), _defineProperty(_view, o.CustomFieldType.Boolean, function (_ref54) {
        var e = _ref54.value;
        return i.a.createElement("span", {
          __source: {
            fileName: l,
            lineNumber: 113
          },
          __self: void 0
        }, !0 === Boolean(e) ? "True" : "False");
      }), _defineProperty(_view, o.CustomFieldType.Integer, function (_ref55) {
        var e = _ref55.value;
        return i.a.createElement("span", {
          __source: {
            fileName: l,
            lineNumber: 116
          },
          __self: void 0
        }, e ? String(e) : "-");
      }), _defineProperty(_view, o.CustomFieldType.DatePicker, function (_ref56) {
        var e = _ref56.value;
        return e ? i.a.createElement(s.Intl.FormattedDate, {
          value: c()(e).toDate(),
          __source: {
            fileName: l,
            lineNumber: 120
          },
          __self: void 0
        }) : i.a.createElement("span", {
          __source: {
            fileName: l,
            lineNumber: 122
          },
          __self: void 0
        }, "'-'");
      }), _view)
    },
        d = function d(_ref57) {
      var e = _ref57.settings.locked,
          t = _ref57.listValues,
          n = _ref57.value,
          r = _ref57.mode,
          i = _ref57.fieldType,
          o = _ref57.onChange;
      return h[r][i]({
        value: n,
        locked: e,
        listValues: t,
        onChange: o
      });
    };

    n.d(t, "a", function () {
      return d;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        i = n.n(r),
        o = n(1),
        a = n(30),
        s = n.n(a),
        u = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\QuickSearch\\QuickSearch.tsx";

    function c() {
      return (c = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var l = Object(o.styled)(function (_ref58) {
      var e = _ref58.fetchData,
          t = _ref58.onOverlayVisible,
          n = _ref58.searchPlaceholder,
          a = _ref58.renderOptions,
          l = _ref58.onSearchValueChange,
          h = _ref58.noDataText,
          d = _ref58.searchTooShortText,
          f = _objectWithoutProperties(_ref58, ["fetchData", "onOverlayVisible", "searchPlaceholder", "renderOptions", "onSearchValueChange", "noDataText", "searchTooShortText"]);

      var _Object82 = Object(r.useState)(),
          _Object83 = _slicedToArray(_Object82, 2),
          p = _Object83[0],
          m = _Object83[1],
          _Object84 = Object(r.useState)(!1),
          _Object85 = _slicedToArray(_Object84, 2),
          _ = _Object85[0],
          y = _Object85[1],
          _Object86 = Object(r.useState)(),
          _Object87 = _slicedToArray(_Object86, 2),
          v = _Object87[0],
          g = _Object87[1],
          b = Object(r.useCallback)(s()(function (e) {
        g("" === e ? void 0 : e), y(!1), l && l(e);
      }, 500), [l]);

      var w;
      return Object(r.useEffect)(function () {
        if (!v || v.length < 2) return y(!1), void m(void 0);
        y(!0), m(void 0), e(v).then(function (e) {
          y(!1), m(e);
        }).catch(function (e) {
          console.error(e), y(!1);
        });
      }, [e, v]), w = _ ? i.a.createElement(o.Flex, {
        align: "center",
        justify: "center",
        __source: {
          fileName: u,
          lineNumber: 82
        },
        __self: this
      }, i.a.createElement(o.Spinner, {
        size: "small",
        __source: {
          fileName: u,
          lineNumber: 83
        },
        __self: this
      })) : !v || v.length < 2 ? d : h, i.a.createElement("div", {
        className: f.className,
        __source: {
          fileName: u,
          lineNumber: 93
        },
        __self: this
      }, i.a.createElement(o.Select, c({
        value: v,
        allowClear: !0,
        prefixIcon: i.a.createElement(o.Icon, {
          type: "search",
          __source: {
            fileName: u,
            lineNumber: 97
          },
          __self: this
        }),
        filterOption: !1,
        notFoundContent: w,
        showArrow: !1,
        onSearch: b,
        onChange: function onChange(e) {
          e && "" !== e || g(void 0);
        },
        onDropdownVisibleChange: t,
        placeholder: n,
        dropdownMatchSelectWidth: !1,
        showSearch: !0,
        style: {
          height: 40,
          width: 600,
          zIndex: 1e3
        },
        getPopupContainer: function getPopupContainer() {
          return f.className ? document.getElementsByClassName(f.className)[0] : document.body;
        }
      }, f, {
        __source: {
          fileName: u,
          lineNumber: 94
        },
        __self: this
      }), p && !_ ? a(p) : null));
    })({
      ".ant-select-dropdown-menu-item-group-title": {
        padding: "24px 24px 12px !important"
      },
      ".ant-select-dropdown-menu-item-group-list li.ant-select-dropdown-menu-item": {
        paddingTop: 5,
        paddingBottom: 5,
        paddingLeft: 24,
        paddingRight: 24,
        marginBottom: 10,
        fontSize: "12px",
        lineHeight: "13px",
        fontWeight: 600,
        i: {
          fontSize: "12px",
          lineHeight: "13px"
        }
      },
      "ul.ant-select-dropdown-menu-item-group-list:not(:first-child)": {
        borderTop: 0,
        paddingTop: 0
      },
      ".ant-select-selection__clear": {
        background: "transparent",
        ".anticon.icon": {
          fontSize: "14px"
        }
      }
    });
    n.d(t, "a", function () {
      return l;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        i = n.n(r),
        o = n(5),
        a = n(1),
        s = n(7),
        u = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\TabLayout\\TabLayout.tsx";

    function c() {
      return (c = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var l = function l(_ref59) {
      var e = _ref59.tabs,
          t = _ref59.routable,
          n = _ref59.stickTo;
      var l;

      var _Object88 = Object(o.useQuery)(),
          h = _Object88.tab,
          d = Object(o.useUpdateQuery)(),
          _Object89 = Object(r.useState)(h || (null === (l = e[0]) || void 0 === l ? void 0 : l.key)),
          _Object90 = _slicedToArray(_Object89, 2),
          f = _Object90[0],
          p = _Object90[1],
          _Object91 = Object(s.f)(),
          m = _Object91.hasPermission,
          _ = Object(r.useMemo)(function () {
        return e.filter(function (e) {
          return Object(s.d)(e.permission).evaluate(m);
        });
      }, [e, m]);

      return i.a.createElement(a.Tabs, {
        activeKey: f,
        onChange: function onChange(e) {
          t && d({
            tab: e
          }), p(e);
        },
        renderTabBar: function renderTabBar(e, t) {
          var r = i.a.createElement(t, c({}, e, {
            __source: {
              fileName: u,
              lineNumber: 49
            },
            __self: void 0
          }));
          return n ? i.a.createElement(a.Affix, {
            target: function target() {
              return n.current;
            },
            __source: {
              fileName: u,
              lineNumber: 54
            },
            __self: void 0
          }, i.a.createElement(a.Container, {
            background: "pageSecondary",
            divider: ["bottom", "every"],
            __source: {
              fileName: u,
              lineNumber: 55
            },
            __self: void 0
          }, r)) : r;
        },
        __source: {
          fileName: u,
          lineNumber: 45
        },
        __self: void 0
      }, _.map(function (e) {
        return i.a.createElement(a.TabPane, {
          tab: i.a.createElement(a.Text, {
            uppercase: !0,
            weight: 700,
            spacing: 1,
            __source: {
              fileName: u,
              lineNumber: 65
            },
            __self: void 0
          }, e.name),
          key: e.key,
          __source: {
            fileName: u,
            lineNumber: 63
          },
          __self: void 0
        }, e.content);
      }));
    };

    n.d(t, "a", function () {
      return l;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        i = n.n(r),
        o = n(1),
        a = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Departments\\Departments.tsx";
    var s = Object(o.styled)(o.Tag)(function (_ref60) {
      var e = _ref60.theme.newColors;
      return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
          backgroundColor: e.bgRowHover,
          border: "1px solid ".concat(e.borderWidgetPrimary),
          cursor: "pointer",
          margin: -1
        }
      };
    });

    var u = function u(_ref61) {
      var e = _ref61.departments;
      if (e.length < 1) return i.a.createElement(o.Text, {
        __source: {
          fileName: a,
          lineNumber: 22
        },
        __self: void 0
      }, "-");
      var t = e[0],
          n = e.length > 1 ? e.slice(1) : void 0;
      return i.a.createElement(o.Flex, {
        gutter: 2,
        __source: {
          fileName: a,
          lineNumber: 29
        },
        __self: void 0
      }, i.a.createElement(o.Tag, {
        color: "bgInputPrimary",
        collapse: !0,
        __source: {
          fileName: a,
          lineNumber: 30
        },
        __self: void 0
      }, i.a.createElement(o.Text, {
        padding: 1,
        align: "center",
        __source: {
          fileName: a,
          lineNumber: 31
        },
        __self: void 0
      }, t.name)), n ? i.a.createElement(o.Tooltip, {
        overlay: i.a.createElement(o.Flex, {
          direction: "column",
          padding: 2,
          gutter: 2,
          gutterDirection: "vertical",
          __source: {
            fileName: a,
            lineNumber: 38
          },
          __self: void 0
        }, n.map(function (_ref62) {
          var e = _ref62.name;
          return i.a.createElement("div", {
            key: e,
            __source: {
              fileName: a,
              lineNumber: 45
            },
            __self: void 0
          }, e);
        })),
        __source: {
          fileName: a,
          lineNumber: 36
        },
        __self: void 0
      }, i.a.createElement(s, {
        color: "bgPagePrimary",
        collapse: !0,
        __source: {
          fileName: a,
          lineNumber: 50
        },
        __self: void 0
      }, i.a.createElement(o.H3, {
        padding: 1,
        align: "center",
        weight: 400,
        __source: {
          fileName: a,
          lineNumber: 51
        },
        __self: void 0
      }, "+", n.length))) : null);
    };

    n.d(t, "a", function () {
      return u;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        i = n.n(r),
        o = n(4),
        a = n(1),
        s = n(8),
        u = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\Appearance\\Provider.tsx";
    var c = {
      bucket: "settings",
      container: "appearance"
    };
    var l;
    !function (e) {
      e[e.Light = 0] = "Light", e[e.Dark = 1] = "Dark";
    }(l || (l = {}));
    var h = {
      theme: l.Light
    },
        d = i.a.createContext({
      appearance: null,
      refresh: function refresh() {},
      update: function update() {}
    });

    function f(_ref63) {
      var e = _ref63.children;

      var _Object92 = Object(r.useState)(null),
          _Object93 = _slicedToArray(_Object92, 2),
          t = _Object93[0],
          n = _Object93[1],
          f = Object(r.useCallback)(function _callee13() {
        var e;
        return _regeneratorRuntime.async(function _callee13$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return _regeneratorRuntime.awrap(function _callee12() {
                  var e;
                  return _regeneratorRuntime.async(function _callee12$(_context32) {
                    while (1) {
                      switch (_context32.prev = _context32.next) {
                        case 0:
                          _context32.next = 2;
                          return _regeneratorRuntime.awrap(Object(s.y)().getResources([new o.Requests.StorageObjectRequest({
                            filter: {
                              key: c
                            }
                          })]));

                        case 2:
                          e = _context32.sent;
                          return _context32.abrupt("return", 0 === e[0].data.length ? h : JSON.parse(e[0].data[0].content));

                        case 4:
                        case "end":
                          return _context32.stop();
                      }
                    }
                  });
                }());

              case 2:
                e = _context33.sent;
                n(e);

              case 4:
              case "end":
                return _context33.stop();
            }
          }
        });
      }, []),
          p = Object(r.useCallback)(function _callee15(e) {
        return _regeneratorRuntime.async(function _callee15$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                !function _callee14(e) {
                  return _regeneratorRuntime.async(function _callee14$(_context34) {
                    while (1) {
                      switch (_context34.prev = _context34.next) {
                        case 0:
                          _context34.next = 2;
                          return _regeneratorRuntime.awrap(Object(s.y)().createMutationRequest(new o.Requests.SetStorageObjectRequest({
                            content: JSON.stringify(e),
                            key: c
                          })));

                        case 2:
                          _context34.sent.data;

                        case 3:
                        case "end":
                          return _context34.stop();
                      }
                    }
                  });
                }(e), n(e);

              case 1:
              case "end":
                return _context35.stop();
            }
          }
        });
      }, []);

      Object(r.useEffect)(function () {
        f();
      }, []);
      var m = Object(r.useMemo)(function () {
        return {
          refresh: f,
          appearance: t,
          update: p
        };
      }, [t, f, p]);
      return i.a.createElement(d.Provider, {
        value: m,
        __source: {
          fileName: u,
          lineNumber: 95
        },
        __self: this
      }, i.a.createElement(a.ThemeProvider, {
        theme: (null == t ? void 0 : t.theme) === l.Dark ? a.DarkTheme : a.Theme,
        __source: {
          fileName: u,
          lineNumber: 96
        },
        __self: this
      }, e));
    }

    n.d(t, "c", function () {
      return l;
    }), n.d(t, "a", function () {
      return d;
    }), n.d(t, "b", function () {
      return f;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(1).styled.div(function (e) {
      return {
        borderRadius: 50,
        backgroundColor: e.color,
        width: e.size,
        height: e.size
      };
    });
    n.d(t, "a", function () {
      return r;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        i = n.n(r),
        o = n(18),
        a = n(7),
        s = n(44),
        u = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\AuthorizedRoute\\AuthorizedRoute.tsx";

    function c() {
      return (c = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var l = function l(e) {
      var _Object94 = Object(a.f)(),
          t = _Object94.hasPermission,
          n = e.permission,
          l = _objectWithoutProperties(e, ["permission"]);

      return Object(r.useMemo)(function () {
        return Object(a.d)(n).evaluate(t);
      }, [t, n]) ? i.a.createElement(o.Route, c({}, l, {
        __source: {
          fileName: u,
          lineNumber: 18
        },
        __self: void 0
      })) : i.a.createElement(s.d, {
        __source: {
          fileName: u,
          lineNumber: 18
        },
        __self: void 0
      });
    };

    n.d(t, "a", function () {
      return l;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(1).styled.div({
      display: "flex",
      justifyContent: "flex-end",
      button: {
        margin: "0 0 0 10px"
      }
    });
    n.d(t, "a", function () {
      return r;
    });
  }, function (e, t, n) {
    e.exports = n(239);
  }, function (e, t, n) {
    /**
     * chroma.js - JavaScript library for color conversions
     *
     * Copyright (c) 2011-2018, Gregor Aisch
     * All rights reserved.
     *
     * Redistribution and use in source and binary forms, with or without
     * modification, are permitted provided that the following conditions are met:
     *
     * 1. Redistributions of source code must retain the above copyright notice, this
     * list of conditions and the following disclaimer.
     *
     * 2. Redistributions in binary form must reproduce the above copyright notice,
     * this list of conditions and the following disclaimer in the documentation
     * and/or other materials provided with the distribution.
     *
     * 3. The name Gregor Aisch may not be used to endorse or promote products
     * derived from this software without specific prior written permission.
     *
     * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
     * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
     * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
     * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
     * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
     * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
     * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
     * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
     * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
     * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
     *
     * -------------------------------------------------------
     *
     * chroma.js includes colors from colorbrewer2.org, which are released under
     * the following license:
     *
     * Copyright (c) 2002 Cynthia Brewer, Mark Harrower,
     * and The Pennsylvania State University.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing,
     * software distributed under the License is distributed on an
     * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
     * either express or implied. See the License for the specific
     * language governing permissions and limitations under the License.
     *
     * ------------------------------------------------------
     *
     * Named colors are taken from X11 Color Names.
     * http://www.w3.org/TR/css3-color/#svg-color
     *
     * @preserve
     */
    e.exports = function () {
      "use strict";

      for (var e = function e(_e8, t, n) {
        return void 0 === t && (t = 0), void 0 === n && (n = 1), _e8 < t ? t : _e8 > n ? n : _e8;
      }, t = {}, n = 0, r = ["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp", "Undefined", "Null"]; n < r.length; n += 1) {
        var i = r[n];
        t["[object " + i + "]"] = i.toLowerCase();
      }

      var o = function o(e) {
        return t[Object.prototype.toString.call(e)] || "object";
      },
          a = Math.PI,
          s = {
        clip_rgb: function clip_rgb(t) {
          t._clipped = !1, t._unclipped = t.slice(0);

          for (var n = 0; n <= 3; n++) {
            n < 3 ? ((t[n] < 0 || t[n] > 255) && (t._clipped = !0), t[n] = e(t[n], 0, 255)) : 3 === n && (t[n] = e(t[n], 0, 1));
          }

          return t;
        },
        limit: e,
        type: o,
        unpack: function unpack(e, t) {
          return void 0 === t && (t = null), e.length >= 3 ? Array.prototype.slice.call(e) : "object" == o(e[0]) && t ? t.split("").filter(function (t) {
            return void 0 !== e[0][t];
          }).map(function (t) {
            return e[0][t];
          }) : e[0];
        },
        last: function last(e) {
          if (e.length < 2) return null;
          var t = e.length - 1;
          return "string" == o(e[t]) ? e[t].toLowerCase() : null;
        },
        PI: a,
        TWOPI: 2 * a,
        PITHIRD: a / 3,
        DEG2RAD: a / 180,
        RAD2DEG: 180 / a
      },
          u = {
        format: {},
        autodetect: []
      },
          c = s.last,
          l = s.clip_rgb,
          h = s.type,
          d = function d() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        if ("object" === h(e[0]) && e[0].constructor && e[0].constructor === this.constructor) return e[0];
        var n = c(e),
            r = !1;

        if (!n) {
          r = !0, u.sorted || (u.autodetect = u.autodetect.sort(function (e, t) {
            return t.p - e.p;
          }), u.sorted = !0);

          for (var i = 0, o = u.autodetect; i < o.length; i += 1) {
            var a = o[i];
            if (n = a.test.apply(a, e)) break;
          }
        }

        if (!u.format[n]) throw new Error("unknown format: " + e);
        var s = u.format[n].apply(null, r ? e : e.slice(0, -1));
        this._rgb = l(s), 3 === this._rgb.length && this._rgb.push(1);
      };

      d.prototype.toString = function () {
        return "function" == h(this.hex) ? this.hex() : "[" + this._rgb.join(",") + "]";
      };

      var f = d,
          p = function p() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(p.Color, [null].concat(e)))();
      };

      p.Color = f, p.version = "2.0.3";

      var m = p,
          _ = s.unpack,
          y = Math.max,
          v = function v() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = _(e, "rgb"),
            r = n[0],
            i = n[1],
            o = n[2],
            a = 1 - y(r /= 255, y(i /= 255, o /= 255)),
            s = a < 1 ? 1 / (1 - a) : 0,
            u = (1 - r - a) * s,
            c = (1 - i - a) * s,
            l = (1 - o - a) * s;

        return [u, c, l, a];
      },
          g = s.unpack,
          b = function b() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = (e = g(e, "cmyk"))[0],
            r = e[1],
            i = e[2],
            o = e[3],
            a = e.length > 4 ? e[4] : 1;
        return 1 === o ? [0, 0, 0, a] : [n >= 1 ? 0 : 255 * (1 - n) * (1 - o), r >= 1 ? 0 : 255 * (1 - r) * (1 - o), i >= 1 ? 0 : 255 * (1 - i) * (1 - o), a];
      },
          w = s.unpack,
          T = s.type;

      f.prototype.cmyk = function () {
        return v(this._rgb);
      }, m.cmyk = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["cmyk"])))();
      }, u.format.cmyk = b, u.autodetect.push({
        p: 2,
        test: function test() {
          for (var e = [], t = arguments.length; t--;) {
            e[t] = arguments[t];
          }

          if (e = w(e, "cmyk"), "array" === T(e) && 4 === e.length) return "cmyk";
        }
      });

      var M = s.unpack,
          E = s.last,
          k = function k(e) {
        return Math.round(100 * e) / 100;
      },
          L = function L() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = M(e, "hsla"),
            r = E(e) || "lsa";
        return n[0] = k(n[0] || 0), n[1] = k(100 * n[1]) + "%", n[2] = k(100 * n[2]) + "%", "hsla" === r || n.length > 3 && n[3] < 1 ? (n[3] = n.length > 3 ? n[3] : 1, r = "hsla") : n.length = 3, r + "(" + n.join(",") + ")";
      },
          S = s.unpack,
          N = function N() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = (e = S(e, "rgba"))[0],
            r = e[1],
            i = e[2];
        n /= 255, r /= 255, i /= 255;
        var o,
            a,
            s = Math.min(n, r, i),
            u = Math.max(n, r, i),
            c = (u + s) / 2;
        return u === s ? (o = 0, a = Number.NaN) : o = c < .5 ? (u - s) / (u + s) : (u - s) / (2 - u - s), n == u ? a = (r - i) / (u - s) : r == u ? a = 2 + (i - n) / (u - s) : i == u && (a = 4 + (n - r) / (u - s)), (a *= 60) < 0 && (a += 360), e.length > 3 && void 0 !== e[3] ? [a, o, c, e[3]] : [a, o, c];
      },
          D = s.unpack,
          I = s.last,
          R = Math.round,
          x = function x() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = D(e, "rgba"),
            r = I(e) || "rgb";
        return "hsl" == r.substr(0, 3) ? L(N(n), r) : (n[0] = R(n[0]), n[1] = R(n[1]), n[2] = R(n[2]), ("rgba" === r || n.length > 3 && n[3] < 1) && (n[3] = n.length > 3 ? n[3] : 1, r = "rgba"), r + "(" + n.slice(0, "rgb" === r ? 3 : 4).join(",") + ")");
      },
          Y = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
          C = /^#?([A-Fa-f0-9]{8})$/,
          O = function O(e) {
        if (e.match(Y)) {
          4 !== e.length && 7 !== e.length || (e = e.substr(1)), 3 === e.length && (e = (e = e.split(""))[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
          var t = parseInt(e, 16),
              n = t >> 16,
              r = t >> 8 & 255,
              i = 255 & t;
          return [n, r, i, 1];
        }

        if (e.match(C)) {
          9 === e.length && (e = e.substr(1));
          var o = parseInt(e, 16),
              a = o >> 24 & 255,
              s = o >> 16 & 255,
              u = o >> 8 & 255,
              c = Math.round((255 & o) / 255 * 100) / 100;
          return [a, s, u, c];
        }

        throw new Error("unknown hex color: " + e);
      },
          F = s.unpack,
          A = Math.round,
          j = function j() {
        for (var e, t = [], n = arguments.length; n--;) {
          t[n] = arguments[n];
        }

        var r,
            i,
            o,
            a = (t = F(t, "hsl"))[0],
            s = t[1],
            u = t[2];
        if (0 === s) r = i = o = 255 * u;else {
          var c = [0, 0, 0],
              l = [0, 0, 0],
              h = u < .5 ? u * (1 + s) : u + s - u * s,
              d = 2 * u - h,
              f = a / 360;
          c[0] = f + 1 / 3, c[1] = f, c[2] = f - 1 / 3;

          for (var p = 0; p < 3; p++) {
            c[p] < 0 && (c[p] += 1), c[p] > 1 && (c[p] -= 1), 6 * c[p] < 1 ? l[p] = d + 6 * (h - d) * c[p] : 2 * c[p] < 1 ? l[p] = h : 3 * c[p] < 2 ? l[p] = d + (h - d) * (2 / 3 - c[p]) * 6 : l[p] = d;
          }

          e = [A(255 * l[0]), A(255 * l[1]), A(255 * l[2])], r = e[0], i = e[1], o = e[2];
        }
        return t.length > 3 ? [r, i, o, t[3]] : [r, i, o, 1];
      },
          U = {
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflower: "#6495ed",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        laserlemon: "#ffff54",
        lavender: "#e6e6fa",
        lavenderblush: "#fff0f5",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrod: "#fafad2",
        lightgoldenrodyellow: "#fafad2",
        lightgray: "#d3d3d3",
        lightgreen: "#90ee90",
        lightgrey: "#d3d3d3",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        maroon2: "#7f0000",
        maroon3: "#b03060",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370db",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#db7093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        purple2: "#7f007f",
        purple3: "#a020f0",
        rebeccapurple: "#663399",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        steelblue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32"
      },
          P = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/,
          V = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/,
          W = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/,
          H = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/,
          B = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/,
          z = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/,
          Z = Math.round,
          Q = function Q(e) {
        if (e = e.toLowerCase().trim(), U[e]) return O(U[e]);
        var t;

        if (t = e.match(P)) {
          for (var n = t.slice(1, 4), r = 0; r < 3; r++) {
            n[r] = +n[r];
          }

          return n[3] = 1, n;
        }

        if (t = e.match(V)) {
          for (var i = t.slice(1, 5), o = 0; o < 4; o++) {
            i[o] = +i[o];
          }

          return i;
        }

        if (t = e.match(W)) {
          for (var a = t.slice(1, 4), s = 0; s < 3; s++) {
            a[s] = Z(2.55 * a[s]);
          }

          return a[3] = 1, a;
        }

        if (t = e.match(H)) {
          for (var u = t.slice(1, 5), c = 0; c < 3; c++) {
            u[c] = Z(2.55 * u[c]);
          }

          return u[3] = +u[3], u;
        }

        if (t = e.match(B)) {
          var l = t.slice(1, 4);
          l[1] *= .01, l[2] *= .01;
          var h = j(l);
          return h[3] = 1, h;
        }

        if (t = e.match(z)) {
          var d = t.slice(1, 4);
          d[1] *= .01, d[2] *= .01;
          var f = j(d);
          return f[3] = +t[4], f;
        }
      };

      Q.test = function (e) {
        return P.test(e) || V.test(e) || W.test(e) || H.test(e) || B.test(e) || z.test(e);
      };

      var G = Q,
          q = s.type;
      f.prototype.css = function (e) {
        return x(this._rgb, e);
      }, m.css = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["css"])))();
      }, u.format.css = G, u.autodetect.push({
        p: 5,
        test: function test(e) {
          for (var t = [], n = arguments.length - 1; n-- > 0;) {
            t[n] = arguments[n + 1];
          }

          if (!t.length && "string" === q(e) && G.test(e)) return "css";
        }
      });
      var J = s.unpack;
      u.format.gl = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = J(e, "rgba");
        return n[0] *= 255, n[1] *= 255, n[2] *= 255, n;
      }, m.gl = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["gl"])))();
      }, f.prototype.gl = function () {
        var e = this._rgb;
        return [e[0] / 255, e[1] / 255, e[2] / 255, e[3]];
      };

      var X = s.unpack,
          K = function K() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n,
            r = X(e, "rgb"),
            i = r[0],
            o = r[1],
            a = r[2],
            s = Math.min(i, o, a),
            u = Math.max(i, o, a),
            c = u - s,
            l = 100 * c / 255,
            h = s / (255 - c) * 100;
        return 0 === c ? n = Number.NaN : (i === u && (n = (o - a) / c), o === u && (n = 2 + (a - i) / c), a === u && (n = 4 + (i - o) / c), (n *= 60) < 0 && (n += 360)), [n, l, h];
      },
          $ = s.unpack,
          ee = Math.floor,
          te = function te() {
        for (var e, t, n, r, i, o, a = [], s = arguments.length; s--;) {
          a[s] = arguments[s];
        }

        var u,
            c,
            l,
            h = (a = $(a, "hcg"))[0],
            d = a[1],
            f = a[2];
        f *= 255;
        var p = 255 * d;
        if (0 === d) u = c = l = f;else {
          360 === h && (h = 0), h > 360 && (h -= 360), h < 0 && (h += 360);

          var m = ee(h /= 60),
              _ = h - m,
              y = f * (1 - d),
              v = y + p * (1 - _),
              g = y + p * _,
              b = y + p;

          switch (m) {
            case 0:
              u = (e = [b, g, y])[0], c = e[1], l = e[2];
              break;

            case 1:
              u = (t = [v, b, y])[0], c = t[1], l = t[2];
              break;

            case 2:
              u = (n = [y, b, g])[0], c = n[1], l = n[2];
              break;

            case 3:
              u = (r = [y, v, b])[0], c = r[1], l = r[2];
              break;

            case 4:
              u = (i = [g, y, b])[0], c = i[1], l = i[2];
              break;

            case 5:
              u = (o = [b, y, v])[0], c = o[1], l = o[2];
          }
        }
        return [u, c, l, a.length > 3 ? a[3] : 1];
      },
          ne = s.unpack,
          re = s.type;

      f.prototype.hcg = function () {
        return K(this._rgb);
      }, m.hcg = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["hcg"])))();
      }, u.format.hcg = te, u.autodetect.push({
        p: 1,
        test: function test() {
          for (var e = [], t = arguments.length; t--;) {
            e[t] = arguments[t];
          }

          if (e = ne(e, "hcg"), "array" === re(e) && 3 === e.length) return "hcg";
        }
      });

      var ie = s.unpack,
          oe = s.last,
          ae = Math.round,
          se = function se() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = ie(e, "rgba"),
            r = n[0],
            i = n[1],
            o = n[2],
            a = n[3],
            s = oe(e) || "auto";
        void 0 === a && (a = 1), "auto" === s && (s = a < 1 ? "rgba" : "rgb"), r = ae(r), i = ae(i), o = ae(o);
        var u = r << 16 | i << 8 | o,
            c = "000000" + u.toString(16);
        c = c.substr(c.length - 6);
        var l = "0" + ae(255 * a).toString(16);

        switch (l = l.substr(l.length - 2), s.toLowerCase()) {
          case "rgba":
            return "#" + c + l;

          case "argb":
            return "#" + l + c;

          default:
            return "#" + c;
        }
      },
          ue = s.type;

      f.prototype.hex = function (e) {
        return se(this._rgb, e);
      }, m.hex = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["hex"])))();
      }, u.format.hex = O, u.autodetect.push({
        p: 4,
        test: function test(e) {
          for (var t = [], n = arguments.length - 1; n-- > 0;) {
            t[n] = arguments[n + 1];
          }

          if (!t.length && "string" === ue(e) && [3, 4, 6, 7, 8, 9].includes(e.length)) return "hex";
        }
      });

      var ce = s.unpack,
          le = s.TWOPI,
          he = Math.min,
          de = Math.sqrt,
          fe = Math.acos,
          pe = function pe() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n,
            r = ce(e, "rgb"),
            i = r[0],
            o = r[1],
            a = r[2],
            s = he(i /= 255, o /= 255, a /= 255),
            u = (i + o + a) / 3,
            c = u > 0 ? 1 - s / u : 0;
        return 0 === c ? n = NaN : (n = (i - o + (i - a)) / 2, n /= de((i - o) * (i - o) + (i - a) * (o - a)), n = fe(n), a > o && (n = le - n), n /= le), [360 * n, c, u];
      },
          me = s.unpack,
          _e = s.limit,
          ye = s.TWOPI,
          ve = s.PITHIRD,
          ge = Math.cos,
          be = function be() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n,
            r,
            i,
            o = (e = me(e, "hsi"))[0],
            a = e[1],
            s = e[2];
        return isNaN(o) && (o = 0), isNaN(a) && (a = 0), o > 360 && (o -= 360), o < 0 && (o += 360), (o /= 360) < 1 / 3 ? (i = (1 - a) / 3, n = (1 + a * ge(ye * o) / ge(ve - ye * o)) / 3, r = 1 - (i + n)) : o < 2 / 3 ? (n = (1 - a) / 3, r = (1 + a * ge(ye * (o -= 1 / 3)) / ge(ve - ye * o)) / 3, i = 1 - (n + r)) : (r = (1 - a) / 3, i = (1 + a * ge(ye * (o -= 2 / 3)) / ge(ve - ye * o)) / 3, n = 1 - (r + i)), n = _e(s * n * 3), r = _e(s * r * 3), i = _e(s * i * 3), [255 * n, 255 * r, 255 * i, e.length > 3 ? e[3] : 1];
      },
          we = s.unpack,
          Te = s.type;

      f.prototype.hsi = function () {
        return pe(this._rgb);
      }, m.hsi = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["hsi"])))();
      }, u.format.hsi = be, u.autodetect.push({
        p: 2,
        test: function test() {
          for (var e = [], t = arguments.length; t--;) {
            e[t] = arguments[t];
          }

          if (e = we(e, "hsi"), "array" === Te(e) && 3 === e.length) return "hsi";
        }
      });
      var Me = s.unpack,
          Ee = s.type;
      f.prototype.hsl = function () {
        return N(this._rgb);
      }, m.hsl = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["hsl"])))();
      }, u.format.hsl = j, u.autodetect.push({
        p: 2,
        test: function test() {
          for (var e = [], t = arguments.length; t--;) {
            e[t] = arguments[t];
          }

          if (e = Me(e, "hsl"), "array" === Ee(e) && 3 === e.length) return "hsl";
        }
      });

      var ke = s.unpack,
          Le = Math.min,
          Se = Math.max,
          Ne = function Ne() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n,
            r,
            i,
            o = (e = ke(e, "rgb"))[0],
            a = e[1],
            s = e[2],
            u = Le(o, a, s),
            c = Se(o, a, s),
            l = c - u;
        return i = c / 255, 0 === c ? (n = Number.NaN, r = 0) : (r = l / c, o === c && (n = (a - s) / l), a === c && (n = 2 + (s - o) / l), s === c && (n = 4 + (o - a) / l), (n *= 60) < 0 && (n += 360)), [n, r, i];
      },
          De = s.unpack,
          Ie = Math.floor,
          Re = function Re() {
        for (var e, t, n, r, i, o, a = [], s = arguments.length; s--;) {
          a[s] = arguments[s];
        }

        var u,
            c,
            l,
            h = (a = De(a, "hsv"))[0],
            d = a[1],
            f = a[2];
        if (f *= 255, 0 === d) u = c = l = f;else {
          360 === h && (h = 0), h > 360 && (h -= 360), h < 0 && (h += 360);

          var p = Ie(h /= 60),
              m = h - p,
              _ = f * (1 - d),
              y = f * (1 - d * m),
              v = f * (1 - d * (1 - m));

          switch (p) {
            case 0:
              u = (e = [f, v, _])[0], c = e[1], l = e[2];
              break;

            case 1:
              u = (t = [y, f, _])[0], c = t[1], l = t[2];
              break;

            case 2:
              u = (n = [_, f, v])[0], c = n[1], l = n[2];
              break;

            case 3:
              u = (r = [_, y, f])[0], c = r[1], l = r[2];
              break;

            case 4:
              u = (i = [v, _, f])[0], c = i[1], l = i[2];
              break;

            case 5:
              u = (o = [f, _, y])[0], c = o[1], l = o[2];
          }
        }
        return [u, c, l, a.length > 3 ? a[3] : 1];
      },
          xe = s.unpack,
          Ye = s.type;

      f.prototype.hsv = function () {
        return Ne(this._rgb);
      }, m.hsv = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["hsv"])))();
      }, u.format.hsv = Re, u.autodetect.push({
        p: 2,
        test: function test() {
          for (var e = [], t = arguments.length; t--;) {
            e[t] = arguments[t];
          }

          if (e = xe(e, "hsv"), "array" === Ye(e) && 3 === e.length) return "hsv";
        }
      });

      var Ce = {
        Kn: 18,
        Xn: .95047,
        Yn: 1,
        Zn: 1.08883,
        t0: .137931034,
        t1: .206896552,
        t2: .12841855,
        t3: .008856452
      },
          Oe = s.unpack,
          Fe = Math.pow,
          Ae = function Ae(e) {
        return (e /= 255) <= .04045 ? e / 12.92 : Fe((e + .055) / 1.055, 2.4);
      },
          je = function je(e) {
        return e > Ce.t3 ? Fe(e, 1 / 3) : e / Ce.t2 + Ce.t0;
      },
          Ue = function Ue(e, t, n) {
        e = Ae(e), t = Ae(t), n = Ae(n);
        var r = je((.4124564 * e + .3575761 * t + .1804375 * n) / Ce.Xn),
            i = je((.2126729 * e + .7151522 * t + .072175 * n) / Ce.Yn),
            o = je((.0193339 * e + .119192 * t + .9503041 * n) / Ce.Zn);
        return [r, i, o];
      },
          Pe = function Pe() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = Oe(e, "rgb"),
            r = n[0],
            i = n[1],
            o = n[2],
            a = Ue(r, i, o),
            s = a[0],
            u = a[1],
            c = a[2],
            l = 116 * u - 16;
        return [l < 0 ? 0 : l, 500 * (s - u), 200 * (u - c)];
      },
          Ve = s.unpack,
          We = Math.pow,
          He = function He(e) {
        return 255 * (e <= .00304 ? 12.92 * e : 1.055 * We(e, 1 / 2.4) - .055);
      },
          Be = function Be(e) {
        return e > Ce.t1 ? e * e * e : Ce.t2 * (e - Ce.t0);
      },
          ze = function ze() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n,
            r,
            i,
            o,
            a,
            s,
            u = (e = Ve(e, "lab"))[0],
            c = e[1],
            l = e[2];
        return r = (u + 16) / 116, n = isNaN(c) ? r : r + c / 500, i = isNaN(l) ? r : r - l / 200, r = Ce.Yn * Be(r), n = Ce.Xn * Be(n), i = Ce.Zn * Be(i), o = He(3.2404542 * n - 1.5371385 * r - .4985314 * i), a = He(-.969266 * n + 1.8760108 * r + .041556 * i), s = He(.0556434 * n - .2040259 * r + 1.0572252 * i), [o, a, s, e.length > 3 ? e[3] : 1];
      },
          Ze = s.unpack,
          Qe = s.type;

      f.prototype.lab = function () {
        return Pe(this._rgb);
      }, m.lab = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["lab"])))();
      }, u.format.lab = ze, u.autodetect.push({
        p: 2,
        test: function test() {
          for (var e = [], t = arguments.length; t--;) {
            e[t] = arguments[t];
          }

          if (e = Ze(e, "lab"), "array" === Qe(e) && 3 === e.length) return "lab";
        }
      });

      var Ge = s.unpack,
          qe = s.RAD2DEG,
          Je = Math.sqrt,
          Xe = Math.atan2,
          Ke = Math.round,
          $e = function $e() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = Ge(e, "lab"),
            r = n[0],
            i = n[1],
            o = n[2],
            a = Je(i * i + o * o),
            s = (Xe(o, i) * qe + 360) % 360;
        return 0 === Ke(1e4 * a) && (s = Number.NaN), [r, a, s];
      },
          et = s.unpack,
          tt = function tt() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = et(e, "rgb"),
            r = n[0],
            i = n[1],
            o = n[2],
            a = Pe(r, i, o),
            s = a[0],
            u = a[1],
            c = a[2];
        return $e(s, u, c);
      },
          nt = s.unpack,
          rt = s.DEG2RAD,
          it = Math.sin,
          ot = Math.cos,
          at = function at() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = nt(e, "lch"),
            r = n[0],
            i = n[1],
            o = n[2];
        return isNaN(o) && (o = 0), [r, ot(o *= rt) * i, it(o) * i];
      },
          st = s.unpack,
          ut = function ut() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = (e = st(e, "lch"))[0],
            r = e[1],
            i = e[2],
            o = at(n, r, i),
            a = o[0],
            s = o[1],
            u = o[2],
            c = ze(a, s, u),
            l = c[0],
            h = c[1],
            d = c[2];
        return [l, h, d, e.length > 3 ? e[3] : 1];
      },
          ct = s.unpack,
          lt = function lt() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = ct(e, "hcl").reverse();
        return ut.apply(void 0, n);
      },
          ht = s.unpack,
          dt = s.type;

      f.prototype.lch = function () {
        return tt(this._rgb);
      }, f.prototype.hcl = function () {
        return tt(this._rgb).reverse();
      }, m.lch = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["lch"])))();
      }, m.hcl = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["hcl"])))();
      }, u.format.lch = ut, u.format.hcl = lt, ["lch", "hcl"].forEach(function (e) {
        return u.autodetect.push({
          p: 2,
          test: function test() {
            for (var t = [], n = arguments.length; n--;) {
              t[n] = arguments[n];
            }

            if (t = ht(t, e), "array" === dt(t) && 3 === t.length) return e;
          }
        });
      });
      var ft = s.type;
      f.prototype.name = function () {
        for (var e = se(this._rgb, "rgb"), t = 0, n = Object.keys(U); t < n.length; t += 1) {
          var r = n[t];
          if (U[r] === e) return r.toLowerCase();
        }

        return e;
      }, u.format.named = function (e) {
        if (e = e.toLowerCase(), U[e]) return O(U[e]);
        throw new Error("unknown color name: " + e);
      }, u.autodetect.push({
        p: 5,
        test: function test(e) {
          for (var t = [], n = arguments.length - 1; n-- > 0;) {
            t[n] = arguments[n + 1];
          }

          if (!t.length && "string" === ft(e) && U[e.toLowerCase()]) return "named";
        }
      });

      var pt = s.unpack,
          mt = function mt() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = pt(e, "rgb"),
            r = n[0],
            i = n[1],
            o = n[2];
        return (r << 16) + (i << 8) + o;
      },
          _t = s.type,
          yt = function yt(e) {
        if ("number" == _t(e) && e >= 0 && e <= 16777215) {
          var t = e >> 16,
              n = e >> 8 & 255,
              r = 255 & e;
          return [t, n, r, 1];
        }

        throw new Error("unknown num color: " + e);
      },
          vt = s.type;

      f.prototype.num = function () {
        return mt(this._rgb);
      }, m.num = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["num"])))();
      }, u.format.num = yt, u.autodetect.push({
        p: 5,
        test: function test() {
          for (var e = [], t = arguments.length; t--;) {
            e[t] = arguments[t];
          }

          if (1 === e.length && "number" === vt(e[0]) && e[0] >= 0 && e[0] <= 16777215) return "num";
        }
      });
      var gt = s.unpack,
          bt = s.type,
          wt = Math.round;
      f.prototype.rgb = function (e) {
        return void 0 === e && (e = !0), !1 === e ? this._rgb.slice(0, 3) : this._rgb.slice(0, 3).map(wt);
      }, f.prototype.rgba = function (e) {
        return void 0 === e && (e = !0), this._rgb.slice(0, 4).map(function (t, n) {
          return n < 3 ? !1 === e ? t : wt(t) : t;
        });
      }, m.rgb = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["rgb"])))();
      }, u.format.rgb = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        var n = gt(e, "rgba");
        return void 0 === n[3] && (n[3] = 1), n;
      }, u.autodetect.push({
        p: 3,
        test: function test() {
          for (var e = [], t = arguments.length; t--;) {
            e[t] = arguments[t];
          }

          if (e = gt(e, "rgba"), "array" === bt(e) && (3 === e.length || 4 === e.length && "number" == bt(e[3]) && e[3] >= 0 && e[3] <= 1)) return "rgb";
        }
      });

      var Tt = Math.log,
          Mt = function Mt(e) {
        var t,
            n,
            r,
            i = e / 100;
        return i < 66 ? (t = 255, n = -155.25485562709179 - .44596950469579133 * (n = i - 2) + 104.49216199393888 * Tt(n), r = i < 20 ? 0 : .8274096064007395 * (r = i - 10) - 254.76935184120902 + 115.67994401066147 * Tt(r)) : (t = 351.97690566805693 + .114206453784165 * (t = i - 55) - 40.25366309332127 * Tt(t), n = 325.4494125711974 + .07943456536662342 * (n = i - 50) - 28.0852963507957 * Tt(n), r = 255), [t, n, r, 1];
      },
          Et = s.unpack,
          kt = Math.round,
          Lt = function Lt() {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        for (var n, r = Et(e, "rgb"), i = r[0], o = r[2], a = 1e3, s = 4e4; s - a > .4;) {
          var u = Mt(n = .5 * (s + a));
          u[2] / u[0] >= o / i ? s = n : a = n;
        }

        return kt(n);
      };

      f.prototype.temp = f.prototype.kelvin = f.prototype.temperature = function () {
        return Lt(this._rgb);
      }, m.temp = m.kelvin = m.temperature = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        return new (Function.prototype.bind.apply(f, [null].concat(e, ["temp"])))();
      }, u.format.temp = u.format.kelvin = u.format.temperature = Mt;
      var St = s.type;
      f.prototype.alpha = function (e, t) {
        return void 0 === t && (t = !1), void 0 !== e && "number" === St(e) ? t ? (this._rgb[3] = e, this) : new f([this._rgb[0], this._rgb[1], this._rgb[2], e], "rgb") : this._rgb[3];
      }, f.prototype.clipped = function () {
        return this._rgb._clipped || !1;
      }, f.prototype.darken = function (e) {
        void 0 === e && (e = 1);
        var t = this.lab();
        return t[0] -= Ce.Kn * e, new f(t, "lab").alpha(this.alpha(), !0);
      }, f.prototype.brighten = function (e) {
        return void 0 === e && (e = 1), this.darken(-e);
      }, f.prototype.darker = f.prototype.darken, f.prototype.brighter = f.prototype.brighten, f.prototype.get = function (e) {
        var t = e.split("."),
            n = t[0],
            r = t[1],
            i = this[n]();

        if (r) {
          var o = n.indexOf(r);
          if (o > -1) return i[o];
          throw new Error("unknown channel " + r + " in mode " + n);
        }

        return i;
      };
      var Nt = s.type,
          Dt = Math.pow;

      f.prototype.luminance = function (e) {
        if (void 0 !== e && "number" === Nt(e)) {
          if (0 === e) return new f([0, 0, 0, this._rgb[3]], "rgb");
          if (1 === e) return new f([255, 255, 255, this._rgb[3]], "rgb");

          var t = this.luminance(),
              n = 20,
              r = function r(t, i) {
            var o = t.interpolate(i, .5, "rgb"),
                a = o.luminance();
            return Math.abs(e - a) < 1e-7 || !n-- ? o : a > e ? r(t, o) : r(o, i);
          },
              i = (t > e ? r(new f([0, 0, 0]), this) : r(this, new f([255, 255, 255]))).rgb();

          return new f(i.concat([this._rgb[3]]));
        }

        return It.apply(void 0, this._rgb.slice(0, 3));
      };

      var It = function It(e, t, n) {
        return e = Rt(e), t = Rt(t), n = Rt(n), .2126 * e + .7152 * t + .0722 * n;
      },
          Rt = function Rt(e) {
        return (e /= 255) <= .03928 ? e / 12.92 : Dt((e + .055) / 1.055, 2.4);
      },
          xt = {},
          Yt = s.type,
          Ct = function Ct(e, t, n) {
        void 0 === n && (n = .5);

        for (var r = [], i = arguments.length - 3; i-- > 0;) {
          r[i] = arguments[i + 3];
        }

        var o = r[0] || "lrgb";
        if (xt[o] || r.length || (o = Object.keys(xt)[0]), !xt[o]) throw new Error("interpolation mode " + o + " is not defined");
        return "object" !== Yt(e) && (e = new f(e)), "object" !== Yt(t) && (t = new f(t)), xt[o](e, t, n).alpha(e.alpha() + n * (t.alpha() - e.alpha()));
      };

      f.prototype.mix = f.prototype.interpolate = function (e, t) {
        void 0 === t && (t = .5);

        for (var n = [], r = arguments.length - 2; r-- > 0;) {
          n[r] = arguments[r + 2];
        }

        return Ct.apply(void 0, [this, e, t].concat(n));
      }, f.prototype.premultiply = function (e) {
        void 0 === e && (e = !1);
        var t = this._rgb,
            n = t[3];
        return e ? (this._rgb = [t[0] * n, t[1] * n, t[2] * n, n], this) : new f([t[0] * n, t[1] * n, t[2] * n, n], "rgb");
      }, f.prototype.saturate = function (e) {
        void 0 === e && (e = 1);
        var t = this.lch();
        return t[1] += Ce.Kn * e, t[1] < 0 && (t[1] = 0), new f(t, "lch").alpha(this.alpha(), !0);
      }, f.prototype.desaturate = function (e) {
        return void 0 === e && (e = 1), this.saturate(-e);
      };
      var Ot = s.type;
      f.prototype.set = function (e, t, n) {
        void 0 === n && (n = !1);
        var r = e.split("."),
            i = r[0],
            o = r[1],
            a = this[i]();

        if (o) {
          var s = i.indexOf(o);

          if (s > -1) {
            if ("string" == Ot(t)) switch (t.charAt(0)) {
              case "+":
              case "-":
                a[s] += +t;
                break;

              case "*":
                a[s] *= +t.substr(1);
                break;

              case "/":
                a[s] /= +t.substr(1);
                break;

              default:
                a[s] = +t;
            } else {
              if ("number" !== Ot(t)) throw new Error("unsupported value for Color.set");
              a[s] = t;
            }
            var u = new f(a, i);
            return n ? (this._rgb = u._rgb, this) : u;
          }

          throw new Error("unknown channel " + o + " in mode " + i);
        }

        return a;
      }, xt.rgb = function (e, t, n) {
        var r = e._rgb,
            i = t._rgb;
        return new f(r[0] + n * (i[0] - r[0]), r[1] + n * (i[1] - r[1]), r[2] + n * (i[2] - r[2]), "rgb");
      };
      var Ft = Math.sqrt,
          At = Math.pow;
      xt.lrgb = function (e, t, n) {
        var r = e._rgb,
            i = r[0],
            o = r[1],
            a = r[2],
            s = t._rgb,
            u = s[0],
            c = s[1],
            l = s[2];
        return new f(Ft(At(i, 2) * (1 - n) + At(u, 2) * n), Ft(At(o, 2) * (1 - n) + At(c, 2) * n), Ft(At(a, 2) * (1 - n) + At(l, 2) * n), "rgb");
      }, xt.lab = function (e, t, n) {
        var r = e.lab(),
            i = t.lab();
        return new f(r[0] + n * (i[0] - r[0]), r[1] + n * (i[1] - r[1]), r[2] + n * (i[2] - r[2]), "lab");
      };

      var jt = function jt(e, t, n, r) {
        var i, o, a, s, u, c, l, h, d, p, m, _;

        return "hsl" === r ? (a = e.hsl(), s = t.hsl()) : "hsv" === r ? (a = e.hsv(), s = t.hsv()) : "hcg" === r ? (a = e.hcg(), s = t.hcg()) : "hsi" === r ? (a = e.hsi(), s = t.hsi()) : "lch" !== r && "hcl" !== r || (r = "hcl", a = e.hcl(), s = t.hcl()), "h" === r.substr(0, 1) && (u = (i = a)[0], l = i[1], d = i[2], c = (o = s)[0], h = o[1], p = o[2]), isNaN(u) || isNaN(c) ? isNaN(u) ? isNaN(c) ? _ = Number.NaN : (_ = c, 1 != d && 0 != d || "hsv" == r || (m = h)) : (_ = u, 1 != p && 0 != p || "hsv" == r || (m = l)) : _ = u + n * (c > u && c - u > 180 ? c - (u + 360) : c < u && u - c > 180 ? c + 360 - u : c - u), void 0 === m && (m = l + n * (h - l)), new f([_, m, d + n * (p - d)], r);
      },
          Ut = function Ut(e, t, n) {
        return jt(e, t, n, "lch");
      };

      xt.lch = Ut, xt.hcl = Ut, xt.num = function (e, t, n) {
        var r = e.num(),
            i = t.num();
        return new f(r + n * (i - r), "num");
      }, xt.hcg = function (e, t, n) {
        return jt(e, t, n, "hcg");
      }, xt.hsi = function (e, t, n) {
        return jt(e, t, n, "hsi");
      }, xt.hsl = function (e, t, n) {
        return jt(e, t, n, "hsl");
      }, xt.hsv = function (e, t, n) {
        return jt(e, t, n, "hsv");
      };

      var Pt = s.clip_rgb,
          Vt = Math.pow,
          Wt = Math.sqrt,
          Ht = Math.PI,
          Bt = Math.cos,
          zt = Math.sin,
          Zt = Math.atan2,
          Qt = function Qt(e) {
        for (var t = e.length, n = 1 / t, r = [0, 0, 0, 0], i = 0, o = e; i < o.length; i += 1) {
          var a = o[i],
              s = a._rgb;
          r[0] += Vt(s[0], 2) * n, r[1] += Vt(s[1], 2) * n, r[2] += Vt(s[2], 2) * n, r[3] += s[3] * n;
        }

        return r[0] = Wt(r[0]), r[1] = Wt(r[1]), r[2] = Wt(r[2]), r[3] > .9999999 && (r[3] = 1), new f(Pt(r));
      },
          Gt = s.type,
          qt = Math.pow,
          Jt = function Jt(e) {
        var t = "rgb",
            n = m("#ccc"),
            r = 0,
            i = [0, 1],
            o = [],
            a = [0, 0],
            s = !1,
            u = [],
            c = !1,
            l = 0,
            h = 1,
            d = !1,
            f = {},
            p = !0,
            _ = 1,
            y = function y(e) {
          if ((e = e || ["#fff", "#000"]) && "string" === Gt(e) && m.brewer && m.brewer[e.toLowerCase()] && (e = m.brewer[e.toLowerCase()]), "array" === Gt(e)) {
            1 === e.length && (e = [e[0], e[0]]), e = e.slice(0);

            for (var t = 0; t < e.length; t++) {
              e[t] = m(e[t]);
            }

            o.length = 0;

            for (var n = 0; n < e.length; n++) {
              o.push(n / (e.length - 1));
            }
          }

          return b(), u = e;
        },
            v = function v(e) {
          return e;
        },
            g = function g(e, r) {
          var i, c;
          if (null == r && (r = !1), isNaN(e) || null === e) return n;
          if (r) c = e;else if (s && s.length > 2) {
            var d = function (e) {
              if (null != s) {
                for (var t = s.length - 1, n = 0; n < t && e >= s[n];) {
                  n++;
                }

                return n - 1;
              }

              return 0;
            }(e);

            c = d / (s.length - 2);
          } else c = h !== l ? (e - l) / (h - l) : 1;
          r || (c = v(c)), 1 !== _ && (c = qt(c, _)), c = a[0] + c * (1 - a[0] - a[1]), c = Math.min(1, Math.max(0, c));
          var y = Math.floor(1e4 * c);
          if (p && f[y]) i = f[y];else {
            if ("array" === Gt(u)) for (var g = 0; g < o.length; g++) {
              var b = o[g];

              if (c <= b) {
                i = u[g];
                break;
              }

              if (c >= b && g === o.length - 1) {
                i = u[g];
                break;
              }

              if (c > b && c < o[g + 1]) {
                c = (c - b) / (o[g + 1] - b), i = m.interpolate(u[g], u[g + 1], c, t);
                break;
              }
            } else "function" === Gt(u) && (i = u(c));
            p && (f[y] = i);
          }
          return i;
        },
            b = function b() {
          return f = {};
        };

        y(e);

        var w = function w(e) {
          var t = m(g(e));
          return c && t[c] ? t[c]() : t;
        };

        return w.classes = function (e) {
          if (null != e) {
            if ("array" === Gt(e)) s = e, i = [e[0], e[e.length - 1]];else {
              var t = m.analyze(i);
              s = 0 === e ? [t.min, t.max] : m.limits(t, "e", e);
            }
            return w;
          }

          return s;
        }, w.domain = function (e) {
          if (!arguments.length) return i;
          l = e[0], h = e[e.length - 1], o = [];
          var t = u.length;
          if (e.length === t && l !== h) for (var n = 0, r = Array.from(e); n < r.length; n += 1) {
            var a = r[n];
            o.push((a - l) / (h - l));
          } else for (var s = 0; s < t; s++) {
            o.push(s / (t - 1));
          }
          return i = [l, h], w;
        }, w.mode = function (e) {
          return arguments.length ? (t = e, b(), w) : t;
        }, w.range = function (e, t) {
          return y(e), w;
        }, w.out = function (e) {
          return c = e, w;
        }, w.spread = function (e) {
          return arguments.length ? (r = e, w) : r;
        }, w.correctLightness = function (e) {
          return null == e && (e = !0), d = e, b(), v = d ? function (e) {
            for (var t = g(0, !0).lab()[0], n = g(1, !0).lab()[0], r = t > n, i = g(e, !0).lab()[0], o = t + (n - t) * e, a = i - o, s = 0, u = 1, c = 20; Math.abs(a) > .01 && c-- > 0;) {
              r && (a *= -1), a < 0 ? (s = e, e += .5 * (u - e)) : (u = e, e += .5 * (s - e)), i = g(e, !0).lab()[0], a = i - o;
            }

            return e;
          } : function (e) {
            return e;
          }, w;
        }, w.padding = function (e) {
          return null != e ? ("number" === Gt(e) && (e = [e, e]), a = e, w) : a;
        }, w.colors = function (t, n) {
          arguments.length < 2 && (n = "hex");
          var r = [];
          if (0 === arguments.length) r = u.slice(0);else if (1 === t) r = [w(.5)];else if (t > 1) {
            var o = i[0],
                a = i[1] - o;

            r = function (e, t, n) {
              for (var r = [], i = e < t, o = n ? i ? t + 1 : t - 1 : t, a = e; i ? a < o : a > o; i ? a++ : a--) {
                r.push(a);
              }

              return r;
            }(0, t, !1).map(function (e) {
              return w(o + e / (t - 1) * a);
            });
          } else {
            e = [];
            var c = [];
            if (s && s.length > 2) for (var l = 1, h = s.length, d = 1 <= h; d ? l < h : l > h; d ? l++ : l--) {
              c.push(.5 * (s[l - 1] + s[l]));
            } else c = i;
            r = c.map(function (e) {
              return w(e);
            });
          }
          return m[n] && (r = r.map(function (e) {
            return e[n]();
          })), r;
        }, w.cache = function (e) {
          return null != e ? (p = e, w) : p;
        }, w.gamma = function (e) {
          return null != e ? (_ = e, w) : _;
        }, w.nodata = function (e) {
          return null != e ? (n = m(e), w) : n;
        }, w;
      },
          Xt = function Xt(e) {
        var t, n, r, i, o, a, s;
        if (2 === (e = e.map(function (e) {
          return new f(e);
        })).length) t = e.map(function (e) {
          return e.lab();
        }), o = t[0], a = t[1], i = function i(e) {
          var t = [0, 1, 2].map(function (t) {
            return o[t] + e * (a[t] - o[t]);
          });
          return new f(t, "lab");
        };else if (3 === e.length) n = e.map(function (e) {
          return e.lab();
        }), o = n[0], a = n[1], s = n[2], i = function i(e) {
          var t = [0, 1, 2].map(function (t) {
            return (1 - e) * (1 - e) * o[t] + 2 * (1 - e) * e * a[t] + e * e * s[t];
          });
          return new f(t, "lab");
        };else if (4 === e.length) {
          var u;
          r = e.map(function (e) {
            return e.lab();
          }), o = r[0], a = r[1], s = r[2], u = r[3], i = function i(e) {
            var t = [0, 1, 2].map(function (t) {
              return (1 - e) * (1 - e) * (1 - e) * o[t] + 3 * (1 - e) * (1 - e) * e * a[t] + 3 * (1 - e) * e * e * s[t] + e * e * e * u[t];
            });
            return new f(t, "lab");
          };
        } else if (5 === e.length) {
          var c = Xt(e.slice(0, 3)),
              l = Xt(e.slice(2, 5));

          i = function i(e) {
            return e < .5 ? c(2 * e) : l(2 * (e - .5));
          };
        }
        return i;
      },
          Kt = function Kt(e, t, n) {
        if (!Kt[n]) throw new Error("unknown blend mode " + n);
        return Kt[n](e, t);
      },
          $t = function $t(e) {
        return function (t, n) {
          var r = m(n).rgb(),
              i = m(t).rgb();
          return m.rgb(e(r, i));
        };
      },
          en = function en(e) {
        return function (t, n) {
          var r = [];
          return r[0] = e(t[0], n[0]), r[1] = e(t[1], n[1]), r[2] = e(t[2], n[2]), r;
        };
      };

      Kt.normal = $t(en(function (e) {
        return e;
      })), Kt.multiply = $t(en(function (e, t) {
        return e * t / 255;
      })), Kt.screen = $t(en(function (e, t) {
        return 255 * (1 - (1 - e / 255) * (1 - t / 255));
      })), Kt.overlay = $t(en(function (e, t) {
        return t < 128 ? 2 * e * t / 255 : 255 * (1 - 2 * (1 - e / 255) * (1 - t / 255));
      })), Kt.darken = $t(en(function (e, t) {
        return e > t ? t : e;
      })), Kt.lighten = $t(en(function (e, t) {
        return e > t ? e : t;
      })), Kt.dodge = $t(en(function (e, t) {
        return 255 === e ? 255 : (e = t / 255 * 255 / (1 - e / 255)) > 255 ? 255 : e;
      })), Kt.burn = $t(en(function (e, t) {
        return 255 * (1 - (1 - t / 255) / (e / 255));
      }));

      for (var tn = Kt, nn = s.type, rn = s.clip_rgb, on = s.TWOPI, an = Math.pow, sn = Math.sin, un = Math.cos, cn = Math.floor, ln = Math.random, hn = Math.log, dn = Math.pow, fn = Math.floor, pn = Math.abs, mn = function mn(e, t) {
        void 0 === t && (t = null);
        var n = {
          min: Number.MAX_VALUE,
          max: -1 * Number.MAX_VALUE,
          sum: 0,
          values: [],
          count: 0
        };
        return "object" === o(e) && (e = Object.values(e)), e.forEach(function (e) {
          t && "object" === o(e) && (e = e[t]), null == e || isNaN(e) || (n.values.push(e), n.sum += e, e < n.min && (n.min = e), e > n.max && (n.max = e), n.count += 1);
        }), n.domain = [n.min, n.max], n.limits = function (e, t) {
          return _n(n, e, t);
        }, n;
      }, _n = function _n(e, t, n) {
        void 0 === t && (t = "equal"), void 0 === n && (n = 7), "array" == o(e) && (e = mn(e));
        var r = e.min,
            i = e.max,
            a = e.values.sort(function (e, t) {
          return e - t;
        });
        if (1 === n) return [r, i];
        var s = [];

        if ("c" === t.substr(0, 1) && (s.push(r), s.push(i)), "e" === t.substr(0, 1)) {
          s.push(r);

          for (var u = 1; u < n; u++) {
            s.push(r + u / n * (i - r));
          }

          s.push(i);
        } else if ("l" === t.substr(0, 1)) {
          if (r <= 0) throw new Error("Logarithmic scales are only possible for values > 0");
          var c = Math.LOG10E * hn(r),
              l = Math.LOG10E * hn(i);
          s.push(r);

          for (var h = 1; h < n; h++) {
            s.push(dn(10, c + h / n * (l - c)));
          }

          s.push(i);
        } else if ("q" === t.substr(0, 1)) {
          s.push(r);

          for (var d = 1; d < n; d++) {
            var f = (a.length - 1) * d / n,
                p = fn(f);
            if (p === f) s.push(a[p]);else {
              var m = f - p;
              s.push(a[p] * (1 - m) + a[p + 1] * m);
            }
          }

          s.push(i);
        } else if ("k" === t.substr(0, 1)) {
          var _,
              y = a.length,
              v = new Array(y),
              g = new Array(n),
              b = !0,
              w = 0,
              T = null;

          (T = []).push(r);

          for (var M = 1; M < n; M++) {
            T.push(r + M / n * (i - r));
          }

          for (T.push(i); b;) {
            for (var E = 0; E < n; E++) {
              g[E] = 0;
            }

            for (var k = 0; k < y; k++) {
              for (var L = a[k], S = Number.MAX_VALUE, N = void 0, D = 0; D < n; D++) {
                var I = pn(T[D] - L);
                I < S && (S = I, N = D), g[N]++, v[k] = N;
              }
            }

            for (var R = new Array(n), x = 0; x < n; x++) {
              R[x] = null;
            }

            for (var Y = 0; Y < y; Y++) {
              _ = v[Y], null === R[_] ? R[_] = a[Y] : R[_] += a[Y];
            }

            for (var C = 0; C < n; C++) {
              R[C] *= 1 / g[C];
            }

            b = !1;

            for (var O = 0; O < n; O++) {
              if (R[O] !== T[O]) {
                b = !0;
                break;
              }
            }

            T = R, ++w > 200 && (b = !1);
          }

          for (var F = {}, A = 0; A < n; A++) {
            F[A] = [];
          }

          for (var j = 0; j < y; j++) {
            _ = v[j], F[_].push(a[j]);
          }

          for (var U = [], P = 0; P < n; P++) {
            U.push(F[P][0]), U.push(F[P][F[P].length - 1]);
          }

          U = U.sort(function (e, t) {
            return e - t;
          }), s.push(U[0]);

          for (var V = 1; V < U.length; V += 2) {
            var W = U[V];
            isNaN(W) || -1 !== s.indexOf(W) || s.push(W);
          }
        }

        return s;
      }, yn = {
        analyze: mn,
        limits: _n
      }, vn = Math.sqrt, gn = Math.atan2, bn = Math.abs, wn = Math.cos, Tn = Math.PI, Mn = {
        cool: function cool() {
          return Jt([m.hsl(180, 1, .9), m.hsl(250, .7, .4)]);
        },
        hot: function hot() {
          return Jt(["#000", "#f00", "#ff0", "#fff"]).mode("rgb");
        }
      }, En = {
        OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"],
        PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"],
        BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"],
        Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"],
        BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"],
        YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"],
        YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"],
        Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"],
        RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"],
        Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"],
        YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
        Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"],
        GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"],
        Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
        YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"],
        PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"],
        Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"],
        PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"],
        Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"],
        Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
        RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
        RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
        PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
        PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
        RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
        BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
        RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
        PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
        Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
        Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
        Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"],
        Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"],
        Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"],
        Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"],
        Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"],
        Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
      }, kn = 0, Ln = Object.keys(En); kn < Ln.length; kn += 1) {
        var Sn = Ln[kn];
        En[Sn.toLowerCase()] = En[Sn];
      }

      var Nn = En;
      return m.average = function (e, t) {
        void 0 === t && (t = "lrgb");
        var n = e.length;
        if (e = e.map(function (e) {
          return new f(e);
        }), "lrgb" === t) return Qt(e);

        for (var r = e.shift(), i = r.get(t), o = [], a = 0, s = 0, u = 0; u < i.length; u++) {
          if (i[u] = i[u] || 0, o.push(isNaN(i[u]) ? 0 : 1), "h" === t.charAt(u) && !isNaN(i[u])) {
            var c = i[u] / 180 * Ht;
            a += Bt(c), s += zt(c);
          }
        }

        var l = r.alpha();
        e.forEach(function (e) {
          var n = e.get(t);
          l += e.alpha();

          for (var r = 0; r < i.length; r++) {
            if (!isNaN(n[r])) if (o[r]++, "h" === t.charAt(r)) {
              var u = n[r] / 180 * Ht;
              a += Bt(u), s += zt(u);
            } else i[r] += n[r];
          }
        });

        for (var h = 0; h < i.length; h++) {
          if ("h" === t.charAt(h)) {
            for (var d = Zt(s / o[h], a / o[h]) / Ht * 180; d < 0;) {
              d += 360;
            }

            for (; d >= 360;) {
              d -= 360;
            }

            i[h] = d;
          } else i[h] = i[h] / o[h];
        }

        return l /= n, new f(i, t).alpha(l > .99999 ? 1 : l, !0);
      }, m.bezier = function (e) {
        var t = Xt(e);
        return t.scale = function () {
          return Jt(t);
        }, t;
      }, m.blend = tn, m.cubehelix = function (e, t, n, r, i) {
        void 0 === e && (e = 300), void 0 === t && (t = -1.5), void 0 === n && (n = 1), void 0 === r && (r = 1), void 0 === i && (i = [0, 1]);
        var o,
            a = 0;
        "array" === nn(i) ? o = i[1] - i[0] : (o = 0, i = [i, i]);

        var s = function s(_s2) {
          var u = on * ((e + 120) / 360 + t * _s2),
              c = an(i[0] + o * _s2, r),
              l = 0 !== a ? n[0] + _s2 * a : n,
              h = l * c * (1 - c) / 2,
              d = un(u),
              f = sn(u),
              p = c + h * (-.14861 * d + 1.78277 * f),
              _ = c + h * (-.29227 * d - .90649 * f),
              y = c + h * (1.97294 * d);

          return m(rn([255 * p, 255 * _, 255 * y, 1]));
        };

        return s.start = function (t) {
          return null == t ? e : (e = t, s);
        }, s.rotations = function (e) {
          return null == e ? t : (t = e, s);
        }, s.gamma = function (e) {
          return null == e ? r : (r = e, s);
        }, s.hue = function (e) {
          return null == e ? n : ("array" === nn(n = e) ? 0 == (a = n[1] - n[0]) && (n = n[1]) : a = 0, s);
        }, s.lightness = function (e) {
          return null == e ? i : ("array" === nn(e) ? (i = e, o = e[1] - e[0]) : (i = [e, e], o = 0), s);
        }, s.scale = function () {
          return m.scale(s);
        }, s.hue(n), s;
      }, m.mix = m.interpolate = Ct, m.random = function () {
        for (var e = "#", t = 0; t < 6; t++) {
          e += "0123456789abcdef".charAt(cn(16 * ln()));
        }

        return new f(e, "hex");
      }, m.scale = Jt, m.analyze = yn.analyze, m.contrast = function (e, t) {
        e = new f(e), t = new f(t);
        var n = e.luminance(),
            r = t.luminance();
        return n > r ? (n + .05) / (r + .05) : (r + .05) / (n + .05);
      }, m.deltaE = function (e, t, n, r) {
        void 0 === n && (n = 1), void 0 === r && (r = 1), e = new f(e), t = new f(t);

        for (var i = Array.from(e.lab()), o = i[0], a = i[1], s = i[2], u = Array.from(t.lab()), c = u[0], l = u[1], h = u[2], d = vn(a * a + s * s), p = vn(l * l + h * h), m = o < 16 ? .511 : .040975 * o / (1 + .01765 * o), _ = .0638 * d / (1 + .0131 * d) + .638, y = d < 1e-6 ? 0 : 180 * gn(s, a) / Tn; y < 0;) {
          y += 360;
        }

        for (; y >= 360;) {
          y -= 360;
        }

        var v = y >= 164 && y <= 345 ? .56 + bn(.2 * wn(Tn * (y + 168) / 180)) : .36 + bn(.4 * wn(Tn * (y + 35) / 180)),
            g = d * d * d * d,
            b = vn(g / (g + 1900)),
            w = _ * (b * v + 1 - b),
            T = d - p,
            M = a - l,
            E = s - h,
            k = (o - c) / (n * m),
            L = T / (r * _);
        return vn(k * k + L * L + (M * M + E * E - T * T) / (w * w));
      }, m.distance = function (e, t, n) {
        void 0 === n && (n = "lab"), e = new f(e), t = new f(t);
        var r = e.get(n),
            i = t.get(n),
            o = 0;

        for (var a in r) {
          var s = (r[a] || 0) - (i[a] || 0);
          o += s * s;
        }

        return Math.sqrt(o);
      }, m.limits = yn.limits, m.valid = function () {
        for (var e = [], t = arguments.length; t--;) {
          e[t] = arguments[t];
        }

        try {
          return new (Function.prototype.bind.apply(f, [null].concat(e)))(), !0;
        } catch (e) {
          return !1;
        }
      }, m.scales = Mn, m.colors = U, m.brewer = Nn, m;
    }();
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(1),
          a = n(5),
          s = n(219),
          u = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetContainer\\components\\ActionMenu.tsx";

      function c() {
        return (c = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var r in n) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        }).apply(this, arguments);
      }

      var l = a.Intl.FormattedMessage,
          h = o.styled.div(_templateObject2()),
          d = Object(o.styled)(o.Button)({
        marginRight: 24
      });

      t.a = function (_ref64) {
        var t = _ref64.onAddNewWidget,
            n = _objectWithoutProperties(_ref64, ["onAddNewWidget"]);

        return i.a.createElement(h, {
          __source: {
            fileName: u,
            lineNumber: 23
          },
          __self: void 0
        }, n.isEditable ? i.a.createElement(d, {
          onClick: t,
          __source: {
            fileName: u,
            lineNumber: 25
          },
          __self: void 0
        }, i.a.createElement(o.H4, {
          __source: {
            fileName: u,
            lineNumber: 26
          },
          __self: void 0
        }, i.a.createElement(l, {
          id: e.modules.widget.actionMenu.add,
          __source: {
            fileName: u,
            lineNumber: 27
          },
          __self: void 0
        })), i.a.createElement(o.Icon, {
          type: "plus",
          textual: !0,
          __source: {
            fileName: u,
            lineNumber: 29
          },
          __self: void 0
        })) : null, i.a.createElement(s.a, c({}, n, {
          __source: {
            fileName: u,
            lineNumber: 32
          },
          __self: void 0
        })));
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(1),
          a = n(5),
          s = n(4),
          u = n(7),
          c = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetContainer\\components\\ContextMenu.tsx";

      function l() {
        return (l = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];

            for (var r in n) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        }).apply(this, arguments);
      }

      var h = a.Intl.FormattedMessage;

      t.a = function (_ref65) {
        var t = _ref65.isEditable,
            n = _ref65.onRefresh,
            a = _ref65.onRestore,
            d = _ref65.onEdit,
            f = _objectWithoutProperties(_ref65, ["isEditable", "onRefresh", "onRestore", "onEdit"]);

        var p = Object(r.useMemo)(function () {
          return function (t, n, r, o) {
            return t ? [{
              icon: "restore",
              text: i.a.createElement(h, {
                id: e.modules.widget.contextMenu.restore,
                __source: {
                  fileName: c,
                  lineNumber: 33
                },
                __self: void 0
              }),
              onClick: function onClick() {
                return r();
              }
            }] : [{
              icon: "refresh",
              text: i.a.createElement(h, {
                id: e.modules.widget.contextMenu.refresh,
                __source: {
                  fileName: c,
                  lineNumber: 44
                },
                __self: void 0
              }),
              onClick: function onClick() {
                return n();
              }
            }, {
              icon: "edit",
              text: i.a.createElement(h, {
                id: e.modules.widget.contextMenu.edit,
                __source: {
                  fileName: c,
                  lineNumber: 53
                },
                __self: void 0
              }),
              onClick: function onClick() {
                return o();
              },
              permission: s.AppPermissions.EditDashboard
            }];
          }(t, n, a, d);
        }, [t, n, a, d]),
            m = Object(u.e)(p);
        return i.a.createElement(o.Dropdown, l({}, f, {
          overlay: i.a.createElement(o.DropdownMenu, {
            items: m,
            style: {
              width: 224
            },
            __source: {
              fileName: c,
              lineNumber: 77
            },
            __self: void 0
          }),
          __source: {
            fileName: c,
            lineNumber: 74
          },
          __self: void 0
        }), i.a.createElement(o.Icon, {
          type: "more",
          style: {
            verticalAlign: "middle"
          },
          __source: {
            fileName: c,
            lineNumber: 80
          },
          __self: void 0
        }));
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(1),
          a = n(5),
          s = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetContainer\\components\\Footer.tsx";
      var u = a.Intl.FormattedMessage,
          c = Object(o.styled)(o.Container)(function (_ref66) {
        var e = _ref66.theme;
        return {
          zIndex: 2,
          backgroundColor: e.newColors.bgWidgetPrimary,
          boxShadow: "0px -6px 16px ".concat(e.newColors.bgRowHover),
          height: 70,
          paddingRight: 40
        };
      });

      t.a = function (_ref67) {
        var t = _ref67.onCancel,
            n = _ref67.onSaveDashboard;
        return i.a.createElement(c, {
          __source: {
            fileName: s,
            lineNumber: 21
          },
          __self: void 0
        }, i.a.createElement(o.Flex, {
          justify: "flex-end",
          align: "center",
          stretch: !0,
          gutter: 3,
          __source: {
            fileName: s,
            lineNumber: 22
          },
          __self: void 0
        }, i.a.createElement(o.Button, {
          onClick: t,
          __source: {
            fileName: s,
            lineNumber: 23
          },
          __self: void 0
        }, i.a.createElement(o.H4, {
          __source: {
            fileName: s,
            lineNumber: 24
          },
          __self: void 0
        }, i.a.createElement(u, {
          id: e.modules.widget.editbar.cancel,
          __source: {
            fileName: s,
            lineNumber: 25
          },
          __self: void 0
        }))), i.a.createElement(o.Button, {
          type: "primary",
          onClick: n,
          __source: {
            fileName: s,
            lineNumber: 28
          },
          __self: void 0
        }, i.a.createElement(o.H4, {
          color: "headerTertiary",
          __source: {
            fileName: s,
            lineNumber: 29
          },
          __self: void 0
        }, i.a.createElement(u, {
          id: e.modules.widget.editbar.save,
          __source: {
            fileName: s,
            lineNumber: 30
          },
          __self: void 0
        })))));
      };
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    var r = n(62);
    n.d(t, "a", function () {
      return r.a;
    });
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return l;
    });
    var r = n(0),
        i = n.n(r),
        o = n(1),
        a = n(5),
        s = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetWizardContainer\\WidgetList.tsx";

    var u = a.Intl.FormattedMessage,
        c = Object(o.styled)(o.Flex)(function (_ref68) {
      var e = _ref68.theme;
      return {
        margin: 10,
        borderRadius: 8,
        width: 320,
        height: 220,
        boxShadow: e.shadows.dropdownCard,
        cursor: "pointer",
        backgroundColor: e.newColors.bgWidgetSecondary,
        color: e.newColors.statusDisabled,
        "&:hover": {
          backgroundColor: e.newColors.bgStandard,
          "&": {
            ".anticon": {
              color: e.newColors.statusStandard
            }
          }
        },
        "& .widget-item-footer": {
          backgroundColor: e.newColors.bgWidgetPrimary
        }
      };
    }),
        l = function l(_ref69) {
      var e = _ref69.widgets,
          t = _ref69.onSelect;
      return i.a.createElement(o.Flex, {
        justify: "space-between",
        __source: {
          fileName: s,
          lineNumber: 42
        },
        __self: void 0
      }, e.map(function (e) {
        return i.a.createElement(c, {
          direction: "column",
          key: e.type,
          onClick: function onClick() {
            return t(e);
          },
          __source: {
            fileName: s,
            lineNumber: 44
          },
          __self: void 0
        }, i.a.createElement(o.FlexItem, {
          __source: {
            fileName: s,
            lineNumber: 49
          },
          __self: void 0
        }, i.a.createElement(o.Flex, {
          stretch: !0,
          align: "center",
          justify: "center",
          __source: {
            fileName: s,
            lineNumber: 50
          },
          __self: void 0
        }, i.a.createElement(o.Icon, {
          type: e.icon,
          style: {
            fontSize: "64px"
          },
          __source: {
            fileName: s,
            lineNumber: 51
          },
          __self: void 0
        }))), i.a.createElement(o.FlexItem, {
          className: "widget-item-footer",
          flex: "100px 0",
          padding: 3,
          __source: {
            fileName: s,
            lineNumber: 54
          },
          __self: void 0
        }, i.a.createElement(o.H3, {
          color: "bodyPrimary",
          __source: {
            fileName: s,
            lineNumber: 55
          },
          __self: void 0
        }, i.a.createElement(u, {
          id: e.title,
          __source: {
            fileName: s,
            lineNumber: 56
          },
          __self: void 0
        })), i.a.createElement(o.Text, {
          color: "labelPrimary",
          padding: [1, 0, 0, 0],
          __source: {
            fileName: s,
            lineNumber: 58
          },
          __self: void 0
        }, i.a.createElement(u, {
          id: e.description,
          __source: {
            fileName: s,
            lineNumber: 59
          },
          __self: void 0
        }))));
      }));
    };
  }, function (e, t, n) {
    (function (e, n) {
      var r = 200,
          i = "Expected a function",
          o = "__lodash_hash_undefined__",
          a = 1,
          s = 2,
          u = 1 / 0,
          c = 9007199254740991,
          l = "[object Arguments]",
          h = "[object Array]",
          d = "[object Boolean]",
          f = "[object Date]",
          p = "[object Error]",
          m = "[object Function]",
          _ = "[object GeneratorFunction]",
          y = "[object Map]",
          v = "[object Number]",
          g = "[object Object]",
          b = "[object RegExp]",
          w = "[object Set]",
          T = "[object String]",
          M = "[object Symbol]",
          E = "[object ArrayBuffer]",
          k = "[object DataView]",
          L = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          S = /^\w*$/,
          N = /^\./,
          D = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          I = /\\(\\)?/g,
          R = /^\[object .+?Constructor\]$/,
          x = /^(?:0|[1-9]\d*)$/,
          Y = {};
      Y["[object Float32Array]"] = Y["[object Float64Array]"] = Y["[object Int8Array]"] = Y["[object Int16Array]"] = Y["[object Int32Array]"] = Y["[object Uint8Array]"] = Y["[object Uint8ClampedArray]"] = Y["[object Uint16Array]"] = Y["[object Uint32Array]"] = !0, Y[l] = Y[h] = Y[E] = Y[d] = Y[k] = Y[f] = Y[p] = Y[m] = Y[y] = Y[v] = Y[g] = Y[b] = Y[w] = Y[T] = Y["[object WeakMap]"] = !1;

      var C = "object" == typeof e && e && e.Object === Object && e,
          O = "object" == typeof self && self && self.Object === Object && self,
          F = C || O || Function("return this")(),
          A = t && !t.nodeType && t,
          j = A && "object" == typeof n && n && !n.nodeType && n,
          U = j && j.exports === A && C.process,
          P = function () {
        try {
          return U && U.binding("util");
        } catch (e) {}
      }(),
          V = P && P.isTypedArray;

      function W(e, t) {
        for (var n = -1, r = e ? e.length : 0; ++n < r;) {
          if (t(e[n], n, e)) return !0;
        }

        return !1;
      }

      function H(e) {
        var t = !1;
        if (null != e && "function" != typeof e.toString) try {
          t = !!(e + "");
        } catch (e) {}
        return t;
      }

      function B(e) {
        var t = -1,
            n = Array(e.size);
        return e.forEach(function (e, r) {
          n[++t] = [r, e];
        }), n;
      }

      function z(e) {
        var t = -1,
            n = Array(e.size);
        return e.forEach(function (e) {
          n[++t] = e;
        }), n;
      }

      var Z,
          Q,
          G,
          q = Array.prototype,
          J = Function.prototype,
          X = Object.prototype,
          K = F["__core-js_shared__"],
          $ = (Z = /[^.]+$/.exec(K && K.keys && K.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Z : "",
          ee = J.toString,
          te = X.hasOwnProperty,
          ne = X.toString,
          re = RegExp("^" + ee.call(te).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          ie = F.Symbol,
          oe = F.Uint8Array,
          ae = X.propertyIsEnumerable,
          se = q.splice,
          ue = (Q = Object.keys, G = Object, function (e) {
        return Q(G(e));
      }),
          ce = Pe(F, "DataView"),
          le = Pe(F, "Map"),
          he = Pe(F, "Promise"),
          de = Pe(F, "Set"),
          fe = Pe(F, "WeakMap"),
          pe = Pe(Object, "create"),
          me = Ge(ce),
          _e = Ge(le),
          ye = Ge(he),
          ve = Ge(de),
          ge = Ge(fe),
          be = ie ? ie.prototype : void 0,
          we = be ? be.valueOf : void 0,
          Te = be ? be.toString : void 0;

      function Me(e) {
        var t = -1,
            n = e ? e.length : 0;

        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }

      function Ee(e) {
        var t = -1,
            n = e ? e.length : 0;

        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }

      function ke(e) {
        var t = -1,
            n = e ? e.length : 0;

        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }

      function Le(e) {
        var t = -1,
            n = e ? e.length : 0;

        for (this.__data__ = new ke(); ++t < n;) {
          this.add(e[t]);
        }
      }

      function Se(e) {
        this.__data__ = new Ee(e);
      }

      function Ne(e, t) {
        var n = Ke(e) || Xe(e) ? function (e, t) {
          for (var n = -1, r = Array(e); ++n < e;) {
            r[n] = t(n);
          }

          return r;
        }(e.length, String) : [],
            r = n.length,
            i = !!r;

        for (var o in e) {
          !t && !te.call(e, o) || i && ("length" == o || We(o, r)) || n.push(o);
        }

        return n;
      }

      function De(e, t) {
        for (var n = e.length; n--;) {
          if (Je(e[n][0], t)) return n;
        }

        return -1;
      }

      function Ie(e, t) {
        for (var n = 0, r = (t = He(t, e) ? [t] : Ae(t)).length; null != e && n < r;) {
          e = e[Qe(t[n++])];
        }

        return n && n == r ? e : void 0;
      }

      function Re(e, t) {
        return e > t;
      }

      function xe(e, t) {
        return null != e && t in Object(e);
      }

      function Ye(e, t, n, r, i) {
        return e === t || (null == e || null == t || !nt(e) && !rt(t) ? e != e && t != t : function (e, t, n, r, i, o) {
          var u = Ke(e),
              c = Ke(t),
              m = h,
              _ = h;
          u || (m = (m = Ve(e)) == l ? g : m);
          c || (_ = (_ = Ve(t)) == l ? g : _);
          var L = m == g && !H(e),
              S = _ == g && !H(t),
              N = m == _;
          if (N && !L) return o || (o = new Se()), u || ot(e) ? je(e, t, n, r, i, o) : function (e, t, n, r, i, o, u) {
            switch (n) {
              case k:
                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                e = e.buffer, t = t.buffer;

              case E:
                return !(e.byteLength != t.byteLength || !r(new oe(e), new oe(t)));

              case d:
              case f:
              case v:
                return Je(+e, +t);

              case p:
                return e.name == t.name && e.message == t.message;

              case b:
              case T:
                return e == t + "";

              case y:
                var c = B;

              case w:
                var l = o & s;
                if (c || (c = z), e.size != t.size && !l) return !1;
                var h = u.get(e);
                if (h) return h == t;
                o |= a, u.set(e, t);
                var m = je(c(e), c(t), r, i, o, u);
                return u.delete(e), m;

              case M:
                if (we) return we.call(e) == we.call(t);
            }

            return !1;
          }(e, t, m, n, r, i, o);

          if (!(i & s)) {
            var D = L && te.call(e, "__wrapped__"),
                I = S && te.call(t, "__wrapped__");

            if (D || I) {
              var R = D ? e.value() : e,
                  x = I ? t.value() : t;
              return o || (o = new Se()), n(R, x, r, i, o);
            }
          }

          if (!N) return !1;
          return o || (o = new Se()), function (e, t, n, r, i, o) {
            var a = i & s,
                u = at(e),
                c = u.length,
                l = at(t).length;
            if (c != l && !a) return !1;

            for (var h = c; h--;) {
              var d = u[h];
              if (!(a ? d in t : te.call(t, d))) return !1;
            }

            var f = o.get(e);
            if (f && o.get(t)) return f == t;
            var p = !0;
            o.set(e, t), o.set(t, e);

            for (var m = a; ++h < c;) {
              d = u[h];
              var _ = e[d],
                  y = t[d];
              if (r) var v = a ? r(y, _, d, t, e, o) : r(_, y, d, e, t, o);

              if (!(void 0 === v ? _ === y || n(_, y, r, i, o) : v)) {
                p = !1;
                break;
              }

              m || (m = "constructor" == d);
            }

            if (p && !m) {
              var g = e.constructor,
                  b = t.constructor;
              g != b && "constructor" in e && "constructor" in t && !("function" == typeof g && g instanceof g && "function" == typeof b && b instanceof b) && (p = !1);
            }

            return o.delete(e), o.delete(t), p;
          }(e, t, n, r, i, o);
        }(e, t, Ye, n, r, i));
      }

      function Ce(e) {
        return !(!nt(e) || (t = e, $ && $ in t)) && (et(e) || H(e) ? re : R).test(Ge(e));
        var t;
      }

      function Oe(e) {
        return "function" == typeof e ? e : null == e ? st : "object" == typeof e ? Ke(e) ? function (e, t) {
          if (He(e) && Be(t)) return ze(Qe(e), t);
          return function (n) {
            var r = function (e, t, n) {
              var r = null == e ? void 0 : Ie(e, t);
              return void 0 === r ? n : r;
            }(n, e);

            return void 0 === r && r === t ? function (e, t) {
              return null != e && function (e, t, n) {
                t = He(t, e) ? [t] : Ae(t);
                var r,
                    i = -1,
                    o = t.length;

                for (; ++i < o;) {
                  var a = Qe(t[i]);
                  if (!(r = null != e && n(e, a))) break;
                  e = e[a];
                }

                if (r) return r;
                return !!(o = e ? e.length : 0) && tt(o) && We(a, o) && (Ke(e) || Xe(e));
              }(e, t, xe);
            }(n, e) : Ye(t, r, void 0, a | s);
          };
        }(e[0], e[1]) : function (e) {
          var t = function (e) {
            var t = at(e),
                n = t.length;

            for (; n--;) {
              var r = t[n],
                  i = e[r];
              t[n] = [r, i, Be(i)];
            }

            return t;
          }(e);

          if (1 == t.length && t[0][2]) return ze(t[0][0], t[0][1]);
          return function (n) {
            return n === e || function (e, t, n, r) {
              var i = n.length,
                  o = i,
                  u = !r;
              if (null == e) return !o;

              for (e = Object(e); i--;) {
                var c = n[i];
                if (u && c[2] ? c[1] !== e[c[0]] : !(c[0] in e)) return !1;
              }

              for (; ++i < o;) {
                var l = (c = n[i])[0],
                    h = e[l],
                    d = c[1];

                if (u && c[2]) {
                  if (void 0 === h && !(l in e)) return !1;
                } else {
                  var f = new Se();
                  if (r) var p = r(h, d, l, e, t, f);
                  if (!(void 0 === p ? Ye(d, h, r, a | s, f) : p)) return !1;
                }
              }

              return !0;
            }(n, e, t);
          };
        }(e) : He(t = e) ? (n = Qe(t), function (e) {
          return null == e ? void 0 : e[n];
        }) : function (e) {
          return function (t) {
            return Ie(t, e);
          };
        }(t);
        var t, n;
      }

      function Fe(e) {
        if (n = (t = e) && t.constructor, r = "function" == typeof n && n.prototype || X, t !== r) return ue(e);
        var t,
            n,
            r,
            i = [];

        for (var o in Object(e)) {
          te.call(e, o) && "constructor" != o && i.push(o);
        }

        return i;
      }

      function Ae(e) {
        return Ke(e) ? e : Ze(e);
      }

      function je(e, t, n, r, i, o) {
        var u = i & s,
            c = e.length,
            l = t.length;
        if (c != l && !(u && l > c)) return !1;
        var h = o.get(e);
        if (h && o.get(t)) return h == t;
        var d = -1,
            f = !0,
            p = i & a ? new Le() : void 0;

        for (o.set(e, t), o.set(t, e); ++d < c;) {
          var m = e[d],
              _ = t[d];
          if (r) var y = u ? r(_, m, d, t, e, o) : r(m, _, d, e, t, o);

          if (void 0 !== y) {
            if (y) continue;
            f = !1;
            break;
          }

          if (p) {
            if (!W(t, function (e, t) {
              if (!p.has(t) && (m === e || n(m, e, r, i, o))) return p.add(t);
            })) {
              f = !1;
              break;
            }
          } else if (m !== _ && !n(m, _, r, i, o)) {
            f = !1;
            break;
          }
        }

        return o.delete(e), o.delete(t), f;
      }

      function Ue(e, t) {
        var n,
            r,
            i = e.__data__;
        return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof t ? "string" : "hash"] : i.map;
      }

      function Pe(e, t) {
        var n = function (e, t) {
          return null == e ? void 0 : e[t];
        }(e, t);

        return Ce(n) ? n : void 0;
      }

      Me.prototype.clear = function () {
        this.__data__ = pe ? pe(null) : {};
      }, Me.prototype.delete = function (e) {
        return this.has(e) && delete this.__data__[e];
      }, Me.prototype.get = function (e) {
        var t = this.__data__;

        if (pe) {
          var n = t[e];
          return n === o ? void 0 : n;
        }

        return te.call(t, e) ? t[e] : void 0;
      }, Me.prototype.has = function (e) {
        var t = this.__data__;
        return pe ? void 0 !== t[e] : te.call(t, e);
      }, Me.prototype.set = function (e, t) {
        return this.__data__[e] = pe && void 0 === t ? o : t, this;
      }, Ee.prototype.clear = function () {
        this.__data__ = [];
      }, Ee.prototype.delete = function (e) {
        var t = this.__data__,
            n = De(t, e);
        return !(n < 0 || (n == t.length - 1 ? t.pop() : se.call(t, n, 1), 0));
      }, Ee.prototype.get = function (e) {
        var t = this.__data__,
            n = De(t, e);
        return n < 0 ? void 0 : t[n][1];
      }, Ee.prototype.has = function (e) {
        return De(this.__data__, e) > -1;
      }, Ee.prototype.set = function (e, t) {
        var n = this.__data__,
            r = De(n, e);
        return r < 0 ? n.push([e, t]) : n[r][1] = t, this;
      }, ke.prototype.clear = function () {
        this.__data__ = {
          hash: new Me(),
          map: new (le || Ee)(),
          string: new Me()
        };
      }, ke.prototype.delete = function (e) {
        return Ue(this, e).delete(e);
      }, ke.prototype.get = function (e) {
        return Ue(this, e).get(e);
      }, ke.prototype.has = function (e) {
        return Ue(this, e).has(e);
      }, ke.prototype.set = function (e, t) {
        return Ue(this, e).set(e, t), this;
      }, Le.prototype.add = Le.prototype.push = function (e) {
        return this.__data__.set(e, o), this;
      }, Le.prototype.has = function (e) {
        return this.__data__.has(e);
      }, Se.prototype.clear = function () {
        this.__data__ = new Ee();
      }, Se.prototype.delete = function (e) {
        return this.__data__.delete(e);
      }, Se.prototype.get = function (e) {
        return this.__data__.get(e);
      }, Se.prototype.has = function (e) {
        return this.__data__.has(e);
      }, Se.prototype.set = function (e, t) {
        var n = this.__data__;

        if (n instanceof Ee) {
          var i = n.__data__;
          if (!le || i.length < r - 1) return i.push([e, t]), this;
          n = this.__data__ = new ke(i);
        }

        return n.set(e, t), this;
      };

      var Ve = function Ve(e) {
        return ne.call(e);
      };

      function We(e, t) {
        return !!(t = null == t ? c : t) && ("number" == typeof e || x.test(e)) && e > -1 && e % 1 == 0 && e < t;
      }

      function He(e, t) {
        if (Ke(e)) return !1;
        var n = typeof e;
        return !("number" != n && "symbol" != n && "boolean" != n && null != e && !it(e)) || S.test(e) || !L.test(e) || null != t && e in Object(t);
      }

      function Be(e) {
        return e == e && !nt(e);
      }

      function ze(e, t) {
        return function (n) {
          return null != n && n[e] === t && (void 0 !== t || e in Object(n));
        };
      }

      (ce && Ve(new ce(new ArrayBuffer(1))) != k || le && Ve(new le()) != y || he && "[object Promise]" != Ve(he.resolve()) || de && Ve(new de()) != w || fe && "[object WeakMap]" != Ve(new fe())) && (Ve = function Ve(e) {
        var t = ne.call(e),
            n = t == g ? e.constructor : void 0,
            r = n ? Ge(n) : void 0;
        if (r) switch (r) {
          case me:
            return k;

          case _e:
            return y;

          case ye:
            return "[object Promise]";

          case ve:
            return w;

          case ge:
            return "[object WeakMap]";
        }
        return t;
      });
      var Ze = qe(function (e) {
        var t;
        e = null == (t = e) ? "" : function (e) {
          if ("string" == typeof e) return e;
          if (it(e)) return Te ? Te.call(e) : "";
          var t = e + "";
          return "0" == t && 1 / e == -u ? "-0" : t;
        }(t);
        var n = [];
        return N.test(e) && n.push(""), e.replace(D, function (e, t, r, i) {
          n.push(r ? i.replace(I, "$1") : t || e);
        }), n;
      });

      function Qe(e) {
        if ("string" == typeof e || it(e)) return e;
        var t = e + "";
        return "0" == t && 1 / e == -u ? "-0" : t;
      }

      function Ge(e) {
        if (null != e) {
          try {
            return ee.call(e);
          } catch (e) {}

          try {
            return e + "";
          } catch (e) {}
        }

        return "";
      }

      function qe(e, t) {
        if ("function" != typeof e || t && "function" != typeof t) throw new TypeError(i);

        var n = function n() {
          var r = arguments,
              i = t ? t.apply(this, r) : r[0],
              o = n.cache;
          if (o.has(i)) return o.get(i);
          var a = e.apply(this, r);
          return n.cache = o.set(i, a), a;
        };

        return n.cache = new (qe.Cache || ke)(), n;
      }

      function Je(e, t) {
        return e === t || e != e && t != t;
      }

      function Xe(e) {
        return function (e) {
          return rt(e) && $e(e);
        }(e) && te.call(e, "callee") && (!ae.call(e, "callee") || ne.call(e) == l);
      }

      qe.Cache = ke;
      var Ke = Array.isArray;

      function $e(e) {
        return null != e && tt(e.length) && !et(e);
      }

      function et(e) {
        var t = nt(e) ? ne.call(e) : "";
        return t == m || t == _;
      }

      function tt(e) {
        return "number" == typeof e && e > -1 && e % 1 == 0 && e <= c;
      }

      function nt(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
      }

      function rt(e) {
        return !!e && "object" == typeof e;
      }

      function it(e) {
        return "symbol" == typeof e || rt(e) && ne.call(e) == M;
      }

      var ot = V ? function (e) {
        return function (t) {
          return e(t);
        };
      }(V) : function (e) {
        return rt(e) && tt(e.length) && !!Y[ne.call(e)];
      };

      function at(e) {
        return $e(e) ? Ne(e) : Fe(e);
      }

      function st(e) {
        return e;
      }

      n.exports = function (e, t) {
        return e && e.length ? function (e, t, n) {
          for (var r = -1, i = e.length; ++r < i;) {
            var o = e[r],
                a = t(o);
            if (null != a && (void 0 === s ? a == a && !it(a) : n(a, s))) var s = a,
                u = o;
          }

          return u;
        }(e, Oe(t), Re) : void 0;
      };
    }).call(this, n(17), n(47)(e));
  }, function (e, t, n) {
    "use strict";

    var r = n(21).compose;
    t.__esModule = !0, t.composeWithDevTools = "undefined" != typeof window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
      if (0 !== arguments.length) return "object" == typeof arguments[0] ? r : r.apply(null, arguments);
    }, t.devToolsEnhancer = "undefined" != typeof window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
      return function (e) {
        return e;
      };
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t,
          n = e.Symbol;
      return "function" == typeof n ? n.observable ? t = n.observable : (t = n("observable"), n.observable = t) : t = "@@observable", t;
    }

    n.d(t, "a", function () {
      return r;
    });
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(5),
          a = n(1),
          s = n(26),
          u = n(19),
          c = n(10),
          l = n(45),
          h = n(11),
          d = n(7),
          f = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetResources\\Table\\TableForm.tsx";
      var _o$Intl2 = o.Intl,
          p = _o$Intl2.FormattedMessage,
          m = _o$Intl2.injectIntl;
      t.a = m(function (_ref70) {
        var t = _ref70.intl,
            n = _ref70.id,
            m = _ref70.widgetId,
            _ = _ref70.type,
            y = _ref70.dynamicWidgetArgs,
            v = _ref70.onSubmit,
            g = _ref70.onBack;

        var b = Object(r.useRef)(),
            _Object95 = Object(d.f)(),
            w = _Object95.hasPermission,
            T = Object(h.a)()[_].filter(function (e) {
          return w(e.permission || "");
        }),
            _Object96 = Object(r.useState)(m),
            _Object97 = _slicedToArray(_Object96, 2),
            M = _Object97[0],
            E = _Object97[1],
            k = Object(l.a)(T),
            L = Object(u.c)(),
            S = Object(u.a)(),
            N = Object(h.c)(c.a.table, M),
            D = N.visibleColumns,
            I = N.optionalColumns;

        var R = y.visibleColumns.filter(function (e) {
          return I.some(function (t) {
            return e === t;
          });
        }) || [];
        var x = 5 - (D || []).length,
            Y = Object(s.b)(N);
        return R = R.concat(D || []), i.a.createElement(a.Form, {
          wrappedComponentRef: b,
          onValidFieldsSubmit: function onValidFieldsSubmit(e) {
            var t = e.title,
                r = e.widgetId,
                i = e.optionalVisibleColumns,
                a = [].concat(_toConsumableArray(D || []), _toConsumableArray(i || [])),
                s = _objectSpread({}, S(N.searchType, e), {
              visibleColumns: a,
              title: t
            });

            v({
              id: n || Object(o.createGuid)(),
              widgetId: r,
              dynamicWidgetArgs: s,
              type: c.a.table
            });
          },
          __source: {
            fileName: f,
            lineNumber: 140
          },
          __self: void 0
        }, i.a.createElement(a.FormItem, {
          id: "widgetId",
          label: t.formatMessage({
            id: e.modules.widget.tableWidget.searchType
          }),
          options: {
            rules: [{
              required: !0
            }],
            initialValue: N.widgetId
          },
          __source: {
            fileName: f,
            lineNumber: 141
          },
          __self: void 0
        }, i.a.createElement(a.Select, {
          onChange: function onChange(e) {
            if (!b.current) return;
            E(e);
            var n = Object(h.c)(c.a.table, e);
            b.current.setFieldsValue({
              title: t.formatMessage({
                id: n.label
              }),
              optionalVisibleColumns: n.visibleColumns
            });
          },
          placeholder: t.formatMessage({
            id: e.modules.widget.tableWidget.searchTypePlaceholder
          }),
          __source: {
            fileName: f,
            lineNumber: 151
          },
          __self: void 0
        }, Object.keys(k).map(function (e) {
          return i.a.createElement(a.OptGroup, {
            label: t.formatMessage({
              id: k[e].label
            }),
            key: e,
            __source: {
              fileName: f,
              lineNumber: 158
            },
            __self: void 0
          }, k[e].widgets.map(function (e) {
            return i.a.createElement(a.Option, {
              key: e.widgetId,
              value: e.widgetId,
              __source: {
                fileName: f,
                lineNumber: 165
              },
              __self: void 0
            }, i.a.createElement(a.Icon, {
              textual: !0,
              type: e.iconType,
              padding: [0, 1, 0, 0],
              __source: {
                fileName: f,
                lineNumber: 166
              },
              __self: void 0
            }), i.a.createElement(p, {
              id: e.label,
              __source: {
                fileName: f,
                lineNumber: 167
              },
              __self: void 0
            }));
          }));
        }))), i.a.createElement(a.FormItem, {
          id: "title",
          label: t.formatMessage({
            id: e.modules.widget.tableWidget.widgetTitleInput
          }),
          hasFeedback: !0,
          options: {
            initialValue: y.title,
            rules: [{
              required: !0,
              message: t.formatMessage({
                id: e.modules.widget.tableWidget.widgetTitleInputError
              }),
              max: 50,
              whitespace: !0
            }]
          },
          __source: {
            fileName: f,
            lineNumber: 174
          },
          __self: void 0
        }, i.a.createElement(a.Input, {
          placeholder: t.formatMessage({
            id: e.modules.widget.tableWidget.widgetTitlePlaceholder
          }),
          __source: {
            fileName: f,
            lineNumber: 194
          },
          __self: void 0
        })), L(N.searchType, y), N && ((null == I ? void 0 : I.length) || 0) > 0 && i.a.createElement(a.FormItem, {
          id: "optionalVisibleColumns",
          label: t.formatMessage({
            id: e.modules.widget.tableWidget.visibleColumns
          }),
          options: {
            initialValue: R,
            rules: [{
              max: x,
              type: "array",
              message: t.formatMessage({
                id: e.modules.widget.tableWidget.widgetVisibleColumnsError
              }, {
                max: x
              })
            }]
          },
          __source: {
            fileName: f,
            lineNumber: 202
          },
          __self: void 0
        }, i.a.createElement(a.CheckboxGroup, {
          __source: {
            fileName: f,
            lineNumber: 225
          },
          __self: void 0
        }, D.map(function (e) {
          var t;
          return i.a.createElement("div", {
            key: e,
            __source: {
              fileName: f,
              lineNumber: 227
            },
            __self: void 0
          }, i.a.createElement(a.Checkbox, {
            key: e,
            value: e,
            disabled: !0,
            __source: {
              fileName: f,
              lineNumber: 228
            },
            __self: void 0
          }, (null === (t = Y.find(function (t) {
            return t.key === e;
          })) || void 0 === t ? void 0 : t.title) || e));
        }), I.map(function (e) {
          var t;
          return i.a.createElement("div", {
            key: e,
            __source: {
              fileName: f,
              lineNumber: 235
            },
            __self: void 0
          }, i.a.createElement(a.Checkbox, {
            key: e,
            value: e,
            __source: {
              fileName: f,
              lineNumber: 236
            },
            __self: void 0
          }, (null === (t = Y.find(function (t) {
            return t.key === e;
          })) || void 0 === t ? void 0 : t.title) || e));
        }))), i.a.createElement(a.Flex, {
          justify: "flex-end",
          gutter: 2,
          gutterDirection: "horizontal",
          __source: {
            fileName: f,
            lineNumber: 245
          },
          __self: void 0
        }, !n && g && i.a.createElement(a.FlexItem, {
          flex: 0,
          __source: {
            fileName: f,
            lineNumber: 247
          },
          __self: void 0
        }, i.a.createElement(a.Button, {
          size: "large",
          onClick: function onClick() {
            return g();
          },
          __source: {
            fileName: f,
            lineNumber: 248
          },
          __self: void 0
        }, i.a.createElement(p, {
          id: e.modules.widget.counterWidget.cancelText,
          __source: {
            fileName: f,
            lineNumber: 249
          },
          __self: void 0
        }))), i.a.createElement(a.FlexItem, {
          flex: 0,
          __source: {
            fileName: f,
            lineNumber: 255
          },
          __self: void 0
        }, i.a.createElement(a.Button, {
          htmlType: "submit",
          size: "large",
          key: "confirm",
          type: "primary",
          __source: {
            fileName: f,
            lineNumber: 256
          },
          __self: void 0
        }, i.a.createElement(p, {
          id: e.modules.widget.counterWidget.okText,
          __source: {
            fileName: f,
            lineNumber: 257
          },
          __self: void 0
        })))));
      });
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(1),
          a = n(5),
          s = n(26),
          u = n(43),
          c = n(46),
          l = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetResources\\Table\\TableWidget.tsx";
      var _a$Intl = a.Intl,
          h = _a$Intl.injectIntl,
          d = _a$Intl.FormattedMessage;
      t.a = h(function (_ref71) {
        var t = _ref71.dynamicWidgetArgs,
            n = _ref71.widgetId,
            r = _ref71.data,
            a = _ref71.id,
            h = _ref71.isLoading,
            f = _ref71.type,
            p = _ref71.isEditable,
            m = _ref71.tableConfig,
            _ = _ref71.onEdit,
            y = _ref71.onRemove,
            v = _ref71.onClick;
        var g = t.visibleColumns,
            b = t.title,
            w = r && r.items.length || 0,
            T = r && r.totalCount || 0,
            M = Object(s.b)(m);
        return i.a.createElement(o.Widget, {
          onClick: v,
          __source: {
            fileName: l,
            lineNumber: 47
          },
          __self: void 0
        }, i.a.createElement(o.WidgetHeader, {
          justify: "space-between",
          align: "center",
          __source: {
            fileName: l,
            lineNumber: 48
          },
          __self: void 0
        }, i.a.createElement(o.Skeleton, {
          active: !0,
          paragraph: {
            rows: 0
          },
          loading: h,
          __source: {
            fileName: l,
            lineNumber: 49
          },
          __self: void 0
        }, i.a.createElement(o.H2, {
          inline: !0,
          color: "bodyPrimary",
          __source: {
            fileName: l,
            lineNumber: 50
          },
          __self: void 0
        }, b), p ? i.a.createElement(o.FlexItem, {
          flex: 0,
          __source: {
            fileName: l,
            lineNumber: 54
          },
          __self: void 0
        }, i.a.createElement(c.a, {
          id: a,
          onRemove: y,
          onEdit: function onEdit() {
            return _({
              id: a,
              widgetId: n,
              dynamicWidgetArgs: t,
              type: f
            });
          },
          __source: {
            fileName: l,
            lineNumber: 55
          },
          __self: void 0
        })) : i.a.createElement(o.FlexItem, {
          flex: 0,
          __source: {
            fileName: l,
            lineNumber: 62
          },
          __self: void 0
        }, i.a.createElement(u.a, {
          to: m.searchRoute || "",
          __source: {
            fileName: l,
            lineNumber: 63
          },
          __self: void 0
        }, i.a.createElement(d, {
          id: e.modules.widget.tableWidget.seeAllLinkText,
          __source: {
            fileName: l,
            lineNumber: 64
          },
          __self: void 0
        }), i.a.createElement(o.Icon, {
          type: "arrow-right",
          textual: !0,
          color: "inherit",
          __source: {
            fileName: l,
            lineNumber: 67
          },
          __self: void 0
        }))))), i.a.createElement(o.WidgetBody, {
          padding: 0,
          __source: {
            fileName: l,
            lineNumber: 73
          },
          __self: void 0
        }, w > 0 || h ? i.a.createElement(i.a.Fragment, null, i.a.createElement(o.Table, {
          columnSelector: !1,
          dataSource: r.items,
          columns: M,
          pagination: !1,
          visibleColumns: g,
          rowKey: "id",
          isLoading: h,
          __source: {
            fileName: l,
            lineNumber: 76
          },
          __self: void 0
        }), i.a.createElement(o.H2, {
          weight: 400,
          padding: 4,
          __source: {
            fileName: l,
            lineNumber: 85
          },
          __self: void 0
        }, 1, " - ", w, " of ", T, " items")) : Object(s.c)(m)));
      });
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(5),
          a = n(1),
          s = n(10),
          u = n(45),
          c = n(19),
          l = n(11),
          h = n(7),
          d = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\WidgetFramework\\WidgetResources\\Counter\\CounterForm.tsx";
      var _o$Intl3 = o.Intl,
          f = _o$Intl3.FormattedMessage,
          p = _o$Intl3.injectIntl;
      t.a = p(function (_ref72) {
        var t = _ref72.intl,
            n = _ref72.id,
            p = _ref72.widgetId,
            m = _ref72.type,
            _ = _ref72.dynamicWidgetArgs,
            y = _ref72.onSubmit,
            v = _ref72.onBack;

        var g = Object(r.useRef)(),
            _Object98 = Object(h.f)(),
            b = _Object98.hasPermission,
            w = Object(l.a)()[m].filter(function (e) {
          return b(e.permission || "");
        }),
            T = Object(u.a)(w),
            M = Object(c.c)(),
            E = Object(c.a)(),
            _Object99 = Object(r.useState)(p),
            _Object100 = _slicedToArray(_Object99, 2),
            k = _Object100[0],
            L = _Object100[1],
            S = Object(l.c)(s.a.counter, k);

        Object(r.useEffect)(function () {
          var e;
          L(p), null === (e = g.current) || void 0 === e || e.setFieldsValue({
            widgetId: p,
            title: _.title
          });
        }, [p]);
        return i.a.createElement(a.Form, {
          wrappedComponentRef: g,
          onValidFieldsSubmit: function onValidFieldsSubmit(e) {
            var t = e.title,
                r = e.widgetId,
                i = _objectSpread({}, E(S.searchType, e), {
              title: t
            });

            y({
              id: n || Object(o.createGuid)(),
              dynamicWidgetArgs: i,
              widgetId: r,
              type: s.a.counter
            });
          },
          __source: {
            fileName: d,
            lineNumber: 113
          },
          __self: void 0
        }, i.a.createElement(a.FormItem, {
          id: "widgetId",
          label: t.formatMessage({
            id: e.modules.widget.counterWidget.countType
          }),
          options: {
            rules: [{
              required: !0
            }],
            initialValue: S.widgetId
          },
          __source: {
            fileName: d,
            lineNumber: 114
          },
          __self: void 0
        }, i.a.createElement(a.Select, {
          onChange: function onChange(e) {
            if (!g.current) return;
            L(e);
            var n = Object(l.c)(s.a.counter, e);
            g.current.setFieldsValue({
              title: t.formatMessage({
                id: n.label
              })
            });
          },
          __source: {
            fileName: d,
            lineNumber: 124
          },
          __self: void 0
        }, Object.keys(T).map(function (e) {
          return i.a.createElement(a.OptGroup, {
            label: t.formatMessage({
              id: T[e].label
            }),
            key: e,
            __source: {
              fileName: d,
              lineNumber: 126
            },
            __self: void 0
          }, T[e].widgets.map(function (e) {
            return i.a.createElement(a.Option, {
              key: e.widgetId,
              value: e.widgetId,
              __source: {
                fileName: d,
                lineNumber: 133
              },
              __self: void 0
            }, i.a.createElement(a.Icon, {
              textual: !0,
              type: e.iconType,
              padding: [0, 1, 0, 0],
              __source: {
                fileName: d,
                lineNumber: 134
              },
              __self: void 0
            }), i.a.createElement(f, {
              id: e.label,
              __source: {
                fileName: d,
                lineNumber: 139
              },
              __self: void 0
            }));
          }));
        }))), i.a.createElement(a.FormItem, {
          id: "title",
          label: t.formatMessage({
            id: e.modules.widget.counterWidget.widgetTitleInput
          }),
          hasFeedback: !0,
          options: {
            initialValue: _.title,
            rules: [{
              required: !0,
              message: t.formatMessage({
                id: e.modules.widget.counterWidget.widgetTitleInputError
              }),
              max: 32,
              whitespace: !0
            }]
          },
          __source: {
            fileName: d,
            lineNumber: 146
          },
          __self: void 0
        }, i.a.createElement(a.Input, {
          placeholder: t.formatMessage({
            id: e.modules.widget.counterWidget.widgetTitlePlaceholder
          }),
          __source: {
            fileName: d,
            lineNumber: 167
          },
          __self: void 0
        })), M(S.searchType, _), i.a.createElement(a.Flex, {
          justify: "flex-end",
          gutter: 2,
          gutterDirection: "horizontal",
          __source: {
            fileName: d,
            lineNumber: 174
          },
          __self: void 0
        }, !n && v && i.a.createElement(a.FlexItem, {
          flex: 0,
          __source: {
            fileName: d,
            lineNumber: 176
          },
          __self: void 0
        }, i.a.createElement(a.Button, {
          size: "large",
          onClick: function onClick() {
            return v();
          },
          __source: {
            fileName: d,
            lineNumber: 177
          },
          __self: void 0
        }, i.a.createElement(f, {
          id: e.modules.widget.counterWidget.cancelText,
          __source: {
            fileName: d,
            lineNumber: 178
          },
          __self: void 0
        }))), i.a.createElement(a.FlexItem, {
          flex: 0,
          __source: {
            fileName: d,
            lineNumber: 184
          },
          __self: void 0
        }, i.a.createElement(a.Button, {
          htmlType: "submit",
          size: "large",
          key: "confirm",
          type: "primary",
          __source: {
            fileName: d,
            lineNumber: 185
          },
          __self: void 0
        }, i.a.createElement(f, {
          id: e.modules.widget.counterWidget.okText,
          __source: {
            fileName: d,
            lineNumber: 186
          },
          __self: void 0
        })))));
      });
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    (function (e, n) {
      var r = 200,
          i = "__lodash_hash_undefined__",
          o = 1,
          a = 2,
          s = 9007199254740991,
          u = "[object Arguments]",
          c = "[object Array]",
          l = "[object AsyncFunction]",
          h = "[object Boolean]",
          d = "[object Date]",
          f = "[object Error]",
          p = "[object Function]",
          m = "[object GeneratorFunction]",
          _ = "[object Map]",
          y = "[object Number]",
          v = "[object Null]",
          g = "[object Object]",
          b = "[object Proxy]",
          w = "[object RegExp]",
          T = "[object Set]",
          M = "[object String]",
          E = "[object Symbol]",
          k = "[object Undefined]",
          L = "[object ArrayBuffer]",
          S = "[object DataView]",
          N = /^\[object .+?Constructor\]$/,
          D = /^(?:0|[1-9]\d*)$/,
          I = {};
      I["[object Float32Array]"] = I["[object Float64Array]"] = I["[object Int8Array]"] = I["[object Int16Array]"] = I["[object Int32Array]"] = I["[object Uint8Array]"] = I["[object Uint8ClampedArray]"] = I["[object Uint16Array]"] = I["[object Uint32Array]"] = !0, I[u] = I[c] = I[L] = I[h] = I[S] = I[d] = I[f] = I[p] = I[_] = I[y] = I[g] = I[w] = I[T] = I[M] = I["[object WeakMap]"] = !1;

      var R = "object" == typeof e && e && e.Object === Object && e,
          x = "object" == typeof self && self && self.Object === Object && self,
          Y = R || x || Function("return this")(),
          C = t && !t.nodeType && t,
          O = C && "object" == typeof n && n && !n.nodeType && n,
          F = O && O.exports === C,
          A = F && R.process,
          j = function () {
        try {
          return A && A.binding && A.binding("util");
        } catch (e) {}
      }(),
          U = j && j.isTypedArray;

      function P(e, t) {
        for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
          if (t(e[n], n, e)) return !0;
        }

        return !1;
      }

      function V(e) {
        var t = -1,
            n = Array(e.size);
        return e.forEach(function (e, r) {
          n[++t] = [r, e];
        }), n;
      }

      function W(e) {
        var t = -1,
            n = Array(e.size);
        return e.forEach(function (e) {
          n[++t] = e;
        }), n;
      }

      var H,
          B,
          z,
          Z = Array.prototype,
          Q = Function.prototype,
          G = Object.prototype,
          q = Y["__core-js_shared__"],
          J = Q.toString,
          X = G.hasOwnProperty,
          K = (H = /[^.]+$/.exec(q && q.keys && q.keys.IE_PROTO || "")) ? "Symbol(src)_1." + H : "",
          $ = G.toString,
          ee = RegExp("^" + J.call(X).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          te = F ? Y.Buffer : void 0,
          ne = Y.Symbol,
          re = Y.Uint8Array,
          ie = G.propertyIsEnumerable,
          oe = Z.splice,
          ae = ne ? ne.toStringTag : void 0,
          se = Object.getOwnPropertySymbols,
          ue = te ? te.isBuffer : void 0,
          ce = (B = Object.keys, z = Object, function (e) {
        return B(z(e));
      }),
          le = je(Y, "DataView"),
          he = je(Y, "Map"),
          de = je(Y, "Promise"),
          fe = je(Y, "Set"),
          pe = je(Y, "WeakMap"),
          me = je(Object, "create"),
          _e = We(le),
          ye = We(he),
          ve = We(de),
          ge = We(fe),
          be = We(pe),
          we = ne ? ne.prototype : void 0,
          Te = we ? we.valueOf : void 0;

      function Me(e) {
        var t = -1,
            n = null == e ? 0 : e.length;

        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }

      function Ee(e) {
        var t = -1,
            n = null == e ? 0 : e.length;

        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }

      function ke(e) {
        var t = -1,
            n = null == e ? 0 : e.length;

        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }

      function Le(e) {
        var t = -1,
            n = null == e ? 0 : e.length;

        for (this.__data__ = new ke(); ++t < n;) {
          this.add(e[t]);
        }
      }

      function Se(e) {
        var t = this.__data__ = new Ee(e);
        this.size = t.size;
      }

      function Ne(e, t) {
        var n = ze(e),
            r = !n && Be(e),
            i = !n && !r && Ze(e),
            o = !n && !r && !i && Xe(e),
            a = n || r || i || o,
            s = a ? function (e, t) {
          for (var n = -1, r = Array(e); ++n < e;) {
            r[n] = t(n);
          }

          return r;
        }(e.length, String) : [],
            u = s.length;

        for (var c in e) {
          !t && !X.call(e, c) || a && ("length" == c || i && ("offset" == c || "parent" == c) || o && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || Ve(c, u)) || s.push(c);
        }

        return s;
      }

      function De(e, t) {
        for (var n = e.length; n--;) {
          if (He(e[n][0], t)) return n;
        }

        return -1;
      }

      function Ie(e) {
        return null == e ? void 0 === e ? k : v : ae && ae in Object(e) ? function (e) {
          var t = X.call(e, ae),
              n = e[ae];

          try {
            e[ae] = void 0;
            var r = !0;
          } catch (e) {}

          var i = $.call(e);
          r && (t ? e[ae] = n : delete e[ae]);
          return i;
        }(e) : function (e) {
          return $.call(e);
        }(e);
      }

      function Re(e) {
        return Je(e) && Ie(e) == u;
      }

      function xe(e, t, n, r, i) {
        return e === t || (null == e || null == t || !Je(e) && !Je(t) ? e != e && t != t : function (e, t, n, r, i, s) {
          var l = ze(e),
              p = ze(t),
              m = l ? c : Pe(e),
              v = p ? c : Pe(t),
              b = (m = m == u ? g : m) == g,
              k = (v = v == u ? g : v) == g,
              N = m == v;

          if (N && Ze(e)) {
            if (!Ze(t)) return !1;
            l = !0, b = !1;
          }

          if (N && !b) return s || (s = new Se()), l || Xe(e) ? Oe(e, t, n, r, i, s) : function (e, t, n, r, i, s, u) {
            switch (n) {
              case S:
                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                e = e.buffer, t = t.buffer;

              case L:
                return !(e.byteLength != t.byteLength || !s(new re(e), new re(t)));

              case h:
              case d:
              case y:
                return He(+e, +t);

              case f:
                return e.name == t.name && e.message == t.message;

              case w:
              case M:
                return e == t + "";

              case _:
                var c = V;

              case T:
                var l = r & o;
                if (c || (c = W), e.size != t.size && !l) return !1;
                var p = u.get(e);
                if (p) return p == t;
                r |= a, u.set(e, t);
                var m = Oe(c(e), c(t), r, i, s, u);
                return u.delete(e), m;

              case E:
                if (Te) return Te.call(e) == Te.call(t);
            }

            return !1;
          }(e, t, m, n, r, i, s);

          if (!(n & o)) {
            var D = b && X.call(e, "__wrapped__"),
                I = k && X.call(t, "__wrapped__");

            if (D || I) {
              var R = D ? e.value() : e,
                  x = I ? t.value() : t;
              return s || (s = new Se()), i(R, x, n, r, s);
            }
          }

          if (!N) return !1;
          return s || (s = new Se()), function (e, t, n, r, i, a) {
            var s = n & o,
                u = Fe(e),
                c = u.length,
                l = Fe(t).length;
            if (c != l && !s) return !1;

            for (var h = c; h--;) {
              var d = u[h];
              if (!(s ? d in t : X.call(t, d))) return !1;
            }

            var f = a.get(e);
            if (f && a.get(t)) return f == t;
            var p = !0;
            a.set(e, t), a.set(t, e);

            for (var m = s; ++h < c;) {
              d = u[h];
              var _ = e[d],
                  y = t[d];
              if (r) var v = s ? r(y, _, d, t, e, a) : r(_, y, d, e, t, a);

              if (!(void 0 === v ? _ === y || i(_, y, n, r, a) : v)) {
                p = !1;
                break;
              }

              m || (m = "constructor" == d);
            }

            if (p && !m) {
              var g = e.constructor,
                  b = t.constructor;
              g != b && "constructor" in e && "constructor" in t && !("function" == typeof g && g instanceof g && "function" == typeof b && b instanceof b) && (p = !1);
            }

            return a.delete(e), a.delete(t), p;
          }(e, t, n, r, i, s);
        }(e, t, n, r, xe, i));
      }

      function Ye(e) {
        return !(!qe(e) || (t = e, K && K in t)) && (Qe(e) ? ee : N).test(We(e));
        var t;
      }

      function Ce(e) {
        if (n = (t = e) && t.constructor, r = "function" == typeof n && n.prototype || G, t !== r) return ce(e);
        var t,
            n,
            r,
            i = [];

        for (var o in Object(e)) {
          X.call(e, o) && "constructor" != o && i.push(o);
        }

        return i;
      }

      function Oe(e, t, n, r, i, s) {
        var u = n & o,
            c = e.length,
            l = t.length;
        if (c != l && !(u && l > c)) return !1;
        var h = s.get(e);
        if (h && s.get(t)) return h == t;
        var d = -1,
            f = !0,
            p = n & a ? new Le() : void 0;

        for (s.set(e, t), s.set(t, e); ++d < c;) {
          var m = e[d],
              _ = t[d];
          if (r) var y = u ? r(_, m, d, t, e, s) : r(m, _, d, e, t, s);

          if (void 0 !== y) {
            if (y) continue;
            f = !1;
            break;
          }

          if (p) {
            if (!P(t, function (e, t) {
              if (o = t, !p.has(o) && (m === e || i(m, e, n, r, s))) return p.push(t);
              var o;
            })) {
              f = !1;
              break;
            }
          } else if (m !== _ && !i(m, _, n, r, s)) {
            f = !1;
            break;
          }
        }

        return s.delete(e), s.delete(t), f;
      }

      function Fe(e) {
        return function (e, t, n) {
          var r = t(e);
          return ze(e) ? r : function (e, t) {
            for (var n = -1, r = t.length, i = e.length; ++n < r;) {
              e[i + n] = t[n];
            }

            return e;
          }(r, n(e));
        }(e, Ke, Ue);
      }

      function Ae(e, t) {
        var n,
            r,
            i = e.__data__;
        return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof t ? "string" : "hash"] : i.map;
      }

      function je(e, t) {
        var n = function (e, t) {
          return null == e ? void 0 : e[t];
        }(e, t);

        return Ye(n) ? n : void 0;
      }

      Me.prototype.clear = function () {
        this.__data__ = me ? me(null) : {}, this.size = 0;
      }, Me.prototype.delete = function (e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= t ? 1 : 0, t;
      }, Me.prototype.get = function (e) {
        var t = this.__data__;

        if (me) {
          var n = t[e];
          return n === i ? void 0 : n;
        }

        return X.call(t, e) ? t[e] : void 0;
      }, Me.prototype.has = function (e) {
        var t = this.__data__;
        return me ? void 0 !== t[e] : X.call(t, e);
      }, Me.prototype.set = function (e, t) {
        var n = this.__data__;
        return this.size += this.has(e) ? 0 : 1, n[e] = me && void 0 === t ? i : t, this;
      }, Ee.prototype.clear = function () {
        this.__data__ = [], this.size = 0;
      }, Ee.prototype.delete = function (e) {
        var t = this.__data__,
            n = De(t, e);
        return !(n < 0 || (n == t.length - 1 ? t.pop() : oe.call(t, n, 1), --this.size, 0));
      }, Ee.prototype.get = function (e) {
        var t = this.__data__,
            n = De(t, e);
        return n < 0 ? void 0 : t[n][1];
      }, Ee.prototype.has = function (e) {
        return De(this.__data__, e) > -1;
      }, Ee.prototype.set = function (e, t) {
        var n = this.__data__,
            r = De(n, e);
        return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
      }, ke.prototype.clear = function () {
        this.size = 0, this.__data__ = {
          hash: new Me(),
          map: new (he || Ee)(),
          string: new Me()
        };
      }, ke.prototype.delete = function (e) {
        var t = Ae(this, e).delete(e);
        return this.size -= t ? 1 : 0, t;
      }, ke.prototype.get = function (e) {
        return Ae(this, e).get(e);
      }, ke.prototype.has = function (e) {
        return Ae(this, e).has(e);
      }, ke.prototype.set = function (e, t) {
        var n = Ae(this, e),
            r = n.size;
        return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
      }, Le.prototype.add = Le.prototype.push = function (e) {
        return this.__data__.set(e, i), this;
      }, Le.prototype.has = function (e) {
        return this.__data__.has(e);
      }, Se.prototype.clear = function () {
        this.__data__ = new Ee(), this.size = 0;
      }, Se.prototype.delete = function (e) {
        var t = this.__data__,
            n = t.delete(e);
        return this.size = t.size, n;
      }, Se.prototype.get = function (e) {
        return this.__data__.get(e);
      }, Se.prototype.has = function (e) {
        return this.__data__.has(e);
      }, Se.prototype.set = function (e, t) {
        var n = this.__data__;

        if (n instanceof Ee) {
          var i = n.__data__;
          if (!he || i.length < r - 1) return i.push([e, t]), this.size = ++n.size, this;
          n = this.__data__ = new ke(i);
        }

        return n.set(e, t), this.size = n.size, this;
      };
      var Ue = se ? function (e) {
        return null == e ? [] : (e = Object(e), function (e, t) {
          for (var n = -1, r = null == e ? 0 : e.length, i = 0, o = []; ++n < r;) {
            var a = e[n];
            t(a, n, e) && (o[i++] = a);
          }

          return o;
        }(se(e), function (t) {
          return ie.call(e, t);
        }));
      } : function () {
        return [];
      },
          Pe = Ie;

      function Ve(e, t) {
        return !!(t = null == t ? s : t) && ("number" == typeof e || D.test(e)) && e > -1 && e % 1 == 0 && e < t;
      }

      function We(e) {
        if (null != e) {
          try {
            return J.call(e);
          } catch (e) {}

          try {
            return e + "";
          } catch (e) {}
        }

        return "";
      }

      function He(e, t) {
        return e === t || e != e && t != t;
      }

      (le && Pe(new le(new ArrayBuffer(1))) != S || he && Pe(new he()) != _ || de && "[object Promise]" != Pe(de.resolve()) || fe && Pe(new fe()) != T || pe && "[object WeakMap]" != Pe(new pe())) && (Pe = function Pe(e) {
        var t = Ie(e),
            n = t == g ? e.constructor : void 0,
            r = n ? We(n) : "";
        if (r) switch (r) {
          case _e:
            return S;

          case ye:
            return _;

          case ve:
            return "[object Promise]";

          case ge:
            return T;

          case be:
            return "[object WeakMap]";
        }
        return t;
      });
      var Be = Re(function () {
        return arguments;
      }()) ? Re : function (e) {
        return Je(e) && X.call(e, "callee") && !ie.call(e, "callee");
      },
          ze = Array.isArray;

      var Ze = ue || function () {
        return !1;
      };

      function Qe(e) {
        if (!qe(e)) return !1;
        var t = Ie(e);
        return t == p || t == m || t == l || t == b;
      }

      function Ge(e) {
        return "number" == typeof e && e > -1 && e % 1 == 0 && e <= s;
      }

      function qe(e) {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t);
      }

      function Je(e) {
        return null != e && "object" == typeof e;
      }

      var Xe = U ? function (e) {
        return function (t) {
          return e(t);
        };
      }(U) : function (e) {
        return Je(e) && Ge(e.length) && !!I[Ie(e)];
      };

      function Ke(e) {
        return null != (t = e) && Ge(t.length) && !Qe(t) ? Ne(e) : Ce(e);
        var t;
      }

      n.exports = function (e, t) {
        return xe(e, t);
      };
    }).call(this, n(17), n(47)(e));
  }, function (e, t, n) {
    "use strict";

    t.a = {
      getInitials: function getInitials(e) {
        return e ? e.split(" ").map(function (e) {
          return e.charAt(0);
        }).join("") : "";
      },
      mergeNotes: function mergeNotes(e, t) {
        var n = new Set(e.map(function (e) {
          return e.id;
        }));
        return [].concat(_toConsumableArray(e), _toConsumableArray(t.filter(function (e) {
          return !n.has(e.id);
        })));
      },
      removeNoteFromArray: function removeNoteFromArray(e, t) {
        return e.filter(function (e) {
          return e.id !== t;
        });
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(4),
        i = n(8);
    t.a = {
      deleteNote: function deleteNote(e) {
        return _regeneratorRuntime.async(function deleteNote$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return _regeneratorRuntime.awrap(Object(i.y)().createMutationRequest(new r.Requests.DeleteNoteRequest({
                  noteId: e
                })));

              case 2:
                return _context36.abrupt("return", !0);

              case 3:
              case "end":
                return _context36.stop();
            }
          }
        });
      },
      submitNote: function submitNote(e, t, n) {
        return _regeneratorRuntime.async(function submitNote$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return _regeneratorRuntime.awrap(Object(i.y)().createMutationRequest(new r.Requests.NewNoteRequest({
                  body: n,
                  peopleToNotify: [],
                  target: {
                    referenceId: t,
                    aboutType: e
                  }
                })));

              case 2:
                return _context37.abrupt("return", _context37.sent[0].data);

              case 3:
              case "end":
                return _context37.stop();
            }
          }
        });
      },
      fetchLatestNotes: function fetchLatestNotes(e, t, n, o) {
        return _regeneratorRuntime.async(function fetchLatestNotes$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return _regeneratorRuntime.awrap(Object(i.y)().getResources([new r.Requests.NoteRequest({
                  filter: {
                    targets: [{
                      aboutType: e,
                      referenceId: t
                    }]
                  },
                  sorter: [{
                    fieldName: "createdOn",
                    direction: r.SortDirection.Ascending
                  }],
                  pager: {
                    offset: n,
                    limit: o
                  }
                })]));

              case 2:
                return _context38.abrupt("return", _context38.sent[0].data.reverse());

              case 3:
              case "end":
                return _context38.stop();
            }
          }
        });
      },
      editNote: function editNote(e, t) {
        return _regeneratorRuntime.async(function editNote$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return _regeneratorRuntime.awrap(Object(i.y)().createMutationRequest(new r.Requests.UpdateNoteRequest({
                  body: t,
                  noteId: e
                })));

              case 2:
                return _context39.abrupt("return", _context39.sent[0].data);

              case 3:
              case "end":
                return _context39.stop();
            }
          }
        });
      }
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          i = n.n(r),
          o = n(233),
          a = n(1),
          s = n(5),
          u = n(42),
          c = n(234),
          l = "D:\\BuildAgent\\work\\REL\\packages\\modules\\src\\components\\AttachmentsPreview\\AttachmentContent.tsx";

      var _s$Intl = s.Intl,
          h = _s$Intl.FormattedMessage,
          d = _s$Intl.injectIntl,
          f = Object(a.styled)(a.Flex)({
        minHeight: "70%"
      }),
          p = Object(a.styled)(a.Tag)({
        cursor: "pointer"
      }),
          m = function m(_ref73) {
        var t = _ref73.name,
            n = _ref73.url,
            r = _ref73.blob;
        return i.a.createElement(f, {
          align: "center",
          justify: "center",
          stretch: !0,
          __source: {
            fileName: l,
            lineNumber: 31
          },
          __self: void 0
        }, n ? i.a.createElement("iframe", {
          frameBorder: 0,
          title: t,
          height: "100%",
          width: "100%",
          src: URL.createObjectURL(r),
          __source: {
            fileName: l,
            lineNumber: 33
          },
          __self: void 0
        }) : i.a.createElement(a.EmptyState, {
          description: i.a.createElement(h, {
            id: e.vms.matchRecord.previewNotSupported,
            __source: {
              fileName: l,
              lineNumber: 43
            },
            __self: void 0
          }),
          __source: {
            fileName: l,
            lineNumber: 41
          },
          __self: void 0
        }));
      },
          _ = Object(a.styled)(a.Flex)({
        overflowY: "auto"
      });

      t.a = d(function (_ref74) {
        var t = _ref74.intl,
            n = _ref74.attachment;

        var _Object101 = Object(u.a)(n.id),
            s = _Object101.blob,
            h = _Object101.dataURL,
            d = _Object101.loading,
            _Object102 = Object(c.a)("application/x-zip-compressed" === (null == s ? void 0 : s.type), h),
            _Object103 = _slicedToArray(_Object102, 2),
            f = _Object103[0],
            y = _Object103[1],
            v = Object(r.useCallback)(function () {
          s && Object(o.saveAs)(s, n.name);
        }, [n.name, s]);

        return i.a.createElement(_, {
          direction: "column",
          padding: [7, 7, 7, 0],
          gutterDirection: "vertical",
          gutter: 8,
          stretch: !0,
          __source: {
            fileName: l,
            lineNumber: 70
          },
          __self: void 0
        }, i.a.createElement(a.Flex, {
          gutterDirection: "horizontal",
          gutter: 3,
          justify: "flex-end",
          __source: {
            fileName: l,
            lineNumber: 77
          },
          __self: void 0
        }, s ? i.a.createElement(p, {
          circle: !0,
          onClick: v,
          __source: {
            fileName: l,
            lineNumber: 79
          },
          __self: void 0
        }, i.a.createElement(a.Icon, {
          type: "download",
          color: "bodyTertiary",
          size: "small",
          __source: {
            fileName: l,
            lineNumber: 80
          },
          __self: void 0
        })) : null), d ? i.a.createElement(a.Flex, {
          align: "center",
          justify: "center",
          stretch: !0,
          __source: {
            fileName: l,
            lineNumber: 85
          },
          __self: void 0
        }, i.a.createElement(a.Spinner, {
          tip: t.formatMessage({
            id: e.vms.matchRecord.loadingAttachment
          }),
          __source: {
            fileName: l,
            lineNumber: 86
          },
          __self: void 0
        })) : f ? y.map(function (e) {
          return i.a.createElement(m, {
            key: e.name,
            name: e.name,
            url: e.url,
            blob: e.blob,
            __source: {
              fileName: l,
              lineNumber: 95
            },
            __self: void 0
          });
        }) : i.a.createElement(m, {
          name: n.name,
          url: h,
          blob: s,
          __source: {
            fileName: l,
            lineNumber: 104
          },
          __self: void 0
        }));
      });
    }).call(this, n(9).MessageKeysMock);
  }, function (e, t, n) {
    (function (n) {
      var r, i, o;
      i = [], void 0 === (o = "function" == typeof (r = function r() {
        "use strict";

        function t(e, t, n) {
          var r = new XMLHttpRequest();
          r.open("GET", e), r.responseType = "blob", r.onload = function () {
            a(r.response, t, n);
          }, r.onerror = function () {
            console.error("could not download file");
          }, r.send();
        }

        function r(e) {
          var t = new XMLHttpRequest();
          t.open("HEAD", e, !1);

          try {
            t.send();
          } catch (e) {}

          return 200 <= t.status && 299 >= t.status;
        }

        function i(e) {
          try {
            e.dispatchEvent(new MouseEvent("click"));
          } catch (n) {
            var t = document.createEvent("MouseEvents");
            t.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(t);
          }
        }

        var o = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof n && n.global === n ? n : void 0,
            a = o.saveAs || ("object" != typeof window || window !== o ? function () {} : "download" in HTMLAnchorElement.prototype ? function (e, n, a) {
          var s = o.URL || o.webkitURL,
              u = document.createElement("a");
          n = n || e.name || "download", u.download = n, u.rel = "noopener", "string" == typeof e ? (u.href = e, u.origin === location.origin ? i(u) : r(u.href) ? t(e, n, a) : i(u, u.target = "_blank")) : (u.href = s.createObjectURL(e), setTimeout(function () {
            s.revokeObjectURL(u.href);
          }, 4e4), setTimeout(function () {
            i(u);
          }, 0));
        } : "msSaveOrOpenBlob" in navigator ? function (e, n, o) {
          if (n = n || e.name || "download", "string" != typeof e) navigator.msSaveOrOpenBlob(function (e, t) {
            return void 0 === t ? t = {
              autoBom: !1
            } : "object" != typeof t && (console.warn("Deprecated: Expected third argument to be a object"), t = {
              autoBom: !t
            }), t.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob(["\uFEFF", e], {
              type: e.type
            }) : e;
          }(e, o), n);else if (r(e)) t(e, n, o);else {
            var a = document.createElement("a");
            a.href = e, a.target = "_blank", setTimeout(function () {
              i(a);
            });
          }
        } : function (e, n, r, i) {
          if ((i = i || open("", "_blank")) && (i.document.title = i.document.body.innerText = "downloading..."), "string" == typeof e) return t(e, n, r);
          var a = "application/octet-stream" === e.type,
              s = /constructor/i.test(o.HTMLElement) || o.safari,
              u = /CriOS\/[\d]+/.test(navigator.userAgent);

          if ((u || a && s) && "object" == typeof FileReader) {
            var c = new FileReader();
            c.onloadend = function () {
              var e = c.result;
              e = u ? e : e.replace(/^data:[^;]*;/, "data:attachment/file;"), i ? i.location.href = e : location = e, i = null;
            }, c.readAsDataURL(e);
          } else {
            var l = o.URL || o.webkitURL,
                h = l.createObjectURL(e);
            i ? i.location = h : location.href = h, i = null, setTimeout(function () {
              l.revokeObjectURL(h);
            }, 4e4);
          }
        });
        o.saveAs = a.saveAs = a, e.exports = a;
      }) ? r.apply(t, i) : r) || (e.exports = o);
    }).call(this, n(17));
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return f;
    });
    var r = n(0),
        i = n(235),
        o = n.n(i),
        a = n(236),
        s = n.n(a),
        u = n(5),
        c = n(22);

    var l = function l(e) {
      return _regeneratorRuntime.async(function l$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return _regeneratorRuntime.awrap(function (e) {
                return new Promise(function (t, n) {
                  s.a.getBinaryContent(e, function (e, r) {
                    e ? n(e) : t(o.a.loadAsync(r));
                  });
                });
              }(e));

            case 2:
              return _context40.abrupt("return", _context40.sent);

            case 3:
            case "end":
              return _context40.stop();
          }
        }
      });
    },
        h = function h(e) {
      return Object(u.getExtension)(e)[0].slice(1);
    },
        d = function d(e) {
      var t = u.supportedMimeTypes.findIndex(function (t) {
        return t.includes(e);
      });
      return u.supportedMimeTypes[t];
    },
        f = function f(e, t) {
      var _Object104 = Object(r.useState)([]),
          _Object105 = _slicedToArray(_Object104, 2),
          n = _Object105[0],
          i = _Object105[1],
          _Object106 = Object(r.useState)(!1),
          _Object107 = _slicedToArray(_Object106, 2),
          o = _Object107[0],
          a = _Object107[1];

      if (e && t) {
        var _e9 = function _e9() {
          var e, n;
          return _regeneratorRuntime.async(function _e9$(_context42) {
            while (1) {
              switch (_context42.prev = _context42.next) {
                case 0:
                  a(!0);
                  _context42.next = 3;
                  return _regeneratorRuntime.awrap(l(t));

                case 3:
                  e = _context42.sent;

                  n = function (e) {
                    return Object.keys(e.files).filter(function (t) {
                      return !1 === e.files[t].dir;
                    });
                  }(e);

                  _context42.next = 7;
                  return _regeneratorRuntime.awrap(function (e, t) {
                    return Promise.all(t.map(function _callee16(t) {
                      var n;
                      return _regeneratorRuntime.async(function _callee16$(_context41) {
                        while (1) {
                          switch (_context41.prev = _context41.next) {
                            case 0:
                              _context41.next = 2;
                              return _regeneratorRuntime.awrap(e.files[t].async("uint8array"));

                            case 2:
                              n = _context41.sent;
                              return _context41.abrupt("return", new Blob([n], {
                                type: d(h(t))
                              }));

                            case 4:
                            case "end":
                              return _context41.stop();
                          }
                        }
                      });
                    }));
                  }(e, n));

                case 7:
                  _context42.t0 = function (e, t) {
                    return Object(c.a)(e, function (e, t) {
                      return function (n) {
                        i(function (r) {
                          return [].concat(_toConsumableArray(r), [{
                            name: e,
                            blob: t,
                            url: n
                          }]);
                        });
                      };
                    }(n[t], e));
                  };

                  _context42.sent.map(_context42.t0);

                case 9:
                case "end":
                  return _context42.stop();
              }
            }
          });
        };

        !o && _e9();
      }

      return [o, n];
    };
  }, function (e, t, n) {
    (function (t, n, r) {
      var i;

      e.exports = function e(t, n, r) {
        function o(s, u) {
          if (!n[s]) {
            if (!t[s]) {
              var c = "function" == typeof i && i;
              if (!u && c) return i(s, !0);
              if (a) return a(s, !0);
              var l = new Error("Cannot find module '" + s + "'");
              throw l.code = "MODULE_NOT_FOUND", l;
            }

            var h = n[s] = {
              exports: {}
            };
            t[s][0].call(h.exports, function (e) {
              var n = t[s][1][e];
              return o(n || e);
            }, h, h.exports, e, t, n, r);
          }

          return n[s].exports;
        }

        for (var a = "function" == typeof i && i, s = 0; s < r.length; s++) {
          o(r[s]);
        }

        return o;
      }({
        1: [function (e, t, n) {
          "use strict";

          var r = e("./utils"),
              i = e("./support"),
              o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          n.encode = function (e) {
            for (var t, n, i, a, s, u, c, l = [], h = 0, d = e.length, f = d, p = "string" !== r.getTypeOf(e); h < e.length;) {
              f = d - h, i = p ? (t = e[h++], n = h < d ? e[h++] : 0, h < d ? e[h++] : 0) : (t = e.charCodeAt(h++), n = h < d ? e.charCodeAt(h++) : 0, h < d ? e.charCodeAt(h++) : 0), a = t >> 2, s = (3 & t) << 4 | n >> 4, u = 1 < f ? (15 & n) << 2 | i >> 6 : 64, c = 2 < f ? 63 & i : 64, l.push(o.charAt(a) + o.charAt(s) + o.charAt(u) + o.charAt(c));
            }

            return l.join("");
          }, n.decode = function (e) {
            var t,
                n,
                r,
                a,
                s,
                u,
                c = 0,
                l = 0,
                h = "data:";
            if (e.substr(0, h.length) === h) throw new Error("Invalid base64 input, it looks like a data url.");
            var d,
                f = 3 * (e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "")).length / 4;
            if (e.charAt(e.length - 1) === o.charAt(64) && f--, e.charAt(e.length - 2) === o.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");

            for (d = i.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); c < e.length;) {
              t = o.indexOf(e.charAt(c++)) << 2 | (a = o.indexOf(e.charAt(c++))) >> 4, n = (15 & a) << 4 | (s = o.indexOf(e.charAt(c++))) >> 2, r = (3 & s) << 6 | (u = o.indexOf(e.charAt(c++))), d[l++] = t, 64 !== s && (d[l++] = n), 64 !== u && (d[l++] = r);
            }

            return d;
          };
        }, {
          "./support": 30,
          "./utils": 32
        }],
        2: [function (e, t, n) {
          "use strict";

          var r = e("./external"),
              i = e("./stream/DataWorker"),
              o = e("./stream/DataLengthProbe"),
              a = e("./stream/Crc32Probe");

          function s(e, t, n, r, i) {
            this.compressedSize = e, this.uncompressedSize = t, this.crc32 = n, this.compression = r, this.compressedContent = i;
          }

          o = e("./stream/DataLengthProbe"), s.prototype = {
            getContentWorker: function getContentWorker() {
              var e = new i(r.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new o("data_length")),
                  t = this;
              return e.on("end", function () {
                if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
              }), e;
            },
            getCompressedWorker: function getCompressedWorker() {
              return new i(r.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
            }
          }, s.createWorkerFrom = function (e, t, n) {
            return e.pipe(new a()).pipe(new o("uncompressedSize")).pipe(t.compressWorker(n)).pipe(new o("compressedSize")).withStreamInfo("compression", t);
          }, t.exports = s;
        }, {
          "./external": 6,
          "./stream/Crc32Probe": 25,
          "./stream/DataLengthProbe": 26,
          "./stream/DataWorker": 27
        }],
        3: [function (e, t, n) {
          "use strict";

          var r = e("./stream/GenericWorker");
          n.STORE = {
            magic: "\0\0",
            compressWorker: function compressWorker(e) {
              return new r("STORE compression");
            },
            uncompressWorker: function uncompressWorker() {
              return new r("STORE decompression");
            }
          }, n.DEFLATE = e("./flate");
        }, {
          "./flate": 7,
          "./stream/GenericWorker": 28
        }],
        4: [function (e, t, n) {
          "use strict";

          var r = e("./utils"),
              i = function () {
            for (var e, t = [], n = 0; n < 256; n++) {
              e = n;

              for (var r = 0; r < 8; r++) {
                e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
              }

              t[n] = e;
            }

            return t;
          }();

          t.exports = function (e, t) {
            return void 0 !== e && e.length ? "string" !== r.getTypeOf(e) ? function (e, t, n, r) {
              var o = i,
                  a = 0 + n;
              e ^= -1;

              for (var s = 0; s < a; s++) {
                e = e >>> 8 ^ o[255 & (e ^ t[s])];
              }

              return -1 ^ e;
            }(0 | t, e, e.length) : function (e, t, n, r) {
              var o = i,
                  a = 0 + n;
              e ^= -1;

              for (var s = 0; s < a; s++) {
                e = e >>> 8 ^ o[255 & (e ^ t.charCodeAt(s))];
              }

              return -1 ^ e;
            }(0 | t, e, e.length) : 0;
          };
        }, {
          "./utils": 32
        }],
        5: [function (e, t, n) {
          "use strict";

          n.base64 = !1, n.binary = !1, n.dir = !1, n.createFolders = !0, n.date = null, n.compression = null, n.compressionOptions = null, n.comment = null, n.unixPermissions = null, n.dosPermissions = null;
        }, {}],
        6: [function (e, t, n) {
          "use strict";

          var r = null;
          r = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
            Promise: r
          };
        }, {
          lie: 37
        }],
        7: [function (e, t, n) {
          "use strict";

          var r = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array,
              i = e("pako"),
              o = e("./utils"),
              a = e("./stream/GenericWorker"),
              s = r ? "uint8array" : "array";

          function u(e, t) {
            a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
          }

          n.magic = "\b\0", o.inherits(u, a), u.prototype.processChunk = function (e) {
            this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(o.transformTo(s, e.data), !1);
          }, u.prototype.flush = function () {
            a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
          }, u.prototype.cleanUp = function () {
            a.prototype.cleanUp.call(this), this._pako = null;
          }, u.prototype._createPako = function () {
            this._pako = new i[this._pakoAction]({
              raw: !0,
              level: this._pakoOptions.level || -1
            });
            var e = this;

            this._pako.onData = function (t) {
              e.push({
                data: t,
                meta: e.meta
              });
            };
          }, n.compressWorker = function (e) {
            return new u("Deflate", e);
          }, n.uncompressWorker = function () {
            return new u("Inflate", {});
          };
        }, {
          "./stream/GenericWorker": 28,
          "./utils": 32,
          pako: 38
        }],
        8: [function (e, t, n) {
          "use strict";

          function r(e, t) {
            var n,
                r = "";

            for (n = 0; n < t; n++) {
              r += String.fromCharCode(255 & e), e >>>= 8;
            }

            return r;
          }

          function i(e, t, n, i, a, l) {
            var h,
                d,
                f = e.file,
                p = e.compression,
                m = l !== s.utf8encode,
                _ = o.transformTo("string", l(f.name)),
                y = o.transformTo("string", s.utf8encode(f.name)),
                v = f.comment,
                g = o.transformTo("string", l(v)),
                b = o.transformTo("string", s.utf8encode(v)),
                w = y.length !== f.name.length,
                T = b.length !== v.length,
                M = "",
                E = "",
                k = "",
                L = f.dir,
                S = f.date,
                N = {
              crc32: 0,
              compressedSize: 0,
              uncompressedSize: 0
            };

            t && !n || (N.crc32 = e.crc32, N.compressedSize = e.compressedSize, N.uncompressedSize = e.uncompressedSize);
            var D = 0;
            t && (D |= 8), m || !w && !T || (D |= 2048);
            var I = 0,
                R = 0;
            L && (I |= 16), "UNIX" === a ? (R = 798, I |= function (e, t) {
              var n = e;
              return e || (n = 33204), (65535 & n) << 16;
            }(f.unixPermissions)) : (R = 20, I |= (f.dosPermissions, 0)), h = S.getUTCHours(), h <<= 6, h |= S.getUTCMinutes(), h <<= 5, h |= S.getUTCSeconds() / 2, d = S.getUTCFullYear() - 1980, d <<= 4, d |= S.getUTCMonth() + 1, d <<= 5, d |= S.getUTCDate(), w && (E = r(1, 1) + r(u(_), 4) + y, M += "up" + r(E.length, 2) + E), T && (k = r(1, 1) + r(u(g), 4) + b, M += "uc" + r(k.length, 2) + k);
            var x = "";
            return x += "\n\0", x += r(D, 2), x += p.magic, x += r(h, 2), x += r(d, 2), x += r(N.crc32, 4), x += r(N.compressedSize, 4), x += r(N.uncompressedSize, 4), x += r(_.length, 2), x += r(M.length, 2), {
              fileRecord: c.LOCAL_FILE_HEADER + x + _ + M,
              dirRecord: c.CENTRAL_FILE_HEADER + r(R, 2) + x + r(g.length, 2) + "\0\0\0\0" + r(I, 4) + r(i, 4) + _ + M + g
            };
          }

          var o = e("../utils"),
              a = e("../stream/GenericWorker"),
              s = e("../utf8"),
              u = e("../crc32"),
              c = e("../signature");

          function l(e, t, n, r) {
            a.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = n, this.encodeFileName = r, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
          }

          o.inherits(l, a), l.prototype.push = function (e) {
            var t = e.meta.percent || 0,
                n = this.entriesCount,
                r = this._sources.length;
            this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, a.prototype.push.call(this, {
              data: e.data,
              meta: {
                currentFile: this.currentFile,
                percent: n ? (t + 100 * (n - r - 1)) / n : 100
              }
            }));
          }, l.prototype.openedSource = function (e) {
            this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
            var t = this.streamFiles && !e.file.dir;

            if (t) {
              var n = i(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
              this.push({
                data: n.fileRecord,
                meta: {
                  percent: 0
                }
              });
            } else this.accumulate = !0;
          }, l.prototype.closedSource = function (e) {
            this.accumulate = !1;
            var t = this.streamFiles && !e.file.dir,
                n = i(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
            if (this.dirRecords.push(n.dirRecord), t) this.push({
              data: function (e) {
                return c.DATA_DESCRIPTOR + r(e.crc32, 4) + r(e.compressedSize, 4) + r(e.uncompressedSize, 4);
              }(e),
              meta: {
                percent: 100
              }
            });else for (this.push({
              data: n.fileRecord,
              meta: {
                percent: 0
              }
            }); this.contentBuffer.length;) {
              this.push(this.contentBuffer.shift());
            }
            this.currentFile = null;
          }, l.prototype.flush = function () {
            for (var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++) {
              this.push({
                data: this.dirRecords[t],
                meta: {
                  percent: 100
                }
              });
            }

            var n = this.bytesWritten - e,
                i = function (e, t, n, i, a) {
              var s = o.transformTo("string", a(i));
              return c.CENTRAL_DIRECTORY_END + "\0\0\0\0" + r(e, 2) + r(e, 2) + r(t, 4) + r(n, 4) + r(s.length, 2) + s;
            }(this.dirRecords.length, n, e, this.zipComment, this.encodeFileName);

            this.push({
              data: i,
              meta: {
                percent: 100
              }
            });
          }, l.prototype.prepareNextSource = function () {
            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
          }, l.prototype.registerPrevious = function (e) {
            this._sources.push(e);

            var t = this;
            return e.on("data", function (e) {
              t.processChunk(e);
            }), e.on("end", function () {
              t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
            }), e.on("error", function (e) {
              t.error(e);
            }), this;
          }, l.prototype.resume = function () {
            return !!a.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
          }, l.prototype.error = function (e) {
            var t = this._sources;
            if (!a.prototype.error.call(this, e)) return !1;

            for (var n = 0; n < t.length; n++) {
              try {
                t[n].error(e);
              } catch (e) {}
            }

            return !0;
          }, l.prototype.lock = function () {
            a.prototype.lock.call(this);

            for (var e = this._sources, t = 0; t < e.length; t++) {
              e[t].lock();
            }
          }, t.exports = l;
        }, {
          "../crc32": 4,
          "../signature": 23,
          "../stream/GenericWorker": 28,
          "../utf8": 31,
          "../utils": 32
        }],
        9: [function (e, t, n) {
          "use strict";

          var r = e("../compressions"),
              i = e("./ZipFileWorker");

          n.generateWorker = function (e, t, n) {
            var o = new i(t.streamFiles, n, t.platform, t.encodeFileName),
                a = 0;

            try {
              e.forEach(function (e, n) {
                a++;

                var i = function (e, t) {
                  var n = e || t,
                      i = r[n];
                  if (!i) throw new Error(n + " is not a valid compression method !");
                  return i;
                }(n.options.compression, t.compression),
                    s = n.options.compressionOptions || t.compressionOptions || {},
                    u = n.dir,
                    c = n.date;

                n._compressWorker(i, s).withStreamInfo("file", {
                  name: e,
                  dir: u,
                  date: c,
                  comment: n.comment || "",
                  unixPermissions: n.unixPermissions,
                  dosPermissions: n.dosPermissions
                }).pipe(o);
              }), o.entriesCount = a;
            } catch (e) {
              o.error(e);
            }

            return o;
          };
        }, {
          "../compressions": 3,
          "./ZipFileWorker": 8
        }],
        10: [function (e, t, n) {
          "use strict";

          function r() {
            if (!(this instanceof r)) return new r();
            if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
            this.files = {}, this.comment = null, this.root = "", this.clone = function () {
              var e = new r();

              for (var t in this) {
                "function" != typeof this[t] && (e[t] = this[t]);
              }

              return e;
            };
          }

          (r.prototype = e("./object")).loadAsync = e("./load"), r.support = e("./support"), r.defaults = e("./defaults"), r.version = "3.4.0", r.loadAsync = function (e, t) {
            return new r().loadAsync(e, t);
          }, r.external = e("./external"), t.exports = r;
        }, {
          "./defaults": 5,
          "./external": 6,
          "./load": 11,
          "./object": 15,
          "./support": 30
        }],
        11: [function (e, t, n) {
          "use strict";

          var r = e("./utils"),
              i = e("./external"),
              o = e("./utf8"),
              a = (r = e("./utils"), e("./zipEntries")),
              s = e("./stream/Crc32Probe"),
              u = e("./nodejsUtils");

          function c(e) {
            return new i.Promise(function (t, n) {
              var r = e.decompressed.getContentWorker().pipe(new s());
              r.on("error", function (e) {
                n(e);
              }).on("end", function () {
                r.streamInfo.crc32 !== e.decompressed.crc32 ? n(new Error("Corrupted zip : CRC32 mismatch")) : t();
              }).resume();
            });
          }

          t.exports = function (e, t) {
            var n = this;
            return t = r.extend(t || {}, {
              base64: !1,
              checkCRC32: !1,
              optimizedBinaryString: !1,
              createFolders: !1,
              decodeFileName: o.utf8decode
            }), u.isNode && u.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : r.prepareContent("the loaded zip file", e, !0, t.optimizedBinaryString, t.base64).then(function (e) {
              var n = new a(t);
              return n.load(e), n;
            }).then(function (e) {
              var n = [i.Promise.resolve(e)],
                  r = e.files;
              if (t.checkCRC32) for (var o = 0; o < r.length; o++) {
                n.push(c(r[o]));
              }
              return i.Promise.all(n);
            }).then(function (e) {
              for (var r = e.shift(), i = r.files, o = 0; o < i.length; o++) {
                var a = i[o];
                n.file(a.fileNameStr, a.decompressed, {
                  binary: !0,
                  optimizedBinaryString: !0,
                  date: a.date,
                  dir: a.dir,
                  comment: a.fileCommentStr.length ? a.fileCommentStr : null,
                  unixPermissions: a.unixPermissions,
                  dosPermissions: a.dosPermissions,
                  createFolders: t.createFolders
                });
              }

              return r.zipComment.length && (n.comment = r.zipComment), n;
            });
          };
        }, {
          "./external": 6,
          "./nodejsUtils": 14,
          "./stream/Crc32Probe": 25,
          "./utf8": 31,
          "./utils": 32,
          "./zipEntries": 33
        }],
        12: [function (e, t, n) {
          "use strict";

          var r = e("../utils"),
              i = e("../stream/GenericWorker");

          function o(e, t) {
            i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
          }

          r.inherits(o, i), o.prototype._bindStream = function (e) {
            var t = this;
            (this._stream = e).pause(), e.on("data", function (e) {
              t.push({
                data: e,
                meta: {
                  percent: 0
                }
              });
            }).on("error", function (e) {
              t.isPaused ? this.generatedError = e : t.error(e);
            }).on("end", function () {
              t.isPaused ? t._upstreamEnded = !0 : t.end();
            });
          }, o.prototype.pause = function () {
            return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
          }, o.prototype.resume = function () {
            return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
          }, t.exports = o;
        }, {
          "../stream/GenericWorker": 28,
          "../utils": 32
        }],
        13: [function (e, t, n) {
          "use strict";

          var r = e("readable-stream").Readable;

          function i(e, t, n) {
            r.call(this, t), this._helper = e;
            var i = this;
            e.on("data", function (e, t) {
              i.push(e) || i._helper.pause(), n && n(t);
            }).on("error", function (e) {
              i.emit("error", e);
            }).on("end", function () {
              i.push(null);
            });
          }

          e("../utils").inherits(i, r), i.prototype._read = function () {
            this._helper.resume();
          }, t.exports = i;
        }, {
          "../utils": 32,
          "readable-stream": 16
        }],
        14: [function (e, n, r) {
          "use strict";

          n.exports = {
            isNode: void 0 !== t,
            newBufferFrom: function newBufferFrom(e, n) {
              if (t.from && t.from !== Uint8Array.from) return t.from(e, n);
              if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
              return new t(e, n);
            },
            allocBuffer: function allocBuffer(e) {
              if (t.alloc) return t.alloc(e);
              var n = new t(e);
              return n.fill(0), n;
            },
            isBuffer: function isBuffer(e) {
              return t.isBuffer(e);
            },
            isStream: function isStream(e) {
              return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
            }
          };
        }, {}],
        15: [function (e, t, n) {
          "use strict";

          function r(e, t, n) {
            var r,
                i = o.getTypeOf(t),
                s = o.extend(n || {}, u);
            s.date = s.date || new Date(), null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = m(e)), s.createFolders && (r = p(e)) && _.call(this, r, !0);
            var h = "string" === i && !1 === s.binary && !1 === s.base64;
            n && void 0 !== n.binary || (s.binary = !h), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
            var y = null;
            y = t instanceof c || t instanceof a ? t : d.isNode && d.isStream(t) ? new f(e, t) : o.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
            var v = new l(e, y, s);
            this.files[e] = v;
          }

          var i = e("./utf8"),
              o = e("./utils"),
              a = e("./stream/GenericWorker"),
              s = e("./stream/StreamHelper"),
              u = e("./defaults"),
              c = e("./compressedObject"),
              l = e("./zipObject"),
              h = e("./generate"),
              d = e("./nodejsUtils"),
              f = e("./nodejs/NodejsStreamInputAdapter"),
              p = function p(e) {
            "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
            var t = e.lastIndexOf("/");
            return 0 < t ? e.substring(0, t) : "";
          },
              m = function m(e) {
            return "/" !== e.slice(-1) && (e += "/"), e;
          },
              _ = function _(e, t) {
            return t = void 0 !== t ? t : u.createFolders, e = m(e), this.files[e] || r.call(this, e, null, {
              dir: !0,
              createFolders: t
            }), this.files[e];
          };

          function y(e) {
            return "[object RegExp]" === Object.prototype.toString.call(e);
          }

          var v = {
            load: function load() {
              throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
            },
            forEach: function forEach(e) {
              var t, n, r;

              for (t in this.files) {
                this.files.hasOwnProperty(t) && (r = this.files[t], (n = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(n, r));
              }
            },
            filter: function filter(e) {
              var t = [];
              return this.forEach(function (n, r) {
                e(n, r) && t.push(r);
              }), t;
            },
            file: function file(e, t, n) {
              if (1 !== arguments.length) return e = this.root + e, r.call(this, e, t, n), this;

              if (y(e)) {
                var i = e;
                return this.filter(function (e, t) {
                  return !t.dir && i.test(e);
                });
              }

              var o = this.files[this.root + e];
              return o && !o.dir ? o : null;
            },
            folder: function folder(e) {
              if (!e) return this;
              if (y(e)) return this.filter(function (t, n) {
                return n.dir && e.test(t);
              });

              var t = this.root + e,
                  n = _.call(this, t),
                  r = this.clone();

              return r.root = n.name, r;
            },
            remove: function remove(e) {
              e = this.root + e;
              var t = this.files[e];
              if (t || ("/" !== e.slice(-1) && (e += "/"), t = this.files[e]), t && !t.dir) delete this.files[e];else for (var n = this.filter(function (t, n) {
                return n.name.slice(0, e.length) === e;
              }), r = 0; r < n.length; r++) {
                delete this.files[n[r].name];
              }
              return this;
            },
            generate: function generate(e) {
              throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
            },
            generateInternalStream: function generateInternalStream(e) {
              var t,
                  n = {};

              try {
                if ((n = o.extend(e || {}, {
                  streamFiles: !1,
                  compression: "STORE",
                  compressionOptions: null,
                  type: "",
                  platform: "DOS",
                  comment: null,
                  mimeType: "application/zip",
                  encodeFileName: i.utf8encode
                })).type = n.type.toLowerCase(), n.compression = n.compression.toUpperCase(), "binarystring" === n.type && (n.type = "string"), !n.type) throw new Error("No output type specified.");
                o.checkSupport(n.type), "darwin" !== n.platform && "freebsd" !== n.platform && "linux" !== n.platform && "sunos" !== n.platform || (n.platform = "UNIX"), "win32" === n.platform && (n.platform = "DOS");
                var r = n.comment || this.comment || "";
                t = h.generateWorker(this, n, r);
              } catch (e) {
                (t = new a("error")).error(e);
              }

              return new s(t, n.type || "string", n.mimeType);
            },
            generateAsync: function generateAsync(e, t) {
              return this.generateInternalStream(e).accumulate(t);
            },
            generateNodeStream: function generateNodeStream(e, t) {
              return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
            }
          };
          t.exports = v;
        }, {
          "./compressedObject": 2,
          "./defaults": 5,
          "./generate": 9,
          "./nodejs/NodejsStreamInputAdapter": 12,
          "./nodejsUtils": 14,
          "./stream/GenericWorker": 28,
          "./stream/StreamHelper": 29,
          "./utf8": 31,
          "./utils": 32,
          "./zipObject": 35
        }],
        16: [function (e, t, n) {
          t.exports = e("stream");
        }, {
          stream: void 0
        }],
        17: [function (e, t, n) {
          "use strict";

          var r = e("./DataReader");

          function i(e) {
            r.call(this, e);

            for (var t = 0; t < this.data.length; t++) {
              e[t] = 255 & e[t];
            }
          }

          e("../utils").inherits(i, r), i.prototype.byteAt = function (e) {
            return this.data[this.zero + e];
          }, i.prototype.lastIndexOfSignature = function (e) {
            for (var t = e.charCodeAt(0), n = e.charCodeAt(1), r = e.charCodeAt(2), i = e.charCodeAt(3), o = this.length - 4; 0 <= o; --o) {
              if (this.data[o] === t && this.data[o + 1] === n && this.data[o + 2] === r && this.data[o + 3] === i) return o - this.zero;
            }

            return -1;
          }, i.prototype.readAndCheckSignature = function (e) {
            var t = e.charCodeAt(0),
                n = e.charCodeAt(1),
                r = e.charCodeAt(2),
                i = e.charCodeAt(3),
                o = this.readData(4);
            return t === o[0] && n === o[1] && r === o[2] && i === o[3];
          }, i.prototype.readData = function (e) {
            if (this.checkOffset(e), 0 === e) return [];
            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
            return this.index += e, t;
          }, t.exports = i;
        }, {
          "../utils": 32,
          "./DataReader": 18
        }],
        18: [function (e, t, n) {
          "use strict";

          var r = e("../utils");

          function i(e) {
            this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
          }

          i.prototype = {
            checkOffset: function checkOffset(e) {
              this.checkIndex(this.index + e);
            },
            checkIndex: function checkIndex(e) {
              if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
            },
            setIndex: function setIndex(e) {
              this.checkIndex(e), this.index = e;
            },
            skip: function skip(e) {
              this.setIndex(this.index + e);
            },
            byteAt: function byteAt(e) {},
            readInt: function readInt(e) {
              var t,
                  n = 0;

              for (this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--) {
                n = (n << 8) + this.byteAt(t);
              }

              return this.index += e, n;
            },
            readString: function readString(e) {
              return r.transformTo("string", this.readData(e));
            },
            readData: function readData(e) {},
            lastIndexOfSignature: function lastIndexOfSignature(e) {},
            readAndCheckSignature: function readAndCheckSignature(e) {},
            readDate: function readDate() {
              var e = this.readInt(4);
              return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
            }
          }, t.exports = i;
        }, {
          "../utils": 32
        }],
        19: [function (e, t, n) {
          "use strict";

          var r = e("./Uint8ArrayReader");

          function i(e) {
            r.call(this, e);
          }

          e("../utils").inherits(i, r), i.prototype.readData = function (e) {
            this.checkOffset(e);
            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
            return this.index += e, t;
          }, t.exports = i;
        }, {
          "../utils": 32,
          "./Uint8ArrayReader": 21
        }],
        20: [function (e, t, n) {
          "use strict";

          var r = e("./DataReader");

          function i(e) {
            r.call(this, e);
          }

          e("../utils").inherits(i, r), i.prototype.byteAt = function (e) {
            return this.data.charCodeAt(this.zero + e);
          }, i.prototype.lastIndexOfSignature = function (e) {
            return this.data.lastIndexOf(e) - this.zero;
          }, i.prototype.readAndCheckSignature = function (e) {
            return e === this.readData(4);
          }, i.prototype.readData = function (e) {
            this.checkOffset(e);
            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
            return this.index += e, t;
          }, t.exports = i;
        }, {
          "../utils": 32,
          "./DataReader": 18
        }],
        21: [function (e, t, n) {
          "use strict";

          var r = e("./ArrayReader");

          function i(e) {
            r.call(this, e);
          }

          e("../utils").inherits(i, r), i.prototype.readData = function (e) {
            if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
            var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
            return this.index += e, t;
          }, t.exports = i;
        }, {
          "../utils": 32,
          "./ArrayReader": 17
        }],
        22: [function (e, t, n) {
          "use strict";

          var r = e("../utils"),
              i = e("../support"),
              o = e("./ArrayReader"),
              a = e("./StringReader"),
              s = e("./NodeBufferReader"),
              u = e("./Uint8ArrayReader");

          t.exports = function (e) {
            var t = r.getTypeOf(e);
            return r.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new s(e) : i.uint8array ? new u(r.transformTo("uint8array", e)) : new o(r.transformTo("array", e)) : new a(e);
          };
        }, {
          "../support": 30,
          "../utils": 32,
          "./ArrayReader": 17,
          "./NodeBufferReader": 19,
          "./StringReader": 20,
          "./Uint8ArrayReader": 21
        }],
        23: [function (e, t, n) {
          "use strict";

          n.LOCAL_FILE_HEADER = "PK", n.CENTRAL_FILE_HEADER = "PK", n.CENTRAL_DIRECTORY_END = "PK", n.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", n.ZIP64_CENTRAL_DIRECTORY_END = "PK", n.DATA_DESCRIPTOR = "PK\b";
        }, {}],
        24: [function (e, t, n) {
          "use strict";

          var r = e("./GenericWorker"),
              i = e("../utils");

          function o(e) {
            r.call(this, "ConvertWorker to " + e), this.destType = e;
          }

          i.inherits(o, r), o.prototype.processChunk = function (e) {
            this.push({
              data: i.transformTo(this.destType, e.data),
              meta: e.meta
            });
          }, t.exports = o;
        }, {
          "../utils": 32,
          "./GenericWorker": 28
        }],
        25: [function (e, t, n) {
          "use strict";

          var r = e("./GenericWorker"),
              i = e("../crc32");

          function o() {
            r.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
          }

          e("../utils").inherits(o, r), o.prototype.processChunk = function (e) {
            this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
          }, t.exports = o;
        }, {
          "../crc32": 4,
          "../utils": 32,
          "./GenericWorker": 28
        }],
        26: [function (e, t, n) {
          "use strict";

          var r = e("../utils"),
              i = e("./GenericWorker");

          function o(e) {
            i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
          }

          r.inherits(o, i), o.prototype.processChunk = function (e) {
            if (e) {
              var t = this.streamInfo[this.propName] || 0;
              this.streamInfo[this.propName] = t + e.data.length;
            }

            i.prototype.processChunk.call(this, e);
          }, t.exports = o;
        }, {
          "../utils": 32,
          "./GenericWorker": 28
        }],
        27: [function (e, t, n) {
          "use strict";

          var r = e("../utils"),
              i = e("./GenericWorker");

          function o(e) {
            i.call(this, "DataWorker");
            var t = this;
            this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function (e) {
              t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = r.getTypeOf(e), t.isPaused || t._tickAndRepeat();
            }, function (e) {
              t.error(e);
            });
          }

          r.inherits(o, i), o.prototype.cleanUp = function () {
            i.prototype.cleanUp.call(this), this.data = null;
          }, o.prototype.resume = function () {
            return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, r.delay(this._tickAndRepeat, [], this)), !0);
          }, o.prototype._tickAndRepeat = function () {
            this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (r.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
          }, o.prototype._tick = function () {
            if (this.isPaused || this.isFinished) return !1;
            var e = null,
                t = Math.min(this.max, this.index + 16384);
            if (this.index >= this.max) return this.end();

            switch (this.type) {
              case "string":
                e = this.data.substring(this.index, t);
                break;

              case "uint8array":
                e = this.data.subarray(this.index, t);
                break;

              case "array":
              case "nodebuffer":
                e = this.data.slice(this.index, t);
            }

            return this.index = t, this.push({
              data: e,
              meta: {
                percent: this.max ? this.index / this.max * 100 : 0
              }
            });
          }, t.exports = o;
        }, {
          "../utils": 32,
          "./GenericWorker": 28
        }],
        28: [function (e, t, n) {
          "use strict";

          function r(e) {
            this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
              data: [],
              end: [],
              error: []
            }, this.previous = null;
          }

          r.prototype = {
            push: function push(e) {
              this.emit("data", e);
            },
            end: function end() {
              if (this.isFinished) return !1;
              this.flush();

              try {
                this.emit("end"), this.cleanUp(), this.isFinished = !0;
              } catch (e) {
                this.emit("error", e);
              }

              return !0;
            },
            error: function error(e) {
              return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
            },
            on: function on(e, t) {
              return this._listeners[e].push(t), this;
            },
            cleanUp: function cleanUp() {
              this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
            },
            emit: function emit(e, t) {
              if (this._listeners[e]) for (var n = 0; n < this._listeners[e].length; n++) {
                this._listeners[e][n].call(this, t);
              }
            },
            pipe: function pipe(e) {
              return e.registerPrevious(this);
            },
            registerPrevious: function registerPrevious(e) {
              if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
              this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
              var t = this;
              return e.on("data", function (e) {
                t.processChunk(e);
              }), e.on("end", function () {
                t.end();
              }), e.on("error", function (e) {
                t.error(e);
              }), this;
            },
            pause: function pause() {
              return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
            },
            resume: function resume() {
              if (!this.isPaused || this.isFinished) return !1;
              var e = this.isPaused = !1;
              return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
            },
            flush: function flush() {},
            processChunk: function processChunk(e) {
              this.push(e);
            },
            withStreamInfo: function withStreamInfo(e, t) {
              return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
            },
            mergeStreamInfo: function mergeStreamInfo() {
              for (var e in this.extraStreamInfo) {
                this.extraStreamInfo.hasOwnProperty(e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
              }
            },
            lock: function lock() {
              if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
              this.isLocked = !0, this.previous && this.previous.lock();
            },
            toString: function toString() {
              var e = "Worker " + this.name;
              return this.previous ? this.previous + " -> " + e : e;
            }
          }, t.exports = r;
        }, {}],
        29: [function (e, n, r) {
          "use strict";

          var i = e("../utils"),
              o = e("./ConvertWorker"),
              a = e("./GenericWorker"),
              s = e("../base64"),
              u = e("../support"),
              c = e("../external"),
              l = null;
          if (u.nodestream) try {
            l = e("../nodejs/NodejsStreamOutputAdapter");
          } catch (e) {}

          function h(e, t, n) {
            var r = t;

            switch (t) {
              case "blob":
              case "arraybuffer":
                r = "uint8array";
                break;

              case "base64":
                r = "string";
            }

            try {
              this._internalType = r, this._outputType = t, this._mimeType = n, i.checkSupport(r), this._worker = e.pipe(new o(r)), e.lock();
            } catch (e) {
              this._worker = new a("error"), this._worker.error(e);
            }
          }

          h.prototype = {
            accumulate: function accumulate(e) {
              return function (e, n) {
                return new c.Promise(function (r, o) {
                  var a = [],
                      u = e._internalType,
                      c = e._outputType,
                      l = e._mimeType;
                  e.on("data", function (e, t) {
                    a.push(e), n && n(t);
                  }).on("error", function (e) {
                    a = [], o(e);
                  }).on("end", function () {
                    try {
                      var e = function (e, t, n) {
                        switch (e) {
                          case "blob":
                            return i.newBlob(i.transformTo("arraybuffer", t), n);

                          case "base64":
                            return s.encode(t);

                          default:
                            return i.transformTo(e, t);
                        }
                      }(c, function (e, n) {
                        var r,
                            i = 0,
                            o = null,
                            a = 0;

                        for (r = 0; r < n.length; r++) {
                          a += n[r].length;
                        }

                        switch (e) {
                          case "string":
                            return n.join("");

                          case "array":
                            return Array.prototype.concat.apply([], n);

                          case "uint8array":
                            for (o = new Uint8Array(a), r = 0; r < n.length; r++) {
                              o.set(n[r], i), i += n[r].length;
                            }

                            return o;

                          case "nodebuffer":
                            return t.concat(n);

                          default:
                            throw new Error("concat : unsupported type '" + e + "'");
                        }
                      }(u, a), l);

                      r(e);
                    } catch (e) {
                      o(e);
                    }

                    a = [];
                  }).resume();
                });
              }(this, e);
            },
            on: function on(e, t) {
              var n = this;
              return "data" === e ? this._worker.on(e, function (e) {
                t.call(n, e.data, e.meta);
              }) : this._worker.on(e, function () {
                i.delay(t, arguments, n);
              }), this;
            },
            resume: function resume() {
              return i.delay(this._worker.resume, [], this._worker), this;
            },
            pause: function pause() {
              return this._worker.pause(), this;
            },
            toNodejsStream: function toNodejsStream(e) {
              if (i.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
              return new l(this, {
                objectMode: "nodebuffer" !== this._outputType
              }, e);
            }
          }, n.exports = h;
        }, {
          "../base64": 1,
          "../external": 6,
          "../nodejs/NodejsStreamOutputAdapter": 13,
          "../support": 30,
          "../utils": 32,
          "./ConvertWorker": 24,
          "./GenericWorker": 28
        }],
        30: [function (e, n, r) {
          "use strict";

          if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = void 0 !== t, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;else {
            var i = new ArrayBuffer(0);

            try {
              r.blob = 0 === new Blob([i], {
                type: "application/zip"
              }).size;
            } catch (e) {
              try {
                var o = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                o.append(i), r.blob = 0 === o.getBlob("application/zip").size;
              } catch (e) {
                r.blob = !1;
              }
            }
          }

          try {
            r.nodestream = !!e("readable-stream").Readable;
          } catch (e) {
            r.nodestream = !1;
          }
        }, {
          "readable-stream": 16
        }],
        31: [function (e, t, n) {
          "use strict";

          for (var r = e("./utils"), i = e("./support"), o = e("./nodejsUtils"), a = e("./stream/GenericWorker"), s = new Array(256), u = 0; u < 256; u++) {
            s[u] = 252 <= u ? 6 : 248 <= u ? 5 : 240 <= u ? 4 : 224 <= u ? 3 : 192 <= u ? 2 : 1;
          }

          function c() {
            a.call(this, "utf-8 decode"), this.leftOver = null;
          }

          function l() {
            a.call(this, "utf-8 encode");
          }

          s[254] = s[254] = 1, n.utf8encode = function (e) {
            return i.nodebuffer ? o.newBufferFrom(e, "utf-8") : function (e) {
              var t,
                  n,
                  r,
                  o,
                  a,
                  s = e.length,
                  u = 0;

              for (o = 0; o < s; o++) {
                55296 == (64512 & (n = e.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (r = e.charCodeAt(o + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), o++), u += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
              }

              for (t = i.uint8array ? new Uint8Array(u) : new Array(u), o = a = 0; a < u; o++) {
                55296 == (64512 & (n = e.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (r = e.charCodeAt(o + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), o++), n < 128 ? t[a++] = n : (n < 2048 ? t[a++] = 192 | n >>> 6 : (n < 65536 ? t[a++] = 224 | n >>> 12 : (t[a++] = 240 | n >>> 18, t[a++] = 128 | n >>> 12 & 63), t[a++] = 128 | n >>> 6 & 63), t[a++] = 128 | 63 & n);
              }

              return t;
            }(e);
          }, n.utf8decode = function (e) {
            return i.nodebuffer ? r.transformTo("nodebuffer", e).toString("utf-8") : function (e) {
              var t,
                  n,
                  i,
                  o,
                  a = e.length,
                  u = new Array(2 * a);

              for (t = n = 0; t < a;) {
                if ((i = e[t++]) < 128) u[n++] = i;else if (4 < (o = s[i])) u[n++] = 65533, t += o - 1;else {
                  for (i &= 2 === o ? 31 : 3 === o ? 15 : 7; 1 < o && t < a;) {
                    i = i << 6 | 63 & e[t++], o--;
                  }

                  1 < o ? u[n++] = 65533 : i < 65536 ? u[n++] = i : (i -= 65536, u[n++] = 55296 | i >> 10 & 1023, u[n++] = 56320 | 1023 & i);
                }
              }

              return u.length !== n && (u.subarray ? u = u.subarray(0, n) : u.length = n), r.applyFromCharCode(u);
            }(e = r.transformTo(i.uint8array ? "uint8array" : "array", e));
          }, r.inherits(c, a), c.prototype.processChunk = function (e) {
            var t = r.transformTo(i.uint8array ? "uint8array" : "array", e.data);

            if (this.leftOver && this.leftOver.length) {
              if (i.uint8array) {
                var o = t;
                (t = new Uint8Array(o.length + this.leftOver.length)).set(this.leftOver, 0), t.set(o, this.leftOver.length);
              } else t = this.leftOver.concat(t);

              this.leftOver = null;
            }

            var a = function (e, t) {
              var n;

              for ((t = t || e.length) > e.length && (t = e.length), n = t - 1; 0 <= n && 128 == (192 & e[n]);) {
                n--;
              }

              return n < 0 ? t : 0 === n ? t : n + s[e[n]] > t ? n : t;
            }(t),
                u = t;

            a !== t.length && (i.uint8array ? (u = t.subarray(0, a), this.leftOver = t.subarray(a, t.length)) : (u = t.slice(0, a), this.leftOver = t.slice(a, t.length))), this.push({
              data: n.utf8decode(u),
              meta: e.meta
            });
          }, c.prototype.flush = function () {
            this.leftOver && this.leftOver.length && (this.push({
              data: n.utf8decode(this.leftOver),
              meta: {}
            }), this.leftOver = null);
          }, n.Utf8DecodeWorker = c, r.inherits(l, a), l.prototype.processChunk = function (e) {
            this.push({
              data: n.utf8encode(e.data),
              meta: e.meta
            });
          }, n.Utf8EncodeWorker = l;
        }, {
          "./nodejsUtils": 14,
          "./stream/GenericWorker": 28,
          "./support": 30,
          "./utils": 32
        }],
        32: [function (e, t, n) {
          "use strict";

          var r = e("./support"),
              i = e("./base64"),
              o = e("./nodejsUtils"),
              a = e("set-immediate-shim"),
              s = e("./external");

          function u(e) {
            return e;
          }

          function c(e, t) {
            for (var n = 0; n < e.length; ++n) {
              t[n] = 255 & e.charCodeAt(n);
            }

            return t;
          }

          n.newBlob = function (e, t) {
            n.checkSupport("blob");

            try {
              return new Blob([e], {
                type: t
              });
            } catch (n) {
              try {
                var r = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                return r.append(e), r.getBlob(t);
              } catch (e) {
                throw new Error("Bug : can't construct the Blob.");
              }
            }
          };

          var l = {
            stringifyByChunk: function stringifyByChunk(e, t, n) {
              var r = [],
                  i = 0,
                  o = e.length;
              if (o <= n) return String.fromCharCode.apply(null, e);

              for (; i < o;) {
                "array" === t || "nodebuffer" === t ? r.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + n, o)))) : r.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + n, o)))), i += n;
              }

              return r.join("");
            },
            stringifyByChar: function stringifyByChar(e) {
              for (var t = "", n = 0; n < e.length; n++) {
                t += String.fromCharCode(e[n]);
              }

              return t;
            },
            applyCanBeUsed: {
              uint8array: function () {
                try {
                  return r.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                } catch (e) {
                  return !1;
                }
              }(),
              nodebuffer: function () {
                try {
                  return r.nodebuffer && 1 === String.fromCharCode.apply(null, o.allocBuffer(1)).length;
                } catch (e) {
                  return !1;
                }
              }()
            }
          };

          function h(e) {
            var t = 65536,
                r = n.getTypeOf(e),
                i = !0;
            if ("uint8array" === r ? i = l.applyCanBeUsed.uint8array : "nodebuffer" === r && (i = l.applyCanBeUsed.nodebuffer), i) for (; 1 < t;) {
              try {
                return l.stringifyByChunk(e, r, t);
              } catch (e) {
                t = Math.floor(t / 2);
              }
            }
            return l.stringifyByChar(e);
          }

          function d(e, t) {
            for (var n = 0; n < e.length; n++) {
              t[n] = e[n];
            }

            return t;
          }

          n.applyFromCharCode = h;
          var f = {};
          f.string = {
            string: u,
            array: function array(e) {
              return c(e, new Array(e.length));
            },
            arraybuffer: function arraybuffer(e) {
              return f.string.uint8array(e).buffer;
            },
            uint8array: function uint8array(e) {
              return c(e, new Uint8Array(e.length));
            },
            nodebuffer: function nodebuffer(e) {
              return c(e, o.allocBuffer(e.length));
            }
          }, f.array = {
            string: h,
            array: u,
            arraybuffer: function arraybuffer(e) {
              return new Uint8Array(e).buffer;
            },
            uint8array: function uint8array(e) {
              return new Uint8Array(e);
            },
            nodebuffer: function nodebuffer(e) {
              return o.newBufferFrom(e);
            }
          }, f.arraybuffer = {
            string: function string(e) {
              return h(new Uint8Array(e));
            },
            array: function array(e) {
              return d(new Uint8Array(e), new Array(e.byteLength));
            },
            arraybuffer: u,
            uint8array: function uint8array(e) {
              return new Uint8Array(e);
            },
            nodebuffer: function nodebuffer(e) {
              return o.newBufferFrom(new Uint8Array(e));
            }
          }, f.uint8array = {
            string: h,
            array: function array(e) {
              return d(e, new Array(e.length));
            },
            arraybuffer: function arraybuffer(e) {
              return e.buffer;
            },
            uint8array: u,
            nodebuffer: function nodebuffer(e) {
              return o.newBufferFrom(e);
            }
          }, f.nodebuffer = {
            string: h,
            array: function array(e) {
              return d(e, new Array(e.length));
            },
            arraybuffer: function arraybuffer(e) {
              return f.nodebuffer.uint8array(e).buffer;
            },
            uint8array: function uint8array(e) {
              return d(e, new Uint8Array(e.length));
            },
            nodebuffer: u
          }, n.transformTo = function (e, t) {
            if (t = t || "", !e) return t;
            n.checkSupport(e);
            var r = n.getTypeOf(t);
            return f[r][e](t);
          }, n.getTypeOf = function (e) {
            return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : r.nodebuffer && o.isBuffer(e) ? "nodebuffer" : r.uint8array && e instanceof Uint8Array ? "uint8array" : r.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
          }, n.checkSupport = function (e) {
            if (!r[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
          }, n.MAX_VALUE_16BITS = 65535, n.MAX_VALUE_32BITS = -1, n.pretty = function (e) {
            var t,
                n,
                r = "";

            for (n = 0; n < (e || "").length; n++) {
              r += "\\x" + ((t = e.charCodeAt(n)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
            }

            return r;
          }, n.delay = function (e, t, n) {
            a(function () {
              e.apply(n || null, t || []);
            });
          }, n.inherits = function (e, t) {
            function n() {}

            n.prototype = t.prototype, e.prototype = new n();
          }, n.extend = function () {
            var e,
                t,
                n = {};

            for (e = 0; e < arguments.length; e++) {
              for (t in arguments[e]) {
                arguments[e].hasOwnProperty(t) && void 0 === n[t] && (n[t] = arguments[e][t]);
              }
            }

            return n;
          }, n.prepareContent = function (e, t, o, a, u) {
            return s.Promise.resolve(t).then(function (e) {
              return r.blob && (e instanceof Blob || -1 !== ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(e))) && "undefined" != typeof FileReader ? new s.Promise(function (t, n) {
                var r = new FileReader();
                r.onload = function (e) {
                  t(e.target.result);
                }, r.onerror = function (e) {
                  n(e.target.error);
                }, r.readAsArrayBuffer(e);
              }) : e;
            }).then(function (t) {
              var l = n.getTypeOf(t);
              return l ? ("arraybuffer" === l ? t = n.transformTo("uint8array", t) : "string" === l && (u ? t = i.decode(t) : o && !0 !== a && (t = function (e) {
                return c(e, r.uint8array ? new Uint8Array(e.length) : new Array(e.length));
              }(t))), t) : s.Promise.reject(new Error("Can't read the data of '" + e + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
            });
          };
        }, {
          "./base64": 1,
          "./external": 6,
          "./nodejsUtils": 14,
          "./support": 30,
          "set-immediate-shim": 54
        }],
        33: [function (e, t, n) {
          "use strict";

          var r = e("./reader/readerFor"),
              i = e("./utils"),
              o = e("./signature"),
              a = e("./zipEntry"),
              s = (e("./utf8"), e("./support"));

          function u(e) {
            this.files = [], this.loadOptions = e;
          }

          u.prototype = {
            checkSignature: function checkSignature(e) {
              if (!this.reader.readAndCheckSignature(e)) {
                this.reader.index -= 4;
                var t = this.reader.readString(4);
                throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
              }
            },
            isSignature: function isSignature(e, t) {
              var n = this.reader.index;
              this.reader.setIndex(e);
              var r = this.reader.readString(4) === t;
              return this.reader.setIndex(n), r;
            },
            readBlockEndOfCentral: function readBlockEndOfCentral() {
              this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
              var e = this.reader.readData(this.zipCommentLength),
                  t = s.uint8array ? "uint8array" : "array",
                  n = i.transformTo(t, e);
              this.zipComment = this.loadOptions.decodeFileName(n);
            },
            readBlockZip64EndOfCentral: function readBlockZip64EndOfCentral() {
              this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};

              for (var e, t, n, r = this.zip64EndOfCentralSize - 44; 0 < r;) {
                e = this.reader.readInt(2), t = this.reader.readInt(4), n = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                  id: e,
                  length: t,
                  value: n
                };
              }
            },
            readBlockZip64EndOfCentralLocator: function readBlockZip64EndOfCentralLocator() {
              if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
            },
            readLocalFiles: function readLocalFiles() {
              var e, t;

              for (e = 0; e < this.files.length; e++) {
                t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(o.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
              }
            },
            readCentralDir: function readCentralDir() {
              var e;

              for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(o.CENTRAL_FILE_HEADER);) {
                (e = new a({
                  zip64: this.zip64
                }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
              }

              if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            },
            readEndOfCentral: function readEndOfCentral() {
              var e = this.reader.lastIndexOfSignature(o.CENTRAL_DIRECTORY_END);
              if (e < 0) throw this.isSignature(0, o.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
              this.reader.setIndex(e);
              var t = e;

              if (this.checkSignature(o.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(o.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                if (this.reader.setIndex(e), this.checkSignature(o.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, o.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(o.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(o.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
              }

              var n = this.centralDirOffset + this.centralDirSize;
              this.zip64 && (n += 20, n += 12 + this.zip64EndOfCentralSize);
              var r = t - n;
              if (0 < r) this.isSignature(t, o.CENTRAL_FILE_HEADER) || (this.reader.zero = r);else if (r < 0) throw new Error("Corrupted zip: missing " + Math.abs(r) + " bytes.");
            },
            prepareReader: function prepareReader(e) {
              this.reader = r(e);
            },
            load: function load(e) {
              this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
            }
          }, t.exports = u;
        }, {
          "./reader/readerFor": 22,
          "./signature": 23,
          "./support": 30,
          "./utf8": 31,
          "./utils": 32,
          "./zipEntry": 34
        }],
        34: [function (e, t, n) {
          "use strict";

          var r = e("./reader/readerFor"),
              i = e("./utils"),
              o = e("./compressedObject"),
              a = e("./crc32"),
              s = e("./utf8"),
              u = e("./compressions"),
              c = e("./support");

          function l(e, t) {
            this.options = e, this.loadOptions = t;
          }

          l.prototype = {
            isEncrypted: function isEncrypted() {
              return 1 == (1 & this.bitFlag);
            },
            useUTF8: function useUTF8() {
              return 2048 == (2048 & this.bitFlag);
            },
            readLocalPart: function readLocalPart(e) {
              var t, n;
              if (e.skip(22), this.fileNameLength = e.readInt(2), n = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(n), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
              if (null === (t = function (e) {
                for (var t in u) {
                  if (u.hasOwnProperty(t) && u[t].magic === e) return u[t];
                }

                return null;
              }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + i.pretty(this.compressionMethod) + " unknown (inner file : " + i.transformTo("string", this.fileName) + ")");
              this.decompressed = new o(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
            },
            readCentralPart: function readCentralPart(e) {
              this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
              var t = e.readInt(2);
              if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
              e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
            },
            processAttributes: function processAttributes() {
              this.unixPermissions = null, this.dosPermissions = null;
              var e = this.versionMadeBy >> 8;
              this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
            },
            parseZIP64ExtraField: function parseZIP64ExtraField(e) {
              if (this.extraFields[1]) {
                var t = r(this.extraFields[1].value);
                this.uncompressedSize === i.MAX_VALUE_32BITS && (this.uncompressedSize = t.readInt(8)), this.compressedSize === i.MAX_VALUE_32BITS && (this.compressedSize = t.readInt(8)), this.localHeaderOffset === i.MAX_VALUE_32BITS && (this.localHeaderOffset = t.readInt(8)), this.diskNumberStart === i.MAX_VALUE_32BITS && (this.diskNumberStart = t.readInt(4));
              }
            },
            readExtraFields: function readExtraFields(e) {
              var t,
                  n,
                  r,
                  i = e.index + this.extraFieldsLength;

              for (this.extraFields || (this.extraFields = {}); e.index < i;) {
                t = e.readInt(2), n = e.readInt(2), r = e.readData(n), this.extraFields[t] = {
                  id: t,
                  length: n,
                  value: r
                };
              }
            },
            handleUTF8: function handleUTF8() {
              var e = c.uint8array ? "uint8array" : "array";
              if (this.useUTF8()) this.fileNameStr = s.utf8decode(this.fileName), this.fileCommentStr = s.utf8decode(this.fileComment);else {
                var t = this.findExtraFieldUnicodePath();
                if (null !== t) this.fileNameStr = t;else {
                  var n = i.transformTo(e, this.fileName);
                  this.fileNameStr = this.loadOptions.decodeFileName(n);
                }
                var r = this.findExtraFieldUnicodeComment();
                if (null !== r) this.fileCommentStr = r;else {
                  var o = i.transformTo(e, this.fileComment);
                  this.fileCommentStr = this.loadOptions.decodeFileName(o);
                }
              }
            },
            findExtraFieldUnicodePath: function findExtraFieldUnicodePath() {
              var e = this.extraFields[28789];

              if (e) {
                var t = r(e.value);
                return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : s.utf8decode(t.readData(e.length - 5));
              }

              return null;
            },
            findExtraFieldUnicodeComment: function findExtraFieldUnicodeComment() {
              var e = this.extraFields[25461];

              if (e) {
                var t = r(e.value);
                return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : s.utf8decode(t.readData(e.length - 5));
              }

              return null;
            }
          }, t.exports = l;
        }, {
          "./compressedObject": 2,
          "./compressions": 3,
          "./crc32": 4,
          "./reader/readerFor": 22,
          "./support": 30,
          "./utf8": 31,
          "./utils": 32
        }],
        35: [function (e, t, n) {
          "use strict";

          function r(e, t, n) {
            this.name = e, this.dir = n.dir, this.date = n.date, this.comment = n.comment, this.unixPermissions = n.unixPermissions, this.dosPermissions = n.dosPermissions, this._data = t, this._dataBinary = n.binary, this.options = {
              compression: n.compression,
              compressionOptions: n.compressionOptions
            };
          }

          var i = e("./stream/StreamHelper"),
              o = e("./stream/DataWorker"),
              a = e("./utf8"),
              s = e("./compressedObject"),
              u = e("./stream/GenericWorker");
          r.prototype = {
            internalStream: function internalStream(e) {
              var t = null,
                  n = "string";

              try {
                if (!e) throw new Error("No output type specified.");
                var r = "string" === (n = e.toLowerCase()) || "text" === n;
                "binarystring" !== n && "text" !== n || (n = "string"), t = this._decompressWorker();
                var o = !this._dataBinary;
                o && !r && (t = t.pipe(new a.Utf8EncodeWorker())), !o && r && (t = t.pipe(new a.Utf8DecodeWorker()));
              } catch (e) {
                (t = new u("error")).error(e);
              }

              return new i(t, n, "");
            },
            async: function async(e, t) {
              return this.internalStream(e).accumulate(t);
            },
            nodeStream: function nodeStream(e, t) {
              return this.internalStream(e || "nodebuffer").toNodejsStream(t);
            },
            _compressWorker: function _compressWorker(e, t) {
              if (this._data instanceof s && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();

              var n = this._decompressWorker();

              return this._dataBinary || (n = n.pipe(new a.Utf8EncodeWorker())), s.createWorkerFrom(n, e, t);
            },
            _decompressWorker: function _decompressWorker() {
              return this._data instanceof s ? this._data.getContentWorker() : this._data instanceof u ? this._data : new o(this._data);
            }
          };

          for (var c = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], l = function l() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          }, h = 0; h < c.length; h++) {
            r.prototype[c[h]] = l;
          }

          t.exports = r;
        }, {
          "./compressedObject": 2,
          "./stream/DataWorker": 27,
          "./stream/GenericWorker": 28,
          "./stream/StreamHelper": 29,
          "./utf8": 31
        }],
        36: [function (e, t, r) {
          (function (e) {
            "use strict";

            var n,
                r,
                i = e.MutationObserver || e.WebKitMutationObserver;

            if (i) {
              var o = 0,
                  a = new i(l),
                  s = e.document.createTextNode("");
              a.observe(s, {
                characterData: !0
              }), n = function n() {
                s.data = o = ++o % 2;
              };
            } else if (e.setImmediate || void 0 === e.MessageChannel) n = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function () {
              var t = e.document.createElement("script");
              t.onreadystatechange = function () {
                l(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null;
              }, e.document.documentElement.appendChild(t);
            } : function () {
              setTimeout(l, 0);
            };else {
              var u = new e.MessageChannel();
              u.port1.onmessage = l, n = function n() {
                u.port2.postMessage(0);
              };
            }

            var c = [];

            function l() {
              var e, t;
              r = !0;

              for (var n = c.length; n;) {
                for (t = c, c = [], e = -1; ++e < n;) {
                  t[e]();
                }

                n = c.length;
              }

              r = !1;
            }

            t.exports = function (e) {
              1 !== c.push(e) || r || n();
            };
          }).call(this, void 0 !== n ? n : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {}],
        37: [function (e, t, n) {
          "use strict";

          var r = e("immediate");

          function i() {}

          var o = {},
              a = ["REJECTED"],
              s = ["FULFILLED"],
              u = ["PENDING"];

          function c(e) {
            if ("function" != typeof e) throw new TypeError("resolver must be a function");
            this.state = u, this.queue = [], this.outcome = void 0, e !== i && f(this, e);
          }

          function l(e, t, n) {
            this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof n && (this.onRejected = n, this.callRejected = this.otherCallRejected);
          }

          function h(e, t, n) {
            r(function () {
              var r;

              try {
                r = t(n);
              } catch (r) {
                return o.reject(e, r);
              }

              r === e ? o.reject(e, new TypeError("Cannot resolve promise with itself")) : o.resolve(e, r);
            });
          }

          function d(e) {
            var t = e && e.then;
            if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function () {
              t.apply(e, arguments);
            };
          }

          function f(e, t) {
            var n = !1;

            function r(t) {
              n || (n = !0, o.reject(e, t));
            }

            function i(t) {
              n || (n = !0, o.resolve(e, t));
            }

            var a = p(function () {
              t(i, r);
            });
            "error" === a.status && r(a.value);
          }

          function p(e, t) {
            var n = {};

            try {
              n.value = e(t), n.status = "success";
            } catch (e) {
              n.status = "error", n.value = e;
            }

            return n;
          }

          (t.exports = c).prototype.finally = function (e) {
            if ("function" != typeof e) return this;
            var t = this.constructor;
            return this.then(function (n) {
              return t.resolve(e()).then(function () {
                return n;
              });
            }, function (n) {
              return t.resolve(e()).then(function () {
                throw n;
              });
            });
          }, c.prototype.catch = function (e) {
            return this.then(null, e);
          }, c.prototype.then = function (e, t) {
            if ("function" != typeof e && this.state === s || "function" != typeof t && this.state === a) return this;
            var n = new this.constructor(i);
            return this.state !== u ? h(n, this.state === s ? e : t, this.outcome) : this.queue.push(new l(n, e, t)), n;
          }, l.prototype.callFulfilled = function (e) {
            o.resolve(this.promise, e);
          }, l.prototype.otherCallFulfilled = function (e) {
            h(this.promise, this.onFulfilled, e);
          }, l.prototype.callRejected = function (e) {
            o.reject(this.promise, e);
          }, l.prototype.otherCallRejected = function (e) {
            h(this.promise, this.onRejected, e);
          }, o.resolve = function (e, t) {
            var n = p(d, t);
            if ("error" === n.status) return o.reject(e, n.value);
            var r = n.value;
            if (r) f(e, r);else {
              e.state = s, e.outcome = t;

              for (var i = -1, a = e.queue.length; ++i < a;) {
                e.queue[i].callFulfilled(t);
              }
            }
            return e;
          }, o.reject = function (e, t) {
            e.state = a, e.outcome = t;

            for (var n = -1, r = e.queue.length; ++n < r;) {
              e.queue[n].callRejected(t);
            }

            return e;
          }, c.resolve = function (e) {
            return e instanceof this ? e : o.resolve(new this(i), e);
          }, c.reject = function (e) {
            var t = new this(i);
            return o.reject(t, e);
          }, c.all = function (e) {
            var t = this;
            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
            var n = e.length,
                r = !1;
            if (!n) return this.resolve([]);

            for (var a = new Array(n), s = 0, u = -1, c = new this(i); ++u < n;) {
              l(e[u], u);
            }

            return c;

            function l(e, i) {
              t.resolve(e).then(function (e) {
                a[i] = e, ++s !== n || r || (r = !0, o.resolve(c, a));
              }, function (e) {
                r || (r = !0, o.reject(c, e));
              });
            }
          }, c.race = function (e) {
            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
            var t = e.length,
                n = !1;
            if (!t) return this.resolve([]);

            for (var r, a = -1, s = new this(i); ++a < t;) {
              r = e[a], this.resolve(r).then(function (e) {
                n || (n = !0, o.resolve(s, e));
              }, function (e) {
                n || (n = !0, o.reject(s, e));
              });
            }

            return s;
          };
        }, {
          immediate: 36
        }],
        38: [function (e, t, n) {
          "use strict";

          var r = {};
          (0, e("./lib/utils/common").assign)(r, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = r;
        }, {
          "./lib/deflate": 39,
          "./lib/inflate": 40,
          "./lib/utils/common": 41,
          "./lib/zlib/constants": 44
        }],
        39: [function (e, t, n) {
          "use strict";

          var r = e("./zlib/deflate"),
              i = e("./utils/common"),
              o = e("./utils/strings"),
              a = e("./zlib/messages"),
              s = e("./zlib/zstream"),
              u = Object.prototype.toString,
              c = 0,
              l = -1,
              h = 0,
              d = 8;

          function f(e) {
            if (!(this instanceof f)) return new f(e);
            this.options = i.assign({
              level: l,
              method: d,
              chunkSize: 16384,
              windowBits: 15,
              memLevel: 8,
              strategy: h,
              to: ""
            }, e || {});
            var t = this.options;
            t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
            var n = r.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
            if (n !== c) throw new Error(a[n]);

            if (t.header && r.deflateSetHeader(this.strm, t.header), t.dictionary) {
              var p;
              if (p = "string" == typeof t.dictionary ? o.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (n = r.deflateSetDictionary(this.strm, p)) !== c) throw new Error(a[n]);
              this._dict_set = !0;
            }
          }

          function p(e, t) {
            var n = new f(t);
            if (n.push(e, !0), n.err) throw n.msg || a[n.err];
            return n.result;
          }

          f.prototype.push = function (e, t) {
            var n,
                a,
                s = this.strm,
                l = this.options.chunkSize;
            if (this.ended) return !1;
            a = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? s.input = o.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? s.input = new Uint8Array(e) : s.input = e, s.next_in = 0, s.avail_in = s.input.length;

            do {
              if (0 === s.avail_out && (s.output = new i.Buf8(l), s.next_out = 0, s.avail_out = l), 1 !== (n = r.deflate(s, a)) && n !== c) return this.onEnd(n), !(this.ended = !0);
              0 !== s.avail_out && (0 !== s.avail_in || 4 !== a && 2 !== a) || ("string" === this.options.to ? this.onData(o.buf2binstring(i.shrinkBuf(s.output, s.next_out))) : this.onData(i.shrinkBuf(s.output, s.next_out)));
            } while ((0 < s.avail_in || 0 === s.avail_out) && 1 !== n);

            return 4 === a ? (n = r.deflateEnd(this.strm), this.onEnd(n), this.ended = !0, n === c) : 2 !== a || (this.onEnd(c), !(s.avail_out = 0));
          }, f.prototype.onData = function (e) {
            this.chunks.push(e);
          }, f.prototype.onEnd = function (e) {
            e === c && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
          }, n.Deflate = f, n.deflate = p, n.deflateRaw = function (e, t) {
            return (t = t || {}).raw = !0, p(e, t);
          }, n.gzip = function (e, t) {
            return (t = t || {}).gzip = !0, p(e, t);
          };
        }, {
          "./utils/common": 41,
          "./utils/strings": 42,
          "./zlib/deflate": 46,
          "./zlib/messages": 51,
          "./zlib/zstream": 53
        }],
        40: [function (e, t, n) {
          "use strict";

          var r = e("./zlib/inflate"),
              i = e("./utils/common"),
              o = e("./utils/strings"),
              a = e("./zlib/constants"),
              s = e("./zlib/messages"),
              u = e("./zlib/zstream"),
              c = e("./zlib/gzheader"),
              l = Object.prototype.toString;

          function h(e) {
            if (!(this instanceof h)) return new h(e);
            this.options = i.assign({
              chunkSize: 16384,
              windowBits: 0,
              to: ""
            }, e || {});
            var t = this.options;
            t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new u(), this.strm.avail_out = 0;
            var n = r.inflateInit2(this.strm, t.windowBits);
            if (n !== a.Z_OK) throw new Error(s[n]);
            this.header = new c(), r.inflateGetHeader(this.strm, this.header);
          }

          function d(e, t) {
            var n = new h(t);
            if (n.push(e, !0), n.err) throw n.msg || s[n.err];
            return n.result;
          }

          h.prototype.push = function (e, t) {
            var n,
                s,
                u,
                c,
                h,
                d,
                f = this.strm,
                p = this.options.chunkSize,
                m = this.options.dictionary,
                _ = !1;

            if (this.ended) return !1;
            s = t === ~~t ? t : !0 === t ? a.Z_FINISH : a.Z_NO_FLUSH, "string" == typeof e ? f.input = o.binstring2buf(e) : "[object ArrayBuffer]" === l.call(e) ? f.input = new Uint8Array(e) : f.input = e, f.next_in = 0, f.avail_in = f.input.length;

            do {
              if (0 === f.avail_out && (f.output = new i.Buf8(p), f.next_out = 0, f.avail_out = p), (n = r.inflate(f, a.Z_NO_FLUSH)) === a.Z_NEED_DICT && m && (d = "string" == typeof m ? o.string2buf(m) : "[object ArrayBuffer]" === l.call(m) ? new Uint8Array(m) : m, n = r.inflateSetDictionary(this.strm, d)), n === a.Z_BUF_ERROR && !0 === _ && (n = a.Z_OK, _ = !1), n !== a.Z_STREAM_END && n !== a.Z_OK) return this.onEnd(n), !(this.ended = !0);
              f.next_out && (0 !== f.avail_out && n !== a.Z_STREAM_END && (0 !== f.avail_in || s !== a.Z_FINISH && s !== a.Z_SYNC_FLUSH) || ("string" === this.options.to ? (u = o.utf8border(f.output, f.next_out), c = f.next_out - u, h = o.buf2string(f.output, u), f.next_out = c, f.avail_out = p - c, c && i.arraySet(f.output, f.output, u, c, 0), this.onData(h)) : this.onData(i.shrinkBuf(f.output, f.next_out)))), 0 === f.avail_in && 0 === f.avail_out && (_ = !0);
            } while ((0 < f.avail_in || 0 === f.avail_out) && n !== a.Z_STREAM_END);

            return n === a.Z_STREAM_END && (s = a.Z_FINISH), s === a.Z_FINISH ? (n = r.inflateEnd(this.strm), this.onEnd(n), this.ended = !0, n === a.Z_OK) : s !== a.Z_SYNC_FLUSH || (this.onEnd(a.Z_OK), !(f.avail_out = 0));
          }, h.prototype.onData = function (e) {
            this.chunks.push(e);
          }, h.prototype.onEnd = function (e) {
            e === a.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
          }, n.Inflate = h, n.inflate = d, n.inflateRaw = function (e, t) {
            return (t = t || {}).raw = !0, d(e, t);
          }, n.ungzip = d;
        }, {
          "./utils/common": 41,
          "./utils/strings": 42,
          "./zlib/constants": 44,
          "./zlib/gzheader": 47,
          "./zlib/inflate": 49,
          "./zlib/messages": 51,
          "./zlib/zstream": 53
        }],
        41: [function (e, t, n) {
          "use strict";

          var r = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
          n.assign = function (e) {
            for (var t = Array.prototype.slice.call(arguments, 1); t.length;) {
              var n = t.shift();

              if (n) {
                if ("object" != typeof n) throw new TypeError(n + "must be non-object");

                for (var r in n) {
                  n.hasOwnProperty(r) && (e[r] = n[r]);
                }
              }
            }

            return e;
          }, n.shrinkBuf = function (e, t) {
            return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
          };
          var i = {
            arraySet: function arraySet(e, t, n, r, i) {
              if (t.subarray && e.subarray) e.set(t.subarray(n, n + r), i);else for (var o = 0; o < r; o++) {
                e[i + o] = t[n + o];
              }
            },
            flattenChunks: function flattenChunks(e) {
              var t, n, r, i, o, a;

              for (t = r = 0, n = e.length; t < n; t++) {
                r += e[t].length;
              }

              for (a = new Uint8Array(r), t = i = 0, n = e.length; t < n; t++) {
                o = e[t], a.set(o, i), i += o.length;
              }

              return a;
            }
          },
              o = {
            arraySet: function arraySet(e, t, n, r, i) {
              for (var o = 0; o < r; o++) {
                e[i + o] = t[n + o];
              }
            },
            flattenChunks: function flattenChunks(e) {
              return [].concat.apply([], e);
            }
          };
          n.setTyped = function (e) {
            e ? (n.Buf8 = Uint8Array, n.Buf16 = Uint16Array, n.Buf32 = Int32Array, n.assign(n, i)) : (n.Buf8 = Array, n.Buf16 = Array, n.Buf32 = Array, n.assign(n, o));
          }, n.setTyped(r);
        }, {}],
        42: [function (e, t, n) {
          "use strict";

          var r = e("./common"),
              i = !0,
              o = !0;

          try {
            String.fromCharCode.apply(null, [0]);
          } catch (e) {
            i = !1;
          }

          try {
            String.fromCharCode.apply(null, new Uint8Array(1));
          } catch (e) {
            o = !1;
          }

          for (var a = new r.Buf8(256), s = 0; s < 256; s++) {
            a[s] = 252 <= s ? 6 : 248 <= s ? 5 : 240 <= s ? 4 : 224 <= s ? 3 : 192 <= s ? 2 : 1;
          }

          function u(e, t) {
            if (t < 65537 && (e.subarray && o || !e.subarray && i)) return String.fromCharCode.apply(null, r.shrinkBuf(e, t));

            for (var n = "", a = 0; a < t; a++) {
              n += String.fromCharCode(e[a]);
            }

            return n;
          }

          a[254] = a[254] = 1, n.string2buf = function (e) {
            var t,
                n,
                i,
                o,
                a,
                s = e.length,
                u = 0;

            for (o = 0; o < s; o++) {
              55296 == (64512 & (n = e.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (i = e.charCodeAt(o + 1))) && (n = 65536 + (n - 55296 << 10) + (i - 56320), o++), u += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
            }

            for (t = new r.Buf8(u), o = a = 0; a < u; o++) {
              55296 == (64512 & (n = e.charCodeAt(o))) && o + 1 < s && 56320 == (64512 & (i = e.charCodeAt(o + 1))) && (n = 65536 + (n - 55296 << 10) + (i - 56320), o++), n < 128 ? t[a++] = n : (n < 2048 ? t[a++] = 192 | n >>> 6 : (n < 65536 ? t[a++] = 224 | n >>> 12 : (t[a++] = 240 | n >>> 18, t[a++] = 128 | n >>> 12 & 63), t[a++] = 128 | n >>> 6 & 63), t[a++] = 128 | 63 & n);
            }

            return t;
          }, n.buf2binstring = function (e) {
            return u(e, e.length);
          }, n.binstring2buf = function (e) {
            for (var t = new r.Buf8(e.length), n = 0, i = t.length; n < i; n++) {
              t[n] = e.charCodeAt(n);
            }

            return t;
          }, n.buf2string = function (e, t) {
            var n,
                r,
                i,
                o,
                s = t || e.length,
                c = new Array(2 * s);

            for (n = r = 0; n < s;) {
              if ((i = e[n++]) < 128) c[r++] = i;else if (4 < (o = a[i])) c[r++] = 65533, n += o - 1;else {
                for (i &= 2 === o ? 31 : 3 === o ? 15 : 7; 1 < o && n < s;) {
                  i = i << 6 | 63 & e[n++], o--;
                }

                1 < o ? c[r++] = 65533 : i < 65536 ? c[r++] = i : (i -= 65536, c[r++] = 55296 | i >> 10 & 1023, c[r++] = 56320 | 1023 & i);
              }
            }

            return u(c, r);
          }, n.utf8border = function (e, t) {
            var n;

            for ((t = t || e.length) > e.length && (t = e.length), n = t - 1; 0 <= n && 128 == (192 & e[n]);) {
              n--;
            }

            return n < 0 ? t : 0 === n ? t : n + a[e[n]] > t ? n : t;
          };
        }, {
          "./common": 41
        }],
        43: [function (e, t, n) {
          "use strict";

          t.exports = function (e, t, n, r) {
            for (var i = 65535 & e | 0, o = e >>> 16 & 65535 | 0, a = 0; 0 !== n;) {
              for (n -= a = 2e3 < n ? 2e3 : n; o = o + (i = i + t[r++] | 0) | 0, --a;) {
                ;
              }

              i %= 65521, o %= 65521;
            }

            return i | o << 16 | 0;
          };
        }, {}],
        44: [function (e, t, n) {
          "use strict";

          t.exports = {
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_BUF_ERROR: -5,
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            Z_BINARY: 0,
            Z_TEXT: 1,
            Z_UNKNOWN: 2,
            Z_DEFLATED: 8
          };
        }, {}],
        45: [function (e, t, n) {
          "use strict";

          var r = function () {
            for (var e, t = [], n = 0; n < 256; n++) {
              e = n;

              for (var r = 0; r < 8; r++) {
                e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
              }

              t[n] = e;
            }

            return t;
          }();

          t.exports = function (e, t, n, i) {
            var o = r,
                a = i + n;
            e ^= -1;

            for (var s = i; s < a; s++) {
              e = e >>> 8 ^ o[255 & (e ^ t[s])];
            }

            return -1 ^ e;
          };
        }, {}],
        46: [function (e, t, n) {
          "use strict";

          var r,
              i = e("../utils/common"),
              o = e("./trees"),
              a = e("./adler32"),
              s = e("./crc32"),
              u = e("./messages"),
              c = 0,
              l = 4,
              h = 0,
              d = -2,
              f = -1,
              p = 4,
              m = 2,
              _ = 8,
              y = 9,
              v = 286,
              g = 30,
              b = 19,
              w = 2 * v + 1,
              T = 15,
              M = 3,
              E = 258,
              k = E + M + 1,
              L = 42,
              S = 113,
              N = 1,
              D = 2,
              I = 3,
              R = 4;

          function x(e, t) {
            return e.msg = u[t], t;
          }

          function Y(e) {
            return (e << 1) - (4 < e ? 9 : 0);
          }

          function C(e) {
            for (var t = e.length; 0 <= --t;) {
              e[t] = 0;
            }
          }

          function O(e) {
            var t = e.state,
                n = t.pending;
            n > e.avail_out && (n = e.avail_out), 0 !== n && (i.arraySet(e.output, t.pending_buf, t.pending_out, n, e.next_out), e.next_out += n, t.pending_out += n, e.total_out += n, e.avail_out -= n, t.pending -= n, 0 === t.pending && (t.pending_out = 0));
          }

          function F(e, t) {
            o._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, O(e.strm);
          }

          function A(e, t) {
            e.pending_buf[e.pending++] = t;
          }

          function j(e, t) {
            e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
          }

          function U(e, t) {
            var n,
                r,
                i = e.max_chain_length,
                o = e.strstart,
                a = e.prev_length,
                s = e.nice_match,
                u = e.strstart > e.w_size - k ? e.strstart - (e.w_size - k) : 0,
                c = e.window,
                l = e.w_mask,
                h = e.prev,
                d = e.strstart + E,
                f = c[o + a - 1],
                p = c[o + a];
            e.prev_length >= e.good_match && (i >>= 2), s > e.lookahead && (s = e.lookahead);

            do {
              if (c[(n = t) + a] === p && c[n + a - 1] === f && c[n] === c[o] && c[++n] === c[o + 1]) {
                o += 2, n++;

                do {} while (c[++o] === c[++n] && c[++o] === c[++n] && c[++o] === c[++n] && c[++o] === c[++n] && c[++o] === c[++n] && c[++o] === c[++n] && c[++o] === c[++n] && c[++o] === c[++n] && o < d);

                if (r = E - (d - o), o = d - E, a < r) {
                  if (e.match_start = t, s <= (a = r)) break;
                  f = c[o + a - 1], p = c[o + a];
                }
              }
            } while ((t = h[t & l]) > u && 0 != --i);

            return a <= e.lookahead ? a : e.lookahead;
          }

          function P(e) {
            var t,
                n,
                r,
                o,
                u,
                c,
                l,
                h,
                d,
                f,
                p = e.w_size;

            do {
              if (o = e.window_size - e.lookahead - e.strstart, e.strstart >= p + (p - k)) {
                for (i.arraySet(e.window, e.window, p, p, 0), e.match_start -= p, e.strstart -= p, e.block_start -= p, t = n = e.hash_size; r = e.head[--t], e.head[t] = p <= r ? r - p : 0, --n;) {
                  ;
                }

                for (t = n = p; r = e.prev[--t], e.prev[t] = p <= r ? r - p : 0, --n;) {
                  ;
                }

                o += p;
              }

              if (0 === e.strm.avail_in) break;
              if (c = e.strm, l = e.window, h = e.strstart + e.lookahead, d = o, f = void 0, f = c.avail_in, d < f && (f = d), n = 0 === f ? 0 : (c.avail_in -= f, i.arraySet(l, c.input, c.next_in, f, h), 1 === c.state.wrap ? c.adler = a(c.adler, l, f, h) : 2 === c.state.wrap && (c.adler = s(c.adler, l, f, h)), c.next_in += f, c.total_in += f, f), e.lookahead += n, e.lookahead + e.insert >= M) for (u = e.strstart - e.insert, e.ins_h = e.window[u], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[u + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[u + M - 1]) & e.hash_mask, e.prev[u & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = u, u++, e.insert--, !(e.lookahead + e.insert < M));) {
                ;
              }
            } while (e.lookahead < k && 0 !== e.strm.avail_in);
          }

          function V(e, t) {
            for (var n, r;;) {
              if (e.lookahead < k) {
                if (P(e), e.lookahead < k && t === c) return N;
                if (0 === e.lookahead) break;
              }

              if (n = 0, e.lookahead >= M && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + M - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== n && e.strstart - n <= e.w_size - k && (e.match_length = U(e, n)), e.match_length >= M) {
                if (r = o._tr_tally(e, e.strstart - e.match_start, e.match_length - M), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= M) {
                  for (e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + M - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;) {
                    ;
                  }

                  e.strstart++;
                } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
              } else r = o._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
              if (r && (F(e, !1), 0 === e.strm.avail_out)) return N;
            }

            return e.insert = e.strstart < M - 1 ? e.strstart : M - 1, t === l ? (F(e, !0), 0 === e.strm.avail_out ? I : R) : e.last_lit && (F(e, !1), 0 === e.strm.avail_out) ? N : D;
          }

          function W(e, t) {
            for (var n, r, i;;) {
              if (e.lookahead < k) {
                if (P(e), e.lookahead < k && t === c) return N;
                if (0 === e.lookahead) break;
              }

              if (n = 0, e.lookahead >= M && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + M - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = M - 1, 0 !== n && e.prev_length < e.max_lazy_match && e.strstart - n <= e.w_size - k && (e.match_length = U(e, n), e.match_length <= 5 && (1 === e.strategy || e.match_length === M && 4096 < e.strstart - e.match_start) && (e.match_length = M - 1)), e.prev_length >= M && e.match_length <= e.prev_length) {
                for (i = e.strstart + e.lookahead - M, r = o._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - M), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + M - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;) {
                  ;
                }

                if (e.match_available = 0, e.match_length = M - 1, e.strstart++, r && (F(e, !1), 0 === e.strm.avail_out)) return N;
              } else if (e.match_available) {
                if ((r = o._tr_tally(e, 0, e.window[e.strstart - 1])) && F(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return N;
              } else e.match_available = 1, e.strstart++, e.lookahead--;
            }

            return e.match_available && (r = o._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < M - 1 ? e.strstart : M - 1, t === l ? (F(e, !0), 0 === e.strm.avail_out ? I : R) : e.last_lit && (F(e, !1), 0 === e.strm.avail_out) ? N : D;
          }

          function H(e, t, n, r, i) {
            this.good_length = e, this.max_lazy = t, this.nice_length = n, this.max_chain = r, this.func = i;
          }

          function B() {
            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = _, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(2 * w), this.dyn_dtree = new i.Buf16(2 * (2 * g + 1)), this.bl_tree = new i.Buf16(2 * (2 * b + 1)), C(this.dyn_ltree), C(this.dyn_dtree), C(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(T + 1), this.heap = new i.Buf16(2 * v + 1), C(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(2 * v + 1), C(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
          }

          function z(e) {
            var t;
            return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = m, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? L : S, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = c, o._tr_init(t), h) : x(e, d);
          }

          function Z(e) {
            var t = z(e);
            return t === h && function (e) {
              e.window_size = 2 * e.w_size, C(e.head), e.max_lazy_match = r[e.level].max_lazy, e.good_match = r[e.level].good_length, e.nice_match = r[e.level].nice_length, e.max_chain_length = r[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = M - 1, e.match_available = 0, e.ins_h = 0;
            }(e.state), t;
          }

          function Q(e, t, n, r, o, a) {
            if (!e) return d;
            var s = 1;
            if (t === f && (t = 6), r < 0 ? (s = 0, r = -r) : 15 < r && (s = 2, r -= 16), o < 1 || y < o || n !== _ || r < 8 || 15 < r || t < 0 || 9 < t || a < 0 || p < a) return x(e, d);
            8 === r && (r = 9);
            var u = new B();
            return (e.state = u).strm = e, u.wrap = s, u.gzhead = null, u.w_bits = r, u.w_size = 1 << u.w_bits, u.w_mask = u.w_size - 1, u.hash_bits = o + 7, u.hash_size = 1 << u.hash_bits, u.hash_mask = u.hash_size - 1, u.hash_shift = ~~((u.hash_bits + M - 1) / M), u.window = new i.Buf8(2 * u.w_size), u.head = new i.Buf16(u.hash_size), u.prev = new i.Buf16(u.w_size), u.lit_bufsize = 1 << o + 6, u.pending_buf_size = 4 * u.lit_bufsize, u.pending_buf = new i.Buf8(u.pending_buf_size), u.d_buf = 1 * u.lit_bufsize, u.l_buf = 3 * u.lit_bufsize, u.level = t, u.strategy = a, u.method = n, Z(e);
          }

          r = [new H(0, 0, 0, 0, function (e, t) {
            var n = 65535;

            for (n > e.pending_buf_size - 5 && (n = e.pending_buf_size - 5);;) {
              if (e.lookahead <= 1) {
                if (P(e), 0 === e.lookahead && t === c) return N;
                if (0 === e.lookahead) break;
              }

              e.strstart += e.lookahead, e.lookahead = 0;
              var r = e.block_start + n;
              if ((0 === e.strstart || e.strstart >= r) && (e.lookahead = e.strstart - r, e.strstart = r, F(e, !1), 0 === e.strm.avail_out)) return N;
              if (e.strstart - e.block_start >= e.w_size - k && (F(e, !1), 0 === e.strm.avail_out)) return N;
            }

            return e.insert = 0, t === l ? (F(e, !0), 0 === e.strm.avail_out ? I : R) : (e.strstart > e.block_start && (F(e, !1), e.strm.avail_out), N);
          }), new H(4, 4, 8, 4, V), new H(4, 5, 16, 8, V), new H(4, 6, 32, 32, V), new H(4, 4, 16, 16, W), new H(8, 16, 32, 32, W), new H(8, 16, 128, 128, W), new H(8, 32, 128, 256, W), new H(32, 128, 258, 1024, W), new H(32, 258, 258, 4096, W)], n.deflateInit = function (e, t) {
            return Q(e, t, _, 15, 8, 0);
          }, n.deflateInit2 = Q, n.deflateReset = Z, n.deflateResetKeep = z, n.deflateSetHeader = function (e, t) {
            return e && e.state ? 2 !== e.state.wrap ? d : (e.state.gzhead = t, h) : d;
          }, n.deflate = function (e, t) {
            var n, i, a, u;
            if (!e || !e.state || 5 < t || t < 0) return e ? x(e, d) : d;
            if (i = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === i.status && t !== l) return x(e, 0 === e.avail_out ? -5 : d);
            if (i.strm = e, n = i.last_flush, i.last_flush = t, i.status === L) if (2 === i.wrap) e.adler = 0, A(i, 31), A(i, 139), A(i, 8), i.gzhead ? (A(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), A(i, 255 & i.gzhead.time), A(i, i.gzhead.time >> 8 & 255), A(i, i.gzhead.time >> 16 & 255), A(i, i.gzhead.time >> 24 & 255), A(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), A(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (A(i, 255 & i.gzhead.extra.length), A(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = s(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69) : (A(i, 0), A(i, 0), A(i, 0), A(i, 0), A(i, 0), A(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), A(i, 3), i.status = S);else {
              var f = _ + (i.w_bits - 8 << 4) << 8;
              f |= (2 <= i.strategy || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (f |= 32), f += 31 - f % 31, i.status = S, j(i, f), 0 !== i.strstart && (j(i, e.adler >>> 16), j(i, 65535 & e.adler)), e.adler = 1;
            }
            if (69 === i.status) if (i.gzhead.extra) {
              for (a = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), O(e), a = i.pending, i.pending !== i.pending_buf_size));) {
                A(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
              }

              i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = 73);
            } else i.status = 73;
            if (73 === i.status) if (i.gzhead.name) {
              a = i.pending;

              do {
                if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), O(e), a = i.pending, i.pending === i.pending_buf_size)) {
                  u = 1;
                  break;
                }

                u = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, A(i, u);
              } while (0 !== u);

              i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), 0 === u && (i.gzindex = 0, i.status = 91);
            } else i.status = 91;
            if (91 === i.status) if (i.gzhead.comment) {
              a = i.pending;

              do {
                if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), O(e), a = i.pending, i.pending === i.pending_buf_size)) {
                  u = 1;
                  break;
                }

                u = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, A(i, u);
              } while (0 !== u);

              i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), 0 === u && (i.status = 103);
            } else i.status = 103;

            if (103 === i.status && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && O(e), i.pending + 2 <= i.pending_buf_size && (A(i, 255 & e.adler), A(i, e.adler >> 8 & 255), e.adler = 0, i.status = S)) : i.status = S), 0 !== i.pending) {
              if (O(e), 0 === e.avail_out) return i.last_flush = -1, h;
            } else if (0 === e.avail_in && Y(t) <= Y(n) && t !== l) return x(e, -5);

            if (666 === i.status && 0 !== e.avail_in) return x(e, -5);

            if (0 !== e.avail_in || 0 !== i.lookahead || t !== c && 666 !== i.status) {
              var p = 2 === i.strategy ? function (e, t) {
                for (var n;;) {
                  if (0 === e.lookahead && (P(e), 0 === e.lookahead)) {
                    if (t === c) return N;
                    break;
                  }

                  if (e.match_length = 0, n = o._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, n && (F(e, !1), 0 === e.strm.avail_out)) return N;
                }

                return e.insert = 0, t === l ? (F(e, !0), 0 === e.strm.avail_out ? I : R) : e.last_lit && (F(e, !1), 0 === e.strm.avail_out) ? N : D;
              }(i, t) : 3 === i.strategy ? function (e, t) {
                for (var n, r, i, a, s = e.window;;) {
                  if (e.lookahead <= E) {
                    if (P(e), e.lookahead <= E && t === c) return N;
                    if (0 === e.lookahead) break;
                  }

                  if (e.match_length = 0, e.lookahead >= M && 0 < e.strstart && (r = s[i = e.strstart - 1]) === s[++i] && r === s[++i] && r === s[++i]) {
                    a = e.strstart + E;

                    do {} while (r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && i < a);

                    e.match_length = E - (a - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                  }

                  if (e.match_length >= M ? (n = o._tr_tally(e, 1, e.match_length - M), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (n = o._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), n && (F(e, !1), 0 === e.strm.avail_out)) return N;
                }

                return e.insert = 0, t === l ? (F(e, !0), 0 === e.strm.avail_out ? I : R) : e.last_lit && (F(e, !1), 0 === e.strm.avail_out) ? N : D;
              }(i, t) : r[i.level].func(i, t);
              if (p !== I && p !== R || (i.status = 666), p === N || p === I) return 0 === e.avail_out && (i.last_flush = -1), h;
              if (p === D && (1 === t ? o._tr_align(i) : 5 !== t && (o._tr_stored_block(i, 0, 0, !1), 3 === t && (C(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), O(e), 0 === e.avail_out)) return i.last_flush = -1, h;
            }

            return t !== l ? h : i.wrap <= 0 ? 1 : (2 === i.wrap ? (A(i, 255 & e.adler), A(i, e.adler >> 8 & 255), A(i, e.adler >> 16 & 255), A(i, e.adler >> 24 & 255), A(i, 255 & e.total_in), A(i, e.total_in >> 8 & 255), A(i, e.total_in >> 16 & 255), A(i, e.total_in >> 24 & 255)) : (j(i, e.adler >>> 16), j(i, 65535 & e.adler)), O(e), 0 < i.wrap && (i.wrap = -i.wrap), 0 !== i.pending ? h : 1);
          }, n.deflateEnd = function (e) {
            var t;
            return e && e.state ? (t = e.state.status) !== L && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== S && 666 !== t ? x(e, d) : (e.state = null, t === S ? x(e, -3) : h) : d;
          }, n.deflateSetDictionary = function (e, t) {
            var n,
                r,
                o,
                s,
                u,
                c,
                l,
                f,
                p = t.length;
            if (!e || !e.state) return d;
            if (2 === (s = (n = e.state).wrap) || 1 === s && n.status !== L || n.lookahead) return d;

            for (1 === s && (e.adler = a(e.adler, t, p, 0)), n.wrap = 0, p >= n.w_size && (0 === s && (C(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0), f = new i.Buf8(n.w_size), i.arraySet(f, t, p - n.w_size, n.w_size, 0), t = f, p = n.w_size), u = e.avail_in, c = e.next_in, l = e.input, e.avail_in = p, e.next_in = 0, e.input = t, P(n); n.lookahead >= M;) {
              for (r = n.strstart, o = n.lookahead - (M - 1); n.ins_h = (n.ins_h << n.hash_shift ^ n.window[r + M - 1]) & n.hash_mask, n.prev[r & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = r, r++, --o;) {
                ;
              }

              n.strstart = r, n.lookahead = M - 1, P(n);
            }

            return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = M - 1, n.match_available = 0, e.next_in = c, e.input = l, e.avail_in = u, n.wrap = s, h;
          }, n.deflateInfo = "pako deflate (from Nodeca project)";
        }, {
          "../utils/common": 41,
          "./adler32": 43,
          "./crc32": 45,
          "./messages": 51,
          "./trees": 52
        }],
        47: [function (e, t, n) {
          "use strict";

          t.exports = function () {
            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
          };
        }, {}],
        48: [function (e, t, n) {
          "use strict";

          t.exports = function (e, t) {
            var n, r, i, o, a, s, u, c, l, h, d, f, p, m, _, y, v, g, b, w, T, M, E, k, L;

            n = e.state, r = e.next_in, k = e.input, i = r + (e.avail_in - 5), o = e.next_out, L = e.output, a = o - (t - e.avail_out), s = o + (e.avail_out - 257), u = n.dmax, c = n.wsize, l = n.whave, h = n.wnext, d = n.window, f = n.hold, p = n.bits, m = n.lencode, _ = n.distcode, y = (1 << n.lenbits) - 1, v = (1 << n.distbits) - 1;

            e: do {
              p < 15 && (f += k[r++] << p, p += 8, f += k[r++] << p, p += 8), g = m[f & y];

              t: for (;;) {
                if (f >>>= b = g >>> 24, p -= b, 0 == (b = g >>> 16 & 255)) L[o++] = 65535 & g;else {
                  if (!(16 & b)) {
                    if (0 == (64 & b)) {
                      g = m[(65535 & g) + (f & (1 << b) - 1)];
                      continue t;
                    }

                    if (32 & b) {
                      n.mode = 12;
                      break e;
                    }

                    e.msg = "invalid literal/length code", n.mode = 30;
                    break e;
                  }

                  w = 65535 & g, (b &= 15) && (p < b && (f += k[r++] << p, p += 8), w += f & (1 << b) - 1, f >>>= b, p -= b), p < 15 && (f += k[r++] << p, p += 8, f += k[r++] << p, p += 8), g = _[f & v];

                  n: for (;;) {
                    if (f >>>= b = g >>> 24, p -= b, !(16 & (b = g >>> 16 & 255))) {
                      if (0 == (64 & b)) {
                        g = _[(65535 & g) + (f & (1 << b) - 1)];
                        continue n;
                      }

                      e.msg = "invalid distance code", n.mode = 30;
                      break e;
                    }

                    if (T = 65535 & g, p < (b &= 15) && (f += k[r++] << p, (p += 8) < b && (f += k[r++] << p, p += 8)), u < (T += f & (1 << b) - 1)) {
                      e.msg = "invalid distance too far back", n.mode = 30;
                      break e;
                    }

                    if (f >>>= b, p -= b, (b = o - a) < T) {
                      if (l < (b = T - b) && n.sane) {
                        e.msg = "invalid distance too far back", n.mode = 30;
                        break e;
                      }

                      if (E = d, (M = 0) === h) {
                        if (M += c - b, b < w) {
                          for (w -= b; L[o++] = d[M++], --b;) {
                            ;
                          }

                          M = o - T, E = L;
                        }
                      } else if (h < b) {
                        if (M += c + h - b, (b -= h) < w) {
                          for (w -= b; L[o++] = d[M++], --b;) {
                            ;
                          }

                          if (M = 0, h < w) {
                            for (w -= b = h; L[o++] = d[M++], --b;) {
                              ;
                            }

                            M = o - T, E = L;
                          }
                        }
                      } else if (M += h - b, b < w) {
                        for (w -= b; L[o++] = d[M++], --b;) {
                          ;
                        }

                        M = o - T, E = L;
                      }

                      for (; 2 < w;) {
                        L[o++] = E[M++], L[o++] = E[M++], L[o++] = E[M++], w -= 3;
                      }

                      w && (L[o++] = E[M++], 1 < w && (L[o++] = E[M++]));
                    } else {
                      for (M = o - T; L[o++] = L[M++], L[o++] = L[M++], L[o++] = L[M++], 2 < (w -= 3);) {
                        ;
                      }

                      w && (L[o++] = L[M++], 1 < w && (L[o++] = L[M++]));
                    }

                    break;
                  }
                }
                break;
              }
            } while (r < i && o < s);

            r -= w = p >> 3, f &= (1 << (p -= w << 3)) - 1, e.next_in = r, e.next_out = o, e.avail_in = r < i ? i - r + 5 : 5 - (r - i), e.avail_out = o < s ? s - o + 257 : 257 - (o - s), n.hold = f, n.bits = p;
          };
        }, {}],
        49: [function (e, t, n) {
          "use strict";

          var r = e("../utils/common"),
              i = e("./adler32"),
              o = e("./crc32"),
              a = e("./inffast"),
              s = e("./inftrees"),
              u = 1,
              c = 2,
              l = 0,
              h = -2,
              d = 1,
              f = 852,
              p = 592;

          function m(e) {
            return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
          }

          function _() {
            this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new r.Buf16(320), this.work = new r.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
          }

          function y(e) {
            var t;
            return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = d, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new r.Buf32(f), t.distcode = t.distdyn = new r.Buf32(p), t.sane = 1, t.back = -1, l) : h;
          }

          function v(e) {
            var t;
            return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, y(e)) : h;
          }

          function g(e, t) {
            var n, r;
            return e && e.state ? (r = e.state, t < 0 ? (n = 0, t = -t) : (n = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? h : (null !== r.window && r.wbits !== t && (r.window = null), r.wrap = n, r.wbits = t, v(e))) : h;
          }

          function b(e, t) {
            var n, r;
            return e ? (r = new _(), (e.state = r).window = null, (n = g(e, t)) !== l && (e.state = null), n) : h;
          }

          var w,
              T,
              M = !0;

          function E(e) {
            if (M) {
              var t;

              for (w = new r.Buf32(512), T = new r.Buf32(32), t = 0; t < 144;) {
                e.lens[t++] = 8;
              }

              for (; t < 256;) {
                e.lens[t++] = 9;
              }

              for (; t < 280;) {
                e.lens[t++] = 7;
              }

              for (; t < 288;) {
                e.lens[t++] = 8;
              }

              for (s(u, e.lens, 0, 288, w, 0, e.work, {
                bits: 9
              }), t = 0; t < 32;) {
                e.lens[t++] = 5;
              }

              s(c, e.lens, 0, 32, T, 0, e.work, {
                bits: 5
              }), M = !1;
            }

            e.lencode = w, e.lenbits = 9, e.distcode = T, e.distbits = 5;
          }

          function k(e, t, n, i) {
            var o,
                a = e.state;
            return null === a.window && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new r.Buf8(a.wsize)), i >= a.wsize ? (r.arraySet(a.window, t, n - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : (i < (o = a.wsize - a.wnext) && (o = i), r.arraySet(a.window, t, n - i, o, a.wnext), (i -= o) ? (r.arraySet(a.window, t, n - i, i, 0), a.wnext = i, a.whave = a.wsize) : (a.wnext += o, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += o))), 0;
          }

          n.inflateReset = v, n.inflateReset2 = g, n.inflateResetKeep = y, n.inflateInit = function (e) {
            return b(e, 15);
          }, n.inflateInit2 = b, n.inflate = function (e, t) {
            var n,
                f,
                p,
                _,
                y,
                v,
                g,
                b,
                w,
                T,
                M,
                L,
                S,
                N,
                D,
                I,
                R,
                x,
                Y,
                C,
                O,
                F,
                A,
                j,
                U = 0,
                P = new r.Buf8(4),
                V = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

            if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return h;
            12 === (n = e.state).mode && (n.mode = 13), y = e.next_out, p = e.output, g = e.avail_out, _ = e.next_in, f = e.input, v = e.avail_in, b = n.hold, w = n.bits, T = v, M = g, F = l;

            e: for (;;) {
              switch (n.mode) {
                case d:
                  if (0 === n.wrap) {
                    n.mode = 13;
                    break;
                  }

                  for (; w < 16;) {
                    if (0 === v) break e;
                    v--, b += f[_++] << w, w += 8;
                  }

                  if (2 & n.wrap && 35615 === b) {
                    P[n.check = 0] = 255 & b, P[1] = b >>> 8 & 255, n.check = o(n.check, P, 2, 0), w = b = 0, n.mode = 2;
                    break;
                  }

                  if (n.flags = 0, n.head && (n.head.done = !1), !(1 & n.wrap) || (((255 & b) << 8) + (b >> 8)) % 31) {
                    e.msg = "incorrect header check", n.mode = 30;
                    break;
                  }

                  if (8 != (15 & b)) {
                    e.msg = "unknown compression method", n.mode = 30;
                    break;
                  }

                  if (w -= 4, O = 8 + (15 & (b >>>= 4)), 0 === n.wbits) n.wbits = O;else if (O > n.wbits) {
                    e.msg = "invalid window size", n.mode = 30;
                    break;
                  }
                  n.dmax = 1 << O, e.adler = n.check = 1, n.mode = 512 & b ? 10 : 12, w = b = 0;
                  break;

                case 2:
                  for (; w < 16;) {
                    if (0 === v) break e;
                    v--, b += f[_++] << w, w += 8;
                  }

                  if (n.flags = b, 8 != (255 & n.flags)) {
                    e.msg = "unknown compression method", n.mode = 30;
                    break;
                  }

                  if (57344 & n.flags) {
                    e.msg = "unknown header flags set", n.mode = 30;
                    break;
                  }

                  n.head && (n.head.text = b >> 8 & 1), 512 & n.flags && (P[0] = 255 & b, P[1] = b >>> 8 & 255, n.check = o(n.check, P, 2, 0)), w = b = 0, n.mode = 3;

                case 3:
                  for (; w < 32;) {
                    if (0 === v) break e;
                    v--, b += f[_++] << w, w += 8;
                  }

                  n.head && (n.head.time = b), 512 & n.flags && (P[0] = 255 & b, P[1] = b >>> 8 & 255, P[2] = b >>> 16 & 255, P[3] = b >>> 24 & 255, n.check = o(n.check, P, 4, 0)), w = b = 0, n.mode = 4;

                case 4:
                  for (; w < 16;) {
                    if (0 === v) break e;
                    v--, b += f[_++] << w, w += 8;
                  }

                  n.head && (n.head.xflags = 255 & b, n.head.os = b >> 8), 512 & n.flags && (P[0] = 255 & b, P[1] = b >>> 8 & 255, n.check = o(n.check, P, 2, 0)), w = b = 0, n.mode = 5;

                case 5:
                  if (1024 & n.flags) {
                    for (; w < 16;) {
                      if (0 === v) break e;
                      v--, b += f[_++] << w, w += 8;
                    }

                    n.length = b, n.head && (n.head.extra_len = b), 512 & n.flags && (P[0] = 255 & b, P[1] = b >>> 8 & 255, n.check = o(n.check, P, 2, 0)), w = b = 0;
                  } else n.head && (n.head.extra = null);

                  n.mode = 6;

                case 6:
                  if (1024 & n.flags && (v < (L = n.length) && (L = v), L && (n.head && (O = n.head.extra_len - n.length, n.head.extra || (n.head.extra = new Array(n.head.extra_len)), r.arraySet(n.head.extra, f, _, L, O)), 512 & n.flags && (n.check = o(n.check, f, L, _)), v -= L, _ += L, n.length -= L), n.length)) break e;
                  n.length = 0, n.mode = 7;

                case 7:
                  if (2048 & n.flags) {
                    if (0 === v) break e;

                    for (L = 0; O = f[_ + L++], n.head && O && n.length < 65536 && (n.head.name += String.fromCharCode(O)), O && L < v;) {
                      ;
                    }

                    if (512 & n.flags && (n.check = o(n.check, f, L, _)), v -= L, _ += L, O) break e;
                  } else n.head && (n.head.name = null);

                  n.length = 0, n.mode = 8;

                case 8:
                  if (4096 & n.flags) {
                    if (0 === v) break e;

                    for (L = 0; O = f[_ + L++], n.head && O && n.length < 65536 && (n.head.comment += String.fromCharCode(O)), O && L < v;) {
                      ;
                    }

                    if (512 & n.flags && (n.check = o(n.check, f, L, _)), v -= L, _ += L, O) break e;
                  } else n.head && (n.head.comment = null);

                  n.mode = 9;

                case 9:
                  if (512 & n.flags) {
                    for (; w < 16;) {
                      if (0 === v) break e;
                      v--, b += f[_++] << w, w += 8;
                    }

                    if (b !== (65535 & n.check)) {
                      e.msg = "header crc mismatch", n.mode = 30;
                      break;
                    }

                    w = b = 0;
                  }

                  n.head && (n.head.hcrc = n.flags >> 9 & 1, n.head.done = !0), e.adler = n.check = 0, n.mode = 12;
                  break;

                case 10:
                  for (; w < 32;) {
                    if (0 === v) break e;
                    v--, b += f[_++] << w, w += 8;
                  }

                  e.adler = n.check = m(b), w = b = 0, n.mode = 11;

                case 11:
                  if (0 === n.havedict) return e.next_out = y, e.avail_out = g, e.next_in = _, e.avail_in = v, n.hold = b, n.bits = w, 2;
                  e.adler = n.check = 1, n.mode = 12;

                case 12:
                  if (5 === t || 6 === t) break e;

                case 13:
                  if (n.last) {
                    b >>>= 7 & w, w -= 7 & w, n.mode = 27;
                    break;
                  }

                  for (; w < 3;) {
                    if (0 === v) break e;
                    v--, b += f[_++] << w, w += 8;
                  }

                  switch (n.last = 1 & b, w -= 1, 3 & (b >>>= 1)) {
                    case 0:
                      n.mode = 14;
                      break;

                    case 1:
                      if (E(n), n.mode = 20, 6 !== t) break;
                      b >>>= 2, w -= 2;
                      break e;

                    case 2:
                      n.mode = 17;
                      break;

                    case 3:
                      e.msg = "invalid block type", n.mode = 30;
                  }

                  b >>>= 2, w -= 2;
                  break;

                case 14:
                  for (b >>>= 7 & w, w -= 7 & w; w < 32;) {
                    if (0 === v) break e;
                    v--, b += f[_++] << w, w += 8;
                  }

                  if ((65535 & b) != (b >>> 16 ^ 65535)) {
                    e.msg = "invalid stored block lengths", n.mode = 30;
                    break;
                  }

                  if (n.length = 65535 & b, w = b = 0, n.mode = 15, 6 === t) break e;

                case 15:
                  n.mode = 16;

                case 16:
                  if (L = n.length) {
                    if (v < L && (L = v), g < L && (L = g), 0 === L) break e;
                    r.arraySet(p, f, _, L, y), v -= L, _ += L, g -= L, y += L, n.length -= L;
                    break;
                  }

                  n.mode = 12;
                  break;

                case 17:
                  for (; w < 14;) {
                    if (0 === v) break e;
                    v--, b += f[_++] << w, w += 8;
                  }

                  if (n.nlen = 257 + (31 & b), b >>>= 5, w -= 5, n.ndist = 1 + (31 & b), b >>>= 5, w -= 5, n.ncode = 4 + (15 & b), b >>>= 4, w -= 4, 286 < n.nlen || 30 < n.ndist) {
                    e.msg = "too many length or distance symbols", n.mode = 30;
                    break;
                  }

                  n.have = 0, n.mode = 18;

                case 18:
                  for (; n.have < n.ncode;) {
                    for (; w < 3;) {
                      if (0 === v) break e;
                      v--, b += f[_++] << w, w += 8;
                    }

                    n.lens[V[n.have++]] = 7 & b, b >>>= 3, w -= 3;
                  }

                  for (; n.have < 19;) {
                    n.lens[V[n.have++]] = 0;
                  }

                  if (n.lencode = n.lendyn, n.lenbits = 7, A = {
                    bits: n.lenbits
                  }, F = s(0, n.lens, 0, 19, n.lencode, 0, n.work, A), n.lenbits = A.bits, F) {
                    e.msg = "invalid code lengths set", n.mode = 30;
                    break;
                  }

                  n.have = 0, n.mode = 19;

                case 19:
                  for (; n.have < n.nlen + n.ndist;) {
                    for (; I = (U = n.lencode[b & (1 << n.lenbits) - 1]) >>> 16 & 255, R = 65535 & U, !((D = U >>> 24) <= w);) {
                      if (0 === v) break e;
                      v--, b += f[_++] << w, w += 8;
                    }

                    if (R < 16) b >>>= D, w -= D, n.lens[n.have++] = R;else {
                      if (16 === R) {
                        for (j = D + 2; w < j;) {
                          if (0 === v) break e;
                          v--, b += f[_++] << w, w += 8;
                        }

                        if (b >>>= D, w -= D, 0 === n.have) {
                          e.msg = "invalid bit length repeat", n.mode = 30;
                          break;
                        }

                        O = n.lens[n.have - 1], L = 3 + (3 & b), b >>>= 2, w -= 2;
                      } else if (17 === R) {
                        for (j = D + 3; w < j;) {
                          if (0 === v) break e;
                          v--, b += f[_++] << w, w += 8;
                        }

                        w -= D, O = 0, L = 3 + (7 & (b >>>= D)), b >>>= 3, w -= 3;
                      } else {
                        for (j = D + 7; w < j;) {
                          if (0 === v) break e;
                          v--, b += f[_++] << w, w += 8;
                        }

                        w -= D, O = 0, L = 11 + (127 & (b >>>= D)), b >>>= 7, w -= 7;
                      }

                      if (n.have + L > n.nlen + n.ndist) {
                        e.msg = "invalid bit length repeat", n.mode = 30;
                        break;
                      }

                      for (; L--;) {
                        n.lens[n.have++] = O;
                      }
                    }
                  }

                  if (30 === n.mode) break;

                  if (0 === n.lens[256]) {
                    e.msg = "invalid code -- missing end-of-block", n.mode = 30;
                    break;
                  }

                  if (n.lenbits = 9, A = {
                    bits: n.lenbits
                  }, F = s(u, n.lens, 0, n.nlen, n.lencode, 0, n.work, A), n.lenbits = A.bits, F) {
                    e.msg = "invalid literal/lengths set", n.mode = 30;
                    break;
                  }

                  if (n.distbits = 6, n.distcode = n.distdyn, A = {
                    bits: n.distbits
                  }, F = s(c, n.lens, n.nlen, n.ndist, n.distcode, 0, n.work, A), n.distbits = A.bits, F) {
                    e.msg = "invalid distances set", n.mode = 30;
                    break;
                  }

                  if (n.mode = 20, 6 === t) break e;

                case 20:
                  n.mode = 21;

                case 21:
                  if (6 <= v && 258 <= g) {
                    e.next_out = y, e.avail_out = g, e.next_in = _, e.avail_in = v, n.hold = b, n.bits = w, a(e, M), y = e.next_out, p = e.output, g = e.avail_out, _ = e.next_in, f = e.input, v = e.avail_in, b = n.hold, w = n.bits, 12 === n.mode && (n.back = -1);
                    break;
                  }

                  for (n.back = 0; I = (U = n.lencode[b & (1 << n.lenbits) - 1]) >>> 16 & 255, R = 65535 & U, !((D = U >>> 24) <= w);) {
                    if (0 === v) break e;
                    v--, b += f[_++] << w, w += 8;
                  }

                  if (I && 0 == (240 & I)) {
                    for (x = D, Y = I, C = R; I = (U = n.lencode[C + ((b & (1 << x + Y) - 1) >> x)]) >>> 16 & 255, R = 65535 & U, !(x + (D = U >>> 24) <= w);) {
                      if (0 === v) break e;
                      v--, b += f[_++] << w, w += 8;
                    }

                    b >>>= x, w -= x, n.back += x;
                  }

                  if (b >>>= D, w -= D, n.back += D, n.length = R, 0 === I) {
                    n.mode = 26;
                    break;
                  }

                  if (32 & I) {
                    n.back = -1, n.mode = 12;
                    break;
                  }

                  if (64 & I) {
                    e.msg = "invalid literal/length code", n.mode = 30;
                    break;
                  }

                  n.extra = 15 & I, n.mode = 22;

                case 22:
                  if (n.extra) {
                    for (j = n.extra; w < j;) {
                      if (0 === v) break e;
                      v--, b += f[_++] << w, w += 8;
                    }

                    n.length += b & (1 << n.extra) - 1, b >>>= n.extra, w -= n.extra, n.back += n.extra;
                  }

                  n.was = n.length, n.mode = 23;

                case 23:
                  for (; I = (U = n.distcode[b & (1 << n.distbits) - 1]) >>> 16 & 255, R = 65535 & U, !((D = U >>> 24) <= w);) {
                    if (0 === v) break e;
                    v--, b += f[_++] << w, w += 8;
                  }

                  if (0 == (240 & I)) {
                    for (x = D, Y = I, C = R; I = (U = n.distcode[C + ((b & (1 << x + Y) - 1) >> x)]) >>> 16 & 255, R = 65535 & U, !(x + (D = U >>> 24) <= w);) {
                      if (0 === v) break e;
                      v--, b += f[_++] << w, w += 8;
                    }

                    b >>>= x, w -= x, n.back += x;
                  }

                  if (b >>>= D, w -= D, n.back += D, 64 & I) {
                    e.msg = "invalid distance code", n.mode = 30;
                    break;
                  }

                  n.offset = R, n.extra = 15 & I, n.mode = 24;

                case 24:
                  if (n.extra) {
                    for (j = n.extra; w < j;) {
                      if (0 === v) break e;
                      v--, b += f[_++] << w, w += 8;
                    }

                    n.offset += b & (1 << n.extra) - 1, b >>>= n.extra, w -= n.extra, n.back += n.extra;
                  }

                  if (n.offset > n.dmax) {
                    e.msg = "invalid distance too far back", n.mode = 30;
                    break;
                  }

                  n.mode = 25;

                case 25:
                  if (0 === g) break e;

                  if (L = M - g, n.offset > L) {
                    if ((L = n.offset - L) > n.whave && n.sane) {
                      e.msg = "invalid distance too far back", n.mode = 30;
                      break;
                    }

                    S = L > n.wnext ? (L -= n.wnext, n.wsize - L) : n.wnext - L, L > n.length && (L = n.length), N = n.window;
                  } else N = p, S = y - n.offset, L = n.length;

                  for (g < L && (L = g), g -= L, n.length -= L; p[y++] = N[S++], --L;) {
                    ;
                  }

                  0 === n.length && (n.mode = 21);
                  break;

                case 26:
                  if (0 === g) break e;
                  p[y++] = n.length, g--, n.mode = 21;
                  break;

                case 27:
                  if (n.wrap) {
                    for (; w < 32;) {
                      if (0 === v) break e;
                      v--, b |= f[_++] << w, w += 8;
                    }

                    if (M -= g, e.total_out += M, n.total += M, M && (e.adler = n.check = n.flags ? o(n.check, p, M, y - M) : i(n.check, p, M, y - M)), M = g, (n.flags ? b : m(b)) !== n.check) {
                      e.msg = "incorrect data check", n.mode = 30;
                      break;
                    }

                    w = b = 0;
                  }

                  n.mode = 28;

                case 28:
                  if (n.wrap && n.flags) {
                    for (; w < 32;) {
                      if (0 === v) break e;
                      v--, b += f[_++] << w, w += 8;
                    }

                    if (b !== (4294967295 & n.total)) {
                      e.msg = "incorrect length check", n.mode = 30;
                      break;
                    }

                    w = b = 0;
                  }

                  n.mode = 29;

                case 29:
                  F = 1;
                  break e;

                case 30:
                  F = -3;
                  break e;

                case 31:
                  return -4;

                case 32:
                default:
                  return h;
              }
            }

            return e.next_out = y, e.avail_out = g, e.next_in = _, e.avail_in = v, n.hold = b, n.bits = w, (n.wsize || M !== e.avail_out && n.mode < 30 && (n.mode < 27 || 4 !== t)) && k(e, e.output, e.next_out, M - e.avail_out) ? (n.mode = 31, -4) : (T -= e.avail_in, M -= e.avail_out, e.total_in += T, e.total_out += M, n.total += M, n.wrap && M && (e.adler = n.check = n.flags ? o(n.check, p, M, e.next_out - M) : i(n.check, p, M, e.next_out - M)), e.data_type = n.bits + (n.last ? 64 : 0) + (12 === n.mode ? 128 : 0) + (20 === n.mode || 15 === n.mode ? 256 : 0), (0 == T && 0 === M || 4 === t) && F === l && (F = -5), F);
          }, n.inflateEnd = function (e) {
            if (!e || !e.state) return h;
            var t = e.state;
            return t.window && (t.window = null), e.state = null, l;
          }, n.inflateGetHeader = function (e, t) {
            var n;
            return e && e.state ? 0 == (2 & (n = e.state).wrap) ? h : ((n.head = t).done = !1, l) : h;
          }, n.inflateSetDictionary = function (e, t) {
            var n,
                r = t.length;
            return e && e.state ? 0 !== (n = e.state).wrap && 11 !== n.mode ? h : 11 === n.mode && i(1, t, r, 0) !== n.check ? -3 : k(e, t, r, r) ? (n.mode = 31, -4) : (n.havedict = 1, l) : h;
          }, n.inflateInfo = "pako inflate (from Nodeca project)";
        }, {
          "../utils/common": 41,
          "./adler32": 43,
          "./crc32": 45,
          "./inffast": 48,
          "./inftrees": 50
        }],
        50: [function (e, t, n) {
          "use strict";

          var r = e("../utils/common"),
              i = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
              o = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
              a = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
              s = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];

          t.exports = function (e, t, n, u, c, l, h, d) {
            var f,
                p,
                m,
                _,
                y,
                v,
                g,
                b,
                w,
                T = d.bits,
                M = 0,
                E = 0,
                k = 0,
                L = 0,
                S = 0,
                N = 0,
                D = 0,
                I = 0,
                R = 0,
                x = 0,
                Y = null,
                C = 0,
                O = new r.Buf16(16),
                F = new r.Buf16(16),
                A = null,
                j = 0;

            for (M = 0; M <= 15; M++) {
              O[M] = 0;
            }

            for (E = 0; E < u; E++) {
              O[t[n + E]]++;
            }

            for (S = T, L = 15; 1 <= L && 0 === O[L]; L--) {
              ;
            }

            if (L < S && (S = L), 0 === L) return c[l++] = 20971520, c[l++] = 20971520, d.bits = 1, 0;

            for (k = 1; k < L && 0 === O[k]; k++) {
              ;
            }

            for (S < k && (S = k), M = I = 1; M <= 15; M++) {
              if (I <<= 1, (I -= O[M]) < 0) return -1;
            }

            if (0 < I && (0 === e || 1 !== L)) return -1;

            for (F[1] = 0, M = 1; M < 15; M++) {
              F[M + 1] = F[M] + O[M];
            }

            for (E = 0; E < u; E++) {
              0 !== t[n + E] && (h[F[t[n + E]]++] = E);
            }

            if (v = 0 === e ? (Y = A = h, 19) : 1 === e ? (Y = i, C -= 257, A = o, j -= 257, 256) : (Y = a, A = s, -1), M = k, y = l, D = E = x = 0, m = -1, _ = (R = 1 << (N = S)) - 1, 1 === e && 852 < R || 2 === e && 592 < R) return 1;

            for (;;) {
              for (g = M - D, w = h[E] < v ? (b = 0, h[E]) : h[E] > v ? (b = A[j + h[E]], Y[C + h[E]]) : (b = 96, 0), f = 1 << M - D, k = p = 1 << N; c[y + (x >> D) + (p -= f)] = g << 24 | b << 16 | w | 0, 0 !== p;) {
                ;
              }

              for (f = 1 << M - 1; x & f;) {
                f >>= 1;
              }

              if (0 !== f ? (x &= f - 1, x += f) : x = 0, E++, 0 == --O[M]) {
                if (M === L) break;
                M = t[n + h[E]];
              }

              if (S < M && (x & _) !== m) {
                for (0 === D && (D = S), y += k, I = 1 << (N = M - D); N + D < L && !((I -= O[N + D]) <= 0);) {
                  N++, I <<= 1;
                }

                if (R += 1 << N, 1 === e && 852 < R || 2 === e && 592 < R) return 1;
                c[m = x & _] = S << 24 | N << 16 | y - l | 0;
              }
            }

            return 0 !== x && (c[y + x] = M - D << 24 | 64 << 16 | 0), d.bits = S, 0;
          };
        }, {
          "../utils/common": 41
        }],
        51: [function (e, t, n) {
          "use strict";

          t.exports = {
            2: "need dictionary",
            1: "stream end",
            0: "",
            "-1": "file error",
            "-2": "stream error",
            "-3": "data error",
            "-4": "insufficient memory",
            "-5": "buffer error",
            "-6": "incompatible version"
          };
        }, {}],
        52: [function (e, t, n) {
          "use strict";

          var r = e("../utils/common");

          function i(e) {
            for (var t = e.length; 0 <= --t;) {
              e[t] = 0;
            }
          }

          var o = 0,
              a = 256,
              s = a + 1 + 29,
              u = 30,
              c = 19,
              l = 2 * s + 1,
              h = 15,
              d = 16,
              f = 256,
              p = 16,
              m = 17,
              _ = 18,
              y = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
              v = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
              g = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
              b = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
              w = new Array(2 * (s + 2));
          i(w);
          var T = new Array(2 * u);
          i(T);
          var M = new Array(512);
          i(M);
          var E = new Array(256);
          i(E);
          var k = new Array(29);
          i(k);
          var L,
              S,
              N,
              D = new Array(u);

          function I(e, t, n, r, i) {
            this.static_tree = e, this.extra_bits = t, this.extra_base = n, this.elems = r, this.max_length = i, this.has_stree = e && e.length;
          }

          function R(e, t) {
            this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
          }

          function x(e) {
            return e < 256 ? M[e] : M[256 + (e >>> 7)];
          }

          function Y(e, t) {
            e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
          }

          function C(e, t, n) {
            e.bi_valid > d - n ? (e.bi_buf |= t << e.bi_valid & 65535, Y(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += n - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += n);
          }

          function O(e, t, n) {
            C(e, n[2 * t], n[2 * t + 1]);
          }

          function F(e, t) {
            for (var n = 0; n |= 1 & e, e >>>= 1, n <<= 1, 0 < --t;) {
              ;
            }

            return n >>> 1;
          }

          function A(e, t, n) {
            var r,
                i,
                o = new Array(h + 1),
                a = 0;

            for (r = 1; r <= h; r++) {
              o[r] = a = a + n[r - 1] << 1;
            }

            for (i = 0; i <= t; i++) {
              var s = e[2 * i + 1];
              0 !== s && (e[2 * i] = F(o[s]++, s));
            }
          }

          function j(e) {
            var t;

            for (t = 0; t < s; t++) {
              e.dyn_ltree[2 * t] = 0;
            }

            for (t = 0; t < u; t++) {
              e.dyn_dtree[2 * t] = 0;
            }

            for (t = 0; t < c; t++) {
              e.bl_tree[2 * t] = 0;
            }

            e.dyn_ltree[2 * f] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
          }

          function U(e) {
            8 < e.bi_valid ? Y(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
          }

          function P(e, t, n, r) {
            var i = 2 * t,
                o = 2 * n;
            return e[i] < e[o] || e[i] === e[o] && r[t] <= r[n];
          }

          function V(e, t, n) {
            for (var r = e.heap[n], i = n << 1; i <= e.heap_len && (i < e.heap_len && P(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !P(t, r, e.heap[i], e.depth));) {
              e.heap[n] = e.heap[i], n = i, i <<= 1;
            }

            e.heap[n] = r;
          }

          function W(e, t, n) {
            var r,
                i,
                o,
                s,
                u = 0;
            if (0 !== e.last_lit) for (; r = e.pending_buf[e.d_buf + 2 * u] << 8 | e.pending_buf[e.d_buf + 2 * u + 1], i = e.pending_buf[e.l_buf + u], u++, 0 === r ? O(e, i, t) : (O(e, (o = E[i]) + a + 1, t), 0 !== (s = y[o]) && C(e, i -= k[o], s), O(e, o = x(--r), n), 0 !== (s = v[o]) && C(e, r -= D[o], s)), u < e.last_lit;) {
              ;
            }
            O(e, f, t);
          }

          function H(e, t) {
            var n,
                r,
                i,
                o = t.dyn_tree,
                a = t.stat_desc.static_tree,
                s = t.stat_desc.has_stree,
                u = t.stat_desc.elems,
                c = -1;

            for (e.heap_len = 0, e.heap_max = l, n = 0; n < u; n++) {
              0 !== o[2 * n] ? (e.heap[++e.heap_len] = c = n, e.depth[n] = 0) : o[2 * n + 1] = 0;
            }

            for (; e.heap_len < 2;) {
              o[2 * (i = e.heap[++e.heap_len] = c < 2 ? ++c : 0)] = 1, e.depth[i] = 0, e.opt_len--, s && (e.static_len -= a[2 * i + 1]);
            }

            for (t.max_code = c, n = e.heap_len >> 1; 1 <= n; n--) {
              V(e, o, n);
            }

            for (i = u; n = e.heap[1], e.heap[1] = e.heap[e.heap_len--], V(e, o, 1), r = e.heap[1], e.heap[--e.heap_max] = n, e.heap[--e.heap_max] = r, o[2 * i] = o[2 * n] + o[2 * r], e.depth[i] = (e.depth[n] >= e.depth[r] ? e.depth[n] : e.depth[r]) + 1, o[2 * n + 1] = o[2 * r + 1] = i, e.heap[1] = i++, V(e, o, 1), 2 <= e.heap_len;) {
              ;
            }

            e.heap[--e.heap_max] = e.heap[1], function (e, t) {
              var n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  u = t.dyn_tree,
                  c = t.max_code,
                  d = t.stat_desc.static_tree,
                  f = t.stat_desc.has_stree,
                  p = t.stat_desc.extra_bits,
                  m = t.stat_desc.extra_base,
                  _ = t.stat_desc.max_length,
                  y = 0;

              for (o = 0; o <= h; o++) {
                e.bl_count[o] = 0;
              }

              for (u[2 * e.heap[e.heap_max] + 1] = 0, n = e.heap_max + 1; n < l; n++) {
                _ < (o = u[2 * u[2 * (r = e.heap[n]) + 1] + 1] + 1) && (o = _, y++), u[2 * r + 1] = o, c < r || (e.bl_count[o]++, a = 0, m <= r && (a = p[r - m]), s = u[2 * r], e.opt_len += s * (o + a), f && (e.static_len += s * (d[2 * r + 1] + a)));
              }

              if (0 !== y) {
                do {
                  for (o = _ - 1; 0 === e.bl_count[o];) {
                    o--;
                  }

                  e.bl_count[o]--, e.bl_count[o + 1] += 2, e.bl_count[_]--, y -= 2;
                } while (0 < y);

                for (o = _; 0 !== o; o--) {
                  for (r = e.bl_count[o]; 0 !== r;) {
                    c < (i = e.heap[--n]) || (u[2 * i + 1] !== o && (e.opt_len += (o - u[2 * i + 1]) * u[2 * i], u[2 * i + 1] = o), r--);
                  }
                }
              }
            }(e, t), A(o, c, e.bl_count);
          }

          function B(e, t, n) {
            var r,
                i,
                o = -1,
                a = t[1],
                s = 0,
                u = 7,
                c = 4;

            for (0 === a && (u = 138, c = 3), t[2 * (n + 1) + 1] = 65535, r = 0; r <= n; r++) {
              i = a, a = t[2 * (r + 1) + 1], ++s < u && i === a || (s < c ? e.bl_tree[2 * i] += s : 0 !== i ? (i !== o && e.bl_tree[2 * i]++, e.bl_tree[2 * p]++) : s <= 10 ? e.bl_tree[2 * m]++ : e.bl_tree[2 * _]++, o = i, c = (s = 0) === a ? (u = 138, 3) : i === a ? (u = 6, 3) : (u = 7, 4));
            }
          }

          function z(e, t, n) {
            var r,
                i,
                o = -1,
                a = t[1],
                s = 0,
                u = 7,
                c = 4;

            for (0 === a && (u = 138, c = 3), r = 0; r <= n; r++) {
              if (i = a, a = t[2 * (r + 1) + 1], !(++s < u && i === a)) {
                if (s < c) for (; O(e, i, e.bl_tree), 0 != --s;) {
                  ;
                } else 0 !== i ? (i !== o && (O(e, i, e.bl_tree), s--), O(e, p, e.bl_tree), C(e, s - 3, 2)) : s <= 10 ? (O(e, m, e.bl_tree), C(e, s - 3, 3)) : (O(e, _, e.bl_tree), C(e, s - 11, 7));
                o = i, c = (s = 0) === a ? (u = 138, 3) : i === a ? (u = 6, 3) : (u = 7, 4);
              }
            }
          }

          i(D);
          var Z = !1;

          function Q(e, t, n, i) {
            C(e, (o << 1) + (i ? 1 : 0), 3), function (e, t, n, i) {
              U(e), Y(e, n), Y(e, ~n), r.arraySet(e.pending_buf, e.window, t, n, e.pending), e.pending += n;
            }(e, t, n);
          }

          n._tr_init = function (e) {
            Z || (function () {
              var e,
                  t,
                  n,
                  r,
                  i,
                  o = new Array(h + 1);

              for (r = n = 0; r < 28; r++) {
                for (k[r] = n, e = 0; e < 1 << y[r]; e++) {
                  E[n++] = r;
                }
              }

              for (E[n - 1] = r, r = i = 0; r < 16; r++) {
                for (D[r] = i, e = 0; e < 1 << v[r]; e++) {
                  M[i++] = r;
                }
              }

              for (i >>= 7; r < u; r++) {
                for (D[r] = i << 7, e = 0; e < 1 << v[r] - 7; e++) {
                  M[256 + i++] = r;
                }
              }

              for (t = 0; t <= h; t++) {
                o[t] = 0;
              }

              for (e = 0; e <= 143;) {
                w[2 * e + 1] = 8, e++, o[8]++;
              }

              for (; e <= 255;) {
                w[2 * e + 1] = 9, e++, o[9]++;
              }

              for (; e <= 279;) {
                w[2 * e + 1] = 7, e++, o[7]++;
              }

              for (; e <= 287;) {
                w[2 * e + 1] = 8, e++, o[8]++;
              }

              for (A(w, s + 1, o), e = 0; e < u; e++) {
                T[2 * e + 1] = 5, T[2 * e] = F(e, 5);
              }

              L = new I(w, y, a + 1, s, h), S = new I(T, v, 0, u, h), N = new I(new Array(0), g, 0, c, 7);
            }(), Z = !0), e.l_desc = new R(e.dyn_ltree, L), e.d_desc = new R(e.dyn_dtree, S), e.bl_desc = new R(e.bl_tree, N), e.bi_buf = 0, e.bi_valid = 0, j(e);
          }, n._tr_stored_block = Q, n._tr_flush_block = function (e, t, n, r) {
            var i,
                o,
                s = 0;
            0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function (e) {
              var t,
                  n = 4093624447;

              for (t = 0; t <= 31; t++, n >>>= 1) {
                if (1 & n && 0 !== e.dyn_ltree[2 * t]) return 0;
              }

              if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;

              for (t = 32; t < a; t++) {
                if (0 !== e.dyn_ltree[2 * t]) return 1;
              }

              return 0;
            }(e)), H(e, e.l_desc), H(e, e.d_desc), s = function (e) {
              var t;

              for (B(e, e.dyn_ltree, e.l_desc.max_code), B(e, e.dyn_dtree, e.d_desc.max_code), H(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * b[t] + 1]; t--) {
                ;
              }

              return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
            }(e), i = e.opt_len + 3 + 7 >>> 3, (o = e.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = n + 5, n + 4 <= i && -1 !== t ? Q(e, t, n, r) : 4 === e.strategy || o === i ? (C(e, 2 + (r ? 1 : 0), 3), W(e, w, T)) : (C(e, 4 + (r ? 1 : 0), 3), function (e, t, n, r) {
              var i;

              for (C(e, t - 257, 5), C(e, n - 1, 5), C(e, r - 4, 4), i = 0; i < r; i++) {
                C(e, e.bl_tree[2 * b[i] + 1], 3);
              }

              z(e, e.dyn_ltree, t - 1), z(e, e.dyn_dtree, n - 1);
            }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, s + 1), W(e, e.dyn_ltree, e.dyn_dtree)), j(e), r && U(e);
          }, n._tr_tally = function (e, t, n) {
            return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & n, e.last_lit++, 0 === t ? e.dyn_ltree[2 * n]++ : (e.matches++, t--, e.dyn_ltree[2 * (E[n] + a + 1)]++, e.dyn_dtree[2 * x(t)]++), e.last_lit === e.lit_bufsize - 1;
          }, n._tr_align = function (e) {
            C(e, 2, 3), O(e, f, w), function (e) {
              16 === e.bi_valid ? (Y(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
            }(e);
          };
        }, {
          "../utils/common": 41
        }],
        53: [function (e, t, n) {
          "use strict";

          t.exports = function () {
            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
          };
        }, {}],
        54: [function (e, t, n) {
          "use strict";

          t.exports = "function" == typeof r ? r : function () {
            var e = [].slice.apply(arguments);
            e.splice(1, 0, 0), setTimeout.apply(null, e);
          };
        }, {}]
      }, {}, [10])(10);
    }).call(this, n(267).Buffer, n(17), n(271).setImmediate);
  }, function (e, t, n) {
    "use strict";

    var r = {};

    function i() {
      try {
        return new window.XMLHttpRequest();
      } catch (e) {}
    }

    r._getBinaryFromXHR = function (e) {
      return e.response || e.responseText;
    };

    var o = "undefined" != typeof window && window.ActiveXObject ? function () {
      return i() || function () {
        try {
          return new window.ActiveXObject("Microsoft.XMLHTTP");
        } catch (e) {}
      }();
    } : i;
    r.getBinaryContent = function (e, t) {
      var n, i, a, s;
      t || (t = {}), "function" == typeof t ? (s = t, t = {}) : "function" == typeof t.callback && (s = t.callback), s || "undefined" == typeof Promise ? (i = function i(e) {
        s(null, e);
      }, a = function a(e) {
        s(e, null);
      }) : n = new Promise(function (e, t) {
        i = e, a = t;
      });

      try {
        var u = o();
        u.open("GET", e, !0), "responseType" in u && (u.responseType = "arraybuffer"), u.overrideMimeType && u.overrideMimeType("text/plain; charset=x-user-defined"), u.onreadystatechange = function (t) {
          if (4 === u.readyState) if (200 === u.status || 0 === u.status) try {
            i(r._getBinaryFromXHR(u));
          } catch (e) {
            a(new Error(e));
          } else a(new Error("Ajax error for " + e + " : " + this.status + " " + this.statusText));
        }, t.progress && (u.onprogress = function (n) {
          t.progress({
            path: e,
            originalEvent: n,
            percent: n.loaded / n.total * 100,
            loaded: n.loaded,
            total: n.total
          });
        }), u.send();
      } catch (e) {
        a(new Error(e), null);
      }

      return n;
    }, e.exports = r;
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(51);

    for (var i in r) {
      ["isNamedObject", "default"].indexOf(i) < 0 && function (e) {
        n.d(t, e, function () {
          return r[e];
        });
      }(i);
    }

    var o = n(42);
    n.d(t, "useMedia", function () {
      return o.a;
    }), n.d(t, "useRootRoute", function () {
      return o.b;
    }), n.d(t, "useSettings", function () {
      return o.c;
    });
    var a = n(8);
    n.d(t, "getResourceApi", function () {
      return a.y;
    }), n.d(t, "createResourceApi", function () {
      return a.v;
    }), n.d(t, "ResourceApi", function () {
      return a.n;
    }), n.d(t, "ResourceApiUntyped", function () {
      return a.o;
    }), n.d(t, "createNotificationService", function () {
      return a.u;
    }), n.d(t, "getNotificationService", function () {
      return a.x;
    }), n.d(t, "FirebaseConfig", function () {
      return a.e;
    }), n.d(t, "Notification", function () {
      return a.h;
    }), n.d(t, "onApiErrorHandler", function () {
      return a.B;
    }), n.d(t, "transformError", function () {
      return a.C;
    }), n.d(t, "getErrorInfo", function () {
      return a.w;
    }), n.d(t, "PositionTemplateRequestWithCompaniesContext", function () {
      return a.l;
    }), n.d(t, "WorksiteRequestWithCompaniesContext", function () {
      return a.t;
    }), n.d(t, "FacilityDepartmentRequestWithCompaniesContext", function () {
      return a.d;
    }), n.d(t, "ShiftTypeRequestWithCompaniesContext", function () {
      return a.s;
    }), n.d(t, "AgreementRequestWithCompaniescontext", function () {
      return a.a;
    }), n.d(t, "OpportunityRequestWithCompaniesContext", function () {
      return a.i;
    }), n.d(t, "ContactRequestWithCompaniesContext", function () {
      return a.c;
    }), n.d(t, "ClientProjectRequestWithCompaniesContext", function () {
      return a.b;
    }), n.d(t, "QuickSearchRequestWithCompaniesContext", function () {
      return a.m;
    }), n.d(t, "PositionSearchRequestWithDataPref", function () {
      return a.k;
    }), n.d(t, "PositionSearchCountRequestWithDataPref", function () {
      return a.j;
    }), n.d(t, "MatchSearchRequestWithDataPref", function () {
      return a.g;
    }), n.d(t, "MatchSearchCountRequestWithDataPref", function () {
      return a.f;
    }), n.d(t, "ShiftSearchDayCountRequestWithDataPref", function () {
      return a.q;
    }), n.d(t, "ShiftSearchRequestWithDataPref", function () {
      return a.r;
    }), n.d(t, "ShiftSearchCountRequestWithDataPref", function () {
      return a.p;
    }), n.d(t, "isMatchPayload", function () {
      return a.z;
    }), n.d(t, "isPositionPayload", function () {
      return a.A;
    });
    var s = n(40);

    for (var i in s) {
      ["isNamedObject", "useMedia", "useRootRoute", "useSettings", "getResourceApi", "createResourceApi", "ResourceApi", "ResourceApiUntyped", "createNotificationService", "getNotificationService", "FirebaseConfig", "Notification", "onApiErrorHandler", "transformError", "getErrorInfo", "PositionTemplateRequestWithCompaniesContext", "WorksiteRequestWithCompaniesContext", "FacilityDepartmentRequestWithCompaniesContext", "ShiftTypeRequestWithCompaniesContext", "AgreementRequestWithCompaniescontext", "OpportunityRequestWithCompaniesContext", "ContactRequestWithCompaniesContext", "ClientProjectRequestWithCompaniesContext", "QuickSearchRequestWithCompaniesContext", "PositionSearchRequestWithDataPref", "PositionSearchCountRequestWithDataPref", "MatchSearchRequestWithDataPref", "MatchSearchCountRequestWithDataPref", "ShiftSearchDayCountRequestWithDataPref", "ShiftSearchRequestWithDataPref", "ShiftSearchCountRequestWithDataPref", "isMatchPayload", "isPositionPayload", "default"].indexOf(i) < 0 && function (e) {
        n.d(t, e, function () {
          return s[e];
        });
      }(i);
    }

    var u = n(205);
    n.d(t, "ContactRoleId", function () {
      return u.a;
    });
    var c = n(22);
    n.d(t, "isNamedObject", function () {
      return c.b;
    });
    var l = n(206);
    n.d(t, "withPermissionsProvider", function () {
      return l.a;
    });
  },, function (e, t, n) {
    "use strict";

    var r = n(15),
        i = n(53),
        o = n(240),
        a = n(59);

    function s(e) {
      var t = new o(e),
          n = i(o.prototype.request, t);
      return r.extend(n, o.prototype, t), r.extend(n, t), n;
    }

    var u = s(n(56));
    u.Axios = o, u.create = function (e) {
      return s(a(u.defaults, e));
    }, u.Cancel = n(60), u.CancelToken = n(253), u.isCancel = n(55), u.all = function (e) {
      return Promise.all(e);
    }, u.spread = n(254), e.exports = u, e.exports.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(15),
        i = n(54),
        o = n(241),
        a = n(242),
        s = n(59);

    function u(e) {
      this.defaults = e, this.interceptors = {
        request: new o(),
        response: new o()
      };
    }

    u.prototype.request = function (e) {
      "string" == typeof e ? (e = arguments[1] || {}).url = arguments[0] : e = e || {}, (e = s(this.defaults, e)).method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
      var t = [a, void 0],
          n = Promise.resolve(e);

      for (this.interceptors.request.forEach(function (e) {
        t.unshift(e.fulfilled, e.rejected);
      }), this.interceptors.response.forEach(function (e) {
        t.push(e.fulfilled, e.rejected);
      }); t.length;) {
        n = n.then(t.shift(), t.shift());
      }

      return n;
    }, u.prototype.getUri = function (e) {
      return e = s(this.defaults, e), i(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
    }, r.forEach(["delete", "get", "head", "options"], function (e) {
      u.prototype[e] = function (t, n) {
        return this.request(r.merge(n || {}, {
          method: e,
          url: t
        }));
      };
    }), r.forEach(["post", "put", "patch"], function (e) {
      u.prototype[e] = function (t, n, i) {
        return this.request(r.merge(i || {}, {
          method: e,
          url: t,
          data: n
        }));
      };
    }), e.exports = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(15);

    function i() {
      this.handlers = [];
    }

    i.prototype.use = function (e, t) {
      return this.handlers.push({
        fulfilled: e,
        rejected: t
      }), this.handlers.length - 1;
    }, i.prototype.eject = function (e) {
      this.handlers[e] && (this.handlers[e] = null);
    }, i.prototype.forEach = function (e) {
      r.forEach(this.handlers, function (t) {
        null !== t && e(t);
      });
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(15),
        i = n(243),
        o = n(55),
        a = n(56);

    function s(e) {
      e.cancelToken && e.cancelToken.throwIfRequested();
    }

    e.exports = function (e) {
      return s(e), e.headers = e.headers || {}, e.data = i(e.data, e.headers, e.transformRequest), e.headers = r.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), r.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (t) {
        delete e.headers[t];
      }), (e.adapter || a.adapter)(e).then(function (t) {
        return s(e), t.data = i(t.data, t.headers, e.transformResponse), t;
      }, function (t) {
        return o(t) || (s(e), t && t.response && (t.response.data = i(t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t);
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(15);

    e.exports = function (e, t, n) {
      return r.forEach(n, function (n) {
        e = n(e, t);
      }), e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(15);

    e.exports = function (e, t) {
      r.forEach(e, function (n, r) {
        r !== t && r.toUpperCase() === t.toUpperCase() && (e[t] = n, delete e[r]);
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(58);

    e.exports = function (e, t, n) {
      var i = n.config.validateStatus;
      !i || i(n.status) ? e(n) : t(r("Request failed with status code " + n.status, n.config, null, n.request, n));
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e, t, n, r, i) {
      return e.config = t, n && (e.code = n), e.request = r, e.response = i, e.isAxiosError = !0, e.toJSON = function () {
        return {
          message: this.message,
          name: this.name,
          description: this.description,
          number: this.number,
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          config: this.config,
          code: this.code
        };
      }, e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(248),
        i = n(249);

    e.exports = function (e, t) {
      return e && !r(t) ? i(e, t) : t;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e, t) {
      return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(15),
        i = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

    e.exports = function (e) {
      var t,
          n,
          o,
          a = {};
      return e ? (r.forEach(e.split("\n"), function (e) {
        if (o = e.indexOf(":"), t = r.trim(e.substr(0, o)).toLowerCase(), n = r.trim(e.substr(o + 1)), t) {
          if (a[t] && i.indexOf(t) >= 0) return;
          a[t] = "set-cookie" === t ? (a[t] ? a[t] : []).concat([n]) : a[t] ? a[t] + ", " + n : n;
        }
      }), a) : a;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(15);
    e.exports = r.isStandardBrowserEnv() ? function () {
      var e,
          t = /(msie|trident)/i.test(navigator.userAgent),
          n = document.createElement("a");

      function i(e) {
        var r = e;
        return t && (n.setAttribute("href", r), r = n.href), n.setAttribute("href", r), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname
        };
      }

      return e = i(window.location.href), function (t) {
        var n = r.isString(t) ? i(t) : t;
        return n.protocol === e.protocol && n.host === e.host;
      };
    }() : function () {
      return !0;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(15);
    e.exports = r.isStandardBrowserEnv() ? {
      write: function write(e, t, n, i, o, a) {
        var s = [];
        s.push(e + "=" + encodeURIComponent(t)), r.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), r.isString(i) && s.push("path=" + i), r.isString(o) && s.push("domain=" + o), !0 === a && s.push("secure"), document.cookie = s.join("; ");
      },
      read: function read(e) {
        var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
        return t ? decodeURIComponent(t[3]) : null;
      },
      remove: function remove(e) {
        this.write(e, "", Date.now() - 864e5);
      }
    } : {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(60);

    function i(e) {
      if ("function" != typeof e) throw new TypeError("executor must be a function.");
      var t;
      this.promise = new Promise(function (e) {
        t = e;
      });
      var n = this;
      e(function (e) {
        n.reason || (n.reason = new r(e), t(n.reason));
      });
    }

    i.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }, i.source = function () {
      var e;
      return {
        token: new i(function (t) {
          e = t;
        }),
        cancel: e
      };
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      return function (t) {
        return e.apply(null, t);
      };
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t), function (e) {
      var t = n(6),
          r = n.n(t);
      (function () {
        var t,
            n = "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, t, n) {
          e != Array.prototype && e != Object.prototype && (e[t] = n.value);
        };

        var i = function (t) {
          t = ["object" == typeof window && window, "object" == typeof self && self, "object" == typeof e && e, t];

          for (var n = 0; n < t.length; ++n) {
            var r = t[n];
            if (r && r.Math == Math) return r;
          }

          return globalThis;
        }(this);

        function o(e) {
          var t = 0;
          return function () {
            return t < e.length ? {
              done: !1,
              value: e[t++]
            } : {
              done: !0
            };
          };
        }

        function a(e) {
          var t = "undefined" != typeof Symbol && Symbol.iterator && e[Symbol.iterator];
          return t ? t.call(e) : {
            next: o(e)
          };
        }

        !function (e, t) {
          if (t) {
            var r = i;
            e = e.split(".");

            for (var o = 0; o < e.length - 1; o++) {
              var a = e[o];
              a in r || (r[a] = {}), r = r[a];
            }

            (t = t(o = r[e = e[e.length - 1]])) != o && null != t && n(r, e, {
              configurable: !0,
              writable: !0,
              value: t
            });
          }
        }("Promise", function (e) {
          function t(e) {
            this.b = 0, this.c = void 0, this.a = [];
            var t = this.f();

            try {
              e(t.resolve, t.reject);
            } catch (e) {
              t.reject(e);
            }
          }

          function n() {
            this.a = null;
          }

          function r(e) {
            return e instanceof t ? e : new t(function (t) {
              t(e);
            });
          }

          if (e) return e;

          n.prototype.b = function (e) {
            if (null == this.a) {
              this.a = [];
              var t = this;
              this.c(function () {
                t.g();
              });
            }

            this.a.push(e);
          };

          var o = i.setTimeout;
          n.prototype.c = function (e) {
            o(e, 0);
          }, n.prototype.g = function () {
            for (; this.a && this.a.length;) {
              var e = this.a;
              this.a = [];

              for (var t = 0; t < e.length; ++t) {
                var n = e[t];
                e[t] = null;

                try {
                  n();
                } catch (e) {
                  this.f(e);
                }
              }
            }

            this.a = null;
          }, n.prototype.f = function (e) {
            this.c(function () {
              throw e;
            });
          }, t.prototype.f = function () {
            function e(e) {
              return function (r) {
                n || (n = !0, e.call(t, r));
              };
            }

            var t = this,
                n = !1;
            return {
              resolve: e(this.m),
              reject: e(this.g)
            };
          }, t.prototype.m = function (e) {
            if (e === this) this.g(new TypeError("A Promise cannot resolve to itself"));else if (e instanceof t) this.s(e);else {
              e: switch (typeof e) {
                case "object":
                  var n = null != e;
                  break e;

                case "function":
                  n = !0;
                  break e;

                default:
                  n = !1;
              }

              n ? this.u(e) : this.h(e);
            }
          }, t.prototype.u = function (e) {
            var t = void 0;

            try {
              t = e.then;
            } catch (e) {
              return void this.g(e);
            }

            "function" == typeof t ? this.w(t, e) : this.h(e);
          }, t.prototype.g = function (e) {
            this.i(2, e);
          }, t.prototype.h = function (e) {
            this.i(1, e);
          }, t.prototype.i = function (e, t) {
            if (0 != this.b) throw Error("Cannot settle(" + e + ", " + t + "): Promise already settled in state" + this.b);
            this.b = e, this.c = t, this.l();
          }, t.prototype.l = function () {
            if (null != this.a) {
              for (var e = 0; e < this.a.length; ++e) {
                s.b(this.a[e]);
              }

              this.a = null;
            }
          };
          var s = new n();
          return t.prototype.s = function (e) {
            var t = this.f();
            e.Oa(t.resolve, t.reject);
          }, t.prototype.w = function (e, t) {
            var n = this.f();

            try {
              e.call(t, n.resolve, n.reject);
            } catch (e) {
              n.reject(e);
            }
          }, t.prototype.then = function (e, n) {
            function r(e, t) {
              return "function" == typeof e ? function (t) {
                try {
                  i(e(t));
                } catch (e) {
                  o(e);
                }
              } : t;
            }

            var i,
                o,
                a = new t(function (e, t) {
              i = e, o = t;
            });
            return this.Oa(r(e, i), r(n, o)), a;
          }, t.prototype.catch = function (e) {
            return this.then(void 0, e);
          }, t.prototype.Oa = function (e, t) {
            function n() {
              switch (r.b) {
                case 1:
                  e(r.c);
                  break;

                case 2:
                  t(r.c);
                  break;

                default:
                  throw Error("Unexpected state: " + r.b);
              }
            }

            var r = this;
            null == this.a ? s.b(n) : this.a.push(n);
          }, t.resolve = r, t.reject = function (e) {
            return new t(function (t, n) {
              n(e);
            });
          }, t.race = function (e) {
            return new t(function (t, n) {
              for (var i = a(e), o = i.next(); !o.done; o = i.next()) {
                r(o.value).Oa(t, n);
              }
            });
          }, t.all = function (e) {
            var n = a(e),
                i = n.next();
            return i.done ? r([]) : new t(function (e, t) {
              function o(t) {
                return function (n) {
                  a[t] = n, 0 == --s && e(a);
                };
              }

              var a = [],
                  s = 0;

              do {
                a.push(void 0), s++, r(i.value).Oa(o(a.length - 1), t), i = n.next();
              } while (!i.done);
            });
          }, t;
        });
        var s = s || {},
            u = this || self,
            c = /^[\w+/_-]+[=]{0,2}$/,
            l = null;

        function h() {}

        function d(e) {
          var t = typeof e;

          if ("object" == t) {
            if (!e) return "null";
            if (e instanceof Array) return "array";
            if (e instanceof Object) return t;
            var n = Object.prototype.toString.call(e);
            if ("[object Window]" == n) return "object";
            if ("[object Array]" == n || "number" == typeof e.length && void 0 !== e.splice && void 0 !== e.propertyIsEnumerable && !e.propertyIsEnumerable("splice")) return "array";
            if ("[object Function]" == n || void 0 !== e.call && void 0 !== e.propertyIsEnumerable && !e.propertyIsEnumerable("call")) return "function";
          } else if ("function" == t && void 0 === e.call) return "object";

          return t;
        }

        function f(e) {
          var t = d(e);
          return "array" == t || "object" == t && "number" == typeof e.length;
        }

        function p(e) {
          return "function" == d(e);
        }

        function m(e) {
          var t = typeof e;
          return "object" == t && null != e || "function" == t;
        }

        function _(e) {
          return Object.prototype.hasOwnProperty.call(e, y) && e[y] || (e[y] = ++v);
        }

        var y = "closure_uid_" + (1e9 * Math.random() >>> 0),
            v = 0;

        function g(e, t, n) {
          return e.call.apply(e.bind, arguments);
        }

        function b(e, t, n) {
          if (!e) throw Error();

          if (2 < arguments.length) {
            var r = Array.prototype.slice.call(arguments, 2);
            return function () {
              var n = Array.prototype.slice.call(arguments);
              return Array.prototype.unshift.apply(n, r), e.apply(t, n);
            };
          }

          return function () {
            return e.apply(t, arguments);
          };
        }

        function w(e, t, n) {
          return (w = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? g : b).apply(null, arguments);
        }

        function T(e, t) {
          var n = Array.prototype.slice.call(arguments, 1);
          return function () {
            var t = n.slice();
            return t.push.apply(t, arguments), e.apply(this, t);
          };
        }

        var M = Date.now || function () {
          return +new Date();
        };

        function E(e, t) {
          function n() {}

          n.prototype = t.prototype, e.Za = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
        }

        function k(e, t, n) {
          this.code = N + e, this.message = t || D[e] || "", this.a = n || null;
        }

        function L(e) {
          var t = e && e.code;
          return t ? new k(t.substring(N.length), e.message, e.serverResponse) : null;
        }

        E(k, Error), k.prototype.v = function () {
          var e = {
            code: this.code,
            message: this.message
          };
          return this.a && (e.serverResponse = this.a), e;
        }, k.prototype.toJSON = function () {
          return this.v();
        };
        var S,
            N = "auth/",
            D = {
          "admin-restricted-operation": "This operation is restricted to administrators only.",
          "argument-error": "",
          "app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
          "app-not-installed": "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
          "captcha-check-failed": "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
          "code-expired": "The SMS code has expired. Please re-send the verification code to try again.",
          "cordova-not-ready": "Cordova framework is not ready.",
          "cors-unsupported": "This browser is not supported.",
          "credential-already-in-use": "This credential is already associated with a different user account.",
          "custom-token-mismatch": "The custom token corresponds to a different audience.",
          "requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
          "dynamic-link-not-activated": "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
          "email-change-needs-verification": "Multi-factor users must always have a verified email.",
          "email-already-in-use": "The email address is already in use by another account.",
          "expired-action-code": "The action code has expired. ",
          "cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.",
          "internal-error": "An internal error has occurred.",
          "invalid-app-credential": "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
          "invalid-app-id": "The mobile app identifier is not registed for the current project.",
          "invalid-user-token": "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
          "invalid-auth-event": "An internal error has occurred.",
          "invalid-verification-code": "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
          "invalid-continue-uri": "The continue URL provided in the request is invalid.",
          "invalid-cordova-configuration": "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
          "invalid-custom-token": "The custom token format is incorrect. Please check the documentation.",
          "invalid-dynamic-link-domain": "The provided dynamic link domain is not configured or authorized for the current project.",
          "invalid-email": "The email address is badly formatted.",
          "invalid-api-key": "Your API key is invalid, please check you have copied it correctly.",
          "invalid-cert-hash": "The SHA-1 certificate hash provided is invalid.",
          "invalid-credential": "The supplied auth credential is malformed or has expired.",
          "invalid-message-payload": "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
          "invalid-multi-factor-session": "The request does not contain a valid proof of first factor successful sign-in.",
          "invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
          "invalid-oauth-client-id": "The OAuth client ID provided is either invalid or does not match the specified API key.",
          "unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
          "invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
          "wrong-password": "The password is invalid or the user does not have a password.",
          "invalid-persistence-type": "The specified persistence type is invalid. It can only be local, session or none.",
          "invalid-phone-number": "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
          "invalid-provider-id": "The specified provider ID is invalid.",
          "invalid-recipient-email": "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
          "invalid-sender": "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
          "invalid-verification-id": "The verification ID used to create the phone auth credential is invalid.",
          "invalid-tenant-id": "The Auth instance's tenant ID is invalid.",
          "multi-factor-info-not-found": "The user does not have a second factor matching the identifier provided.",
          "multi-factor-auth-required": "Proof of ownership of a second factor is required to complete sign-in.",
          "missing-android-pkg-name": "An Android Package Name must be provided if the Android App is required to be installed.",
          "auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
          "missing-app-credential": "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
          "missing-verification-code": "The phone auth credential was created with an empty SMS verification code.",
          "missing-continue-uri": "A continue URL must be provided in the request.",
          "missing-iframe-start": "An internal error has occurred.",
          "missing-ios-bundle-id": "An iOS Bundle ID must be provided if an App Store ID is provided.",
          "missing-multi-factor-info": "No second factor identifier is provided.",
          "missing-multi-factor-session": "The request is missing proof of first factor successful sign-in.",
          "missing-or-invalid-nonce": "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
          "missing-phone-number": "To send verification codes, provide a phone number for the recipient.",
          "missing-verification-id": "The phone auth credential was created with an empty verification ID.",
          "app-deleted": "This instance of FirebaseApp has been deleted.",
          "account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
          "network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
          "no-auth-event": "An internal error has occurred.",
          "no-such-provider": "User was not linked to an account with the given provider.",
          "null-user": "A null user object was provided as the argument for an operation which requires a non-null user object.",
          "operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
          "operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
          "popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.",
          "popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.",
          "provider-already-linked": "User can only be linked to one identity for the given provider.",
          "quota-exceeded": "The project's quota for this operation has been exceeded.",
          "redirect-cancelled-by-user": "The redirect operation has been cancelled by the user before finalizing.",
          "redirect-operation-pending": "A redirect sign-in operation is already pending.",
          "rejected-credential": "The request contains malformed or mismatching credentials.",
          "second-factor-already-in-use": "The second factor is already enrolled on this account.",
          "maximum-second-factor-count-exceeded": "The maximum allowed number of second factors on a user has been exceeded.",
          "tenant-id-mismatch": "The provided tenant ID does not match the Auth instance's tenant ID",
          timeout: "The operation has timed out.",
          "user-token-expired": "The user's credential is no longer valid. The user must sign in again.",
          "too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.",
          "unauthorized-continue-uri": "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
          "unsupported-first-factor": "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
          "unsupported-persistence-type": "The current environment does not support the specified persistence type.",
          "unsupported-tenant-operation": "This operation is not supported in a multi-tenant context.",
          "unverified-email": "The operation requires a verified email.",
          "user-cancelled": "The user did not grant your application the permissions it requested.",
          "user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.",
          "user-disabled": "The user account has been disabled by an administrator.",
          "user-mismatch": "The supplied credentials do not correspond to the previously signed in user.",
          "user-signed-out": "",
          "weak-password": "The password must be 6 characters long or more.",
          "web-storage-unsupported": "This browser is not supported or 3rd party cookies and data may be disabled."
        },
            I = {
          hd: {
            Ra: "https://staging-identitytoolkit.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://staging-securetoken.sandbox.googleapis.com/v1/token",
            Ua: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "b"
          },
          pd: {
            Ra: "https://www.googleapis.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://securetoken.googleapis.com/v1/token",
            Ua: "https://identitytoolkit.googleapis.com/v2/",
            id: "p"
          },
          rd: {
            Ra: "https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://staging-securetoken.sandbox.googleapis.com/v1/token",
            Ua: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "s"
          },
          sd: {
            Ra: "https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",
            Xa: "https://test-securetoken.sandbox.googleapis.com/v1/token",
            Ua: "https://test-identitytoolkit.sandbox.googleapis.com/v2/",
            id: "t"
          }
        };

        function R(e) {
          for (var t in I) {
            if (I[t].id === e) return {
              firebaseEndpoint: (e = I[t]).Ra,
              secureTokenEndpoint: e.Xa,
              identityPlatformEndpoint: e.Ua
            };
          }

          return null;
        }

        function x(e) {
          if (!e) return !1;

          try {
            return !!e.$goog_Thenable;
          } catch (e) {
            return !1;
          }
        }

        function Y(e) {
          if (Error.captureStackTrace) Error.captureStackTrace(this, Y);else {
            var t = Error().stack;
            t && (this.stack = t);
          }
          e && (this.message = String(e));
        }

        function C(e, t) {
          for (var n = "", r = (e = e.split("%s")).length - 1, i = 0; i < r; i++) {
            n += e[i] + (i < t.length ? t[i] : "%s");
          }

          Y.call(this, n + e[r]);
        }

        function O(e, t) {
          throw new C("Failure" + (e ? ": " + e : ""), Array.prototype.slice.call(arguments, 1));
        }

        function F(e, t) {
          this.c = e, this.f = t, this.b = 0, this.a = null;
        }

        function A(e, t) {
          e.f(t), 100 > e.b && (e.b++, t.next = e.a, e.a = t);
        }

        function j() {
          this.b = this.a = null;
        }

        S = R("__EID__") ? "__EID__" : void 0, E(Y, Error), Y.prototype.name = "CustomError", E(C, Y), C.prototype.name = "AssertionError", F.prototype.get = function () {
          if (0 < this.b) {
            this.b--;
            var e = this.a;
            this.a = e.next, e.next = null;
          } else e = this.c();

          return e;
        };
        var U = new F(function () {
          return new V();
        }, function (e) {
          e.reset();
        });

        function P() {
          var e = vt,
              t = null;
          return e.a && (t = e.a, e.a = e.a.next, e.a || (e.b = null), t.next = null), t;
        }

        function V() {
          this.next = this.b = this.a = null;
        }

        j.prototype.add = function (e, t) {
          var n = U.get();
          n.set(e, t), this.b ? this.b.next = n : this.a = n, this.b = n;
        }, V.prototype.set = function (e, t) {
          this.a = e, this.b = t, this.next = null;
        }, V.prototype.reset = function () {
          this.next = this.b = this.a = null;
        };
        var W = Array.prototype.indexOf ? function (e, t) {
          return Array.prototype.indexOf.call(e, t, void 0);
        } : function (e, t) {
          if ("string" == typeof e) return "string" != typeof t || 1 != t.length ? -1 : e.indexOf(t, 0);

          for (var n = 0; n < e.length; n++) {
            if (n in e && e[n] === t) return n;
          }

          return -1;
        },
            H = Array.prototype.forEach ? function (e, t, n) {
          Array.prototype.forEach.call(e, t, n);
        } : function (e, t, n) {
          for (var r = e.length, i = "string" == typeof e ? e.split("") : e, o = 0; o < r; o++) {
            o in i && t.call(n, i[o], o, e);
          }
        };
        var B = Array.prototype.filter ? function (e, t) {
          return Array.prototype.filter.call(e, t, void 0);
        } : function (e, t) {
          for (var n = e.length, r = [], i = 0, o = "string" == typeof e ? e.split("") : e, a = 0; a < n; a++) {
            if (a in o) {
              var s = o[a];
              t.call(void 0, s, a, e) && (r[i++] = s);
            }
          }

          return r;
        },
            z = Array.prototype.map ? function (e, t) {
          return Array.prototype.map.call(e, t, void 0);
        } : function (e, t) {
          for (var n = e.length, r = Array(n), i = "string" == typeof e ? e.split("") : e, o = 0; o < n; o++) {
            o in i && (r[o] = t.call(void 0, i[o], o, e));
          }

          return r;
        },
            Z = Array.prototype.some ? function (e, t) {
          return Array.prototype.some.call(e, t, void 0);
        } : function (e, t) {
          for (var n = e.length, r = "string" == typeof e ? e.split("") : e, i = 0; i < n; i++) {
            if (i in r && t.call(void 0, r[i], i, e)) return !0;
          }

          return !1;
        };

        function Q(e, t) {
          return 0 <= W(e, t);
        }

        function G(e, t) {
          var n;
          return (n = 0 <= (t = W(e, t))) && Array.prototype.splice.call(e, t, 1), n;
        }

        function q(e, t) {
          !function (e, t) {
            for (var n = "string" == typeof e ? e.split("") : e, r = e.length - 1; 0 <= r; --r) {
              r in n && t.call(void 0, n[r], r, e);
            }
          }(e, function (n, r) {
            t.call(void 0, n, r, e) && 1 == Array.prototype.splice.call(e, r, 1).length && 0;
          });
        }

        function J(e) {
          return Array.prototype.concat.apply([], arguments);
        }

        function X(e) {
          var t = e.length;

          if (0 < t) {
            for (var n = Array(t), r = 0; r < t; r++) {
              n[r] = e[r];
            }

            return n;
          }

          return [];
        }

        var K,
            $ = String.prototype.trim ? function (e) {
          return e.trim();
        } : function (e) {
          return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(e)[1];
        },
            ee = /&/g,
            te = /</g,
            ne = />/g,
            re = /"/g,
            ie = /'/g,
            oe = /\x00/g,
            ae = /[\x00&<>"']/;

        function se(e, t) {
          return -1 != e.indexOf(t);
        }

        function ue(e, t) {
          return e < t ? -1 : e > t ? 1 : 0;
        }

        e: {
          var ce = u.navigator;

          if (ce) {
            var le = ce.userAgent;

            if (le) {
              K = le;
              break e;
            }
          }

          K = "";
        }

        function he(e) {
          return se(K, e);
        }

        function de(e, t) {
          for (var n in e) {
            t.call(void 0, e[n], n, e);
          }
        }

        function fe(e) {
          for (var t in e) {
            return !1;
          }

          return !0;
        }

        function pe(e) {
          var t,
              n = {};

          for (t in e) {
            n[t] = e[t];
          }

          return n;
        }

        var me = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");

        function _e(e, t) {
          for (var n, r, i = 1; i < arguments.length; i++) {
            for (n in r = arguments[i]) {
              e[n] = r[n];
            }

            for (var o = 0; o < me.length; o++) {
              n = me[o], Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
          }
        }

        function ye(e, t) {
          e: {
            try {
              var n = e && e.ownerDocument,
                  r = n && (n.defaultView || n.parentWindow);

              if ((r = r || u).Element && r.Location) {
                var i = r;
                break e;
              }
            } catch (e) {}

            i = null;
          }

          if (i && void 0 !== i[t] && (!e || !(e instanceof i[t]) && (e instanceof i.Location || e instanceof i.Element))) {
            if (m(e)) try {
              var o = e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e);
            } catch (e) {
              o = "<object could not be stringified>";
            } else o = void 0 === e ? "undefined" : null === e ? "null" : typeof e;
            O("Argument is not a %s (or a non-Element, non-Location mock); got: %s", t, o);
          }
        }

        function ve(e, t) {
          this.a = e === we && t || "", this.b = be;
        }

        function ge(e) {
          return e instanceof ve && e.constructor === ve && e.b === be ? e.a : (O("expected object of type Const, got '" + e + "'"), "type_error:Const");
        }

        ve.prototype.ra = !0, ve.prototype.qa = function () {
          return this.a;
        }, ve.prototype.toString = function () {
          return "Const{" + this.a + "}";
        };
        var be = {},
            we = {},
            Te = new ve(we, "");

        function Me(e, t) {
          this.a = e === De && t || "", this.b = Ne;
        }

        function Ee(e) {
          return e instanceof Me && e.constructor === Me && e.b === Ne ? e.a : (O("expected object of type TrustedResourceUrl, got '" + e + "' of type " + d(e)), "type_error:TrustedResourceUrl");
        }

        function ke(e, t) {
          var n = ge(e);
          if (!Se.test(n)) throw Error("Invalid TrustedResourceUrl format: " + n);
          return e = n.replace(Le, function (e, r) {
            if (!Object.prototype.hasOwnProperty.call(t, r)) throw Error('Found marker, "' + r + '", in format string, "' + n + '", but no valid label mapping found in args: ' + JSON.stringify(t));
            return (e = t[r]) instanceof ve ? ge(e) : encodeURIComponent(String(e));
          }), new Me(De, e);
        }

        Me.prototype.ra = !0, Me.prototype.qa = function () {
          return this.a.toString();
        }, Me.prototype.toString = function () {
          return "TrustedResourceUrl{" + this.a + "}";
        };
        var Le = /%{(\w+)}/g,
            Se = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i,
            Ne = {},
            De = {};

        function Ie(e, t) {
          this.a = e === Oe && t || "", this.b = Ce;
        }

        function Re(e) {
          return e instanceof Ie && e.constructor === Ie && e.b === Ce ? e.a : (O("expected object of type SafeUrl, got '" + e + "' of type " + d(e)), "type_error:SafeUrl");
        }

        Ie.prototype.ra = !0, Ie.prototype.qa = function () {
          return this.a.toString();
        }, Ie.prototype.toString = function () {
          return "SafeUrl{" + this.a + "}";
        };
        var xe = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;

        function Ye(e) {
          return e instanceof Ie ? e : (e = "object" == typeof e && e.ra ? e.qa() : String(e), xe.test(e) || (e = "about:invalid#zClosurez"), new Ie(Oe, e));
        }

        var Ce = {},
            Oe = {};

        function Fe() {
          this.a = "", this.b = je;
        }

        function Ae(e) {
          return e instanceof Fe && e.constructor === Fe && e.b === je ? e.a : (O("expected object of type SafeHtml, got '" + e + "' of type " + d(e)), "type_error:SafeHtml");
        }

        Fe.prototype.ra = !0, Fe.prototype.qa = function () {
          return this.a.toString();
        }, Fe.prototype.toString = function () {
          return "SafeHtml{" + this.a + "}";
        };
        var je = {};

        function Ue(e) {
          var t = new Fe();
          return t.a = e, t;
        }

        Ue("<!DOCTYPE html>");
        var Pe = Ue("");

        function Ve(e, t) {
          for (var n = e.split("%s"), r = "", i = Array.prototype.slice.call(arguments, 1); i.length && 1 < n.length;) {
            r += n.shift() + i.shift();
          }

          return r + n.join("%s");
        }

        function We(e) {
          return ae.test(e) && (-1 != e.indexOf("&") && (e = e.replace(ee, "&amp;")), -1 != e.indexOf("<") && (e = e.replace(te, "&lt;")), -1 != e.indexOf(">") && (e = e.replace(ne, "&gt;")), -1 != e.indexOf('"') && (e = e.replace(re, "&quot;")), -1 != e.indexOf("'") && (e = e.replace(ie, "&#39;")), -1 != e.indexOf("\0") && (e = e.replace(oe, "&#0;"))), e;
        }

        function He(e) {
          return He[" "](e), e;
        }

        Ue("<br>"), He[" "] = h;
        var Be,
            ze,
            Ze = he("Opera"),
            Qe = he("Trident") || he("MSIE"),
            Ge = he("Edge"),
            qe = Ge || Qe,
            Je = he("Gecko") && !(se(K.toLowerCase(), "webkit") && !he("Edge")) && !(he("Trident") || he("MSIE")) && !he("Edge"),
            Xe = se(K.toLowerCase(), "webkit") && !he("Edge");

        function Ke() {
          var e = u.document;
          return e ? e.documentMode : void 0;
        }

        e: {
          var $e = "",
              et = (ze = K, Je ? /rv:([^\);]+)(\)|;)/.exec(ze) : Ge ? /Edge\/([\d\.]+)/.exec(ze) : Qe ? /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(ze) : Xe ? /WebKit\/(\S+)/.exec(ze) : Ze ? /(?:Version)[ \/]?(\S+)/.exec(ze) : void 0);

          if (et && ($e = et ? et[1] : ""), Qe) {
            var tt = Ke();

            if (null != tt && tt > parseFloat($e)) {
              Be = String(tt);
              break e;
            }
          }

          Be = $e;
        }

        var nt,
            rt = {};

        function it(e) {
          return function (e, t) {
            var n = rt;
            return Object.prototype.hasOwnProperty.call(n, e) ? n[e] : n[e] = t(e);
          }(e, function () {
            for (var t = 0, n = $(String(Be)).split("."), r = $(String(e)).split("."), i = Math.max(n.length, r.length), o = 0; 0 == t && o < i; o++) {
              var a = n[o] || "",
                  s = r[o] || "";

              do {
                if (a = /(\d*)(\D*)(.*)/.exec(a) || ["", "", "", ""], s = /(\d*)(\D*)(.*)/.exec(s) || ["", "", "", ""], 0 == a[0].length && 0 == s[0].length) break;
                t = ue(0 == a[1].length ? 0 : parseInt(a[1], 10), 0 == s[1].length ? 0 : parseInt(s[1], 10)) || ue(0 == a[2].length, 0 == s[2].length) || ue(a[2], s[2]), a = a[3], s = s[3];
              } while (0 == t);
            }

            return 0 <= t;
          });
        }

        nt = u.document && Qe ? Ke() : void 0;

        try {
          new self.OffscreenCanvas(0, 0).getContext("2d");
        } catch (ze) {}

        var ot = !Qe || 9 <= Number(nt);

        function at(e) {
          var t = document;
          return "string" == typeof e ? t.getElementById(e) : e;
        }

        function st(e, t) {
          de(t, function (t, n) {
            t && "object" == typeof t && t.ra && (t = t.qa()), "style" == n ? e.style.cssText = t : "class" == n ? e.className = t : "for" == n ? e.htmlFor = t : lt.hasOwnProperty(n) ? e.setAttribute(lt[n], t) : 0 == n.lastIndexOf("aria-", 0) || 0 == n.lastIndexOf("data-", 0) ? e.setAttribute(n, t) : e[n] = t;
          });
        }

        var ut,
            ct,
            lt = {
          cellpadding: "cellPadding",
          cellspacing: "cellSpacing",
          colspan: "colSpan",
          frameborder: "frameBorder",
          height: "height",
          maxlength: "maxLength",
          nonce: "nonce",
          role: "role",
          rowspan: "rowSpan",
          type: "type",
          usemap: "useMap",
          valign: "vAlign",
          width: "width"
        };

        function ht(e, t, n) {
          var r = arguments,
              i = document,
              o = String(r[0]),
              a = r[1];

          if (!ot && a && (a.name || a.type)) {
            if (o = ["<", o], a.name && o.push(' name="', We(a.name), '"'), a.type) {
              o.push(' type="', We(a.type), '"');
              var s = {};
              _e(s, a), delete s.type, a = s;
            }

            o.push(">"), o = o.join("");
          }

          return o = dt(i, o), a && ("string" == typeof a ? o.className = a : Array.isArray(a) ? o.className = a.join(" ") : st(o, a)), 2 < r.length && function (e, t, n) {
            function r(n) {
              n && t.appendChild("string" == typeof n ? e.createTextNode(n) : n);
            }

            for (var i = 2; i < n.length; i++) {
              var o = n[i];
              !f(o) || m(o) && 0 < o.nodeType ? r(o) : H(ft(o) ? X(o) : o, r);
            }
          }(i, o, r), o;
        }

        function dt(e, t) {
          return t = String(t), "application/xhtml+xml" === e.contentType && (t = t.toLowerCase()), e.createElement(t);
        }

        function ft(e) {
          if (e && "number" == typeof e.length) {
            if (m(e)) return "function" == typeof e.item || "string" == typeof e.item;
            if (p(e)) return "function" == typeof e.item;
          }

          return !1;
        }

        function pt(e) {
          u.setTimeout(function () {
            throw e;
          }, 0);
        }

        function mt() {
          var e = u.MessageChannel;

          if (void 0 === e && "undefined" != typeof window && window.postMessage && window.addEventListener && !he("Presto") && (e = function e() {
            var e,
                t,
                n = dt(document, "IFRAME");
            n.style.display = "none", e = n, t = new Me(De, ge(Te)), ye(e, "HTMLIFrameElement"), e.src = Ee(t).toString(), document.documentElement.appendChild(n);
            var r = n.contentWindow;
            (n = r.document).open(), n.write(Ae(Pe)), n.close();
            var i = "callImmediate" + Math.random(),
                o = "file:" == r.location.protocol ? "*" : r.location.protocol + "//" + r.location.host;
            n = w(function (e) {
              "*" != o && e.origin != o || e.data != i || this.port1.onmessage();
            }, this), r.addEventListener("message", n, !1), this.port1 = {}, this.port2 = {
              postMessage: function postMessage() {
                r.postMessage(i, o);
              }
            };
          }), void 0 !== e && !he("Trident") && !he("MSIE")) {
            var t = new e(),
                n = {},
                r = n;
            return t.port1.onmessage = function () {
              if (void 0 !== n.next) {
                var e = (n = n.next).Db;
                n.Db = null, e();
              }
            }, function (e) {
              r.next = {
                Db: e
              }, r = r.next, t.port2.postMessage(0);
            };
          }

          return function (e) {
            u.setTimeout(e, 0);
          };
        }

        function _t(e, t) {
          ct || function () {
            if (u.Promise && u.Promise.resolve) {
              var e = u.Promise.resolve(void 0);

              ct = function ct() {
                e.then(gt);
              };
            } else ct = function ct() {
              var e = gt;
              !p(u.setImmediate) || u.Window && u.Window.prototype && !he("Edge") && u.Window.prototype.setImmediate == u.setImmediate ? (ut || (ut = mt()), ut(e)) : u.setImmediate(e);
            };
          }(), yt || (ct(), yt = !0), vt.add(e, t);
        }

        var yt = !1,
            vt = new j();

        function gt() {
          for (var e; e = P();) {
            try {
              e.a.call(e.b);
            } catch (e) {
              pt(e);
            }

            A(U, e);
          }

          yt = !1;
        }

        function bt(e, t) {
          if (this.a = wt, this.i = void 0, this.f = this.b = this.c = null, this.g = this.h = !1, e != h) try {
            var n = this;
            e.call(t, function (e) {
              Yt(n, Tt, e);
            }, function (e) {
              if (!(e instanceof Pt)) try {
                if (e instanceof Error) throw e;
                throw Error("Promise rejected.");
              } catch (e) {}
              Yt(n, Mt, e);
            });
          } catch (e) {
            Yt(this, Mt, e);
          }
        }

        var wt = 0,
            Tt = 2,
            Mt = 3;

        function Et() {
          this.next = this.f = this.b = this.g = this.a = null, this.c = !1;
        }

        Et.prototype.reset = function () {
          this.f = this.b = this.g = this.a = null, this.c = !1;
        };

        var kt = new F(function () {
          return new Et();
        }, function (e) {
          e.reset();
        });

        function Lt(e, t, n) {
          var r = kt.get();
          return r.g = e, r.b = t, r.f = n, r;
        }

        function St(e) {
          if (e instanceof bt) return e;
          var t = new bt(h);
          return Yt(t, Tt, e), t;
        }

        function Nt(e) {
          return new bt(function (t, n) {
            n(e);
          });
        }

        function Dt(e, t, n) {
          Ct(e, t, n, null) || _t(T(t, e));
        }

        function It(e) {
          return new bt(function (t) {
            var n = e.length,
                r = [];
            if (n) for (var i = function i(e, _i6, o) {
              n--, r[e] = _i6 ? {
                Mb: !0,
                value: o
              } : {
                Mb: !1,
                reason: o
              }, 0 == n && t(r);
            }, o = 0; o < e.length; o++) {
              Dt(e[o], T(i, o, !0), T(i, o, !1));
            } else t(r);
          });
        }

        function Rt(e, t) {
          e.b || e.a != Tt && e.a != Mt || Ot(e), e.f ? e.f.next = t : e.b = t, e.f = t;
        }

        function xt(e, t, n, r) {
          var i = Lt(null, null, null);
          return i.a = new bt(function (e, o) {
            i.g = t ? function (n) {
              try {
                var i = t.call(r, n);
                e(i);
              } catch (e) {
                o(e);
              }
            } : e, i.b = n ? function (t) {
              try {
                var i = n.call(r, t);
                void 0 === i && t instanceof Pt ? o(t) : e(i);
              } catch (e) {
                o(e);
              }
            } : o;
          }), i.a.c = e, Rt(e, i), i.a;
        }

        function Yt(e, t, n) {
          e.a == wt && (e === n && (t = Mt, n = new TypeError("Promise cannot resolve to itself")), e.a = 1, Ct(n, e.Yc, e.Zc, e) || (e.i = n, e.a = t, e.c = null, Ot(e), t != Mt || n instanceof Pt || function (e, t) {
            e.g = !0, _t(function () {
              e.g && Ut.call(null, t);
            });
          }(e, n)));
        }

        function Ct(e, t, n, r) {
          if (e instanceof bt) return Rt(e, Lt(t || h, n || null, r)), !0;
          if (x(e)) return e.then(t, n, r), !0;
          if (m(e)) try {
            var i = e.then;
            if (p(i)) return function (e, t, n, r, i) {
              function o(e) {
                a || (a = !0, r.call(i, e));
              }

              var a = !1;

              try {
                t.call(e, function (e) {
                  a || (a = !0, n.call(i, e));
                }, o);
              } catch (e) {
                o(e);
              }
            }(e, i, t, n, r), !0;
          } catch (e) {
            return n.call(r, e), !0;
          }
          return !1;
        }

        function Ot(e) {
          e.h || (e.h = !0, _t(e.ec, e));
        }

        function Ft(e) {
          var t = null;
          return e.b && (t = e.b, e.b = t.next, t.next = null), e.b || (e.f = null), t;
        }

        function At(e, t, n, r) {
          if (n == Mt && t.b && !t.c) for (; e && e.g; e = e.c) {
            e.g = !1;
          }
          if (t.a) t.a.c = null, jt(t, n, r);else try {
            t.c ? t.g.call(t.f) : jt(t, n, r);
          } catch (e) {
            Ut.call(null, e);
          }
          A(kt, t);
        }

        function jt(e, t, n) {
          t == Tt ? e.g.call(e.f, n) : e.b && e.b.call(e.f, n);
        }

        bt.prototype.then = function (e, t, n) {
          return xt(this, p(e) ? e : null, p(t) ? t : null, n);
        }, bt.prototype.$goog_Thenable = !0, (t = bt.prototype).ma = function (e, t) {
          return (e = Lt(e, e, t)).c = !0, Rt(this, e), this;
        }, t.o = function (e, t) {
          return xt(this, null, e, t);
        }, t.cancel = function (e) {
          if (this.a == wt) {
            var t = new Pt(e);

            _t(function () {
              !function e(t, n) {
                if (t.a == wt) if (t.c) {
                  var r = t.c;

                  if (r.b) {
                    for (var i = 0, o = null, a = null, s = r.b; s && (s.c || (i++, s.a == t && (o = s), !(o && 1 < i))); s = s.next) {
                      o || (a = s);
                    }

                    o && (r.a == wt && 1 == i ? e(r, n) : (a ? ((i = a).next == r.f && (r.f = i), i.next = i.next.next) : Ft(r), At(r, o, Mt, n)));
                  }

                  t.c = null;
                } else Yt(t, Mt, n);
              }(this, t);
            }, this);
          }
        }, t.Yc = function (e) {
          this.a = wt, Yt(this, Tt, e);
        }, t.Zc = function (e) {
          this.a = wt, Yt(this, Mt, e);
        }, t.ec = function () {
          for (var e; e = Ft(this);) {
            At(this, e, this.a, this.i);
          }

          this.h = !1;
        };
        var Ut = pt;

        function Pt(e) {
          Y.call(this, e);
        }

        function Vt() {
          0 != Wt && (Ht[_(this)] = this), this.wa = this.wa, this.na = this.na;
        }

        E(Pt, Y), Pt.prototype.name = "cancel";
        var Wt = 0,
            Ht = {};

        function Bt(e) {
          if (!e.wa && (e.wa = !0, e.Ba(), 0 != Wt)) {
            var t = _(e);

            if (0 != Wt && e.na && 0 < e.na.length) throw Error(e + " did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");
            delete Ht[t];
          }
        }

        Vt.prototype.wa = !1, Vt.prototype.Ba = function () {
          if (this.na) for (; this.na.length;) {
            this.na.shift()();
          }
        };

        var zt = Object.freeze || function (e) {
          return e;
        },
            Zt = !Qe || 9 <= Number(nt),
            Qt = Qe && !it("9"),
            Gt = function () {
          if (!u.addEventListener || !Object.defineProperty) return !1;
          var e = !1,
              t = Object.defineProperty({}, "passive", {
            get: function get() {
              e = !0;
            }
          });

          try {
            u.addEventListener("test", h, t), u.removeEventListener("test", h, t);
          } catch (e) {}

          return e;
        }();

        function qt(e, t) {
          this.type = e, this.b = this.target = t, this.defaultPrevented = !1;
        }

        function Jt(e, t) {
          if (qt.call(this, e ? e.type : ""), this.relatedTarget = this.b = this.target = null, this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0, this.key = "", this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1, this.pointerId = 0, this.pointerType = "", this.a = null, e) {
            var n = this.type = e.type,
                r = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : null;

            if (this.target = e.target || e.srcElement, this.b = t, t = e.relatedTarget) {
              if (Je) {
                e: {
                  try {
                    He(t.nodeName);
                    var i = !0;
                    break e;
                  } catch (e) {}

                  i = !1;
                }

                i || (t = null);
              }
            } else "mouseover" == n ? t = e.fromElement : "mouseout" == n && (t = e.toElement);

            this.relatedTarget = t, r ? (this.clientX = void 0 !== r.clientX ? r.clientX : r.pageX, this.clientY = void 0 !== r.clientY ? r.clientY : r.pageY, this.screenX = r.screenX || 0, this.screenY = r.screenY || 0) : (this.clientX = void 0 !== e.clientX ? e.clientX : e.pageX, this.clientY = void 0 !== e.clientY ? e.clientY : e.pageY, this.screenX = e.screenX || 0, this.screenY = e.screenY || 0), this.button = e.button, this.key = e.key || "", this.ctrlKey = e.ctrlKey, this.altKey = e.altKey, this.shiftKey = e.shiftKey, this.metaKey = e.metaKey, this.pointerId = e.pointerId || 0, this.pointerType = "string" == typeof e.pointerType ? e.pointerType : Xt[e.pointerType] || "", this.a = e, e.defaultPrevented && this.preventDefault();
          }
        }

        qt.prototype.preventDefault = function () {
          this.defaultPrevented = !0;
        }, E(Jt, qt);
        var Xt = zt({
          2: "touch",
          3: "pen",
          4: "mouse"
        });
        Jt.prototype.preventDefault = function () {
          Jt.Za.preventDefault.call(this);
          var e = this.a;
          if (e.preventDefault) e.preventDefault();else if (e.returnValue = !1, Qt) try {
            (e.ctrlKey || 112 <= e.keyCode && 123 >= e.keyCode) && (e.keyCode = -1);
          } catch (e) {}
        }, Jt.prototype.f = function () {
          return this.a;
        };
        var Kt = "closure_listenable_" + (1e6 * Math.random() | 0),
            $t = 0;

        function en(e, t, n, r, i) {
          this.listener = e, this.proxy = null, this.src = t, this.type = n, this.capture = !!r, this.Ta = i, this.key = ++$t, this.ua = this.Na = !1;
        }

        function tn(e) {
          e.ua = !0, e.listener = null, e.proxy = null, e.src = null, e.Ta = null;
        }

        function nn(e) {
          this.src = e, this.a = {}, this.b = 0;
        }

        function rn(e, t) {
          var n = t.type;
          n in e.a && G(e.a[n], t) && (tn(t), 0 == e.a[n].length && (delete e.a[n], e.b--));
        }

        function on(e, t, n, r) {
          for (var i = 0; i < e.length; ++i) {
            var o = e[i];
            if (!o.ua && o.listener == t && o.capture == !!n && o.Ta == r) return i;
          }

          return -1;
        }

        nn.prototype.add = function (e, t, n, r, i) {
          var o = e.toString();
          (e = this.a[o]) || (e = this.a[o] = [], this.b++);
          var a = on(e, t, r, i);
          return -1 < a ? (t = e[a], n || (t.Na = !1)) : ((t = new en(t, this.src, o, !!r, i)).Na = n, e.push(t)), t;
        };

        var an = "closure_lm_" + (1e6 * Math.random() | 0),
            sn = {};

        function un(e, t, n, r, i) {
          if (r && r.once) ln(e, t, n, r, i);else if (Array.isArray(t)) for (var o = 0; o < t.length; o++) {
            un(e, t[o], n, r, i);
          } else n = gn(n), e && e[Kt] ? wn(e, t, n, m(r) ? !!r.capture : !!r, i) : cn(e, t, n, !1, r, i);
        }

        function cn(e, t, n, r, i, o) {
          if (!t) throw Error("Invalid event type");
          var a = m(i) ? !!i.capture : !!i,
              s = yn(e);

          if (s || (e[an] = s = new nn(e)), !(n = s.add(t, n, r, a, o)).proxy) {
            if (r = function () {
              var e = _n,
                  t = Zt ? function (n) {
                return e.call(t.src, t.listener, n);
              } : function (n) {
                if (!(n = e.call(t.src, t.listener, n))) return n;
              };
              return t;
            }(), n.proxy = r, r.src = e, r.listener = n, e.addEventListener) Gt || (i = a), void 0 === i && (i = !1), e.addEventListener(t.toString(), r, i);else if (e.attachEvent) e.attachEvent(fn(t.toString()), r);else {
              if (!e.addListener || !e.removeListener) throw Error("addEventListener and attachEvent are unavailable.");
              e.addListener(r);
            }
            0;
          }
        }

        function ln(e, t, n, r, i) {
          if (Array.isArray(t)) for (var o = 0; o < t.length; o++) {
            ln(e, t[o], n, r, i);
          } else n = gn(n), e && e[Kt] ? Tn(e, t, n, m(r) ? !!r.capture : !!r, i) : cn(e, t, n, !0, r, i);
        }

        function hn(e, t, n, r, i) {
          if (Array.isArray(t)) for (var o = 0; o < t.length; o++) {
            hn(e, t[o], n, r, i);
          } else r = m(r) ? !!r.capture : !!r, n = gn(n), e && e[Kt] ? (e = e.u, (t = String(t).toString()) in e.a && -1 < (n = on(o = e.a[t], n, r, i)) && (tn(o[n]), Array.prototype.splice.call(o, n, 1), 0 == o.length && (delete e.a[t], e.b--))) : e && (e = yn(e)) && (t = e.a[t.toString()], e = -1, t && (e = on(t, n, r, i)), (n = -1 < e ? t[e] : null) && dn(n));
        }

        function dn(e) {
          if ("number" != typeof e && e && !e.ua) {
            var t = e.src;
            if (t && t[Kt]) rn(t.u, e);else {
              var n = e.type,
                  r = e.proxy;
              t.removeEventListener ? t.removeEventListener(n, r, e.capture) : t.detachEvent ? t.detachEvent(fn(n), r) : t.addListener && t.removeListener && t.removeListener(r), 0, (n = yn(t)) ? (rn(n, e), 0 == n.b && (n.src = null, t[an] = null)) : tn(e);
            }
          }
        }

        function fn(e) {
          return e in sn ? sn[e] : sn[e] = "on" + e;
        }

        function pn(e, t, n, r) {
          var i = !0;
          if ((e = yn(e)) && (t = e.a[t.toString()])) for (t = t.concat(), e = 0; e < t.length; e++) {
            var o = t[e];
            o && o.capture == n && !o.ua && (o = mn(o, r), i = i && !1 !== o);
          }
          return i;
        }

        function mn(e, t) {
          var n = e.listener,
              r = e.Ta || e.src;
          return e.Na && dn(e), n.call(r, t);
        }

        function _n(e, t) {
          if (e.ua) return !0;

          if (!Zt) {
            if (!t) e: {
              t = ["window", "event"];

              for (var n = u, r = 0; r < t.length; r++) {
                if (null == (n = n[t[r]])) {
                  t = null;
                  break e;
                }
              }

              t = n;
            }

            if (t = new Jt(r = t, this), n = !0, !(0 > r.keyCode || null != r.returnValue)) {
              e: {
                var i = !1;
                if (0 == r.keyCode) try {
                  r.keyCode = -1;
                  break e;
                } catch (e) {
                  i = !0;
                }
                (i || null == r.returnValue) && (r.returnValue = !0);
              }

              for (r = [], i = t.b; i; i = i.parentNode) {
                r.push(i);
              }

              for (e = e.type, i = r.length - 1; 0 <= i; i--) {
                t.b = r[i];
                var o = pn(r[i], e, !0, t);
                n = n && o;
              }

              for (i = 0; i < r.length; i++) {
                t.b = r[i], o = pn(r[i], e, !1, t), n = n && o;
              }
            }

            return n;
          }

          return mn(e, new Jt(t, this));
        }

        function yn(e) {
          return (e = e[an]) instanceof nn ? e : null;
        }

        var vn = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);

        function gn(e) {
          return p(e) ? e : (e[vn] || (e[vn] = function (t) {
            return e.handleEvent(t);
          }), e[vn]);
        }

        function bn() {
          Vt.call(this), this.u = new nn(this), this.Yb = this, this.eb = null;
        }

        function wn(e, t, n, r, i) {
          e.u.add(String(t), n, !1, r, i);
        }

        function Tn(e, t, n, r, i) {
          e.u.add(String(t), n, !0, r, i);
        }

        function Mn(e, t, n, r) {
          if (!(t = e.u.a[String(t)])) return !0;
          t = t.concat();

          for (var i = !0, o = 0; o < t.length; ++o) {
            var a = t[o];

            if (a && !a.ua && a.capture == n) {
              var s = a.listener,
                  u = a.Ta || a.src;
              a.Na && rn(e.u, a), i = !1 !== s.call(u, r) && i;
            }
          }

          return i && !r.defaultPrevented;
        }

        function En(e, t, n) {
          if (p(e)) n && (e = w(e, n));else {
            if (!e || "function" != typeof e.handleEvent) throw Error("Invalid listener argument");
            e = w(e.handleEvent, e);
          }
          return 2147483647 < Number(t) ? -1 : u.setTimeout(e, t || 0);
        }

        function kn(e) {
          var t = null;
          return new bt(function (n, r) {
            -1 == (t = En(function () {
              n(void 0);
            }, e)) && r(Error("Failed to schedule timer."));
          }).o(function (e) {
            throw u.clearTimeout(t), e;
          });
        }

        function Ln(e) {
          if (e.V && "function" == typeof e.V) return e.V();
          if ("string" == typeof e) return e.split("");

          if (f(e)) {
            for (var t = [], n = e.length, r = 0; r < n; r++) {
              t.push(e[r]);
            }

            return t;
          }

          for (r in t = [], n = 0, e) {
            t[n++] = e[r];
          }

          return t;
        }

        function Sn(e) {
          if (e.X && "function" == typeof e.X) return e.X();

          if (!e.V || "function" != typeof e.V) {
            if (f(e) || "string" == typeof e) {
              var t = [];
              e = e.length;

              for (var n = 0; n < e; n++) {
                t.push(n);
              }

              return t;
            }

            for (var r in t = [], n = 0, e) {
              t[n++] = r;
            }

            return t;
          }
        }

        function Nn(e, t) {
          this.b = {}, this.a = [], this.c = 0;
          var n = arguments.length;

          if (1 < n) {
            if (n % 2) throw Error("Uneven number of arguments");

            for (var r = 0; r < n; r += 2) {
              this.set(arguments[r], arguments[r + 1]);
            }
          } else if (e) if (e instanceof Nn) for (n = e.X(), r = 0; r < n.length; r++) {
            this.set(n[r], e.get(n[r]));
          } else for (r in e) {
            this.set(r, e[r]);
          }
        }

        function Dn(e) {
          if (e.c != e.a.length) {
            for (var t = 0, n = 0; t < e.a.length;) {
              var r = e.a[t];
              In(e.b, r) && (e.a[n++] = r), t++;
            }

            e.a.length = n;
          }

          if (e.c != e.a.length) {
            var i = {};

            for (n = t = 0; t < e.a.length;) {
              In(i, r = e.a[t]) || (e.a[n++] = r, i[r] = 1), t++;
            }

            e.a.length = n;
          }
        }

        function In(e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }

        E(bn, Vt), bn.prototype[Kt] = !0, bn.prototype.addEventListener = function (e, t, n, r) {
          un(this, e, t, n, r);
        }, bn.prototype.removeEventListener = function (e, t, n, r) {
          hn(this, e, t, n, r);
        }, bn.prototype.dispatchEvent = function (e) {
          var t,
              n = this.eb;
          if (n) for (t = []; n; n = n.eb) {
            t.push(n);
          }
          n = this.Yb;
          var r = e.type || e;
          if ("string" == typeof e) e = new qt(e, n);else if (e instanceof qt) e.target = e.target || n;else {
            var i = e;

            _e(e = new qt(r, n), i);
          }
          if (i = !0, t) for (var o = t.length - 1; 0 <= o; o--) {
            var a = e.b = t[o];
            i = Mn(a, r, !0, e) && i;
          }
          if (i = Mn(a = e.b = n, r, !0, e) && i, i = Mn(a, r, !1, e) && i, t) for (o = 0; o < t.length; o++) {
            i = Mn(a = e.b = t[o], r, !1, e) && i;
          }
          return i;
        }, bn.prototype.Ba = function () {
          if (bn.Za.Ba.call(this), this.u) {
            var e,
                t = this.u;

            for (e in t.a) {
              for (var n = t.a[e], r = 0; r < n.length; r++) {
                0, tn(n[r]);
              }

              delete t.a[e], t.b--;
            }
          }

          this.eb = null;
        }, (t = Nn.prototype).V = function () {
          Dn(this);

          for (var e = [], t = 0; t < this.a.length; t++) {
            e.push(this.b[this.a[t]]);
          }

          return e;
        }, t.X = function () {
          return Dn(this), this.a.concat();
        }, t.clear = function () {
          this.b = {}, this.c = this.a.length = 0;
        }, t.get = function (e, t) {
          return In(this.b, e) ? this.b[e] : t;
        }, t.set = function (e, t) {
          In(this.b, e) || (this.c++, this.a.push(e)), this.b[e] = t;
        }, t.forEach = function (e, t) {
          for (var n = this.X(), r = 0; r < n.length; r++) {
            var i = n[r],
                o = this.get(i);
            e.call(t, o, i, this);
          }
        };
        var Rn = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/\\#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;

        function xn(e, t) {
          var n;
          this.b = this.i = this.f = "", this.l = null, this.g = this.c = "", this.h = !1, e instanceof xn ? (this.h = void 0 !== t ? t : e.h, Yn(this, e.f), this.i = e.i, this.b = e.b, Cn(this, e.l), this.c = e.c, On(this, er(e.a)), this.g = e.g) : e && (n = String(e).match(Rn)) ? (this.h = !!t, Yn(this, n[1] || "", !0), this.i = Pn(n[2] || ""), this.b = Pn(n[3] || "", !0), Cn(this, n[4]), this.c = Pn(n[5] || "", !0), On(this, n[6] || "", !0), this.g = Pn(n[7] || "")) : (this.h = !!t, this.a = new Gn(null, this.h));
        }

        function Yn(e, t, n) {
          e.f = n ? Pn(t, !0) : t, e.f && (e.f = e.f.replace(/:$/, ""));
        }

        function Cn(e, t) {
          if (t) {
            if (t = Number(t), isNaN(t) || 0 > t) throw Error("Bad port number " + t);
            e.l = t;
          } else e.l = null;
        }

        function On(e, t, n) {
          t instanceof Gn ? (e.a = t, function (e, t) {
            t && !e.f && (qn(e), e.c = null, e.a.forEach(function (e, t) {
              var n = t.toLowerCase();
              t != n && (Xn(this, t), $n(this, n, e));
            }, e)), e.f = t;
          }(e.a, e.h)) : (n || (t = Vn(t, Zn)), e.a = new Gn(t, e.h));
        }

        function Fn(e, t, n) {
          e.a.set(t, n);
        }

        function An(e, t) {
          return e.a.get(t);
        }

        function jn(e) {
          return e instanceof xn ? new xn(e) : new xn(e, void 0);
        }

        function Un(e, t) {
          var n = new xn(null, void 0);
          return Yn(n, "https"), e && (n.b = e), t && (n.c = t), n;
        }

        function Pn(e, t) {
          return e ? t ? decodeURI(e.replace(/%25/g, "%2525")) : decodeURIComponent(e) : "";
        }

        function Vn(e, t, n) {
          return "string" == typeof e ? (e = encodeURI(e).replace(t, Wn), n && (e = e.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), e) : null;
        }

        function Wn(e) {
          return "%" + ((e = e.charCodeAt(0)) >> 4 & 15).toString(16) + (15 & e).toString(16);
        }

        xn.prototype.toString = function () {
          var e = [],
              t = this.f;
          t && e.push(Vn(t, Hn, !0), ":");
          var n = this.b;
          return (n || "file" == t) && (e.push("//"), (t = this.i) && e.push(Vn(t, Hn, !0), "@"), e.push(encodeURIComponent(String(n)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), null != (n = this.l) && e.push(":", String(n))), (n = this.c) && (this.b && "/" != n.charAt(0) && e.push("/"), e.push(Vn(n, "/" == n.charAt(0) ? zn : Bn, !0))), (n = this.a.toString()) && e.push("?", n), (n = this.g) && e.push("#", Vn(n, Qn)), e.join("");
        }, xn.prototype.resolve = function (e) {
          var t = new xn(this),
              n = !!e.f;
          n ? Yn(t, e.f) : n = !!e.i, n ? t.i = e.i : n = !!e.b, n ? t.b = e.b : n = null != e.l;
          var r = e.c;
          if (n) Cn(t, e.l);else if (n = !!e.c) {
            if ("/" != r.charAt(0)) if (this.b && !this.c) r = "/" + r;else {
              var i = t.c.lastIndexOf("/");
              -1 != i && (r = t.c.substr(0, i + 1) + r);
            }
            if (".." == (i = r) || "." == i) r = "";else if (se(i, "./") || se(i, "/.")) {
              r = 0 == i.lastIndexOf("/", 0), i = i.split("/");

              for (var o = [], a = 0; a < i.length;) {
                var s = i[a++];
                "." == s ? r && a == i.length && o.push("") : ".." == s ? ((1 < o.length || 1 == o.length && "" != o[0]) && o.pop(), r && a == i.length && o.push("")) : (o.push(s), r = !0);
              }

              r = o.join("/");
            } else r = i;
          }
          return n ? t.c = r : n = "" !== e.a.toString(), n ? On(t, er(e.a)) : n = !!e.g, n && (t.g = e.g), t;
        };
        var Hn = /[#\/\?@]/g,
            Bn = /[#\?:]/g,
            zn = /[#\?]/g,
            Zn = /[#\?@]/g,
            Qn = /#/g;

        function Gn(e, t) {
          this.b = this.a = null, this.c = e || null, this.f = !!t;
        }

        function qn(e) {
          e.a || (e.a = new Nn(), e.b = 0, e.c && function (e, t) {
            if (e) {
              e = e.split("&");

              for (var n = 0; n < e.length; n++) {
                var r = e[n].indexOf("="),
                    i = null;

                if (0 <= r) {
                  var o = e[n].substring(0, r);
                  i = e[n].substring(r + 1);
                } else o = e[n];

                t(o, i ? decodeURIComponent(i.replace(/\+/g, " ")) : "");
              }
            }
          }(e.c, function (t, n) {
            e.add(decodeURIComponent(t.replace(/\+/g, " ")), n);
          }));
        }

        function Jn(e) {
          var t = Sn(e);
          if (void 0 === t) throw Error("Keys are undefined");
          var n = new Gn(null, void 0);
          e = Ln(e);

          for (var r = 0; r < t.length; r++) {
            var i = t[r],
                o = e[r];
            Array.isArray(o) ? $n(n, i, o) : n.add(i, o);
          }

          return n;
        }

        function Xn(e, t) {
          qn(e), t = tr(e, t), In(e.a.b, t) && (e.c = null, e.b -= e.a.get(t).length, In((e = e.a).b, t) && (delete e.b[t], e.c--, e.a.length > 2 * e.c && Dn(e)));
        }

        function Kn(e, t) {
          return qn(e), t = tr(e, t), In(e.a.b, t);
        }

        function $n(e, t, n) {
          Xn(e, t), 0 < n.length && (e.c = null, e.a.set(tr(e, t), X(n)), e.b += n.length);
        }

        function er(e) {
          var t = new Gn();
          return t.c = e.c, e.a && (t.a = new Nn(e.a), t.b = e.b), t;
        }

        function tr(e, t) {
          return t = String(t), e.f && (t = t.toLowerCase()), t;
        }

        function nr(e) {
          var t = [];
          return function e(t, n, r) {
            if (null == n) r.push("null");else {
              if ("object" == typeof n) {
                if (Array.isArray(n)) {
                  var i = n;
                  n = i.length, r.push("[");

                  for (var o = "", a = 0; a < n; a++) {
                    r.push(o), e(t, i[a], r), o = ",";
                  }

                  return void r.push("]");
                }

                if (!(n instanceof String || n instanceof Number || n instanceof Boolean)) {
                  for (i in r.push("{"), o = "", n) {
                    Object.prototype.hasOwnProperty.call(n, i) && "function" != typeof (a = n[i]) && (r.push(o), ar(i, r), r.push(":"), e(t, a, r), o = ",");
                  }

                  return void r.push("}");
                }

                n = n.valueOf();
              }

              switch (typeof n) {
                case "string":
                  ar(n, r);
                  break;

                case "number":
                  r.push(isFinite(n) && !isNaN(n) ? String(n) : "null");
                  break;

                case "boolean":
                  r.push(String(n));
                  break;

                case "function":
                  r.push("null");
                  break;

                default:
                  throw Error("Unknown type: " + typeof n);
              }
            }
          }(new rr(), e, t), t.join("");
        }

        function rr() {}

        (t = Gn.prototype).add = function (e, t) {
          qn(this), this.c = null, e = tr(this, e);
          var n = this.a.get(e);
          return n || this.a.set(e, n = []), n.push(t), this.b += 1, this;
        }, t.clear = function () {
          this.a = this.c = null, this.b = 0;
        }, t.forEach = function (e, t) {
          qn(this), this.a.forEach(function (n, r) {
            H(n, function (n) {
              e.call(t, n, r, this);
            }, this);
          }, this);
        }, t.X = function () {
          qn(this);

          for (var e = this.a.V(), t = this.a.X(), n = [], r = 0; r < t.length; r++) {
            for (var i = e[r], o = 0; o < i.length; o++) {
              n.push(t[r]);
            }
          }

          return n;
        }, t.V = function (e) {
          qn(this);
          var t = [];
          if ("string" == typeof e) Kn(this, e) && (t = J(t, this.a.get(tr(this, e))));else {
            e = this.a.V();

            for (var n = 0; n < e.length; n++) {
              t = J(t, e[n]);
            }
          }
          return t;
        }, t.set = function (e, t) {
          return qn(this), this.c = null, Kn(this, e = tr(this, e)) && (this.b -= this.a.get(e).length), this.a.set(e, [t]), this.b += 1, this;
        }, t.get = function (e, t) {
          return e && 0 < (e = this.V(e)).length ? String(e[0]) : t;
        }, t.toString = function () {
          if (this.c) return this.c;
          if (!this.a) return "";

          for (var e = [], t = this.a.X(), n = 0; n < t.length; n++) {
            var r = t[n],
                i = encodeURIComponent(String(r));
            r = this.V(r);

            for (var o = 0; o < r.length; o++) {
              var a = i;
              "" !== r[o] && (a += "=" + encodeURIComponent(String(r[o]))), e.push(a);
            }
          }

          return this.c = e.join("&");
        };
        var ir = {
          '"': '\\"',
          "\\": "\\\\",
          "/": "\\/",
          "\b": "\\b",
          "\f": "\\f",
          "\n": "\\n",
          "\r": "\\r",
          "\t": "\\t",
          "\v": "\\u000b"
        },
            or = /\uffff/.test("￿") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;

        function ar(e, t) {
          t.push('"', e.replace(or, function (e) {
            var t = ir[e];
            return t || (t = "\\u" + (65536 | e.charCodeAt(0)).toString(16).substr(1), ir[e] = t), t;
          }), '"');
        }

        function sr() {
          var e = Lr();
          return Qe && !!nt && 11 == nt || /Edge\/\d+/.test(e);
        }

        function ur() {
          return u.window && u.window.location.href || self && self.location && self.location.href || "";
        }

        function cr(e, t) {
          t = t || u.window;
          var n = "about:blank";
          e && (n = Re(Ye(e))), t.location.href = n;
        }

        function lr(e) {
          return !!((e = (e || Lr()).toLowerCase()).match(/android/) || e.match(/webos/) || e.match(/iphone|ipad|ipod/) || e.match(/blackberry/) || e.match(/windows phone/) || e.match(/iemobile/));
        }

        function hr(e) {
          e = e || u.window;

          try {
            e.close();
          } catch (e) {}
        }

        function dr(e, t, n) {
          var r = Math.floor(1e9 * Math.random()).toString();
          t = t || 500, n = n || 600;
          var i = (window.screen.availHeight - n) / 2,
              o = (window.screen.availWidth - t) / 2;

          for (a in t = {
            width: t,
            height: n,
            top: 0 < i ? i : 0,
            left: 0 < o ? o : 0,
            location: !0,
            resizable: !0,
            statusbar: !0,
            toolbar: !1
          }, n = Lr().toLowerCase(), r && (t.target = r, se(n, "crios/") && (t.target = "_blank")), Mr(Lr()) == wr && (e = e || "http://localhost", t.scrollbars = !0), n = e || "", (e = t) || (e = {}), r = window, t = n instanceof Ie ? n : Ye(void 0 !== n.href ? n.href : String(n)), n = e.target || n.target, i = [], e) {
            switch (a) {
              case "width":
              case "height":
              case "top":
              case "left":
                i.push(a + "=" + e[a]);
                break;

              case "target":
              case "noopener":
              case "noreferrer":
                break;

              default:
                i.push(a + "=" + (e[a] ? 1 : 0));
            }
          }

          var a = i.join(",");
          if ((he("iPhone") && !he("iPod") && !he("iPad") || he("iPad") || he("iPod")) && r.navigator && r.navigator.standalone && n && "_self" != n ? (ye(a = dt(document, "A"), "HTMLAnchorElement"), t instanceof Ie || t instanceof Ie || (t = "object" == typeof t && t.ra ? t.qa() : String(t), xe.test(t) || (t = "about:invalid#zClosurez"), t = new Ie(Oe, t)), a.href = Re(t), a.setAttribute("target", n), e.noreferrer && a.setAttribute("rel", "noreferrer"), (e = document.createEvent("MouseEvent")).initMouseEvent("click", !0, !0, r, 1), a.dispatchEvent(e), a = {}) : e.noreferrer ? (a = r.open("", n, a), e = Re(t), a && (qe && se(e, ";") && (e = "'" + e.replace(/'/g, "%27") + "'"), a.opener = null, e = Ue('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url=' + We(e) + '">'), r = a.document) && (r.write(Ae(e)), r.close())) : (a = r.open(Re(t), n, a)) && e.noopener && (a.opener = null), a) try {
            a.focus();
          } catch (e) {}
          return a;
        }

        var fr = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
            pr = /^[^@]+@[^@]+$/;

        function mr() {
          var e = null;
          return new bt(function (t) {
            "complete" == u.document.readyState ? t() : (e = function e() {
              t();
            }, ln(window, "load", e));
          }).o(function (t) {
            throw hn(window, "load", e), t;
          });
        }

        function _r(e) {
          return e = e || Lr(), !("file:" !== Rr() && "ionic:" !== Rr() || !e.toLowerCase().match(/iphone|ipad|ipod|android/));
        }

        function yr() {
          var e = u.window;

          try {
            return !(!e || e == e.top);
          } catch (e) {
            return !1;
          }
        }

        function vr() {
          return void 0 !== u.WorkerGlobalScope && "function" == typeof u.importScripts;
        }

        function gr() {
          return r.a.INTERNAL.hasOwnProperty("reactNative") ? "ReactNative" : r.a.INTERNAL.hasOwnProperty("node") ? "Node" : vr() ? "Worker" : "Browser";
        }

        function br() {
          var e = gr();
          return "ReactNative" === e || "Node" === e;
        }

        var wr = "Firefox",
            Tr = "Chrome";

        function Mr(e) {
          var t = e.toLowerCase();
          return se(t, "opera/") || se(t, "opr/") || se(t, "opios/") ? "Opera" : se(t, "iemobile") ? "IEMobile" : se(t, "msie") || se(t, "trident/") ? "IE" : se(t, "edge/") ? "Edge" : se(t, "firefox/") ? wr : se(t, "silk/") ? "Silk" : se(t, "blackberry") ? "Blackberry" : se(t, "webos") ? "Webos" : !se(t, "safari/") || se(t, "chrome/") || se(t, "crios/") || se(t, "android") ? !se(t, "chrome/") && !se(t, "crios/") || se(t, "edge/") ? se(t, "android") ? "Android" : (e = e.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/)) && 2 == e.length ? e[1] : "Other" : Tr : "Safari";
        }

        var Er = {
          jd: "FirebaseCore-web",
          ld: "FirebaseUI-web"
        };

        function kr(e, t) {
          t = t || [];
          var n,
              r = [],
              i = {};

          for (n in Er) {
            i[Er[n]] = !0;
          }

          for (n = 0; n < t.length; n++) {
            void 0 !== i[t[n]] && (delete i[t[n]], r.push(t[n]));
          }

          return r.sort(), (t = r).length || (t = ["FirebaseCore-web"]), "Browser" === (r = gr()) ? r = Mr(i = Lr()) : "Worker" === r && (r = Mr(i = Lr()) + "-" + r), r + "/JsCore/" + e + "/" + t.join(",");
        }

        function Lr() {
          return u.navigator && u.navigator.userAgent || "";
        }

        function Sr(e, t) {
          e = e.split("."), t = t || u;

          for (var n = 0; n < e.length && "object" == typeof t && null != t; n++) {
            t = t[e[n]];
          }

          return n != e.length && (t = void 0), t;
        }

        function Nr() {
          try {
            var e = u.localStorage,
                t = Fr();
            if (e) return e.setItem(t, "1"), e.removeItem(t), !sr() || !!u.indexedDB;
          } catch (e) {
            return vr() && !!u.indexedDB;
          }

          return !1;
        }

        function Dr() {
          return (Ir() || "chrome-extension:" === Rr() || _r()) && !br() && Nr() && !vr();
        }

        function Ir() {
          return "http:" === Rr() || "https:" === Rr();
        }

        function Rr() {
          return u.location && u.location.protocol || null;
        }

        function xr(e) {
          return !lr(e = e || Lr()) && Mr(e) != wr;
        }

        function Yr(e) {
          return void 0 === e ? null : nr(e);
        }

        function Cr(e) {
          var t,
              n = {};

          for (t in e) {
            e.hasOwnProperty(t) && null !== e[t] && void 0 !== e[t] && (n[t] = e[t]);
          }

          return n;
        }

        function Or(e) {
          if (null !== e) return JSON.parse(e);
        }

        function Fr(e) {
          return e || Math.floor(1e9 * Math.random()).toString();
        }

        function Ar(e) {
          return "Safari" != Mr(e = e || Lr()) && !e.toLowerCase().match(/iphone|ipad|ipod/);
        }

        function jr() {
          var e = u.___jsl;
          if (e && e.H) for (var t in e.H) {
            if (e.H[t].r = e.H[t].r || [], e.H[t].L = e.H[t].L || [], e.H[t].r = e.H[t].L.concat(), e.CP) for (var n = 0; n < e.CP.length; n++) {
              e.CP[n] = null;
            }
          }
        }

        function Ur(e, t) {
          if (e > t) throw Error("Short delay should be less than long delay!");
          this.a = e, this.c = t, e = Lr(), t = gr(), this.b = lr(e) || "ReactNative" === t;
        }

        function Pr() {
          var e = u.document;
          return !e || void 0 === e.visibilityState || "visible" == e.visibilityState;
        }

        function Vr(e) {
          try {
            var t = new Date(parseInt(e, 10));
            if (!isNaN(t.getTime()) && !/[^0-9]/.test(e)) return t.toUTCString();
          } catch (e) {}

          return null;
        }

        function Wr() {
          return !(!Sr("fireauth.oauthhelper", u) && !Sr("fireauth.iframe", u));
        }

        Ur.prototype.get = function () {
          var e = u.navigator;
          return !e || "boolean" != typeof e.onLine || !Ir() && "chrome-extension:" !== Rr() && void 0 === e.connection || e.onLine ? this.b ? this.c : this.a : Math.min(5e3, this.a);
        };

        var Hr,
            Br = {};

        function zr(e) {
          Br[e] || (Br[e] = !0, "undefined" != typeof console && "function" == typeof console.warn && console.warn(e));
        }

        try {
          var Zr = {};
          Object.defineProperty(Zr, "abcd", {
            configurable: !0,
            enumerable: !0,
            value: 1
          }), Object.defineProperty(Zr, "abcd", {
            configurable: !0,
            enumerable: !0,
            value: 2
          }), Hr = 2 == Zr.abcd;
        } catch (ze) {
          Hr = !1;
        }

        function Qr(e, t, n) {
          Hr ? Object.defineProperty(e, t, {
            configurable: !0,
            enumerable: !0,
            value: n
          }) : e[t] = n;
        }

        function Gr(e, t) {
          if (t) for (var n in t) {
            t.hasOwnProperty(n) && Qr(e, n, t[n]);
          }
        }

        function qr(e) {
          var t = {};
          return Gr(t, e), t;
        }

        function Jr(e) {
          var t = e;
          if ("object" == typeof e && null != e) for (var n in t = "length" in e ? [] : {}, e) {
            Qr(t, n, Jr(e[n]));
          }
          return t;
        }

        function Xr(e) {
          var t = e && (e[ni] ? "phone" : null);
          if (!(t && e && e[ti])) throw new k("internal-error", "Internal assert: invalid MultiFactorInfo object");
          Qr(this, "uid", e[ti]), Qr(this, "displayName", e[$r] || null);
          var n = null;
          e[ei] && (n = new Date(e[ei]).toUTCString()), Qr(this, "enrollmentTime", n), Qr(this, "factorId", t);
        }

        function Kr(e) {
          try {
            var t = new ri(e);
          } catch (e) {
            t = null;
          }

          return t;
        }

        Xr.prototype.v = function () {
          return {
            uid: this.uid,
            displayName: this.displayName,
            factorId: this.factorId,
            enrollmentTime: this.enrollmentTime
          };
        };

        var $r = "displayName",
            ei = "enrolledAt",
            ti = "mfaEnrollmentId",
            ni = "phoneInfo";

        function ri(e) {
          Xr.call(this, e), Qr(this, "phoneNumber", e[ni]);
        }

        function ii(e) {
          var t = {},
              n = e[ui],
              r = e[li],
              i = e[hi];
          if (e = Kr(e[ci]), !i || i != ai && i != si && !n || i == si && !r || i == oi && !e) throw Error("Invalid checkActionCode response!");
          i == si ? (t[fi] = n || null, t[mi] = n || null, t[di] = r) : (t[fi] = r || null, t[mi] = r || null, t[di] = n || null), t[pi] = e || null, Qr(this, yi, i), Qr(this, _i, Jr(t));
        }

        E(ri, Xr), ri.prototype.v = function () {
          var e = ri.Za.v.call(this);
          return e.phoneNumber = this.phoneNumber, e;
        };
        var oi = "REVERT_SECOND_FACTOR_ADDITION",
            ai = "EMAIL_SIGNIN",
            si = "VERIFY_AND_CHANGE_EMAIL",
            ui = "email",
            ci = "mfaInfo",
            li = "newEmail",
            hi = "requestType",
            di = "email",
            fi = "fromEmail",
            pi = "multiFactorInfo",
            mi = "previousEmail",
            _i = "data",
            yi = "operation";

        function vi(e) {
          var t = An(e = jn(e), gi) || null,
              n = An(e, bi) || null,
              r = An(e, Mi) || null;
          if (r = r && ki[r] || null, !t || !n || !r) throw new k("argument-error", gi + ", " + bi + "and " + Mi + " are required in a valid action code URL.");
          Gr(this, {
            apiKey: t,
            operation: r,
            code: n,
            continueUrl: An(e, wi) || null,
            languageCode: An(e, Ti) || null,
            tenantId: An(e, Ei) || null
          });
        }

        var gi = "apiKey",
            bi = "oobCode",
            wi = "continueUrl",
            Ti = "languageCode",
            Mi = "mode",
            Ei = "tenantId",
            ki = {
          recoverEmail: "RECOVER_EMAIL",
          resetPassword: "PASSWORD_RESET",
          revertSecondFactorAddition: oi,
          signIn: ai,
          verifyAndChangeEmail: si,
          verifyEmail: "VERIFY_EMAIL"
        };

        function Li(e) {
          try {
            return new vi(e);
          } catch (e) {
            return null;
          }
        }

        function Si(e) {
          var t = e[xi];
          if (void 0 === t) throw new k("missing-continue-uri");
          if ("string" != typeof t || "string" == typeof t && !t.length) throw new k("invalid-continue-uri");
          this.h = t, this.b = this.a = null, this.g = !1;
          var n = e[Ni];

          if (n && "object" == typeof n) {
            t = n[Oi];
            var r = n[Yi];

            if (n = n[Ci], "string" == typeof t && t.length) {
              if (this.a = t, void 0 !== r && "boolean" != typeof r) throw new k("argument-error", Yi + " property must be a boolean when specified.");
              if (this.g = !!r, void 0 !== n && ("string" != typeof n || "string" == typeof n && !n.length)) throw new k("argument-error", Ci + " property must be a non empty string when specified.");
              this.b = n || null;
            } else {
              if (void 0 !== t) throw new k("argument-error", Oi + " property must be a non empty string when specified.");
              if (void 0 !== r || void 0 !== n) throw new k("missing-android-pkg-name");
            }
          } else if (void 0 !== n) throw new k("argument-error", Ni + " property must be a non null object when specified.");

          if (this.f = null, (t = e[Ri]) && "object" == typeof t) {
            if ("string" == typeof (t = t[Fi]) && t.length) this.f = t;else if (void 0 !== t) throw new k("argument-error", Fi + " property must be a non empty string when specified.");
          } else if (void 0 !== t) throw new k("argument-error", Ri + " property must be a non null object when specified.");

          if (void 0 !== (t = e[Ii]) && "boolean" != typeof t) throw new k("argument-error", Ii + " property must be a boolean when specified.");
          if (this.c = !!t, void 0 !== (e = e[Di]) && ("string" != typeof e || "string" == typeof e && !e.length)) throw new k("argument-error", Di + " property must be a non empty string when specified.");
          this.i = e || null;
        }

        var Ni = "android",
            Di = "dynamicLinkDomain",
            Ii = "handleCodeInApp",
            Ri = "iOS",
            xi = "url",
            Yi = "installApp",
            Ci = "minimumVersion",
            Oi = "packageName",
            Fi = "bundleId";

        function Ai(e) {
          var t = {};

          for (var n in t.continueUrl = e.h, t.canHandleCodeInApp = e.c, (t.androidPackageName = e.a) && (t.androidMinimumVersion = e.b, t.androidInstallApp = e.g), t.iOSBundleId = e.f, t.dynamicLinkDomain = e.i, t) {
            null === t[n] && delete t[n];
          }

          return t;
        }

        var ji = null;

        function Ui(e) {
          var t = "";
          return function (e, t) {
            function n(t) {
              for (; r < e.length;) {
                var n = e.charAt(r++),
                    i = ji[n];
                if (null != i) return i;
                if (!/^[\s\xa0]*$/.test(n)) throw Error("Unknown base64 encoding at char: " + n);
              }

              return t;
            }

            !function () {
              if (!ji) {
                ji = {};

                for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), t = ["+/=", "+/", "-_=", "-_.", "-_"], n = 0; 5 > n; n++) {
                  for (var r = e.concat(t[n].split("")), i = 0; i < r.length; i++) {
                    var o = r[i];
                    void 0 === ji[o] && (ji[o] = i);
                  }
                }
              }
            }();

            for (var r = 0;;) {
              var i = n(-1),
                  o = n(0),
                  a = n(64),
                  s = n(64);
              if (64 === s && -1 === i) break;
              t(i << 2 | o >> 4), 64 != a && (t(o << 4 & 240 | a >> 2), 64 != s && t(a << 6 & 192 | s));
            }
          }(e, function (e) {
            t += String.fromCharCode(e);
          }), t;
        }

        function Pi(e) {
          var t = Wi(e);
          if (!(t && t.sub && t.iss && t.aud && t.exp)) throw Error("Invalid JWT");
          this.g = e, this.c = t.exp, this.h = t.sub, M(), this.a = t.provider_id || t.firebase && t.firebase.sign_in_provider || null, this.f = t.firebase && t.firebase.tenant || null, this.b = !!t.is_anonymous || "anonymous" == this.a;
        }

        function Vi(e) {
          try {
            return new Pi(e);
          } catch (e) {
            return null;
          }
        }

        function Wi(e) {
          if (!e) return null;
          if (3 != (e = e.split(".")).length) return null;

          for (var t = (4 - (e = e[1]).length % 4) % 4, n = 0; n < t; n++) {
            e += ".";
          }

          try {
            return JSON.parse(Ui(e));
          } catch (e) {}

          return null;
        }

        Pi.prototype.S = function () {
          return this.f;
        }, Pi.prototype.i = function () {
          return this.b;
        }, Pi.prototype.toString = function () {
          return this.g;
        };
        var Hi = "oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),
            Bi = ["client_id", "response_type", "scope", "redirect_uri", "state"],
            zi = {
          kd: {
            Ha: "locale",
            ta: 700,
            sa: 600,
            ea: "facebook.com",
            Va: Bi
          },
          md: {
            Ha: null,
            ta: 500,
            sa: 750,
            ea: "github.com",
            Va: Bi
          },
          nd: {
            Ha: "hl",
            ta: 515,
            sa: 680,
            ea: "google.com",
            Va: Bi
          },
          td: {
            Ha: "lang",
            ta: 485,
            sa: 705,
            ea: "twitter.com",
            Va: Hi
          },
          gd: {
            Ha: "locale",
            ta: 640,
            sa: 600,
            ea: "apple.com",
            Va: []
          }
        };

        function Zi(e) {
          for (var t in zi) {
            if (zi[t].ea == e) return zi[t];
          }

          return null;
        }

        function Qi(e) {
          var t = {};
          t["facebook.com"] = Ki, t["google.com"] = eo, t["github.com"] = $i, t["twitter.com"] = to;
          var n = e && e[qi];

          try {
            if (n) return t[n] ? new t[n](e) : new Xi(e);
            if (void 0 !== e[Gi]) return new Ji(e);
          } catch (e) {}

          return null;
        }

        var Gi = "idToken",
            qi = "providerId";

        function Ji(e) {
          var t = e[qi];

          if (!t && e[Gi]) {
            var n = Vi(e[Gi]);
            n && n.a && (t = n.a);
          }

          if (!t) throw Error("Invalid additional user info!");
          "anonymous" != t && "custom" != t || (t = null), n = !1, void 0 !== e.isNewUser ? n = !!e.isNewUser : "identitytoolkit#SignupNewUserResponse" === e.kind && (n = !0), Qr(this, "providerId", t), Qr(this, "isNewUser", n);
        }

        function Xi(e) {
          Ji.call(this, e), Qr(this, "profile", Jr((e = Or(e.rawUserInfo || "{}")) || {}));
        }

        function Ki(e) {
          if (Xi.call(this, e), "facebook.com" != this.providerId) throw Error("Invalid provider ID!");
        }

        function $i(e) {
          if (Xi.call(this, e), "github.com" != this.providerId) throw Error("Invalid provider ID!");
          Qr(this, "username", this.profile && this.profile.login || null);
        }

        function eo(e) {
          if (Xi.call(this, e), "google.com" != this.providerId) throw Error("Invalid provider ID!");
        }

        function to(e) {
          if (Xi.call(this, e), "twitter.com" != this.providerId) throw Error("Invalid provider ID!");
          Qr(this, "username", e.screenName || null);
        }

        function no(e) {
          var t = jn(e),
              n = An(t, "link"),
              r = An(jn(n), "link");
          return t = An(t, "deep_link_id"), An(jn(t), "link") || t || r || n || e;
        }

        function ro(e, t) {
          if (!e && !t) throw new k("internal-error", "Internal assert: no raw session string available");
          if (e && t) throw new k("internal-error", "Internal assert: unable to determine the session type");
          this.a = e || null, this.b = t || null, this.type = this.a ? io : oo;
        }

        E(Xi, Ji), E(Ki, Xi), E($i, Xi), E(eo, Xi), E(to, Xi);
        var io = "enroll",
            oo = "signin";

        function ao() {}

        function so(e, t) {
          return e.then(function (e) {
            if (e[qa]) {
              var n = Vi(e[qa]);
              if (!n || t != n.h) throw new k("user-mismatch");
              return e;
            }

            throw new k("user-mismatch");
          }).o(function (e) {
            throw e && e.code && e.code == N + "user-not-found" ? new k("user-mismatch") : e;
          });
        }

        function uo(e, t) {
          if (!t) throw new k("internal-error", "failed to construct a credential");
          this.a = t, Qr(this, "providerId", e), Qr(this, "signInMethod", e);
        }

        function co(e) {
          return {
            pendingToken: e.a,
            requestUri: "http://localhost"
          };
        }

        function lo(e) {
          if (e && e.providerId && e.signInMethod && 0 == e.providerId.indexOf("saml.") && e.pendingToken) try {
            return new uo(e.providerId, e.pendingToken);
          } catch (e) {}
          return null;
        }

        function ho(e, t, n) {
          if (this.a = null, t.idToken || t.accessToken) t.idToken && Qr(this, "idToken", t.idToken), t.accessToken && Qr(this, "accessToken", t.accessToken), t.nonce && !t.pendingToken && Qr(this, "nonce", t.nonce), t.pendingToken && (this.a = t.pendingToken);else {
            if (!t.oauthToken || !t.oauthTokenSecret) throw new k("internal-error", "failed to construct a credential");
            Qr(this, "accessToken", t.oauthToken), Qr(this, "secret", t.oauthTokenSecret);
          }
          Qr(this, "providerId", e), Qr(this, "signInMethod", n);
        }

        function fo(e) {
          var t = {};
          return e.idToken && (t.id_token = e.idToken), e.accessToken && (t.access_token = e.accessToken), e.secret && (t.oauth_token_secret = e.secret), t.providerId = e.providerId, e.nonce && !e.a && (t.nonce = e.nonce), t = {
            postBody: Jn(t).toString(),
            requestUri: "http://localhost"
          }, e.a && (delete t.postBody, t.pendingToken = e.a), t;
        }

        function po(e) {
          if (e && e.providerId && e.signInMethod) {
            var t = {
              idToken: e.oauthIdToken,
              accessToken: e.oauthTokenSecret ? null : e.oauthAccessToken,
              oauthTokenSecret: e.oauthTokenSecret,
              oauthToken: e.oauthTokenSecret && e.oauthAccessToken,
              nonce: e.nonce,
              pendingToken: e.pendingToken
            };

            try {
              return new ho(e.providerId, t, e.signInMethod);
            } catch (e) {}
          }

          return null;
        }

        function mo(e, t) {
          this.Oc = t || [], Gr(this, {
            providerId: e,
            isOAuthProvider: !0
          }), this.Fb = {}, this.lb = (Zi(e) || {}).Ha || null, this.kb = null;
        }

        function _o(e) {
          if ("string" != typeof e || 0 != e.indexOf("saml.")) throw new k("argument-error", 'SAML provider IDs must be prefixed with "saml."');
          mo.call(this, e, []);
        }

        function yo(e) {
          mo.call(this, e, Bi), this.a = [];
        }

        function vo() {
          yo.call(this, "facebook.com");
        }

        function go(e) {
          if (!e) throw new k("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
          var t = e;
          return m(e) && (t = e.accessToken), new vo().credential({
            accessToken: t
          });
        }

        function bo() {
          yo.call(this, "github.com");
        }

        function wo(e) {
          if (!e) throw new k("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
          var t = e;
          return m(e) && (t = e.accessToken), new bo().credential({
            accessToken: t
          });
        }

        function To() {
          yo.call(this, "google.com"), this.Aa("profile");
        }

        function Mo(e, t) {
          var n = e;
          return m(e) && (n = e.idToken, t = e.accessToken), new To().credential({
            idToken: n,
            accessToken: t
          });
        }

        function Eo() {
          mo.call(this, "twitter.com", Hi);
        }

        function ko(e, t) {
          var n = e;
          if (m(n) || (n = {
            oauthToken: e,
            oauthTokenSecret: t
          }), !n.oauthToken || !n.oauthTokenSecret) throw new k("argument-error", "credential failed: expected 2 arguments (the OAuth access token and secret).");
          return new ho("twitter.com", n, "twitter.com");
        }

        function Lo(e, t, n) {
          this.a = e, this.f = t, Qr(this, "providerId", "password"), Qr(this, "signInMethod", n === No.EMAIL_LINK_SIGN_IN_METHOD ? No.EMAIL_LINK_SIGN_IN_METHOD : No.EMAIL_PASSWORD_SIGN_IN_METHOD);
        }

        function So(e) {
          return e && e.email && e.password ? new Lo(e.email, e.password, e.signInMethod) : null;
        }

        function No() {
          Gr(this, {
            providerId: "password",
            isOAuthProvider: !1
          });
        }

        function Do(e, t) {
          if (!(t = Io(t))) throw new k("argument-error", "Invalid email link!");
          return new Lo(e, t.code, No.EMAIL_LINK_SIGN_IN_METHOD);
        }

        function Io(e) {
          return (e = Li(e = no(e))) && e.operation === ai ? e : null;
        }

        function Ro(e) {
          if (!(e.bb && e.ab || e.Ja && e.da)) throw new k("internal-error");
          this.a = e, Qr(this, "providerId", "phone"), this.ea = "phone", Qr(this, "signInMethod", "phone");
        }

        function xo(e) {
          if (e && "phone" === e.providerId && (e.verificationId && e.verificationCode || e.temporaryProof && e.phoneNumber)) {
            var t = {};
            return H(["verificationId", "verificationCode", "temporaryProof", "phoneNumber"], function (n) {
              e[n] && (t[n] = e[n]);
            }), new Ro(t);
          }

          return null;
        }

        function Yo(e) {
          return e.a.Ja && e.a.da ? {
            temporaryProof: e.a.Ja,
            phoneNumber: e.a.da
          } : {
            sessionInfo: e.a.bb,
            code: e.a.ab
          };
        }

        function Co(e) {
          try {
            this.a = e || r.a.auth();
          } catch (e) {
            throw new k("argument-error", "Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");
          }

          Gr(this, {
            providerId: "phone",
            isOAuthProvider: !1
          });
        }

        function Oo(e, t) {
          if (!e) throw new k("missing-verification-id");
          if (!t) throw new k("missing-verification-code");
          return new Ro({
            bb: e,
            ab: t
          });
        }

        function Fo(e) {
          if (e.temporaryProof && e.phoneNumber) return new Ro({
            Ja: e.temporaryProof,
            da: e.phoneNumber
          });
          var t = e && e.providerId;
          if (!t || "password" === t) return null;
          var n = e && e.oauthAccessToken,
              r = e && e.oauthTokenSecret,
              i = e && e.nonce,
              o = e && e.oauthIdToken,
              a = e && e.pendingToken;

          try {
            switch (t) {
              case "google.com":
                return Mo(o, n);

              case "facebook.com":
                return go(n);

              case "github.com":
                return wo(n);

              case "twitter.com":
                return ko(n, r);

              default:
                return n || r || o || a ? a ? 0 == t.indexOf("saml.") ? new uo(t, a) : new ho(t, {
                  pendingToken: a,
                  idToken: e.oauthIdToken,
                  accessToken: e.oauthAccessToken
                }, t) : new yo(t).credential({
                  idToken: o,
                  accessToken: n,
                  rawNonce: i
                }) : null;
            }
          } catch (e) {
            return null;
          }
        }

        function Ao(e) {
          if (!e.isOAuthProvider) throw new k("invalid-oauth-provider");
        }

        function jo(e, t, n, r, i, o, a) {
          if (this.c = e, this.b = t || null, this.g = n || null, this.f = r || null, this.i = o || null, this.h = a || null, this.a = i || null, !this.g && !this.a) throw new k("invalid-auth-event");
          if (this.g && this.a) throw new k("invalid-auth-event");
          if (this.g && !this.f) throw new k("invalid-auth-event");
        }

        function Uo(e) {
          return (e = e || {}).type ? new jo(e.type, e.eventId, e.urlResponse, e.sessionId, e.error && L(e.error), e.postBody, e.tenantId) : null;
        }

        function Po() {
          this.b = null, this.a = [];
        }

        ro.prototype.Fa = function () {
          return this.a ? St(this.a) : St(this.b);
        }, ro.prototype.v = function () {
          return this.type == io ? {
            multiFactorSession: {
              idToken: this.a
            }
          } : {
            multiFactorSession: {
              pendingCredential: this.b
            }
          };
        }, ao.prototype.ia = function () {}, ao.prototype.b = function () {}, ao.prototype.c = function () {}, ao.prototype.v = function () {}, uo.prototype.ia = function (e) {
          return ms(e, co(this));
        }, uo.prototype.b = function (e, t) {
          var n = co(this);
          return n.idToken = t, _s(e, n);
        }, uo.prototype.c = function (e, t) {
          return so(ys(e, co(this)), t);
        }, uo.prototype.v = function () {
          return {
            providerId: this.providerId,
            signInMethod: this.signInMethod,
            pendingToken: this.a
          };
        }, ho.prototype.ia = function (e) {
          return ms(e, fo(this));
        }, ho.prototype.b = function (e, t) {
          var n = fo(this);
          return n.idToken = t, _s(e, n);
        }, ho.prototype.c = function (e, t) {
          return so(ys(e, fo(this)), t);
        }, ho.prototype.v = function () {
          var e = {
            providerId: this.providerId,
            signInMethod: this.signInMethod
          };
          return this.idToken && (e.oauthIdToken = this.idToken), this.accessToken && (e.oauthAccessToken = this.accessToken), this.secret && (e.oauthTokenSecret = this.secret), this.nonce && (e.nonce = this.nonce), this.a && (e.pendingToken = this.a), e;
        }, mo.prototype.Ia = function (e) {
          return this.Fb = pe(e), this;
        }, E(_o, mo), E(yo, mo), yo.prototype.Aa = function (e) {
          return Q(this.a, e) || this.a.push(e), this;
        }, yo.prototype.Nb = function () {
          return X(this.a);
        }, yo.prototype.credential = function (e, t) {
          var n;
          if (!(n = m(e) ? {
            idToken: e.idToken || null,
            accessToken: e.accessToken || null,
            nonce: e.rawNonce || null
          } : {
            idToken: e || null,
            accessToken: t || null
          }).idToken && !n.accessToken) throw new k("argument-error", "credential failed: must provide the ID token and/or the access token.");
          return new ho(this.providerId, n, this.providerId);
        }, E(vo, yo), Qr(vo, "PROVIDER_ID", "facebook.com"), Qr(vo, "FACEBOOK_SIGN_IN_METHOD", "facebook.com"), E(bo, yo), Qr(bo, "PROVIDER_ID", "github.com"), Qr(bo, "GITHUB_SIGN_IN_METHOD", "github.com"), E(To, yo), Qr(To, "PROVIDER_ID", "google.com"), Qr(To, "GOOGLE_SIGN_IN_METHOD", "google.com"), E(Eo, mo), Qr(Eo, "PROVIDER_ID", "twitter.com"), Qr(Eo, "TWITTER_SIGN_IN_METHOD", "twitter.com"), Lo.prototype.ia = function (e) {
          return this.signInMethod == No.EMAIL_LINK_SIGN_IN_METHOD ? Ks(e, ks, {
            email: this.a,
            oobCode: this.f
          }) : Ks(e, Qs, {
            email: this.a,
            password: this.f
          });
        }, Lo.prototype.b = function (e, t) {
          return this.signInMethod == No.EMAIL_LINK_SIGN_IN_METHOD ? Ks(e, Ls, {
            idToken: t,
            email: this.a,
            oobCode: this.f
          }) : Ks(e, Us, {
            idToken: t,
            email: this.a,
            password: this.f
          });
        }, Lo.prototype.c = function (e, t) {
          return so(this.ia(e), t);
        }, Lo.prototype.v = function () {
          return {
            email: this.a,
            password: this.f,
            signInMethod: this.signInMethod
          };
        }, Gr(No, {
          PROVIDER_ID: "password"
        }), Gr(No, {
          EMAIL_LINK_SIGN_IN_METHOD: "emailLink"
        }), Gr(No, {
          EMAIL_PASSWORD_SIGN_IN_METHOD: "password"
        }), Ro.prototype.ia = function (e) {
          return e.cb(Yo(this));
        }, Ro.prototype.b = function (e, t) {
          var n = Yo(this);
          return n.idToken = t, Ks(e, qs, n);
        }, Ro.prototype.c = function (e, t) {
          var n = Yo(this);
          return n.operation = "REAUTH", so(e = Ks(e, Js, n), t);
        }, Ro.prototype.v = function () {
          var e = {
            providerId: "phone"
          };
          return this.a.bb && (e.verificationId = this.a.bb), this.a.ab && (e.verificationCode = this.a.ab), this.a.Ja && (e.temporaryProof = this.a.Ja), this.a.da && (e.phoneNumber = this.a.da), e;
        }, Co.prototype.cb = function (e, t) {
          var n = this.a.b;
          return St(t.verify()).then(function (r) {
            if ("string" != typeof r) throw new k("argument-error", "An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");

            switch (t.type) {
              case "recaptcha":
                var i = m(e) ? e.session : null,
                    o = m(e) ? e.phoneNumber : e;
                return (i && i.type == io ? i.Fa().then(function (e) {
                  return Ks(n, Vs, {
                    idToken: e,
                    phoneEnrollmentInfo: {
                      phoneNumber: o,
                      recaptchaToken: r
                    }
                  }).then(function (e) {
                    return e.phoneSessionInfo.sessionInfo;
                  });
                }) : i && i.type == oo ? i.Fa().then(function (t) {
                  return function (e, t) {
                    return Ks(e, Ws, t).then(function (e) {
                      return e.phoneResponseInfo.sessionInfo;
                    });
                  }(n, {
                    mfaPendingCredential: t,
                    mfaEnrollmentId: e.multiFactorHint && e.multiFactorHint.uid || e.multiFactorUid,
                    phoneSignInInfo: {
                      recaptchaToken: r
                    }
                  });
                }) : function (e, t) {
                  return Ks(e, As, t);
                }(n, {
                  phoneNumber: o,
                  recaptchaToken: r
                })).then(function (e) {
                  return "function" == typeof t.reset && t.reset(), e;
                }, function (e) {
                  throw "function" == typeof t.reset && t.reset(), e;
                });

              default:
                throw new k("argument-error", 'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');
            }
          });
        }, Gr(Co, {
          PROVIDER_ID: "phone"
        }), Gr(Co, {
          PHONE_SIGN_IN_METHOD: "phone"
        }), jo.prototype.getUid = function () {
          var e = [];
          return e.push(this.c), this.b && e.push(this.b), this.f && e.push(this.f), this.h && e.push(this.h), e.join("-");
        }, jo.prototype.S = function () {
          return this.h;
        }, jo.prototype.v = function () {
          return {
            type: this.c,
            eventId: this.b,
            urlResponse: this.g,
            sessionId: this.f,
            postBody: this.i,
            tenantId: this.h,
            error: this.a && this.a.v()
          };
        };
        var Vo,
            Wo = null;

        function Ho(e) {
          var t = "unauthorized-domain",
              n = void 0,
              r = jn(e);
          e = r.b, "chrome-extension" == (r = r.f) ? n = Ve("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", e) : "http" == r || "https" == r ? n = Ve("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", e) : t = "operation-not-supported-in-this-environment", k.call(this, t, n);
        }

        function Bo(e, t, n) {
          k.call(this, e, n), (e = t || {}).Gb && Qr(this, "email", e.Gb), e.da && Qr(this, "phoneNumber", e.da), e.credential && Qr(this, "credential", e.credential), e.Wb && Qr(this, "tenantId", e.Wb);
        }

        function zo(e) {
          if (e.code) {
            var t = e.code || "";
            0 == t.indexOf(N) && (t = t.substring(N.length));
            var n = {
              credential: Fo(e),
              Wb: e.tenantId
            };
            if (e.email) n.Gb = e.email;else if (e.phoneNumber) n.da = e.phoneNumber;else if (!n.credential) return new k(t, e.message || void 0);
            return new Bo(t, n, e.message);
          }

          return null;
        }

        function Zo() {}

        function Qo(e) {
          return e.c || (e.c = e.b());
        }

        function Go() {}

        function qo(e) {
          if (!e.f && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
            for (var t = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], n = 0; n < t.length; n++) {
              var r = t[n];

              try {
                return new ActiveXObject(r), e.f = r;
              } catch (e) {}
            }

            throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
          }

          return e.f;
        }

        function Jo() {}

        function Xo() {
          this.a = new XDomainRequest(), this.readyState = 0, this.onreadystatechange = null, this.responseType = this.responseText = this.response = "", this.status = -1, this.statusText = "", this.a.onload = w(this.oc, this), this.a.onerror = w(this.Pb, this), this.a.onprogress = w(this.pc, this), this.a.ontimeout = w(this.tc, this);
        }

        function Ko(e, t) {
          e.readyState = t, e.onreadystatechange && e.onreadystatechange();
        }

        function $o(e, t, n) {
          this.reset(e, t, n, void 0, void 0);
        }

        E(Ho, k), E(Bo, k), Bo.prototype.v = function () {
          var e = {
            code: this.code,
            message: this.message
          };
          this.email && (e.email = this.email), this.phoneNumber && (e.phoneNumber = this.phoneNumber), this.tenantId && (e.tenantId = this.tenantId);
          var t = this.credential && this.credential.v();
          return t && _e(e, t), e;
        }, Bo.prototype.toJSON = function () {
          return this.v();
        }, Zo.prototype.c = null, E(Go, Zo), Go.prototype.a = function () {
          var e = qo(this);
          return e ? new ActiveXObject(e) : new XMLHttpRequest();
        }, Go.prototype.b = function () {
          var e = {};
          return qo(this) && (e[0] = !0, e[1] = !0), e;
        }, Vo = new Go(), E(Jo, Zo), Jo.prototype.a = function () {
          var e = new XMLHttpRequest();
          if ("withCredentials" in e) return e;
          if ("undefined" != typeof XDomainRequest) return new Xo();
          throw Error("Unsupported browser");
        }, Jo.prototype.b = function () {
          return {};
        }, (t = Xo.prototype).open = function (e, t, n) {
          if (null != n && !n) throw Error("Only async requests are supported.");
          this.a.open(e, t);
        }, t.send = function (e) {
          if (e) {
            if ("string" != typeof e) throw Error("Only string data is supported");
            this.a.send(e);
          } else this.a.send();
        }, t.abort = function () {
          this.a.abort();
        }, t.setRequestHeader = function () {}, t.getResponseHeader = function (e) {
          return "content-type" == e.toLowerCase() ? this.a.contentType : "";
        }, t.oc = function () {
          this.status = 200, this.response = this.responseText = this.a.responseText, Ko(this, 4);
        }, t.Pb = function () {
          this.status = 500, this.response = this.responseText = "", Ko(this, 4);
        }, t.tc = function () {
          this.Pb();
        }, t.pc = function () {
          this.status = 200, Ko(this, 1);
        }, t.getAllResponseHeaders = function () {
          return "content-type: " + this.a.contentType;
        }, $o.prototype.a = null;

        function ea(e) {
          this.f = e, this.b = this.c = this.a = null;
        }

        function ta(e, t) {
          this.name = e, this.value = t;
        }

        $o.prototype.reset = function (e, t, n, r, i) {
          "number" == typeof i || 0, r || M(), delete this.a;
        }, ta.prototype.toString = function () {
          return this.name;
        };
        var na = new ta("SEVERE", 1e3),
            ra = new ta("WARNING", 900),
            ia = new ta("CONFIG", 700),
            oa = new ta("FINE", 500);

        ea.prototype.log = function (e, t, n) {
          if (e.value >= function e(t) {
            return t.c ? t.c : t.a ? e(t.a) : (O("Root logger has no level set."), null);
          }(this).value) for (p(t) && (t = t()), e = new $o(e, String(t), this.f), n && (e.a = n), n = this; n;) {
            n = n.a;
          }
        };

        var aa = {},
            sa = null;

        function ua(e) {
          var t;

          if (sa || (sa = new ea(""), aa[""] = sa, sa.c = ia), !(t = aa[e])) {
            t = new ea(e);
            var n = e.lastIndexOf("."),
                r = e.substr(n + 1);
            (n = ua(e.substr(0, n))).b || (n.b = {}), n.b[r] = t, t.a = n, aa[e] = t;
          }

          return t;
        }

        function ca(e, t) {
          e && e.log(oa, t, void 0);
        }

        function la(e) {
          this.f = e;
        }

        function ha(e) {
          bn.call(this), this.s = e, this.readyState = da, this.status = 0, this.responseType = this.responseText = this.response = this.statusText = "", this.onreadystatechange = null, this.i = new Headers(), this.b = null, this.m = "GET", this.g = "", this.a = !1, this.h = ua("goog.net.FetchXmlHttp"), this.l = this.c = this.f = null;
        }

        E(la, Zo), la.prototype.a = function () {
          return new ha(this.f);
        }, la.prototype.b = function (e) {
          return function () {
            return e;
          };
        }({}), E(ha, bn);
        var da = 0;

        function fa(e) {
          e.c.read().then(e.nc.bind(e)).catch(e.Sa.bind(e));
        }

        function pa(e, t) {
          t && e.f && (e.status = e.f.status, e.statusText = e.f.statusText), e.readyState = 4, e.f = null, e.c = null, e.l = null, ma(e);
        }

        function ma(e) {
          e.onreadystatechange && e.onreadystatechange.call(e);
        }

        function _a(e) {
          bn.call(this), this.headers = new Nn(), this.D = e || null, this.c = !1, this.B = this.a = null, this.h = this.P = this.l = "", this.f = this.O = this.i = this.N = !1, this.g = 0, this.s = null, this.m = ya, this.w = this.R = !1;
        }

        (t = ha.prototype).open = function (e, t) {
          if (this.readyState != da) throw this.abort(), Error("Error reopening a connection");
          this.m = e, this.g = t, this.readyState = 1, ma(this);
        }, t.send = function (e) {
          if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
          this.a = !0;
          var t = {
            headers: this.i,
            method: this.m,
            credentials: void 0,
            cache: void 0
          };
          e && (t.body = e), this.s.fetch(new Request(this.g, t)).then(this.sc.bind(this), this.Sa.bind(this));
        }, t.abort = function () {
          this.response = this.responseText = "", this.i = new Headers(), this.status = 0, this.c && this.c.cancel("Request was aborted."), 1 <= this.readyState && this.a && 4 != this.readyState && (this.a = !1, pa(this, !1)), this.readyState = da;
        }, t.sc = function (e) {
          this.a && (this.f = e, this.b || (this.b = e.headers, this.readyState = 2, ma(this)), this.a && (this.readyState = 3, ma(this), this.a && ("arraybuffer" === this.responseType ? e.arrayBuffer().then(this.qc.bind(this), this.Sa.bind(this)) : void 0 !== u.ReadableStream && "body" in e ? (this.response = this.responseText = "", this.c = e.body.getReader(), this.l = new TextDecoder(), fa(this)) : e.text().then(this.rc.bind(this), this.Sa.bind(this)))));
        }, t.nc = function (e) {
          if (this.a) {
            var t = this.l.decode(e.value ? e.value : new Uint8Array(0), {
              stream: !e.done
            });
            t && (this.response = this.responseText += t), e.done ? pa(this, !0) : ma(this), 3 == this.readyState && fa(this);
          }
        }, t.rc = function (e) {
          this.a && (this.response = this.responseText = e, pa(this, !0));
        }, t.qc = function (e) {
          this.a && (this.response = e, pa(this, !0));
        }, t.Sa = function (e) {
          var t = this.h;
          t && t.log(ra, "Failed to fetch url " + this.g, e instanceof Error ? e : Error(e)), this.a && pa(this, !0);
        }, t.setRequestHeader = function (e, t) {
          this.i.append(e, t);
        }, t.getResponseHeader = function (e) {
          return this.b ? this.b.get(e.toLowerCase()) || "" : ((e = this.h) && e.log(ra, "Attempting to get response header but no headers have been received for url: " + this.g, void 0), "");
        }, t.getAllResponseHeaders = function () {
          if (!this.b) {
            var e = this.h;
            return e && e.log(ra, "Attempting to get all response headers but no headers have been received for url: " + this.g, void 0), "";
          }

          e = [];

          for (var t = this.b.entries(), n = t.next(); !n.done;) {
            n = n.value, e.push(n[0] + ": " + n[1]), n = t.next();
          }

          return e.join("\r\n");
        }, E(_a, bn);
        var ya = "";
        _a.prototype.b = ua("goog.net.XhrIo");
        var va = /^https?$/i,
            ga = ["POST", "PUT"];

        function ba(e, t, n, r, i) {
          if (e.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + e.l + "; newUri=" + t);
          n = n ? n.toUpperCase() : "GET", e.l = t, e.h = "", e.P = n, e.N = !1, e.c = !0, e.a = e.D ? e.D.a() : Vo.a(), e.B = e.D ? Qo(e.D) : Qo(Vo), e.a.onreadystatechange = w(e.Sb, e);

          try {
            ca(e.b, Da(e, "Opening Xhr")), e.O = !0, e.a.open(n, String(t), !0), e.O = !1;
          } catch (t) {
            return ca(e.b, Da(e, "Error opening Xhr: " + t.message)), void Ta(e, t);
          }

          t = r || "";
          var o = new Nn(e.headers);
          i && function (e, t) {
            if (e.forEach && "function" == typeof e.forEach) e.forEach(t, void 0);else if (f(e) || "string" == typeof e) H(e, t, void 0);else for (var n = Sn(e), r = Ln(e), i = r.length, o = 0; o < i; o++) {
              t.call(void 0, r[o], n && n[o], e);
            }
          }(i, function (e, t) {
            o.set(t, e);
          }), i = function (e) {
            e: {
              for (var t = wa, n = e.length, r = "string" == typeof e ? e.split("") : e, i = 0; i < n; i++) {
                if (i in r && t.call(void 0, r[i], i, e)) {
                  t = i;
                  break e;
                }
              }

              t = -1;
            }

            return 0 > t ? null : "string" == typeof e ? e.charAt(t) : e[t];
          }(o.X()), r = u.FormData && t instanceof u.FormData, !Q(ga, n) || i || r || o.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"), o.forEach(function (e, t) {
            this.a.setRequestHeader(t, e);
          }, e), e.m && (e.a.responseType = e.m), "withCredentials" in e.a && e.a.withCredentials !== e.R && (e.a.withCredentials = e.R);

          try {
            La(e), 0 < e.g && (e.w = function (e) {
              return Qe && it(9) && "number" == typeof e.timeout && void 0 !== e.ontimeout;
            }(e.a), ca(e.b, Da(e, "Will abort after " + e.g + "ms if incomplete, xhr2 " + e.w)), e.w ? (e.a.timeout = e.g, e.a.ontimeout = w(e.Ka, e)) : e.s = En(e.Ka, e.g, e)), ca(e.b, Da(e, "Sending request")), e.i = !0, e.a.send(t), e.i = !1;
          } catch (t) {
            ca(e.b, Da(e, "Send error: " + t.message)), Ta(e, t);
          }
        }

        function wa(e) {
          return "content-type" == e.toLowerCase();
        }

        function Ta(e, t) {
          e.c = !1, e.a && (e.f = !0, e.a.abort(), e.f = !1), e.h = t, Ma(e), ka(e);
        }

        function Ma(e) {
          e.N || (e.N = !0, e.dispatchEvent("complete"), e.dispatchEvent("error"));
        }

        function Ea(e) {
          if (e.c && void 0 !== s) if (e.B[1] && 4 == Sa(e) && 2 == Na(e)) ca(e.b, Da(e, "Local request error detected and ignored"));else if (e.i && 4 == Sa(e)) En(e.Sb, 0, e);else if (e.dispatchEvent("readystatechange"), 4 == Sa(e)) {
            ca(e.b, Da(e, "Request complete")), e.c = !1;

            try {
              var t,
                  n = Na(e);

              e: switch (n) {
                case 200:
                case 201:
                case 202:
                case 204:
                case 206:
                case 304:
                case 1223:
                  var r = !0;
                  break e;

                default:
                  r = !1;
              }

              if (!(t = r)) {
                var i;

                if (i = 0 === n) {
                  var o = String(e.l).match(Rn)[1] || null;

                  if (!o && u.self && u.self.location) {
                    var a = u.self.location.protocol;
                    o = a.substr(0, a.length - 1);
                  }

                  i = !va.test(o ? o.toLowerCase() : "");
                }

                t = i;
              }

              if (t) e.dispatchEvent("complete"), e.dispatchEvent("success");else {
                try {
                  var c = 2 < Sa(e) ? e.a.statusText : "";
                } catch (t) {
                  ca(e.b, "Can not get status: " + t.message), c = "";
                }

                e.h = c + " [" + Na(e) + "]", Ma(e);
              }
            } finally {
              ka(e);
            }
          }
        }

        function ka(e, t) {
          if (e.a) {
            La(e);
            var n = e.a,
                r = e.B[0] ? h : null;
            e.a = null, e.B = null, t || e.dispatchEvent("ready");

            try {
              n.onreadystatechange = r;
            } catch (t) {
              (e = e.b) && e.log(na, "Problem encountered resetting onreadystatechange: " + t.message, void 0);
            }
          }
        }

        function La(e) {
          e.a && e.w && (e.a.ontimeout = null), e.s && (u.clearTimeout(e.s), e.s = null);
        }

        function Sa(e) {
          return e.a ? e.a.readyState : 0;
        }

        function Na(e) {
          try {
            return 2 < Sa(e) ? e.a.status : -1;
          } catch (e) {
            return -1;
          }
        }

        function Da(e, t) {
          return t + " [" + e.P + " " + e.l + " " + Na(e) + "]";
        }

        function Ia(e) {
          var t = Va;
          this.g = [], this.w = t, this.s = e || null, this.f = this.a = !1, this.c = void 0, this.u = this.B = this.i = !1, this.h = 0, this.b = null, this.l = 0;
        }

        function Ra(e, t, n) {
          e.a = !0, e.c = n, e.f = !t, Oa(e);
        }

        function xa(e) {
          if (e.a) {
            if (!e.u) throw new Fa(e);
            e.u = !1;
          }
        }

        function Ya(e, t, n, r) {
          e.g.push([t, n, r]), e.a && Oa(e);
        }

        function Ca(e) {
          return Z(e.g, function (e) {
            return p(e[1]);
          });
        }

        function Oa(e) {
          if (e.h && e.a && Ca(e)) {
            var t = e.h,
                n = Ua[t];
            n && (u.clearTimeout(n.a), delete Ua[t]), e.h = 0;
          }

          e.b && (e.b.l--, delete e.b), t = e.c;

          for (var r = n = !1; e.g.length && !e.i;) {
            var i = e.g.shift(),
                o = i[0],
                a = i[1];
            if (i = i[2], o = e.f ? a : o) try {
              var s = o.call(i || e.s, t);
              void 0 !== s && (e.f = e.f && (s == t || s instanceof Error), e.c = t = s), (x(t) || "function" == typeof u.Promise && t instanceof u.Promise) && (r = !0, e.i = !0);
            } catch (r) {
              t = r, e.f = !0, Ca(e) || (n = !0);
            }
          }

          e.c = t, r && (s = w(e.m, e, !0), r = w(e.m, e, !1), t instanceof Ia ? (Ya(t, s, r), t.B = !0) : t.then(s, r)), n && (t = new ja(t), Ua[t.a] = t, e.h = t.a);
        }

        function Fa() {
          Y.call(this);
        }

        function Aa() {
          Y.call(this);
        }

        function ja(e) {
          this.a = u.setTimeout(w(this.c, this), 0), this.b = e;
        }

        (t = _a.prototype).Ka = function () {
          void 0 !== s && this.a && (this.h = "Timed out after " + this.g + "ms, aborting", ca(this.b, Da(this, this.h)), this.dispatchEvent("timeout"), this.abort(8));
        }, t.abort = function () {
          this.a && this.c && (ca(this.b, Da(this, "Aborting")), this.c = !1, this.f = !0, this.a.abort(), this.f = !1, this.dispatchEvent("complete"), this.dispatchEvent("abort"), ka(this));
        }, t.Ba = function () {
          this.a && (this.c && (this.c = !1, this.f = !0, this.a.abort(), this.f = !1), ka(this, !0)), _a.Za.Ba.call(this);
        }, t.Sb = function () {
          this.wa || (this.O || this.i || this.f ? Ea(this) : this.Hc());
        }, t.Hc = function () {
          Ea(this);
        }, t.getResponse = function () {
          try {
            if (!this.a) return null;
            if ("response" in this.a) return this.a.response;

            switch (this.m) {
              case ya:
              case "text":
                return this.a.responseText;

              case "arraybuffer":
                if ("mozResponseArrayBuffer" in this.a) return this.a.mozResponseArrayBuffer;
            }

            var e = this.b;
            return e && e.log(na, "Response type " + this.m + " is not supported on this browser", void 0), null;
          } catch (e) {
            return ca(this.b, "Can not get response: " + e.message), null;
          }
        }, Ia.prototype.cancel = function (e) {
          if (this.a) this.c instanceof Ia && this.c.cancel();else {
            if (this.b) {
              var t = this.b;
              delete this.b, e ? t.cancel(e) : (t.l--, 0 >= t.l && t.cancel());
            }

            this.w ? this.w.call(this.s, this) : this.u = !0, this.a || (e = new Aa(this), xa(this), Ra(this, !1, e));
          }
        }, Ia.prototype.m = function (e, t) {
          this.i = !1, Ra(this, e, t);
        }, Ia.prototype.then = function (e, t, n) {
          var r,
              i,
              o = new bt(function (e, t) {
            r = e, i = t;
          });
          return Ya(this, r, function (e) {
            e instanceof Aa ? o.cancel() : i(e);
          }), o.then(e, t, n);
        }, Ia.prototype.$goog_Thenable = !0, E(Fa, Y), Fa.prototype.message = "Deferred has already fired", Fa.prototype.name = "AlreadyCalledError", E(Aa, Y), Aa.prototype.message = "Deferred was canceled", Aa.prototype.name = "CanceledError", ja.prototype.c = function () {
          throw delete Ua[this.a], this.b;
        };
        var Ua = {};

        function Pa(e) {
          var t = {},
              n = t.document || document,
              r = Ee(e).toString(),
              i = dt(document, "SCRIPT"),
              o = {
            Tb: i,
            Ka: void 0
          },
              a = new Ia(o),
              s = null,
              h = null != t.timeout ? t.timeout : 5e3;
          return 0 < h && (s = window.setTimeout(function () {
            Wa(i, !0);
            var e = new za(Ba, "Timeout reached for loading script " + r);
            xa(a), Ra(a, !1, e);
          }, h), o.Ka = s), i.onload = i.onreadystatechange = function () {
            i.readyState && "loaded" != i.readyState && "complete" != i.readyState || (Wa(i, t.ud || !1, s), xa(a), Ra(a, !0, null));
          }, i.onerror = function () {
            Wa(i, !0, s);
            var e = new za(Ha, "Error while loading script " + r);
            xa(a), Ra(a, !1, e);
          }, _e(o = t.attributes || {}, {
            type: "text/javascript",
            charset: "UTF-8"
          }), st(i, o), function (e, t) {
            ye(e, "HTMLScriptElement"), e.src = Ee(t), null === l && (l = (t = (t = u.document).querySelector && t.querySelector("script[nonce]")) && (t = t.nonce || t.getAttribute("nonce")) && c.test(t) ? t : ""), (t = l) && e.setAttribute("nonce", t);
          }(i, e), function (e) {
            var t;
            return (t = (e || document).getElementsByTagName("HEAD")) && 0 != t.length ? t[0] : e.documentElement;
          }(n).appendChild(i), a;
        }

        function Va() {
          if (this && this.Tb) {
            var e = this.Tb;
            e && "SCRIPT" == e.tagName && Wa(e, !0, this.Ka);
          }
        }

        function Wa(e, t, n) {
          null != n && u.clearTimeout(n), e.onload = h, e.onerror = h, e.onreadystatechange = h, t && window.setTimeout(function () {
            e && e.parentNode && e.parentNode.removeChild(e);
          }, 0);
        }

        var Ha = 0,
            Ba = 1;

        function za(e, t) {
          var n = "Jsloader error (code #" + e + ")";
          t && (n += ": " + t), Y.call(this, n), this.code = e;
        }

        function Za(e) {
          this.f = e;
        }

        function Qa(e, t, n) {
          if (this.c = e, e = t || {}, this.u = e.secureTokenEndpoint || "https://securetoken.googleapis.com/v1/token", this.m = e.secureTokenTimeout || Ja, this.g = pe(e.secureTokenHeaders || Xa), this.h = e.firebaseEndpoint || "https://www.googleapis.com/identitytoolkit/v3/relyingparty/", this.l = e.identityPlatformEndpoint || "https://identitytoolkit.googleapis.com/v2/", this.i = e.firebaseTimeout || Ka, this.a = pe(e.firebaseHeaders || $a), n && (this.a["X-Client-Version"] = n, this.g["X-Client-Version"] = n), n = "Node" == gr(), !(n = u.XMLHttpRequest || n && r.a.INTERNAL.node && r.a.INTERNAL.node.XMLHttpRequest) && !vr()) throw new k("internal-error", "The XMLHttpRequest compatibility library was not found.");
          this.f = void 0, vr() ? this.f = new la(self) : br() ? this.f = new Za(n) : this.f = new Jo(), this.b = null;
        }

        E(za, Y), E(Za, Zo), Za.prototype.a = function () {
          return new this.f();
        }, Za.prototype.b = function () {
          return {};
        };
        var Ga,
            qa = "idToken",
            Ja = new Ur(3e4, 6e4),
            Xa = {
          "Content-Type": "application/x-www-form-urlencoded"
        },
            Ka = new Ur(3e4, 6e4),
            $a = {
          "Content-Type": "application/json"
        };

        function es(e, t) {
          t ? e.a["X-Firebase-Locale"] = t : delete e.a["X-Firebase-Locale"];
        }

        function ts(e, t) {
          t ? (e.a["X-Client-Version"] = t, e.g["X-Client-Version"] = t) : (delete e.a["X-Client-Version"], delete e.g["X-Client-Version"]);
        }

        function ns(e, t, n, r, i, o, a) {
          (function () {
            var e = Lr();
            return !((e = Mr(e) != Tr ? null : (e = e.match(/\sChrome\/(\d+)/i)) && 2 == e.length ? parseInt(e[1], 10) : null) && 30 > e || Qe && nt && !(9 < nt));
          })() || vr() ? e = w(e.w, e) : (Ga || (Ga = new bt(function (e, t) {
            !function (e, t) {
              if (((window.gapi || {}).client || {}).request) e();else {
                u[is] = function () {
                  ((window.gapi || {}).client || {}).request ? e() : t(Error("CORS_UNSUPPORTED"));
                };

                var n = ke(rs, {
                  onload: is
                });
                !function (e, t) {
                  Ya(e, null, t, void 0);
                }(Pa(n), function () {
                  t(Error("CORS_UNSUPPORTED"));
                });
              }
            }(e, t);
          })), e = w(e.s, e)), e(t, n, r, i, o, a);
        }

        Qa.prototype.S = function () {
          return this.b;
        }, Qa.prototype.w = function (e, t, n, r, i, o) {
          if (vr() && (void 0 === u.fetch || void 0 === u.Headers || void 0 === u.Request)) throw new k("operation-not-supported-in-this-environment", "fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");
          var a = new _a(this.f);

          if (o) {
            a.g = Math.max(0, o);
            var s = setTimeout(function () {
              a.dispatchEvent("timeout");
            }, o);
          }

          wn(a, "complete", function () {
            s && clearTimeout(s);
            var e = null;

            try {
              e = JSON.parse(function (e) {
                try {
                  return e.a ? e.a.responseText : "";
                } catch (t) {
                  return ca(e.b, "Can not get responseText: " + t.message), "";
                }
              }(this)) || null;
            } catch (t) {
              e = null;
            }

            t && t(e);
          }), Tn(a, "ready", function () {
            s && clearTimeout(s), Bt(this);
          }), Tn(a, "timeout", function () {
            s && clearTimeout(s), Bt(this), t && t(null);
          }), ba(a, e, n, r, i);
        };
        var rs = new ve(we, "https://apis.google.com/js/client.js?onload=%{onload}"),
            is = "__fcb" + Math.floor(1e6 * Math.random()).toString();

        function os(e, t, n, r, i, o, a) {
          var s = jn(t + n);
          Fn(s, "key", e.c), a && Fn(s, "cb", M().toString());
          var u = "GET" == r;
          if (u) for (var c in i) {
            i.hasOwnProperty(c) && Fn(s, c, i[c]);
          }
          return new bt(function (t, n) {
            ns(e, s.toString(), function (e) {
              e ? e.error ? n(eu(e, o || {})) : t(e) : n(new k("network-request-failed"));
            }, r, u ? void 0 : nr(Cr(i)), e.a, e.i.get());
          });
        }

        function as(e) {
          if ("string" != typeof (e = e.email) || !pr.test(e)) throw new k("invalid-email");
        }

        function ss(e) {
          "email" in e && as(e);
        }

        function us(e) {
          if (!e[qa]) {
            if (e.mfaPendingCredential) throw new k("multi-factor-auth-required", null, pe(e));
            throw new k("internal-error");
          }
        }

        function cs(e) {
          if (e.phoneNumber || e.temporaryProof) {
            if (!e.phoneNumber || !e.temporaryProof) throw new k("internal-error");
          } else {
            if (!e.sessionInfo) throw new k("missing-verification-id");
            if (!e.code) throw new k("missing-verification-code");
          }
        }

        Qa.prototype.s = function (e, t, n, r, i) {
          var o = this;
          Ga.then(function () {
            window.gapi.client.setApiKey(o.c);
            var a = window.gapi.auth.getToken();
            window.gapi.auth.setToken(null), window.gapi.client.request({
              path: e,
              method: n,
              body: r,
              headers: i,
              authType: "none",
              callback: function callback(e) {
                window.gapi.auth.setToken(a), t && t(e);
              }
            });
          }).o(function (e) {
            t && t({
              error: {
                message: e && e.message || "CORS_UNSUPPORTED"
              }
            });
          });
        }, Qa.prototype.vb = function () {
          return Ks(this, Ps, {});
        }, Qa.prototype.xb = function (e, t) {
          return Ks(this, js, {
            idToken: e,
            email: t
          });
        }, Qa.prototype.yb = function (e, t) {
          return Ks(this, Us, {
            idToken: e,
            password: t
          });
        };
        var ls = {
          displayName: "DISPLAY_NAME",
          photoUrl: "PHOTO_URL"
        };

        function hs(e) {
          if (!e.phoneVerificationInfo) throw new k("internal-error");
          if (!e.phoneVerificationInfo.sessionInfo) throw new k("missing-verification-id");
          if (!e.phoneVerificationInfo.code) throw new k("missing-verification-code");
        }

        function ds(e) {
          if (!e.requestUri || !e.sessionId && !e.postBody && !e.pendingToken) throw new k("internal-error");
        }

        function fs(e, t) {
          return t.oauthIdToken && t.providerId && 0 == t.providerId.indexOf("oidc.") && !t.pendingToken && (e.sessionId ? t.nonce = e.sessionId : e.postBody && Kn(e = new Gn(e.postBody), "nonce") && (t.nonce = e.get("nonce"))), t;
        }

        function ps(e) {
          var t = null;
          if (e.needConfirmation ? (e.code = "account-exists-with-different-credential", t = zo(e)) : "FEDERATED_USER_ID_ALREADY_LINKED" == e.errorMessage ? (e.code = "credential-already-in-use", t = zo(e)) : "EMAIL_EXISTS" == e.errorMessage ? (e.code = "email-already-in-use", t = zo(e)) : e.errorMessage && (t = $s(e.errorMessage)), t) throw t;
          us(e);
        }

        function ms(e, t) {
          return t.returnIdpCredential = !0, Ks(e, Hs, t);
        }

        function _s(e, t) {
          return t.returnIdpCredential = !0, Ks(e, zs, t);
        }

        function ys(e, t) {
          return t.returnIdpCredential = !0, t.autoCreate = !1, Ks(e, Bs, t);
        }

        function vs(e) {
          if (!e.oobCode) throw new k("invalid-action-code");
        }

        (t = Qa.prototype).zb = function (e, t) {
          var n = {
            idToken: e
          },
              r = [];
          return de(ls, function (e, i) {
            var o = t[i];
            null === o ? r.push(e) : i in t && (n[i] = o);
          }), r.length && (n.deleteAttribute = r), Ks(this, js, n);
        }, t.rb = function (e, t) {
          return _e(e = {
            requestType: "PASSWORD_RESET",
            email: e
          }, t), Ks(this, Ys, e);
        }, t.sb = function (e, t) {
          return _e(e = {
            requestType: "EMAIL_SIGNIN",
            email: e
          }, t), Ks(this, Is, e);
        }, t.qb = function (e, t) {
          return _e(e = {
            requestType: "VERIFY_EMAIL",
            idToken: e
          }, t), Ks(this, Rs, e);
        }, t.Ab = function (e, t, n) {
          return _e(e = {
            requestType: "VERIFY_AND_CHANGE_EMAIL",
            idToken: e,
            newEmail: t
          }, n), Ks(this, xs, e);
        }, t.cb = function (e) {
          return Ks(this, Gs, e);
        }, t.jb = function (e, t) {
          return Ks(this, Fs, {
            oobCode: e,
            newPassword: t
          });
        }, t.Pa = function (e) {
          return Ks(this, bs, {
            oobCode: e
          });
        }, t.fb = function (e) {
          return Ks(this, gs, {
            oobCode: e
          });
        };
        var gs = {
          endpoint: "setAccountInfo",
          A: vs,
          Y: "email",
          C: !0
        },
            bs = {
          endpoint: "resetPassword",
          A: vs,
          G: function G(e) {
            var t = e.requestType;
            if (!t || !e.email && "EMAIL_SIGNIN" != t && "VERIFY_AND_CHANGE_EMAIL" != t) throw new k("internal-error");
          },
          C: !0
        },
            ws = {
          endpoint: "signupNewUser",
          A: function A(e) {
            if (as(e), !e.password) throw new k("weak-password");
          },
          G: us,
          U: !0,
          C: !0
        },
            Ts = {
          endpoint: "createAuthUri",
          C: !0
        },
            Ms = {
          endpoint: "deleteAccount",
          M: ["idToken"]
        },
            Es = {
          endpoint: "setAccountInfo",
          M: ["idToken", "deleteProvider"],
          A: function A(e) {
            if ("array" != d(e.deleteProvider)) throw new k("internal-error");
          }
        },
            ks = {
          endpoint: "emailLinkSignin",
          M: ["email", "oobCode"],
          A: as,
          G: us,
          U: !0,
          C: !0
        },
            Ls = {
          endpoint: "emailLinkSignin",
          M: ["idToken", "email", "oobCode"],
          A: as,
          G: us,
          U: !0
        },
            Ss = {
          endpoint: "accounts/mfaEnrollment:finalize",
          M: ["idToken", "phoneVerificationInfo"],
          A: hs,
          G: us,
          C: !0,
          La: !0
        },
            Ns = {
          endpoint: "accounts/mfaSignIn:finalize",
          M: ["mfaPendingCredential", "phoneVerificationInfo"],
          A: hs,
          G: us,
          C: !0,
          La: !0
        },
            Ds = {
          endpoint: "getAccountInfo"
        },
            Is = {
          endpoint: "getOobConfirmationCode",
          M: ["requestType"],
          A: function A(e) {
            if ("EMAIL_SIGNIN" != e.requestType) throw new k("internal-error");
            as(e);
          },
          Y: "email",
          C: !0
        },
            Rs = {
          endpoint: "getOobConfirmationCode",
          M: ["idToken", "requestType"],
          A: function A(e) {
            if ("VERIFY_EMAIL" != e.requestType) throw new k("internal-error");
          },
          Y: "email",
          C: !0
        },
            xs = {
          endpoint: "getOobConfirmationCode",
          M: ["idToken", "newEmail", "requestType"],
          A: function A(e) {
            if ("VERIFY_AND_CHANGE_EMAIL" != e.requestType) throw new k("internal-error");
          },
          Y: "email",
          C: !0
        },
            Ys = {
          endpoint: "getOobConfirmationCode",
          M: ["requestType"],
          A: function A(e) {
            if ("PASSWORD_RESET" != e.requestType) throw new k("internal-error");
            as(e);
          },
          Y: "email",
          C: !0
        },
            Cs = {
          hb: !0,
          endpoint: "getProjectConfig",
          Rb: "GET"
        },
            Os = {
          hb: !0,
          endpoint: "getRecaptchaParam",
          Rb: "GET",
          G: function G(e) {
            if (!e.recaptchaSiteKey) throw new k("internal-error");
          }
        },
            Fs = {
          endpoint: "resetPassword",
          A: vs,
          Y: "email",
          C: !0
        },
            As = {
          endpoint: "sendVerificationCode",
          M: ["phoneNumber", "recaptchaToken"],
          Y: "sessionInfo",
          C: !0
        },
            js = {
          endpoint: "setAccountInfo",
          M: ["idToken"],
          A: ss,
          U: !0
        },
            Us = {
          endpoint: "setAccountInfo",
          M: ["idToken"],
          A: function A(e) {
            if (ss(e), !e.password) throw new k("weak-password");
          },
          G: us,
          U: !0
        },
            Ps = {
          endpoint: "signupNewUser",
          G: us,
          U: !0,
          C: !0
        },
            Vs = {
          endpoint: "accounts/mfaEnrollment:start",
          M: ["idToken", "phoneEnrollmentInfo"],
          A: function A(e) {
            if (!e.phoneEnrollmentInfo) throw new k("internal-error");
            if (!e.phoneEnrollmentInfo.phoneNumber) throw new k("missing-phone-number");
            if (!e.phoneEnrollmentInfo.recaptchaToken) throw new k("missing-app-credential");
          },
          G: function G(e) {
            if (!e.phoneSessionInfo || !e.phoneSessionInfo.sessionInfo) throw new k("internal-error");
          },
          C: !0,
          La: !0
        },
            Ws = {
          endpoint: "accounts/mfaSignIn:start",
          M: ["mfaPendingCredential", "mfaEnrollmentId", "phoneSignInInfo"],
          A: function A(e) {
            if (!e.phoneSignInInfo || !e.phoneSignInInfo.recaptchaToken) throw new k("missing-app-credential");
          },
          G: function G(e) {
            if (!e.phoneResponseInfo || !e.phoneResponseInfo.sessionInfo) throw new k("internal-error");
          },
          C: !0,
          La: !0
        },
            Hs = {
          endpoint: "verifyAssertion",
          A: ds,
          Wa: fs,
          G: ps,
          U: !0,
          C: !0
        },
            Bs = {
          endpoint: "verifyAssertion",
          A: ds,
          Wa: fs,
          G: function G(e) {
            if (e.errorMessage && "USER_NOT_FOUND" == e.errorMessage) throw new k("user-not-found");
            if (e.errorMessage) throw $s(e.errorMessage);
            us(e);
          },
          U: !0,
          C: !0
        },
            zs = {
          endpoint: "verifyAssertion",
          A: function A(e) {
            if (ds(e), !e.idToken) throw new k("internal-error");
          },
          Wa: fs,
          G: ps,
          U: !0
        },
            Zs = {
          endpoint: "verifyCustomToken",
          A: function A(e) {
            if (!e.token) throw new k("invalid-custom-token");
          },
          G: us,
          U: !0,
          C: !0
        },
            Qs = {
          endpoint: "verifyPassword",
          A: function A(e) {
            if (as(e), !e.password) throw new k("wrong-password");
          },
          G: us,
          U: !0,
          C: !0
        },
            Gs = {
          endpoint: "verifyPhoneNumber",
          A: cs,
          G: us,
          C: !0
        },
            qs = {
          endpoint: "verifyPhoneNumber",
          A: function A(e) {
            if (!e.idToken) throw new k("internal-error");
            cs(e);
          },
          G: function G(e) {
            if (e.temporaryProof) throw e.code = "credential-already-in-use", zo(e);
            us(e);
          }
        },
            Js = {
          Eb: {
            USER_NOT_FOUND: "user-not-found"
          },
          endpoint: "verifyPhoneNumber",
          A: cs,
          G: us,
          C: !0
        },
            Xs = {
          endpoint: "accounts/mfaEnrollment:withdraw",
          M: ["idToken", "mfaEnrollmentId"],
          G: function G(e) {
            if (!!e[qa] ^ !!e.refreshToken) throw new k("internal-error");
          },
          C: !0,
          La: !0
        };

        function Ks(e, t, n) {
          if (!function (e, t) {
            if (!t || !t.length) return !0;
            if (!e) return !1;

            for (var n = 0; n < t.length; n++) {
              var r = e[t[n]];
              if (null == r || "" === r) return !1;
            }

            return !0;
          }(n, t.M)) return Nt(new k("internal-error"));
          var r,
              i = !!t.La,
              o = t.Rb || "POST";
          return St(n).then(t.A).then(function () {
            return t.U && (n.returnSecureToken = !0), t.C && e.b && void 0 === n.tenantId && (n.tenantId = e.b), os(e, i ? e.l : e.h, t.endpoint, o, n, t.Eb, t.hb || !1);
          }).then(function (e) {
            return r = e, t.Wa ? t.Wa(n, r) : r;
          }).then(t.G).then(function () {
            if (!t.Y) return r;
            if (!(t.Y in r)) throw new k("internal-error");
            return r[t.Y];
          });
        }

        function $s(e) {
          return eu({
            error: {
              errors: [{
                message: e
              }],
              code: 400,
              message: e
            }
          });
        }

        function eu(e, t) {
          var n = (e.error && e.error.errors && e.error.errors[0] || {}).reason || "",
              r = {
            keyInvalid: "invalid-api-key",
            ipRefererBlocked: "app-not-authorized"
          };
          if (n = r[n] ? new k(r[n]) : null) return n;

          for (var i in n = e.error && e.error.message || "", _e(r = {
            INVALID_CUSTOM_TOKEN: "invalid-custom-token",
            CREDENTIAL_MISMATCH: "custom-token-mismatch",
            MISSING_CUSTOM_TOKEN: "internal-error",
            INVALID_IDENTIFIER: "invalid-email",
            MISSING_CONTINUE_URI: "internal-error",
            INVALID_EMAIL: "invalid-email",
            INVALID_PASSWORD: "wrong-password",
            USER_DISABLED: "user-disabled",
            MISSING_PASSWORD: "internal-error",
            EMAIL_EXISTS: "email-already-in-use",
            PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
            INVALID_IDP_RESPONSE: "invalid-credential",
            INVALID_PENDING_TOKEN: "invalid-credential",
            FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
            MISSING_OR_INVALID_NONCE: "missing-or-invalid-nonce",
            INVALID_MESSAGE_PAYLOAD: "invalid-message-payload",
            INVALID_RECIPIENT_EMAIL: "invalid-recipient-email",
            INVALID_SENDER: "invalid-sender",
            EMAIL_NOT_FOUND: "user-not-found",
            RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
            EXPIRED_OOB_CODE: "expired-action-code",
            INVALID_OOB_CODE: "invalid-action-code",
            MISSING_OOB_CODE: "internal-error",
            INVALID_PROVIDER_ID: "invalid-provider-id",
            CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
            INVALID_ID_TOKEN: "invalid-user-token",
            TOKEN_EXPIRED: "user-token-expired",
            USER_NOT_FOUND: "user-token-expired",
            CORS_UNSUPPORTED: "cors-unsupported",
            DYNAMIC_LINK_NOT_ACTIVATED: "dynamic-link-not-activated",
            INVALID_APP_ID: "invalid-app-id",
            TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
            WEAK_PASSWORD: "weak-password",
            OPERATION_NOT_ALLOWED: "operation-not-allowed",
            USER_CANCELLED: "user-cancelled",
            CAPTCHA_CHECK_FAILED: "captcha-check-failed",
            INVALID_APP_CREDENTIAL: "invalid-app-credential",
            INVALID_CODE: "invalid-verification-code",
            INVALID_PHONE_NUMBER: "invalid-phone-number",
            INVALID_SESSION_INFO: "invalid-verification-id",
            INVALID_TEMPORARY_PROOF: "invalid-credential",
            MISSING_APP_CREDENTIAL: "missing-app-credential",
            MISSING_CODE: "missing-verification-code",
            MISSING_PHONE_NUMBER: "missing-phone-number",
            MISSING_SESSION_INFO: "missing-verification-id",
            QUOTA_EXCEEDED: "quota-exceeded",
            SESSION_EXPIRED: "code-expired",
            REJECTED_CREDENTIAL: "rejected-credential",
            INVALID_CONTINUE_URI: "invalid-continue-uri",
            MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
            MISSING_IOS_BUNDLE_ID: "missing-ios-bundle-id",
            UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
            INVALID_DYNAMIC_LINK_DOMAIN: "invalid-dynamic-link-domain",
            INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
            INVALID_CERT_HASH: "invalid-cert-hash",
            UNSUPPORTED_TENANT_OPERATION: "unsupported-tenant-operation",
            INVALID_TENANT_ID: "invalid-tenant-id",
            TENANT_ID_MISMATCH: "tenant-id-mismatch",
            ADMIN_ONLY_OPERATION: "admin-restricted-operation",
            INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
            MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
            MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
            MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
            EMAIL_CHANGE_NEEDS_VERIFICATION: "email-change-needs-verification",
            SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
            SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
            UNSUPPORTED_FIRST_FACTOR: "unsupported-first-factor",
            UNVERIFIED_EMAIL: "unverified-email"
          }, t || {}), t = (t = n.match(/^[^\s]+\s*:\s*([\s\S]*)$/)) && 1 < t.length ? t[1] : void 0, r) {
            if (0 === n.indexOf(i)) return new k(r[i], t);
          }

          return !t && e && (t = Yr(e)), new k("internal-error", t);
        }

        function tu(e) {
          this.b = e, this.a = null, this.nb = function (e) {
            return (ou || (ou = new bt(function (e, t) {
              function n() {
                jr(), Sr("gapi.load")("gapi.iframes", {
                  callback: e,
                  ontimeout: function ontimeout() {
                    jr(), t(Error("Network Error"));
                  },
                  timeout: ru.get()
                });
              }

              if (Sr("gapi.iframes.Iframe")) e();else if (Sr("gapi.load")) n();else {
                var r = "__iframefcb" + Math.floor(1e6 * Math.random()).toString();
                u[r] = function () {
                  Sr("gapi.load") ? n() : t(Error("Network Error"));
                }, St(Pa(r = ke(nu, {
                  onload: r
                }))).o(function () {
                  t(Error("Network Error"));
                });
              }
            }).o(function (e) {
              throw ou = null, e;
            }))).then(function () {
              return new bt(function (t, n) {
                Sr("gapi.iframes.getContext")().open({
                  where: document.body,
                  url: e.b,
                  messageHandlersFilter: Sr("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),
                  attributes: {
                    style: {
                      position: "absolute",
                      top: "-100px",
                      width: "1px",
                      height: "1px"
                    }
                  },
                  dontclear: !0
                }, function (r) {
                  function i() {
                    clearTimeout(o), t();
                  }

                  e.a = r, e.a.restyle({
                    setHideOnLeave: !1
                  });
                  var o = setTimeout(function () {
                    n(Error("Network Error"));
                  }, iu.get());
                  r.ping(i).then(i, function () {
                    n(Error("Network Error"));
                  });
                });
              });
            });
          }(this);
        }

        var nu = new ve(we, "https://apis.google.com/js/api.js?onload=%{onload}"),
            ru = new Ur(3e4, 6e4),
            iu = new Ur(5e3, 15e3),
            ou = null;

        function au(e, t, n) {
          this.i = e, this.g = t, this.h = n, this.f = null, this.a = Un(this.i, "/__/auth/iframe"), Fn(this.a, "apiKey", this.g), Fn(this.a, "appName", this.h), this.b = null, this.c = [];
        }

        function su(e, t, n, r, i) {
          this.s = e, this.m = t, this.c = n, this.u = r, this.i = this.g = this.l = null, this.a = i, this.h = this.f = null;
        }

        function uu(e) {
          try {
            return r.a.app(e).auth().Ea();
          } catch (e) {
            return [];
          }
        }

        function cu(e, t, n, r, i) {
          this.u = e, this.f = t, this.b = n, this.c = r || null, this.h = i || null, this.m = this.s = this.w = null, this.g = [], this.l = this.a = null;
        }

        function lu(e) {
          var t = ur();
          return function (e) {
            return Ks(e, Cs, {}).then(function (e) {
              return e.authorizedDomains || [];
            });
          }(e).then(function (e) {
            e: {
              var n = jn(t),
                  r = n.f;
              n = n.b;

              for (var i = 0; i < e.length; i++) {
                var o = e[i],
                    a = n,
                    s = r;

                if (0 == o.indexOf("chrome-extension://") ? a = jn(o).b == a && "chrome-extension" == s : "http" != s && "https" != s ? a = !1 : fr.test(o) ? a = a == o : (o = o.split(".").join("\\."), a = new RegExp("^(.+\\." + o + "|" + o + ")$", "i").test(a)), a) {
                  e = !0;
                  break e;
                }
              }

              e = !1;
            }

            if (!e) throw new Ho(ur());
          });
        }

        function hu(e) {
          return e.l ? e.l : (e.l = mr().then(function () {
            if (!e.s) {
              var t = e.c,
                  n = e.h,
                  r = uu(e.b),
                  i = new au(e.u, e.f, e.b);
              i.f = t, i.b = n, i.c = X(r || []), e.s = i.toString();
            }

            e.i = new tu(e.s), function (e) {
              if (!e.i) throw Error("IfcHandler must be initialized!");
              !function (e, t) {
                e.nb.then(function () {
                  e.a.register("authEvent", t, Sr("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
                });
              }(e.i, function (t) {
                var n = {};

                if (t && t.authEvent) {
                  var r = !1;

                  for (t = Uo(t.authEvent), n = 0; n < e.g.length; n++) {
                    r = e.g[n](t) || r;
                  }

                  return (n = {}).status = r ? "ACK" : "ERROR", St(n);
                }

                return n.status = "ERROR", St(n);
              });
            }(e);
          }), e.l);
        }

        function du(e) {
          return e.m || (e.w = e.c ? kr(e.c, uu(e.b)) : null, e.m = new Qa(e.f, R(e.h), e.w)), e.m;
        }

        function fu(e, t, n, r, i, o, a, s, u, c, l) {
          return (e = new su(e, t, n, r, i)).l = o, e.g = a, e.i = s, e.b = pe(u || null), e.f = c, e.ub(l).toString();
        }

        function pu(e) {
          if (this.a = e || r.a.INTERNAL.reactNative && r.a.INTERNAL.reactNative.AsyncStorage, !this.a) throw new k("internal-error", "The React Native compatibility library was not found.");
          this.type = "asyncStorage";
        }

        function mu(e) {
          this.b = e, this.a = {}, this.f = w(this.c, this);
        }

        au.prototype.toString = function () {
          return this.f ? Fn(this.a, "v", this.f) : Xn(this.a.a, "v"), this.b ? Fn(this.a, "eid", this.b) : Xn(this.a.a, "eid"), this.c.length ? Fn(this.a, "fw", this.c.join(",")) : Xn(this.a.a, "fw"), this.a.toString();
        }, su.prototype.ub = function (e) {
          return this.h = e, this;
        }, su.prototype.toString = function () {
          var e = Un(this.s, "/__/auth/handler");

          if (Fn(e, "apiKey", this.m), Fn(e, "appName", this.c), Fn(e, "authType", this.u), this.a.isOAuthProvider) {
            var t = this.a;

            try {
              var n = r.a.app(this.c).auth().ja();
            } catch (e) {
              n = null;
            }

            for (var i in t.kb = n, Fn(e, "providerId", this.a.providerId), n = Cr((t = this.a).Fb)) {
              n[i] = n[i].toString();
            }

            i = t.Oc, n = pe(n);

            for (var o = 0; o < i.length; o++) {
              var a = i[o];
              a in n && delete n[a];
            }

            t.lb && t.kb && !n[t.lb] && (n[t.lb] = t.kb), fe(n) || Fn(e, "customParameters", Yr(n));
          }

          if ("function" == typeof this.a.Nb && (t = this.a.Nb()).length && Fn(e, "scopes", t.join(",")), this.l ? Fn(e, "redirectUrl", this.l) : Xn(e.a, "redirectUrl"), this.g ? Fn(e, "eventId", this.g) : Xn(e.a, "eventId"), this.i ? Fn(e, "v", this.i) : Xn(e.a, "v"), this.b) for (var s in this.b) {
            this.b.hasOwnProperty(s) && !An(e, s) && Fn(e, s, this.b[s]);
          }
          return this.h ? Fn(e, "tid", this.h) : Xn(e.a, "tid"), this.f ? Fn(e, "eid", this.f) : Xn(e.a, "eid"), (s = uu(this.c)).length && Fn(e, "fw", s.join(",")), e.toString();
        }, (t = cu.prototype).Lb = function (e, t, n) {
          var r = new k("popup-closed-by-user"),
              i = new k("web-storage-unsupported"),
              o = this,
              a = !1;
          return this.ka().then(function () {
            (function (e) {
              var t = {
                type: "webStorageSupport"
              };
              return hu(e).then(function () {
                return function (e, t) {
                  return e.nb.then(function () {
                    return new bt(function (n) {
                      e.a.send(t.type, t, n, Sr("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
                    });
                  });
                }(e.i, t);
              }).then(function (e) {
                if (e && e.length && void 0 !== e[0].webStorageSupport) return e[0].webStorageSupport;
                throw Error();
              });
            })(o).then(function (n) {
              n || (e && hr(e), t(i), a = !0);
            });
          }).o(function () {}).then(function () {
            if (!a) return function (e) {
              return new bt(function (t) {
                return function n() {
                  kn(2e3).then(function () {
                    if (e && !e.closed) return n();
                    t();
                  });
                }();
              });
            }(e);
          }).then(function () {
            if (!a) return kn(n).then(function () {
              t(r);
            });
          });
        }, t.Ub = function () {
          var e = Lr();
          return !xr(e) && !Ar(e);
        }, t.Qb = function () {
          return !1;
        }, t.Jb = function (e, t, n, r, i, o, a, s) {
          if (!e) return Nt(new k("popup-blocked"));
          if (a && !xr()) return this.ka().o(function (t) {
            hr(e), i(t);
          }), r(), St();
          this.a || (this.a = lu(du(this)));
          var u = this;
          return this.a.then(function () {
            var t = u.ka().o(function (t) {
              throw hr(e), i(t), t;
            });
            return r(), t;
          }).then(function () {
            (Ao(n), a) || cr(fu(u.u, u.f, u.b, t, n, null, o, u.c, void 0, u.h, s), e);
          }).o(function (e) {
            throw "auth/network-request-failed" == e.code && (u.a = null), e;
          });
        }, t.Kb = function (e, t, n, r) {
          this.a || (this.a = lu(du(this)));
          var i = this;
          return this.a.then(function () {
            Ao(t), cr(fu(i.u, i.f, i.b, e, t, ur(), n, i.c, void 0, i.h, r));
          }).o(function (e) {
            throw "auth/network-request-failed" == e.code && (i.a = null), e;
          });
        }, t.ka = function () {
          var e = this;
          return hu(this).then(function () {
            return e.i.nb;
          }).o(function () {
            throw e.a = null, new k("network-request-failed");
          });
        }, t.Xb = function () {
          return !0;
        }, t.Ca = function (e) {
          this.g.push(e);
        }, t.Qa = function (e) {
          q(this.g, function (t) {
            return t == e;
          });
        }, (t = pu.prototype).get = function (e) {
          return St(this.a.getItem(e)).then(function (e) {
            return e && Or(e);
          });
        }, t.set = function (e, t) {
          return St(this.a.setItem(e, Yr(t)));
        }, t.T = function (e) {
          return St(this.a.removeItem(e));
        }, t.ba = function () {}, t.ha = function () {};

        var _u,
            yu = [];

        function vu(e, t, n) {
          fe(e.a) && e.b.addEventListener("message", e.f), void 0 === e.a[t] && (e.a[t] = []), e.a[t].push(n);
        }

        function gu(e) {
          this.a = e;
        }

        function bu(e) {
          this.c = e, this.b = !1, this.a = [];
        }

        function wu(e, t, n, r) {
          var i,
              o,
              a,
              s,
              u = n || {},
              c = null;
          if (e.b) return Nt(Error("connection_unavailable"));
          var l = r ? 800 : 50,
              h = "undefined" != typeof MessageChannel ? new MessageChannel() : null;
          return new bt(function (n, r) {
            h ? (i = Math.floor(Math.random() * Math.pow(10, 20)).toString(), h.port1.start(), a = setTimeout(function () {
              r(Error("unsupported_event"));
            }, l), c = {
              messageChannel: h,
              onMessage: o = function o(e) {
                e.data.eventId === i && ("ack" === e.data.status ? (clearTimeout(a), s = setTimeout(function () {
                  r(Error("timeout"));
                }, 3e3)) : "done" === e.data.status ? (clearTimeout(s), void 0 !== e.data.response ? n(e.data.response) : r(Error("unknown_error"))) : (clearTimeout(a), clearTimeout(s), r(Error("invalid_response"))));
              }
            }, e.a.push(c), h.port1.addEventListener("message", o), e.c.postMessage({
              eventType: t,
              eventId: i,
              data: u
            }, [h.port2])) : r(Error("connection_unavailable"));
          }).then(function (t) {
            return Tu(e, c), t;
          }).o(function (t) {
            throw Tu(e, c), t;
          });
        }

        function Tu(e, t) {
          if (t) {
            var n = t.messageChannel,
                r = t.onMessage;
            n && (n.port1.removeEventListener("message", r), n.port1.close()), q(e.a, function (e) {
              return e == t;
            });
          }
        }

        function Mu() {
          if (!Lu()) throw new k("web-storage-unsupported");
          this.c = {}, this.a = [], this.b = 0, this.u = u.indexedDB, this.type = "indexedDB", this.g = this.l = this.f = this.i = null, this.s = !1, this.h = null;
          var e = this;
          vr() && self ? (this.l = function () {
            var e = vr() ? self : null;

            if (H(yu, function (n) {
              n.b == e && (t = n);
            }), !t) {
              var t = new mu(e);
              yu.push(t);
            }

            return t;
          }(), vu(this.l, "keyChanged", function (t, n) {
            return Ru(e).then(function (t) {
              return 0 < t.length && H(e.a, function (e) {
                e(t);
              }), {
                keyProcessed: Q(t, n.key)
              };
            });
          }), vu(this.l, "ping", function () {
            return St(["keyChanged"]);
          })) : function () {
            var e = u.navigator;
            return e && e.serviceWorker ? St().then(function () {
              return e.serviceWorker.ready;
            }).then(function (e) {
              return e.active || null;
            }).o(function () {
              return null;
            }) : St(null);
          }().then(function (t) {
            (e.h = t) && (e.g = new bu(new gu(t)), wu(e.g, "ping", null, !0).then(function (t) {
              t[0].fulfilled && Q(t[0].value, "keyChanged") && (e.s = !0);
            }).o(function () {}));
          });
        }

        function Eu(e) {
          return new bt(function (t, n) {
            var r = e.u.open("firebaseLocalStorageDb", 1);
            r.onerror = function (e) {
              try {
                e.preventDefault();
              } catch (e) {}

              n(Error(e.target.error));
            }, r.onupgradeneeded = function (e) {
              e = e.target.result;

              try {
                e.createObjectStore("firebaseLocalStorage", {
                  keyPath: "fbase_key"
                });
              } catch (e) {
                n(e);
              }
            }, r.onsuccess = function (r) {
              (r = r.target.result).objectStoreNames.contains("firebaseLocalStorage") ? t(r) : function (e) {
                return new bt(function (t, n) {
                  var r = e.u.deleteDatabase("firebaseLocalStorageDb");
                  r.onsuccess = function () {
                    t();
                  }, r.onerror = function (e) {
                    n(Error(e.target.error));
                  };
                });
              }(e).then(function () {
                return Eu(e);
              }).then(function (e) {
                t(e);
              }).o(function (e) {
                n(e);
              });
            };
          });
        }

        function ku(e) {
          return e.m || (e.m = Eu(e)), e.m;
        }

        function Lu() {
          try {
            return !!u.indexedDB;
          } catch (e) {
            return !1;
          }
        }

        function Su(e) {
          return e.objectStore("firebaseLocalStorage");
        }

        function Nu(e, t) {
          return e.transaction(["firebaseLocalStorage"], t ? "readwrite" : "readonly");
        }

        function Du(e) {
          return new bt(function (t, n) {
            e.onsuccess = function (e) {
              e && e.target ? t(e.target.result) : t();
            }, e.onerror = function (e) {
              n(e.target.error);
            };
          });
        }

        function Iu(e, t) {
          return e.g && e.h && function () {
            var e = u.navigator;
            return e && e.serviceWorker && e.serviceWorker.controller || null;
          }() === e.h ? wu(e.g, "keyChanged", {
            key: t
          }, e.s).then(function () {}).o(function () {}) : St();
        }

        function Ru(e) {
          return ku(e).then(function (e) {
            var t = Su(Nu(e, !1));
            return t.getAll ? Du(t.getAll()) : new bt(function (e, n) {
              var r = [],
                  i = t.openCursor();
              i.onsuccess = function (t) {
                (t = t.target.result) ? (r.push(t.value), t.continue()) : e(r);
              }, i.onerror = function (e) {
                n(e.target.error);
              };
            });
          }).then(function (t) {
            var n = {},
                r = [];

            if (0 == e.b) {
              for (r = 0; r < t.length; r++) {
                n[t[r].fbase_key] = t[r].value;
              }

              r = function e(t, n) {
                var r,
                    i = [];

                for (r in t) {
                  r in n ? typeof t[r] != typeof n[r] ? i.push(r) : "object" == typeof t[r] && null != t[r] && null != n[r] ? 0 < e(t[r], n[r]).length && i.push(r) : t[r] !== n[r] && i.push(r) : i.push(r);
                }

                for (r in n) {
                  r in t || i.push(r);
                }

                return i;
              }(e.c, n), e.c = n;
            }

            return r;
          });
        }

        function xu(e) {
          e.i && e.i.cancel("STOP_EVENT"), e.f && (clearTimeout(e.f), e.f = null);
        }

        function Yu(e) {
          var t = this,
              n = null;
          this.a = [], this.type = "indexedDB", this.c = e, this.b = St().then(function () {
            if (Lu()) {
              var e = Fr(),
                  r = "__sak" + e;
              return _u || (_u = new Mu()), (n = _u).set(r, e).then(function () {
                return n.get(r);
              }).then(function (t) {
                if (t !== e) throw Error("indexedDB not supported!");
                return n.T(r);
              }).then(function () {
                return n;
              }).o(function () {
                return t.c;
              });
            }

            return t.c;
          }).then(function (e) {
            return t.type = e.type, e.ba(function (e) {
              H(t.a, function (t) {
                t(e);
              });
            }), e;
          });
        }

        function Cu() {
          this.a = {}, this.type = "inMemory";
        }

        function Ou() {
          if (!function () {
            var e = "Node" == gr();
            if (!(e = Fu() || e && r.a.INTERNAL.node && r.a.INTERNAL.node.localStorage)) return !1;

            try {
              return e.setItem("__sak", "1"), e.removeItem("__sak"), !0;
            } catch (e) {
              return !1;
            }
          }()) {
            if ("Node" == gr()) throw new k("internal-error", "The LocalStorage compatibility library was not found.");
            throw new k("web-storage-unsupported");
          }

          this.a = Fu() || r.a.INTERNAL.node.localStorage, this.type = "localStorage";
        }

        function Fu() {
          try {
            var e = u.localStorage,
                t = Fr();
            return e && (e.setItem(t, "1"), e.removeItem(t)), e;
          } catch (e) {
            return null;
          }
        }

        function Au() {
          this.type = "nullStorage";
        }

        function ju() {
          if (!function () {
            var e = "Node" == gr();
            if (!(e = Uu() || e && r.a.INTERNAL.node && r.a.INTERNAL.node.sessionStorage)) return !1;

            try {
              return e.setItem("__sak", "1"), e.removeItem("__sak"), !0;
            } catch (e) {
              return !1;
            }
          }()) {
            if ("Node" == gr()) throw new k("internal-error", "The SessionStorage compatibility library was not found.");
            throw new k("web-storage-unsupported");
          }

          this.a = Uu() || r.a.INTERNAL.node.sessionStorage, this.type = "sessionStorage";
        }

        function Uu() {
          try {
            var e = u.sessionStorage,
                t = Fr();
            return e && (e.setItem(t, "1"), e.removeItem(t)), e;
          } catch (e) {
            return null;
          }
        }

        function Pu() {
          var e = {};
          e.Browser = Hu, e.Node = Bu, e.ReactNative = zu, e.Worker = Zu, this.a = e[gr()];
        }

        mu.prototype.c = function (e) {
          var t = e.data.eventType,
              n = e.data.eventId,
              r = this.a[t];

          if (r && 0 < r.length) {
            e.ports[0].postMessage({
              status: "ack",
              eventId: n,
              eventType: t,
              response: null
            });
            var i = [];
            H(r, function (t) {
              i.push(St().then(function () {
                return t(e.origin, e.data.data);
              }));
            }), It(i).then(function (r) {
              var i = [];
              H(r, function (e) {
                i.push({
                  fulfilled: e.Mb,
                  value: e.value,
                  reason: e.reason ? e.reason.message : void 0
                });
              }), H(i, function (e) {
                for (var t in e) {
                  void 0 === e[t] && delete e[t];
                }
              }), e.ports[0].postMessage({
                status: "done",
                eventId: n,
                eventType: t,
                response: i
              });
            });
          }
        }, gu.prototype.postMessage = function (e, t) {
          this.a.postMessage(e, t);
        }, bu.prototype.close = function () {
          for (; 0 < this.a.length;) {
            Tu(this, this.a[0]);
          }

          this.b = !0;
        }, (t = Mu.prototype).set = function (e, t) {
          var n,
              r = !1,
              i = this;
          return ku(this).then(function (t) {
            return Du((t = Su(Nu(n = t, !0))).get(e));
          }).then(function (o) {
            var a = Su(Nu(n, !0));
            return o ? (o.value = t, Du(a.put(o))) : (i.b++, r = !0, (o = {}).fbase_key = e, o.value = t, Du(a.add(o)));
          }).then(function () {
            return i.c[e] = t, Iu(i, e);
          }).ma(function () {
            r && i.b--;
          });
        }, t.get = function (e) {
          return ku(this).then(function (t) {
            return Du(Su(Nu(t, !1)).get(e));
          }).then(function (e) {
            return e && e.value;
          });
        }, t.T = function (e) {
          var t = !1,
              n = this;
          return ku(this).then(function (r) {
            return t = !0, n.b++, Du(Su(Nu(r, !0)).delete(e));
          }).then(function () {
            return delete n.c[e], Iu(n, e);
          }).ma(function () {
            t && n.b--;
          });
        }, t.ba = function (e) {
          0 == this.a.length && function (e) {
            xu(e), function t() {
              e.f = setTimeout(function () {
                e.i = Ru(e).then(function (t) {
                  0 < t.length && H(e.a, function (e) {
                    e(t);
                  });
                }).then(function () {
                  t();
                }).o(function (e) {
                  "STOP_EVENT" != e.message && t();
                });
              }, 800);
            }();
          }(this), this.a.push(e);
        }, t.ha = function (e) {
          q(this.a, function (t) {
            return t == e;
          }), 0 == this.a.length && xu(this);
        }, (t = Yu.prototype).get = function (e) {
          return this.b.then(function (t) {
            return t.get(e);
          });
        }, t.set = function (e, t) {
          return this.b.then(function (n) {
            return n.set(e, t);
          });
        }, t.T = function (e) {
          return this.b.then(function (t) {
            return t.T(e);
          });
        }, t.ba = function (e) {
          this.a.push(e);
        }, t.ha = function (e) {
          q(this.a, function (t) {
            return t == e;
          });
        }, (t = Cu.prototype).get = function (e) {
          return St(this.a[e]);
        }, t.set = function (e, t) {
          return this.a[e] = t, St();
        }, t.T = function (e) {
          return delete this.a[e], St();
        }, t.ba = function () {}, t.ha = function () {}, (t = Ou.prototype).get = function (e) {
          var t = this;
          return St().then(function () {
            return Or(t.a.getItem(e));
          });
        }, t.set = function (e, t) {
          var n = this;
          return St().then(function () {
            var r = Yr(t);
            null === r ? n.T(e) : n.a.setItem(e, r);
          });
        }, t.T = function (e) {
          var t = this;
          return St().then(function () {
            t.a.removeItem(e);
          });
        }, t.ba = function (e) {
          u.window && un(u.window, "storage", e);
        }, t.ha = function (e) {
          u.window && hn(u.window, "storage", e);
        }, (t = Au.prototype).get = function () {
          return St(null);
        }, t.set = function () {
          return St();
        }, t.T = function () {
          return St();
        }, t.ba = function () {}, t.ha = function () {}, (t = ju.prototype).get = function (e) {
          var t = this;
          return St().then(function () {
            return Or(t.a.getItem(e));
          });
        }, t.set = function (e, t) {
          var n = this;
          return St().then(function () {
            var r = Yr(t);
            null === r ? n.T(e) : n.a.setItem(e, r);
          });
        }, t.T = function (e) {
          var t = this;
          return St().then(function () {
            t.a.removeItem(e);
          });
        }, t.ba = function () {}, t.ha = function () {};
        var Vu,
            Wu,
            Hu = {
          F: Ou,
          $a: ju
        },
            Bu = {
          F: Ou,
          $a: ju
        },
            zu = {
          F: pu,
          $a: Au
        },
            Zu = {
          F: Ou,
          $a: Au
        },
            Qu = {
          od: "local",
          NONE: "none",
          qd: "session"
        };

        function Gu() {
          var e = !(Ar(Lr()) || !yr()),
              t = xr(),
              n = Nr();
          this.m = e, this.h = t, this.l = n, this.a = {}, Vu || (Vu = new Pu()), e = Vu;

          try {
            this.g = !sr() && Wr() || !u.indexedDB ? new e.a.F() : new Yu(vr() ? new Cu() : new e.a.F());
          } catch (e) {
            this.g = new Cu(), this.h = !0;
          }

          try {
            this.i = new e.a.$a();
          } catch (e) {
            this.i = new Cu();
          }

          this.u = new Cu(), this.f = w(this.Vb, this), this.b = {};
        }

        function qu() {
          return Wu || (Wu = new Gu()), Wu;
        }

        function Ju(e, t) {
          switch (t) {
            case "session":
              return e.i;

            case "none":
              return e.u;

            default:
              return e.g;
          }
        }

        function Xu(e, t) {
          return "firebase:" + e.name + (t ? ":" + t : "");
        }

        function Ku(e, t, n) {
          return n = Xu(t, n), "local" == t.F && (e.b[n] = null), Ju(e, t.F).T(n);
        }

        function $u(e) {
          e.c && (clearInterval(e.c), e.c = null);
        }

        function ec(e) {
          this.a = e, this.b = qu();
        }

        (t = Gu.prototype).get = function (e, t) {
          return Ju(this, e.F).get(Xu(e, t));
        }, t.set = function (e, t, n) {
          var r = Xu(e, n),
              i = this,
              o = Ju(this, e.F);
          return o.set(r, t).then(function () {
            return o.get(r);
          }).then(function (t) {
            "local" == e.F && (i.b[r] = t);
          });
        }, t.addListener = function (e, t, n) {
          e = Xu(e, t), this.l && (this.b[e] = u.localStorage.getItem(e)), fe(this.a) && (Ju(this, "local").ba(this.f), this.h || (sr() || !Wr()) && u.indexedDB || !this.l || function (e) {
            $u(e), e.c = setInterval(function () {
              for (var t in e.a) {
                var n = u.localStorage.getItem(t),
                    r = e.b[t];
                n != r && (e.b[t] = n, n = new Jt({
                  type: "storage",
                  key: t,
                  target: window,
                  oldValue: r,
                  newValue: n,
                  a: !0
                }), e.Vb(n));
              }
            }, 1e3);
          }(this)), this.a[e] || (this.a[e] = []), this.a[e].push(n);
        }, t.removeListener = function (e, t, n) {
          e = Xu(e, t), this.a[e] && (q(this.a[e], function (e) {
            return e == n;
          }), 0 == this.a[e].length && delete this.a[e]), fe(this.a) && (Ju(this, "local").ha(this.f), $u(this));
        }, t.Vb = function (e) {
          if (e && e.f) {
            var t = e.a.key;
            if (null == t) for (var n in this.a) {
              var r = this.b[n];
              void 0 === r && (r = null);
              var i = u.localStorage.getItem(n);
              i !== r && (this.b[n] = i, this.ib(n));
            } else if (0 == t.indexOf("firebase:") && this.a[t]) {
              if (void 0 !== e.a.a ? Ju(this, "local").ha(this.f) : $u(this), this.m) if (n = u.localStorage.getItem(t), (r = e.a.newValue) !== n) null !== r ? u.localStorage.setItem(t, r) : u.localStorage.removeItem(t);else if (this.b[t] === r && void 0 === e.a.a) return;
              var o = this;
              n = function n() {
                void 0 === e.a.a && o.b[t] === u.localStorage.getItem(t) || (o.b[t] = u.localStorage.getItem(t), o.ib(t));
              }, Qe && nt && 10 == nt && u.localStorage.getItem(t) !== e.a.newValue && e.a.newValue !== e.a.oldValue ? setTimeout(n, 10) : n();
            }
          } else H(e, w(this.ib, this));
        }, t.ib = function (e) {
          this.a[e] && H(this.a[e], function (e) {
            e();
          });
        };
        var tc,
            nc = {
          name: "authEvent",
          F: "local"
        };

        function rc() {
          this.a = qu();
        }

        function ic(e, t) {
          this.b = oc, this.f = u.Uint8Array ? new Uint8Array(this.b) : Array(this.b), this.g = this.c = 0, this.a = [], this.i = e, this.h = t, this.l = u.Int32Array ? new Int32Array(64) : Array(64), void 0 === tc && (tc = u.Int32Array ? new Int32Array(dc) : dc), this.reset();
        }

        E(ic, function () {
          this.b = -1;
        });

        for (var oc = 64, ac = oc - 1, sc = [], uc = 0; uc < ac; uc++) {
          sc[uc] = 0;
        }

        var cc = J(128, sc);

        function lc(e) {
          for (var t = e.f, n = e.l, r = 0, i = 0; i < t.length;) {
            n[r++] = t[i] << 24 | t[i + 1] << 16 | t[i + 2] << 8 | t[i + 3], i = 4 * r;
          }

          for (t = 16; 64 > t; t++) {
            i = 0 | n[t - 15], r = 0 | n[t - 2];
            var o = (0 | n[t - 16]) + ((i >>> 7 | i << 25) ^ (i >>> 18 | i << 14) ^ i >>> 3) | 0,
                a = (0 | n[t - 7]) + ((r >>> 17 | r << 15) ^ (r >>> 19 | r << 13) ^ r >>> 10) | 0;
            n[t] = o + a | 0;
          }

          r = 0 | e.a[0], i = 0 | e.a[1];
          var s = 0 | e.a[2],
              u = 0 | e.a[3],
              c = 0 | e.a[4],
              l = 0 | e.a[5],
              h = 0 | e.a[6];

          for (o = 0 | e.a[7], t = 0; 64 > t; t++) {
            var d = ((r >>> 2 | r << 30) ^ (r >>> 13 | r << 19) ^ (r >>> 22 | r << 10)) + (r & i ^ r & s ^ i & s) | 0;
            a = (o = o + ((c >>> 6 | c << 26) ^ (c >>> 11 | c << 21) ^ (c >>> 25 | c << 7)) | 0) + ((a = (a = c & l ^ ~c & h) + (0 | tc[t]) | 0) + (0 | n[t]) | 0) | 0, o = h, h = l, l = c, c = u + a | 0, u = s, s = i, i = r, r = a + d | 0;
          }

          e.a[0] = e.a[0] + r | 0, e.a[1] = e.a[1] + i | 0, e.a[2] = e.a[2] + s | 0, e.a[3] = e.a[3] + u | 0, e.a[4] = e.a[4] + c | 0, e.a[5] = e.a[5] + l | 0, e.a[6] = e.a[6] + h | 0, e.a[7] = e.a[7] + o | 0;
        }

        function hc(e, t, n) {
          void 0 === n && (n = t.length);
          var r = 0,
              i = e.c;
          if ("string" == typeof t) for (; r < n;) {
            e.f[i++] = t.charCodeAt(r++), i == e.b && (lc(e), i = 0);
          } else {
            if (!f(t)) throw Error("message must be string or array");

            for (; r < n;) {
              var o = t[r++];
              if (!("number" == typeof o && 0 <= o && 255 >= o && o == (0 | o))) throw Error("message must be a byte array");
              e.f[i++] = o, i == e.b && (lc(e), i = 0);
            }
          }
          e.c = i, e.g += n;
        }

        ic.prototype.reset = function () {
          this.g = this.c = 0, this.a = u.Int32Array ? new Int32Array(this.h) : X(this.h);
        };

        var dc = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

        function fc() {
          ic.call(this, 8, pc);
        }

        E(fc, ic);
        var pc = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225];

        function mc(e, t, n, r, i) {
          this.u = e, this.i = t, this.l = n, this.m = r || null, this.s = i || null, this.h = t + ":" + n, this.w = new rc(), this.g = new ec(this.h), this.f = null, this.b = [], this.a = this.c = null;
        }

        function _c(e) {
          return new k("invalid-cordova-configuration", e);
        }

        function yc(e) {
          var t = new fc();
          hc(t, e), e = [];
          var n = 8 * t.g;
          56 > t.c ? hc(t, cc, 56 - t.c) : hc(t, cc, t.b - (t.c - 56));

          for (var r = 63; 56 <= r; r--) {
            t.f[r] = 255 & n, n /= 256;
          }

          for (lc(t), r = n = 0; r < t.i; r++) {
            for (var i = 24; 0 <= i; i -= 8) {
              e[n++] = t.a[r] >> i & 255;
            }
          }

          return function (e) {
            return z(e, function (e) {
              return 1 < (e = e.toString(16)).length ? e : "0" + e;
            }).join("");
          }(e);
        }

        function vc(e, t) {
          for (var n = 0; n < e.b.length; n++) {
            try {
              e.b[n](t);
            } catch (e) {}
          }
        }

        function gc(e) {
          return e.f || (e.f = e.ka().then(function () {
            return new bt(function (t) {
              e.Ca(function n(r) {
                return t(r), e.Qa(n), !1;
              }), function (e) {
                function t(t) {
                  r = !0, i && i.cancel(), bc(e).then(function (r) {
                    var i = n;

                    if (r && t && t.url) {
                      var o = null;
                      -1 != (i = no(t.url)).indexOf("/__/auth/callback") && (o = (o = "object" == typeof (o = Or(An(o = jn(i), "firebaseError") || null)) ? L(o) : null) ? new jo(r.c, r.b, null, null, o, null, r.S()) : new jo(r.c, r.b, i, r.f, null, null, r.S())), i = o || n;
                    }

                    vc(e, i);
                  });
                }

                var n = new jo("unknown", null, null, null, new k("no-auth-event")),
                    r = !1,
                    i = kn(500).then(function () {
                  return bc(e).then(function () {
                    r || vc(e, n);
                  });
                }),
                    o = u.handleOpenURL;
                u.handleOpenURL = function (e) {
                  if (0 == e.toLowerCase().indexOf(Sr("BuildInfo.packageName", u).toLowerCase() + "://") && t({
                    url: e
                  }), "function" == typeof o) try {
                    o(e);
                  } catch (e) {
                    console.error(e);
                  }
                }, Wo || (Wo = new Po()), function (e) {
                  var t = Wo;
                  t.a.push(e), t.b || (t.b = function (e) {
                    for (var n = 0; n < t.a.length; n++) {
                      t.a[n](e);
                    }
                  }, "function" == typeof (e = Sr("universalLinks.subscribe", u)) && e(null, t.b));
                }(t);
              }(e);
            });
          })), e.f;
        }

        function bc(e) {
          var t = null;
          return function (e) {
            return e.b.get(nc, e.a).then(function (e) {
              return Uo(e);
            });
          }(e.g).then(function (n) {
            return t = n, Ku((n = e.g).b, nc, n.a);
          }).then(function () {
            return t;
          });
        }

        function wc(e) {
          this.a = e, this.b = qu();
        }

        (t = mc.prototype).ka = function () {
          return this.Ga ? this.Ga : this.Ga = (_r(void 0) ? mr().then(function () {
            return new bt(function (e, t) {
              var n = u.document,
                  r = setTimeout(function () {
                t(Error("Cordova framework is not ready."));
              }, 1e3);
              n.addEventListener("deviceready", function () {
                clearTimeout(r), e();
              }, !1);
            });
          }) : Nt(Error("Cordova must run in an Android or iOS file scheme."))).then(function () {
            if ("function" != typeof Sr("universalLinks.subscribe", u)) throw _c("cordova-universal-links-plugin-fix is not installed");
            if (void 0 === Sr("BuildInfo.packageName", u)) throw _c("cordova-plugin-buildinfo is not installed");
            if ("function" != typeof Sr("cordova.plugins.browsertab.openUrl", u)) throw _c("cordova-plugin-browsertab is not installed");
            if ("function" != typeof Sr("cordova.InAppBrowser.open", u)) throw _c("cordova-plugin-inappbrowser is not installed");
          }, function () {
            throw new k("cordova-not-ready");
          });
        }, t.Lb = function (e, t) {
          return t(new k("operation-not-supported-in-this-environment")), St();
        }, t.Jb = function () {
          return Nt(new k("operation-not-supported-in-this-environment"));
        }, t.Xb = function () {
          return !1;
        }, t.Ub = function () {
          return !0;
        }, t.Qb = function () {
          return !0;
        }, t.Kb = function (e, t, n, r) {
          if (this.c) return Nt(new k("redirect-operation-pending"));
          var i = this,
              o = u.document,
              a = null,
              s = null,
              c = null,
              l = null;
          return this.c = St().then(function () {
            return Ao(t), gc(i);
          }).then(function () {
            return function (e, t, n, r, i) {
              var o = function () {
                for (var e = 20, t = []; 0 < e;) {
                  t.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), e--;
                }

                return t.join("");
              }(),
                  a = new jo(t, r, null, o, new k("no-auth-event"), null, i),
                  s = Sr("BuildInfo.packageName", u);

              if ("string" != typeof s) throw new k("invalid-cordova-configuration");
              var c = Sr("BuildInfo.displayName", u),
                  l = {};
              if (Lr().toLowerCase().match(/iphone|ipad|ipod/)) l.ibi = s;else {
                if (!Lr().toLowerCase().match(/android/)) return Nt(new k("operation-not-supported-in-this-environment"));
                l.apn = s;
              }
              c && (l.appDisplayName = c), o = yc(o), l.sessionId = o;
              var h = fu(e.u, e.i, e.l, t, n, null, r, e.m, l, e.s, i);
              return e.ka().then(function () {
                var t = e.h;
                return e.w.a.set(nc, a.v(), t);
              }).then(function () {
                var t = Sr("cordova.plugins.browsertab.isAvailable", u);
                if ("function" != typeof t) throw new k("invalid-cordova-configuration");
                var n = null;
                t(function (t) {
                  if (t) {
                    if ("function" != typeof (n = Sr("cordova.plugins.browsertab.openUrl", u))) throw new k("invalid-cordova-configuration");
                    n(h);
                  } else {
                    if ("function" != typeof (n = Sr("cordova.InAppBrowser.open", u))) throw new k("invalid-cordova-configuration");
                    t = Lr(), e.a = n(h, t.match(/(iPad|iPhone|iPod).*OS 7_\d/i) || t.match(/(iPad|iPhone|iPod).*OS 8_\d/i) ? "_blank" : "_system", "location=yes");
                  }
                });
              });
            }(i, e, t, n, r);
          }).then(function () {
            return new bt(function (e, t) {
              s = function s() {
                var t = Sr("cordova.plugins.browsertab.close", u);
                return e(), "function" == typeof t && t(), i.a && "function" == typeof i.a.close && (i.a.close(), i.a = null), !1;
              }, i.Ca(s), c = function c() {
                a || (a = kn(2e3).then(function () {
                  t(new k("redirect-cancelled-by-user"));
                }));
              }, l = function l() {
                Pr() && c();
              }, o.addEventListener("resume", c, !1), Lr().toLowerCase().match(/android/) || o.addEventListener("visibilitychange", l, !1);
            }).o(function (e) {
              return bc(i).then(function () {
                throw e;
              });
            });
          }).ma(function () {
            c && o.removeEventListener("resume", c, !1), l && o.removeEventListener("visibilitychange", l, !1), a && a.cancel(), s && i.Qa(s), i.c = null;
          });
        }, t.Ca = function (e) {
          this.b.push(e), gc(this).o(function (t) {
            "auth/invalid-cordova-configuration" === t.code && (t = new jo("unknown", null, null, null, new k("no-auth-event")), e(t));
          });
        }, t.Qa = function (e) {
          q(this.b, function (t) {
            return t == e;
          });
        };
        var Tc = {
          name: "pendingRedirect",
          F: "session"
        };

        function Mc(e) {
          return Ku(e.b, Tc, e.a);
        }

        function Ec(e, t, n) {
          this.i = {}, this.w = 0, this.D = e, this.u = t, this.m = n, this.h = [], this.f = !1, this.l = w(this.s, this), this.b = new jc(), this.B = new Hc(), this.g = new wc(this.u + ":" + this.m), this.c = {}, this.c.unknown = this.b, this.c.signInViaRedirect = this.b, this.c.linkViaRedirect = this.b, this.c.reauthViaRedirect = this.b, this.c.signInViaPopup = this.B, this.c.linkViaPopup = this.B, this.c.reauthViaPopup = this.B, this.a = kc(this.D, this.u, this.m, S);
        }

        function kc(e, t, n, i) {
          var o = r.a.SDK_VERSION || null;
          return _r() ? new mc(e, t, n, o, i) : new cu(e, t, n, o, i);
        }

        function Lc(e) {
          e.f || (e.f = !0, e.a.Ca(e.l));
          var t = e.a;
          return e.a.ka().o(function (n) {
            throw e.a == t && e.reset(), n;
          });
        }

        function Sc(e) {
          e.a.Ub() && Lc(e).o(function (t) {
            var n = new jo("unknown", null, null, null, new k("operation-not-supported-in-this-environment"));
            Yc(t) && e.s(n);
          }), e.a.Qb() || Uc(e.b);
        }

        function Nc(e, t) {
          Q(e.h, t) || e.h.push(t), e.f || function (e) {
            return e.b.get(Tc, e.a).then(function (e) {
              return "pending" == e;
            });
          }(e.g).then(function (t) {
            t ? Mc(e.g).then(function () {
              Lc(e).o(function (t) {
                var n = new jo("unknown", null, null, null, new k("operation-not-supported-in-this-environment"));
                Yc(t) && e.s(n);
              });
            }) : Sc(e);
          }).o(function () {
            Sc(e);
          });
        }

        function Dc(e, t) {
          q(e.h, function (e) {
            return e == t;
          });
        }

        Ec.prototype.reset = function () {
          this.f = !1, this.a.Qa(this.l), this.a = kc(this.D, this.u, this.m), this.i = {};
        }, Ec.prototype.s = function (e) {
          if (!e) throw new k("invalid-auth-event");
          if (6e5 <= M() - this.w && (this.i = {}, this.w = 0), e && e.getUid() && this.i.hasOwnProperty(e.getUid())) return !1;

          for (var t = !1, n = 0; n < this.h.length; n++) {
            var r = this.h[n];

            if (r.Cb(e.c, e.b)) {
              (t = this.c[e.c]) && (t.h(e, r), e && (e.f || e.b) && (this.i[e.getUid()] = !0, this.w = M())), t = !0;
              break;
            }
          }

          return Uc(this.b), t;
        };
        var Ic = new Ur(2e3, 1e4),
            Rc = new Ur(3e4, 6e4);

        function xc(e, t, n, r, i, o, a) {
          return e.a.Jb(t, n, r, function () {
            e.f || (e.f = !0, e.a.Ca(e.l));
          }, function () {
            e.reset();
          }, i, o, a);
        }

        function Yc(e) {
          return !(!e || "auth/cordova-not-ready" != e.code);
        }

        function Cc(e, t, n, r, i) {
          var o;
          return function (e) {
            return e.b.set(Tc, "pending", e.a);
          }(e.g).then(function () {
            return e.a.Kb(t, n, r, i).o(function (t) {
              if (Yc(t)) throw new k("operation-not-supported-in-this-environment");
              return o = t, Mc(e.g).then(function () {
                throw o;
              });
            }).then(function () {
              return e.a.Xb() ? new bt(function () {}) : Mc(e.g).then(function () {
                return e.pa();
              }).then(function () {}).o(function () {});
            });
          });
        }

        function Oc(e, t, n, r, i) {
          return e.a.Lb(r, function (e) {
            t.la(n, null, e, i);
          }, Ic.get());
        }

        Ec.prototype.pa = function () {
          return this.b.pa();
        };

        var Fc = {};

        function Ac(e, t, n) {
          var r = t + ":" + n;
          return Fc[r] || (Fc[r] = new Ec(e, t, n)), Fc[r];
        }

        function jc() {
          this.b = null, this.f = [], this.c = [], this.a = null, this.i = this.g = !1;
        }

        function Uc(e) {
          e.g || (e.g = !0, Wc(e, !1, null, null));
        }

        function Pc(e) {
          e.g && !e.i && Wc(e, !1, null, null);
        }

        function Vc(e, t) {
          if (e.b = function () {
            return St(t);
          }, e.f.length) for (var n = 0; n < e.f.length; n++) {
            e.f[n](t);
          }
        }

        function Wc(e, t, n, r) {
          t ? r ? function (e, t) {
            if (e.b = function () {
              return Nt(t);
            }, e.c.length) for (var n = 0; n < e.c.length; n++) {
              e.c[n](t);
            }
          }(e, r) : Vc(e, n) : Vc(e, {
            user: null
          }), e.f = [], e.c = [];
        }

        function Hc() {}

        function Bc() {
          this.Bb = !1, Object.defineProperty(this, "appVerificationDisabled", {
            get: function get() {
              return this.Bb;
            },
            set: function set(e) {
              this.Bb = e;
            },
            enumerable: !1
          });
        }

        function zc(e, t) {
          this.a = t, Qr(this, "verificationId", e);
        }

        function Zc(e, t, n, r) {
          return new Co(e).cb(t, n).then(function (e) {
            return new zc(e, r);
          });
        }

        function Qc(e) {
          var t = Wi(e);
          if (!(t && t.exp && t.auth_time && t.iat)) throw new k("internal-error", "An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");
          Gr(this, {
            token: e,
            expirationTime: Vr(1e3 * t.exp),
            authTime: Vr(1e3 * t.auth_time),
            issuedAtTime: Vr(1e3 * t.iat),
            signInProvider: t.firebase && t.firebase.sign_in_provider ? t.firebase.sign_in_provider : null,
            signInSecondFactor: t.firebase && t.firebase.sign_in_second_factor ? t.firebase.sign_in_second_factor : null,
            claims: t
          });
        }

        function Gc(e, t, n) {
          var r = t && t[Jc];
          if (!r) throw new k("argument-error", "Internal assert: Invalid MultiFactorResolver");
          this.a = e, this.f = pe(t), this.g = n, this.c = new ro(null, r), this.b = [];
          var i = this;
          H(t[qc] || [], function (e) {
            (e = Kr(e)) && i.b.push(e);
          }), Qr(this, "auth", this.a), Qr(this, "session", this.c), Qr(this, "hints", this.b);
        }

        jc.prototype.reset = function () {
          this.b = null, this.a && (this.a.cancel(), this.a = null);
        }, jc.prototype.h = function (e, t) {
          if (e) {
            this.reset(), this.g = !0;
            var n = e.c,
                r = e.b,
                i = e.a && "auth/web-storage-unsupported" == e.a.code,
                o = e.a && "auth/operation-not-supported-in-this-environment" == e.a.code;
            this.i = !(!i && !o), "unknown" != n || i || o ? e.a ? (Wc(this, !0, null, e.a), St()) : t.Da(n, r) ? function (e, t, n) {
              n = n.Da(t.c, t.b);
              var r = t.g,
                  i = t.f,
                  o = t.i,
                  a = t.S(),
                  s = !!t.c.match(/Redirect$/);
              n(r, i, a, o).then(function (t) {
                Wc(e, s, t, null);
              }).o(function (t) {
                Wc(e, s, null, t);
              });
            }(this, e, t) : Nt(new k("invalid-auth-event")) : (Wc(this, !1, null, null), St());
          } else Nt(new k("invalid-auth-event"));
        }, jc.prototype.pa = function () {
          var e = this;
          return new bt(function (t, n) {
            e.b ? e.b().then(t, n) : (e.f.push(t), e.c.push(n), function (e) {
              var t = new k("timeout");
              e.a && e.a.cancel(), e.a = kn(Rc.get()).then(function () {
                e.b || (e.g = !0, Wc(e, !0, null, t));
              });
            }(e));
          });
        }, Hc.prototype.h = function (e, t) {
          if (e) {
            var n = e.c,
                r = e.b;
            e.a ? (t.la(e.c, null, e.a, e.b), St()) : t.Da(n, r) ? function (e, t) {
              var n = e.b,
                  r = e.c;
              t.Da(r, n)(e.g, e.f, e.S(), e.i).then(function (e) {
                t.la(r, e, null, n);
              }).o(function (e) {
                t.la(r, null, e, n);
              });
            }(e, t) : Nt(new k("invalid-auth-event"));
          } else Nt(new k("invalid-auth-event"));
        }, zc.prototype.confirm = function (e) {
          return e = Oo(this.verificationId, e), this.a(e);
        };
        var qc = "mfaInfo",
            Jc = "mfaPendingCredential";

        function Xc(e, t, n, r) {
          k.call(this, "multi-factor-auth-required", r, t), this.b = new Gc(e, t, n), Qr(this, "resolver", this.b);
        }

        function Kc(e, t, n) {
          if (e && m(e.serverResponse) && "auth/multi-factor-auth-required" === e.code) try {
            return new Xc(t, e.serverResponse, n, e.message);
          } catch (e) {}
          return null;
        }

        function $c() {}

        function el(e) {
          Qr(this, "factorId", e.ea), this.a = e;
        }

        function tl(e) {
          if (el.call(this, e), this.a.ea != Co.PROVIDER_ID) throw new k("argument-error", "firebase.auth.PhoneMultiFactorAssertion requires a valid firebase.auth.PhoneAuthCredential");
        }

        function nl(e, t) {
          for (var n in qt.call(this, e), t) {
            this[n] = t[n];
          }
        }

        function rl(e, t) {
          this.a = e, this.b = [], this.c = w(this.wc, this), un(this.a, "userReloaded", this.c);
          var n = [];
          t && t.multiFactor && t.multiFactor.enrolledFactors && H(t.multiFactor.enrolledFactors, function (e) {
            var t = null,
                r = {};

            if (e) {
              e.uid && (r[ti] = e.uid), e.displayName && (r[$r] = e.displayName), e.enrollmentTime && (r[ei] = new Date(e.enrollmentTime).toISOString()), e.phoneNumber && (r[ni] = e.phoneNumber);

              try {
                t = new ri(r);
              } catch (e) {}

              e = t;
            } else e = null;

            e && n.push(e);
          }), il(this, n);
        }

        function il(e, t) {
          e.b = t, Qr(e, "enrolledFactors", t);
        }

        function ol(e, t, n) {
          if (this.h = e, this.i = t, this.g = n, this.c = 3e4, this.f = 96e4, this.b = null, this.a = this.c, this.f < this.c) throw Error("Proactive refresh lower bound greater than upper bound!");
        }

        function al(e) {
          this.c = e, this.b = this.a = null;
        }

        function sl(e) {
          return e.b && 1e3 * e.b.c || 0;
        }

        function ul(e, t) {
          var n = t.refreshToken;
          e.b = Vi(t[qa] || ""), e.a = n;
        }

        function cl(e, t) {
          return function (e, t) {
            return new bt(function (n, r) {
              "refresh_token" == t.grant_type && t.refresh_token || "authorization_code" == t.grant_type && t.code ? ns(e, e.u + "?key=" + encodeURIComponent(e.c), function (e) {
                e ? e.error ? r(eu(e)) : e.access_token && e.refresh_token ? n(e) : r(new k("internal-error")) : r(new k("network-request-failed"));
              }, "POST", Jn(t).toString(), e.g, e.m.get()) : r(new k("internal-error"));
            });
          }(e.c, t).then(function (t) {
            return e.b = Vi(t.access_token), e.a = t.refresh_token, {
              accessToken: e.b.toString(),
              refreshToken: e.a
            };
          }).o(function (t) {
            throw "auth/user-token-expired" == t.code && (e.a = null), t;
          });
        }

        function ll(e, t) {
          this.a = e || null, this.b = t || null, Gr(this, {
            lastSignInTime: Vr(t || null),
            creationTime: Vr(e || null)
          });
        }

        function hl(e, t, n, r, i, o) {
          Gr(this, {
            uid: e,
            displayName: r || null,
            photoURL: i || null,
            email: n || null,
            phoneNumber: o || null,
            providerId: t
          });
        }

        function dl(e, t, n) {
          this.N = [], this.l = e.apiKey, this.m = e.appName, this.s = e.authDomain || null, e = r.a.SDK_VERSION ? kr(r.a.SDK_VERSION) : null, this.a = new Qa(this.l, R(S), e), this.b = new al(this.a), gl(this, t[qa]), ul(this.b, t), Qr(this, "refreshToken", this.b.a), Tl(this, n || {}), bn.call(this), this.P = !1, this.s && Dr() && (this.i = Ac(this.s, this.l, this.m)), this.R = [], this.h = null, this.B = function (e) {
            return new ol(function () {
              return e.I(!0);
            }, function (e) {
              return !(!e || "auth/network-request-failed" != e.code);
            }, function () {
              var t = sl(e.b) - M() - 3e5;
              return 0 < t ? t : 0;
            });
          }(this), this.Z = w(this.Ma, this);
          var i = this;
          this.oa = null, this.za = function (e) {
            i.va(e.g);
          }, this.aa = null, this.W = [], this.ya = function (e) {
            pl(i, e.c);
          }, this.$ = null, this.O = new rl(this, n), Qr(this, "multiFactor", this.O);
        }

        function fl(e, t) {
          e.aa && hn(e.aa, "languageCodeChanged", e.za), (e.aa = t) && un(t, "languageCodeChanged", e.za);
        }

        function pl(e, t) {
          e.W = t, ts(e.a, r.a.SDK_VERSION ? kr(r.a.SDK_VERSION, e.W) : null);
        }

        function ml(e, t) {
          e.$ && hn(e.$, "frameworkChanged", e.ya), (e.$ = t) && un(t, "frameworkChanged", e.ya);
        }

        function _l(e) {
          try {
            return r.a.app(e.m).auth();
          } catch (t) {
            throw new k("internal-error", "No firebase.auth.Auth instance is available for the Firebase App '" + e.m + "'!");
          }
        }

        function yl(e) {
          e.D || e.B.b || (e.B.start(), hn(e, "tokenChanged", e.Z), un(e, "tokenChanged", e.Z));
        }

        function vl(e) {
          hn(e, "tokenChanged", e.Z), e.B.stop();
        }

        function gl(e, t) {
          e.xa = t, Qr(e, "_lat", t);
        }

        function bl(e) {
          for (var t = [], n = 0; n < e.R.length; n++) {
            t.push(e.R[n](e));
          }

          return It(t).then(function () {
            return e;
          });
        }

        function wl(e) {
          e.i && !e.P && (e.P = !0, Nc(e.i, e));
        }

        function Tl(e, t) {
          Gr(e, {
            uid: t.uid,
            displayName: t.displayName || null,
            photoURL: t.photoURL || null,
            email: t.email || null,
            emailVerified: t.emailVerified || !1,
            phoneNumber: t.phoneNumber || null,
            isAnonymous: t.isAnonymous || !1,
            tenantId: t.tenantId || null,
            metadata: new ll(t.createdAt, t.lastLoginAt),
            providerData: []
          }), e.a.b = e.tenantId;
        }

        function Ml() {}

        function El(e) {
          return St().then(function () {
            if (e.D) throw new k("app-deleted");
          });
        }

        function kl(e) {
          return z(e.providerData, function (e) {
            return e.providerId;
          });
        }

        function Ll(e, t) {
          t && (Sl(e, t.providerId), e.providerData.push(t));
        }

        function Sl(e, t) {
          q(e.providerData, function (e) {
            return e.providerId == t;
          });
        }

        function Nl(e, t, n) {
          ("uid" != t || n) && e.hasOwnProperty(t) && Qr(e, t, n);
        }

        function Dl(e, t) {
          e != t && (Gr(e, {
            uid: t.uid,
            displayName: t.displayName,
            photoURL: t.photoURL,
            email: t.email,
            emailVerified: t.emailVerified,
            phoneNumber: t.phoneNumber,
            isAnonymous: t.isAnonymous,
            tenantId: t.tenantId,
            providerData: []
          }), t.metadata ? Qr(e, "metadata", function (e) {
            return new ll(e.a, e.b);
          }(t.metadata)) : Qr(e, "metadata", new ll()), H(t.providerData, function (t) {
            Ll(e, t);
          }), function (e, t) {
            e.b = t.b, e.a = t.a;
          }(e.b, t.b), Qr(e, "refreshToken", e.b.a), il(e.O, t.O.b));
        }

        function Il(e) {
          return e.I().then(function (t) {
            var n = e.isAnonymous;
            return function (e, t) {
              return Ks(e.a, Ds, {
                idToken: t
              }).then(w(e.Ic, e));
            }(e, t).then(function () {
              return n || Nl(e, "isAnonymous", !1), t;
            });
          });
        }

        function Rl(e, t) {
          t[qa] && e.xa != t[qa] && (ul(e.b, t), e.dispatchEvent(new nl("tokenChanged")), gl(e, t[qa]), Nl(e, "refreshToken", e.b.a));
        }

        function xl(e, t) {
          return Il(e).then(function () {
            if (Q(kl(e), t)) return bl(e).then(function () {
              throw new k("provider-already-linked");
            });
          });
        }

        function Yl(e, t, n) {
          return qr({
            user: e,
            credential: Fo(t),
            additionalUserInfo: t = Qi(t),
            operationType: n
          });
        }

        function Cl(e, t) {
          return Rl(e, t), e.reload().then(function () {
            return e;
          });
        }

        function Ol(e, t, n, i, o) {
          if (!Dr()) return Nt(new k("operation-not-supported-in-this-environment"));
          if (e.h && !o) return Nt(e.h);
          var a = Zi(n.providerId),
              s = Fr(e.uid + ":::"),
              u = null;
          (!xr() || yr()) && e.s && n.isOAuthProvider && (u = fu(e.s, e.l, e.m, t, n, null, s, r.a.SDK_VERSION || null, null, null, e.tenantId));
          var c = dr(u, a && a.ta, a && a.sa);
          return i = i().then(function () {
            if (Al(e), !o) return e.I().then(function () {});
          }).then(function () {
            return xc(e.i, c, t, n, s, !!u, e.tenantId);
          }).then(function () {
            return new bt(function (n, r) {
              e.la(t, null, new k("cancelled-popup-request"), e.g || null), e.f = n, e.w = r, e.g = s, e.c = Oc(e.i, e, t, c, s);
            });
          }).then(function (e) {
            return c && hr(c), e ? qr(e) : null;
          }).o(function (e) {
            throw c && hr(c), e;
          }), jl(e, i, o);
        }

        function Fl(e, t, n, r, i) {
          if (!Dr()) return Nt(new k("operation-not-supported-in-this-environment"));
          if (e.h && !i) return Nt(e.h);
          var o = null,
              a = Fr(e.uid + ":::");
          return r = r().then(function () {
            if (Al(e), !i) return e.I().then(function () {});
          }).then(function () {
            return e.fa = a, bl(e);
          }).then(function (t) {
            return e.ga && (t = (t = e.ga).b.set(Vl, e.v(), t.a)), t;
          }).then(function () {
            return Cc(e.i, t, n, a, e.tenantId);
          }).o(function (t) {
            if (o = t, e.ga) return Wl(e.ga);
            throw o;
          }).then(function () {
            if (o) throw o;
          }), jl(e, r, i);
        }

        function Al(e) {
          if (!e.i || !e.P) {
            if (e.i && !e.P) throw new k("internal-error");
            throw new k("auth-domain-config-required");
          }
        }

        function jl(e, t, n) {
          var r = function (e, t, n) {
            return e.h && !n ? (t.cancel(), Nt(e.h)) : t.o(function (t) {
              throw !t || "auth/user-disabled" != t.code && "auth/user-token-expired" != t.code || (e.h || e.dispatchEvent(new nl("userInvalidated")), e.h = t), t;
            });
          }(e, t, n);

          return e.N.push(r), r.ma(function () {
            G(e.N, r);
          }), r.o(function (t) {
            var n = null;
            throw t && "auth/multi-factor-auth-required" === t.code && (n = Kc(t.v(), _l(e), w(e.hc, e))), n || t;
          });
        }

        function Ul(e) {
          if (!e.apiKey) return null;
          var t = {
            apiKey: e.apiKey,
            authDomain: e.authDomain,
            appName: e.appName
          },
              n = {};
          if (!e.stsTokenManager || !e.stsTokenManager.accessToken) return null;
          n[qa] = e.stsTokenManager.accessToken, n.refreshToken = e.stsTokenManager.refreshToken || null;
          var r = new dl(t, n, e);
          return e.providerData && H(e.providerData, function (e) {
            e && Ll(r, qr(e));
          }), e.redirectEventId && (r.fa = e.redirectEventId), r;
        }

        function Pl(e) {
          this.a = e, this.b = qu();
        }

        Gc.prototype.Pc = function (e) {
          var t = this;
          return e.ob(this.a.b, this.c).then(function (e) {
            var n = pe(t.f);
            return delete n[qc], delete n[Jc], _e(n, e), t.g(n);
          });
        }, E(Xc, k), $c.prototype.ob = function (e, t, n) {
          return t.type == io ? function (e, t, n, r) {
            return n.Fa().then(function (n) {
              return n = {
                idToken: n
              }, void 0 !== r && (n.displayName = r), _e(n, {
                phoneVerificationInfo: Yo(e.a)
              }), Ks(t, Ss, n);
            });
          }(this, e, t, n) : function (e, t, n) {
            return n.Fa().then(function (n) {
              return _e(n = {
                mfaPendingCredential: n
              }, {
                phoneVerificationInfo: Yo(e.a)
              }), Ks(t, Ns, n);
            });
          }(this, e, t);
        }, E(el, $c), E(tl, el), E(nl, qt), (t = rl.prototype).wc = function (e) {
          il(this, function (e) {
            var t = [];
            return H(e.mfaInfo || [], function (e) {
              (e = Kr(e)) && t.push(e);
            }), t;
          }(e.ed));
        }, t.Ob = function () {
          return this.a.I().then(function (e) {
            return new ro(e, null);
          });
        }, t.dc = function (e, t) {
          var n = this,
              r = this.a.a;
          return this.Ob().then(function (n) {
            return e.ob(r, n, t);
          }).then(function (e) {
            return Rl(n.a, e), n.a.reload();
          });
        }, t.$c = function (e) {
          var t = this,
              n = "string" == typeof e ? e : e.uid,
              r = this.a.a;
          return this.a.I().then(function (e) {
            return Ks(r, Xs, {
              idToken: e,
              mfaEnrollmentId: n
            });
          }).then(function (e) {
            var r = B(t.b, function (e) {
              return e.uid != n;
            });
            return il(t, r), Rl(t.a, e), t.a.reload().o(function (e) {
              if ("auth/user-token-expired" != e.code) throw e;
            });
          });
        }, t.v = function () {
          return {
            multiFactor: {
              enrolledFactors: z(this.b, function (e) {
                return e.v();
              })
            }
          };
        }, ol.prototype.start = function () {
          this.a = this.c, function e(t, n) {
            t.stop();
            t.b = kn(function (e, t) {
              return t ? (e.a = e.c, e.g()) : (t = e.a, e.a *= 2, e.a > e.f && (e.a = e.f), t);
            }(t, n)).then(function () {
              return e = u.document, _t13 = null, Pr() || !e ? St() : new bt(function (n) {
                _t13 = function t() {
                  Pr() && (e.removeEventListener("visibilitychange", _t13, !1), n());
                }, e.addEventListener("visibilitychange", _t13, !1);
              }).o(function (n) {
                throw e.removeEventListener("visibilitychange", _t13, !1), n;
              });

              var e, _t13;
            }).then(function () {
              return t.h();
            }).then(function () {
              e(t, !0);
            }).o(function (n) {
              t.i(n) && e(t, !1);
            });
          }(this, !0);
        }, ol.prototype.stop = function () {
          this.b && (this.b.cancel(), this.b = null);
        }, al.prototype.v = function () {
          return {
            apiKey: this.c.c,
            refreshToken: this.a,
            accessToken: this.b && this.b.toString(),
            expirationTime: sl(this)
          };
        }, al.prototype.getToken = function (e) {
          return e = !!e, this.b && !this.a ? Nt(new k("user-token-expired")) : e || !this.b || M() > sl(this) - 3e4 ? this.a ? cl(this, {
            grant_type: "refresh_token",
            refresh_token: this.a
          }) : St(null) : St({
            accessToken: this.b.toString(),
            refreshToken: this.a
          });
        }, ll.prototype.v = function () {
          return {
            lastLoginAt: this.b,
            createdAt: this.a
          };
        }, E(dl, bn), dl.prototype.va = function (e) {
          this.oa = e, es(this.a, e);
        }, dl.prototype.ja = function () {
          return this.oa;
        }, dl.prototype.Ea = function () {
          return X(this.W);
        }, dl.prototype.Ma = function () {
          this.B.b && (this.B.stop(), this.B.start());
        }, Qr(dl.prototype, "providerId", "firebase"), (t = dl.prototype).reload = function () {
          var e = this;
          return jl(this, El(this).then(function () {
            return Il(e).then(function () {
              return bl(e);
            }).then(Ml);
          }));
        }, t.mc = function (e) {
          return this.I(e).then(function (e) {
            return new Qc(e);
          });
        }, t.I = function (e) {
          var t = this;
          return jl(this, El(this).then(function () {
            return t.b.getToken(e);
          }).then(function (e) {
            if (!e) throw new k("internal-error");
            return e.accessToken != t.xa && (gl(t, e.accessToken), t.dispatchEvent(new nl("tokenChanged"))), Nl(t, "refreshToken", e.refreshToken), e.accessToken;
          }));
        }, t.Ic = function (e) {
          if (!(e = e.users) || !e.length) throw new k("internal-error");
          Tl(this, {
            uid: (e = e[0]).localId,
            displayName: e.displayName,
            photoURL: e.photoUrl,
            email: e.email,
            emailVerified: !!e.emailVerified,
            phoneNumber: e.phoneNumber,
            lastLoginAt: e.lastLoginAt,
            createdAt: e.createdAt,
            tenantId: e.tenantId
          });

          for (var t = function (e) {
            return (e = e.providerUserInfo) && e.length ? z(e, function (e) {
              return new hl(e.rawId, e.providerId, e.email, e.displayName, e.photoUrl, e.phoneNumber);
            }) : [];
          }(e), n = 0; n < t.length; n++) {
            Ll(this, t[n]);
          }

          Nl(this, "isAnonymous", !(this.email && e.passwordHash || this.providerData && this.providerData.length)), this.dispatchEvent(new nl("userReloaded", {
            ed: e
          }));
        }, t.Jc = function (e) {
          return zr("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead."), this.pb(e);
        }, t.pb = function (e) {
          var t = this,
              n = null;
          return jl(this, e.c(this.a, this.uid).then(function (e) {
            return Rl(t, e), n = Yl(t, e, "reauthenticate"), t.h = null, t.reload();
          }).then(function () {
            return n;
          }), !0);
        }, t.Ac = function (e) {
          return zr("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead."), this.mb(e);
        }, t.mb = function (e) {
          var t = this,
              n = null;
          return jl(this, xl(this, e.providerId).then(function () {
            return t.I();
          }).then(function (n) {
            return e.b(t.a, n);
          }).then(function (e) {
            return n = Yl(t, e, "link"), Cl(t, e);
          }).then(function () {
            return n;
          }));
        }, t.Bc = function (e, t) {
          var n = this;
          return jl(this, xl(this, "phone").then(function () {
            return Zc(_l(n), e, t, w(n.mb, n));
          }));
        }, t.Kc = function (e, t) {
          var n = this;
          return jl(this, St().then(function () {
            return Zc(_l(n), e, t, w(n.pb, n));
          }), !0);
        }, t.xb = function (e) {
          var t = this;
          return jl(this, this.I().then(function (n) {
            return t.a.xb(n, e);
          }).then(function (e) {
            return Rl(t, e), t.reload();
          }));
        }, t.cd = function (e) {
          var t = this;
          return jl(this, this.I().then(function (n) {
            return e.b(t.a, n);
          }).then(function (e) {
            return Rl(t, e), t.reload();
          }));
        }, t.yb = function (e) {
          var t = this;
          return jl(this, this.I().then(function (n) {
            return t.a.yb(n, e);
          }).then(function (e) {
            return Rl(t, e), t.reload();
          }));
        }, t.zb = function (e) {
          if (void 0 === e.displayName && void 0 === e.photoURL) return El(this);
          var t = this;
          return jl(this, this.I().then(function (n) {
            return t.a.zb(n, {
              displayName: e.displayName,
              photoUrl: e.photoURL
            });
          }).then(function (e) {
            return Rl(t, e), Nl(t, "displayName", e.displayName || null), Nl(t, "photoURL", e.photoUrl || null), H(t.providerData, function (e) {
              "password" === e.providerId && (Qr(e, "displayName", t.displayName), Qr(e, "photoURL", t.photoURL));
            }), bl(t);
          }).then(Ml));
        }, t.ad = function (e) {
          var t = this;
          return jl(this, Il(this).then(function (n) {
            return Q(kl(t), e) ? function (e, t, n) {
              return Ks(e, Es, {
                idToken: t,
                deleteProvider: n
              });
            }(t.a, n, [e]).then(function (e) {
              var n = {};
              return H(e.providerUserInfo || [], function (e) {
                n[e.providerId] = !0;
              }), H(kl(t), function (e) {
                n[e] || Sl(t, e);
              }), n[Co.PROVIDER_ID] || Qr(t, "phoneNumber", null), bl(t);
            }) : bl(t).then(function () {
              throw new k("no-such-provider");
            });
          }));
        }, t.delete = function () {
          var e = this;
          return jl(this, this.I().then(function (t) {
            return Ks(e.a, Ms, {
              idToken: t
            });
          }).then(function () {
            e.dispatchEvent(new nl("userDeleted"));
          })).then(function () {
            for (var t = 0; t < e.N.length; t++) {
              e.N[t].cancel("app-deleted");
            }

            fl(e, null), ml(e, null), e.N = [], e.D = !0, vl(e), Qr(e, "refreshToken", null), e.i && Dc(e.i, e);
          });
        }, t.Cb = function (e, t) {
          return !!("linkViaPopup" == e && (this.g || null) == t && this.f || "reauthViaPopup" == e && (this.g || null) == t && this.f || "linkViaRedirect" == e && (this.fa || null) == t || "reauthViaRedirect" == e && (this.fa || null) == t);
        }, t.la = function (e, t, n, r) {
          "linkViaPopup" != e && "reauthViaPopup" != e || r != (this.g || null) || (n && this.w ? this.w(n) : t && !n && this.f && this.f(t), this.c && (this.c.cancel(), this.c = null), delete this.f, delete this.w);
        }, t.Da = function (e, t) {
          return "linkViaPopup" == e && t == (this.g || null) ? w(this.Hb, this) : "reauthViaPopup" == e && t == (this.g || null) ? w(this.Ib, this) : "linkViaRedirect" == e && (this.fa || null) == t ? w(this.Hb, this) : "reauthViaRedirect" == e && (this.fa || null) == t ? w(this.Ib, this) : null;
        }, t.Cc = function (e) {
          var t = this;
          return Ol(this, "linkViaPopup", e, function () {
            return xl(t, e.providerId).then(function () {
              return bl(t);
            });
          }, !1);
        }, t.Lc = function (e) {
          return Ol(this, "reauthViaPopup", e, function () {
            return St();
          }, !0);
        }, t.Dc = function (e) {
          var t = this;
          return Fl(this, "linkViaRedirect", e, function () {
            return xl(t, e.providerId);
          }, !1);
        }, t.Mc = function (e) {
          return Fl(this, "reauthViaRedirect", e, function () {
            return St();
          }, !0);
        }, t.Hb = function (e, t, n, r) {
          var i = this;
          this.c && (this.c.cancel(), this.c = null);
          var o = null;
          return jl(this, this.I().then(function (n) {
            return _s(i.a, {
              requestUri: e,
              postBody: r,
              sessionId: t,
              idToken: n
            });
          }).then(function (e) {
            return o = Yl(i, e, "link"), Cl(i, e);
          }).then(function () {
            return o;
          }));
        }, t.Ib = function (e, t, n, r) {
          var i = this;
          this.c && (this.c.cancel(), this.c = null);
          var o = null;
          return jl(this, St().then(function () {
            return so(ys(i.a, {
              requestUri: e,
              sessionId: t,
              postBody: r,
              tenantId: n
            }), i.uid);
          }).then(function (e) {
            return o = Yl(i, e, "reauthenticate"), Rl(i, e), i.h = null, i.reload();
          }).then(function () {
            return o;
          }), !0);
        }, t.qb = function (e) {
          var t = this,
              n = null;
          return jl(this, this.I().then(function (t) {
            return n = t, void 0 === e || fe(e) ? {} : Ai(new Si(e));
          }).then(function (e) {
            return t.a.qb(n, e);
          }).then(function (e) {
            if (t.email != e) return t.reload();
          }).then(function () {}));
        }, t.Ab = function (e, t) {
          var n = this,
              r = null;
          return jl(this, this.I().then(function (e) {
            return r = e, void 0 === t || fe(t) ? {} : Ai(new Si(t));
          }).then(function (t) {
            return n.a.Ab(r, e, t);
          }).then(function (e) {
            if (n.email != e) return n.reload();
          }).then(function () {}));
        }, t.hc = function (e) {
          var t = null,
              n = this;
          return jl(this, e = so(St(e), n.uid).then(function (e) {
            return t = Yl(n, e, "reauthenticate"), Rl(n, e), n.h = null, n.reload();
          }).then(function () {
            return t;
          }), !0);
        }, t.toJSON = function () {
          return this.v();
        }, t.v = function () {
          var e = {
            uid: this.uid,
            displayName: this.displayName,
            photoURL: this.photoURL,
            email: this.email,
            emailVerified: this.emailVerified,
            phoneNumber: this.phoneNumber,
            isAnonymous: this.isAnonymous,
            tenantId: this.tenantId,
            providerData: [],
            apiKey: this.l,
            appName: this.m,
            authDomain: this.s,
            stsTokenManager: this.b.v(),
            redirectEventId: this.fa || null
          };
          return this.metadata && _e(e, this.metadata.v()), H(this.providerData, function (t) {
            e.providerData.push(function (e) {
              var t,
                  n = {};

              for (t in e) {
                e.hasOwnProperty(t) && (n[t] = e[t]);
              }

              return n;
            }(t));
          }), _e(e, this.O.v()), e;
        };
        var Vl = {
          name: "redirectUser",
          F: "session"
        };

        function Wl(e) {
          return Ku(e.b, Vl, e.a);
        }

        function Hl(e) {
          this.a = e, this.b = qu(), this.c = null, this.f = function (e) {
            var t = Zl("local"),
                n = Zl("session"),
                r = Zl("none");
            return function (e, t, n) {
              var r = Xu(t, n),
                  i = Ju(e, t.F);
              return e.get(t, n).then(function (o) {
                var a = null;

                try {
                  a = Or(u.localStorage.getItem(r));
                } catch (e) {}

                if (a && !o) return u.localStorage.removeItem(r), e.set(t, a, n);
                a && o && "localStorage" != i.type && u.localStorage.removeItem(r);
              });
            }(e.b, t, e.a).then(function () {
              return e.b.get(n, e.a);
            }).then(function (i) {
              return i ? n : e.b.get(r, e.a).then(function (n) {
                return n ? r : e.b.get(t, e.a).then(function (n) {
                  return n ? t : e.b.get(zl, e.a).then(function (e) {
                    return e ? Zl(e) : t;
                  });
                });
              });
            }).then(function (t) {
              return e.c = t, Bl(e, t.F);
            }).o(function () {
              e.c || (e.c = t);
            });
          }(this), this.b.addListener(Zl("local"), this.a, w(this.g, this));
        }

        function Bl(e, t) {
          var n,
              r = [];

          for (n in Qu) {
            Qu[n] !== t && r.push(Ku(e.b, Zl(Qu[n]), e.a));
          }

          return r.push(Ku(e.b, zl, e.a)), function (e) {
            return new bt(function (t, n) {
              var r = e.length,
                  i = [];
              if (r) for (var o = function o(e, n) {
                r--, i[e] = n, 0 == r && t(i);
              }, a = function a(e) {
                n(e);
              }, s = 0; s < e.length; s++) {
                Dt(e[s], T(o, s), a);
              } else t(i);
            });
          }(r);
        }

        Hl.prototype.g = function () {
          var e = this,
              t = Zl("local");
          Jl(this, function () {
            return St().then(function () {
              return e.c && "local" != e.c.F ? e.b.get(t, e.a) : null;
            }).then(function (n) {
              if (n) return Bl(e, "local").then(function () {
                e.c = t;
              });
            });
          });
        };

        var zl = {
          name: "persistence",
          F: "session"
        };

        function Zl(e) {
          return {
            name: "authUser",
            F: e
          };
        }

        function Ql(e, t) {
          return Jl(e, function () {
            return e.b.set(e.c, t.v(), e.a);
          });
        }

        function Gl(e) {
          return Jl(e, function () {
            return Ku(e.b, e.c, e.a);
          });
        }

        function ql(e, t) {
          return Jl(e, function () {
            return e.b.get(e.c, e.a).then(function (e) {
              return e && t && (e.authDomain = t), Ul(e || {});
            });
          });
        }

        function Jl(e, t) {
          return e.f = e.f.then(t, t), e.f;
        }

        function Xl(e) {
          if (this.l = !1, Qr(this, "settings", new Bc()), Qr(this, "app", e), !oh(this).options || !oh(this).options.apiKey) throw new k("invalid-api-key");
          e = r.a.SDK_VERSION ? kr(r.a.SDK_VERSION) : null, this.b = new Qa(oh(this).options && oh(this).options.apiKey, R(S), e), this.P = [], this.m = [], this.O = [], this.$b = r.a.INTERNAL.createSubscribe(w(this.xc, this)), this.W = void 0, this.ac = r.a.INTERNAL.createSubscribe(w(this.yc, this)), rh(this, null), this.i = new Hl(oh(this).options.apiKey + ":" + oh(this).name), this.B = new Pl(oh(this).options.apiKey + ":" + oh(this).name), this.Z = ch(this, function (e) {
            var t = oh(e).options.authDomain,
                n = function (e) {
              var t = function (e, t) {
                return e.b.get(Vl, e.a).then(function (e) {
                  return e && t && (e.authDomain = t), Ul(e || {});
                });
              }(e.B, oh(e).options.authDomain).then(function (t) {
                return (e.D = t) && (t.ga = e.B), Wl(e.B);
              });

              return ch(e, t);
            }(e).then(function () {
              return ql(e.i, t);
            }).then(function (t) {
              return t ? (t.ga = e.B, e.D && (e.D.fa || null) == (t.fa || null) ? t : t.reload().then(function () {
                return Ql(e.i, t).then(function () {
                  return t;
                });
              }).o(function (n) {
                return "auth/network-request-failed" == n.code ? t : Gl(e.i);
              })) : null;
            }).then(function (t) {
              rh(e, t || null);
            });

            return ch(e, n);
          }(this)), this.h = ch(this, function (e) {
            return e.Z.then(function () {
              return th(e);
            }).o(function () {}).then(function () {
              if (!e.l) return e.oa();
            }).o(function () {}).then(function () {
              if (!e.l) {
                e.aa = !0;
                var t = e.i;
                t.b.addListener(Zl("local"), t.a, e.oa);
              }
            });
          }(this)), this.aa = !1, this.oa = w(this.Xc, this), this.Ma = w(this.ca, this), this.xa = w(this.jc, this), this.ya = w(this.uc, this), this.za = w(this.vc, this), this.a = null, function (e) {
            var t = oh(e).options.authDomain,
                n = oh(e).options.apiKey;
            t && Dr() && (e.Zb = e.Z.then(function () {
              if (!e.l) {
                if (e.a = Ac(t, n, oh(e).name), Nc(e.a, e), ah(e) && wl(ah(e)), e.D) {
                  wl(e.D);
                  var r = e.D;
                  r.va(e.ja()), fl(r, e), pl(r = e.D, e.N), ml(r, e), e.D = null;
                }

                return e.a;
              }
            }));
          }(this), this.INTERNAL = {}, this.INTERNAL.delete = w(this.delete, this), this.INTERNAL.logFramework = w(this.Ec, this), this.s = 0, bn.call(this), function (e) {
            Object.defineProperty(e, "lc", {
              get: function get() {
                return this.ja();
              },
              set: function set(e) {
                this.va(e);
              },
              enumerable: !1
            }), e.$ = null, Object.defineProperty(e, "ti", {
              get: function get() {
                return this.S();
              },
              set: function set(e) {
                this.ub(e);
              },
              enumerable: !1
            }), e.R = null;
          }(this), this.N = [];
        }

        function Kl(e) {
          qt.call(this, "languageCodeChanged"), this.g = e;
        }

        function $l(e) {
          qt.call(this, "frameworkChanged"), this.c = e;
        }

        function eh(e) {
          return e.Zb || Nt(new k("auth-domain-config-required"));
        }

        function th(e) {
          if (!Dr()) return Nt(new k("operation-not-supported-in-this-environment"));
          var t = eh(e).then(function () {
            return e.a.pa();
          }).then(function (e) {
            return e ? qr(e) : null;
          });
          return ch(e, t);
        }

        function nh(e, t) {
          var n = {};
          return n.apiKey = oh(e).options.apiKey, n.authDomain = oh(e).options.authDomain, n.appName = oh(e).name, e.Z.then(function () {
            return function (e, t, n, r) {
              var i = new dl(e, t);
              return n && (i.ga = n), r && pl(i, r), i.reload().then(function () {
                return i;
              });
            }(n, t, e.B, e.Ea());
          }).then(function (t) {
            return ah(e) && t.uid == ah(e).uid ? (Dl(ah(e), t), e.ca(t)) : (rh(e, t), wl(t), e.ca(t));
          }).then(function () {
            uh(e);
          });
        }

        function rh(e, t) {
          ah(e) && (function (e, t) {
            q(e.R, function (e) {
              return e == t;
            });
          }(ah(e), e.Ma), hn(ah(e), "tokenChanged", e.xa), hn(ah(e), "userDeleted", e.ya), hn(ah(e), "userInvalidated", e.za), vl(ah(e))), t && (t.R.push(e.Ma), un(t, "tokenChanged", e.xa), un(t, "userDeleted", e.ya), un(t, "userInvalidated", e.za), 0 < e.s && yl(t)), Qr(e, "currentUser", t), t && (t.va(e.ja()), fl(t, e), pl(t, e.N), ml(t, e));
        }

        function ih(e, t) {
          var n = null,
              r = null;
          return ch(e, t.then(function (t) {
            return n = Fo(t), r = Qi(t), nh(e, t);
          }, function (t) {
            var n = null;
            throw t && "auth/multi-factor-auth-required" === t.code && (n = Kc(t.v(), e, w(e.ic, e))), n || t;
          }).then(function () {
            return qr({
              user: ah(e),
              credential: n,
              additionalUserInfo: r,
              operationType: "signIn"
            });
          }));
        }

        function oh(e) {
          return e.app;
        }

        function ah(e) {
          return e.currentUser;
        }

        function sh(e) {
          return ah(e) && ah(e)._lat || null;
        }

        function uh(e) {
          if (e.aa) {
            for (var t = 0; t < e.m.length; t++) {
              e.m[t] && e.m[t](sh(e));
            }

            if (e.W !== e.getUid() && e.O.length) for (e.W = e.getUid(), t = 0; t < e.O.length; t++) {
              e.O[t] && e.O[t](sh(e));
            }
          }
        }

        function ch(e, t) {
          return e.P.push(t), t.ma(function () {
            G(e.P, t);
          }), t;
        }

        function lh() {}

        function hh() {
          this.a = {}, this.b = 1e12;
        }

        Hl.prototype.tb = function (e) {
          var t = null,
              n = this;
          return function (e) {
            var t = new k("invalid-persistence-type"),
                n = new k("unsupported-persistence-type");

            e: {
              for (r in Qu) {
                if (Qu[r] == e) {
                  var r = !0;
                  break e;
                }
              }

              r = !1;
            }

            if (!r || "string" != typeof e) throw t;

            switch (gr()) {
              case "ReactNative":
                if ("session" === e) throw n;
                break;

              case "Node":
                if ("none" !== e) throw n;
                break;

              case "Worker":
                if ("session" === e || !Lu() && "none" !== e) throw n;
                break;

              default:
                if (!Nr() && "none" !== e) throw n;
            }
          }(e), Jl(this, function () {
            return e != n.c.F ? n.b.get(n.c, n.a).then(function (r) {
              return t = r, Bl(n, e);
            }).then(function () {
              if (n.c = Zl(e), t) return n.b.set(n.c, t, n.a);
            }) : St();
          });
        }, E(Xl, bn), E(Kl, qt), E($l, qt), (t = Xl.prototype).tb = function (e) {
          return ch(this, e = this.i.tb(e));
        }, t.va = function (e) {
          this.$ === e || this.l || (this.$ = e, es(this.b, this.$), this.dispatchEvent(new Kl(this.ja())));
        }, t.ja = function () {
          return this.$;
        }, t.dd = function () {
          var e = u.navigator;
          this.va(e && (e.languages && e.languages[0] || e.language || e.userLanguage) || null);
        }, t.Ec = function (e) {
          this.N.push(e), ts(this.b, r.a.SDK_VERSION ? kr(r.a.SDK_VERSION, this.N) : null), this.dispatchEvent(new $l(this.N));
        }, t.Ea = function () {
          return X(this.N);
        }, t.ub = function (e) {
          this.R === e || this.l || (this.R = e, this.b.b = this.R);
        }, t.S = function () {
          return this.R;
        }, t.toJSON = function () {
          return {
            apiKey: oh(this).options.apiKey,
            authDomain: oh(this).options.authDomain,
            appName: oh(this).name,
            currentUser: ah(this) && ah(this).v()
          };
        }, t.Cb = function (e, t) {
          switch (e) {
            case "unknown":
            case "signInViaRedirect":
              return !0;

            case "signInViaPopup":
              return this.g == t && !!this.f;

            default:
              return !1;
          }
        }, t.la = function (e, t, n, r) {
          "signInViaPopup" == e && this.g == r && (n && this.w ? this.w(n) : t && !n && this.f && this.f(t), this.c && (this.c.cancel(), this.c = null), delete this.f, delete this.w);
        }, t.Da = function (e, t) {
          return "signInViaRedirect" == e || "signInViaPopup" == e && this.g == t && this.f ? w(this.gc, this) : null;
        }, t.gc = function (e, t, n, r) {
          var i = this,
              o = {
            requestUri: e,
            postBody: r,
            sessionId: t,
            tenantId: n
          };
          return this.c && (this.c.cancel(), this.c = null), i.Z.then(function () {
            return ih(i, ms(i.b, o));
          });
        }, t.Vc = function (e) {
          if (!Dr()) return Nt(new k("operation-not-supported-in-this-environment"));
          var t = this,
              n = Zi(e.providerId),
              i = Fr(),
              o = null;
          (!xr() || yr()) && oh(this).options.authDomain && e.isOAuthProvider && (o = fu(oh(this).options.authDomain, oh(this).options.apiKey, oh(this).name, "signInViaPopup", e, null, i, r.a.SDK_VERSION || null, null, null, this.S()));
          var a = dr(o, n && n.ta, n && n.sa);
          return ch(this, n = eh(this).then(function (n) {
            return xc(n, a, "signInViaPopup", e, i, !!o, t.S());
          }).then(function () {
            return new bt(function (e, n) {
              t.la("signInViaPopup", null, new k("cancelled-popup-request"), t.g), t.f = e, t.w = n, t.g = i, t.c = Oc(t.a, t, "signInViaPopup", a, i);
            });
          }).then(function (e) {
            return a && hr(a), e ? qr(e) : null;
          }).o(function (e) {
            throw a && hr(a), e;
          }));
        }, t.Wc = function (e) {
          if (!Dr()) return Nt(new k("operation-not-supported-in-this-environment"));
          var t = this;
          return ch(this, eh(this).then(function () {
            return Jl(e = t.i, function () {
              return e.b.set(zl, e.c.F, e.a);
            });
            var e;
          }).then(function () {
            return Cc(t.a, "signInViaRedirect", e, void 0, t.S());
          }));
        }, t.pa = function () {
          var e = this;
          return th(this).then(function (t) {
            return e.a && Pc(e.a.b), t;
          }).o(function (t) {
            throw e.a && Pc(e.a.b), t;
          });
        }, t.bd = function (e) {
          if (!e) return Nt(new k("null-user"));
          if (this.R != e.tenantId) return Nt(new k("tenant-id-mismatch"));
          var t = this,
              n = {};
          n.apiKey = oh(this).options.apiKey, n.authDomain = oh(this).options.authDomain, n.appName = oh(this).name;

          var r = function (e, t, n, r) {
            var i = e.b,
                o = {};
            return o[qa] = i.b && i.b.toString(), o.refreshToken = i.a, t = new dl(t || {
              apiKey: e.l,
              authDomain: e.s,
              appName: e.m
            }, o), n && (t.ga = n), r && pl(t, r), Dl(t, e), t;
          }(e, n, t.B, t.Ea());

          return ch(this, this.h.then(function () {
            if (oh(t).options.apiKey != e.l) return r.reload();
          }).then(function () {
            return ah(t) && e.uid == ah(t).uid ? (Dl(ah(t), e), t.ca(e)) : (rh(t, r), wl(r), t.ca(r));
          }).then(function () {
            uh(t);
          }));
        }, t.wb = function () {
          var e = this;
          return ch(this, this.h.then(function () {
            return e.a && Pc(e.a.b), ah(e) ? (rh(e, null), Gl(e.i).then(function () {
              uh(e);
            })) : St();
          }));
        }, t.Xc = function () {
          var e = this;
          return ql(this.i, oh(this).options.authDomain).then(function (t) {
            if (!e.l) {
              var n;

              if (n = ah(e) && t) {
                n = ah(e).uid;
                var r = t.uid;
                n = null != n && "" !== n && null != r && "" !== r && n == r;
              }

              if (n) return Dl(ah(e), t), ah(e).I();
              (ah(e) || t) && (rh(e, t), t && (wl(t), t.ga = e.B), e.a && Nc(e.a, e), uh(e));
            }
          });
        }, t.ca = function (e) {
          return Ql(this.i, e);
        }, t.jc = function () {
          uh(this), this.ca(ah(this));
        }, t.uc = function () {
          this.wb();
        }, t.vc = function () {
          this.wb();
        }, t.ic = function (e) {
          var t = this;
          return this.h.then(function () {
            return ih(t, St(e));
          });
        }, t.xc = function (e) {
          var t = this;
          this.addAuthTokenListener(function () {
            e.next(ah(t));
          });
        }, t.yc = function (e) {
          var t = this;
          !function (e, t) {
            e.O.push(t), ch(e, e.h.then(function () {
              !e.l && Q(e.O, t) && e.W !== e.getUid() && (e.W = e.getUid(), t(sh(e)));
            }));
          }(this, function () {
            e.next(ah(t));
          });
        }, t.Gc = function (e, t, n) {
          var r = this;
          return this.aa && Promise.resolve().then(function () {
            p(e) ? e(ah(r)) : p(e.next) && e.next(ah(r));
          }), this.$b(e, t, n);
        }, t.Fc = function (e, t, n) {
          var r = this;
          return this.aa && Promise.resolve().then(function () {
            r.W = r.getUid(), p(e) ? e(ah(r)) : p(e.next) && e.next(ah(r));
          }), this.ac(e, t, n);
        }, t.kc = function (e) {
          var t = this;
          return ch(this, this.h.then(function () {
            return ah(t) ? ah(t).I(e).then(function (e) {
              return {
                accessToken: e
              };
            }) : null;
          }));
        }, t.Rc = function (e) {
          var t = this;
          return this.h.then(function () {
            return ih(t, Ks(t.b, Zs, {
              token: e
            }));
          }).then(function (e) {
            var n = e.user;
            return Nl(n, "isAnonymous", !1), t.ca(n), e;
          });
        }, t.Sc = function (e, t) {
          var n = this;
          return this.h.then(function () {
            return ih(n, Ks(n.b, Qs, {
              email: e,
              password: t
            }));
          });
        }, t.cc = function (e, t) {
          var n = this;
          return this.h.then(function () {
            return ih(n, Ks(n.b, ws, {
              email: e,
              password: t
            }));
          });
        }, t.Ya = function (e) {
          var t = this;
          return this.h.then(function () {
            return ih(t, e.ia(t.b));
          });
        }, t.Qc = function (e) {
          return zr("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead."), this.Ya(e);
        }, t.vb = function () {
          var e = this;
          return this.h.then(function () {
            var t = ah(e);

            if (t && t.isAnonymous) {
              var n = qr({
                providerId: null,
                isNewUser: !1
              });
              return qr({
                user: t,
                credential: null,
                additionalUserInfo: n,
                operationType: "signIn"
              });
            }

            return ih(e, e.b.vb()).then(function (t) {
              var n = t.user;
              return Nl(n, "isAnonymous", !0), e.ca(n), t;
            });
          });
        }, t.getUid = function () {
          return ah(this) && ah(this).uid || null;
        }, t.bc = function (e) {
          this.addAuthTokenListener(e), this.s++, 0 < this.s && ah(this) && yl(ah(this));
        }, t.Nc = function (e) {
          var t = this;
          H(this.m, function (n) {
            n == e && t.s--;
          }), 0 > this.s && (this.s = 0), 0 == this.s && ah(this) && vl(ah(this)), this.removeAuthTokenListener(e);
        }, t.addAuthTokenListener = function (e) {
          var t = this;
          this.m.push(e), ch(this, this.h.then(function () {
            t.l || Q(t.m, e) && e(sh(t));
          }));
        }, t.removeAuthTokenListener = function (e) {
          q(this.m, function (t) {
            return t == e;
          });
        }, t.delete = function () {
          this.l = !0;

          for (var e = 0; e < this.P.length; e++) {
            this.P[e].cancel("app-deleted");
          }

          return this.P = [], this.i && (e = this.i).b.removeListener(Zl("local"), e.a, this.oa), this.a && (Dc(this.a, this), Pc(this.a.b)), Promise.resolve();
        }, t.fc = function (e) {
          return ch(this, function (e, t) {
            return Ks(e, Ts, {
              identifier: t,
              continueUri: Ir() ? ur() : "http://localhost"
            }).then(function (e) {
              return e.signinMethods || [];
            });
          }(this.b, e));
        }, t.zc = function (e) {
          return !!Io(e);
        }, t.sb = function (e, t) {
          var n = this;
          return ch(this, St().then(function () {
            var e = new Si(t);
            if (!e.c) throw new k("argument-error", Ii + " must be true when sending sign in link to email");
            return Ai(e);
          }).then(function (t) {
            return n.b.sb(e, t);
          }).then(function () {}));
        }, t.fd = function (e) {
          return this.Pa(e).then(function (e) {
            return e.data.email;
          });
        }, t.jb = function (e, t) {
          return ch(this, this.b.jb(e, t).then(function () {}));
        }, t.Pa = function (e) {
          return ch(this, this.b.Pa(e).then(function (e) {
            return new ii(e);
          }));
        }, t.fb = function (e) {
          return ch(this, this.b.fb(e).then(function () {}));
        }, t.rb = function (e, t) {
          var n = this;
          return ch(this, St().then(function () {
            return void 0 === t || fe(t) ? {} : Ai(new Si(t));
          }).then(function (t) {
            return n.b.rb(e, t);
          }).then(function () {}));
        }, t.Uc = function (e, t) {
          return ch(this, Zc(this, e, t, w(this.Ya, this)));
        }, t.Tc = function (e, t) {
          var n = this;
          return ch(this, St().then(function () {
            var r = t || ur(),
                i = Do(e, r);
            if (!(r = Io(r))) throw new k("argument-error", "Invalid email link!");
            if (r.tenantId !== n.S()) throw new k("tenant-id-mismatch");
            return n.Ya(i);
          }));
        }, lh.prototype.render = function () {}, lh.prototype.reset = function () {}, lh.prototype.getResponse = function () {}, lh.prototype.execute = function () {};
        var dh = null;

        function fh(e, t) {
          return (t = ph(t)) && e.a[t] || null;
        }

        function ph(e) {
          return (e = void 0 === e ? 1e12 : e) ? e.toString() : null;
        }

        function mh(e, t) {
          this.g = !1, this.c = t, this.a = this.b = null, this.h = "invisible" !== this.c.size, this.f = at(e);
          var n = this;
          this.i = function () {
            n.execute();
          }, this.h ? this.execute() : un(this.f, "click", this.i);
        }

        function _h(e) {
          if (e.g) throw Error("reCAPTCHA mock was already deleted!");
        }

        function yh() {}

        function vh() {}

        hh.prototype.render = function (e, t) {
          return this.a[this.b.toString()] = new mh(e, t), this.b++;
        }, hh.prototype.reset = function (e) {
          var t = fh(this, e);
          e = ph(e), t && e && (t.delete(), delete this.a[e]);
        }, hh.prototype.getResponse = function (e) {
          return (e = fh(this, e)) ? e.getResponse() : null;
        }, hh.prototype.execute = function (e) {
          (e = fh(this, e)) && e.execute();
        }, mh.prototype.getResponse = function () {
          return _h(this), this.b;
        }, mh.prototype.execute = function () {
          _h(this);

          var e = this;
          this.a || (this.a = setTimeout(function () {
            e.b = function () {
              for (var e = 50, t = []; 0 < e;) {
                t.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), e--;
              }

              return t.join("");
            }();

            var t = e.c.callback,
                n = e.c["expired-callback"];
            if (t) try {
              t(e.b);
            } catch (e) {}
            e.a = setTimeout(function () {
              if (e.a = null, e.b = null, n) try {
                n();
              } catch (e) {}
              e.h && e.execute();
            }, 6e4);
          }, 500));
        }, mh.prototype.delete = function () {
          _h(this), this.g = !0, clearTimeout(this.a), this.a = null, hn(this.f, "click", this.i);
        }, Qr(yh, "FACTOR_ID", "phone"), vh.prototype.g = function () {
          return dh || (dh = new hh()), St(dh);
        }, vh.prototype.c = function () {};
        var gh = null;

        function bh() {
          this.b = u.grecaptcha ? 1 / 0 : 0, this.f = null, this.a = "__rcb" + Math.floor(1e6 * Math.random()).toString();
        }

        var wh = new ve(we, "https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),
            Th = new Ur(3e4, 6e4);
        bh.prototype.g = function (e) {
          var t = this;
          return new bt(function (n, r) {
            var i = setTimeout(function () {
              r(new k("network-request-failed"));
            }, Th.get());
            !u.grecaptcha || e !== t.f && !t.b ? (u[t.a] = function () {
              if (u.grecaptcha) {
                t.f = e;
                var o = u.grecaptcha.render;
                u.grecaptcha.render = function (e, n) {
                  return e = o(e, n), t.b++, e;
                }, clearTimeout(i), n(u.grecaptcha);
              } else clearTimeout(i), r(new k("internal-error"));

              delete u[t.a];
            }, St(Pa(ke(wh, {
              onload: t.a,
              hl: e || ""
            }))).o(function () {
              clearTimeout(i), r(new k("internal-error", "Unable to load external reCAPTCHA dependencies!"));
            })) : (clearTimeout(i), n(u.grecaptcha));
          });
        }, bh.prototype.c = function () {
          this.b--;
        };
        var Mh = null;

        function Eh(e, t, n, r, i, o, a) {
          if (Qr(this, "type", "recaptcha"), this.c = this.f = null, this.D = !1, this.u = t, this.g = null, a ? (gh || (gh = new vh()), a = gh) : (Mh || (Mh = new bh()), a = Mh), this.m = a, this.a = n || {
            theme: "light",
            type: "image"
          }, this.h = [], this.a[Sh]) throw new k("argument-error", "sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");
          if (this.i = "invisible" === this.a[Nh], !u.document) throw new k("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
          if (!at(t) || !this.i && at(t).hasChildNodes()) throw new k("argument-error", "reCAPTCHA container is either not found or already contains inner elements!");
          this.s = new Qa(e, o || null, i || null), this.w = r || function () {
            return null;
          };
          var s = this;
          this.l = [];
          var c = this.a[kh];

          this.a[kh] = function (e) {
            if (Dh(s, e), "function" == typeof c) c(e);else if ("string" == typeof c) {
              var t = Sr(c, u);
              "function" == typeof t && t(e);
            }
          };

          var l = this.a[Lh];

          this.a[Lh] = function () {
            if (Dh(s, null), "function" == typeof l) l();else if ("string" == typeof l) {
              var e = Sr(l, u);
              "function" == typeof e && e();
            }
          };
        }

        var kh = "callback",
            Lh = "expired-callback",
            Sh = "sitekey",
            Nh = "size";

        function Dh(e, t) {
          for (var n = 0; n < e.l.length; n++) {
            try {
              e.l[n](t);
            } catch (e) {}
          }
        }

        function Ih(e, t) {
          return e.h.push(t), t.ma(function () {
            G(e.h, t);
          }), t;
        }

        function Rh(e) {
          if (e.D) throw new k("internal-error", "RecaptchaVerifier instance has been destroyed.");
        }

        function xh(e, t, n) {
          var i = !1;

          try {
            this.b = n || r.a.app();
          } catch (e) {
            throw new k("argument-error", "No firebase.app.App instance is currently initialized.");
          }

          if (!this.b.options || !this.b.options.apiKey) throw new k("invalid-api-key");
          n = this.b.options.apiKey;
          var o = this,
              a = null;

          try {
            a = this.b.auth().Ea();
          } catch (e) {}

          try {
            i = this.b.auth().settings.appVerificationDisabledForTesting;
          } catch (e) {}

          a = r.a.SDK_VERSION ? kr(r.a.SDK_VERSION, a) : null, Eh.call(this, n, e, t, function () {
            try {
              var e = o.b.auth().ja();
            } catch (t) {
              e = null;
            }

            return e;
          }, a, R(S), i);
        }

        function Yh(e, t, n, r) {
          e: {
            n = Array.prototype.slice.call(n);

            for (var i = 0, o = !1, a = 0; a < t.length; a++) {
              if (t[a].optional) o = !0;else {
                if (o) throw new k("internal-error", "Argument validator encountered a required argument after an optional argument.");
                i++;
              }
            }

            if (o = t.length, n.length < i || o < n.length) r = "Expected " + (i == o ? 1 == i ? "1 argument" : i + " arguments" : i + "-" + o + " arguments") + " but got " + n.length + ".";else {
              for (i = 0; i < n.length; i++) {
                if (o = t[i].optional && void 0 === n[i], !t[i].K(n[i]) && !o) {
                  if (t = t[i], 0 > i || i >= Ch.length) throw new k("internal-error", "Argument validator received an unsupported number of arguments.");
                  n = Ch[i], r = (r ? "" : n + " argument ") + (t.name ? '"' + t.name + '" ' : "") + "must be " + t.J + ".";
                  break e;
                }
              }

              r = null;
            }
          }

          if (r) throw new k("argument-error", e + " failed: " + r);
        }

        (t = Eh.prototype).Ga = function () {
          var e = this;
          return this.f ? this.f : this.f = Ih(this, St().then(function () {
            if (Ir() && !vr()) return mr();
            throw new k("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");
          }).then(function () {
            return e.m.g(e.w());
          }).then(function (t) {
            return e.g = t, Ks(e.s, Os, {});
          }).then(function (t) {
            e.a[Sh] = t.recaptchaSiteKey;
          }).o(function (t) {
            throw e.f = null, t;
          }));
        }, t.render = function () {
          Rh(this);
          var e = this;
          return Ih(this, this.Ga().then(function () {
            if (null === e.c) {
              var t = e.u;

              if (!e.i) {
                var n = at(t);
                t = ht("DIV"), n.appendChild(t);
              }

              e.c = e.g.render(t, e.a);
            }

            return e.c;
          }));
        }, t.verify = function () {
          Rh(this);
          var e = this;
          return Ih(this, this.render().then(function (t) {
            return new bt(function (n) {
              var r = e.g.getResponse(t);
              if (r) n(r);else {
                var i = function i(t) {
                  t && (function (e, t) {
                    q(e.l, function (e) {
                      return e == t;
                    });
                  }(e, i), n(t));
                };

                e.l.push(i), e.i && e.g.execute(e.c);
              }
            });
          }));
        }, t.reset = function () {
          Rh(this), null !== this.c && this.g.reset(this.c);
        }, t.clear = function () {
          Rh(this), this.D = !0, this.m.c();

          for (var e = 0; e < this.h.length; e++) {
            this.h[e].cancel("RecaptchaVerifier instance has been destroyed.");
          }

          if (!this.i) {
            e = at(this.u);

            for (var t; t = e.firstChild;) {
              e.removeChild(t);
            }
          }
        }, E(xh, Eh);
        var Ch = "First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");

        function Oh(e, t) {
          return {
            name: e || "",
            J: "a valid string",
            optional: !!t,
            K: function K(e) {
              return "string" == typeof e;
            }
          };
        }

        function Fh(e, t) {
          return {
            name: e || "",
            J: "a boolean",
            optional: !!t,
            K: function K(e) {
              return "boolean" == typeof e;
            }
          };
        }

        function Ah(e, t) {
          return {
            name: e || "",
            J: "a valid object",
            optional: !!t,
            K: m
          };
        }

        function jh(e, t) {
          return {
            name: e || "",
            J: "a function",
            optional: !!t,
            K: p
          };
        }

        function Uh(e, t) {
          return {
            name: e || "",
            J: "null",
            optional: !!t,
            K: function K(e) {
              return null === e;
            }
          };
        }

        function Ph(e) {
          return {
            name: e ? e + "Credential" : "credential",
            J: e ? "a valid " + e + " credential" : "a valid credential",
            optional: !1,
            K: function K(t) {
              if (!t) return !1;
              var n = !e || t.providerId === e;
              return !(!t.ia || !n);
            }
          };
        }

        function Vh(e, t) {
          return m(e) && "string" == typeof e.type && e.type === t && p(e.Fa);
        }

        function Wh(e) {
          return m(e) && "string" == typeof e.uid;
        }

        function Hh() {
          return {
            name: "applicationVerifier",
            J: "an implementation of firebase.auth.ApplicationVerifier",
            optional: !1,
            K: function K(e) {
              return !(!e || "string" != typeof e.type || !p(e.verify));
            }
          };
        }

        function Bh(e, t, n, r) {
          return {
            name: n || "",
            J: e.J + " or " + t.J,
            optional: !!r,
            K: function K(n) {
              return e.K(n) || t.K(n);
            }
          };
        }

        function zh(e, t) {
          for (var n in t) {
            var r = t[n].name;
            e[r] = Gh(r, e[n], t[n].j);
          }
        }

        function Zh(e, t) {
          for (var n in t) {
            var r = t[n].name;
            r !== n && Object.defineProperty(e, r, {
              get: T(function (e) {
                return this[e];
              }, n),
              set: T(function (e, t, n, r) {
                Yh(e, [n], [r], !0), this[t] = r;
              }, r, n, t[n].gb),
              enumerable: !0
            });
          }
        }

        function Qh(e, t, n, r) {
          e[t] = Gh(t, n, r);
        }

        function Gh(e, t, n) {
          function r() {
            var e = Array.prototype.slice.call(arguments);
            return Yh(o, n, e), t.apply(this, e);
          }

          if (!n) return t;

          var i,
              o = function (e) {
            return (e = e.split("."))[e.length - 1];
          }(e);

          for (i in t) {
            r[i] = t[i];
          }

          for (i in t.prototype) {
            r.prototype[i] = t.prototype[i];
          }

          return r;
        }

        zh(Xl.prototype, {
          fb: {
            name: "applyActionCode",
            j: [Oh("code")]
          },
          Pa: {
            name: "checkActionCode",
            j: [Oh("code")]
          },
          jb: {
            name: "confirmPasswordReset",
            j: [Oh("code"), Oh("newPassword")]
          },
          cc: {
            name: "createUserWithEmailAndPassword",
            j: [Oh("email"), Oh("password")]
          },
          fc: {
            name: "fetchSignInMethodsForEmail",
            j: [Oh("email")]
          },
          pa: {
            name: "getRedirectResult",
            j: []
          },
          zc: {
            name: "isSignInWithEmailLink",
            j: [Oh("emailLink")]
          },
          Fc: {
            name: "onAuthStateChanged",
            j: [Bh(Ah(), jh(), "nextOrObserver"), jh("opt_error", !0), jh("opt_completed", !0)]
          },
          Gc: {
            name: "onIdTokenChanged",
            j: [Bh(Ah(), jh(), "nextOrObserver"), jh("opt_error", !0), jh("opt_completed", !0)]
          },
          rb: {
            name: "sendPasswordResetEmail",
            j: [Oh("email"), Bh(Ah("opt_actionCodeSettings", !0), Uh(null, !0), "opt_actionCodeSettings", !0)]
          },
          sb: {
            name: "sendSignInLinkToEmail",
            j: [Oh("email"), Ah("actionCodeSettings")]
          },
          tb: {
            name: "setPersistence",
            j: [Oh("persistence")]
          },
          Qc: {
            name: "signInAndRetrieveDataWithCredential",
            j: [Ph()]
          },
          vb: {
            name: "signInAnonymously",
            j: []
          },
          Ya: {
            name: "signInWithCredential",
            j: [Ph()]
          },
          Rc: {
            name: "signInWithCustomToken",
            j: [Oh("token")]
          },
          Sc: {
            name: "signInWithEmailAndPassword",
            j: [Oh("email"), Oh("password")]
          },
          Tc: {
            name: "signInWithEmailLink",
            j: [Oh("email"), Oh("emailLink", !0)]
          },
          Uc: {
            name: "signInWithPhoneNumber",
            j: [Oh("phoneNumber"), Hh()]
          },
          Vc: {
            name: "signInWithPopup",
            j: [{
              name: "authProvider",
              J: "a valid Auth provider",
              optional: !1,
              K: function K(e) {
                return !!(e && e.providerId && e.hasOwnProperty && e.hasOwnProperty("isOAuthProvider"));
              }
            }]
          },
          Wc: {
            name: "signInWithRedirect",
            j: [{
              name: "authProvider",
              J: "a valid Auth provider",
              optional: !1,
              K: function K(e) {
                return !!(e && e.providerId && e.hasOwnProperty && e.hasOwnProperty("isOAuthProvider"));
              }
            }]
          },
          bd: {
            name: "updateCurrentUser",
            j: [Bh({
              name: "user",
              J: "an instance of Firebase User",
              optional: !1,
              K: function K(e) {
                return !!(e && e instanceof dl);
              }
            }, Uh(), "user")]
          },
          wb: {
            name: "signOut",
            j: []
          },
          toJSON: {
            name: "toJSON",
            j: [Oh(null, !0)]
          },
          dd: {
            name: "useDeviceLanguage",
            j: []
          },
          fd: {
            name: "verifyPasswordResetCode",
            j: [Oh("code")]
          }
        }), Zh(Xl.prototype, {
          lc: {
            name: "languageCode",
            gb: Bh(Oh(), Uh(), "languageCode")
          },
          ti: {
            name: "tenantId",
            gb: Bh(Oh(), Uh(), "tenantId")
          }
        }), Xl.Persistence = Qu, Xl.Persistence.LOCAL = "local", Xl.Persistence.SESSION = "session", Xl.Persistence.NONE = "none", zh(dl.prototype, {
          delete: {
            name: "delete",
            j: []
          },
          mc: {
            name: "getIdTokenResult",
            j: [Fh("opt_forceRefresh", !0)]
          },
          I: {
            name: "getIdToken",
            j: [Fh("opt_forceRefresh", !0)]
          },
          Ac: {
            name: "linkAndRetrieveDataWithCredential",
            j: [Ph()]
          },
          mb: {
            name: "linkWithCredential",
            j: [Ph()]
          },
          Bc: {
            name: "linkWithPhoneNumber",
            j: [Oh("phoneNumber"), Hh()]
          },
          Cc: {
            name: "linkWithPopup",
            j: [{
              name: "authProvider",
              J: "a valid Auth provider",
              optional: !1,
              K: function K(e) {
                return !!(e && e.providerId && e.hasOwnProperty && e.hasOwnProperty("isOAuthProvider"));
              }
            }]
          },
          Dc: {
            name: "linkWithRedirect",
            j: [{
              name: "authProvider",
              J: "a valid Auth provider",
              optional: !1,
              K: function K(e) {
                return !!(e && e.providerId && e.hasOwnProperty && e.hasOwnProperty("isOAuthProvider"));
              }
            }]
          },
          Jc: {
            name: "reauthenticateAndRetrieveDataWithCredential",
            j: [Ph()]
          },
          pb: {
            name: "reauthenticateWithCredential",
            j: [Ph()]
          },
          Kc: {
            name: "reauthenticateWithPhoneNumber",
            j: [Oh("phoneNumber"), Hh()]
          },
          Lc: {
            name: "reauthenticateWithPopup",
            j: [{
              name: "authProvider",
              J: "a valid Auth provider",
              optional: !1,
              K: function K(e) {
                return !!(e && e.providerId && e.hasOwnProperty && e.hasOwnProperty("isOAuthProvider"));
              }
            }]
          },
          Mc: {
            name: "reauthenticateWithRedirect",
            j: [{
              name: "authProvider",
              J: "a valid Auth provider",
              optional: !1,
              K: function K(e) {
                return !!(e && e.providerId && e.hasOwnProperty && e.hasOwnProperty("isOAuthProvider"));
              }
            }]
          },
          reload: {
            name: "reload",
            j: []
          },
          qb: {
            name: "sendEmailVerification",
            j: [Bh(Ah("opt_actionCodeSettings", !0), Uh(null, !0), "opt_actionCodeSettings", !0)]
          },
          toJSON: {
            name: "toJSON",
            j: [Oh(null, !0)]
          },
          ad: {
            name: "unlink",
            j: [Oh("provider")]
          },
          xb: {
            name: "updateEmail",
            j: [Oh("email")]
          },
          yb: {
            name: "updatePassword",
            j: [Oh("password")]
          },
          cd: {
            name: "updatePhoneNumber",
            j: [Ph("phone")]
          },
          zb: {
            name: "updateProfile",
            j: [Ah("profile")]
          },
          Ab: {
            name: "verifyBeforeUpdateEmail",
            j: [Oh("email"), Bh(Ah("opt_actionCodeSettings", !0), Uh(null, !0), "opt_actionCodeSettings", !0)]
          }
        }), zh(hh.prototype, {
          execute: {
            name: "execute"
          },
          render: {
            name: "render"
          },
          reset: {
            name: "reset"
          },
          getResponse: {
            name: "getResponse"
          }
        }), zh(lh.prototype, {
          execute: {
            name: "execute"
          },
          render: {
            name: "render"
          },
          reset: {
            name: "reset"
          },
          getResponse: {
            name: "getResponse"
          }
        }), zh(bt.prototype, {
          ma: {
            name: "finally"
          },
          o: {
            name: "catch"
          },
          then: {
            name: "then"
          }
        }), Zh(Bc.prototype, {
          appVerificationDisabled: {
            name: "appVerificationDisabledForTesting",
            gb: Fh("appVerificationDisabledForTesting")
          }
        }), zh(zc.prototype, {
          confirm: {
            name: "confirm",
            j: [Oh("verificationCode")]
          }
        }), Qh(ao, "fromJSON", function (e) {
          e = "string" == typeof e ? JSON.parse(e) : e;

          for (var t, n = [po, So, xo, lo], r = 0; r < n.length; r++) {
            if (t = n[r](e)) return t;
          }

          return null;
        }, [Bh(Oh(), Ah(), "json")]), Qh(No, "credential", function (e, t) {
          return new Lo(e, t);
        }, [Oh("email"), Oh("password")]), zh(Lo.prototype, {
          v: {
            name: "toJSON",
            j: [Oh(null, !0)]
          }
        }), zh(vo.prototype, {
          Aa: {
            name: "addScope",
            j: [Oh("scope")]
          },
          Ia: {
            name: "setCustomParameters",
            j: [Ah("customOAuthParameters")]
          }
        }), Qh(vo, "credential", go, [Bh(Oh(), Ah(), "token")]), Qh(No, "credentialWithLink", Do, [Oh("email"), Oh("emailLink")]), zh(bo.prototype, {
          Aa: {
            name: "addScope",
            j: [Oh("scope")]
          },
          Ia: {
            name: "setCustomParameters",
            j: [Ah("customOAuthParameters")]
          }
        }), Qh(bo, "credential", wo, [Bh(Oh(), Ah(), "token")]), zh(To.prototype, {
          Aa: {
            name: "addScope",
            j: [Oh("scope")]
          },
          Ia: {
            name: "setCustomParameters",
            j: [Ah("customOAuthParameters")]
          }
        }), Qh(To, "credential", Mo, [Bh(Oh(), Bh(Ah(), Uh()), "idToken"), Bh(Oh(), Uh(), "accessToken", !0)]), zh(Eo.prototype, {
          Ia: {
            name: "setCustomParameters",
            j: [Ah("customOAuthParameters")]
          }
        }), Qh(Eo, "credential", ko, [Bh(Oh(), Ah(), "token"), Oh("secret", !0)]), zh(yo.prototype, {
          Aa: {
            name: "addScope",
            j: [Oh("scope")]
          },
          credential: {
            name: "credential",
            j: [Bh(Oh(), Bh(Ah(), Uh()), "optionsOrIdToken"), Bh(Oh(), Uh(), "accessToken", !0)]
          },
          Ia: {
            name: "setCustomParameters",
            j: [Ah("customOAuthParameters")]
          }
        }), zh(ho.prototype, {
          v: {
            name: "toJSON",
            j: [Oh(null, !0)]
          }
        }), zh(uo.prototype, {
          v: {
            name: "toJSON",
            j: [Oh(null, !0)]
          }
        }), Qh(Co, "credential", Oo, [Oh("verificationId"), Oh("verificationCode")]), zh(Co.prototype, {
          cb: {
            name: "verifyPhoneNumber",
            j: [Bh(Oh(), {
              name: "phoneInfoOptions",
              J: "valid phone info options",
              optional: !1,
              K: function K(e) {
                return !!e && (e.session && e.phoneNumber ? Vh(e.session, io) && "string" == typeof e.phoneNumber : e.session && e.multiFactorHint ? Vh(e.session, oo) && Wh(e.multiFactorHint) : e.session && e.multiFactorUid ? Vh(e.session, oo) && "string" == typeof e.multiFactorUid : !!e.phoneNumber && "string" == typeof e.phoneNumber);
              }
            }, "phoneInfoOptions"), Hh()]
          }
        }), zh(Ro.prototype, {
          v: {
            name: "toJSON",
            j: [Oh(null, !0)]
          }
        }), zh(k.prototype, {
          toJSON: {
            name: "toJSON",
            j: [Oh(null, !0)]
          }
        }), zh(Bo.prototype, {
          toJSON: {
            name: "toJSON",
            j: [Oh(null, !0)]
          }
        }), zh(Ho.prototype, {
          toJSON: {
            name: "toJSON",
            j: [Oh(null, !0)]
          }
        }), zh(Xc.prototype, {
          toJSON: {
            name: "toJSON",
            j: [Oh(null, !0)]
          }
        }), zh(Gc.prototype, {
          Pc: {
            name: "resolveSignIn",
            j: [{
              name: "multiFactorAssertion",
              J: "a valid multiFactorAssertion",
              optional: !1,
              K: function K(e) {
                return !!e && !!e.ob;
              }
            }]
          }
        }), zh(rl.prototype, {
          Ob: {
            name: "getSession",
            j: []
          },
          dc: {
            name: "enroll",
            j: [{
              name: "multiFactorAssertion",
              J: "a valid multiFactorAssertion",
              optional: !1,
              K: function K(e) {
                return !!e && !!e.ob;
              }
            }, Oh("displayName", !0)]
          },
          $c: {
            name: "unenroll",
            j: [Bh({
              name: "multiFactorInfo",
              J: "a valid multiFactorInfo",
              optional: !1,
              K: Wh
            }, Oh(), "multiFactorInfoIdentifier")]
          }
        }), zh(xh.prototype, {
          clear: {
            name: "clear",
            j: []
          },
          render: {
            name: "render",
            j: []
          },
          verify: {
            name: "verify",
            j: []
          }
        }), Qh(vi, "parseLink", Li, [Oh("link")]), Qh(yh, "assertion", function (e) {
          return new tl(e);
        }, [Ph("phone")]), function () {
          if (void 0 === r.a || !r.a.INTERNAL || !r.a.INTERNAL.registerComponent) throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
          var e = {
            ActionCodeInfo: {
              Operation: {
                EMAIL_SIGNIN: ai,
                PASSWORD_RESET: "PASSWORD_RESET",
                RECOVER_EMAIL: "RECOVER_EMAIL",
                REVERT_SECOND_FACTOR_ADDITION: oi,
                VERIFY_AND_CHANGE_EMAIL: si,
                VERIFY_EMAIL: "VERIFY_EMAIL"
              }
            },
            Auth: Xl,
            AuthCredential: ao,
            Error: k
          };
          Qh(e, "EmailAuthProvider", No, []), Qh(e, "FacebookAuthProvider", vo, []), Qh(e, "GithubAuthProvider", bo, []), Qh(e, "GoogleAuthProvider", To, []), Qh(e, "TwitterAuthProvider", Eo, []), Qh(e, "OAuthProvider", yo, [Oh("providerId")]), Qh(e, "SAMLAuthProvider", _o, [Oh("providerId")]), Qh(e, "PhoneAuthProvider", Co, [{
            name: "auth",
            J: "an instance of Firebase Auth",
            optional: !0,
            K: function K(e) {
              return !!(e && e instanceof Xl);
            }
          }]), Qh(e, "RecaptchaVerifier", xh, [Bh(Oh(), {
            name: "",
            J: "an HTML element",
            optional: !1,
            K: function K(e) {
              return !!(e && e instanceof Element);
            }
          }, "recaptchaContainer"), Ah("recaptchaParameters", !0), {
            name: "app",
            J: "an instance of Firebase App",
            optional: !0,
            K: function K(e) {
              return !!(e && e instanceof r.a.app.App);
            }
          }]), Qh(e, "ActionCodeURL", vi, []), Qh(e, "PhoneMultiFactorGenerator", yh, []), r.a.INTERNAL.registerComponent({
            name: "auth",
            instanceFactory: function instanceFactory(e) {
              return new Xl(e = e.getProvider("app").getImmediate());
            },
            multipleInstances: !1,
            serviceProps: e,
            instantiationMode: "LAZY",
            type: "PUBLIC"
          }), r.a.INTERNAL.registerComponent({
            name: "auth-internal",
            instanceFactory: function instanceFactory(e) {
              return {
                getUid: w((e = e.getProvider("auth").getImmediate()).getUid, e),
                getToken: w(e.kc, e),
                addAuthTokenListener: w(e.bc, e),
                removeAuthTokenListener: w(e.Nc, e)
              };
            },
            multipleInstances: !1,
            instantiationMode: "LAZY",
            type: "PRIVATE"
          }), r.a.registerVersion("@firebase/auth", "0.14.5"), r.a.INTERNAL.extendNamespace({
            User: dl
          });
        }();
      }).apply(void 0 !== e ? e : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }.call(this, n(17));
  }, function (e, t, n) {
    "use strict";

    (function (r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i,
          o,
          a = (i = n(6)) && "object" == typeof i && "default" in i ? i.default : i,
          s = n(3),
          u = n(16),
          c = n(25),
          l = n(13),
          h = function () {
        function e(e) {
          this.domStorage_ = e, this.prefix_ = "firebase:";
        }

        return e.prototype.set = function (e, t) {
          null == t ? this.domStorage_.removeItem(this.prefixedName_(e)) : this.domStorage_.setItem(this.prefixedName_(e), u.stringify(t));
        }, e.prototype.get = function (e) {
          var t = this.domStorage_.getItem(this.prefixedName_(e));
          return null == t ? null : u.jsonEval(t);
        }, e.prototype.remove = function (e) {
          this.domStorage_.removeItem(this.prefixedName_(e));
        }, e.prototype.prefixedName_ = function (e) {
          return this.prefix_ + e;
        }, e.prototype.toString = function () {
          return this.domStorage_.toString();
        }, e;
      }(),
          d = function () {
        function e() {
          this.cache_ = {}, this.isInMemoryStorage = !0;
        }

        return e.prototype.set = function (e, t) {
          null == t ? delete this.cache_[e] : this.cache_[e] = t;
        }, e.prototype.get = function (e) {
          return u.contains(this.cache_, e) ? this.cache_[e] : null;
        }, e.prototype.remove = function (e) {
          delete this.cache_[e];
        }, e;
      }(),
          f = function f(e) {
        try {
          if ("undefined" != typeof window && void 0 !== window[e]) {
            var t = window[e];
            return t.setItem("firebase:sentinel", "cache"), t.removeItem("firebase:sentinel"), new h(t);
          }
        } catch (e) {}

        return new d();
      },
          p = f("localStorage"),
          m = f("sessionStorage"),
          _ = new c.Logger("@firebase/database"),
          y = (o = 1, function () {
        return o++;
      }),
          v = function v(e) {
        var t = u.stringToByteArray(e),
            n = new u.Sha1();
        n.update(t);
        var r = n.digest();
        return u.base64.encodeByteArray(r);
      },
          g = function g() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        for (var n = "", r = 0; r < e.length; r++) {
          var i = e[r];
          Array.isArray(i) || i && "object" == typeof i && "number" == typeof i.length ? n += g.apply(null, i) : n += "object" == typeof i ? u.stringify(i) : i, n += " ";
        }

        return n;
      },
          b = null,
          w = !0,
          T = function T(e, t) {
        u.assert(!t || !0 === e || !1 === e, "Can't turn on custom loggers persistently."), !0 === e ? (_.logLevel = c.LogLevel.VERBOSE, b = _.log.bind(_), t && m.set("logging_enabled", !0)) : "function" == typeof e ? b = e : (b = null, m.remove("logging_enabled"));
      },
          M = function M() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        if (!0 === w && (w = !1, null === b && !0 === m.get("logging_enabled") && T(!0)), b) {
          var n = g.apply(null, e);
          b(n);
        }
      },
          E = function E(e) {
        return function () {
          for (var t = [], n = 0; n < arguments.length; n++) {
            t[n] = arguments[n];
          }

          M.apply(void 0, s.__spread([e], t));
        };
      },
          k = function k() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        var n = "FIREBASE INTERNAL ERROR: " + g.apply(void 0, s.__spread(e));

        _.error(n);
      },
          L = function L() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        var n = "FIREBASE FATAL ERROR: " + g.apply(void 0, s.__spread(e));
        throw _.error(n), new Error(n);
      },
          S = function S() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        var n = "FIREBASE WARNING: " + g.apply(void 0, s.__spread(e));

        _.warn(n);
      },
          N = function N(e) {
        return "number" == typeof e && (e != e || e === Number.POSITIVE_INFINITY || e === Number.NEGATIVE_INFINITY);
      },
          D = "[MIN_NAME]",
          I = "[MAX_NAME]",
          R = function R(e, t) {
        if (e === t) return 0;
        if (e === D || t === I) return -1;
        if (t === D || e === I) return 1;
        var n = U(e),
            r = U(t);
        return null !== n ? null !== r ? n - r == 0 ? e.length - t.length : n - r : -1 : null !== r ? 1 : e < t ? -1 : 1;
      },
          x = function x(e, t) {
        return e === t ? 0 : e < t ? -1 : 1;
      },
          Y = function Y(e, t) {
        if (t && e in t) return t[e];
        throw new Error("Missing required key (" + e + ") in object: " + u.stringify(t));
      },
          C = function C(e) {
        if ("object" != typeof e || null === e) return u.stringify(e);
        var t = [];

        for (var n in e) {
          t.push(n);
        }

        t.sort();

        for (var r = "{", i = 0; i < t.length; i++) {
          0 !== i && (r += ","), r += u.stringify(t[i]), r += ":", r += C(e[t[i]]);
        }

        return r += "}";
      },
          O = function O(e, t) {
        var n = e.length;
        if (n <= t) return [e];

        for (var r = [], i = 0; i < n; i += t) {
          i + t > n ? r.push(e.substring(i, n)) : r.push(e.substring(i, i + t));
        }

        return r;
      };

      function F(e, t) {
        for (var n in e) {
          e.hasOwnProperty(n) && t(n, e[n]);
        }
      }

      var A = function A(e) {
        u.assert(!N(e), "Invalid JSON number");
        var t, n, r, i, o;
        0 === e ? (n = 0, r = 0, t = 1 / e == -1 / 0 ? 1 : 0) : (t = e < 0, (e = Math.abs(e)) >= Math.pow(2, -1022) ? (n = (i = Math.min(Math.floor(Math.log(e) / Math.LN2), 1023)) + 1023, r = Math.round(e * Math.pow(2, 52 - i) - Math.pow(2, 52))) : (n = 0, r = Math.round(e / Math.pow(2, -1074))));
        var a = [];

        for (o = 52; o; o -= 1) {
          a.push(r % 2 ? 1 : 0), r = Math.floor(r / 2);
        }

        for (o = 11; o; o -= 1) {
          a.push(n % 2 ? 1 : 0), n = Math.floor(n / 2);
        }

        a.push(t ? 1 : 0), a.reverse();
        var s = a.join(""),
            c = "";

        for (o = 0; o < 64; o += 8) {
          var l = parseInt(s.substr(o, 8), 2).toString(16);
          1 === l.length && (l = "0" + l), c += l;
        }

        return c.toLowerCase();
      },
          j = new RegExp("^-?(0*)\\d{1,10}$"),
          U = function U(e) {
        if (j.test(e)) {
          var t = Number(e);
          if (t >= -2147483648 && t <= 2147483647) return t;
        }

        return null;
      },
          P = function P(e) {
        try {
          e();
        } catch (e) {
          setTimeout(function () {
            var t = e.stack || "";
            throw S("Exception was thrown by user callback.", t), e;
          }, Math.floor(0));
        }
      },
          V = function V() {
        return ("object" == typeof window && window.navigator && window.navigator.userAgent || "").search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
      },
          W = function W(e, t) {
        var n = setTimeout(e, t);
        return "object" == typeof n && n.unref && n.unref(), n;
      },
          H = function () {
        function e(e, t) {
          if (void 0 === t) {
            this.pieces_ = e.split("/");

            for (var n = 0, r = 0; r < this.pieces_.length; r++) {
              this.pieces_[r].length > 0 && (this.pieces_[n] = this.pieces_[r], n++);
            }

            this.pieces_.length = n, this.pieceNum_ = 0;
          } else this.pieces_ = e, this.pieceNum_ = t;
        }

        return Object.defineProperty(e, "Empty", {
          get: function get() {
            return new e("");
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.getFront = function () {
          return this.pieceNum_ >= this.pieces_.length ? null : this.pieces_[this.pieceNum_];
        }, e.prototype.getLength = function () {
          return this.pieces_.length - this.pieceNum_;
        }, e.prototype.popFront = function () {
          var t = this.pieceNum_;
          return t < this.pieces_.length && t++, new e(this.pieces_, t);
        }, e.prototype.getBack = function () {
          return this.pieceNum_ < this.pieces_.length ? this.pieces_[this.pieces_.length - 1] : null;
        }, e.prototype.toString = function () {
          for (var e = "", t = this.pieceNum_; t < this.pieces_.length; t++) {
            "" !== this.pieces_[t] && (e += "/" + this.pieces_[t]);
          }

          return e || "/";
        }, e.prototype.toUrlEncodedString = function () {
          for (var e = "", t = this.pieceNum_; t < this.pieces_.length; t++) {
            "" !== this.pieces_[t] && (e += "/" + encodeURIComponent(String(this.pieces_[t])));
          }

          return e || "/";
        }, e.prototype.slice = function (e) {
          return void 0 === e && (e = 0), this.pieces_.slice(this.pieceNum_ + e);
        }, e.prototype.parent = function () {
          if (this.pieceNum_ >= this.pieces_.length) return null;

          for (var t = [], n = this.pieceNum_; n < this.pieces_.length - 1; n++) {
            t.push(this.pieces_[n]);
          }

          return new e(t, 0);
        }, e.prototype.child = function (t) {
          for (var n = [], r = this.pieceNum_; r < this.pieces_.length; r++) {
            n.push(this.pieces_[r]);
          }

          if (t instanceof e) for (r = t.pieceNum_; r < t.pieces_.length; r++) {
            n.push(t.pieces_[r]);
          } else {
            var i = t.split("/");

            for (r = 0; r < i.length; r++) {
              i[r].length > 0 && n.push(i[r]);
            }
          }
          return new e(n, 0);
        }, e.prototype.isEmpty = function () {
          return this.pieceNum_ >= this.pieces_.length;
        }, e.relativePath = function (t, n) {
          var r = t.getFront(),
              i = n.getFront();
          if (null === r) return n;
          if (r === i) return e.relativePath(t.popFront(), n.popFront());
          throw new Error("INTERNAL ERROR: innerPath (" + n + ") is not within outerPath (" + t + ")");
        }, e.comparePaths = function (e, t) {
          for (var n = e.slice(), r = t.slice(), i = 0; i < n.length && i < r.length; i++) {
            var o = R(n[i], r[i]);
            if (0 !== o) return o;
          }

          return n.length === r.length ? 0 : n.length < r.length ? -1 : 1;
        }, e.prototype.equals = function (e) {
          if (this.getLength() !== e.getLength()) return !1;

          for (var t = this.pieceNum_, n = e.pieceNum_; t <= this.pieces_.length; t++, n++) {
            if (this.pieces_[t] !== e.pieces_[n]) return !1;
          }

          return !0;
        }, e.prototype.contains = function (e) {
          var t = this.pieceNum_,
              n = e.pieceNum_;
          if (this.getLength() > e.getLength()) return !1;

          for (; t < this.pieces_.length;) {
            if (this.pieces_[t] !== e.pieces_[n]) return !1;
            ++t, ++n;
          }

          return !0;
        }, e;
      }(),
          B = function () {
        function e(e, t) {
          this.errorPrefix_ = t, this.parts_ = e.slice(), this.byteLength_ = Math.max(1, this.parts_.length);

          for (var n = 0; n < this.parts_.length; n++) {
            this.byteLength_ += u.stringLength(this.parts_[n]);
          }

          this.checkValid_();
        }

        return Object.defineProperty(e, "MAX_PATH_DEPTH", {
          get: function get() {
            return 32;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "MAX_PATH_LENGTH_BYTES", {
          get: function get() {
            return 768;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.push = function (e) {
          this.parts_.length > 0 && (this.byteLength_ += 1), this.parts_.push(e), this.byteLength_ += u.stringLength(e), this.checkValid_();
        }, e.prototype.pop = function () {
          var e = this.parts_.pop();
          this.byteLength_ -= u.stringLength(e), this.parts_.length > 0 && (this.byteLength_ -= 1);
        }, e.prototype.checkValid_ = function () {
          if (this.byteLength_ > e.MAX_PATH_LENGTH_BYTES) throw new Error(this.errorPrefix_ + "has a key path longer than " + e.MAX_PATH_LENGTH_BYTES + " bytes (" + this.byteLength_ + ").");
          if (this.parts_.length > e.MAX_PATH_DEPTH) throw new Error(this.errorPrefix_ + "path specified exceeds the maximum depth that can be written (" + e.MAX_PATH_DEPTH + ") or object contains a cycle " + this.toErrorString());
        }, e.prototype.toErrorString = function () {
          return 0 === this.parts_.length ? "" : "in property '" + this.parts_.join(".") + "'";
        }, e;
      }(),
          z = "long_polling",
          Z = function () {
        function e(e, t, n, r, i, o) {
          void 0 === i && (i = ""), void 0 === o && (o = !1), this.secure = t, this.namespace = n, this.webSocketOnly = r, this.persistenceKey = i, this.includeNamespaceInQueryParams = o, this.host = e.toLowerCase(), this.domain = this.host.substr(this.host.indexOf(".") + 1), this.internalHost = p.get("host:" + e) || this.host;
        }

        return e.prototype.needsQueryParam = function () {
          return this.host !== this.internalHost || this.isCustomHost() || this.includeNamespaceInQueryParams;
        }, e.prototype.isCacheableHost = function () {
          return "s-" === this.internalHost.substr(0, 2);
        }, e.prototype.isDemoHost = function () {
          return "firebaseio-demo.com" === this.domain;
        }, e.prototype.isCustomHost = function () {
          return "firebaseio.com" !== this.domain && "firebaseio-demo.com" !== this.domain;
        }, e.prototype.updateHost = function (e) {
          e !== this.internalHost && (this.internalHost = e, this.isCacheableHost() && p.set("host:" + this.host, this.internalHost));
        }, e.prototype.connectionURL = function (e, t) {
          var n;
          if (u.assert("string" == typeof e, "typeof type must == string"), u.assert("object" == typeof t, "typeof params must == object"), "websocket" === e) n = (this.secure ? "wss://" : "ws://") + this.internalHost + "/.ws?";else {
            if (e !== z) throw new Error("Unknown connection type: " + e);
            n = (this.secure ? "https://" : "http://") + this.internalHost + "/.lp?";
          }
          this.needsQueryParam() && (t.ns = this.namespace);
          var r = [];
          return F(t, function (e, t) {
            r.push(e + "=" + t);
          }), n + r.join("&");
        }, e.prototype.toString = function () {
          var e = this.toURLString();
          return this.persistenceKey && (e += "<" + this.persistenceKey + ">"), e;
        }, e.prototype.toURLString = function () {
          return (this.secure ? "https://" : "http://") + this.host;
        }, e;
      }();

      var Q,
          G,
          q,
          J,
          X,
          K = function K(e) {
        var t = $(e),
            n = t.namespace;
        "firebase" === t.domain && L(t.host + " is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead"), n && "undefined" !== n || "localhost" === t.domain || L("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com"), t.secure || "undefined" != typeof window && window.location && window.location.protocol && -1 !== window.location.protocol.indexOf("https:") && S("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
        var r = "ws" === t.scheme || "wss" === t.scheme;
        return {
          repoInfo: new Z(t.host, t.secure, n, r, "", n !== t.subdomain),
          path: new H(t.pathString)
        };
      },
          $ = function $(e) {
        var t = "",
            n = "",
            r = "",
            i = "",
            o = "",
            a = !0,
            u = "https",
            c = 443;

        if ("string" == typeof e) {
          var l = e.indexOf("//");
          l >= 0 && (u = e.substring(0, l - 1), e = e.substring(l + 2));
          var h = e.indexOf("/");
          -1 === h && (h = e.length);
          var d = e.indexOf("?");
          -1 === d && (d = e.length), t = e.substring(0, Math.min(h, d)), h < d && (i =
          /**
           * @license
           * Copyright 2017 Google Inc.
           *
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           *   http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           */
          function (e) {
            for (var t = "", n = e.split("/"), r = 0; r < n.length; r++) {
              if (n[r].length > 0) {
                var i = n[r];

                try {
                  i = decodeURIComponent(i.replace(/\+/g, " "));
                } catch (e) {}

                t += "/" + i;
              }
            }

            return t;
          }(e.substring(h, d)));

          var f = function (e) {
            var t,
                n,
                r = {};
            "?" === e.charAt(0) && (e = e.substring(1));

            try {
              for (var i = s.__values(e.split("&")), o = i.next(); !o.done; o = i.next()) {
                var a = o.value;

                if (0 !== a.length) {
                  var u = a.split("=");
                  2 === u.length ? r[decodeURIComponent(u[0])] = decodeURIComponent(u[1]) : S("Invalid query segment '" + a + "' in query '" + e + "'");
                }
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                o && !o.done && (n = i.return) && n.call(i);
              } finally {
                if (t) throw t.error;
              }
            }

            return r;
          }(e.substring(Math.min(e.length, d)));

          (l = t.indexOf(":")) >= 0 ? (a = "https" === u || "wss" === u, c = parseInt(t.substring(l + 1), 10)) : l = e.length;
          var p = t.split(".");
          3 === p.length ? (n = p[1], o = r = p[0].toLowerCase()) : 2 === p.length ? n = p[0] : "localhost" === p[0].slice(0, l).toLowerCase() && (n = "localhost"), "ns" in f && (o = f.ns);
        }

        return {
          host: t,
          port: c,
          domain: n,
          subdomain: r,
          secure: a,
          scheme: u,
          pathString: i,
          namespace: o
        };
      },
          ee = /[\[\].#$\/\u0000-\u001F\u007F]/,
          te = /[\[\].#$\u0000-\u001F\u007F]/,
          ne = function ne(e) {
        return "string" == typeof e && 0 !== e.length && !ee.test(e);
      },
          re = function re(e) {
        return "string" == typeof e && 0 !== e.length && !te.test(e);
      },
          ie = function ie(e) {
        return null === e || "string" == typeof e || "number" == typeof e && !N(e) || e && "object" == typeof e && u.contains(e, ".sv");
      },
          oe = function oe(e, t, n, r, i) {
        i && void 0 === n || ae(u.errorPrefix(e, t, i), n, r);
      },
          ae = function ae(e, t, n) {
        var r = n instanceof H ? new B(n, e) : n;
        if (void 0 === t) throw new Error(e + "contains undefined " + r.toErrorString());
        if ("function" == typeof t) throw new Error(e + "contains a function " + r.toErrorString() + " with contents = " + t.toString());
        if (N(t)) throw new Error(e + "contains " + t.toString() + " " + r.toErrorString());
        if ("string" == typeof t && t.length > 10485760 / 3 && u.stringLength(t) > 10485760) throw new Error(e + "contains a string greater than 10485760 utf8 bytes " + r.toErrorString() + " ('" + t.substring(0, 50) + "...')");

        if (t && "object" == typeof t) {
          var i = !1,
              o = !1;
          if (F(t, function (t, n) {
            if (".value" === t) i = !0;else if (".priority" !== t && ".sv" !== t && (o = !0, !ne(t))) throw new Error(e + " contains an invalid key (" + t + ") " + r.toErrorString() + '.  Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');
            r.push(t), ae(e, n, r), r.pop();
          }), i && o) throw new Error(e + ' contains ".value" child ' + r.toErrorString() + " in addition to actual children.");
        }
      },
          se = function se(e, t, n, r, i) {
        if (!i || void 0 !== n) {
          var o = u.errorPrefix(e, t, i);
          if (!n || "object" != typeof n || Array.isArray(n)) throw new Error(o + " must be an object containing the children to replace.");
          var a = [];
          F(n, function (e, t) {
            var n = new H(e);
            if (ae(o, t, r.child(n)), ".priority" === n.getBack() && !ie(t)) throw new Error(o + "contains an invalid value for '" + n.toString() + "', which must be a valid Firebase priority (a string, finite number, server value, or null).");
            a.push(n);
          }), function (e, t) {
            var n, r;

            for (n = 0; n < t.length; n++) {
              for (var i = (r = t[n]).slice(), o = 0; o < i.length; o++) {
                if (".priority" === i[o] && o === i.length - 1) ;else if (!ne(i[o])) throw new Error(e + "contains an invalid key (" + i[o] + ") in path " + r.toString() + '. Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');
              }
            }

            t.sort(H.comparePaths);
            var a = null;

            for (n = 0; n < t.length; n++) {
              if (r = t[n], null !== a && a.contains(r)) throw new Error(e + "contains a path " + a.toString() + " that is ancestor of another path " + r.toString());
              a = r;
            }
          }(o, a);
        }
      },
          ue = function ue(e, t, n, r) {
        if (!r || void 0 !== n) {
          if (N(n)) throw new Error(u.errorPrefix(e, t, r) + "is " + n.toString() + ", but must be a valid Firebase priority (a string, finite number, server value, or null).");
          if (!ie(n)) throw new Error(u.errorPrefix(e, t, r) + "must be a valid Firebase priority (a string, finite number, server value, or null).");
        }
      },
          ce = function ce(e, t, n, r) {
        if (!r || void 0 !== n) switch (n) {
          case "value":
          case "child_added":
          case "child_removed":
          case "child_changed":
          case "child_moved":
            break;

          default:
            throw new Error(u.errorPrefix(e, t, r) + 'must be a valid event type = "value", "child_added", "child_removed", "child_changed", or "child_moved".');
        }
      },
          le = function le(e, t, n, r) {
        if (!(r && void 0 === n || ne(n))) throw new Error(u.errorPrefix(e, t, r) + 'was an invalid key = "' + n + '".  Firebase keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]").');
      },
          he = function he(e, t, n, r) {
        if (!(r && void 0 === n || re(n))) throw new Error(u.errorPrefix(e, t, r) + 'was an invalid path = "' + n + '". Paths must be non-empty strings and can\'t contain ".", "#", "$", "[", or "]"');
      },
          de = function de(e, t) {
        if (".info" === t.getFront()) throw new Error(e + " failed = Can't modify data under /.info/");
      },
          fe = function fe(e, t, n) {
        var r = n.path.toString();
        if ("string" != typeof n.repoInfo.host || 0 === n.repoInfo.host.length || !ne(n.repoInfo.namespace) && "localhost" !== n.repoInfo.host.split(":")[0] || 0 !== r.length && !function (e) {
          return e && (e = e.replace(/^\/*\.info(\/|$)/, "/")), re(e);
        }(r)) throw new Error(u.errorPrefix(e, t, !1) + 'must be a valid firebase URL and the path can\'t contain ".", "#", "$", "[", or "]".');
      },
          pe = function () {
        function e(e, t) {
          this.repo_ = e, this.path_ = t;
        }

        return e.prototype.cancel = function (e) {
          u.validateArgCount("OnDisconnect.cancel", 0, 1, arguments.length), u.validateCallback("OnDisconnect.cancel", 1, e, !0);
          var t = new u.Deferred();
          return this.repo_.onDisconnectCancel(this.path_, t.wrapCallback(e)), t.promise;
        }, e.prototype.remove = function (e) {
          u.validateArgCount("OnDisconnect.remove", 0, 1, arguments.length), de("OnDisconnect.remove", this.path_), u.validateCallback("OnDisconnect.remove", 1, e, !0);
          var t = new u.Deferred();
          return this.repo_.onDisconnectSet(this.path_, null, t.wrapCallback(e)), t.promise;
        }, e.prototype.set = function (e, t) {
          u.validateArgCount("OnDisconnect.set", 1, 2, arguments.length), de("OnDisconnect.set", this.path_), oe("OnDisconnect.set", 1, e, this.path_, !1), u.validateCallback("OnDisconnect.set", 2, t, !0);
          var n = new u.Deferred();
          return this.repo_.onDisconnectSet(this.path_, e, n.wrapCallback(t)), n.promise;
        }, e.prototype.setWithPriority = function (e, t, n) {
          u.validateArgCount("OnDisconnect.setWithPriority", 2, 3, arguments.length), de("OnDisconnect.setWithPriority", this.path_), oe("OnDisconnect.setWithPriority", 1, e, this.path_, !1), ue("OnDisconnect.setWithPriority", 2, t, !1), u.validateCallback("OnDisconnect.setWithPriority", 3, n, !0);
          var r = new u.Deferred();
          return this.repo_.onDisconnectSetWithPriority(this.path_, e, t, r.wrapCallback(n)), r.promise;
        }, e.prototype.update = function (e, t) {
          if (u.validateArgCount("OnDisconnect.update", 1, 2, arguments.length), de("OnDisconnect.update", this.path_), Array.isArray(e)) {
            for (var n = {}, r = 0; r < e.length; ++r) {
              n["" + r] = e[r];
            }

            e = n, S("Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
          }

          se("OnDisconnect.update", 1, e, this.path_, !1), u.validateCallback("OnDisconnect.update", 2, t, !0);
          var i = new u.Deferred();
          return this.repo_.onDisconnectUpdate(this.path_, e, i.wrapCallback(t)), i.promise;
        }, e;
      }(),
          me = function () {
        function e(e, t) {
          this.committed = e, this.snapshot = t;
        }

        return e.prototype.toJSON = function () {
          return u.validateArgCount("TransactionResult.toJSON", 0, 1, arguments.length), {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
          };
        }, e;
      }(),
          _e = (Q = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz", G = 0, q = [], function (e) {
        var t,
            n = e === G;
        G = e;
        var r = new Array(8);

        for (t = 7; t >= 0; t--) {
          r[t] = Q.charAt(e % 64), e = Math.floor(e / 64);
        }

        u.assert(0 === e, "Cannot push at time == 0");
        var i = r.join("");

        if (n) {
          for (t = 11; t >= 0 && 63 === q[t]; t--) {
            q[t] = 0;
          }

          q[t]++;
        } else for (t = 0; t < 12; t++) {
          q[t] = Math.floor(64 * Math.random());
        }

        for (t = 0; t < 12; t++) {
          i += Q.charAt(q[t]);
        }

        return u.assert(20 === i.length, "nextPushId: Length should be 20."), i;
      }),
          ye = function () {
        function e(e, t) {
          this.name = e, this.node = t;
        }

        return e.Wrap = function (t, n) {
          return new e(t, n);
        }, e;
      }(),
          ve = function () {
        function e() {}

        return e.prototype.getCompare = function () {
          return this.compare.bind(this);
        }, e.prototype.indexedValueChanged = function (e, t) {
          var n = new ye(D, e),
              r = new ye(D, t);
          return 0 !== this.compare(n, r);
        }, e.prototype.minPost = function () {
          return ye.MIN;
        }, e;
      }(),
          ge = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }

        return s.__extends(t, e), Object.defineProperty(t, "__EMPTY_NODE", {
          get: function get() {
            return J;
          },
          set: function set(e) {
            J = e;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.compare = function (e, t) {
          return R(e.name, t.name);
        }, t.prototype.isDefinedOn = function (e) {
          throw u.assertionError("KeyIndex.isDefinedOn not expected to be called.");
        }, t.prototype.indexedValueChanged = function (e, t) {
          return !1;
        }, t.prototype.minPost = function () {
          return ye.MIN;
        }, t.prototype.maxPost = function () {
          return new ye(I, J);
        }, t.prototype.makePost = function (e, t) {
          return u.assert("string" == typeof e, "KeyIndex indexValue must always be a string."), new ye(e, J);
        }, t.prototype.toString = function () {
          return ".key";
        }, t;
      }(ve),
          be = new ge();

      var we,
          Te,
          Me,
          Ee = function Ee(e) {
        return "number" == typeof e ? "number:" + A(e) : "string:" + e;
      },
          ke = function ke(e) {
        if (e.isLeafNode()) {
          var t = e.val();
          u.assert("string" == typeof t || "number" == typeof t || "object" == typeof t && u.contains(t, ".sv"), "Priority must be a string or number.");
        } else u.assert(e === X || e.isEmpty(), "priority of unexpected type.");

        u.assert(e === X || e.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
      },
          Le = function () {
        function e(t, n) {
          void 0 === n && (n = e.__childrenNodeConstructor.EMPTY_NODE), this.value_ = t, this.priorityNode_ = n, this.lazyHash_ = null, u.assert(void 0 !== this.value_ && null !== this.value_, "LeafNode shouldn't be created with null/undefined value."), ke(this.priorityNode_);
        }

        return Object.defineProperty(e, "__childrenNodeConstructor", {
          get: function get() {
            return we;
          },
          set: function set(e) {
            we = e;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.isLeafNode = function () {
          return !0;
        }, e.prototype.getPriority = function () {
          return this.priorityNode_;
        }, e.prototype.updatePriority = function (t) {
          return new e(this.value_, t);
        }, e.prototype.getImmediateChild = function (t) {
          return ".priority" === t ? this.priorityNode_ : e.__childrenNodeConstructor.EMPTY_NODE;
        }, e.prototype.getChild = function (t) {
          return t.isEmpty() ? this : ".priority" === t.getFront() ? this.priorityNode_ : e.__childrenNodeConstructor.EMPTY_NODE;
        }, e.prototype.hasChild = function () {
          return !1;
        }, e.prototype.getPredecessorChildName = function (e, t) {
          return null;
        }, e.prototype.updateImmediateChild = function (t, n) {
          return ".priority" === t ? this.updatePriority(n) : n.isEmpty() && ".priority" !== t ? this : e.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(t, n).updatePriority(this.priorityNode_);
        }, e.prototype.updateChild = function (t, n) {
          var r = t.getFront();
          return null === r ? n : n.isEmpty() && ".priority" !== r ? this : (u.assert(".priority" !== r || 1 === t.getLength(), ".priority must be the last token in a path"), this.updateImmediateChild(r, e.__childrenNodeConstructor.EMPTY_NODE.updateChild(t.popFront(), n)));
        }, e.prototype.isEmpty = function () {
          return !1;
        }, e.prototype.numChildren = function () {
          return 0;
        }, e.prototype.forEachChild = function (e, t) {
          return !1;
        }, e.prototype.val = function (e) {
          return e && !this.getPriority().isEmpty() ? {
            ".value": this.getValue(),
            ".priority": this.getPriority().val()
          } : this.getValue();
        }, e.prototype.hash = function () {
          if (null === this.lazyHash_) {
            var e = "";
            this.priorityNode_.isEmpty() || (e += "priority:" + Ee(this.priorityNode_.val()) + ":");
            var t = typeof this.value_;
            e += t + ":", e += "number" === t ? A(this.value_) : this.value_, this.lazyHash_ = v(e);
          }

          return this.lazyHash_;
        }, e.prototype.getValue = function () {
          return this.value_;
        }, e.prototype.compareTo = function (t) {
          return t === e.__childrenNodeConstructor.EMPTY_NODE ? 1 : t instanceof e.__childrenNodeConstructor ? -1 : (u.assert(t.isLeafNode(), "Unknown node type"), this.compareToLeafNode_(t));
        }, e.prototype.compareToLeafNode_ = function (t) {
          var n = typeof t.value_,
              r = typeof this.value_,
              i = e.VALUE_TYPE_ORDER.indexOf(n),
              o = e.VALUE_TYPE_ORDER.indexOf(r);
          return u.assert(i >= 0, "Unknown leaf type: " + n), u.assert(o >= 0, "Unknown leaf type: " + r), i === o ? "object" === r ? 0 : this.value_ < t.value_ ? -1 : this.value_ === t.value_ ? 0 : 1 : o - i;
        }, e.prototype.withIndex = function () {
          return this;
        }, e.prototype.isIndexed = function () {
          return !0;
        }, e.prototype.equals = function (e) {
          if (e === this) return !0;

          if (e.isLeafNode()) {
            var t = e;
            return this.value_ === t.value_ && this.priorityNode_.equals(t.priorityNode_);
          }

          return !1;
        }, e.VALUE_TYPE_ORDER = ["object", "boolean", "number", "string"], e;
      }();

      var Se,
          Ne,
          De = new (function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }

        return s.__extends(t, e), t.prototype.compare = function (e, t) {
          var n = e.node.getPriority(),
              r = t.node.getPriority(),
              i = n.compareTo(r);
          return 0 === i ? R(e.name, t.name) : i;
        }, t.prototype.isDefinedOn = function (e) {
          return !e.getPriority().isEmpty();
        }, t.prototype.indexedValueChanged = function (e, t) {
          return !e.getPriority().equals(t.getPriority());
        }, t.prototype.minPost = function () {
          return ye.MIN;
        }, t.prototype.maxPost = function () {
          return new ye(I, new Le("[PRIORITY-POST]", Me));
        }, t.prototype.makePost = function (e, t) {
          var n = Te(e);
          return new ye(t, new Le("[PRIORITY-POST]", n));
        }, t.prototype.toString = function () {
          return ".priority";
        }, t;
      }(ve))(),
          Ie = function () {
        function e(e, t, n, r, i) {
          void 0 === i && (i = null), this.isReverse_ = r, this.resultGenerator_ = i, this.nodeStack_ = [];

          for (var o = 1; !e.isEmpty();) {
            if (e = e, o = t ? n(e.key, t) : 1, r && (o *= -1), o < 0) e = this.isReverse_ ? e.left : e.right;else {
              if (0 === o) {
                this.nodeStack_.push(e);
                break;
              }

              this.nodeStack_.push(e), e = this.isReverse_ ? e.right : e.left;
            }
          }
        }

        return e.prototype.getNext = function () {
          if (0 === this.nodeStack_.length) return null;
          var e,
              t = this.nodeStack_.pop();
          if (e = this.resultGenerator_ ? this.resultGenerator_(t.key, t.value) : {
            key: t.key,
            value: t.value
          }, this.isReverse_) for (t = t.left; !t.isEmpty();) {
            this.nodeStack_.push(t), t = t.right;
          } else for (t = t.right; !t.isEmpty();) {
            this.nodeStack_.push(t), t = t.left;
          }
          return e;
        }, e.prototype.hasNext = function () {
          return this.nodeStack_.length > 0;
        }, e.prototype.peek = function () {
          if (0 === this.nodeStack_.length) return null;
          var e = this.nodeStack_[this.nodeStack_.length - 1];
          return this.resultGenerator_ ? this.resultGenerator_(e.key, e.value) : {
            key: e.key,
            value: e.value
          };
        }, e;
      }(),
          Re = function () {
        function e(t, n, r, i, o) {
          this.key = t, this.value = n, this.color = null != r ? r : e.RED, this.left = null != i ? i : Ye.EMPTY_NODE, this.right = null != o ? o : Ye.EMPTY_NODE;
        }

        return e.prototype.copy = function (t, n, r, i, o) {
          return new e(null != t ? t : this.key, null != n ? n : this.value, null != r ? r : this.color, null != i ? i : this.left, null != o ? o : this.right);
        }, e.prototype.count = function () {
          return this.left.count() + 1 + this.right.count();
        }, e.prototype.isEmpty = function () {
          return !1;
        }, e.prototype.inorderTraversal = function (e) {
          return this.left.inorderTraversal(e) || !!e(this.key, this.value) || this.right.inorderTraversal(e);
        }, e.prototype.reverseTraversal = function (e) {
          return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
        }, e.prototype.min_ = function () {
          return this.left.isEmpty() ? this : this.left.min_();
        }, e.prototype.minKey = function () {
          return this.min_().key;
        }, e.prototype.maxKey = function () {
          return this.right.isEmpty() ? this.key : this.right.maxKey();
        }, e.prototype.insert = function (e, t, n) {
          var r = this,
              i = n(e, r.key);
          return (r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n))).fixUp_();
        }, e.prototype.removeMin_ = function () {
          if (this.left.isEmpty()) return Ye.EMPTY_NODE;
          var e = this;
          return e.left.isRed_() || e.left.left.isRed_() || (e = e.moveRedLeft_()), (e = e.copy(null, null, null, e.left.removeMin_(), null)).fixUp_();
        }, e.prototype.remove = function (e, t) {
          var n, r;
          if (t(e, (n = this).key) < 0) n.left.isEmpty() || n.left.isRed_() || n.left.left.isRed_() || (n = n.moveRedLeft_()), n = n.copy(null, null, null, n.left.remove(e, t), null);else {
            if (n.left.isRed_() && (n = n.rotateRight_()), n.right.isEmpty() || n.right.isRed_() || n.right.left.isRed_() || (n = n.moveRedRight_()), 0 === t(e, n.key)) {
              if (n.right.isEmpty()) return Ye.EMPTY_NODE;
              r = n.right.min_(), n = n.copy(r.key, r.value, null, null, n.right.removeMin_());
            }

            n = n.copy(null, null, null, null, n.right.remove(e, t));
          }
          return n.fixUp_();
        }, e.prototype.isRed_ = function () {
          return this.color;
        }, e.prototype.fixUp_ = function () {
          var e = this;
          return e.right.isRed_() && !e.left.isRed_() && (e = e.rotateLeft_()), e.left.isRed_() && e.left.left.isRed_() && (e = e.rotateRight_()), e.left.isRed_() && e.right.isRed_() && (e = e.colorFlip_()), e;
        }, e.prototype.moveRedLeft_ = function () {
          var e = this.colorFlip_();
          return e.right.left.isRed_() && (e = (e = (e = e.copy(null, null, null, null, e.right.rotateRight_())).rotateLeft_()).colorFlip_()), e;
        }, e.prototype.moveRedRight_ = function () {
          var e = this.colorFlip_();
          return e.left.left.isRed_() && (e = (e = e.rotateRight_()).colorFlip_()), e;
        }, e.prototype.rotateLeft_ = function () {
          var t = this.copy(null, null, e.RED, null, this.right.left);
          return this.right.copy(null, null, this.color, t, null);
        }, e.prototype.rotateRight_ = function () {
          var t = this.copy(null, null, e.RED, this.left.right, null);
          return this.left.copy(null, null, this.color, null, t);
        }, e.prototype.colorFlip_ = function () {
          var e = this.left.copy(null, null, !this.left.color, null, null),
              t = this.right.copy(null, null, !this.right.color, null, null);
          return this.copy(null, null, !this.color, e, t);
        }, e.prototype.checkMaxDepth_ = function () {
          var e = this.check_();
          return Math.pow(2, e) <= this.count() + 1;
        }, e.prototype.check_ = function () {
          if (this.isRed_() && this.left.isRed_()) throw new Error("Red node has red child(" + this.key + "," + this.value + ")");
          if (this.right.isRed_()) throw new Error("Right child of (" + this.key + "," + this.value + ") is red");
          var e = this.left.check_();
          if (e !== this.right.check_()) throw new Error("Black depths differ");
          return e + (this.isRed_() ? 0 : 1);
        }, e.RED = !0, e.BLACK = !1, e;
      }(),
          xe = function () {
        function e() {}

        return e.prototype.copy = function (e, t, n, r, i) {
          return this;
        }, e.prototype.insert = function (e, t, n) {
          return new Re(e, t, null);
        }, e.prototype.remove = function (e, t) {
          return this;
        }, e.prototype.count = function () {
          return 0;
        }, e.prototype.isEmpty = function () {
          return !0;
        }, e.prototype.inorderTraversal = function (e) {
          return !1;
        }, e.prototype.reverseTraversal = function (e) {
          return !1;
        }, e.prototype.minKey = function () {
          return null;
        }, e.prototype.maxKey = function () {
          return null;
        }, e.prototype.check_ = function () {
          return 0;
        }, e.prototype.isRed_ = function () {
          return !1;
        }, e;
      }(),
          Ye = function () {
        function e(t, n) {
          void 0 === n && (n = e.EMPTY_NODE), this.comparator_ = t, this.root_ = n;
        }

        return e.prototype.insert = function (t, n) {
          return new e(this.comparator_, this.root_.insert(t, n, this.comparator_).copy(null, null, Re.BLACK, null, null));
        }, e.prototype.remove = function (t) {
          return new e(this.comparator_, this.root_.remove(t, this.comparator_).copy(null, null, Re.BLACK, null, null));
        }, e.prototype.get = function (e) {
          for (var t, n = this.root_; !n.isEmpty();) {
            if (0 === (t = this.comparator_(e, n.key))) return n.value;
            t < 0 ? n = n.left : t > 0 && (n = n.right);
          }

          return null;
        }, e.prototype.getPredecessorKey = function (e) {
          for (var t, n = this.root_, r = null; !n.isEmpty();) {
            if (0 === (t = this.comparator_(e, n.key))) {
              if (n.left.isEmpty()) return r ? r.key : null;

              for (n = n.left; !n.right.isEmpty();) {
                n = n.right;
              }

              return n.key;
            }

            t < 0 ? n = n.left : t > 0 && (r = n, n = n.right);
          }

          throw new Error("Attempted to find predecessor key for a nonexistent key.  What gives?");
        }, e.prototype.isEmpty = function () {
          return this.root_.isEmpty();
        }, e.prototype.count = function () {
          return this.root_.count();
        }, e.prototype.minKey = function () {
          return this.root_.minKey();
        }, e.prototype.maxKey = function () {
          return this.root_.maxKey();
        }, e.prototype.inorderTraversal = function (e) {
          return this.root_.inorderTraversal(e);
        }, e.prototype.reverseTraversal = function (e) {
          return this.root_.reverseTraversal(e);
        }, e.prototype.getIterator = function (e) {
          return new Ie(this.root_, null, this.comparator_, !1, e);
        }, e.prototype.getIteratorFrom = function (e, t) {
          return new Ie(this.root_, e, this.comparator_, !1, t);
        }, e.prototype.getReverseIteratorFrom = function (e, t) {
          return new Ie(this.root_, e, this.comparator_, !0, t);
        }, e.prototype.getReverseIterator = function (e) {
          return new Ie(this.root_, null, this.comparator_, !0, e);
        }, e.EMPTY_NODE = new xe(), e;
      }(),
          Ce = Math.log(2),
          Oe = function () {
        function e(e) {
          var t;
          this.count = (t = e + 1, parseInt(Math.log(t) / Ce, 10)), this.current_ = this.count - 1;
          var n,
              r = (n = this.count, parseInt(Array(n + 1).join("1"), 2));
          this.bits_ = e + 1 & r;
        }

        return e.prototype.nextBitIsOne = function () {
          var e = !(this.bits_ & 1 << this.current_);
          return this.current_--, e;
        }, e;
      }(),
          Fe = function Fe(e, t, n, r) {
        e.sort(t);

        var i = function i(t, r) {
          var o,
              a,
              s = r - t;
          if (0 === s) return null;
          if (1 === s) return o = e[t], a = n ? n(o) : o, new Re(a, o.node, Re.BLACK, null, null);
          var u = parseInt(s / 2, 10) + t,
              c = i(t, u),
              l = i(u + 1, r);
          return o = e[u], a = n ? n(o) : o, new Re(a, o.node, Re.BLACK, c, l);
        },
            o = function (t) {
          for (var r = null, o = null, a = e.length, s = function s(t, r) {
            var o = a - t,
                s = a;
            a -= t;
            var c = i(o + 1, s),
                l = e[o],
                h = n ? n(l) : l;
            u(new Re(h, l.node, r, null, c));
          }, u = function u(e) {
            r ? (r.left = e, r = e) : (o = e, r = e);
          }, c = 0; c < t.count; ++c) {
            var l = t.nextBitIsOne(),
                h = Math.pow(2, t.count - (c + 1));
            l ? s(h, Re.BLACK) : (s(h, Re.BLACK), s(h, Re.RED));
          }

          return o;
        }(new Oe(e.length));

        return new Ye(r || t, o);
      },
          Ae = {},
          je = function () {
        function e(e, t) {
          this.indexes_ = e, this.indexSet_ = t;
        }

        return Object.defineProperty(e, "Default", {
          get: function get() {
            return u.assert(Ae && De, "ChildrenNode.ts has not been loaded"), Se = Se || new e({
              ".priority": Ae
            }, {
              ".priority": De
            });
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.get = function (e) {
          var t = u.safeGet(this.indexes_, e);
          if (!t) throw new Error("No index defined for " + e);
          return t instanceof Ye ? t : null;
        }, e.prototype.hasIndex = function (e) {
          return u.contains(this.indexSet_, e.toString());
        }, e.prototype.addIndex = function (t, n) {
          u.assert(t !== be, "KeyIndex always exists and isn't meant to be added to the IndexMap.");

          for (var r, i = [], o = !1, a = n.getIterator(ye.Wrap), c = a.getNext(); c;) {
            o = o || t.isDefinedOn(c.node), i.push(c), c = a.getNext();
          }

          r = o ? Fe(i, t.getCompare()) : Ae;

          var l = t.toString(),
              h = s.__assign({}, this.indexSet_);

          h[l] = t;

          var d = s.__assign({}, this.indexes_);

          return d[l] = r, new e(d, h);
        }, e.prototype.addToIndexes = function (t, n) {
          var r = this;
          return new e(u.map(this.indexes_, function (e, i) {
            var o = u.safeGet(r.indexSet_, i);

            if (u.assert(o, "Missing index implementation for " + i), e === Ae) {
              if (o.isDefinedOn(t.node)) {
                for (var a = [], s = n.getIterator(ye.Wrap), c = s.getNext(); c;) {
                  c.name !== t.name && a.push(c), c = s.getNext();
                }

                return a.push(t), Fe(a, o.getCompare());
              }

              return Ae;
            }

            var l = n.get(t.name),
                h = e;
            return l && (h = h.remove(new ye(t.name, l))), h.insert(t, t.node);
          }), this.indexSet_);
        }, e.prototype.removeFromIndexes = function (t, n) {
          return new e(u.map(this.indexes_, function (e) {
            if (e === Ae) return e;
            var r = n.get(t.name);
            return r ? e.remove(new ye(t.name, r)) : e;
          }), this.indexSet_);
        }, e;
      }();
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      function Ue(e, t) {
        return R(e.name, t.name);
      }

      function Pe(e, t) {
        return R(e, t);
      }
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      var Ve = function () {
        function e(e, t, n) {
          this.children_ = e, this.priorityNode_ = t, this.indexMap_ = n, this.lazyHash_ = null, this.priorityNode_ && ke(this.priorityNode_), this.children_.isEmpty() && u.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), "An empty node cannot have a priority");
        }

        return Object.defineProperty(e, "EMPTY_NODE", {
          get: function get() {
            return Ne || (Ne = new e(new Ye(Pe), null, je.Default));
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.isLeafNode = function () {
          return !1;
        }, e.prototype.getPriority = function () {
          return this.priorityNode_ || Ne;
        }, e.prototype.updatePriority = function (t) {
          return this.children_.isEmpty() ? this : new e(this.children_, t, this.indexMap_);
        }, e.prototype.getImmediateChild = function (e) {
          if (".priority" === e) return this.getPriority();
          var t = this.children_.get(e);
          return null === t ? Ne : t;
        }, e.prototype.getChild = function (e) {
          var t = e.getFront();
          return null === t ? this : this.getImmediateChild(t).getChild(e.popFront());
        }, e.prototype.hasChild = function (e) {
          return null !== this.children_.get(e);
        }, e.prototype.updateImmediateChild = function (t, n) {
          if (u.assert(n, "We should always be passing snapshot nodes"), ".priority" === t) return this.updatePriority(n);
          var r = new ye(t, n),
              i = void 0,
              o = void 0;
          n.isEmpty() ? (i = this.children_.remove(t), o = this.indexMap_.removeFromIndexes(r, this.children_)) : (i = this.children_.insert(t, n), o = this.indexMap_.addToIndexes(r, this.children_));
          var a = i.isEmpty() ? Ne : this.priorityNode_;
          return new e(i, a, o);
        }, e.prototype.updateChild = function (e, t) {
          var n = e.getFront();
          if (null === n) return t;
          u.assert(".priority" !== e.getFront() || 1 === e.getLength(), ".priority must be the last token in a path");
          var r = this.getImmediateChild(n).updateChild(e.popFront(), t);
          return this.updateImmediateChild(n, r);
        }, e.prototype.isEmpty = function () {
          return this.children_.isEmpty();
        }, e.prototype.numChildren = function () {
          return this.children_.count();
        }, e.prototype.val = function (t) {
          if (this.isEmpty()) return null;
          var n = {},
              r = 0,
              i = 0,
              o = !0;

          if (this.forEachChild(De, function (a, s) {
            n[a] = s.val(t), r++, o && e.INTEGER_REGEXP_.test(a) ? i = Math.max(i, Number(a)) : o = !1;
          }), !t && o && i < 2 * r) {
            var a = [];

            for (var s in n) {
              a[s] = n[s];
            }

            return a;
          }

          return t && !this.getPriority().isEmpty() && (n[".priority"] = this.getPriority().val()), n;
        }, e.prototype.hash = function () {
          if (null === this.lazyHash_) {
            var e = "";
            this.getPriority().isEmpty() || (e += "priority:" + Ee(this.getPriority().val()) + ":"), this.forEachChild(De, function (t, n) {
              var r = n.hash();
              "" !== r && (e += ":" + t + ":" + r);
            }), this.lazyHash_ = "" === e ? "" : v(e);
          }

          return this.lazyHash_;
        }, e.prototype.getPredecessorChildName = function (e, t, n) {
          var r = this.resolveIndex_(n);

          if (r) {
            var i = r.getPredecessorKey(new ye(e, t));
            return i ? i.name : null;
          }

          return this.children_.getPredecessorKey(e);
        }, e.prototype.getFirstChildName = function (e) {
          var t = this.resolveIndex_(e);

          if (t) {
            var n = t.minKey();
            return n && n.name;
          }

          return this.children_.minKey();
        }, e.prototype.getFirstChild = function (e) {
          var t = this.getFirstChildName(e);
          return t ? new ye(t, this.children_.get(t)) : null;
        }, e.prototype.getLastChildName = function (e) {
          var t = this.resolveIndex_(e);

          if (t) {
            var n = t.maxKey();
            return n && n.name;
          }

          return this.children_.maxKey();
        }, e.prototype.getLastChild = function (e) {
          var t = this.getLastChildName(e);
          return t ? new ye(t, this.children_.get(t)) : null;
        }, e.prototype.forEachChild = function (e, t) {
          var n = this.resolveIndex_(e);
          return n ? n.inorderTraversal(function (e) {
            return t(e.name, e.node);
          }) : this.children_.inorderTraversal(t);
        }, e.prototype.getIterator = function (e) {
          return this.getIteratorFrom(e.minPost(), e);
        }, e.prototype.getIteratorFrom = function (e, t) {
          var n = this.resolveIndex_(t);
          if (n) return n.getIteratorFrom(e, function (e) {
            return e;
          });

          for (var r = this.children_.getIteratorFrom(e.name, ye.Wrap), i = r.peek(); null != i && t.compare(i, e) < 0;) {
            r.getNext(), i = r.peek();
          }

          return r;
        }, e.prototype.getReverseIterator = function (e) {
          return this.getReverseIteratorFrom(e.maxPost(), e);
        }, e.prototype.getReverseIteratorFrom = function (e, t) {
          var n = this.resolveIndex_(t);
          if (n) return n.getReverseIteratorFrom(e, function (e) {
            return e;
          });

          for (var r = this.children_.getReverseIteratorFrom(e.name, ye.Wrap), i = r.peek(); null != i && t.compare(i, e) > 0;) {
            r.getNext(), i = r.peek();
          }

          return r;
        }, e.prototype.compareTo = function (e) {
          return this.isEmpty() ? e.isEmpty() ? 0 : -1 : e.isLeafNode() || e.isEmpty() ? 1 : e === We ? -1 : 0;
        }, e.prototype.withIndex = function (t) {
          if (t === be || this.indexMap_.hasIndex(t)) return this;
          var n = this.indexMap_.addIndex(t, this.children_);
          return new e(this.children_, this.priorityNode_, n);
        }, e.prototype.isIndexed = function (e) {
          return e === be || this.indexMap_.hasIndex(e);
        }, e.prototype.equals = function (e) {
          if (e === this) return !0;
          if (e.isLeafNode()) return !1;
          var t = e;

          if (this.getPriority().equals(t.getPriority())) {
            if (this.children_.count() === t.children_.count()) {
              for (var n = this.getIterator(De), r = t.getIterator(De), i = n.getNext(), o = r.getNext(); i && o;) {
                if (i.name !== o.name || !i.node.equals(o.node)) return !1;
                i = n.getNext(), o = r.getNext();
              }

              return null === i && null === o;
            }

            return !1;
          }

          return !1;
        }, e.prototype.resolveIndex_ = function (e) {
          return e === be ? null : this.indexMap_.get(e.toString());
        }, e.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/, e;
      }(),
          We = new (function (e) {
        function t() {
          return e.call(this, new Ye(Pe), Ve.EMPTY_NODE, je.Default) || this;
        }

        return s.__extends(t, e), t.prototype.compareTo = function (e) {
          return e === this ? 0 : 1;
        }, t.prototype.equals = function (e) {
          return e === this;
        }, t.prototype.getPriority = function () {
          return this;
        }, t.prototype.getImmediateChild = function (e) {
          return Ve.EMPTY_NODE;
        }, t.prototype.isEmpty = function () {
          return !1;
        }, t;
      }(Ve))();

      Object.defineProperties(ye, {
        MIN: {
          value: new ye(D, Ve.EMPTY_NODE)
        },
        MAX: {
          value: new ye(I, We)
        }
      }), ge.__EMPTY_NODE = Ve.EMPTY_NODE, Le.__childrenNodeConstructor = Ve, X = We, function (e) {
        Me = e;
      }(We);
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */

      var He = !0;

      function Be(e, t) {
        if (void 0 === t && (t = null), null === e) return Ve.EMPTY_NODE;
        if ("object" == typeof e && ".priority" in e && (t = e[".priority"]), u.assert(null === t || "string" == typeof t || "number" == typeof t || "object" == typeof t && ".sv" in t, "Invalid priority type found: " + typeof t), "object" == typeof e && ".value" in e && null !== e[".value"] && (e = e[".value"]), "object" != typeof e || ".sv" in e) return new Le(e, Be(t));

        if (e instanceof Array || !He) {
          var n = Ve.EMPTY_NODE;
          return F(e, function (t, r) {
            if (u.contains(e, t) && "." !== t.substring(0, 1)) {
              var i = Be(r);
              !i.isLeafNode() && i.isEmpty() || (n = n.updateImmediateChild(t, i));
            }
          }), n.updatePriority(Be(t));
        }

        var r = [],
            i = !1;
        if (F(e, function (e, t) {
          if ("." !== e.substring(0, 1)) {
            var n = Be(t);
            n.isEmpty() || (i = i || !n.getPriority().isEmpty(), r.push(new ye(e, n)));
          }
        }), 0 === r.length) return Ve.EMPTY_NODE;
        var o = Fe(r, Ue, function (e) {
          return e.name;
        }, Pe);

        if (i) {
          var a = Fe(r, De.getCompare());
          return new Ve(o, Be(t), new je({
            ".priority": a
          }, {
            ".priority": De
          }));
        }

        return new Ve(o, Be(t), je.Default);
      }

      !function (e) {
        Te = e;
      }(Be);
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */

      var ze,
          Ze = new (function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }

        return s.__extends(t, e), t.prototype.compare = function (e, t) {
          var n = e.node.compareTo(t.node);
          return 0 === n ? R(e.name, t.name) : n;
        }, t.prototype.isDefinedOn = function (e) {
          return !0;
        }, t.prototype.indexedValueChanged = function (e, t) {
          return !e.equals(t);
        }, t.prototype.minPost = function () {
          return ye.MIN;
        }, t.prototype.maxPost = function () {
          return ye.MAX;
        }, t.prototype.makePost = function (e, t) {
          var n = Be(e);
          return new ye(t, n);
        }, t.prototype.toString = function () {
          return ".value";
        }, t;
      }(ve))(),
          Qe = function (e) {
        function t(t) {
          var n = e.call(this) || this;
          return n.indexPath_ = t, u.assert(!t.isEmpty() && ".priority" !== t.getFront(), "Can't create PathIndex with empty path or .priority key"), n;
        }

        return s.__extends(t, e), t.prototype.extractChild = function (e) {
          return e.getChild(this.indexPath_);
        }, t.prototype.isDefinedOn = function (e) {
          return !e.getChild(this.indexPath_).isEmpty();
        }, t.prototype.compare = function (e, t) {
          var n = this.extractChild(e.node),
              r = this.extractChild(t.node),
              i = n.compareTo(r);
          return 0 === i ? R(e.name, t.name) : i;
        }, t.prototype.makePost = function (e, t) {
          var n = Be(e),
              r = Ve.EMPTY_NODE.updateChild(this.indexPath_, n);
          return new ye(t, r);
        }, t.prototype.maxPost = function () {
          var e = Ve.EMPTY_NODE.updateChild(this.indexPath_, We);
          return new ye(I, e);
        }, t.prototype.toString = function () {
          return this.indexPath_.slice().join("/");
        }, t;
      }(ve),
          Ge = function () {
        function e(e, t, n) {
          this.node_ = e, this.ref_ = t, this.index_ = n;
        }

        return e.prototype.val = function () {
          return u.validateArgCount("DataSnapshot.val", 0, 0, arguments.length), this.node_.val();
        }, e.prototype.exportVal = function () {
          return u.validateArgCount("DataSnapshot.exportVal", 0, 0, arguments.length), this.node_.val(!0);
        }, e.prototype.toJSON = function () {
          return u.validateArgCount("DataSnapshot.toJSON", 0, 1, arguments.length), this.exportVal();
        }, e.prototype.exists = function () {
          return u.validateArgCount("DataSnapshot.exists", 0, 0, arguments.length), !this.node_.isEmpty();
        }, e.prototype.child = function (t) {
          u.validateArgCount("DataSnapshot.child", 0, 1, arguments.length), t = String(t), he("DataSnapshot.child", 1, t, !1);
          var n = new H(t),
              r = this.ref_.child(n);
          return new e(this.node_.getChild(n), r, De);
        }, e.prototype.hasChild = function (e) {
          u.validateArgCount("DataSnapshot.hasChild", 1, 1, arguments.length), he("DataSnapshot.hasChild", 1, e, !1);
          var t = new H(e);
          return !this.node_.getChild(t).isEmpty();
        }, e.prototype.getPriority = function () {
          return u.validateArgCount("DataSnapshot.getPriority", 0, 0, arguments.length), this.node_.getPriority().val();
        }, e.prototype.forEach = function (t) {
          var n = this;
          return u.validateArgCount("DataSnapshot.forEach", 1, 1, arguments.length), u.validateCallback("DataSnapshot.forEach", 1, t, !1), !this.node_.isLeafNode() && !!this.node_.forEachChild(this.index_, function (r, i) {
            return t(new e(i, n.ref_.child(r), De));
          });
        }, e.prototype.hasChildren = function () {
          return u.validateArgCount("DataSnapshot.hasChildren", 0, 0, arguments.length), !this.node_.isLeafNode() && !this.node_.isEmpty();
        }, Object.defineProperty(e.prototype, "key", {
          get: function get() {
            return this.ref_.getKey();
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.numChildren = function () {
          return u.validateArgCount("DataSnapshot.numChildren", 0, 0, arguments.length), this.node_.numChildren();
        }, e.prototype.getRef = function () {
          return u.validateArgCount("DataSnapshot.ref", 0, 0, arguments.length), this.ref_;
        }, Object.defineProperty(e.prototype, "ref", {
          get: function get() {
            return this.getRef();
          },
          enumerable: !0,
          configurable: !0
        }), e;
      }(),
          qe = function () {
        function e(e, t, n, r) {
          this.eventType = e, this.eventRegistration = t, this.snapshot = n, this.prevName = r;
        }

        return e.prototype.getPath = function () {
          var e = this.snapshot.getRef();
          return "value" === this.eventType ? e.path : e.getParent().path;
        }, e.prototype.getEventType = function () {
          return this.eventType;
        }, e.prototype.getEventRunner = function () {
          return this.eventRegistration.getEventRunner(this);
        }, e.prototype.toString = function () {
          return this.getPath().toString() + ":" + this.eventType + ":" + u.stringify(this.snapshot.exportVal());
        }, e;
      }(),
          Je = function () {
        function e(e, t, n) {
          this.eventRegistration = e, this.error = t, this.path = n;
        }

        return e.prototype.getPath = function () {
          return this.path;
        }, e.prototype.getEventType = function () {
          return "cancel";
        }, e.prototype.getEventRunner = function () {
          return this.eventRegistration.getEventRunner(this);
        }, e.prototype.toString = function () {
          return this.path.toString() + ":cancel";
        }, e;
      }(),
          Xe = function () {
        function e(e, t, n) {
          this.callback_ = e, this.cancelCallback_ = t, this.context_ = n;
        }

        return e.prototype.respondsTo = function (e) {
          return "value" === e;
        }, e.prototype.createEvent = function (e, t) {
          var n = t.getQueryParams().getIndex();
          return new qe("value", this, new Ge(e.snapshotNode, t.getRef(), n));
        }, e.prototype.getEventRunner = function (e) {
          var t = this.context_;

          if ("cancel" === e.getEventType()) {
            u.assert(this.cancelCallback_, "Raising a cancel event on a listener with no cancel callback");
            var n = this.cancelCallback_;
            return function () {
              n.call(t, e.error);
            };
          }

          var r = this.callback_;
          return function () {
            r.call(t, e.snapshot);
          };
        }, e.prototype.createCancelEvent = function (e, t) {
          return this.cancelCallback_ ? new Je(this, e, t) : null;
        }, e.prototype.matches = function (t) {
          return t instanceof e && (!t.callback_ || !this.callback_ || t.callback_ === this.callback_ && t.context_ === this.context_);
        }, e.prototype.hasAnyCallback = function () {
          return null !== this.callback_;
        }, e;
      }(),
          Ke = function () {
        function e(e, t, n) {
          this.callbacks_ = e, this.cancelCallback_ = t, this.context_ = n;
        }

        return e.prototype.respondsTo = function (e) {
          var t = "children_added" === e ? "child_added" : e;
          return t = "children_removed" === t ? "child_removed" : t, u.contains(this.callbacks_, t);
        }, e.prototype.createCancelEvent = function (e, t) {
          return this.cancelCallback_ ? new Je(this, e, t) : null;
        }, e.prototype.createEvent = function (e, t) {
          u.assert(null != e.childName, "Child events should have a childName.");
          var n = t.getRef().child(e.childName),
              r = t.getQueryParams().getIndex();
          return new qe(e.type, this, new Ge(e.snapshotNode, n, r), e.prevName);
        }, e.prototype.getEventRunner = function (e) {
          var t = this.context_;

          if ("cancel" === e.getEventType()) {
            u.assert(this.cancelCallback_, "Raising a cancel event on a listener with no cancel callback");
            var n = this.cancelCallback_;
            return function () {
              n.call(t, e.error);
            };
          }

          var r = this.callbacks_[e.eventType];
          return function () {
            r.call(t, e.snapshot, e.prevName);
          };
        }, e.prototype.matches = function (t) {
          var n = this;

          if (t instanceof e) {
            if (!this.callbacks_ || !t.callbacks_) return !0;

            if (this.context_ === t.context_) {
              var r = Object.keys(t.callbacks_),
                  i = Object.keys(this.callbacks_),
                  o = r.length;

              if (o === i.length) {
                if (1 === o) {
                  var a = r[0],
                      s = i[0];
                  return !(s !== a || t.callbacks_[a] && this.callbacks_[s] && t.callbacks_[a] !== this.callbacks_[s]);
                }

                return i.every(function (e) {
                  return t.callbacks_[e] === n.callbacks_[e];
                });
              }
            }
          }

          return !1;
        }, e.prototype.hasAnyCallback = function () {
          return null !== this.callbacks_;
        }, e;
      }(),
          $e = function () {
        function e(e, t, n, r) {
          this.repo = e, this.path = t, this.queryParams_ = n, this.orderByCalled_ = r;
        }

        return Object.defineProperty(e, "__referenceConstructor", {
          get: function get() {
            return u.assert(ze, "Reference.ts has not been loaded"), ze;
          },
          set: function set(e) {
            ze = e;
          },
          enumerable: !0,
          configurable: !0
        }), e.validateQueryEndpoints_ = function (e) {
          var t = null,
              n = null;

          if (e.hasStart() && (t = e.getIndexStartValue()), e.hasEnd() && (n = e.getIndexEndValue()), e.getIndex() === be) {
            var r = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().",
                i = "Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.";

            if (e.hasStart()) {
              if (e.getIndexStartName() !== D) throw new Error(r);
              if ("string" != typeof t) throw new Error(i);
            }

            if (e.hasEnd()) {
              if (e.getIndexEndName() !== I) throw new Error(r);
              if ("string" != typeof n) throw new Error(i);
            }
          } else if (e.getIndex() === De) {
            if (null != t && !ie(t) || null != n && !ie(n)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");
          } else if (u.assert(e.getIndex() instanceof Qe || e.getIndex() === Ze, "unknown index type."), null != t && "object" == typeof t || null != n && "object" == typeof n) throw new Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
        }, e.validateLimit_ = function (e) {
          if (e.hasStart() && e.hasEnd() && e.hasLimit() && !e.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
        }, e.prototype.validateNoPreviousOrderByCall_ = function (e) {
          if (!0 === this.orderByCalled_) throw new Error(e + ": You can't combine multiple orderBy calls.");
        }, e.prototype.getQueryParams = function () {
          return this.queryParams_;
        }, e.prototype.getRef = function () {
          return u.validateArgCount("Query.ref", 0, 0, arguments.length), new e.__referenceConstructor(this.repo, this.path);
        }, e.prototype.on = function (t, n, r, i) {
          u.validateArgCount("Query.on", 2, 4, arguments.length), ce("Query.on", 1, t, !1), u.validateCallback("Query.on", 2, n, !1);
          var o = e.getCancelAndContextArgs_("Query.on", r, i);
          if ("value" === t) this.onValueEvent(n, o.cancel, o.context);else {
            var a = {};
            a[t] = n, this.onChildEvent(a, o.cancel, o.context);
          }
          return n;
        }, e.prototype.onValueEvent = function (e, t, n) {
          var r = new Xe(e, t || null, n || null);
          this.repo.addEventCallbackForQuery(this, r);
        }, e.prototype.onChildEvent = function (e, t, n) {
          var r = new Ke(e, t, n);
          this.repo.addEventCallbackForQuery(this, r);
        }, e.prototype.off = function (e, t, n) {
          u.validateArgCount("Query.off", 0, 3, arguments.length), ce("Query.off", 1, e, !0), u.validateCallback("Query.off", 2, t, !0), u.validateContextObject("Query.off", 3, n, !0);
          var r = null,
              i = null;
          "value" === e ? r = new Xe(t || null, null, n || null) : e && (t && ((i = {})[e] = t), r = new Ke(i, null, n || null));
          this.repo.removeEventCallbackForQuery(this, r);
        }, e.prototype.once = function (t, n, r, i) {
          var o = this;
          u.validateArgCount("Query.once", 1, 4, arguments.length), ce("Query.once", 1, t, !1), u.validateCallback("Query.once", 2, n, !0);
          var a = e.getCancelAndContextArgs_("Query.once", r, i),
              s = !0,
              c = new u.Deferred();
          c.promise.catch(function () {});

          var l = function l(e) {
            s && (s = !1, o.off(t, l), n && n.bind(a.context)(e), c.resolve(e));
          };

          return this.on(t, l, function (e) {
            o.off(t, l), a.cancel && a.cancel.bind(a.context)(e), c.reject(e);
          }), c.promise;
        }, e.prototype.limitToFirst = function (t) {
          if (u.validateArgCount("Query.limitToFirst", 1, 1, arguments.length), "number" != typeof t || Math.floor(t) !== t || t <= 0) throw new Error("Query.limitToFirst: First argument must be a positive integer.");
          if (this.queryParams_.hasLimit()) throw new Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");
          return new e(this.repo, this.path, this.queryParams_.limitToFirst(t), this.orderByCalled_);
        }, e.prototype.limitToLast = function (t) {
          if (u.validateArgCount("Query.limitToLast", 1, 1, arguments.length), "number" != typeof t || Math.floor(t) !== t || t <= 0) throw new Error("Query.limitToLast: First argument must be a positive integer.");
          if (this.queryParams_.hasLimit()) throw new Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");
          return new e(this.repo, this.path, this.queryParams_.limitToLast(t), this.orderByCalled_);
        }, e.prototype.orderByChild = function (t) {
          if (u.validateArgCount("Query.orderByChild", 1, 1, arguments.length), "$key" === t) throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
          if ("$priority" === t) throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
          if ("$value" === t) throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
          he("Query.orderByChild", 1, t, !1), this.validateNoPreviousOrderByCall_("Query.orderByChild");
          var n = new H(t);
          if (n.isEmpty()) throw new Error("Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.");
          var r = new Qe(n),
              i = this.queryParams_.orderBy(r);
          return e.validateQueryEndpoints_(i), new e(this.repo, this.path, i, !0);
        }, e.prototype.orderByKey = function () {
          u.validateArgCount("Query.orderByKey", 0, 0, arguments.length), this.validateNoPreviousOrderByCall_("Query.orderByKey");
          var t = this.queryParams_.orderBy(be);
          return e.validateQueryEndpoints_(t), new e(this.repo, this.path, t, !0);
        }, e.prototype.orderByPriority = function () {
          u.validateArgCount("Query.orderByPriority", 0, 0, arguments.length), this.validateNoPreviousOrderByCall_("Query.orderByPriority");
          var t = this.queryParams_.orderBy(De);
          return e.validateQueryEndpoints_(t), new e(this.repo, this.path, t, !0);
        }, e.prototype.orderByValue = function () {
          u.validateArgCount("Query.orderByValue", 0, 0, arguments.length), this.validateNoPreviousOrderByCall_("Query.orderByValue");
          var t = this.queryParams_.orderBy(Ze);
          return e.validateQueryEndpoints_(t), new e(this.repo, this.path, t, !0);
        }, e.prototype.startAt = function (t, n) {
          void 0 === t && (t = null), u.validateArgCount("Query.startAt", 0, 2, arguments.length), oe("Query.startAt", 1, t, this.path, !0), le("Query.startAt", 2, n, !0);
          var r = this.queryParams_.startAt(t, n);
          if (e.validateLimit_(r), e.validateQueryEndpoints_(r), this.queryParams_.hasStart()) throw new Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");
          return void 0 === t && (t = null, n = null), new e(this.repo, this.path, r, this.orderByCalled_);
        }, e.prototype.endAt = function (t, n) {
          void 0 === t && (t = null), u.validateArgCount("Query.endAt", 0, 2, arguments.length), oe("Query.endAt", 1, t, this.path, !0), le("Query.endAt", 2, n, !0);
          var r = this.queryParams_.endAt(t, n);
          if (e.validateLimit_(r), e.validateQueryEndpoints_(r), this.queryParams_.hasEnd()) throw new Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");
          return new e(this.repo, this.path, r, this.orderByCalled_);
        }, e.prototype.equalTo = function (e, t) {
          if (u.validateArgCount("Query.equalTo", 1, 2, arguments.length), oe("Query.equalTo", 1, e, this.path, !1), le("Query.equalTo", 2, t, !0), this.queryParams_.hasStart()) throw new Error("Query.equalTo: Starting point was already set (by another call to startAt or equalTo).");
          if (this.queryParams_.hasEnd()) throw new Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");
          return this.startAt(e, t).endAt(e, t);
        }, e.prototype.toString = function () {
          return u.validateArgCount("Query.toString", 0, 0, arguments.length), this.repo.toString() + this.path.toUrlEncodedString();
        }, e.prototype.toJSON = function () {
          return u.validateArgCount("Query.toJSON", 0, 1, arguments.length), this.toString();
        }, e.prototype.queryObject = function () {
          return this.queryParams_.getQueryObject();
        }, e.prototype.queryIdentifier = function () {
          var e = this.queryObject(),
              t = C(e);
          return "{}" === t ? "default" : t;
        }, e.prototype.isEqual = function (t) {
          if (u.validateArgCount("Query.isEqual", 1, 1, arguments.length), !(t instanceof e)) {
            throw new Error("Query.isEqual failed: First argument must be an instance of firebase.database.Query.");
          }

          var n = this.repo === t.repo,
              r = this.path.equals(t.path),
              i = this.queryIdentifier() === t.queryIdentifier();
          return n && r && i;
        }, e.getCancelAndContextArgs_ = function (e, t, n) {
          var r = {
            cancel: null,
            context: null
          };
          if (t && n) r.cancel = t, u.validateCallback(e, 3, r.cancel, !0), r.context = n, u.validateContextObject(e, 4, r.context, !0);else if (t) if ("object" == typeof t && null !== t) r.context = t;else {
            if ("function" != typeof t) throw new Error(u.errorPrefix(e, 3, !0) + " must either be a cancel callback or a context object.");
            r.cancel = t;
          }
          return r;
        }, Object.defineProperty(e.prototype, "ref", {
          get: function get() {
            return this.getRef();
          },
          enumerable: !0,
          configurable: !0
        }), e;
      }(),
          et = function () {
        function e(e) {
          this.node_ = e;
        }

        return e.prototype.getImmediateChild = function (t) {
          return new e(this.node_.getImmediateChild(t));
        }, e.prototype.node = function () {
          return this.node_;
        }, e;
      }(),
          tt = function () {
        function e(e, t) {
          this.syncTree_ = e, this.path_ = t;
        }

        return e.prototype.getImmediateChild = function (t) {
          var n = this.path_.child(t);
          return new e(this.syncTree_, n);
        }, e.prototype.node = function () {
          return this.syncTree_.calcCompleteEventCache(this.path_);
        }, e;
      }(),
          nt = function nt(e, t, n) {
        return e && "object" == typeof e ? (u.assert(".sv" in e, "Unexpected leaf node or priority contents"), "string" == typeof e[".sv"] ? rt(e[".sv"], t, n) : "object" == typeof e[".sv"] ? it(e[".sv"], t) : void u.assert(!1, "Unexpected server value: " + JSON.stringify(e, null, 2))) : e;
      },
          rt = function rt(e, t, n) {
        switch (e) {
          case "timestamp":
            return n.timestamp;

          default:
            u.assert(!1, "Unexpected server value: " + e);
        }
      },
          it = function it(e, t, n) {
        e.hasOwnProperty("increment") || u.assert(!1, "Unexpected server value: " + JSON.stringify(e, null, 2));
        var r = e.increment;
        "number" != typeof r && u.assert(!1, "Unexpected increment value: " + r);
        var i = t.node();
        if (u.assert(null != i, "Expected ChildrenNode.EMPTY_NODE for nulls"), !i.isLeafNode()) return r;
        var o = i.getValue();
        return "number" != typeof o ? r : o + r;
      },
          ot = function ot(e, t, n, r) {
        return st(t, new tt(n, e), r);
      },
          at = function at(e, t, n) {
        return st(e, new et(t), n);
      };

      function st(e, t, n) {
        var r,
            i = e.getPriority().val(),
            o = nt(i, t.getImmediateChild(".priority"), n);

        if (e.isLeafNode()) {
          var a = e,
              s = nt(a.getValue(), t, n);
          return s !== a.getValue() || o !== a.getPriority().val() ? new Le(s, Be(o)) : e;
        }

        var u = e;
        return r = u, o !== u.getPriority().val() && (r = r.updatePriority(new Le(o))), u.forEachChild(De, function (e, i) {
          var o = st(i, t.getImmediateChild(e), n);
          o !== i && (r = r.updateImmediateChild(e, o));
        }), r;
      }
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      var ut,
          ct = function () {
        function e() {
          this.value = null, this.children = new Map();
        }

        return e.prototype.find = function (e) {
          if (null != this.value) return this.value.getChild(e);

          if (!e.isEmpty() && this.children.size > 0) {
            var t = e.getFront();
            return e = e.popFront(), this.children.has(t) ? this.children.get(t).find(e) : null;
          }

          return null;
        }, e.prototype.remember = function (t, n) {
          if (t.isEmpty()) this.value = n, this.children.clear();else if (null !== this.value) this.value = this.value.updateChild(t, n);else {
            var r = t.getFront();
            this.children.has(r) || this.children.set(r, new e());
            var i = this.children.get(r);
            t = t.popFront(), i.remember(t, n);
          }
        }, e.prototype.forget = function (e) {
          if (e.isEmpty()) return this.value = null, this.children.clear(), !0;

          if (null !== this.value) {
            if (this.value.isLeafNode()) return !1;
            var t = this.value;
            this.value = null;
            var n = this;
            return t.forEachChild(De, function (e, t) {
              n.remember(new H(e), t);
            }), this.forget(e);
          }

          if (this.children.size > 0) {
            var r = e.getFront();
            if (e = e.popFront(), this.children.has(r)) this.children.get(r).forget(e) && this.children.delete(r);
            return 0 === this.children.size;
          }

          return !0;
        }, e.prototype.forEachTree = function (e, t) {
          null !== this.value ? t(e, this.value) : this.forEachChild(function (n, r) {
            var i = new H(e.toString() + "/" + n);
            r.forEachTree(i, t);
          });
        }, e.prototype.forEachChild = function (e) {
          this.children.forEach(function (t, n) {
            e(n, t);
          });
        }, e;
      }();
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      !function (e) {
        e[e.OVERWRITE = 0] = "OVERWRITE", e[e.MERGE = 1] = "MERGE", e[e.ACK_USER_WRITE = 2] = "ACK_USER_WRITE", e[e.LISTEN_COMPLETE = 3] = "LISTEN_COMPLETE";
      }(ut || (ut = {}));

      var lt,
          ht,
          dt = function () {
        function e(e, t, n, r) {
          this.fromUser = e, this.fromServer = t, this.queryId = n, this.tagged = r, u.assert(!r || t, "Tagged queries must be from server.");
        }

        return e.User = new e(!0, !1, null, !1), e.Server = new e(!1, !0, null, !1), e.forServerTaggedQuery = function (t) {
          return new e(!1, !0, t, !0);
        }, e;
      }(),
          ft = function () {
        function e(e, t, n) {
          this.path = e, this.affectedTree = t, this.revert = n, this.type = ut.ACK_USER_WRITE, this.source = dt.User;
        }

        return e.prototype.operationForChild = function (t) {
          if (this.path.isEmpty()) {
            if (null != this.affectedTree.value) return u.assert(this.affectedTree.children.isEmpty(), "affectedTree should not have overlapping affected paths."), this;
            var n = this.affectedTree.subtree(new H(t));
            return new e(H.Empty, n, this.revert);
          }

          return u.assert(this.path.getFront() === t, "operationForChild called for unrelated child."), new e(this.path.popFront(), this.affectedTree, this.revert);
        }, e;
      }(),
          pt = function pt() {
        return lt || (lt = new Ye(x)), lt;
      },
          mt = function () {
        function e(e, t) {
          void 0 === t && (t = pt()), this.value = e, this.children = t;
        }

        return e.fromObject = function (t) {
          var n = e.Empty;
          return F(t, function (e, t) {
            n = n.set(new H(e), t);
          }), n;
        }, e.prototype.isEmpty = function () {
          return null === this.value && this.children.isEmpty();
        }, e.prototype.findRootMostMatchingPathAndValue = function (e, t) {
          if (null != this.value && t(this.value)) return {
            path: H.Empty,
            value: this.value
          };
          if (e.isEmpty()) return null;
          var n = e.getFront(),
              r = this.children.get(n);

          if (null !== r) {
            var i = r.findRootMostMatchingPathAndValue(e.popFront(), t);
            return null != i ? {
              path: new H(n).child(i.path),
              value: i.value
            } : null;
          }

          return null;
        }, e.prototype.findRootMostValueAndPath = function (e) {
          return this.findRootMostMatchingPathAndValue(e, function () {
            return !0;
          });
        }, e.prototype.subtree = function (t) {
          if (t.isEmpty()) return this;
          var n = t.getFront(),
              r = this.children.get(n);
          return null !== r ? r.subtree(t.popFront()) : e.Empty;
        }, e.prototype.set = function (t, n) {
          if (t.isEmpty()) return new e(n, this.children);
          var r = t.getFront(),
              i = (this.children.get(r) || e.Empty).set(t.popFront(), n),
              o = this.children.insert(r, i);
          return new e(this.value, o);
        }, e.prototype.remove = function (t) {
          if (t.isEmpty()) return this.children.isEmpty() ? e.Empty : new e(null, this.children);
          var n = t.getFront(),
              r = this.children.get(n);

          if (r) {
            var i = r.remove(t.popFront()),
                o = void 0;
            return o = i.isEmpty() ? this.children.remove(n) : this.children.insert(n, i), null === this.value && o.isEmpty() ? e.Empty : new e(this.value, o);
          }

          return this;
        }, e.prototype.get = function (e) {
          if (e.isEmpty()) return this.value;
          var t = e.getFront(),
              n = this.children.get(t);
          return n ? n.get(e.popFront()) : null;
        }, e.prototype.setTree = function (t, n) {
          if (t.isEmpty()) return n;
          var r = t.getFront(),
              i = (this.children.get(r) || e.Empty).setTree(t.popFront(), n),
              o = void 0;
          return o = i.isEmpty() ? this.children.remove(r) : this.children.insert(r, i), new e(this.value, o);
        }, e.prototype.fold = function (e) {
          return this.fold_(H.Empty, e);
        }, e.prototype.fold_ = function (e, t) {
          var n = {};
          return this.children.inorderTraversal(function (r, i) {
            n[r] = i.fold_(e.child(r), t);
          }), t(e, this.value, n);
        }, e.prototype.findOnPath = function (e, t) {
          return this.findOnPath_(e, H.Empty, t);
        }, e.prototype.findOnPath_ = function (e, t, n) {
          var r = !!this.value && n(t, this.value);
          if (r) return r;
          if (e.isEmpty()) return null;
          var i = e.getFront(),
              o = this.children.get(i);
          return o ? o.findOnPath_(e.popFront(), t.child(i), n) : null;
        }, e.prototype.foreachOnPath = function (e, t) {
          return this.foreachOnPath_(e, H.Empty, t);
        }, e.prototype.foreachOnPath_ = function (t, n, r) {
          if (t.isEmpty()) return this;
          this.value && r(n, this.value);
          var i = t.getFront(),
              o = this.children.get(i);
          return o ? o.foreachOnPath_(t.popFront(), n.child(i), r) : e.Empty;
        }, e.prototype.foreach = function (e) {
          this.foreach_(H.Empty, e);
        }, e.prototype.foreach_ = function (e, t) {
          this.children.inorderTraversal(function (n, r) {
            r.foreach_(e.child(n), t);
          }), this.value && t(e, this.value);
        }, e.prototype.foreachChild = function (e) {
          this.children.inorderTraversal(function (t, n) {
            n.value && e(t, n.value);
          });
        }, e.Empty = new e(null), e;
      }(),
          _t = function () {
        function e(e, t) {
          this.source = e, this.path = t, this.type = ut.LISTEN_COMPLETE;
        }

        return e.prototype.operationForChild = function (t) {
          return this.path.isEmpty() ? new e(this.source, H.Empty) : new e(this.source, this.path.popFront());
        }, e;
      }(),
          yt = function () {
        function e(e, t, n) {
          this.source = e, this.path = t, this.snap = n, this.type = ut.OVERWRITE;
        }

        return e.prototype.operationForChild = function (t) {
          return this.path.isEmpty() ? new e(this.source, H.Empty, this.snap.getImmediateChild(t)) : new e(this.source, this.path.popFront(), this.snap);
        }, e;
      }(),
          vt = function () {
        function e(e, t, n) {
          this.source = e, this.path = t, this.children = n, this.type = ut.MERGE;
        }

        return e.prototype.operationForChild = function (t) {
          if (this.path.isEmpty()) {
            var n = this.children.subtree(new H(t));
            return n.isEmpty() ? null : n.value ? new yt(this.source, H.Empty, n.value) : new e(this.source, H.Empty, n);
          }

          return u.assert(this.path.getFront() === t, "Can't get a merge for a child not on the path of the operation"), new e(this.source, this.path.popFront(), this.children);
        }, e.prototype.toString = function () {
          return "Operation(" + this.path + ": " + this.source.toString() + " merge: " + this.children.toString() + ")";
        }, e;
      }(),
          gt = function () {
        function e(e, t, n) {
          this.node_ = e, this.fullyInitialized_ = t, this.filtered_ = n;
        }

        return e.prototype.isFullyInitialized = function () {
          return this.fullyInitialized_;
        }, e.prototype.isFiltered = function () {
          return this.filtered_;
        }, e.prototype.isCompleteForPath = function (e) {
          if (e.isEmpty()) return this.isFullyInitialized() && !this.filtered_;
          var t = e.getFront();
          return this.isCompleteForChild(t);
        }, e.prototype.isCompleteForChild = function (e) {
          return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(e);
        }, e.prototype.getNode = function () {
          return this.node_;
        }, e;
      }(),
          bt = function () {
        function e(e, t) {
          this.eventCache_ = e, this.serverCache_ = t;
        }

        return e.prototype.updateEventSnap = function (t, n, r) {
          return new e(new gt(t, n, r), this.serverCache_);
        }, e.prototype.updateServerSnap = function (t, n, r) {
          return new e(this.eventCache_, new gt(t, n, r));
        }, e.prototype.getEventCache = function () {
          return this.eventCache_;
        }, e.prototype.getCompleteEventSnap = function () {
          return this.eventCache_.isFullyInitialized() ? this.eventCache_.getNode() : null;
        }, e.prototype.getServerCache = function () {
          return this.serverCache_;
        }, e.prototype.getCompleteServerSnap = function () {
          return this.serverCache_.isFullyInitialized() ? this.serverCache_.getNode() : null;
        }, e.Empty = new e(new gt(Ve.EMPTY_NODE, !1, !1), new gt(Ve.EMPTY_NODE, !1, !1)), e;
      }(),
          wt = function () {
        function e(e, t, n, r, i) {
          this.type = e, this.snapshotNode = t, this.childName = n, this.oldSnap = r, this.prevName = i;
        }

        return e.valueChange = function (t) {
          return new e(e.VALUE, t);
        }, e.childAddedChange = function (t, n) {
          return new e(e.CHILD_ADDED, n, t);
        }, e.childRemovedChange = function (t, n) {
          return new e(e.CHILD_REMOVED, n, t);
        }, e.childChangedChange = function (t, n, r) {
          return new e(e.CHILD_CHANGED, n, t, r);
        }, e.childMovedChange = function (t, n) {
          return new e(e.CHILD_MOVED, n, t);
        }, e.CHILD_ADDED = "child_added", e.CHILD_REMOVED = "child_removed", e.CHILD_CHANGED = "child_changed", e.CHILD_MOVED = "child_moved", e.VALUE = "value", e;
      }(),
          Tt = function () {
        function e(e) {
          this.index_ = e;
        }

        return e.prototype.updateChild = function (e, t, n, r, i, o) {
          u.assert(e.isIndexed(this.index_), "A node must be indexed if only a child is updated");
          var a = e.getImmediateChild(t);
          return a.getChild(r).equals(n.getChild(r)) && a.isEmpty() === n.isEmpty() ? e : (null != o && (n.isEmpty() ? e.hasChild(t) ? o.trackChildChange(wt.childRemovedChange(t, a)) : u.assert(e.isLeafNode(), "A child remove without an old child only makes sense on a leaf node") : a.isEmpty() ? o.trackChildChange(wt.childAddedChange(t, n)) : o.trackChildChange(wt.childChangedChange(t, n, a))), e.isLeafNode() && n.isEmpty() ? e : e.updateImmediateChild(t, n).withIndex(this.index_));
        }, e.prototype.updateFullNode = function (e, t, n) {
          return null != n && (e.isLeafNode() || e.forEachChild(De, function (e, r) {
            t.hasChild(e) || n.trackChildChange(wt.childRemovedChange(e, r));
          }), t.isLeafNode() || t.forEachChild(De, function (t, r) {
            if (e.hasChild(t)) {
              var i = e.getImmediateChild(t);
              i.equals(r) || n.trackChildChange(wt.childChangedChange(t, r, i));
            } else n.trackChildChange(wt.childAddedChange(t, r));
          })), t.withIndex(this.index_);
        }, e.prototype.updatePriority = function (e, t) {
          return e.isEmpty() ? Ve.EMPTY_NODE : e.updatePriority(t);
        }, e.prototype.filtersNodes = function () {
          return !1;
        }, e.prototype.getIndexedFilter = function () {
          return this;
        }, e.prototype.getIndex = function () {
          return this.index_;
        }, e;
      }(),
          Mt = function () {
        function e() {
          this.changeMap = new Map();
        }

        return e.prototype.trackChildChange = function (e) {
          var t = e.type,
              n = e.childName;
          u.assert(t === wt.CHILD_ADDED || t === wt.CHILD_CHANGED || t === wt.CHILD_REMOVED, "Only child changes supported for tracking"), u.assert(".priority" !== n, "Only non-priority child changes can be tracked.");
          var r = this.changeMap.get(n);

          if (r) {
            var i = r.type;
            if (t === wt.CHILD_ADDED && i === wt.CHILD_REMOVED) this.changeMap.set(n, wt.childChangedChange(n, e.snapshotNode, r.snapshotNode));else if (t === wt.CHILD_REMOVED && i === wt.CHILD_ADDED) this.changeMap.delete(n);else if (t === wt.CHILD_REMOVED && i === wt.CHILD_CHANGED) this.changeMap.set(n, wt.childRemovedChange(n, r.oldSnap));else if (t === wt.CHILD_CHANGED && i === wt.CHILD_ADDED) this.changeMap.set(n, wt.childAddedChange(n, e.snapshotNode));else {
              if (t !== wt.CHILD_CHANGED || i !== wt.CHILD_CHANGED) throw u.assertionError("Illegal combination of changes: " + e + " occurred after " + r);
              this.changeMap.set(n, wt.childChangedChange(n, e.snapshotNode, r.oldSnap));
            }
          } else this.changeMap.set(n, e);
        }, e.prototype.getChanges = function () {
          return Array.from(this.changeMap.values());
        }, e;
      }(),
          Et = new (function () {
        function e() {}

        return e.prototype.getCompleteChild = function (e) {
          return null;
        }, e.prototype.getChildAfterChild = function (e, t, n) {
          return null;
        }, e;
      }())(),
          kt = function () {
        function e(e, t, n) {
          void 0 === n && (n = null), this.writes_ = e, this.viewCache_ = t, this.optCompleteServerCache_ = n;
        }

        return e.prototype.getCompleteChild = function (e) {
          var t = this.viewCache_.getEventCache();
          if (t.isCompleteForChild(e)) return t.getNode().getImmediateChild(e);
          var n = null != this.optCompleteServerCache_ ? new gt(this.optCompleteServerCache_, !0, !1) : this.viewCache_.getServerCache();
          return this.writes_.calcCompleteChild(e, n);
        }, e.prototype.getChildAfterChild = function (e, t, n) {
          var r = null != this.optCompleteServerCache_ ? this.optCompleteServerCache_ : this.viewCache_.getCompleteServerSnap(),
              i = this.writes_.calcIndexedSlice(r, t, 1, n, e);
          return 0 === i.length ? null : i[0];
        }, e;
      }(),
          Lt = function () {
        return function (e, t) {
          this.viewCache = e, this.changes = t;
        };
      }(),
          St = function () {
        function e(e) {
          this.filter_ = e;
        }

        return e.prototype.assertIndexed = function (e) {
          u.assert(e.getEventCache().getNode().isIndexed(this.filter_.getIndex()), "Event snap not indexed"), u.assert(e.getServerCache().getNode().isIndexed(this.filter_.getIndex()), "Server snap not indexed");
        }, e.prototype.applyOperation = function (t, n, r, i) {
          var o,
              a,
              s = new Mt();

          if (n.type === ut.OVERWRITE) {
            var c = n;
            c.source.fromUser ? o = this.applyUserOverwrite_(t, c.path, c.snap, r, i, s) : (u.assert(c.source.fromServer, "Unknown source."), a = c.source.tagged || t.getServerCache().isFiltered() && !c.path.isEmpty(), o = this.applyServerOverwrite_(t, c.path, c.snap, r, i, a, s));
          } else if (n.type === ut.MERGE) {
            var l = n;
            l.source.fromUser ? o = this.applyUserMerge_(t, l.path, l.children, r, i, s) : (u.assert(l.source.fromServer, "Unknown source."), a = l.source.tagged || t.getServerCache().isFiltered(), o = this.applyServerMerge_(t, l.path, l.children, r, i, a, s));
          } else if (n.type === ut.ACK_USER_WRITE) {
            var h = n;
            o = h.revert ? this.revertUserWrite_(t, h.path, r, i, s) : this.ackUserWrite_(t, h.path, h.affectedTree, r, i, s);
          } else {
            if (n.type !== ut.LISTEN_COMPLETE) throw u.assertionError("Unknown operation type: " + n.type);
            o = this.listenComplete_(t, n.path, r, s);
          }

          var d = s.getChanges();
          return e.maybeAddValueEvent_(t, o, d), new Lt(o, d);
        }, e.maybeAddValueEvent_ = function (e, t, n) {
          var r = t.getEventCache();

          if (r.isFullyInitialized()) {
            var i = r.getNode().isLeafNode() || r.getNode().isEmpty(),
                o = e.getCompleteEventSnap();
            (n.length > 0 || !e.getEventCache().isFullyInitialized() || i && !r.getNode().equals(o) || !r.getNode().getPriority().equals(o.getPriority())) && n.push(wt.valueChange(t.getCompleteEventSnap()));
          }
        }, e.prototype.generateEventCacheAfterServerEvent_ = function (e, t, n, r, i) {
          var o = e.getEventCache();
          if (null != n.shadowingWrite(t)) return e;
          var a = void 0,
              s = void 0;
          if (t.isEmpty()) {
            if (u.assert(e.getServerCache().isFullyInitialized(), "If change path is empty, we must have complete server data"), e.getServerCache().isFiltered()) {
              var c = e.getCompleteServerSnap(),
                  l = c instanceof Ve ? c : Ve.EMPTY_NODE,
                  h = n.calcCompleteEventChildren(l);
              a = this.filter_.updateFullNode(e.getEventCache().getNode(), h, i);
            } else {
              var d = n.calcCompleteEventCache(e.getCompleteServerSnap());
              a = this.filter_.updateFullNode(e.getEventCache().getNode(), d, i);
            }
          } else {
            var f = t.getFront();

            if (".priority" === f) {
              u.assert(1 === t.getLength(), "Can't have a priority with additional path components");
              var p = o.getNode();
              s = e.getServerCache().getNode();
              var m = n.calcEventCacheAfterServerOverwrite(t, p, s);
              a = null != m ? this.filter_.updatePriority(p, m) : o.getNode();
            } else {
              var _ = t.popFront(),
                  y = void 0;

              if (o.isCompleteForChild(f)) {
                s = e.getServerCache().getNode();
                var v = n.calcEventCacheAfterServerOverwrite(t, o.getNode(), s);
                y = null != v ? o.getNode().getImmediateChild(f).updateChild(_, v) : o.getNode().getImmediateChild(f);
              } else y = n.calcCompleteChild(f, e.getServerCache());

              a = null != y ? this.filter_.updateChild(o.getNode(), f, y, _, r, i) : o.getNode();
            }
          }
          return e.updateEventSnap(a, o.isFullyInitialized() || t.isEmpty(), this.filter_.filtersNodes());
        }, e.prototype.applyServerOverwrite_ = function (e, t, n, r, i, o, a) {
          var s,
              u = e.getServerCache(),
              c = o ? this.filter_ : this.filter_.getIndexedFilter();
          if (t.isEmpty()) s = c.updateFullNode(u.getNode(), n, null);else if (c.filtersNodes() && !u.isFiltered()) {
            var l = u.getNode().updateChild(t, n);
            s = c.updateFullNode(u.getNode(), l, null);
          } else {
            var h = t.getFront();
            if (!u.isCompleteForPath(t) && t.getLength() > 1) return e;
            var d = t.popFront(),
                f = u.getNode().getImmediateChild(h).updateChild(d, n);
            s = ".priority" === h ? c.updatePriority(u.getNode(), f) : c.updateChild(u.getNode(), h, f, d, Et, null);
          }
          var p = e.updateServerSnap(s, u.isFullyInitialized() || t.isEmpty(), c.filtersNodes()),
              m = new kt(r, p, i);
          return this.generateEventCacheAfterServerEvent_(p, t, r, m, a);
        }, e.prototype.applyUserOverwrite_ = function (e, t, n, r, i, o) {
          var a,
              s,
              u = e.getEventCache(),
              c = new kt(r, e, i);
          if (t.isEmpty()) s = this.filter_.updateFullNode(e.getEventCache().getNode(), n, o), a = e.updateEventSnap(s, !0, this.filter_.filtersNodes());else {
            var l = t.getFront();
            if (".priority" === l) s = this.filter_.updatePriority(e.getEventCache().getNode(), n), a = e.updateEventSnap(s, u.isFullyInitialized(), u.isFiltered());else {
              var h = t.popFront(),
                  d = u.getNode().getImmediateChild(l),
                  f = void 0;
              if (h.isEmpty()) f = n;else {
                var p = c.getCompleteChild(l);
                f = null != p ? ".priority" === h.getBack() && p.getChild(h.parent()).isEmpty() ? p : p.updateChild(h, n) : Ve.EMPTY_NODE;
              }
              if (d.equals(f)) a = e;else {
                var m = this.filter_.updateChild(u.getNode(), l, f, h, c, o);
                a = e.updateEventSnap(m, u.isFullyInitialized(), this.filter_.filtersNodes());
              }
            }
          }
          return a;
        }, e.cacheHasChild_ = function (e, t) {
          return e.getEventCache().isCompleteForChild(t);
        }, e.prototype.applyUserMerge_ = function (t, n, r, i, o, a) {
          var s = this,
              u = t;
          return r.foreach(function (r, c) {
            var l = n.child(r);
            e.cacheHasChild_(t, l.getFront()) && (u = s.applyUserOverwrite_(u, l, c, i, o, a));
          }), r.foreach(function (r, c) {
            var l = n.child(r);
            e.cacheHasChild_(t, l.getFront()) || (u = s.applyUserOverwrite_(u, l, c, i, o, a));
          }), u;
        }, e.prototype.applyMerge_ = function (e, t) {
          return t.foreach(function (t, n) {
            e = e.updateChild(t, n);
          }), e;
        }, e.prototype.applyServerMerge_ = function (e, t, n, r, i, o, a) {
          var s = this;
          if (e.getServerCache().getNode().isEmpty() && !e.getServerCache().isFullyInitialized()) return e;
          var u,
              c = e;
          u = t.isEmpty() ? n : mt.Empty.setTree(t, n);
          var l = e.getServerCache().getNode();
          return u.children.inorderTraversal(function (t, n) {
            if (l.hasChild(t)) {
              var u = e.getServerCache().getNode().getImmediateChild(t),
                  h = s.applyMerge_(u, n);
              c = s.applyServerOverwrite_(c, new H(t), h, r, i, o, a);
            }
          }), u.children.inorderTraversal(function (t, n) {
            var u = !e.getServerCache().isCompleteForChild(t) && null == n.value;

            if (!l.hasChild(t) && !u) {
              var h = e.getServerCache().getNode().getImmediateChild(t),
                  d = s.applyMerge_(h, n);
              c = s.applyServerOverwrite_(c, new H(t), d, r, i, o, a);
            }
          }), c;
        }, e.prototype.ackUserWrite_ = function (e, t, n, r, i, o) {
          if (null != r.shadowingWrite(t)) return e;
          var a = e.getServerCache().isFiltered(),
              s = e.getServerCache();

          if (null != n.value) {
            if (t.isEmpty() && s.isFullyInitialized() || s.isCompleteForPath(t)) return this.applyServerOverwrite_(e, t, s.getNode().getChild(t), r, i, a, o);

            if (t.isEmpty()) {
              var u = mt.Empty;
              return s.getNode().forEachChild(be, function (e, t) {
                u = u.set(new H(e), t);
              }), this.applyServerMerge_(e, t, u, r, i, a, o);
            }

            return e;
          }

          var c = mt.Empty;
          return n.foreach(function (e, n) {
            var r = t.child(e);
            s.isCompleteForPath(r) && (c = c.set(e, s.getNode().getChild(r)));
          }), this.applyServerMerge_(e, t, c, r, i, a, o);
        }, e.prototype.listenComplete_ = function (e, t, n, r) {
          var i = e.getServerCache(),
              o = e.updateServerSnap(i.getNode(), i.isFullyInitialized() || t.isEmpty(), i.isFiltered());
          return this.generateEventCacheAfterServerEvent_(o, t, n, Et, r);
        }, e.prototype.revertUserWrite_ = function (e, t, n, r, i) {
          var o;
          if (null != n.shadowingWrite(t)) return e;
          var a = new kt(n, e, r),
              s = e.getEventCache().getNode(),
              c = void 0;

          if (t.isEmpty() || ".priority" === t.getFront()) {
            var l = void 0;
            if (e.getServerCache().isFullyInitialized()) l = n.calcCompleteEventCache(e.getCompleteServerSnap());else {
              var h = e.getServerCache().getNode();
              u.assert(h instanceof Ve, "serverChildren would be complete if leaf node"), l = n.calcCompleteEventChildren(h);
            }
            l = l, c = this.filter_.updateFullNode(s, l, i);
          } else {
            var d = t.getFront(),
                f = n.calcCompleteChild(d, e.getServerCache());
            null == f && e.getServerCache().isCompleteForChild(d) && (f = s.getImmediateChild(d)), (c = null != f ? this.filter_.updateChild(s, d, f, t.popFront(), a, i) : e.getEventCache().getNode().hasChild(d) ? this.filter_.updateChild(s, d, Ve.EMPTY_NODE, t.popFront(), a, i) : s).isEmpty() && e.getServerCache().isFullyInitialized() && (o = n.calcCompleteEventCache(e.getCompleteServerSnap())).isLeafNode() && (c = this.filter_.updateFullNode(c, o, i));
          }

          return o = e.getServerCache().isFullyInitialized() || null != n.shadowingWrite(H.Empty), e.updateEventSnap(c, o, this.filter_.filtersNodes());
        }, e;
      }(),
          Nt = function () {
        function e(e) {
          this.query_ = e, this.index_ = this.query_.getQueryParams().getIndex();
        }

        return e.prototype.generateEventsForChanges = function (e, t, n) {
          var r = this,
              i = [],
              o = [];
          return e.forEach(function (e) {
            e.type === wt.CHILD_CHANGED && r.index_.indexedValueChanged(e.oldSnap, e.snapshotNode) && o.push(wt.childMovedChange(e.childName, e.snapshotNode));
          }), this.generateEventsForType_(i, wt.CHILD_REMOVED, e, n, t), this.generateEventsForType_(i, wt.CHILD_ADDED, e, n, t), this.generateEventsForType_(i, wt.CHILD_MOVED, o, n, t), this.generateEventsForType_(i, wt.CHILD_CHANGED, e, n, t), this.generateEventsForType_(i, wt.VALUE, e, n, t), i;
        }, e.prototype.generateEventsForType_ = function (e, t, n, r, i) {
          var o = this,
              a = n.filter(function (e) {
            return e.type === t;
          });
          a.sort(this.compareChanges_.bind(this)), a.forEach(function (t) {
            var n = o.materializeSingleChange_(t, i);
            r.forEach(function (r) {
              r.respondsTo(t.type) && e.push(r.createEvent(n, o.query_));
            });
          });
        }, e.prototype.materializeSingleChange_ = function (e, t) {
          return "value" === e.type || "child_removed" === e.type ? e : (e.prevName = t.getPredecessorChildName(e.childName, e.snapshotNode, this.index_), e);
        }, e.prototype.compareChanges_ = function (e, t) {
          if (null == e.childName || null == t.childName) throw u.assertionError("Should only compare child_ events.");
          var n = new ye(e.childName, e.snapshotNode),
              r = new ye(t.childName, t.snapshotNode);
          return this.index_.compare(n, r);
        }, e;
      }(),
          Dt = function () {
        function e(e, t) {
          this.query_ = e, this.eventRegistrations_ = [];
          var n = this.query_.getQueryParams(),
              r = new Tt(n.getIndex()),
              i = n.getNodeFilter();
          this.processor_ = new St(i);
          var o = t.getServerCache(),
              a = t.getEventCache(),
              s = r.updateFullNode(Ve.EMPTY_NODE, o.getNode(), null),
              u = i.updateFullNode(Ve.EMPTY_NODE, a.getNode(), null),
              c = new gt(s, o.isFullyInitialized(), r.filtersNodes()),
              l = new gt(u, a.isFullyInitialized(), i.filtersNodes());
          this.viewCache_ = new bt(l, c), this.eventGenerator_ = new Nt(this.query_);
        }

        return e.prototype.getQuery = function () {
          return this.query_;
        }, e.prototype.getServerCache = function () {
          return this.viewCache_.getServerCache().getNode();
        }, e.prototype.getCompleteServerCache = function (e) {
          var t = this.viewCache_.getCompleteServerSnap();
          return t && (this.query_.getQueryParams().loadsAllData() || !e.isEmpty() && !t.getImmediateChild(e.getFront()).isEmpty()) ? t.getChild(e) : null;
        }, e.prototype.isEmpty = function () {
          return 0 === this.eventRegistrations_.length;
        }, e.prototype.addEventRegistration = function (e) {
          this.eventRegistrations_.push(e);
        }, e.prototype.removeEventRegistration = function (e, t) {
          var n = [];

          if (t) {
            u.assert(null == e, "A cancel should cancel all event registrations.");
            var r = this.query_.path;
            this.eventRegistrations_.forEach(function (e) {
              t = t;
              var i = e.createCancelEvent(t, r);
              i && n.push(i);
            });
          }

          if (e) {
            for (var i = [], o = 0; o < this.eventRegistrations_.length; ++o) {
              var a = this.eventRegistrations_[o];

              if (a.matches(e)) {
                if (e.hasAnyCallback()) {
                  i = i.concat(this.eventRegistrations_.slice(o + 1));
                  break;
                }
              } else i.push(a);
            }

            this.eventRegistrations_ = i;
          } else this.eventRegistrations_ = [];

          return n;
        }, e.prototype.applyOperation = function (e, t, n) {
          e.type === ut.MERGE && null !== e.source.queryId && (u.assert(this.viewCache_.getCompleteServerSnap(), "We should always have a full cache before handling merges"), u.assert(this.viewCache_.getCompleteEventSnap(), "Missing event cache, even though we have a server cache"));
          var r = this.viewCache_,
              i = this.processor_.applyOperation(r, e, t, n);
          return this.processor_.assertIndexed(i.viewCache), u.assert(i.viewCache.getServerCache().isFullyInitialized() || !r.getServerCache().isFullyInitialized(), "Once a server snap is complete, it should never go back"), this.viewCache_ = i.viewCache, this.generateEventsForChanges_(i.changes, i.viewCache.getEventCache().getNode(), null);
        }, e.prototype.getInitialEvents = function (e) {
          var t = this.viewCache_.getEventCache(),
              n = [];
          t.getNode().isLeafNode() || t.getNode().forEachChild(De, function (e, t) {
            n.push(wt.childAddedChange(e, t));
          });
          return t.isFullyInitialized() && n.push(wt.valueChange(t.getNode())), this.generateEventsForChanges_(n, t.getNode(), e);
        }, e.prototype.generateEventsForChanges_ = function (e, t, n) {
          var r = n ? [n] : this.eventRegistrations_;
          return this.eventGenerator_.generateEventsForChanges(e, t, r);
        }, e;
      }(),
          It = function () {
        function e() {
          this.views = new Map();
        }

        return Object.defineProperty(e, "__referenceConstructor", {
          get: function get() {
            return u.assert(ht, "Reference.ts has not been loaded"), ht;
          },
          set: function set(e) {
            u.assert(!ht, "__referenceConstructor has already been defined"), ht = e;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.isEmpty = function () {
          return 0 === this.views.size;
        }, e.prototype.applyOperation = function (e, t, n) {
          var r,
              i,
              o = e.source.queryId;

          if (null !== o) {
            var a = this.views.get(o);
            return u.assert(null != a, "SyncTree gave us an op for an invalid query."), a.applyOperation(e, t, n);
          }

          var c = [];

          try {
            for (var l = s.__values(this.views.values()), h = l.next(); !h.done; h = l.next()) {
              a = h.value;
              c = c.concat(a.applyOperation(e, t, n));
            }
          } catch (e) {
            r = {
              error: e
            };
          } finally {
            try {
              h && !h.done && (i = l.return) && i.call(l);
            } finally {
              if (r) throw r.error;
            }
          }

          return c;
        }, e.prototype.addEventRegistration = function (e, t, n, r, i) {
          var o = e.queryIdentifier(),
              a = this.views.get(o);

          if (!a) {
            var s = n.calcCompleteEventCache(i ? r : null),
                u = !1;
            s ? u = !0 : r instanceof Ve ? (s = n.calcCompleteEventChildren(r), u = !1) : (s = Ve.EMPTY_NODE, u = !1);
            var c = new bt(new gt(s, u, !1), new gt(r, i, !1));
            a = new Dt(e, c), this.views.set(o, a);
          }

          return a.addEventRegistration(t), a.getInitialEvents(t);
        }, e.prototype.removeEventRegistration = function (t, n, r) {
          var i,
              o,
              a = t.queryIdentifier(),
              u = [],
              c = [],
              l = this.hasCompleteView();
          if ("default" === a) try {
            for (var h = s.__values(this.views.entries()), d = h.next(); !d.done; d = h.next()) {
              var f = s.__read(d.value, 2),
                  p = f[0],
                  m = f[1];

              c = c.concat(m.removeEventRegistration(n, r)), m.isEmpty() && (this.views.delete(p), m.getQuery().getQueryParams().loadsAllData() || u.push(m.getQuery()));
            }
          } catch (e) {
            i = {
              error: e
            };
          } finally {
            try {
              d && !d.done && (o = h.return) && o.call(h);
            } finally {
              if (i) throw i.error;
            }
          } else (m = this.views.get(a)) && (c = c.concat(m.removeEventRegistration(n, r)), m.isEmpty() && (this.views.delete(a), m.getQuery().getQueryParams().loadsAllData() || u.push(m.getQuery())));
          return l && !this.hasCompleteView() && u.push(new e.__referenceConstructor(t.repo, t.path)), {
            removed: u,
            events: c
          };
        }, e.prototype.getQueryViews = function () {
          var e,
              t,
              n = [];

          try {
            for (var r = s.__values(this.views.values()), i = r.next(); !i.done; i = r.next()) {
              var o = i.value;
              o.getQuery().getQueryParams().loadsAllData() || n.push(o);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              i && !i.done && (t = r.return) && t.call(r);
            } finally {
              if (e) throw e.error;
            }
          }

          return n;
        }, e.prototype.getCompleteServerCache = function (e) {
          var t,
              n,
              r = null;

          try {
            for (var i = s.__values(this.views.values()), o = i.next(); !o.done; o = i.next()) {
              var a = o.value;
              r = r || a.getCompleteServerCache(e);
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              o && !o.done && (n = i.return) && n.call(i);
            } finally {
              if (t) throw t.error;
            }
          }

          return r;
        }, e.prototype.viewForQuery = function (e) {
          if (e.getQueryParams().loadsAllData()) return this.getCompleteView();
          var t = e.queryIdentifier();
          return this.views.get(t);
        }, e.prototype.viewExistsForQuery = function (e) {
          return null != this.viewForQuery(e);
        }, e.prototype.hasCompleteView = function () {
          return null != this.getCompleteView();
        }, e.prototype.getCompleteView = function () {
          var e, t;

          try {
            for (var n = s.__values(this.views.values()), r = n.next(); !r.done; r = n.next()) {
              var i = r.value;
              if (i.getQuery().getQueryParams().loadsAllData()) return i;
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              r && !r.done && (t = n.return) && t.call(n);
            } finally {
              if (e) throw e.error;
            }
          }

          return null;
        }, e;
      }(),
          Rt = function () {
        function e(e) {
          this.writeTree_ = e;
        }

        return e.prototype.addWrite = function (t, n) {
          if (t.isEmpty()) return new e(new mt(n));
          var r = this.writeTree_.findRootMostValueAndPath(t);

          if (null != r) {
            var i = r.path,
                o = r.value,
                a = H.relativePath(i, t);
            return o = o.updateChild(a, n), new e(this.writeTree_.set(i, o));
          }

          var s = new mt(n);
          return new e(this.writeTree_.setTree(t, s));
        }, e.prototype.addWrites = function (e, t) {
          var n = this;
          return F(t, function (t, r) {
            n = n.addWrite(e.child(t), r);
          }), n;
        }, e.prototype.removeWrite = function (t) {
          return t.isEmpty() ? e.Empty : new e(this.writeTree_.setTree(t, mt.Empty));
        }, e.prototype.hasCompleteWrite = function (e) {
          return null != this.getCompleteNode(e);
        }, e.prototype.getCompleteNode = function (e) {
          var t = this.writeTree_.findRootMostValueAndPath(e);
          return null != t ? this.writeTree_.get(t.path).getChild(H.relativePath(t.path, e)) : null;
        }, e.prototype.getCompleteChildren = function () {
          var e = [],
              t = this.writeTree_.value;
          return null != t ? t.isLeafNode() || t.forEachChild(De, function (t, n) {
            e.push(new ye(t, n));
          }) : this.writeTree_.children.inorderTraversal(function (t, n) {
            null != n.value && e.push(new ye(t, n.value));
          }), e;
        }, e.prototype.childCompoundWrite = function (t) {
          if (t.isEmpty()) return this;
          var n = this.getCompleteNode(t);
          return new e(null != n ? new mt(n) : this.writeTree_.subtree(t));
        }, e.prototype.isEmpty = function () {
          return this.writeTree_.isEmpty();
        }, e.prototype.apply = function (e) {
          return function e(t, n, r) {
            if (null != n.value) return r.updateChild(t, n.value);
            var i = null;
            return n.children.inorderTraversal(function (n, o) {
              ".priority" === n ? (u.assert(null !== o.value, "Priority writes must always be leaf nodes"), i = o.value) : r = e(t.child(n), o, r);
            }), r.getChild(t).isEmpty() || null === i || (r = r.updateChild(t.child(".priority"), i)), r;
          }
          /**
           * @license
           * Copyright 2017 Google Inc.
           *
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           *   http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           */
          (H.Empty, this.writeTree_, e);
        }, e.Empty = new e(new mt(null)), e;
      }();
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      var xt = function () {
        function e() {
          this.visibleWrites_ = Rt.Empty, this.allWrites_ = [], this.lastWriteId_ = -1;
        }

        return e.prototype.childWrites = function (e) {
          return new Yt(e, this);
        }, e.prototype.addOverwrite = function (e, t, n, r) {
          u.assert(n > this.lastWriteId_, "Stacking an older write on top of newer ones"), void 0 === r && (r = !0), this.allWrites_.push({
            path: e,
            snap: t,
            writeId: n,
            visible: r
          }), r && (this.visibleWrites_ = this.visibleWrites_.addWrite(e, t)), this.lastWriteId_ = n;
        }, e.prototype.addMerge = function (e, t, n) {
          u.assert(n > this.lastWriteId_, "Stacking an older merge on top of newer ones"), this.allWrites_.push({
            path: e,
            children: t,
            writeId: n,
            visible: !0
          }), this.visibleWrites_ = this.visibleWrites_.addWrites(e, t), this.lastWriteId_ = n;
        }, e.prototype.getWrite = function (e) {
          for (var t = 0; t < this.allWrites_.length; t++) {
            var n = this.allWrites_[t];
            if (n.writeId === e) return n;
          }

          return null;
        }, e.prototype.removeWrite = function (e) {
          var t = this,
              n = this.allWrites_.findIndex(function (t) {
            return t.writeId === e;
          });
          u.assert(n >= 0, "removeWrite called with nonexistent writeId.");
          var r = this.allWrites_[n];
          this.allWrites_.splice(n, 1);

          for (var i = r.visible, o = !1, a = this.allWrites_.length - 1; i && a >= 0;) {
            var s = this.allWrites_[a];
            s.visible && (a >= n && this.recordContainsPath_(s, r.path) ? i = !1 : r.path.contains(s.path) && (o = !0)), a--;
          }

          if (i) {
            if (o) return this.resetTree_(), !0;
            r.snap ? this.visibleWrites_ = this.visibleWrites_.removeWrite(r.path) : F(r.children, function (e) {
              t.visibleWrites_ = t.visibleWrites_.removeWrite(r.path.child(e));
            });
            return !0;
          }

          return !1;
        }, e.prototype.getCompleteWriteData = function (e) {
          return this.visibleWrites_.getCompleteNode(e);
        }, e.prototype.calcCompleteEventCache = function (t, n, r, i) {
          if (r || i) {
            var o = this.visibleWrites_.childCompoundWrite(t);
            if (!i && o.isEmpty()) return n;

            if (i || null != n || o.hasCompleteWrite(H.Empty)) {
              var a = e.layerTree_(this.allWrites_, function (e) {
                return (e.visible || i) && (!r || !~r.indexOf(e.writeId)) && (e.path.contains(t) || t.contains(e.path));
              }, t);
              c = n || Ve.EMPTY_NODE;
              return a.apply(c);
            }

            return null;
          }

          var s = this.visibleWrites_.getCompleteNode(t);
          if (null != s) return s;
          var u = this.visibleWrites_.childCompoundWrite(t);
          if (u.isEmpty()) return n;

          if (null != n || u.hasCompleteWrite(H.Empty)) {
            var c = n || Ve.EMPTY_NODE;
            return u.apply(c);
          }

          return null;
        }, e.prototype.calcCompleteEventChildren = function (e, t) {
          var n = Ve.EMPTY_NODE,
              r = this.visibleWrites_.getCompleteNode(e);
          if (r) return r.isLeafNode() || r.forEachChild(De, function (e, t) {
            n = n.updateImmediateChild(e, t);
          }), n;

          if (t) {
            var i = this.visibleWrites_.childCompoundWrite(e);
            return t.forEachChild(De, function (e, t) {
              var r = i.childCompoundWrite(new H(e)).apply(t);
              n = n.updateImmediateChild(e, r);
            }), i.getCompleteChildren().forEach(function (e) {
              n = n.updateImmediateChild(e.name, e.node);
            }), n;
          }

          return this.visibleWrites_.childCompoundWrite(e).getCompleteChildren().forEach(function (e) {
            n = n.updateImmediateChild(e.name, e.node);
          }), n;
        }, e.prototype.calcEventCacheAfterServerOverwrite = function (e, t, n, r) {
          u.assert(n || r, "Either existingEventSnap or existingServerSnap must exist");
          var i = e.child(t);
          if (this.visibleWrites_.hasCompleteWrite(i)) return null;
          var o = this.visibleWrites_.childCompoundWrite(i);
          return o.isEmpty() ? r.getChild(t) : o.apply(r.getChild(t));
        }, e.prototype.calcCompleteChild = function (e, t, n) {
          var r = e.child(t),
              i = this.visibleWrites_.getCompleteNode(r);
          return null != i ? i : n.isCompleteForChild(t) ? this.visibleWrites_.childCompoundWrite(r).apply(n.getNode().getImmediateChild(t)) : null;
        }, e.prototype.shadowingWrite = function (e) {
          return this.visibleWrites_.getCompleteNode(e);
        }, e.prototype.calcIndexedSlice = function (e, t, n, r, i, o) {
          var a,
              s = this.visibleWrites_.childCompoundWrite(e),
              u = s.getCompleteNode(H.Empty);
          if (null != u) a = u;else {
            if (null == t) return [];
            a = s.apply(t);
          }
          if ((a = a.withIndex(o)).isEmpty() || a.isLeafNode()) return [];

          for (var c = [], l = o.getCompare(), h = i ? a.getReverseIteratorFrom(n, o) : a.getIteratorFrom(n, o), d = h.getNext(); d && c.length < r;) {
            0 !== l(d, n) && c.push(d), d = h.getNext();
          }

          return c;
        }, e.prototype.recordContainsPath_ = function (e, t) {
          if (e.snap) return e.path.contains(t);

          for (var n in e.children) {
            if (e.children.hasOwnProperty(n) && e.path.child(n).contains(t)) return !0;
          }

          return !1;
        }, e.prototype.resetTree_ = function () {
          this.visibleWrites_ = e.layerTree_(this.allWrites_, e.DefaultFilter_, H.Empty), this.allWrites_.length > 0 ? this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId : this.lastWriteId_ = -1;
        }, e.DefaultFilter_ = function (e) {
          return e.visible;
        }, e.layerTree_ = function (e, t, n) {
          for (var r = Rt.Empty, i = 0; i < e.length; ++i) {
            var o = e[i];

            if (t(o)) {
              var a = o.path,
                  s = void 0;
              if (o.snap) n.contains(a) ? (s = H.relativePath(n, a), r = r.addWrite(s, o.snap)) : a.contains(n) && (s = H.relativePath(a, n), r = r.addWrite(H.Empty, o.snap.getChild(s)));else {
                if (!o.children) throw u.assertionError("WriteRecord should have .snap or .children");
                if (n.contains(a)) s = H.relativePath(n, a), r = r.addWrites(s, o.children);else if (a.contains(n)) if ((s = H.relativePath(a, n)).isEmpty()) r = r.addWrites(H.Empty, o.children);else {
                  var c = u.safeGet(o.children, s.getFront());

                  if (c) {
                    var l = c.getChild(s.popFront());
                    r = r.addWrite(H.Empty, l);
                  }
                }
              }
            }
          }

          return r;
        }, e;
      }(),
          Yt = function () {
        function e(e, t) {
          this.treePath_ = e, this.writeTree_ = t;
        }

        return e.prototype.calcCompleteEventCache = function (e, t, n) {
          return this.writeTree_.calcCompleteEventCache(this.treePath_, e, t, n);
        }, e.prototype.calcCompleteEventChildren = function (e) {
          return this.writeTree_.calcCompleteEventChildren(this.treePath_, e);
        }, e.prototype.calcEventCacheAfterServerOverwrite = function (e, t, n) {
          return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, e, t, n);
        }, e.prototype.shadowingWrite = function (e) {
          return this.writeTree_.shadowingWrite(this.treePath_.child(e));
        }, e.prototype.calcIndexedSlice = function (e, t, n, r, i) {
          return this.writeTree_.calcIndexedSlice(this.treePath_, e, t, n, r, i);
        }, e.prototype.calcCompleteChild = function (e, t) {
          return this.writeTree_.calcCompleteChild(this.treePath_, e, t);
        }, e.prototype.child = function (t) {
          return new e(this.treePath_.child(t), this.writeTree_);
        }, e;
      }(),
          Ct = function () {
        function e(e) {
          this.listenProvider_ = e, this.syncPointTree_ = mt.Empty, this.pendingWriteTree_ = new xt(), this.tagToQueryMap = new Map(), this.queryToTagMap = new Map();
        }

        return e.prototype.applyUserOverwrite = function (e, t, n, r) {
          return this.pendingWriteTree_.addOverwrite(e, t, n, r), r ? this.applyOperationToSyncPoints_(new yt(dt.User, e, t)) : [];
        }, e.prototype.applyUserMerge = function (e, t, n) {
          this.pendingWriteTree_.addMerge(e, t, n);
          var r = mt.fromObject(t);
          return this.applyOperationToSyncPoints_(new vt(dt.User, e, r));
        }, e.prototype.ackUserWrite = function (e, t) {
          void 0 === t && (t = !1);
          var n = this.pendingWriteTree_.getWrite(e);

          if (this.pendingWriteTree_.removeWrite(e)) {
            var r = mt.Empty;
            return null != n.snap ? r = r.set(H.Empty, !0) : F(n.children, function (e, t) {
              r = r.set(new H(e), t);
            }), this.applyOperationToSyncPoints_(new ft(n.path, r, t));
          }

          return [];
        }, e.prototype.applyServerOverwrite = function (e, t) {
          return this.applyOperationToSyncPoints_(new yt(dt.Server, e, t));
        }, e.prototype.applyServerMerge = function (e, t) {
          var n = mt.fromObject(t);
          return this.applyOperationToSyncPoints_(new vt(dt.Server, e, n));
        }, e.prototype.applyListenComplete = function (e) {
          return this.applyOperationToSyncPoints_(new _t(dt.Server, e));
        }, e.prototype.applyTaggedQueryOverwrite = function (t, n, r) {
          var i = this.queryKeyForTag_(r);

          if (null != i) {
            var o = e.parseQueryKey_(i),
                a = o.path,
                s = o.queryId,
                u = H.relativePath(a, t),
                c = new yt(dt.forServerTaggedQuery(s), u, n);
            return this.applyTaggedOperation_(a, c);
          }

          return [];
        }, e.prototype.applyTaggedQueryMerge = function (t, n, r) {
          var i = this.queryKeyForTag_(r);

          if (i) {
            var o = e.parseQueryKey_(i),
                a = o.path,
                s = o.queryId,
                u = H.relativePath(a, t),
                c = mt.fromObject(n),
                l = new vt(dt.forServerTaggedQuery(s), u, c);
            return this.applyTaggedOperation_(a, l);
          }

          return [];
        }, e.prototype.applyTaggedListenComplete = function (t, n) {
          var r = this.queryKeyForTag_(n);

          if (r) {
            var i = e.parseQueryKey_(r),
                o = i.path,
                a = i.queryId,
                s = H.relativePath(o, t),
                u = new _t(dt.forServerTaggedQuery(a), s);
            return this.applyTaggedOperation_(o, u);
          }

          return [];
        }, e.prototype.addEventRegistration = function (t, n) {
          var r = t.path,
              i = null,
              o = !1;
          this.syncPointTree_.foreachOnPath(r, function (e, t) {
            var n = H.relativePath(e, r);
            i = i || t.getCompleteServerCache(n), o = o || t.hasCompleteView();
          });
          var a,
              s = this.syncPointTree_.get(r);
          (s ? (o = o || s.hasCompleteView(), i = i || s.getCompleteServerCache(H.Empty)) : (s = new It(), this.syncPointTree_ = this.syncPointTree_.set(r, s)), null != i) ? a = !0 : (a = !1, i = Ve.EMPTY_NODE, this.syncPointTree_.subtree(r).foreachChild(function (e, t) {
            var n = t.getCompleteServerCache(H.Empty);
            n && (i = i.updateImmediateChild(e, n));
          }));
          var c = s.viewExistsForQuery(t);

          if (!c && !t.getQueryParams().loadsAllData()) {
            var l = e.makeQueryKey_(t);
            u.assert(!this.queryToTagMap.has(l), "View does not exist, but we have a tag");
            var h = e.getNextQueryTag_();
            this.queryToTagMap.set(l, h), this.tagToQueryMap.set(h, l);
          }

          var d = this.pendingWriteTree_.childWrites(r),
              f = s.addEventRegistration(t, n, d, i, a);

          if (!c && !o) {
            var p = s.viewForQuery(t);
            f = f.concat(this.setupListener_(t, p));
          }

          return f;
        }, e.prototype.removeEventRegistration = function (t, n, r) {
          var i = this,
              o = t.path,
              a = this.syncPointTree_.get(o),
              s = [];

          if (a && ("default" === t.queryIdentifier() || a.viewExistsForQuery(t))) {
            var u = a.removeEventRegistration(t, n, r);
            a.isEmpty() && (this.syncPointTree_ = this.syncPointTree_.remove(o));
            var c = u.removed;
            s = u.events;
            var l = -1 !== c.findIndex(function (e) {
              return e.getQueryParams().loadsAllData();
            }),
                h = this.syncPointTree_.findOnPath(o, function (e, t) {
              return t.hasCompleteView();
            });

            if (l && !h) {
              var d = this.syncPointTree_.subtree(o);
              if (!d.isEmpty()) for (var f = this.collectDistinctViewsForSubTree_(d), p = 0; p < f.length; ++p) {
                var m = f[p],
                    _ = m.getQuery(),
                    y = this.createListenerForView_(m);

                this.listenProvider_.startListening(e.queryForListening_(_), this.tagForQuery_(_), y.hashFn, y.onComplete);
              }
            }

            if (!h && c.length > 0 && !r) if (l) {
              this.listenProvider_.stopListening(e.queryForListening_(t), null);
            } else c.forEach(function (t) {
              var n = i.queryToTagMap.get(e.makeQueryKey_(t));
              i.listenProvider_.stopListening(e.queryForListening_(t), n);
            });
            this.removeTags_(c);
          }

          return s;
        }, e.prototype.calcCompleteEventCache = function (e, t) {
          var n = this.pendingWriteTree_,
              r = this.syncPointTree_.findOnPath(e, function (t, n) {
            var r = H.relativePath(t, e),
                i = n.getCompleteServerCache(r);
            if (i) return i;
          });
          return n.calcCompleteEventCache(e, r, t, !0);
        }, e.prototype.collectDistinctViewsForSubTree_ = function (e) {
          return e.fold(function (e, t, n) {
            if (t && t.hasCompleteView()) return [t.getCompleteView()];
            var r = [];
            return t && (r = t.getQueryViews()), F(n, function (e, t) {
              r = r.concat(t);
            }), r;
          });
        }, e.prototype.removeTags_ = function (t) {
          for (var n = 0; n < t.length; ++n) {
            var r = t[n];

            if (!r.getQueryParams().loadsAllData()) {
              var i = e.makeQueryKey_(r),
                  o = this.queryToTagMap.get(i);
              this.queryToTagMap.delete(i), this.tagToQueryMap.delete(o);
            }
          }
        }, e.queryForListening_ = function (e) {
          return e.getQueryParams().loadsAllData() && !e.getQueryParams().isDefault() ? e.getRef() : e;
        }, e.prototype.setupListener_ = function (t, n) {
          var r = t.path,
              i = this.tagForQuery_(t),
              o = this.createListenerForView_(n),
              a = this.listenProvider_.startListening(e.queryForListening_(t), i, o.hashFn, o.onComplete),
              s = this.syncPointTree_.subtree(r);
          if (i) u.assert(!s.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");else for (var c = s.fold(function (e, t, n) {
            if (!e.isEmpty() && t && t.hasCompleteView()) return [t.getCompleteView().getQuery()];
            var r = [];
            return t && (r = r.concat(t.getQueryViews().map(function (e) {
              return e.getQuery();
            }))), F(n, function (e, t) {
              r = r.concat(t);
            }), r;
          }), l = 0; l < c.length; ++l) {
            var h = c[l];
            this.listenProvider_.stopListening(e.queryForListening_(h), this.tagForQuery_(h));
          }
          return a;
        }, e.prototype.createListenerForView_ = function (e) {
          var t = this,
              n = e.getQuery(),
              r = this.tagForQuery_(n);
          return {
            hashFn: function hashFn() {
              return (e.getServerCache() || Ve.EMPTY_NODE).hash();
            },
            onComplete: function onComplete(e) {
              if ("ok" === e) return r ? t.applyTaggedListenComplete(n.path, r) : t.applyListenComplete(n.path);

              var i = function (e, t) {
                var n = "Unknown Error";
                "too_big" === e ? n = "The data requested exceeds the maximum size that can be accessed with a single request." : "permission_denied" === e ? n = "Client doesn't have permission to access the desired data." : "unavailable" === e && (n = "The service is unavailable");
                var r = new Error(e + " at " + t.path.toString() + ": " + n);
                return r.code = e.toUpperCase(), r;
              }(e, n);

              return t.removeEventRegistration(n, null, i);
            }
          };
        }, e.makeQueryKey_ = function (e) {
          return e.path.toString() + "$" + e.queryIdentifier();
        }, e.parseQueryKey_ = function (e) {
          var t = e.indexOf("$");
          return u.assert(-1 !== t && t < e.length - 1, "Bad queryKey."), {
            queryId: e.substr(t + 1),
            path: new H(e.substr(0, t))
          };
        }, e.prototype.queryKeyForTag_ = function (e) {
          return this.tagToQueryMap.get(e);
        }, e.prototype.tagForQuery_ = function (t) {
          var n = e.makeQueryKey_(t);
          return this.queryToTagMap.get(n);
        }, e.getNextQueryTag_ = function () {
          return e.nextQueryTag_++;
        }, e.prototype.applyTaggedOperation_ = function (e, t) {
          var n = this.syncPointTree_.get(e);
          u.assert(n, "Missing sync point for query tag that we're tracking");
          var r = this.pendingWriteTree_.childWrites(e);
          return n.applyOperation(t, r, null);
        }, e.prototype.applyOperationToSyncPoints_ = function (e) {
          return this.applyOperationHelper_(e, this.syncPointTree_, null, this.pendingWriteTree_.childWrites(H.Empty));
        }, e.prototype.applyOperationHelper_ = function (e, t, n, r) {
          if (e.path.isEmpty()) return this.applyOperationDescendantsHelper_(e, t, n, r);
          var i = t.get(H.Empty);
          null == n && null != i && (n = i.getCompleteServerCache(H.Empty));
          var o = [],
              a = e.path.getFront(),
              s = e.operationForChild(a),
              u = t.children.get(a);

          if (u && s) {
            var c = n ? n.getImmediateChild(a) : null,
                l = r.child(a);
            o = o.concat(this.applyOperationHelper_(s, u, c, l));
          }

          return i && (o = o.concat(i.applyOperation(e, r, n))), o;
        }, e.prototype.applyOperationDescendantsHelper_ = function (e, t, n, r) {
          var i = this,
              o = t.get(H.Empty);
          null == n && null != o && (n = o.getCompleteServerCache(H.Empty));
          var a = [];
          return t.children.inorderTraversal(function (t, o) {
            var s = n ? n.getImmediateChild(t) : null,
                u = r.child(t),
                c = e.operationForChild(t);
            c && (a = a.concat(i.applyOperationDescendantsHelper_(c, o, s, u)));
          }), o && (a = a.concat(o.applyOperation(e, r, n))), a;
        }, e.nextQueryTag_ = 1, e;
      }(),
          Ot = function () {
        function e() {
          this.rootNode_ = Ve.EMPTY_NODE;
        }

        return e.prototype.getNode = function (e) {
          return this.rootNode_.getChild(e);
        }, e.prototype.updateSnapshot = function (e, t) {
          this.rootNode_ = this.rootNode_.updateChild(e, t);
        }, e;
      }(),
          Ft = function () {
        function e(e, t) {
          var n = this;
          this.app_ = e, this.authProvider_ = t, this.auth_ = null, this.auth_ = t.getImmediate({
            optional: !0
          }), this.auth_ || t.get().then(function (e) {
            return n.auth_ = e;
          });
        }

        return e.prototype.getToken = function (e) {
          return this.auth_ ? this.auth_.getToken(e).catch(function (e) {
            return e && "auth/token-not-initialized" === e.code ? (M("Got auth/token-not-initialized error.  Treating as null token."), null) : Promise.reject(e);
          }) : Promise.resolve(null);
        }, e.prototype.addTokenChangeListener = function (e) {
          this.auth_ ? this.auth_.addAuthTokenListener(e) : (setTimeout(function () {
            return e(null);
          }, 0), this.authProvider_.get().then(function (t) {
            return t.addAuthTokenListener(e);
          }));
        }, e.prototype.removeTokenChangeListener = function (e) {
          this.authProvider_.get().then(function (t) {
            return t.removeAuthTokenListener(e);
          });
        }, e.prototype.notifyForInvalidToken = function () {
          var e = 'Provided authentication credentials for the app named "' + this.app_.name + '" are invalid. This usually indicates your app was not initialized correctly. ';
          "credential" in this.app_.options ? e += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.' : "serviceAccount" in this.app_.options ? e += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.' : e += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.', S(e);
        }, e;
      }(),
          At = function () {
        function e() {
          this.counters_ = {};
        }

        return e.prototype.incrementCounter = function (e, t) {
          void 0 === t && (t = 1), u.contains(this.counters_, e) || (this.counters_[e] = 0), this.counters_[e] += t;
        }, e.prototype.get = function () {
          return u.deepCopy(this.counters_);
        }, e;
      }(),
          jt = function () {
        function e() {}

        return e.getCollection = function (e) {
          var t = e.toString();
          return this.collections_[t] || (this.collections_[t] = new At()), this.collections_[t];
        }, e.getOrCreateReporter = function (e, t) {
          var n = e.toString();
          return this.reporters_[n] || (this.reporters_[n] = t()), this.reporters_[n];
        }, e.collections_ = {}, e.reporters_ = {}, e;
      }(),
          Ut = function () {
        function e(e) {
          this.collection_ = e, this.last_ = null;
        }

        return e.prototype.get = function () {
          var e = this.collection_.get(),
              t = s.__assign({}, e);

          return this.last_ && F(this.last_, function (e, n) {
            t[e] = t[e] - n;
          }), this.last_ = e, t;
        }, e;
      }(),
          Pt = 1e4,
          Vt = 3e4,
          Wt = function () {
        function e(e, t) {
          this.server_ = t, this.statsToReport_ = {}, this.statsListener_ = new Ut(e);
          var n = Pt + (Vt - Pt) * Math.random();
          W(this.reportStats_.bind(this), Math.floor(n));
        }

        return e.prototype.includeStat = function (e) {
          this.statsToReport_[e] = !0;
        }, e.prototype.reportStats_ = function () {
          var e = this,
              t = this.statsListener_.get(),
              n = {},
              r = !1;
          F(t, function (t, i) {
            i > 0 && u.contains(e.statsToReport_, t) && (n[t] = i, r = !0);
          }), r && this.server_.reportStats(n), W(this.reportStats_.bind(this), Math.floor(2 * Math.random() * 3e5));
        }, e;
      }(),
          Ht = function () {
        function e() {
          this.eventLists_ = [], this.recursionDepth_ = 0;
        }

        return e.prototype.queueEvents = function (e) {
          for (var t = null, n = 0; n < e.length; n++) {
            var r = e[n],
                i = r.getPath();
            null === t || i.equals(t.getPath()) || (this.eventLists_.push(t), t = null), null === t && (t = new Bt(i)), t.add(r);
          }

          t && this.eventLists_.push(t);
        }, e.prototype.raiseEventsAtPath = function (e, t) {
          this.queueEvents(t), this.raiseQueuedEventsMatchingPredicate_(function (t) {
            return t.equals(e);
          });
        }, e.prototype.raiseEventsForChangedPath = function (e, t) {
          this.queueEvents(t), this.raiseQueuedEventsMatchingPredicate_(function (t) {
            return t.contains(e) || e.contains(t);
          });
        }, e.prototype.raiseQueuedEventsMatchingPredicate_ = function (e) {
          this.recursionDepth_++;

          for (var t = !0, n = 0; n < this.eventLists_.length; n++) {
            var r = this.eventLists_[n];
            if (r) e(r.getPath()) ? (this.eventLists_[n].raise(), this.eventLists_[n] = null) : t = !1;
          }

          t && (this.eventLists_ = []), this.recursionDepth_--;
        }, e;
      }(),
          Bt = function () {
        function e(e) {
          this.path_ = e, this.events_ = [];
        }

        return e.prototype.add = function (e) {
          this.events_.push(e);
        }, e.prototype.raise = function () {
          for (var e = 0; e < this.events_.length; e++) {
            var t = this.events_[e];

            if (null !== t) {
              this.events_[e] = null;
              var n = t.getEventRunner();
              b && M("event: " + t.toString()), P(n);
            }
          }
        }, e.prototype.getPath = function () {
          return this.path_;
        }, e;
      }(),
          zt = function () {
        function e(e) {
          this.allowedEvents_ = e, this.listeners_ = {}, u.assert(Array.isArray(e) && e.length > 0, "Requires a non-empty array");
        }

        return e.prototype.trigger = function (e) {
          for (var t = [], n = 1; n < arguments.length; n++) {
            t[n - 1] = arguments[n];
          }

          if (Array.isArray(this.listeners_[e])) for (var r = s.__spread(this.listeners_[e]), i = 0; i < r.length; i++) {
            r[i].callback.apply(r[i].context, t);
          }
        }, e.prototype.on = function (e, t, n) {
          this.validateEventType_(e), this.listeners_[e] = this.listeners_[e] || [], this.listeners_[e].push({
            callback: t,
            context: n
          });
          var r = this.getInitialEvent(e);
          r && t.apply(n, r);
        }, e.prototype.off = function (e, t, n) {
          this.validateEventType_(e);

          for (var r = this.listeners_[e] || [], i = 0; i < r.length; i++) {
            if (r[i].callback === t && (!n || n === r[i].context)) return void r.splice(i, 1);
          }
        }, e.prototype.validateEventType_ = function (e) {
          u.assert(this.allowedEvents_.find(function (t) {
            return t === e;
          }), "Unknown event: " + e);
        }, e;
      }(),
          Zt = function (e) {
        function t() {
          var t,
              n,
              r = e.call(this, ["visible"]) || this;
          return "undefined" != typeof document && void 0 !== document.addEventListener && (void 0 !== document.hidden ? (n = "visibilitychange", t = "hidden") : void 0 !== document.mozHidden ? (n = "mozvisibilitychange", t = "mozHidden") : void 0 !== document.msHidden ? (n = "msvisibilitychange", t = "msHidden") : void 0 !== document.webkitHidden && (n = "webkitvisibilitychange", t = "webkitHidden")), r.visible_ = !0, n && document.addEventListener(n, function () {
            var e = !document[t];
            e !== r.visible_ && (r.visible_ = e, r.trigger("visible", e));
          }, !1), r;
        }

        return s.__extends(t, e), t.getInstance = function () {
          return new t();
        }, t.prototype.getInitialEvent = function (e) {
          return u.assert("visible" === e, "Unknown event type: " + e), [this.visible_];
        }, t;
      }(zt),
          Qt = function (e) {
        function t() {
          var t = e.call(this, ["online"]) || this;
          return t.online_ = !0, "undefined" == typeof window || void 0 === window.addEventListener || u.isMobileCordova() || (window.addEventListener("online", function () {
            t.online_ || (t.online_ = !0, t.trigger("online", !0));
          }, !1), window.addEventListener("offline", function () {
            t.online_ && (t.online_ = !1, t.trigger("online", !1));
          }, !1)), t;
        }

        return s.__extends(t, e), t.getInstance = function () {
          return new t();
        }, t.prototype.getInitialEvent = function (e) {
          return u.assert("online" === e, "Unknown event type: " + e), [this.online_];
        }, t.prototype.currentlyOnline = function () {
          return this.online_;
        }, t;
      }(zt),
          Gt = function () {
        function e(e) {
          this.onMessage_ = e, this.pendingResponses = [], this.currentResponseNum = 0, this.closeAfterResponse = -1, this.onClose = null;
        }

        return e.prototype.closeAfter = function (e, t) {
          this.closeAfterResponse = e, this.onClose = t, this.closeAfterResponse < this.currentResponseNum && (this.onClose(), this.onClose = null);
        }, e.prototype.handleResponse = function (e, t) {
          var n = this;
          this.pendingResponses[e] = t;

          for (var r = function r() {
            var e = i.pendingResponses[i.currentResponseNum];
            delete i.pendingResponses[i.currentResponseNum];

            for (var t = function t(_t14) {
              e[_t14] && P(function () {
                n.onMessage_(e[_t14]);
              });
            }, r = 0; r < e.length; ++r) {
              t(r);
            }

            if (i.currentResponseNum === i.closeAfterResponse) return i.onClose && (i.onClose(), i.onClose = null), "break";
            i.currentResponseNum++;
          }, i = this; this.pendingResponses[this.currentResponseNum];) {
            if ("break" === r()) break;
          }
        }, e;
      }(),
          qt = "pLPCommand",
          Jt = "pRTLPCB",
          Xt = function () {
        function e(e, t, n, r) {
          this.connId = e, this.repoInfo = t, this.transportSessionId = n, this.lastSessionId = r, this.bytesSent = 0, this.bytesReceived = 0, this.everConnected_ = !1, this.log_ = E(e), this.stats_ = jt.getCollection(t), this.urlFn = function (e) {
            return t.connectionURL(z, e);
          };
        }

        return e.prototype.open = function (e, t) {
          var n = this;
          this.curSegmentNum = 0, this.onDisconnect_ = t, this.myPacketOrderer = new Gt(e), this.isClosed_ = !1, this.connectTimeoutTimer_ = setTimeout(function () {
            n.log_("Timed out trying to connect."), n.onClosed_(), n.connectTimeoutTimer_ = null;
          }, Math.floor(3e4)), function (e) {
            if (u.isNodeSdk() || "complete" === document.readyState) e();else {
              var t = !1,
                  n = function n() {
                document.body ? t || (t = !0, e()) : setTimeout(n, Math.floor(10));
              };

              document.addEventListener ? (document.addEventListener("DOMContentLoaded", n, !1), window.addEventListener("load", n, !1)) : document.attachEvent && (document.attachEvent("onreadystatechange", function () {
                "complete" === document.readyState && n();
              }), window.attachEvent("onload", n));
            }
          }(function () {
            if (!n.isClosed_) {
              n.scriptTagHolder = new Kt(function () {
                for (var e = [], t = 0; t < arguments.length; t++) {
                  e[t] = arguments[t];
                }

                var r = s.__read(e, 5),
                    i = r[0],
                    o = r[1],
                    a = r[2];

                r[3], r[4];
                if (n.incrementIncomingBytes_(e), n.scriptTagHolder) if (n.connectTimeoutTimer_ && (clearTimeout(n.connectTimeoutTimer_), n.connectTimeoutTimer_ = null), n.everConnected_ = !0, "start" === i) n.id = o, n.password = a;else {
                  if ("close" !== i) throw new Error("Unrecognized command received: " + i);
                  o ? (n.scriptTagHolder.sendNewPolls = !1, n.myPacketOrderer.closeAfter(o, function () {
                    n.onClosed_();
                  })) : n.onClosed_();
                }
              }, function () {
                for (var e = [], t = 0; t < arguments.length; t++) {
                  e[t] = arguments[t];
                }

                var r = s.__read(e, 2),
                    i = r[0],
                    o = r[1];

                n.incrementIncomingBytes_(e), n.myPacketOrderer.handleResponse(i, o);
              }, function () {
                n.onClosed_();
              }, n.urlFn);
              var e = {
                start: "t"
              };
              e.ser = Math.floor(1e8 * Math.random()), n.scriptTagHolder.uniqueCallbackIdentifier && (e.cb = n.scriptTagHolder.uniqueCallbackIdentifier), e.v = "5", n.transportSessionId && (e.s = n.transportSessionId), n.lastSessionId && (e.ls = n.lastSessionId), "undefined" != typeof location && location.href && -1 !== location.href.indexOf("firebaseio.com") && (e.r = "f");
              var t = n.urlFn(e);
              n.log_("Connecting via long-poll to " + t), n.scriptTagHolder.addTag(t, function () {});
            }
          });
        }, e.prototype.start = function () {
          this.scriptTagHolder.startLongPoll(this.id, this.password), this.addDisconnectPingFrame(this.id, this.password);
        }, e.forceAllow = function () {
          e.forceAllow_ = !0;
        }, e.forceDisallow = function () {
          e.forceDisallow_ = !0;
        }, e.isAvailable = function () {
          return !u.isNodeSdk() && (!!e.forceAllow_ || !(e.forceDisallow_ || "undefined" == typeof document || null == document.createElement || "object" == typeof window && window.chrome && window.chrome.extension && !/^chrome/.test(window.location.href) || "object" == typeof Windows && "object" == typeof Windows.UI));
        }, e.prototype.markConnectionHealthy = function () {}, e.prototype.shutdown_ = function () {
          this.isClosed_ = !0, this.scriptTagHolder && (this.scriptTagHolder.close(), this.scriptTagHolder = null), this.myDisconnFrame && (document.body.removeChild(this.myDisconnFrame), this.myDisconnFrame = null), this.connectTimeoutTimer_ && (clearTimeout(this.connectTimeoutTimer_), this.connectTimeoutTimer_ = null);
        }, e.prototype.onClosed_ = function () {
          this.isClosed_ || (this.log_("Longpoll is closing itself"), this.shutdown_(), this.onDisconnect_ && (this.onDisconnect_(this.everConnected_), this.onDisconnect_ = null));
        }, e.prototype.close = function () {
          this.isClosed_ || (this.log_("Longpoll is being closed."), this.shutdown_());
        }, e.prototype.send = function (e) {
          var t = u.stringify(e);
          this.bytesSent += t.length, this.stats_.incrementCounter("bytes_sent", t.length);

          for (var n = u.base64Encode(t), r = O(n, 1840), i = 0; i < r.length; i++) {
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, r.length, r[i]), this.curSegmentNum++;
          }
        }, e.prototype.addDisconnectPingFrame = function (e, t) {
          if (!u.isNodeSdk()) {
            this.myDisconnFrame = document.createElement("iframe");
            var n = {
              dframe: "t"
            };
            n.id = e, n.pw = t, this.myDisconnFrame.src = this.urlFn(n), this.myDisconnFrame.style.display = "none", document.body.appendChild(this.myDisconnFrame);
          }
        }, e.prototype.incrementIncomingBytes_ = function (e) {
          var t = u.stringify(e).length;
          this.bytesReceived += t, this.stats_.incrementCounter("bytes_received", t);
        }, e;
      }(),
          Kt = function () {
        function e(t, n, r, i) {
          if (this.onDisconnect = r, this.urlFn = i, this.outstandingRequests = new Set(), this.pendingSegs = [], this.currentSerial = Math.floor(1e8 * Math.random()), this.sendNewPolls = !0, u.isNodeSdk()) this.commandCB = t, this.onMessageCB = n;else {
            this.uniqueCallbackIdentifier = y(), window[qt + this.uniqueCallbackIdentifier] = t, window[Jt + this.uniqueCallbackIdentifier] = n, this.myIFrame = e.createIFrame_();
            var o = "";
            if (this.myIFrame.src && "javascript:" === this.myIFrame.src.substr(0, "javascript:".length)) o = '<script>document.domain="' + document.domain + '";<\/script>';
            var a = "<html><body>" + o + "</body></html>";

            try {
              this.myIFrame.doc.open(), this.myIFrame.doc.write(a), this.myIFrame.doc.close();
            } catch (e) {
              M("frame writing exception"), e.stack && M(e.stack), M(e);
            }
          }
        }

        return e.createIFrame_ = function () {
          var e = document.createElement("iframe");
          if (e.style.display = "none", !document.body) throw "Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
          document.body.appendChild(e);

          try {
            e.contentWindow.document || M("No IE domain setting required");
          } catch (n) {
            var t = document.domain;
            e.src = "javascript:void((function(){document.open();document.domain='" + t + "';document.close();})())";
          }

          return e.contentDocument ? e.doc = e.contentDocument : e.contentWindow ? e.doc = e.contentWindow.document : e.document && (e.doc = e.document), e;
        }, e.prototype.close = function () {
          var e = this;
          this.alive = !1, this.myIFrame && (this.myIFrame.doc.body.innerHTML = "", setTimeout(function () {
            null !== e.myIFrame && (document.body.removeChild(e.myIFrame), e.myIFrame = null);
          }, Math.floor(0)));
          var t = this.onDisconnect;
          t && (this.onDisconnect = null, t());
        }, e.prototype.startLongPoll = function (e, t) {
          for (this.myID = e, this.myPW = t, this.alive = !0; this.newRequest_();) {
            ;
          }
        }, e.prototype.newRequest_ = function () {
          if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            this.currentSerial++;
            var e = {};
            e.id = this.myID, e.pw = this.myPW, e.ser = this.currentSerial;

            for (var t = this.urlFn(e), n = "", r = 0; this.pendingSegs.length > 0;) {
              if (!(this.pendingSegs[0].d.length + 30 + n.length <= 1870)) break;
              var i = this.pendingSegs.shift();
              n = n + "&seg" + r + "=" + i.seg + "&ts" + r + "=" + i.ts + "&d" + r + "=" + i.d, r++;
            }

            return t += n, this.addLongPollTag_(t, this.currentSerial), !0;
          }

          return !1;
        }, e.prototype.enqueueSegment = function (e, t, n) {
          this.pendingSegs.push({
            seg: e,
            ts: t,
            d: n
          }), this.alive && this.newRequest_();
        }, e.prototype.addLongPollTag_ = function (e, t) {
          var n = this;
          this.outstandingRequests.add(t);

          var r = function r() {
            n.outstandingRequests.delete(t), n.newRequest_();
          },
              i = setTimeout(r, Math.floor(25e3));

          this.addTag(e, function () {
            clearTimeout(i), r();
          });
        }, e.prototype.addTag = function (e, t) {
          var n = this;
          u.isNodeSdk() ? this.doNodeLongPoll(e, t) : setTimeout(function () {
            try {
              if (!n.sendNewPolls) return;
              var r = n.myIFrame.doc.createElement("script");
              r.type = "text/javascript", r.async = !0, r.src = e, r.onload = r.onreadystatechange = function () {
                var e = r.readyState;
                e && "loaded" !== e && "complete" !== e || (r.onload = r.onreadystatechange = null, r.parentNode && r.parentNode.removeChild(r), t());
              }, r.onerror = function () {
                M("Long-poll script failed to load: " + e), n.sendNewPolls = !1, n.close();
              }, n.myIFrame.doc.body.appendChild(r);
            } catch (e) {}
          }, Math.floor(1));
        }, e;
      }(),
          $t = "";
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      var en = null;
      "undefined" != typeof MozWebSocket ? en = MozWebSocket : "undefined" != typeof WebSocket && (en = WebSocket);

      var tn = function () {
        function e(t, n, r, i) {
          this.connId = t, this.keepaliveTimer = null, this.frames = null, this.totalFrames = 0, this.bytesSent = 0, this.bytesReceived = 0, this.log_ = E(this.connId), this.stats_ = jt.getCollection(n), this.connURL = e.connectionURL_(n, r, i);
        }

        return e.connectionURL_ = function (e, t, n) {
          var r = {
            v: "5"
          };
          return !u.isNodeSdk() && "undefined" != typeof location && location.href && -1 !== location.href.indexOf("firebaseio.com") && (r.r = "f"), t && (r.s = t), n && (r.ls = n), e.connectionURL("websocket", r);
        }, e.prototype.open = function (e, t) {
          var n = this;
          this.onDisconnect = t, this.onMessage = e, this.log_("Websocket connecting to " + this.connURL), this.everConnected_ = !1, p.set("previous_websocket_failure", !0);

          try {
            if (u.isNodeSdk()) {
              var i = u.CONSTANTS.NODE_ADMIN ? "AdminNode" : "Node",
                  o = {
                headers: {
                  "User-Agent": "Firebase/5/" + $t + "/" + r.platform + "/" + i
                }
              },
                  a = r.env,
                  s = 0 === this.connURL.indexOf("wss://") ? a.HTTPS_PROXY || a.https_proxy : a.HTTP_PROXY || a.http_proxy;
              s && (o.proxy = {
                origin: s
              }), this.mySock = new en(this.connURL, [], o);
            } else this.mySock = new en(this.connURL);
          } catch (e) {
            this.log_("Error instantiating WebSocket.");
            var c = e.message || e.data;
            return c && this.log_(c), void this.onClosed_();
          }

          this.mySock.onopen = function () {
            n.log_("Websocket connected."), n.everConnected_ = !0;
          }, this.mySock.onclose = function () {
            n.log_("Websocket connection was disconnected."), n.mySock = null, n.onClosed_();
          }, this.mySock.onmessage = function (e) {
            n.handleIncomingFrame(e);
          }, this.mySock.onerror = function (e) {
            n.log_("WebSocket error.  Closing connection.");
            var t = e.message || e.data;
            t && n.log_(t), n.onClosed_();
          };
        }, e.prototype.start = function () {}, e.forceDisallow = function () {
          e.forceDisallow_ = !0;
        }, e.isAvailable = function () {
          var t = !1;

          if ("undefined" != typeof navigator && navigator.userAgent) {
            var n = navigator.userAgent.match(/Android ([0-9]{0,}\.[0-9]{0,})/);
            n && n.length > 1 && parseFloat(n[1]) < 4.4 && (t = !0);
          }

          return !t && null !== en && !e.forceDisallow_;
        }, e.previouslyFailed = function () {
          return p.isInMemoryStorage || !0 === p.get("previous_websocket_failure");
        }, e.prototype.markConnectionHealthy = function () {
          p.remove("previous_websocket_failure");
        }, e.prototype.appendFrame_ = function (e) {
          if (this.frames.push(e), this.frames.length === this.totalFrames) {
            var t = this.frames.join("");
            this.frames = null;
            var n = u.jsonEval(t);
            this.onMessage(n);
          }
        }, e.prototype.handleNewFrameCount_ = function (e) {
          this.totalFrames = e, this.frames = [];
        }, e.prototype.extractFrameCount_ = function (e) {
          if (u.assert(null === this.frames, "We already have a frame buffer"), e.length <= 6) {
            var t = Number(e);
            if (!isNaN(t)) return this.handleNewFrameCount_(t), null;
          }

          return this.handleNewFrameCount_(1), e;
        }, e.prototype.handleIncomingFrame = function (e) {
          if (null !== this.mySock) {
            var t = e.data;
            if (this.bytesReceived += t.length, this.stats_.incrementCounter("bytes_received", t.length), this.resetKeepAlive(), null !== this.frames) this.appendFrame_(t);else {
              var n = this.extractFrameCount_(t);
              null !== n && this.appendFrame_(n);
            }
          }
        }, e.prototype.send = function (e) {
          this.resetKeepAlive();
          var t = u.stringify(e);
          this.bytesSent += t.length, this.stats_.incrementCounter("bytes_sent", t.length);
          var n = O(t, 16384);
          n.length > 1 && this.sendString_(String(n.length));

          for (var r = 0; r < n.length; r++) {
            this.sendString_(n[r]);
          }
        }, e.prototype.shutdown_ = function () {
          this.isClosed_ = !0, this.keepaliveTimer && (clearInterval(this.keepaliveTimer), this.keepaliveTimer = null), this.mySock && (this.mySock.close(), this.mySock = null);
        }, e.prototype.onClosed_ = function () {
          this.isClosed_ || (this.log_("WebSocket is closing itself"), this.shutdown_(), this.onDisconnect && (this.onDisconnect(this.everConnected_), this.onDisconnect = null));
        }, e.prototype.close = function () {
          this.isClosed_ || (this.log_("WebSocket is being closed"), this.shutdown_());
        }, e.prototype.resetKeepAlive = function () {
          var e = this;
          clearInterval(this.keepaliveTimer), this.keepaliveTimer = setInterval(function () {
            e.mySock && e.sendString_("0"), e.resetKeepAlive();
          }, Math.floor(45e3));
        }, e.prototype.sendString_ = function (e) {
          try {
            this.mySock.send(e);
          } catch (e) {
            this.log_("Exception thrown from WebSocket.send():", e.message || e.data, "Closing connection."), setTimeout(this.onClosed_.bind(this), 0);
          }
        }, e.responsesRequiredToBeHealthy = 2, e.healthyTimeout = 3e4, e;
      }(),
          nn = function () {
        function e(e) {
          this.initTransports_(e);
        }

        return Object.defineProperty(e, "ALL_TRANSPORTS", {
          get: function get() {
            return [Xt, tn];
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.initTransports_ = function (t) {
          var n,
              r,
              i = tn && tn.isAvailable(),
              o = i && !tn.previouslyFailed();
          if (t.webSocketOnly && (i || S("wss:// URL used, but browser isn't known to support websockets.  Trying anyway."), o = !0), o) this.transports_ = [tn];else {
            var a = this.transports_ = [];

            try {
              for (var u = s.__values(e.ALL_TRANSPORTS), c = u.next(); !c.done; c = u.next()) {
                var l = c.value;
                l && l.isAvailable() && a.push(l);
              }
            } catch (e) {
              n = {
                error: e
              };
            } finally {
              try {
                c && !c.done && (r = u.return) && r.call(u);
              } finally {
                if (n) throw n.error;
              }
            }
          }
        }, e.prototype.initialTransport = function () {
          if (this.transports_.length > 0) return this.transports_[0];
          throw new Error("No transports available");
        }, e.prototype.upgradeTransport = function () {
          return this.transports_.length > 1 ? this.transports_[1] : null;
        }, e;
      }(),
          rn = function () {
        function e(e, t, n, r, i, o, a) {
          this.id = e, this.repoInfo_ = t, this.onMessage_ = n, this.onReady_ = r, this.onDisconnect_ = i, this.onKill_ = o, this.lastSessionId = a, this.connectionCount = 0, this.pendingDataMessages = [], this.state_ = 0, this.log_ = E("c:" + this.id + ":"), this.transportManager_ = new nn(t), this.log_("Connection created"), this.start_();
        }

        return e.prototype.start_ = function () {
          var e = this,
              t = this.transportManager_.initialTransport();
          this.conn_ = new t(this.nextTransportId_(), this.repoInfo_, void 0, this.lastSessionId), this.primaryResponsesRequired_ = t.responsesRequiredToBeHealthy || 0;
          var n = this.connReceiver_(this.conn_),
              r = this.disconnReceiver_(this.conn_);
          this.tx_ = this.conn_, this.rx_ = this.conn_, this.secondaryConn_ = null, this.isHealthy_ = !1, setTimeout(function () {
            e.conn_ && e.conn_.open(n, r);
          }, Math.floor(0));
          var i = t.healthyTimeout || 0;
          i > 0 && (this.healthyTimeout_ = W(function () {
            e.healthyTimeout_ = null, e.isHealthy_ || (e.conn_ && e.conn_.bytesReceived > 102400 ? (e.log_("Connection exceeded healthy timeout but has received " + e.conn_.bytesReceived + " bytes.  Marking connection healthy."), e.isHealthy_ = !0, e.conn_.markConnectionHealthy()) : e.conn_ && e.conn_.bytesSent > 10240 ? e.log_("Connection exceeded healthy timeout but has sent " + e.conn_.bytesSent + " bytes.  Leaving connection alive.") : (e.log_("Closing unhealthy connection after timeout."), e.close()));
          }, Math.floor(i)));
        }, e.prototype.nextTransportId_ = function () {
          return "c:" + this.id + ":" + this.connectionCount++;
        }, e.prototype.disconnReceiver_ = function (e) {
          var t = this;
          return function (n) {
            e === t.conn_ ? t.onConnectionLost_(n) : e === t.secondaryConn_ ? (t.log_("Secondary connection lost."), t.onSecondaryConnectionLost_()) : t.log_("closing an old connection");
          };
        }, e.prototype.connReceiver_ = function (e) {
          var t = this;
          return function (n) {
            2 !== t.state_ && (e === t.rx_ ? t.onPrimaryMessageReceived_(n) : e === t.secondaryConn_ ? t.onSecondaryMessageReceived_(n) : t.log_("message on old connection"));
          };
        }, e.prototype.sendRequest = function (e) {
          var t = {
            t: "d",
            d: e
          };
          this.sendData_(t);
        }, e.prototype.tryCleanupConnection = function () {
          this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_ && (this.log_("cleaning up and promoting a connection: " + this.secondaryConn_.connId), this.conn_ = this.secondaryConn_, this.secondaryConn_ = null);
        }, e.prototype.onSecondaryControl_ = function (e) {
          if ("t" in e) {
            var t = e.t;
            "a" === t ? this.upgradeIfSecondaryHealthy_() : "r" === t ? (this.log_("Got a reset on secondary, closing it"), this.secondaryConn_.close(), this.tx_ !== this.secondaryConn_ && this.rx_ !== this.secondaryConn_ || this.close()) : "o" === t && (this.log_("got pong on secondary."), this.secondaryResponsesRequired_--, this.upgradeIfSecondaryHealthy_());
          }
        }, e.prototype.onSecondaryMessageReceived_ = function (e) {
          var t = Y("t", e),
              n = Y("d", e);
          if ("c" === t) this.onSecondaryControl_(n);else {
            if ("d" !== t) throw new Error("Unknown protocol layer: " + t);
            this.pendingDataMessages.push(n);
          }
        }, e.prototype.upgradeIfSecondaryHealthy_ = function () {
          this.secondaryResponsesRequired_ <= 0 ? (this.log_("Secondary connection is healthy."), this.isHealthy_ = !0, this.secondaryConn_.markConnectionHealthy(), this.proceedWithUpgrade_()) : (this.log_("sending ping on secondary."), this.secondaryConn_.send({
            t: "c",
            d: {
              t: "p",
              d: {}
            }
          }));
        }, e.prototype.proceedWithUpgrade_ = function () {
          this.secondaryConn_.start(), this.log_("sending client ack on secondary"), this.secondaryConn_.send({
            t: "c",
            d: {
              t: "a",
              d: {}
            }
          }), this.log_("Ending transmission on primary"), this.conn_.send({
            t: "c",
            d: {
              t: "n",
              d: {}
            }
          }), this.tx_ = this.secondaryConn_, this.tryCleanupConnection();
        }, e.prototype.onPrimaryMessageReceived_ = function (e) {
          var t = Y("t", e),
              n = Y("d", e);
          "c" === t ? this.onControl_(n) : "d" === t && this.onDataMessage_(n);
        }, e.prototype.onDataMessage_ = function (e) {
          this.onPrimaryResponse_(), this.onMessage_(e);
        }, e.prototype.onPrimaryResponse_ = function () {
          this.isHealthy_ || (this.primaryResponsesRequired_--, this.primaryResponsesRequired_ <= 0 && (this.log_("Primary connection is healthy."), this.isHealthy_ = !0, this.conn_.markConnectionHealthy()));
        }, e.prototype.onControl_ = function (e) {
          var t = Y("t", e);

          if ("d" in e) {
            var n = e.d;
            if ("h" === t) this.onHandshake_(n);else if ("n" === t) {
              this.log_("recvd end transmission on primary"), this.rx_ = this.secondaryConn_;

              for (var r = 0; r < this.pendingDataMessages.length; ++r) {
                this.onDataMessage_(this.pendingDataMessages[r]);
              }

              this.pendingDataMessages = [], this.tryCleanupConnection();
            } else "s" === t ? this.onConnectionShutdown_(n) : "r" === t ? this.onReset_(n) : "e" === t ? k("Server Error: " + n) : "o" === t ? (this.log_("got pong on primary."), this.onPrimaryResponse_(), this.sendPingOnPrimaryIfNecessary_()) : k("Unknown control packet command: " + t);
          }
        }, e.prototype.onHandshake_ = function (e) {
          var t = e.ts,
              n = e.v,
              r = e.h;
          this.sessionId = e.s, this.repoInfo_.updateHost(r), 0 === this.state_ && (this.conn_.start(), this.onConnectionEstablished_(this.conn_, t), "5" !== n && S("Protocol version mismatch detected"), this.tryStartUpgrade_());
        }, e.prototype.tryStartUpgrade_ = function () {
          var e = this.transportManager_.upgradeTransport();
          e && this.startUpgrade_(e);
        }, e.prototype.startUpgrade_ = function (e) {
          var t = this;
          this.secondaryConn_ = new e(this.nextTransportId_(), this.repoInfo_, this.sessionId), this.secondaryResponsesRequired_ = e.responsesRequiredToBeHealthy || 0;
          var n = this.connReceiver_(this.secondaryConn_),
              r = this.disconnReceiver_(this.secondaryConn_);
          this.secondaryConn_.open(n, r), W(function () {
            t.secondaryConn_ && (t.log_("Timed out trying to upgrade."), t.secondaryConn_.close());
          }, Math.floor(6e4));
        }, e.prototype.onReset_ = function (e) {
          this.log_("Reset packet received.  New host: " + e), this.repoInfo_.updateHost(e), 1 === this.state_ ? this.close() : (this.closeConnections_(), this.start_());
        }, e.prototype.onConnectionEstablished_ = function (e, t) {
          var n = this;
          this.log_("Realtime connection established."), this.conn_ = e, this.state_ = 1, this.onReady_ && (this.onReady_(t, this.sessionId), this.onReady_ = null), 0 === this.primaryResponsesRequired_ ? (this.log_("Primary connection is healthy."), this.isHealthy_ = !0) : W(function () {
            n.sendPingOnPrimaryIfNecessary_();
          }, Math.floor(5e3));
        }, e.prototype.sendPingOnPrimaryIfNecessary_ = function () {
          this.isHealthy_ || 1 !== this.state_ || (this.log_("sending ping on primary."), this.sendData_({
            t: "c",
            d: {
              t: "p",
              d: {}
            }
          }));
        }, e.prototype.onSecondaryConnectionLost_ = function () {
          var e = this.secondaryConn_;
          this.secondaryConn_ = null, this.tx_ !== e && this.rx_ !== e || this.close();
        }, e.prototype.onConnectionLost_ = function (e) {
          this.conn_ = null, e || 0 !== this.state_ ? 1 === this.state_ && this.log_("Realtime connection lost.") : (this.log_("Realtime connection failed."), this.repoInfo_.isCacheableHost() && (p.remove("host:" + this.repoInfo_.host), this.repoInfo_.internalHost = this.repoInfo_.host)), this.close();
        }, e.prototype.onConnectionShutdown_ = function (e) {
          this.log_("Connection shutdown command received. Shutting down..."), this.onKill_ && (this.onKill_(e), this.onKill_ = null), this.onDisconnect_ = null, this.close();
        }, e.prototype.sendData_ = function (e) {
          if (1 !== this.state_) throw "Connection is not connected";
          this.tx_.send(e);
        }, e.prototype.close = function () {
          2 !== this.state_ && (this.log_("Closing realtime connection."), this.state_ = 2, this.closeConnections_(), this.onDisconnect_ && (this.onDisconnect_(), this.onDisconnect_ = null));
        }, e.prototype.closeConnections_ = function () {
          this.log_("Shutting down all connections"), this.conn_ && (this.conn_.close(), this.conn_ = null), this.secondaryConn_ && (this.secondaryConn_.close(), this.secondaryConn_ = null), this.healthyTimeout_ && (clearTimeout(this.healthyTimeout_), this.healthyTimeout_ = null);
        }, e;
      }(),
          on = function () {
        function e() {}

        return e.prototype.put = function (e, t, n, r) {}, e.prototype.merge = function (e, t, n, r) {}, e.prototype.refreshAuthToken = function (e) {}, e.prototype.onDisconnectPut = function (e, t, n) {}, e.prototype.onDisconnectMerge = function (e, t, n) {}, e.prototype.onDisconnectCancel = function (e, t) {}, e.prototype.reportStats = function (e) {}, e;
      }(),
          an = 1e3,
          sn = 3e5,
          un = function (e) {
        function t(n, r, i, o, a, s) {
          var c = e.call(this) || this;
          if (c.repoInfo_ = n, c.onDataUpdate_ = r, c.onConnectStatus_ = i, c.onServerInfoUpdate_ = o, c.authTokenProvider_ = a, c.authOverride_ = s, c.id = t.nextPersistentConnectionId_++, c.log_ = E("p:" + c.id + ":"), c.interruptReasons_ = {}, c.listens = new Map(), c.outstandingPuts_ = [], c.outstandingPutCount_ = 0, c.onDisconnectRequestQueue_ = [], c.connected_ = !1, c.reconnectDelay_ = an, c.maxReconnectDelay_ = sn, c.securityDebugCallback_ = null, c.lastSessionId = null, c.establishConnectionTimer_ = null, c.visible_ = !1, c.requestCBHash_ = {}, c.requestNumber_ = 0, c.realtime_ = null, c.authToken_ = null, c.forceTokenRefresh_ = !1, c.invalidAuthTokenCount_ = 0, c.firstConnection_ = !0, c.lastConnectionAttemptTime_ = null, c.lastConnectionEstablishedTime_ = null, s && !u.isNodeSdk()) throw new Error("Auth override specified in options, but not supported on non Node.js platforms");
          return c.scheduleConnect_(0), Zt.getInstance().on("visible", c.onVisible_, c), -1 === n.host.indexOf("fblocal") && Qt.getInstance().on("online", c.onOnline_, c), c;
        }

        return s.__extends(t, e), t.prototype.sendRequest = function (e, t, n) {
          var r = ++this.requestNumber_,
              i = {
            r: r,
            a: e,
            b: t
          };
          this.log_(u.stringify(i)), u.assert(this.connected_, "sendRequest call when we're not connected not allowed."), this.realtime_.sendRequest(i), n && (this.requestCBHash_[r] = n);
        }, t.prototype.listen = function (e, t, n, r) {
          var i = e.queryIdentifier(),
              o = e.path.toString();
          this.log_("Listen called for " + o + " " + i), this.listens.has(o) || this.listens.set(o, new Map()), u.assert(e.getQueryParams().isDefault() || !e.getQueryParams().loadsAllData(), "listen() called for non-default but complete query"), u.assert(!this.listens.get(o).has(i), "listen() called twice for same path/queryId.");
          var a = {
            onComplete: r,
            hashFn: t,
            query: e,
            tag: n
          };
          this.listens.get(o).set(i, a), this.connected_ && this.sendListen_(a);
        }, t.prototype.sendListen_ = function (e) {
          var n = this,
              r = e.query,
              i = r.path.toString(),
              o = r.queryIdentifier();
          this.log_("Listen on " + i + " for " + o);
          var a = {
            p: i
          };
          e.tag && (a.q = r.queryObject(), a.t = e.tag), a.h = e.hashFn(), this.sendRequest("q", a, function (a) {
            var s = a.d,
                u = a.s;
            t.warnOnListenWarnings_(s, r), (n.listens.get(i) && n.listens.get(i).get(o)) === e && (n.log_("listen response", a), "ok" !== u && n.removeListen_(i, o), e.onComplete && e.onComplete(u, s));
          });
        }, t.warnOnListenWarnings_ = function (e, t) {
          if (e && "object" == typeof e && u.contains(e, "w")) {
            var n = u.safeGet(e, "w");

            if (Array.isArray(n) && ~n.indexOf("no_index")) {
              var r = '".indexOn": "' + t.getQueryParams().getIndex().toString() + '"',
                  i = t.path.toString();
              S("Using an unspecified index. Your data will be downloaded and filtered on the client. Consider adding " + r + " at " + i + " to your security rules for better performance.");
            }
          }
        }, t.prototype.refreshAuthToken = function (e) {
          this.authToken_ = e, this.log_("Auth token refreshed"), this.authToken_ ? this.tryAuth() : this.connected_ && this.sendRequest("unauth", {}, function () {}), this.reduceReconnectDelayIfAdminCredential_(e);
        }, t.prototype.reduceReconnectDelayIfAdminCredential_ = function (e) {
          (e && 40 === e.length || u.isAdmin(e)) && (this.log_("Admin auth credential detected.  Reducing max reconnect time."), this.maxReconnectDelay_ = 3e4);
        }, t.prototype.tryAuth = function () {
          var e = this;

          if (this.connected_ && this.authToken_) {
            var t = this.authToken_,
                n = u.isValidFormat(t) ? "auth" : "gauth",
                r = {
              cred: t
            };
            null === this.authOverride_ ? r.noauth = !0 : "object" == typeof this.authOverride_ && (r.authvar = this.authOverride_), this.sendRequest(n, r, function (n) {
              var r = n.s,
                  i = n.d || "error";
              e.authToken_ === t && ("ok" === r ? e.invalidAuthTokenCount_ = 0 : e.onAuthRevoked_(r, i));
            });
          }
        }, t.prototype.unlisten = function (e, t) {
          var n = e.path.toString(),
              r = e.queryIdentifier();
          this.log_("Unlisten called for " + n + " " + r), u.assert(e.getQueryParams().isDefault() || !e.getQueryParams().loadsAllData(), "unlisten() called for non-default but complete query"), this.removeListen_(n, r) && this.connected_ && this.sendUnlisten_(n, r, e.queryObject(), t);
        }, t.prototype.sendUnlisten_ = function (e, t, n, r) {
          this.log_("Unlisten on " + e + " for " + t);
          var i = {
            p: e
          };
          r && (i.q = n, i.t = r), this.sendRequest("n", i);
        }, t.prototype.onDisconnectPut = function (e, t, n) {
          this.connected_ ? this.sendOnDisconnect_("o", e, t, n) : this.onDisconnectRequestQueue_.push({
            pathString: e,
            action: "o",
            data: t,
            onComplete: n
          });
        }, t.prototype.onDisconnectMerge = function (e, t, n) {
          this.connected_ ? this.sendOnDisconnect_("om", e, t, n) : this.onDisconnectRequestQueue_.push({
            pathString: e,
            action: "om",
            data: t,
            onComplete: n
          });
        }, t.prototype.onDisconnectCancel = function (e, t) {
          this.connected_ ? this.sendOnDisconnect_("oc", e, null, t) : this.onDisconnectRequestQueue_.push({
            pathString: e,
            action: "oc",
            data: null,
            onComplete: t
          });
        }, t.prototype.sendOnDisconnect_ = function (e, t, n, r) {
          var i = {
            p: t,
            d: n
          };
          this.log_("onDisconnect " + e, i), this.sendRequest(e, i, function (e) {
            r && setTimeout(function () {
              r(e.s, e.d);
            }, Math.floor(0));
          });
        }, t.prototype.put = function (e, t, n, r) {
          this.putInternal("p", e, t, n, r);
        }, t.prototype.merge = function (e, t, n, r) {
          this.putInternal("m", e, t, n, r);
        }, t.prototype.putInternal = function (e, t, n, r, i) {
          var o = {
            p: t,
            d: n
          };
          void 0 !== i && (o.h = i), this.outstandingPuts_.push({
            action: e,
            request: o,
            onComplete: r
          }), this.outstandingPutCount_++;
          var a = this.outstandingPuts_.length - 1;
          this.connected_ ? this.sendPut_(a) : this.log_("Buffering put: " + t);
        }, t.prototype.sendPut_ = function (e) {
          var t = this,
              n = this.outstandingPuts_[e].action,
              r = this.outstandingPuts_[e].request,
              i = this.outstandingPuts_[e].onComplete;
          this.outstandingPuts_[e].queued = this.connected_, this.sendRequest(n, r, function (r) {
            t.log_(n + " response", r), delete t.outstandingPuts_[e], t.outstandingPutCount_--, 0 === t.outstandingPutCount_ && (t.outstandingPuts_ = []), i && i(r.s, r.d);
          });
        }, t.prototype.reportStats = function (e) {
          var t = this;

          if (this.connected_) {
            var n = {
              c: e
            };
            this.log_("reportStats", n), this.sendRequest("s", n, function (e) {
              if ("ok" !== e.s) {
                var n = e.d;
                t.log_("reportStats", "Error sending stats: " + n);
              }
            });
          }
        }, t.prototype.onDataMessage_ = function (e) {
          if ("r" in e) {
            this.log_("from server: " + u.stringify(e));
            var t = e.r,
                n = this.requestCBHash_[t];
            n && (delete this.requestCBHash_[t], n(e.b));
          } else {
            if ("error" in e) throw "A server-side error has occurred: " + e.error;
            "a" in e && this.onDataPush_(e.a, e.b);
          }
        }, t.prototype.onDataPush_ = function (e, t) {
          this.log_("handleServerMessage", e, t), "d" === e ? this.onDataUpdate_(t.p, t.d, !1, t.t) : "m" === e ? this.onDataUpdate_(t.p, t.d, !0, t.t) : "c" === e ? this.onListenRevoked_(t.p, t.q) : "ac" === e ? this.onAuthRevoked_(t.s, t.d) : "sd" === e ? this.onSecurityDebugPacket_(t) : k("Unrecognized action received from server: " + u.stringify(e) + "\nAre you using the latest client?");
        }, t.prototype.onReady_ = function (e, t) {
          this.log_("connection ready"), this.connected_ = !0, this.lastConnectionEstablishedTime_ = new Date().getTime(), this.handleTimestamp_(e), this.lastSessionId = t, this.firstConnection_ && this.sendConnectStats_(), this.restoreState_(), this.firstConnection_ = !1, this.onConnectStatus_(!0);
        }, t.prototype.scheduleConnect_ = function (e) {
          var t = this;
          u.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?"), this.establishConnectionTimer_ && clearTimeout(this.establishConnectionTimer_), this.establishConnectionTimer_ = setTimeout(function () {
            t.establishConnectionTimer_ = null, t.establishConnection_();
          }, Math.floor(e));
        }, t.prototype.onVisible_ = function (e) {
          e && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_ && (this.log_("Window became visible.  Reducing delay."), this.reconnectDelay_ = an, this.realtime_ || this.scheduleConnect_(0)), this.visible_ = e;
        }, t.prototype.onOnline_ = function (e) {
          e ? (this.log_("Browser went online."), this.reconnectDelay_ = an, this.realtime_ || this.scheduleConnect_(0)) : (this.log_("Browser went offline.  Killing connection."), this.realtime_ && this.realtime_.close());
        }, t.prototype.onRealtimeDisconnect_ = function () {
          if (this.log_("data client disconnected"), this.connected_ = !1, this.realtime_ = null, this.cancelSentTransactions_(), this.requestCBHash_ = {}, this.shouldReconnect_()) {
            if (this.visible_) {
              if (this.lastConnectionEstablishedTime_) {
                new Date().getTime() - this.lastConnectionEstablishedTime_ > 3e4 && (this.reconnectDelay_ = an), this.lastConnectionEstablishedTime_ = null;
              }
            } else this.log_("Window isn't visible.  Delaying reconnect."), this.reconnectDelay_ = this.maxReconnectDelay_, this.lastConnectionAttemptTime_ = new Date().getTime();

            var e = new Date().getTime() - this.lastConnectionAttemptTime_,
                t = Math.max(0, this.reconnectDelay_ - e);
            t = Math.random() * t, this.log_("Trying to reconnect in " + t + "ms"), this.scheduleConnect_(t), this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, 1.3 * this.reconnectDelay_);
          }

          this.onConnectStatus_(!1);
        }, t.prototype.establishConnection_ = function () {
          if (this.shouldReconnect_()) {
            this.log_("Making a connection attempt"), this.lastConnectionAttemptTime_ = new Date().getTime(), this.lastConnectionEstablishedTime_ = null;

            var e = this.onDataMessage_.bind(this),
                n = this.onReady_.bind(this),
                r = this.onRealtimeDisconnect_.bind(this),
                i = this.id + ":" + t.nextConnectionId_++,
                o = this,
                a = this.lastSessionId,
                s = !1,
                c = null,
                l = function l() {
              c ? c.close() : (s = !0, r());
            };

            this.realtime_ = {
              close: l,
              sendRequest: function sendRequest(e) {
                u.assert(c, "sendRequest call when we're not connected not allowed."), c.sendRequest(e);
              }
            };
            var h = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = !1, this.authTokenProvider_.getToken(h).then(function (t) {
              s ? M("getToken() completed but was canceled") : (M("getToken() completed. Creating connection."), o.authToken_ = t && t.accessToken, c = new rn(i, o.repoInfo_, e, n, r, function (e) {
                S(e + " (" + o.repoInfo_.toString() + ")"), o.interrupt("server_kill");
              }, a));
            }).then(null, function (e) {
              o.log_("Failed to get token: " + e), s || (u.CONSTANTS.NODE_ADMIN && S(e), l());
            });
          }
        }, t.prototype.interrupt = function (e) {
          M("Interrupting connection for reason: " + e), this.interruptReasons_[e] = !0, this.realtime_ ? this.realtime_.close() : (this.establishConnectionTimer_ && (clearTimeout(this.establishConnectionTimer_), this.establishConnectionTimer_ = null), this.connected_ && this.onRealtimeDisconnect_());
        }, t.prototype.resume = function (e) {
          M("Resuming connection for reason: " + e), delete this.interruptReasons_[e], u.isEmpty(this.interruptReasons_) && (this.reconnectDelay_ = an, this.realtime_ || this.scheduleConnect_(0));
        }, t.prototype.handleTimestamp_ = function (e) {
          var t = e - new Date().getTime();
          this.onServerInfoUpdate_({
            serverTimeOffset: t
          });
        }, t.prototype.cancelSentTransactions_ = function () {
          for (var e = 0; e < this.outstandingPuts_.length; e++) {
            var t = this.outstandingPuts_[e];
            t && "h" in t.request && t.queued && (t.onComplete && t.onComplete("disconnect"), delete this.outstandingPuts_[e], this.outstandingPutCount_--);
          }

          0 === this.outstandingPutCount_ && (this.outstandingPuts_ = []);
        }, t.prototype.onListenRevoked_ = function (e, t) {
          var n;
          n = t ? t.map(function (e) {
            return C(e);
          }).join("$") : "default";
          var r = this.removeListen_(e, n);
          r && r.onComplete && r.onComplete("permission_denied");
        }, t.prototype.removeListen_ = function (e, t) {
          var n,
              r = new H(e).toString();

          if (this.listens.has(r)) {
            var i = this.listens.get(r);
            n = i.get(t), i.delete(t), 0 === i.size && this.listens.delete(r);
          } else n = void 0;

          return n;
        }, t.prototype.onAuthRevoked_ = function (e, t) {
          M("Auth token revoked: " + e + "/" + t), this.authToken_ = null, this.forceTokenRefresh_ = !0, this.realtime_.close(), "invalid_token" !== e && "permission_denied" !== e || (this.invalidAuthTokenCount_++, this.invalidAuthTokenCount_ >= 3 && (this.reconnectDelay_ = 3e4, this.authTokenProvider_.notifyForInvalidToken()));
        }, t.prototype.onSecurityDebugPacket_ = function (e) {
          this.securityDebugCallback_ ? this.securityDebugCallback_(e) : "msg" in e && console.log("FIREBASE: " + e.msg.replace("\n", "\nFIREBASE: "));
        }, t.prototype.restoreState_ = function () {
          var e, t, n, r;
          this.tryAuth();

          try {
            for (var i = s.__values(this.listens.values()), o = i.next(); !o.done; o = i.next()) {
              var a = o.value;

              try {
                for (var u = (n = void 0, s.__values(a.values())), c = u.next(); !c.done; c = u.next()) {
                  var l = c.value;
                  this.sendListen_(l);
                }
              } catch (e) {
                n = {
                  error: e
                };
              } finally {
                try {
                  c && !c.done && (r = u.return) && r.call(u);
                } finally {
                  if (n) throw n.error;
                }
              }
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              o && !o.done && (t = i.return) && t.call(i);
            } finally {
              if (e) throw e.error;
            }
          }

          for (var h = 0; h < this.outstandingPuts_.length; h++) {
            this.outstandingPuts_[h] && this.sendPut_(h);
          }

          for (; this.onDisconnectRequestQueue_.length;) {
            var d = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(d.action, d.pathString, d.data, d.onComplete);
          }
        }, t.prototype.sendConnectStats_ = function () {
          var e = {},
              t = "js";
          u.CONSTANTS.NODE_ADMIN ? t = "admin_node" : u.CONSTANTS.NODE_CLIENT && (t = "node"), e["sdk." + t + "." + $t.replace(/\./g, "-")] = 1, u.isMobileCordova() ? e["framework.cordova"] = 1 : u.isReactNative() && (e["framework.reactnative"] = 1), this.reportStats(e);
        }, t.prototype.shouldReconnect_ = function () {
          var e = Qt.getInstance().currentlyOnline();
          return u.isEmpty(this.interruptReasons_) && e;
        }, t.nextPersistentConnectionId_ = 0, t.nextConnectionId_ = 0, t;
      }(on),
          cn = function (e) {
        function t(t, n, r) {
          var i = e.call(this) || this;
          return i.repoInfo_ = t, i.onDataUpdate_ = n, i.authTokenProvider_ = r, i.log_ = E("p:rest:"), i.listens_ = {}, i;
        }

        return s.__extends(t, e), t.prototype.reportStats = function (e) {
          throw new Error("Method not implemented.");
        }, t.getListenId_ = function (e, t) {
          return void 0 !== t ? "tag$" + t : (u.assert(e.getQueryParams().isDefault(), "should have a tag if it's not a default query."), e.path.toString());
        }, t.prototype.listen = function (e, n, r, i) {
          var o = this,
              a = e.path.toString();
          this.log_("Listen called for " + a + " " + e.queryIdentifier());
          var s = t.getListenId_(e, r),
              c = {};
          this.listens_[s] = c;
          var l = e.getQueryParams().toRestQueryStringParameters();
          this.restRequest_(a + ".json", l, function (e, t) {
            var n = t;
            (404 === e && (n = null, e = null), null === e && o.onDataUpdate_(a, n, !1, r), u.safeGet(o.listens_, s) === c) && i(e ? 401 === e ? "permission_denied" : "rest_error:" + e : "ok", null);
          });
        }, t.prototype.unlisten = function (e, n) {
          var r = t.getListenId_(e, n);
          delete this.listens_[r];
        }, t.prototype.refreshAuthToken = function (e) {}, t.prototype.restRequest_ = function (e, t, n) {
          var r = this;
          void 0 === t && (t = {}), t.format = "export", this.authTokenProvider_.getToken(!1).then(function (i) {
            var o = i && i.accessToken;
            o && (t.auth = o);
            var a = (r.repoInfo_.secure ? "https://" : "http://") + r.repoInfo_.host + e + "?ns=" + r.repoInfo_.namespace + u.querystring(t);
            r.log_("Sending REST request for " + a);
            var s = new XMLHttpRequest();
            s.onreadystatechange = function () {
              if (n && 4 === s.readyState) {
                r.log_("REST Response for " + a + " received. status:", s.status, "response:", s.responseText);
                var e = null;

                if (s.status >= 200 && s.status < 300) {
                  try {
                    e = u.jsonEval(s.responseText);
                  } catch (e) {
                    S("Failed to parse JSON response for " + a + ": " + s.responseText);
                  }

                  n(null, e);
                } else 401 !== s.status && 404 !== s.status && S("Got unsuccessful REST response for " + a + " Status: " + s.status), n(s.status);

                n = null;
              }
            }, s.open("GET", a, !0), s.send();
          });
        }, t;
      }(on),
          ln = function () {
        function e(e, t, n, r) {
          var i = this;
          this.repoInfo_ = e, this.app = n, this.dataUpdateCount = 0, this.statsListener_ = null, this.eventQueue_ = new Ht(), this.nextWriteId_ = 1, this.interceptServerDataCallback_ = null, this.onDisconnect_ = new ct(), this.persistentConnection_ = null;
          var o = new Ft(n, r);
          if (this.stats_ = jt.getCollection(e), t || V()) this.server_ = new cn(this.repoInfo_, this.onDataUpdate_.bind(this), o), setTimeout(this.onConnectStatus_.bind(this, !0), 0);else {
            var a = n.options.databaseAuthVariableOverride;

            if (null != a) {
              if ("object" != typeof a) throw new Error("Only objects are supported for option databaseAuthVariableOverride");

              try {
                u.stringify(a);
              } catch (e) {
                throw new Error("Invalid authOverride provided: " + e);
              }
            }

            this.persistentConnection_ = new un(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), o, a), this.server_ = this.persistentConnection_;
          }
          o.addTokenChangeListener(function (e) {
            i.server_.refreshAuthToken(e);
          }), this.statsReporter_ = jt.getOrCreateReporter(e, function () {
            return new Wt(i.stats_, i.server_);
          }), this.transactionsInit_(), this.infoData_ = new Ot(), this.infoSyncTree_ = new Ct({
            startListening: function startListening(e, t, n, r) {
              var o = [],
                  a = i.infoData_.getNode(e.path);
              return a.isEmpty() || (o = i.infoSyncTree_.applyServerOverwrite(e.path, a), setTimeout(function () {
                r("ok");
              }, 0)), o;
            },
            stopListening: function stopListening() {}
          }), this.updateInfo_("connected", !1), this.serverSyncTree_ = new Ct({
            startListening: function startListening(e, t, n, r) {
              return i.server_.listen(e, n, t, function (t, n) {
                var o = r(t, n);
                i.eventQueue_.raiseEventsForChangedPath(e.path, o);
              }), [];
            },
            stopListening: function stopListening(e, t) {
              i.server_.unlisten(e, t);
            }
          });
        }

        return e.prototype.toString = function () {
          return (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host;
        }, e.prototype.name = function () {
          return this.repoInfo_.namespace;
        }, e.prototype.serverTime = function () {
          var e = this.infoData_.getNode(new H(".info/serverTimeOffset")).val() || 0;
          return new Date().getTime() + e;
        }, e.prototype.generateServerValues = function () {
          return (e = (e = {
            timestamp: this.serverTime()
          }) || {}).timestamp = e.timestamp || new Date().getTime(), e;
          var e;
        }, e.prototype.onDataUpdate_ = function (e, t, n, r) {
          this.dataUpdateCount++;
          var i = new H(e);
          t = this.interceptServerDataCallback_ ? this.interceptServerDataCallback_(e, t) : t;
          var o = [];
          if (r) {
            if (n) {
              var a = u.map(t, function (e) {
                return Be(e);
              });
              o = this.serverSyncTree_.applyTaggedQueryMerge(i, a, r);
            } else {
              var s = Be(t);
              o = this.serverSyncTree_.applyTaggedQueryOverwrite(i, s, r);
            }
          } else if (n) {
            var c = u.map(t, function (e) {
              return Be(e);
            });
            o = this.serverSyncTree_.applyServerMerge(i, c);
          } else {
            var l = Be(t);
            o = this.serverSyncTree_.applyServerOverwrite(i, l);
          }
          var h = i;
          o.length > 0 && (h = this.rerunTransactions_(i)), this.eventQueue_.raiseEventsForChangedPath(h, o);
        }, e.prototype.interceptServerData_ = function (e) {
          this.interceptServerDataCallback_ = e;
        }, e.prototype.onConnectStatus_ = function (e) {
          this.updateInfo_("connected", e), !1 === e && this.runOnDisconnectEvents_();
        }, e.prototype.onServerInfoUpdate_ = function (e) {
          var t = this;
          F(e, function (e, n) {
            t.updateInfo_(e, n);
          });
        }, e.prototype.updateInfo_ = function (e, t) {
          var n = new H("/.info/" + e),
              r = Be(t);
          this.infoData_.updateSnapshot(n, r);
          var i = this.infoSyncTree_.applyServerOverwrite(n, r);
          this.eventQueue_.raiseEventsForChangedPath(n, i);
        }, e.prototype.getNextWriteId_ = function () {
          return this.nextWriteId_++;
        }, e.prototype.setWithPriority = function (e, t, n, r) {
          var i = this;
          this.log_("set", {
            path: e.toString(),
            value: t,
            priority: n
          });
          var o = this.generateServerValues(),
              a = Be(t, n),
              s = this.serverSyncTree_.calcCompleteEventCache(e),
              u = at(a, s, o),
              c = this.getNextWriteId_(),
              l = this.serverSyncTree_.applyUserOverwrite(e, u, c, !0);
          this.eventQueue_.queueEvents(l), this.server_.put(e.toString(), a.val(!0), function (t, n) {
            var o = "ok" === t;
            o || S("set at " + e + " failed: " + t);
            var a = i.serverSyncTree_.ackUserWrite(c, !o);
            i.eventQueue_.raiseEventsForChangedPath(e, a), i.callOnCompleteCallback(r, t, n);
          });
          var h = this.abortTransactions_(e);
          this.rerunTransactions_(h), this.eventQueue_.raiseEventsForChangedPath(h, []);
        }, e.prototype.update = function (e, t, n) {
          var r = this;
          this.log_("update", {
            path: e.toString(),
            value: t
          });
          var i = !0,
              o = this.generateServerValues(),
              a = {};
          if (F(t, function (t, n) {
            i = !1, a[t] = ot(e.child(t), Be(n), r.serverSyncTree_, o);
          }), i) M("update() called with empty data.  Don't do anything."), this.callOnCompleteCallback(n, "ok");else {
            var s = this.getNextWriteId_(),
                u = this.serverSyncTree_.applyUserMerge(e, a, s);
            this.eventQueue_.queueEvents(u), this.server_.merge(e.toString(), t, function (t, i) {
              var o = "ok" === t;
              o || S("update at " + e + " failed: " + t);
              var a = r.serverSyncTree_.ackUserWrite(s, !o),
                  u = a.length > 0 ? r.rerunTransactions_(e) : e;
              r.eventQueue_.raiseEventsForChangedPath(u, a), r.callOnCompleteCallback(n, t, i);
            }), F(t, function (t) {
              var n = r.abortTransactions_(e.child(t));
              r.rerunTransactions_(n);
            }), this.eventQueue_.raiseEventsForChangedPath(e, []);
          }
        }, e.prototype.runOnDisconnectEvents_ = function () {
          var e = this;
          this.log_("onDisconnectEvents");
          var t = this.generateServerValues(),
              n = new ct();
          this.onDisconnect_.forEachTree(H.Empty, function (r, i) {
            var o = ot(r, i, e.serverSyncTree_, t);
            n.remember(r, o);
          });
          var r = [];
          n.forEachTree(H.Empty, function (t, n) {
            r = r.concat(e.serverSyncTree_.applyServerOverwrite(t, n));
            var i = e.abortTransactions_(t);
            e.rerunTransactions_(i);
          }), this.onDisconnect_ = new ct(), this.eventQueue_.raiseEventsForChangedPath(H.Empty, r);
        }, e.prototype.onDisconnectCancel = function (e, t) {
          var n = this;
          this.server_.onDisconnectCancel(e.toString(), function (r, i) {
            "ok" === r && n.onDisconnect_.forget(e), n.callOnCompleteCallback(t, r, i);
          });
        }, e.prototype.onDisconnectSet = function (e, t, n) {
          var r = this,
              i = Be(t);
          this.server_.onDisconnectPut(e.toString(), i.val(!0), function (t, o) {
            "ok" === t && r.onDisconnect_.remember(e, i), r.callOnCompleteCallback(n, t, o);
          });
        }, e.prototype.onDisconnectSetWithPriority = function (e, t, n, r) {
          var i = this,
              o = Be(t, n);
          this.server_.onDisconnectPut(e.toString(), o.val(!0), function (t, n) {
            "ok" === t && i.onDisconnect_.remember(e, o), i.callOnCompleteCallback(r, t, n);
          });
        }, e.prototype.onDisconnectUpdate = function (e, t, n) {
          var r = this;
          if (u.isEmpty(t)) return M("onDisconnect().update() called with empty data.  Don't do anything."), void this.callOnCompleteCallback(n, "ok");
          this.server_.onDisconnectMerge(e.toString(), t, function (i, o) {
            "ok" === i && F(t, function (t, n) {
              var i = Be(n);
              r.onDisconnect_.remember(e.child(t), i);
            }), r.callOnCompleteCallback(n, i, o);
          });
        }, e.prototype.addEventCallbackForQuery = function (e, t) {
          var n;
          n = ".info" === e.path.getFront() ? this.infoSyncTree_.addEventRegistration(e, t) : this.serverSyncTree_.addEventRegistration(e, t), this.eventQueue_.raiseEventsAtPath(e.path, n);
        }, e.prototype.removeEventCallbackForQuery = function (e, t) {
          var n;
          n = ".info" === e.path.getFront() ? this.infoSyncTree_.removeEventRegistration(e, t) : this.serverSyncTree_.removeEventRegistration(e, t), this.eventQueue_.raiseEventsAtPath(e.path, n);
        }, e.prototype.interrupt = function () {
          this.persistentConnection_ && this.persistentConnection_.interrupt("repo_interrupt");
        }, e.prototype.resume = function () {
          this.persistentConnection_ && this.persistentConnection_.resume("repo_interrupt");
        }, e.prototype.stats = function (e) {
          if (void 0 === e && (e = !1), "undefined" != typeof console) {
            var t;
            e ? (this.statsListener_ || (this.statsListener_ = new Ut(this.stats_)), t = this.statsListener_.get()) : t = this.stats_.get();
            var n = Object.keys(t).reduce(function (e, t) {
              return Math.max(t.length, e);
            }, 0);
            F(t, function (e, t) {
              for (var r = e, i = e.length; i < n + 2; i++) {
                r += " ";
              }

              console.log(r + t);
            });
          }
        }, e.prototype.statsIncrementCounter = function (e) {
          this.stats_.incrementCounter(e), this.statsReporter_.includeStat(e);
        }, e.prototype.log_ = function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          var n = "";
          this.persistentConnection_ && (n = this.persistentConnection_.id + ":"), M.apply(void 0, s.__spread([n], e));
        }, e.prototype.callOnCompleteCallback = function (e, t, n) {
          e && P(function () {
            if ("ok" === t) e(null);else {
              var r = (t || "error").toUpperCase(),
                  i = r;
              n && (i += ": " + n);
              var o = new Error(i);
              o.code = r, e(o);
            }
          });
        }, Object.defineProperty(e.prototype, "database", {
          get: function get() {
            return this.__database || (this.__database = new bn(this));
          },
          enumerable: !0,
          configurable: !0
        }), e;
      }(),
          hn = function () {
        function e(t) {
          this.indexedFilter_ = new Tt(t.getIndex()), this.index_ = t.getIndex(), this.startPost_ = e.getStartPost_(t), this.endPost_ = e.getEndPost_(t);
        }

        return e.prototype.getStartPost = function () {
          return this.startPost_;
        }, e.prototype.getEndPost = function () {
          return this.endPost_;
        }, e.prototype.matches = function (e) {
          return this.index_.compare(this.getStartPost(), e) <= 0 && this.index_.compare(e, this.getEndPost()) <= 0;
        }, e.prototype.updateChild = function (e, t, n, r, i, o) {
          return this.matches(new ye(t, n)) || (n = Ve.EMPTY_NODE), this.indexedFilter_.updateChild(e, t, n, r, i, o);
        }, e.prototype.updateFullNode = function (e, t, n) {
          t.isLeafNode() && (t = Ve.EMPTY_NODE);
          var r = t.withIndex(this.index_);
          r = r.updatePriority(Ve.EMPTY_NODE);
          var i = this;
          return t.forEachChild(De, function (e, t) {
            i.matches(new ye(e, t)) || (r = r.updateImmediateChild(e, Ve.EMPTY_NODE));
          }), this.indexedFilter_.updateFullNode(e, r, n);
        }, e.prototype.updatePriority = function (e, t) {
          return e;
        }, e.prototype.filtersNodes = function () {
          return !0;
        }, e.prototype.getIndexedFilter = function () {
          return this.indexedFilter_;
        }, e.prototype.getIndex = function () {
          return this.index_;
        }, e.getStartPost_ = function (e) {
          if (e.hasStart()) {
            var t = e.getIndexStartName();
            return e.getIndex().makePost(e.getIndexStartValue(), t);
          }

          return e.getIndex().minPost();
        }, e.getEndPost_ = function (e) {
          if (e.hasEnd()) {
            var t = e.getIndexEndName();
            return e.getIndex().makePost(e.getIndexEndValue(), t);
          }

          return e.getIndex().maxPost();
        }, e;
      }(),
          dn = function () {
        function e(e) {
          this.rangedFilter_ = new hn(e), this.index_ = e.getIndex(), this.limit_ = e.getLimit(), this.reverse_ = !e.isViewFromLeft();
        }

        return e.prototype.updateChild = function (e, t, n, r, i, o) {
          return this.rangedFilter_.matches(new ye(t, n)) || (n = Ve.EMPTY_NODE), e.getImmediateChild(t).equals(n) ? e : e.numChildren() < this.limit_ ? this.rangedFilter_.getIndexedFilter().updateChild(e, t, n, r, i, o) : this.fullLimitUpdateChild_(e, t, n, i, o);
        }, e.prototype.updateFullNode = function (e, t, n) {
          var r;
          if (t.isLeafNode() || t.isEmpty()) r = Ve.EMPTY_NODE.withIndex(this.index_);else if (2 * this.limit_ < t.numChildren() && t.isIndexed(this.index_)) {
            r = Ve.EMPTY_NODE.withIndex(this.index_);
            var i = void 0;
            i = this.reverse_ ? t.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_) : t.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);

            for (var o = 0; i.hasNext() && o < this.limit_;) {
              var a = i.getNext();
              if (!(this.reverse_ ? this.index_.compare(this.rangedFilter_.getStartPost(), a) <= 0 : this.index_.compare(a, this.rangedFilter_.getEndPost()) <= 0)) break;
              r = r.updateImmediateChild(a.name, a.node), o++;
            }
          } else {
            r = (r = t.withIndex(this.index_)).updatePriority(Ve.EMPTY_NODE);
            var s = void 0,
                u = void 0,
                c = void 0;
            i = void 0;

            if (this.reverse_) {
              i = r.getReverseIterator(this.index_), s = this.rangedFilter_.getEndPost(), u = this.rangedFilter_.getStartPost();
              var l = this.index_.getCompare();

              c = function c(e, t) {
                return l(t, e);
              };
            } else i = r.getIterator(this.index_), s = this.rangedFilter_.getStartPost(), u = this.rangedFilter_.getEndPost(), c = this.index_.getCompare();

            o = 0;

            for (var h = !1; i.hasNext();) {
              a = i.getNext();
              !h && c(s, a) <= 0 && (h = !0), h && o < this.limit_ && c(a, u) <= 0 ? o++ : r = r.updateImmediateChild(a.name, Ve.EMPTY_NODE);
            }
          }
          return this.rangedFilter_.getIndexedFilter().updateFullNode(e, r, n);
        }, e.prototype.updatePriority = function (e, t) {
          return e;
        }, e.prototype.filtersNodes = function () {
          return !0;
        }, e.prototype.getIndexedFilter = function () {
          return this.rangedFilter_.getIndexedFilter();
        }, e.prototype.getIndex = function () {
          return this.index_;
        }, e.prototype.fullLimitUpdateChild_ = function (e, t, n, r, i) {
          var o;

          if (this.reverse_) {
            var a = this.index_.getCompare();

            o = function o(e, t) {
              return a(t, e);
            };
          } else o = this.index_.getCompare();

          var s = e;
          u.assert(s.numChildren() === this.limit_, "");
          var c = new ye(t, n),
              l = this.reverse_ ? s.getFirstChild(this.index_) : s.getLastChild(this.index_),
              h = this.rangedFilter_.matches(c);

          if (s.hasChild(t)) {
            for (var d = s.getImmediateChild(t), f = r.getChildAfterChild(this.index_, l, this.reverse_); null != f && (f.name === t || s.hasChild(f.name));) {
              f = r.getChildAfterChild(this.index_, f, this.reverse_);
            }

            var p = null == f ? 1 : o(f, c);
            if (h && !n.isEmpty() && p >= 0) return null != i && i.trackChildChange(wt.childChangedChange(t, n, d)), s.updateImmediateChild(t, n);
            null != i && i.trackChildChange(wt.childRemovedChange(t, d));
            var m = s.updateImmediateChild(t, Ve.EMPTY_NODE);
            return null != f && this.rangedFilter_.matches(f) ? (null != i && i.trackChildChange(wt.childAddedChange(f.name, f.node)), m.updateImmediateChild(f.name, f.node)) : m;
          }

          return n.isEmpty() ? e : h && o(l, c) >= 0 ? (null != i && (i.trackChildChange(wt.childRemovedChange(l.name, l.node)), i.trackChildChange(wt.childAddedChange(t, n))), s.updateImmediateChild(t, n).updateImmediateChild(l.name, Ve.EMPTY_NODE)) : e;
        }, e;
      }(),
          fn = function () {
        function e() {
          this.limitSet_ = !1, this.startSet_ = !1, this.startNameSet_ = !1, this.endSet_ = !1, this.endNameSet_ = !1, this.limit_ = 0, this.viewFrom_ = "", this.indexStartValue_ = null, this.indexStartName_ = "", this.indexEndValue_ = null, this.indexEndName_ = "", this.index_ = De;
        }

        return e.prototype.hasStart = function () {
          return this.startSet_;
        }, e.prototype.isViewFromLeft = function () {
          return "" === this.viewFrom_ ? this.startSet_ : this.viewFrom_ === e.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        }, e.prototype.getIndexStartValue = function () {
          return u.assert(this.startSet_, "Only valid if start has been set"), this.indexStartValue_;
        }, e.prototype.getIndexStartName = function () {
          return u.assert(this.startSet_, "Only valid if start has been set"), this.startNameSet_ ? this.indexStartName_ : D;
        }, e.prototype.hasEnd = function () {
          return this.endSet_;
        }, e.prototype.getIndexEndValue = function () {
          return u.assert(this.endSet_, "Only valid if end has been set"), this.indexEndValue_;
        }, e.prototype.getIndexEndName = function () {
          return u.assert(this.endSet_, "Only valid if end has been set"), this.endNameSet_ ? this.indexEndName_ : I;
        }, e.prototype.hasLimit = function () {
          return this.limitSet_;
        }, e.prototype.hasAnchoredLimit = function () {
          return this.limitSet_ && "" !== this.viewFrom_;
        }, e.prototype.getLimit = function () {
          return u.assert(this.limitSet_, "Only valid if limit has been set"), this.limit_;
        }, e.prototype.getIndex = function () {
          return this.index_;
        }, e.prototype.copy_ = function () {
          var t = new e();
          return t.limitSet_ = this.limitSet_, t.limit_ = this.limit_, t.startSet_ = this.startSet_, t.indexStartValue_ = this.indexStartValue_, t.startNameSet_ = this.startNameSet_, t.indexStartName_ = this.indexStartName_, t.endSet_ = this.endSet_, t.indexEndValue_ = this.indexEndValue_, t.endNameSet_ = this.endNameSet_, t.indexEndName_ = this.indexEndName_, t.index_ = this.index_, t.viewFrom_ = this.viewFrom_, t;
        }, e.prototype.limit = function (e) {
          var t = this.copy_();
          return t.limitSet_ = !0, t.limit_ = e, t.viewFrom_ = "", t;
        }, e.prototype.limitToFirst = function (t) {
          var n = this.copy_();
          return n.limitSet_ = !0, n.limit_ = t, n.viewFrom_ = e.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT, n;
        }, e.prototype.limitToLast = function (t) {
          var n = this.copy_();
          return n.limitSet_ = !0, n.limit_ = t, n.viewFrom_ = e.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT, n;
        }, e.prototype.startAt = function (e, t) {
          var n = this.copy_();
          return n.startSet_ = !0, void 0 === e && (e = null), n.indexStartValue_ = e, null != t ? (n.startNameSet_ = !0, n.indexStartName_ = t) : (n.startNameSet_ = !1, n.indexStartName_ = ""), n;
        }, e.prototype.endAt = function (e, t) {
          var n = this.copy_();
          return n.endSet_ = !0, void 0 === e && (e = null), n.indexEndValue_ = e, void 0 !== t ? (n.endNameSet_ = !0, n.indexEndName_ = t) : (n.endNameSet_ = !1, n.indexEndName_ = ""), n;
        }, e.prototype.orderBy = function (e) {
          var t = this.copy_();
          return t.index_ = e, t;
        }, e.prototype.getQueryObject = function () {
          var t = e.WIRE_PROTOCOL_CONSTANTS_,
              n = {};

          if (this.startSet_ && (n[t.INDEX_START_VALUE] = this.indexStartValue_, this.startNameSet_ && (n[t.INDEX_START_NAME] = this.indexStartName_)), this.endSet_ && (n[t.INDEX_END_VALUE] = this.indexEndValue_, this.endNameSet_ && (n[t.INDEX_END_NAME] = this.indexEndName_)), this.limitSet_) {
            n[t.LIMIT] = this.limit_;
            var r = this.viewFrom_;
            "" === r && (r = this.isViewFromLeft() ? t.VIEW_FROM_LEFT : t.VIEW_FROM_RIGHT), n[t.VIEW_FROM] = r;
          }

          return this.index_ !== De && (n[t.INDEX] = this.index_.toString()), n;
        }, e.prototype.loadsAllData = function () {
          return !(this.startSet_ || this.endSet_ || this.limitSet_);
        }, e.prototype.isDefault = function () {
          return this.loadsAllData() && this.index_ === De;
        }, e.prototype.getNodeFilter = function () {
          return this.loadsAllData() ? new Tt(this.getIndex()) : this.hasLimit() ? new dn(this) : new hn(this);
        }, e.prototype.toRestQueryStringParameters = function () {
          var t,
              n = e.REST_QUERY_CONSTANTS_,
              r = {};
          return this.isDefault() ? r : (this.index_ === De ? t = n.PRIORITY_INDEX : this.index_ === Ze ? t = n.VALUE_INDEX : this.index_ === be ? t = n.KEY_INDEX : (u.assert(this.index_ instanceof Qe, "Unrecognized index type!"), t = this.index_.toString()), r[n.ORDER_BY] = u.stringify(t), this.startSet_ && (r[n.START_AT] = u.stringify(this.indexStartValue_), this.startNameSet_ && (r[n.START_AT] += "," + u.stringify(this.indexStartName_))), this.endSet_ && (r[n.END_AT] = u.stringify(this.indexEndValue_), this.endNameSet_ && (r[n.END_AT] += "," + u.stringify(this.indexEndName_))), this.limitSet_ && (this.isViewFromLeft() ? r[n.LIMIT_TO_FIRST] = this.limit_ : r[n.LIMIT_TO_LAST] = this.limit_), r);
        }, e.WIRE_PROTOCOL_CONSTANTS_ = {
          INDEX_START_VALUE: "sp",
          INDEX_START_NAME: "sn",
          INDEX_END_VALUE: "ep",
          INDEX_END_NAME: "en",
          LIMIT: "l",
          VIEW_FROM: "vf",
          VIEW_FROM_LEFT: "l",
          VIEW_FROM_RIGHT: "r",
          INDEX: "i"
        }, e.REST_QUERY_CONSTANTS_ = {
          ORDER_BY: "orderBy",
          PRIORITY_INDEX: "$priority",
          VALUE_INDEX: "$value",
          KEY_INDEX: "$key",
          START_AT: "startAt",
          END_AT: "endAt",
          LIMIT_TO_FIRST: "limitToFirst",
          LIMIT_TO_LAST: "limitToLast"
        }, e.DEFAULT = new e(), e;
      }(),
          pn = function (e) {
        function t(t, n) {
          if (!(t instanceof ln)) throw new Error("new Reference() no longer supported - use app.database().");
          return e.call(this, t, n, fn.DEFAULT, !1) || this;
        }

        return s.__extends(t, e), t.prototype.getKey = function () {
          return u.validateArgCount("Reference.key", 0, 0, arguments.length), this.path.isEmpty() ? null : this.path.getBack();
        }, t.prototype.child = function (e) {
          return u.validateArgCount("Reference.child", 1, 1, arguments.length), "number" == typeof e ? e = String(e) : e instanceof H || (null === this.path.getFront() ? function (e, t, n, r) {
            n && (n = n.replace(/^\/*\.info(\/|$)/, "/")), he(e, t, n, r);
          }("Reference.child", 1, e, !1) : he("Reference.child", 1, e, !1)), new t(this.repo, this.path.child(e));
        }, t.prototype.getParent = function () {
          u.validateArgCount("Reference.parent", 0, 0, arguments.length);
          var e = this.path.parent();
          return null === e ? null : new t(this.repo, e);
        }, t.prototype.getRoot = function () {
          u.validateArgCount("Reference.root", 0, 0, arguments.length);

          for (var e = this; null !== e.getParent();) {
            e = e.getParent();
          }

          return e;
        }, t.prototype.databaseProp = function () {
          return this.repo.database;
        }, t.prototype.set = function (e, t) {
          u.validateArgCount("Reference.set", 1, 2, arguments.length), de("Reference.set", this.path), oe("Reference.set", 1, e, this.path, !1), u.validateCallback("Reference.set", 2, t, !0);
          var n = new u.Deferred();
          return this.repo.setWithPriority(this.path, e, null, n.wrapCallback(t)), n.promise;
        }, t.prototype.update = function (e, t) {
          if (u.validateArgCount("Reference.update", 1, 2, arguments.length), de("Reference.update", this.path), Array.isArray(e)) {
            for (var n = {}, r = 0; r < e.length; ++r) {
              n["" + r] = e[r];
            }

            e = n, S("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
          }

          se("Reference.update", 1, e, this.path, !1), u.validateCallback("Reference.update", 2, t, !0);
          var i = new u.Deferred();
          return this.repo.update(this.path, e, i.wrapCallback(t)), i.promise;
        }, t.prototype.setWithPriority = function (e, t, n) {
          if (u.validateArgCount("Reference.setWithPriority", 2, 3, arguments.length), de("Reference.setWithPriority", this.path), oe("Reference.setWithPriority", 1, e, this.path, !1), ue("Reference.setWithPriority", 2, t, !1), u.validateCallback("Reference.setWithPriority", 3, n, !0), ".length" === this.getKey() || ".keys" === this.getKey()) throw "Reference.setWithPriority failed: " + this.getKey() + " is a read-only object.";
          var r = new u.Deferred();
          return this.repo.setWithPriority(this.path, e, t, r.wrapCallback(n)), r.promise;
        }, t.prototype.remove = function (e) {
          return u.validateArgCount("Reference.remove", 0, 1, arguments.length), de("Reference.remove", this.path), u.validateCallback("Reference.remove", 1, e, !0), this.set(null, e);
        }, t.prototype.transaction = function (e, t, n) {
          if (u.validateArgCount("Reference.transaction", 1, 3, arguments.length), de("Reference.transaction", this.path), u.validateCallback("Reference.transaction", 1, e, !1), u.validateCallback("Reference.transaction", 2, t, !0), function (e, t, n, r) {
            if ((!r || void 0 !== n) && "boolean" != typeof n) throw new Error(u.errorPrefix(e, t, r) + "must be a boolean.");
          }("Reference.transaction", 3, n, !0), ".length" === this.getKey() || ".keys" === this.getKey()) throw "Reference.transaction failed: " + this.getKey() + " is a read-only object.";
          void 0 === n && (n = !0);
          var r = new u.Deferred();
          "function" == typeof t && r.promise.catch(function () {});
          return this.repo.startTransaction(this.path, e, function (e, n, i) {
            e ? r.reject(e) : r.resolve(new me(n, i)), "function" == typeof t && t(e, n, i);
          }, n), r.promise;
        }, t.prototype.setPriority = function (e, t) {
          u.validateArgCount("Reference.setPriority", 1, 2, arguments.length), de("Reference.setPriority", this.path), ue("Reference.setPriority", 1, e, !1), u.validateCallback("Reference.setPriority", 2, t, !0);
          var n = new u.Deferred();
          return this.repo.setWithPriority(this.path.child(".priority"), e, null, n.wrapCallback(t)), n.promise;
        }, t.prototype.push = function (e, t) {
          u.validateArgCount("Reference.push", 0, 2, arguments.length), de("Reference.push", this.path), oe("Reference.push", 1, e, this.path, !0), u.validateCallback("Reference.push", 2, t, !0);

          var n,
              r = this.repo.serverTime(),
              i = _e(r),
              o = this.child(i),
              a = this.child(i);

          return n = null != e ? o.set(e, t).then(function () {
            return a;
          }) : Promise.resolve(a), o.then = n.then.bind(n), o.catch = n.then.bind(n, void 0), "function" == typeof t && n.catch(function () {}), o;
        }, t.prototype.onDisconnect = function () {
          return de("Reference.onDisconnect", this.path), new pe(this.repo, this.path);
        }, Object.defineProperty(t.prototype, "database", {
          get: function get() {
            return this.databaseProp();
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "key", {
          get: function get() {
            return this.getKey();
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "parent", {
          get: function get() {
            return this.getParent();
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "root", {
          get: function get() {
            return this.getRoot();
          },
          enumerable: !0,
          configurable: !0
        }), t;
      }($e);
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */


      $e.__referenceConstructor = pn, It.__referenceConstructor = pn;
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */

      var mn,
          _n = function () {
        return function () {
          this.children = {}, this.childCount = 0, this.value = null;
        };
      }(),
          yn = function () {
        function e(e, t, n) {
          void 0 === e && (e = ""), void 0 === t && (t = null), void 0 === n && (n = new _n()), this.name_ = e, this.parent_ = t, this.node_ = n;
        }

        return e.prototype.subTree = function (t) {
          for (var n = t instanceof H ? t : new H(t), r = this, i = n.getFront(); null !== i;) {
            r = new e(i, r, u.safeGet(r.node_.children, i) || new _n()), i = (n = n.popFront()).getFront();
          }

          return r;
        }, e.prototype.getValue = function () {
          return this.node_.value;
        }, e.prototype.setValue = function (e) {
          u.assert(void 0 !== e, "Cannot set value to undefined"), this.node_.value = e, this.updateParents_();
        }, e.prototype.clear = function () {
          this.node_.value = null, this.node_.children = {}, this.node_.childCount = 0, this.updateParents_();
        }, e.prototype.hasChildren = function () {
          return this.node_.childCount > 0;
        }, e.prototype.isEmpty = function () {
          return null === this.getValue() && !this.hasChildren();
        }, e.prototype.forEachChild = function (t) {
          var n = this;
          F(this.node_.children, function (r, i) {
            t(new e(r, n, i));
          });
        }, e.prototype.forEachDescendant = function (e, t, n) {
          t && !n && e(this), this.forEachChild(function (t) {
            t.forEachDescendant(e, !0, n);
          }), t && n && e(this);
        }, e.prototype.forEachAncestor = function (e, t) {
          for (var n = t ? this : this.parent(); null !== n;) {
            if (e(n)) return !0;
            n = n.parent();
          }

          return !1;
        }, e.prototype.forEachImmediateDescendantWithValue = function (e) {
          this.forEachChild(function (t) {
            null !== t.getValue() ? e(t) : t.forEachImmediateDescendantWithValue(e);
          });
        }, e.prototype.path = function () {
          return new H(null === this.parent_ ? this.name_ : this.parent_.path() + "/" + this.name_);
        }, e.prototype.name = function () {
          return this.name_;
        }, e.prototype.parent = function () {
          return this.parent_;
        }, e.prototype.updateParents_ = function () {
          null !== this.parent_ && this.parent_.updateChild_(this.name_, this);
        }, e.prototype.updateChild_ = function (e, t) {
          var n = t.isEmpty(),
              r = u.contains(this.node_.children, e);
          n && r ? (delete this.node_.children[e], this.node_.childCount--, this.updateParents_()) : n || r || (this.node_.children[e] = t.node_, this.node_.childCount++, this.updateParents_());
        }, e;
      }();

      !function (e) {
        e[e.RUN = 0] = "RUN", e[e.SENT = 1] = "SENT", e[e.COMPLETED = 2] = "COMPLETED", e[e.SENT_NEEDS_ABORT = 3] = "SENT_NEEDS_ABORT", e[e.NEEDS_ABORT = 4] = "NEEDS_ABORT";
      }(mn || (mn = {})), ln.MAX_TRANSACTION_RETRIES_ = 25, ln.prototype.transactionsInit_ = function () {
        this.transactionQueueTree_ = new yn();
      }, ln.prototype.startTransaction = function (e, t, n, r) {
        this.log_("transaction on " + e);

        var i = function i() {},
            o = new pn(this, e);

        o.on("value", i);
        var a = {
          path: e,
          update: t,
          onComplete: n,
          status: null,
          order: y(),
          applyLocally: r,
          retryCount: 0,
          unwatcher: function unwatcher() {
            o.off("value", i);
          },
          abortReason: null,
          currentWriteId: null,
          currentInputSnapshot: null,
          currentOutputSnapshotRaw: null,
          currentOutputSnapshotResolved: null
        },
            s = this.getLatestState_(e);
        a.currentInputSnapshot = s;
        var c = a.update(s.val());

        if (void 0 === c) {
          if (a.unwatcher(), a.currentOutputSnapshotRaw = null, a.currentOutputSnapshotResolved = null, a.onComplete) {
            var l = new Ge(a.currentInputSnapshot, new pn(this, a.path), De);
            a.onComplete(null, !1, l);
          }
        } else {
          ae("transaction failed: Data returned ", c, a.path), a.status = mn.RUN;
          var h = this.transactionQueueTree_.subTree(e),
              d = h.getValue() || [];
          d.push(a), h.setValue(d);
          var f = void 0;
          if ("object" == typeof c && null !== c && u.contains(c, ".priority")) f = u.safeGet(c, ".priority"), u.assert(ie(f), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");else f = (this.serverSyncTree_.calcCompleteEventCache(e) || Ve.EMPTY_NODE).getPriority().val();
          f = f;

          var p = this.generateServerValues(),
              m = Be(c, f),
              _ = at(m, s, p);

          a.currentOutputSnapshotRaw = m, a.currentOutputSnapshotResolved = _, a.currentWriteId = this.getNextWriteId_();
          var v = this.serverSyncTree_.applyUserOverwrite(e, _, a.currentWriteId, a.applyLocally);
          this.eventQueue_.raiseEventsForChangedPath(e, v), this.sendReadyTransactions_();
        }
      }, ln.prototype.getLatestState_ = function (e, t) {
        return this.serverSyncTree_.calcCompleteEventCache(e, t) || Ve.EMPTY_NODE;
      }, ln.prototype.sendReadyTransactions_ = function (e) {
        var t = this;

        if (void 0 === e && (e = this.transactionQueueTree_), e || this.pruneCompletedTransactionsBelowNode_(e), null !== e.getValue()) {
          var n = this.buildTransactionQueue_(e);
          u.assert(n.length > 0, "Sending zero length transaction queue"), n.every(function (e) {
            return e.status === mn.RUN;
          }) && this.sendTransactionQueue_(e.path(), n);
        } else e.hasChildren() && e.forEachChild(function (e) {
          t.sendReadyTransactions_(e);
        });
      }, ln.prototype.sendTransactionQueue_ = function (e, t) {
        for (var n = this, r = t.map(function (e) {
          return e.currentWriteId;
        }), i = this.getLatestState_(e, r), o = i, a = i.hash(), s = 0; s < t.length; s++) {
          var c = t[s];
          u.assert(c.status === mn.RUN, "tryToSendTransactionQueue_: items in queue should all be run."), c.status = mn.SENT, c.retryCount++;
          var l = H.relativePath(e, c.path);
          o = o.updateChild(l, c.currentOutputSnapshotRaw);
        }

        var h = o.val(!0),
            d = e;
        this.server_.put(d.toString(), h, function (r) {
          n.log_("transaction put response", {
            path: d.toString(),
            status: r
          });
          var i = [];

          if ("ok" === r) {
            for (var o = [], a = 0; a < t.length; a++) {
              if (t[a].status = mn.COMPLETED, i = i.concat(n.serverSyncTree_.ackUserWrite(t[a].currentWriteId)), t[a].onComplete) {
                var s = t[a].currentOutputSnapshotResolved,
                    u = new pn(n, t[a].path),
                    c = new Ge(s, u, De);
                o.push(t[a].onComplete.bind(null, null, !0, c));
              }

              t[a].unwatcher();
            }

            n.pruneCompletedTransactionsBelowNode_(n.transactionQueueTree_.subTree(e)), n.sendReadyTransactions_(), n.eventQueue_.raiseEventsForChangedPath(e, i);

            for (a = 0; a < o.length; a++) {
              P(o[a]);
            }
          } else {
            if ("datastale" === r) for (a = 0; a < t.length; a++) {
              t[a].status === mn.SENT_NEEDS_ABORT ? t[a].status = mn.NEEDS_ABORT : t[a].status = mn.RUN;
            } else {
              S("transaction at " + d.toString() + " failed: " + r);

              for (a = 0; a < t.length; a++) {
                t[a].status = mn.NEEDS_ABORT, t[a].abortReason = r;
              }
            }
            n.rerunTransactions_(e);
          }
        }, a);
      }, ln.prototype.rerunTransactions_ = function (e) {
        var t = this.getAncestorTransactionNode_(e),
            n = t.path(),
            r = this.buildTransactionQueue_(t);
        return this.rerunTransactionQueue_(r, n), n;
      }, ln.prototype.rerunTransactionQueue_ = function (e, t) {
        if (0 !== e.length) {
          for (var n, r = [], i = [], o = e.filter(function (e) {
            return e.status === mn.RUN;
          }).map(function (e) {
            return e.currentWriteId;
          }), a = 0; a < e.length; a++) {
            var s = e[a],
                c = H.relativePath(t, s.path),
                l = !1,
                h = void 0;
            if (u.assert(null !== c, "rerunTransactionsUnderNode_: relativePath should not be null."), s.status === mn.NEEDS_ABORT) l = !0, h = s.abortReason, i = i.concat(this.serverSyncTree_.ackUserWrite(s.currentWriteId, !0));else if (s.status === mn.RUN) if (s.retryCount >= ln.MAX_TRANSACTION_RETRIES_) l = !0, h = "maxretry", i = i.concat(this.serverSyncTree_.ackUserWrite(s.currentWriteId, !0));else {
              var d = this.getLatestState_(s.path, o);
              s.currentInputSnapshot = d;
              var f = e[a].update(d.val());

              if (void 0 !== f) {
                ae("transaction failed: Data returned ", f, s.path);
                var p = Be(f);
                "object" == typeof f && null != f && u.contains(f, ".priority") || (p = p.updatePriority(d.getPriority()));

                var m = s.currentWriteId,
                    _ = this.generateServerValues(),
                    y = at(p, d, _);

                s.currentOutputSnapshotRaw = p, s.currentOutputSnapshotResolved = y, s.currentWriteId = this.getNextWriteId_(), o.splice(o.indexOf(m), 1), i = (i = i.concat(this.serverSyncTree_.applyUserOverwrite(s.path, y, s.currentWriteId, s.applyLocally))).concat(this.serverSyncTree_.ackUserWrite(m, !0));
              } else l = !0, h = "nodata", i = i.concat(this.serverSyncTree_.ackUserWrite(s.currentWriteId, !0));
            }
            if (this.eventQueue_.raiseEventsForChangedPath(t, i), i = [], l && (e[a].status = mn.COMPLETED, n = e[a].unwatcher, setTimeout(n, Math.floor(0)), e[a].onComplete)) if ("nodata" === h) {
              var v = new pn(this, e[a].path),
                  g = e[a].currentInputSnapshot,
                  b = new Ge(g, v, De);
              r.push(e[a].onComplete.bind(null, null, !1, b));
            } else r.push(e[a].onComplete.bind(null, new Error(h), !1, null));
          }

          this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);

          for (a = 0; a < r.length; a++) {
            P(r[a]);
          }

          this.sendReadyTransactions_();
        }
      }, ln.prototype.getAncestorTransactionNode_ = function (e) {
        var t,
            n = this.transactionQueueTree_;

        for (t = e.getFront(); null !== t && null === n.getValue();) {
          n = n.subTree(t), t = (e = e.popFront()).getFront();
        }

        return n;
      }, ln.prototype.buildTransactionQueue_ = function (e) {
        var t = [];
        return this.aggregateTransactionQueuesForNode_(e, t), t.sort(function (e, t) {
          return e.order - t.order;
        }), t;
      }, ln.prototype.aggregateTransactionQueuesForNode_ = function (e, t) {
        var n = this,
            r = e.getValue();
        if (null !== r) for (var i = 0; i < r.length; i++) {
          t.push(r[i]);
        }
        e.forEachChild(function (e) {
          n.aggregateTransactionQueuesForNode_(e, t);
        });
      }, ln.prototype.pruneCompletedTransactionsBelowNode_ = function (e) {
        var t = this,
            n = e.getValue();

        if (n) {
          for (var r = 0, i = 0; i < n.length; i++) {
            n[i].status !== mn.COMPLETED && (n[r] = n[i], r++);
          }

          n.length = r, e.setValue(n.length > 0 ? n : null);
        }

        e.forEachChild(function (e) {
          t.pruneCompletedTransactionsBelowNode_(e);
        });
      }, ln.prototype.abortTransactions_ = function (e) {
        var t = this,
            n = this.getAncestorTransactionNode_(e).path(),
            r = this.transactionQueueTree_.subTree(e);
        return r.forEachAncestor(function (e) {
          t.abortTransactionsOnNode_(e);
        }), this.abortTransactionsOnNode_(r), r.forEachDescendant(function (e) {
          t.abortTransactionsOnNode_(e);
        }), n;
      }, ln.prototype.abortTransactionsOnNode_ = function (e) {
        var t = e.getValue();

        if (null !== t) {
          for (var n = [], r = [], i = -1, o = 0; o < t.length; o++) {
            if (t[o].status === mn.SENT_NEEDS_ABORT) ;else if (t[o].status === mn.SENT) u.assert(i === o - 1, "All SENT items should be at beginning of queue."), i = o, t[o].status = mn.SENT_NEEDS_ABORT, t[o].abortReason = "set";else if (u.assert(t[o].status === mn.RUN, "Unexpected transaction status in abort"), t[o].unwatcher(), r = r.concat(this.serverSyncTree_.ackUserWrite(t[o].currentWriteId, !0)), t[o].onComplete) {
              n.push(t[o].onComplete.bind(null, new Error("set"), !1, null));
            }
          }

          -1 === i ? e.setValue(null) : t.length = i + 1, this.eventQueue_.raiseEventsForChangedPath(e.path(), r);

          for (o = 0; o < n.length; o++) {
            P(n[o]);
          }
        }
      };
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */

      var vn,
          gn = function () {
        function e() {
          this.repos_ = {}, this.useRestClient_ = !1;
        }

        return e.getInstance = function () {
          return vn || (vn = new e()), vn;
        }, e.prototype.interrupt = function () {
          var e, t, n, r;

          try {
            for (var i = s.__values(Object.keys(this.repos_)), o = i.next(); !o.done; o = i.next()) {
              var a = o.value;

              try {
                for (var u = (n = void 0, s.__values(Object.keys(this.repos_[a]))), c = u.next(); !c.done; c = u.next()) {
                  var l = c.value;
                  this.repos_[a][l].interrupt();
                }
              } catch (e) {
                n = {
                  error: e
                };
              } finally {
                try {
                  c && !c.done && (r = u.return) && r.call(u);
                } finally {
                  if (n) throw n.error;
                }
              }
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              o && !o.done && (t = i.return) && t.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
        }, e.prototype.resume = function () {
          var e, t, n, r;

          try {
            for (var i = s.__values(Object.keys(this.repos_)), o = i.next(); !o.done; o = i.next()) {
              var a = o.value;

              try {
                for (var u = (n = void 0, s.__values(Object.keys(this.repos_[a]))), c = u.next(); !c.done; c = u.next()) {
                  var l = c.value;
                  this.repos_[a][l].resume();
                }
              } catch (e) {
                n = {
                  error: e
                };
              } finally {
                try {
                  c && !c.done && (r = u.return) && r.call(u);
                } finally {
                  if (n) throw n.error;
                }
              }
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              o && !o.done && (t = i.return) && t.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
        }, e.prototype.databaseFromApp = function (e, t, n) {
          var i = n || e.options.databaseURL;
          void 0 === i && L("Can't determine Firebase Database URL.  Be sure to include databaseURL option when calling firebase.initializeApp().");
          var o = K(i),
              a = o.repoInfo,
              s = void 0;
          return void 0 !== r && (s = r.env.FIREBASE_DATABASE_EMULATOR_HOST), s && (i = "http://" + s + "?ns=" + a.namespace, a = (o = K(i)).repoInfo), fe("Invalid Firebase Database URL", 1, o), o.path.isEmpty() || L("Database URL must point to the root of a Firebase Database (not including a child path)."), this.createRepo(a, e, t).database;
        }, e.prototype.deleteRepo = function (e) {
          var t = u.safeGet(this.repos_, e.app.name);
          t && u.safeGet(t, e.repoInfo_.toURLString()) === e || L("Database " + e.app.name + "(" + e.repoInfo_ + ") has already been deleted."), e.interrupt(), delete t[e.repoInfo_.toURLString()];
        }, e.prototype.createRepo = function (e, t, n) {
          var r = u.safeGet(this.repos_, t.name);
          r || (r = {}, this.repos_[t.name] = r);
          var i = u.safeGet(r, e.toURLString());
          return i && L("Database initialized multiple times. Please make sure the format of the database URL matches with each database() call."), i = new ln(e, this.useRestClient_, t, n), r[e.toURLString()] = i, i;
        }, e.prototype.forceRestClient = function (e) {
          this.useRestClient_ = e;
        }, e;
      }(),
          bn = function () {
        function e(e) {
          this.repo_ = e, e instanceof ln || L("Don't call new Database() directly - please use firebase.database()."), this.root_ = new pn(e, H.Empty), this.INTERNAL = new wn(this);
        }

        return Object.defineProperty(e.prototype, "app", {
          get: function get() {
            return this.repo_.app;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.ref = function (e) {
          return this.checkDeleted_("ref"), u.validateArgCount("database.ref", 0, 1, arguments.length), e instanceof pn ? this.refFromURL(e.toString()) : void 0 !== e ? this.root_.child(e) : this.root_;
        }, e.prototype.refFromURL = function (e) {
          var t = "database.refFromURL";
          this.checkDeleted_(t), u.validateArgCount(t, 1, 1, arguments.length);
          var n = K(e);
          fe(t, 1, n);
          var r = n.repoInfo;
          return r.host !== this.repo_.repoInfo_.host && L(t + ": Host name does not match the current database: (found " + r.host + " but expected " + this.repo_.repoInfo_.host + ")"), this.ref(n.path.toString());
        }, e.prototype.checkDeleted_ = function (e) {
          null === this.repo_ && L("Cannot call " + e + " on a deleted database.");
        }, e.prototype.goOffline = function () {
          u.validateArgCount("database.goOffline", 0, 0, arguments.length), this.checkDeleted_("goOffline"), this.repo_.interrupt();
        }, e.prototype.goOnline = function () {
          u.validateArgCount("database.goOnline", 0, 0, arguments.length), this.checkDeleted_("goOnline"), this.repo_.resume();
        }, e.ServerValue = {
          TIMESTAMP: {
            ".sv": "timestamp"
          },
          increment: function increment(e) {
            return {
              ".sv": {
                increment: e
              }
            };
          }
        }, e;
      }(),
          wn = function () {
        function e(e) {
          this.database = e;
        }

        return e.prototype.delete = function () {
          return s.__awaiter(this, void 0, void 0, function () {
            return s.__generator(this, function (e) {
              return this.database.checkDeleted_("delete"), gn.getInstance().deleteRepo(this.database.repo_), this.database.repo_ = null, this.database.root_ = null, this.database.INTERNAL = null, this.database = null, [2];
            });
          });
        }, e;
      }(),
          Tn = Object.freeze({
        __proto__: null,
        forceLongPolling: function forceLongPolling() {
          tn.forceDisallow(), Xt.forceAllow();
        },
        forceWebSockets: function forceWebSockets() {
          Xt.forceDisallow();
        },
        isWebSocketsAvailable: function isWebSocketsAvailable() {
          return tn.isAvailable();
        },
        setSecurityDebugCallback: function setSecurityDebugCallback(e, t) {
          e.repo.persistentConnection_.securityDebugCallback_ = t;
        },
        stats: function stats(e, t) {
          e.repo.stats(t);
        },
        statsIncrementCounter: function statsIncrementCounter(e, t) {
          e.repo.statsIncrementCounter(t);
        },
        dataUpdateCount: function dataUpdateCount(e) {
          return e.repo.dataUpdateCount;
        },
        interceptServerData: function interceptServerData(e, t) {
          return e.repo.interceptServerData_(t);
        }
      }),
          Mn = un;

      un.prototype.simpleListen = function (e, t) {
        this.sendRequest("q", {
          p: e
        }, t);
      }, un.prototype.echo = function (e, t) {
        this.sendRequest("echo", {
          d: e
        }, t);
      };
      var En = rn,
          kn = Z,
          Ln = Object.freeze({
        __proto__: null,
        DataConnection: Mn,
        RealTimeConnection: En,
        hijackHash: function hijackHash(e) {
          var t = un.prototype.put;
          return un.prototype.put = function (n, r, i, o) {
            void 0 !== o && (o = e()), t.call(this, n, r, i, o);
          }, function () {
            un.prototype.put = t;
          };
        },
        ConnectionTarget: kn,
        queryIdentifier: function queryIdentifier(e) {
          return e.queryIdentifier();
        },
        forceRestClient: function forceRestClient(e) {
          gn.getInstance().forceRestClient(e);
        }
      }),
          Sn = "@firebase/database",
          Nn = "0.6.2",
          Dn = bn.ServerValue;

      function In(t) {
        !function (e) {
          $t = e;
        }(t.SDK_VERSION);
        var n = t.INTERNAL.registerComponent(new l.Component("database", function (e, t) {
          var n = e.getProvider("app").getImmediate(),
              r = e.getProvider("auth-internal");
          return gn.getInstance().databaseFromApp(n, r, t);
        }, "PUBLIC").setServiceProps({
          Reference: pn,
          Query: $e,
          Database: bn,
          DataSnapshot: Ge,
          enableLogging: T,
          INTERNAL: Tn,
          ServerValue: Dn,
          TEST_ACCESS: Ln
        }).setMultipleInstances(!0));
        t.registerVersion(Sn, Nn), u.isNodeSdk() && (e.exports = n);
      }

      In(a), t.DataSnapshot = Ge, t.Database = bn, t.OnDisconnect = pe, t.Query = $e, t.Reference = pn, t.ServerValue = Dn, t.enableLogging = T, t.registerDatabase = In;
    }).call(this, n(32));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r,
        i = n(3),
        o = (r = n(6)) && "object" == typeof r && "default" in r ? r.default : r,
        a = n(25),
        s = n(16),
        u = n(13),
        c = n(258),
        l = o.SDK_VERSION,
        h = function () {
      function e(e) {
        this.uid = e;
      }

      return e.prototype.t = function () {
        return null != this.uid;
      }, e.prototype.s = function () {
        return this.t() ? "uid:" + this.uid : "anonymous-user";
      }, e.prototype.isEqual = function (e) {
        return e.uid === this.uid;
      }, e;
    }();

    h.UNAUTHENTICATED = new h(null), h.i = new h("google-credentials-uid"), h.h = new h("first-party-uid");
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    var d = {
      OK: "ok",
      CANCELLED: "cancelled",
      UNKNOWN: "unknown",
      INVALID_ARGUMENT: "invalid-argument",
      DEADLINE_EXCEEDED: "deadline-exceeded",
      NOT_FOUND: "not-found",
      ALREADY_EXISTS: "already-exists",
      PERMISSION_DENIED: "permission-denied",
      UNAUTHENTICATED: "unauthenticated",
      RESOURCE_EXHAUSTED: "resource-exhausted",
      FAILED_PRECONDITION: "failed-precondition",
      ABORTED: "aborted",
      OUT_OF_RANGE: "out-of-range",
      UNIMPLEMENTED: "unimplemented",
      INTERNAL: "internal",
      UNAVAILABLE: "unavailable",
      DATA_LOSS: "data-loss"
    },
        f = function (e) {
      function t(t, n) {
        var r = this;
        return (r = e.call(this, n) || this).code = t, r.message = n, r.name = "FirebaseError", r.toString = function () {
          return r.name + ": [code=" + r.code + "]: " + r.message;
        }, r;
      }

      return i.__extends(t, e), t;
    }(Error),
        p = function p(e, t) {
      this.user = t, this.type = "OAuth", this.o = {}, this.o.Authorization = "Bearer " + e;
    },
        m = function () {
      function e() {
        this.u = null;
      }

      return e.prototype.getToken = function () {
        return Promise.resolve(null);
      }, e.prototype._ = function () {}, e.prototype.l = function (e) {
        this.u = e, e(h.UNAUTHENTICATED);
      }, e.prototype.T = function () {
        this.u = null;
      }, e;
    }(),
        _ = function () {
      function e(e) {
        var t = this;
        this.I = null, this.currentUser = h.UNAUTHENTICATED, this.R = !1, this.m = 0, this.u = null, this.forceRefresh = !1, this.I = function () {
          t.m++, t.currentUser = t.A(), t.R = !0, t.u && t.u(t.currentUser);
        }, this.m = 0, this.auth = e.getImmediate({
          optional: !0
        }), this.auth ? this.auth.addAuthTokenListener(this.I) : (this.I(null), e.get().then(function (e) {
          t.auth = e, t.I && t.auth.addAuthTokenListener(t.I);
        }, function () {}));
      }

      return e.prototype.getToken = function () {
        var e = this,
            t = this.m,
            n = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(n).then(function (n) {
          if (e.m !== t) throw new f(d.ABORTED, "getToken aborted due to token change.");
          return n ? (wt("string" == typeof n.accessToken), new p(n.accessToken, e.currentUser)) : null;
        }) : Promise.resolve(null);
      }, e.prototype._ = function () {
        this.forceRefresh = !0;
      }, e.prototype.l = function (e) {
        this.u = e, this.R && e(this.currentUser);
      }, e.prototype.T = function () {
        this.auth && this.auth.removeAuthTokenListener(this.I), this.I = null, this.u = null;
      }, e.prototype.A = function () {
        var e = this.auth && this.auth.getUid();
        return wt(null === e || "string" == typeof e), new h(e);
      }, e;
    }(),
        y = function () {
      function e(e, t) {
        this.P = e, this.V = t, this.type = "FirstParty", this.user = h.h;
      }

      return Object.defineProperty(e.prototype, "o", {
        get: function get() {
          var e = {
            "X-Goog-AuthUser": this.V
          },
              t = this.P.auth.g([]);
          return t && (e.Authorization = t), e;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        v = function () {
      function e(e, t) {
        this.P = e, this.V = t;
      }

      return e.prototype.getToken = function () {
        return Promise.resolve(new y(this.P, this.V));
      }, e.prototype.l = function (e) {
        e(h.h);
      }, e.prototype.T = function () {}, e.prototype._ = function () {}, e;
    }(),
        g = function () {
      function e(e, t) {
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new f(d.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new f(d.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < -62135596800) throw new f(d.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        if (e >= 253402300800) throw new f(d.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
      }

      return e.now = function () {
        return e.fromMillis(Date.now());
      }, e.fromDate = function (t) {
        return e.fromMillis(t.getTime());
      }, e.fromMillis = function (t) {
        var n = Math.floor(t / 1e3);
        return new e(n, 1e6 * (t - 1e3 * n));
      }, e.prototype.toDate = function () {
        return new Date(this.toMillis());
      }, e.prototype.toMillis = function () {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
      }, e.prototype.p = function (e) {
        return this.seconds === e.seconds ? Et(this.nanoseconds, e.nanoseconds) : Et(this.seconds, e.seconds);
      }, e.prototype.isEqual = function (e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
      }, e.prototype.toString = function () {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
      }, e.prototype.valueOf = function () {
        var e = this.seconds - -62135596800;
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
      }, e;
    }(),
        b = function () {
      function e(e) {
        this.timestamp = e;
      }

      return e.v = function (t) {
        return new e(t);
      }, e.min = function () {
        return new e(new g(0, 0));
      }, e.prototype.S = function (e) {
        return this.timestamp.p(e.timestamp);
      }, e.prototype.isEqual = function (e) {
        return this.timestamp.isEqual(e.timestamp);
      }, e.prototype.D = function () {
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
      }, e.prototype.toString = function () {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
      }, e.prototype.C = function () {
        return this.timestamp;
      }, e;
    }(),
        w = function () {
      function e(e, t, n) {
        void 0 === t ? t = 0 : t > e.length && bt(), void 0 === n ? n = e.length - t : n > e.length - t && bt(), this.segments = e, this.offset = t, this.F = n;
      }

      return Object.defineProperty(e.prototype, "length", {
        get: function get() {
          return this.F;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.isEqual = function (t) {
        return 0 === e.N(this, t);
      }, e.prototype.child = function (t) {
        var n = this.segments.slice(this.offset, this.limit());
        return t instanceof e ? t.forEach(function (e) {
          n.push(e);
        }) : n.push(t), this.k(n);
      }, e.prototype.limit = function () {
        return this.offset + this.length;
      }, e.prototype.$ = function (e) {
        return e = void 0 === e ? 1 : e, this.k(this.segments, this.offset + e, this.length - e);
      }, e.prototype.M = function () {
        return this.k(this.segments, this.offset, this.length - 1);
      }, e.prototype.L = function () {
        return this.segments[this.offset];
      }, e.prototype.O = function () {
        return this.get(this.length - 1);
      }, e.prototype.get = function (e) {
        return this.segments[this.offset + e];
      }, e.prototype.B = function () {
        return 0 === this.length;
      }, e.prototype.q = function (e) {
        if (e.length < this.length) return !1;

        for (var t = 0; t < this.length; t++) {
          if (this.get(t) !== e.get(t)) return !1;
        }

        return !0;
      }, e.prototype.U = function (e) {
        if (this.length + 1 !== e.length) return !1;

        for (var t = 0; t < this.length; t++) {
          if (this.get(t) !== e.get(t)) return !1;
        }

        return !0;
      }, e.prototype.forEach = function (e) {
        for (var t = this.offset, n = this.limit(); t < n; t++) {
          e(this.segments[t]);
        }
      }, e.prototype.W = function () {
        return this.segments.slice(this.offset, this.limit());
      }, e.N = function (e, t) {
        for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) {
          var i = e.get(r),
              o = t.get(r);
          if (i < o) return -1;
          if (i > o) return 1;
        }

        return e.length < t.length ? -1 : e.length > t.length ? 1 : 0;
      }, e;
    }(),
        T = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return i.__extends(t, e), t.prototype.k = function (e, n, r) {
        return new t(e, n, r);
      }, t.prototype.j = function () {
        return this.W().join("/");
      }, t.prototype.toString = function () {
        return this.j();
      }, t.K = function (e) {
        if (e.indexOf("//") >= 0) throw new f(d.INVALID_ARGUMENT, "Invalid path (" + e + "). Paths must not contain // in them.");
        return new t(e.split("/").filter(function (e) {
          return e.length > 0;
        }));
      }, t;
    }(w);

    T.G = new T([]);

    var M = /^[_a-zA-Z][_a-zA-Z0-9]*$/,
        E = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return i.__extends(t, e), t.prototype.k = function (e, n, r) {
        return new t(e, n, r);
      }, t.H = function (e) {
        return M.test(e);
      }, t.prototype.j = function () {
        return this.W().map(function (e) {
          return e = e.replace("\\", "\\\\").replace("`", "\\`"), t.H(e) || (e = "`" + e + "`"), e;
        }).join(".");
      }, t.prototype.toString = function () {
        return this.j();
      }, t.prototype.Y = function () {
        return 1 === this.length && "__name__" === this.get(0);
      }, t.J = function () {
        return new t(["__name__"]);
      }, t.X = function (e) {
        for (var n = [], r = "", i = 0, o = function o() {
          if (0 === r.length) throw new f(d.INVALID_ARGUMENT, "Invalid field path (" + e + "). Paths must not be empty, begin with '.', end with '.', or contain '..'");
          n.push(r), r = "";
        }, a = !1; i < e.length;) {
          var s = e[i];

          if ("\\" === s) {
            if (i + 1 === e.length) throw new f(d.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
            var u = e[i + 1];
            if ("\\" !== u && "." !== u && "`" !== u) throw new f(d.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
            r += u, i += 2;
          } else "`" === s ? (a = !a, i++) : "." !== s || a ? (r += s, i++) : (o(), i++);
        }

        if (o(), a) throw new f(d.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new t(n);
      }, t;
    }(w);

    E.G = new E([]);
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    var k = function () {
      function e(e) {
        this.path = e;
      }

      return e.Z = function (t) {
        return new e(T.K(t).$(5));
      }, e.prototype.tt = function (e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
      }, e.prototype.isEqual = function (e) {
        return null !== e && 0 === T.N(this.path, e.path);
      }, e.prototype.toString = function () {
        return this.path.toString();
      }, e.N = function (e, t) {
        return T.N(e.path, t.path);
      }, e.et = function (e) {
        return e.length % 2 == 0;
      }, e.st = function (t) {
        return new e(new T(t.slice()));
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function L(e) {
      var t = 0;

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && t++;
      }

      return t;
    }

    function S(e, t) {
      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
      }
    }

    function N(e) {
      for (var t in e) {
        if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
      }

      return !0;
    }
    /**
     * @license
     * Copyright 2020 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    k.EMPTY = new k(new T([]));

    var D = function () {
      function e(e) {
        this.it = e;
      }

      return e.fromBase64String = function (t) {
        return new e(ft.nt().atob(t));
      }, e.fromUint8Array = function (t) {
        return new e(function (e) {
          for (var t = "", n = 0; n < e.length; ++n) {
            t += String.fromCharCode(e[n]);
          }

          return t;
        }(t));
      }, e.prototype.toBase64 = function () {
        return ft.nt().btoa(this.it);
      }, e.prototype.toUint8Array = function () {
        return function (e) {
          for (var t = new Uint8Array(e.length), n = 0; n < e.length; n++) {
            t[n] = e.charCodeAt(n);
          }

          return t;
        }(this.it);
      }, e.prototype.rt = function () {
        return 2 * this.it.length;
      }, e.prototype.S = function (e) {
        return Et(this.it, e.it);
      }, e.prototype.isEqual = function (e) {
        return this.it === e.it;
      }, e;
    }();

    function I(e) {
      return null == e;
    }

    function R(e) {
      return -0 === e && 1 / e == -1 / 0;
    }

    function x(e) {
      return "number" == typeof e && Number.isInteger(e) && !R(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
    }
    /**
     * @license
     * Copyright 2020 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Y(e) {
      var t, n;
      return "server_timestamp" === (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
    }

    function C(e) {
      var t = W(e.mapValue.fields.__local_write_time__.timestampValue);
      return new g(t.seconds, t.nanos);
    }
    /**
     * @license
     * Copyright 2020 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    D.ht = new D("");
    var O = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);

    function F(e) {
      return "nullValue" in e ? 0 : "booleanValue" in e ? 1 : "integerValue" in e || "doubleValue" in e ? 2 : "timestampValue" in e ? 3 : "stringValue" in e ? 5 : "bytesValue" in e ? 6 : "referenceValue" in e ? 7 : "geoPointValue" in e ? 8 : "arrayValue" in e ? 9 : "mapValue" in e ? Y(e) ? 4 : 10 : bt();
    }

    function A(e, t) {
      var n = F(e);
      if (n !== F(t)) return !1;

      switch (n) {
        case 0:
          return !0;

        case 1:
          return e.booleanValue === t.booleanValue;

        case 4:
          return C(e).isEqual(C(t));

        case 3:
          return function (e, t) {
            if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) return e.timestampValue === t.timestampValue;
            var n = W(e.timestampValue),
                r = W(t.timestampValue);
            return n.seconds === r.seconds && n.nanos === r.nanos;
          }(e, t);

        case 5:
          return e.stringValue === t.stringValue;

        case 6:
          return function (e, t) {
            return B(e.bytesValue).isEqual(B(t.bytesValue));
          }(e, t);

        case 7:
          return e.referenceValue === t.referenceValue;

        case 8:
          return function (e, t) {
            return H(e.geoPointValue.latitude) === H(t.geoPointValue.latitude) && H(e.geoPointValue.longitude) === H(t.geoPointValue.longitude);
          }(e, t);

        case 2:
          return function (e, t) {
            if ("integerValue" in e && "integerValue" in t) return H(e.integerValue) === H(t.integerValue);

            if ("doubleValue" in e && "doubleValue" in t) {
              var n = H(e.doubleValue),
                  r = H(t.doubleValue);
              return n === r ? R(n) === R(r) : isNaN(n) && isNaN(r);
            }

            return !1;
          }(e, t);

        case 9:
          return kt(e.arrayValue.values || [], t.arrayValue.values || [], A);

        case 10:
          return function (e, t) {
            var n = e.mapValue.fields || {},
                r = t.mapValue.fields || {};
            if (L(n) !== L(r)) return !1;

            for (var i in n) {
              if (n.hasOwnProperty(i) && (void 0 === r[i] || !A(n[i], r[i]))) return !1;
            }

            return !0;
          }(e, t);

        default:
          return bt();
      }
    }

    function j(e, t) {
      return void 0 !== (e.values || []).find(function (e) {
        return A(e, t);
      });
    }

    function U(e, t) {
      var n = F(e),
          r = F(t);
      if (n !== r) return Et(n, r);

      switch (n) {
        case 0:
          return 0;

        case 1:
          return Et(e.booleanValue, t.booleanValue);

        case 2:
          return function (e, t) {
            var n = H(e.integerValue || e.doubleValue),
                r = H(t.integerValue || t.doubleValue);
            return n < r ? -1 : n > r ? 1 : n === r ? 0 : isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
          }(e, t);

        case 3:
          return P(e.timestampValue, t.timestampValue);

        case 4:
          return P(C(e), C(t));

        case 5:
          return Et(e.stringValue, t.stringValue);

        case 6:
          return function (e, t) {
            var n = B(e),
                r = B(t);
            return n.S(r);
          }(e.bytesValue, t.bytesValue);

        case 7:
          return function (e, t) {
            for (var n = e.split("/"), r = t.split("/"), i = 0; i < n.length && i < r.length; i++) {
              var o = Et(n[i], r[i]);
              if (0 !== o) return o;
            }

            return Et(n.length, r.length);
          }(e.referenceValue, t.referenceValue);

        case 8:
          return function (e, t) {
            var n = Et(H(e.latitude), H(t.latitude));
            return 0 !== n ? n : Et(H(e.longitude), H(t.longitude));
          }(e.geoPointValue, t.geoPointValue);

        case 9:
          return function (e, t) {
            for (var n = e.values || [], r = t.values || [], i = 0; i < n.length && i < r.length; ++i) {
              var o = U(n[i], r[i]);
              if (o) return o;
            }

            return Et(n.length, r.length);
          }(e.arrayValue, t.arrayValue);

        case 10:
          return function (e, t) {
            var n = e.fields || {},
                r = Object.keys(n),
                i = t.fields || {},
                o = Object.keys(i);
            r.sort(), o.sort();

            for (var a = 0; a < r.length && a < o.length; ++a) {
              var s = Et(r[a], o[a]);
              if (0 !== s) return s;
              var u = U(n[r[a]], i[o[a]]);
              if (0 !== u) return u;
            }

            return Et(r.length, o.length);
          }(e.mapValue, t.mapValue);

        default:
          throw bt();
      }
    }

    function P(e, t) {
      if ("string" == typeof e && "string" == typeof t && e.length === t.length) return Et(e, t);
      var n = W(e),
          r = W(t),
          i = Et(n.seconds, r.seconds);
      return 0 !== i ? i : Et(n.nanos, r.nanos);
    }

    function V(e) {
      return function e(t) {
        return "nullValue" in t ? "null" : "booleanValue" in t ? "" + t.booleanValue : "integerValue" in t ? "" + t.integerValue : "doubleValue" in t ? "" + t.doubleValue : "timestampValue" in t ? function (e) {
          var t = W(e);
          return "time(" + t.seconds + "," + t.nanos + ")";
        }(t.timestampValue) : "stringValue" in t ? t.stringValue : "bytesValue" in t ? B(t.bytesValue).toBase64() : "referenceValue" in t ? (r = t.referenceValue, k.Z(r).toString()) : "geoPointValue" in t ? "geo(" + (n = t.geoPointValue).latitude + "," + n.longitude + ")" : "arrayValue" in t ? function (t) {
          for (var n = "[", r = !0, i = 0, o = t.values || []; i < o.length; i++) {
            var a = o[i];
            r ? r = !1 : n += ",", n += e(a);
          }

          return n + "]";
        }(t.arrayValue) : "mapValue" in t ? function (t) {
          for (var n = "{", r = !0, i = 0, o = Object.keys(t.fields || {}).sort(); i < o.length; i++) {
            var a = o[i];
            r ? r = !1 : n += ",", n += a + ":" + e(t.fields[a]);
          }

          return n + "}";
        }(t.mapValue) : bt();
        var n, r;
      }(e);
    }

    function W(e) {
      if (wt(!!e), "string" == typeof e) {
        var t = 0,
            n = O.exec(e);

        if (wt(!!n), n[1]) {
          var r = n[1];
          r = (r + "000000000").substr(0, 9), t = Number(r);
        }

        var i = new Date(e);
        return {
          seconds: Math.floor(i.getTime() / 1e3),
          nanos: t
        };
      }

      return {
        seconds: H(e.seconds),
        nanos: H(e.nanos)
      };
    }

    function H(e) {
      return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
    }

    function B(e) {
      return "string" == typeof e ? D.fromBase64String(e) : D.fromUint8Array(e);
    }

    function z(e, t) {
      return {
        referenceValue: "projects/" + e.projectId + "/databases/" + e.database + "/documents/" + t.path.j()
      };
    }

    function Z(e) {
      return !!e && "integerValue" in e;
    }

    function Q(e) {
      return !!e && "arrayValue" in e;
    }

    function G(e) {
      return !!e && "nullValue" in e;
    }

    function q(e) {
      return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
    }

    function J(e) {
      return !!e && "mapValue" in e;
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var X = function () {
      function e() {}

      return e.prototype.ot = function (e, t) {
        return function (e, t) {
          var n = {
            fields: {
              __type__: {
                stringValue: "server_timestamp"
              },
              __local_write_time__: {
                timestampValue: {
                  seconds: e.seconds,
                  nanos: e.nanoseconds
                }
              }
            }
          };
          return t && (n.fields.__previous_value__ = t), {
            mapValue: n
          };
        }(t, e);
      }, e.prototype.at = function (e, t) {
        return t;
      }, e.prototype.ut = function (e) {
        return null;
      }, e.prototype.isEqual = function (t) {
        return t instanceof e;
      }, e;
    }();

    X.instance = new X();

    var K = function () {
      function e(e) {
        this.elements = e;
      }

      return e.prototype.ot = function (e, t) {
        return this.apply(e);
      }, e.prototype.at = function (e, t) {
        return this.apply(e);
      }, e.prototype.apply = function (e) {
        for (var t = te(e), n = function n(e) {
          t.some(function (t) {
            return A(t, e);
          }) || t.push(e);
        }, r = 0, i = this.elements; r < i.length; r++) {
          n(i[r]);
        }

        return {
          arrayValue: {
            values: t
          }
        };
      }, e.prototype.ut = function (e) {
        return null;
      }, e.prototype.isEqual = function (t) {
        return t instanceof e && kt(this.elements, t.elements, A);
      }, e;
    }(),
        $ = function () {
      function e(e) {
        this.elements = e;
      }

      return e.prototype.ot = function (e, t) {
        return this.apply(e);
      }, e.prototype.at = function (e, t) {
        return this.apply(e);
      }, e.prototype.apply = function (e) {
        for (var t = te(e), n = function n(e) {
          t = t.filter(function (t) {
            return !A(t, e);
          });
        }, r = 0, i = this.elements; r < i.length; r++) {
          n(i[r]);
        }

        return {
          arrayValue: {
            values: t
          }
        };
      }, e.prototype.ut = function (e) {
        return null;
      }, e.prototype.isEqual = function (t) {
        return t instanceof e && kt(this.elements, t.elements, A);
      }, e;
    }(),
        ee = function () {
      function e(e, t) {
        this.serializer = e, this.ct = t;
      }

      return e.prototype.ot = function (e, t) {
        var n = this.ut(e),
            r = this.asNumber(n) + this.asNumber(this.ct);
        return Z(n) && Z(this.ct) ? this.serializer._t(r) : this.serializer.lt(r);
      }, e.prototype.at = function (e, t) {
        return t;
      }, e.prototype.ut = function (e) {
        return Z(t = e) || t && "doubleValue" in t ? e : {
          integerValue: 0
        };
        var t;
      }, e.prototype.isEqual = function (t) {
        return t instanceof e && A(this.ct, t.ct);
      }, e.prototype.asNumber = function (e) {
        return H(e.integerValue || e.doubleValue);
      }, e;
    }();

    function te(e) {
      return Q(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var ne = function () {
      function e(e) {
        this.fields = e, e.sort(E.N);
      }

      return e.prototype.dt = function (e) {
        for (var t = 0, n = this.fields; t < n.length; t++) {
          if (n[t].q(e)) return !0;
        }

        return !1;
      }, e.prototype.isEqual = function (e) {
        return kt(this.fields, e.fields, function (e, t) {
          return e.isEqual(t);
        });
      }, e;
    }(),
        re = function () {
      function e(e, t) {
        this.field = e, this.transform = t;
      }

      return e.prototype.isEqual = function (e) {
        return this.field.isEqual(e.field) && this.transform.isEqual(e.transform);
      }, e;
    }(),
        ie = function ie(e, t) {
      this.version = e, this.transformResults = t;
    },
        oe = function () {
      function e(e, t) {
        this.updateTime = e, this.exists = t;
      }

      return e.ft = function () {
        return new e();
      }, e.exists = function (t) {
        return new e(void 0, t);
      }, e.updateTime = function (t) {
        return new e(t);
      }, Object.defineProperty(e.prototype, "Tt", {
        get: function get() {
          return void 0 === this.updateTime && void 0 === this.exists;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.Et = function (e) {
        return void 0 !== this.updateTime ? e instanceof ve && e.version.isEqual(this.updateTime) : void 0 === this.exists || this.exists === e instanceof ve;
      }, e.prototype.isEqual = function (e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
      }, e;
    }(),
        ae = function () {
      function e() {}

      return e.prototype.It = function (e) {}, e.wt = function (e) {
        return e instanceof ve ? e.version : b.min();
      }, e;
    }(),
        se = function (e) {
      function t(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).key = t, i.value = n, i.Rt = r, i.type = 0, i;
      }

      return i.__extends(t, e), t.prototype.at = function (e, t) {
        this.It(e);
        var n = t.version;
        return new ve(this.key, n, this.value, {
          hasCommittedMutations: !0
        });
      }, t.prototype.ot = function (e, t, n) {
        if (this.It(e), !this.Rt.Et(e)) return e;
        var r = ae.wt(e);
        return new ve(this.key, r, this.value, {
          At: !0
        });
      }, t.prototype.Pt = function (e) {
        return null;
      }, t.prototype.isEqual = function (e) {
        return e instanceof t && this.key.isEqual(e.key) && this.value.isEqual(e.value) && this.Rt.isEqual(e.Rt);
      }, t;
    }(ae),
        ue = function (e) {
      function t(t, n, r, i) {
        var o = this;
        return (o = e.call(this) || this).key = t, o.data = n, o.Vt = r, o.Rt = i, o.type = 1, o;
      }

      return i.__extends(t, e), t.prototype.at = function (e, t) {
        if (this.It(e), !this.Rt.Et(e)) return new be(this.key, t.version);
        var n = this.gt(e);
        return new ve(this.key, t.version, n, {
          hasCommittedMutations: !0
        });
      }, t.prototype.ot = function (e, t, n) {
        if (this.It(e), !this.Rt.Et(e)) return e;
        var r = ae.wt(e),
            i = this.gt(e);
        return new ve(this.key, r, i, {
          At: !0
        });
      }, t.prototype.Pt = function (e) {
        return null;
      }, t.prototype.isEqual = function (e) {
        return e instanceof t && this.key.isEqual(e.key) && this.Vt.isEqual(e.Vt) && this.Rt.isEqual(e.Rt);
      }, t.prototype.gt = function (e) {
        var t;
        return t = e instanceof ve ? e.data() : de.empty(), this.pt(t);
      }, t.prototype.pt = function (e) {
        var t = this,
            n = new fe(e);
        return this.Vt.fields.forEach(function (e) {
          if (!e.B()) {
            var r = t.data.field(e);
            null !== r ? n.set(e, r) : n.delete(e);
          }
        }), n.yt();
      }, t;
    }(ae),
        ce = function (e) {
      function t(t, n) {
        var r = this;
        return (r = e.call(this) || this).key = t, r.fieldTransforms = n, r.type = 2, r.Rt = oe.exists(!0), r;
      }

      return i.__extends(t, e), t.prototype.at = function (e, t) {
        if (this.It(e), wt(null != t.transformResults), !this.Rt.Et(e)) return new be(this.key, t.version);
        var n = this.bt(e),
            r = this.vt(e, t.transformResults),
            i = t.version,
            o = this.St(n.data(), r);
        return new ve(this.key, i, o, {
          hasCommittedMutations: !0
        });
      }, t.prototype.ot = function (e, t, n) {
        if (this.It(e), !this.Rt.Et(e)) return e;
        var r = this.bt(e),
            i = this.Dt(n, e, t),
            o = this.St(r.data(), i);
        return new ve(this.key, r.version, o, {
          At: !0
        });
      }, t.prototype.Pt = function (e) {
        for (var t = null, n = 0, r = this.fieldTransforms; n < r.length; n++) {
          var i = r[n],
              o = e instanceof ve ? e.field(i.field) : void 0,
              a = i.transform.ut(o || null);
          null != a && (t = null == t ? new fe().set(i.field, a) : t.set(i.field, a));
        }

        return t ? t.yt() : null;
      }, t.prototype.isEqual = function (e) {
        return e instanceof t && this.key.isEqual(e.key) && kt(this.fieldTransforms, e.fieldTransforms, function (e, t) {
          return e.isEqual(t);
        }) && this.Rt.isEqual(e.Rt);
      }, t.prototype.bt = function (e) {
        return e;
      }, t.prototype.vt = function (e, t) {
        var n = [];
        wt(this.fieldTransforms.length === t.length);

        for (var r = 0; r < t.length; r++) {
          var i = this.fieldTransforms[r],
              o = i.transform,
              a = null;
          e instanceof ve && (a = e.field(i.field)), n.push(o.at(a, t[r]));
        }

        return n;
      }, t.prototype.Dt = function (e, t, n) {
        for (var r = [], i = 0, o = this.fieldTransforms; i < o.length; i++) {
          var a = o[i],
              s = a.transform,
              u = null;
          t instanceof ve && (u = t.field(a.field)), null === u && n instanceof ve && (u = n.field(a.field)), r.push(s.ot(u, e));
        }

        return r;
      }, t.prototype.St = function (e, t) {
        for (var n = new fe(e), r = 0; r < this.fieldTransforms.length; r++) {
          var i = this.fieldTransforms[r].field;
          n.set(i, t[r]);
        }

        return n.yt();
      }, t;
    }(ae),
        le = function (e) {
      function t(t, n) {
        var r = this;
        return (r = e.call(this) || this).key = t, r.Rt = n, r.type = 3, r;
      }

      return i.__extends(t, e), t.prototype.at = function (e, t) {
        return this.It(e), new ge(this.key, t.version, {
          hasCommittedMutations: !0
        });
      }, t.prototype.ot = function (e, t, n) {
        return this.It(e), this.Rt.Et(e) ? new ge(this.key, b.min()) : e;
      }, t.prototype.Pt = function (e) {
        return null;
      }, t.prototype.isEqual = function (e) {
        return e instanceof t && this.key.isEqual(e.key) && this.Rt.isEqual(e.Rt);
      }, t;
    }(ae),
        he = function (e) {
      function t(t, n) {
        var r = this;
        return (r = e.call(this) || this).key = t, r.Rt = n, r.type = 4, r;
      }

      return i.__extends(t, e), t.prototype.at = function (e, t) {
        bt();
      }, t.prototype.ot = function (e, t, n) {
        bt();
      }, t.prototype.Pt = function (e) {
        bt();
      }, t.prototype.isEqual = function (e) {
        return e instanceof t && this.key.isEqual(e.key) && this.Rt.isEqual(e.Rt);
      }, t;
    }(ae),
        de = function () {
      function e(e) {
        this.proto = e;
      }

      return e.empty = function () {
        return new e({
          mapValue: {}
        });
      }, e.prototype.field = function (e) {
        if (e.B()) return this.proto;

        for (var t = this.proto, n = 0; n < e.length - 1; ++n) {
          if (!t.mapValue.fields) return null;
          if (!J(t = t.mapValue.fields[e.get(n)])) return null;
        }

        return (t = (t.mapValue.fields || {})[e.O()]) || null;
      }, e.prototype.isEqual = function (e) {
        return A(this.proto, e.proto);
      }, e;
    }(),
        fe = function () {
      function e(e) {
        void 0 === e && (e = de.empty()), this.Ct = e, this.Ft = new Map();
      }

      return e.prototype.set = function (e, t) {
        return this.Nt(e, t), this;
      }, e.prototype.delete = function (e) {
        return this.Nt(e, null), this;
      }, e.prototype.Nt = function (e, t) {
        for (var n = this.Ft, r = 0; r < e.length - 1; ++r) {
          var i = e.get(r),
              o = n.get(i);
          o instanceof Map ? n = o : o && 10 === F(o) ? (o = new Map(Object.entries(o.mapValue.fields || {})), n.set(i, o), n = o) : (o = new Map(), n.set(i, o), n = o);
        }

        n.set(e.O(), t);
      }, e.prototype.yt = function () {
        var e = this.kt(E.G, this.Ft);
        return null != e ? new de(e) : this.Ct;
      }, e.prototype.kt = function (e, t) {
        var n = this,
            r = !1,
            i = this.Ct.field(e),
            o = J(i) ? Object.assign({}, i.mapValue.fields) : {};
        return t.forEach(function (t, i) {
          if (t instanceof Map) {
            var a = n.kt(e.child(i), t);
            null != a && (o[i] = a, r = !0);
          } else null !== t ? (o[i] = t, r = !0) : o.hasOwnProperty(i) && (delete o[i], r = !0);
        }), r ? {
          mapValue: {
            fields: o
          }
        } : null;
      }, e;
    }();

    function pe(e) {
      var t = [];
      return S(e.fields || {}, function (e, n) {
        var r = new E([e]);

        if (J(n)) {
          var i = pe(n.mapValue).fields;
          if (0 === i.length) t.push(r);else for (var o = 0, a = i; o < a.length; o++) {
            var s = a[o];
            t.push(r.child(s));
          }
        } else t.push(r);
      }), new ne(t);
      /**
       * @license
       * Copyright 2017 Google LLC
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */
    }

    var me,
        _e,
        ye = function ye(e, t) {
      this.key = e, this.version = t;
    },
        ve = function (e) {
      function t(t, n, r, i) {
        var o = this;
        return (o = e.call(this, t, n) || this).$t = r, o.At = !!i.At, o.hasCommittedMutations = !!i.hasCommittedMutations, o;
      }

      return i.__extends(t, e), t.prototype.field = function (e) {
        return this.$t.field(e);
      }, t.prototype.data = function () {
        return this.$t;
      }, t.prototype.Mt = function () {
        return this.$t.proto;
      }, t.prototype.isEqual = function (e) {
        return e instanceof t && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.At === e.At && this.hasCommittedMutations === e.hasCommittedMutations && this.$t.isEqual(e.$t);
      }, t.prototype.toString = function () {
        return "Document(" + this.key + ", " + this.version + ", " + this.$t.toString() + ", {hasLocalMutations: " + this.At + "}), {hasCommittedMutations: " + this.hasCommittedMutations + "})";
      }, Object.defineProperty(t.prototype, "hasPendingWrites", {
        get: function get() {
          return this.At || this.hasCommittedMutations;
        },
        enumerable: !0,
        configurable: !0
      }), t;
    }(ye),
        ge = function (e) {
      function t(t, n, r) {
        var i = this;
        return (i = e.call(this, t, n) || this).hasCommittedMutations = !(!r || !r.hasCommittedMutations), i;
      }

      return i.__extends(t, e), t.prototype.toString = function () {
        return "NoDocument(" + this.key + ", " + this.version + ")";
      }, Object.defineProperty(t.prototype, "hasPendingWrites", {
        get: function get() {
          return this.hasCommittedMutations;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.isEqual = function (e) {
        return e instanceof t && e.hasCommittedMutations === this.hasCommittedMutations && e.version.isEqual(this.version) && e.key.isEqual(this.key);
      }, t;
    }(ye),
        be = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return i.__extends(t, e), t.prototype.toString = function () {
        return "UnknownDocument(" + this.key + ", " + this.version + ")";
      }, Object.defineProperty(t.prototype, "hasPendingWrites", {
        get: function get() {
          return !0;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.isEqual = function (e) {
        return e instanceof t && e.version.isEqual(this.version) && e.key.isEqual(this.key);
      }, t;
    }(ye),
        we = function () {
      function e(e, t, n, r, i, o, a) {
        void 0 === t && (t = null), void 0 === n && (n = []), void 0 === r && (r = []), void 0 === i && (i = null), void 0 === o && (o = null), void 0 === a && (a = null), this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = o, this.endAt = a, this.Lt = null;
      }

      return e.prototype.canonicalId = function () {
        if (null === this.Lt) {
          var e = this.path.j();
          null !== this.collectionGroup && (e += "|cg:" + this.collectionGroup), e += "|f:", e += this.filters.map(function (e) {
            return e.canonicalId();
          }).join(","), e += "|ob:", e += this.orderBy.map(function (e) {
            return e.canonicalId();
          }).join(","), I(this.limit) || (e += "|l:", e += this.limit), this.startAt && (e += "|lb:", e += this.startAt.canonicalId()), this.endAt && (e += "|ub:", e += this.endAt.canonicalId()), this.Lt = e;
        }

        return this.Lt;
      }, e.prototype.toString = function () {
        var e = this.path.j();
        return null !== this.collectionGroup && (e += " collectionGroup=" + this.collectionGroup), this.filters.length > 0 && (e += ", filters: [" + this.filters.join(", ") + "]"), I(this.limit) || (e += ", limit: " + this.limit), this.orderBy.length > 0 && (e += ", orderBy: [" + this.orderBy.join(", ") + "]"), this.startAt && (e += ", startAt: " + this.startAt.canonicalId()), this.endAt && (e += ", endAt: " + this.endAt.canonicalId()), "Target(" + e + ")";
      }, e.prototype.isEqual = function (e) {
        if (this.limit !== e.limit) return !1;
        if (this.orderBy.length !== e.orderBy.length) return !1;

        for (var t = 0; t < this.orderBy.length; t++) {
          if (!this.orderBy[t].isEqual(e.orderBy[t])) return !1;
        }

        if (this.filters.length !== e.filters.length) return !1;

        for (var n = 0; n < this.filters.length; n++) {
          if (!this.filters[n].isEqual(e.filters[n])) return !1;
        }

        return this.collectionGroup === e.collectionGroup && !!this.path.isEqual(e.path) && !!(null !== this.startAt ? this.startAt.isEqual(e.startAt) : null === e.startAt) && (null !== this.endAt ? this.endAt.isEqual(e.endAt) : null === e.endAt);
      }, e.prototype.xt = function () {
        return k.et(this.path) && null === this.collectionGroup && 0 === this.filters.length;
      }, e;
    }(),
        Te = function () {
      function e(e, t, n, r, i, o, a, s) {
        void 0 === t && (t = null), void 0 === n && (n = []), void 0 === r && (r = []), void 0 === i && (i = null), void 0 === o && (o = "F"), void 0 === a && (a = null), void 0 === s && (s = null), this.path = e, this.collectionGroup = t, this.Ot = n, this.filters = r, this.limit = i, this.Bt = o, this.startAt = a, this.endAt = s, this.qt = null, this.Ut = null, this.startAt && this.Qt(this.startAt), this.endAt && this.Qt(this.endAt);
      }

      return e.Wt = function (t) {
        return new e(t);
      }, Object.defineProperty(e.prototype, "orderBy", {
        get: function get() {
          if (null === this.qt) {
            this.qt = [];
            var e = this.jt(),
                t = this.Kt();
            if (null !== e && null === t) e.Y() || this.qt.push(new Ie(e)), this.qt.push(new Ie(E.J(), "asc"));else {
              for (var n = !1, r = 0, i = this.Ot; r < i.length; r++) {
                var o = i[r];
                this.qt.push(o), o.field.Y() && (n = !0);
              }

              if (!n) {
                var a = this.Ot.length > 0 ? this.Ot[this.Ot.length - 1].dir : "asc";
                this.qt.push(new Ie(E.J(), a));
              }
            }
          }

          return this.qt;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.Gt = function (t) {
        var n = this.filters.concat([t]);
        return new e(this.path, this.collectionGroup, this.Ot.slice(), n, this.limit, this.Bt, this.startAt, this.endAt);
      }, e.prototype.zt = function (t) {
        var n = this.Ot.concat([t]);
        return new e(this.path, this.collectionGroup, n, this.filters.slice(), this.limit, this.Bt, this.startAt, this.endAt);
      }, e.prototype.Ht = function (t) {
        return new e(this.path, this.collectionGroup, this.Ot.slice(), this.filters.slice(), t, "F", this.startAt, this.endAt);
      }, e.prototype.Yt = function (t) {
        return new e(this.path, this.collectionGroup, this.Ot.slice(), this.filters.slice(), t, "L", this.startAt, this.endAt);
      }, e.prototype.Jt = function (t) {
        return new e(this.path, this.collectionGroup, this.Ot.slice(), this.filters.slice(), this.limit, this.Bt, t, this.endAt);
      }, e.prototype.Xt = function (t) {
        return new e(this.path, this.collectionGroup, this.Ot.slice(), this.filters.slice(), this.limit, this.Bt, this.startAt, t);
      }, e.prototype.Zt = function (t) {
        return new e(t, null, this.Ot.slice(), this.filters.slice(), this.limit, this.Bt, this.startAt, this.endAt);
      }, e.prototype.te = function () {
        return 0 === this.filters.length && null === this.limit && null == this.startAt && null == this.endAt && (0 === this.Ot.length || 1 === this.Ot.length && this.Ot[0].field.Y());
      }, e.prototype.canonicalId = function () {
        return this.ee().canonicalId() + "|lt:" + this.Bt;
      }, e.prototype.toString = function () {
        return "Query(target=" + this.ee().toString() + "; limitType=" + this.Bt + ")";
      }, e.prototype.isEqual = function (e) {
        return this.ee().isEqual(e.ee()) && this.Bt === e.Bt;
      }, e.prototype.se = function (e, t) {
        for (var n = !1, r = 0, i = this.orderBy; r < i.length; r++) {
          var o = i[r],
              a = o.compare(e, t);
          if (0 !== a) return a;
          n = n || o.field.Y();
        }

        return 0;
      }, e.prototype.matches = function (e) {
        return this.ie(e) && this.ne(e) && this.re(e) && this.he(e);
      }, e.prototype.oe = function () {
        return !I(this.limit) && "F" === this.Bt;
      }, e.prototype.ae = function () {
        return !I(this.limit) && "L" === this.Bt;
      }, e.prototype.Kt = function () {
        return this.Ot.length > 0 ? this.Ot[0].field : null;
      }, e.prototype.jt = function () {
        for (var e = 0, t = this.filters; e < t.length; e++) {
          var n = t[e];
          if (n instanceof Me && n.ue()) return n.field;
        }

        return null;
      }, e.prototype.ce = function (e) {
        for (var t = 0, n = this.filters; t < n.length; t++) {
          var r = n[t];
          if (r instanceof Me && e.indexOf(r.op) >= 0) return r.op;
        }

        return null;
      }, e.prototype.xt = function () {
        return this.ee().xt();
      }, e.prototype._e = function () {
        return null !== this.collectionGroup;
      }, e.prototype.ee = function () {
        if (!this.Ut) if ("F" === this.Bt) this.Ut = new we(this.path, this.collectionGroup, this.orderBy, this.filters, this.limit, this.startAt, this.endAt);else {
          for (var e = [], t = 0, n = this.orderBy; t < n.length; t++) {
            var r = n[t],
                i = "desc" === r.dir ? "asc" : "desc";
            e.push(new Ie(r.field, i));
          }

          var o = this.endAt ? new De(this.endAt.position, !this.endAt.before) : null,
              a = this.startAt ? new De(this.startAt.position, !this.startAt.before) : null;
          this.Ut = new we(this.path, this.collectionGroup, e, this.filters, this.limit, o, a);
        }
        return this.Ut;
      }, e.prototype.ie = function (e) {
        var t = e.key.path;
        return null !== this.collectionGroup ? e.key.tt(this.collectionGroup) && this.path.q(t) : k.et(this.path) ? this.path.isEqual(t) : this.path.U(t);
      }, e.prototype.ne = function (e) {
        for (var t = 0, n = this.Ot; t < n.length; t++) {
          var r = n[t];
          if (!r.field.Y() && null === e.field(r.field)) return !1;
        }

        return !0;
      }, e.prototype.re = function (e) {
        for (var t = 0, n = this.filters; t < n.length; t++) {
          if (!n[t].matches(e)) return !1;
        }

        return !0;
      }, e.prototype.he = function (e) {
        return !(this.startAt && !this.startAt.le(this.orderBy, e) || this.endAt && this.endAt.le(this.orderBy, e));
      }, e.prototype.Qt = function (e) {}, e;
    }(),
        Me = function (e) {
      function t(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).field = t, i.op = n, i.value = r, i;
      }

      return i.__extends(t, e), t.create = function (e, n, r) {
        if (e.Y()) return "in" === n ? new ke(e, r) : new Ee(e, n, r);

        if (G(r)) {
          if ("==" !== n) throw new f(d.INVALID_ARGUMENT, "Invalid query. Null supports only equality comparisons.");
          return new t(e, n, r);
        }

        if (q(r)) {
          if ("==" !== n) throw new f(d.INVALID_ARGUMENT, "Invalid query. NaN supports only equality comparisons.");
          return new t(e, n, r);
        }

        return "array-contains" === n ? new Le(e, r) : "in" === n ? new Se(e, r) : "array-contains-any" === n ? new Ne(e, r) : new t(e, n, r);
      }, t.prototype.matches = function (e) {
        var t = e.field(this.field);
        return null !== t && F(this.value) === F(t) && this.de(U(t, this.value));
      }, t.prototype.de = function (e) {
        switch (this.op) {
          case "<":
            return e < 0;

          case "<=":
            return e <= 0;

          case "==":
            return 0 === e;

          case ">":
            return e > 0;

          case ">=":
            return e >= 0;

          default:
            return bt();
        }
      }, t.prototype.ue = function () {
        return ["<", "<=", ">", ">="].indexOf(this.op) >= 0;
      }, t.prototype.canonicalId = function () {
        return this.field.j() + this.op.toString() + V(this.value);
      }, t.prototype.isEqual = function (e) {
        return e instanceof t && this.op === e.op && this.field.isEqual(e.field) && A(this.value, e.value);
      }, t.prototype.toString = function () {
        return this.field.j() + " " + this.op + " " + V(this.value);
      }, t;
    }(function () {}),
        Ee = function (e) {
      function t(t, n, r) {
        var i = this;
        return (i = e.call(this, t, n, r) || this).key = k.Z(r.referenceValue), i;
      }

      return i.__extends(t, e), t.prototype.matches = function (e) {
        var t = k.N(e.key, this.key);
        return this.de(t);
      }, t;
    }(Me),
        ke = function (e) {
      function t(t, n) {
        var r = this;
        return (r = e.call(this, t, "in", n) || this).keys = (n.arrayValue.values || []).map(function (e) {
          return k.Z(e.referenceValue);
        }), r;
      }

      return i.__extends(t, e), t.prototype.matches = function (e) {
        return this.keys.some(function (t) {
          return t.isEqual(e.key);
        });
      }, t;
    }(Me),
        Le = function (e) {
      function t(t, n) {
        return e.call(this, t, "array-contains", n) || this;
      }

      return i.__extends(t, e), t.prototype.matches = function (e) {
        var t = e.field(this.field);
        return Q(t) && j(t.arrayValue, this.value);
      }, t;
    }(Me),
        Se = function (e) {
      function t(t, n) {
        return e.call(this, t, "in", n) || this;
      }

      return i.__extends(t, e), t.prototype.matches = function (e) {
        var t = e.field(this.field);
        return null !== t && j(this.value.arrayValue, t);
      }, t;
    }(Me),
        Ne = function (e) {
      function t(t, n) {
        return e.call(this, t, "array-contains-any", n) || this;
      }

      return i.__extends(t, e), t.prototype.matches = function (e) {
        var t = this,
            n = e.field(this.field);
        return !(!Q(n) || !n.arrayValue.values) && n.arrayValue.values.some(function (e) {
          return j(t.value.arrayValue, e);
        });
      }, t;
    }(Me),
        De = function () {
      function e(e, t) {
        this.position = e, this.before = t;
      }

      return e.prototype.canonicalId = function () {
        return (this.before ? "b" : "a") + ":" + this.position.map(function (e) {
          return V(e);
        }).join(",");
      }, e.prototype.le = function (e, t) {
        for (var n = 0, r = 0; r < this.position.length; r++) {
          var i = e[r],
              o = this.position[r];
          if (n = i.field.Y() ? k.N(k.Z(o.referenceValue), t.key) : U(o, t.field(i.field)), "desc" === i.dir && (n *= -1), 0 !== n) break;
        }

        return this.before ? n <= 0 : n < 0;
      }, e.prototype.isEqual = function (e) {
        if (null === e) return !1;
        if (this.before !== e.before || this.position.length !== e.position.length) return !1;

        for (var t = 0; t < this.position.length; t++) {
          if (!A(this.position[t], e.position[t])) return !1;
        }

        return !0;
      }, e;
    }(),
        Ie = function () {
      function e(e, t) {
        this.field = e, void 0 === t && (t = "asc"), this.dir = t, this.fe = e.Y();
      }

      return e.prototype.compare = function (e, t) {
        var n = this.fe ? k.N(e.key, t.key) : function (e, t, n) {
          var r = t.field(e),
              i = n.field(e);
          return null !== r && null !== i ? U(r, i) : bt();
        }(this.field, e, t);

        switch (this.dir) {
          case "asc":
            return n;

          case "desc":
            return -1 * n;

          default:
            return bt();
        }
      }, e.prototype.canonicalId = function () {
        return this.field.j() + this.dir.toString();
      }, e.prototype.toString = function () {
        return this.field.j() + " (" + this.dir + ")";
      }, e.prototype.isEqual = function (e) {
        return this.dir === e.dir && this.field.isEqual(e.field);
      }, e;
    }(),
        Re = function () {
      function e(e, t, n, r, i, o, a) {
        void 0 === i && (i = b.min()), void 0 === o && (o = b.min()), void 0 === a && (a = D.ht), this.target = e, this.targetId = t, this.Te = n, this.sequenceNumber = r, this.Ee = i, this.lastLimboFreeSnapshotVersion = o, this.resumeToken = a;
      }

      return e.prototype.Ie = function (t) {
        return new e(this.target, this.targetId, this.Te, t, this.Ee, this.lastLimboFreeSnapshotVersion, this.resumeToken);
      }, e.prototype.we = function (t, n) {
        return new e(this.target, this.targetId, this.Te, this.sequenceNumber, n, this.lastLimboFreeSnapshotVersion, t);
      }, e.prototype.Re = function (t) {
        return new e(this.target, this.targetId, this.Te, this.sequenceNumber, this.Ee, t, this.resumeToken);
      }, e;
    }(),
        xe = function xe(e) {
      this.count = e;
    };

    function Ye(e) {
      switch (e) {
        case d.OK:
          return bt();

        case d.CANCELLED:
        case d.UNKNOWN:
        case d.DEADLINE_EXCEEDED:
        case d.RESOURCE_EXHAUSTED:
        case d.INTERNAL:
        case d.UNAVAILABLE:
        case d.UNAUTHENTICATED:
          return !1;

        case d.INVALID_ARGUMENT:
        case d.NOT_FOUND:
        case d.ALREADY_EXISTS:
        case d.PERMISSION_DENIED:
        case d.FAILED_PRECONDITION:
        case d.ABORTED:
        case d.OUT_OF_RANGE:
        case d.UNIMPLEMENTED:
        case d.DATA_LOSS:
          return !0;

        default:
          return bt();
      }
    }

    function Ce(e) {
      if (void 0 === e) return vt("GRPC error has no .code"), d.UNKNOWN;

      switch (e) {
        case me.OK:
          return d.OK;

        case me.CANCELLED:
          return d.CANCELLED;

        case me.UNKNOWN:
          return d.UNKNOWN;

        case me.DEADLINE_EXCEEDED:
          return d.DEADLINE_EXCEEDED;

        case me.RESOURCE_EXHAUSTED:
          return d.RESOURCE_EXHAUSTED;

        case me.INTERNAL:
          return d.INTERNAL;

        case me.UNAVAILABLE:
          return d.UNAVAILABLE;

        case me.UNAUTHENTICATED:
          return d.UNAUTHENTICATED;

        case me.INVALID_ARGUMENT:
          return d.INVALID_ARGUMENT;

        case me.NOT_FOUND:
          return d.NOT_FOUND;

        case me.ALREADY_EXISTS:
          return d.ALREADY_EXISTS;

        case me.PERMISSION_DENIED:
          return d.PERMISSION_DENIED;

        case me.FAILED_PRECONDITION:
          return d.FAILED_PRECONDITION;

        case me.ABORTED:
          return d.ABORTED;

        case me.OUT_OF_RANGE:
          return d.OUT_OF_RANGE;

        case me.UNIMPLEMENTED:
          return d.UNIMPLEMENTED;

        case me.DATA_LOSS:
          return d.DATA_LOSS;

        default:
          return bt();
      }
    }

    (_e = me || (me = {}))[_e.OK = 0] = "OK", _e[_e.CANCELLED = 1] = "CANCELLED", _e[_e.UNKNOWN = 2] = "UNKNOWN", _e[_e.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", _e[_e.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", _e[_e.NOT_FOUND = 5] = "NOT_FOUND", _e[_e.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", _e[_e.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", _e[_e.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", _e[_e.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", _e[_e.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", _e[_e.ABORTED = 10] = "ABORTED", _e[_e.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", _e[_e.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", _e[_e.INTERNAL = 13] = "INTERNAL", _e[_e.UNAVAILABLE = 14] = "UNAVAILABLE", _e[_e.DATA_LOSS = 15] = "DATA_LOSS";
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    var Oe = function () {
      function e(e, t) {
        this.N = e, this.root = t || Ae.EMPTY;
      }

      return e.prototype.me = function (t, n) {
        return new e(this.N, this.root.me(t, n, this.N).Ae(null, null, Ae.Pe, null, null));
      }, e.prototype.remove = function (t) {
        return new e(this.N, this.root.remove(t, this.N).Ae(null, null, Ae.Pe, null, null));
      }, e.prototype.get = function (e) {
        for (var t = this.root; !t.B();) {
          var n = this.N(e, t.key);
          if (0 === n) return t.value;
          n < 0 ? t = t.left : n > 0 && (t = t.right);
        }

        return null;
      }, e.prototype.indexOf = function (e) {
        for (var t = 0, n = this.root; !n.B();) {
          var r = this.N(e, n.key);
          if (0 === r) return t + n.left.size;
          r < 0 ? n = n.left : (t += n.left.size + 1, n = n.right);
        }

        return -1;
      }, e.prototype.B = function () {
        return this.root.B();
      }, Object.defineProperty(e.prototype, "size", {
        get: function get() {
          return this.root.size;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.Ve = function () {
        return this.root.Ve();
      }, e.prototype.ge = function () {
        return this.root.ge();
      }, e.prototype.pe = function (e) {
        return this.root.pe(e);
      }, e.prototype.forEach = function (e) {
        this.pe(function (t, n) {
          return e(t, n), !1;
        });
      }, e.prototype.toString = function () {
        var e = [];
        return this.pe(function (t, n) {
          return e.push(t + ":" + n), !1;
        }), "{" + e.join(", ") + "}";
      }, e.prototype.ye = function (e) {
        return this.root.ye(e);
      }, e.prototype.be = function () {
        return new Fe(this.root, null, this.N, !1);
      }, e.prototype.ve = function (e) {
        return new Fe(this.root, e, this.N, !1);
      }, e.prototype.Se = function () {
        return new Fe(this.root, null, this.N, !0);
      }, e.prototype.De = function (e) {
        return new Fe(this.root, e, this.N, !0);
      }, e;
    }(),
        Fe = function () {
      function e(e, t, n, r) {
        this.Ce = r, this.Fe = [];

        for (var i = 1; !e.B();) {
          if (i = t ? n(e.key, t) : 1, r && (i *= -1), i < 0) e = this.Ce ? e.left : e.right;else {
            if (0 === i) {
              this.Fe.push(e);
              break;
            }

            this.Fe.push(e), e = this.Ce ? e.right : e.left;
          }
        }
      }

      return e.prototype.Ne = function () {
        var e = this.Fe.pop(),
            t = {
          key: e.key,
          value: e.value
        };
        if (this.Ce) for (e = e.left; !e.B();) {
          this.Fe.push(e), e = e.right;
        } else for (e = e.right; !e.B();) {
          this.Fe.push(e), e = e.left;
        }
        return t;
      }, e.prototype.ke = function () {
        return this.Fe.length > 0;
      }, e.prototype.$e = function () {
        if (0 === this.Fe.length) return null;
        var e = this.Fe[this.Fe.length - 1];
        return {
          key: e.key,
          value: e.value
        };
      }, e;
    }(),
        Ae = function () {
      function e(t, n, r, i, o) {
        this.key = t, this.value = n, this.color = null != r ? r : e.RED, this.left = null != i ? i : e.EMPTY, this.right = null != o ? o : e.EMPTY, this.size = this.left.size + 1 + this.right.size;
      }

      return e.prototype.Ae = function (t, n, r, i, o) {
        return new e(null != t ? t : this.key, null != n ? n : this.value, null != r ? r : this.color, null != i ? i : this.left, null != o ? o : this.right);
      }, e.prototype.B = function () {
        return !1;
      }, e.prototype.pe = function (e) {
        return this.left.pe(e) || e(this.key, this.value) || this.right.pe(e);
      }, e.prototype.ye = function (e) {
        return this.right.ye(e) || e(this.key, this.value) || this.left.ye(e);
      }, e.prototype.min = function () {
        return this.left.B() ? this : this.left.min();
      }, e.prototype.Ve = function () {
        return this.min().key;
      }, e.prototype.ge = function () {
        return this.right.B() ? this.key : this.right.ge();
      }, e.prototype.me = function (e, t, n) {
        var r = this,
            i = n(e, r.key);
        return (r = i < 0 ? r.Ae(null, null, null, r.left.me(e, t, n), null) : 0 === i ? r.Ae(null, t, null, null, null) : r.Ae(null, null, null, null, r.right.me(e, t, n))).Me();
      }, e.prototype.Le = function () {
        if (this.left.B()) return e.EMPTY;
        var t = this;
        return t.left.xe() || t.left.left.xe() || (t = t.Oe()), (t = t.Ae(null, null, null, t.left.Le(), null)).Me();
      }, e.prototype.remove = function (t, n) {
        var r,
            i = this;
        if (n(t, i.key) < 0) i.left.B() || i.left.xe() || i.left.left.xe() || (i = i.Oe()), i = i.Ae(null, null, null, i.left.remove(t, n), null);else {
          if (i.left.xe() && (i = i.Be()), i.right.B() || i.right.xe() || i.right.left.xe() || (i = i.qe()), 0 === n(t, i.key)) {
            if (i.right.B()) return e.EMPTY;
            r = i.right.min(), i = i.Ae(r.key, r.value, null, null, i.right.Le());
          }

          i = i.Ae(null, null, null, null, i.right.remove(t, n));
        }
        return i.Me();
      }, e.prototype.xe = function () {
        return this.color;
      }, e.prototype.Me = function () {
        var e = this;
        return e.right.xe() && !e.left.xe() && (e = e.Ue()), e.left.xe() && e.left.left.xe() && (e = e.Be()), e.left.xe() && e.right.xe() && (e = e.Qe()), e;
      }, e.prototype.Oe = function () {
        var e = this.Qe();
        return e.right.left.xe() && (e = (e = (e = e.Ae(null, null, null, null, e.right.Be())).Ue()).Qe()), e;
      }, e.prototype.qe = function () {
        var e = this.Qe();
        return e.left.left.xe() && (e = (e = e.Be()).Qe()), e;
      }, e.prototype.Ue = function () {
        var t = this.Ae(null, null, e.RED, null, this.right.left);
        return this.right.Ae(null, null, this.color, t, null);
      }, e.prototype.Be = function () {
        var t = this.Ae(null, null, e.RED, this.left.right, null);
        return this.left.Ae(null, null, this.color, null, t);
      }, e.prototype.Qe = function () {
        var e = this.left.Ae(null, null, !this.left.color, null, null),
            t = this.right.Ae(null, null, !this.right.color, null, null);
        return this.Ae(null, null, !this.color, e, t);
      }, e.prototype.We = function () {
        var e = this.je();
        return Math.pow(2, e) <= this.size + 1;
      }, e.prototype.je = function () {
        if (this.xe() && this.left.xe()) throw bt();
        if (this.right.xe()) throw bt();
        var e = this.left.je();
        if (e !== this.right.je()) throw bt();
        return e + (this.xe() ? 0 : 1);
      }, e;
    }();

    Ae.EMPTY = null, Ae.RED = !0, Ae.Pe = !1, Ae.EMPTY = new (function () {
      function e() {
        this.size = 0;
      }

      return Object.defineProperty(e.prototype, "key", {
        get: function get() {
          throw bt();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "value", {
        get: function get() {
          throw bt();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "color", {
        get: function get() {
          throw bt();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "left", {
        get: function get() {
          throw bt();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "right", {
        get: function get() {
          throw bt();
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.Ae = function (e, t, n, r, i) {
        return this;
      }, e.prototype.me = function (e, t, n) {
        return new Ae(e, t);
      }, e.prototype.remove = function (e, t) {
        return this;
      }, e.prototype.B = function () {
        return !0;
      }, e.prototype.pe = function (e) {
        return !1;
      }, e.prototype.ye = function (e) {
        return !1;
      }, e.prototype.Ve = function () {
        return null;
      }, e.prototype.ge = function () {
        return null;
      }, e.prototype.xe = function () {
        return !1;
      }, e.prototype.We = function () {
        return !0;
      }, e.prototype.je = function () {
        return 0;
      }, e;
    }())();
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    var je = function () {
      function e(e) {
        this.N = e, this.data = new Oe(this.N);
      }

      return e.prototype.has = function (e) {
        return null !== this.data.get(e);
      }, e.prototype.first = function () {
        return this.data.Ve();
      }, e.prototype.last = function () {
        return this.data.ge();
      }, Object.defineProperty(e.prototype, "size", {
        get: function get() {
          return this.data.size;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.indexOf = function (e) {
        return this.data.indexOf(e);
      }, e.prototype.forEach = function (e) {
        this.data.pe(function (t, n) {
          return e(t), !1;
        });
      }, e.prototype.Ke = function (e, t) {
        for (var n = this.data.ve(e[0]); n.ke();) {
          var r = n.Ne();
          if (this.N(r.key, e[1]) >= 0) return;
          t(r.key);
        }
      }, e.prototype.Ge = function (e, t) {
        var n;

        for (n = void 0 !== t ? this.data.ve(t) : this.data.be(); n.ke();) {
          if (!e(n.Ne().key)) return;
        }
      }, e.prototype.ze = function (e) {
        var t = this.data.ve(e);
        return t.ke() ? t.Ne().key : null;
      }, e.prototype.be = function () {
        return new Ue(this.data.be());
      }, e.prototype.ve = function (e) {
        return new Ue(this.data.ve(e));
      }, e.prototype.add = function (e) {
        return this.Ae(this.data.remove(e).me(e, !0));
      }, e.prototype.delete = function (e) {
        return this.has(e) ? this.Ae(this.data.remove(e)) : this;
      }, e.prototype.B = function () {
        return this.data.B();
      }, e.prototype.He = function (e) {
        var t = this;
        return t.size < e.size && (t = e, e = this), e.forEach(function (e) {
          t = t.add(e);
        }), t;
      }, e.prototype.isEqual = function (t) {
        if (!(t instanceof e)) return !1;
        if (this.size !== t.size) return !1;

        for (var n = this.data.be(), r = t.data.be(); n.ke();) {
          var i = n.Ne().key,
              o = r.Ne().key;
          if (0 !== this.N(i, o)) return !1;
        }

        return !0;
      }, e.prototype.W = function () {
        var e = [];
        return this.forEach(function (t) {
          e.push(t);
        }), e;
      }, e.prototype.toString = function () {
        var e = [];
        return this.forEach(function (t) {
          return e.push(t);
        }), "SortedSet(" + e.toString() + ")";
      }, e.prototype.Ae = function (t) {
        var n = new e(this.N);
        return n.data = t, n;
      }, e;
    }(),
        Ue = function () {
      function e(e) {
        this.Ye = e;
      }

      return e.prototype.Ne = function () {
        return this.Ye.Ne().key;
      }, e.prototype.ke = function () {
        return this.Ye.ke();
      }, e;
    }(),
        Pe = new Oe(k.N);

    function Ve() {
      return Pe;
    }

    function We() {
      return Ve();
    }

    var He = new Oe(k.N);

    function Be() {
      return He;
    }

    var ze = new Oe(k.N);

    function Ze() {
      return ze;
    }

    var Qe = new je(k.N);

    function Ge() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }

      for (var n = Qe, r = 0, i = e; r < i.length; r++) {
        var o = i[r];
        n = n.add(o);
      }

      return n;
    }

    var qe = new je(Et);

    function Je() {
      return qe;
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var Xe = function () {
      function e(e) {
        this.N = e ? function (t, n) {
          return e(t, n) || k.N(t.key, n.key);
        } : function (e, t) {
          return k.N(e.key, t.key);
        }, this.Je = Be(), this.Xe = new Oe(this.N);
      }

      return e.Ze = function (t) {
        return new e(t.N);
      }, e.prototype.has = function (e) {
        return null != this.Je.get(e);
      }, e.prototype.get = function (e) {
        return this.Je.get(e);
      }, e.prototype.first = function () {
        return this.Xe.Ve();
      }, e.prototype.last = function () {
        return this.Xe.ge();
      }, e.prototype.B = function () {
        return this.Xe.B();
      }, e.prototype.indexOf = function (e) {
        var t = this.Je.get(e);
        return t ? this.Xe.indexOf(t) : -1;
      }, Object.defineProperty(e.prototype, "size", {
        get: function get() {
          return this.Xe.size;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.forEach = function (e) {
        this.Xe.pe(function (t, n) {
          return e(t), !1;
        });
      }, e.prototype.add = function (e) {
        var t = this.delete(e.key);
        return t.Ae(t.Je.me(e.key, e), t.Xe.me(e, null));
      }, e.prototype.delete = function (e) {
        var t = this.get(e);
        return t ? this.Ae(this.Je.remove(e), this.Xe.remove(t)) : this;
      }, e.prototype.isEqual = function (t) {
        if (!(t instanceof e)) return !1;
        if (this.size !== t.size) return !1;

        for (var n = this.Xe.be(), r = t.Xe.be(); n.ke();) {
          var i = n.Ne().key,
              o = r.Ne().key;
          if (!i.isEqual(o)) return !1;
        }

        return !0;
      }, e.prototype.toString = function () {
        var e = [];
        return this.forEach(function (t) {
          e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
      }, e.prototype.Ae = function (t, n) {
        var r = new e();
        return r.N = this.N, r.Je = t, r.Xe = n, r;
      }, e;
    }(),
        Ke = function () {
      function e() {
        this.ts = new Oe(k.N);
      }

      return e.prototype.track = function (e) {
        var t = e.doc.key,
            n = this.ts.get(t);
        n ? 0 !== e.type && 3 === n.type ? this.ts = this.ts.me(t, e) : 3 === e.type && 1 !== n.type ? this.ts = this.ts.me(t, {
          type: n.type,
          doc: e.doc
        }) : 2 === e.type && 2 === n.type ? this.ts = this.ts.me(t, {
          type: 2,
          doc: e.doc
        }) : 2 === e.type && 0 === n.type ? this.ts = this.ts.me(t, {
          type: 0,
          doc: e.doc
        }) : 1 === e.type && 0 === n.type ? this.ts = this.ts.remove(t) : 1 === e.type && 2 === n.type ? this.ts = this.ts.me(t, {
          type: 1,
          doc: n.doc
        }) : 0 === e.type && 1 === n.type ? this.ts = this.ts.me(t, {
          type: 2,
          doc: e.doc
        }) : bt() : this.ts = this.ts.me(t, e);
      }, e.prototype.es = function () {
        var e = [];
        return this.ts.pe(function (t, n) {
          e.push(n);
        }), e;
      }, e;
    }(),
        $e = function () {
      function e(e, t, n, r, i, o, a, s) {
        this.query = e, this.docs = t, this.ss = n, this.docChanges = r, this.ns = i, this.fromCache = o, this.rs = a, this.hs = s;
      }

      return e.os = function (t, n, r, i) {
        var o = [];
        return n.forEach(function (e) {
          o.push({
            type: 0,
            doc: e
          });
        }), new e(t, n, Xe.Ze(n), o, r, i, !0, !1);
      }, Object.defineProperty(e.prototype, "hasPendingWrites", {
        get: function get() {
          return !this.ns.B();
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.isEqual = function (e) {
        if (!(this.fromCache === e.fromCache && this.rs === e.rs && this.ns.isEqual(e.ns) && this.query.isEqual(e.query) && this.docs.isEqual(e.docs) && this.ss.isEqual(e.ss))) return !1;
        var t = this.docChanges,
            n = e.docChanges;
        if (t.length !== n.length) return !1;

        for (var r = 0; r < t.length; r++) {
          if (t[r].type !== n[r].type || !t[r].doc.isEqual(n[r].doc)) return !1;
        }

        return !0;
      }, e;
    }(),
        et = function () {
      function e(e, t, n, r, i) {
        this.Ee = e, this.as = t, this.us = n, this.cs = r, this._s = i;
      }

      return e.ls = function (t, n) {
        var r = new Map();
        return r.set(t, tt.ds(t, n)), new e(b.min(), r, Je(), Ve(), Ge());
      }, e;
    }(),
        tt = function () {
      function e(e, t, n, r, i) {
        this.resumeToken = e, this.fs = t, this.Ts = n, this.Es = r, this.Is = i;
      }

      return e.ds = function (t, n) {
        return new e(D.ht, n, Ge(), Ge(), Ge());
      }, e;
    }(),
        nt = function nt(e, t, n, r) {
      this.ws = e, this.removedTargetIds = t, this.key = n, this.Rs = r;
    },
        rt = function rt(e, t) {
      this.targetId = e, this.ms = t;
    },
        it = function it(e, t, n, r) {
      void 0 === n && (n = D.ht), void 0 === r && (r = null), this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    },
        ot = function () {
      function e() {
        this.As = 0, this.Ps = ut(), this.Vs = D.ht, this.gs = !1, this.ps = !0;
      }

      return Object.defineProperty(e.prototype, "fs", {
        get: function get() {
          return this.gs;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "resumeToken", {
        get: function get() {
          return this.Vs;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "ys", {
        get: function get() {
          return 0 !== this.As;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "bs", {
        get: function get() {
          return this.ps;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.vs = function (e) {
        e.rt() > 0 && (this.ps = !0, this.Vs = e);
      }, e.prototype.Ss = function () {
        var e = Ge(),
            t = Ge(),
            n = Ge();
        return this.Ps.forEach(function (r, i) {
          switch (i) {
            case 0:
              e = e.add(r);
              break;

            case 2:
              t = t.add(r);
              break;

            case 1:
              n = n.add(r);
              break;

            default:
              bt();
          }
        }), new tt(this.Vs, this.gs, e, t, n);
      }, e.prototype.Ds = function () {
        this.ps = !1, this.Ps = ut();
      }, e.prototype.Cs = function (e, t) {
        this.ps = !0, this.Ps = this.Ps.me(e, t);
      }, e.prototype.Fs = function (e) {
        this.ps = !0, this.Ps = this.Ps.remove(e);
      }, e.prototype.Ns = function () {
        this.As += 1;
      }, e.prototype.ks = function () {
        this.As -= 1;
      }, e.prototype.$s = function () {
        this.ps = !0, this.gs = !0;
      }, e;
    }(),
        at = function () {
      function e(e) {
        this.Ms = e, this.Ls = new Map(), this.xs = Ve(), this.Os = st(), this.Bs = new je(Et);
      }

      return e.prototype.qs = function (e) {
        for (var t = 0, n = e.ws; t < n.length; t++) {
          var r = n[t];
          e.Rs instanceof ve ? this.Us(r, e.Rs) : e.Rs instanceof ge && this.Qs(r, e.key, e.Rs);
        }

        for (var i = 0, o = e.removedTargetIds; i < o.length; i++) {
          var a = o[i];
          this.Qs(a, e.key, e.Rs);
        }
      }, e.prototype.Ws = function (e) {
        var t = this;
        this.js(e, function (n) {
          var r = t.Ks(n);

          switch (e.state) {
            case 0:
              t.Gs(n) && r.vs(e.resumeToken);
              break;

            case 1:
              r.ks(), r.ys || r.Ds(), r.vs(e.resumeToken);
              break;

            case 2:
              r.ks(), r.ys || t.removeTarget(n);
              break;

            case 3:
              t.Gs(n) && (r.$s(), r.vs(e.resumeToken));
              break;

            case 4:
              t.Gs(n) && (t.zs(n), r.vs(e.resumeToken));
              break;

            default:
              bt();
          }
        });
      }, e.prototype.js = function (e, t) {
        var n = this;
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Ls.forEach(function (e, r) {
          n.Gs(r) && t(r);
        });
      }, e.prototype.Hs = function (e) {
        var t = e.targetId,
            n = e.ms.count,
            r = this.Ys(t);

        if (r) {
          var i = r.target;
          if (i.xt()) {
            if (0 === n) {
              var o = new k(i.path);
              this.Qs(t, o, new ge(o, b.min()));
            } else wt(1 === n);
          } else this.Js(t) !== n && (this.zs(t), this.Bs = this.Bs.add(t));
        }
      }, e.prototype.Xs = function (e) {
        var t = this,
            n = new Map();
        this.Ls.forEach(function (r, i) {
          var o = t.Ys(i);

          if (o) {
            if (r.fs && o.target.xt()) {
              var a = new k(o.target.path);
              null !== t.xs.get(a) || t.Zs(i, a) || t.Qs(i, a, new ge(a, e));
            }

            r.bs && (n.set(i, r.Ss()), r.Ds());
          }
        });
        var r = Ge();
        this.Os.forEach(function (e, n) {
          var i = !0;
          n.Ge(function (e) {
            var n = t.Ys(e);
            return !n || 2 === n.Te || (i = !1, !1);
          }), i && (r = r.add(e));
        });
        var i = new et(e, n, this.Bs, this.xs, r);
        return this.xs = Ve(), this.Os = st(), this.Bs = new je(Et), i;
      }, e.prototype.Us = function (e, t) {
        if (this.Gs(e)) {
          var n = this.Zs(e, t.key) ? 2 : 0;
          this.Ks(e).Cs(t.key, n), this.xs = this.xs.me(t.key, t), this.Os = this.Os.me(t.key, this.ti(t.key).add(e));
        }
      }, e.prototype.Qs = function (e, t, n) {
        if (this.Gs(e)) {
          var r = this.Ks(e);
          this.Zs(e, t) ? r.Cs(t, 1) : r.Fs(t), this.Os = this.Os.me(t, this.ti(t).delete(e)), n && (this.xs = this.xs.me(t, n));
        }
      }, e.prototype.removeTarget = function (e) {
        this.Ls.delete(e);
      }, e.prototype.Js = function (e) {
        var t = this.Ks(e).Ss();
        return this.Ms.ei(e).size + t.Ts.size - t.Is.size;
      }, e.prototype.Ns = function (e) {
        this.Ks(e).Ns();
      }, e.prototype.Ks = function (e) {
        var t = this.Ls.get(e);
        return t || (t = new ot(), this.Ls.set(e, t)), t;
      }, e.prototype.ti = function (e) {
        var t = this.Os.get(e);
        return t || (t = new je(Et), this.Os = this.Os.me(e, t)), t;
      }, e.prototype.Gs = function (e) {
        var t = null !== this.Ys(e);
        return t || yt("WatchChangeAggregator", "Detected inactive target", e), t;
      }, e.prototype.Ys = function (e) {
        var t = this.Ls.get(e);
        return t && t.ys ? null : this.Ms.si(e);
      }, e.prototype.zs = function (e) {
        var t = this;
        this.Ls.set(e, new ot()), this.Ms.ei(e).forEach(function (n) {
          t.Qs(e, n, null);
        });
      }, e.prototype.Zs = function (e, t) {
        return this.Ms.ei(e).has(t);
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function st() {
      return new Oe(k.N);
    }

    function ut() {
      return new Oe(k.N);
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var ct = {
      asc: "ASCENDING",
      desc: "DESCENDING"
    },
        lt = {
      "<": "LESS_THAN",
      "<=": "LESS_THAN_OR_EQUAL",
      ">": "GREATER_THAN",
      ">=": "GREATER_THAN_OR_EQUAL",
      "==": "EQUAL",
      "array-contains": "ARRAY_CONTAINS",
      in: "IN",
      "array-contains-any": "ARRAY_CONTAINS_ANY"
    },
        ht = function () {
      function e(e, t) {
        this.ii = e, this.options = t;
      }

      return e.prototype.ni = function (e) {
        var t = void 0 === e.code ? d.UNKNOWN : Ce(e.code);
        return new f(t, e.message || "");
      }, e.prototype.ri = function (e) {
        return this.options.hi || I(e) ? e : {
          value: e
        };
      }, e.prototype.oi = function (e) {
        var t;
        return I(t = "object" == typeof e ? e.value : e) ? null : t;
      }, e.prototype._t = function (e) {
        return {
          integerValue: "" + e
        };
      }, e.prototype.lt = function (e) {
        if (this.options.hi) {
          if (isNaN(e)) return {
            doubleValue: "NaN"
          };
          if (e === 1 / 0) return {
            doubleValue: "Infinity"
          };
          if (e === -1 / 0) return {
            doubleValue: "-Infinity"
          };
        }

        return {
          doubleValue: R(e) ? "-0" : e
        };
      }, e.prototype.ai = function (e) {
        return x(e) ? this._t(e) : this.lt(e);
      }, e.prototype.C = function (e) {
        return this.options.hi ? new Date(1e3 * e.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "") + "." + ("000000000" + e.nanoseconds).slice(-9) + "Z" : {
          seconds: "" + e.seconds,
          nanos: e.nanoseconds
        };
      }, e.prototype.v = function (e) {
        var t = W(e);
        return new g(t.seconds, t.nanos);
      }, e.prototype.ui = function (e) {
        return this.options.hi ? e.toBase64() : e.toUint8Array();
      }, e.prototype.ci = function (e) {
        return this.options.hi ? (wt(void 0 === e || "string" == typeof e), D.fromBase64String(e || "")) : (wt(void 0 === e || e instanceof Uint8Array), D.fromUint8Array(e || new Uint8Array()));
      }, e.prototype.toVersion = function (e) {
        return this.C(e.C());
      }, e.prototype.fromVersion = function (e) {
        return wt(!!e), b.v(this.v(e));
      }, e.prototype._i = function (e, t) {
        return this.li(t || this.ii).child("documents").child(e).j();
      }, e.prototype.di = function (e) {
        var t = T.K(e);
        return wt(dt(t)), t;
      }, e.prototype.fi = function (e) {
        return this._i(e.path);
      }, e.prototype.Z = function (e) {
        var t = this.di(e);
        return wt(t.get(1) === this.ii.projectId), wt(!t.get(3) && !this.ii.database || t.get(3) === this.ii.database), new k(this.Ti(t));
      }, e.prototype.Ei = function (e) {
        return this._i(e);
      }, e.prototype.Ii = function (e) {
        var t = this.di(e);
        return 4 === t.length ? T.G : this.Ti(t);
      }, Object.defineProperty(e.prototype, "wi", {
        get: function get() {
          return new T(["projects", this.ii.projectId, "databases", this.ii.database]).j();
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.li = function (e) {
        return new T(["projects", e.projectId, "databases", e.database]);
      }, e.prototype.Ti = function (e) {
        return wt(e.length > 4 && "documents" === e.get(4)), e.$(5);
      }, e.prototype.Ri = function (e, t) {
        return {
          name: this.fi(e),
          fields: t.proto.mapValue.fields
        };
      }, e.prototype.mi = function (e) {
        return {
          name: this.fi(e.key),
          fields: e.Mt().mapValue.fields,
          updateTime: this.C(e.version.C())
        };
      }, e.prototype.Ai = function (e, t) {
        var n = this.Z(e.name),
            r = this.fromVersion(e.updateTime),
            i = new de({
          mapValue: {
            fields: e.fields
          }
        });
        return new ve(n, r, i, {
          hasCommittedMutations: !!t
        });
      }, e.prototype.Pi = function (e) {
        wt(!!e.found), e.found.name, e.found.updateTime;
        var t = this.Z(e.found.name),
            n = this.fromVersion(e.found.updateTime),
            r = new de({
          mapValue: {
            fields: e.found.fields
          }
        });
        return new ve(t, n, r, {});
      }, e.prototype.Vi = function (e) {
        wt(!!e.missing), wt(!!e.readTime);
        var t = this.Z(e.missing),
            n = this.fromVersion(e.readTime);
        return new ge(t, n);
      }, e.prototype.gi = function (e) {
        return "found" in e ? this.Pi(e) : "missing" in e ? this.Vi(e) : bt();
      }, e.prototype.pi = function (e) {
        var t;

        if ("targetChange" in e) {
          e.targetChange;
          var n = this.yi(e.targetChange.targetChangeType || "NO_CHANGE"),
              r = e.targetChange.targetIds || [],
              i = this.ci(e.targetChange.resumeToken),
              o = e.targetChange.cause,
              a = o && this.ni(o);
          t = new it(n, r, i, a || null);
        } else if ("documentChange" in e) {
          e.documentChange;
          var s = e.documentChange;
          s.document, s.document.name, s.document.updateTime;
          var u = this.Z(s.document.name),
              c = this.fromVersion(s.document.updateTime),
              l = new de({
            mapValue: {
              fields: s.document.fields
            }
          }),
              h = new ve(u, c, l, {}),
              d = s.targetIds || [],
              f = s.removedTargetIds || [];
          t = new nt(d, f, h.key, h);
        } else if ("documentDelete" in e) {
          e.documentDelete;
          var p = e.documentDelete;
          p.document;

          var m = this.Z(p.document),
              _ = p.readTime ? this.fromVersion(p.readTime) : b.min(),
              y = new ge(m, _),
              v = p.removedTargetIds || [];

          t = new nt([], v, y.key, y);
        } else if ("documentRemove" in e) {
          e.documentRemove;
          var g = e.documentRemove;
          g.document;
          var w = this.Z(g.document),
              T = g.removedTargetIds || [];
          t = new nt([], T, w, null);
        } else {
          if (!("filter" in e)) return bt();
          e.filter;
          var M = e.filter;
          M.targetId;
          var E = M.count || 0,
              k = new xe(E),
              L = M.targetId;
          t = new rt(L, k);
        }

        return t;
      }, e.prototype.yi = function (e) {
        return "NO_CHANGE" === e ? 0 : "ADD" === e ? 1 : "REMOVE" === e ? 2 : "CURRENT" === e ? 3 : "RESET" === e ? 4 : bt();
      }, e.prototype.bi = function (e) {
        if (!("targetChange" in e)) return b.min();
        var t = e.targetChange;
        return t.targetIds && t.targetIds.length ? b.min() : t.readTime ? this.fromVersion(t.readTime) : b.min();
      }, e.prototype.vi = function (e) {
        var t,
            n = this;
        if (e instanceof se) t = {
          update: this.Ri(e.key, e.value)
        };else if (e instanceof le) t = {
          delete: this.fi(e.key)
        };else if (e instanceof ue) t = {
          update: this.Ri(e.key, e.data),
          updateMask: this.Si(e.Vt)
        };else if (e instanceof ce) t = {
          transform: {
            document: this.fi(e.key),
            fieldTransforms: e.fieldTransforms.map(function (e) {
              return n.Di(e);
            })
          }
        };else {
          if (!(e instanceof he)) return bt();
          t = {
            verify: this.fi(e.key)
          };
        }
        return e.Rt.Tt || (t.currentDocument = this.Ci(e.Rt)), t;
      }, e.prototype.Fi = function (e) {
        var t = this,
            n = e.currentDocument ? this.Ni(e.currentDocument) : oe.ft();

        if (e.update) {
          e.update.name;
          var r = this.Z(e.update.name),
              i = new de({
            mapValue: {
              fields: e.update.fields
            }
          });

          if (e.updateMask) {
            var o = this.ki(e.updateMask);
            return new ue(r, i, o, n);
          }

          return new se(r, i, n);
        }

        if (e.delete) {
          var a = this.Z(e.delete);
          return new le(a, n);
        }

        if (e.transform) {
          var s = this.Z(e.transform.document),
              u = e.transform.fieldTransforms.map(function (e) {
            return t.$i(e);
          });
          return wt(!0 === n.exists), new ce(s, u);
        }

        if (e.verify) {
          var c = this.Z(e.verify);
          return new he(c, n);
        }

        return bt();
      }, e.prototype.Ci = function (e) {
        return void 0 !== e.updateTime ? {
          updateTime: this.toVersion(e.updateTime)
        } : void 0 !== e.exists ? {
          exists: e.exists
        } : bt();
      }, e.prototype.Ni = function (e) {
        return void 0 !== e.updateTime ? oe.updateTime(this.fromVersion(e.updateTime)) : void 0 !== e.exists ? oe.exists(e.exists) : oe.ft();
      }, e.prototype.Mi = function (e, t) {
        var n = e.updateTime ? this.fromVersion(e.updateTime) : this.fromVersion(t);
        n.isEqual(b.min()) && (n = this.fromVersion(t));
        var r = null;
        return e.transformResults && e.transformResults.length > 0 && (r = e.transformResults), new ie(n, r);
      }, e.prototype.Li = function (e, t) {
        var n = this;
        return e && e.length > 0 ? (wt(void 0 !== t), e.map(function (e) {
          return n.Mi(e, t);
        })) : [];
      }, e.prototype.Di = function (e) {
        var t = e.transform;
        if (t instanceof X) return {
          fieldPath: e.field.j(),
          setToServerValue: "REQUEST_TIME"
        };
        if (t instanceof K) return {
          fieldPath: e.field.j(),
          appendMissingElements: {
            values: t.elements
          }
        };
        if (t instanceof $) return {
          fieldPath: e.field.j(),
          removeAllFromArray: {
            values: t.elements
          }
        };
        if (t instanceof ee) return {
          fieldPath: e.field.j(),
          increment: t.ct
        };
        throw bt();
      }, e.prototype.$i = function (e) {
        var t = null;
        if ("setToServerValue" in e) wt("REQUEST_TIME" === e.setToServerValue), t = X.instance;else if ("appendMissingElements" in e) {
          var n = e.appendMissingElements.values || [];
          t = new K(n);
        } else if ("removeAllFromArray" in e) {
          var r = e.removeAllFromArray.values || [];
          t = new $(r);
        } else "increment" in e ? t = new ee(this, e.increment) : bt();
        var i = E.X(e.fieldPath);
        return new re(i, t);
      }, e.prototype.xi = function (e) {
        return {
          documents: [this.Ei(e.path)]
        };
      }, e.prototype.Oi = function (e) {
        wt(1 === e.documents.length);
        var t = e.documents[0];
        return Te.Wt(this.Ii(t)).ee();
      }, e.prototype.Bi = function (e) {
        var t = {
          structuredQuery: {}
        },
            n = e.path;
        null !== e.collectionGroup ? (t.parent = this.Ei(n), t.structuredQuery.from = [{
          collectionId: e.collectionGroup,
          allDescendants: !0
        }]) : (t.parent = this.Ei(n.M()), t.structuredQuery.from = [{
          collectionId: n.O()
        }]);
        var r = this.qi(e.filters);
        r && (t.structuredQuery.where = r);
        var i = this.Ui(e.orderBy);
        i && (t.structuredQuery.orderBy = i);
        var o = this.ri(e.limit);
        return null !== o && (t.structuredQuery.limit = o), e.startAt && (t.structuredQuery.startAt = this.Qi(e.startAt)), e.endAt && (t.structuredQuery.endAt = this.Qi(e.endAt)), t;
      }, e.prototype.Wi = function (e) {
        var t = this.Ii(e.parent),
            n = e.structuredQuery,
            r = n.from ? n.from.length : 0,
            i = null;

        if (r > 0) {
          wt(1 === r);
          var o = n.from[0];
          o.allDescendants ? i = o.collectionId : t = t.child(o.collectionId);
        }

        var a = [];
        n.where && (a = this.ji(n.where));
        var s = [];
        n.orderBy && (s = this.Ki(n.orderBy));
        var u = null;
        n.limit && (u = this.oi(n.limit));
        var c = null;
        n.startAt && (c = this.Gi(n.startAt));
        var l = null;
        return n.endAt && (l = this.Gi(n.endAt)), new Te(t, i, s, a, u, "F", c, l).ee();
      }, e.prototype.zi = function (e) {
        var t = this.Hi(e.Te);
        return null == t ? null : {
          "goog-listen-tags": t
        };
      }, e.prototype.Hi = function (e) {
        switch (e) {
          case 0:
            return null;

          case 1:
            return "existence-filter-mismatch";

          case 2:
            return "limbo-document";

          default:
            return bt();
        }
      }, e.prototype.ee = function (e) {
        var t,
            n = e.target;
        return (t = n.xt() ? {
          documents: this.xi(n)
        } : {
          query: this.Bi(n)
        }).targetId = e.targetId, e.resumeToken.rt() > 0 && (t.resumeToken = this.ui(e.resumeToken)), t;
      }, e.prototype.qi = function (e) {
        var t = this;

        if (0 !== e.length) {
          var n = e.map(function (e) {
            return e instanceof Me ? t.Yi(e) : bt();
          });
          return 1 === n.length ? n[0] : {
            compositeFilter: {
              op: "AND",
              filters: n
            }
          };
        }
      }, e.prototype.ji = function (e) {
        var t = this;
        return e ? void 0 !== e.unaryFilter ? [this.Ji(e)] : void 0 !== e.fieldFilter ? [this.Xi(e)] : void 0 !== e.compositeFilter ? e.compositeFilter.filters.map(function (e) {
          return t.ji(e);
        }).reduce(function (e, t) {
          return e.concat(t);
        }) : bt() : [];
      }, e.prototype.Ui = function (e) {
        var t = this;
        if (0 !== e.length) return e.map(function (e) {
          return t.Zi(e);
        });
      }, e.prototype.Ki = function (e) {
        var t = this;
        return e.map(function (e) {
          return t.tn(e);
        });
      }, e.prototype.Qi = function (e) {
        return {
          before: e.before,
          values: e.position
        };
      }, e.prototype.Gi = function (e) {
        var t = !!e.before,
            n = e.values || [];
        return new De(n, t);
      }, e.prototype.en = function (e) {
        return ct[e];
      }, e.prototype.sn = function (e) {
        switch (e) {
          case "ASCENDING":
            return "asc";

          case "DESCENDING":
            return "desc";

          default:
            return;
        }
      }, e.prototype.nn = function (e) {
        return lt[e];
      }, e.prototype.rn = function (e) {
        switch (e) {
          case "EQUAL":
            return "==";

          case "GREATER_THAN":
            return ">";

          case "GREATER_THAN_OR_EQUAL":
            return ">=";

          case "LESS_THAN":
            return "<";

          case "LESS_THAN_OR_EQUAL":
            return "<=";

          case "ARRAY_CONTAINS":
            return "array-contains";

          case "IN":
            return "in";

          case "ARRAY_CONTAINS_ANY":
            return "array-contains-any";

          case "OPERATOR_UNSPECIFIED":
          default:
            return bt();
        }
      }, e.prototype.hn = function (e) {
        return {
          fieldPath: e.j()
        };
      }, e.prototype.on = function (e) {
        return E.X(e.fieldPath);
      }, e.prototype.Zi = function (e) {
        return {
          field: this.hn(e.field),
          direction: this.en(e.dir)
        };
      }, e.prototype.tn = function (e) {
        return new Ie(this.on(e.field), this.sn(e.direction));
      }, e.prototype.Xi = function (e) {
        return Me.create(this.on(e.fieldFilter.field), this.rn(e.fieldFilter.op), e.fieldFilter.value);
      }, e.prototype.Yi = function (e) {
        if ("==" === e.op) {
          if (q(e.value)) return {
            unaryFilter: {
              field: this.hn(e.field),
              op: "IS_NAN"
            }
          };
          if (G(e.value)) return {
            unaryFilter: {
              field: this.hn(e.field),
              op: "IS_NULL"
            }
          };
        }

        return {
          fieldFilter: {
            field: this.hn(e.field),
            op: this.nn(e.op),
            value: e.value
          }
        };
      }, e.prototype.Ji = function (e) {
        switch (e.unaryFilter.op) {
          case "IS_NAN":
            var t = this.on(e.unaryFilter.field);
            return Me.create(t, "==", {
              doubleValue: NaN
            });

          case "IS_NULL":
            var n = this.on(e.unaryFilter.field);
            return Me.create(n, "==", {
              nullValue: "NULL_VALUE"
            });

          case "OPERATOR_UNSPECIFIED":
          default:
            return bt();
        }
      }, e.prototype.Si = function (e) {
        var t = [];
        return e.fields.forEach(function (e) {
          return t.push(e.j());
        }), {
          fieldPaths: t
        };
      }, e.prototype.ki = function (e) {
        var t = e.fieldPaths || [];
        return new ne(t.map(function (e) {
          return E.X(e);
        }));
      }, e;
    }();

    function dt(e) {
      return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var ft = function () {
      function e() {}

      return e.an = function (t) {
        e.platform && bt(), e.platform = t;
      }, e.nt = function () {
        return e.platform || bt(), e.platform;
      }, e;
    }(),
        pt = new a.Logger("@firebase/firestore");
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function mt() {
      return pt.logLevel;
    }

    function _t(e) {
      pt.logLevel = e;
    }

    function yt(e) {
      for (var t = [], n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }

      if (pt.logLevel <= a.LogLevel.DEBUG) {
        var r = t.map(gt);
        pt.debug.apply(pt, i.__spreadArrays(["Firestore (" + l + "): " + e], r));
      }
    }

    function vt(e) {
      for (var t = [], n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }

      if (pt.logLevel <= a.LogLevel.ERROR) {
        var r = t.map(gt);
        pt.error.apply(pt, i.__spreadArrays(["Firestore (" + l + "): " + e], r));
      }
    }

    function gt(e) {
      if ("string" == typeof e) return e;
      var t = ft.nt();

      try {
        return t.un(e);
      } catch (t) {
        return e;
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function bt(e) {
      void 0 === e && (e = "Unexpected state");
      var t = "FIRESTORE (" + l + ") INTERNAL ASSERTION FAILED: " + e;
      throw vt(t), new Error(t);
    }

    function wt(e, t) {
      e || bt();
    }

    function Tt(e, t) {
      return e;
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var Mt = function () {
      function e() {}

      return e.cn = function () {
        for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = Math.floor(256 / e.length) * e.length, n = ""; n.length < 20;) {
          for (var r = ft.nt()._n(40), i = 0; i < r.length; ++i) {
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % e.length));
          }
        }

        return n;
      }, e;
    }();

    function Et(e, t) {
      return e < t ? -1 : e > t ? 1 : 0;
    }

    function kt(e, t, n) {
      return e.length === t.length && e.every(function (e, r) {
        return n(e, t[r]);
      });
    }

    function Lt(e) {
      return e + "\0";
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var St = function St(e, t, n, r, i) {
      this.ii = e, this.persistenceKey = t, this.host = n, this.ssl = r, this.forceLongPolling = i;
    },
        Nt = function () {
      function e(e, t) {
        this.projectId = e, this.database = t || "(default)";
      }

      return Object.defineProperty(e.prototype, "ln", {
        get: function get() {
          return "(default)" === this.database;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.isEqual = function (t) {
        return t instanceof e && t.projectId === this.projectId && t.database === this.database;
      }, e.prototype.S = function (e) {
        return Et(this.projectId, e.projectId) || Et(this.database, e.database);
      }, e;
    }(),
        Dt = function () {
      function e(e) {
        this.dn = e, this.fn = {};
      }

      return e.prototype.get = function (e) {
        var t = this.dn(e),
            n = this.fn[t];
        if (void 0 !== n) for (var r = 0, i = n; r < i.length; r++) {
          var o = i[r],
              a = o[0],
              s = o[1];
          if (a.isEqual(e)) return s;
        }
      }, e.prototype.has = function (e) {
        return void 0 !== this.get(e);
      }, e.prototype.set = function (e, t) {
        var n = this.dn(e),
            r = this.fn[n];

        if (void 0 !== r) {
          for (var i = 0; i < r.length; i++) {
            if (r[i][0].isEqual(e)) return void (r[i] = [e, t]);
          }

          r.push([e, t]);
        } else this.fn[n] = [[e, t]];
      }, e.prototype.delete = function (e) {
        var t = this.dn(e),
            n = this.fn[t];
        if (void 0 === n) return !1;

        for (var r = 0; r < n.length; r++) {
          if (n[r][0].isEqual(e)) return 1 === n.length ? delete this.fn[t] : n.splice(r, 1), !0;
        }

        return !1;
      }, e.prototype.forEach = function (e) {
        S(this.fn, function (t, n) {
          for (var r = 0, i = n; r < i.length; r++) {
            var o = i[r],
                a = o[0],
                s = o[1];
            e(a, s);
          }
        });
      }, e.prototype.B = function () {
        return N(this.fn);
      }, e;
    }(),
        It = function () {
      function e(e, t, n, r) {
        this.batchId = e, this.Tn = t, this.baseMutations = n, this.mutations = r;
      }

      return e.prototype.at = function (e, t, n) {
        for (var r = n.En, i = 0; i < this.mutations.length; i++) {
          var o = this.mutations[i];

          if (o.key.isEqual(e)) {
            var a = r[i];
            t = o.at(t, a);
          }
        }

        return t;
      }, e.prototype.ot = function (e, t) {
        for (var n = 0, r = this.baseMutations; n < r.length; n++) {
          var i = r[n];
          i.key.isEqual(e) && (t = i.ot(t, t, this.Tn));
        }

        for (var o = t, a = 0, s = this.mutations; a < s.length; a++) {
          var u = s[a];
          u.key.isEqual(e) && (t = u.ot(t, o, this.Tn));
        }

        return t;
      }, e.prototype.In = function (e) {
        var t = this,
            n = e;
        return this.mutations.forEach(function (r) {
          var i = t.ot(r.key, e.get(r.key));
          i && (n = n.me(r.key, i));
        }), n;
      }, e.prototype.keys = function () {
        return this.mutations.reduce(function (e, t) {
          return e.add(t.key);
        }, Ge());
      }, e.prototype.isEqual = function (e) {
        return this.batchId === e.batchId && kt(this.mutations, e.mutations, function (e, t) {
          return e.isEqual(t);
        }) && kt(this.baseMutations, e.baseMutations, function (e, t) {
          return e.isEqual(t);
        });
      }, e;
    }(),
        Rt = function () {
      function e(e, t, n, r, i) {
        this.batch = e, this.wn = t, this.En = n, this.streamToken = r, this.Rn = i;
      }

      return e.from = function (t, n, r, i) {
        wt(t.mutations.length === r.length);

        for (var o = Ze(), a = t.mutations, s = 0; s < a.length; s++) {
          o = o.me(a[s].key, r[s].version);
        }

        return new e(t, n, r, i, o);
      }, e;
    }(),
        xt = function () {
      function e() {
        this.mn = new je(Yt.An), this.Pn = new je(Yt.Vn);
      }

      return e.prototype.B = function () {
        return this.mn.B();
      }, e.prototype.gn = function (e, t) {
        var n = new Yt(e, t);
        this.mn = this.mn.add(n), this.Pn = this.Pn.add(n);
      }, e.prototype.pn = function (e, t) {
        var n = this;
        e.forEach(function (e) {
          return n.gn(e, t);
        });
      }, e.prototype.yn = function (e, t) {
        this.bn(new Yt(e, t));
      }, e.prototype.vn = function (e, t) {
        var n = this;
        e.forEach(function (e) {
          return n.yn(e, t);
        });
      }, e.prototype.Sn = function (e) {
        var t = this,
            n = k.EMPTY,
            r = new Yt(n, e),
            i = new Yt(n, e + 1),
            o = [];
        return this.Pn.Ke([r, i], function (e) {
          t.bn(e), o.push(e.key);
        }), o;
      }, e.prototype.Dn = function () {
        var e = this;
        this.mn.forEach(function (t) {
          return e.bn(t);
        });
      }, e.prototype.bn = function (e) {
        this.mn = this.mn.delete(e), this.Pn = this.Pn.delete(e);
      }, e.prototype.Cn = function (e) {
        var t = k.EMPTY,
            n = new Yt(t, e),
            r = new Yt(t, e + 1),
            i = Ge();
        return this.Pn.Ke([n, r], function (e) {
          i = i.add(e.key);
        }), i;
      }, e.prototype.Fn = function (e) {
        var t = new Yt(e, 0),
            n = this.mn.ze(t);
        return null !== n && e.isEqual(n.key);
      }, e;
    }(),
        Yt = function () {
      function e(e, t) {
        this.key = e, this.Nn = t;
      }

      return e.An = function (e, t) {
        return k.N(e.key, t.key) || Et(e.Nn, t.Nn);
      }, e.Vn = function (e, t) {
        return Et(e.Nn, t.Nn) || k.N(e.key, t.key);
      }, e;
    }(),
        Ct = function () {
      function e(e) {
        var t = this;
        this.kn = null, this.$n = null, this.result = void 0, this.error = void 0, this.Mn = !1, this.Ln = !1, e(function (e) {
          t.Mn = !0, t.result = e, t.kn && t.kn(e);
        }, function (e) {
          t.Mn = !0, t.error = e, t.$n && t.$n(e);
        });
      }

      return e.prototype.catch = function (e) {
        return this.next(void 0, e);
      }, e.prototype.next = function (t, n) {
        var r = this;
        return this.Ln && bt(), this.Ln = !0, this.Mn ? this.error ? this.xn(n, this.error) : this.On(t, this.result) : new e(function (e, i) {
          r.kn = function (n) {
            r.On(t, n).next(e, i);
          }, r.$n = function (t) {
            r.xn(n, t).next(e, i);
          };
        });
      }, e.prototype.Bn = function () {
        var e = this;
        return new Promise(function (t, n) {
          e.next(t, n);
        });
      }, e.prototype.qn = function (t) {
        try {
          var n = t();
          return n instanceof e ? n : e.resolve(n);
        } catch (t) {
          return e.reject(t);
        }
      }, e.prototype.On = function (t, n) {
        return t ? this.qn(function () {
          return t(n);
        }) : e.resolve(n);
      }, e.prototype.xn = function (t, n) {
        return t ? this.qn(function () {
          return t(n);
        }) : e.reject(n);
      }, e.resolve = function (t) {
        return new e(function (e, n) {
          e(t);
        });
      }, e.reject = function (t) {
        return new e(function (e, n) {
          n(t);
        });
      }, e.Un = function (t) {
        return new e(function (e, n) {
          var r = 0,
              i = 0,
              o = !1;
          t.forEach(function (t) {
            ++r, t.next(function () {
              ++i, o && i === r && e();
            }, function (e) {
              return n(e);
            });
          }), o = !0, i === r && e();
        });
      }, e.Qn = function (t) {
        for (var n = e.resolve(!1), r = function r(t) {
          n = n.next(function (n) {
            return n ? e.resolve(n) : t();
          });
        }, i = 0, o = t; i < o.length; i++) {
          r(o[i]);
        }

        return n;
      }, e.forEach = function (e, t) {
        var n = this,
            r = [];
        return e.forEach(function (e, i) {
          r.push(t.call(n, e, i));
        }), this.Un(r);
      }, e;
    }(),
        Ot = function () {
      function e() {
        this.Wn = new Dt(function (e) {
          return e.toString();
        }), this.jn = !1;
      }

      return Object.defineProperty(e.prototype, "readTime", {
        get: function get() {
          return this.Kn;
        },
        set: function set(e) {
          this.Kn = e;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.Gn = function (e, t) {
        this.zn(), this.readTime = t, this.Wn.set(e.key, e);
      }, e.prototype.Hn = function (e, t) {
        this.zn(), t && (this.readTime = t), this.Wn.set(e, null);
      }, e.prototype.Yn = function (e, t) {
        this.zn();
        var n = this.Wn.get(t);
        return void 0 !== n ? Ct.resolve(n) : this.Jn(e, t);
      }, e.prototype.getEntries = function (e, t) {
        return this.Xn(e, t);
      }, e.prototype.apply = function (e) {
        return this.zn(), this.jn = !0, this.Zn(e);
      }, e.prototype.zn = function () {}, e;
    }(),
        Ft = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.",
        At = function () {
      function e() {
        this.tr = [];
      }

      return e.prototype.er = function (e) {
        this.tr.push(e);
      }, e.prototype.sr = function () {
        this.tr.forEach(function (e) {
          return e();
        });
      }, e;
    }(),
        jt = function () {
      function e(e, t, n) {
        this.ir = e, this.nr = t, this.rr = n;
      }

      return e.prototype.hr = function (e, t) {
        var n = this;
        return this.nr.or(e, t).next(function (r) {
          return n.ar(e, t, r);
        });
      }, e.prototype.ar = function (e, t, n) {
        return this.ir.Yn(e, t).next(function (e) {
          for (var r = 0, i = n; r < i.length; r++) {
            e = i[r].ot(t, e);
          }

          return e;
        });
      }, e.prototype.ur = function (e, t, n) {
        var r = We();
        return t.forEach(function (e, t) {
          for (var i = 0, o = n; i < o.length; i++) {
            t = o[i].ot(e, t);
          }

          r = r.me(e, t);
        }), r;
      }, e.prototype.cr = function (e, t) {
        var n = this;
        return this.ir.getEntries(e, t).next(function (t) {
          return n._r(e, t);
        });
      }, e.prototype._r = function (e, t) {
        var n = this;
        return this.nr.lr(e, t).next(function (r) {
          var i = n.ur(e, t, r),
              o = Ve();
          return i.forEach(function (e, t) {
            t || (t = new ge(e, b.min())), o = o.me(e, t);
          }), o;
        });
      }, e.prototype.dr = function (e, t, n) {
        return t.xt() ? this.Tr(e, t.path) : t._e() ? this.Er(e, t, n) : this.Ir(e, t, n);
      }, e.prototype.Tr = function (e, t) {
        return this.hr(e, new k(t)).next(function (e) {
          var t = Be();
          return e instanceof ve && (t = t.me(e.key, e)), t;
        });
      }, e.prototype.Er = function (e, t, n) {
        var r = this,
            i = t.collectionGroup,
            o = Be();
        return this.rr.wr(e, i).next(function (a) {
          return Ct.forEach(a, function (a) {
            var s = t.Zt(a.child(i));
            return r.Ir(e, s, n).next(function (e) {
              e.forEach(function (e, t) {
                o = o.me(e, t);
              });
            });
          }).next(function () {
            return o;
          });
        });
      }, e.prototype.Ir = function (e, t, n) {
        var r,
            i,
            o = this;
        return this.ir.dr(e, t, n).next(function (n) {
          return r = n, o.nr.Rr(e, t);
        }).next(function (t) {
          return i = t, o.mr(e, i, r).next(function (e) {
            r = e;

            for (var t = 0, n = i; t < n.length; t++) {
              for (var o = n[t], a = 0, s = o.mutations; a < s.length; a++) {
                var u = s[a],
                    c = u.key,
                    l = r.get(c),
                    h = u.ot(l, l, o.Tn);
                r = h instanceof ve ? r.me(c, h) : r.remove(c);
              }
            }
          });
        }).next(function () {
          return r.forEach(function (e, n) {
            t.matches(n) || (r = r.remove(e));
          }), r;
        });
      }, e.prototype.mr = function (e, t, n) {
        for (var r = Ge(), i = 0, o = t; i < o.length; i++) {
          for (var a = 0, s = o[i].mutations; a < s.length; a++) {
            var u = s[a];
            u instanceof ue && null === n.get(u.key) && (r = r.add(u.key));
          }
        }

        var c = n;
        return this.ir.getEntries(e, r).next(function (e) {
          return e.forEach(function (e, t) {
            null !== t && t instanceof ve && (c = c.me(e, t));
          }), c;
        });
      }, e;
    }(),
        Ut = function () {
      function e(e, t, n, r) {
        this.targetId = e, this.fromCache = t, this.Ar = n, this.Pr = r;
      }

      return e.Vr = function (t, n) {
        for (var r = Ge(), i = Ge(), o = 0, a = n.docChanges; o < a.length; o++) {
          var s = a[o];

          switch (s.type) {
            case 0:
              r = r.add(s.doc.key);
              break;

            case 1:
              i = i.add(s.doc.key);
          }
        }

        return new e(t, n.fromCache, r, i);
      }, e;
    }(),
        Pt = function () {
      function e(e, t) {
        var n = this;
        this.previousValue = e, t && (t.gr = function (e) {
          return n.pr(e);
        }, this.yr = function (e) {
          return t.br(e);
        });
      }

      return e.prototype.pr = function (e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
      }, e.prototype.next = function () {
        var e = ++this.previousValue;
        return this.yr && this.yr(e), e;
      }, e;
    }();

    Pt.vr = -1;
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    var Vt = function Vt() {
      var e = this;
      this.promise = new Promise(function (t, n) {
        e.resolve = t, e.reject = n;
      });
    },
        Wt = function () {
      function e(e, t, n, r, i) {
        void 0 === n && (n = 1e3), void 0 === r && (r = 1.5), void 0 === i && (i = 6e4), this.Sr = e, this.Dr = t, this.Cr = n, this.Fr = r, this.Nr = i, this.kr = 0, this.$r = null, this.Mr = Date.now(), this.reset();
      }

      return e.prototype.reset = function () {
        this.kr = 0;
      }, e.prototype.Lr = function () {
        this.kr = this.Nr;
      }, e.prototype.xr = function (e) {
        var t = this;
        this.cancel();
        var n = Math.floor(this.kr + this.Or()),
            r = Math.max(0, Date.now() - this.Mr),
            i = Math.max(0, n - r);
        i > 0 && yt("ExponentialBackoff", "Backing off for " + i + " ms (base delay: " + this.kr + " ms, delay with jitter: " + n + " ms, last attempt: " + r + " ms ago)"), this.$r = this.Sr.Br(this.Dr, i, function () {
          return t.Mr = Date.now(), e();
        }), this.kr *= this.Fr, this.kr < this.Cr && (this.kr = this.Cr), this.kr > this.Nr && (this.kr = this.Nr);
      }, e.prototype.cancel = function () {
        null !== this.$r && (this.$r.cancel(), this.$r = null);
      }, e.prototype.Or = function () {
        return (Math.random() - .5) * this.kr;
      }, e;
    }(),
        Ht = function () {
      function e(e, t, n, r, i) {
        this.qr = e, this.Dr = t, this.Ur = n, this.op = r, this.Qr = i, this.Wr = new Vt(), this.then = this.Wr.promise.then.bind(this.Wr.promise), this.catch = this.Wr.promise.catch.bind(this.Wr.promise), this.Wr.promise.catch(function (e) {});
      }

      return e.jr = function (t, n, r, i, o) {
        var a = new e(t, n, Date.now() + r, i, o);
        return a.start(r), a;
      }, e.prototype.start = function (e) {
        var t = this;
        this.Kr = setTimeout(function () {
          return t.Gr();
        }, e);
      }, e.prototype.zr = function () {
        return this.Gr();
      }, e.prototype.cancel = function (e) {
        null !== this.Kr && (this.clearTimeout(), this.Wr.reject(new f(d.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
      }, e.prototype.Gr = function () {
        var e = this;
        this.qr.Hr(function () {
          return null !== e.Kr ? (e.clearTimeout(), e.op().then(function (t) {
            return e.Wr.resolve(t);
          })) : Promise.resolve();
        });
      }, e.prototype.clearTimeout = function () {
        null !== this.Kr && (this.Qr(this), clearTimeout(this.Kr), this.Kr = null);
      }, e;
    }(),
        Bt = function () {
      function e() {
        var e = this;
        this.Yr = Promise.resolve(), this.Jr = Promise.resolve(), this.Xr = !1, this.Zr = [], this.th = null, this.eh = !1, this.sh = [], this.ih = new Wt(this, "async_queue_retry"), this.nh = function () {
          e.rh("async_queue_retry");
        };
        var t = ft.nt().window;
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.nh);
      }

      return Object.defineProperty(e.prototype, "hh", {
        get: function get() {
          return this.Xr;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.Hr = function (e) {
        this.enqueue(e);
      }, e.prototype.oh = function (e) {
        this.ah(), this.uh(e);
      }, e.prototype._h = function (e) {
        return this.ah(), this.uh(e);
      }, e.prototype.lh = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t;
          return i.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return this.ah(), this.Xr ? [3, 2] : (this.Xr = !0, (t = ft.nt().window) && t.removeEventListener("visibilitychange", this.nh), [4, this._h(e)]);

              case 1:
                n.sent(), n.label = 2;

              case 2:
                return [2];
            }
          });
        });
      }, e.prototype.enqueue = function (e) {
        return this.ah(), this.Xr ? new Promise(function (e) {}) : this.uh(e);
      }, e.prototype.dh = function (e) {
        var t = this;
        this.ah(), this.Xr || (this.Jr = this.Jr.then(function () {
          var n = new Vt(),
              r = function r() {
            return i.__awaiter(t, void 0, void 0, function () {
              var t;
              return i.__generator(this, function (i) {
                switch (i.label) {
                  case 0:
                    return i.trys.push([0, 2,, 3]), [4, e()];

                  case 1:
                    return i.sent(), n.resolve(), this.ih.reset(), [3, 3];

                  case 2:
                    if ("IndexedDbTransactionError" !== (t = i.sent()).name) throw n.resolve(), t;
                    return yt("AsyncQueue", "Operation failed with retryable error: " + t), this.ih.xr(r), [3, 3];

                  case 3:
                    return [2];
                }
              });
            });
          };

          return t.Hr(r), n.promise;
        }));
      }, e.prototype.uh = function (e) {
        var t = this,
            n = this.Yr.then(function () {
          return t.eh = !0, e().catch(function (e) {
            throw t.th = e, t.eh = !1, vt("INTERNAL UNHANDLED ERROR: ", e.stack || e.message || ""), e;
          }).then(function (e) {
            return t.eh = !1, e;
          });
        });
        return this.Yr = n, n;
      }, e.prototype.Br = function (e, t, n) {
        var r = this;
        this.ah(), this.sh.indexOf(e) > -1 && (t = 0);
        var i = Ht.jr(this, e, t, n, function (e) {
          return r.fh(e);
        });
        return this.Zr.push(i), i;
      }, e.prototype.ah = function () {
        this.th && bt();
      }, e.prototype.Th = function () {}, e.prototype.Eh = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          var e;
          return i.__generator(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, e = this.Yr];

              case 1:
                t.sent(), t.label = 2;

              case 2:
                if (e !== this.Yr) return [3, 0];
                t.label = 3;

              case 3:
                return [2];
            }
          });
        });
      }, e.prototype.Ih = function (e) {
        for (var t = 0, n = this.Zr; t < n.length; t++) {
          if (n[t].Dr === e) return !0;
        }

        return !1;
      }, e.prototype.rh = function (e) {
        var t = this;
        return this.Eh().then(function () {
          t.Zr.sort(function (e, t) {
            return e.Ur - t.Ur;
          });

          for (var n = 0, r = t.Zr; n < r.length; n++) {
            var i = r[n];
            if (i.zr(), "all" !== e && i.Dr === e) break;
          }

          return t.Eh();
        });
      }, e.prototype.wh = function (e) {
        this.sh.push(e);
      }, e.prototype.fh = function (e) {
        var t = this.Zr.indexOf(e);
        this.Zr.splice(t, 1);
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function zt(e, t) {
      var n = e[0],
          r = e[1],
          i = t[0],
          o = t[1],
          a = Et(n, i);
      return 0 === a ? Et(r, o) : a;
    }

    var Zt = function () {
      function e(e) {
        this.Rh = e, this.buffer = new je(zt), this.mh = 0;
      }

      return e.prototype.Ah = function () {
        return ++this.mh;
      }, e.prototype.Ph = function (e) {
        var t = [e, this.Ah()];
        if (this.buffer.size < this.Rh) this.buffer = this.buffer.add(t);else {
          var n = this.buffer.last();
          zt(t, n) < 0 && (this.buffer = this.buffer.delete(n).add(t));
        }
      }, Object.defineProperty(e.prototype, "maxValue", {
        get: function get() {
          return this.buffer.last()[0];
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        Qt = {
      Vh: !1,
      gh: 0,
      ph: 0,
      yh: 0
    },
        Gt = function () {
      function e(e, t, n) {
        this.bh = e, this.vh = t, this.Sh = n;
      }

      return e.Dh = function (t) {
        return new e(t, e.Ch, e.Fh);
      }, e;
    }();

    Gt.Nh = -1, Gt.kh = 1048576, Gt.$h = 41943040, Gt.Ch = 10, Gt.Fh = 1e3, Gt.Mh = new Gt(Gt.$h, Gt.Ch, Gt.Fh), Gt.DISABLED = new Gt(Gt.Nh, 0, 0);

    var qt = function () {
      function e(e, t) {
        this.Lh = e, this.qr = t, this.xh = !1, this.Oh = null;
      }

      return e.prototype.start = function (e) {
        this.Lh.Bh.bh !== Gt.Nh && this.qh(e);
      }, e.prototype.stop = function () {
        this.Oh && (this.Oh.cancel(), this.Oh = null);
      }, Object.defineProperty(e.prototype, "Uh", {
        get: function get() {
          return null !== this.Oh;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.qh = function (e) {
        var t = this,
            n = this.xh ? 3e5 : 6e4;
        yt("LruGarbageCollector", "Garbage collection scheduled in " + n + "ms"), this.Oh = this.qr.Br("lru_garbage_collection", n, function () {
          return i.__awaiter(t, void 0, void 0, function () {
            var t;
            return i.__generator(this, function (n) {
              switch (n.label) {
                case 0:
                  this.Oh = null, this.xh = !0, n.label = 1;

                case 1:
                  return n.trys.push([1, 3,, 7]), [4, e.Qh(this.Lh)];

                case 2:
                  return n.sent(), [3, 7];

                case 3:
                  return "IndexedDbTransactionError" !== (t = n.sent()).name ? [3, 4] : (yt("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", t), [3, 6]);

                case 4:
                  return [4, or(t)];

                case 5:
                  n.sent(), n.label = 6;

                case 6:
                  return [3, 7];

                case 7:
                  return [4, this.qh(e)];

                case 8:
                  return n.sent(), [2];
              }
            });
          });
        });
      }, e;
    }(),
        Jt = function () {
      function e(e, t) {
        this.Wh = e, this.Bh = t;
      }

      return e.prototype.jh = function (e, t) {
        return this.Wh.Kh(e).next(function (e) {
          return Math.floor(t / 100 * e);
        });
      }, e.prototype.Gh = function (e, t) {
        var n = this;
        if (0 === t) return Ct.resolve(Pt.vr);
        var r = new Zt(t);
        return this.Wh.js(e, function (e) {
          return r.Ph(e.sequenceNumber);
        }).next(function () {
          return n.Wh.zh(e, function (e) {
            return r.Ph(e);
          });
        }).next(function () {
          return r.maxValue;
        });
      }, e.prototype.Hh = function (e, t, n) {
        return this.Wh.Hh(e, t, n);
      }, e.prototype.Yh = function (e, t) {
        return this.Wh.Yh(e, t);
      }, e.prototype.Jh = function (e, t) {
        var n = this;
        return this.Bh.bh === Gt.Nh ? (yt("LruGarbageCollector", "Garbage collection skipped; disabled"), Ct.resolve(Qt)) : this.Xh(e).next(function (r) {
          return r < n.Bh.bh ? (yt("LruGarbageCollector", "Garbage collection skipped; Cache size " + r + " is lower than threshold " + n.Bh.bh), Qt) : n.Zh(e, t);
        });
      }, e.prototype.Xh = function (e) {
        return this.Wh.Xh(e);
      }, e.prototype.Zh = function (e, t) {
        var n,
            r,
            i,
            o,
            s,
            u,
            c,
            l = this,
            h = Date.now();
        return this.jh(e, this.Bh.vh).next(function (t) {
          return t > l.Bh.Sh ? (yt("LruGarbageCollector", "Capping sequence numbers to collect down to the maximum of " + l.Bh.Sh + " from " + t), r = l.Bh.Sh) : r = t, o = Date.now(), l.Gh(e, r);
        }).next(function (r) {
          return n = r, s = Date.now(), l.Hh(e, n, t);
        }).next(function (t) {
          return i = t, u = Date.now(), l.Yh(e, n);
        }).next(function (e) {
          return c = Date.now(), mt() <= a.LogLevel.DEBUG && yt("LruGarbageCollector", "LRU Garbage Collection\n\tCounted targets in " + (o - h) + "ms\n\tDetermined least recently used " + r + " in " + (s - o) + "ms\n\tRemoved " + i + " targets in " + (u - s) + "ms\n\tRemoved " + e + " documents in " + (c - u) + "ms\nTotal Duration: " + (c - h) + "ms"), Ct.resolve({
            Vh: !0,
            gh: r,
            ph: i,
            yh: e
          });
        });
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Xt(e) {
      for (var t = "", n = 0; n < e.length; n++) {
        t.length > 0 && (t = $t(t)), t = Kt(e.get(n), t);
      }

      return $t(t);
    }

    function Kt(e, t) {
      for (var n = t, r = e.length, i = 0; i < r; i++) {
        var o = e.charAt(i);

        switch (o) {
          case "\0":
            n += "";
            break;

          case "":
            n += "";
            break;

          default:
            n += o;
        }
      }

      return n;
    }

    function $t(e) {
      return e + "";
    }

    function en(e) {
      var t = e.length;
      if (wt(t >= 2), 2 === t) return wt("" === e.charAt(0) && "" === e.charAt(1)), T.G;

      for (var n = t - 2, r = [], i = "", o = 0; o < t;) {
        var a = e.indexOf("", o);

        switch ((a < 0 || a > n) && bt(), e.charAt(a + 1)) {
          case "":
            var s = e.substring(o, a),
                u = void 0;
            0 === i.length ? u = s : (u = i += s, i = ""), r.push(u);
            break;

          case "":
            i += e.substring(o, a), i += "\0";
            break;

          case "":
            i += e.substring(o, a + 1);
            break;

          default:
            bt();
        }

        o = a + 2;
      }

      return new T(r);
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var tn = function () {
      function e(t) {
        this.db = t, 12.2 === e.to(s.getUA()) && vt("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
      }

      return e.eo = function (t, n, r) {
        return yt("SimpleDb", "Opening database:", t), new Ct(function (i, o) {
          var a = window.indexedDB.open(t, n);
          a.onsuccess = function (t) {
            var n = t.target.result;
            i(new e(n));
          }, a.onblocked = function () {
            o(new f(d.FAILED_PRECONDITION, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
          }, a.onerror = function (e) {
            var t = e.target.error;
            "VersionError" === t.name ? o(new f(d.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : o(t);
          }, a.onupgradeneeded = function (e) {
            yt("SimpleDb", 'Database "' + t + '" requires upgrade from version:', e.oldVersion);
            var n = e.target.result;
            r.createOrUpgrade(n, a.transaction, e.oldVersion, Dn).next(function () {
              yt("SimpleDb", "Database upgrade to version " + Dn + " complete");
            });
          };
        }).Bn();
      }, e.delete = function (e) {
        return yt("SimpleDb", "Removing database:", e), sn(window.indexedDB.deleteDatabase(e)).Bn();
      }, e.so = function () {
        if ("undefined" == typeof window || null == window.indexedDB) return !1;
        if (e.io()) return !0;
        if (void 0 === window.navigator) return !1;
        var t = s.getUA(),
            n = e.to(t),
            r = 0 < n && n < 10,
            i = e.no(t),
            o = 0 < i && i < 4.5;
        return !(t.indexOf("MSIE ") > 0 || t.indexOf("Trident/") > 0 || t.indexOf("Edge/") > 0 || r || o);
      }, e.io = function () {
        var e;
        return "undefined" != typeof __PRIVATE_process && "YES" === (null === (e = __PRIVATE_process.__PRIVATE_env) || void 0 === e ? void 0 : e.ro);
      }, e.ho = function (e, t) {
        return e.store(t);
      }, e.to = function (e) {
        var t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i),
            n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
      }, e.no = function (e) {
        var t = e.match(/Android ([\d.]+)/i),
            n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
        return Number(n);
      }, e.prototype.oo = function (e) {
        this.db.onversionchange = function (t) {
          return e(t);
        };
      }, e.prototype.runTransaction = function (e, t, n) {
        return i.__awaiter(this, void 0, void 0, function () {
          var r, o, a, s, u;
          return i.__generator(this, function (c) {
            switch (c.label) {
              case 0:
                r = "readonly" === e, o = 0, a = function a() {
                  var e, a, u, c, l;
                  return i.__generator(this, function (i) {
                    switch (i.label) {
                      case 0:
                        ++o, e = on.open(s.db, r ? "readonly" : "readwrite", t), i.label = 1;

                      case 1:
                        return i.trys.push([1, 3,, 4]), a = n(e).catch(function (t) {
                          return e.abort(t), Ct.reject(t);
                        }).Bn(), u = {}, a.catch(function () {}), [4, e.ao];

                      case 2:
                        return [2, (u.value = (i.sent(), a), u)];

                      case 3:
                        return c = i.sent(), l = "FirebaseError" !== c.name && o < 3, yt("SimpleDb", "Transaction failed with error: %s. Retrying: %s.", c.message, l), l ? [3, 4] : [2, {
                          value: Promise.reject(c)
                        }];

                      case 4:
                        return [2];
                    }
                  });
                }, s = this, c.label = 1;

              case 1:
                return [5, a()];

              case 2:
                if ("object" == typeof (u = c.sent())) return [2, u.value];
                c.label = 3;

              case 3:
                return [3, 1];

              case 4:
                return [2];
            }
          });
        });
      }, e.prototype.close = function () {
        this.db.close();
      }, e;
    }(),
        nn = function () {
      function e(e) {
        this.uo = e, this.co = !1, this._o = null;
      }

      return Object.defineProperty(e.prototype, "Mn", {
        get: function get() {
          return this.co;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "lo", {
        get: function get() {
          return this._o;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "cursor", {
        set: function set(e) {
          this.uo = e;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.done = function () {
        this.co = !0;
      }, e.prototype.do = function (e) {
        this._o = e;
      }, e.prototype.delete = function () {
        return sn(this.uo.delete());
      }, e;
    }(),
        rn = function (e) {
      function t(t) {
        var n = this;
        return (n = e.call(this, d.UNAVAILABLE, "IndexedDB transaction failed: " + t) || this).name = "IndexedDbTransactionError", n;
      }

      return i.__extends(t, e), t;
    }(f),
        on = function () {
      function e(e) {
        var t = this;
        this.transaction = e, this.aborted = !1, this.fo = new Vt(), this.transaction.oncomplete = function () {
          t.fo.resolve();
        }, this.transaction.onabort = function () {
          e.error ? t.fo.reject(new rn(e.error)) : t.fo.resolve();
        }, this.transaction.onerror = function (e) {
          var n = cn(e.target.error);
          t.fo.reject(new rn(n));
        };
      }

      return e.open = function (t, n, r) {
        return new e(t.transaction(r, n));
      }, Object.defineProperty(e.prototype, "ao", {
        get: function get() {
          return this.fo.promise;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.abort = function (e) {
        e && this.fo.reject(e), this.aborted || (yt("SimpleDb", "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
      }, e.prototype.store = function (e) {
        var t = this.transaction.objectStore(e);
        return new an(t);
      }, e;
    }(),
        an = function () {
      function e(e) {
        this.store = e;
      }

      return e.prototype.put = function (e, t) {
        var n;
        return void 0 !== t ? (yt("SimpleDb", "PUT", this.store.name, e, t), n = this.store.put(t, e)) : (yt("SimpleDb", "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), sn(n);
      }, e.prototype.add = function (e) {
        return yt("SimpleDb", "ADD", this.store.name, e, e), sn(this.store.add(e));
      }, e.prototype.get = function (e) {
        var t = this;
        return sn(this.store.get(e)).next(function (n) {
          return void 0 === n && (n = null), yt("SimpleDb", "GET", t.store.name, e, n), n;
        });
      }, e.prototype.delete = function (e) {
        return yt("SimpleDb", "DELETE", this.store.name, e), sn(this.store.delete(e));
      }, e.prototype.count = function () {
        return yt("SimpleDb", "COUNT", this.store.name), sn(this.store.count());
      }, e.prototype.To = function (e, t) {
        var n = this.cursor(this.options(e, t)),
            r = [];
        return this.Eo(n, function (e, t) {
          r.push(t);
        }).next(function () {
          return r;
        });
      }, e.prototype.Io = function (e, t) {
        yt("SimpleDb", "DELETE ALL", this.store.name);
        var n = this.options(e, t);
        n.wo = !1;
        var r = this.cursor(n);
        return this.Eo(r, function (e, t, n) {
          return n.delete();
        });
      }, e.prototype.Ro = function (e, t) {
        var n;
        t ? n = e : (n = {}, t = e);
        var r = this.cursor(n);
        return this.Eo(r, t);
      }, e.prototype.mo = function (e) {
        var t = this.cursor({});
        return new Ct(function (n, r) {
          t.onerror = function (e) {
            var t = cn(e.target.error);
            r(t);
          }, t.onsuccess = function (t) {
            var r = t.target.result;
            r ? e(r.primaryKey, r.value).next(function (e) {
              e ? r.continue() : n();
            }) : n();
          };
        });
      }, e.prototype.Eo = function (e, t) {
        var n = [];
        return new Ct(function (r, i) {
          e.onerror = function (e) {
            i(e.target.error);
          }, e.onsuccess = function (e) {
            var i = e.target.result;

            if (i) {
              var o = new nn(i),
                  a = t(i.primaryKey, i.value, o);

              if (a instanceof Ct) {
                var s = a.catch(function (e) {
                  return o.done(), Ct.reject(e);
                });
                n.push(s);
              }

              o.Mn ? r() : null === o.lo ? i.continue() : i.continue(o.lo);
            } else r();
          };
        }).next(function () {
          return Ct.Un(n);
        });
      }, e.prototype.options = function (e, t) {
        var n = void 0;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
          index: n,
          range: t
        };
      }, e.prototype.cursor = function (e) {
        var t = "next";

        if (e.reverse && (t = "prev"), e.index) {
          var n = this.store.index(e.index);
          return e.wo ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }

        return this.store.openCursor(e.range, t);
      }, e;
    }();

    function sn(e) {
      return new Ct(function (t, n) {
        e.onsuccess = function (e) {
          var n = e.target.result;
          t(n);
        }, e.onerror = function (e) {
          var t = cn(e.target.error);
          n(t);
        };
      });
    }

    var un = !1;

    function cn(e) {
      var t = tn.to(s.getUA());

      if (t >= 12.2 && t < 13) {
        var n = "An internal error was encountered in the Indexed Database server";

        if (e.message.indexOf(n) >= 0) {
          var r = new f("internal", "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '" + n + "'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
          return un || (un = !0, setTimeout(function () {
            throw r;
          }, 0)), r;
        }
      }

      return e;
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var ln = function () {
      function e(e, t, n, r) {
        this.userId = e, this.serializer = t, this.rr = n, this.Ao = r, this.Po = {};
      }

      return e.Vo = function (t, n, r, i) {
        return wt("" !== t.uid), new e(t.t() ? t.uid : "", n, r, i);
      }, e.prototype.po = function (e) {
        var t = !0,
            n = IDBKeyRange.bound([this.userId, Number.NEGATIVE_INFINITY], [this.userId, Number.POSITIVE_INFINITY]);
        return fn(e).Ro({
          index: Cn.userMutationsIndex,
          range: n
        }, function (e, n, r) {
          t = !1, r.done();
        }).next(function () {
          return t;
        });
      }, e.prototype.yo = function (e, t, n) {
        return this.bo(e).next(function (t) {
          return t.lastStreamToken = n.toBase64(), mn(e).put(t);
        });
      }, e.prototype.vo = function (e) {
        return this.bo(e).next(function (e) {
          return D.fromBase64String(e.lastStreamToken);
        });
      }, e.prototype.So = function (e, t) {
        return this.bo(e).next(function (n) {
          return n.lastStreamToken = t.toBase64(), mn(e).put(n);
        });
      }, e.prototype.Do = function (e, t, n, r) {
        var i = this,
            o = pn(e),
            a = fn(e);
        return a.add({}).next(function (s) {
          wt("number" == typeof s);

          for (var u = new It(s, t, n, r), c = i.serializer.Co(i.userId, u), l = [], h = new je(function (e, t) {
            return Et(e.j(), t.j());
          }), d = 0, f = r; d < f.length; d++) {
            var p = f[d],
                m = On.key(i.userId, p.key.path, s);
            h = h.add(p.key.path.M()), l.push(a.put(c)), l.push(o.put(m, On.PLACEHOLDER));
          }

          return h.forEach(function (t) {
            l.push(i.rr.Fo(e, t));
          }), e.er(function () {
            i.Po[s] = u.keys();
          }), Ct.Un(l).next(function () {
            return u;
          });
        });
      }, e.prototype.No = function (e, t) {
        var n = this;
        return fn(e).get(t).next(function (e) {
          return e ? (wt(e.userId === n.userId), n.serializer.ko(e)) : null;
        });
      }, e.prototype.$o = function (e, t) {
        var n = this;
        return this.Po[t] ? Ct.resolve(this.Po[t]) : this.No(e, t).next(function (e) {
          if (e) {
            var r = e.keys();
            return n.Po[t] = r, r;
          }

          return null;
        });
      }, e.prototype.Mo = function (e, t) {
        var n = this,
            r = t + 1,
            i = IDBKeyRange.lowerBound([this.userId, r]),
            o = null;
        return fn(e).Ro({
          index: Cn.userMutationsIndex,
          range: i
        }, function (e, t, i) {
          t.userId === n.userId && (wt(t.batchId >= r), o = n.serializer.ko(t)), i.done();
        }).next(function () {
          return o;
        });
      }, e.prototype.Lo = function (e) {
        var t = IDBKeyRange.upperBound([this.userId, Number.POSITIVE_INFINITY]),
            n = -1;
        return fn(e).Ro({
          index: Cn.userMutationsIndex,
          range: t,
          reverse: !0
        }, function (e, t, r) {
          n = t.batchId, r.done();
        }).next(function () {
          return n;
        });
      }, e.prototype.xo = function (e) {
        var t = this,
            n = IDBKeyRange.bound([this.userId, -1], [this.userId, Number.POSITIVE_INFINITY]);
        return fn(e).To(Cn.userMutationsIndex, n).next(function (e) {
          return e.map(function (e) {
            return t.serializer.ko(e);
          });
        });
      }, e.prototype.or = function (e, t) {
        var n = this,
            r = On.prefixForPath(this.userId, t.path),
            i = IDBKeyRange.lowerBound(r),
            o = [];
        return pn(e).Ro({
          range: i
        }, function (r, i, a) {
          var s = r[0],
              u = r[1],
              c = r[2],
              l = en(u);
          if (s === n.userId && t.path.isEqual(l)) return fn(e).get(c).next(function (e) {
            if (!e) throw bt();
            wt(e.userId === n.userId), o.push(n.serializer.ko(e));
          });
          a.done();
        }).next(function () {
          return o;
        });
      }, e.prototype.lr = function (e, t) {
        var n = this,
            r = new je(Et),
            i = [];
        return t.forEach(function (t) {
          var o = On.prefixForPath(n.userId, t.path),
              a = IDBKeyRange.lowerBound(o),
              s = pn(e).Ro({
            range: a
          }, function (e, i, o) {
            var a = e[0],
                s = e[1],
                u = e[2],
                c = en(s);
            a === n.userId && t.path.isEqual(c) ? r = r.add(u) : o.done();
          });
          i.push(s);
        }), Ct.Un(i).next(function () {
          return n.Oo(e, r);
        });
      }, e.prototype.Rr = function (e, t) {
        var n = this,
            r = t.path,
            i = r.length + 1,
            o = On.prefixForPath(this.userId, r),
            a = IDBKeyRange.lowerBound(o),
            s = new je(Et);
        return pn(e).Ro({
          range: a
        }, function (e, t, o) {
          var a = e[0],
              u = e[1],
              c = e[2],
              l = en(u);
          a === n.userId && r.q(l) ? l.length === i && (s = s.add(c)) : o.done();
        }).next(function () {
          return n.Oo(e, s);
        });
      }, e.prototype.Oo = function (e, t) {
        var n = this,
            r = [],
            i = [];
        return t.forEach(function (t) {
          i.push(fn(e).get(t).next(function (e) {
            if (null === e) throw bt();
            wt(e.userId === n.userId), r.push(n.serializer.ko(e));
          }));
        }), Ct.Un(i).next(function () {
          return r;
        });
      }, e.prototype.Bo = function (e, t) {
        var n = this;
        return dn(e.qo, this.userId, t).next(function (r) {
          return e.er(function () {
            n.Uo(t.batchId);
          }), Ct.forEach(r, function (t) {
            return n.Ao.Qo(e, t);
          });
        });
      }, e.prototype.Uo = function (e) {
        delete this.Po[e];
      }, e.prototype.Wo = function (e) {
        var t = this;
        return this.po(e).next(function (n) {
          if (!n) return Ct.resolve();
          var r = IDBKeyRange.lowerBound(On.prefixForUser(t.userId)),
              i = [];
          return pn(e).Ro({
            range: r
          }, function (e, n, r) {
            if (e[0] === t.userId) {
              var o = en(e[1]);
              i.push(o);
            } else r.done();
          }).next(function () {
            wt(0 === i.length);
          });
        });
      }, e.prototype.Fn = function (e, t) {
        return hn(e, this.userId, t);
      }, e.prototype.bo = function (e) {
        var t = this;
        return mn(e).get(this.userId).next(function (e) {
          return e || new Yn(t.userId, -1, "");
        });
      }, e;
    }();

    function hn(e, t, n) {
      var r = On.prefixForPath(t, n.path),
          i = r[1],
          o = IDBKeyRange.lowerBound(r),
          a = !1;
      return pn(e).Ro({
        range: o,
        wo: !0
      }, function (e, n, r) {
        var o = e[0],
            s = e[1];
        e[2], o === t && s === i && (a = !0), r.done();
      }).next(function () {
        return a;
      });
    }

    function dn(e, t, n) {
      var r = e.store(Cn.store),
          i = e.store(On.store),
          o = [],
          a = IDBKeyRange.only(n.batchId),
          s = 0,
          u = r.Ro({
        range: a
      }, function (e, t, n) {
        return s++, n.delete();
      });
      o.push(u.next(function () {
        wt(1 === s);
      }));

      for (var c = [], l = 0, h = n.mutations; l < h.length; l++) {
        var d = h[l],
            f = On.key(t, d.key.path, n.batchId);
        o.push(i.delete(f)), c.push(d.key);
      }

      return Ct.Un(o).next(function () {
        return c;
      });
    }

    function fn(e) {
      return Kn.ho(e, Cn.store);
    }

    function pn(e) {
      return Kn.ho(e, On.store);
    }

    function mn(e) {
      return Kn.ho(e, Yn.store);
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var _n = function () {
      function e(e) {
        this.jo = e;
      }

      return e.prototype.next = function () {
        return this.jo += 2, this.jo;
      }, e.Ko = function () {
        return new e(0);
      }, e.Go = function () {
        return new e(-1);
      }, e;
    }(),
        yn = function () {
      function e(e, t) {
        this.Ao = e, this.serializer = t;
      }

      return e.prototype.zo = function (e) {
        var t = this;
        return this.Ho(e).next(function (n) {
          var r = new _n(n.highestTargetId);
          return n.highestTargetId = r.next(), t.Yo(e, n).next(function () {
            return n.highestTargetId;
          });
        });
      }, e.prototype.Jo = function (e) {
        return this.Ho(e).next(function (e) {
          return b.v(new g(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds));
        });
      }, e.prototype.Xo = function (e) {
        return bn(e.qo);
      }, e.prototype.Zo = function (e, t, n) {
        var r = this;
        return this.Ho(e).next(function (i) {
          return i.highestListenSequenceNumber = t, n && (i.lastRemoteSnapshotVersion = n.C()), t > i.highestListenSequenceNumber && (i.highestListenSequenceNumber = t), r.Yo(e, i);
        });
      }, e.prototype.ta = function (e, t) {
        var n = this;
        return this.ea(e, t).next(function () {
          return n.Ho(e).next(function (r) {
            return r.targetCount += 1, n.sa(t, r), n.Yo(e, r);
          });
        });
      }, e.prototype.ia = function (e, t) {
        return this.ea(e, t);
      }, e.prototype.na = function (e, t) {
        var n = this;
        return this.ra(e, t.targetId).next(function () {
          return vn(e).delete(t.targetId);
        }).next(function () {
          return n.Ho(e);
        }).next(function (t) {
          return wt(t.targetCount > 0), t.targetCount -= 1, n.Yo(e, t);
        });
      }, e.prototype.Hh = function (e, t, n) {
        var r = this,
            i = 0,
            o = [];
        return vn(e).Ro(function (a, s) {
          var u = r.serializer.ha(s);
          u.sequenceNumber <= t && null === n.get(u.targetId) && (i++, o.push(r.na(e, u)));
        }).next(function () {
          return Ct.Un(o);
        }).next(function () {
          return i;
        });
      }, e.prototype.js = function (e, t) {
        var n = this;
        return vn(e).Ro(function (e, r) {
          var i = n.serializer.ha(r);
          t(i);
        });
      }, e.prototype.Ho = function (e) {
        return gn(e.qo);
      }, e.prototype.Yo = function (e, t) {
        return (n = e, Kn.ho(n, Wn.store)).put(Wn.key, t);
        var n;
      }, e.prototype.ea = function (e, t) {
        return vn(e).put(this.serializer.oa(t));
      }, e.prototype.sa = function (e, t) {
        var n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
      }, e.prototype.aa = function (e) {
        return this.Ho(e).next(function (e) {
          return e.targetCount;
        });
      }, e.prototype.ua = function (e, t) {
        var n = this,
            r = t.canonicalId(),
            i = IDBKeyRange.bound([r, Number.NEGATIVE_INFINITY], [r, Number.POSITIVE_INFINITY]),
            o = null;
        return vn(e).Ro({
          range: i,
          index: Pn.queryTargetsIndexName
        }, function (e, r, i) {
          var a = n.serializer.ha(r);
          t.isEqual(a.target) && (o = a, i.done());
        }).next(function () {
          return o;
        });
      }, e.prototype.ca = function (e, t, n) {
        var r = this,
            i = [],
            o = wn(e);
        return t.forEach(function (t) {
          var a = Xt(t.path);
          i.push(o.put(new Vn(n, a))), i.push(r.Ao.gn(e, t));
        }), Ct.Un(i);
      }, e.prototype._a = function (e, t, n) {
        var r = this,
            i = wn(e);
        return Ct.forEach(t, function (t) {
          var o = Xt(t.path);
          return Ct.Un([i.delete([n, o]), r.Ao.yn(e, t)]);
        });
      }, e.prototype.ra = function (e, t) {
        var n = wn(e),
            r = IDBKeyRange.bound([t], [t + 1], !1, !0);
        return n.delete(r);
      }, e.prototype.la = function (e, t) {
        var n = IDBKeyRange.bound([t], [t + 1], !1, !0),
            r = wn(e),
            i = Ge();
        return r.Ro({
          range: n,
          wo: !0
        }, function (e, t, n) {
          var r = en(e[1]),
              o = new k(r);
          i = i.add(o);
        }).next(function () {
          return i;
        });
      }, e.prototype.Fn = function (e, t) {
        var n = Xt(t.path),
            r = IDBKeyRange.bound([n], [Lt(n)], !1, !0),
            i = 0;
        return wn(e).Ro({
          index: Vn.documentTargetsIndex,
          wo: !0,
          range: r
        }, function (e, t, n) {
          var r = e[0];
          e[1], 0 !== r && (i++, n.done());
        }).next(function () {
          return i > 0;
        });
      }, e.prototype.si = function (e, t) {
        var n = this;
        return vn(e).get(t).next(function (e) {
          return e ? n.serializer.ha(e) : null;
        });
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function vn(e) {
      return Kn.ho(e, Pn.store);
    }

    function gn(e) {
      return tn.ho(e, Wn.store).get(Wn.key).next(function (e) {
        return wt(null !== e), e;
      });
    }

    function bn(e) {
      return gn(e).next(function (e) {
        return e.highestListenSequenceNumber;
      });
    }

    function wn(e) {
      return Kn.ho(e, Vn.store);
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var Tn = function () {
      function e(e, t) {
        this.serializer = e, this.rr = t;
      }

      return e.prototype.Gn = function (e, t, n) {
        return En(e).put(kn(t), n);
      }, e.prototype.Hn = function (e, t) {
        var n = En(e),
            r = kn(t);
        return n.delete(r);
      }, e.prototype.updateMetadata = function (e, t) {
        var n = this;
        return this.getMetadata(e).next(function (r) {
          return r.byteSize += t, n.da(e, r);
        });
      }, e.prototype.Yn = function (e, t) {
        var n = this;
        return En(e).get(kn(t)).next(function (e) {
          return n.fa(e);
        });
      }, e.prototype.Ta = function (e, t) {
        var n = this;
        return En(e).get(kn(t)).next(function (e) {
          var t = n.fa(e);
          return t ? {
            Ea: t,
            size: Ln(e)
          } : null;
        });
      }, e.prototype.getEntries = function (e, t) {
        var n = this,
            r = We();
        return this.Ia(e, t, function (e, t) {
          var i = n.fa(t);
          r = r.me(e, i);
        }).next(function () {
          return r;
        });
      }, e.prototype.wa = function (e, t) {
        var n = this,
            r = We(),
            i = new Oe(k.N);
        return this.Ia(e, t, function (e, t) {
          var o = n.fa(t);
          o ? (r = r.me(e, o), i = i.me(e, Ln(t))) : (r = r.me(e, null), i = i.me(e, 0));
        }).next(function () {
          return {
            Ra: r,
            ma: i
          };
        });
      }, e.prototype.Ia = function (e, t, n) {
        if (t.B()) return Ct.resolve();
        var r = IDBKeyRange.bound(t.first().path.W(), t.last().path.W()),
            i = t.be(),
            o = i.Ne();
        return En(e).Ro({
          range: r
        }, function (e, t, r) {
          for (var a = k.st(e); o && k.N(o, a) < 0;) {
            n(o, null), o = i.Ne();
          }

          o && o.isEqual(a) && (n(o, t), o = i.ke() ? i.Ne() : null), o ? r.do(o.path.W()) : r.done();
        }).next(function () {
          for (; o;) {
            n(o, null), o = i.ke() ? i.Ne() : null;
          }
        });
      }, e.prototype.dr = function (e, t, n) {
        var r = this,
            i = Be(),
            o = t.path.length + 1,
            a = {};

        if (n.isEqual(b.min())) {
          var s = t.path.W();
          a.range = IDBKeyRange.lowerBound(s);
        } else {
          var u = t.path.W(),
              c = this.serializer.Aa(n);
          a.range = IDBKeyRange.lowerBound([u, c], !0), a.index = jn.collectionReadTimeIndex;
        }

        return En(e).Ro(a, function (e, n, a) {
          if (e.length === o) {
            var s = r.serializer.Pa(n);
            t.path.q(s.key.path) ? s instanceof ve && t.matches(s) && (i = i.me(s.key, s)) : a.done();
          }
        }).next(function () {
          return i;
        });
      }, e.prototype.Va = function (e, t) {
        var n = this,
            r = Ve(),
            i = this.serializer.Aa(t),
            o = En(e),
            a = IDBKeyRange.lowerBound(i, !0);
        return o.Ro({
          index: jn.readTimeIndex,
          range: a
        }, function (e, t) {
          var o = n.serializer.Pa(t);
          r = r.me(o.key, o), i = t.readTime;
        }).next(function () {
          return {
            ga: r,
            readTime: n.serializer.pa(i)
          };
        });
      }, e.prototype.ya = function (e) {
        var t = this,
            n = En(e),
            r = b.min();
        return n.Ro({
          index: jn.readTimeIndex,
          reverse: !0
        }, function (e, n, i) {
          n.readTime && (r = t.serializer.pa(n.readTime)), i.done();
        }).next(function () {
          return r;
        });
      }, e.prototype.ba = function (t) {
        return new e.va(this, !!t && t.Sa);
      }, e.prototype.Da = function (e) {
        return this.getMetadata(e).next(function (e) {
          return e.byteSize;
        });
      }, e.prototype.getMetadata = function (e) {
        return Mn(e).get(Un.key).next(function (e) {
          return wt(!!e), e;
        });
      }, e.prototype.da = function (e, t) {
        return Mn(e).put(Un.key, t);
      }, e.prototype.fa = function (e) {
        if (e) {
          var t = this.serializer.Pa(e);
          return t instanceof ge && t.version.isEqual(b.min()) ? null : t;
        }

        return null;
      }, e;
    }();

    function Mn(e) {
      return Kn.ho(e, Un.store);
    }

    function En(e) {
      return Kn.ho(e, jn.store);
    }

    function kn(e) {
      return e.path.W();
    }

    function Ln(e) {
      var t;
      if (e.document) t = e.document;else if (e.unknownDocument) t = e.unknownDocument;else {
        if (!e.noDocument) throw bt();
        t = e.noDocument;
      }
      return JSON.stringify(t).length;
    }
    /**
     * @license
     * Copyright 2019 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    Tn.va = function (e) {
      function t(t, n) {
        var r = this;
        return (r = e.call(this) || this).Ca = t, r.Sa = n, r.Fa = new Dt(function (e) {
          return e.toString();
        }), r;
      }

      return i.__extends(t, e), t.prototype.Zn = function (e) {
        var t = this,
            n = [],
            r = 0,
            i = new je(function (e, t) {
          return Et(e.j(), t.j());
        });
        return this.Wn.forEach(function (o, a) {
          var s = t.Fa.get(o);

          if (a) {
            var u = t.Ca.serializer.Na(a, t.readTime);
            i = i.add(o.path.M());
            var c = Ln(u);
            r += c - s, n.push(t.Ca.Gn(e, o, u));
          } else if (r -= s, t.Sa) {
            var l = t.Ca.serializer.Na(new ge(o, b.min()), t.readTime);
            n.push(t.Ca.Gn(e, o, l));
          } else n.push(t.Ca.Hn(e, o));
        }), i.forEach(function (r) {
          n.push(t.Ca.rr.Fo(e, r));
        }), n.push(this.Ca.updateMetadata(e, r)), Ct.Un(n);
      }, t.prototype.Jn = function (e, t) {
        var n = this;
        return this.Ca.Ta(e, t).next(function (e) {
          return null === e ? (n.Fa.set(t, 0), null) : (n.Fa.set(t, e.size), e.Ea);
        });
      }, t.prototype.Xn = function (e, t) {
        var n = this;
        return this.Ca.wa(e, t).next(function (e) {
          var t = e.Ra;
          return e.ma.forEach(function (e, t) {
            n.Fa.set(e, t);
          }), t;
        });
      }, t;
    }(Ot);

    var Sn = function () {
      function e() {
        this.ka = new Nn();
      }

      return e.prototype.Fo = function (e, t) {
        return this.ka.add(t), Ct.resolve();
      }, e.prototype.wr = function (e, t) {
        return Ct.resolve(this.ka.getEntries(t));
      }, e;
    }(),
        Nn = function () {
      function e() {
        this.index = {};
      }

      return e.prototype.add = function (e) {
        var t = e.O(),
            n = e.M(),
            r = this.index[t] || new je(T.N),
            i = !r.has(n);
        return this.index[t] = r.add(n), i;
      }, e.prototype.has = function (e) {
        var t = e.O(),
            n = e.M(),
            r = this.index[t];
        return r && r.has(n);
      }, e.prototype.getEntries = function (e) {
        return (this.index[e] || new je(T.N)).W();
      }, e;
    }(),
        Dn = 10,
        In = function () {
      function e(e) {
        this.serializer = e;
      }

      return e.prototype.createOrUpgrade = function (e, t, n, r) {
        var i = this;
        wt(n < r && n >= 0 && r <= Dn);
        var o = new on(t);
        n < 1 && r >= 1 && (function (e) {
          e.createObjectStore(xn.store);
        }(e), function (e) {
          e.createObjectStore(Yn.store, {
            keyPath: Yn.keyPath
          }), e.createObjectStore(Cn.store, {
            keyPath: Cn.keyPath,
            autoIncrement: !0
          }).createIndex(Cn.userMutationsIndex, Cn.userMutationsKeyPath, {
            unique: !0
          }), e.createObjectStore(On.store);
        }(e), Bn(e), function (e) {
          e.createObjectStore(jn.store);
        }(e));
        var a = Ct.resolve();
        return n < 3 && r >= 3 && (0 !== n && (function (e) {
          e.deleteObjectStore(Vn.store), e.deleteObjectStore(Pn.store), e.deleteObjectStore(Wn.store);
        }(e), Bn(e)), a = a.next(function () {
          return e = o.store(Wn.store), t = new Wn(0, 0, b.min().C(), 0), e.put(Wn.key, t);
          var e, t;
        })), n < 4 && r >= 4 && (0 !== n && (a = a.next(function () {
          return function (e, t) {
            return t.store(Cn.store).To().next(function (n) {
              e.deleteObjectStore(Cn.store), e.createObjectStore(Cn.store, {
                keyPath: Cn.keyPath,
                autoIncrement: !0
              }).createIndex(Cn.userMutationsIndex, Cn.userMutationsKeyPath, {
                unique: !0
              });
              var r = t.store(Cn.store),
                  i = n.map(function (e) {
                return r.put(e);
              });
              return Ct.Un(i);
            });
          }(e, o);
        })), a = a.next(function () {
          !function (e) {
            e.createObjectStore(zn.store, {
              keyPath: zn.keyPath
            });
          }(e);
        })), n < 5 && r >= 5 && (a = a.next(function () {
          return i.removeAcknowledgedMutations(o);
        })), n < 6 && r >= 6 && (a = a.next(function () {
          return function (e) {
            e.createObjectStore(Un.store);
          }(e), i.addDocumentGlobal(o);
        })), n < 7 && r >= 7 && (a = a.next(function () {
          return i.ensureSequenceNumbers(o);
        })), n < 8 && r >= 8 && (a = a.next(function () {
          return i.createCollectionParentIndex(e, o);
        })), n < 9 && r >= 9 && (a = a.next(function () {
          !function (e) {
            e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
          }(e), function (e) {
            var t = e.objectStore(jn.store);
            t.createIndex(jn.readTimeIndex, jn.readTimeIndexPath, {
              unique: !1
            }), t.createIndex(jn.collectionReadTimeIndex, jn.collectionReadTimeIndexPath, {
              unique: !1
            });
          }(t);
        })), n < 10 && r >= 10 && (a = a.next(function () {
          return i.rewriteCanonicalIds(o);
        })), a;
      }, e.prototype.addDocumentGlobal = function (e) {
        var t = 0;
        return e.store(jn.store).Ro(function (e, n) {
          t += Ln(n);
        }).next(function () {
          var n = new Un(t);
          return e.store(Un.store).put(Un.key, n);
        });
      }, e.prototype.removeAcknowledgedMutations = function (e) {
        var t = this,
            n = e.store(Yn.store),
            r = e.store(Cn.store);
        return n.To().next(function (n) {
          return Ct.forEach(n, function (n) {
            var i = IDBKeyRange.bound([n.userId, -1], [n.userId, n.lastAcknowledgedBatchId]);
            return r.To(Cn.userMutationsIndex, i).next(function (r) {
              return Ct.forEach(r, function (r) {
                wt(r.userId === n.userId);
                var i = t.serializer.ko(r);
                return dn(e, n.userId, i).next(function () {});
              });
            });
          });
        });
      }, e.prototype.ensureSequenceNumbers = function (e) {
        var t = e.store(Vn.store),
            n = e.store(jn.store);
        return bn(e).next(function (e) {
          var r = [];
          return n.Ro(function (n, i) {
            var o = new T(n),
                a = [0, Xt(o)];
            r.push(t.get(a).next(function (n) {
              return n ? Ct.resolve() : function (n) {
                return t.put(new Vn(0, Xt(n), e));
              }(o);
            }));
          }).next(function () {
            return Ct.Un(r);
          });
        });
      }, e.prototype.createCollectionParentIndex = function (e, t) {
        e.createObjectStore(Hn.store, {
          keyPath: Hn.keyPath
        });

        var n = t.store(Hn.store),
            r = new Nn(),
            i = function i(e) {
          if (r.add(e)) {
            var t = e.O(),
                i = e.M();
            return n.put({
              collectionId: t,
              parent: Xt(i)
            });
          }
        };

        return t.store(jn.store).Ro({
          wo: !0
        }, function (e, t) {
          var n = new T(e);
          return i(n.M());
        }).next(function () {
          return t.store(On.store).Ro({
            wo: !0
          }, function (e, t) {
            e[0];
            var n = e[1],
                r = (e[2], en(n));
            return i(r.M());
          });
        });
      }, e.prototype.rewriteCanonicalIds = function (e) {
        var t = this,
            n = e.store(Pn.store);
        return n.Ro(function (e, r) {
          var i = t.serializer.ha(r),
              o = t.serializer.oa(i);
          return n.put(o);
        });
      }, e;
    }(),
        Rn = function Rn(e, t) {
      this.seconds = e, this.nanoseconds = t;
    },
        xn = function xn(e, t, n) {
      this.ownerId = e, this.allowTabSynchronization = t, this.leaseTimestampMs = n;
    };

    xn.store = "owner", xn.key = "owner";

    var Yn = function Yn(e, t, n) {
      this.userId = e, this.lastAcknowledgedBatchId = t, this.lastStreamToken = n;
    };

    Yn.store = "mutationQueues", Yn.keyPath = "userId";

    var Cn = function Cn(e, t, n, r, i) {
      this.userId = e, this.batchId = t, this.localWriteTimeMs = n, this.baseMutations = r, this.mutations = i;
    };

    Cn.store = "mutations", Cn.keyPath = "batchId", Cn.userMutationsIndex = "userMutationsIndex", Cn.userMutationsKeyPath = ["userId", "batchId"];

    var On = function () {
      function e() {}

      return e.prefixForUser = function (e) {
        return [e];
      }, e.prefixForPath = function (e, t) {
        return [e, Xt(t)];
      }, e.key = function (e, t, n) {
        return [e, Xt(t), n];
      }, e;
    }();

    On.store = "documentMutations", On.PLACEHOLDER = new On();

    var Fn = function Fn(e, t) {
      this.path = e, this.readTime = t;
    },
        An = function An(e, t) {
      this.path = e, this.version = t;
    },
        jn = function jn(e, t, n, r, i, o) {
      this.unknownDocument = e, this.noDocument = t, this.document = n, this.hasCommittedMutations = r, this.readTime = i, this.parentPath = o;
    };

    jn.store = "remoteDocuments", jn.readTimeIndex = "readTimeIndex", jn.readTimeIndexPath = "readTime", jn.collectionReadTimeIndex = "collectionReadTimeIndex", jn.collectionReadTimeIndexPath = ["parentPath", "readTime"];

    var Un = function Un(e) {
      this.byteSize = e;
    };

    Un.store = "remoteDocumentGlobal", Un.key = "remoteDocumentGlobalKey";

    var Pn = function Pn(e, t, n, r, i, o, a) {
      this.targetId = e, this.canonicalId = t, this.readTime = n, this.resumeToken = r, this.lastListenSequenceNumber = i, this.lastLimboFreeSnapshotVersion = o, this.query = a;
    };

    Pn.store = "targets", Pn.keyPath = "targetId", Pn.queryTargetsIndexName = "queryTargetsIndex", Pn.queryTargetsKeyPath = ["canonicalId", "targetId"];

    var Vn = function Vn(e, t, n) {
      this.targetId = e, this.path = t, this.sequenceNumber = n;
    };

    Vn.store = "targetDocuments", Vn.keyPath = ["targetId", "path"], Vn.documentTargetsIndex = "documentTargetsIndex", Vn.documentTargetsKeyPath = ["path", "targetId"];

    var Wn = function Wn(e, t, n, r) {
      this.highestTargetId = e, this.highestListenSequenceNumber = t, this.lastRemoteSnapshotVersion = n, this.targetCount = r;
    };

    Wn.key = "targetGlobalKey", Wn.store = "targetGlobal";

    var Hn = function Hn(e, t) {
      this.collectionId = e, this.parent = t;
    };

    function Bn(e) {
      e.createObjectStore(Vn.store, {
        keyPath: Vn.keyPath
      }).createIndex(Vn.documentTargetsIndex, Vn.documentTargetsKeyPath, {
        unique: !0
      }), e.createObjectStore(Pn.store, {
        keyPath: Pn.keyPath
      }).createIndex(Pn.queryTargetsIndexName, Pn.queryTargetsKeyPath, {
        unique: !0
      }), e.createObjectStore(Wn.store);
    }

    Hn.store = "collectionParents", Hn.keyPath = ["collectionId", "parent"];

    var zn = function zn(e, t, n, r) {
      this.clientId = e, this.updateTimeMs = t, this.networkEnabled = n, this.inForeground = r;
    };

    zn.store = "clientMetadata", zn.keyPath = "clientId";

    var Zn = i.__spreadArrays(i.__spreadArrays(i.__spreadArrays([Yn.store, Cn.store, On.store, jn.store, Pn.store, xn.store, Wn.store, Vn.store], [zn.store]), [Un.store]), [Hn.store]),
        Qn = function () {
      function e() {
        this.$a = new Nn();
      }

      return e.prototype.Fo = function (e, t) {
        var n = this;

        if (!this.$a.has(t)) {
          var r = t.O(),
              i = t.M();
          e.er(function () {
            n.$a.add(t);
          });
          var o = {
            collectionId: r,
            parent: Xt(i)
          };
          return Gn(e).put(o);
        }

        return Ct.resolve();
      }, e.prototype.wr = function (e, t) {
        var n = [],
            r = IDBKeyRange.bound([t, ""], [Lt(t), ""], !1, !0);
        return Gn(e).To(r).next(function (e) {
          for (var r = 0, i = e; r < i.length; r++) {
            var o = i[r];
            if (o.collectionId !== t) break;
            n.push(en(o.parent));
          }

          return n;
        });
      }, e;
    }();
    /**
     * @license
     * Copyright 2019 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Gn(e) {
      return Kn.ho(e, Hn.store);
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var qn = function () {
      function e(e) {
        this.Ma = e;
      }

      return e.prototype.Pa = function (e) {
        if (e.document) return this.Ma.Ai(e.document, !!e.hasCommittedMutations);

        if (e.noDocument) {
          var t = k.st(e.noDocument.path),
              n = this.La(e.noDocument.readTime);
          return new ge(t, n, {
            hasCommittedMutations: !!e.hasCommittedMutations
          });
        }

        if (e.unknownDocument) {
          var r = k.st(e.unknownDocument.path),
              i = this.La(e.unknownDocument.version);
          return new be(r, i);
        }

        return bt();
      }, e.prototype.Na = function (e, t) {
        var n = this.Aa(t),
            r = e.key.path.M().W();

        if (e instanceof ve) {
          var i = this.Ma.mi(e),
              o = e.hasCommittedMutations;
          return new jn(null, null, i, o, n, r);
        }

        if (e instanceof ge) {
          var a = e.key.path.W(),
              s = this.xa(e.version),
              u = e.hasCommittedMutations;
          return new jn(null, new Fn(a, s), null, u, n, r);
        }

        if (e instanceof be) {
          var c = e.key.path.W(),
              l = this.xa(e.version);
          return new jn(new An(c, l), null, null, !0, n, r);
        }

        return bt();
      }, e.prototype.Aa = function (e) {
        var t = e.C();
        return [t.seconds, t.nanoseconds];
      }, e.prototype.pa = function (e) {
        var t = new g(e[0], e[1]);
        return b.v(t);
      }, e.prototype.xa = function (e) {
        var t = e.C();
        return new Rn(t.seconds, t.nanoseconds);
      }, e.prototype.La = function (e) {
        var t = new g(e.seconds, e.nanoseconds);
        return b.v(t);
      }, e.prototype.Co = function (e, t) {
        var n = this,
            r = t.baseMutations.map(function (e) {
          return n.Ma.vi(e);
        }),
            i = t.mutations.map(function (e) {
          return n.Ma.vi(e);
        });
        return new Cn(e, t.batchId, t.Tn.toMillis(), r, i);
      }, e.prototype.ko = function (e) {
        var t = this,
            n = (e.baseMutations || []).map(function (e) {
          return t.Ma.Fi(e);
        }),
            r = e.mutations.map(function (e) {
          return t.Ma.Fi(e);
        }),
            i = g.fromMillis(e.localWriteTimeMs);
        return new It(e.batchId, i, n, r);
      }, e.prototype.ha = function (e) {
        var t,
            n = this.La(e.readTime),
            r = void 0 !== e.lastLimboFreeSnapshotVersion ? this.La(e.lastLimboFreeSnapshotVersion) : b.min();
        return t = void 0 !== e.query.documents ? this.Ma.Oi(e.query) : this.Ma.Wi(e.query), new Re(t, e.targetId, 0, e.lastListenSequenceNumber, n, r, D.fromBase64String(e.resumeToken));
      }, e.prototype.oa = function (e) {
        var t,
            n = this.xa(e.Ee),
            r = this.xa(e.lastLimboFreeSnapshotVersion);
        t = e.target.xt() ? this.Ma.xi(e.target) : this.Ma.Bi(e.target);
        var i = e.resumeToken.toBase64();
        return new Pn(e.targetId, e.target.canonicalId(), n, i, e.sequenceNumber, r, t);
      }, e;
    }(),
        Jn = "Another tab has exclusive access to the persistence layer. To allow shared access, make sure to invoke `enablePersistence()` with `synchronizeTabs:true` in all tabs.",
        Xn = function (e) {
      function t(t, n) {
        var r = this;
        return (r = e.call(this) || this).qo = t, r.Oa = n, r;
      }

      return i.__extends(t, e), t;
    }(At),
        Kn = function () {
      function e(t, n, r, i, o, a, s, u) {
        if (this.allowTabSynchronization = t, this.persistenceKey = n, this.clientId = r, this.Sr = a, this.Ba = u, this.qa = !1, this.isPrimary = !1, this.networkEnabled = !0, this.Ua = null, this.inForeground = !1, this.Qa = null, this.Wa = null, this.ja = Number.NEGATIVE_INFINITY, this.Ka = function (e) {
          return Promise.resolve();
        }, !e.so()) throw new f(d.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        if (this.Ao = new tr(this, o), this.Ga = n + e.za, this.serializer = new qn(s), this.document = i.document, this.Ha = new yn(this.Ao, this.serializer), this.rr = new Qn(), this.ir = new Tn(this.serializer, this.rr), !i.window || !i.window.localStorage) throw new f(d.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        this.window = i.window, this.Ya = this.window.localStorage;
      }

      return e.ho = function (e, t) {
        if (e instanceof Xn) return tn.ho(e.qo, t);
        throw bt();
      }, e.prototype.start = function () {
        var e = this;
        return tn.eo(this.Ga, Dn, new In(this.serializer)).then(function (t) {
          return e.Ja = t, e.Xa();
        }).then(function () {
          return e.Za(), e.tu(), e.eu(), e.Ja.runTransaction("readonly", [Wn.store], function (e) {
            return bn(e);
          });
        }).then(function (t) {
          e.su = new Pt(t, e.Ba);
        }).then(function () {
          e.qa = !0;
        }).catch(function (t) {
          return e.Ja && e.Ja.close(), Promise.reject(t);
        });
      }, e.prototype.iu = function (e) {
        var t = this;
        return this.Ka = function (n) {
          return i.__awaiter(t, void 0, void 0, function () {
            return i.__generator(this, function (t) {
              return this.Uh ? [2, e(n)] : [2];
            });
          });
        }, e(this.isPrimary);
      }, e.prototype.nu = function (e) {
        var t = this;
        this.Ja.oo(function (n) {
          return i.__awaiter(t, void 0, void 0, function () {
            return i.__generator(this, function (t) {
              switch (t.label) {
                case 0:
                  return null === n.newVersion ? [4, e()] : [3, 2];

                case 1:
                  t.sent(), t.label = 2;

                case 2:
                  return [2];
              }
            });
          });
        });
      }, e.prototype.ru = function (e) {
        var t = this;
        this.networkEnabled !== e && (this.networkEnabled = e, this.Sr.Hr(function () {
          return i.__awaiter(t, void 0, void 0, function () {
            return i.__generator(this, function (e) {
              switch (e.label) {
                case 0:
                  return this.Uh ? [4, this.Xa()] : [3, 2];

                case 1:
                  e.sent(), e.label = 2;

                case 2:
                  return [2];
              }
            });
          });
        }));
      }, e.prototype.Xa = function () {
        var e = this;
        return this.Ja.runTransaction("readwrite", Zn, function (t) {
          return er(t).put(new zn(e.clientId, Date.now(), e.networkEnabled, e.inForeground)).next(function () {
            if (e.isPrimary) return e.hu(t).next(function (t) {
              t || (e.isPrimary = !1, e.Sr.Hr(function () {
                return e.Ka(!1);
              }));
            });
          }).next(function () {
            return e.ou(t);
          }).next(function (n) {
            return e.isPrimary && !n ? e.au(t).next(function () {
              return !1;
            }) : !!n && e.uu(t).next(function () {
              return !0;
            });
          });
        }).catch(function (t) {
          if (!e.allowTabSynchronization) throw t;
          return yt("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", t), !1;
        }).then(function (t) {
          e.isPrimary !== t && e.Sr.Hr(function () {
            return e.Ka(t);
          }), e.isPrimary = t;
        });
      }, e.prototype.hu = function (e) {
        var t = this;
        return $n(e).get(xn.key).next(function (e) {
          return Ct.resolve(t.cu(e));
        });
      }, e.prototype._u = function (e) {
        return er(e).delete(this.clientId);
      }, e.prototype.lu = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          var t = this;
          return i.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return !this.isPrimary || this.du(this.ja, 18e5) ? [3, 2] : (this.ja = Date.now(), [4, this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", function (n) {
                  var r = e.ho(n, zn.store);
                  return r.To().next(function (e) {
                    var n = t.fu(e, 18e5),
                        i = e.filter(function (e) {
                      return -1 === n.indexOf(e);
                    });
                    return Ct.forEach(i, function (e) {
                      return r.delete(e.clientId);
                    }).next(function () {
                      return i;
                    });
                  });
                }).catch(function () {
                  return [];
                })]);

              case 1:
                n.sent().forEach(function (e) {
                  t.window.localStorage.removeItem(t.Tu(e.clientId));
                }), n.label = 2;

              case 2:
                return [2];
            }
          });
        });
      }, e.prototype.eu = function () {
        var e = this;
        this.Wa = this.Sr.Br("client_metadata_refresh", 4e3, function () {
          return e.Xa().then(function () {
            return e.lu();
          }).then(function () {
            return e.eu();
          });
        });
      }, e.prototype.cu = function (e) {
        return !!e && e.ownerId === this.clientId;
      }, e.prototype.ou = function (e) {
        var t = this;
        return $n(e).get(xn.key).next(function (n) {
          if (null !== n && t.du(n.leaseTimestampMs, 5e3) && !t.Eu(n.ownerId)) {
            if (t.cu(n) && t.networkEnabled) return !0;

            if (!t.cu(n)) {
              if (!n.allowTabSynchronization) throw new f(d.FAILED_PRECONDITION, Jn);
              return !1;
            }
          }

          return !(!t.networkEnabled || !t.inForeground) || er(e).To().next(function (e) {
            return void 0 === t.fu(e, 5e3).find(function (e) {
              if (t.clientId !== e.clientId) {
                var n = !t.networkEnabled && e.networkEnabled,
                    r = !t.inForeground && e.inForeground,
                    i = t.networkEnabled === e.networkEnabled;
                if (n || r && i) return !0;
              }

              return !1;
            });
          });
        }).next(function (e) {
          return t.isPrimary !== e && yt("IndexedDbPersistence", "Client " + (e ? "is" : "is not") + " eligible for a primary lease."), e;
        });
      }, e.prototype.Iu = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          var e = this;
          return i.__generator(this, function (t) {
            switch (t.label) {
              case 0:
                return this.qa = !1, this.wu(), this.Wa && (this.Wa.cancel(), this.Wa = null), this.Ru(), this.mu(), [4, this.Ja.runTransaction("readwrite", [xn.store, zn.store], function (t) {
                  return e.au(t).next(function () {
                    return e._u(t);
                  });
                })];

              case 1:
                return t.sent(), this.Ja.close(), this.Au(), [2];
            }
          });
        });
      }, e.prototype.fu = function (e, t) {
        var n = this;
        return e.filter(function (e) {
          return n.du(e.updateTimeMs, t) && !n.Eu(e.clientId);
        });
      }, e.prototype.Pu = function () {
        var e = this;
        return this.Ja.runTransaction("readonly", [zn.store], function (t) {
          return er(t).To().next(function (t) {
            return e.fu(t, 18e5).map(function (e) {
              return e.clientId;
            });
          });
        });
      }, e.clearPersistence = function (t) {
        return i.__awaiter(this, void 0, void 0, function () {
          var n;
          return i.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return e.so() ? (n = t + e.za, [4, tn.delete(n)]) : [2, Promise.resolve()];

              case 1:
                return r.sent(), [2];
            }
          });
        });
      }, Object.defineProperty(e.prototype, "Uh", {
        get: function get() {
          return this.qa;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.Vu = function (e) {
        return ln.Vo(e, this.serializer, this.rr, this.Ao);
      }, e.prototype.gu = function () {
        return this.Ha;
      }, e.prototype.pu = function () {
        return this.ir;
      }, e.prototype.yu = function () {
        return this.rr;
      }, e.prototype.runTransaction = function (e, t, n) {
        var r = this;
        yt("IndexedDbPersistence", "Starting transaction:", e);
        var i,
            o = "readonly" === t ? "readonly" : "readwrite";
        return this.Ja.runTransaction(o, Zn, function (o) {
          return i = new Xn(o, r.su.next()), "readwrite-primary" === t ? r.hu(o).next(function (e) {
            return !!e || r.ou(o);
          }).next(function (t) {
            if (!t) throw vt("Failed to obtain primary lease for action '" + e + "'."), r.isPrimary = !1, r.Sr.Hr(function () {
              return r.Ka(!1);
            }), new f(d.FAILED_PRECONDITION, Ft);
            return n(i);
          }).next(function (e) {
            return r.uu(o).next(function () {
              return e;
            });
          }) : r.bu(o).next(function () {
            return n(i);
          });
        }).then(function (e) {
          return i.sr(), e;
        });
      }, e.prototype.bu = function (e) {
        var t = this;
        return $n(e).get(xn.key).next(function (e) {
          if (null !== e && t.du(e.leaseTimestampMs, 5e3) && !t.Eu(e.ownerId) && !t.cu(e) && !e.allowTabSynchronization) throw new f(d.FAILED_PRECONDITION, Jn);
        });
      }, e.prototype.uu = function (e) {
        var t = new xn(this.clientId, this.allowTabSynchronization, Date.now());
        return $n(e).put(xn.key, t);
      }, e.so = function () {
        return tn.so();
      }, e.vu = function (e) {
        var t = e.ii.projectId;
        return e.ii.ln || (t += "." + e.ii.database), "firestore/" + e.persistenceKey + "/" + t + "/";
      }, e.prototype.au = function (e) {
        var t = this,
            n = $n(e);
        return n.get(xn.key).next(function (e) {
          return t.cu(e) ? (yt("IndexedDbPersistence", "Releasing primary lease."), n.delete(xn.key)) : Ct.resolve();
        });
      }, e.prototype.du = function (e, t) {
        var n = Date.now();
        return !(e < n - t || e > n && (vt("Detected an update time that is in the future: " + e + " > " + n), 1));
      }, e.prototype.Za = function () {
        var e = this;
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Qa = function () {
          e.Sr.Hr(function () {
            return e.inForeground = "visible" === e.document.visibilityState, e.Xa();
          });
        }, this.document.addEventListener("visibilitychange", this.Qa), this.inForeground = "visible" === this.document.visibilityState);
      }, e.prototype.Ru = function () {
        this.Qa && (this.document.removeEventListener("visibilitychange", this.Qa), this.Qa = null);
      }, e.prototype.tu = function () {
        var e = this;
        "function" == typeof this.window.addEventListener && (this.Ua = function () {
          e.wu(), e.Sr.Hr(function () {
            return e.Iu();
          });
        }, this.window.addEventListener("unload", this.Ua));
      }, e.prototype.mu = function () {
        this.Ua && (this.window.removeEventListener("unload", this.Ua), this.Ua = null);
      }, e.prototype.Eu = function (e) {
        try {
          var t = null !== this.Ya.getItem(this.Tu(e));
          return yt("IndexedDbPersistence", "Client '" + e + "' " + (t ? "is" : "is not") + " zombied in LocalStorage"), t;
        } catch (e) {
          return vt("IndexedDbPersistence", "Failed to get zombied client id.", e), !1;
        }
      }, e.prototype.wu = function () {
        try {
          this.Ya.setItem(this.Tu(this.clientId), String(Date.now()));
        } catch (e) {
          vt("Failed to set zombie client id.", e);
        }
      }, e.prototype.Au = function () {
        try {
          this.Ya.removeItem(this.Tu(this.clientId));
        } catch (e) {}
      }, e.prototype.Tu = function (e) {
        return "firestore_zombie_" + this.persistenceKey + "_" + e;
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function $n(e) {
      return e.store(xn.store);
    }

    function er(e) {
      return e.store(zn.store);
    }

    Kn.za = "main";

    var tr = function () {
      function e(e, t) {
        this.db = e, this.Su = null, this.Lh = new Jt(this, t);
      }

      return e.prototype.Kh = function (e) {
        var t = this.Du(e);
        return this.db.gu().aa(e).next(function (e) {
          return t.next(function (t) {
            return e + t;
          });
        });
      }, e.prototype.Du = function (e) {
        var t = 0;
        return this.zh(e, function (e) {
          t++;
        }).next(function () {
          return t;
        });
      }, e.prototype.js = function (e, t) {
        return this.db.gu().js(e, t);
      }, e.prototype.zh = function (e, t) {
        return this.Cu(e, function (e, n) {
          return t(n);
        });
      }, e.prototype.Fu = function (e) {
        this.Su = e;
      }, e.prototype.gn = function (e, t) {
        return nr(e, t);
      }, e.prototype.yn = function (e, t) {
        return nr(e, t);
      }, e.prototype.Hh = function (e, t, n) {
        return this.db.gu().Hh(e, t, n);
      }, e.prototype.Qo = function (e, t) {
        return nr(e, t);
      }, e.prototype.Nu = function (e, t) {
        return this.Su.Fn(t) ? Ct.resolve(!0) : function (e, t) {
          var n = !1;
          return mn(e).mo(function (r) {
            return hn(e, r, t).next(function (e) {
              return e && (n = !0), Ct.resolve(!e);
            });
          }).next(function () {
            return n;
          });
        }(e, t);
      }, e.prototype.Yh = function (e, t) {
        var n = this,
            r = this.db.pu().ba(),
            i = [],
            o = 0;
        return this.Cu(e, function (a, s) {
          if (s <= t) {
            var u = n.Nu(e, a).next(function (t) {
              if (!t) return o++, r.Yn(e, a).next(function () {
                return r.Hn(a), wn(e).delete([0, Xt(a.path)]);
              });
            });
            i.push(u);
          }
        }).next(function () {
          return Ct.Un(i);
        }).next(function () {
          return r.apply(e);
        }).next(function () {
          return o;
        });
      }, e.prototype.removeTarget = function (e, t) {
        var n = t.Ie(e.Oa);
        return this.db.gu().ia(e, n);
      }, e.prototype.ku = function (e, t) {
        return nr(e, t);
      }, e.prototype.Cu = function (e, t) {
        var n,
            r = wn(e),
            i = Pt.vr;
        return r.Ro({
          index: Vn.documentTargetsIndex
        }, function (e, r) {
          var o = e[0],
              a = (e[1], r.path),
              s = r.sequenceNumber;
          0 === o ? (i !== Pt.vr && t(new k(en(n)), i), i = s, n = a) : i = Pt.vr;
        }).next(function () {
          i !== Pt.vr && t(new k(en(n)), i);
        });
      }, e.prototype.Xh = function (e) {
        return this.db.pu().Da(e);
      }, e;
    }();

    function nr(e, t) {
      return wn(e).put(function (e, t) {
        return new Vn(0, Xt(e.path), t);
      }(t, e.Oa));
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var rr = function () {
      function e(e, t, n) {
        this.persistence = e, this.$u = t, this.Mu = new xt(), this.Lu = new Oe(Et), this.xu = new Dt(function (e) {
          return e.canonicalId();
        }), this.Ou = b.min(), this.persistence.Ao.Fu(this.Mu), this.nr = e.Vu(n), this.Bu = e.pu(), this.Ha = e.gu(), this.qu = new jt(this.Bu, this.nr, this.persistence.yu()), this.$u.Uu(this.qu);
      }

      return e.prototype.start = function () {
        return Promise.resolve();
      }, e.prototype.Qu = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t,
              n,
              r,
              o = this;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                return t = this.nr, n = this.qu, [4, this.persistence.runTransaction("Handle user change", "readonly", function (r) {
                  var i;
                  return o.nr.xo(r).next(function (a) {
                    return i = a, t = o.persistence.Vu(e), n = new jt(o.Bu, t, o.persistence.yu()), t.xo(r);
                  }).next(function (e) {
                    for (var t = [], o = [], a = Ge(), s = 0, u = i; s < u.length; s++) {
                      var c = u[s];
                      t.push(c.batchId);

                      for (var l = 0, h = c.mutations; l < h.length; l++) {
                        var d = h[l];
                        a = a.add(d.key);
                      }
                    }

                    for (var f = 0, p = e; f < p.length; f++) {
                      var m = p[f];
                      o.push(m.batchId);

                      for (var _ = 0, y = m.mutations; _ < y.length; _++) {
                        var v = y[_];
                        a = a.add(v.key);
                      }
                    }

                    return n.cr(r, a).next(function (e) {
                      return {
                        Wu: e,
                        ju: t,
                        Ku: o
                      };
                    });
                  });
                })];

              case 1:
                return r = i.sent(), [2, (this.nr = t, this.qu = n, this.$u.Uu(this.qu), r)];
            }
          });
        });
      }, e.prototype.Gu = function (e) {
        var t,
            n = this,
            r = g.now(),
            i = e.reduce(function (e, t) {
          return e.add(t.key);
        }, Ge());
        return this.persistence.runTransaction("Locally write mutations", "readwrite", function (o) {
          return n.qu.cr(o, i).next(function (i) {
            t = i;

            for (var a = [], s = 0, u = e; s < u.length; s++) {
              var c = u[s],
                  l = c.Pt(t.get(c.key));
              null != l && a.push(new ue(c.key, l, pe(l.proto.mapValue), oe.exists(!0)));
            }

            return n.nr.Do(o, r, a, e);
          });
        }).then(function (e) {
          var n = e.In(t);
          return {
            batchId: e.batchId,
            Wn: n
          };
        });
      }, e.prototype.yo = function (e) {
        var t = this;
        return this.persistence.runTransaction("Acknowledge batch", "readwrite-primary", function (n) {
          var r = e.batch.keys(),
              i = t.Bu.ba({
            Sa: !0
          });
          return t.nr.yo(n, e.batch, e.streamToken).next(function () {
            return t.zu(n, e, i);
          }).next(function () {
            return i.apply(n);
          }).next(function () {
            return t.nr.Wo(n);
          }).next(function () {
            return t.qu.cr(n, r);
          });
        });
      }, e.prototype.Hu = function (e) {
        var t = this;
        return this.persistence.runTransaction("Reject batch", "readwrite-primary", function (n) {
          var r;
          return t.nr.No(n, e).next(function (e) {
            return wt(null !== e), r = e.keys(), t.nr.Bo(n, e);
          }).next(function () {
            return t.nr.Wo(n);
          }).next(function () {
            return t.qu.cr(n, r);
          });
        });
      }, e.prototype.Lo = function () {
        var e = this;
        return this.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", function (t) {
          return e.nr.Lo(t);
        });
      }, e.prototype.vo = function () {
        var e = this;
        return this.persistence.runTransaction("Get last stream token", "readonly", function (t) {
          return e.nr.vo(t);
        });
      }, e.prototype.So = function (e) {
        var t = this;
        return this.persistence.runTransaction("Set last stream token", "readwrite-primary", function (n) {
          return t.nr.So(n, e);
        });
      }, e.prototype.Jo = function () {
        var e = this;
        return this.persistence.runTransaction("Get last remote snapshot version", "readonly", function (t) {
          return e.Ha.Jo(t);
        });
      }, e.prototype.Yu = function (t) {
        var n = this,
            r = t.Ee,
            i = this.Lu;
        return this.persistence.runTransaction("Apply remote event", "readwrite-primary", function (o) {
          var a = n.Bu.ba({
            Sa: !0
          });
          i = n.Lu;
          var s = [];
          t.as.forEach(function (t, a) {
            var u = i.get(a);

            if (u) {
              s.push(n.Ha._a(o, t.Is, a).next(function () {
                return n.Ha.ca(o, t.Ts, a);
              }));
              var c = t.resumeToken;

              if (c.rt() > 0) {
                var l = u.we(c, r).Ie(o.Oa);
                i = i.me(a, l), e.Ju(u, l, t) && s.push(n.Ha.ia(o, l));
              }
            }
          });
          var u = Ve(),
              c = Ge();

          if (t.cs.forEach(function (e, t) {
            c = c.add(e);
          }), s.push(a.getEntries(o, c).next(function (e) {
            t.cs.forEach(function (i, c) {
              var l = e.get(i);
              c instanceof ge && c.version.isEqual(b.min()) ? (a.Hn(i, r), u = u.me(i, c)) : null == l || c.version.S(l.version) > 0 || 0 === c.version.S(l.version) && l.hasPendingWrites ? (a.Gn(c, r), u = u.me(i, c)) : yt("LocalStore", "Ignoring outdated watch update for ", i, ". Current version:", l.version, " Watch version:", c.version), t._s.has(i) && s.push(n.persistence.Ao.ku(o, i));
            });
          })), !r.isEqual(b.min())) {
            var l = n.Ha.Jo(o).next(function (e) {
              return n.Ha.Zo(o, o.Oa, r);
            });
            s.push(l);
          }

          return Ct.Un(s).next(function () {
            return a.apply(o);
          }).next(function () {
            return n.qu._r(o, u);
          });
        }).then(function (e) {
          return n.Lu = i, e;
        });
      }, e.Ju = function (e, t, n) {
        return wt(t.resumeToken.rt() > 0), 0 === e.resumeToken.rt() || t.Ee.D() - e.Ee.D() >= this.Xu || n.Ts.size + n.Es.size + n.Is.size > 0;
      }, e.prototype.Zu = function (e) {
        for (var t = this, n = 0, r = e; n < r.length; n++) {
          var i = r[n],
              o = i.targetId;

          if (this.Mu.pn(i.Ar, o), this.Mu.vn(i.Pr, o), !i.fromCache) {
            var a = this.Lu.get(o),
                s = a.Ee,
                u = a.Re(s);
            this.Lu = this.Lu.me(o, u);
          }
        }

        return this.persistence.runTransaction("notifyLocalViewChanges", "readwrite", function (n) {
          return Ct.forEach(e, function (e) {
            return Ct.forEach(e.Pr, function (e) {
              return t.persistence.Ao.yn(n, e);
            });
          });
        });
      }, e.prototype.tc = function (e) {
        var t = this;
        return this.persistence.runTransaction("Get next mutation batch", "readonly", function (n) {
          return void 0 === e && (e = -1), t.nr.Mo(n, e);
        });
      }, e.prototype.ec = function (e) {
        var t = this;
        return this.persistence.runTransaction("read document", "readonly", function (n) {
          return t.qu.hr(n, e);
        });
      }, e.prototype.sc = function (e) {
        var t = this;
        return this.persistence.runTransaction("Allocate target", "readwrite", function (n) {
          var r;
          return t.Ha.ua(n, e).next(function (i) {
            return i ? (r = i, Ct.resolve(r)) : t.Ha.zo(n).next(function (i) {
              return r = new Re(e, i, 0, n.Oa), t.Ha.ta(n, r).next(function () {
                return r;
              });
            });
          });
        }).then(function (n) {
          return null === t.Lu.get(n.targetId) && (t.Lu = t.Lu.me(n.targetId, n), t.xu.set(e, n.targetId)), n;
        });
      }, e.prototype.ua = function (e, t) {
        var n = this.xu.get(t);
        return void 0 !== n ? Ct.resolve(this.Lu.get(n)) : this.Ha.ua(e, t);
      }, e.prototype.ic = function (e, t) {
        var n = this,
            r = this.Lu.get(e),
            i = t ? "readwrite" : "readwrite-primary";
        return this.persistence.runTransaction("Release target", i, function (i) {
          var o = n.Mu.Sn(e);
          return t ? Ct.resolve() : Ct.forEach(o, function (e) {
            return n.persistence.Ao.yn(i, e);
          }).next(function () {
            n.persistence.Ao.removeTarget(i, r);
          });
        }).then(function () {
          n.Lu = n.Lu.remove(e), n.xu.delete(r.target);
        });
      }, e.prototype.nc = function (e, t) {
        var n = this,
            r = b.min(),
            i = Ge();
        return this.persistence.runTransaction("Execute query", "readonly", function (o) {
          return n.ua(o, e.ee()).next(function (e) {
            if (e) return r = e.lastLimboFreeSnapshotVersion, n.Ha.la(o, e.targetId).next(function (e) {
              i = e;
            });
          }).next(function () {
            return n.$u.dr(o, e, t ? r : b.min(), t ? i : Ge());
          }).next(function (e) {
            return {
              documents: e,
              rc: i
            };
          });
        });
      }, e.prototype.hc = function (e) {
        var t = this;
        return this.persistence.runTransaction("Remote document keys", "readonly", function (n) {
          return t.Ha.la(n, e);
        });
      }, e.prototype.zu = function (e, t, n) {
        var r = this,
            i = t.batch,
            o = i.keys(),
            a = Ct.resolve();
        return o.forEach(function (r) {
          a = a.next(function () {
            return n.Yn(e, r);
          }).next(function (e) {
            var o = e,
                a = t.Rn.get(r);
            wt(null !== a), (!o || o.version.S(a) < 0) && (o = i.at(r, o, t)) && n.Gn(o, t.wn);
          });
        }), a.next(function () {
          return r.nr.Bo(e, i);
        });
      }, e.prototype.Qh = function (e) {
        var t = this;
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", function (n) {
          return e.Jh(n, t.Lu);
        });
      }, e;
    }();

    rr.Xu = 3e8;

    var ir = function (e) {
      function t(t, n, r) {
        var i = this;
        return (i = e.call(this, t, n, r) || this).persistence = t, i.nr = t.Vu(r), i.Bu = t.pu(), i.Ha = t.gu(), i;
      }

      return i.__extends(t, e), t.prototype.start = function () {
        return this.oc();
      }, t.prototype.ac = function (e) {
        var t = this;
        return this.persistence.runTransaction("Lookup mutation documents", "readonly", function (n) {
          return t.nr.$o(n, e).next(function (e) {
            return e ? t.qu.cr(n, e) : Ct.resolve(null);
          });
        });
      }, t.prototype.uc = function (e) {
        this.nr.Uo(e);
      }, t.prototype.ru = function (e) {
        this.persistence.ru(e);
      }, t.prototype.Pu = function () {
        return this.persistence.Pu();
      }, t.prototype.cc = function (e) {
        var t = this,
            n = this.Lu.get(e);
        return n ? Promise.resolve(n.target) : this.persistence.runTransaction("Get target data", "readonly", function (n) {
          return t.Ha.si(n, e).next(function (e) {
            return e ? e.target : null;
          });
        });
      }, t.prototype.Va = function () {
        var e = this;
        return this.persistence.runTransaction("Get new document changes", "readonly", function (t) {
          return e.Bu.Va(t, e.Ou);
        }).then(function (t) {
          var n = t.ga,
              r = t.readTime;
          return e.Ou = r, n;
        });
      }, t.prototype.oc = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          var e,
              t = this;
          return i.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return e = this, [4, this.persistence.runTransaction("Synchronize last document change read time", "readonly", function (e) {
                  return t.Bu.ya(e);
                })];

              case 1:
                return e.Ou = n.sent(), [2];
            }
          });
        });
      }, t;
    }(rr);

    function or(e) {
      return i.__awaiter(this, void 0, void 0, function () {
        return i.__generator(this, function (t) {
          if (e.code !== d.FAILED_PRECONDITION || e.message !== Ft) throw e;
          return yt("LocalStore", "Unexpectedly lost primary lease"), [2];
        });
      });
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function ar(e, t) {
      if (0 !== t.length) throw new f(d.INVALID_ARGUMENT, "Function " + e + "() does not support arguments, but was called with " + Mr(t.length, "argument") + ".");
    }

    function sr(e, t, n) {
      if (t.length !== n) throw new f(d.INVALID_ARGUMENT, "Function " + e + "() requires " + Mr(n, "argument") + ", but was called with " + Mr(t.length, "argument") + ".");
    }

    function ur(e, t, n) {
      if (t.length < n) throw new f(d.INVALID_ARGUMENT, "Function " + e + "() requires at least " + Mr(n, "argument") + ", but was called with " + Mr(t.length, "argument") + ".");
    }

    function cr(e, t, n, r) {
      if (t.length < n || t.length > r) throw new f(d.INVALID_ARGUMENT, "Function " + e + "() requires between " + n + " and " + r + " arguments, but was called with " + Mr(t.length, "argument") + ".");
    }

    function lr(e, t, n, r) {
      mr(e, t, Tr(n) + " argument", r);
    }

    function hr(e, t, n, r) {
      void 0 !== r && lr(e, t, n, r);
    }

    function dr(e, t, n, r) {
      mr(e, t, n + " option", r);
    }

    function fr(e, t, n, r) {
      void 0 !== r && dr(e, t, n, r);
    }

    function pr(e, t, n, r, i) {
      void 0 !== r && function (e, t, n, r, i) {
        for (var o = [], a = 0, s = i; a < s.length; a++) {
          var u = s[a];
          if (u === r) return;
          o.push(yr(u));
        }

        var c = yr(r);
        throw new f(d.INVALID_ARGUMENT, "Invalid value " + c + " provided to function " + e + '() for option "' + n + '". Acceptable values: ' + o.join(", "));
      }(e, 0, n, r, i);
    }

    function mr(e, t, n, r) {
      if (!("object" === t ? _r(r) : "non-empty string" === t ? "string" == typeof r && "" !== r : typeof r === t)) {
        var i = yr(r);
        throw new f(d.INVALID_ARGUMENT, "Function " + e + "() requires its " + n + " to be of type " + t + ", but it was: " + i);
      }
    }

    function _r(e) {
      return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
    }

    function yr(e) {
      if (void 0 === e) return "undefined";
      if (null === e) return "null";
      if ("string" == typeof e) return e.length > 20 && (e = e.substring(0, 20) + "..."), JSON.stringify(e);
      if ("number" == typeof e || "boolean" == typeof e) return "" + e;

      if ("object" == typeof e) {
        if (e instanceof Array) return "an array";

        var t = function (e) {
          if (e.constructor) {
            var t = /function\s+([^\s(]+)\s*\(/.exec(e.constructor.toString());
            if (t && t.length > 1) return t[1];
          }

          return null;
        }(e);

        return t ? "a custom " + t + " object" : "an object";
      }

      return "function" == typeof e ? "a function" : bt();
    }

    function vr(e, t, n) {
      if (void 0 === n) throw new f(d.INVALID_ARGUMENT, "Function " + e + "() requires a valid " + Tr(t) + " argument, but it was undefined.");
    }

    function gr(e, t, n) {
      S(t, function (t, r) {
        if (n.indexOf(t) < 0) throw new f(d.INVALID_ARGUMENT, "Unknown option '" + t + "' passed to function " + e + "(). Available options: " + n.join(", "));
      });
    }

    function br(e, t, n, r) {
      var i = yr(r);
      return new f(d.INVALID_ARGUMENT, "Function " + e + "() requires its " + Tr(n) + " argument to be a " + t + ", but it was: " + i);
    }

    function wr(e, t, n) {
      if (n <= 0) throw new f(d.INVALID_ARGUMENT, 'Function "' + e + '()" requires its ' + Tr(t) + " argument to be a positive number, but it was: " + n + ".");
    }

    function Tr(e) {
      switch (e) {
        case 1:
          return "first";

        case 2:
          return "second";

        case 3:
          return "third";

        default:
          return e + "th";
      }
    }

    function Mr(e, t) {
      return e + " " + t + (1 === e ? "" : "s");
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Er() {
      if ("undefined" == typeof Uint8Array) throw new f(d.UNIMPLEMENTED, "Uint8Arrays are not available in this environment.");
    }

    function kr() {
      if (!ft.nt()._c) throw new f(d.UNIMPLEMENTED, "Blobs are unavailable in Firestore in this environment.");
    }

    var Lr = function () {
      function e(e) {
        kr(), this.lc = e;
      }

      return e.fromBase64String = function (t) {
        sr("Blob.fromBase64String", arguments, 1), lr("Blob.fromBase64String", "string", 1, t), kr();

        try {
          return new e(D.fromBase64String(t));
        } catch (t) {
          throw new f(d.INVALID_ARGUMENT, "Failed to construct Blob from Base64 string: " + t);
        }
      }, e.fromUint8Array = function (t) {
        if (sr("Blob.fromUint8Array", arguments, 1), Er(), !(t instanceof Uint8Array)) throw br("Blob.fromUint8Array", "Uint8Array", 1, t);
        return new e(D.fromUint8Array(t));
      }, e.prototype.toBase64 = function () {
        return sr("Blob.toBase64", arguments, 0), kr(), this.lc.toBase64();
      }, e.prototype.toUint8Array = function () {
        return sr("Blob.toUint8Array", arguments, 0), Er(), this.lc.toUint8Array();
      }, e.prototype.toString = function () {
        return "Blob(base64: " + this.toBase64() + ")";
      }, e.prototype.isEqual = function (e) {
        return this.lc.isEqual(e.lc);
      }, e;
    }(),
        Sr = function () {
      function e() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        !function (e, t, n, r) {
          if (!(t instanceof Array) || t.length < 1) throw new f(d.INVALID_ARGUMENT, "Function FieldPath() requires its fieldNames argument to be an array with at least " + Mr(1, "element") + ".");
        }(0, e);

        for (var n = 0; n < e.length; ++n) {
          if (lr("FieldPath", "string", n, e[n]), 0 === e[n].length) throw new f(d.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        }

        this.dc = new E(e);
      }

      return e.documentId = function () {
        return e.fc;
      }, e.prototype.isEqual = function (t) {
        if (!(t instanceof e)) throw br("isEqual", "FieldPath", 1, t);
        return this.dc.isEqual(t.dc);
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    Sr.fc = new Sr(E.J().j());

    var Nr = new RegExp("[~\\*/\\[\\]]"),
        Dr = function Dr(e) {
      this.Tc = e;
    },
        Ir = function (e) {
      function t() {
        return e.call(this, "FieldValue.delete") || this;
      }

      return i.__extends(t, e), t.prototype.Di = function (e) {
        if (2 !== e.Ec) throw 1 === e.Ec ? e.Ic("FieldValue.delete() can only appear at the top level of your update data") : e.Ic("FieldValue.delete() cannot be used with set() unless you pass {merge:true}");
        return e.Vt.push(e.path), null;
      }, t.prototype.isEqual = function (e) {
        return e instanceof t;
      }, t;
    }(Dr),
        Rr = function (e) {
      function t() {
        return e.call(this, "FieldValue.serverTimestamp") || this;
      }

      return i.__extends(t, e), t.prototype.Di = function (e) {
        return new re(e.path, X.instance);
      }, t.prototype.isEqual = function (e) {
        return e instanceof t;
      }, t;
    }(Dr),
        xr = function (e) {
      function t(t) {
        var n = this;
        return (n = e.call(this, "FieldValue.arrayUnion") || this).wc = t, n;
      }

      return i.__extends(t, e), t.prototype.Di = function (e) {
        var t = e.Rc({
          Ec: 3,
          methodName: this.Tc
        }),
            n = this.wc.map(function (e, n) {
          return Wr(e, t.mc(n));
        }),
            r = new K(n);
        return new re(e.path, r);
      }, t.prototype.isEqual = function (e) {
        return this === e;
      }, t;
    }(Dr),
        Yr = function (e) {
      function t(t) {
        var n = this;
        return (n = e.call(this, "FieldValue.arrayRemove") || this).wc = t, n;
      }

      return i.__extends(t, e), t.prototype.Di = function (e) {
        var t = e.Rc({
          Ec: 3,
          methodName: this.Tc
        }),
            n = this.wc.map(function (e, n) {
          return Wr(e, t.mc(n));
        }),
            r = new $(n);
        return new re(e.path, r);
      }, t.prototype.isEqual = function (e) {
        return this === e;
      }, t;
    }(Dr),
        Cr = function (e) {
      function t(t) {
        var n = this;
        return (n = e.call(this, "FieldValue.increment") || this).Ac = t, n;
      }

      return i.__extends(t, e), t.prototype.Di = function (e) {
        e.Rc({
          methodName: this.Tc
        });
        var t = Wr(this.Ac, e),
            n = new ee(e.serializer, t);
        return new re(e.path, n);
      }, t.prototype.isEqual = function (e) {
        return this === e;
      }, t;
    }(Dr),
        Or = function () {
      function e(e, t) {
        if (sr("GeoPoint", arguments, 2), lr("GeoPoint", "number", 1, e), lr("GeoPoint", "number", 2, t), !isFinite(e) || e < -90 || e > 90) throw new f(d.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new f(d.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this.Pc = e, this.Vc = t;
      }

      return Object.defineProperty(e.prototype, "latitude", {
        get: function get() {
          return this.Pc;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "longitude", {
        get: function get() {
          return this.Vc;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.isEqual = function (e) {
        return this.Pc === e.Pc && this.Vc === e.Vc;
      }, e.prototype.p = function (e) {
        return Et(this.Pc, e.Pc) || Et(this.Vc, e.Vc);
      }, e;
    }(),
        Fr = /^__.*__$/,
        Ar = function () {
      function e(e, t, n) {
        this.data = e, this.Vt = t, this.fieldTransforms = n;
      }

      return e.prototype.gc = function (e, t) {
        var n = [];
        return null !== this.Vt ? n.push(new ue(e, this.data, this.Vt, t)) : n.push(new se(e, this.data, t)), this.fieldTransforms.length > 0 && n.push(new ce(e, this.fieldTransforms)), n;
      }, e;
    }(),
        jr = function () {
      function e(e, t, n) {
        this.data = e, this.Vt = t, this.fieldTransforms = n;
      }

      return e.prototype.gc = function (e, t) {
        var n = [new ue(e, this.data, this.Vt, t)];
        return this.fieldTransforms.length > 0 && n.push(new ce(e, this.fieldTransforms)), n;
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Ur(e) {
      switch (e) {
        case 0:
        case 2:
        case 1:
          return !0;

        case 3:
        case 4:
          return !1;

        default:
          throw bt();
      }
    }

    var Pr = function () {
      function e(e, t, n, r, i) {
        this.settings = e, this.ii = t, this.serializer = n, void 0 === r && this.pc(), this.fieldTransforms = r || [], this.Vt = i || [];
      }

      return Object.defineProperty(e.prototype, "path", {
        get: function get() {
          return this.settings.path;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "Ec", {
        get: function get() {
          return this.settings.Ec;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.Rc = function (t) {
        return new e(Object.assign(Object.assign({}, this.settings), t), this.ii, this.serializer, this.fieldTransforms, this.Vt);
      }, e.prototype.yc = function (e) {
        var t = null == this.path ? null : this.path.child(e),
            n = this.Rc({
          path: t,
          bc: !1
        });
        return n.vc(e), n;
      }, e.prototype.Sc = function (e) {
        var t = null == this.path ? null : this.path.child(e),
            n = this.Rc({
          path: t,
          bc: !1
        });
        return n.pc(), n;
      }, e.prototype.mc = function (e) {
        return this.Rc({
          path: null,
          bc: !0
        });
      }, e.prototype.Ic = function (e) {
        var t = null === this.path || this.path.B() ? "" : " (found in field " + this.path.toString() + ")";
        return new f(d.INVALID_ARGUMENT, "Function " + this.settings.methodName + "() called with invalid data. " + e + t);
      }, e.prototype.contains = function (e) {
        return void 0 !== this.Vt.find(function (t) {
          return e.q(t);
        }) || void 0 !== this.fieldTransforms.find(function (t) {
          return e.q(t.field);
        });
      }, e.prototype.pc = function () {
        if (null !== this.path) for (var e = 0; e < this.path.length; e++) {
          this.vc(this.path.get(e));
        }
      }, e.prototype.vc = function (e) {
        if (0 === e.length) throw this.Ic("Document fields must not be empty");
        if (Ur(this.Ec) && Fr.test(e)) throw this.Ic('Document fields cannot begin and end with "__"');
      }, e;
    }(),
        Vr = function () {
      function e(e, t) {
        this.ii = e, this.serializer = t || ft.nt().Dc(e);
      }

      return e.prototype.Cc = function (e, t) {
        var n = this.Fc(0, e);
        zr("Data must be an object, but it was:", n, t);
        var r = Hr(t, n);
        return new Ar(new de(r), null, n.fieldTransforms);
      }, e.prototype.Nc = function (e, t, n) {
        var r = this.Fc(2, e);
        zr("Data must be an object, but it was:", r, t);
        var i,
            o,
            a = Hr(t, r);

        if (n) {
          for (var s = [], u = 0, c = n; u < c.length; u++) {
            var l = c[u],
                h = void 0;
            if (l instanceof Sr) h = l.dc;else {
              if ("string" != typeof l) throw bt();
              h = Qr(e, l);
            }
            if (!r.contains(h)) throw new f(d.INVALID_ARGUMENT, "Field '" + h + "' is specified in your field mask but missing from your input data.");
            Gr(s, h) || s.push(h);
          }

          i = new ne(s), o = r.fieldTransforms.filter(function (e) {
            return i.dt(e.field);
          });
        } else i = new ne(r.Vt), o = r.fieldTransforms;

        return new Ar(new de(a), i, o);
      }, e.prototype.kc = function (e, t) {
        var n = this.Fc(1, e);
        zr("Data must be an object, but it was:", n, t);
        var r = [],
            i = new fe();
        S(t, function (t, o) {
          var a = Qr(e, t),
              s = n.Sc(a);
          if (o instanceof Ir) r.push(a);else {
            var u = Wr(o, s);
            null != u && (r.push(a), i.set(a, u));
          }
        });
        var o = new ne(r);
        return new jr(i.yt(), o, n.fieldTransforms);
      }, e.prototype.$c = function (e, t, n, r) {
        var i = this.Fc(1, e),
            o = [Zr(e, t)],
            a = [n];
        if (r.length % 2 != 0) throw new f(d.INVALID_ARGUMENT, "Function " + e + "() needs to be called with an even number of arguments that alternate between field names and values.");

        for (var s = 0; s < r.length; s += 2) {
          o.push(Zr(e, r[s])), a.push(r[s + 1]);
        }

        for (var u = [], c = new fe(), l = o.length - 1; l >= 0; --l) {
          if (!Gr(u, o[l])) {
            var h = o[l],
                p = a[l],
                m = i.Sc(h);
            if (p instanceof Ir) u.push(h);else {
              var _ = Wr(p, m);

              null != _ && (u.push(h), c.set(h, _));
            }
          }
        }

        var y = new ne(u);
        return new jr(c.yt(), y, i.fieldTransforms);
      }, e.prototype.Fc = function (e, t) {
        return new Pr({
          Ec: e,
          methodName: t,
          path: E.G,
          bc: !1
        }, this.ii, this.serializer);
      }, e.prototype.Mc = function (e, t, n) {
        return void 0 === n && (n = !1), Wr(t, this.Fc(n ? 4 : 3, e));
      }, e;
    }();

    function Wr(e, t) {
      if (Br(e)) return zr("Unsupported field value:", t, e), Hr(e, t);
      if (e instanceof Dr) return function (e, t) {
        if (!Ur(t.Ec)) throw t.Ic(e.Tc + "() can only be used with update() and set()");
        if (null === t.path) throw t.Ic(e.Tc + "() is not currently supported inside arrays");
        var n = e.Di(t);
        n && t.fieldTransforms.push(n);
      }(e, t), null;

      if (t.path && t.Vt.push(t.path), e instanceof Array) {
        if (t.settings.bc && 4 !== t.Ec) throw t.Ic("Nested arrays are not supported");
        return function (e, t) {
          for (var n = [], r = 0, i = 0, o = e; i < o.length; i++) {
            var a = Wr(o[i], t.mc(r));
            null == a && (a = {
              nullValue: "NULL_VALUE"
            }), n.push(a), r++;
          }

          return {
            arrayValue: {
              values: n
            }
          };
        }(e, t);
      }

      return function (e, t) {
        if (null === e) return {
          nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return t.serializer.ai(e);
        if ("boolean" == typeof e) return {
          booleanValue: e
        };
        if ("string" == typeof e) return {
          stringValue: e
        };

        if (e instanceof Date) {
          var n = g.fromDate(e);
          return {
            timestampValue: t.serializer.C(n)
          };
        }

        if (e instanceof g) {
          var r = new g(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
          return {
            timestampValue: t.serializer.C(r)
          };
        }

        if (e instanceof Or) return {
          geoPointValue: {
            latitude: e.latitude,
            longitude: e.longitude
          }
        };
        if (e instanceof Lr) return {
          bytesValue: t.serializer.ui(e)
        };

        if (e instanceof Vi) {
          var i = t.ii,
              o = e.firestore.Lc;
          if (!o.isEqual(i)) throw t.Ic("Document reference is for database " + o.projectId + "/" + o.database + " but should be for database " + i.projectId + "/" + i.database);
          return {
            referenceValue: t.serializer._i(e.xc.path, e.firestore.Lc)
          };
        }

        throw t.Ic("Unsupported field value: " + yr(e));
      }(e, t);
    }

    function Hr(e, t) {
      var n = {};
      return N(e) ? t.path && t.path.length > 0 && t.Vt.push(t.path) : S(e, function (e, r) {
        var i = Wr(r, t.yc(e));
        null != i && (n[e] = i);
      }), {
        mapValue: {
          fields: n
        }
      };
    }

    function Br(e) {
      return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof g || e instanceof Or || e instanceof Lr || e instanceof Vi || e instanceof Dr);
    }

    function zr(e, t, n) {
      if (!Br(n) || !_r(n)) {
        var r = yr(n);
        throw "an object" === r ? t.Ic(e + " a custom object") : t.Ic(e + " " + r);
      }
    }

    function Zr(e, t) {
      if (t instanceof Sr) return t.dc;
      if ("string" == typeof t) return Qr(e, t);
      throw new f(d.INVALID_ARGUMENT, "Function " + e + "() called with invalid data. Field path arguments must be of type string or FieldPath.");
    }

    function Qr(e, t) {
      try {
        return function (e) {
          if (e.search(Nr) >= 0) throw new f(d.INVALID_ARGUMENT, "Invalid field path (" + e + "). Paths must not contain '~', '*', '/', '[', or ']'");

          try {
            return new (Sr.bind.apply(Sr, i.__spreadArrays([void 0], e.split("."))))();
          } catch (t) {
            throw new f(d.INVALID_ARGUMENT, "Invalid field path (" + e + "). Paths must not be empty, begin with '.', end with '.', or contain '..'");
          }
        }(t).dc;
      } catch (t) {
        var n = (r = t) instanceof Error ? r.message : r.toString();
        throw new f(d.INVALID_ARGUMENT, "Function " + e + "() called with invalid data. " + n);
      }

      var r;
    }

    function Gr(e, t) {
      return e.some(function (e) {
        return e.isEqual(t);
      });
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var qr = function () {
      function e(e, t, n, r, i, o) {
        this.Sr = e, this.Oc = n, this.Bc = r, this.qc = i, this.listener = o, this.state = 0, this.Uc = 0, this.Qc = null, this.stream = null, this.ih = new Wt(e, t);
      }

      return e.prototype.Wc = function () {
        return 1 === this.state || 2 === this.state || 4 === this.state;
      }, e.prototype.jc = function () {
        return 2 === this.state;
      }, e.prototype.start = function () {
        3 !== this.state ? this.auth() : this.Kc();
      }, e.prototype.stop = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (e) {
            switch (e.label) {
              case 0:
                return this.Wc() ? [4, this.close(0)] : [3, 2];

              case 1:
                e.sent(), e.label = 2;

              case 2:
                return [2];
            }
          });
        });
      }, e.prototype.Gc = function () {
        this.state = 0, this.ih.reset();
      }, e.prototype.zc = function () {
        var e = this;
        this.jc() && null === this.Qc && (this.Qc = this.Sr.Br(this.Oc, 6e4, function () {
          return e.Hc();
        }));
      }, e.prototype.Yc = function (e) {
        this.Jc(), this.stream.send(e);
      }, e.prototype.Hc = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (e) {
            return this.jc() ? [2, this.close(0)] : [2];
          });
        });
      }, e.prototype.Jc = function () {
        this.Qc && (this.Qc.cancel(), this.Qc = null);
      }, e.prototype.close = function (e, t) {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return this.Jc(), this.ih.cancel(), this.Uc++, 3 !== e ? this.ih.reset() : t && t.code === d.RESOURCE_EXHAUSTED ? (vt(t.toString()), vt("Using maximum backoff delay to prevent overloading the backend."), this.ih.Lr()) : t && t.code === d.UNAUTHENTICATED && this.qc._(), null !== this.stream && (this.Xc(), this.stream.close(), this.stream = null), this.state = e, [4, this.listener.Zc(t)];

              case 1:
                return n.sent(), [2];
            }
          });
        });
      }, e.prototype.Xc = function () {}, e.prototype.auth = function () {
        var e = this;
        this.state = 1;
        var t = this.t_(this.Uc),
            n = this.Uc;
        this.qc.getToken().then(function (t) {
          e.Uc === n && e.e_(t);
        }, function (n) {
          t(function () {
            var t = new f(d.UNKNOWN, "Fetching auth token failed: " + n.message);
            return e.s_(t);
          });
        });
      }, e.prototype.e_ = function (e) {
        var t = this,
            n = this.t_(this.Uc);
        this.stream = this.i_(e), this.stream.n_(function () {
          n(function () {
            return t.state = 2, t.listener.n_();
          });
        }), this.stream.Zc(function (e) {
          n(function () {
            return t.s_(e);
          });
        }), this.stream.onMessage(function (e) {
          n(function () {
            return t.onMessage(e);
          });
        });
      }, e.prototype.Kc = function () {
        var e = this;
        this.state = 4, this.ih.xr(function () {
          return i.__awaiter(e, void 0, void 0, function () {
            return i.__generator(this, function (e) {
              return this.state = 0, this.start(), [2];
            });
          });
        });
      }, e.prototype.s_ = function (e) {
        return yt("PersistentStream", "close with error: " + e), this.stream = null, this.close(3, e);
      }, e.prototype.t_ = function (e) {
        var t = this;
        return function (n) {
          t.Sr.Hr(function () {
            return t.Uc === e ? n() : (yt("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve());
          });
        };
      }, e;
    }(),
        Jr = function (e) {
      function t(t, n, r, i, o) {
        var a = this;
        return (a = e.call(this, t, "listen_stream_connection_backoff", "listen_stream_idle", n, r, o) || this).serializer = i, a;
      }

      return i.__extends(t, e), t.prototype.i_ = function (e) {
        return this.Bc.r_("Listen", e);
      }, t.prototype.onMessage = function (e) {
        this.ih.reset();
        var t = this.serializer.pi(e),
            n = this.serializer.bi(e);
        return this.listener.h_(t, n);
      }, t.prototype.o_ = function (e) {
        var t = {};
        t.database = this.serializer.wi, t.addTarget = this.serializer.ee(e);
        var n = this.serializer.zi(e);
        n && (t.labels = n), this.Yc(t);
      }, t.prototype.a_ = function (e) {
        var t = {};
        t.database = this.serializer.wi, t.removeTarget = e, this.Yc(t);
      }, t;
    }(qr),
        Xr = function (e) {
      function t(t, n, r, i, o) {
        var a = this;
        return (a = e.call(this, t, "write_stream_connection_backoff", "write_stream_idle", n, r, o) || this).serializer = i, a.u_ = !1, a.lastStreamToken = D.ht, a;
      }

      return i.__extends(t, e), Object.defineProperty(t.prototype, "c_", {
        get: function get() {
          return this.u_;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.start = function () {
        this.u_ = !1, e.prototype.start.call(this);
      }, t.prototype.Xc = function () {
        this.u_ && this.__([]);
      }, t.prototype.i_ = function (e) {
        return this.Bc.r_("Write", e);
      }, t.prototype.onMessage = function (e) {
        if (wt(!!e.streamToken), this.lastStreamToken = this.serializer.ci(e.streamToken), this.u_) {
          this.ih.reset();
          var t = this.serializer.Li(e.writeResults, e.commitTime),
              n = this.serializer.fromVersion(e.commitTime);
          return this.listener.l_(n, t);
        }

        return wt(!e.writeResults || 0 === e.writeResults.length), this.u_ = !0, this.listener.d_();
      }, t.prototype.f_ = function () {
        var e = {};
        e.database = this.serializer.wi, this.Yc(e);
      }, t.prototype.__ = function (e) {
        var t = this,
            n = {
          streamToken: this.serializer.ui(this.lastStreamToken),
          writes: e.map(function (e) {
            return t.serializer.vi(e);
          })
        };
        this.Yc(n);
      }, t;
    }(qr),
        Kr = function (e) {
      function t(t, n, r) {
        var i = this;
        return (i = e.call(this) || this).Bc = t, i.credentials = n, i.serializer = r, i;
      }

      return i.__extends(t, e), t.prototype.E_ = function (e, t) {
        var n = this;
        return this.credentials.getToken().then(function (r) {
          return n.Bc.E_(e, t, r);
        }).catch(function (e) {
          throw e.code === d.UNAUTHENTICATED && n.credentials._(), e;
        });
      }, t.prototype.I_ = function (e, t) {
        var n = this;
        return this.credentials.getToken().then(function (r) {
          return n.Bc.I_(e, t, r);
        }).catch(function (e) {
          throw e.code === d.UNAUTHENTICATED && n.credentials._(), e;
        });
      }, t;
    }(function () {
      this.T_ = void 0;
    }),
        $r = function () {
      function e(e) {
        this.w_ = e, this.R_ = Ze(), this.mutations = [], this.m_ = !1, this.A_ = null, this.P_ = new Set();
      }

      return e.prototype.V_ = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t,
              n = this;
          return i.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                if (this.g_(), this.mutations.length > 0) throw new f(d.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
                return [4, function (e, t) {
                  return i.__awaiter(this, void 0, void 0, function () {
                    var n, r, o, a, s;
                    return i.__generator(this, function (i) {
                      switch (i.label) {
                        case 0:
                          return n = Tt(e), r = {
                            database: n.serializer.wi,
                            documents: t.map(function (e) {
                              return n.serializer.fi(e);
                            })
                          }, [4, n.I_("BatchGetDocuments", r)];

                        case 1:
                          return o = i.sent(), a = new Map(), o.forEach(function (e) {
                            var t = n.serializer.gi(e);
                            a.set(t.key.toString(), t);
                          }), s = [], [2, (t.forEach(function (e) {
                            var t = a.get(e.toString());
                            wt(!!t), s.push(t);
                          }), s)];
                      }
                    });
                  });
                }(this.w_, e)];

              case 1:
                return [2, ((t = r.sent()).forEach(function (e) {
                  e instanceof ge || e instanceof ve ? n.p_(e) : bt();
                }), t)];
            }
          });
        });
      }, e.prototype.set = function (e, t) {
        this.write(t.gc(e, this.Rt(e))), this.P_.add(e);
      }, e.prototype.update = function (e, t) {
        try {
          this.write(t.gc(e, this.y_(e)));
        } catch (e) {
          this.A_ = e;
        }

        this.P_.add(e);
      }, e.prototype.delete = function (e) {
        this.write([new le(e, this.Rt(e))]), this.P_.add(e);
      }, e.prototype.commit = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          var e,
              t = this;
          return i.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                if (this.g_(), this.A_) throw this.A_;
                return e = this.R_, this.mutations.forEach(function (t) {
                  e = e.remove(t.key);
                }), e.forEach(function (e, n) {
                  t.mutations.push(new he(e, t.Rt(e)));
                }), [4, function (e, t) {
                  return i.__awaiter(this, void 0, void 0, function () {
                    var n, r, o;
                    return i.__generator(this, function (i) {
                      switch (i.label) {
                        case 0:
                          return n = Tt(e), r = {
                            database: n.serializer.wi,
                            writes: t.map(function (e) {
                              return n.serializer.vi(e);
                            })
                          }, [4, n.E_("Commit", r)];

                        case 1:
                          return o = i.sent(), [2, n.serializer.Li(o.writeResults, o.commitTime)];
                      }
                    });
                  });
                }(this.w_, this.mutations)];

              case 1:
                return n.sent(), this.m_ = !0, [2];
            }
          });
        });
      }, e.prototype.p_ = function (e) {
        var t;
        if (e instanceof ve) t = e.version;else {
          if (!(e instanceof ge)) throw bt();
          t = b.min();
        }
        var n = this.R_.get(e.key);

        if (null !== n) {
          if (!t.isEqual(n)) throw new f(d.ABORTED, "Document version changed between two reads.");
        } else this.R_ = this.R_.me(e.key, t);
      }, e.prototype.Rt = function (e) {
        var t = this.R_.get(e);
        return !this.P_.has(e) && t ? oe.updateTime(t) : oe.ft();
      }, e.prototype.y_ = function (e) {
        var t = this.R_.get(e);

        if (!this.P_.has(e) && t) {
          if (t.isEqual(b.min())) throw new f(d.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
          return oe.updateTime(t);
        }

        return oe.exists(!0);
      }, e.prototype.write = function (e) {
        this.g_(), this.mutations = this.mutations.concat(e);
      }, e.prototype.g_ = function () {}, e;
    }(),
        ei = function () {
      function e(e, t) {
        this.qr = e, this.b_ = t, this.state = "Unknown", this.v_ = 0, this.S_ = null, this.D_ = !0;
      }

      return e.prototype.C_ = function () {
        var e = this;
        0 === this.v_ && (this.F_("Unknown"), this.S_ = this.qr.Br("online_state_timeout", 1e4, function () {
          return e.S_ = null, e.N_("Backend didn't respond within 10 seconds."), e.F_("Offline"), Promise.resolve();
        }));
      }, e.prototype.k_ = function (e) {
        "Online" === this.state ? this.F_("Unknown") : (this.v_++, this.v_ >= 1 && (this.M_(), this.N_("Connection failed 1 times. Most recent error: " + e.toString()), this.F_("Offline")));
      }, e.prototype.set = function (e) {
        this.M_(), this.v_ = 0, "Online" === e && (this.D_ = !1), this.F_(e);
      }, e.prototype.F_ = function (e) {
        e !== this.state && (this.state = e, this.b_(e));
      }, e.prototype.N_ = function (e) {
        var t = "Could not reach Cloud Firestore backend. " + e + "\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.";
        this.D_ ? (vt(t), this.D_ = !1) : yt("OnlineStateTracker", t);
      }, e.prototype.M_ = function () {
        null !== this.S_ && (this.S_.cancel(), this.S_ = null);
      }, e;
    }(),
        ti = function () {
      function e(e, t, n, r, o) {
        var a = this;
        this.L_ = e, this.w_ = t, this.qr = n, this.x_ = [], this.O_ = new Map(), this.B_ = null, this.networkEnabled = !1, this.isPrimary = !1, this.q_ = !1, this.U_ = o, this.U_.Q_(function (e) {
          n.Hr(function () {
            return i.__awaiter(a, void 0, void 0, function () {
              return i.__generator(this, function (e) {
                switch (e.label) {
                  case 0:
                    return this.W_() ? (yt("RemoteStore", "Restarting streams for network reachability change."), [4, this.j_()]) : [3, 2];

                  case 1:
                    e.sent(), e.label = 2;

                  case 2:
                    return [2];
                }
              });
            });
          });
        }), this.K_ = new ei(n, r), this.G_ = function (e, t, n) {
          var r = Tt(e);
          return new Jr(t, r.Bc, r.credentials, r.serializer, n);
        }(this.w_, n, {
          n_: this.z_.bind(this),
          Zc: this.H_.bind(this),
          h_: this.Y_.bind(this)
        }), this.J_ = function (e, t, n) {
          var r = Tt(e);
          return new Xr(t, r.Bc, r.credentials, r.serializer, n);
        }(this.w_, n, {
          n_: this.X_.bind(this),
          Zc: this.Z_.bind(this),
          d_: this.tl.bind(this),
          l_: this.l_.bind(this)
        });
      }

      return e.prototype.start = function () {
        return this.enableNetwork();
      }, e.prototype.enableNetwork = function () {
        return this.networkEnabled = !0, this.el();
      }, e.prototype.el = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          var e;
          return i.__generator(this, function (t) {
            switch (t.label) {
              case 0:
                return this.W_() ? (e = this.J_, [4, this.L_.vo()]) : [3, 3];

              case 1:
                return e.lastStreamToken = t.sent(), this.sl() ? this.il() : this.K_.set("Unknown"), [4, this.nl()];

              case 2:
                t.sent(), t.label = 3;

              case 3:
                return [2];
            }
          });
        });
      }, e.prototype.disableNetwork = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (e) {
            switch (e.label) {
              case 0:
                return this.networkEnabled = !1, [4, this.rl()];

              case 1:
                return e.sent(), this.K_.set("Offline"), [2];
            }
          });
        });
      }, e.prototype.rl = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.J_.stop()];

              case 1:
                return e.sent(), [4, this.G_.stop()];

              case 2:
                return e.sent(), this.x_.length > 0 && (yt("RemoteStore", "Stopping write stream with " + this.x_.length + " pending writes"), this.x_ = []), this.hl(), [2];
            }
          });
        });
      }, e.prototype.Iu = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (e) {
            switch (e.label) {
              case 0:
                return yt("RemoteStore", "RemoteStore shutting down."), this.networkEnabled = !1, [4, this.rl()];

              case 1:
                return e.sent(), this.U_.Iu(), this.K_.set("Unknown"), [2];
            }
          });
        });
      }, e.prototype.listen = function (e) {
        this.O_.has(e.targetId) || (this.O_.set(e.targetId, e), this.sl() ? this.il() : this.G_.jc() && this.ol(e));
      }, e.prototype.al = function (e) {
        this.O_.delete(e), this.G_.jc() && this.ul(e), 0 === this.O_.size && (this.G_.jc() ? this.G_.zc() : this.W_() && this.K_.set("Unknown"));
      }, e.prototype.si = function (e) {
        return this.O_.get(e) || null;
      }, e.prototype.ei = function (e) {
        return this.cl.ei(e);
      }, e.prototype.ol = function (e) {
        this.B_.Ns(e.targetId), this.G_.o_(e);
      }, e.prototype.ul = function (e) {
        this.B_.Ns(e), this.G_.a_(e);
      }, e.prototype.il = function () {
        this.B_ = new at(this), this.G_.start(), this.K_.C_();
      }, e.prototype.sl = function () {
        return this.W_() && !this.G_.Wc() && this.O_.size > 0;
      }, e.prototype.W_ = function () {
        return !this.q_ && this.isPrimary && this.networkEnabled;
      }, e.prototype.hl = function () {
        this.B_ = null;
      }, e.prototype.z_ = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          var e = this;
          return i.__generator(this, function (t) {
            return this.O_.forEach(function (t, n) {
              e.ol(t);
            }), [2];
          });
        });
      }, e.prototype.H_ = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (t) {
            return this.hl(), this.sl() ? (this.K_.k_(e), this.il()) : this.K_.set("Unknown"), [2];
          });
        });
      }, e.prototype.Y_ = function (e, t) {
        return i.__awaiter(this, void 0, void 0, function () {
          var n, r, o;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                if (this.K_.set("Online"), !(e instanceof it && 2 === e.state && e.cause)) return [3, 6];
                i.label = 1;

              case 1:
                return i.trys.push([1, 3,, 5]), [4, this._l(e)];

              case 2:
                return i.sent(), [3, 5];

              case 3:
                return n = i.sent(), yt("RemoteStore", "Failed to remove targets %s: %s ", e.targetIds.join(","), n), [4, this.ll(n)];

              case 4:
                return i.sent(), [3, 5];

              case 5:
                return [3, 13];

              case 6:
                if (e instanceof nt ? this.B_.qs(e) : e instanceof rt ? this.B_.Hs(e) : this.B_.Ws(e), t.isEqual(b.min())) return [3, 13];
                i.label = 7;

              case 7:
                return i.trys.push([7, 11,, 13]), [4, this.L_.Jo()];

              case 8:
                return r = i.sent(), t.S(r) >= 0 ? [4, this.dl(t)] : [3, 10];

              case 9:
                i.sent(), i.label = 10;

              case 10:
                return [3, 13];

              case 11:
                return yt("RemoteStore", "Failed to raise snapshot:", o = i.sent()), [4, this.ll(o)];

              case 12:
                return i.sent(), [3, 13];

              case 13:
                return [2];
            }
          });
        });
      }, e.prototype.ll = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t = this;
          return i.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                if ("IndexedDbTransactionError" !== e.name) throw e;
                return this.q_ = !0, [4, this.rl()];

              case 1:
                return n.sent(), this.K_.set("Offline"), this.qr.dh(function () {
                  return i.__awaiter(t, void 0, void 0, function () {
                    return i.__generator(this, function (e) {
                      switch (e.label) {
                        case 0:
                          return yt("RemoteStore", "Retrying IndexedDB access"), [4, this.L_.Jo()];

                        case 1:
                          return e.sent(), this.q_ = !1, [4, this.el()];

                        case 2:
                          return e.sent(), [2];
                      }
                    });
                  });
                }), [2];
            }
          });
        });
      }, e.prototype.dl = function (e) {
        var t = this,
            n = this.B_.Xs(e);
        return n.as.forEach(function (n, r) {
          if (n.resumeToken.rt() > 0) {
            var i = t.O_.get(r);
            i && t.O_.set(r, i.we(n.resumeToken, e));
          }
        }), n.us.forEach(function (e) {
          var n = t.O_.get(e);

          if (n) {
            t.O_.set(e, n.we(D.ht, n.Ee)), t.ul(e);
            var r = new Re(n.target, e, 1, n.sequenceNumber);
            t.ol(r);
          }
        }), this.cl.Yu(n);
      }, e.prototype._l = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t, n, r, o;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                t = e.cause, n = 0, r = e.targetIds, i.label = 1;

              case 1:
                return n < r.length ? (o = r[n], this.O_.has(o) ? [4, this.cl.fl(o, t)] : [3, 3]) : [3, 5];

              case 2:
                i.sent(), this.O_.delete(o), this.B_.removeTarget(o), i.label = 3;

              case 3:
                i.label = 4;

              case 4:
                return n++, [3, 1];

              case 5:
                return [2];
            }
          });
        });
      }, e.prototype.nl = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          var e, t;
          return i.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return this.Tl() ? (e = this.x_.length > 0 ? this.x_[this.x_.length - 1].batchId : -1, [4, this.L_.tc(e)]) : [3, 5];

              case 1:
                return null !== (t = n.sent()) ? [3, 2] : (0 === this.x_.length && this.J_.zc(), [3, 4]);

              case 2:
                return this.El(t), [4, this.nl()];

              case 3:
                n.sent(), n.label = 4;

              case 4:
                n.label = 5;

              case 5:
                return this.Il() && this.wl(), [2];
            }
          });
        });
      }, e.prototype.Tl = function () {
        return this.W_() && this.x_.length < 10;
      }, e.prototype.Rl = function () {
        return this.x_.length;
      }, e.prototype.El = function (e) {
        this.x_.push(e), this.J_.jc() && this.J_.c_ && this.J_.__(e.mutations);
      }, e.prototype.Il = function () {
        return this.W_() && !this.J_.Wc() && this.x_.length > 0;
      }, e.prototype.wl = function () {
        this.J_.start();
      }, e.prototype.X_ = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (e) {
            return this.J_.f_(), [2];
          });
        });
      }, e.prototype.tl = function () {
        var e = this;
        return this.L_.So(this.J_.lastStreamToken).then(function () {
          for (var t = 0, n = e.x_; t < n.length; t++) {
            var r = n[t];

            e.J_.__(r.mutations);
          }
        }).catch(or);
      }, e.prototype.l_ = function (e, t) {
        var n = this,
            r = this.x_.shift(),
            i = Rt.from(r, e, t, this.J_.lastStreamToken);
        return this.cl.ml(i).then(function () {
          return n.nl();
        });
      }, e.prototype.Z_ = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (t) {
            switch (t.label) {
              case 0:
                return e && this.x_.length > 0 ? this.J_.c_ ? [4, this.Al(e)] : [3, 2] : [3, 5];

              case 1:
                return t.sent(), [3, 4];

              case 2:
                return [4, this.Pl(e)];

              case 3:
                t.sent(), t.label = 4;

              case 4:
                this.Il() && this.wl(), t.label = 5;

              case 5:
                return [2];
            }
          });
        });
      }, e.prototype.Pl = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (t) {
            return Ye(e.code) ? [2, (yt("RemoteStore", "RemoteStore error before completed handshake; resetting stream token: ", this.J_.lastStreamToken), this.J_.lastStreamToken = D.ht, this.L_.So(D.ht).catch(or))] : [2];
          });
        });
      }, e.prototype.Al = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t,
              n,
              r = this;
          return i.__generator(this, function (i) {
            return Ye(n = e.code) && n !== d.ABORTED ? (t = this.x_.shift(), [2, (this.J_.Gc(), this.cl.Vl(t.batchId, e).then(function () {
              return r.nl();
            }))]) : [2];
          });
        });
      }, e.prototype.gl = function () {
        return new $r(this.w_);
      }, e.prototype.j_ = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (e) {
            switch (e.label) {
              case 0:
                return this.networkEnabled = !1, [4, this.rl()];

              case 1:
                return e.sent(), this.K_.set("Unknown"), [4, this.enableNetwork()];

              case 2:
                return e.sent(), [2];
            }
          });
        });
      }, e.prototype.pl = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (e) {
            switch (e.label) {
              case 0:
                return this.W_() ? (yt("RemoteStore", "RemoteStore restarting streams for new credential"), [4, this.j_()]) : [3, 2];

              case 1:
                e.sent(), e.label = 2;

              case 2:
                return [2];
            }
          });
        });
      }, e.prototype.yl = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (t) {
            switch (t.label) {
              case 0:
                return this.isPrimary = e, e && this.networkEnabled ? [4, this.enableNetwork()] : [3, 2];

              case 1:
                return t.sent(), [3, 5];

              case 2:
                return e ? [3, 4] : [4, this.rl()];

              case 3:
                t.sent(), this.K_.set("Unknown"), t.label = 4;

              case 4:
                t.label = 5;

              case 5:
                return [2];
            }
          });
        });
      }, e;
    }();
    /**
     * @license
     * Copyright 2019 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function ni(e, t) {
      return "firestore_clients_" + e + "_" + t;
    }

    function ri(e, t, n) {
      var r = "firestore_mutations_" + e + "_" + n;
      return t.t() && (r += "_" + t.uid), r;
    }

    function ii(e, t) {
      return "firestore_targets_" + e + "_" + t;
    }

    var oi = function () {
      function e(e, t, n, r) {
        this.user = e, this.batchId = t, this.state = n, this.error = r;
      }

      return e.bl = function (t, n, r) {
        var i = JSON.parse(r),
            o = "object" == typeof i && -1 !== ["pending", "acknowledged", "rejected"].indexOf(i.state) && (void 0 === i.error || "object" == typeof i.error),
            a = void 0;
        return o && i.error && (o = "string" == typeof i.error.message && "string" == typeof i.error.code) && (a = new f(i.error.code, i.error.message)), o ? new e(t, n, i.state, a) : (vt("SharedClientState", "Failed to parse mutation state for ID '" + n + "': " + r), null);
      }, e.prototype.vl = function () {
        var e = {
          state: this.state,
          updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
          code: this.error.code,
          message: this.error.message
        }), JSON.stringify(e);
      }, e;
    }(),
        ai = function () {
      function e(e, t, n) {
        this.targetId = e, this.state = t, this.error = n;
      }

      return e.bl = function (t, n) {
        var r = JSON.parse(n),
            i = "object" == typeof r && -1 !== ["not-current", "current", "rejected"].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error),
            o = void 0;
        return i && r.error && (i = "string" == typeof r.error.message && "string" == typeof r.error.code) && (o = new f(r.error.code, r.error.message)), i ? new e(t, r.state, o) : (vt("SharedClientState", "Failed to parse target state for ID '" + t + "': " + n), null);
      }, e.prototype.vl = function () {
        var e = {
          state: this.state,
          updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
          code: this.error.code,
          message: this.error.message
        }), JSON.stringify(e);
      }, e;
    }(),
        si = function () {
      function e(e, t) {
        this.clientId = e, this.activeTargetIds = t;
      }

      return e.bl = function (t, n) {
        for (var r = JSON.parse(n), i = "object" == typeof r && r.activeTargetIds instanceof Array, o = Je(), a = 0; i && a < r.activeTargetIds.length; ++a) {
          i = x(r.activeTargetIds[a]), o = o.add(r.activeTargetIds[a]);
        }

        return i ? new e(t, o) : (vt("SharedClientState", "Failed to parse client data for instance '" + t + "': " + n), null);
      }, e;
    }(),
        ui = function () {
      function e(e, t) {
        this.clientId = e, this.onlineState = t;
      }

      return e.bl = function (t) {
        var n = JSON.parse(t);
        return "object" == typeof n && -1 !== ["Unknown", "Online", "Offline"].indexOf(n.onlineState) && "string" == typeof n.clientId ? new e(n.clientId, n.onlineState) : (vt("SharedClientState", "Failed to parse online state: " + t), null);
      }, e;
    }(),
        ci = function () {
      function e() {
        this.activeTargetIds = Je();
      }

      return e.prototype.Sl = function (e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
      }, e.prototype.Dl = function (e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
      }, e.prototype.vl = function () {
        var e = {
          activeTargetIds: this.activeTargetIds.W(),
          updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
      }, e;
    }(),
        li = function () {
      function e(t, n, r, i, o) {
        if (this.Sr = t, this.platform = n, this.persistenceKey = r, this.Cl = i, this.cl = null, this.b_ = null, this.gr = null, this.Fl = this.Nl.bind(this), this.kl = new Oe(Et), this.Uh = !1, this.$l = [], !e.so(this.platform)) throw new f(d.UNIMPLEMENTED, "LocalStorage is not available on this platform.");
        var a = r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.platform.window.localStorage, this.currentUser = o, this.Ml = ni(this.persistenceKey, this.Cl), this.Ll = function (e) {
          return "firestore_sequence_number_" + e;
        }(this.persistenceKey), this.kl = this.kl.me(this.Cl, new ci()), this.xl = new RegExp("^firestore_clients_" + a + "_([^_]*)$"), this.Ol = new RegExp("^firestore_mutations_" + a + "_(\\d+)(?:_(.*))?$"), this.Bl = new RegExp("^firestore_targets_" + a + "_(\\d+)$"), this.ql = function (e) {
          return "firestore_online_state_" + e;
        }(this.persistenceKey), this.platform.window.addEventListener("storage", this.Fl);
      }

      return e.so = function (e) {
        return !(!e.window || null == e.window.localStorage);
      }, e.prototype.start = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          var e,
              t,
              n,
              r,
              o,
              a,
              s,
              u,
              c,
              l,
              h,
              d = this;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, this.cl.Pu()];

              case 1:
                for (e = i.sent(), t = 0, n = e; t < n.length; t++) {
                  (r = n[t]) !== this.Cl && (o = this.getItem(ni(this.persistenceKey, r))) && (a = si.bl(r, o)) && (this.kl = this.kl.me(a.clientId, a));
                }

                for (this.Ul(), (s = this.storage.getItem(this.ql)) && (u = this.Ql(s)) && this.Wl(u), c = 0, l = this.$l; c < l.length; c++) {
                  h = l[c], this.Nl(h);
                }

                return this.$l = [], this.platform.window.addEventListener("unload", function () {
                  return d.Iu();
                }), this.Uh = !0, [2];
            }
          });
        });
      }, e.prototype.br = function (e) {
        this.setItem(this.Ll, JSON.stringify(e));
      }, e.prototype.jl = function () {
        return this.Kl(this.kl);
      }, e.prototype.Gl = function (e) {
        var t = !1;
        return this.kl.forEach(function (n, r) {
          r.activeTargetIds.has(e) && (t = !0);
        }), t;
      }, e.prototype.zl = function (e) {
        this.Hl(e, "pending");
      }, e.prototype.Yl = function (e, t, n) {
        this.Hl(e, t, n), this.Jl(e);
      }, e.prototype.Xl = function (e) {
        var t = "not-current";

        if (this.Gl(e)) {
          var n = this.storage.getItem(ii(this.persistenceKey, e));

          if (n) {
            var r = ai.bl(e, n);
            r && (t = r.state);
          }
        }

        return this.Zl.Sl(e), this.Ul(), t;
      }, e.prototype.td = function (e) {
        this.Zl.Dl(e), this.Ul();
      }, e.prototype.ed = function (e) {
        return this.Zl.activeTargetIds.has(e);
      }, e.prototype.sd = function (e) {
        this.removeItem(ii(this.persistenceKey, e));
      }, e.prototype.nd = function (e, t, n) {
        this.rd(e, t, n);
      }, e.prototype.Qu = function (e, t, n) {
        var r = this;
        t.forEach(function (e) {
          r.Jl(e);
        }), this.currentUser = e, n.forEach(function (e) {
          r.zl(e);
        });
      }, e.prototype.hd = function (e) {
        this.od(e);
      }, e.prototype.Iu = function () {
        this.Uh && (this.platform.window.removeEventListener("storage", this.Fl), this.removeItem(this.Ml), this.Uh = !1);
      }, e.prototype.getItem = function (e) {
        var t = this.storage.getItem(e);
        return yt("SharedClientState", "READ", e, t), t;
      }, e.prototype.setItem = function (e, t) {
        yt("SharedClientState", "SET", e, t), this.storage.setItem(e, t);
      }, e.prototype.removeItem = function (e) {
        yt("SharedClientState", "REMOVE", e), this.storage.removeItem(e);
      }, e.prototype.Nl = function (e) {
        var t = this;

        if (e.storageArea === this.storage) {
          if (yt("SharedClientState", "EVENT", e.key, e.newValue), e.key === this.Ml) return void vt("Received WebStorage notification for local change. Another client might have garbage-collected our state");
          this.Sr.dh(function () {
            return i.__awaiter(t, void 0, void 0, function () {
              var t, n, r, o, a, s;
              return i.__generator(this, function (i) {
                if (this.Uh) {
                  if (null !== e.key) if (this.xl.test(e.key)) {
                    if (null == e.newValue) return t = this.ad(e.key), [2, this.ud(t, null)];
                    if (n = this._d(e.key, e.newValue)) return [2, this.ud(n.clientId, n)];
                  } else if (this.Ol.test(e.key)) {
                    if (null !== e.newValue && (r = this.ld(e.key, e.newValue))) return [2, this.dd(r)];
                  } else if (this.Bl.test(e.key)) {
                    if (null !== e.newValue && (o = this.fd(e.key, e.newValue))) return [2, this.Td(o)];
                  } else if (e.key === this.ql) {
                    if (null !== e.newValue && (a = this.Ql(e.newValue))) return [2, this.Wl(a)];
                  } else e.key === this.Ll && (s = function (e) {
                    var t = Pt.vr;
                    if (null != e) try {
                      var n = JSON.parse(e);
                      wt("number" == typeof n), t = n;
                    } catch (e) {
                      vt("SharedClientState", "Failed to read sequence number from WebStorage", e);
                    }
                    return t;
                  }(e.newValue)) !== Pt.vr && this.gr(s);
                } else this.$l.push(e);

                return [2];
              });
            });
          });
        }
      }, Object.defineProperty(e.prototype, "Zl", {
        get: function get() {
          return this.kl.get(this.Cl);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.Ul = function () {
        this.setItem(this.Ml, this.Zl.vl());
      }, e.prototype.Hl = function (e, t, n) {
        var r = new oi(this.currentUser, e, t, n),
            i = ri(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.vl());
      }, e.prototype.Jl = function (e) {
        var t = ri(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
      }, e.prototype.od = function (e) {
        var t = {
          clientId: this.Cl,
          onlineState: e
        };
        this.storage.setItem(this.ql, JSON.stringify(t));
      }, e.prototype.rd = function (e, t, n) {
        var r = ii(this.persistenceKey, e),
            i = new ai(e, t, n);
        this.setItem(r, i.vl());
      }, e.prototype.ad = function (e) {
        var t = this.xl.exec(e);
        return t ? t[1] : null;
      }, e.prototype._d = function (e, t) {
        var n = this.ad(e);
        return si.bl(n, t);
      }, e.prototype.ld = function (e, t) {
        var n = this.Ol.exec(e),
            r = Number(n[1]),
            i = void 0 !== n[2] ? n[2] : null;
        return oi.bl(new h(i), r, t);
      }, e.prototype.fd = function (e, t) {
        var n = this.Bl.exec(e),
            r = Number(n[1]);
        return ai.bl(r, t);
      }, e.prototype.Ql = function (e) {
        return ui.bl(e);
      }, e.prototype.dd = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          return i.__generator(this, function (t) {
            return e.user.uid === this.currentUser.uid ? [2, this.cl.Ed(e.batchId, e.state, e.error)] : (yt("SharedClientState", "Ignoring mutation for non-active user " + e.user.uid), [2]);
          });
        });
      }, e.prototype.Td = function (e) {
        return this.cl.Id(e.targetId, e.state, e.error);
      }, e.prototype.ud = function (e, t) {
        var n = this,
            r = t ? this.kl.me(e, t) : this.kl.remove(e),
            i = this.Kl(this.kl),
            o = this.Kl(r),
            a = [],
            s = [];
        return o.forEach(function (e) {
          i.has(e) || a.push(e);
        }), i.forEach(function (e) {
          o.has(e) || s.push(e);
        }), this.cl.wd(a, s).then(function () {
          n.kl = r;
        });
      }, e.prototype.Wl = function (e) {
        this.kl.get(e.clientId) && this.b_(e.onlineState);
      }, e.prototype.Kl = function (e) {
        var t = Je();
        return e.forEach(function (e, n) {
          t = t.He(n.activeTargetIds);
        }), t;
      }, e;
    }(),
        hi = function () {
      function e() {
        this.Rd = new ci(), this.md = {}, this.cl = null, this.b_ = null, this.gr = null;
      }

      return e.prototype.zl = function (e) {}, e.prototype.Yl = function (e, t, n) {}, e.prototype.Xl = function (e) {
        return this.Rd.Sl(e), this.md[e] || "not-current";
      }, e.prototype.nd = function (e, t, n) {
        this.md[e] = t;
      }, e.prototype.td = function (e) {
        this.Rd.Dl(e);
      }, e.prototype.ed = function (e) {
        return this.Rd.activeTargetIds.has(e);
      }, e.prototype.sd = function (e) {
        delete this.md[e];
      }, e.prototype.jl = function () {
        return this.Rd.activeTargetIds;
      }, e.prototype.Gl = function (e) {
        return this.Rd.activeTargetIds.has(e);
      }, e.prototype.start = function () {
        return this.Rd = new ci(), Promise.resolve();
      }, e.prototype.Qu = function (e, t, n) {}, e.prototype.hd = function (e) {}, e.prototype.Iu = function () {}, e.prototype.br = function (e) {}, e;
    }(),
        di = function di(e) {
      this.key = e;
    },
        fi = function fi(e) {
      this.key = e;
    },
        pi = function () {
      function e(e, t) {
        this.query = e, this.Ad = t, this.Pd = null, this.fs = !1, this.Vd = Ge(), this.ns = Ge(), this.gd = new Xe(e.se.bind(e));
      }

      return Object.defineProperty(e.prototype, "pd", {
        get: function get() {
          return this.Ad;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.yd = function (e, t) {
        var n = this,
            r = t ? t.bd : new Ke(),
            i = t ? t.gd : this.gd,
            o = t ? t.ns : this.ns,
            a = i,
            s = !1,
            u = this.query.oe() && i.size === this.query.limit ? i.last() : null,
            c = this.query.ae() && i.size === this.query.limit ? i.first() : null;
        if (e.pe(function (e, t) {
          var l = i.get(e),
              h = t instanceof ve ? t : null;
          h && (h = n.query.matches(h) ? h : null);
          var d = !!l && n.ns.has(l.key),
              f = !!h && (h.At || n.ns.has(h.key) && h.hasCommittedMutations),
              p = !1;
          l && h ? l.data().isEqual(h.data()) ? d !== f && (r.track({
            type: 3,
            doc: h
          }), p = !0) : n.vd(l, h) || (r.track({
            type: 2,
            doc: h
          }), p = !0, (u && n.query.se(h, u) > 0 || c && n.query.se(h, c) < 0) && (s = !0)) : !l && h ? (r.track({
            type: 0,
            doc: h
          }), p = !0) : l && !h && (r.track({
            type: 1,
            doc: l
          }), p = !0, (u || c) && (s = !0)), p && (h ? (a = a.add(h), o = f ? o.add(e) : o.delete(e)) : (a = a.delete(e), o = o.delete(e)));
        }), this.query.oe() || this.query.ae()) for (; a.size > this.query.limit;) {
          var l = this.query.oe() ? a.last() : a.first();
          a = a.delete(l.key), o = o.delete(l.key), r.track({
            type: 1,
            doc: l
          });
        }
        return {
          gd: a,
          bd: r,
          Sd: s,
          ns: o
        };
      }, e.prototype.vd = function (e, t) {
        return e.At && t.hasCommittedMutations && !t.At;
      }, e.prototype.Zn = function (e, t, n) {
        var r = this,
            i = this.gd;
        this.gd = e.gd, this.ns = e.ns;
        var o = e.bd.es();
        o.sort(function (e, t) {
          return function (e, t) {
            var n = function n(e) {
              switch (e) {
                case 0:
                  return 1;

                case 2:
                case 3:
                  return 2;

                case 1:
                  return 0;

                default:
                  return bt();
              }
            };

            return n(e) - n(t);
          }(e.type, t.type) || r.query.se(e.doc, t.doc);
        }), this.Dd(n);
        var a = t ? this.Cd() : [],
            s = 0 === this.Vd.size && this.fs ? 1 : 0,
            u = s !== this.Pd;
        return this.Pd = s, 0 !== o.length || u ? {
          snapshot: new $e(this.query, e.gd, i, o, e.ns, 0 === s, u, !1),
          Fd: a
        } : {
          Fd: a
        };
      }, e.prototype.Nd = function (e) {
        return this.fs && "Offline" === e ? (this.fs = !1, this.Zn({
          gd: this.gd,
          bd: new Ke(),
          ns: this.ns,
          Sd: !1
        }, !1)) : {
          Fd: []
        };
      }, e.prototype.kd = function (e) {
        return !this.Ad.has(e) && !!this.gd.has(e) && !this.gd.get(e).At;
      }, e.prototype.Dd = function (e) {
        var t = this;
        e && (e.Ts.forEach(function (e) {
          return t.Ad = t.Ad.add(e);
        }), e.Es.forEach(function (e) {}), e.Is.forEach(function (e) {
          return t.Ad = t.Ad.delete(e);
        }), this.fs = e.fs);
      }, e.prototype.Cd = function () {
        var e = this;
        if (!this.fs) return [];
        var t = this.Vd;
        this.Vd = Ge(), this.gd.forEach(function (t) {
          e.kd(t.key) && (e.Vd = e.Vd.add(t.key));
        });
        var n = [];
        return t.forEach(function (t) {
          e.Vd.has(t) || n.push(new fi(t));
        }), this.Vd.forEach(function (e) {
          t.has(e) || n.push(new di(e));
        }), n;
      }, e.prototype.$d = function (e) {
        this.Ad = e.rc, this.Vd = Ge();
        var t = this.yd(e.documents);
        return this.Zn(t, !0);
      }, e.prototype.Md = function () {
        return $e.os(this.query, this.gd, this.ns, 0 === this.Pd);
      }, e;
    }(),
        mi = function () {
      function e(e, t, n, r) {
        this.qr = e, this.Ld = t, this.updateFunction = n, this.Wr = r, this.xd = 5, this.ih = new Wt(this.qr, "transaction_retry");
      }

      return e.prototype.Od = function () {
        this.Bd();
      }, e.prototype.Bd = function () {
        var e = this;
        this.ih.xr(function () {
          return i.__awaiter(e, void 0, void 0, function () {
            var e,
                t,
                n = this;
            return i.__generator(this, function (r) {
              return e = this.Ld.gl(), (t = this.qd(e)) && t.then(function (t) {
                n.qr.Hr(function () {
                  return e.commit().then(function () {
                    n.Wr.resolve(t);
                  }).catch(function (e) {
                    n.Ud(e);
                  });
                });
              }).catch(function (e) {
                n.Ud(e);
              }), [2];
            });
          });
        });
      }, e.prototype.qd = function (e) {
        try {
          var t = this.updateFunction(e);
          return !I(t) && t.catch && t.then ? t : (this.Wr.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
          return this.Wr.reject(e), null;
        }
      }, e.prototype.Ud = function (e) {
        var t = this;
        this.xd > 0 && this.Qd(e) ? (this.xd -= 1, this.qr.Hr(function () {
          return t.Bd(), Promise.resolve();
        })) : this.Wr.reject(e);
      }, e.prototype.Qd = function (e) {
        if ("FirebaseError" === e.name) {
          var t = e.code;
          return "aborted" === t || "failed-precondition" === t || !Ye(t);
        }

        return !1;
      }, e;
    }(),
        _i = function _i(e, t, n) {
      this.query = e, this.targetId = t, this.view = n;
    },
        yi = function yi(e) {
      this.key = e, this.Wd = !1;
    },
        vi = function () {
      function e(e, t, n, r, i) {
        this.L_ = e, this.Ld = t, this.jd = n, this.currentUser = r, this.Kd = i, this.Gd = null, this.zd = new Dt(function (e) {
          return e.canonicalId();
        }), this.Hd = new Map(), this.Yd = [], this.Jd = new Oe(k.N), this.Xd = new Map(), this.Zd = new xt(), this.tf = {}, this.ef = new Map(), this.sf = _n.Go(), this.onlineState = "Unknown";
      }

      return Object.defineProperty(e.prototype, "if", {
        get: function get() {
          return !0;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.subscribe = function (e) {
        this.Gd = e;
      }, e.prototype.listen = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                return this.nf("listen()"), (r = this.zd.get(e)) ? (t = r.targetId, this.jd.Xl(t), n = r.view.Md(), [3, 4]) : [3, 1];

              case 1:
                return [4, this.L_.sc(e.ee())];

              case 2:
                return o = i.sent(), a = this.jd.Xl(o.targetId), t = o.targetId, [4, this.rf(e, t, "current" === a)];

              case 3:
                n = i.sent(), this.if && this.Ld.listen(o), i.label = 4;

              case 4:
                return [2, n];
            }
          });
        });
      }, e.prototype.rf = function (e, t, n) {
        return i.__awaiter(this, void 0, void 0, function () {
          var r, o, a, s, u, c;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, this.L_.nc(e, !0)];

              case 1:
                return r = i.sent(), o = new pi(e, r.rc), a = o.yd(r.documents), s = tt.ds(t, n && "Offline" !== this.onlineState), u = o.Zn(a, this.if, s), this.hf(t, u.Fd), c = new _i(e, t, o), [2, (this.zd.set(e, c), this.Hd.has(t) ? this.Hd.get(t).push(e) : this.Hd.set(t, [e]), u.snapshot)];
            }
          });
        });
      }, e.prototype.al = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t,
              n,
              r = this;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                return this.nf("unlisten()"), t = this.zd.get(e), (n = this.Hd.get(t.targetId)).length > 1 ? [2, (this.Hd.set(t.targetId, n.filter(function (t) {
                  return !t.isEqual(e);
                })), void this.zd.delete(e))] : this.if ? (this.jd.td(t.targetId), this.jd.Gl(t.targetId) ? [3, 2] : [4, this.L_.ic(t.targetId, !1).then(function () {
                  r.jd.sd(t.targetId), r.Ld.al(t.targetId), r.af(t.targetId);
                }).catch(or)]) : [3, 3];

              case 1:
                i.sent(), i.label = 2;

              case 2:
                return [3, 5];

              case 3:
                return this.af(t.targetId), [4, this.L_.ic(t.targetId, !0)];

              case 4:
                i.sent(), i.label = 5;

              case 5:
                return [2];
            }
          });
        });
      }, e.prototype.write = function (e, t) {
        return i.__awaiter(this, void 0, void 0, function () {
          var n, r;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                this.nf("write()"), i.label = 1;

              case 1:
                return i.trys.push([1, 3,, 4]), [4, this.L_.Gu(e)];

              case 2:
                return n = i.sent(), [3, 4];

              case 3:
                if ("IndexedDbTransactionError" === (r = i.sent()).name) return [2, (vt("SyncEngine", "Dropping write that cannot be persisted: " + r), void t.reject(new f(d.UNAVAILABLE, "Failed to persist write: " + r)))];
                throw r;

              case 4:
                return this.jd.zl(n.batchId), this.uf(n.batchId, t), [4, this.cf(n.Wn)];

              case 5:
                return i.sent(), [4, this.Ld.nl()];

              case 6:
                return i.sent(), [2];
            }
          });
        });
      }, e.prototype.runTransaction = function (e, t, n) {
        new mi(e, this.Ld, t, n).Od();
      }, e.prototype.Yu = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t,
              n = this;
          return i.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                this.nf("applyRemoteEvent()"), r.label = 1;

              case 1:
                return r.trys.push([1, 4,, 6]), [4, this.L_.Yu(e)];

              case 2:
                return t = r.sent(), e.as.forEach(function (e, t) {
                  var r = n.Xd.get(t);
                  r && (wt(e.Ts.size + e.Es.size + e.Is.size <= 1), e.Ts.size > 0 ? r.Wd = !0 : e.Es.size > 0 ? wt(r.Wd) : e.Is.size > 0 && (wt(r.Wd), r.Wd = !1));
                }), [4, this.cf(t, e)];

              case 3:
                return r.sent(), [3, 6];

              case 4:
                return [4, or(r.sent())];

              case 5:
                return r.sent(), [3, 6];

              case 6:
                return [2];
            }
          });
        });
      }, e.prototype.Nd = function (e, t) {
        this.nf("applyOnlineStateChange()");
        var n = [];
        this.zd.forEach(function (t, r) {
          var i = r.view.Nd(e);
          i.snapshot && n.push(i.snapshot);
        }), this.Gd._f(e), this.Gd.h_(n), this.onlineState = e;
      }, e.prototype.fl = function (e, t) {
        return i.__awaiter(this, void 0, void 0, function () {
          var n,
              r,
              o,
              a,
              s,
              u = this;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                return this.nf("rejectListens()"), this.jd.nd(e, "rejected", t), n = this.Xd.get(e), (r = n && n.key) ? (this.Jd = this.Jd.remove(r), this.Xd.delete(e), this.lf(), o = (o = new Oe(k.N)).me(r, new ge(r, b.min())), a = Ge().add(r), s = new et(b.min(), new Map(), new je(Et), o, a), [2, this.Yu(s)]) : [4, this.L_.ic(e, !1).then(function () {
                  return u.af(e, t);
                }).catch(or)];

              case 1:
                return i.sent(), [2];
            }
          });
        });
      }, e.prototype.ml = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t, n;
          return i.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                this.nf("applySuccessfulWrite()"), t = e.batch.batchId, this.df(t, null), this.ff(t), r.label = 1;

              case 1:
                return r.trys.push([1, 4,, 6]), [4, this.L_.yo(e)];

              case 2:
                return n = r.sent(), this.jd.Yl(t, "acknowledged"), [4, this.cf(n)];

              case 3:
                return r.sent(), [3, 6];

              case 4:
                return [4, or(r.sent())];

              case 5:
                return r.sent(), [3, 6];

              case 6:
                return [2];
            }
          });
        });
      }, e.prototype.Vl = function (e, t) {
        return i.__awaiter(this, void 0, void 0, function () {
          var n;
          return i.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                this.nf("rejectFailedWrite()"), this.df(e, t), this.ff(e), r.label = 1;

              case 1:
                return r.trys.push([1, 4,, 6]), [4, this.L_.Hu(e)];

              case 2:
                return n = r.sent(), this.jd.Yl(e, "rejected", t), [4, this.cf(n)];

              case 3:
                return r.sent(), [3, 6];

              case 4:
                return [4, or(r.sent())];

              case 5:
                return r.sent(), [3, 6];

              case 6:
                return [2];
            }
          });
        });
      }, e.prototype.Tf = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t, n;
          return i.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return this.Ld.W_() || yt("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled."), [4, this.L_.Lo()];

              case 1:
                return -1 === (t = r.sent()) ? [2, void e.resolve()] : ((n = this.ef.get(t) || []).push(e), this.ef.set(t, n), [2]);
            }
          });
        });
      }, e.prototype.ff = function (e) {
        (this.ef.get(e) || []).forEach(function (e) {
          e.resolve();
        }), this.ef.delete(e);
      }, e.prototype.Ef = function (e) {
        this.ef.forEach(function (t) {
          t.forEach(function (t) {
            t.reject(new f(d.CANCELLED, e));
          });
        }), this.ef.clear();
      }, e.prototype.uf = function (e, t) {
        var n = this.tf[this.currentUser.s()];
        n || (n = new Oe(Et)), n = n.me(e, t), this.tf[this.currentUser.s()] = n;
      }, e.prototype.df = function (e, t) {
        var n = this.tf[this.currentUser.s()];

        if (n) {
          var r = n.get(e);
          r && (t ? r.reject(t) : r.resolve(), n = n.remove(e)), this.tf[this.currentUser.s()] = n;
        }
      }, e.prototype.af = function (e, t) {
        var n = this;
        void 0 === t && (t = null), this.jd.td(e);

        for (var r = 0, i = this.Hd.get(e); r < i.length; r++) {
          var o = i[r];
          this.zd.delete(o), t && this.Gd.If(o, t);
        }

        if (this.Hd.delete(e), this.if) {
          var a = this.Zd.Cn(e);
          this.Zd.Sn(e), a.forEach(function (e) {
            n.Zd.Fn(e) || n.wf(e);
          });
        }
      }, e.prototype.wf = function (e) {
        var t = this.Jd.get(e);
        null !== t && (this.Ld.al(t), this.Jd = this.Jd.remove(e), this.Xd.delete(t), this.lf());
      }, e.prototype.hf = function (e, t) {
        for (var n = 0, r = t; n < r.length; n++) {
          var i = r[n];
          i instanceof di ? (this.Zd.gn(i.key, e), this.Rf(i)) : i instanceof fi ? (yt("SyncEngine", "Document no longer in limbo: " + i.key), this.Zd.yn(i.key, e), this.Zd.Fn(i.key) || this.wf(i.key)) : bt();
        }
      }, e.prototype.Rf = function (e) {
        var t = e.key;
        this.Jd.get(t) || (yt("SyncEngine", "New document in limbo: " + t), this.Yd.push(t), this.lf());
      }, e.prototype.lf = function () {
        for (; this.Yd.length > 0 && this.Jd.size < this.Kd;) {
          var e = this.Yd.shift(),
              t = this.sf.next();
          this.Xd.set(t, new yi(e)), this.Jd = this.Jd.me(e, t), this.Ld.listen(new Re(Te.Wt(e.path).ee(), t, 2, Pt.vr));
        }
      }, e.prototype.mf = function () {
        return this.Jd;
      }, e.prototype.Af = function () {
        return this.Yd;
      }, e.prototype.cf = function (e, t) {
        return i.__awaiter(this, void 0, void 0, function () {
          var n,
              r,
              o,
              a = this;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                return n = [], r = [], o = [], this.zd.forEach(function (i, s) {
                  o.push(Promise.resolve().then(function () {
                    var t = s.view.yd(e);
                    return t.Sd ? a.L_.nc(s.query, !1).then(function (e) {
                      var n = e.documents;
                      return s.view.yd(n, t);
                    }) : t;
                  }).then(function (e) {
                    var i = t && t.as.get(s.targetId),
                        o = s.view.Zn(e, a.if, i);

                    if (a.hf(s.targetId, o.Fd), o.snapshot) {
                      a.if && a.jd.nd(s.targetId, o.snapshot.fromCache ? "not-current" : "current"), n.push(o.snapshot);
                      var u = Ut.Vr(s.targetId, o.snapshot);
                      r.push(u);
                    }
                  }));
                }), [4, Promise.all(o)];

              case 1:
                return i.sent(), this.Gd.h_(n), [4, this.L_.Zu(r)];

              case 2:
                return i.sent(), [2];
            }
          });
        });
      }, e.prototype.nf = function (e) {}, e.prototype.pl = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t, n;
          return i.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return t = !this.currentUser.isEqual(e), this.currentUser = e, t ? (this.Ef("'waitForPendingWrites' promise is rejected due to a user change."), [4, this.L_.Qu(e)]) : [3, 3];

              case 1:
                return n = r.sent(), this.jd.Qu(e, n.ju, n.Ku), [4, this.cf(n.Wu)];

              case 2:
                r.sent(), r.label = 3;

              case 3:
                return [4, this.Ld.pl()];

              case 4:
                return r.sent(), [2];
            }
          });
        });
      }, e.prototype.enableNetwork = function () {
        return this.Ld.enableNetwork();
      }, e.prototype.disableNetwork = function () {
        return this.Ld.disableNetwork();
      }, e.prototype.ei = function (e) {
        var t = this.Xd.get(e);
        if (t && t.Wd) return Ge().add(t.key);
        var n = Ge(),
            r = this.Hd.get(e);
        if (!r) return n;

        for (var i = 0, o = r; i < o.length; i++) {
          var a = o[i],
              s = this.zd.get(a);
          n = n.He(s.view.pd);
        }

        return n;
      }, e;
    }(),
        gi = function (e) {
      function t(t, n, r, i, o) {
        var a = this;
        return (a = e.call(this, t, n, r, i, o) || this).L_ = t, a.isPrimary = void 0, a;
      }

      return i.__extends(t, e), Object.defineProperty(t.prototype, "if", {
        get: function get() {
          return !0 === this.isPrimary;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.enableNetwork = function () {
        return this.L_.ru(!0), e.prototype.enableNetwork.call(this);
      }, t.prototype.disableNetwork = function () {
        return this.L_.ru(!1), e.prototype.disableNetwork.call(this);
      }, t.prototype.Pf = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t, n;
          return i.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.L_.nc(e.query, !0)];

              case 1:
                return t = r.sent(), n = e.view.$d(t), [2, (this.isPrimary && this.hf(e.targetId, n.Fd), n)];
            }
          });
        });
      }, t.prototype.Nd = function (t, n) {
        this.if && 0 === n && (e.prototype.Nd.call(this, t, n), this.jd.hd(t)), this.if || 1 !== n || e.prototype.Nd.call(this, t, n);
      }, t.prototype.Ed = function (e, t, n) {
        return i.__awaiter(this, void 0, void 0, function () {
          var r;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                return this.nf("applyBatchState()"), [4, this.L_.ac(e)];

              case 1:
                return null === (r = i.sent()) ? [3, 6] : "pending" !== t ? [3, 3] : [4, this.Ld.nl()];

              case 2:
                return i.sent(), [3, 4];

              case 3:
                "acknowledged" === t || "rejected" === t ? (this.df(e, n || null), this.L_.uc(e)) : bt(), i.label = 4;

              case 4:
                return [4, this.cf(r)];

              case 5:
                return i.sent(), [3, 7];

              case 6:
                yt("SyncEngine", "Cannot apply mutation batch with id: " + e), i.label = 7;

              case 7:
                return [2];
            }
          });
        });
      }, t.prototype.yl = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t,
              n,
              r,
              o,
              a,
              s,
              u,
              c = this;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                return !0 !== e || !0 === this.isPrimary ? [3, 3] : (this.isPrimary = !0, [4, this.Ld.yl(!0)]);

              case 1:
                return i.sent(), t = this.jd.jl(), [4, this.Vf(t.W())];

              case 2:
                for (n = i.sent(), r = 0, o = n; r < o.length; r++) {
                  a = o[r], this.Ld.listen(a);
                }

                return [3, 7];

              case 3:
                return !1 !== e || !1 === this.isPrimary ? [3, 7] : (this.isPrimary = !1, s = [], u = Promise.resolve(), this.Hd.forEach(function (e, t) {
                  c.jd.ed(t) ? s.push(t) : u = u.then(function () {
                    return c.af(t), c.L_.ic(t, !0);
                  }), c.Ld.al(t);
                }), [4, u]);

              case 4:
                return i.sent(), [4, this.Vf(s)];

              case 5:
                return i.sent(), this.gf(), [4, this.Ld.yl(!1)];

              case 6:
                i.sent(), i.label = 7;

              case 7:
                return [2];
            }
          });
        });
      }, t.prototype.gf = function () {
        var e = this;
        this.Xd.forEach(function (t, n) {
          e.Ld.al(n);
        }), this.Zd.Dn(), this.Xd = new Map(), this.Jd = new Oe(k.N);
      }, t.prototype.Vf = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t, n, r, o, a, s, u, c, l, h, d, f, p;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                t = [], n = [], r = 0, o = e, i.label = 1;

              case 1:
                return r < o.length ? (a = o[r], s = void 0, (u = this.Hd.get(a)) && 0 !== u.length ? [4, this.L_.ic(a, !0)] : [3, 8]) : [3, 14];

              case 2:
                return i.sent(), [4, this.L_.sc(u[0].ee())];

              case 3:
                s = i.sent(), c = 0, l = u, i.label = 4;

              case 4:
                return c < l.length ? (h = l[c], d = this.zd.get(h), [4, this.Pf(d)]) : [3, 7];

              case 5:
                (f = i.sent()).snapshot && n.push(f.snapshot), i.label = 6;

              case 6:
                return c++, [3, 4];

              case 7:
                return [3, 12];

              case 8:
                return [4, this.L_.cc(a)];

              case 9:
                return p = i.sent(), [4, this.L_.sc(p)];

              case 10:
                return s = i.sent(), [4, this.rf(this.pf(p), a, !1)];

              case 11:
                i.sent(), i.label = 12;

              case 12:
                t.push(s), i.label = 13;

              case 13:
                return r++, [3, 1];

              case 14:
                return [2, (this.Gd.h_(n), t)];
            }
          });
        });
      }, t.prototype.pf = function (e) {
        return new Te(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F", e.startAt, e.endAt);
      }, t.prototype.Pu = function () {
        return this.L_.Pu();
      }, t.prototype.Id = function (e, t, n) {
        return i.__awaiter(this, void 0, void 0, function () {
          var r, o;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                return this.isPrimary ? (yt("SyncEngine", "Ignoring unexpected query state notification."), [3, 8]) : [3, 1];

              case 1:
                if (!this.Hd.has(e)) return [3, 8];

                switch (t) {
                  case "current":
                  case "not-current":
                    return [3, 2];

                  case "rejected":
                    return [3, 5];
                }

                return [3, 7];

              case 2:
                return [4, this.L_.Va()];

              case 3:
                return r = i.sent(), o = et.ls(e, "current" === t), [4, this.cf(r, o)];

              case 4:
                return i.sent(), [3, 8];

              case 5:
                return [4, this.L_.ic(e, !0)];

              case 6:
                return i.sent(), this.af(e, n), [3, 8];

              case 7:
                bt(), i.label = 8;

              case 8:
                return [2];
            }
          });
        });
      }, t.prototype.wd = function (e, t) {
        return i.__awaiter(this, void 0, void 0, function () {
          var n,
              r,
              o,
              a,
              s,
              u,
              c,
              l,
              h,
              d,
              f = this;
          return i.__generator(this, function (p) {
            switch (p.label) {
              case 0:
                if (!this.isPrimary) return [3, 10];
                n = 0, r = e, p.label = 1;

              case 1:
                return n < r.length ? (o = r[n], this.Hd.has(o) ? (yt("SyncEngine", "Adding an already active target " + o), [3, 5]) : [4, this.L_.cc(o)]) : [3, 6];

              case 2:
                return a = p.sent(), [4, this.L_.sc(a)];

              case 3:
                return s = p.sent(), [4, this.rf(this.pf(a), s.targetId, !1)];

              case 4:
                p.sent(), this.Ld.listen(s), p.label = 5;

              case 5:
                return n++, [3, 1];

              case 6:
                u = function u(e) {
                  return i.__generator(this, function (t) {
                    switch (t.label) {
                      case 0:
                        return c.Hd.has(e) ? [4, c.L_.ic(e, !1).then(function () {
                          f.Ld.al(e), f.af(e);
                        }).catch(or)] : [3, 2];

                      case 1:
                        t.sent(), t.label = 2;

                      case 2:
                        return [2];
                    }
                  });
                }, c = this, l = 0, h = t, p.label = 7;

              case 7:
                return l < h.length ? (d = h[l], [5, u(d)]) : [3, 10];

              case 8:
                p.sent(), p.label = 9;

              case 9:
                return l++, [3, 7];

              case 10:
                return [2];
            }
          });
        });
      }, t;
    }(vi),
        bi = function bi() {
      this.yf = void 0, this.bf = [];
    },
        wi = function () {
      function e(e) {
        this.cl = e, this.vf = new Dt(function (e) {
          return e.canonicalId();
        }), this.onlineState = "Unknown", this.Sf = new Set(), this.cl.subscribe(this);
      }

      return e.prototype.listen = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t, n, r, o, a, s;
          return i.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                if (t = e.query, n = !1, (r = this.vf.get(t)) || (n = !0, r = new bi()), !n) return [3, 4];
                i.label = 1;

              case 1:
                return i.trys.push([1, 3,, 4]), o = r, [4, this.cl.listen(t)];

              case 2:
                return o.yf = i.sent(), [3, 4];

              case 3:
                if (a = i.sent(), vt("EventManager", s = "Initialization of query '" + t + "' failed: " + a), "IndexedDbTransactionError" !== a.name) throw a;
                return [2, void e.onError(new f(d.UNAVAILABLE, s))];

              case 4:
                return this.vf.set(t, r), r.bf.push(e), e.Nd(this.onlineState), r.yf && e.Df(r.yf) && this.Cf(), [2];
            }
          });
        });
      }, e.prototype.al = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t, n, r, o;
          return i.__generator(this, function (i) {
            return t = e.query, n = !1, (r = this.vf.get(t)) && (o = r.bf.indexOf(e)) >= 0 && (r.bf.splice(o, 1), n = 0 === r.bf.length), n ? [2, (this.vf.delete(t), this.cl.al(t))] : [2];
          });
        });
      }, e.prototype.h_ = function (e) {
        for (var t = !1, n = 0, r = e; n < r.length; n++) {
          var i = r[n],
              o = i.query,
              a = this.vf.get(o);

          if (a) {
            for (var s = 0, u = a.bf; s < u.length; s++) {
              u[s].Df(i) && (t = !0);
            }

            a.yf = i;
          }
        }

        t && this.Cf();
      }, e.prototype.If = function (e, t) {
        var n = this.vf.get(e);
        if (n) for (var r = 0, i = n.bf; r < i.length; r++) {
          i[r].onError(t);
        }
        this.vf.delete(e);
      }, e.prototype._f = function (e) {
        this.onlineState = e;
        var t = !1;
        this.vf.forEach(function (n, r) {
          for (var i = 0, o = r.bf; i < o.length; i++) {
            o[i].Nd(e) && (t = !0);
          }
        }), t && this.Cf();
      }, e.prototype.Ff = function (e) {
        this.Sf.add(e), e.next();
      }, e.prototype.Nf = function (e) {
        this.Sf.delete(e);
      }, e.prototype.Cf = function () {
        this.Sf.forEach(function (e) {
          e.next();
        });
      }, e;
    }(),
        Ti = function () {
      function e(e, t, n) {
        this.query = e, this.kf = t, this.$f = !1, this.Mf = null, this.onlineState = "Unknown", this.options = n || {};
      }

      return e.prototype.Df = function (e) {
        if (!this.options.includeMetadataChanges) {
          for (var t = [], n = 0, r = e.docChanges; n < r.length; n++) {
            var i = r[n];
            3 !== i.type && t.push(i);
          }

          e = new $e(e.query, e.docs, e.ss, t, e.ns, e.fromCache, e.rs, !0);
        }

        var o = !1;
        return this.$f ? this.Lf(e) && (this.kf.next(e), o = !0) : this.xf(e, this.onlineState) && (this.Of(e), o = !0), this.Mf = e, o;
      }, e.prototype.onError = function (e) {
        this.kf.error(e);
      }, e.prototype.Nd = function (e) {
        this.onlineState = e;
        var t = !1;
        return this.Mf && !this.$f && this.xf(this.Mf, e) && (this.Of(this.Mf), t = !0), t;
      }, e.prototype.xf = function (e, t) {
        if (!e.fromCache) return !0;
        var n = "Offline" !== t;
        return !(this.options.Bf && n || e.docs.B() && "Offline" !== t);
      }, e.prototype.Lf = function (e) {
        if (e.docChanges.length > 0) return !0;
        var t = this.Mf && this.Mf.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.rs && !t) && !0 === this.options.includeMetadataChanges;
      }, e.prototype.Of = function (e) {
        e = $e.os(e.query, e.docs, e.ns, e.fromCache), this.$f = !0, this.kf.next(e);
      }, e;
    }(),
        Mi = function () {
      function e() {}

      return e.prototype.Uu = function (e) {
        this.qf = e;
      }, e.prototype.dr = function (e, t, n, r) {
        var i = this;
        return t.te() || n.isEqual(b.min()) ? this.Uf(e, t) : this.qf.cr(e, r).next(function (o) {
          var s = i.Qf(t, o);
          return (t.oe() || t.ae()) && i.Sd(t.Bt, s, r, n) ? i.Uf(e, t) : (mt() <= a.LogLevel.DEBUG && yt("IndexFreeQueryEngine", "Re-using previous result from %s to execute query: %s", n.toString(), t.toString()), i.qf.dr(e, t, n).next(function (e) {
            return s.forEach(function (t) {
              e = e.me(t.key, t);
            }), e;
          }));
        });
      }, e.prototype.Qf = function (e, t) {
        var n = new je(function (t, n) {
          return e.se(t, n);
        });
        return t.forEach(function (t, r) {
          r instanceof ve && e.matches(r) && (n = n.add(r));
        }), n;
      }, e.prototype.Sd = function (e, t, n, r) {
        if (n.size !== t.size) return !0;
        var i = "F" === e ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.S(r) > 0);
      }, e.prototype.Uf = function (e, t) {
        return mt() <= a.LogLevel.DEBUG && yt("IndexFreeQueryEngine", "Using full collection scan to execute query: %s", t.toString()), this.qf.dr(e, t, b.min());
      }, e;
    }(),
        Ei = function () {
      function e(e, t) {
        this.rr = e, this.Ao = t, this.nr = [], this.Wf = 1, this.lastStreamToken = D.ht, this.jf = new je(Yt.An);
      }

      return e.prototype.po = function (e) {
        return Ct.resolve(0 === this.nr.length);
      }, e.prototype.yo = function (e, t, n) {
        var r = t.batchId,
            i = this.Kf(r, "acknowledged");
        return wt(0 === i), this.nr[i], this.lastStreamToken = n, Ct.resolve();
      }, e.prototype.vo = function (e) {
        return Ct.resolve(this.lastStreamToken);
      }, e.prototype.So = function (e, t) {
        return this.lastStreamToken = t, Ct.resolve();
      }, e.prototype.Do = function (e, t, n, r) {
        var i = this.Wf;
        this.Wf++, this.nr.length > 0 && this.nr[this.nr.length - 1];
        var o = new It(i, t, n, r);
        this.nr.push(o);

        for (var a = 0, s = r; a < s.length; a++) {
          var u = s[a];
          this.jf = this.jf.add(new Yt(u.key, i)), this.rr.Fo(e, u.key.path.M());
        }

        return Ct.resolve(o);
      }, e.prototype.No = function (e, t) {
        return Ct.resolve(this.Gf(t));
      }, e.prototype.Mo = function (e, t) {
        var n = t + 1,
            r = this.zf(n),
            i = r < 0 ? 0 : r;
        return Ct.resolve(this.nr.length > i ? this.nr[i] : null);
      }, e.prototype.Lo = function () {
        return Ct.resolve(0 === this.nr.length ? -1 : this.Wf - 1);
      }, e.prototype.xo = function (e) {
        return Ct.resolve(this.nr.slice());
      }, e.prototype.or = function (e, t) {
        var n = this,
            r = new Yt(t, 0),
            i = new Yt(t, Number.POSITIVE_INFINITY),
            o = [];
        return this.jf.Ke([r, i], function (e) {
          var t = n.Gf(e.Nn);
          o.push(t);
        }), Ct.resolve(o);
      }, e.prototype.lr = function (e, t) {
        var n = this,
            r = new je(Et);
        return t.forEach(function (e) {
          var t = new Yt(e, 0),
              i = new Yt(e, Number.POSITIVE_INFINITY);
          n.jf.Ke([t, i], function (e) {
            r = r.add(e.Nn);
          });
        }), Ct.resolve(this.Hf(r));
      }, e.prototype.Rr = function (e, t) {
        var n = t.path,
            r = n.length + 1,
            i = n;
        k.et(i) || (i = i.child(""));
        var o = new Yt(new k(i), 0),
            a = new je(Et);
        return this.jf.Ge(function (e) {
          var t = e.key.path;
          return !!n.q(t) && (t.length === r && (a = a.add(e.Nn)), !0);
        }, o), Ct.resolve(this.Hf(a));
      }, e.prototype.Hf = function (e) {
        var t = this,
            n = [];
        return e.forEach(function (e) {
          var r = t.Gf(e);
          null !== r && n.push(r);
        }), n;
      }, e.prototype.Bo = function (e, t) {
        var n = this;
        wt(0 === this.Kf(t.batchId, "removed")), this.nr.shift();
        var r = this.jf;
        return Ct.forEach(t.mutations, function (i) {
          var o = new Yt(i.key, t.batchId);
          return r = r.delete(o), n.Ao.Qo(e, i.key);
        }).next(function () {
          n.jf = r;
        });
      }, e.prototype.Uo = function (e) {}, e.prototype.Fn = function (e, t) {
        var n = new Yt(t, 0),
            r = this.jf.ze(n);
        return Ct.resolve(t.isEqual(r && r.key));
      }, e.prototype.Wo = function (e) {
        return this.nr.length, Ct.resolve();
      }, e.prototype.Kf = function (e, t) {
        return this.zf(e);
      }, e.prototype.zf = function (e) {
        return 0 === this.nr.length ? 0 : e - this.nr[0].batchId;
      }, e.prototype.Gf = function (e) {
        var t = this.zf(e);
        return t < 0 || t >= this.nr.length ? null : this.nr[t];
      }, e;
    }(),
        ki = function () {
      function e(e, t) {
        this.rr = e, this.Yf = t, this.docs = new Oe(k.N), this.size = 0;
      }

      return e.prototype.Gn = function (e, t, n) {
        var r = t.key,
            i = this.docs.get(r),
            o = i ? i.size : 0,
            a = this.Yf(t);
        return this.docs = this.docs.me(r, {
          Ea: t,
          size: a,
          readTime: n
        }), this.size += a - o, this.rr.Fo(e, r.path.M());
      }, e.prototype.Hn = function (e) {
        var t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
      }, e.prototype.Yn = function (e, t) {
        var n = this.docs.get(t);
        return Ct.resolve(n ? n.Ea : null);
      }, e.prototype.getEntries = function (e, t) {
        var n = this,
            r = We();
        return t.forEach(function (e) {
          var t = n.docs.get(e);
          r = r.me(e, t ? t.Ea : null);
        }), Ct.resolve(r);
      }, e.prototype.dr = function (e, t, n) {
        for (var r = Be(), i = new k(t.path.child("")), o = this.docs.ve(i); o.ke();) {
          var a = o.Ne(),
              s = a.key,
              u = a.value,
              c = u.Ea,
              l = u.readTime;
          if (!t.path.q(s.path)) break;
          l.S(n) <= 0 || c instanceof ve && t.matches(c) && (r = r.me(c.key, c));
        }

        return Ct.resolve(r);
      }, e.prototype.Jf = function (e, t) {
        return Ct.forEach(this.docs, function (e) {
          return t(e);
        });
      }, e.prototype.ba = function (t) {
        return new e.va(this);
      }, e.prototype.Da = function (e) {
        return Ct.resolve(this.size);
      }, e;
    }();

    ki.va = function (e) {
      function t(t) {
        var n = this;
        return (n = e.call(this) || this).Ca = t, n;
      }

      return i.__extends(t, e), t.prototype.Zn = function (e) {
        var t = this,
            n = [];
        return this.Wn.forEach(function (r, i) {
          i ? n.push(t.Ca.Gn(e, i, t.readTime)) : t.Ca.Hn(r);
        }), Ct.Un(n);
      }, t.prototype.Jn = function (e, t) {
        return this.Ca.Yn(e, t);
      }, t.prototype.Xn = function (e, t) {
        return this.Ca.getEntries(e, t);
      }, t;
    }(Ot);
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var Li = function () {
      function e(e) {
        this.persistence = e, this.Xf = new Dt(function (e) {
          return e.canonicalId();
        }), this.lastRemoteSnapshotVersion = b.min(), this.highestTargetId = 0, this.Zf = 0, this.tT = new xt(), this.targetCount = 0, this.eT = _n.Ko();
      }

      return e.prototype.js = function (e, t) {
        return this.Xf.forEach(function (e, n) {
          return t(n);
        }), Ct.resolve();
      }, e.prototype.Jo = function (e) {
        return Ct.resolve(this.lastRemoteSnapshotVersion);
      }, e.prototype.Xo = function (e) {
        return Ct.resolve(this.Zf);
      }, e.prototype.zo = function (e) {
        return this.highestTargetId = this.eT.next(), Ct.resolve(this.highestTargetId);
      }, e.prototype.Zo = function (e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.Zf && (this.Zf = t), Ct.resolve();
      }, e.prototype.ea = function (e) {
        this.Xf.set(e.target, e);
        var t = e.targetId;
        t > this.highestTargetId && (this.eT = new _n(t), this.highestTargetId = t), e.sequenceNumber > this.Zf && (this.Zf = e.sequenceNumber);
      }, e.prototype.ta = function (e, t) {
        return this.ea(t), this.targetCount += 1, Ct.resolve();
      }, e.prototype.ia = function (e, t) {
        return this.ea(t), Ct.resolve();
      }, e.prototype.na = function (e, t) {
        return this.Xf.delete(t.target), this.tT.Sn(t.targetId), this.targetCount -= 1, Ct.resolve();
      }, e.prototype.Hh = function (e, t, n) {
        var r = this,
            i = 0,
            o = [];
        return this.Xf.forEach(function (a, s) {
          s.sequenceNumber <= t && null === n.get(s.targetId) && (r.Xf.delete(a), o.push(r.ra(e, s.targetId)), i++);
        }), Ct.Un(o).next(function () {
          return i;
        });
      }, e.prototype.aa = function (e) {
        return Ct.resolve(this.targetCount);
      }, e.prototype.ua = function (e, t) {
        var n = this.Xf.get(t) || null;
        return Ct.resolve(n);
      }, e.prototype.ca = function (e, t, n) {
        this.tT.pn(t, n);
        var r = this.persistence.Ao,
            i = [];
        return r && t.forEach(function (t) {
          i.push(r.gn(e, t));
        }), Ct.Un(i);
      }, e.prototype._a = function (e, t, n) {
        this.tT.vn(t, n);
        var r = this.persistence.Ao,
            i = [];
        return r && t.forEach(function (t) {
          i.push(r.yn(e, t));
        }), Ct.Un(i);
      }, e.prototype.ra = function (e, t) {
        return this.tT.Sn(t), Ct.resolve();
      }, e.prototype.la = function (e, t) {
        var n = this.tT.Cn(t);
        return Ct.resolve(n);
      }, e.prototype.Fn = function (e, t) {
        return Ct.resolve(this.tT.Fn(t));
      }, e;
    }(),
        Si = function () {
      function e(e) {
        var t = this;
        this.sT = {}, this.su = new Pt(0), this.qa = !1, this.qa = !0, this.Ao = e(this), this.Ha = new Li(this), this.rr = new Sn(), this.ir = new ki(this.rr, function (e) {
          return t.Ao.iT(e);
        });
      }

      return e.prototype.start = function () {
        return Promise.resolve();
      }, e.prototype.Iu = function () {
        return this.qa = !1, Promise.resolve();
      }, Object.defineProperty(e.prototype, "Uh", {
        get: function get() {
          return this.qa;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.nu = function () {}, e.prototype.yu = function () {
        return this.rr;
      }, e.prototype.Vu = function (e) {
        var t = this.sT[e.s()];
        return t || (t = new Ei(this.rr, this.Ao), this.sT[e.s()] = t), t;
      }, e.prototype.gu = function () {
        return this.Ha;
      }, e.prototype.pu = function () {
        return this.ir;
      }, e.prototype.runTransaction = function (e, t, n) {
        var r = this;
        yt("MemoryPersistence", "Starting transaction:", e);
        var i = new Ni(this.su.next());
        return this.Ao.nT(), n(i).next(function (e) {
          return r.Ao.rT(i).next(function () {
            return e;
          });
        }).Bn().then(function (e) {
          return i.sr(), e;
        });
      }, e.prototype.hT = function (e, t) {
        return Ct.Qn(Object.values(this.sT).map(function (n) {
          return function () {
            return n.Fn(e, t);
          };
        }));
      }, e;
    }(),
        Ni = function (e) {
      function t(t) {
        var n = this;
        return (n = e.call(this) || this).Oa = t, n;
      }

      return i.__extends(t, e), t;
    }(At),
        Di = function () {
      function e(e) {
        this.persistence = e, this.Su = null, this.oT = null;
      }

      return e.aT = function (t) {
        return new e(t);
      }, Object.defineProperty(e.prototype, "uT", {
        get: function get() {
          if (this.oT) return this.oT;
          throw bt();
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.Fu = function (e) {
        this.Su = e;
      }, e.prototype.gn = function (e, t) {
        return this.uT.delete(t), Ct.resolve();
      }, e.prototype.yn = function (e, t) {
        return this.uT.add(t), Ct.resolve();
      }, e.prototype.Qo = function (e, t) {
        return this.uT.add(t), Ct.resolve();
      }, e.prototype.removeTarget = function (e, t) {
        var n = this,
            r = this.persistence.gu();
        return r.la(e, t.targetId).next(function (e) {
          e.forEach(function (e) {
            return n.uT.add(e);
          });
        }).next(function () {
          return r.na(e, t);
        });
      }, e.prototype.nT = function () {
        this.oT = new Set();
      }, e.prototype.rT = function (e) {
        var t = this,
            n = this.persistence.pu().ba();
        return Ct.forEach(this.uT, function (r) {
          return t.cT(e, r).next(function (e) {
            e || n.Hn(r);
          });
        }).next(function () {
          return t.oT = null, n.apply(e);
        });
      }, e.prototype.ku = function (e, t) {
        var n = this;
        return this.cT(e, t).next(function (e) {
          e ? n.uT.delete(t) : n.uT.add(t);
        });
      }, e.prototype.iT = function (e) {
        return 0;
      }, e.prototype.cT = function (e, t) {
        var n = this;
        return Ct.Qn([function () {
          return n.persistence.gu().Fn(e, t);
        }, function () {
          return n.persistence.hT(e, t);
        }, function () {
          return Ct.resolve(n.Su.Fn(t));
        }]);
      }, e;
    }(),
        Ii = function () {
      function e() {}

      return e.prototype.initialize = function (e) {
        return i.__awaiter(this, void 0, void 0, function () {
          var t = this;
          return i.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return this.jd = this._T(e), this.persistence = this.lT(e), [4, this.persistence.start()];

              case 1:
                return n.sent(), this.dT = this.fT(e), this.L_ = this.TT(e), this.Ld = this.ET(e), this.cl = this.IT(e), this.wT = this.RT(e), this.jd.b_ = function (e) {
                  return t.cl.Nd(e, 1);
                }, this.Ld.cl = this.cl, [4, this.L_.start()];

              case 2:
                return n.sent(), [4, this.jd.start()];

              case 3:
                return n.sent(), [4, this.Ld.start()];

              case 4:
                return n.sent(), [4, this.Ld.yl(this.cl.if)];

              case 5:
                return n.sent(), [2];
            }
          });
        });
      }, e.prototype.RT = function (e) {
        return new wi(this.cl);
      }, e.prototype.fT = function (e) {
        return null;
      }, e.prototype.TT = function (e) {
        return new rr(this.persistence, new Mi(), e.mT);
      }, e.prototype.lT = function (e) {
        return new Si(Di.aT);
      }, e.prototype.ET = function (e) {
        var t = this;
        return new ti(this.L_, e.w_, e.qr, function (e) {
          return t.cl.Nd(e, 0);
        }, e.platform.AT());
      }, e.prototype._T = function (e) {
        return new hi();
      }, e.prototype.IT = function (e) {
        return new vi(this.L_, this.Ld, this.jd, e.mT, e.Kd);
      }, e.prototype.clearPersistence = function (e) {
        throw new f(d.FAILED_PRECONDITION, "You are using the memory-only build of Firestore. Persistence support is only available via the @firebase/firestore bundle or the firebase-firestore.js build.");
      }, e;
    }(),
        Ri = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return i.__extends(t, e), t.prototype.initialize = function (t) {
        return i.__awaiter(this, void 0, void 0, function () {
          var n = this;
          return i.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, e.prototype.initialize.call(this, t)];

              case 1:
                return r.sent(), [4, this.persistence.iu(function (e) {
                  return i.__awaiter(n, void 0, void 0, function () {
                    return i.__generator(this, function (t) {
                      switch (t.label) {
                        case 0:
                          return [4, this.cl.yl(e)];

                        case 1:
                          return t.sent(), this.dT && (e && !this.dT.Uh ? this.dT.start(this.L_) : e || this.dT.stop()), [2];
                      }
                    });
                  });
                })];

              case 2:
                return r.sent(), [2];
            }
          });
        });
      }, t.prototype.TT = function (e) {
        return new ir(this.persistence, new Mi(), e.mT);
      }, t.prototype.IT = function (e) {
        var t = new gi(this.L_, this.Ld, this.jd, e.mT, e.Kd);
        return this.jd instanceof li && (this.jd.cl = t), t;
      }, t.prototype.fT = function (e) {
        var t = this.persistence.Ao.Lh;
        return new qt(t, e.qr);
      }, t.prototype.lT = function (e) {
        var t = Kn.vu(e.PT),
            n = e.platform.Dc(e.PT.ii);
        return new Kn(e.VT.synchronizeTabs, t, e.clientId, e.platform, Gt.Dh(e.VT.cacheSizeBytes), e.qr, n, this.jd);
      }, t.prototype._T = function (e) {
        if (e.VT.gT && e.VT.synchronizeTabs) {
          if (!li.so(e.platform)) throw new f(d.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
          var t = Kn.vu(e.PT);
          return new li(e.qr, e.platform, t, e.clientId, e.mT);
        }

        return new hi();
      }, t.prototype.clearPersistence = function (e) {
        var t = Kn.vu(e);
        return Kn.clearPersistence(t);
      }, t;
    }(Ii),
        xi = function () {
      function e(e, t, n, r) {
        this.platform = e, this.PT = t, this.credentials = n, this.qr = r, this.clientId = Mt.cn();
      }

      return e.prototype.start = function (e, t) {
        var n = this;
        this.pT();
        var r = new Vt(),
            i = new Vt(),
            o = !1;
        return this.credentials.l(function (a) {
          if (!o) return o = !0, yt("FirestoreClient", "Initializing. user=", a.uid), n.yT(e, t, a, i).then(r.resolve, r.reject);
          n.qr.Hr(function () {
            return n.pl(a);
          });
        }), this.qr.Hr(function () {
          return r.promise;
        }), i.promise;
      }, e.prototype.enableNetwork = function () {
        var e = this;
        return this.pT(), this.qr.enqueue(function () {
          return e.cl.enableNetwork();
        });
      }, e.prototype.yT = function (e, t, n, r) {
        return i.__awaiter(this, void 0, void 0, function () {
          var o,
              a,
              s,
              u,
              c = this;
          return i.__generator(this, function (l) {
            switch (l.label) {
              case 0:
                return l.trys.push([0, 3,, 4]), [4, this.platform.bT(this.PT)];

              case 1:
                return o = l.sent(), a = this.platform.Dc(this.PT.ii), s = function (e, t, n) {
                  return new Kr(e, t, a);
                }(o, this.credentials), [4, e.initialize({
                  qr: this.qr,
                  PT: this.PT,
                  platform: this.platform,
                  w_: s,
                  clientId: this.clientId,
                  mT: n,
                  Kd: 100,
                  VT: t
                })];

              case 2:
                return l.sent(), this.persistence = e.persistence, this.jd = e.jd, this.L_ = e.L_, this.Ld = e.Ld, this.cl = e.cl, this.dT = e.dT, this.vT = e.wT, this.persistence.nu(function () {
                  return i.__awaiter(c, void 0, void 0, function () {
                    return i.__generator(this, function (e) {
                      switch (e.label) {
                        case 0:
                          return [4, this.terminate()];

                        case 1:
                          return e.sent(), [2];
                      }
                    });
                  });
                }), r.resolve(), [3, 4];

              case 3:
                if (u = l.sent(), r.reject(u), !this.ST(u)) throw u;
                return [2, (console.warn("Error enabling offline persistence. Falling back to persistence disabled: " + u), this.yT(new Ii(), {
                  gT: !1
                }, n, r))];

              case 4:
                return [2];
            }
          });
        });
      }, e.prototype.ST = function (e) {
        return "FirebaseError" === e.name ? e.code === d.FAILED_PRECONDITION || e.code === d.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || 22 === e.code || 20 === e.code || 11 === e.code;
      }, e.prototype.pT = function () {
        if (this.qr.hh) throw new f(d.FAILED_PRECONDITION, "The client has already been terminated.");
      }, e.prototype.pl = function (e) {
        return this.qr.Th(), yt("FirestoreClient", "Credential Changed. Current user: " + e.uid), this.cl.pl(e);
      }, e.prototype.disableNetwork = function () {
        var e = this;
        return this.pT(), this.qr.enqueue(function () {
          return e.cl.disableNetwork();
        });
      }, e.prototype.terminate = function () {
        var e = this;
        return this.qr.lh(function () {
          return i.__awaiter(e, void 0, void 0, function () {
            return i.__generator(this, function (e) {
              switch (e.label) {
                case 0:
                  return this.dT && this.dT.stop(), [4, this.Ld.Iu()];

                case 1:
                  return e.sent(), [4, this.jd.Iu()];

                case 2:
                  return e.sent(), [4, this.persistence.Iu()];

                case 3:
                  return e.sent(), this.credentials.T(), [2];
              }
            });
          });
        });
      }, e.prototype.waitForPendingWrites = function () {
        var e = this;
        this.pT();
        var t = new Vt();
        return this.qr.Hr(function () {
          return e.cl.Tf(t);
        }), t.promise;
      }, e.prototype.listen = function (e, t, n) {
        var r = this;
        this.pT();
        var i = new Ti(e, t, n);
        return this.qr.Hr(function () {
          return r.vT.listen(i);
        }), i;
      }, e.prototype.al = function (e) {
        var t = this;
        this.DT || this.qr.Hr(function () {
          return t.vT.al(e);
        });
      }, e.prototype.CT = function (e) {
        var t = this;
        return this.pT(), this.qr.enqueue(function () {
          return t.L_.ec(e);
        }).then(function (e) {
          if (e instanceof ve) return e;
          if (e instanceof ge) return null;
          throw new f(d.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)");
        });
      }, e.prototype.FT = function (e) {
        var t = this;
        return this.pT(), this.qr.enqueue(function () {
          return i.__awaiter(t, void 0, void 0, function () {
            var t, n, r;
            return i.__generator(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, this.L_.nc(e, !0)];

                case 1:
                  return t = i.sent(), n = new pi(e, t.rc), r = n.yd(t.documents), [2, n.Zn(r, !1).snapshot];
              }
            });
          });
        });
      }, e.prototype.write = function (e) {
        var t = this;
        this.pT();
        var n = new Vt();
        return this.qr.Hr(function () {
          return t.cl.write(e, n);
        }), n.promise;
      }, e.prototype.ii = function () {
        return this.PT.ii;
      }, e.prototype.Ff = function (e) {
        var t = this;
        this.pT(), this.qr.Hr(function () {
          return t.vT.Ff(e), Promise.resolve();
        });
      }, e.prototype.Nf = function (e) {
        this.DT || this.vT.Nf(e);
      }, Object.defineProperty(e.prototype, "DT", {
        get: function get() {
          return this.qr.hh;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.transaction = function (e) {
        var t = this;
        this.pT();
        var n = new Vt();
        return this.qr.Hr(function () {
          return t.cl.runTransaction(t.qr, e, n), Promise.resolve();
        }), n.promise;
      }, e;
    }(),
        Yi = function () {
      function e(e) {
        this.observer = e, this.muted = !1;
      }

      return e.prototype.next = function (e) {
        this.NT(this.observer.next, e);
      }, e.prototype.error = function (e) {
        this.NT(this.observer.error, e);
      }, e.prototype.kT = function () {
        this.muted = !0;
      }, e.prototype.NT = function (e, t) {
        var n = this;
        this.muted || setTimeout(function () {
          n.muted || e(t);
        }, 0);
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Ci(e) {
      return function (e, t) {
        if ("object" != typeof e || null === e) return !1;

        for (var n = e, r = 0, i = ["next", "error", "complete"]; r < i.length; r++) {
          var o = i[r];
          if (o in n && "function" == typeof n[o]) return !0;
        }

        return !1;
      }(e);
    }

    var Oi = function () {
      function e(e, t, n, r) {
        this.firestore = e, this.timestampsInSnapshots = t, this.$T = n, this.converter = r;
      }

      return e.prototype.MT = function (e) {
        switch (F(e)) {
          case 0:
            return null;

          case 1:
            return e.booleanValue;

          case 2:
            return H(e.integerValue || e.doubleValue);

          case 3:
            return this.LT(e.timestampValue);

          case 4:
            return this.xT(e);

          case 5:
            return e.stringValue;

          case 6:
            return new Lr(B(e.bytesValue));

          case 7:
            return this.OT(e.referenceValue);

          case 8:
            return this.BT(e.geoPointValue);

          case 9:
            return this.qT(e.arrayValue);

          case 10:
            return this.UT(e.mapValue);

          default:
            throw bt();
        }
      }, e.prototype.UT = function (e) {
        var t = this,
            n = {};
        return S(e.fields || {}, function (e, r) {
          n[e] = t.MT(r);
        }), n;
      }, e.prototype.BT = function (e) {
        return new Or(H(e.latitude), H(e.longitude));
      }, e.prototype.qT = function (e) {
        var t = this;
        return (e.values || []).map(function (e) {
          return t.MT(e);
        });
      }, e.prototype.xT = function (e) {
        switch (this.$T) {
          case "previous":
            var t = function e(t) {
              var n = t.mapValue.fields.__previous_value__;
              return Y(n) ? e(n) : n;
            }(e);

            return null == t ? null : this.MT(t);

          case "estimate":
            return this.LT(C(e));

          default:
            return null;
        }
      }, e.prototype.LT = function (e) {
        var t = W(e),
            n = new g(t.seconds, t.nanos);
        return this.timestampsInSnapshots ? n : n.toDate();
      }, e.prototype.OT = function (e) {
        var t = T.K(e);
        wt(dt(t));
        var n = new Nt(t.get(1), t.get(3)),
            r = new k(t.$(5));
        return n.isEqual(this.firestore.Lc) || vt("Document " + r + " contains a document reference within a different database (" + n.projectId + "/" + n.database + ") which is not supported. It will be treated as a reference in the current database (" + this.firestore.Lc.projectId + "/" + this.firestore.Lc.database + ") instead."), new Vi(r, this.firestore, this.converter);
      }, e;
    }(),
        Fi = Gt.Nh,
        Ai = function () {
      function e(e) {
        var t, n;

        if (void 0 === e.host) {
          if (void 0 !== e.ssl) throw new f(d.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
          this.host = "firestore.googleapis.com", this.ssl = !0;
        } else dr("settings", "non-empty string", "host", e.host), this.host = e.host, fr("settings", "boolean", "ssl", e.ssl), this.ssl = null === (t = e.ssl) || void 0 === t || t;

        if (gr("settings", e, ["host", "ssl", "credentials", "timestampsInSnapshots", "cacheSizeBytes", "experimentalForceLongPolling"]), fr("settings", "object", "credentials", e.credentials), this.credentials = e.credentials, fr("settings", "boolean", "timestampsInSnapshots", e.timestampsInSnapshots), !0 === e.timestampsInSnapshots ? vt("The setting 'timestampsInSnapshots: true' is no longer required and should be removed.") : !1 === e.timestampsInSnapshots && vt("Support for 'timestampsInSnapshots: false' will be removed soon. You must update your code to handle Timestamp objects."), this.timestampsInSnapshots = null === (n = e.timestampsInSnapshots) || void 0 === n || n, fr("settings", "number", "cacheSizeBytes", e.cacheSizeBytes), void 0 === e.cacheSizeBytes) this.cacheSizeBytes = Gt.$h;else {
          if (e.cacheSizeBytes !== Fi && e.cacheSizeBytes < Gt.kh) throw new f(d.INVALID_ARGUMENT, "cacheSizeBytes must be at least " + Gt.kh);
          this.cacheSizeBytes = e.cacheSizeBytes;
        }
        fr("settings", "boolean", "experimentalForceLongPolling", e.experimentalForceLongPolling), this.forceLongPolling = void 0 !== e.experimentalForceLongPolling && e.experimentalForceLongPolling;
      }

      return e.prototype.isEqual = function (e) {
        return this.host === e.host && this.ssl === e.ssl && this.timestampsInSnapshots === e.timestampsInSnapshots && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.forceLongPolling === e.forceLongPolling;
      }, e;
    }(),
        ji = function () {
      function e(t, n, r) {
        var o = this;

        if (void 0 === r && (r = new Ii()), this.QT = null, this.WT = new Bt(), this.INTERNAL = {
          delete: function _delete() {
            return i.__awaiter(o, void 0, void 0, function () {
              return i.__generator(this, function (e) {
                switch (e.label) {
                  case 0:
                    return this.jT(), [4, this.KT.terminate()];

                  case 1:
                    return e.sent(), [2];
                }
              });
            });
          }
        }, "object" == typeof t.options) {
          var a = t;
          this.QT = a, this.Lc = e.GT(a), this.zT = a.name, this.HT = new _(n);
        } else {
          var s = t;
          if (!s.projectId) throw new f(d.INVALID_ARGUMENT, "Must provide projectId");
          this.Lc = new Nt(s.projectId, s.database), this.zT = "[DEFAULT]", this.HT = new m();
        }

        this.YT = r, this.JT = new Ai({}), this.XT = new Vr(this.Lc);
      }

      return e.prototype.settings = function (e) {
        sr("Firestore.settings", arguments, 1), lr("Firestore.settings", "object", 1, e);
        var t = new Ai(e);
        if (this.KT && !this.JT.isEqual(t)) throw new f(d.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only call settings() before calling any other methods on a Firestore object.");
        this.JT = t, void 0 !== t.credentials && (this.HT = function (e) {
          if (!e) return new m();

          switch (e.type) {
            case "gapi":
              var t = e.ZT;
              return wt(!("object" != typeof t || null === t || !t.auth || !t.auth.getAuthHeaderValueForFirstParty)), new v(t, e.V || "0");

            case "provider":
              return e.ZT;

            default:
              throw new f(d.INVALID_ARGUMENT, "makeCredentialsProvider failed due to invalid credential type");
          }
        }(t.credentials));
      }, e.prototype.enableNetwork = function () {
        return this.jT(), this.KT.enableNetwork();
      }, e.prototype.disableNetwork = function () {
        return this.jT(), this.KT.disableNetwork();
      }, e.prototype.enablePersistence = function (e) {
        var t, n;
        if (this.KT) throw new f(d.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only call enablePersistence() before calling any other methods on a Firestore object.");
        var r = !1;
        return e && (void 0 !== e.experimentalTabSynchronization && vt("The 'experimentalTabSynchronization' setting will be removed. Use 'synchronizeTabs' instead."), r = null !== (n = null !== (t = e.synchronizeTabs) && void 0 !== t ? t : e.experimentalTabSynchronization) && void 0 !== n && n), this.tE(this.YT, {
          gT: !0,
          cacheSizeBytes: this.JT.cacheSizeBytes,
          synchronizeTabs: r
        });
      }, e.prototype.clearPersistence = function () {
        return i.__awaiter(this, void 0, void 0, function () {
          var e,
              t = this;
          return i.__generator(this, function (n) {
            if (void 0 !== this.KT && !this.KT.DT) throw new f(d.FAILED_PRECONDITION, "Persistence cannot be cleared after this Firestore instance is initialized.");
            return e = new Vt(), [2, (this.WT.oh(function () {
              return i.__awaiter(t, void 0, void 0, function () {
                var t, n;
                return i.__generator(this, function (r) {
                  switch (r.label) {
                    case 0:
                      return r.trys.push([0, 2,, 3]), t = this.eE(), [4, this.YT.clearPersistence(t)];

                    case 1:
                      return r.sent(), e.resolve(), [3, 3];

                    case 2:
                      return n = r.sent(), e.reject(n), [3, 3];

                    case 3:
                      return [2];
                  }
                });
              });
            }), e.promise)];
          });
        });
      }, e.prototype.terminate = function () {
        return this.app._removeServiceInstance("firestore"), this.INTERNAL.delete();
      }, Object.defineProperty(e.prototype, "sE", {
        get: function get() {
          return this.jT(), this.KT.DT;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.waitForPendingWrites = function () {
        return this.jT(), this.KT.waitForPendingWrites();
      }, e.prototype.onSnapshotsInSync = function (e) {
        if (this.jT(), Ci(e)) return this.iE(e);
        lr("Firestore.onSnapshotsInSync", "function", 1, e);
        var t = {
          next: e
        };
        return this.iE(t);
      }, e.prototype.iE = function (e) {
        var t = this,
            n = new Yi({
          next: function next() {
            e.next && e.next();
          },
          error: function error(e) {
            throw bt();
          }
        });
        return this.KT.Ff(n), function () {
          n.kT(), t.KT.Nf(n);
        };
      }, e.prototype.jT = function () {
        return this.KT || this.tE(new Ii(), {
          gT: !1
        }), this.KT;
      }, e.prototype.eE = function () {
        return new St(this.Lc, this.zT, this.JT.host, this.JT.ssl, this.JT.forceLongPolling);
      }, e.prototype.tE = function (e, t) {
        var n = this.eE();
        return this.KT = new xi(ft.nt(), n, this.HT, this.WT), this.KT.start(e, t);
      }, e.GT = function (e) {
        if (t = e.options, !Object.prototype.hasOwnProperty.call(t, "projectId")) throw new f(d.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
        var t,
            n = e.options.projectId;
        /**
         * @license
         * Copyright 2017 Google Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         *   http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         */

        if (!n || "string" != typeof n) throw new f(d.INVALID_ARGUMENT, "projectId must be a string in FirebaseApp.options");
        return new Nt(n);
      }, Object.defineProperty(e.prototype, "app", {
        get: function get() {
          if (!this.QT) throw new f(d.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
          return this.QT;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.collection = function (e) {
        return sr("Firestore.collection", arguments, 1), lr("Firestore.collection", "non-empty string", 1, e), this.jT(), new Qi(T.K(e), this);
      }, e.prototype.doc = function (e) {
        return sr("Firestore.doc", arguments, 1), lr("Firestore.doc", "non-empty string", 1, e), this.jT(), Vi.nE(T.K(e), this);
      }, e.prototype.collectionGroup = function (e) {
        if (sr("Firestore.collectionGroup", arguments, 1), lr("Firestore.collectionGroup", "non-empty string", 1, e), e.indexOf("/") >= 0) throw new f(d.INVALID_ARGUMENT, "Invalid collection ID '" + e + "' passed to function Firestore.collectionGroup(). Collection IDs must not contain '/'.");
        return this.jT(), new zi(new Te(T.G, e), this);
      }, e.prototype.runTransaction = function (e) {
        var t = this;
        return sr("Firestore.runTransaction", arguments, 1), lr("Firestore.runTransaction", "function", 1, e), this.jT().transaction(function (n) {
          return e(new Ui(t, n));
        });
      }, e.prototype.batch = function () {
        return this.jT(), new Pi(this);
      }, Object.defineProperty(e, "logLevel", {
        get: function get() {
          switch (mt()) {
            case a.LogLevel.DEBUG:
              return "debug";

            case a.LogLevel.SILENT:
              return "silent";

            default:
              return "error";
          }
        },
        enumerable: !0,
        configurable: !0
      }), e.setLogLevel = function (e) {
        switch (sr("Firestore.setLogLevel", arguments, 1), lr("Firestore.setLogLevel", "non-empty string", 1, e), e) {
          case "debug":
            _t(a.LogLevel.DEBUG);

            break;

          case "error":
            _t(a.LogLevel.ERROR);

            break;

          case "silent":
            _t(a.LogLevel.SILENT);

            break;

          default:
            throw new f(d.INVALID_ARGUMENT, "Invalid log level: " + e);
        }
      }, e.prototype.rE = function () {
        return this.JT.timestampsInSnapshots;
      }, e;
    }(),
        Ui = function () {
      function e(e, t) {
        this.hE = e, this.oE = t;
      }

      return e.prototype.get = function (e) {
        var t = this;
        sr("Transaction.get", arguments, 1);
        var n = Xi("Transaction.get", e, this.hE);
        return this.oE.V_([n.xc]).then(function (e) {
          if (!e || 1 !== e.length) return bt();
          var r = e[0];
          if (r instanceof ge) return new Hi(t.hE, n.xc, null, !1, !1, n.aE);
          if (r instanceof ve) return new Hi(t.hE, n.xc, r, !1, !1, n.aE);
          throw bt();
        });
      }, e.prototype.set = function (e, t, n) {
        cr("Transaction.set", arguments, 2, 3);
        var r = Xi("Transaction.set", e, this.hE);
        n = Gi("Transaction.set", n);
        var i = $i(r.aE, t, "Transaction.set"),
            o = i[0],
            a = i[1],
            s = n.merge || n.mergeFields ? this.hE.XT.Nc(a, o, n.mergeFields) : this.hE.XT.Cc(a, o);
        return this.oE.set(r.xc, s), this;
      }, e.prototype.update = function (e, t, n) {
        for (var r, i, o = [], a = 3; a < arguments.length; a++) {
          o[a - 3] = arguments[a];
        }

        return "string" == typeof t || t instanceof Sr ? (ur("Transaction.update", arguments, 3), r = Xi("Transaction.update", e, this.hE), i = this.hE.XT.$c("Transaction.update", t, n, o)) : (sr("Transaction.update", arguments, 2), r = Xi("Transaction.update", e, this.hE), i = this.hE.XT.kc("Transaction.update", t)), this.oE.update(r.xc, i), this;
      }, e.prototype.delete = function (e) {
        sr("Transaction.delete", arguments, 1);
        var t = Xi("Transaction.delete", e, this.hE);
        return this.oE.delete(t.xc), this;
      }, e;
    }(),
        Pi = function () {
      function e(e) {
        this.hE = e, this.uE = [], this.cE = !1;
      }

      return e.prototype.set = function (e, t, n) {
        cr("WriteBatch.set", arguments, 2, 3), this._E();
        var r = Xi("WriteBatch.set", e, this.hE);
        n = Gi("WriteBatch.set", n);
        var i = $i(r.aE, t, "WriteBatch.set"),
            o = i[0],
            a = i[1],
            s = n.merge || n.mergeFields ? this.hE.XT.Nc(a, o, n.mergeFields) : this.hE.XT.Cc(a, o);
        return this.uE = this.uE.concat(s.gc(r.xc, oe.ft())), this;
      }, e.prototype.update = function (e, t, n) {
        for (var r, i, o = [], a = 3; a < arguments.length; a++) {
          o[a - 3] = arguments[a];
        }

        return this._E(), "string" == typeof t || t instanceof Sr ? (ur("WriteBatch.update", arguments, 3), r = Xi("WriteBatch.update", e, this.hE), i = this.hE.XT.$c("WriteBatch.update", t, n, o)) : (sr("WriteBatch.update", arguments, 2), r = Xi("WriteBatch.update", e, this.hE), i = this.hE.XT.kc("WriteBatch.update", t)), this.uE = this.uE.concat(i.gc(r.xc, oe.exists(!0))), this;
      }, e.prototype.delete = function (e) {
        sr("WriteBatch.delete", arguments, 1), this._E();
        var t = Xi("WriteBatch.delete", e, this.hE);
        return this.uE = this.uE.concat(new le(t.xc, oe.ft())), this;
      }, e.prototype.commit = function () {
        return this._E(), this.cE = !0, this.uE.length > 0 ? this.hE.jT().write(this.uE) : Promise.resolve();
      }, e.prototype._E = function () {
        if (this.cE) throw new f(d.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
      }, e;
    }(),
        Vi = function () {
      function e(e, t, n) {
        this.xc = e, this.firestore = t, this.aE = n, this.KT = this.firestore.jT();
      }

      return e.nE = function (t, n, r) {
        if (t.length % 2 != 0) throw new f(d.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but " + t.j() + " has " + t.length);
        return new e(new k(t), n, r);
      }, Object.defineProperty(e.prototype, "id", {
        get: function get() {
          return this.xc.path.O();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "parent", {
        get: function get() {
          return new Qi(this.xc.path.M(), this.firestore, this.aE);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "path", {
        get: function get() {
          return this.xc.path.j();
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.collection = function (e) {
        if (sr("DocumentReference.collection", arguments, 1), lr("DocumentReference.collection", "non-empty string", 1, e), !e) throw new f(d.INVALID_ARGUMENT, "Must provide a non-empty collection name to collection()");
        var t = T.K(e);
        return new Qi(this.xc.path.child(t), this.firestore);
      }, e.prototype.isEqual = function (t) {
        if (!(t instanceof e)) throw br("isEqual", "DocumentReference", 1, t);
        return this.firestore === t.firestore && this.xc.isEqual(t.xc) && this.aE === t.aE;
      }, e.prototype.set = function (e, t) {
        cr("DocumentReference.set", arguments, 1, 2), t = Gi("DocumentReference.set", t);
        var n = $i(this.aE, e, "DocumentReference.set"),
            r = n[0],
            i = n[1],
            o = t.merge || t.mergeFields ? this.firestore.XT.Nc(i, r, t.mergeFields) : this.firestore.XT.Cc(i, r);
        return this.KT.write(o.gc(this.xc, oe.ft()));
      }, e.prototype.update = function (e, t) {
        for (var n, r = [], i = 2; i < arguments.length; i++) {
          r[i - 2] = arguments[i];
        }

        return "string" == typeof e || e instanceof Sr ? (ur("DocumentReference.update", arguments, 2), n = this.firestore.XT.$c("DocumentReference.update", e, t, r)) : (sr("DocumentReference.update", arguments, 1), n = this.firestore.XT.kc("DocumentReference.update", e)), this.KT.write(n.gc(this.xc, oe.exists(!0)));
      }, e.prototype.delete = function () {
        return sr("DocumentReference.delete", arguments, 0), this.KT.write([new le(this.xc, oe.ft())]);
      }, e.prototype.onSnapshot = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        cr("DocumentReference.onSnapshot", arguments, 1, 4);
        var n,
            r = {
          includeMetadataChanges: !1
        },
            i = 0;
        "object" != typeof e[i] || Ci(e[i]) || (gr("DocumentReference.onSnapshot", r = e[i], ["includeMetadataChanges"]), fr("DocumentReference.onSnapshot", "boolean", "includeMetadataChanges", r.includeMetadataChanges), i++);
        var o = {
          includeMetadataChanges: r.includeMetadataChanges
        };
        return Ci(e[i]) ? n = e[i] : (lr("DocumentReference.onSnapshot", "function", i, e[i]), hr("DocumentReference.onSnapshot", "function", i + 1, e[i + 1]), hr("DocumentReference.onSnapshot", "function", i + 2, e[i + 2]), n = {
          next: e[i],
          error: e[i + 1],
          complete: e[i + 2]
        }), this.lE(o, n);
      }, e.prototype.lE = function (e, t) {
        var n = this,
            r = function r(e) {
          console.error("Uncaught Error in onSnapshot:", e);
        };

        t.error && (r = t.error.bind(t));
        var i = new Yi({
          next: function next(e) {
            if (t.next) {
              var r = e.docs.get(n.xc);
              t.next(new Hi(n.firestore, n.xc, r, e.fromCache, e.hasPendingWrites, n.aE));
            }
          },
          error: r
        }),
            o = this.KT.listen(Te.Wt(this.xc.path), i, e);
        return function () {
          i.kT(), n.KT.al(o);
        };
      }, e.prototype.get = function (e) {
        var t = this;
        return cr("DocumentReference.get", arguments, 0, 1), Ji("DocumentReference.get", e), new Promise(function (n, r) {
          e && "cache" === e.source ? t.firestore.jT().CT(t.xc).then(function (e) {
            n(new Hi(t.firestore, t.xc, e, !0, e instanceof ve && e.At, t.aE));
          }, r) : t.dE(n, r, e);
        });
      }, e.prototype.dE = function (e, t, n) {
        var r = this.lE({
          includeMetadataChanges: !0,
          Bf: !0
        }, {
          next: function next(i) {
            r(), !i.exists && i.metadata.fromCache ? t(new f(d.UNAVAILABLE, "Failed to get document because the client is offline.")) : i.exists && i.metadata.fromCache && n && "server" === n.source ? t(new f(d.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : e(i);
          },
          error: t
        });
      }, e.prototype.withConverter = function (t) {
        return new e(this.xc, this.firestore, t);
      }, e;
    }(),
        Wi = function () {
      function e(e, t) {
        this.hasPendingWrites = e, this.fromCache = t;
      }

      return e.prototype.isEqual = function (e) {
        return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
      }, e;
    }(),
        Hi = function () {
      function e(e, t, n, r, i, o) {
        this.hE = e, this.xc = t, this.fE = n, this.TE = r, this.EE = i, this.aE = o;
      }

      return e.prototype.data = function (e) {
        if (cr("DocumentSnapshot.data", arguments, 0, 1), e = qi("DocumentSnapshot.data", e), this.fE) {
          if (this.aE) {
            var t = new Bi(this.hE, this.xc, this.fE, this.TE, this.EE);
            return this.aE.fromFirestore(t, e);
          }

          return new Oi(this.hE, this.hE.rE(), e.serverTimestamps, void 0).MT(this.fE.Mt());
        }
      }, e.prototype.get = function (e, t) {
        if (cr("DocumentSnapshot.get", arguments, 1, 2), t = qi("DocumentSnapshot.get", t), this.fE) {
          var n = this.fE.data().field(Zr("DocumentSnapshot.get", e));
          if (null !== n) return new Oi(this.hE, this.hE.rE(), t.serverTimestamps, this.aE).MT(n);
        }
      }, Object.defineProperty(e.prototype, "id", {
        get: function get() {
          return this.xc.path.O();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "ref", {
        get: function get() {
          return new Vi(this.xc, this.hE, this.aE);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "exists", {
        get: function get() {
          return null !== this.fE;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "metadata", {
        get: function get() {
          return new Wi(this.EE, this.TE);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.isEqual = function (t) {
        if (!(t instanceof e)) throw br("isEqual", "DocumentSnapshot", 1, t);
        return this.hE === t.hE && this.TE === t.TE && this.xc.isEqual(t.xc) && (null === this.fE ? null === t.fE : this.fE.isEqual(t.fE)) && this.aE === t.aE;
      }, e;
    }(),
        Bi = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return i.__extends(t, e), t.prototype.data = function (t) {
        return e.prototype.data.call(this, t);
      }, t;
    }(Hi),
        zi = function () {
      function e(e, t, n) {
        this.IE = e, this.firestore = t, this.aE = n;
      }

      return e.prototype.where = function (t, n, r) {
        sr("Query.where", arguments, 3), vr("Query.where", 3, r);

        var i,
            o = function (e, t, n, r) {
          if (!t.some(function (e) {
            return e === r;
          })) throw new f(d.INVALID_ARGUMENT, "Invalid value " + yr(r) + " provided to function Query.where() for its " + Tr(2) + " argument. Acceptable values: " + t.join(", "));
          return r;
        }(0, ["<", "<=", "==", ">=", ">", "array-contains", "in", "array-contains-any"], 0, n),
            a = Zr("Query.where", t);

        if (a.Y()) {
          if ("array-contains" === o || "array-contains-any" === o) throw new f(d.INVALID_ARGUMENT, "Invalid Query. You can't perform '" + o + "' queries on FieldPath.documentId().");

          if ("in" === o) {
            this.wE(r, o);

            for (var s = [], u = 0, c = r; u < c.length; u++) {
              var l = c[u];
              s.push(this.RE(l));
            }

            i = {
              arrayValue: {
                values: s
              }
            };
          } else i = this.RE(r);
        } else "in" !== o && "array-contains-any" !== o || this.wE(r, o), i = this.firestore.XT.Mc("Query.where", r, "in" === o);

        var h = Me.create(a, o, i);
        return this.mE(h), new e(this.IE.Gt(h), this.firestore, this.aE);
      }, e.prototype.orderBy = function (t, n) {
        var r;
        if (cr("Query.orderBy", arguments, 1, 2), hr("Query.orderBy", "non-empty string", 2, n), void 0 === n || "asc" === n) r = "asc";else {
          if ("desc" !== n) throw new f(d.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + n + "', expected 'asc' or 'desc'.");
          r = "desc";
        }
        if (null !== this.IE.startAt) throw new f(d.INVALID_ARGUMENT, "Invalid query. You must not call Query.startAt() or Query.startAfter() before calling Query.orderBy().");
        if (null !== this.IE.endAt) throw new f(d.INVALID_ARGUMENT, "Invalid query. You must not call Query.endAt() or Query.endBefore() before calling Query.orderBy().");
        var i = Zr("Query.orderBy", t),
            o = new Ie(i, r);
        return this.AE(o), new e(this.IE.zt(o), this.firestore, this.aE);
      }, e.prototype.limit = function (t) {
        return sr("Query.limit", arguments, 1), lr("Query.limit", "number", 1, t), wr("Query.limit", 1, t), new e(this.IE.Ht(t), this.firestore, this.aE);
      }, e.prototype.limitToLast = function (t) {
        return sr("Query.limitToLast", arguments, 1), lr("Query.limitToLast", "number", 1, t), wr("Query.limitToLast", 1, t), new e(this.IE.Yt(t), this.firestore, this.aE);
      }, e.prototype.startAt = function (t) {
        for (var n = [], r = 1; r < arguments.length; r++) {
          n[r - 1] = arguments[r];
        }

        ur("Query.startAt", arguments, 1);
        var i = this.PE("Query.startAt", t, n, !0);
        return new e(this.IE.Jt(i), this.firestore, this.aE);
      }, e.prototype.startAfter = function (t) {
        for (var n = [], r = 1; r < arguments.length; r++) {
          n[r - 1] = arguments[r];
        }

        ur("Query.startAfter", arguments, 1);
        var i = this.PE("Query.startAfter", t, n, !1);
        return new e(this.IE.Jt(i), this.firestore, this.aE);
      }, e.prototype.endBefore = function (t) {
        for (var n = [], r = 1; r < arguments.length; r++) {
          n[r - 1] = arguments[r];
        }

        ur("Query.endBefore", arguments, 1);
        var i = this.PE("Query.endBefore", t, n, !0);
        return new e(this.IE.Xt(i), this.firestore, this.aE);
      }, e.prototype.endAt = function (t) {
        for (var n = [], r = 1; r < arguments.length; r++) {
          n[r - 1] = arguments[r];
        }

        ur("Query.endAt", arguments, 1);
        var i = this.PE("Query.endAt", t, n, !1);
        return new e(this.IE.Xt(i), this.firestore, this.aE);
      }, e.prototype.isEqual = function (t) {
        if (!(t instanceof e)) throw br("isEqual", "Query", 1, t);
        return this.firestore === t.firestore && this.IE.isEqual(t.IE);
      }, e.prototype.withConverter = function (t) {
        return new e(this.IE, this.firestore, t);
      }, e.prototype.PE = function (e, t, n, r) {
        if (vr(e, 1, t), t instanceof Hi) {
          if (n.length > 0) throw new f(d.INVALID_ARGUMENT, "Too many arguments provided to " + e + "().");
          var i = t;
          if (!i.exists) throw new f(d.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " + e + "().");
          return this.VE(i.fE, r);
        }

        var o = [t].concat(n);
        return this.gE(e, o, r);
      }, e.prototype.VE = function (e, t) {
        for (var n = [], r = 0, i = this.IE.orderBy; r < i.length; r++) {
          var o = i[r];
          if (o.field.Y()) n.push(z(this.firestore.Lc, e.key));else {
            var a = e.field(o.field);
            if (Y(a)) throw new f(d.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + o.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');

            if (null === a) {
              var s = o.field.j();
              throw new f(d.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a document for which the field '" + s + "' (used as the orderBy) does not exist.");
            }

            n.push(a);
          }
        }

        return new De(n, t);
      }, e.prototype.gE = function (e, t, n) {
        var r = this.IE.Ot;
        if (t.length > r.length) throw new f(d.INVALID_ARGUMENT, "Too many arguments provided to " + e + "(). The number of arguments must be less than or equal to the number of Query.orderBy() clauses");

        for (var i = [], o = 0; o < t.length; o++) {
          var a = t[o];

          if (r[o].field.Y()) {
            if ("string" != typeof a) throw new f(d.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " + e + "(), but got a " + typeof a);
            if (!this.IE._e() && -1 !== a.indexOf("/")) throw new f(d.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by FieldPath.documentId(), the value passed to " + e + "() must be a plain document ID, but '" + a + "' contains a slash.");
            var s = this.IE.path.child(T.K(a));
            if (!k.et(s)) throw new f(d.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by FieldPath.documentId(), the value passed to " + e + "() must result in a valid document path, but '" + s + "' is not because it contains an odd number of segments.");
            var u = new k(s);
            i.push(z(this.firestore.Lc, u));
          } else {
            var c = this.firestore.XT.Mc(e, a);
            i.push(c);
          }
        }

        return new De(i, n);
      }, e.prototype.onSnapshot = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        cr("Query.onSnapshot", arguments, 1, 4);
        var n,
            r = {},
            i = 0;
        return "object" != typeof e[i] || Ci(e[i]) || (gr("Query.onSnapshot", r = e[i], ["includeMetadataChanges"]), fr("Query.onSnapshot", "boolean", "includeMetadataChanges", r.includeMetadataChanges), i++), Ci(e[i]) ? n = e[i] : (lr("Query.onSnapshot", "function", i, e[i]), hr("Query.onSnapshot", "function", i + 1, e[i + 1]), hr("Query.onSnapshot", "function", i + 2, e[i + 2]), n = {
          next: e[i],
          error: e[i + 1],
          complete: e[i + 2]
        }), this.pE(this.IE), this.lE(r, n);
      }, e.prototype.lE = function (e, t) {
        var n = this,
            r = function r(e) {
          console.error("Uncaught Error in onSnapshot:", e);
        };

        t.error && (r = t.error.bind(t));
        var i = new Yi({
          next: function next(e) {
            t.next && t.next(new Zi(n.firestore, n.IE, e, n.aE));
          },
          error: r
        }),
            o = this.firestore.jT(),
            a = o.listen(this.IE, i, e);
        return function () {
          i.kT(), o.al(a);
        };
      }, e.prototype.pE = function (e) {
        if (e.ae() && 0 === e.Ot.length) throw new f(d.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
      }, e.prototype.get = function (e) {
        var t = this;
        return cr("Query.get", arguments, 0, 1), Ji("Query.get", e), this.pE(this.IE), new Promise(function (n, r) {
          e && "cache" === e.source ? t.firestore.jT().FT(t.IE).then(function (e) {
            n(new Zi(t.firestore, t.IE, e, t.aE));
          }, r) : t.dE(n, r, e);
        });
      }, e.prototype.dE = function (e, t, n) {
        var r = this.lE({
          includeMetadataChanges: !0,
          Bf: !0
        }, {
          next: function next(i) {
            r(), i.metadata.fromCache && n && "server" === n.source ? t(new f(d.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : e(i);
          },
          error: t
        });
      }, e.prototype.RE = function (e) {
        if ("string" == typeof e) {
          if ("" === e) throw new f(d.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid document ID, but it was an empty string.");
          if (!this.IE._e() && -1 !== e.indexOf("/")) throw new f(d.INVALID_ARGUMENT, "Invalid query. When querying a collection by FieldPath.documentId(), you must provide a plain document ID, but '" + e + "' contains a '/' character.");
          var t = this.IE.path.child(T.K(e));
          if (!k.et(t)) throw new f(d.INVALID_ARGUMENT, "Invalid query. When querying a collection group by FieldPath.documentId(), the value provided must result in a valid document path, but '" + t + "' is not because it has an odd number of segments (" + t.length + ").");
          return z(this.firestore.Lc, new k(t));
        }

        if (e instanceof Vi) {
          var n = e;
          return z(this.firestore.Lc, n.xc);
        }

        throw new f(d.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid string or a DocumentReference, but it was: " + yr(e) + ".");
      }, e.prototype.wE = function (e, t) {
        if (!Array.isArray(e) || 0 === e.length) throw new f(d.INVALID_ARGUMENT, "Invalid Query. A non-empty array is required for '" + t.toString() + "' filters.");
        if (e.length > 10) throw new f(d.INVALID_ARGUMENT, "Invalid Query. '" + t.toString() + "' filters support a maximum of 10 elements in the value array.");
        if (e.indexOf(null) >= 0) throw new f(d.INVALID_ARGUMENT, "Invalid Query. '" + t.toString() + "' filters cannot contain 'null' in the value array.");
        if (e.filter(function (e) {
          return Number.isNaN(e);
        }).length > 0) throw new f(d.INVALID_ARGUMENT, "Invalid Query. '" + t.toString() + "' filters cannot contain 'NaN' in the value array.");
      }, e.prototype.mE = function (e) {
        if (e instanceof Me) {
          var t = ["array-contains", "array-contains-any"],
              n = ["in", "array-contains-any"],
              r = t.indexOf(e.op) >= 0,
              i = n.indexOf(e.op) >= 0;

          if (e.ue()) {
            var o = this.IE.jt();
            if (null !== o && !o.isEqual(e.field)) throw new f(d.INVALID_ARGUMENT, "Invalid query. All where filters with an inequality (<, <=, >, or >=) must be on the same field. But you have inequality filters on '" + o.toString() + "' and '" + e.field.toString() + "'");
            var a = this.IE.Kt();
            null !== a && this.yE(e.field, a);
          } else if (i || r) {
            var s = null;
            if (i && (s = this.IE.ce(n)), null === s && r && (s = this.IE.ce(t)), null != s) throw s === e.op ? new f(d.INVALID_ARGUMENT, "Invalid query. You cannot use more than one '" + e.op.toString() + "' filter.") : new f(d.INVALID_ARGUMENT, "Invalid query. You cannot use '" + e.op.toString() + "' filters with '" + s.toString() + "' filters.");
          }
        }
      }, e.prototype.AE = function (e) {
        if (null === this.IE.Kt()) {
          var t = this.IE.jt();
          null !== t && this.yE(t, e.field);
        }
      }, e.prototype.yE = function (e, t) {
        if (!t.isEqual(e)) throw new f(d.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality (<, <=, >, or >=) on field '" + e.toString() + "' and so you must also use '" + e.toString() + "' as your first Query.orderBy(), but your first Query.orderBy() is on field '" + t.toString() + "' instead.");
      }, e;
    }(),
        Zi = function () {
      function e(e, t, n, r) {
        this.hE = e, this.bE = t, this.vE = n, this.aE = r, this.SE = null, this.DE = null, this.metadata = new Wi(n.hasPendingWrites, n.fromCache);
      }

      return Object.defineProperty(e.prototype, "docs", {
        get: function get() {
          var e = [];
          return this.forEach(function (t) {
            return e.push(t);
          }), e;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "empty", {
        get: function get() {
          return this.vE.docs.B();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "size", {
        get: function get() {
          return this.vE.docs.size;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.forEach = function (e, t) {
        var n = this;
        cr("QuerySnapshot.forEach", arguments, 1, 2), lr("QuerySnapshot.forEach", "function", 1, e), this.vE.docs.forEach(function (r) {
          e.call(t, n.CE(r));
        });
      }, Object.defineProperty(e.prototype, "query", {
        get: function get() {
          return new zi(this.bE, this.hE, this.aE);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.docChanges = function (e) {
        e && (gr("QuerySnapshot.docChanges", e, ["includeMetadataChanges"]), fr("QuerySnapshot.docChanges", "boolean", "includeMetadataChanges", e.includeMetadataChanges));
        var t = !(!e || !e.includeMetadataChanges);
        if (t && this.vE.hs) throw new f(d.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this.SE && this.DE === t || (this.SE = function (e, t, n, r) {
          if (n.ss.B()) {
            var i = 0;
            return n.docChanges.map(function (t) {
              var o = new Bi(e, t.doc.key, t.doc, n.fromCache, n.ns.has(t.doc.key), r);
              return t.doc, {
                type: "added",
                doc: o,
                oldIndex: -1,
                newIndex: i++
              };
            });
          }

          var o = n.ss;
          return n.docChanges.filter(function (e) {
            return t || 3 !== e.type;
          }).map(function (t) {
            var i = new Bi(e, t.doc.key, t.doc, n.fromCache, n.ns.has(t.doc.key), r),
                a = -1,
                s = -1;
            return 0 !== t.type && (a = o.indexOf(t.doc.key), o = o.delete(t.doc.key)), 1 !== t.type && (s = (o = o.add(t.doc)).indexOf(t.doc.key)), {
              type: Ki(t.type),
              doc: i,
              oldIndex: a,
              newIndex: s
            };
          });
        }(this.hE, t, this.vE, this.aE), this.DE = t), this.SE;
      }, e.prototype.isEqual = function (t) {
        if (!(t instanceof e)) throw br("isEqual", "QuerySnapshot", 1, t);
        return this.hE === t.hE && this.bE.isEqual(t.bE) && this.vE.isEqual(t.vE) && this.aE === t.aE;
      }, e.prototype.CE = function (e) {
        return new Bi(this.hE, e.key, e, this.metadata.fromCache, this.vE.ns.has(e.key), this.aE);
      }, e;
    }(),
        Qi = function (e) {
      function t(t, n, r) {
        var i = this;
        if ((i = e.call(this, Te.Wt(t), n, r) || this).FE = t, t.length % 2 != 1) throw new f(d.INVALID_ARGUMENT, "Invalid collection reference. Collection references must have an odd number of segments, but " + t.j() + " has " + t.length);
        return i;
      }

      return i.__extends(t, e), Object.defineProperty(t.prototype, "id", {
        get: function get() {
          return this.IE.path.O();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "parent", {
        get: function get() {
          var e = this.IE.path.M();
          return e.B() ? null : new Vi(new k(e), this.firestore);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "path", {
        get: function get() {
          return this.IE.path.j();
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.doc = function (e) {
        if (cr("CollectionReference.doc", arguments, 0, 1), 0 === arguments.length && (e = Mt.cn()), lr("CollectionReference.doc", "non-empty string", 1, e), "" === e) throw new f(d.INVALID_ARGUMENT, "Document path must be a non-empty string");
        var t = T.K(e);
        return Vi.nE(this.IE.path.child(t), this.firestore, this.aE);
      }, t.prototype.add = function (e) {
        sr("CollectionReference.add", arguments, 1), lr("CollectionReference.add", "object", 1, this.aE ? this.aE.toFirestore(e) : e);
        var t = this.doc();
        return t.set(e).then(function () {
          return t;
        });
      }, t.prototype.withConverter = function (e) {
        return new t(this.FE, this.firestore, e);
      }, t;
    }(zi);
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Gi(e, t) {
      if (void 0 === t) return {
        merge: !1
      };
      if (gr(e, t, ["merge", "mergeFields"]), fr(e, "boolean", "merge", t.merge), function (e, t, n, r, i) {
        void 0 !== r && function (e, t, n, r, i) {
          if (!(r instanceof Array)) throw new f(d.INVALID_ARGUMENT, "Function " + e + "() requires its " + t + " option to be an array, but it was: " + yr(r));

          for (var o = 0; o < r.length; ++o) {
            if (!i(r[o])) throw new f(d.INVALID_ARGUMENT, "Function " + e + "() requires all " + t + " elements to be a string or a FieldPath, but the value at index " + o + " was: " + yr(r[o]));
          }
        }(e, "mergeFields", 0, r, function (e) {
          return "string" == typeof e || e instanceof Sr;
        });
      }(e, 0, 0, t.mergeFields), void 0 !== t.mergeFields && void 0 !== t.merge) throw new f(d.INVALID_ARGUMENT, "Invalid options passed to function " + e + '(): You cannot specify both "merge" and "mergeFields".');
      return t;
    }

    function qi(e, t) {
      return void 0 === t ? {} : (gr(e, t, ["serverTimestamps"]), pr(e, 0, "serverTimestamps", t.serverTimestamps, ["estimate", "previous", "none"]), t);
    }

    function Ji(e, t) {
      hr(e, "object", 1, t), t && (gr(e, t, ["source"]), pr(e, 0, "source", t.source, ["default", "server", "cache"]));
    }

    function Xi(e, t, n) {
      if (t instanceof Vi) {
        if (t.firestore !== n) throw new f(d.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
        return t;
      }

      throw br(e, "DocumentReference", 1, t);
    }

    function Ki(e) {
      switch (e) {
        case 0:
          return "added";

        case 2:
        case 3:
          return "modified";

        case 1:
          return "removed";

        default:
          return bt();
      }
    }

    function $i(e, t, n) {
      var r;
      return e ? (r = e.toFirestore(t), n = "toFirestore() in " + n) : r = t, [r, n];
    }

    function eo(e, t) {
      function n() {
        var e = "This constructor is private.";
        throw t && (e += " ", e += t), new f(d.INVALID_ARGUMENT, e);
      }

      return n.prototype = e.prototype, Object.assign(n, e), n;
    }
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var to = eo(ji, "Use firebase.firestore() instead."),
        no = eo(Ui, "Use firebase.firestore().runTransaction() instead."),
        ro = eo(Pi, "Use firebase.firestore().batch() instead."),
        io = eo(Vi, "Use firebase.firestore().doc() instead."),
        oo = eo(Hi),
        ao = eo(Bi),
        so = eo(zi),
        uo = eo(Zi),
        co = eo(Qi, "Use firebase.firestore().collection() instead."),
        lo = eo(function () {
      function e() {}

      return e.delete = function () {
        return ar("FieldValue.delete", arguments), new Ir();
      }, e.serverTimestamp = function () {
        return ar("FieldValue.serverTimestamp", arguments), new Rr();
      }, e.arrayUnion = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        return ur("FieldValue.arrayUnion", arguments, 1), new xr(e);
      }, e.arrayRemove = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        return ur("FieldValue.arrayRemove", arguments, 1), new Yr(e);
      }, e.increment = function (e) {
        return lr("FieldValue.increment", "number", 1, e), sr("FieldValue.increment", arguments, 1), new Cr(e);
      }, e.prototype.isEqual = function (e) {
        return this === e;
      }, e;
    }(), "Use FieldValue.<field>() instead."),
        ho = eo(Lr, "Use Blob.fromUint8Array() or Blob.fromBase64String() instead."),
        fo = {
      Firestore: to,
      GeoPoint: Or,
      Timestamp: g,
      Blob: ho,
      Transaction: no,
      WriteBatch: ro,
      DocumentReference: io,
      DocumentSnapshot: oo,
      Query: so,
      QueryDocumentSnapshot: ao,
      QuerySnapshot: uo,
      CollectionReference: co,
      FieldPath: Sr,
      FieldValue: lo,
      setLogLevel: ji.setLogLevel,
      CACHE_SIZE_UNLIMITED: Fi
    },
        po = function () {
      function e() {}

      return e.prototype.Q_ = function (e) {}, e.prototype.Iu = function () {}, e;
    }(),
        mo = function () {
      function e() {
        var e = this;
        this.NE = function () {
          return e.kE();
        }, this.$E = function () {
          return e.ME();
        }, this.LE = [], this.xE();
      }

      return e.prototype.Q_ = function (e) {
        this.LE.push(e);
      }, e.prototype.Iu = function () {
        window.removeEventListener("online", this.NE), window.removeEventListener("offline", this.$E);
      }, e.prototype.xE = function () {
        window.addEventListener("online", this.NE), window.addEventListener("offline", this.$E);
      }, e.prototype.kE = function () {
        yt("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");

        for (var e = 0, t = this.LE; e < t.length; e++) {
          (0, t[e])(0);
        }
      }, e.prototype.ME = function () {
        yt("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");

        for (var e = 0, t = this.LE; e < t.length; e++) {
          (0, t[e])(1);
        }
      }, e.so = function () {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
      }, e;
    }(),
        _o = function () {
      function e(e) {
        this.OE = e.OE, this.BE = e.BE;
      }

      return e.prototype.n_ = function (e) {
        this.qE = e;
      }, e.prototype.Zc = function (e) {
        this.UE = e;
      }, e.prototype.onMessage = function (e) {
        this.QE = e;
      }, e.prototype.close = function () {
        this.BE();
      }, e.prototype.send = function (e) {
        this.OE(e);
      }, e.prototype.WE = function () {
        this.qE();
      }, e.prototype.jE = function (e) {
        this.UE(e);
      }, e.prototype.KE = function (e) {
        this.QE(e);
      }, e;
    }(),
        yo = {
      BatchGetDocuments: "batchGet",
      Commit: "commit"
    },
        vo = "gl-js/ fire/" + l,
        go = function () {
      function e(e) {
        this.ii = e.ii;
        var t = e.ssl ? "https" : "http";
        this.GE = t + "://" + e.host, this.forceLongPolling = e.forceLongPolling;
      }

      return e.prototype.zE = function (e, t) {
        if (t) for (var n in t.o) {
          t.o.hasOwnProperty(n) && (e[n] = t.o[n]);
        }
        e["X-Goog-Api-Client"] = vo;
      }, e.prototype.E_ = function (e, t, n) {
        var r = this,
            i = this.HE(e);
        return new Promise(function (o, a) {
          var s = new c.XhrIo();
          s.listenOnce(c.EventType.COMPLETE, function () {
            try {
              switch (s.getLastErrorCode()) {
                case c.ErrorCode.NO_ERROR:
                  var t = s.getResponseJson();
                  yt("Connection", "XHR received:", JSON.stringify(t)), o(t);
                  break;

                case c.ErrorCode.TIMEOUT:
                  yt("Connection", 'RPC "' + e + '" timed out'), a(new f(d.DEADLINE_EXCEEDED, "Request time out"));
                  break;

                case c.ErrorCode.HTTP_ERROR:
                  var n = s.getStatus();

                  if (yt("Connection", 'RPC "' + e + '" failed with status:', n, "response text:", s.getResponseText()), n > 0) {
                    var r = s.getResponseJson().error;

                    if (r && r.status && r.message) {
                      var i = function (e) {
                        var t = r.status.toLowerCase().replace("_", "-");
                        return Object.values(d).indexOf(t) >= 0 ? t : d.UNKNOWN;
                      }();

                      a(new f(i, r.message));
                    } else a(new f(d.UNKNOWN, "Server responded with status " + s.getStatus()));
                  } else yt("Connection", 'RPC "' + e + '" failed'), a(new f(d.UNAVAILABLE, "Connection failed."));

                  break;

                default:
                  bt();
              }
            } finally {
              yt("Connection", 'RPC "' + e + '" completed.');
            }
          });
          var u = Object.assign({}, t);
          delete u.database;
          var l = JSON.stringify(u);
          yt("Connection", "XHR sending: ", i + " " + l);
          var h = {
            "Content-Type": "text/plain"
          };
          r.zE(h, n), s.send(i, "POST", l, h, 15);
        });
      }, e.prototype.I_ = function (e, t, n) {
        return this.E_(e, t, n);
      }, e.prototype.r_ = function (e, t) {
        var n = [this.GE, "/", "google.firestore.v1.Firestore", "/", e, "/channel"],
            r = c.createWebChannelTransport(),
            i = {
          httpSessionIdParam: "gsessionid",
          initMessageHeaders: {},
          messageUrlParams: {
            database: "projects/" + this.ii.projectId + "/databases/" + this.ii.database
          },
          sendRawJson: !0,
          supportsCrossDomainXhr: !0,
          internalChannelParams: {
            forwardChannelRequestTimeoutMs: 6e5
          },
          forceLongPolling: this.forceLongPolling
        };
        this.zE(i.initMessageHeaders, t), s.isMobileCordova() || s.isReactNative() || s.isElectron() || s.isIE() || s.isUWP() || s.isBrowserExtension() || (i.httpHeadersOverwriteParam = "$httpHeaders");
        var o = n.join("");
        yt("Connection", "Creating WebChannel: " + o + " " + i);

        var a = r.createWebChannel(o, i),
            u = !1,
            l = !1,
            h = new _o({
          OE: function OE(e) {
            l ? yt("Connection", "Not sending because WebChannel is closed:", e) : (u || (yt("Connection", "Opening WebChannel transport."), a.open(), u = !0), yt("Connection", "WebChannel sending:", e), a.send(e));
          },
          BE: function BE() {
            return a.close();
          }
        }),
            p = function p(e, t) {
          a.listen(e, function (e) {
            try {
              t(e);
            } catch (e) {
              setTimeout(function () {
                throw e;
              }, 0);
            }
          });
        };

        return p(c.WebChannel.EventType.OPEN, function () {
          l || yt("Connection", "WebChannel transport opened.");
        }), p(c.WebChannel.EventType.CLOSE, function () {
          l || (l = !0, yt("Connection", "WebChannel transport closed"), h.jE());
        }), p(c.WebChannel.EventType.ERROR, function (e) {
          l || (l = !0, yt("Connection", "WebChannel transport errored:", e), h.jE(new f(d.UNAVAILABLE, "The operation could not be completed")));
        }), p(c.WebChannel.EventType.MESSAGE, function (e) {
          var t;

          if (!l) {
            var n = e.data[0];
            wt(!!n);
            var r = n,
                i = r.error || (null === (t = r[0]) || void 0 === t ? void 0 : t.error);

            if (i) {
              yt("Connection", "WebChannel received error:", i);

              var o = i.status,
                  s = function (e) {
                var t = me[o];
                if (void 0 !== t) return Ce(t);
              }(),
                  u = i.message;

              void 0 === s && (s = d.INTERNAL, u = "Unknown error status: " + o + " with message " + i.message), l = !0, h.jE(new f(s, u)), a.close();
            } else yt("Connection", "WebChannel received:", n), h.KE(n);
          }
        }), setTimeout(function () {
          h.WE();
        }, 0), h;
      }, e.prototype.HE = function (e) {
        var t = yo[e];
        return this.GE + "/v1/projects/" + this.ii.projectId + "/databases/" + this.ii.database + "/documents:" + t;
      }, e;
    }();
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function bo(e) {
      !function (e, t) {
        e.INTERNAL.registerComponent(new u.Component("firestore", function (e) {
          return function (e, t) {
            return new ji(e, t, new Ri());
          }(e.getProvider("app").getImmediate(), e.getProvider("auth-internal"));
        }, "PUBLIC").setServiceProps(Object.assign({}, fo)));
      }(e), e.registerVersion("@firebase/firestore", "1.14.3");
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */
    }

    ft.an(new (function () {
      function e() {
        this._c = "undefined" != typeof atob;
      }

      return Object.defineProperty(e.prototype, "document", {
        get: function get() {
          return "undefined" != typeof document ? document : null;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "window", {
        get: function get() {
          return "undefined" != typeof window ? window : null;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.bT = function (e) {
        return Promise.resolve(new go(e));
      }, e.prototype.AT = function () {
        return mo.so() ? new mo() : new po();
      }, e.prototype.Dc = function (e) {
        return new ht(e, {
          hi: !0
        });
      }, e.prototype.un = function (e) {
        return JSON.stringify(e);
      }, e.prototype.atob = function (e) {
        return atob(e);
      }, e.prototype.btoa = function (e) {
        return btoa(e);
      }, e.prototype._n = function (e) {
        var t = "undefined" != typeof self && (self.crypto || self.msCrypto),
            n = new Uint8Array(e);
        if (t) t.getRandomValues(n);else for (var r = 0; r < e; r++) {
          n[r] = Math.floor(256 * Math.random());
        }
        return n;
      }, e;
    }())()), bo(o), t.__PRIVATE_registerFirestore = bo;
  }, function (e, t, n) {
    "use strict";

    n.r(t), function (e) {
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */
      function r(e) {
        var t = "function" == typeof Symbol && Symbol.iterator,
            n = t && e[t],
            r = 0;
        if (n) return n.call(e);
        if (e && "number" == typeof e.length) return {
          next: function next() {
            return e && r >= e.length && (e = void 0), {
              value: e && e[r++],
              done: !e
            };
          }
        };
        throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }

      n.d(t, "ErrorCode", function () {
        return Xn;
      }), n.d(t, "EventType", function () {
        return Kn;
      }), n.d(t, "WebChannel", function () {
        return $n;
      }), n.d(t, "XhrIo", function () {
        return er;
      }), n.d(t, "createWebChannelTransport", function () {
        return Jn;
      });
      var i,
          o = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : {},
          a = a || {},
          s = o || self;

      function u() {}

      function c(e) {
        var t = typeof e;

        if ("object" == t) {
          if (!e) return "null";
          if (e instanceof Array) return "array";
          if (e instanceof Object) return t;
          var n = Object.prototype.toString.call(e);
          if ("[object Window]" == n) return "object";
          if ("[object Array]" == n || "number" == typeof e.length && void 0 !== e.splice && void 0 !== e.propertyIsEnumerable && !e.propertyIsEnumerable("splice")) return "array";
          if ("[object Function]" == n || void 0 !== e.call && void 0 !== e.propertyIsEnumerable && !e.propertyIsEnumerable("call")) return "function";
        } else if ("function" == t && void 0 === e.call) return "object";

        return t;
      }

      function l(e) {
        var t = c(e);
        return "array" == t || "object" == t && "number" == typeof e.length;
      }

      function h(e) {
        var t = typeof e;
        return "object" == t && null != e || "function" == t;
      }

      var d = "closure_uid_" + (1e9 * Math.random() >>> 0),
          f = 0;

      function p(e, t, n) {
        return e.call.apply(e.bind, arguments);
      }

      function m(e, t, n) {
        if (!e) throw Error();

        if (2 < arguments.length) {
          var r = Array.prototype.slice.call(arguments, 2);
          return function () {
            var n = Array.prototype.slice.call(arguments);
            return Array.prototype.unshift.apply(n, r), e.apply(t, n);
          };
        }

        return function () {
          return e.apply(t, arguments);
        };
      }

      function _(e, t, n) {
        return (_ = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? p : m).apply(null, arguments);
      }

      function y(e, t) {
        var n = Array.prototype.slice.call(arguments, 1);
        return function () {
          var t = n.slice();
          return t.push.apply(t, arguments), e.apply(this, t);
        };
      }

      var v = Date.now || function () {
        return +new Date();
      };

      function g(e, t) {
        function n() {}

        n.prototype = t.prototype, e.M = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
      }

      function b() {
        this.j = this.j, this.i = this.i;
      }

      b.prototype.j = !1, b.prototype.da = function () {
        if (!this.j && (this.j = !0, this.C(), 0)) (function (e) {
          Object.prototype.hasOwnProperty.call(e, d) && e[d] || (e[d] = ++f);
        })(this);
      }, b.prototype.C = function () {
        if (this.i) for (; this.i.length;) {
          this.i.shift()();
        }
      };
      var w = Array.prototype.indexOf ? function (e, t) {
        return Array.prototype.indexOf.call(e, t, void 0);
      } : function (e, t) {
        if ("string" == typeof e) return "string" != typeof t || 1 != t.length ? -1 : e.indexOf(t, 0);

        for (var n = 0; n < e.length; n++) {
          if (n in e && e[n] === t) return n;
        }

        return -1;
      },
          T = Array.prototype.forEach ? function (e, t, n) {
        Array.prototype.forEach.call(e, t, n);
      } : function (e, t, n) {
        for (var r = e.length, i = "string" == typeof e ? e.split("") : e, o = 0; o < r; o++) {
          o in i && t.call(n, i[o], o, e);
        }
      };

      function M(e) {
        return Array.prototype.concat.apply([], arguments);
      }

      function E(e) {
        var t = e.length;

        if (0 < t) {
          for (var n = Array(t), r = 0; r < t; r++) {
            n[r] = e[r];
          }

          return n;
        }

        return [];
      }

      function k(e) {
        return /^[\s\xa0]*$/.test(e);
      }

      var L,
          S = String.prototype.trim ? function (e) {
        return e.trim();
      } : function (e) {
        return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(e)[1];
      };

      function N(e, t) {
        return -1 != e.indexOf(t);
      }

      function D(e, t) {
        return e < t ? -1 : e > t ? 1 : 0;
      }

      e: {
        var I = s.navigator;

        if (I) {
          var R = I.userAgent;

          if (R) {
            L = R;
            break e;
          }
        }

        L = "";
      }

      function x(e, t, n) {
        for (var r in e) {
          t.call(n, e[r], r, e);
        }
      }

      function Y(e) {
        var t = {};

        for (var n in e) {
          t[n] = e[n];
        }

        return t;
      }

      var C = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");

      function O(e, t) {
        for (var n, r, i = 1; i < arguments.length; i++) {
          for (n in r = arguments[i]) {
            e[n] = r[n];
          }

          for (var o = 0; o < C.length; o++) {
            n = C[o], Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }
      }

      function F(e) {
        return F[" "](e), e;
      }

      F[" "] = u;
      var A,
          j,
          U = N(L, "Opera"),
          P = N(L, "Trident") || N(L, "MSIE"),
          V = N(L, "Edge"),
          W = V || P,
          H = N(L, "Gecko") && !(N(L.toLowerCase(), "webkit") && !N(L, "Edge")) && !(N(L, "Trident") || N(L, "MSIE")) && !N(L, "Edge"),
          B = N(L.toLowerCase(), "webkit") && !N(L, "Edge");

      function z() {
        var e = s.document;
        return e ? e.documentMode : void 0;
      }

      e: {
        var Z = "",
            Q = (j = L, H ? /rv:([^\);]+)(\)|;)/.exec(j) : V ? /Edge\/([\d\.]+)/.exec(j) : P ? /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(j) : B ? /WebKit\/(\S+)/.exec(j) : U ? /(?:Version)[ \/]?(\S+)/.exec(j) : void 0);

        if (Q && (Z = Q ? Q[1] : ""), P) {
          var G = z();

          if (null != G && G > parseFloat(Z)) {
            A = String(G);
            break e;
          }
        }

        A = Z;
      }

      var q,
          J = {};

      function X(e) {
        return function (e, t) {
          var n = J;
          return Object.prototype.hasOwnProperty.call(n, e) ? n[e] : n[e] = t(e);
        }(e, function () {
          for (var t = 0, n = S(String(A)).split("."), r = S(String(e)).split("."), i = Math.max(n.length, r.length), o = 0; 0 == t && o < i; o++) {
            var a = n[o] || "",
                s = r[o] || "";

            do {
              if (a = /(\d*)(\D*)(.*)/.exec(a) || ["", "", "", ""], s = /(\d*)(\D*)(.*)/.exec(s) || ["", "", "", ""], 0 == a[0].length && 0 == s[0].length) break;
              t = D(0 == a[1].length ? 0 : parseInt(a[1], 10), 0 == s[1].length ? 0 : parseInt(s[1], 10)) || D(0 == a[2].length, 0 == s[2].length) || D(a[2], s[2]), a = a[3], s = s[3];
            } while (0 == t);
          }

          return 0 <= t;
        });
      }

      if (s.document && P) {
        var K = z();
        q = K || parseInt(A, 10) || void 0;
      } else q = void 0;

      var $ = q,
          ee = !P || 9 <= Number($),
          te = P && !X("9"),
          ne = function () {
        if (!s.addEventListener || !Object.defineProperty) return !1;
        var e = !1,
            t = Object.defineProperty({}, "passive", {
          get: function get() {
            e = !0;
          }
        });

        try {
          s.addEventListener("test", u, t), s.removeEventListener("test", u, t);
        } catch (e) {}

        return e;
      }();

      function re(e, t) {
        this.type = e, this.a = this.target = t, this.defaultPrevented = !1;
      }

      function ie(e, t) {
        if (re.call(this, e ? e.type : ""), this.relatedTarget = this.a = this.target = null, this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0, this.key = "", this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1, this.pointerId = 0, this.pointerType = "", this.c = null, e) {
          var n = this.type = e.type,
              r = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : null;

          if (this.target = e.target || e.srcElement, this.a = t, t = e.relatedTarget) {
            if (H) {
              e: {
                try {
                  F(t.nodeName);
                  var i = !0;
                  break e;
                } catch (e) {}

                i = !1;
              }

              i || (t = null);
            }
          } else "mouseover" == n ? t = e.fromElement : "mouseout" == n && (t = e.toElement);

          this.relatedTarget = t, r ? (this.clientX = void 0 !== r.clientX ? r.clientX : r.pageX, this.clientY = void 0 !== r.clientY ? r.clientY : r.pageY, this.screenX = r.screenX || 0, this.screenY = r.screenY || 0) : (this.clientX = void 0 !== e.clientX ? e.clientX : e.pageX, this.clientY = void 0 !== e.clientY ? e.clientY : e.pageY, this.screenX = e.screenX || 0, this.screenY = e.screenY || 0), this.button = e.button, this.key = e.key || "", this.ctrlKey = e.ctrlKey, this.altKey = e.altKey, this.shiftKey = e.shiftKey, this.metaKey = e.metaKey, this.pointerId = e.pointerId || 0, this.pointerType = "string" == typeof e.pointerType ? e.pointerType : oe[e.pointerType] || "", this.c = e, e.defaultPrevented && this.b();
        }
      }

      re.prototype.b = function () {
        this.defaultPrevented = !0;
      }, g(ie, re);
      var oe = {
        2: "touch",
        3: "pen",
        4: "mouse"
      };

      ie.prototype.b = function () {
        ie.M.b.call(this);
        var e = this.c;
        if (e.preventDefault) e.preventDefault();else if (e.returnValue = !1, te) try {
          (e.ctrlKey || 112 <= e.keyCode && 123 >= e.keyCode) && (e.keyCode = -1);
        } catch (e) {}
      };

      var ae = "closure_listenable_" + (1e6 * Math.random() | 0),
          se = 0;

      function ue(e, t, n, r, i) {
        this.listener = e, this.proxy = null, this.src = t, this.type = n, this.capture = !!r, this.aa = i, this.key = ++se, this.V = this.X = !1;
      }

      function ce(e) {
        e.V = !0, e.listener = null, e.proxy = null, e.src = null, e.aa = null;
      }

      function le(e) {
        this.src = e, this.a = {}, this.b = 0;
      }

      function he(e, t) {
        var n = t.type;

        if (n in e.a) {
          var r,
              i = e.a[n],
              o = w(i, t);
          (r = 0 <= o) && Array.prototype.splice.call(i, o, 1), r && (ce(t), 0 == e.a[n].length && (delete e.a[n], e.b--));
        }
      }

      function de(e, t, n, r) {
        for (var i = 0; i < e.length; ++i) {
          var o = e[i];
          if (!o.V && o.listener == t && o.capture == !!n && o.aa == r) return i;
        }

        return -1;
      }

      le.prototype.add = function (e, t, n, r, i) {
        var o = e.toString();
        (e = this.a[o]) || (e = this.a[o] = [], this.b++);
        var a = de(e, t, r, i);
        return -1 < a ? (t = e[a], n || (t.X = !1)) : ((t = new ue(t, this.src, o, !!r, i)).X = n, e.push(t)), t;
      };

      var fe = "closure_lm_" + (1e6 * Math.random() | 0),
          pe = {};

      function me(e, t, n, r, i) {
        if (r && r.once) return function e(t, n, r, i, o) {
          if (Array.isArray(n)) {
            for (var a = 0; a < n.length; a++) {
              e(t, n[a], r, i, o);
            }

            return null;
          }

          r = Me(r);
          return t && t[ae] ? t.sa(n, r, h(i) ? !!i.capture : !!i, o) : _e(t, n, r, !0, i, o);
        }(e, t, n, r, i);

        if (Array.isArray(t)) {
          for (var o = 0; o < t.length; o++) {
            me(e, t[o], n, r, i);
          }

          return null;
        }

        return n = Me(n), e && e[ae] ? e.ra(t, n, h(r) ? !!r.capture : !!r, i) : _e(e, t, n, !1, r, i);
      }

      function _e(e, t, n, r, i, o) {
        if (!t) throw Error("Invalid event type");
        var a = h(i) ? !!i.capture : !!i;
        if (a && !ee) return null;
        var s = we(e);
        if (s || (e[fe] = s = new le(e)), (n = s.add(t, n, r, a, o)).proxy) return n;
        if (r = function () {
          var e = be,
              t = ee ? function (n) {
            return e.call(t.src, t.listener, n);
          } : function (n) {
            if (!(n = e.call(t.src, t.listener, n))) return n;
          };
          return t;
        }(), n.proxy = r, r.src = e, r.listener = n, e.addEventListener) ne || (i = a), void 0 === i && (i = !1), e.addEventListener(t.toString(), r, i);else if (e.attachEvent) e.attachEvent(ve(t.toString()), r);else {
          if (!e.addListener || !e.removeListener) throw Error("addEventListener and attachEvent are unavailable.");
          e.addListener(r);
        }
        return n;
      }

      function ye(e) {
        if ("number" != typeof e && e && !e.V) {
          var t = e.src;
          if (t && t[ae]) he(t.c, e);else {
            var n = e.type,
                r = e.proxy;
            t.removeEventListener ? t.removeEventListener(n, r, e.capture) : t.detachEvent ? t.detachEvent(ve(n), r) : t.addListener && t.removeListener && t.removeListener(r), (n = we(t)) ? (he(n, e), 0 == n.b && (n.src = null, t[fe] = null)) : ce(e);
          }
        }
      }

      function ve(e) {
        return e in pe ? pe[e] : pe[e] = "on" + e;
      }

      function ge(e, t) {
        var n = e.listener,
            r = e.aa || e.src;
        return e.X && ye(e), n.call(r, t);
      }

      function be(e, t) {
        if (e.V) return !0;

        if (!ee) {
          if (!t) e: {
            t = ["window", "event"];

            for (var n = s, r = 0; r < t.length; r++) {
              if (null == (n = n[t[r]])) {
                t = null;
                break e;
              }
            }

            t = n;
          }
          return ge(e, t = new ie(t, this));
        }

        return ge(e, new ie(t, this));
      }

      function we(e) {
        return (e = e[fe]) instanceof le ? e : null;
      }

      var Te = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);

      function Me(e) {
        return "function" == c(e) ? e : (e[Te] || (e[Te] = function (t) {
          return e.handleEvent(t);
        }), e[Te]);
      }

      function Ee() {
        b.call(this), this.c = new le(this), this.J = this, this.A = null;
      }

      function ke(e, t, n, r) {
        if (!(t = e.c.a[String(t)])) return !0;
        t = t.concat();

        for (var i = !0, o = 0; o < t.length; ++o) {
          var a = t[o];

          if (a && !a.V && a.capture == n) {
            var s = a.listener,
                u = a.aa || a.src;
            a.X && he(e.c, a), i = !1 !== s.call(u, r) && i;
          }
        }

        return i && !r.defaultPrevented;
      }

      g(Ee, b), Ee.prototype[ae] = !0, (i = Ee.prototype).addEventListener = function (e, t, n, r) {
        me(this, e, t, n, r);
      }, i.removeEventListener = function (e, t, n, r) {
        !function e(t, n, r, i, o) {
          if (Array.isArray(n)) for (var a = 0; a < n.length; a++) {
            e(t, n[a], r, i, o);
          } else i = h(i) ? !!i.capture : !!i, r = Me(r), t && t[ae] ? (t = t.c, (n = String(n).toString()) in t.a && -1 < (r = de(a = t.a[n], r, i, o)) && (ce(a[r]), Array.prototype.splice.call(a, r, 1), 0 == a.length && (delete t.a[n], t.b--))) : t && (t = we(t)) && (n = t.a[n.toString()], t = -1, n && (t = de(n, r, i, o)), (r = -1 < t ? n[t] : null) && ye(r));
        }(this, e, t, n, r);
      }, i.dispatchEvent = function (e) {
        var t,
            n = this.A;
        if (n) for (t = []; n; n = n.A) {
          t.push(n);
        }
        n = this.J;
        var r = e.type || e;
        if ("string" == typeof e) e = new re(e, n);else if (e instanceof re) e.target = e.target || n;else {
          var i = e;
          O(e = new re(r, n), i);
        }
        if (i = !0, t) for (var o = t.length - 1; 0 <= o; o--) {
          var a = e.a = t[o];
          i = ke(a, r, !0, e) && i;
        }
        if (i = ke(a = e.a = n, r, !0, e) && i, i = ke(a, r, !1, e) && i, t) for (o = 0; o < t.length; o++) {
          i = ke(a = e.a = t[o], r, !1, e) && i;
        }
        return i;
      }, i.C = function () {
        if (Ee.M.C.call(this), this.c) {
          var e,
              t = this.c;

          for (e in t.a) {
            for (var n = t.a[e], r = 0; r < n.length; r++) {
              ce(n[r]);
            }

            delete t.a[e], t.b--;
          }
        }

        this.A = null;
      }, i.ra = function (e, t, n, r) {
        return this.c.add(String(e), t, !1, n, r);
      }, i.sa = function (e, t, n, r) {
        return this.c.add(String(e), t, !0, n, r);
      };
      var Le = s.JSON.stringify;

      function Se() {
        this.b = this.a = null;
      }

      var Ne,
          De = new (function () {
        function e(e, t, n) {
          this.f = n, this.c = e, this.g = t, this.b = 0, this.a = null;
        }

        return e.prototype.get = function () {
          var e;
          return 0 < this.b ? (this.b--, e = this.a, this.a = e.next, e.next = null) : e = this.c(), e;
        }, e;
      }())(function () {
        return new Re();
      }, function (e) {
        e.reset();
      }, 100);

      function Ie() {
        var e = Oe,
            t = null;
        return e.a && (t = e.a, e.a = e.a.next, e.a || (e.b = null), t.next = null), t;
      }

      function Re() {
        this.next = this.b = this.a = null;
      }

      function xe(e) {
        s.setTimeout(function () {
          throw e;
        }, 0);
      }

      function Ye(e, t) {
        Ne || function () {
          var e = s.Promise.resolve(void 0);

          Ne = function Ne() {
            e.then(Fe);
          };
        }(), Ce || (Ne(), Ce = !0), Oe.add(e, t);
      }

      Se.prototype.add = function (e, t) {
        var n = De.get();
        n.set(e, t), this.b ? this.b.next = n : this.a = n, this.b = n;
      }, Re.prototype.set = function (e, t) {
        this.a = e, this.b = t, this.next = null;
      }, Re.prototype.reset = function () {
        this.next = this.b = this.a = null;
      };
      var Ce = !1,
          Oe = new Se();

      function Fe() {
        for (var e; e = Ie();) {
          try {
            e.a.call(e.b);
          } catch (e) {
            xe(e);
          }

          var t = De;
          t.g(e), t.b < t.f && (t.b++, e.next = t.a, t.a = e);
        }

        Ce = !1;
      }

      function Ae(e, t) {
        Ee.call(this), this.b = e || 1, this.a = t || s, this.f = _(this.Ua, this), this.g = v();
      }

      function je(e) {
        e.Z = !1, e.L && (e.a.clearTimeout(e.L), e.L = null);
      }

      function Ue(e, t, n) {
        if ("function" == c(e)) n && (e = _(e, n));else {
          if (!e || "function" != typeof e.handleEvent) throw Error("Invalid listener argument");
          e = _(e.handleEvent, e);
        }
        return 2147483647 < Number(t) ? -1 : s.setTimeout(e, t || 0);
      }

      function Pe(e, t, n) {
        b.call(this), this.f = null != n ? _(e, n) : e, this.c = t, this.b = _(this.Pa, this), this.a = [];
      }

      function Ve(e) {
        e.T = Ue(e.b, e.c), e.f.apply(null, e.a);
      }

      function We(e) {
        b.call(this), this.b = e, this.a = {};
      }

      g(Ae, Ee), (i = Ae.prototype).Z = !1, i.L = null, i.Ua = function () {
        if (this.Z) {
          var e = v() - this.g;
          0 < e && e < .8 * this.b ? this.L = this.a.setTimeout(this.f, this.b - e) : (this.L && (this.a.clearTimeout(this.L), this.L = null), this.dispatchEvent("tick"), this.Z && (je(this), this.start()));
        }
      }, i.start = function () {
        this.Z = !0, this.L || (this.L = this.a.setTimeout(this.f, this.b), this.g = v());
      }, i.C = function () {
        Ae.M.C.call(this), je(this), delete this.a;
      }, g(Pe, b), (i = Pe.prototype).ba = !1, i.T = null, i.Ia = function (e) {
        this.a = arguments, this.T ? this.ba = !0 : Ve(this);
      }, i.C = function () {
        Pe.M.C.call(this), this.T && (s.clearTimeout(this.T), this.T = null, this.ba = !1, this.a = []);
      }, i.Pa = function () {
        this.T = null, this.ba && (this.ba = !1, Ve(this));
      }, g(We, b);
      var He = [];

      function Be(e, t, n, r) {
        Array.isArray(n) || (n && (He[0] = n.toString()), n = He);

        for (var i = 0; i < n.length; i++) {
          var o = me(t, n[i], r || e.handleEvent, !1, e.b || e);
          if (!o) break;
          e.a[o.key] = o;
        }
      }

      function ze(e) {
        x(e.a, function (e, t) {
          this.a.hasOwnProperty(t) && ye(e);
        }, e), e.a = {};
      }

      function Ze() {}

      We.prototype.C = function () {
        We.M.C.call(this), ze(this);
      }, We.prototype.handleEvent = function () {
        throw Error("EventHandler.handleEvent not implemented");
      };
      var Qe = null;

      function Ge() {
        return Qe = Qe || new Ee();
      }

      function qe(e) {
        re.call(this, "serverreachability", e);
      }

      function Je(e) {
        var t = Ge();
        t.dispatchEvent(new qe(t, e));
      }

      function Xe(e) {
        re.call(this, "statevent", e);
      }

      function Ke(e) {
        var t = Ge();
        t.dispatchEvent(new Xe(t, e));
      }

      function $e(e) {
        re.call(this, "timingevent", e);
      }

      function et(e, t) {
        if ("function" != c(e)) throw Error("Fn must not be null and must be a function");
        return s.setTimeout(function () {
          e();
        }, t);
      }

      g(qe, re), g(Xe, re), g($e, re);
      var tt = {
        NO_ERROR: 0,
        Va: 1,
        bb: 2,
        ab: 3,
        Ya: 4,
        $a: 5,
        cb: 6,
        za: 7,
        TIMEOUT: 8,
        gb: 9
      },
          nt = {
        Xa: "complete",
        kb: "success",
        Aa: "error",
        za: "abort",
        ib: "ready",
        jb: "readystatechange",
        TIMEOUT: "timeout",
        eb: "incrementaldata",
        hb: "progress",
        Za: "downloadprogress",
        lb: "uploadprogress"
      };

      function rt() {}

      function it(e) {
        var t;
        return (t = e.a) || (t = e.a = {}), t;
      }

      function ot() {}

      rt.prototype.a = null;
      var at,
          st = {
        OPEN: "a",
        Wa: "b",
        Aa: "c",
        fb: "d"
      };

      function ut() {
        re.call(this, "d");
      }

      function ct() {
        re.call(this, "c");
      }

      function lt() {}

      function ht(e, t, n) {
        this.g = e, this.W = t, this.U = n || 1, this.G = new We(this), this.N = dt, e = W ? 125 : void 0, this.O = new Ae(e), this.m = null, this.b = !1, this.j = this.A = this.f = this.B = this.s = this.P = this.h = null, this.i = [], this.a = null, this.w = 0, this.c = this.v = null, this.H = -1, this.l = !1, this.J = 0, this.D = null, this.o = this.R = this.F = !1;
      }

      g(ut, re), g(ct, re), g(lt, rt), at = new lt();
      var dt = 45e3,
          ft = {},
          pt = {};

      function mt(e, t, n) {
        e.B = 1, e.f = At(Rt(t)), e.j = n, e.F = !0, _t(e, null);
      }

      function _t(e, t) {
        e.s = v(), gt(e), e.A = Rt(e.f);
        var n = e.A,
            r = e.U;
        Array.isArray(r) || (r = [String(r)]), Jt(n.b, "t", r), e.w = 0, e.a = Wn(e.g, e.g.w ? t : null), 0 < e.J && (e.D = new Pe(_(e.ya, e, e.a), e.J)), Be(e.G, e.a, "readystatechange", e.Sa), t = e.m ? Y(e.m) : {}, e.j ? (e.v || (e.v = "POST"), t["Content-Type"] = "application/x-www-form-urlencoded", e.a.$(e.A, e.v, e.j, t)) : (e.v = "GET", e.a.$(e.A, e.v, null, t)), Je(1);
      }

      function yt(e, t, n) {
        for (var r = !0; !e.l && e.w < n.length;) {
          var i = vt(e, n);

          if (i == pt) {
            4 == t && (e.c = 4, Ke(14), r = !1);
            break;
          }

          if (i == ft) {
            e.c = 4, Ke(15), r = !1;
            break;
          }

          Et(e, i);
        }

        4 == t && 0 == n.length && (e.c = 1, Ke(16), r = !1), e.b = e.b && r, r || (Mt(e), Tt(e));
      }

      function vt(e, t) {
        var n = e.w,
            r = t.indexOf("\n", n);
        return -1 == r ? pt : (n = Number(t.substring(n, r)), isNaN(n) ? ft : (r += 1) + n > t.length ? pt : (t = t.substr(r, n), e.w = r + n, t));
      }

      function gt(e) {
        e.P = v() + e.N, bt(e, e.N);
      }

      function bt(e, t) {
        if (null != e.h) throw Error("WatchDog timer not null");
        e.h = et(_(e.Qa, e), t);
      }

      function wt(e) {
        e.h && (s.clearTimeout(e.h), e.h = null);
      }

      function Tt(e) {
        0 == e.g.u || e.l || An(e.g, e);
      }

      function Mt(e) {
        wt(e);
        var t = e.D;
        t && "function" == typeof t.da && t.da(), e.D = null, je(e.O), ze(e.G), e.a && (t = e.a, e.a = null, t.abort(), t.da());
      }

      function Et(e, t) {
        try {
          var n = e.g;
          if (0 != n.u && (n.a == e || rn(n.b, e))) if (n.A = e.H, !e.o && rn(n.b, e) && 3 == n.u) {
            try {
              var r = n.ja.a.parse(t);
            } catch (e) {
              r = null;
            }

            if (Array.isArray(r) && 3 == r.length) {
              var i = r;

              if (0 == i[0]) {
                e: if (!n.i) {
                  if (n.a) {
                    if (!(n.a.s + 3e3 < e.s)) break e;
                    Fn(n), n.a.cancel(), n.a = null;
                  }

                  On(n), Ke(18);
                }
              } else n.ia = i[1], 0 < n.ia - n.G && 37500 > i[2] && n.U && 0 == n.m && !n.l && (n.l = et(_(n.Na, n), 6e3));

              if (1 >= nn(n.b) && n.O) {
                try {
                  n.O();
                } catch (e) {}

                n.O = void 0;
              }
            } else Un(n, 11);
          } else if ((e.o || n.a == e) && Fn(n), !k(t)) for (t = r = n.ja.a.parse(t), r = 0; r < t.length; r++) {
            if (i = t[r], n.G = i[0], i = i[1], 2 == n.u) {
              if ("c" == i[0]) {
                n.B = i[1], n.R = i[2];
                var o = i[3];
                null != o && (n.oa = o);
                var a = i[5];
                null != a && "number" == typeof a && 0 < a && (n.D = 1.5 * a);
                var s = n,
                    u = e.a;

                if (u) {
                  var c = u.a ? u.a.getResponseHeader("X-Client-Wire-Protocol") : null;

                  if (c) {
                    var l = s.b;
                    !l.a && (N(c, "spdy") || N(c, "quic") || N(c, "h2")) && (l.f = l.g, l.a = new Set(), l.b && (on(l, l.b), l.b = null));
                  }

                  if (s.s) {
                    var h = u.a ? u.a.getResponseHeader("X-HTTP-Session-Id") : null;
                    h && (s.ha = h, Ft(s.v, s.s, h));
                  }
                }

                n.u = 3, n.c && n.c.na();
                var d = e;

                if ((s = n).ea = Vn(s, s.w ? s.R : null, s.P), d.o) {
                  an(s.b, d);
                  var f = d,
                      p = s.D;
                  p && f.setTimeout(p), f.h && (wt(f), gt(f)), s.a = d;
                } else Cn(s);

                0 < n.f.length && In(n);
              } else "stop" != i[0] && "close" != i[0] || Un(n, 7);
            } else 3 == n.u && ("stop" == i[0] || "close" == i[0] ? "stop" == i[0] ? Un(n, 7) : Sn(n) : "noop" != i[0] && n.c && n.c.ma(i), n.m = 0);
          }
          Je(4);
        } catch (e) {}
      }

      function kt(e, t) {
        if (e.forEach && "function" == typeof e.forEach) e.forEach(t, void 0);else if (l(e) || "string" == typeof e) T(e, t, void 0);else {
          if (e.K && "function" == typeof e.K) var n = e.K();else if (e.I && "function" == typeof e.I) n = void 0;else if (l(e) || "string" == typeof e) {
            n = [];

            for (var r = e.length, i = 0; i < r; i++) {
              n.push(i);
            }
          } else for (i in n = [], r = 0, e) {
            n[r++] = i;
          }

          i = (r = function (e) {
            if (e.I && "function" == typeof e.I) return e.I();
            if ("string" == typeof e) return e.split("");

            if (l(e)) {
              for (var t = [], n = e.length, r = 0; r < n; r++) {
                t.push(e[r]);
              }

              return t;
            }

            for (r in t = [], n = 0, e) {
              t[n++] = e[r];
            }

            return t;
          }(e)).length;

          for (var o = 0; o < i; o++) {
            t.call(void 0, r[o], n && n[o], e);
          }
        }
      }

      function Lt(e, t) {
        this.b = {}, this.a = [], this.c = 0;
        var n = arguments.length;

        if (1 < n) {
          if (n % 2) throw Error("Uneven number of arguments");

          for (var r = 0; r < n; r += 2) {
            this.set(arguments[r], arguments[r + 1]);
          }
        } else if (e) if (e instanceof Lt) for (n = e.K(), r = 0; r < n.length; r++) {
          this.set(n[r], e.get(n[r]));
        } else for (r in e) {
          this.set(r, e[r]);
        }
      }

      function St(e) {
        if (e.c != e.a.length) {
          for (var t = 0, n = 0; t < e.a.length;) {
            var r = e.a[t];
            Nt(e.b, r) && (e.a[n++] = r), t++;
          }

          e.a.length = n;
        }

        if (e.c != e.a.length) {
          var i = {};

          for (n = t = 0; t < e.a.length;) {
            Nt(i, r = e.a[t]) || (e.a[n++] = r, i[r] = 1), t++;
          }

          e.a.length = n;
        }
      }

      function Nt(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }

      (i = ht.prototype).setTimeout = function (e) {
        this.N = e;
      }, i.Sa = function (e) {
        e = e.target;
        var t = this.D;
        t && 3 == Mn(e) ? t.Ia() : this.ya(e);
      }, i.ya = function (e) {
        try {
          if (e == this.a) e: {
            var t = Mn(this.a),
                n = this.a.qa(),
                r = this.a.S();

            if (!(3 > t || 3 == t && !W && !this.a.Y())) {
              this.l || 4 != t || 7 == n || Je(8 == n || 0 >= r ? 3 : 2), wt(this);
              var i = this.a.S();
              this.H = i;
              var o = this.a.Y();

              if (this.b = 200 == i) {
                if (this.R && !this.o) {
                  t: {
                    if (this.a) {
                      var a,
                          s = this.a;

                      if ((a = s.a ? s.a.getResponseHeader("X-HTTP-Initial-Response") : null) && !k(a)) {
                        var u = a;
                        break t;
                      }
                    }

                    u = null;
                  }

                  if (!u) {
                    this.b = !1, this.c = 3, Ke(12), Mt(this), Tt(this);
                    break e;
                  }

                  this.o = !0, Et(this, u);
                }

                this.F ? (yt(this, t, o), W && this.b && 3 == t && (Be(this.G, this.O, "tick", this.Ra), this.O.start())) : Et(this, o), 4 == t && Mt(this), this.b && !this.l && (4 == t ? An(this.g, this) : (this.b = !1, gt(this)));
              } else 400 == i && 0 < o.indexOf("Unknown SID") ? (this.c = 3, Ke(12)) : (this.c = 0, Ke(13)), Mt(this), Tt(this);
            }
          }
        } catch (e) {}
      }, i.Ra = function () {
        if (this.a) {
          var e = Mn(this.a),
              t = this.a.Y();
          this.w < t.length && (wt(this), yt(this, e, t), this.b && 4 != e && gt(this));
        }
      }, i.cancel = function () {
        this.l = !0, Mt(this);
      }, i.Qa = function () {
        this.h = null;
        var e = v();
        0 <= e - this.P ? (2 != this.B && (Je(3), Ke(17)), Mt(this), this.c = 2, Tt(this)) : bt(this, this.P - e);
      }, (i = Lt.prototype).I = function () {
        St(this);

        for (var e = [], t = 0; t < this.a.length; t++) {
          e.push(this.b[this.a[t]]);
        }

        return e;
      }, i.K = function () {
        return St(this), this.a.concat();
      }, i.get = function (e, t) {
        return Nt(this.b, e) ? this.b[e] : t;
      }, i.set = function (e, t) {
        Nt(this.b, e) || (this.c++, this.a.push(e)), this.b[e] = t;
      }, i.forEach = function (e, t) {
        for (var n = this.K(), r = 0; r < n.length; r++) {
          var i = n[r],
              o = this.get(i);
          e.call(t, o, i, this);
        }
      };
      var Dt = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;

      function It(e, t) {
        if (this.c = this.j = this.f = "", this.h = null, this.i = this.g = "", this.a = !1, e instanceof It) {
          this.a = void 0 !== t ? t : e.a, xt(this, e.f), this.j = e.j, Yt(this, e.c), Ct(this, e.h), this.g = e.g, t = e.b;
          var n = new Zt();
          n.c = t.c, t.a && (n.a = new Lt(t.a), n.b = t.b), Ot(this, n), this.i = e.i;
        } else e && (n = String(e).match(Dt)) ? (this.a = !!t, xt(this, n[1] || "", !0), this.j = jt(n[2] || ""), Yt(this, n[3] || "", !0), Ct(this, n[4]), this.g = jt(n[5] || "", !0), Ot(this, n[6] || "", !0), this.i = jt(n[7] || "")) : (this.a = !!t, this.b = new Zt(null, this.a));
      }

      function Rt(e) {
        return new It(e);
      }

      function xt(e, t, n) {
        e.f = n ? jt(t, !0) : t, e.f && (e.f = e.f.replace(/:$/, ""));
      }

      function Yt(e, t, n) {
        e.c = n ? jt(t, !0) : t;
      }

      function Ct(e, t) {
        if (t) {
          if (t = Number(t), isNaN(t) || 0 > t) throw Error("Bad port number " + t);
          e.h = t;
        } else e.h = null;
      }

      function Ot(e, t, n) {
        t instanceof Zt ? (e.b = t, function (e, t) {
          t && !e.f && (Qt(e), e.c = null, e.a.forEach(function (e, t) {
            var n = t.toLowerCase();
            t != n && (Gt(this, t), Jt(this, n, e));
          }, e)), e.f = t;
        }(e.b, e.a)) : (n || (t = Ut(t, Bt)), e.b = new Zt(t, e.a));
      }

      function Ft(e, t, n) {
        e.b.set(t, n);
      }

      function At(e) {
        return Ft(e, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ v()).toString(36)), e;
      }

      function jt(e, t) {
        return e ? t ? decodeURI(e.replace(/%25/g, "%2525")) : decodeURIComponent(e) : "";
      }

      function Ut(e, t, n) {
        return "string" == typeof e ? (e = encodeURI(e).replace(t, Pt), n && (e = e.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), e) : null;
      }

      function Pt(e) {
        return "%" + ((e = e.charCodeAt(0)) >> 4 & 15).toString(16) + (15 & e).toString(16);
      }

      It.prototype.toString = function () {
        var e = [],
            t = this.f;
        t && e.push(Ut(t, Vt, !0), ":");
        var n = this.c;
        return (n || "file" == t) && (e.push("//"), (t = this.j) && e.push(Ut(t, Vt, !0), "@"), e.push(encodeURIComponent(String(n)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), null != (n = this.h) && e.push(":", String(n))), (n = this.g) && (this.c && "/" != n.charAt(0) && e.push("/"), e.push(Ut(n, "/" == n.charAt(0) ? Ht : Wt, !0))), (n = this.b.toString()) && e.push("?", n), (n = this.i) && e.push("#", Ut(n, zt)), e.join("");
      };

      var Vt = /[#\/\?@]/g,
          Wt = /[#\?:]/g,
          Ht = /[#\?]/g,
          Bt = /[#\?@]/g,
          zt = /#/g;

      function Zt(e, t) {
        this.b = this.a = null, this.c = e || null, this.f = !!t;
      }

      function Qt(e) {
        e.a || (e.a = new Lt(), e.b = 0, e.c && function (e, t) {
          if (e) {
            e = e.split("&");

            for (var n = 0; n < e.length; n++) {
              var r = e[n].indexOf("="),
                  i = null;

              if (0 <= r) {
                var o = e[n].substring(0, r);
                i = e[n].substring(r + 1);
              } else o = e[n];

              t(o, i ? decodeURIComponent(i.replace(/\+/g, " ")) : "");
            }
          }
        }(e.c, function (t, n) {
          e.add(decodeURIComponent(t.replace(/\+/g, " ")), n);
        }));
      }

      function Gt(e, t) {
        Qt(e), t = Xt(e, t), Nt(e.a.b, t) && (e.c = null, e.b -= e.a.get(t).length, Nt((e = e.a).b, t) && (delete e.b[t], e.c--, e.a.length > 2 * e.c && St(e)));
      }

      function qt(e, t) {
        return Qt(e), t = Xt(e, t), Nt(e.a.b, t);
      }

      function Jt(e, t, n) {
        Gt(e, t), 0 < n.length && (e.c = null, e.a.set(Xt(e, t), E(n)), e.b += n.length);
      }

      function Xt(e, t) {
        return t = String(t), e.f && (t = t.toLowerCase()), t;
      }

      function Kt(e, t) {
        this.b = e, this.a = t;
      }

      function $t(e) {
        this.g = e || en, s.PerformanceNavigationTiming ? e = 0 < (e = s.performance.getEntriesByType("navigation")).length && ("hq" == e[0].nextHopProtocol || "h2" == e[0].nextHopProtocol) : e = !!(s.ca && s.ca.ua && s.ca.ua() && s.ca.ua().mb), this.f = e ? this.g : 1, this.a = null, 1 < this.f && (this.a = new Set()), this.b = null, this.c = [];
      }

      (i = Zt.prototype).add = function (e, t) {
        Qt(this), this.c = null, e = Xt(this, e);
        var n = this.a.get(e);
        return n || this.a.set(e, n = []), n.push(t), this.b += 1, this;
      }, i.forEach = function (e, t) {
        Qt(this), this.a.forEach(function (n, r) {
          T(n, function (n) {
            e.call(t, n, r, this);
          }, this);
        }, this);
      }, i.K = function () {
        Qt(this);

        for (var e = this.a.I(), t = this.a.K(), n = [], r = 0; r < t.length; r++) {
          for (var i = e[r], o = 0; o < i.length; o++) {
            n.push(t[r]);
          }
        }

        return n;
      }, i.I = function (e) {
        Qt(this);
        var t = [];
        if ("string" == typeof e) qt(this, e) && (t = M(t, this.a.get(Xt(this, e))));else {
          e = this.a.I();

          for (var n = 0; n < e.length; n++) {
            t = M(t, e[n]);
          }
        }
        return t;
      }, i.set = function (e, t) {
        return Qt(this), this.c = null, qt(this, e = Xt(this, e)) && (this.b -= this.a.get(e).length), this.a.set(e, [t]), this.b += 1, this;
      }, i.get = function (e, t) {
        return e && 0 < (e = this.I(e)).length ? String(e[0]) : t;
      }, i.toString = function () {
        if (this.c) return this.c;
        if (!this.a) return "";

        for (var e = [], t = this.a.K(), n = 0; n < t.length; n++) {
          var r = t[n],
              i = encodeURIComponent(String(r));
          r = this.I(r);

          for (var o = 0; o < r.length; o++) {
            var a = i;
            "" !== r[o] && (a += "=" + encodeURIComponent(String(r[o]))), e.push(a);
          }
        }

        return this.c = e.join("&");
      };
      var en = 10;

      function tn(e) {
        return !!e.b || !!e.a && e.a.size >= e.f;
      }

      function nn(e) {
        return e.b ? 1 : e.a ? e.a.size : 0;
      }

      function rn(e, t) {
        return e.b ? e.b == t : !!e.a && e.a.has(t);
      }

      function on(e, t) {
        e.a ? e.a.add(t) : e.b = t;
      }

      function an(e, t) {
        e.b && e.b == t ? e.b = null : e.a && e.a.has(t) && e.a.delete(t);
      }

      function sn(e) {
        var t, n;
        if (null != e.b) return e.c.concat(e.b.i);

        if (null != e.a && 0 !== e.a.size) {
          var i = e.c;

          try {
            for (var o = r(e.a.values()), a = o.next(); !a.done; a = o.next()) {
              var s = a.value;
              i = i.concat(s.i);
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              a && !a.done && (n = o.return) && n.call(o);
            } finally {
              if (t) throw t.error;
            }
          }

          return i;
        }

        return E(e.c);
      }

      function un() {}

      function cn() {
        this.a = new un();
      }

      function ln(e, t, n) {
        var r = n || "";

        try {
          kt(e, function (e, n) {
            var i = e;
            h(e) && (i = Le(e)), t.push(r + n + "=" + encodeURIComponent(i));
          });
        } catch (e) {
          throw t.push(r + "type=" + encodeURIComponent("_badmap")), e;
        }
      }

      function hn(e, t, n, r, i) {
        try {
          t.onload = null, t.onerror = null, t.onabort = null, t.ontimeout = null, i(r);
        } catch (e) {}
      }

      $t.prototype.cancel = function () {
        var e, t;
        if (this.c = sn(this), this.b) this.b.cancel(), this.b = null;else if (this.a && 0 !== this.a.size) {
          try {
            for (var n = r(this.a.values()), i = n.next(); !i.done; i = n.next()) {
              i.value.cancel();
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              i && !i.done && (t = n.return) && t.call(n);
            } finally {
              if (e) throw e.error;
            }
          }

          this.a.clear();
        }
      }, un.prototype.stringify = function (e) {
        return s.JSON.stringify(e, void 0);
      }, un.prototype.parse = function (e) {
        return s.JSON.parse(e, void 0);
      };
      var dn = s.JSON.parse;

      function fn(e) {
        Ee.call(this), this.headers = new Lt(), this.G = e || null, this.b = !1, this.s = this.a = null, this.D = "", this.h = 0, this.f = "", this.g = this.w = this.l = this.v = !1, this.o = 0, this.m = null, this.H = pn, this.B = this.F = !1;
      }

      g(fn, Ee);
      var pn = "",
          mn = /^https?$/i,
          _n = ["POST", "PUT"];

      function yn(e) {
        return "content-type" == e.toLowerCase();
      }

      function vn(e, t) {
        e.b = !1, e.a && (e.g = !0, e.a.abort(), e.g = !1), e.f = t, e.h = 5, gn(e), wn(e);
      }

      function gn(e) {
        e.v || (e.v = !0, e.dispatchEvent("complete"), e.dispatchEvent("error"));
      }

      function bn(e) {
        if (e.b && void 0 !== a && (!e.s[1] || 4 != Mn(e) || 2 != e.S())) if (e.l && 4 == Mn(e)) Ue(e.va, 0, e);else if (e.dispatchEvent("readystatechange"), 4 == Mn(e)) {
          e.b = !1;

          try {
            var t,
                n = e.S();

            e: switch (n) {
              case 200:
              case 201:
              case 202:
              case 204:
              case 206:
              case 304:
              case 1223:
                var r = !0;
                break e;

              default:
                r = !1;
            }

            if (!(t = r)) {
              var i;

              if (i = 0 === n) {
                var o = String(e.D).match(Dt)[1] || null;

                if (!o && s.self && s.self.location) {
                  var u = s.self.location.protocol;
                  o = u.substr(0, u.length - 1);
                }

                i = !mn.test(o ? o.toLowerCase() : "");
              }

              t = i;
            }

            if (t) e.dispatchEvent("complete"), e.dispatchEvent("success");else {
              e.h = 6;

              try {
                var c = 2 < Mn(e) ? e.a.statusText : "";
              } catch (e) {
                c = "";
              }

              e.f = c + " [" + e.S() + "]", gn(e);
            }
          } finally {
            wn(e);
          }
        }
      }

      function wn(e, t) {
        if (e.a) {
          Tn(e);
          var n = e.a,
              r = e.s[0] ? u : null;
          e.a = null, e.s = null, t || e.dispatchEvent("ready");

          try {
            n.onreadystatechange = r;
          } catch (e) {}
        }
      }

      function Tn(e) {
        e.a && e.B && (e.a.ontimeout = null), e.m && (s.clearTimeout(e.m), e.m = null);
      }

      function Mn(e) {
        return e.a ? e.a.readyState : 0;
      }

      function En(e, t, n) {
        e: {
          for (r in n) {
            var r = !1;
            break e;
          }

          r = !0;
        }

        r || (n = function (e) {
          var t = "";
          return x(e, function (e, n) {
            t += n, t += ":", t += e, t += "\r\n";
          }), t;
        }(n), "string" == typeof e ? null != n && encodeURIComponent(String(n)) : Ft(e, t, n));
      }

      function kn(e, t, n) {
        return n && n.internalChannelParams && n.internalChannelParams[e] || t;
      }

      function Ln(e) {
        this.f = [], this.R = this.ea = this.v = this.P = this.a = this.ha = this.s = this.N = this.h = this.F = this.j = null, this.Fa = this.H = 0, this.Ca = kn("failFast", !1, e), this.U = this.l = this.i = this.g = this.c = null, this.W = !0, this.A = this.ia = this.G = -1, this.J = this.m = this.o = 0, this.Ba = kn("baseRetryDelayMs", 5e3, e), this.Ga = kn("retryDelaySeedMs", 1e4, e), this.Da = kn("forwardChannelMaxRetries", 2, e), this.ga = kn("forwardChannelRequestTimeoutMs", 2e4, e), this.Ea = e && e.nb || void 0, this.D = void 0, this.w = e && e.supportsCrossDomainXhr || !1, this.B = "", this.b = new $t(e && e.concurrentRequestLimit), this.ja = new cn(), this.fa = e && e.fastHandshake || !1, e && e.forceLongPolling && (this.W = !1), this.O = void 0;
      }

      function Sn(e) {
        if (Nn(e), 3 == e.u) {
          var t = e.H++,
              n = Rt(e.v);
          Ft(n, "SID", e.B), Ft(n, "RID", t), Ft(n, "TYPE", "terminate"), xn(e, n), (t = new ht(e, t, void 0)).B = 2, t.f = At(Rt(n)), n = !1, s.navigator && s.navigator.sendBeacon && (n = s.navigator.sendBeacon(t.f.toString(), "")), !n && s.Image && (new Image().src = t.f, n = !0), n || (t.a = Wn(t.g, null), t.a.$(t.f)), t.s = v(), gt(t);
        }

        Pn(e);
      }

      function Nn(e) {
        e.a && (e.a.cancel(), e.a = null), e.i && (s.clearTimeout(e.i), e.i = null), Fn(e), e.b.cancel(), e.g && ("number" == typeof e.g && s.clearTimeout(e.g), e.g = null);
      }

      function Dn(e, t) {
        e.f.push(new Kt(e.Fa++, t)), 3 == e.u && In(e);
      }

      function In(e) {
        tn(e.b) || e.g || (e.g = !0, Ye(e.xa, e), e.o = 0);
      }

      function Rn(e, t) {
        var n;
        n = t ? t.W : e.H++;
        var r = Rt(e.v);
        Ft(r, "SID", e.B), Ft(r, "RID", n), Ft(r, "AID", e.G), xn(e, r), e.h && e.j && En(r, e.h, e.j), n = new ht(e, n, e.o + 1), null === e.h && (n.m = e.j), t && (e.f = t.i.concat(e.f)), t = Yn(e, n, 1e3), n.setTimeout(Math.round(.5 * e.ga) + Math.round(.5 * e.ga * Math.random())), on(e.b, n), mt(n, r, t);
      }

      function xn(e, t) {
        e.c && kt({}, function (e, n) {
          Ft(t, n, e);
        });
      }

      function Yn(e, t, n) {
        n = Math.min(e.f.length, n);
        var r = e.c ? _(e.c.Ha, e.c, e) : null;

        e: for (var i = e.f, o = -1;;) {
          var a = ["count=" + n];
          -1 == o ? 0 < n ? (o = i[0].b, a.push("ofs=" + o)) : o = 0 : a.push("ofs=" + o);

          for (var s = !0, u = 0; u < n; u++) {
            var c = i[u].b,
                l = i[u].a;
            if (0 > (c -= o)) o = Math.max(0, i[u].b - 100), s = !1;else try {
              ln(l, a, "req" + c + "_");
            } catch (e) {
              r && r(l);
            }
          }

          if (s) {
            r = a.join("&");
            break e;
          }
        }

        return e = e.f.splice(0, n), t.i = e, r;
      }

      function Cn(e) {
        e.a || e.i || (e.J = 1, Ye(e.wa, e), e.m = 0);
      }

      function On(e) {
        return !(e.a || e.i || 3 <= e.m) && (e.J++, e.i = et(_(e.wa, e), jn(e, e.m)), e.m++, !0);
      }

      function Fn(e) {
        null != e.l && (s.clearTimeout(e.l), e.l = null);
      }

      function An(e, t) {
        var n = null;

        if (e.a == t) {
          Fn(e), e.a = null;
          var r = 2;
        } else {
          if (!rn(e.b, t)) return;
          n = t.i, an(e.b, t), r = 1;
        }

        if (e.A = t.H, 0 != e.u) if (t.b) {
          if (1 == r) {
            n = t.j ? t.j.length : 0, t = v() - t.s;
            var i = e.o;
            (r = Ge()).dispatchEvent(new $e(r, n, t, i)), In(e);
          } else Cn(e);
        } else if (3 == (i = t.c) || 0 == i && 0 < e.A || !(1 == r && function (e, t) {
          return !(nn(e.b) >= e.b.f - (e.g ? 1 : 0) || (e.g ? (e.f = t.i.concat(e.f), 0) : 1 == e.u || 2 == e.u || e.o >= (e.Ca ? 0 : e.Da) || (e.g = et(_(e.xa, e, t), jn(e, e.o)), e.o++, 0)));
        }(e, t) || 2 == r && On(e))) switch (n && 0 < n.length && (t = e.b, t.c = t.c.concat(n)), i) {
          case 1:
            Un(e, 5);
            break;

          case 4:
            Un(e, 10);
            break;

          case 3:
            Un(e, 6);
            break;

          default:
            Un(e, 2);
        }
      }

      function jn(e, t) {
        var n = e.Ba + Math.floor(Math.random() * e.Ga);
        return e.c || (n *= 2), n * t;
      }

      function Un(e, t) {
        if (2 == t) {
          var n = null;
          e.c && (n = null);

          var r = _(e.Ta, e);

          n || (n = new It("//www.google.com/images/cleardot.gif"), s.location && "http" == s.location.protocol || xt(n, "https"), At(n)), function (e, t) {
            var n = new Ze();

            if (s.Image) {
              var r = new Image();
              r.onload = y(hn, n, r, "TestLoadImage: loaded", !0, t), r.onerror = y(hn, n, r, "TestLoadImage: error", !1, t), r.onabort = y(hn, n, r, "TestLoadImage: abort", !1, t), r.ontimeout = y(hn, n, r, "TestLoadImage: timeout", !1, t), s.setTimeout(function () {
                r.ontimeout && r.ontimeout();
              }, 1e4), r.src = e;
            } else t(!1);
          }(n.toString(), r);
        } else Ke(2);

        e.u = 0, e.c && e.c.la(t), Pn(e), Nn(e);
      }

      function Pn(e) {
        e.u = 0, e.A = -1, e.c && (0 == sn(e.b).length && 0 == e.f.length || (e.b.c.length = 0, E(e.f), e.f.length = 0), e.c.ka());
      }

      function Vn(e, t, n) {
        var r = function (e) {
          return e instanceof It ? Rt(e) : new It(e, void 0);
        }(n);

        if ("" != r.c) t && Yt(r, t + "." + r.c), Ct(r, r.h);else {
          var i = s.location;

          r = function (e, t, n, r) {
            var i = new It(null, void 0);
            return e && xt(i, e), t && Yt(i, t), n && Ct(i, n), r && (i.g = r), i;
          }(i.protocol, t ? t + "." + i.hostname : i.hostname, +i.port, n);
        }
        return e.N && x(e.N, function (e, t) {
          Ft(r, t, e);
        }), t = e.s, n = e.ha, t && n && Ft(r, t, n), Ft(r, "VER", e.oa), xn(e, r), r;
      }

      function Wn(e, t) {
        if (t && !e.w) throw Error("Can't create secondary domain capable XhrIo object.");
        return (t = new fn(e.Ea)).F = e.w, t;
      }

      function Hn() {}

      function Bn() {
        if (P && !(10 <= Number($))) throw Error("Environmental error: no available transport.");
      }

      function zn(e, t) {
        Ee.call(this), this.a = new Ln(t), this.l = e, this.b = t && t.messageUrlParams || null, e = t && t.messageHeaders || null, t && t.clientProtocolHeaderRequired && (e ? e["X-Client-Protocol"] = "webchannel" : e = {
          "X-Client-Protocol": "webchannel"
        }), this.a.j = e, e = t && t.initMessageHeaders || null, t && t.messageContentType && (e ? e["X-WebChannel-Content-Type"] = t.messageContentType : e = {
          "X-WebChannel-Content-Type": t.messageContentType
        }), t && t.pa && (e ? e["X-WebChannel-Client-Profile"] = t.pa : e = {
          "X-WebChannel-Client-Profile": t.pa
        }), this.a.F = e, (e = t && t.httpHeadersOverwriteParam) && !k(e) && (this.a.h = e), this.h = t && t.supportsCrossDomainXhr || !1, this.g = t && t.sendRawJson || !1, (t = t && t.httpSessionIdParam) && !k(t) && (this.a.s = t, null !== (e = this.b) && t in e && t in (e = this.b) && delete e[t]), this.f = new Gn(this);
      }

      function Zn(e) {
        ut.call(this);
        var t = e.__sm__;

        if (t) {
          e: {
            for (var n in t) {
              e = n;
              break e;
            }

            e = void 0;
          }

          (this.c = e) ? (e = this.c, this.data = null !== t && e in t ? t[e] : void 0) : this.data = t;
        } else this.data = e;
      }

      function Qn() {
        ct.call(this), this.status = 1;
      }

      function Gn(e) {
        this.a = e;
      }

      (i = fn.prototype).$ = function (e, t, n, r) {
        if (this.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + e);
        t = t ? t.toUpperCase() : "GET", this.D = e, this.f = "", this.h = 0, this.v = !1, this.b = !0, this.a = new XMLHttpRequest(), this.s = this.G ? it(this.G) : it(at), this.a.onreadystatechange = _(this.va, this);

        try {
          this.w = !0, this.a.open(t, String(e), !0), this.w = !1;
        } catch (e) {
          return void vn(this, e);
        }

        e = n || "";
        var i = new Lt(this.headers);
        r && kt(r, function (e, t) {
          i.set(t, e);
        }), r = function (e) {
          e: {
            for (var t = yn, n = e.length, r = "string" == typeof e ? e.split("") : e, i = 0; i < n; i++) {
              if (i in r && t.call(void 0, r[i], i, e)) {
                t = i;
                break e;
              }
            }

            t = -1;
          }

          return 0 > t ? null : "string" == typeof e ? e.charAt(t) : e[t];
        }(i.K()), n = s.FormData && e instanceof s.FormData, !(0 <= w(_n, t)) || r || n || i.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"), i.forEach(function (e, t) {
          this.a.setRequestHeader(t, e);
        }, this), this.H && (this.a.responseType = this.H), "withCredentials" in this.a && this.a.withCredentials !== this.F && (this.a.withCredentials = this.F);

        try {
          Tn(this), 0 < this.o && ((this.B = function (e) {
            return P && X(9) && "number" == typeof e.timeout && void 0 !== e.ontimeout;
          }(this.a)) ? (this.a.timeout = this.o, this.a.ontimeout = _(this.ta, this)) : this.m = Ue(this.ta, this.o, this)), this.l = !0, this.a.send(e), this.l = !1;
        } catch (e) {
          vn(this, e);
        }
      }, i.ta = function () {
        void 0 !== a && this.a && (this.f = "Timed out after " + this.o + "ms, aborting", this.h = 8, this.dispatchEvent("timeout"), this.abort(8));
      }, i.abort = function (e) {
        this.a && this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1, this.h = e || 7, this.dispatchEvent("complete"), this.dispatchEvent("abort"), wn(this));
      }, i.C = function () {
        this.a && (this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1), wn(this, !0)), fn.M.C.call(this);
      }, i.va = function () {
        this.j || (this.w || this.l || this.g ? bn(this) : this.Oa());
      }, i.Oa = function () {
        bn(this);
      }, i.S = function () {
        try {
          return 2 < Mn(this) ? this.a.status : -1;
        } catch (e) {
          return -1;
        }
      }, i.Y = function () {
        try {
          return this.a ? this.a.responseText : "";
        } catch (e) {
          return "";
        }
      }, i.Ja = function (e) {
        if (this.a) {
          var t = this.a.responseText;
          return e && 0 == t.indexOf(e) && (t = t.substring(e.length)), dn(t);
        }
      }, i.qa = function () {
        return this.h;
      }, i.Ma = function () {
        return "string" == typeof this.f ? this.f : String(this.f);
      }, (i = Ln.prototype).oa = 8, i.u = 1, i.xa = function (e) {
        if (this.g) if (this.g = null, 1 == this.u) {
          if (!e) {
            this.H = Math.floor(1e5 * Math.random());
            var t,
                n = new ht(this, e = this.H++, void 0),
                r = this.j;
            if (this.F && (r ? O(r = Y(r), this.F) : r = this.F), null === this.h && (n.m = r), this.fa) e: {
              for (var i = t = 0; i < this.f.length; i++) {
                var o = this.f[i];
                if (void 0 === (o = "__data__" in o.a && "string" == typeof (o = o.a.__data__) ? o.length : void 0)) break;

                if (4096 < (t += o)) {
                  t = i;
                  break e;
                }

                if (4096 === t || i === this.f.length - 1) {
                  t = i + 1;
                  break e;
                }
              }

              t = 1e3;
            } else t = 1e3;
            t = Yn(this, n, t), Ft(i = Rt(this.v), "RID", e), Ft(i, "CVER", 22), this.s && Ft(i, "X-HTTP-Session-Id", this.s), xn(this, i), this.h && r && En(i, this.h, r), on(this.b, n), this.fa ? (Ft(i, "$req", t), Ft(i, "SID", "null"), n.R = !0, mt(n, i, null)) : mt(n, i, t), this.u = 2;
          }
        } else 3 == this.u && (e ? Rn(this, e) : 0 == this.f.length || tn(this.b) || Rn(this));
      }, i.wa = function () {
        this.i = null, this.a = new ht(this, "rpc", this.J), null === this.h && (this.a.m = this.j), this.a.J = 0;
        var e = Rt(this.ea);
        Ft(e, "RID", "rpc"), Ft(e, "SID", this.B), Ft(e, "CI", this.U ? "0" : "1"), Ft(e, "AID", this.G), xn(this, e), Ft(e, "TYPE", "xmlhttp"), this.h && this.j && En(e, this.h, this.j), this.D && this.a.setTimeout(this.D);
        var t = this.a,
            n = this.R;
        t.B = 1, t.f = At(Rt(e)), t.j = null, t.F = !0, _t(t, n);
      }, i.Na = function () {
        null != this.l && (this.l = null, this.a.cancel(), this.a = null, On(this), Ke(19));
      }, i.Ta = function (e) {
        Ke(e ? 2 : 1);
      }, (i = Hn.prototype).na = function () {}, i.ma = function () {}, i.la = function () {}, i.ka = function () {}, i.Ha = function () {}, Bn.prototype.a = function (e, t) {
        return new zn(e, t);
      }, g(zn, Ee), (i = zn.prototype).addEventListener = function (e, t, n, r) {
        zn.M.addEventListener.call(this, e, t, n, r);
      }, i.removeEventListener = function (e, t, n, r) {
        zn.M.removeEventListener.call(this, e, t, n, r);
      }, i.Ka = function () {
        this.a.c = this.f, this.h && (this.a.w = !0);
        var e = this.a,
            t = this.l,
            n = this.b || void 0;
        Ke(0), e.P = t, e.N = n || {}, e.U = e.W, e.v = Vn(e, null, e.P), In(e);
      }, i.close = function () {
        Sn(this.a);
      }, i.La = function (e) {
        if ("string" == typeof e) {
          var t = {};
          t.__data__ = e, Dn(this.a, t);
        } else this.g ? ((t = {}).__data__ = Le(e), Dn(this.a, t)) : Dn(this.a, e);
      }, i.C = function () {
        this.a.c = null, delete this.f, Sn(this.a), delete this.a, zn.M.C.call(this);
      }, g(Zn, ut), g(Qn, ct), g(Gn, Hn), Gn.prototype.na = function () {
        this.a.dispatchEvent("a");
      }, Gn.prototype.ma = function (e) {
        this.a.dispatchEvent(new Zn(e));
      }, Gn.prototype.la = function (e) {
        this.a.dispatchEvent(new Qn(e));
      }, Gn.prototype.ka = function () {
        this.a.dispatchEvent("b");
      }, Bn.prototype.createWebChannel = Bn.prototype.a, zn.prototype.send = zn.prototype.La, zn.prototype.open = zn.prototype.Ka, zn.prototype.close = zn.prototype.close, tt.NO_ERROR = 0, tt.TIMEOUT = 8, tt.HTTP_ERROR = 6, nt.COMPLETE = "complete", ot.EventType = st, st.OPEN = "a", st.CLOSE = "b", st.ERROR = "c", st.MESSAGE = "d", Ee.prototype.listen = Ee.prototype.ra, fn.prototype.listenOnce = fn.prototype.sa, fn.prototype.getLastError = fn.prototype.Ma, fn.prototype.getLastErrorCode = fn.prototype.qa, fn.prototype.getStatus = fn.prototype.S, fn.prototype.getResponseJson = fn.prototype.Ja, fn.prototype.getResponseText = fn.prototype.Y, fn.prototype.send = fn.prototype.$;
      var qn = {
        createWebChannelTransport: function createWebChannelTransport() {
          return new Bn();
        },
        ErrorCode: tt,
        EventType: nt,
        WebChannel: ot,
        XhrIo: fn
      },
          Jn = qn.createWebChannelTransport,
          Xn = qn.ErrorCode,
          Kn = qn.EventType,
          $n = qn.WebChannel,
          er = qn.XhrIo;
      t.default = qn;
    }.call(this, n(17));
  }, function (e, t, n) {
    "use strict";

    var r,
        i = (r = n(6)) && "object" == typeof r && "default" in r ? r.default : r,
        o = n(3),
        a = n(13),
        s = {
      OK: "ok",
      CANCELLED: "cancelled",
      UNKNOWN: "unknown",
      INVALID_ARGUMENT: "invalid-argument",
      DEADLINE_EXCEEDED: "deadline-exceeded",
      NOT_FOUND: "not-found",
      ALREADY_EXISTS: "already-exists",
      PERMISSION_DENIED: "permission-denied",
      UNAUTHENTICATED: "unauthenticated",
      RESOURCE_EXHAUSTED: "resource-exhausted",
      FAILED_PRECONDITION: "failed-precondition",
      ABORTED: "aborted",
      OUT_OF_RANGE: "out-of-range",
      UNIMPLEMENTED: "unimplemented",
      INTERNAL: "internal",
      UNAVAILABLE: "unavailable",
      DATA_LOSS: "data-loss"
    },
        u = function (e) {
      function t(n, r, i) {
        var o = e.call(this, r) || this;
        return Object.setPrototypeOf(o, t.prototype), o.code = n, o.details = i, o;
      }

      return o.__extends(t, e), t;
    }(Error);

    var c = function () {
      function e(e, t) {
        var n = this;
        this.auth = null, this.messaging = null, this.auth = e.getImmediate({
          optional: !0
        }), this.messaging = t.getImmediate({
          optional: !0
        }), this.auth || e.get().then(function (e) {
          return n.auth = e;
        }, function () {}), this.messaging || t.get().then(function (e) {
          return n.messaging = e;
        }, function () {});
      }

      return e.prototype.getAuthToken = function () {
        return o.__awaiter(this, void 0, void 0, function () {
          var e;
          return o.__generator(this, function (t) {
            switch (t.label) {
              case 0:
                if (!this.auth) return [2, void 0];
                t.label = 1;

              case 1:
                return t.trys.push([1, 3,, 4]), [4, this.auth.getToken()];

              case 2:
                return (e = t.sent()) ? [2, e.accessToken] : [2, void 0];

              case 3:
                return t.sent(), [2, void 0];

              case 4:
                return [2];
            }
          });
        });
      }, e.prototype.getInstanceIdToken = function () {
        return o.__awaiter(this, void 0, void 0, function () {
          return o.__generator(this, function (e) {
            if (!(this.messaging && "Notification" in self && "granted" === Notification.permission)) return [2, void 0];

            try {
              return [2, this.messaging.getToken()];
            } catch (e) {
              return [2, void 0];
            }

            return [2];
          });
        });
      }, e.prototype.getContext = function () {
        return o.__awaiter(this, void 0, void 0, function () {
          var e, t;
          return o.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.getAuthToken()];

              case 1:
                return e = n.sent(), [4, this.getInstanceIdToken()];

              case 2:
                return t = n.sent(), [2, {
                  authToken: e,
                  instanceIdToken: t
                }];
            }
          });
        });
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function l(e, t) {
      var n = {};

      for (var r in e) {
        e.hasOwnProperty(r) && (n[r] = t(e[r]));
      }

      return n;
    }

    var h = function () {
      function e() {}

      return e.prototype.encode = function (e) {
        var t = this;
        if (null == e) return null;
        if (e instanceof Number && (e = e.valueOf()), "number" == typeof e && isFinite(e)) return e;
        if (!0 === e || !1 === e) return e;
        if ("[object String]" === Object.prototype.toString.call(e)) return e;
        if (Array.isArray(e)) return e.map(function (e) {
          return t.encode(e);
        });
        if ("function" == typeof e || "object" == typeof e) return l(e, function (e) {
          return t.encode(e);
        });
        throw new Error("Data cannot be encoded in JSON: " + e);
      }, e.prototype.decode = function (e) {
        var t = this;
        if (null == e) return e;
        if (e["@type"]) switch (e["@type"]) {
          case "type.googleapis.com/google.protobuf.Int64Value":
          case "type.googleapis.com/google.protobuf.UInt64Value":
            var n = Number(e.value);
            if (isNaN(n)) throw new Error("Data cannot be decoded from JSON: " + e);
            return n;

          default:
            throw new Error("Data cannot be decoded from JSON: " + e);
        }
        return Array.isArray(e) ? e.map(function (e) {
          return t.decode(e);
        }) : "function" == typeof e || "object" == typeof e ? l(e, function (e) {
          return t.decode(e);
        }) : e;
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var d = function () {
      function e(e, t, n, r) {
        var i = this;
        void 0 === r && (r = "us-central1"), this.app_ = e, this.region_ = r, this.serializer = new h(), this.emulatorOrigin = null, this.INTERNAL = {
          delete: function _delete() {
            return i.deleteService();
          }
        }, this.contextProvider = new c(t, n), this.cancelAllRequests = new Promise(function (e) {
          i.deleteService = function () {
            return e();
          };
        });
      }

      return Object.defineProperty(e.prototype, "app", {
        get: function get() {
          return this.app_;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._url = function (e) {
        var t = this.app_.options.projectId,
            n = this.region_;
        return null !== this.emulatorOrigin ? this.emulatorOrigin + "/" + t + "/" + n + "/" + e : "https://" + n + "-" + t + ".cloudfunctions.net/" + e;
      }, e.prototype.useFunctionsEmulator = function (e) {
        this.emulatorOrigin = e;
      }, e.prototype.httpsCallable = function (e, t) {
        var n = this;
        return function (r) {
          return n.call(e, r, t || {});
        };
      }, e.prototype.postJSON = function (e, t, n) {
        return o.__awaiter(this, void 0, void 0, function () {
          var r, i;
          return o.__generator(this, function (o) {
            switch (o.label) {
              case 0:
                n.append("Content-Type", "application/json"), o.label = 1;

              case 1:
                return o.trys.push([1, 3,, 4]), [4, fetch(e, {
                  method: "POST",
                  body: JSON.stringify(t),
                  headers: n
                })];

              case 2:
                return r = o.sent(), [3, 4];

              case 3:
                return o.sent(), [2, {
                  status: 0,
                  json: null
                }];

              case 4:
                i = null, o.label = 5;

              case 5:
                return o.trys.push([5, 7,, 8]), [4, r.json()];

              case 6:
                return i = o.sent(), [3, 8];

              case 7:
                return o.sent(), [3, 8];

              case 8:
                return [2, {
                  status: r.status,
                  json: i
                }];
            }
          });
        });
      }, e.prototype.call = function (e, t, n) {
        return o.__awaiter(this, void 0, void 0, function () {
          var r, i, a, c, l, h, d, f;
          return o.__generator(this, function (o) {
            switch (o.label) {
              case 0:
                return r = this._url(e), t = this.serializer.encode(t), i = {
                  data: t
                }, a = new Headers(), [4, this.contextProvider.getContext()];

              case 1:
                return (c = o.sent()).authToken && a.append("Authorization", "Bearer " + c.authToken), c.instanceIdToken && a.append("Firebase-Instance-ID-Token", c.instanceIdToken), l = n.timeout || 7e4, [4, Promise.race([this.postJSON(r, i, a), (p = l, new Promise(function (e, t) {
                  setTimeout(function () {
                    t(new u("deadline-exceeded", "deadline-exceeded"));
                  }, p);
                })), this.cancelAllRequests])];

              case 2:
                if (!(h = o.sent())) throw new u("cancelled", "Firebase Functions instance was deleted.");
                if (d = function (e, t, n) {
                  var r = function (e) {
                    if (e >= 200 && e < 300) return "ok";

                    switch (e) {
                      case 0:
                        return "internal";

                      case 400:
                        return "invalid-argument";

                      case 401:
                        return "unauthenticated";

                      case 403:
                        return "permission-denied";

                      case 404:
                        return "not-found";

                      case 409:
                        return "aborted";

                      case 429:
                        return "resource-exhausted";

                      case 499:
                        return "cancelled";

                      case 500:
                        return "internal";

                      case 501:
                        return "unimplemented";

                      case 503:
                        return "unavailable";

                      case 504:
                        return "deadline-exceeded";
                    }

                    return "unknown";
                  }(e),
                      i = r,
                      o = void 0;

                  try {
                    var a = t && t.error;

                    if (a) {
                      var c = a.status;

                      if ("string" == typeof c) {
                        if (!s[c]) return new u("internal", "internal");
                        r = s[c], i = c;
                      }

                      var l = a.message;
                      "string" == typeof l && (i = l), void 0 !== (o = a.details) && (o = n.decode(o));
                    }
                  } catch (e) {}

                  return "ok" === r ? null : new u(r, i, o);
                }(h.status, h.json, this.serializer)) throw d;
                if (!h.json) throw new u("internal", "Response is not valid JSON object.");
                if (void 0 === (f = h.json.data) && (f = h.json.result), void 0 === f) throw new u("internal", "Response is missing data field.");
                return [2, {
                  data: this.serializer.decode(f)
                }];
            }

            var p;
          });
        });
      }, e;
    }(),
        f = "functions";
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function p(e, t) {
      var n = e.getProvider("app").getImmediate(),
          r = e.getProvider("auth-internal"),
          i = e.getProvider("messaging");
      return new d(n, r, i, t);
    }

    var m;
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    m = {
      Functions: d
    }, i.INTERNAL.registerComponent(new a.Component(f, p, "PUBLIC").setServiceProps(m).setMultipleInstances(!0)), i.registerVersion("@firebase/functions", "0.4.43");
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r,
        i = n(6),
        o = n.n(i),
        a = (n(33), n(13)),
        s = n(3),
        u = n(16),
        c = n(24),
        l = ((r = {})["missing-app-config-values"] = 'Missing App configuration value: "{$valueName}"', r["only-available-in-window"] = "This method is available in a Window context.", r["only-available-in-sw"] = "This method is available in a service worker context.", r["permission-default"] = "The notification permission was not granted and dismissed instead.", r["permission-blocked"] = "The notification permission was not granted and blocked instead.", r["unsupported-browser"] = "This browser doesn't support the API's required to use the firebase SDK.", r["failed-service-worker-registration"] = "We are unable to register the default service worker. {$browserErrorMessage}", r["token-subscribe-failed"] = "A problem occured while subscribing the user to FCM: {$errorInfo}", r["token-subscribe-no-token"] = "FCM returned no token when subscribing the user to push.", r["token-unsubscribe-failed"] = "A problem occured while unsubscribing the user from FCM: {$errorInfo}", r["token-update-failed"] = "A problem occured while updating the user from FCM: {$errorInfo}", r["token-update-no-token"] = "FCM returned no token when updating the user to push.", r["use-sw-after-get-token"] = "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.", r["invalid-sw-registration"] = "The input to useServiceWorker() must be a ServiceWorkerRegistration.", r["invalid-bg-handler"] = "The input to setBackgroundMessageHandler() must be a function.", r["invalid-vapid-key"] = "The public VAPID key must be a string.", r["use-vapid-key-after-get-token"] = "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used.", r),
        h = new u.ErrorFactory("messaging", "Messaging", l);

    function d(e) {
      return h.create("missing-app-config-values", {
        valueName: e
      });
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function f(e) {
      var t = new Uint8Array(e);
      return btoa(String.fromCharCode.apply(String, Object(s.__spread)(t))).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    }

    function p(e) {
      for (var t = (e + "=".repeat((4 - e.length % 4) % 4)).replace(/\-/g, "+").replace(/_/g, "/"), n = atob(t), r = new Uint8Array(n.length), i = 0; i < n.length; ++i) {
        r[i] = n.charCodeAt(i);
      }

      return r;
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var m = "fcm_token_details_db",
        _ = 5,
        y = "fcm_token_object_Store";

    function v(e) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var t,
            n,
            r = this;
        return Object(s.__generator)(this, function (i) {
          switch (i.label) {
            case 0:
              return "databases" in indexedDB ? [4, indexedDB.databases()] : [3, 2];

            case 1:
              if (t = i.sent(), !t.map(function (e) {
                return e.name;
              }).includes(m)) return [2, null];
              i.label = 2;

            case 2:
              return n = null, [4, Object(c.openDb)(m, _, function (t) {
                return Object(s.__awaiter)(r, void 0, void 0, function () {
                  var r, i, o, a;
                  return Object(s.__generator)(this, function (s) {
                    switch (s.label) {
                      case 0:
                        return t.oldVersion < 2 ? [2] : t.objectStoreNames.contains(y) ? [4, (r = t.transaction.objectStore(y)).index("fcmSenderId").get(e)] : [2];

                      case 1:
                        return i = s.sent(), [4, r.clear()];

                      case 2:
                        if (s.sent(), !i) return [2];

                        if (2 === t.oldVersion) {
                          if (!(o = i).auth || !o.p256dh || !o.endpoint) return [2];
                          n = {
                            token: o.fcmToken,
                            createTime: null !== (a = o.createTime) && void 0 !== a ? a : Date.now(),
                            subscriptionOptions: {
                              auth: o.auth,
                              p256dh: o.p256dh,
                              endpoint: o.endpoint,
                              swScope: o.swScope,
                              vapidKey: "string" == typeof o.vapidKey ? o.vapidKey : f(o.vapidKey)
                            }
                          };
                        } else 3 === t.oldVersion ? n = {
                          token: (o = i).fcmToken,
                          createTime: o.createTime,
                          subscriptionOptions: {
                            auth: f(o.auth),
                            p256dh: f(o.p256dh),
                            endpoint: o.endpoint,
                            swScope: o.swScope,
                            vapidKey: f(o.vapidKey)
                          }
                        } : 4 === t.oldVersion && (n = {
                          token: (o = i).fcmToken,
                          createTime: o.createTime,
                          subscriptionOptions: {
                            auth: f(o.auth),
                            p256dh: f(o.p256dh),
                            endpoint: o.endpoint,
                            swScope: o.swScope,
                            vapidKey: f(o.vapidKey)
                          }
                        });

                        return [2];
                    }
                  });
                });
              })];

            case 3:
              return i.sent().close(), [4, Object(c.deleteDb)(m)];

            case 4:
              return i.sent(), [4, Object(c.deleteDb)("fcm_vapid_details_db")];

            case 5:
              return i.sent(), [4, Object(c.deleteDb)("undefined")];

            case 6:
              return i.sent(), [2, g(n) ? n : null];
          }
        });
      });
    }

    function g(e) {
      if (!e || !e.subscriptionOptions) return !1;
      var t = e.subscriptionOptions;
      return "number" == typeof e.createTime && e.createTime > 0 && "string" == typeof e.token && e.token.length > 0 && "string" == typeof t.auth && t.auth.length > 0 && "string" == typeof t.p256dh && t.p256dh.length > 0 && "string" == typeof t.endpoint && t.endpoint.length > 0 && "string" == typeof t.swScope && t.swScope.length > 0 && "string" == typeof t.vapidKey && t.vapidKey.length > 0;
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var b = "firebase-messaging-database",
        w = 1,
        T = "firebase-messaging-store",
        M = null;

    function E() {
      return M || (M = Object(c.openDb)(b, w, function (e) {
        switch (e.oldVersion) {
          case 0:
            e.createObjectStore(T);
        }
      })), M;
    }

    function k(e) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var t, n, r;
        return Object(s.__generator)(this, function (i) {
          switch (i.label) {
            case 0:
              return t = N(e), [4, E()];

            case 1:
              return [4, i.sent().transaction(T).objectStore(T).get(t)];

            case 2:
              return (n = i.sent()) ? [2, n] : [3, 3];

            case 3:
              return [4, v(e.appConfig.senderId)];

            case 4:
              return (r = i.sent()) ? [4, L(e, r)] : [3, 6];

            case 5:
              return i.sent(), [2, r];

            case 6:
              return [2];
          }
        });
      });
    }

    function L(e, t) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var n, r, i;
        return Object(s.__generator)(this, function (o) {
          switch (o.label) {
            case 0:
              return n = N(e), [4, E()];

            case 1:
              return r = o.sent(), [4, (i = r.transaction(T, "readwrite")).objectStore(T).put(t, n)];

            case 2:
              return o.sent(), [4, i.complete];

            case 3:
              return o.sent(), [2, t];
          }
        });
      });
    }

    function S(e) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var t, n, r;
        return Object(s.__generator)(this, function (i) {
          switch (i.label) {
            case 0:
              return t = N(e), [4, E()];

            case 1:
              return n = i.sent(), [4, (r = n.transaction(T, "readwrite")).objectStore(T).delete(t)];

            case 2:
              return i.sent(), [4, r.complete];

            case 3:
              return i.sent(), [2];
          }
        });
      });
    }

    function N(e) {
      return e.appConfig.appId;
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var D = "BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4",
        I = "https://fcmregistrations.googleapis.com/v1",
        R = "FCM_MSG",
        x = "google.c.a.c_id";
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    function Y(e, t) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var n, r, i, o, a, u;
        return Object(s.__generator)(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, A(e)];

            case 1:
              n = s.sent(), r = j(t), i = {
                method: "POST",
                headers: n,
                body: JSON.stringify(r)
              }, s.label = 2;

            case 2:
              return s.trys.push([2, 5,, 6]), [4, fetch(F(e.appConfig), i)];

            case 3:
              return [4, s.sent().json()];

            case 4:
              return o = s.sent(), [3, 6];

            case 5:
              throw a = s.sent(), h.create("token-subscribe-failed", {
                errorInfo: a
              });

            case 6:
              if (o.error) throw u = o.error.message, h.create("token-subscribe-failed", {
                errorInfo: u
              });
              if (!o.token) throw h.create("token-subscribe-no-token");
              return [2, o.token];
          }
        });
      });
    }

    function C(e, t) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var n, r, i, o, a, u;
        return Object(s.__generator)(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, A(e)];

            case 1:
              n = s.sent(), r = j(t.subscriptionOptions), i = {
                method: "PATCH",
                headers: n,
                body: JSON.stringify(r)
              }, s.label = 2;

            case 2:
              return s.trys.push([2, 5,, 6]), [4, fetch(F(e.appConfig) + "/" + t.token, i)];

            case 3:
              return [4, s.sent().json()];

            case 4:
              return o = s.sent(), [3, 6];

            case 5:
              throw a = s.sent(), h.create("token-update-failed", {
                errorInfo: a
              });

            case 6:
              if (o.error) throw u = o.error.message, h.create("token-update-failed", {
                errorInfo: u
              });
              if (!o.token) throw h.create("token-update-no-token");
              return [2, o.token];
          }
        });
      });
    }

    function O(e, t) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var n, r, i, o, a;
        return Object(s.__generator)(this, function (s) {
          switch (s.label) {
            case 0:
              return [4, A(e)];

            case 1:
              n = s.sent(), r = {
                method: "DELETE",
                headers: n
              }, s.label = 2;

            case 2:
              return s.trys.push([2, 5,, 6]), [4, fetch(F(e.appConfig) + "/" + t, r)];

            case 3:
              return [4, s.sent().json()];

            case 4:
              if ((i = s.sent()).error) throw o = i.error.message, h.create("token-unsubscribe-failed", {
                errorInfo: o
              });
              return [3, 6];

            case 5:
              throw a = s.sent(), h.create("token-unsubscribe-failed", {
                errorInfo: a
              });

            case 6:
              return [2];
          }
        });
      });
    }

    function F(e) {
      var t = e.projectId;
      return I + "/projects/" + t + "/registrations";
    }

    function A(e) {
      var t = e.appConfig,
          n = e.installations;
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var e;
        return Object(s.__generator)(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, n.getToken()];

            case 1:
              return e = r.sent(), [2, new Headers({
                "Content-Type": "application/json",
                Accept: "application/json",
                "x-goog-api-key": t.apiKey,
                "x-goog-firebase-installations-auth": "FIS " + e
              })];
          }
        });
      });
    }

    function j(e) {
      var t = e.p256dh,
          n = e.auth,
          r = e.endpoint,
          i = e.vapidKey,
          o = {
        web: {
          endpoint: r,
          auth: n,
          p256dh: t
        }
      };
      return i !== D && (o.web.applicationPubKey = i), o;
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var U,
        P = 6048e5;

    function V(e, t, n) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var r, i, o, a;
        return Object(s.__generator)(this, function (s) {
          switch (s.label) {
            case 0:
              if ("granted" !== Notification.permission) throw h.create("permission-blocked");
              return [4, z(t, n)];

            case 1:
              return r = s.sent(), [4, k(e)];

            case 2:
              return i = s.sent(), o = {
                vapidKey: n,
                swScope: t.scope,
                endpoint: r.endpoint,
                auth: f(r.getKey("auth")),
                p256dh: f(r.getKey("p256dh"))
              }, i ? [3, 3] : [2, B(e, o)];

            case 3:
              if (u = i.subscriptionOptions, l = (c = o).vapidKey === u.vapidKey, d = c.endpoint === u.endpoint, p = c.auth === u.auth, m = c.p256dh === u.p256dh, l && d && p && m) return [3, 8];
              s.label = 4;

            case 4:
              return s.trys.push([4, 6,, 7]), [4, O(e, i.token)];

            case 5:
              return s.sent(), [3, 7];

            case 6:
              return a = s.sent(), console.warn(a), [3, 7];

            case 7:
              return [2, B(e, o)];

            case 8:
              return Date.now() >= i.createTime + P ? [2, H({
                token: i.token,
                createTime: Date.now(),
                subscriptionOptions: o
              }, e, t)] : [2, i.token];

            case 9:
              return [2];
          }

          var u, c, l, d, p, m;
          /**
           * @license
           * Copyright 2017 Google Inc.
           *
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           *   http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           */
        });
      });
    }

    function W(e, t) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var n, r;
        return Object(s.__generator)(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, k(e)];

            case 1:
              return (n = i.sent()) ? [4, O(e, n.token)] : [3, 4];

            case 2:
              return i.sent(), [4, S(e)];

            case 3:
              i.sent(), i.label = 4;

            case 4:
              return [4, t.pushManager.getSubscription()];

            case 5:
              return (r = i.sent()) ? [2, r.unsubscribe()] : [2, !0];
          }
        });
      });
    }

    function H(e, t, n) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var r, i, o;
        return Object(s.__generator)(this, function (a) {
          switch (a.label) {
            case 0:
              return a.trys.push([0, 3,, 5]), [4, C(t, e)];

            case 1:
              return r = a.sent(), i = Object(s.__assign)({
                token: r,
                createTime: Date.now()
              }, e), [4, L(t, i)];

            case 2:
              return a.sent(), [2, r];

            case 3:
              return o = a.sent(), [4, W(t, n)];

            case 4:
              throw a.sent(), o;

            case 5:
              return [2];
          }
        });
      });
    }

    function B(e, t) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var n, r;
        return Object(s.__generator)(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, Y(e, t)];

            case 1:
              return n = i.sent(), r = {
                token: n,
                createTime: Date.now(),
                subscriptionOptions: t
              }, [4, L(e, r)];

            case 2:
              return i.sent(), [2, r.token];
          }
        });
      });
    }

    function z(e, t) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var n;
        return Object(s.__generator)(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, e.pushManager.getSubscription()];

            case 1:
              return (n = r.sent()) ? [2, n] : [2, e.pushManager.subscribe({
                userVisibleOnly: !0,
                applicationServerKey: p(t)
              })];
          }
        });
      });
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Z(e) {
      return "object" == typeof e && !!e && x in e;
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    !function (e) {
      e.PUSH_RECEIVED = "push-received", e.NOTIFICATION_CLICKED = "notification-clicked";
    }(U || (U = {}));

    var Q = function () {
      function e(e) {
        var t = this;
        this.firebaseDependencies = e, this.vapidKey = null, this.onMessageCallback = null, navigator.serviceWorker.addEventListener("message", function (e) {
          return t.messageEventListener(e);
        });
      }

      return Object.defineProperty(e.prototype, "app", {
        get: function get() {
          return this.firebaseDependencies.app;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getToken = function () {
        return Object(s.__awaiter)(this, void 0, void 0, function () {
          var e;
          return Object(s.__generator)(this, function (t) {
            switch (t.label) {
              case 0:
                return this.vapidKey || (this.vapidKey = D), [4, this.getServiceWorkerRegistration()];

              case 1:
                return e = t.sent(), "default" !== Notification.permission ? [3, 3] : [4, Notification.requestPermission()];

              case 2:
                t.sent(), t.label = 3;

              case 3:
                if ("granted" !== Notification.permission) throw h.create("permission-blocked");
                return [2, V(this.firebaseDependencies, e, this.vapidKey)];
            }
          });
        });
      }, e.prototype.deleteToken = function () {
        return Object(s.__awaiter)(this, void 0, void 0, function () {
          var e;
          return Object(s.__generator)(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.getServiceWorkerRegistration()];

              case 1:
                return e = t.sent(), [2, W(this.firebaseDependencies, e)];
            }
          });
        });
      }, e.prototype.requestPermission = function () {
        return Object(s.__awaiter)(this, void 0, void 0, function () {
          var e;
          return Object(s.__generator)(this, function (t) {
            switch (t.label) {
              case 0:
                return "granted" === Notification.permission ? [2] : [4, Notification.requestPermission()];

              case 1:
                if ("granted" === (e = t.sent())) return [2];
                throw "denied" === e ? h.create("permission-blocked") : h.create("permission-default");
            }
          });
        });
      }, e.prototype.usePublicVapidKey = function (e) {
        if (null !== this.vapidKey) throw h.create("use-vapid-key-after-get-token");
        if ("string" != typeof e || 0 === e.length) throw h.create("invalid-vapid-key");
        this.vapidKey = e;
      }, e.prototype.useServiceWorker = function (e) {
        if (!(e instanceof ServiceWorkerRegistration)) throw h.create("invalid-sw-registration");
        if (this.swRegistration) throw h.create("use-sw-after-get-token");
        this.swRegistration = e;
      }, e.prototype.onMessage = function (e) {
        var t = this;
        return this.onMessageCallback = "function" == typeof e ? e : e.next, function () {
          t.onMessageCallback = null;
        };
      }, e.prototype.setBackgroundMessageHandler = function () {
        throw h.create("only-available-in-sw");
      }, e.prototype.onTokenRefresh = function () {
        return function () {};
      }, e.prototype.getServiceWorkerRegistration = function () {
        return Object(s.__awaiter)(this, void 0, void 0, function () {
          var e, t;
          return Object(s.__generator)(this, function (n) {
            switch (n.label) {
              case 0:
                if (this.swRegistration) return [3, 4];
                n.label = 1;

              case 1:
                return n.trys.push([1, 3,, 4]), e = this, [4, navigator.serviceWorker.register("/firebase-messaging-sw.js", {
                  scope: "/firebase-cloud-messaging-push-scope"
                })];

              case 2:
                return e.swRegistration = n.sent(), this.swRegistration.update().catch(function () {}), [3, 4];

              case 3:
                throw t = n.sent(), h.create("failed-service-worker-registration", {
                  browserErrorMessage: t.message
                });

              case 4:
                return [2, this.swRegistration];
            }
          });
        });
      }, e.prototype.messageEventListener = function (e) {
        var t;
        return Object(s.__awaiter)(this, void 0, void 0, function () {
          var n, r, i, o;
          return Object(s.__generator)(this, function (a) {
            switch (a.label) {
              case 0:
                return (null === (t = e.data) || void 0 === t ? void 0 : t.firebaseMessaging) ? (n = e.data.firebaseMessaging, r = n.type, i = n.payload, this.onMessageCallback && r === U.PUSH_RECEIVED && this.onMessageCallback(i), Z(o = i.data) && "1" === o["google.c.a.e"] ? [4, this.logEvent(r, o)] : [3, 2]) : [2];

              case 1:
                a.sent(), a.label = 2;

              case 2:
                return [2];
            }
          });
        });
      }, e.prototype.logEvent = function (e, t) {
        return Object(s.__awaiter)(this, void 0, void 0, function () {
          var n;
          return Object(s.__generator)(this, function (r) {
            switch (r.label) {
              case 0:
                return n = function (e) {
                  switch (e) {
                    case U.NOTIFICATION_CLICKED:
                      return "notification_open";

                    case U.PUSH_RECEIVED:
                      return "notification_foreground";

                    default:
                      throw new Error();
                  }
                }
                /**
                 * @license
                 * Copyright 2019 Google Inc.
                 *
                 * Licensed under the Apache License, Version 2.0 (the "License");
                 * you may not use this file except in compliance with the License.
                 * You may obtain a copy of the License at
                 *
                 *   http://www.apache.org/licenses/LICENSE-2.0
                 *
                 * Unless required by applicable law or agreed to in writing, software
                 * distributed under the License is distributed on an "AS IS" BASIS,
                 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                 * See the License for the specific language governing permissions and
                 * limitations under the License.
                 */
                (e), [4, this.firebaseDependencies.analyticsProvider.get()];

              case 1:
                return r.sent().logEvent(n, {
                  message_id: t[x],
                  message_name: t["google.c.a.c_l"],
                  message_time: t["google.c.a.ts"],
                  message_device_time: Math.floor(Date.now() / 1e3)
                }), [2];
            }
          });
        });
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var G = function () {
      function e(e) {
        var t = this;
        this.firebaseDependencies = e, this.vapidKey = null, this.bgMessageHandler = null, self.addEventListener("push", function (e) {
          e.waitUntil(t.onPush(e));
        }), self.addEventListener("pushsubscriptionchange", function (e) {
          e.waitUntil(t.onSubChange(e));
        }), self.addEventListener("notificationclick", function (e) {
          e.waitUntil(t.onNotificationClick(e));
        });
      }

      return Object.defineProperty(e.prototype, "app", {
        get: function get() {
          return this.firebaseDependencies.app;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.setBackgroundMessageHandler = function (e) {
        if (!e || "function" != typeof e) throw h.create("invalid-bg-handler");
        this.bgMessageHandler = e;
      }, e.prototype.getToken = function () {
        var e, t;
        return Object(s.__awaiter)(this, void 0, void 0, function () {
          var n;
          return Object(s.__generator)(this, function (r) {
            switch (r.label) {
              case 0:
                return this.vapidKey ? [3, 2] : [4, k(this.firebaseDependencies)];

              case 1:
                n = r.sent(), this.vapidKey = null !== (t = null === (e = null == n ? void 0 : n.subscriptionOptions) || void 0 === e ? void 0 : e.vapidKey) && void 0 !== t ? t : D, r.label = 2;

              case 2:
                return [2, V(this.firebaseDependencies, self.registration, this.vapidKey)];
            }
          });
        });
      }, e.prototype.deleteToken = function () {
        return W(this.firebaseDependencies, self.registration);
      }, e.prototype.requestPermission = function () {
        throw h.create("only-available-in-window");
      }, e.prototype.usePublicVapidKey = function (e) {
        if (null !== this.vapidKey) throw h.create("use-vapid-key-after-get-token");
        if ("string" != typeof e || 0 === e.length) throw h.create("invalid-vapid-key");
        this.vapidKey = e;
      }, e.prototype.useServiceWorker = function () {
        throw h.create("only-available-in-window");
      }, e.prototype.onMessage = function () {
        throw h.create("only-available-in-window");
      }, e.prototype.onTokenRefresh = function () {
        throw h.create("only-available-in-window");
      }, e.prototype.onPush = function (e) {
        return Object(s.__awaiter)(this, void 0, void 0, function () {
          var t, n, r;
          return Object(s.__generator)(this, function (i) {
            switch (i.label) {
              case 0:
                return (t = function (e) {
                  var t = e.data;
                  if (!t) return null;

                  try {
                    return t.json();
                  } catch (e) {
                    return null;
                  }
                }(e)) ? [4, X()] : [2];

              case 1:
                return function (e) {
                  return e.some(function (e) {
                    return "visible" === e.visibilityState && !e.url.startsWith("chrome-extension://");
                  });
                }(n = i.sent()) ? [2, J(n, t)] : (r = function (e) {
                  var t;
                  if (!e || "object" != typeof e.notification) return;
                  var n = Object(s.__assign)({}, e.notification);
                  return n.data = Object(s.__assign)(Object(s.__assign)({}, e.notification.data), ((t = {})[R] = e, t)), n;
                }(t)) ? [4, $(r)] : [3, 3];

              case 2:
                return i.sent(), [3, 5];

              case 3:
                return this.bgMessageHandler ? [4, this.bgMessageHandler(t)] : [3, 5];

              case 4:
                i.sent(), i.label = 5;

              case 5:
                return [2];
            }
          });
        });
      }, e.prototype.onSubChange = function (e) {
        var t, n;
        return Object(s.__awaiter)(this, void 0, void 0, function () {
          var r;
          return Object(s.__generator)(this, function (i) {
            switch (i.label) {
              case 0:
                return e.newSubscription ? [3, 2] : [4, W(this.firebaseDependencies, self.registration)];

              case 1:
                return i.sent(), [2];

              case 2:
                return [4, k(this.firebaseDependencies)];

              case 3:
                return r = i.sent(), [4, W(this.firebaseDependencies, self.registration)];

              case 4:
                return i.sent(), [4, V(this.firebaseDependencies, self.registration, null !== (n = null === (t = null == r ? void 0 : r.subscriptionOptions) || void 0 === t ? void 0 : t.vapidKey) && void 0 !== n ? n : D)];

              case 5:
                return i.sent(), [2];
            }
          });
        });
      }, e.prototype.onNotificationClick = function (e) {
        var t, n;
        return Object(s.__awaiter)(this, void 0, void 0, function () {
          var r, i, o, a;
          return Object(s.__generator)(this, function (s) {
            switch (s.label) {
              case 0:
                return (r = null === (n = null === (t = e.notification) || void 0 === t ? void 0 : t.data) || void 0 === n ? void 0 : n[R]) ? e.action ? [2] : (e.stopImmediatePropagation(), e.notification.close(), (i = function (e) {
                  var t,
                      n,
                      r,
                      i = null !== (n = null === (t = e.fcmOptions) || void 0 === t ? void 0 : t.link) && void 0 !== n ? n : null === (r = e.notification) || void 0 === r ? void 0 : r.click_action;
                  if (i) return i;
                  return Z(e.data) ? self.location.origin : null;
                }
                /**
                 * @license
                 * Copyright 2017 Google Inc.
                 *
                 * Licensed under the Apache License, Version 2.0 (the "License");
                 * you may not use this file except in compliance with the License.
                 * You may obtain a copy of the License at
                 *
                 *   http://www.apache.org/licenses/LICENSE-2.0
                 *
                 * Unless required by applicable law or agreed to in writing, software
                 * distributed under the License is distributed on an "AS IS" BASIS,
                 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                 * See the License for the specific language governing permissions and
                 * limitations under the License.
                 */
                (r)) ? [4, q(i)] : [2]) : [2];

              case 1:
                return (o = s.sent()) ? [3, 4] : [4, self.clients.openWindow(i)];

              case 2:
                return o = s.sent(), [4, (u = 3e3, new Promise(function (e) {
                  setTimeout(e, u);
                }))];

              case 3:
                return s.sent(), [3, 6];

              case 4:
                return [4, o.focus()];

              case 5:
                o = s.sent(), s.label = 6;

              case 6:
                return o ? (a = K(U.NOTIFICATION_CLICKED, r), [2, o.postMessage(a)]) : [2];
            }

            var u;
          });
        });
      }, e;
    }();

    function q(e) {
      return Object(s.__awaiter)(this, void 0, void 0, function () {
        var t, n, r, i, o, a, u;
        return Object(s.__generator)(this, function (c) {
          switch (c.label) {
            case 0:
              return t = new URL(e, self.location.href), [4, X()];

            case 1:
              n = c.sent();

              try {
                for (r = Object(s.__values)(n), i = r.next(); !i.done; i = r.next()) {
                  if (o = i.value, new URL(o.url, self.location.href).host === t.host) return [2, o];
                }
              } catch (e) {
                a = {
                  error: e
                };
              } finally {
                try {
                  i && !i.done && (u = r.return) && u.call(r);
                } finally {
                  if (a) throw a.error;
                }
              }

              return [2, null];
          }
        });
      });
    }

    function J(e, t) {
      var n,
          r,
          i = K(U.PUSH_RECEIVED, t);

      try {
        for (var o = Object(s.__values)(e), a = o.next(); !a.done; a = o.next()) {
          a.value.postMessage(i);
        }
      } catch (e) {
        n = {
          error: e
        };
      } finally {
        try {
          a && !a.done && (r = o.return) && r.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }

    function X() {
      return self.clients.matchAll({
        type: "window",
        includeUncontrolled: !0
      });
    }

    function K(e, t) {
      return {
        firebaseMessaging: {
          type: e,
          payload: t
        }
      };
    }

    function $(e) {
      var t,
          n = null !== (t = e.title) && void 0 !== t ? t : "",
          r = e.actions,
          i = Notification.maxActions;
      return r && i && r.length > i && console.warn("This browser only supports " + i + " actions. The remaining actions will not be displayed."), self.registration.showNotification(n, e);
    }

    var ee = {
      isSupported: te
    };

    function te() {
      return self && "ServiceWorkerGlobalScope" in self ? "indexedDB" in self && null !== indexedDB && "PushManager" in self && "Notification" in self && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey") : "indexedDB" in window && null !== indexedDB && navigator.cookieEnabled && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && "fetch" in window && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
    }

    o.a.INTERNAL.registerComponent(new a.Component("messaging", function (e) {
      var t = e.getProvider("app").getImmediate(),
          n = {
        app: t,
        appConfig:
        /**
         * @license
         * Copyright 2019 Google Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         *   http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         */
        function (e) {
          var t, n;
          if (!e || !e.options) throw d("App Configuration Object");
          if (!e.name) throw d("App Name");
          var r = e.options;

          try {
            for (var i = Object(s.__values)(["projectId", "apiKey", "appId", "messagingSenderId"]), o = i.next(); !o.done; o = i.next()) {
              var a = o.value;
              if (!r[a]) throw d(a);
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              o && !o.done && (n = i.return) && n.call(i);
            } finally {
              if (t) throw t.error;
            }
          }

          return {
            appName: e.name,
            projectId: r.projectId,
            apiKey: r.apiKey,
            appId: r.appId,
            senderId: r.messagingSenderId
          };
        }(t),
        installations: e.getProvider("installations").getImmediate(),
        analyticsProvider: e.getProvider("analytics-internal")
      };
      if (!te()) throw h.create("unsupported-browser");
      return self && "ServiceWorkerGlobalScope" in self ? new G(n) : new Q(n);
    }, "PUBLIC").setServiceProps(ee));
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "registerStorage", function () {
      return Je;
    });

    var r = n(6),
        i = n.n(r),
        o = n(3),
        a = n(13),
        s = "firebasestorage.googleapis.com",
        u = 12e4,
        c = 6e5,
        l = -9007199254740991,
        h = function () {
      function e(e, t) {
        this.code_ = f(e), this.message_ = "Firebase Storage: " + t, this.serverResponse_ = null, this.name_ = "FirebaseError";
      }

      return e.prototype.codeProp = function () {
        return this.code;
      }, e.prototype.codeEquals = function (e) {
        return f(e) === this.codeProp();
      }, e.prototype.serverResponseProp = function () {
        return this.serverResponse_;
      }, e.prototype.setServerResponseProp = function (e) {
        this.serverResponse_ = e;
      }, Object.defineProperty(e.prototype, "name", {
        get: function get() {
          return this.name_;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "code", {
        get: function get() {
          return this.code_;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "message", {
        get: function get() {
          return this.message_;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "serverResponse", {
        get: function get() {
          return this.serverResponse_;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        d = {
      UNKNOWN: "unknown",
      OBJECT_NOT_FOUND: "object-not-found",
      BUCKET_NOT_FOUND: "bucket-not-found",
      PROJECT_NOT_FOUND: "project-not-found",
      QUOTA_EXCEEDED: "quota-exceeded",
      UNAUTHENTICATED: "unauthenticated",
      UNAUTHORIZED: "unauthorized",
      RETRY_LIMIT_EXCEEDED: "retry-limit-exceeded",
      INVALID_CHECKSUM: "invalid-checksum",
      CANCELED: "canceled",
      INVALID_EVENT_NAME: "invalid-event-name",
      INVALID_URL: "invalid-url",
      INVALID_DEFAULT_BUCKET: "invalid-default-bucket",
      NO_DEFAULT_BUCKET: "no-default-bucket",
      CANNOT_SLICE_BLOB: "cannot-slice-blob",
      SERVER_FILE_WRONG_SIZE: "server-file-wrong-size",
      NO_DOWNLOAD_URL: "no-download-url",
      INVALID_ARGUMENT: "invalid-argument",
      INVALID_ARGUMENT_COUNT: "invalid-argument-count",
      APP_DELETED: "app-deleted",
      INVALID_ROOT_OPERATION: "invalid-root-operation",
      INVALID_FORMAT: "invalid-format",
      INTERNAL_ERROR: "internal-error"
    };

    function f(e) {
      return "storage/" + e;
    }

    function p() {
      return new h(d.UNKNOWN, "An unknown error occurred, please check the error payload for server response.");
    }

    function m() {
      return new h(d.CANCELED, "User canceled the upload/download.");
    }

    function _() {
      return new h(d.CANNOT_SLICE_BLOB, "Cannot slice blob for upload. Please retry the upload.");
    }

    function y(e, t, n) {
      return new h(d.INVALID_ARGUMENT, "Invalid argument in `" + t + "` at index " + e + ": " + n);
    }

    function v() {
      return new h(d.APP_DELETED, "The Firebase app was deleted.");
    }

    function g(e, t) {
      return new h(d.INVALID_FORMAT, "String does not match format '" + e + "': " + t);
    }

    function b(e) {
      throw new h(d.INTERNAL_ERROR, "Internal error: " + e);
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var w = {
      RAW: "raw",
      BASE64: "base64",
      BASE64URL: "base64url",
      DATA_URL: "data_url"
    };

    function T(e) {
      switch (e) {
        case w.RAW:
        case w.BASE64:
        case w.BASE64URL:
        case w.DATA_URL:
          return;

        default:
          throw "Expected one of the event types: [" + w.RAW + ", " + w.BASE64 + ", " + w.BASE64URL + ", " + w.DATA_URL + "].";
      }
    }

    var M = function () {
      return function (e, t) {
        this.data = e, this.contentType = t || null;
      };
    }();

    function E(e, t) {
      switch (e) {
        case w.RAW:
          return new M(k(t));

        case w.BASE64:
        case w.BASE64URL:
          return new M(L(e, t));

        case w.DATA_URL:
          return new M((n = new S(t)).base64 ? L(w.BASE64, n.rest) : function (e) {
            var t;

            try {
              t = decodeURIComponent(e);
            } catch (e) {
              throw g(w.DATA_URL, "Malformed data URL.");
            }

            return k(t);
          }(n.rest), function (e) {
            return new S(e).contentType;
          }(t));
      }

      var n;
      throw p();
    }

    function k(e) {
      for (var t = [], n = 0; n < e.length; n++) {
        var r = e.charCodeAt(n);
        if (r <= 127) t.push(r);else if (r <= 2047) t.push(192 | r >> 6, 128 | 63 & r);else if (55296 == (64512 & r)) {
          if (n < e.length - 1 && 56320 == (64512 & e.charCodeAt(n + 1))) r = 65536 | (1023 & r) << 10 | 1023 & e.charCodeAt(++n), t.push(240 | r >> 18, 128 | r >> 12 & 63, 128 | r >> 6 & 63, 128 | 63 & r);else t.push(239, 191, 189);
        } else 56320 == (64512 & r) ? t.push(239, 191, 189) : t.push(224 | r >> 12, 128 | r >> 6 & 63, 128 | 63 & r);
      }

      return new Uint8Array(t);
    }

    function L(e, t) {
      switch (e) {
        case w.BASE64:
          var n = -1 !== t.indexOf("-"),
              r = -1 !== t.indexOf("_");
          if (n || r) throw g(e, "Invalid character '" + (n ? "-" : "_") + "' found: is it base64url encoded?");
          break;

        case w.BASE64URL:
          var i = -1 !== t.indexOf("+"),
              o = -1 !== t.indexOf("/");
          if (i || o) throw g(e, "Invalid character '" + (i ? "+" : "/") + "' found: is it base64 encoded?");
          t = t.replace(/-/g, "+").replace(/_/g, "/");
      }

      var a;

      try {
        a = atob(t);
      } catch (t) {
        throw g(e, "Invalid character found");
      }

      for (var s = new Uint8Array(a.length), u = 0; u < a.length; u++) {
        s[u] = a.charCodeAt(u);
      }

      return s;
    }

    var S = function () {
      return function (e) {
        this.base64 = !1, this.contentType = null;
        var t = e.match(/^data:([^,]+)?,/);
        if (null === t) throw g(w.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        var n = t[1] || null;
        null != n && (this.base64 = (r = n, i = ";base64", r.length >= i.length && r.substring(r.length - i.length) === i), this.contentType = this.base64 ? n.substring(0, n.length - ";base64".length) : n), this.rest = e.substring(e.indexOf(",") + 1);
        var r, i;
        /**
         * @license
         * Copyright 2017 Google Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         *   http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         */
      };
    }();

    var N,
        D = {
      STATE_CHANGED: "state_changed"
    },
        I = {
      RUNNING: "running",
      PAUSING: "pausing",
      PAUSED: "paused",
      SUCCESS: "success",
      CANCELING: "canceling",
      CANCELED: "canceled",
      ERROR: "error"
    },
        R = {
      RUNNING: "running",
      PAUSED: "paused",
      SUCCESS: "success",
      CANCELED: "canceled",
      ERROR: "error"
    };

    function x(e) {
      switch (e) {
        case I.RUNNING:
        case I.PAUSING:
        case I.CANCELING:
          return R.RUNNING;

        case I.PAUSED:
          return R.PAUSED;

        case I.SUCCESS:
          return R.SUCCESS;

        case I.CANCELED:
          return R.CANCELED;

        case I.ERROR:
        default:
          return R.ERROR;
      }
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Y(e) {
      return null != e;
    }

    function C(e) {
      return void 0 !== e;
    }

    function O(e) {
      return "function" == typeof e;
    }

    function F(e) {
      return "object" == typeof e;
    }

    function A(e) {
      return F(e) && null !== e;
    }

    function j(e) {
      return "string" == typeof e || e instanceof String;
    }

    function U(e) {
      return P(e) && Number.isInteger(e);
    }

    function P(e) {
      return "number" == typeof e || e instanceof Number;
    }

    function V(e) {
      return W() && e instanceof Blob;
    }

    function W() {
      return "undefined" != typeof Blob;
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    !function (e) {
      e[e.NO_ERROR = 0] = "NO_ERROR", e[e.NETWORK_ERROR = 1] = "NETWORK_ERROR", e[e.ABORT = 2] = "ABORT";
    }(N || (N = {}));
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    var H = function () {
      function e() {
        var e = this;
        this.sent_ = !1, this.xhr_ = new XMLHttpRequest(), this.errorCode_ = N.NO_ERROR, this.sendPromise_ = new Promise(function (t) {
          e.xhr_.addEventListener("abort", function () {
            e.errorCode_ = N.ABORT, t(e);
          }), e.xhr_.addEventListener("error", function () {
            e.errorCode_ = N.NETWORK_ERROR, t(e);
          }), e.xhr_.addEventListener("load", function () {
            t(e);
          });
        });
      }

      return e.prototype.send = function (e, t, n, r) {
        if (this.sent_) throw b("cannot .send() more than once");
        if (this.sent_ = !0, this.xhr_.open(t, e, !0), Y(r)) for (var i in r) {
          r.hasOwnProperty(i) && this.xhr_.setRequestHeader(i, r[i].toString());
        }
        return Y(n) ? this.xhr_.send(n) : this.xhr_.send(), this.sendPromise_;
      }, e.prototype.getErrorCode = function () {
        if (!this.sent_) throw b("cannot .getErrorCode() before sending");
        return this.errorCode_;
      }, e.prototype.getStatus = function () {
        if (!this.sent_) throw b("cannot .getStatus() before sending");

        try {
          return this.xhr_.status;
        } catch (e) {
          return -1;
        }
      }, e.prototype.getResponseText = function () {
        if (!this.sent_) throw b("cannot .getResponseText() before sending");
        return this.xhr_.responseText;
      }, e.prototype.abort = function () {
        this.xhr_.abort();
      }, e.prototype.getResponseHeader = function (e) {
        return this.xhr_.getResponseHeader(e);
      }, e.prototype.addUploadProgressListener = function (e) {
        Y(this.xhr_.upload) && this.xhr_.upload.addEventListener("progress", e);
      }, e.prototype.removeUploadProgressListener = function (e) {
        Y(this.xhr_.upload) && this.xhr_.upload.removeEventListener("progress", e);
      }, e;
    }(),
        B = function () {
      function e() {}

      return e.prototype.createXhrIo = function () {
        return new H();
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function z() {
      return "undefined" != typeof BlobBuilder ? BlobBuilder : "undefined" != typeof WebKitBlobBuilder ? WebKitBlobBuilder : void 0;
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var Z = function () {
      function e(e, t) {
        var n = 0,
            r = "";
        V(e) ? (this.data_ = e, n = e.size, r = e.type) : e instanceof ArrayBuffer ? (t ? this.data_ = new Uint8Array(e) : (this.data_ = new Uint8Array(e.byteLength), this.data_.set(new Uint8Array(e))), n = this.data_.length) : e instanceof Uint8Array && (t ? this.data_ = e : (this.data_ = new Uint8Array(e.length), this.data_.set(e)), n = e.length), this.size_ = n, this.type_ = r;
      }

      return e.prototype.size = function () {
        return this.size_;
      }, e.prototype.type = function () {
        return this.type_;
      }, e.prototype.slice = function (t, n) {
        if (V(this.data_)) {
          var r = this.data_,
              i = (a = t, s = n, (o = r).webkitSlice ? o.webkitSlice(a, s) : o.mozSlice ? o.mozSlice(a, s) : o.slice ? o.slice(a, s) : null);
          return null === i ? null : new e(i);
        }

        var o, a, s;
        return new e(new Uint8Array(this.data_.buffer, t, n - t), !0);
      }, e.getBlob = function () {
        for (var t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }

        if (W()) {
          var r = t.map(function (t) {
            return t instanceof e ? t.data_ : t;
          });
          return new e(function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            var n = z();

            if (void 0 !== n) {
              for (var r = new n(), i = 0; i < e.length; i++) {
                r.append(e[i]);
              }

              return r.getBlob();
            }

            if (W()) return new Blob(e);
            throw Error("This browser doesn't seem to support creating Blobs");
          }.apply(null, r));
        }

        var i = t.map(function (e) {
          return j(e) ? E(w.RAW, e).data : e.data_;
        }),
            o = 0;
        i.forEach(function (e) {
          o += e.byteLength;
        });
        var a = new Uint8Array(o),
            s = 0;
        return i.forEach(function (e) {
          for (var t = 0; t < e.length; t++) {
            a[s++] = e[t];
          }
        }), new e(a, !0);
      }, e.prototype.uploadData = function () {
        return this.data_;
      }, e;
    }(),
        Q = function () {
      function e(e, t) {
        this.bucket = e, this.path_ = t;
      }

      return Object.defineProperty(e.prototype, "path", {
        get: function get() {
          return this.path_;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isRoot", {
        get: function get() {
          return 0 === this.path.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.fullServerUrl = function () {
        var e = encodeURIComponent;
        return "/b/" + e(this.bucket) + "/o/" + e(this.path);
      }, e.prototype.bucketOnlyServerUrl = function () {
        return "/b/" + encodeURIComponent(this.bucket) + "/o";
      }, e.makeFromBucketSpec = function (t) {
        var n, r;

        try {
          n = e.makeFromUrl(t);
        } catch (n) {
          return new e(t, "");
        }

        if ("" === n.path) return n;
        throw r = t, new h(d.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + r + "'.");
      }, e.makeFromUrl = function (t) {
        var n = null;
        var r = new RegExp("^gs://([A-Za-z0-9.\\-_]+)(/(.*))?$", "i");

        function i(e) {
          e.path_ = decodeURIComponent(e.path);
        }

        for (var o = s.replace(/[.]/g, "\\."), a = [{
          regex: r,
          indices: {
            bucket: 1,
            path: 3
          },
          postModify: function postModify(e) {
            "/" === e.path.charAt(e.path.length - 1) && (e.path_ = e.path_.slice(0, -1));
          }
        }, {
          regex: new RegExp("^https?://" + o + "/v[A-Za-z0-9_]+/b/([A-Za-z0-9.\\-_]+)/o(/([^?#]*).*)?$", "i"),
          indices: {
            bucket: 1,
            path: 3
          },
          postModify: i
        }, {
          regex: new RegExp("^https?://(?:storage.googleapis.com|storage.cloud.google.com)/([A-Za-z0-9.\\-_]+)/([^?#]*)", "i"),
          indices: {
            bucket: 1,
            path: 2
          },
          postModify: i
        }], u = 0; u < a.length; u++) {
          var c = a[u],
              l = c.regex.exec(t);

          if (l) {
            var f = l[c.indices.bucket],
                p = l[c.indices.path];
            p || (p = ""), n = new e(f, p), c.postModify(n);
            break;
          }
        }

        if (null == n) throw function (e) {
          return new h(d.INVALID_URL, "Invalid URL '" + e + "'.");
        }(t);
        return n;
      }, e;
    }();
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function G(e) {
      var t, n;

      try {
        t = JSON.parse(e);
      } catch (e) {
        return null;
      }

      return F(n = t) && !Array.isArray(n) ? t : null;
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function q(e) {
      var t = e.lastIndexOf("/", e.length - 2);
      return -1 === t ? e : e.slice(t + 1);
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function J(e) {
      return "https://" + s + "/v0" + e;
    }

    function X(e) {
      var t = encodeURIComponent,
          n = "?";

      for (var r in e) {
        if (e.hasOwnProperty(r)) n = n + (t(r) + "=" + t(e[r])) + "&";
      }

      return n = n.slice(0, -1);
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function K(e, t) {
      return t;
    }

    var $ = function () {
      return function (e, t, n, r) {
        this.server = e, this.local = t || e, this.writable = !!n, this.xform = r || K;
      };
    }(),
        ee = null;

    function te() {
      if (ee) return ee;
      var e = [];
      e.push(new $("bucket")), e.push(new $("generation")), e.push(new $("metageneration")), e.push(new $("name", "fullPath", !0));
      var t = new $("name");
      t.xform = function (e, t) {
        return function (e) {
          return !j(e) || e.length < 2 ? e : q(e);
        }(t);
      }, e.push(t);
      var n = new $("size");
      return n.xform = function (e, t) {
        return Y(t) ? Number(t) : t;
      }, e.push(n), e.push(new $("timeCreated")), e.push(new $("updated")), e.push(new $("md5Hash", null, !0)), e.push(new $("cacheControl", null, !0)), e.push(new $("contentDisposition", null, !0)), e.push(new $("contentEncoding", null, !0)), e.push(new $("contentLanguage", null, !0)), e.push(new $("contentType", null, !0)), e.push(new $("metadata", "customMetadata", !0)), ee = e;
    }

    function ne(e, t, n) {
      for (var r = {
        type: "file"
      }, i = n.length, o = 0; o < i; o++) {
        var a = n[o];
        r[a.local] = a.xform(r, t[a.server]);
      }

      return function (e, t) {
        Object.defineProperty(e, "ref", {
          get: function get() {
            var n = e.bucket,
                r = e.fullPath,
                i = new Q(n, r);
            return t.makeStorageReference(i);
          }
        });
      }(r, e), r;
    }

    function re(e, t, n) {
      var r = G(t);
      return null === r ? null : ne(e, r, n);
    }

    function ie(e, t) {
      for (var n = {}, r = t.length, i = 0; i < r; i++) {
        var o = t[i];
        o.writable && (n[o.server] = e[o.local]);
      }

      return JSON.stringify(n);
    }

    function oe(e) {
      if (!F(e) || !e) throw "Expected Metadata object.";

      for (var t in e) {
        if (e.hasOwnProperty(t)) {
          var n = e[t];

          if ("customMetadata" === t) {
            if (!F(n)) throw "Expected object for 'customMetadata' mapping.";
          } else if (A(n)) throw "Mapping for '" + t + "' cannot be an object.";
        }
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var ae = "maxResults",
        se = 1e3,
        ue = "pageToken",
        ce = "prefixes",
        le = "items";

    function he(e, t, n) {
      var r = G(n);
      return null === r ? null : function (e, t, n) {
        var r = {
          prefixes: [],
          items: [],
          nextPageToken: n.nextPageToken
        };
        if (n[ce]) for (var i = 0, o = n[ce]; i < o.length; i++) {
          var a = o[i].replace(/\/$/, ""),
              s = e.makeStorageReference(new Q(t, a));
          r.prefixes.push(s);
        }
        if (n[le]) for (var u = 0, c = n[le]; u < c.length; u++) {
          var l = c[u];
          s = e.makeStorageReference(new Q(t, l.name)), r.items.push(s);
        }
        return r;
      }(e, t, r);
    }

    function de(e) {
      if (!F(e) || !e) throw "Expected ListOptions object.";

      for (var t in e) {
        if (t === ae) {
          if (!U(e[ae]) || e[ae] <= 0) throw "Expected maxResults to be a positive number.";
          if (e[ae] > 1e3) throw "Expected maxResults to be less than or equal to " + se + ".";
        } else {
          if (t !== ue) throw "Unknown option: " + t;
          if (e[ue] && !j(e[ue])) throw "Expected pageToken to be string.";
        }
      }
    }

    var fe = function () {
      return function (e, t, n, r) {
        this.url = e, this.method = t, this.handler = n, this.timeout = r, this.urlParams = {}, this.headers = {}, this.body = null, this.errorHandler = null, this.progressCallback = null, this.successCodes = [200], this.additionalRetryCodes = [];
      };
    }();
    /**
     * @license
     * Copyright 2017 Google LLC
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function pe(e) {
      if (!e) throw p();
    }

    function me(e, t) {
      return function (n, r) {
        var i = re(e, r, t);
        return pe(null !== i), i;
      };
    }

    function _e(e, t) {
      return function (n, r) {
        var i = re(e, r, t);
        return pe(null !== i), function (e, t) {
          var n = G(t);
          if (null === n) return null;
          if (!j(n.downloadTokens)) return null;
          var r = n.downloadTokens;
          if (0 === r.length) return null;
          var i = encodeURIComponent;
          return r.split(",").map(function (t) {
            var n = e.bucket,
                r = e.fullPath;
            return J("/b/" + i(n) + "/o/" + i(r)) + X({
              alt: "media",
              token: t
            });
          })[0];
        }(i, r);
      };
    }

    function ye(e) {
      return function (t, n) {
        var r, i, o;
        return 401 === t.getStatus() ? r = new h(d.UNAUTHENTICATED, "User is not authenticated, please authenticate using Firebase Authentication and try again.") : 402 === t.getStatus() ? (o = e.bucket, r = new h(d.QUOTA_EXCEEDED, "Quota for bucket '" + o + "' exceeded, please view quota on https://firebase.google.com/pricing/.")) : 403 === t.getStatus() ? (i = e.path, r = new h(d.UNAUTHORIZED, "User does not have permission to access '" + i + "'.")) : r = n, r.setServerResponseProp(n.serverResponseProp()), r;
      };
    }

    function ve(e) {
      var t = ye(e);
      return function (n, r) {
        var i,
            o = t(n, r);
        return 404 === n.getStatus() && (i = e.path, o = new h(d.OBJECT_NOT_FOUND, "Object '" + i + "' does not exist.")), o.setServerResponseProp(r.serverResponseProp()), o;
      };
    }

    function ge(e, t, n) {
      var r = J(t.fullServerUrl()),
          i = e.maxOperationRetryTime(),
          o = new fe(r, "GET", me(e, n), i);
      return o.errorHandler = ve(t), o;
    }

    function be(e, t, n, r, i) {
      var o = {};
      t.isRoot ? o.prefix = "" : o.prefix = t.path + "/", n && n.length > 0 && (o.delimiter = n), r && (o.pageToken = r), i && (o.maxResults = i);
      var a = J(t.bucketOnlyServerUrl()),
          s = e.maxOperationRetryTime(),
          u = new fe(a, "GET", function (e, t) {
        return function (n, r) {
          var i = he(e, t, r);
          return pe(null !== i), i;
        };
      }(e, t.bucket), s);
      return u.urlParams = o, u.errorHandler = ye(t), u;
    }

    function we(e, t, n) {
      var r = Object.assign({}, n);
      return r.fullPath = e.path, r.size = t.size(), r.contentType || (r.contentType = function (e, t) {
        return e && e.contentType || t && t.type() || "application/octet-stream";
      }(null, t)), r;
    }

    var Te = function () {
      return function (e, t, n, r) {
        this.current = e, this.total = t, this.finalized = !!n, this.metadata = r || null;
      };
    }();

    function Me(e, t) {
      var n = null;

      try {
        n = e.getResponseHeader("X-Goog-Upload-Status");
      } catch (e) {
        pe(!1);
      }

      return pe(!!n && -1 !== (t || ["active"]).indexOf(n)), n;
    }

    function Ee(e, t, n, r, i, o, a, s) {
      var u = new Te(0, 0);
      if (a ? (u.current = a.current, u.total = a.total) : (u.current = 0, u.total = r.size()), r.size() !== u.total) throw new h(d.SERVER_FILE_WRONG_SIZE, "Server recorded incorrect upload file size, please retry the upload.");
      var c = u.total - u.current,
          l = c;
      i > 0 && (l = Math.min(l, i));
      var f = u.current,
          p = f + l,
          m = {
        "X-Goog-Upload-Command": l === c ? "upload, finalize" : "upload",
        "X-Goog-Upload-Offset": u.current
      },
          y = r.slice(f, p);
      if (null === y) throw _();
      var v = t.maxUploadRetryTime(),
          g = new fe(n, "POST", function (e, n) {
        var i,
            a = Me(e, ["active", "final"]),
            s = u.current + l,
            c = r.size();
        return i = "final" === a ? me(t, o)(e, n) : null, new Te(s, c, "final" === a, i);
      }, v);
      return g.headers = m, g.body = y.uploadData(), g.progressCallback = s || null, g.errorHandler = ye(e), g;
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var ke = function () {
      return function (e, t, n) {
        if (O(e) || Y(t) || Y(n)) this.next = e, this.error = t || null, this.complete = n || null;else {
          var r = e;
          this.next = r.next || null, this.error = r.error || null, this.complete = r.complete || null;
        }
      };
    }(),
        Le = function () {
      return function (e, t, n, r, i, o) {
        this.bytesTransferred = e, this.totalBytes = t, this.state = n, this.metadata = r, this.task = i, this.ref = o;
      };
    }();
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Se(e, t, n) {
      for (var r = t.length, i = t.length, o = 0; o < t.length; o++) {
        if (t[o].optional) {
          r = o;
          break;
        }
      }

      var a, s, u, c, l, f;
      if (!(r <= n.length && n.length <= i)) throw a = r, s = i, u = e, c = n.length, a === s ? (l = a, f = 1 === a ? "argument" : "arguments") : (l = "between " + a + " and " + s, f = "arguments"), new h(d.INVALID_ARGUMENT_COUNT, "Invalid argument count in `" + u + "`: Expected " + l + " " + f + ", received " + c + ".");

      for (o = 0; o < n.length; o++) {
        try {
          t[o].validator(n[o]);
        } catch (t) {
          throw t instanceof Error ? y(o, e, t.message) : y(o, e, t);
        }
      }
    }

    var Ne = function () {
      return function (e, t) {
        var n = this;
        this.validator = function (t) {
          n.optional && !C(t) || e(t);
        }, this.optional = !!t;
      };
    }();

    function De(e, t) {
      function n(e) {
        if (!j(e)) throw "Expected string.";
      }

      var r, i, o;
      return e ? (i = n, o = e, r = function r(e) {
        i(e), o(e);
      }) : r = n, new Ne(r, t);
    }

    function Ie() {
      return new Ne(function (e) {
        if (!(e instanceof Uint8Array || e instanceof ArrayBuffer || W() && e instanceof Blob)) throw "Expected Blob or File.";
      });
    }

    function Re(e) {
      return new Ne(oe, e);
    }

    function xe() {
      return new Ne(function (e) {
        if (!(P(e) && e >= 0)) throw "Expected a number 0 or greater.";
      });
    }

    function Ye(e, t) {
      return new Ne(function (t) {
        if (!(null === t || Y(t) && t instanceof Object)) throw "Expected an Object.";
        null != e && e(t);
      }, t);
    }

    function Ce(e) {
      return new Ne(function (e) {
        if (null !== e && !O(e)) throw "Expected a Function.";
      }, e);
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function Oe(e) {
      return function () {
        for (var t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }

        Promise.resolve().then(function () {
          return e.apply(void 0, t);
        });
      };
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var Fe = function () {
      function e(e, t, n, r, i, o) {
        var a = this;
        void 0 === o && (o = null), this.transferred_ = 0, this.needToFetchStatus_ = !1, this.needToFetchMetadata_ = !1, this.observers_ = [], this.error_ = null, this.uploadUrl_ = null, this.request_ = null, this.chunkMultiplier_ = 1, this.resolve_ = null, this.reject_ = null, this.ref_ = e, this.authWrapper_ = t, this.location_ = n, this.blob_ = i, this.metadata_ = o, this.mappings_ = r, this.resumable_ = this.shouldDoResumable_(this.blob_), this.state_ = I.RUNNING, this.errorHandler_ = function (e) {
          a.request_ = null, a.chunkMultiplier_ = 1, e.codeEquals(d.CANCELED) ? (a.needToFetchStatus_ = !0, a.completeTransitions_()) : (a.error_ = e, a.transition_(I.ERROR));
        }, this.metadataErrorHandler_ = function (e) {
          a.request_ = null, e.codeEquals(d.CANCELED) ? a.completeTransitions_() : (a.error_ = e, a.transition_(I.ERROR));
        }, this.promise_ = new Promise(function (e, t) {
          a.resolve_ = e, a.reject_ = t, a.start_();
        }), this.promise_.then(null, function () {});
      }

      return e.prototype.makeProgressCallback_ = function () {
        var e = this,
            t = this.transferred_;
        return function (n) {
          return e.updateProgress_(t + n);
        };
      }, e.prototype.shouldDoResumable_ = function (e) {
        return e.size() > 262144;
      }, e.prototype.start_ = function () {
        this.state_ === I.RUNNING && null === this.request_ && (this.resumable_ ? null === this.uploadUrl_ ? this.createResumable_() : this.needToFetchStatus_ ? this.fetchStatus_() : this.needToFetchMetadata_ ? this.fetchMetadata_() : this.continueUpload_() : this.oneShotUpload_());
      }, e.prototype.resolveToken_ = function (e) {
        var t = this;
        this.authWrapper_.getAuthToken().then(function (n) {
          switch (t.state_) {
            case I.RUNNING:
              e(n);
              break;

            case I.CANCELING:
              t.transition_(I.CANCELED);
              break;

            case I.PAUSING:
              t.transition_(I.PAUSED);
          }
        });
      }, e.prototype.createResumable_ = function () {
        var e = this;
        this.resolveToken_(function (t) {
          var n = function (e, t, n, r, i) {
            var o = t.bucketOnlyServerUrl(),
                a = we(t, r, i),
                s = {
              name: a.fullPath
            },
                u = J(o),
                c = {
              "X-Goog-Upload-Protocol": "resumable",
              "X-Goog-Upload-Command": "start",
              "X-Goog-Upload-Header-Content-Length": r.size(),
              "X-Goog-Upload-Header-Content-Type": a.contentType,
              "Content-Type": "application/json; charset=utf-8"
            },
                l = ie(a, n),
                h = e.maxUploadRetryTime(),
                d = new fe(u, "POST", function (e) {
              var t;
              Me(e);

              try {
                t = e.getResponseHeader("X-Goog-Upload-URL");
              } catch (e) {
                pe(!1);
              }

              return pe(j(t)), t;
            }, h);
            return d.urlParams = s, d.headers = c, d.body = l, d.errorHandler = ye(t), d;
          }(e.authWrapper_, e.location_, e.mappings_, e.blob_, e.metadata_),
              r = e.authWrapper_.makeRequest(n, t);

          e.request_ = r, r.getPromise().then(function (t) {
            e.request_ = null, e.uploadUrl_ = t, e.needToFetchStatus_ = !1, e.completeTransitions_();
          }, e.errorHandler_);
        });
      }, e.prototype.fetchStatus_ = function () {
        var e = this,
            t = this.uploadUrl_;
        this.resolveToken_(function (n) {
          var r = function (e, t, n, r) {
            var i = e.maxUploadRetryTime(),
                o = new fe(n, "POST", function (e) {
              var t = Me(e, ["active", "final"]),
                  n = null;

              try {
                n = e.getResponseHeader("X-Goog-Upload-Size-Received");
              } catch (e) {
                pe(!1);
              }

              n || pe(!1);
              var i = Number(n);
              return pe(!isNaN(i)), new Te(i, r.size(), "final" === t);
            }, i);
            return o.headers = {
              "X-Goog-Upload-Command": "query"
            }, o.errorHandler = ye(t), o;
          }(e.authWrapper_, e.location_, t, e.blob_),
              i = e.authWrapper_.makeRequest(r, n);

          e.request_ = i, i.getPromise().then(function (t) {
            t = t, e.request_ = null, e.updateProgress_(t.current), e.needToFetchStatus_ = !1, t.finalized && (e.needToFetchMetadata_ = !0), e.completeTransitions_();
          }, e.errorHandler_);
        });
      }, e.prototype.continueUpload_ = function () {
        var e = this,
            t = 262144 * this.chunkMultiplier_,
            n = new Te(this.transferred_, this.blob_.size()),
            r = this.uploadUrl_;
        this.resolveToken_(function (i) {
          var o;

          try {
            o = Ee(e.location_, e.authWrapper_, r, e.blob_, t, e.mappings_, n, e.makeProgressCallback_());
          } catch (t) {
            return e.error_ = t, void e.transition_(I.ERROR);
          }

          var a = e.authWrapper_.makeRequest(o, i);
          e.request_ = a, a.getPromise().then(function (t) {
            e.increaseMultiplier_(), e.request_ = null, e.updateProgress_(t.current), t.finalized ? (e.metadata_ = t.metadata, e.transition_(I.SUCCESS)) : e.completeTransitions_();
          }, e.errorHandler_);
        });
      }, e.prototype.increaseMultiplier_ = function () {
        262144 * this.chunkMultiplier_ < 33554432 && (this.chunkMultiplier_ *= 2);
      }, e.prototype.fetchMetadata_ = function () {
        var e = this;
        this.resolveToken_(function (t) {
          var n = ge(e.authWrapper_, e.location_, e.mappings_),
              r = e.authWrapper_.makeRequest(n, t);
          e.request_ = r, r.getPromise().then(function (t) {
            e.request_ = null, e.metadata_ = t, e.transition_(I.SUCCESS);
          }, e.metadataErrorHandler_);
        });
      }, e.prototype.oneShotUpload_ = function () {
        var e = this;
        this.resolveToken_(function (t) {
          var n = function (e, t, n, r, i) {
            var o = t.bucketOnlyServerUrl(),
                a = {
              "X-Goog-Upload-Protocol": "multipart"
            },
                s = function () {
              for (var e = "", t = 0; t < 2; t++) {
                e += Math.random().toString().slice(2);
              }

              return e;
            }();

            a["Content-Type"] = "multipart/related; boundary=" + s;
            var u = we(t, r, i),
                c = "--" + s + "\r\nContent-Type: application/json; charset=utf-8\r\n\r\n" + ie(u, n) + "\r\n--" + s + "\r\nContent-Type: " + u.contentType + "\r\n\r\n",
                l = "\r\n--" + s + "--",
                h = Z.getBlob(c, r, l);
            if (null === h) throw _();
            var d = {
              name: u.fullPath
            },
                f = J(o),
                p = e.maxUploadRetryTime(),
                m = new fe(f, "POST", me(e, n), p);
            return m.urlParams = d, m.headers = a, m.body = h.uploadData(), m.errorHandler = ye(t), m;
          }(e.authWrapper_, e.location_, e.mappings_, e.blob_, e.metadata_),
              r = e.authWrapper_.makeRequest(n, t);

          e.request_ = r, r.getPromise().then(function (t) {
            e.request_ = null, e.metadata_ = t, e.updateProgress_(e.blob_.size()), e.transition_(I.SUCCESS);
          }, e.errorHandler_);
        });
      }, e.prototype.updateProgress_ = function (e) {
        var t = this.transferred_;
        this.transferred_ = e, this.transferred_ !== t && this.notifyObservers_();
      }, e.prototype.transition_ = function (e) {
        if (this.state_ !== e) switch (e) {
          case I.CANCELING:
          case I.PAUSING:
            this.state_ = e, null !== this.request_ && this.request_.cancel();
            break;

          case I.RUNNING:
            var t = this.state_ === I.PAUSED;
            this.state_ = e, t && (this.notifyObservers_(), this.start_());
            break;

          case I.PAUSED:
            this.state_ = e, this.notifyObservers_();
            break;

          case I.CANCELED:
            this.error_ = m(), this.state_ = e, this.notifyObservers_();
            break;

          case I.ERROR:
          case I.SUCCESS:
            this.state_ = e, this.notifyObservers_();
        }
      }, e.prototype.completeTransitions_ = function () {
        switch (this.state_) {
          case I.PAUSING:
            this.transition_(I.PAUSED);
            break;

          case I.CANCELING:
            this.transition_(I.CANCELED);
            break;

          case I.RUNNING:
            this.start_();
        }
      }, Object.defineProperty(e.prototype, "snapshot", {
        get: function get() {
          var e = x(this.state_);
          return new Le(this.transferred_, this.blob_.size(), e, this.metadata_, this, this.ref_);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.on = function (e, t, n, r) {
        var i = "Expected a function or an Object with one of `next`, `error`, `complete` properties.",
            o = Ce(!0).validator,
            a = Ye(null, !0).validator;

        function s(e) {
          try {
            return void o(e);
          } catch (e) {}

          try {
            if (a(e), !(C(e.next) || C(e.error) || C(e.complete))) throw "";
            return;
          } catch (e) {
            throw i;
          }
        }

        Se("on", [De(function () {
          if (e !== D.STATE_CHANGED) throw "Expected one of the event types: [" + D.STATE_CHANGED + "].";
        }), Ye(s, !0), Ce(!0), Ce(!0)], arguments);
        var u = this;

        function c(e) {
          return function (t, n, i) {
            null !== e && Se("on", e, arguments);
            var o = new ke(t, n, r);
            return u.addObserver_(o), function () {
              u.removeObserver_(o);
            };
          };
        }

        var l = [Ye(function (e) {
          if (null === e) throw i;
          s(e);
        }), Ce(!0), Ce(!0)];
        return !(C(t) || C(n) || C(r)) ? c(l) : c(null)(t, n, r);
      }, e.prototype.then = function (e, t) {
        return this.promise_.then(e, t);
      }, e.prototype.catch = function (e) {
        return this.then(null, e);
      }, e.prototype.addObserver_ = function (e) {
        this.observers_.push(e), this.notifyObserver_(e);
      }, e.prototype.removeObserver_ = function (e) {
        var t = this.observers_.indexOf(e);
        -1 !== t && this.observers_.splice(t, 1);
      }, e.prototype.notifyObservers_ = function () {
        var e = this;
        this.finishPromise_(), this.observers_.slice().forEach(function (t) {
          e.notifyObserver_(t);
        });
      }, e.prototype.finishPromise_ = function () {
        if (null !== this.resolve_) {
          var e = !0;

          switch (x(this.state_)) {
            case R.SUCCESS:
              Oe(this.resolve_.bind(null, this.snapshot))();
              break;

            case R.CANCELED:
            case R.ERROR:
              Oe(this.reject_.bind(null, this.error_))();
              break;

            default:
              e = !1;
          }

          e && (this.resolve_ = null, this.reject_ = null);
        }
      }, e.prototype.notifyObserver_ = function (e) {
        switch (x(this.state_)) {
          case R.RUNNING:
          case R.PAUSED:
            e.next && Oe(e.next.bind(e, this.snapshot))();
            break;

          case R.SUCCESS:
            e.complete && Oe(e.complete.bind(e))();
            break;

          case R.CANCELED:
          case R.ERROR:
            e.error && Oe(e.error.bind(e, this.error_))();
            break;

          default:
            e.error && Oe(e.error.bind(e, this.error_))();
        }
      }, e.prototype.resume = function () {
        Se("resume", [], arguments);
        var e = this.state_ === I.PAUSED || this.state_ === I.PAUSING;
        return e && this.transition_(I.RUNNING), e;
      }, e.prototype.pause = function () {
        Se("pause", [], arguments);
        var e = this.state_ === I.RUNNING;
        return e && this.transition_(I.PAUSING), e;
      }, e.prototype.cancel = function () {
        Se("cancel", [], arguments);
        var e = this.state_ === I.RUNNING || this.state_ === I.PAUSING;
        return e && this.transition_(I.CANCELING), e;
      }, e;
    }(),
        Ae = function () {
      function e(e, t) {
        this.authWrapper = e, this.location = t instanceof Q ? t : Q.makeFromUrl(t);
      }

      return e.prototype.toString = function () {
        return Se("toString", [], arguments), "gs://" + this.location.bucket + "/" + this.location.path;
      }, e.prototype.newRef = function (t, n) {
        return new e(t, n);
      }, e.prototype.mappings = function () {
        return te();
      }, e.prototype.child = function (e) {
        Se("child", [De()], arguments);

        var t = function (e, t) {
          var n = t.split("/").filter(function (e) {
            return e.length > 0;
          }).join("/");
          return 0 === e.length ? n : e + "/" + n;
        }(this.location.path, e),
            n = new Q(this.location.bucket, t);

        return this.newRef(this.authWrapper, n);
      }, Object.defineProperty(e.prototype, "parent", {
        get: function get() {
          var e = function (e) {
            if (0 === e.length) return null;
            var t = e.lastIndexOf("/");
            return -1 === t ? "" : e.slice(0, t);
          }(this.location.path);

          if (null === e) return null;
          var t = new Q(this.location.bucket, e);
          return this.newRef(this.authWrapper, t);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "root", {
        get: function get() {
          var e = new Q(this.location.bucket, "");
          return this.newRef(this.authWrapper, e);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "bucket", {
        get: function get() {
          return this.location.bucket;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "fullPath", {
        get: function get() {
          return this.location.path;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "name", {
        get: function get() {
          return q(this.location.path);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "storage", {
        get: function get() {
          return this.authWrapper.service();
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.put = function (e, t) {
        return void 0 === t && (t = null), Se("put", [Ie(), Re(!0)], arguments), this.throwIfRoot_("put"), new Fe(this, this.authWrapper, this.location, this.mappings(), new Z(e), t);
      }, e.prototype.putString = function (e, t, n) {
        void 0 === t && (t = w.RAW), Se("putString", [De(), De(T, !0), Re(!0)], arguments), this.throwIfRoot_("putString");
        var r = E(t, e),
            i = Object.assign({}, n);
        return !Y(i.contentType) && Y(r.contentType) && (i.contentType = r.contentType), new Fe(this, this.authWrapper, this.location, this.mappings(), new Z(r.data, !0), i);
      }, e.prototype.delete = function () {
        var e = this;
        return Se("delete", [], arguments), this.throwIfRoot_("delete"), this.authWrapper.getAuthToken().then(function (t) {
          var n = function (e, t) {
            var n = J(t.fullServerUrl()),
                r = e.maxOperationRetryTime(),
                i = new fe(n, "DELETE", function (e, t) {}, r);
            return i.successCodes = [200, 204], i.errorHandler = ve(t), i;
          }(e.authWrapper, e.location);

          return e.authWrapper.makeRequest(n, t).getPromise();
        });
      }, e.prototype.listAll = function () {
        Se("listAll", [], arguments);
        var e = {
          prefixes: [],
          items: []
        };
        return this.listAllHelper(e).then(function () {
          return e;
        });
      }, e.prototype.listAllHelper = function (e, t) {
        return Object(o.__awaiter)(this, void 0, void 0, function () {
          var n, r, i, a;
          return Object(o.__generator)(this, function (o) {
            switch (o.label) {
              case 0:
                return n = {
                  pageToken: t
                }, [4, this.list(n)];

              case 1:
                return r = o.sent(), (i = e.prefixes).push.apply(i, r.prefixes), (a = e.items).push.apply(a, r.items), null == r.nextPageToken ? [3, 3] : [4, this.listAllHelper(e, r.nextPageToken)];

              case 2:
                o.sent(), o.label = 3;

              case 3:
                return [2];
            }
          });
        });
      }, e.prototype.list = function (e) {
        var t;
        Se("list", [(t = !0, new Ne(de, t))], arguments);
        var n = this;
        return this.authWrapper.getAuthToken().then(function (t) {
          var r = e || {},
              i = be(n.authWrapper, n.location, "/", r.pageToken, r.maxResults);
          return n.authWrapper.makeRequest(i, t).getPromise();
        });
      }, e.prototype.getMetadata = function () {
        var e = this;
        return Se("getMetadata", [], arguments), this.throwIfRoot_("getMetadata"), this.authWrapper.getAuthToken().then(function (t) {
          var n = ge(e.authWrapper, e.location, e.mappings());
          return e.authWrapper.makeRequest(n, t).getPromise();
        });
      }, e.prototype.updateMetadata = function (e) {
        var t = this;
        return Se("updateMetadata", [Re()], arguments), this.throwIfRoot_("updateMetadata"), this.authWrapper.getAuthToken().then(function (n) {
          var r = function (e, t, n, r) {
            var i = J(t.fullServerUrl()),
                o = ie(n, r),
                a = e.maxOperationRetryTime(),
                s = new fe(i, "PATCH", me(e, r), a);
            return s.headers = {
              "Content-Type": "application/json; charset=utf-8"
            }, s.body = o, s.errorHandler = ve(t), s;
          }(t.authWrapper, t.location, e, t.mappings());

          return t.authWrapper.makeRequest(r, n).getPromise();
        });
      }, e.prototype.getDownloadURL = function () {
        var e = this;
        return Se("getDownloadURL", [], arguments), this.throwIfRoot_("getDownloadURL"), this.authWrapper.getAuthToken().then(function (t) {
          var n = function (e, t, n) {
            var r = J(t.fullServerUrl()),
                i = e.maxOperationRetryTime(),
                o = new fe(r, "GET", _e(e, n), i);
            return o.errorHandler = ve(t), o;
          }(e.authWrapper, e.location, e.mappings());

          return e.authWrapper.makeRequest(n, t).getPromise().then(function (e) {
            if (null === e) throw new h(d.NO_DOWNLOAD_URL, "The given file does not have any download URLs.");
            return e;
          });
        });
      }, e.prototype.throwIfRoot_ = function (e) {
        if ("" === this.location.path) throw function (e) {
          return new h(d.INVALID_ROOT_OPERATION, "The operation '" + e + "' cannot be performed on a root reference, create a non-root reference using child, such as .child('file.png').");
        }(e);
      }, e;
    }(),
        je = function () {
      function e(e) {
        this.promise_ = Promise.reject(e);
      }

      return e.prototype.getPromise = function () {
        return this.promise_;
      }, e.prototype.cancel = function (e) {}, e;
    }(),
        Ue = function () {
      function e() {
        this.map = new Map(), this.id = l;
      }

      return e.prototype.addRequest = function (e) {
        var t = this,
            n = this.id;
        this.id++, this.map.set(n, e), e.getPromise().then(function () {
          return t.map.delete(n);
        }, function () {
          return t.map.delete(n);
        });
      }, e.prototype.clear = function () {
        this.map.forEach(function (e) {
          e && e.cancel(!0);
        }), this.map.clear();
      }, e;
    }(),
        Pe = function () {
      function e(t, n, r, i, o, a) {
        var s;

        if (this.bucket_ = null, this.appId_ = null, this.deleted_ = !1, this.app_ = t, null !== this.app_) {
          var l = this.app_.options;
          Y(l) && (this.bucket_ = e.extractBucket_(l), this.appId_ = null !== (s = l.appId) && void 0 !== s ? s : null);
        }

        this.authProvider_ = n, this.storageRefMaker_ = r, this.requestMaker_ = i, this.pool_ = a, this.service_ = o, this.maxOperationRetryTime_ = u, this.maxUploadRetryTime_ = c, this.requestMap_ = new Ue();
      }

      return e.extractBucket_ = function (e) {
        var t = e.storageBucket || null;
        return null == t ? null : Q.makeFromBucketSpec(t).bucket;
      }, e.prototype.getAuthToken = function () {
        var e = this.authProvider_.getImmediate({
          optional: !0
        });
        return e ? e.getToken().then(function (e) {
          return null !== e ? e.accessToken : null;
        }, function () {
          return null;
        }) : Promise.resolve(null);
      }, e.prototype.bucket = function () {
        if (this.deleted_) throw v();
        return this.bucket_;
      }, e.prototype.service = function () {
        return this.service_;
      }, e.prototype.makeStorageReference = function (e) {
        return this.storageRefMaker_(this, e);
      }, e.prototype.makeRequest = function (e, t) {
        if (this.deleted_) return new je(v());
        var n = this.requestMaker_(e, this.appId_, t, this.pool_);
        return this.requestMap_.addRequest(n), n;
      }, e.prototype.deleteApp = function () {
        this.deleted_ = !0, this.app_ = null, this.requestMap_.clear();
      }, e.prototype.maxUploadRetryTime = function () {
        return this.maxUploadRetryTime_;
      }, e.prototype.setMaxUploadRetryTime = function (e) {
        this.maxUploadRetryTime_ = e;
      }, e.prototype.maxOperationRetryTime = function () {
        return this.maxOperationRetryTime_;
      }, e.prototype.setMaxOperationRetryTime = function (e) {
        this.maxOperationRetryTime_ = e;
      }, e;
    }();
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var Ve = function () {
      function e(e, t, n, r, i, o, a, s, u, c, l) {
        var h = this;
        this.pendingXhr_ = null, this.backoffId_ = null, this.resolve_ = null, this.reject_ = null, this.canceled_ = !1, this.appDelete_ = !1, this.url_ = e, this.method_ = t, this.headers_ = n, this.body_ = r, this.successCodes_ = i.slice(), this.additionalRetryCodes_ = o.slice(), this.callback_ = a, this.errorCallback_ = s, this.progressCallback_ = c, this.timeout_ = u, this.pool_ = l, this.promise_ = new Promise(function (e, t) {
          h.resolve_ = e, h.reject_ = t, h.start_();
        });
      }

      return e.prototype.start_ = function () {
        var e = this;

        function t(t, n) {
          var r,
              i = e.resolve_,
              o = e.reject_,
              a = n.xhr;
          if (n.wasSuccessCode) try {
            var s = e.callback_(a, a.getResponseText());
            C(s) ? i(s) : i();
          } catch (e) {
            o(e);
          } else null !== a ? ((r = p()).setServerResponseProp(a.getResponseText()), e.errorCallback_ ? o(e.errorCallback_(a, r)) : o(r)) : n.canceled ? o(r = e.appDelete_ ? v() : m()) : o(r = new h(d.RETRY_LIMIT_EXCEEDED, "Max retry time for operation exceeded, please try again."));
        }

        this.canceled_ ? t(0, new We(!1, null, !0)) : this.backoffId_ =
        /**
         * @license
         * Copyright 2017 Google Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         *   http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         */
        function (e, t, n) {
          var r = 1,
              i = null,
              a = !1,
              s = 0;

          function u() {
            return 2 === s;
          }

          var c = !1;

          function l() {
            for (var e = [], n = 0; n < arguments.length; n++) {
              e[n] = arguments[n];
            }

            c || (c = !0, t.apply(null, e));
          }

          function h(t) {
            i = setTimeout(function () {
              i = null, e(d, u());
            }, t);
          }

          function d(e) {
            for (var t, n = [], i = 1; i < arguments.length; i++) {
              n[i - 1] = arguments[i];
            }

            c || (e ? l.call.apply(l, Object(o.__spreadArrays)([null, e], n)) : u() || a ? l.call.apply(l, Object(o.__spreadArrays)([null, e], n)) : (r < 64 && (r *= 2), 1 === s ? (s = 2, t = 0) : t = 1e3 * (r + Math.random()), h(t)));
          }

          var f = !1;

          function p(e) {
            f || (f = !0, c || (null !== i ? (e || (s = 2), clearTimeout(i), h(0)) : e || (s = 1)));
          }

          return h(0), setTimeout(function () {
            a = !0, p(!0);
          }, n), p;
        }(function (t, n) {
          if (n) t(!1, new We(!1, null, !0));else {
            var r = e.pool_.createXhrIo();
            e.pendingXhr_ = r, null !== e.progressCallback_ && r.addUploadProgressListener(i), r.send(e.url_, e.method_, e.body_, e.headers_).then(function (n) {
              null !== e.progressCallback_ && n.removeUploadProgressListener(i), e.pendingXhr_ = null;
              var r = (n = n).getErrorCode() === N.NO_ERROR,
                  o = n.getStatus();

              if (r && !e.isRetryStatusCode_(o)) {
                var a = -1 !== e.successCodes_.indexOf(o);
                t(!0, new We(a, n));
              } else {
                var s = n.getErrorCode() === N.ABORT;
                t(!1, new We(!1, null, s));
              }
            });
          }

          function i(t) {
            var n = t.loaded,
                r = t.lengthComputable ? t.total : -1;
            null !== e.progressCallback_ && e.progressCallback_(n, r);
          }
        }, t, this.timeout_);
      }, e.prototype.getPromise = function () {
        return this.promise_;
      }, e.prototype.cancel = function (e) {
        this.canceled_ = !0, this.appDelete_ = e || !1, null !== this.backoffId_ && (0, this.backoffId_)(!1), null !== this.pendingXhr_ && this.pendingXhr_.abort();
      }, e.prototype.isRetryStatusCode_ = function (e) {
        var t = e >= 500 && e < 600,
            n = -1 !== [408, 429].indexOf(e),
            r = -1 !== this.additionalRetryCodes_.indexOf(e);
        return t || n || r;
      }, e;
    }(),
        We = function () {
      return function (e, t, n) {
        this.wasSuccessCode = e, this.xhr = t, this.canceled = !!n;
      };
    }();

    function He(e, t, n, r) {
      var o = X(e.urlParams),
          a = e.url + o,
          s = Object.assign({}, e.headers);
      return function (e, t) {
        t && (e["X-Firebase-GMPID"] = t);
      }(s, t), function (e, t) {
        null !== t && t.length > 0 && (e.Authorization = "Firebase " + t);
      }(s, n), function (e) {
        var t = void 0 !== i.a ? i.a.SDK_VERSION : "AppManager";
        e["X-Firebase-Storage-Version"] = "webjs/" + t;
      }(s), new Ve(a, e.method, s, e.body, e.successCodes, e.additionalRetryCodes, e.handler, e.errorHandler, e.timeout, e.progressCallback, r);
    }
    /**
     * @license
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var Be = function () {
      function e(e, t, n, r) {
        if (this.bucket_ = null, this.authWrapper_ = new Pe(e, t, function (e, t) {
          return new Ae(e, t);
        }, He, this, n), this.app_ = e, null != r) this.bucket_ = Q.makeFromBucketSpec(r);else {
          var i = this.authWrapper_.bucket();
          null != i && (this.bucket_ = new Q(i, ""));
        }
        this.internals_ = new ze(this);
      }

      return e.prototype.ref = function (e) {
        if (Se("ref", [De(function (e) {
          if ("string" != typeof e) throw "Path is not a string.";
          if (/^[A-Za-z]+:\/\//.test(e)) throw "Expected child path but got a URL, use refFromURL instead.";
        }, !0)], arguments), null == this.bucket_) throw new Error("No Storage Bucket defined in Firebase Options.");
        var t = new Ae(this.authWrapper_, this.bucket_);
        return null != e ? t.child(e) : t;
      }, e.prototype.refFromURL = function (e) {
        return Se("refFromURL", [De(function (e) {
          if ("string" != typeof e) throw "Path is not a string.";
          if (!/^[A-Za-z]+:\/\//.test(e)) throw "Expected full URL but got a child path, use ref instead.";

          try {
            Q.makeFromUrl(e);
          } catch (e) {
            throw "Expected valid full URL but got an invalid one.";
          }
        }, !1)], arguments), new Ae(this.authWrapper_, e);
      }, Object.defineProperty(e.prototype, "maxUploadRetryTime", {
        get: function get() {
          return this.authWrapper_.maxUploadRetryTime();
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.setMaxUploadRetryTime = function (e) {
        Se("setMaxUploadRetryTime", [xe()], arguments), this.authWrapper_.setMaxUploadRetryTime(e);
      }, e.prototype.setMaxOperationRetryTime = function (e) {
        Se("setMaxOperationRetryTime", [xe()], arguments), this.authWrapper_.setMaxOperationRetryTime(e);
      }, Object.defineProperty(e.prototype, "app", {
        get: function get() {
          return this.app_;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "INTERNAL", {
        get: function get() {
          return this.internals_;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        ze = function () {
      function e(e) {
        this.service_ = e;
      }

      return e.prototype.delete = function () {
        return this.service_.authWrapper_.deleteApp(), Promise.resolve();
      }, e;
    }(),
        Ze = "@firebase/storage",
        Qe = "0.3.33",
        Ge = "storage";

    function qe(e, t) {
      var n = e.getProvider("app").getImmediate(),
          r = e.getProvider("auth-internal");
      return new Be(n, r, new B(), t);
    }

    function Je(e) {
      var t = {
        TaskState: R,
        TaskEvent: D,
        StringFormat: w,
        Storage: Be,
        Reference: Ae
      };
      e.INTERNAL.registerComponent(new a.Component(Ge, qe, "PUBLIC").setServiceProps(t).setMultipleInstances(!0)), e.registerVersion(Ze, Qe);
    }

    Je(i.a);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r,
        i = (r = n(6)) && "object" == typeof r && "default" in r ? r.default : r;
    n(33);

    var o,
        a,
        s,
        u,
        c = n(3),
        l = n(16),
        h = n(25),
        d = n(13),
        f = "@firebase/performance",
        p = "0.3.3",
        m = p,
        _ = "FB-PERF-TRACE-START",
        y = "FB-PERF-TRACE-STOP",
        v = "FB-PERF-TRACE-MEASURE",
        g = "_wt_",
        b = "@firebase/performance/config",
        w = "@firebase/performance/configexpire",
        T = ((o = {})["trace started"] = "Trace {$traceName} was started before.", o["trace stopped"] = "Trace {$traceName} is not running.", o["no window"] = "Window is not available.", o["no app id"] = "App id is not available.", o["no project id"] = "Project id is not available.", o["no api key"] = "Api key is not available.", o["invalid cc log"] = "Attempted to queue invalid cc event", o["FB not default"] = "Performance can only start when Firebase app instance is the default one.", o["RC response not ok"] = "RC response is not ok", o["invalid attribute name"] = "Attribute name {$attributeName} is invalid.", o["invalid attribute value"] = "Attribute value {$attributeValue} is invalid.", o["invalid custom metric name"] = "Custom metric name {$customMetricName} is invalid", o["invalid String merger input"] = "Input for String merger is invalid, contact support team to resolve.", o),
        M = new l.ErrorFactory("performance", "Performance", T),
        E = function () {
      function e(e) {
        if (this.window = e, !e) throw M.create("no window");
        this.performance = e.performance, this.PerformanceObserver = e.PerformanceObserver, this.windowLocation = e.location, this.navigator = e.navigator, this.document = e.document, this.navigator && this.navigator.cookieEnabled && (this.localStorage = e.localStorage), e.perfMetrics && e.perfMetrics.onFirstInputDelay && (this.onFirstInputDelay = e.perfMetrics.onFirstInputDelay);
      }

      return e.prototype.getUrl = function () {
        return this.windowLocation.href.split("?")[0];
      }, e.prototype.mark = function (e) {
        this.performance && this.performance.mark && this.performance.mark(e);
      }, e.prototype.measure = function (e, t, n) {
        this.performance && this.performance.measure && this.performance.measure(e, t, n);
      }, e.prototype.getEntriesByType = function (e) {
        return this.performance && this.performance.getEntriesByType ? this.performance.getEntriesByType(e) : [];
      }, e.prototype.getEntriesByName = function (e) {
        return this.performance && this.performance.getEntriesByName ? this.performance.getEntriesByName(e) : [];
      }, e.prototype.getTimeOrigin = function () {
        return this.performance && (this.performance.timeOrigin || this.performance.timing.navigationStart);
      }, e.prototype.requiredApisAvailable = function () {
        return !!(fetch && Promise && this.navigator && this.navigator.cookieEnabled);
      }, e.prototype.setupObserver = function (e, t) {
        this.PerformanceObserver && new this.PerformanceObserver(function (e) {
          for (var n = 0, r = e.getEntries(); n < r.length; n++) {
            var i = r[n];
            t(i);
          }
        }).observe({
          entryTypes: [e]
        });
      }, e.getInstance = function () {
        return void 0 === a && (a = new e(s)), a;
      }, e;
    }();
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function k(e, t) {
      var n = e.length - t.length;
      if (n < 0 || n > 1) throw M.create("invalid String merger input");

      for (var r = [], i = 0; i < e.length; i++) {
        r.push(e.charAt(i)), t.length > i && r.push(t.charAt(i));
      }

      return r.join("");
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var L,
        S,
        N = function () {
      function e() {
        this.instrumentationEnabled = !0, this.dataCollectionEnabled = !0, this.loggingEnabled = !1, this.tracesSamplingRate = 1, this.networkRequestsSamplingRate = 1, this.logEndPointUrl = "https://firebaselogging.googleapis.com/v0cc/log?format=json_proto", this.flTransportEndpointUrl = k("hts/frbslgigp.ogepscmv/ieo/eaylg", "tp:/ieaeogn-agolai.o/1frlglgc/o"), this.transportKey = k("AzSC8r6ReiGqFMyfvgow", "Iayx0u-XT3vksVM-pIV"), this.shouldSendToFl = !1, this.logSource = 462, this.logTraceAfterSampling = !1, this.logNetworkAfterSampling = !1, this.configTimeToLive = 12;
      }

      return e.prototype.getAppId = function () {
        var e = this.firebaseAppInstance && this.firebaseAppInstance.options && this.firebaseAppInstance.options.appId;
        if (!e) throw M.create("no app id");
        return e;
      }, e.prototype.getProjectId = function () {
        var e = this.firebaseAppInstance && this.firebaseAppInstance.options && this.firebaseAppInstance.options.projectId;
        if (!e) throw M.create("no project id");
        return e;
      }, e.prototype.getApiKey = function () {
        var e = this.firebaseAppInstance && this.firebaseAppInstance.options && this.firebaseAppInstance.options.apiKey;
        if (!e) throw M.create("no api key");
        return e;
      }, e.prototype.getFlTransportFullUrl = function () {
        return this.flTransportEndpointUrl.concat("?key=", this.transportKey);
      }, e.getInstance = function () {
        return void 0 === u && (u = new e()), u;
      }, e;
    }();
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function D() {
      return L;
    }

    !function (e) {
      e[e.UNKNOWN = 0] = "UNKNOWN", e[e.VISIBLE = 1] = "VISIBLE", e[e.HIDDEN = 2] = "HIDDEN";
    }(S || (S = {}));
    var I = ["firebase_", "google_", "ga_"],
        R = new RegExp("^[a-zA-Z]\\w*$"),
        x = 40,
        Y = 100;

    function C() {
      switch (E.getInstance().document.visibilityState) {
        case "visible":
          return S.VISIBLE;

        case "hidden":
          return S.HIDDEN;

        default:
          return S.UNKNOWN;
      }
    }

    function O() {
      var e = E.getInstance().navigator.connection;

      switch (e && e.effectiveType) {
        case "slow-2g":
          return 1;

        case "2g":
          return 2;

        case "3g":
          return 3;

        case "4g":
          return 4;

        default:
          return 0;
      }
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var F = new h.Logger("Performance");
    F.logLevel = h.LogLevel.INFO;
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    var A = "0.0.1",
        j = {
      loggingEnabled: !0,
      shouldSendToFl: !0
    },
        U = {
      shouldSendToFl: !1
    },
        P = "FIREBASE_INSTALLATIONS_AUTH";

    function V(e) {
      var t = function () {
        var e = E.getInstance().localStorage;
        if (!e) return;
        var t = e.getItem(w);
        if (!(t && (n = t, Number(n) > Date.now()))) return;
        var n;
        var r = e.getItem(b);
        if (!r) return;

        try {
          var i = JSON.parse(r);
          return i;
        } catch (e) {
          return;
        }
      }();

      return t ? (H(e, t), Promise.resolve()) : function (e) {
        return (t = N.getInstance().installationsService.getToken(), t.then(function (e) {}), t).then(function (t) {
          var n = N.getInstance().getProjectId(),
              r = "https://firebaseremoteconfig.googleapis.com/v1/projects/" + n + "/namespaces/fireperf:fetch?key=" + N.getInstance().getApiKey(),
              i = new Request(r, {
            method: "POST",
            headers: {
              Authorization: P + " " + t
            },
            body: JSON.stringify({
              app_instance_id: e,
              app_instance_id_token: t,
              app_id: N.getInstance().getAppId(),
              app_version: m,
              sdk_version: A
            })
          });
          return fetch(i).then(function (e) {
            if (e.ok) return e.json();
            throw M.create("RC response not ok");
          });
        }).catch(function () {
          F.info(W);
        });
        var t;
        /**
         * @license
         * Copyright 2019 Google Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         *   http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         */
      }(e).then(function (t) {
        return H(e, t);
      }).then(function (e) {
        return function (e) {
          var t = E.getInstance().localStorage;
          if (!e || !t) return;
          t.setItem(b, JSON.stringify(e)), t.setItem(w, String(Date.now() + 60 * N.getInstance().configTimeToLive * 60 * 1e3));
        }(e);
      }, function () {});
    }

    var W = "Could not fetch config, will use default configs";

    function H(e, t) {
      if (!t) return t;
      var n = N.getInstance(),
          r = t.entries || {},
          i = t.state;
      return void 0 !== r.fpr_enabled ? n.loggingEnabled = "true" === String(r.fpr_enabled) : n.loggingEnabled = j.loggingEnabled, r.fpr_log_source && (n.logSource = Number(r.fpr_log_source)), r.fpr_log_endpoint_url && (n.logEndPointUrl = r.fpr_log_endpoint_url), r.fpr_log_transport_key && (n.transportKey = r.fpr_log_transport_key), void 0 === i || "INSTANCE_STATE_UNSPECIFIED" === i || "NO_TEMPLATE" === i ? n.shouldSendToFl = U.shouldSendToFl : r.fpr_log_transport_web_percent ? n.shouldSendToFl = function (e, t) {
        if (0 === e.length) return !1;
        return function (e) {
          for (var t = 0, n = 0; n < e.length; n++) {
            t = (t << 3) + t - e.charCodeAt(n);
          }

          return t = Math.abs(t % 100);
        }
        /**
         * @license
         * Copyright 2019 Google Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         *   http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         */
        (e) < t;
      }(e, Number(r.fpr_log_transport_web_percent)) : n.shouldSendToFl = j.shouldSendToFl, void 0 !== r.fpr_vc_network_request_sampling_rate && (n.networkRequestsSamplingRate = Number(r.fpr_vc_network_request_sampling_rate)), void 0 !== r.fpr_vc_trace_sampling_rate && (n.tracesSamplingRate = Number(r.fpr_vc_trace_sampling_rate)), n.logTraceAfterSampling = B(n.tracesSamplingRate), n.logNetworkAfterSampling = B(n.networkRequestsSamplingRate), t;
    }

    function B(e) {
      return Math.random() <= e;
    }

    var z,
        Z = 1;

    function Q() {
      var e;
      return Z = 2, z = z || (e = E.getInstance().document, new Promise(function (t) {
        if (e && "complete" !== e.readyState) {
          var n = function n() {
            "complete" === e.readyState && (e.removeEventListener("readystatechange", n), t());
          };

          e.addEventListener("readystatechange", n);
        } else t();
      })).then(function () {
        return (e = N.getInstance().installationsService.getId()).then(function (e) {
          L = e;
        }), e;
        var e;
      }).then(function (e) {
        return V(e);
      }).then(function () {
        return G();
      }, function () {
        return G();
      });
    }

    function G() {
      Z = 3;
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var q,
        J = 1e4,
        X = 5500,
        K = 3,
        $ = K,
        ee = [],
        te = !1;

    function ne(e) {
      setTimeout(function () {
        if (0 !== $) return ee.length ? void function () {
          var e = c.__spreadArrays(ee);

          ee = [];
          var t = e.map(function (e) {
            return {
              source_extension_json_proto3: e.message,
              event_time_ms: String(e.eventTime)
            };
          });
          (function (e, t) {
            return N.getInstance().shouldSendToFl ? function (e, t) {
              return function (e) {
                var t = N.getInstance().getFlTransportFullUrl();
                return fetch(t, {
                  method: "POST",
                  body: JSON.stringify(e)
                });
              }(e).then(function (e) {
                return e.ok || F.info("Call to Firebase backend failed."), e.json();
              }).then(function (e) {
                var n = Number(e.nextRequestWaitMillis),
                    r = J;
                isNaN(n) || (r = Math.max(n, r));
                var i = e.logResponseDetails;
                Array.isArray(i) && i.length > 0 && "RETRY_REQUEST_LATER" === i[0].responseAction && (ee = c.__spreadArrays(t, ee), F.info("Retry transport request later.")), $ = K, ne(r);
              });
            }(e, t) : function (e) {
              return fetch(N.getInstance().logEndPointUrl, {
                method: "POST",
                body: JSON.stringify(e)
              }).then(function (e) {
                return e.ok || F.info("Call to Firebase backend failed."), e.json();
              }).then(function (e) {
                var t = Number(e.next_request_wait_millis),
                    n = isNaN(t) ? J : Math.max(J, t);
                $ = K, ne(n);
              });
            }(e);
          })({
            request_time_ms: String(Date.now()),
            client_info: {
              client_type: 1,
              js_client_info: {}
            },
            log_source: N.getInstance().logSource,
            log_event: t
          }, e).catch(function () {
            ee = c.__spreadArrays(e, ee), $--, F.info("Tries left: " + $ + "."), ne(J);
          });
        }() : ne(J);
      }, e);
    }

    function re(e) {
      return function () {
        for (var t = [], n = 0; n < arguments.length; n++) {
          t[n] = arguments[n];
        }

        !function (e) {
          if (!e.eventTime || !e.message) throw M.create("invalid cc log");
          ee = c.__spreadArrays(ee, [e]);
        }({
          message: e.apply(void 0, t),
          eventTime: Date.now()
        });
      };
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function ie(e, t) {
      q || (q = re(se)), q(e, t);
    }

    function oe(e) {
      var t = N.getInstance();
      !t.instrumentationEnabled && e.isAuto || (t.dataCollectionEnabled || e.isAuto) && E.getInstance().requiredApisAvailable() && (e.isAuto && C() !== S.VISIBLE || t.loggingEnabled && t.logTraceAfterSampling && (3 === Z ? ae(e) : Q().then(function () {
        return ae(e);
      }, function () {
        return ae(e);
      })));
    }

    function ae(e) {
      D() && setTimeout(function () {
        return ie(e, 1);
      }, 0);
    }

    function se(e, t) {
      return 0 === t ? (r = {
        url: (n = e).url,
        http_method: n.httpMethod || 0,
        http_response_code: 200,
        response_payload_bytes: n.responsePayloadBytes,
        client_start_time_us: n.startTimeUs,
        time_to_response_initiated_us: n.timeToResponseInitiatedUs,
        time_to_response_completed_us: n.timeToResponseCompletedUs
      }, i = {
        application_info: ue(),
        network_request_metric: r
      }, JSON.stringify(i)) : function (e) {
        var t = {
          name: e.name,
          is_auto: e.isAuto,
          client_start_time_us: e.startTimeUs,
          duration_us: e.durationUs
        };
        0 !== Object.keys(e.counters).length && (t.counters = e.counters);
        var n = e.getAttributes();
        0 !== Object.keys(n).length && (t.custom_attributes = n);
        var r = {
          application_info: ue(),
          trace_metric: t
        };
        return JSON.stringify(r);
      }(e);
      var n, r, i;
    }

    function ue() {
      return {
        google_app_id: N.getInstance().getAppId(),
        app_instance_id: D(),
        web_app_info: {
          sdk_version: m,
          page_url: E.getInstance().getUrl(),
          service_worker_status: (e = E.getInstance().navigator, "serviceWorker" in e ? e.serviceWorker.controller ? 2 : 3 : 1),
          visibility_state: C(),
          effective_connection_type: O()
        },
        application_process_state: 0
      };
      var e;
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var ce = 100,
        le = "_",
        he = ["_fp", "_fcp", "_fid"];
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    var de = function () {
      function e(e, t, n) {
        void 0 === t && (t = !1), this.name = e, this.isAuto = t, this.state = 1, this.customAttributes = {}, this.counters = {}, this.api = E.getInstance(), this.randomId = Math.floor(1e6 * Math.random()), this.isAuto || (this.traceStartMark = _ + "-" + this.randomId + "-" + this.name, this.traceStopMark = y + "-" + this.randomId + "-" + this.name, this.traceMeasure = n || v + "-" + this.randomId + "-" + this.name, n && this.calculateTraceMetrics());
      }

      return e.prototype.start = function () {
        if (1 !== this.state) throw M.create("trace started", {
          traceName: this.name
        });
        this.api.mark(this.traceStartMark), this.state = 2;
      }, e.prototype.stop = function () {
        if (2 !== this.state) throw M.create("trace stopped", {
          traceName: this.name
        });
        this.state = 3, this.api.mark(this.traceStopMark), this.api.measure(this.traceMeasure, this.traceStartMark, this.traceStopMark), this.calculateTraceMetrics(), oe(this);
      }, e.prototype.record = function (e, t, n) {
        if (this.durationUs = Math.floor(1e3 * t), this.startTimeUs = Math.floor(1e3 * e), n && n.attributes && (this.customAttributes = c.__assign({}, n.attributes)), n && n.metrics) for (var r = 0, i = Object.keys(n.metrics); r < i.length; r++) {
          var o = i[r];
          isNaN(Number(n.metrics[o])) || (this.counters[o] = Number(Math.floor(n.metrics[o])));
        }
        oe(this);
      }, e.prototype.incrementMetric = function (e, t) {
        void 0 === t && (t = 1), void 0 === this.counters[e] && this.putMetric(e, 0), this.counters[e] += t;
      }, e.prototype.putMetric = function (e, t) {
        if (n = e, r = this.name, 0 === n.length || n.length > ce || !(r && r.startsWith(g) && he.indexOf(n) > -1) && n.startsWith(le)) throw M.create("invalid custom metric name", {
          customMetricName: e
        });
        var n, r;
        this.counters[e] = t;
      }, e.prototype.getMetric = function (e) {
        return this.counters[e] || 0;
      }, e.prototype.putAttribute = function (e, t) {
        var n,
            r = !(0 === (n = e).length || n.length > x || I.some(function (e) {
          return n.startsWith(e);
        }) || !n.match(R)),
            i = function (e) {
          return 0 !== e.length && e.length <= Y;
        }(t);

        if (r && i) this.customAttributes[e] = t;else {
          if (!r) throw M.create("invalid attribute name", {
            attributeName: e
          });
          if (!i) throw M.create("invalid attribute value", {
            attributeValue: t
          });
        }
      }, e.prototype.getAttribute = function (e) {
        return this.customAttributes[e];
      }, e.prototype.removeAttribute = function (e) {
        void 0 !== this.customAttributes[e] && delete this.customAttributes[e];
      }, e.prototype.getAttributes = function () {
        return c.__assign({}, this.customAttributes);
      }, e.prototype.setStartTime = function (e) {
        this.startTimeUs = e;
      }, e.prototype.setDuration = function (e) {
        this.durationUs = e;
      }, e.prototype.calculateTraceMetrics = function () {
        var e = this.api.getEntriesByName(this.traceMeasure),
            t = e && e[0];
        t && (this.durationUs = Math.floor(1e3 * t.duration), this.startTimeUs = Math.floor(1e3 * (t.startTime + this.api.getTimeOrigin())));
      }, e.createOobTrace = function (t, n, r) {
        var i = E.getInstance().getUrl();

        if (i) {
          var o = new e(g + i, !0),
              a = Math.floor(1e3 * E.getInstance().getTimeOrigin());
          o.setStartTime(a), t && t[0] && (o.setDuration(Math.floor(1e3 * t[0].duration)), o.putMetric("domInteractive", Math.floor(1e3 * t[0].domInteractive)), o.putMetric("domContentLoadedEventEnd", Math.floor(1e3 * t[0].domContentLoadedEventEnd)), o.putMetric("loadEventEnd", Math.floor(1e3 * t[0].loadEventEnd)));

          if (n) {
            var s = n.find(function (e) {
              return "first-paint" === e.name;
            });
            s && s.startTime && o.putMetric("_fp", Math.floor(1e3 * s.startTime));
            var u = n.find(function (e) {
              return "first-contentful-paint" === e.name;
            });
            u && u.startTime && o.putMetric("_fcp", Math.floor(1e3 * u.startTime)), r && o.putMetric("_fid", Math.floor(1e3 * r));
          }

          oe(o);
        }
      }, e.createUserTimingTrace = function (t) {
        oe(new e(t, !1, t));
      }, e;
    }();
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function fe(e) {
      var t = e;

      if (t && void 0 !== t.responseStart) {
        var n = E.getInstance().getTimeOrigin(),
            r = Math.floor(1e3 * (t.startTime + n)),
            i = t.responseStart ? Math.floor(1e3 * (t.responseStart - t.startTime)) : void 0,
            o = Math.floor(1e3 * (t.responseEnd - t.startTime));
        !function (e) {
          var t = N.getInstance();

          if (t.instrumentationEnabled) {
            var n = e.url,
                r = t.logEndPointUrl.split("?")[0],
                i = t.flTransportEndpointUrl.split("?")[0];
            n !== r && n !== i && t.loggingEnabled && t.logNetworkAfterSampling && setTimeout(function () {
              return ie(e, 0);
            }, 0);
          }
        }({
          url: t.name && t.name.split("?")[0],
          responsePayloadBytes: t.transferSize,
          startTimeUs: r,
          timeToResponseInitiatedUs: i,
          timeToResponseCompletedUs: o
        });
      }
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var pe = 5e3;

    function me() {
      D() && (setTimeout(function () {
        return function () {
          var e = E.getInstance(),
              t = e.getEntriesByType("navigation"),
              n = e.getEntriesByType("paint");

          if (e.onFirstInputDelay) {
            var r = setTimeout(function () {
              de.createOobTrace(t, n), r = void 0;
            }, pe);
            e.onFirstInputDelay(function (e) {
              r && (clearTimeout(r), de.createOobTrace(t, n, e));
            });
          } else de.createOobTrace(t, n);
        }();
      }, 0), setTimeout(function () {
        return function () {
          for (var e = E.getInstance(), t = e.getEntriesByType("resource"), n = 0, r = t; n < r.length; n++) {
            var i = r[n];
            fe(i);
          }

          e.setupObserver("resource", fe);
        }();
      }, 0), setTimeout(function () {
        return function () {
          for (var e = E.getInstance(), t = e.getEntriesByType("measure"), n = 0, r = t; n < r.length; n++) {
            var i = r[n];

            _e(i);
          }

          e.setupObserver("measure", _e);
        }();
      }, 0));
    }

    function _e(e) {
      var t = e.name;
      t.substring(0, v.length) !== v && de.createUserTimingTrace(t);
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var ye = function () {
      function e(e) {
        this.app = e, E.getInstance().requiredApisAvailable() ? (te || (ne(X), te = !0), Q().then(me, me)) : F.info("Firebase Performance cannot start if browser does not support fetch and Promise or cookie is disabled.");
      }

      return e.prototype.trace = function (e) {
        return new de(e);
      }, Object.defineProperty(e.prototype, "instrumentationEnabled", {
        get: function get() {
          return N.getInstance().instrumentationEnabled;
        },
        set: function set(e) {
          N.getInstance().instrumentationEnabled = e;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dataCollectionEnabled", {
        get: function get() {
          return N.getInstance().dataCollectionEnabled;
        },
        set: function set(e) {
          N.getInstance().dataCollectionEnabled = e;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        ve = "[DEFAULT]";
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function ge(e) {
      var t = function t(e, _t15) {
        if (e.name !== ve) throw M.create("FB not default");
        if ("undefined" == typeof window) throw M.create("no window");
        return function (e) {
          s = e;
        }(window), N.getInstance().firebaseAppInstance = e, N.getInstance().installationsService = _t15, new ye(e);
      };

      e.INTERNAL.registerComponent(new d.Component("performance", function (e) {
        var n = e.getProvider("app").getImmediate(),
            r = e.getProvider("installations").getImmediate();
        return t(n, r);
      }, "PUBLIC")), e.registerVersion(f, p);
    }

    ge(i), t.registerPerformance = ge;
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "factory", function () {
      return D;
    }), n.d(t, "getGlobalVars", function () {
      return S;
    }), n.d(t, "registerAnalytics", function () {
      return Y;
    }), n.d(t, "resetGlobalVars", function () {
      return L;
    }), n.d(t, "settings", function () {
      return N;
    });
    var r,
        i,
        o = n(6),
        a = n.n(o),
        s = (n(33), n(3)),
        u = n(25),
        c = n(16),
        l = n(13),
        h = "measurementId",
        d = "firebase_id",
        f = "origin",
        p = "https://www.googletagmanager.com/gtag/js";
    !function (e) {
      e.EVENT = "event", e.SET = "set", e.CONFIG = "config";
    }(r || (r = {})), function (e) {
      e.ADD_SHIPPING_INFO = "add_shipping_info", e.ADD_PAYMENT_INFO = "add_payment_info", e.ADD_TO_CART = "add_to_cart", e.ADD_TO_WISHLIST = "add_to_wishlist", e.BEGIN_CHECKOUT = "begin_checkout", e.CHECKOUT_PROGRESS = "checkout_progress", e.EXCEPTION = "exception", e.GENERATE_LEAD = "generate_lead", e.LOGIN = "login", e.PAGE_VIEW = "page_view", e.PURCHASE = "purchase", e.REFUND = "refund", e.REMOVE_FROM_CART = "remove_from_cart", e.SCREEN_VIEW = "screen_view", e.SEARCH = "search", e.SELECT_CONTENT = "select_content", e.SELECT_ITEM = "select_item", e.SELECT_PROMOTION = "select_promotion", e.SET_CHECKOUT_OPTION = "set_checkout_option", e.SHARE = "share", e.SIGN_UP = "sign_up", e.TIMING_COMPLETE = "timing_complete", e.VIEW_CART = "view_cart", e.VIEW_ITEM = "view_item", e.VIEW_ITEM_LIST = "view_item_list", e.VIEW_PROMOTION = "view_promotion", e.VIEW_SEARCH_RESULTS = "view_search_results";
    }(i || (i = {}));
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */

    var m,
        _ = new u.Logger("@firebase/analytics");
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function y(e, t, n) {
      var i = function i() {
        for (var e = [], n = 0; n < arguments.length; n++) {
          e[n] = arguments[n];
        }

        window[t].push(arguments);
      };

      return window[n] && "function" == typeof window[n] && (i = window[n]), window[n] = function (e, t) {
        return function (n, i, o) {
          if (n === r.EVENT) {
            var a = [];

            if (o && o.send_to) {
              var s = o.send_to;
              Array.isArray(s) || (s = [s]);

              for (var u = 0, c = s; u < c.length; u++) {
                var l = c[u],
                    h = t[l];

                if (!h) {
                  a = [];
                  break;
                }

                a.push(h);
              }
            }

            if (0 === a.length) for (var d = 0, f = Object.values(t); d < f.length; d++) {
              var p = f[d];
              a.push(p);
            }
            Promise.all(a).then(function () {
              return e(r.EVENT, i, o || {});
            }).catch(function (e) {
              return _.error(e);
            });
          } else n === r.CONFIG ? (t[i] || Promise.resolve()).then(function () {
            e(r.CONFIG, i, o);
          }).catch(function (e) {
            return _.error(e);
          }) : e(r.SET, i);
        };
      }(i, e), {
        gtagCore: i,
        wrappedGtag: window[n]
      };
    }

    var v,
        g,
        b = ((m = {})["no-ga-id"] = '"' + h + '" field is empty in Firebase config. Firebase Analytics requires this field to contain a valid measurement ID.', m["already-exists"] = "A Firebase Analytics instance with the measurement ID ${id}  already exists. Only one Firebase Analytics instance can be created for each measurement ID.", m["already-initialized"] = "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.", m["interop-component-reg-failed"] = "Firebase Analytics Interop Component failed to instantiate", m),
        w = new c.ErrorFactory("analytics", "Analytics", b),
        T = {},
        M = "dataLayer",
        E = "gtag",
        k = !1;

    function L(e, t) {
      void 0 === e && (e = !1), void 0 === t && (t = {}), k = e, T = t, M = "dataLayer", E = "gtag";
    }

    function S() {
      return {
        initializedIdPromisesMap: T
      };
    }

    function N(e) {
      if (k) throw w.create("already-initialized");
      e.dataLayerName && (M = e.dataLayerName), e.gtagName && (E = e.gtagName);
    }

    function D(e, t) {
      var n = e.options[h];
      if (!n) throw w.create("no-ga-id");
      if (null != T[n]) throw w.create("already-exists", {
        id: n
      });

      if (!k) {
        (function () {
          for (var e = window.document.getElementsByTagName("script"), t = 0, n = Object.values(e); t < n.length; t++) {
            var r = n[t];
            if (r.src && r.src.includes(p)) return r;
          }

          return null;
        }
        /**
         * @license
         * Copyright 2019 Google Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         *   http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         */
        )() || function (e) {
          var t = document.createElement("script");
          t.src = p + "?l=" + e, t.async = !0, document.head.appendChild(t);
        }(M), function (e) {
          var t = [];
          Array.isArray(window[e]) ? t = window[e] : window[e] = t;
        }(M);
        var i = y(T, M, E),
            o = i.wrappedGtag,
            a = i.gtagCore;
        g = o, v = a, k = !0;
      }

      return T[n] = function (e, t, n) {
        return Object(s.__awaiter)(this, void 0, void 0, function () {
          var i, o;
          return Object(s.__generator)(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, t.getId()];

              case 1:
                return i = a.sent(), n("js", new Date()), n(r.CONFIG, e.options[h], ((o = {})[d] = i, o[f] = "firebase", o.update = !0, o)), [2];
            }
          });
        });
      }(e, t, v), {
        app: e,
        logEvent: function logEvent(e, t, i) {
          /**
           * @license
           * Copyright 2019 Google Inc.
           *
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           *   http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           */
          return function (e, t, n, i, o) {
            var a = i || {};
            o && o.global || (a = Object(s.__assign)(Object(s.__assign)({}, i), {
              send_to: t
            })), e(r.EVENT, n, a || {});
          }(g, n, e, t, i);
        },
        setCurrentScreen: function setCurrentScreen(e, t) {
          return function (e, t, n, i) {
            i && i.global ? e(r.SET, {
              screen_name: n
            }) : e(r.CONFIG, t, {
              update: !0,
              screen_name: n
            });
          }(g, n, e, t);
        },
        setUserId: function setUserId(e, t) {
          return function (e, t, n, i) {
            i && i.global ? e(r.SET, {
              user_id: n
            }) : e(r.CONFIG, t, {
              update: !0,
              user_id: n
            });
          }(g, n, e, t);
        },
        setUserProperties: function setUserProperties(e, t) {
          return function (e, t, n, i) {
            if (i && i.global) {
              for (var o = {}, a = 0, s = Object.keys(n); a < s.length; a++) {
                var u = s[a];
                o["user_properties." + u] = n[u];
              }

              e(r.SET, o);
            } else e(r.CONFIG, t, {
              update: !0,
              user_properties: n
            });
          }(g, n, e, t);
        },
        setAnalyticsCollectionEnabled: function setAnalyticsCollectionEnabled(e) {
          return function (e, t) {
            window["ga-disable-" + e] = !t;
          }(n, e);
        }
      };
    }

    var I = "@firebase/analytics",
        R = "0.3.4",
        x = "analytics";

    function Y(e) {
      e.INTERNAL.registerComponent(new l.Component(x, function (e) {
        return D(e.getProvider("app").getImmediate(), e.getProvider("installations").getImmediate());
      }, "PUBLIC").setServiceProps({
        settings: N,
        EventName: i
      })), e.INTERNAL.registerComponent(new l.Component("analytics-internal", function (e) {
        try {
          var t = e.getProvider(x).getImmediate();
          return {
            logEvent: t.logEvent
          };
        } catch (e) {
          throw w.create("interop-component-reg-failed", {
            reason: e
          });
        }
      }, "PRIVATE")), e.registerVersion(I, R);
    }

    Y(a.a);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r,
        i = (r = n(6)) && "object" == typeof r && "default" in r ? r.default : r;
    n(33);

    var o,
        a = n(3),
        s = n(16),
        u = n(25),
        c = n(13),
        l = function () {
      function e(e, t, n, r) {
        this.client = e, this.storage = t, this.storageCache = n, this.logger = r;
      }

      return e.prototype.isCachedDataFresh = function (e, t) {
        if (!t) return this.logger.debug("Config fetch cache check. Cache unpopulated."), !1;
        var n = Date.now() - t,
            r = n <= e;
        return this.logger.debug("Config fetch cache check. Cache age millis: " + n + ". Cache max age millis (minimumFetchIntervalMillis setting): " + e + ". Is cache hit: " + r + "."), r;
      }, e.prototype.fetch = function (e) {
        return a.__awaiter(this, void 0, void 0, function () {
          var t, n, r, i, o;
          return a.__generator(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, Promise.all([this.storage.getLastSuccessfulFetchTimestampMillis(), this.storage.getLastSuccessfulFetchResponse()])];

              case 1:
                return t = a.sent(), n = t[0], (r = t[1]) && this.isCachedDataFresh(e.cacheMaxAgeMillis, n) ? [2, r] : (e.eTag = r && r.eTag, [4, this.client.fetch(e)]);

              case 2:
                return i = a.sent(), o = [this.storageCache.setLastSuccessfulFetchTimestampMillis(Date.now())], 200 === i.status && o.push(this.storage.setLastSuccessfulFetchResponse(i)), [4, Promise.all(o)];

              case 3:
                return a.sent(), [2, i];
            }
          });
        });
      }, e;
    }(),
        h = ((o = {})["registration-window"] = "Undefined window object. This SDK only supports usage in a browser environment.", o["registration-project-id"] = "Undefined project identifier. Check Firebase app initialization.", o["registration-api-key"] = "Undefined API key. Check Firebase app initialization.", o["registration-app-id"] = "Undefined app identifier. Check Firebase app initialization.", o["storage-open"] = "Error thrown when opening storage. Original error: {$originalErrorMessage}.", o["storage-get"] = "Error thrown when reading from storage. Original error: {$originalErrorMessage}.", o["storage-set"] = "Error thrown when writing to storage. Original error: {$originalErrorMessage}.", o["storage-delete"] = "Error thrown when deleting from storage. Original error: {$originalErrorMessage}.", o["fetch-client-network"] = "Fetch client failed to connect to a network. Check Internet connection. Original error: {$originalErrorMessage}.", o["fetch-timeout"] = 'The config fetch request timed out.  Configure timeout using "fetchTimeoutMillis" SDK setting.', o["fetch-throttle"] = 'The config fetch request timed out while in an exponential backoff state. Configure timeout using "fetchTimeoutMillis" SDK setting. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.', o["fetch-client-parse"] = "Fetch client could not parse response. Original error: {$originalErrorMessage}.", o["fetch-status"] = "Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.", o),
        d = new s.ErrorFactory("remoteconfig", "Remote Config", h);
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    var f = function () {
      function e(e, t, n, r, i, o) {
        this.firebaseInstallations = e, this.sdkVersion = t, this.namespace = n, this.projectId = r, this.apiKey = i, this.appId = o;
      }

      return e.prototype.fetch = function (e) {
        return a.__awaiter(this, void 0, void 0, function () {
          var t, n, r, i, o, s, u, c, l, h, f, p, m, _, y, v, g, b, w;

          return a.__generator(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, Promise.all([this.firebaseInstallations.getId(), this.firebaseInstallations.getToken()])];

              case 1:
                t = a.sent(), n = t[0], r = t[1], i = window.FIREBASE_REMOTE_CONFIG_URL_BASE || "https://firebaseremoteconfig.googleapis.com", o = i + "/v1/projects/" + this.projectId + "/namespaces/" + this.namespace + ":fetch?key=" + this.apiKey, s = {
                  "Content-Type": "application/json",
                  "Content-Encoding": "gzip",
                  "If-None-Match": e.eTag || "*"
                }, u = {
                  sdk_version: this.sdkVersion,
                  app_instance_id: n,
                  app_instance_id_token: r,
                  app_id: this.appId,
                  language_code: (void 0 === T && (T = navigator), T.languages && T.languages[0] || T.language)
                }, c = {
                  method: "POST",
                  headers: s,
                  body: JSON.stringify(u)
                }, l = fetch(o, c), h = new Promise(function (t, n) {
                  e.signal.addEventListener(function () {
                    var e = new Error("The operation was aborted.");
                    e.name = "AbortError", n(e);
                  });
                }), a.label = 2;

              case 2:
                return a.trys.push([2, 5,, 6]), [4, Promise.race([l, h])];

              case 3:
                return a.sent(), [4, l];

              case 4:
                return f = a.sent(), [3, 6];

              case 5:
                throw p = a.sent(), m = "fetch-client-network", "AbortError" === p.name && (m = "fetch-timeout"), d.create(m, {
                  originalErrorMessage: p.message
                });

              case 6:
                if (_ = f.status, y = f.headers.get("ETag") || void 0, 200 !== f.status) return [3, 11];
                b = void 0, a.label = 7;

              case 7:
                return a.trys.push([7, 9,, 10]), [4, f.json()];

              case 8:
                return b = a.sent(), [3, 10];

              case 9:
                throw w = a.sent(), d.create("fetch-client-parse", {
                  originalErrorMessage: w.message
                });

              case 10:
                v = b.entries, g = b.state, a.label = 11;

              case 11:
                if ("INSTANCE_STATE_UNSPECIFIED" === g ? _ = 500 : "NO_CHANGE" === g ? _ = 304 : "NO_TEMPLATE" !== g && "EMPTY_CONFIG" !== g || (v = {}), 304 !== _ && 200 !== _) throw d.create("fetch-status", {
                  httpStatus: _
                });
                return [2, {
                  status: _,
                  eTag: y,
                  config: v
                }];
            }
            /**
             * @license
             * Copyright 2019 Google Inc.
             *
             * Licensed under the Apache License, Version 2.0 (the "License");
             * you may not use this file except in compliance with the License.
             * You may obtain a copy of the License at
             *
             *   http://www.apache.org/licenses/LICENSE-2.0
             *
             * Unless required by applicable law or agreed to in writing, software
             * distributed under the License is distributed on an "AS IS" BASIS,
             * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
             * See the License for the specific language governing permissions and
             * limitations under the License.
             */


            var T;
          });
        });
      }, e;
    }(),
        p = function () {
      function e() {
        this.listeners = [];
      }

      return e.prototype.addEventListener = function (e) {
        this.listeners.push(e);
      }, e.prototype.abort = function () {
        this.listeners.forEach(function (e) {
          return e();
        });
      }, e;
    }(),
        m = "",
        _ = ["1", "true", "t", "yes", "y", "on"],
        y = function () {
      function e(e, t) {
        void 0 === t && (t = m), this._source = e, this._value = t;
      }

      return e.prototype.asString = function () {
        return this._value;
      }, e.prototype.asBoolean = function () {
        return "static" !== this._source && _.indexOf(this._value.toLowerCase()) >= 0;
      }, e.prototype.asNumber = function () {
        if ("static" === this._source) return 0;
        var e = Number(this._value);
        return isNaN(e) && (e = 0), e;
      }, e.prototype.getSource = function () {
        return this._source;
      }, e;
    }(),
        v = 6e4,
        g = 432e5,
        b = function () {
      function e(e, t, n, r, i) {
        this.app = e, this._client = t, this._storageCache = n, this._storage = r, this._logger = i, this._isInitializationComplete = !1, this.settings = {
          fetchTimeoutMillis: v,
          minimumFetchIntervalMillis: g
        }, this.defaultConfig = {};
      }

      return e.prototype.setLogLevel = function (e) {
        switch (e) {
          case "debug":
            this._logger.logLevel = u.LogLevel.DEBUG;
            break;

          case "silent":
            this._logger.logLevel = u.LogLevel.SILENT;
            break;

          default:
            this._logger.logLevel = u.LogLevel.ERROR;
        }
      }, Object.defineProperty(e.prototype, "fetchTimeMillis", {
        get: function get() {
          return this._storageCache.getLastSuccessfulFetchTimestampMillis() || -1;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "lastFetchStatus", {
        get: function get() {
          return this._storageCache.getLastFetchStatus() || "no-fetch-yet";
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.activate = function () {
        return a.__awaiter(this, void 0, void 0, function () {
          var e, t, n;
          return a.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, Promise.all([this._storage.getLastSuccessfulFetchResponse(), this._storage.getActiveConfigEtag()])];

              case 1:
                return e = r.sent(), t = e[0], n = e[1], t && t.config && t.eTag && t.eTag !== n ? [4, Promise.all([this._storageCache.setActiveConfig(t.config), this._storage.setActiveConfigEtag(t.eTag)])] : [2, !1];

              case 2:
                return r.sent(), [2, !0];
            }
          });
        });
      }, e.prototype.ensureInitialized = function () {
        var e = this;
        return this._initializePromise || (this._initializePromise = this._storageCache.loadFromStorage().then(function () {
          e._isInitializationComplete = !0;
        })), this._initializePromise;
      }, e.prototype.fetch = function () {
        return a.__awaiter(this, void 0, void 0, function () {
          var e,
              t,
              n,
              r = this;
          return a.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                e = new p(), setTimeout(function () {
                  return a.__awaiter(r, void 0, void 0, function () {
                    return a.__generator(this, function (t) {
                      return e.abort(), [2];
                    });
                  });
                }, this.settings.fetchTimeoutMillis), i.label = 1;

              case 1:
                return i.trys.push([1, 4,, 6]), [4, this._client.fetch({
                  cacheMaxAgeMillis: this.settings.minimumFetchIntervalMillis,
                  signal: e
                })];

              case 2:
                return i.sent(), [4, this._storageCache.setLastFetchStatus("success")];

              case 3:
                return i.sent(), [3, 6];

              case 4:
                return t = i.sent(), u = "fetch-throttle", n = (o = t) instanceof s.FirebaseError && -1 !== o.code.indexOf(u) ? "throttle" : "failure", [4, this._storageCache.setLastFetchStatus(n)];

              case 5:
                throw i.sent(), t;

              case 6:
                return [2];
            }

            var o, u;
          });
        });
      }, e.prototype.fetchAndActivate = function () {
        return a.__awaiter(this, void 0, void 0, function () {
          return a.__generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.fetch()];

              case 1:
                return e.sent(), [2, this.activate()];
            }
          });
        });
      }, e.prototype.getAll = function () {
        var e = this;
        return function (e, t) {
          void 0 === e && (e = {});
          void 0 === t && (t = {});
          return Object.keys(a.__assign(a.__assign({}, e), t));
        }
        /**
         * @license
         * Copyright 2019 Google Inc.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         *   http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         */
        (this._storageCache.getActiveConfig(), this.defaultConfig).reduce(function (t, n) {
          return t[n] = e.getValue(n), t;
        }, {});
      }, e.prototype.getBoolean = function (e) {
        return this.getValue(e).asBoolean();
      }, e.prototype.getNumber = function (e) {
        return this.getValue(e).asNumber();
      }, e.prototype.getString = function (e) {
        return this.getValue(e).asString();
      }, e.prototype.getValue = function (e) {
        this._isInitializationComplete || this._logger.debug('A value was requested for key "' + e + '" before SDK initialization completed. Await on ensureInitialized if the intent was to get a previously activated value.');

        var t = this._storageCache.getActiveConfig();

        return t && void 0 !== t[e] ? new y("remote", t[e]) : this.defaultConfig && void 0 !== this.defaultConfig[e] ? new y("default", String(this.defaultConfig[e])) : (this._logger.debug('Returning static value for key "' + e + '". Define a default or remote value if this is unintentional.'), new y("static"));
      }, e;
    }();
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function w(e, t) {
      var n = e.target.error || void 0;
      return d.create(t, {
        originalErrorMessage: n && n.message
      });
    }

    var T = "app_namespace_store",
        M = "firebase_remote_config",
        E = 1;

    var k = function () {
      function e(e, t, n, r) {
        void 0 === r && (r = new Promise(function (e, t) {
          var n = indexedDB.open(M, E);
          n.onerror = function (e) {
            t(w(e, "storage-open"));
          }, n.onsuccess = function (t) {
            e(t.target.result);
          }, n.onupgradeneeded = function (e) {
            var t = e.target.result;

            switch (e.oldVersion) {
              case 0:
                t.createObjectStore(T, {
                  keyPath: "compositeKey"
                });
            }
          };
        })), this.appId = e, this.appName = t, this.namespace = n, this.openDbPromise = r;
      }

      return e.prototype.getLastFetchStatus = function () {
        return this.get("last_fetch_status");
      }, e.prototype.setLastFetchStatus = function (e) {
        return this.set("last_fetch_status", e);
      }, e.prototype.getLastSuccessfulFetchTimestampMillis = function () {
        return this.get("last_successful_fetch_timestamp_millis");
      }, e.prototype.setLastSuccessfulFetchTimestampMillis = function (e) {
        return this.set("last_successful_fetch_timestamp_millis", e);
      }, e.prototype.getLastSuccessfulFetchResponse = function () {
        return this.get("last_successful_fetch_response");
      }, e.prototype.setLastSuccessfulFetchResponse = function (e) {
        return this.set("last_successful_fetch_response", e);
      }, e.prototype.getActiveConfig = function () {
        return this.get("active_config");
      }, e.prototype.setActiveConfig = function (e) {
        return this.set("active_config", e);
      }, e.prototype.getActiveConfigEtag = function () {
        return this.get("active_config_etag");
      }, e.prototype.setActiveConfigEtag = function (e) {
        return this.set("active_config_etag", e);
      }, e.prototype.getThrottleMetadata = function () {
        return this.get("throttle_metadata");
      }, e.prototype.setThrottleMetadata = function (e) {
        return this.set("throttle_metadata", e);
      }, e.prototype.deleteThrottleMetadata = function () {
        return this.delete("throttle_metadata");
      }, e.prototype.get = function (e) {
        return a.__awaiter(this, void 0, void 0, function () {
          var t,
              n = this;
          return a.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.openDbPromise];

              case 1:
                return t = r.sent(), [2, new Promise(function (r, i) {
                  var o = t.transaction([T], "readonly").objectStore(T),
                      a = n.createCompositeKey(e);

                  try {
                    var s = o.get(a);
                    s.onerror = function (e) {
                      i(w(e, "storage-get"));
                    }, s.onsuccess = function (e) {
                      var t = e.target.result;
                      r(t ? t.value : void 0);
                    };
                  } catch (e) {
                    i(d.create("storage-get", {
                      originalErrorMessage: e && e.message
                    }));
                  }
                })];
            }
          });
        });
      }, e.prototype.set = function (e, t) {
        return a.__awaiter(this, void 0, void 0, function () {
          var n,
              r = this;
          return a.__generator(this, function (i) {
            switch (i.label) {
              case 0:
                return [4, this.openDbPromise];

              case 1:
                return n = i.sent(), [2, new Promise(function (i, o) {
                  var a = n.transaction([T], "readwrite").objectStore(T),
                      s = r.createCompositeKey(e);

                  try {
                    var u = a.put({
                      compositeKey: s,
                      value: t
                    });
                    u.onerror = function (e) {
                      o(w(e, "storage-set"));
                    }, u.onsuccess = function () {
                      i();
                    };
                  } catch (e) {
                    o(d.create("storage-set", {
                      originalErrorMessage: e && e.message
                    }));
                  }
                })];
            }
          });
        });
      }, e.prototype.delete = function (e) {
        return a.__awaiter(this, void 0, void 0, function () {
          var t,
              n = this;
          return a.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.openDbPromise];

              case 1:
                return t = r.sent(), [2, new Promise(function (r, i) {
                  var o = t.transaction([T], "readwrite").objectStore(T),
                      a = n.createCompositeKey(e);

                  try {
                    var s = o.delete(a);
                    s.onerror = function (e) {
                      i(w(e, "storage-delete"));
                    }, s.onsuccess = function () {
                      r();
                    };
                  } catch (e) {
                    i(d.create("storage-delete", {
                      originalErrorMessage: e && e.message
                    }));
                  }
                })];
            }
          });
        });
      }, e.prototype.createCompositeKey = function (e) {
        return [this.appId, this.appName, this.namespace, e].join();
      }, e;
    }(),
        L = function () {
      function e(e) {
        this.storage = e;
      }

      return e.prototype.getLastFetchStatus = function () {
        return this.lastFetchStatus;
      }, e.prototype.getLastSuccessfulFetchTimestampMillis = function () {
        return this.lastSuccessfulFetchTimestampMillis;
      }, e.prototype.getActiveConfig = function () {
        return this.activeConfig;
      }, e.prototype.loadFromStorage = function () {
        return a.__awaiter(this, void 0, void 0, function () {
          var e, t, n, r, i, o;
          return a.__generator(this, function (a) {
            switch (a.label) {
              case 0:
                return e = this.storage.getLastFetchStatus(), t = this.storage.getLastSuccessfulFetchTimestampMillis(), n = this.storage.getActiveConfig(), [4, e];

              case 1:
                return (r = a.sent()) && (this.lastFetchStatus = r), [4, t];

              case 2:
                return (i = a.sent()) && (this.lastSuccessfulFetchTimestampMillis = i), [4, n];

              case 3:
                return (o = a.sent()) && (this.activeConfig = o), [2];
            }
          });
        });
      }, e.prototype.setLastFetchStatus = function (e) {
        return this.lastFetchStatus = e, this.storage.setLastFetchStatus(e);
      }, e.prototype.setLastSuccessfulFetchTimestampMillis = function (e) {
        return this.lastSuccessfulFetchTimestampMillis = e, this.storage.setLastSuccessfulFetchTimestampMillis(e);
      }, e.prototype.setActiveConfig = function (e) {
        return this.activeConfig = e, this.storage.setActiveConfig(e);
      }, e;
    }(),
        S = 1e3,
        N = 2,
        D = 144e5,
        I = .5;
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function R(e) {
      var t = S * Math.pow(N, e),
          n = Math.round(I * t * (Math.random() - .5) * 2);
      return Math.min(D, t + n);
    }
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function x(e, t) {
      return new Promise(function (n, r) {
        var i = Math.max(t - Date.now(), 0),
            o = setTimeout(n, i);
        e.addEventListener(function () {
          clearTimeout(o), r(d.create("fetch-throttle", {
            throttleEndTimeMillis: t
          }));
        });
      });
    }

    var Y = function () {
      function e(e, t) {
        this.client = e, this.storage = t;
      }

      return e.prototype.fetch = function (e) {
        return a.__awaiter(this, void 0, void 0, function () {
          var t;
          return a.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.storage.getThrottleMetadata()];

              case 1:
                return t = n.sent() || {
                  backoffCount: 0,
                  throttleEndTimeMillis: Date.now()
                }, [2, this.attemptFetch(e, t)];
            }
          });
        });
      }, e.prototype.attemptFetch = function (e, t) {
        var n = t.throttleEndTimeMillis,
            r = t.backoffCount;
        return a.__awaiter(this, void 0, void 0, function () {
          var t, i, o;
          return a.__generator(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, x(e.signal, n)];

              case 1:
                a.sent(), a.label = 2;

              case 2:
                return a.trys.push([2, 5,, 7]), [4, this.client.fetch(e)];

              case 3:
                return t = a.sent(), [4, this.storage.deleteThrottleMetadata()];

              case 4:
                return a.sent(), [2, t];

              case 5:
                if (!function (e) {
                  if (!(e instanceof s.FirebaseError)) return !1;
                  var t = Number(e.httpStatus);
                  return 429 === t || 500 === t || 503 === t || 504 === t;
                }(i = a.sent())) throw i;
                return o = {
                  throttleEndTimeMillis: Date.now() + R(r),
                  backoffCount: r + 1
                }, [4, this.storage.setThrottleMetadata(o)];

              case 6:
                return a.sent(), [2, this.attemptFetch(e, o)];

              case 7:
                return [2];
            }
          });
        });
      }, e;
    }(),
        C = "@firebase/remote-config",
        O = "0.1.20";
    /**
     * @license
     * Copyright 2019 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */


    function F(e) {
      e.INTERNAL.registerComponent(new c.Component("remoteConfig", function (t, n) {
        var r = t.getProvider("app").getImmediate(),
            i = t.getProvider("installations").getImmediate();
        if ("undefined" == typeof window) throw d.create("registration-window");
        var o = r.options,
            a = o.projectId,
            s = o.apiKey,
            c = o.appId;
        if (!a) throw d.create("registration-project-id");
        if (!s) throw d.create("registration-api-key");
        if (!c) throw d.create("registration-app-id");
        n = n || "firebase";
        var h = new k(c, r.name, n),
            p = new L(h),
            m = new u.Logger(C);
        m.logLevel = u.LogLevel.ERROR;

        var _ = new f(i, e.SDK_VERSION, n, a, s, c),
            y = new Y(_, h),
            v = new l(y, h, p, m),
            g = new b(r, v, p, h, m);

        return g.ensureInitialized(), g;
      }, "PUBLIC").setMultipleInstances(!0)), e.registerVersion(C, O);
    }

    F(i), t.registerRemoteConfig = F;
  }, function (e, t) {
    e.exports = function (e) {
      if (!e.webpackPolyfill) {
        var t = Object.create(e);
        t.children || (t.children = []), Object.defineProperty(t, "loaded", {
          enumerable: !0,
          get: function get() {
            return t.l;
          }
        }), Object.defineProperty(t, "id", {
          enumerable: !0,
          get: function get() {
            return t.i;
          }
        }), Object.defineProperty(t, "exports", {
          enumerable: !0
        }), t.webpackPolyfill = 1;
      }

      return t;
    };
  }, function (e, t, n) {
    var r = {
      "./af": 63,
      "./af.js": 63,
      "./ar": 64,
      "./ar-dz": 65,
      "./ar-dz.js": 65,
      "./ar-kw": 66,
      "./ar-kw.js": 66,
      "./ar-ly": 67,
      "./ar-ly.js": 67,
      "./ar-ma": 68,
      "./ar-ma.js": 68,
      "./ar-sa": 69,
      "./ar-sa.js": 69,
      "./ar-tn": 70,
      "./ar-tn.js": 70,
      "./ar.js": 64,
      "./az": 71,
      "./az.js": 71,
      "./be": 72,
      "./be.js": 72,
      "./bg": 73,
      "./bg.js": 73,
      "./bm": 74,
      "./bm.js": 74,
      "./bn": 75,
      "./bn.js": 75,
      "./bo": 76,
      "./bo.js": 76,
      "./br": 77,
      "./br.js": 77,
      "./bs": 78,
      "./bs.js": 78,
      "./ca": 79,
      "./ca.js": 79,
      "./cs": 80,
      "./cs.js": 80,
      "./cv": 81,
      "./cv.js": 81,
      "./cy": 82,
      "./cy.js": 82,
      "./da": 83,
      "./da.js": 83,
      "./de": 84,
      "./de-at": 85,
      "./de-at.js": 85,
      "./de-ch": 86,
      "./de-ch.js": 86,
      "./de.js": 84,
      "./dv": 87,
      "./dv.js": 87,
      "./el": 88,
      "./el.js": 88,
      "./en-SG": 89,
      "./en-SG.js": 89,
      "./en-au": 90,
      "./en-au.js": 90,
      "./en-ca": 91,
      "./en-ca.js": 91,
      "./en-gb": 92,
      "./en-gb.js": 92,
      "./en-ie": 93,
      "./en-ie.js": 93,
      "./en-il": 94,
      "./en-il.js": 94,
      "./en-nz": 95,
      "./en-nz.js": 95,
      "./eo": 96,
      "./eo.js": 96,
      "./es": 97,
      "./es-do": 98,
      "./es-do.js": 98,
      "./es-us": 99,
      "./es-us.js": 99,
      "./es.js": 97,
      "./et": 100,
      "./et.js": 100,
      "./eu": 101,
      "./eu.js": 101,
      "./fa": 102,
      "./fa.js": 102,
      "./fi": 103,
      "./fi.js": 103,
      "./fo": 104,
      "./fo.js": 104,
      "./fr": 105,
      "./fr-ca": 106,
      "./fr-ca.js": 106,
      "./fr-ch": 107,
      "./fr-ch.js": 107,
      "./fr.js": 105,
      "./fy": 108,
      "./fy.js": 108,
      "./ga": 109,
      "./ga.js": 109,
      "./gd": 110,
      "./gd.js": 110,
      "./gl": 111,
      "./gl.js": 111,
      "./gom-latn": 112,
      "./gom-latn.js": 112,
      "./gu": 113,
      "./gu.js": 113,
      "./he": 114,
      "./he.js": 114,
      "./hi": 115,
      "./hi.js": 115,
      "./hr": 116,
      "./hr.js": 116,
      "./hu": 117,
      "./hu.js": 117,
      "./hy-am": 118,
      "./hy-am.js": 118,
      "./id": 119,
      "./id.js": 119,
      "./is": 120,
      "./is.js": 120,
      "./it": 121,
      "./it-ch": 122,
      "./it-ch.js": 122,
      "./it.js": 121,
      "./ja": 123,
      "./ja.js": 123,
      "./jv": 124,
      "./jv.js": 124,
      "./ka": 125,
      "./ka.js": 125,
      "./kk": 126,
      "./kk.js": 126,
      "./km": 127,
      "./km.js": 127,
      "./kn": 128,
      "./kn.js": 128,
      "./ko": 129,
      "./ko.js": 129,
      "./ku": 130,
      "./ku.js": 130,
      "./ky": 131,
      "./ky.js": 131,
      "./lb": 132,
      "./lb.js": 132,
      "./lo": 133,
      "./lo.js": 133,
      "./lt": 134,
      "./lt.js": 134,
      "./lv": 135,
      "./lv.js": 135,
      "./me": 136,
      "./me.js": 136,
      "./mi": 137,
      "./mi.js": 137,
      "./mk": 138,
      "./mk.js": 138,
      "./ml": 139,
      "./ml.js": 139,
      "./mn": 140,
      "./mn.js": 140,
      "./mr": 141,
      "./mr.js": 141,
      "./ms": 142,
      "./ms-my": 143,
      "./ms-my.js": 143,
      "./ms.js": 142,
      "./mt": 144,
      "./mt.js": 144,
      "./my": 145,
      "./my.js": 145,
      "./nb": 146,
      "./nb.js": 146,
      "./ne": 147,
      "./ne.js": 147,
      "./nl": 148,
      "./nl-be": 149,
      "./nl-be.js": 149,
      "./nl.js": 148,
      "./nn": 150,
      "./nn.js": 150,
      "./pa-in": 151,
      "./pa-in.js": 151,
      "./pl": 152,
      "./pl.js": 152,
      "./pt": 153,
      "./pt-br": 154,
      "./pt-br.js": 154,
      "./pt.js": 153,
      "./ro": 155,
      "./ro.js": 155,
      "./ru": 156,
      "./ru.js": 156,
      "./sd": 157,
      "./sd.js": 157,
      "./se": 158,
      "./se.js": 158,
      "./si": 159,
      "./si.js": 159,
      "./sk": 160,
      "./sk.js": 160,
      "./sl": 161,
      "./sl.js": 161,
      "./sq": 162,
      "./sq.js": 162,
      "./sr": 163,
      "./sr-cyrl": 164,
      "./sr-cyrl.js": 164,
      "./sr.js": 163,
      "./ss": 165,
      "./ss.js": 165,
      "./sv": 166,
      "./sv.js": 166,
      "./sw": 167,
      "./sw.js": 167,
      "./ta": 168,
      "./ta.js": 168,
      "./te": 169,
      "./te.js": 169,
      "./tet": 170,
      "./tet.js": 170,
      "./tg": 171,
      "./tg.js": 171,
      "./th": 172,
      "./th.js": 172,
      "./tl-ph": 173,
      "./tl-ph.js": 173,
      "./tlh": 174,
      "./tlh.js": 174,
      "./tr": 175,
      "./tr.js": 175,
      "./tzl": 176,
      "./tzl.js": 176,
      "./tzm": 177,
      "./tzm-latn": 178,
      "./tzm-latn.js": 178,
      "./tzm.js": 177,
      "./ug-cn": 179,
      "./ug-cn.js": 179,
      "./uk": 180,
      "./uk.js": 180,
      "./ur": 181,
      "./ur.js": 181,
      "./uz": 182,
      "./uz-latn": 183,
      "./uz-latn.js": 183,
      "./uz.js": 182,
      "./vi": 184,
      "./vi.js": 184,
      "./x-pseudo": 185,
      "./x-pseudo.js": 185,
      "./yo": 186,
      "./yo.js": 186,
      "./zh-cn": 187,
      "./zh-cn.js": 187,
      "./zh-hk": 188,
      "./zh-hk.js": 188,
      "./zh-tw": 189,
      "./zh-tw.js": 189
    };

    function i(e) {
      var t = o(e);
      return n(t);
    }

    function o(e) {
      if (!n.o(r, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }

      return r[e];
    }

    i.keys = function () {
      return Object.keys(r);
    }, i.resolve = o, e.exports = i, i.id = 266;
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
       * @license  MIT
       */
      var r = n(268),
          i = n(269),
          o = n(270);

      function a() {
        return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function s(e, t) {
        if (a() < t) throw new RangeError("Invalid typed array length");
        return u.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = u.prototype : (null === e && (e = new u(t)), e.length = t), e;
      }

      function u(e, t, n) {
        if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(e, t, n);

        if ("number" == typeof e) {
          if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
          return h(this, e);
        }

        return c(this, e, t, n);
      }

      function c(e, t, n, r) {
        if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, n, r) {
          if (t.byteLength, n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");
          if (t.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
          t = void 0 === n && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, n) : new Uint8Array(t, n, r);
          u.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = u.prototype : e = d(e, t);
          return e;
        }(e, t, n, r) : "string" == typeof t ? function (e, t, n) {
          "string" == typeof n && "" !== n || (n = "utf8");
          if (!u.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
          var r = 0 | p(t, n),
              i = (e = s(e, r)).write(t, n);
          i !== r && (e = e.slice(0, i));
          return e;
        }(e, t, n) : function (e, t) {
          if (u.isBuffer(t)) {
            var n = 0 | f(t.length);
            return 0 === (e = s(e, n)).length ? e : (t.copy(e, 0, 0, n), e);
          }

          if (t) {
            if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (r = t.length) != r ? s(e, 0) : d(e, t);
            if ("Buffer" === t.type && o(t.data)) return d(e, t.data);
          }

          var r;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(e, t);
      }

      function l(e) {
        if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
        if (e < 0) throw new RangeError('"size" argument must not be negative');
      }

      function h(e, t) {
        if (l(t), e = s(e, t < 0 ? 0 : 0 | f(t)), !u.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) {
          e[n] = 0;
        }
        return e;
      }

      function d(e, t) {
        var n = t.length < 0 ? 0 : 0 | f(t.length);
        e = s(e, n);

        for (var r = 0; r < n; r += 1) {
          e[r] = 255 & t[r];
        }

        return e;
      }

      function f(e) {
        if (e >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
        return 0 | e;
      }

      function p(e, t) {
        if (u.isBuffer(e)) return e.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
        "string" != typeof e && (e = "" + e);
        var n = e.length;
        if (0 === n) return 0;

        for (var r = !1;;) {
          switch (t) {
            case "ascii":
            case "latin1":
            case "binary":
              return n;

            case "utf8":
            case "utf-8":
            case void 0:
              return P(e).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * n;

            case "hex":
              return n >>> 1;

            case "base64":
              return V(e).length;

            default:
              if (r) return P(e).length;
              t = ("" + t).toLowerCase(), r = !0;
          }
        }
      }

      function m(e, t, n) {
        var r = e[t];
        e[t] = e[n], e[n] = r;
      }

      function _(e, t, n, r, i) {
        if (0 === e.length) return -1;

        if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
          if (i) return -1;
          n = e.length - 1;
        } else if (n < 0) {
          if (!i) return -1;
          n = 0;
        }

        if ("string" == typeof t && (t = u.from(t, r)), u.isBuffer(t)) return 0 === t.length ? -1 : y(e, t, n, r, i);
        if ("number" == typeof t) return t &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : y(e, [t], n, r, i);
        throw new TypeError("val must be string, number or Buffer");
      }

      function y(e, t, n, r, i) {
        var o,
            a = 1,
            s = e.length,
            u = t.length;

        if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
          if (e.length < 2 || t.length < 2) return -1;
          a = 2, s /= 2, u /= 2, n /= 2;
        }

        function c(e, t) {
          return 1 === a ? e[t] : e.readUInt16BE(t * a);
        }

        if (i) {
          var l = -1;

          for (o = n; o < s; o++) {
            if (c(e, o) === c(t, -1 === l ? 0 : o - l)) {
              if (-1 === l && (l = o), o - l + 1 === u) return l * a;
            } else -1 !== l && (o -= o - l), l = -1;
          }
        } else for (n + u > s && (n = s - u), o = n; o >= 0; o--) {
          for (var h = !0, d = 0; d < u; d++) {
            if (c(e, o + d) !== c(t, d)) {
              h = !1;
              break;
            }
          }

          if (h) return o;
        }

        return -1;
      }

      function v(e, t, n, r) {
        n = Number(n) || 0;
        var i = e.length - n;
        r ? (r = Number(r)) > i && (r = i) : r = i;
        var o = t.length;
        if (o % 2 != 0) throw new TypeError("Invalid hex string");
        r > o / 2 && (r = o / 2);

        for (var a = 0; a < r; ++a) {
          var s = parseInt(t.substr(2 * a, 2), 16);
          if (isNaN(s)) return a;
          e[n + a] = s;
        }

        return a;
      }

      function g(e, t, n, r) {
        return W(P(t, e.length - n), e, n, r);
      }

      function b(e, t, n, r) {
        return W(function (e) {
          for (var t = [], n = 0; n < e.length; ++n) {
            t.push(255 & e.charCodeAt(n));
          }

          return t;
        }(t), e, n, r);
      }

      function w(e, t, n, r) {
        return b(e, t, n, r);
      }

      function T(e, t, n, r) {
        return W(V(t), e, n, r);
      }

      function M(e, t, n, r) {
        return W(function (e, t) {
          for (var n, r, i, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) {
            n = e.charCodeAt(a), r = n >> 8, i = n % 256, o.push(i), o.push(r);
          }

          return o;
        }(t, e.length - n), e, n, r);
      }

      function E(e, t, n) {
        return 0 === t && n === e.length ? r.fromByteArray(e) : r.fromByteArray(e.slice(t, n));
      }

      function k(e, t, n) {
        n = Math.min(e.length, n);

        for (var r = [], i = t; i < n;) {
          var o,
              a,
              s,
              u,
              c = e[i],
              l = null,
              h = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
          if (i + h <= n) switch (h) {
            case 1:
              c < 128 && (l = c);
              break;

            case 2:
              128 == (192 & (o = e[i + 1])) && (u = (31 & c) << 6 | 63 & o) > 127 && (l = u);
              break;

            case 3:
              o = e[i + 1], a = e[i + 2], 128 == (192 & o) && 128 == (192 & a) && (u = (15 & c) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (u < 55296 || u > 57343) && (l = u);
              break;

            case 4:
              o = e[i + 1], a = e[i + 2], s = e[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (u = (15 & c) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && u < 1114112 && (l = u);
          }
          null === l ? (l = 65533, h = 1) : l > 65535 && (l -= 65536, r.push(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), r.push(l), i += h;
        }

        return function (e) {
          var t = e.length;
          if (t <= L) return String.fromCharCode.apply(String, e);
          var n = "",
              r = 0;

          for (; r < t;) {
            n += String.fromCharCode.apply(String, e.slice(r, r += L));
          }

          return n;
        }(r);
      }

      t.Buffer = u, t.SlowBuffer = function (e) {
        +e != e && (e = 0);
        return u.alloc(+e);
      }, t.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
        try {
          var e = new Uint8Array(1);
          return e.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
        } catch (e) {
          return !1;
        }
      }(), t.kMaxLength = a(), u.poolSize = 8192, u._augment = function (e) {
        return e.__proto__ = u.prototype, e;
      }, u.from = function (e, t, n) {
        return c(null, e, t, n);
      }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
        value: null,
        configurable: !0
      })), u.alloc = function (e, t, n) {
        return function (e, t, n, r) {
          return l(t), t <= 0 ? s(e, t) : void 0 !== n ? "string" == typeof r ? s(e, t).fill(n, r) : s(e, t).fill(n) : s(e, t);
        }(null, e, t, n);
      }, u.allocUnsafe = function (e) {
        return h(null, e);
      }, u.allocUnsafeSlow = function (e) {
        return h(null, e);
      }, u.isBuffer = function (e) {
        return !(null == e || !e._isBuffer);
      }, u.compare = function (e, t) {
        if (!u.isBuffer(e) || !u.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
        if (e === t) return 0;

        for (var n = e.length, r = t.length, i = 0, o = Math.min(n, r); i < o; ++i) {
          if (e[i] !== t[i]) {
            n = e[i], r = t[i];
            break;
          }
        }

        return n < r ? -1 : r < n ? 1 : 0;
      }, u.isEncoding = function (e) {
        switch (String(e).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, u.concat = function (e, t) {
        if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === e.length) return u.alloc(0);
        var n;
        if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) {
          t += e[n].length;
        }
        var r = u.allocUnsafe(t),
            i = 0;

        for (n = 0; n < e.length; ++n) {
          var a = e[n];
          if (!u.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
          a.copy(r, i), i += a.length;
        }

        return r;
      }, u.byteLength = p, u.prototype._isBuffer = !0, u.prototype.swap16 = function () {
        var e = this.length;
        if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var t = 0; t < e; t += 2) {
          m(this, t, t + 1);
        }

        return this;
      }, u.prototype.swap32 = function () {
        var e = this.length;
        if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var t = 0; t < e; t += 4) {
          m(this, t, t + 3), m(this, t + 1, t + 2);
        }

        return this;
      }, u.prototype.swap64 = function () {
        var e = this.length;
        if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var t = 0; t < e; t += 8) {
          m(this, t, t + 7), m(this, t + 1, t + 6), m(this, t + 2, t + 5), m(this, t + 3, t + 4);
        }

        return this;
      }, u.prototype.toString = function () {
        var e = 0 | this.length;
        return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : function (e, t, n) {
          var r = !1;
          if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
          if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
          if ((n >>>= 0) <= (t >>>= 0)) return "";

          for (e || (e = "utf8");;) {
            switch (e) {
              case "hex":
                return D(this, t, n);

              case "utf8":
              case "utf-8":
                return k(this, t, n);

              case "ascii":
                return S(this, t, n);

              case "latin1":
              case "binary":
                return N(this, t, n);

              case "base64":
                return E(this, t, n);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return I(this, t, n);

              default:
                if (r) throw new TypeError("Unknown encoding: " + e);
                e = (e + "").toLowerCase(), r = !0;
            }
          }
        }.apply(this, arguments);
      }, u.prototype.equals = function (e) {
        if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        return this === e || 0 === u.compare(this, e);
      }, u.prototype.inspect = function () {
        var e = "",
            n = t.INSPECT_MAX_BYTES;
        return this.length > 0 && (e = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (e += " ... ")), "<Buffer " + e + ">";
      }, u.prototype.compare = function (e, t, n, r, i) {
        if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw new RangeError("out of range index");
        if (r >= i && t >= n) return 0;
        if (r >= i) return -1;
        if (t >= n) return 1;
        if (this === e) return 0;

        for (var o = (i >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (t >>>= 0), s = Math.min(o, a), c = this.slice(r, i), l = e.slice(t, n), h = 0; h < s; ++h) {
          if (c[h] !== l[h]) {
            o = c[h], a = l[h];
            break;
          }
        }

        return o < a ? -1 : a < o ? 1 : 0;
      }, u.prototype.includes = function (e, t, n) {
        return -1 !== this.indexOf(e, t, n);
      }, u.prototype.indexOf = function (e, t, n) {
        return _(this, e, t, n, !0);
      }, u.prototype.lastIndexOf = function (e, t, n) {
        return _(this, e, t, n, !1);
      }, u.prototype.write = function (e, t, n, r) {
        if (void 0 === t) r = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;else {
          if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          t |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
        }
        var i = this.length - t;
        if ((void 0 === n || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        r || (r = "utf8");

        for (var o = !1;;) {
          switch (r) {
            case "hex":
              return v(this, e, t, n);

            case "utf8":
            case "utf-8":
              return g(this, e, t, n);

            case "ascii":
              return b(this, e, t, n);

            case "latin1":
            case "binary":
              return w(this, e, t, n);

            case "base64":
              return T(this, e, t, n);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return M(this, e, t, n);

            default:
              if (o) throw new TypeError("Unknown encoding: " + r);
              r = ("" + r).toLowerCase(), o = !0;
          }
        }
      }, u.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      var L = 4096;

      function S(e, t, n) {
        var r = "";
        n = Math.min(e.length, n);

        for (var i = t; i < n; ++i) {
          r += String.fromCharCode(127 & e[i]);
        }

        return r;
      }

      function N(e, t, n) {
        var r = "";
        n = Math.min(e.length, n);

        for (var i = t; i < n; ++i) {
          r += String.fromCharCode(e[i]);
        }

        return r;
      }

      function D(e, t, n) {
        var r = e.length;
        (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);

        for (var i = "", o = t; o < n; ++o) {
          i += U(e[o]);
        }

        return i;
      }

      function I(e, t, n) {
        for (var r = e.slice(t, n), i = "", o = 0; o < r.length; o += 2) {
          i += String.fromCharCode(r[o] + 256 * r[o + 1]);
        }

        return i;
      }

      function R(e, t, n) {
        if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
        if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
      }

      function x(e, t, n, r, i, o) {
        if (!u.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
        if (n + r > e.length) throw new RangeError("Index out of range");
      }

      function Y(e, t, n, r) {
        t < 0 && (t = 65535 + t + 1);

        for (var i = 0, o = Math.min(e.length - n, 2); i < o; ++i) {
          e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
        }
      }

      function C(e, t, n, r) {
        t < 0 && (t = 4294967295 + t + 1);

        for (var i = 0, o = Math.min(e.length - n, 4); i < o; ++i) {
          e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
        }
      }

      function O(e, t, n, r, i, o) {
        if (n + r > e.length) throw new RangeError("Index out of range");
        if (n < 0) throw new RangeError("Index out of range");
      }

      function F(e, t, n, r, o) {
        return o || O(e, 0, n, 4), i.write(e, t, n, r, 23, 4), n + 4;
      }

      function A(e, t, n, r, o) {
        return o || O(e, 0, n, 8), i.write(e, t, n, r, 52, 8), n + 8;
      }

      u.prototype.slice = function (e, t) {
        var n,
            r = this.length;
        if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), u.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = u.prototype;else {
          var i = t - e;
          n = new u(i, void 0);

          for (var o = 0; o < i; ++o) {
            n[o] = this[o + e];
          }
        }
        return n;
      }, u.prototype.readUIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || R(e, t, this.length);

        for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
          r += this[e + o] * i;
        }

        return r;
      }, u.prototype.readUIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || R(e, t, this.length);

        for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) {
          r += this[e + --t] * i;
        }

        return r;
      }, u.prototype.readUInt8 = function (e, t) {
        return t || R(e, 1, this.length), this[e];
      }, u.prototype.readUInt16LE = function (e, t) {
        return t || R(e, 2, this.length), this[e] | this[e + 1] << 8;
      }, u.prototype.readUInt16BE = function (e, t) {
        return t || R(e, 2, this.length), this[e] << 8 | this[e + 1];
      }, u.prototype.readUInt32LE = function (e, t) {
        return t || R(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
      }, u.prototype.readUInt32BE = function (e, t) {
        return t || R(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
      }, u.prototype.readIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || R(e, t, this.length);

        for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) {
          r += this[e + o] * i;
        }

        return r >= (i *= 128) && (r -= Math.pow(2, 8 * t)), r;
      }, u.prototype.readIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || R(e, t, this.length);

        for (var r = t, i = 1, o = this[e + --r]; r > 0 && (i *= 256);) {
          o += this[e + --r] * i;
        }

        return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
      }, u.prototype.readInt8 = function (e, t) {
        return t || R(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
      }, u.prototype.readInt16LE = function (e, t) {
        t || R(e, 2, this.length);
        var n = this[e] | this[e + 1] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, u.prototype.readInt16BE = function (e, t) {
        t || R(e, 2, this.length);
        var n = this[e + 1] | this[e] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, u.prototype.readInt32LE = function (e, t) {
        return t || R(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
      }, u.prototype.readInt32BE = function (e, t) {
        return t || R(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
      }, u.prototype.readFloatLE = function (e, t) {
        return t || R(e, 4, this.length), i.read(this, e, !0, 23, 4);
      }, u.prototype.readFloatBE = function (e, t) {
        return t || R(e, 4, this.length), i.read(this, e, !1, 23, 4);
      }, u.prototype.readDoubleLE = function (e, t) {
        return t || R(e, 8, this.length), i.read(this, e, !0, 52, 8);
      }, u.prototype.readDoubleBE = function (e, t) {
        return t || R(e, 8, this.length), i.read(this, e, !1, 52, 8);
      }, u.prototype.writeUIntLE = function (e, t, n, r) {
        (e = +e, t |= 0, n |= 0, r) || x(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
        var i = 1,
            o = 0;

        for (this[t] = 255 & e; ++o < n && (i *= 256);) {
          this[t + o] = e / i & 255;
        }

        return t + n;
      }, u.prototype.writeUIntBE = function (e, t, n, r) {
        (e = +e, t |= 0, n |= 0, r) || x(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
        var i = n - 1,
            o = 1;

        for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) {
          this[t + i] = e / o & 255;
        }

        return t + n;
      }, u.prototype.writeUInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || x(this, e, t, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
      }, u.prototype.writeUInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || x(this, e, t, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : Y(this, e, t, !0), t + 2;
      }, u.prototype.writeUInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || x(this, e, t, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : Y(this, e, t, !1), t + 2;
      }, u.prototype.writeUInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || x(this, e, t, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : C(this, e, t, !0), t + 4;
      }, u.prototype.writeUInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || x(this, e, t, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : C(this, e, t, !1), t + 4;
      }, u.prototype.writeIntLE = function (e, t, n, r) {
        if (e = +e, t |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);
          x(this, e, t, n, i - 1, -i);
        }

        var o = 0,
            a = 1,
            s = 0;

        for (this[t] = 255 & e; ++o < n && (a *= 256);) {
          e < 0 && 0 === s && 0 !== this[t + o - 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
        }

        return t + n;
      }, u.prototype.writeIntBE = function (e, t, n, r) {
        if (e = +e, t |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);
          x(this, e, t, n, i - 1, -i);
        }

        var o = n - 1,
            a = 1,
            s = 0;

        for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) {
          e < 0 && 0 === s && 0 !== this[t + o + 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
        }

        return t + n;
      }, u.prototype.writeInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || x(this, e, t, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
      }, u.prototype.writeInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || x(this, e, t, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : Y(this, e, t, !0), t + 2;
      }, u.prototype.writeInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || x(this, e, t, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : Y(this, e, t, !1), t + 2;
      }, u.prototype.writeInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || x(this, e, t, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : C(this, e, t, !0), t + 4;
      }, u.prototype.writeInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || x(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : C(this, e, t, !1), t + 4;
      }, u.prototype.writeFloatLE = function (e, t, n) {
        return F(this, e, t, !0, n);
      }, u.prototype.writeFloatBE = function (e, t, n) {
        return F(this, e, t, !1, n);
      }, u.prototype.writeDoubleLE = function (e, t, n) {
        return A(this, e, t, !0, n);
      }, u.prototype.writeDoubleBE = function (e, t, n) {
        return A(this, e, t, !1, n);
      }, u.prototype.copy = function (e, t, n, r) {
        if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;
        if (0 === e.length || 0 === this.length) return 0;
        if (t < 0) throw new RangeError("targetStart out of bounds");
        if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
        if (r < 0) throw new RangeError("sourceEnd out of bounds");
        r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
        var i,
            o = r - n;
        if (this === e && n < t && t < r) for (i = o - 1; i >= 0; --i) {
          e[i + t] = this[i + n];
        } else if (o < 1e3 || !u.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
          e[i + t] = this[i + n];
        } else Uint8Array.prototype.set.call(e, this.subarray(n, n + o), t);
        return o;
      }, u.prototype.fill = function (e, t, n, r) {
        if ("string" == typeof e) {
          if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === e.length) {
            var i = e.charCodeAt(0);
            i < 256 && (e = i);
          }

          if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
          if ("string" == typeof r && !u.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
        } else "number" == typeof e && (e &= 255);

        if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
        if (n <= t) return this;
        var o;
        if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < n; ++o) {
          this[o] = e;
        } else {
          var a = u.isBuffer(e) ? e : P(new u(e, r).toString()),
              s = a.length;

          for (o = 0; o < n - t; ++o) {
            this[o + t] = a[o % s];
          }
        }
        return this;
      };
      var j = /[^+\/0-9A-Za-z-_]/g;

      function U(e) {
        return e < 16 ? "0" + e.toString(16) : e.toString(16);
      }

      function P(e, t) {
        var n;
        t = t || 1 / 0;

        for (var r = e.length, i = null, o = [], a = 0; a < r; ++a) {
          if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
            if (!i) {
              if (n > 56319) {
                (t -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              if (a + 1 === r) {
                (t -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              i = n;
              continue;
            }

            if (n < 56320) {
              (t -= 3) > -1 && o.push(239, 191, 189), i = n;
              continue;
            }

            n = 65536 + (i - 55296 << 10 | n - 56320);
          } else i && (t -= 3) > -1 && o.push(239, 191, 189);

          if (i = null, n < 128) {
            if ((t -= 1) < 0) break;
            o.push(n);
          } else if (n < 2048) {
            if ((t -= 2) < 0) break;
            o.push(n >> 6 | 192, 63 & n | 128);
          } else if (n < 65536) {
            if ((t -= 3) < 0) break;
            o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
          } else {
            if (!(n < 1114112)) throw new Error("Invalid code point");
            if ((t -= 4) < 0) break;
            o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
          }
        }

        return o;
      }

      function V(e) {
        return r.toByteArray(function (e) {
          if ((e = function (e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
          }(e).replace(j, "")).length < 2) return "";

          for (; e.length % 4 != 0;) {
            e += "=";
          }

          return e;
        }(e));
      }

      function W(e, t, n, r) {
        for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) {
          t[i + n] = e[i];
        }

        return i;
      }
    }).call(this, n(17));
  }, function (e, t, n) {
    "use strict";

    t.byteLength = function (e) {
      var t = c(e),
          n = t[0],
          r = t[1];
      return 3 * (n + r) / 4 - r;
    }, t.toByteArray = function (e) {
      for (var t, n = c(e), r = n[0], a = n[1], s = new o(function (e, t, n) {
        return 3 * (t + n) / 4 - n;
      }(0, r, a)), u = 0, l = a > 0 ? r - 4 : r, h = 0; h < l; h += 4) {
        t = i[e.charCodeAt(h)] << 18 | i[e.charCodeAt(h + 1)] << 12 | i[e.charCodeAt(h + 2)] << 6 | i[e.charCodeAt(h + 3)], s[u++] = t >> 16 & 255, s[u++] = t >> 8 & 255, s[u++] = 255 & t;
      }

      2 === a && (t = i[e.charCodeAt(h)] << 2 | i[e.charCodeAt(h + 1)] >> 4, s[u++] = 255 & t);
      1 === a && (t = i[e.charCodeAt(h)] << 10 | i[e.charCodeAt(h + 1)] << 4 | i[e.charCodeAt(h + 2)] >> 2, s[u++] = t >> 8 & 255, s[u++] = 255 & t);
      return s;
    }, t.fromByteArray = function (e) {
      for (var t, n = e.length, i = n % 3, o = [], a = 0, s = n - i; a < s; a += 16383) {
        o.push(l(e, a, a + 16383 > s ? s : a + 16383));
      }

      1 === i ? (t = e[n - 1], o.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === i && (t = (e[n - 2] << 8) + e[n - 1], o.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "="));
      return o.join("");
    };

    for (var r = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, u = a.length; s < u; ++s) {
      r[s] = a[s], i[a.charCodeAt(s)] = s;
    }

    function c(e) {
      var t = e.length;
      if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var n = e.indexOf("=");
      return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
    }

    function l(e, t, n) {
      for (var i, o, a = [], s = t; s < n; s += 3) {
        i = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), a.push(r[(o = i) >> 18 & 63] + r[o >> 12 & 63] + r[o >> 6 & 63] + r[63 & o]);
      }

      return a.join("");
    }

    i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
  }, function (e, t) {
    t.read = function (e, t, n, r, i) {
      var o,
          a,
          s = 8 * i - r - 1,
          u = (1 << s) - 1,
          c = u >> 1,
          l = -7,
          h = n ? i - 1 : 0,
          d = n ? -1 : 1,
          f = e[t + h];

      for (h += d, o = f & (1 << -l) - 1, f >>= -l, l += s; l > 0; o = 256 * o + e[t + h], h += d, l -= 8) {
        ;
      }

      for (a = o & (1 << -l) - 1, o >>= -l, l += r; l > 0; a = 256 * a + e[t + h], h += d, l -= 8) {
        ;
      }

      if (0 === o) o = 1 - c;else {
        if (o === u) return a ? NaN : 1 / 0 * (f ? -1 : 1);
        a += Math.pow(2, r), o -= c;
      }
      return (f ? -1 : 1) * a * Math.pow(2, o - r);
    }, t.write = function (e, t, n, r, i, o) {
      var a,
          s,
          u,
          c = 8 * o - i - 1,
          l = (1 << c) - 1,
          h = l >> 1,
          d = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          f = r ? 0 : o - 1,
          p = r ? 1 : -1,
          m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

      for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = l) : (a = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), (t += a + h >= 1 ? d / u : d * Math.pow(2, 1 - h)) * u >= 2 && (a++, u /= 2), a + h >= l ? (s = 0, a = l) : a + h >= 1 ? (s = (t * u - 1) * Math.pow(2, i), a += h) : (s = t * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; e[n + f] = 255 & s, f += p, s /= 256, i -= 8) {
        ;
      }

      for (a = a << i | s, c += i; c > 0; e[n + f] = 255 & a, f += p, a /= 256, c -= 8) {
        ;
      }

      e[n + f - p] |= 128 * m;
    };
  }, function (e, t) {
    var n = {}.toString;

    e.exports = Array.isArray || function (e) {
      return "[object Array]" == n.call(e);
    };
  }, function (e, t, n) {
    (function (e) {
      var r = void 0 !== e && e || "undefined" != typeof self && self || window,
          i = Function.prototype.apply;

      function o(e, t) {
        this._id = e, this._clearFn = t;
      }

      t.setTimeout = function () {
        return new o(i.call(setTimeout, r, arguments), clearTimeout);
      }, t.setInterval = function () {
        return new o(i.call(setInterval, r, arguments), clearInterval);
      }, t.clearTimeout = t.clearInterval = function (e) {
        e && e.close();
      }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
        this._clearFn.call(r, this._id);
      }, t.enroll = function (e, t) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
      }, t.unenroll = function (e) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
      }, t._unrefActive = t.active = function (e) {
        clearTimeout(e._idleTimeoutId);
        var t = e._idleTimeout;
        t >= 0 && (e._idleTimeoutId = setTimeout(function () {
          e._onTimeout && e._onTimeout();
        }, t));
      }, n(272), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
    }).call(this, n(17));
  }, function (e, t, n) {
    (function (e, t) {
      !function (e, n) {
        "use strict";

        if (!e.setImmediate) {
          var r,
              i,
              o,
              a,
              s,
              u = 1,
              c = {},
              l = !1,
              h = e.document,
              d = Object.getPrototypeOf && Object.getPrototypeOf(e);
          d = d && d.setTimeout ? d : e, "[object process]" === {}.toString.call(e.process) ? r = function r(e) {
            t.nextTick(function () {
              p(e);
            });
          } : !function () {
            if (e.postMessage && !e.importScripts) {
              var t = !0,
                  n = e.onmessage;
              return e.onmessage = function () {
                t = !1;
              }, e.postMessage("", "*"), e.onmessage = n, t;
            }
          }() ? e.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (e) {
            p(e.data);
          }, r = function r(e) {
            o.port2.postMessage(e);
          }) : h && "onreadystatechange" in h.createElement("script") ? (i = h.documentElement, r = function r(e) {
            var t = h.createElement("script");
            t.onreadystatechange = function () {
              p(e), t.onreadystatechange = null, i.removeChild(t), t = null;
            }, i.appendChild(t);
          }) : r = function r(e) {
            setTimeout(p, 0, e);
          } : (a = "setImmediate$" + Math.random() + "$", s = function s(t) {
            t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(a) && p(+t.data.slice(a.length));
          }, e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s), r = function r(t) {
            e.postMessage(a + t, "*");
          }), d.setImmediate = function (e) {
            "function" != typeof e && (e = new Function("" + e));

            for (var t = new Array(arguments.length - 1), n = 0; n < t.length; n++) {
              t[n] = arguments[n + 1];
            }

            var i = {
              callback: e,
              args: t
            };
            return c[u] = i, r(u), u++;
          }, d.clearImmediate = f;
        }

        function f(e) {
          delete c[e];
        }

        function p(e) {
          if (l) setTimeout(p, 0, e);else {
            var t = c[e];

            if (t) {
              l = !0;

              try {
                !function (e) {
                  var t = e.callback,
                      r = e.args;

                  switch (r.length) {
                    case 0:
                      t();
                      break;

                    case 1:
                      t(r[0]);
                      break;

                    case 2:
                      t(r[0], r[1]);
                      break;

                    case 3:
                      t(r[0], r[1], r[2]);
                      break;

                    default:
                      t.apply(n, r);
                  }
                }(t);
              } finally {
                f(e), l = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === e ? this : e : self);
    }).call(this, n(17), n(32));
  }]);
});